/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1290);
	
	__webpack_require__(729);
	
	__webpack_require__(675);
	
	__webpack_require__(676);
	
	__webpack_require__(677);
	
	__webpack_require__(674);
	
	var _utils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (false) {
	    // Require '?performance' query parameter to activate why-did-you-update
	    if (typeof window !== 'undefined' && window.location.search.indexOf('performance') !== -1) {
	        var createClass = _react2.default.createClass; // eslint-disable-line
	        Object.defineProperty(_react2.default, 'createClass', {
	            set: function set(nextCreateClass) {
	                createClass = nextCreateClass;
	            }
	        });
	
	        var _require = require('why-did-you-update'),
	            whyDidYouUpdate = _require.whyDidYouUpdate;
	
	        whyDidYouUpdate(_react2.default, { exclude: /^(Portal|Wrapped|Map)/ });
	    }
	}
	
	if (typeof window !== 'undefined') {
	    window.Components.MapLocationBlock = __webpack_require__(234);
	    window.Components.ProjectListPage = __webpack_require__(240);
	
	    __webpack_require__(1084).polyfill();
	}
	
	// Prevent clicks on disabled anchor tags
	if (typeof document !== 'undefined') {
	    document.addEventListener('click', function (e) {
	        if (e.target && e.target.tagName === 'A') {
	            if (e.target.getAttribute("disabled") !== null) e.preventDefault();
	        }
	    });
	
	    if (document.body.classList.contains("project-print-page")) {
	        (0, _utils.addLogoToPrintProjects)();
	    }
	
	    (0, _utils.GTMTrackingForEpiFormsHandler)();
	}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(40);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(177)();
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Icon = __webpack_require__(122);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Icon2.default;
	module.exports = exports['default'];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(19);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Button = __webpack_require__(75);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Button2.default;
	module.exports = exports['default'];

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* @preserve
	 * Leaflet 1.2.0, a JS library for interactive maps. http://leafletjs.com
	 * (c) 2010-2017 Vladimir Agafonkin, (c) 2010-2011 CloudMade
	 */
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.L = {})));
	}(this, (function (exports) { 'use strict';
	
	var version = "1.2.0";
	
	/*
	 * @namespace Util
	 *
	 * Various utility functions, used by Leaflet internally.
	 */
	
	var freeze = Object.freeze;
	Object.freeze = function (obj) { return obj; };
	
	// @function extend(dest: Object, src?: Object): Object
	// Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
	function extend(dest) {
		var i, j, len, src;
	
		for (j = 1, len = arguments.length; j < len; j++) {
			src = arguments[j];
			for (i in src) {
				dest[i] = src[i];
			}
		}
		return dest;
	}
	
	// @function create(proto: Object, properties?: Object): Object
	// Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
	var create = Object.create || (function () {
		function F() {}
		return function (proto) {
			F.prototype = proto;
			return new F();
		};
	})();
	
	// @function bind(fn: Function, …): Function
	// Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	// Has a `L.bind()` shortcut.
	function bind(fn, obj) {
		var slice = Array.prototype.slice;
	
		if (fn.bind) {
			return fn.bind.apply(fn, slice.call(arguments, 1));
		}
	
		var args = slice.call(arguments, 2);
	
		return function () {
			return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
		};
	}
	
	// @property lastId: Number
	// Last unique ID used by [`stamp()`](#util-stamp)
	var lastId = 0;
	
	// @function stamp(obj: Object): Number
	// Returns the unique ID of an object, assiging it one if it doesn't have it.
	function stamp(obj) {
		/*eslint-disable */
		obj._leaflet_id = obj._leaflet_id || ++lastId;
		return obj._leaflet_id;
		/*eslint-enable */
	}
	
	// @function throttle(fn: Function, time: Number, context: Object): Function
	// Returns a function which executes function `fn` with the given scope `context`
	// (so that the `this` keyword refers to `context` inside `fn`'s code). The function
	// `fn` will be called no more than one time per given amount of `time`. The arguments
	// received by the bound function will be any arguments passed when binding the
	// function, followed by any arguments passed when invoking the bound function.
	// Has an `L.throttle` shortcut.
	function throttle(fn, time, context) {
		var lock, args, wrapperFn, later;
	
		later = function () {
			// reset lock and call if queued
			lock = false;
			if (args) {
				wrapperFn.apply(context, args);
				args = false;
			}
		};
	
		wrapperFn = function () {
			if (lock) {
				// called too soon, queue to call later
				args = arguments;
	
			} else {
				// call and lock until later
				fn.apply(context, arguments);
				setTimeout(later, time);
				lock = true;
			}
		};
	
		return wrapperFn;
	}
	
	// @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
	// Returns the number `num` modulo `range` in such a way so it lies within
	// `range[0]` and `range[1]`. The returned value will be always smaller than
	// `range[1]` unless `includeMax` is set to `true`.
	function wrapNum(x, range, includeMax) {
		var max = range[1],
		    min = range[0],
		    d = max - min;
		return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
	}
	
	// @function falseFn(): Function
	// Returns a function which always returns `false`.
	function falseFn() { return false; }
	
	// @function formatNum(num: Number, digits?: Number): Number
	// Returns the number `num` rounded to `digits` decimals, or to 5 decimals by default.
	function formatNum(num, digits) {
		var pow = Math.pow(10, digits || 5);
		return Math.round(num * pow) / pow;
	}
	
	// @function trim(str: String): String
	// Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
	function trim(str) {
		return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	}
	
	// @function splitWords(str: String): String[]
	// Trims and splits the string on whitespace and returns the array of parts.
	function splitWords(str) {
		return trim(str).split(/\s+/);
	}
	
	// @function setOptions(obj: Object, options: Object): Object
	// Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
	function setOptions(obj, options) {
		if (!obj.hasOwnProperty('options')) {
			obj.options = obj.options ? create(obj.options) : {};
		}
		for (var i in options) {
			obj.options[i] = options[i];
		}
		return obj.options;
	}
	
	// @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
	// Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
	// translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
	// be appended at the end. If `uppercase` is `true`, the parameter names will
	// be uppercased (e.g. `'?A=foo&B=bar'`)
	function getParamString(obj, existingUrl, uppercase) {
		var params = [];
		for (var i in obj) {
			params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
		}
		return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
	}
	
	var templateRe = /\{ *([\w_\-]+) *\}/g;
	
	// @function template(str: String, data: Object): String
	// Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
	// and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
	// `('Hello foo, bar')`. You can also specify functions instead of strings for
	// data values — they will be evaluated passing `data` as an argument.
	function template(str, data) {
		return str.replace(templateRe, function (str, key) {
			var value = data[key];
	
			if (value === undefined) {
				throw new Error('No value provided for variable ' + str);
	
			} else if (typeof value === 'function') {
				value = value(data);
			}
			return value;
		});
	}
	
	// @function isArray(obj): Boolean
	// Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
	var isArray = Array.isArray || function (obj) {
		return (Object.prototype.toString.call(obj) === '[object Array]');
	};
	
	// @function indexOf(array: Array, el: Object): Number
	// Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
	function indexOf(array, el) {
		for (var i = 0; i < array.length; i++) {
			if (array[i] === el) { return i; }
		}
		return -1;
	}
	
	// @property emptyImageUrl: String
	// Data URI string containing a base64-encoded empty GIF image.
	// Used as a hack to free memory from unused images on WebKit-powered
	// mobile devices (by setting image `src` to this string).
	var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
	
	// inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	
	function getPrefixed(name) {
		return window['webkit' + name] || window['moz' + name] || window['ms' + name];
	}
	
	var lastTime = 0;
	
	// fallback for IE 7-8
	function timeoutDefer(fn) {
		var time = +new Date(),
		    timeToCall = Math.max(0, 16 - (time - lastTime));
	
		lastTime = time + timeToCall;
		return window.setTimeout(fn, timeToCall);
	}
	
	var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
	var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
			getPrefixed('CancelRequestAnimationFrame') || function (id) { window.clearTimeout(id); };
	
	// @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
	// Schedules `fn` to be executed when the browser repaints. `fn` is bound to
	// `context` if given. When `immediate` is set, `fn` is called immediately if
	// the browser doesn't have native support for
	// [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
	// otherwise it's delayed. Returns a request ID that can be used to cancel the request.
	function requestAnimFrame(fn, context, immediate) {
		if (immediate && requestFn === timeoutDefer) {
			fn.call(context);
		} else {
			return requestFn.call(window, bind(fn, context));
		}
	}
	
	// @function cancelAnimFrame(id: Number): undefined
	// Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
	function cancelAnimFrame(id) {
		if (id) {
			cancelFn.call(window, id);
		}
	}
	
	
	var Util = (Object.freeze || Object)({
		freeze: freeze,
		extend: extend,
		create: create,
		bind: bind,
		lastId: lastId,
		stamp: stamp,
		throttle: throttle,
		wrapNum: wrapNum,
		falseFn: falseFn,
		formatNum: formatNum,
		trim: trim,
		splitWords: splitWords,
		setOptions: setOptions,
		getParamString: getParamString,
		template: template,
		isArray: isArray,
		indexOf: indexOf,
		emptyImageUrl: emptyImageUrl,
		requestFn: requestFn,
		cancelFn: cancelFn,
		requestAnimFrame: requestAnimFrame,
		cancelAnimFrame: cancelAnimFrame
	});
	
	// @class Class
	// @aka L.Class
	
	// @section
	// @uninheritable
	
	// Thanks to John Resig and Dean Edwards for inspiration!
	
	function Class() {}
	
	Class.extend = function (props) {
	
		// @function extend(props: Object): Function
		// [Extends the current class](#class-inheritance) given the properties to be included.
		// Returns a Javascript function that is a class constructor (to be called with `new`).
		var NewClass = function () {
	
			// call the constructor
			if (this.initialize) {
				this.initialize.apply(this, arguments);
			}
	
			// call all constructor hooks
			this.callInitHooks();
		};
	
		var parentProto = NewClass.__super__ = this.prototype;
	
		var proto = create(parentProto);
		proto.constructor = NewClass;
	
		NewClass.prototype = proto;
	
		// inherit parent's statics
		for (var i in this) {
			if (this.hasOwnProperty(i) && i !== 'prototype' && i !== '__super__') {
				NewClass[i] = this[i];
			}
		}
	
		// mix static properties into the class
		if (props.statics) {
			extend(NewClass, props.statics);
			delete props.statics;
		}
	
		// mix includes into the prototype
		if (props.includes) {
			checkDeprecatedMixinEvents(props.includes);
			extend.apply(null, [proto].concat(props.includes));
			delete props.includes;
		}
	
		// merge options
		if (proto.options) {
			props.options = extend(create(proto.options), props.options);
		}
	
		// mix given properties into the prototype
		extend(proto, props);
	
		proto._initHooks = [];
	
		// add method for calling all hooks
		proto.callInitHooks = function () {
	
			if (this._initHooksCalled) { return; }
	
			if (parentProto.callInitHooks) {
				parentProto.callInitHooks.call(this);
			}
	
			this._initHooksCalled = true;
	
			for (var i = 0, len = proto._initHooks.length; i < len; i++) {
				proto._initHooks[i].call(this);
			}
		};
	
		return NewClass;
	};
	
	
	// @function include(properties: Object): this
	// [Includes a mixin](#class-includes) into the current class.
	Class.include = function (props) {
		extend(this.prototype, props);
		return this;
	};
	
	// @function mergeOptions(options: Object): this
	// [Merges `options`](#class-options) into the defaults of the class.
	Class.mergeOptions = function (options) {
		extend(this.prototype.options, options);
		return this;
	};
	
	// @function addInitHook(fn: Function): this
	// Adds a [constructor hook](#class-constructor-hooks) to the class.
	Class.addInitHook = function (fn) { // (Function) || (String, args...)
		var args = Array.prototype.slice.call(arguments, 1);
	
		var init = typeof fn === 'function' ? fn : function () {
			this[fn].apply(this, args);
		};
	
		this.prototype._initHooks = this.prototype._initHooks || [];
		this.prototype._initHooks.push(init);
		return this;
	};
	
	function checkDeprecatedMixinEvents(includes) {
		if (!L || !L.Mixin) { return; }
	
		includes = isArray(includes) ? includes : [includes];
	
		for (var i = 0; i < includes.length; i++) {
			if (includes[i] === L.Mixin.Events) {
				console.warn('Deprecated include of L.Mixin.Events: ' +
					'this property will be removed in future releases, ' +
					'please inherit from L.Evented instead.', new Error().stack);
			}
		}
	}
	
	/*
	 * @class Evented
	 * @aka L.Evented
	 * @inherits Class
	 *
	 * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
	 *
	 * @example
	 *
	 * ```js
	 * map.on('click', function(e) {
	 * 	alert(e.latlng);
	 * } );
	 * ```
	 *
	 * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
	 *
	 * ```js
	 * function onClick(e) { ... }
	 *
	 * map.on('click', onClick);
	 * map.off('click', onClick);
	 * ```
	 */
	
	var Events = {
		/* @method on(type: String, fn: Function, context?: Object): this
		 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
		 *
		 * @alternative
		 * @method on(eventMap: Object): this
		 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
		 */
		on: function (types, fn, context) {
	
			// types can be a map of types/handlers
			if (typeof types === 'object') {
				for (var type in types) {
					// we don't process space-separated events here for performance;
					// it's a hot path since Layer uses the on(obj) syntax
					this._on(type, types[type], fn);
				}
	
			} else {
				// types can be a string of space-separated words
				types = splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._on(types[i], fn, context);
				}
			}
	
			return this;
		},
	
		/* @method off(type: String, fn?: Function, context?: Object): this
		 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
		 *
		 * @alternative
		 * @method off(eventMap: Object): this
		 * Removes a set of type/listener pairs.
		 *
		 * @alternative
		 * @method off: this
		 * Removes all listeners to all events on the object.
		 */
		off: function (types, fn, context) {
	
			if (!types) {
				// clear all listeners if called without arguments
				delete this._events;
	
			} else if (typeof types === 'object') {
				for (var type in types) {
					this._off(type, types[type], fn);
				}
	
			} else {
				types = splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._off(types[i], fn, context);
				}
			}
	
			return this;
		},
	
		// attach listener (without syntactic sugar now)
		_on: function (type, fn, context) {
			this._events = this._events || {};
	
			/* get/init listeners for type */
			var typeListeners = this._events[type];
			if (!typeListeners) {
				typeListeners = [];
				this._events[type] = typeListeners;
			}
	
			if (context === this) {
				// Less memory footprint.
				context = undefined;
			}
			var newListener = {fn: fn, ctx: context},
			    listeners = typeListeners;
	
			// check if fn already there
			for (var i = 0, len = listeners.length; i < len; i++) {
				if (listeners[i].fn === fn && listeners[i].ctx === context) {
					return;
				}
			}
	
			listeners.push(newListener);
		},
	
		_off: function (type, fn, context) {
			var listeners,
			    i,
			    len;
	
			if (!this._events) { return; }
	
			listeners = this._events[type];
	
			if (!listeners) {
				return;
			}
	
			if (!fn) {
				// Set all removed listeners to noop so they are not called if remove happens in fire
				for (i = 0, len = listeners.length; i < len; i++) {
					listeners[i].fn = falseFn;
				}
				// clear all listeners for a type if function isn't specified
				delete this._events[type];
				return;
			}
	
			if (context === this) {
				context = undefined;
			}
	
			if (listeners) {
	
				// find fn and remove it
				for (i = 0, len = listeners.length; i < len; i++) {
					var l = listeners[i];
					if (l.ctx !== context) { continue; }
					if (l.fn === fn) {
	
						// set the removed listener to noop so that's not called if remove happens in fire
						l.fn = falseFn;
	
						if (this._firingCount) {
							/* copy array in case events are being fired */
							this._events[type] = listeners = listeners.slice();
						}
						listeners.splice(i, 1);
	
						return;
					}
				}
			}
		},
	
		// @method fire(type: String, data?: Object, propagate?: Boolean): this
		// Fires an event of the specified type. You can optionally provide an data
		// object — the first argument of the listener function will contain its
		// properties. The event can optionally be propagated to event parents.
		fire: function (type, data, propagate) {
			if (!this.listens(type, propagate)) { return this; }
	
			var event = extend({}, data, {type: type, target: this});
	
			if (this._events) {
				var listeners = this._events[type];
	
				if (listeners) {
					this._firingCount = (this._firingCount + 1) || 1;
					for (var i = 0, len = listeners.length; i < len; i++) {
						var l = listeners[i];
						l.fn.call(l.ctx || this, event);
					}
	
					this._firingCount--;
				}
			}
	
			if (propagate) {
				// propagate the event to parents (set with addEventParent)
				this._propagateEvent(event);
			}
	
			return this;
		},
	
		// @method listens(type: String): Boolean
		// Returns `true` if a particular event type has any listeners attached to it.
		listens: function (type, propagate) {
			var listeners = this._events && this._events[type];
			if (listeners && listeners.length) { return true; }
	
			if (propagate) {
				// also check parents for listeners if event propagates
				for (var id in this._eventParents) {
					if (this._eventParents[id].listens(type, propagate)) { return true; }
				}
			}
			return false;
		},
	
		// @method once(…): this
		// Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
		once: function (types, fn, context) {
	
			if (typeof types === 'object') {
				for (var type in types) {
					this.once(type, types[type], fn);
				}
				return this;
			}
	
			var handler = bind(function () {
				this
				    .off(types, fn, context)
				    .off(types, handler, context);
			}, this);
	
			// add a listener that's executed once and removed after that
			return this
			    .on(types, fn, context)
			    .on(types, handler, context);
		},
	
		// @method addEventParent(obj: Evented): this
		// Adds an event parent - an `Evented` that will receive propagated events
		addEventParent: function (obj) {
			this._eventParents = this._eventParents || {};
			this._eventParents[stamp(obj)] = obj;
			return this;
		},
	
		// @method removeEventParent(obj: Evented): this
		// Removes an event parent, so it will stop receiving propagated events
		removeEventParent: function (obj) {
			if (this._eventParents) {
				delete this._eventParents[stamp(obj)];
			}
			return this;
		},
	
		_propagateEvent: function (e) {
			for (var id in this._eventParents) {
				this._eventParents[id].fire(e.type, extend({layer: e.target}, e), true);
			}
		}
	};
	
	// aliases; we should ditch those eventually
	
	// @method addEventListener(…): this
	// Alias to [`on(…)`](#evented-on)
	Events.addEventListener = Events.on;
	
	// @method removeEventListener(…): this
	// Alias to [`off(…)`](#evented-off)
	
	// @method clearAllEventListeners(…): this
	// Alias to [`off()`](#evented-off)
	Events.removeEventListener = Events.clearAllEventListeners = Events.off;
	
	// @method addOneTimeEventListener(…): this
	// Alias to [`once(…)`](#evented-once)
	Events.addOneTimeEventListener = Events.once;
	
	// @method fireEvent(…): this
	// Alias to [`fire(…)`](#evented-fire)
	Events.fireEvent = Events.fire;
	
	// @method hasEventListeners(…): Boolean
	// Alias to [`listens(…)`](#evented-listens)
	Events.hasEventListeners = Events.listens;
	
	var Evented = Class.extend(Events);
	
	/*
	 * @class Point
	 * @aka L.Point
	 *
	 * Represents a point with `x` and `y` coordinates in pixels.
	 *
	 * @example
	 *
	 * ```js
	 * var point = L.point(200, 300);
	 * ```
	 *
	 * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
	 *
	 * ```js
	 * map.panBy([200, 300]);
	 * map.panBy(L.point(200, 300));
	 * ```
	 */
	
	function Point(x, y, round) {
		// @property x: Number; The `x` coordinate of the point
		this.x = (round ? Math.round(x) : x);
		// @property y: Number; The `y` coordinate of the point
		this.y = (round ? Math.round(y) : y);
	}
	
	Point.prototype = {
	
		// @method clone(): Point
		// Returns a copy of the current point.
		clone: function () {
			return new Point(this.x, this.y);
		},
	
		// @method add(otherPoint: Point): Point
		// Returns the result of addition of the current and the given points.
		add: function (point) {
			// non-destructive, returns a new point
			return this.clone()._add(toPoint(point));
		},
	
		_add: function (point) {
			// destructive, used directly for performance in situations where it's safe to modify existing point
			this.x += point.x;
			this.y += point.y;
			return this;
		},
	
		// @method subtract(otherPoint: Point): Point
		// Returns the result of subtraction of the given point from the current.
		subtract: function (point) {
			return this.clone()._subtract(toPoint(point));
		},
	
		_subtract: function (point) {
			this.x -= point.x;
			this.y -= point.y;
			return this;
		},
	
		// @method divideBy(num: Number): Point
		// Returns the result of division of the current point by the given number.
		divideBy: function (num) {
			return this.clone()._divideBy(num);
		},
	
		_divideBy: function (num) {
			this.x /= num;
			this.y /= num;
			return this;
		},
	
		// @method multiplyBy(num: Number): Point
		// Returns the result of multiplication of the current point by the given number.
		multiplyBy: function (num) {
			return this.clone()._multiplyBy(num);
		},
	
		_multiplyBy: function (num) {
			this.x *= num;
			this.y *= num;
			return this;
		},
	
		// @method scaleBy(scale: Point): Point
		// Multiply each coordinate of the current point by each coordinate of
		// `scale`. In linear algebra terms, multiply the point by the
		// [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
		// defined by `scale`.
		scaleBy: function (point) {
			return new Point(this.x * point.x, this.y * point.y);
		},
	
		// @method unscaleBy(scale: Point): Point
		// Inverse of `scaleBy`. Divide each coordinate of the current point by
		// each coordinate of `scale`.
		unscaleBy: function (point) {
			return new Point(this.x / point.x, this.y / point.y);
		},
	
		// @method round(): Point
		// Returns a copy of the current point with rounded coordinates.
		round: function () {
			return this.clone()._round();
		},
	
		_round: function () {
			this.x = Math.round(this.x);
			this.y = Math.round(this.y);
			return this;
		},
	
		// @method floor(): Point
		// Returns a copy of the current point with floored coordinates (rounded down).
		floor: function () {
			return this.clone()._floor();
		},
	
		_floor: function () {
			this.x = Math.floor(this.x);
			this.y = Math.floor(this.y);
			return this;
		},
	
		// @method ceil(): Point
		// Returns a copy of the current point with ceiled coordinates (rounded up).
		ceil: function () {
			return this.clone()._ceil();
		},
	
		_ceil: function () {
			this.x = Math.ceil(this.x);
			this.y = Math.ceil(this.y);
			return this;
		},
	
		// @method distanceTo(otherPoint: Point): Number
		// Returns the cartesian distance between the current and the given points.
		distanceTo: function (point) {
			point = toPoint(point);
	
			var x = point.x - this.x,
			    y = point.y - this.y;
	
			return Math.sqrt(x * x + y * y);
		},
	
		// @method equals(otherPoint: Point): Boolean
		// Returns `true` if the given point has the same coordinates.
		equals: function (point) {
			point = toPoint(point);
	
			return point.x === this.x &&
			       point.y === this.y;
		},
	
		// @method contains(otherPoint: Point): Boolean
		// Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
		contains: function (point) {
			point = toPoint(point);
	
			return Math.abs(point.x) <= Math.abs(this.x) &&
			       Math.abs(point.y) <= Math.abs(this.y);
		},
	
		// @method toString(): String
		// Returns a string representation of the point for debugging purposes.
		toString: function () {
			return 'Point(' +
			        formatNum(this.x) + ', ' +
			        formatNum(this.y) + ')';
		}
	};
	
	// @factory L.point(x: Number, y: Number, round?: Boolean)
	// Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
	
	// @alternative
	// @factory L.point(coords: Number[])
	// Expects an array of the form `[x, y]` instead.
	
	// @alternative
	// @factory L.point(coords: Object)
	// Expects a plain object of the form `{x: Number, y: Number}` instead.
	function toPoint(x, y, round) {
		if (x instanceof Point) {
			return x;
		}
		if (isArray(x)) {
			return new Point(x[0], x[1]);
		}
		if (x === undefined || x === null) {
			return x;
		}
		if (typeof x === 'object' && 'x' in x && 'y' in x) {
			return new Point(x.x, x.y);
		}
		return new Point(x, y, round);
	}
	
	/*
	 * @class Bounds
	 * @aka L.Bounds
	 *
	 * Represents a rectangular area in pixel coordinates.
	 *
	 * @example
	 *
	 * ```js
	 * var p1 = L.point(10, 10),
	 * p2 = L.point(40, 60),
	 * bounds = L.bounds(p1, p2);
	 * ```
	 *
	 * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	 *
	 * ```js
	 * otherBounds.intersects([[10, 10], [40, 60]]);
	 * ```
	 */
	
	function Bounds(a, b) {
		if (!a) { return; }
	
		var points = b ? [a, b] : a;
	
		for (var i = 0, len = points.length; i < len; i++) {
			this.extend(points[i]);
		}
	}
	
	Bounds.prototype = {
		// @method extend(point: Point): this
		// Extends the bounds to contain the given point.
		extend: function (point) { // (Point)
			point = toPoint(point);
	
			// @property min: Point
			// The top left corner of the rectangle.
			// @property max: Point
			// The bottom right corner of the rectangle.
			if (!this.min && !this.max) {
				this.min = point.clone();
				this.max = point.clone();
			} else {
				this.min.x = Math.min(point.x, this.min.x);
				this.max.x = Math.max(point.x, this.max.x);
				this.min.y = Math.min(point.y, this.min.y);
				this.max.y = Math.max(point.y, this.max.y);
			}
			return this;
		},
	
		// @method getCenter(round?: Boolean): Point
		// Returns the center point of the bounds.
		getCenter: function (round) {
			return new Point(
			        (this.min.x + this.max.x) / 2,
			        (this.min.y + this.max.y) / 2, round);
		},
	
		// @method getBottomLeft(): Point
		// Returns the bottom-left point of the bounds.
		getBottomLeft: function () {
			return new Point(this.min.x, this.max.y);
		},
	
		// @method getTopRight(): Point
		// Returns the top-right point of the bounds.
		getTopRight: function () { // -> Point
			return new Point(this.max.x, this.min.y);
		},
	
		// @method getTopLeft(): Point
		// Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
		getTopLeft: function () {
			return this.min; // left, top
		},
	
		// @method getBottomRight(): Point
		// Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
		getBottomRight: function () {
			return this.max; // right, bottom
		},
	
		// @method getSize(): Point
		// Returns the size of the given bounds
		getSize: function () {
			return this.max.subtract(this.min);
		},
	
		// @method contains(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle contains the given one.
		// @alternative
		// @method contains(point: Point): Boolean
		// Returns `true` if the rectangle contains the given point.
		contains: function (obj) {
			var min, max;
	
			if (typeof obj[0] === 'number' || obj instanceof Point) {
				obj = toPoint(obj);
			} else {
				obj = toBounds(obj);
			}
	
			if (obj instanceof Bounds) {
				min = obj.min;
				max = obj.max;
			} else {
				min = max = obj;
			}
	
			return (min.x >= this.min.x) &&
			       (max.x <= this.max.x) &&
			       (min.y >= this.min.y) &&
			       (max.y <= this.max.y);
		},
	
		// @method intersects(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle intersects the given bounds. Two bounds
		// intersect if they have at least one point in common.
		intersects: function (bounds) { // (Bounds) -> Boolean
			bounds = toBounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
			    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);
	
			return xIntersects && yIntersects;
		},
	
		// @method overlaps(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle overlaps the given bounds. Two bounds
		// overlap if their intersection is an area.
		overlaps: function (bounds) { // (Bounds) -> Boolean
			bounds = toBounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xOverlaps = (max2.x > min.x) && (min2.x < max.x),
			    yOverlaps = (max2.y > min.y) && (min2.y < max.y);
	
			return xOverlaps && yOverlaps;
		},
	
		isValid: function () {
			return !!(this.min && this.max);
		}
	};
	
	
	// @factory L.bounds(corner1: Point, corner2: Point)
	// Creates a Bounds object from two corners coordinate pairs.
	// @alternative
	// @factory L.bounds(points: Point[])
	// Creates a Bounds object from the given array of points.
	function toBounds(a, b) {
		if (!a || a instanceof Bounds) {
			return a;
		}
		return new Bounds(a, b);
	}
	
	/*
	 * @class LatLngBounds
	 * @aka L.LatLngBounds
	 *
	 * Represents a rectangular geographical area on a map.
	 *
	 * @example
	 *
	 * ```js
	 * var corner1 = L.latLng(40.712, -74.227),
	 * corner2 = L.latLng(40.774, -74.125),
	 * bounds = L.latLngBounds(corner1, corner2);
	 * ```
	 *
	 * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	 *
	 * ```js
	 * map.fitBounds([
	 * 	[40.712, -74.227],
	 * 	[40.774, -74.125]
	 * ]);
	 * ```
	 *
	 * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
	 */
	
	function LatLngBounds(corner1, corner2) { // (LatLng, LatLng) or (LatLng[])
		if (!corner1) { return; }
	
		var latlngs = corner2 ? [corner1, corner2] : corner1;
	
		for (var i = 0, len = latlngs.length; i < len; i++) {
			this.extend(latlngs[i]);
		}
	}
	
	LatLngBounds.prototype = {
	
		// @method extend(latlng: LatLng): this
		// Extend the bounds to contain the given point
	
		// @alternative
		// @method extend(otherBounds: LatLngBounds): this
		// Extend the bounds to contain the given bounds
		extend: function (obj) {
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof LatLng) {
				sw2 = obj;
				ne2 = obj;
	
			} else if (obj instanceof LatLngBounds) {
				sw2 = obj._southWest;
				ne2 = obj._northEast;
	
				if (!sw2 || !ne2) { return this; }
	
			} else {
				return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
			}
	
			if (!sw && !ne) {
				this._southWest = new LatLng(sw2.lat, sw2.lng);
				this._northEast = new LatLng(ne2.lat, ne2.lng);
			} else {
				sw.lat = Math.min(sw2.lat, sw.lat);
				sw.lng = Math.min(sw2.lng, sw.lng);
				ne.lat = Math.max(ne2.lat, ne.lat);
				ne.lng = Math.max(ne2.lng, ne.lng);
			}
	
			return this;
		},
	
		// @method pad(bufferRatio: Number): LatLngBounds
		// Returns bigger bounds created by extending the current bounds by a given percentage in each direction.
		pad: function (bufferRatio) {
			var sw = this._southWest,
			    ne = this._northEast,
			    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
			    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
	
			return new LatLngBounds(
			        new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
			        new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
		},
	
		// @method getCenter(): LatLng
		// Returns the center point of the bounds.
		getCenter: function () {
			return new LatLng(
			        (this._southWest.lat + this._northEast.lat) / 2,
			        (this._southWest.lng + this._northEast.lng) / 2);
		},
	
		// @method getSouthWest(): LatLng
		// Returns the south-west point of the bounds.
		getSouthWest: function () {
			return this._southWest;
		},
	
		// @method getNorthEast(): LatLng
		// Returns the north-east point of the bounds.
		getNorthEast: function () {
			return this._northEast;
		},
	
		// @method getNorthWest(): LatLng
		// Returns the north-west point of the bounds.
		getNorthWest: function () {
			return new LatLng(this.getNorth(), this.getWest());
		},
	
		// @method getSouthEast(): LatLng
		// Returns the south-east point of the bounds.
		getSouthEast: function () {
			return new LatLng(this.getSouth(), this.getEast());
		},
	
		// @method getWest(): Number
		// Returns the west longitude of the bounds
		getWest: function () {
			return this._southWest.lng;
		},
	
		// @method getSouth(): Number
		// Returns the south latitude of the bounds
		getSouth: function () {
			return this._southWest.lat;
		},
	
		// @method getEast(): Number
		// Returns the east longitude of the bounds
		getEast: function () {
			return this._northEast.lng;
		},
	
		// @method getNorth(): Number
		// Returns the north latitude of the bounds
		getNorth: function () {
			return this._northEast.lat;
		},
	
		// @method contains(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle contains the given one.
	
		// @alternative
		// @method contains (latlng: LatLng): Boolean
		// Returns `true` if the rectangle contains the given point.
		contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
			if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) {
				obj = toLatLng(obj);
			} else {
				obj = toLatLngBounds(obj);
			}
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof LatLngBounds) {
				sw2 = obj.getSouthWest();
				ne2 = obj.getNorthEast();
			} else {
				sw2 = ne2 = obj;
			}
	
			return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
			       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
		},
	
		// @method intersects(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
		intersects: function (bounds) {
			bounds = toLatLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
			    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);
	
			return latIntersects && lngIntersects;
		},
	
		// @method overlaps(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
		overlaps: function (bounds) {
			bounds = toLatLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latOverlaps = (ne2.lat > sw.lat) && (sw2.lat < ne.lat),
			    lngOverlaps = (ne2.lng > sw.lng) && (sw2.lng < ne.lng);
	
			return latOverlaps && lngOverlaps;
		},
	
		// @method toBBoxString(): String
		// Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
		toBBoxString: function () {
			return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
		},
	
		// @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
		// Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overriden by setting `maxMargin` to a small number.
		equals: function (bounds, maxMargin) {
			if (!bounds) { return false; }
	
			bounds = toLatLngBounds(bounds);
	
			return this._southWest.equals(bounds.getSouthWest(), maxMargin) &&
			       this._northEast.equals(bounds.getNorthEast(), maxMargin);
		},
	
		// @method isValid(): Boolean
		// Returns `true` if the bounds are properly initialized.
		isValid: function () {
			return !!(this._southWest && this._northEast);
		}
	};
	
	// TODO International date line?
	
	// @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
	// Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
	
	// @alternative
	// @factory L.latLngBounds(latlngs: LatLng[])
	// Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
	function toLatLngBounds(a, b) {
		if (a instanceof LatLngBounds) {
			return a;
		}
		return new LatLngBounds(a, b);
	}
	
	/* @class LatLng
	 * @aka L.LatLng
	 *
	 * Represents a geographical point with a certain latitude and longitude.
	 *
	 * @example
	 *
	 * ```
	 * var latlng = L.latLng(50.5, 30.5);
	 * ```
	 *
	 * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
	 *
	 * ```
	 * map.panTo([50, 30]);
	 * map.panTo({lon: 30, lat: 50});
	 * map.panTo({lat: 50, lng: 30});
	 * map.panTo(L.latLng(50, 30));
	 * ```
	 */
	
	function LatLng(lat, lng, alt) {
		if (isNaN(lat) || isNaN(lng)) {
			throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
		}
	
		// @property lat: Number
		// Latitude in degrees
		this.lat = +lat;
	
		// @property lng: Number
		// Longitude in degrees
		this.lng = +lng;
	
		// @property alt: Number
		// Altitude in meters (optional)
		if (alt !== undefined) {
			this.alt = +alt;
		}
	}
	
	LatLng.prototype = {
		// @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
		// Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overriden by setting `maxMargin` to a small number.
		equals: function (obj, maxMargin) {
			if (!obj) { return false; }
	
			obj = toLatLng(obj);
	
			var margin = Math.max(
			        Math.abs(this.lat - obj.lat),
			        Math.abs(this.lng - obj.lng));
	
			return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
		},
	
		// @method toString(): String
		// Returns a string representation of the point (for debugging purposes).
		toString: function (precision) {
			return 'LatLng(' +
			        formatNum(this.lat, precision) + ', ' +
			        formatNum(this.lng, precision) + ')';
		},
	
		// @method distanceTo(otherLatLng: LatLng): Number
		// Returns the distance (in meters) to the given `LatLng` calculated using the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula).
		distanceTo: function (other) {
			return Earth.distance(this, toLatLng(other));
		},
	
		// @method wrap(): LatLng
		// Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
		wrap: function () {
			return Earth.wrapLatLng(this);
		},
	
		// @method toBounds(sizeInMeters: Number): LatLngBounds
		// Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
		toBounds: function (sizeInMeters) {
			var latAccuracy = 180 * sizeInMeters / 40075017,
			    lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * this.lat);
	
			return toLatLngBounds(
			        [this.lat - latAccuracy, this.lng - lngAccuracy],
			        [this.lat + latAccuracy, this.lng + lngAccuracy]);
		},
	
		clone: function () {
			return new LatLng(this.lat, this.lng, this.alt);
		}
	};
	
	
	
	// @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
	// Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
	
	// @alternative
	// @factory L.latLng(coords: Array): LatLng
	// Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
	
	// @alternative
	// @factory L.latLng(coords: Object): LatLng
	// Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
	
	function toLatLng(a, b, c) {
		if (a instanceof LatLng) {
			return a;
		}
		if (isArray(a) && typeof a[0] !== 'object') {
			if (a.length === 3) {
				return new LatLng(a[0], a[1], a[2]);
			}
			if (a.length === 2) {
				return new LatLng(a[0], a[1]);
			}
			return null;
		}
		if (a === undefined || a === null) {
			return a;
		}
		if (typeof a === 'object' && 'lat' in a) {
			return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
		}
		if (b === undefined) {
			return null;
		}
		return new LatLng(a, b, c);
	}
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Base
	 * Object that defines coordinate reference systems for projecting
	 * geographical points into pixel (screen) coordinates and back (and to
	 * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
	 * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
	 *
	 * Leaflet defines the most usual CRSs by default. If you want to use a
	 * CRS not defined by default, take a look at the
	 * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
	 */
	
	var CRS = {
		// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
		// Projects geographical coordinates into pixel coordinates for a given zoom.
		latLngToPoint: function (latlng, zoom) {
			var projectedPoint = this.projection.project(latlng),
			    scale = this.scale(zoom);
	
			return this.transformation._transform(projectedPoint, scale);
		},
	
		// @method pointToLatLng(point: Point, zoom: Number): LatLng
		// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
		// zoom into geographical coordinates.
		pointToLatLng: function (point, zoom) {
			var scale = this.scale(zoom),
			    untransformedPoint = this.transformation.untransform(point, scale);
	
			return this.projection.unproject(untransformedPoint);
		},
	
		// @method project(latlng: LatLng): Point
		// Projects geographical coordinates into coordinates in units accepted for
		// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
		project: function (latlng) {
			return this.projection.project(latlng);
		},
	
		// @method unproject(point: Point): LatLng
		// Given a projected coordinate returns the corresponding LatLng.
		// The inverse of `project`.
		unproject: function (point) {
			return this.projection.unproject(point);
		},
	
		// @method scale(zoom: Number): Number
		// Returns the scale used when transforming projected coordinates into
		// pixel coordinates for a particular zoom. For example, it returns
		// `256 * 2^zoom` for Mercator-based CRS.
		scale: function (zoom) {
			return 256 * Math.pow(2, zoom);
		},
	
		// @method zoom(scale: Number): Number
		// Inverse of `scale()`, returns the zoom level corresponding to a scale
		// factor of `scale`.
		zoom: function (scale) {
			return Math.log(scale / 256) / Math.LN2;
		},
	
		// @method getProjectedBounds(zoom: Number): Bounds
		// Returns the projection's bounds scaled and transformed for the provided `zoom`.
		getProjectedBounds: function (zoom) {
			if (this.infinite) { return null; }
	
			var b = this.projection.bounds,
			    s = this.scale(zoom),
			    min = this.transformation.transform(b.min, s),
			    max = this.transformation.transform(b.max, s);
	
			return new Bounds(min, max);
		},
	
		// @method distance(latlng1: LatLng, latlng2: LatLng): Number
		// Returns the distance between two geographical coordinates.
	
		// @property code: String
		// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
		//
		// @property wrapLng: Number[]
		// An array of two numbers defining whether the longitude (horizontal) coordinate
		// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
		// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
		//
		// @property wrapLat: Number[]
		// Like `wrapLng`, but for the latitude (vertical) axis.
	
		// wrapLng: [min, max],
		// wrapLat: [min, max],
	
		// @property infinite: Boolean
		// If true, the coordinate space will be unbounded (infinite in both axes)
		infinite: false,
	
		// @method wrapLatLng(latlng: LatLng): LatLng
		// Returns a `LatLng` where lat and lng has been wrapped according to the
		// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
		wrapLatLng: function (latlng) {
			var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
			    lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
			    alt = latlng.alt;
	
			return new LatLng(lat, lng, alt);
		},
	
		// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
		// Returns a `LatLngBounds` with the same size as the given one, ensuring
		// that its center is within the CRS's bounds.
		// Only accepts actual `L.LatLngBounds` instances, not arrays.
		wrapLatLngBounds: function (bounds) {
			var center = bounds.getCenter(),
			    newCenter = this.wrapLatLng(center),
			    latShift = center.lat - newCenter.lat,
			    lngShift = center.lng - newCenter.lng;
	
			if (latShift === 0 && lngShift === 0) {
				return bounds;
			}
	
			var sw = bounds.getSouthWest(),
			    ne = bounds.getNorthEast(),
			    newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift),
			    newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
	
			return new LatLngBounds(newSw, newNe);
		}
	};
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Earth
	 *
	 * Serves as the base for CRS that are global such that they cover the earth.
	 * Can only be used as the base for other CRS and cannot be used directly,
	 * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
	 * meters.
	 */
	
	var Earth = extend({}, CRS, {
		wrapLng: [-180, 180],
	
		// Mean Earth Radius, as recommended for use by
		// the International Union of Geodesy and Geophysics,
		// see http://rosettacode.org/wiki/Haversine_formula
		R: 6371000,
	
		// distance between two geographical points using spherical law of cosines approximation
		distance: function (latlng1, latlng2) {
			var rad = Math.PI / 180,
			    lat1 = latlng1.lat * rad,
			    lat2 = latlng2.lat * rad,
			    a = Math.sin(lat1) * Math.sin(lat2) +
			        Math.cos(lat1) * Math.cos(lat2) * Math.cos((latlng2.lng - latlng1.lng) * rad);
	
			return this.R * Math.acos(Math.min(a, 1));
		}
	});
	
	/*
	 * @namespace Projection
	 * @projection L.Projection.SphericalMercator
	 *
	 * Spherical Mercator projection — the most common projection for online maps,
	 * used by almost all free and commercial tile providers. Assumes that Earth is
	 * a sphere. Used by the `EPSG:3857` CRS.
	 */
	
	var SphericalMercator = {
	
		R: 6378137,
		MAX_LATITUDE: 85.0511287798,
	
		project: function (latlng) {
			var d = Math.PI / 180,
			    max = this.MAX_LATITUDE,
			    lat = Math.max(Math.min(max, latlng.lat), -max),
			    sin = Math.sin(lat * d);
	
			return new Point(
					this.R * latlng.lng * d,
					this.R * Math.log((1 + sin) / (1 - sin)) / 2);
		},
	
		unproject: function (point) {
			var d = 180 / Math.PI;
	
			return new LatLng(
				(2 * Math.atan(Math.exp(point.y / this.R)) - (Math.PI / 2)) * d,
				point.x * d / this.R);
		},
	
		bounds: (function () {
			var d = 6378137 * Math.PI;
			return new Bounds([-d, -d], [d, d]);
		})()
	};
	
	/*
	 * @class Transformation
	 * @aka L.Transformation
	 *
	 * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
	 * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
	 * the reverse. Used by Leaflet in its projections code.
	 *
	 * @example
	 *
	 * ```js
	 * var transformation = L.transformation(2, 5, -1, 10),
	 * 	p = L.point(1, 2),
	 * 	p2 = transformation.transform(p), //  L.point(7, 8)
	 * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
	 * ```
	 */
	
	
	// factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
	// Creates a `Transformation` object with the given coefficients.
	function Transformation(a, b, c, d) {
		if (isArray(a)) {
			// use array properties
			this._a = a[0];
			this._b = a[1];
			this._c = a[2];
			this._d = a[3];
			return;
		}
		this._a = a;
		this._b = b;
		this._c = c;
		this._d = d;
	}
	
	Transformation.prototype = {
		// @method transform(point: Point, scale?: Number): Point
		// Returns a transformed point, optionally multiplied by the given scale.
		// Only accepts actual `L.Point` instances, not arrays.
		transform: function (point, scale) { // (Point, Number) -> Point
			return this._transform(point.clone(), scale);
		},
	
		// destructive transform (faster)
		_transform: function (point, scale) {
			scale = scale || 1;
			point.x = scale * (this._a * point.x + this._b);
			point.y = scale * (this._c * point.y + this._d);
			return point;
		},
	
		// @method untransform(point: Point, scale?: Number): Point
		// Returns the reverse transformation of the given point, optionally divided
		// by the given scale. Only accepts actual `L.Point` instances, not arrays.
		untransform: function (point, scale) {
			scale = scale || 1;
			return new Point(
			        (point.x / scale - this._b) / this._a,
			        (point.y / scale - this._d) / this._c);
		}
	};
	
	// factory L.transformation(a: Number, b: Number, c: Number, d: Number)
	
	// @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
	// Instantiates a Transformation object with the given coefficients.
	
	// @alternative
	// @factory L.transformation(coefficients: Array): Transformation
	// Expects an coeficients array of the form
	// `[a: Number, b: Number, c: Number, d: Number]`.
	
	function toTransformation(a, b, c, d) {
		return new Transformation(a, b, c, d);
	}
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG3857
	 *
	 * The most common CRS for online maps, used by almost all free and commercial
	 * tile providers. Uses Spherical Mercator projection. Set in by default in
	 * Map's `crs` option.
	 */
	
	var EPSG3857 = extend({}, Earth, {
		code: 'EPSG:3857',
		projection: SphericalMercator,
	
		transformation: (function () {
			var scale = 0.5 / (Math.PI * SphericalMercator.R);
			return toTransformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	var EPSG900913 = extend({}, EPSG3857, {
		code: 'EPSG:900913'
	});
	
	// @namespace SVG; @section
	// There are several static functions which can be called without instantiating L.SVG:
	
	// @function create(name: String): SVGElement
	// Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
	// corresponding to the class name passed. For example, using 'line' will return
	// an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
	function svgCreate(name) {
		return document.createElementNS('http://www.w3.org/2000/svg', name);
	}
	
	// @function pointsToPath(rings: Point[], closed: Boolean): String
	// Generates a SVG path string for multiple rings, with each ring turning
	// into "M..L..L.." instructions
	function pointsToPath(rings, closed) {
		var str = '',
		i, j, len, len2, points, p;
	
		for (i = 0, len = rings.length; i < len; i++) {
			points = rings[i];
	
			for (j = 0, len2 = points.length; j < len2; j++) {
				p = points[j];
				str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
			}
	
			// closes the ring for polygons; "x" is VML syntax
			str += closed ? (svg ? 'z' : 'x') : '';
		}
	
		// SVG complains about empty path strings
		return str || 'M0 0';
	}
	
	/*
	 * @namespace Browser
	 * @aka L.Browser
	 *
	 * A namespace with static properties for browser/feature detection used by Leaflet internally.
	 *
	 * @example
	 *
	 * ```js
	 * if (L.Browser.ielt9) {
	 *   alert('Upgrade your browser, dude!');
	 * }
	 * ```
	 */
	
	var style$1 = document.documentElement.style;
	
	// @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
	var ie = 'ActiveXObject' in window;
	
	// @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
	var ielt9 = ie && !document.addEventListener;
	
	// @property edge: Boolean; `true` for the Edge web browser.
	var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
	
	// @property webkit: Boolean;
	// `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
	var webkit = userAgentContains('webkit');
	
	// @property android: Boolean
	// `true` for any browser running on an Android platform.
	var android = userAgentContains('android');
	
	// @property android23: Boolean; `true` for browsers running on Android 2 or Android 3.
	var android23 = userAgentContains('android 2') || userAgentContains('android 3');
	
	// @property opera: Boolean; `true` for the Opera browser
	var opera = !!window.opera;
	
	// @property chrome: Boolean; `true` for the Chrome browser.
	var chrome = userAgentContains('chrome');
	
	// @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
	var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
	
	// @property safari: Boolean; `true` for the Safari browser.
	var safari = !chrome && userAgentContains('safari');
	
	var phantom = userAgentContains('phantom');
	
	// @property opera12: Boolean
	// `true` for the Opera browser supporting CSS transforms (version 12 or later).
	var opera12 = 'OTransition' in style$1;
	
	// @property win: Boolean; `true` when the browser is running in a Windows platform
	var win = navigator.platform.indexOf('Win') === 0;
	
	// @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
	var ie3d = ie && ('transition' in style$1);
	
	// @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
	var webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23;
	
	// @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
	var gecko3d = 'MozPerspective' in style$1;
	
	// @property any3d: Boolean
	// `true` for all browsers supporting CSS transforms.
	var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
	
	// @property mobile: Boolean; `true` for all browsers running in a mobile device.
	var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
	
	// @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
	var mobileWebkit = mobile && webkit;
	
	// @property mobileWebkit3d: Boolean
	// `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
	var mobileWebkit3d = mobile && webkit3d;
	
	// @property msPointer: Boolean
	// `true` for browsers implementing the Microsoft touch events model (notably IE10).
	var msPointer = !window.PointerEvent && window.MSPointerEvent;
	
	// @property pointer: Boolean
	// `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
	var pointer = !!(window.PointerEvent || msPointer);
	
	// @property touch: Boolean
	// `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
	// This does not necessarily mean that the browser is running in a computer with
	// a touchscreen, it only means that the browser is capable of understanding
	// touch events.
	var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window ||
			(window.DocumentTouch && document instanceof window.DocumentTouch));
	
	// @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
	var mobileOpera = mobile && opera;
	
	// @property mobileGecko: Boolean
	// `true` for gecko-based browsers running in a mobile device.
	var mobileGecko = mobile && gecko;
	
	// @property retina: Boolean
	// `true` for browsers on a high-resolution "retina" screen.
	var retina = (window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI)) > 1;
	
	
	// @property canvas: Boolean
	// `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	var canvas = (function () {
		return !!document.createElement('canvas').getContext;
	}());
	
	// @property svg: Boolean
	// `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
	var svg = !!(document.createElementNS && svgCreate('svg').createSVGRect);
	
	// @property vml: Boolean
	// `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
	var vml = !svg && (function () {
		try {
			var div = document.createElement('div');
			div.innerHTML = '<v:shape adj="1"/>';
	
			var shape = div.firstChild;
			shape.style.behavior = 'url(#default#VML)';
	
			return shape && (typeof shape.adj === 'object');
	
		} catch (e) {
			return false;
		}
	}());
	
	
	function userAgentContains(str) {
		return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
	}
	
	
	var Browser = (Object.freeze || Object)({
		ie: ie,
		ielt9: ielt9,
		edge: edge,
		webkit: webkit,
		android: android,
		android23: android23,
		opera: opera,
		chrome: chrome,
		gecko: gecko,
		safari: safari,
		phantom: phantom,
		opera12: opera12,
		win: win,
		ie3d: ie3d,
		webkit3d: webkit3d,
		gecko3d: gecko3d,
		any3d: any3d,
		mobile: mobile,
		mobileWebkit: mobileWebkit,
		mobileWebkit3d: mobileWebkit3d,
		msPointer: msPointer,
		pointer: pointer,
		touch: touch,
		mobileOpera: mobileOpera,
		mobileGecko: mobileGecko,
		retina: retina,
		canvas: canvas,
		svg: svg,
		vml: vml
	});
	
	/*
	 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
	 */
	
	
	var POINTER_DOWN =   msPointer ? 'MSPointerDown'   : 'pointerdown';
	var POINTER_MOVE =   msPointer ? 'MSPointerMove'   : 'pointermove';
	var POINTER_UP =     msPointer ? 'MSPointerUp'     : 'pointerup';
	var POINTER_CANCEL = msPointer ? 'MSPointerCancel' : 'pointercancel';
	var TAG_WHITE_LIST = ['INPUT', 'SELECT', 'OPTION'];
	var _pointers = {};
	var _pointerDocListener = false;
	
	// DomEvent.DoubleTap needs to know about this
	var _pointersCount = 0;
	
	// Provides a touch events wrapper for (ms)pointer events.
	// ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
	
	function addPointerListener(obj, type, handler, id) {
		if (type === 'touchstart') {
			_addPointerStart(obj, handler, id);
	
		} else if (type === 'touchmove') {
			_addPointerMove(obj, handler, id);
	
		} else if (type === 'touchend') {
			_addPointerEnd(obj, handler, id);
		}
	
		return this;
	}
	
	function removePointerListener(obj, type, id) {
		var handler = obj['_leaflet_' + type + id];
	
		if (type === 'touchstart') {
			obj.removeEventListener(POINTER_DOWN, handler, false);
	
		} else if (type === 'touchmove') {
			obj.removeEventListener(POINTER_MOVE, handler, false);
	
		} else if (type === 'touchend') {
			obj.removeEventListener(POINTER_UP, handler, false);
			obj.removeEventListener(POINTER_CANCEL, handler, false);
		}
	
		return this;
	}
	
	function _addPointerStart(obj, handler, id) {
		var onDown = bind(function (e) {
			if (e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
				// In IE11, some touch events needs to fire for form controls, or
				// the controls will stop working. We keep a whitelist of tag names that
				// need these events. For other target tags, we prevent default on the event.
				if (TAG_WHITE_LIST.indexOf(e.target.tagName) < 0) {
					preventDefault(e);
				} else {
					return;
				}
			}
	
			_handlePointer(e, handler);
		});
	
		obj['_leaflet_touchstart' + id] = onDown;
		obj.addEventListener(POINTER_DOWN, onDown, false);
	
		// need to keep track of what pointers and how many are active to provide e.touches emulation
		if (!_pointerDocListener) {
			// we listen documentElement as any drags that end by moving the touch off the screen get fired there
			document.documentElement.addEventListener(POINTER_DOWN, _globalPointerDown, true);
			document.documentElement.addEventListener(POINTER_MOVE, _globalPointerMove, true);
			document.documentElement.addEventListener(POINTER_UP, _globalPointerUp, true);
			document.documentElement.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
	
			_pointerDocListener = true;
		}
	}
	
	function _globalPointerDown(e) {
		_pointers[e.pointerId] = e;
		_pointersCount++;
	}
	
	function _globalPointerMove(e) {
		if (_pointers[e.pointerId]) {
			_pointers[e.pointerId] = e;
		}
	}
	
	function _globalPointerUp(e) {
		delete _pointers[e.pointerId];
		_pointersCount--;
	}
	
	function _handlePointer(e, handler) {
		e.touches = [];
		for (var i in _pointers) {
			e.touches.push(_pointers[i]);
		}
		e.changedTouches = [e];
	
		handler(e);
	}
	
	function _addPointerMove(obj, handler, id) {
		var onMove = function (e) {
			// don't fire touch moves when mouse isn't down
			if ((e.pointerType === e.MSPOINTER_TYPE_MOUSE || e.pointerType === 'mouse') && e.buttons === 0) { return; }
	
			_handlePointer(e, handler);
		};
	
		obj['_leaflet_touchmove' + id] = onMove;
		obj.addEventListener(POINTER_MOVE, onMove, false);
	}
	
	function _addPointerEnd(obj, handler, id) {
		var onUp = function (e) {
			_handlePointer(e, handler);
		};
	
		obj['_leaflet_touchend' + id] = onUp;
		obj.addEventListener(POINTER_UP, onUp, false);
		obj.addEventListener(POINTER_CANCEL, onUp, false);
	}
	
	/*
	 * Extends the event handling code with double tap support for mobile browsers.
	 */
	
	var _touchstart = msPointer ? 'MSPointerDown' : pointer ? 'pointerdown' : 'touchstart';
	var _touchend = msPointer ? 'MSPointerUp' : pointer ? 'pointerup' : 'touchend';
	var _pre = '_leaflet_';
	
	// inspired by Zepto touch code by Thomas Fuchs
	function addDoubleTapListener(obj, handler, id) {
		var last, touch$$1,
		    doubleTap = false,
		    delay = 250;
	
		function onTouchStart(e) {
			var count;
	
			if (pointer) {
				if ((!edge) || e.pointerType === 'mouse') { return; }
				count = _pointersCount;
			} else {
				count = e.touches.length;
			}
	
			if (count > 1) { return; }
	
			var now = Date.now(),
			    delta = now - (last || now);
	
			touch$$1 = e.touches ? e.touches[0] : e;
			doubleTap = (delta > 0 && delta <= delay);
			last = now;
		}
	
		function onTouchEnd(e) {
			if (doubleTap && !touch$$1.cancelBubble) {
				if (pointer) {
					if ((!edge) || e.pointerType === 'mouse') { return; }
					// work around .type being readonly with MSPointer* events
					var newTouch = {},
					    prop, i;
	
					for (i in touch$$1) {
						prop = touch$$1[i];
						newTouch[i] = prop && prop.bind ? prop.bind(touch$$1) : prop;
					}
					touch$$1 = newTouch;
				}
				touch$$1.type = 'dblclick';
				handler(touch$$1);
				last = null;
			}
		}
	
		obj[_pre + _touchstart + id] = onTouchStart;
		obj[_pre + _touchend + id] = onTouchEnd;
		obj[_pre + 'dblclick' + id] = handler;
	
		obj.addEventListener(_touchstart, onTouchStart, false);
		obj.addEventListener(_touchend, onTouchEnd, false);
	
		// On some platforms (notably, chrome<55 on win10 + touchscreen + mouse),
		// the browser doesn't fire touchend/pointerup events but does fire
		// native dblclicks. See #4127.
		// Edge 14 also fires native dblclicks, but only for pointerType mouse, see #5180.
		obj.addEventListener('dblclick', handler, false);
	
		return this;
	}
	
	function removeDoubleTapListener(obj, id) {
		var touchstart = obj[_pre + _touchstart + id],
		    touchend = obj[_pre + _touchend + id],
		    dblclick = obj[_pre + 'dblclick' + id];
	
		obj.removeEventListener(_touchstart, touchstart, false);
		obj.removeEventListener(_touchend, touchend, false);
		if (!edge) {
			obj.removeEventListener('dblclick', dblclick, false);
		}
	
		return this;
	}
	
	/*
	 * @namespace DomEvent
	 * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
	 */
	
	// Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
	
	// @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
	// Adds a listener function (`fn`) to a particular DOM event type of the
	// element `el`. You can optionally specify the context of the listener
	// (object the `this` keyword will point to). You can also pass several
	// space-separated types (e.g. `'click dblclick'`).
	
	// @alternative
	// @function on(el: HTMLElement, eventMap: Object, context?: Object): this
	// Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	function on(obj, types, fn, context) {
	
		if (typeof types === 'object') {
			for (var type in types) {
				addOne(obj, type, types[type], fn);
			}
		} else {
			types = splitWords(types);
	
			for (var i = 0, len = types.length; i < len; i++) {
				addOne(obj, types[i], fn, context);
			}
		}
	
		return this;
	}
	
	var eventsKey = '_leaflet_events';
	
	// @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
	// Removes a previously added listener function. If no function is specified,
	// it will remove all the listeners of that particular DOM event from the element.
	// Note that if you passed a custom context to on, you must pass the same
	// context to `off` in order to remove the listener.
	
	// @alternative
	// @function off(el: HTMLElement, eventMap: Object, context?: Object): this
	// Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	
	// @alternative
	// @function off(el: HTMLElement): this
	// Removes all known event listeners
	function off(obj, types, fn, context) {
	
		if (typeof types === 'object') {
			for (var type in types) {
				removeOne(obj, type, types[type], fn);
			}
		} else if (types) {
			types = splitWords(types);
	
			for (var i = 0, len = types.length; i < len; i++) {
				removeOne(obj, types[i], fn, context);
			}
		} else {
			for (var j in obj[eventsKey]) {
				removeOne(obj, j, obj[eventsKey][j]);
			}
			delete obj[eventsKey];
		}
	
		return this;
	}
	
	function addOne(obj, type, fn, context) {
		var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
	
		if (obj[eventsKey] && obj[eventsKey][id]) { return this; }
	
		var handler = function (e) {
			return fn.call(context || obj, e || window.event);
		};
	
		var originalHandler = handler;
	
		if (pointer && type.indexOf('touch') === 0) {
			// Needs DomEvent.Pointer.js
			addPointerListener(obj, type, handler, id);
	
		} else if (touch && (type === 'dblclick') && addDoubleTapListener &&
		           !(pointer && chrome)) {
			// Chrome >55 does not need the synthetic dblclicks from addDoubleTapListener
			// See #5180
			addDoubleTapListener(obj, handler, id);
	
		} else if ('addEventListener' in obj) {
	
			if (type === 'mousewheel') {
				obj.addEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);
	
			} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
				handler = function (e) {
					e = e || window.event;
					if (isExternalTarget(obj, e)) {
						originalHandler(e);
					}
				};
				obj.addEventListener(type === 'mouseenter' ? 'mouseover' : 'mouseout', handler, false);
	
			} else {
				if (type === 'click' && android) {
					handler = function (e) {
						filterClick(e, originalHandler);
					};
				}
				obj.addEventListener(type, handler, false);
			}
	
		} else if ('attachEvent' in obj) {
			obj.attachEvent('on' + type, handler);
		}
	
		obj[eventsKey] = obj[eventsKey] || {};
		obj[eventsKey][id] = handler;
	}
	
	function removeOne(obj, type, fn, context) {
	
		var id = type + stamp(fn) + (context ? '_' + stamp(context) : ''),
		    handler = obj[eventsKey] && obj[eventsKey][id];
	
		if (!handler) { return this; }
	
		if (pointer && type.indexOf('touch') === 0) {
			removePointerListener(obj, type, id);
	
		} else if (touch && (type === 'dblclick') && removeDoubleTapListener) {
			removeDoubleTapListener(obj, id);
	
		} else if ('removeEventListener' in obj) {
	
			if (type === 'mousewheel') {
				obj.removeEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);
	
			} else {
				obj.removeEventListener(
					type === 'mouseenter' ? 'mouseover' :
					type === 'mouseleave' ? 'mouseout' : type, handler, false);
			}
	
		} else if ('detachEvent' in obj) {
			obj.detachEvent('on' + type, handler);
		}
	
		obj[eventsKey][id] = null;
	}
	
	// @function stopPropagation(ev: DOMEvent): this
	// Stop the given event from propagation to parent elements. Used inside the listener functions:
	// ```js
	// L.DomEvent.on(div, 'click', function (ev) {
	// 	L.DomEvent.stopPropagation(ev);
	// });
	// ```
	function stopPropagation(e) {
	
		if (e.stopPropagation) {
			e.stopPropagation();
		} else if (e.originalEvent) {  // In case of Leaflet event.
			e.originalEvent._stopped = true;
		} else {
			e.cancelBubble = true;
		}
		skipped(e);
	
		return this;
	}
	
	// @function disableScrollPropagation(el: HTMLElement): this
	// Adds `stopPropagation` to the element's `'mousewheel'` events (plus browser variants).
	function disableScrollPropagation(el) {
		addOne(el, 'mousewheel', stopPropagation);
		return this;
	}
	
	// @function disableClickPropagation(el: HTMLElement): this
	// Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
	// `'mousedown'` and `'touchstart'` events (plus browser variants).
	function disableClickPropagation(el) {
		on(el, 'mousedown touchstart dblclick', stopPropagation);
		addOne(el, 'click', fakeStop);
		return this;
	}
	
	// @function preventDefault(ev: DOMEvent): this
	// Prevents the default action of the DOM Event `ev` from happening (such as
	// following a link in the href of the a element, or doing a POST request
	// with page reload when a `<form>` is submitted).
	// Use it inside listener functions.
	function preventDefault(e) {
		if (e.preventDefault) {
			e.preventDefault();
		} else {
			e.returnValue = false;
		}
		return this;
	}
	
	// @function stop(ev): this
	// Does `stopPropagation` and `preventDefault` at the same time.
	function stop(e) {
		preventDefault(e);
		stopPropagation(e);
		return this;
	}
	
	// @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
	// Gets normalized mouse position from a DOM event relative to the
	// `container` or to the whole page if not specified.
	function getMousePosition(e, container) {
		if (!container) {
			return new Point(e.clientX, e.clientY);
		}
	
		var rect = container.getBoundingClientRect();
	
		return new Point(
			e.clientX - rect.left - container.clientLeft,
			e.clientY - rect.top - container.clientTop);
	}
	
	// Chrome on Win scrolls double the pixels as in other platforms (see #4538),
	// and Firefox scrolls device pixels, not CSS pixels
	var wheelPxFactor =
		(win && chrome) ? 2 * window.devicePixelRatio :
		gecko ? window.devicePixelRatio : 1;
	
	// @function getWheelDelta(ev: DOMEvent): Number
	// Gets normalized wheel delta from a mousewheel DOM event, in vertical
	// pixels scrolled (negative if scrolling down).
	// Events from pointing devices without precise scrolling are mapped to
	// a best guess of 60 pixels.
	function getWheelDelta(e) {
		return (edge) ? e.wheelDeltaY / 2 : // Don't trust window-geometry-based delta
		       (e.deltaY && e.deltaMode === 0) ? -e.deltaY / wheelPxFactor : // Pixels
		       (e.deltaY && e.deltaMode === 1) ? -e.deltaY * 20 : // Lines
		       (e.deltaY && e.deltaMode === 2) ? -e.deltaY * 60 : // Pages
		       (e.deltaX || e.deltaZ) ? 0 :	// Skip horizontal/depth wheel events
		       e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : // Legacy IE pixels
		       (e.detail && Math.abs(e.detail) < 32765) ? -e.detail * 20 : // Legacy Moz lines
		       e.detail ? e.detail / -32765 * 60 : // Legacy Moz pages
		       0;
	}
	
	var skipEvents = {};
	
	function fakeStop(e) {
		// fakes stopPropagation by setting a special event flag, checked/reset with skipped(e)
		skipEvents[e.type] = true;
	}
	
	function skipped(e) {
		var events = skipEvents[e.type];
		// reset when checking, as it's only used in map container and propagates outside of the map
		skipEvents[e.type] = false;
		return events;
	}
	
	// check if element really left/entered the event target (for mouseenter/mouseleave)
	function isExternalTarget(el, e) {
	
		var related = e.relatedTarget;
	
		if (!related) { return true; }
	
		try {
			while (related && (related !== el)) {
				related = related.parentNode;
			}
		} catch (err) {
			return false;
		}
		return (related !== el);
	}
	
	var lastClick;
	
	// this is a horrible workaround for a bug in Android where a single touch triggers two click events
	function filterClick(e, handler) {
		var timeStamp = (e.timeStamp || (e.originalEvent && e.originalEvent.timeStamp)),
		    elapsed = lastClick && (timeStamp - lastClick);
	
		// are they closer together than 500ms yet more than 100ms?
		// Android typically triggers them ~300ms apart while multiple listeners
		// on the same event should be triggered far faster;
		// or check if click is simulated on the element, and if it is, reject any non-simulated events
	
		if ((elapsed && elapsed > 100 && elapsed < 500) || (e.target._simulatedClick && !e._simulated)) {
			stop(e);
			return;
		}
		lastClick = timeStamp;
	
		handler(e);
	}
	
	
	
	
	var DomEvent = (Object.freeze || Object)({
		on: on,
		off: off,
		stopPropagation: stopPropagation,
		disableScrollPropagation: disableScrollPropagation,
		disableClickPropagation: disableClickPropagation,
		preventDefault: preventDefault,
		stop: stop,
		getMousePosition: getMousePosition,
		getWheelDelta: getWheelDelta,
		fakeStop: fakeStop,
		skipped: skipped,
		isExternalTarget: isExternalTarget,
		addListener: on,
		removeListener: off
	});
	
	/*
	 * @namespace DomUtil
	 *
	 * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
	 * tree, used by Leaflet internally.
	 *
	 * Most functions expecting or returning a `HTMLElement` also work for
	 * SVG elements. The only difference is that classes refer to CSS classes
	 * in HTML and SVG classes in SVG.
	 */
	
	
	// @property TRANSFORM: String
	// Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
	var TRANSFORM = testProp(
		['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
	
	// webkitTransition comes first because some browser versions that drop vendor prefix don't do
	// the same for the transitionend event, in particular the Android 4.1 stock browser
	
	// @property TRANSITION: String
	// Vendor-prefixed transition style name.
	var TRANSITION = testProp(
		['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);
	
	// @property TRANSITION_END: String
	// Vendor-prefixed transitionend event name.
	var TRANSITION_END =
		TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
	
	
	// @function get(id: String|HTMLElement): HTMLElement
	// Returns an element given its DOM id, or returns the element itself
	// if it was passed directly.
	function get(id) {
		return typeof id === 'string' ? document.getElementById(id) : id;
	}
	
	// @function getStyle(el: HTMLElement, styleAttrib: String): String
	// Returns the value for a certain style attribute on an element,
	// including computed values or values set through CSS.
	function getStyle(el, style) {
		var value = el.style[style] || (el.currentStyle && el.currentStyle[style]);
	
		if ((!value || value === 'auto') && document.defaultView) {
			var css = document.defaultView.getComputedStyle(el, null);
			value = css ? css[style] : null;
		}
		return value === 'auto' ? null : value;
	}
	
	// @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
	// Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
	function create$1(tagName, className, container) {
		var el = document.createElement(tagName);
		el.className = className || '';
	
		if (container) {
			container.appendChild(el);
		}
		return el;
	}
	
	// @function remove(el: HTMLElement)
	// Removes `el` from its parent element
	function remove(el) {
		var parent = el.parentNode;
		if (parent) {
			parent.removeChild(el);
		}
	}
	
	// @function empty(el: HTMLElement)
	// Removes all of `el`'s children elements from `el`
	function empty(el) {
		while (el.firstChild) {
			el.removeChild(el.firstChild);
		}
	}
	
	// @function toFront(el: HTMLElement)
	// Makes `el` the last child of its parent, so it renders in front of the other children.
	function toFront(el) {
		var parent = el.parentNode;
		if (parent.lastChild !== el) {
			parent.appendChild(el);
		}
	}
	
	// @function toBack(el: HTMLElement)
	// Makes `el` the first child of its parent, so it renders behind the other children.
	function toBack(el) {
		var parent = el.parentNode;
		if (parent.firstChild !== el) {
			parent.insertBefore(el, parent.firstChild);
		}
	}
	
	// @function hasClass(el: HTMLElement, name: String): Boolean
	// Returns `true` if the element's class attribute contains `name`.
	function hasClass(el, name) {
		if (el.classList !== undefined) {
			return el.classList.contains(name);
		}
		var className = getClass(el);
		return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
	}
	
	// @function addClass(el: HTMLElement, name: String)
	// Adds `name` to the element's class attribute.
	function addClass(el, name) {
		if (el.classList !== undefined) {
			var classes = splitWords(name);
			for (var i = 0, len = classes.length; i < len; i++) {
				el.classList.add(classes[i]);
			}
		} else if (!hasClass(el, name)) {
			var className = getClass(el);
			setClass(el, (className ? className + ' ' : '') + name);
		}
	}
	
	// @function removeClass(el: HTMLElement, name: String)
	// Removes `name` from the element's class attribute.
	function removeClass(el, name) {
		if (el.classList !== undefined) {
			el.classList.remove(name);
		} else {
			setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
		}
	}
	
	// @function setClass(el: HTMLElement, name: String)
	// Sets the element's class.
	function setClass(el, name) {
		if (el.className.baseVal === undefined) {
			el.className = name;
		} else {
			// in case of SVG element
			el.className.baseVal = name;
		}
	}
	
	// @function getClass(el: HTMLElement): String
	// Returns the element's class.
	function getClass(el) {
		return el.className.baseVal === undefined ? el.className : el.className.baseVal;
	}
	
	// @function setOpacity(el: HTMLElement, opacity: Number)
	// Set the opacity of an element (including old IE support).
	// `opacity` must be a number from `0` to `1`.
	function setOpacity(el, value) {
		if ('opacity' in el.style) {
			el.style.opacity = value;
		} else if ('filter' in el.style) {
			_setOpacityIE(el, value);
		}
	}
	
	function _setOpacityIE(el, value) {
		var filter = false,
		    filterName = 'DXImageTransform.Microsoft.Alpha';
	
		// filters collection throws an error if we try to retrieve a filter that doesn't exist
		try {
			filter = el.filters.item(filterName);
		} catch (e) {
			// don't set opacity to 1 if we haven't already set an opacity,
			// it isn't needed and breaks transparent pngs.
			if (value === 1) { return; }
		}
	
		value = Math.round(value * 100);
	
		if (filter) {
			filter.Enabled = (value !== 100);
			filter.Opacity = value;
		} else {
			el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
		}
	}
	
	// @function testProp(props: String[]): String|false
	// Goes through the array of style names and returns the first name
	// that is a valid style name for an element. If no such name is found,
	// it returns false. Useful for vendor-prefixed styles like `transform`.
	function testProp(props) {
		var style = document.documentElement.style;
	
		for (var i = 0; i < props.length; i++) {
			if (props[i] in style) {
				return props[i];
			}
		}
		return false;
	}
	
	// @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
	// Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
	// and optionally scaled by `scale`. Does not have an effect if the
	// browser doesn't support 3D CSS transforms.
	function setTransform(el, offset, scale) {
		var pos = offset || new Point(0, 0);
	
		el.style[TRANSFORM] =
			(ie3d ?
				'translate(' + pos.x + 'px,' + pos.y + 'px)' :
				'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') +
			(scale ? ' scale(' + scale + ')' : '');
	}
	
	// @function setPosition(el: HTMLElement, position: Point)
	// Sets the position of `el` to coordinates specified by `position`,
	// using CSS translate or top/left positioning depending on the browser
	// (used by Leaflet internally to position its layers).
	function setPosition(el, point) {
	
		/*eslint-disable */
		el._leaflet_pos = point;
		/*eslint-enable */
	
		if (any3d) {
			setTransform(el, point);
		} else {
			el.style.left = point.x + 'px';
			el.style.top = point.y + 'px';
		}
	}
	
	// @function getPosition(el: HTMLElement): Point
	// Returns the coordinates of an element previously positioned with setPosition.
	function getPosition(el) {
		// this method is only used for elements previously positioned using setPosition,
		// so it's safe to cache the position for performance
	
		return el._leaflet_pos || new Point(0, 0);
	}
	
	// @function disableTextSelection()
	// Prevents the user from generating `selectstart` DOM events, usually generated
	// when the user drags the mouse through a page with text. Used internally
	// by Leaflet to override the behaviour of any click-and-drag interaction on
	// the map. Affects drag interactions on the whole document.
	
	// @function enableTextSelection()
	// Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
	var disableTextSelection;
	var enableTextSelection;
	var _userSelect;
	if ('onselectstart' in document) {
		disableTextSelection = function () {
			on(window, 'selectstart', preventDefault);
		};
		enableTextSelection = function () {
			off(window, 'selectstart', preventDefault);
		};
	} else {
		var userSelectProperty = testProp(
			['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);
	
		disableTextSelection = function () {
			if (userSelectProperty) {
				var style = document.documentElement.style;
				_userSelect = style[userSelectProperty];
				style[userSelectProperty] = 'none';
			}
		};
		enableTextSelection = function () {
			if (userSelectProperty) {
				document.documentElement.style[userSelectProperty] = _userSelect;
				_userSelect = undefined;
			}
		};
	}
	
	// @function disableImageDrag()
	// As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
	// for `dragstart` DOM events, usually generated when the user drags an image.
	function disableImageDrag() {
		on(window, 'dragstart', preventDefault);
	}
	
	// @function enableImageDrag()
	// Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
	function enableImageDrag() {
		off(window, 'dragstart', preventDefault);
	}
	
	var _outlineElement;
	var _outlineStyle;
	// @function preventOutline(el: HTMLElement)
	// Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
	// of the element `el` invisible. Used internally by Leaflet to prevent
	// focusable elements from displaying an outline when the user performs a
	// drag interaction on them.
	function preventOutline(element) {
		while (element.tabIndex === -1) {
			element = element.parentNode;
		}
		if (!element.style) { return; }
		restoreOutline();
		_outlineElement = element;
		_outlineStyle = element.style.outline;
		element.style.outline = 'none';
		on(window, 'keydown', restoreOutline);
	}
	
	// @function restoreOutline()
	// Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
	function restoreOutline() {
		if (!_outlineElement) { return; }
		_outlineElement.style.outline = _outlineStyle;
		_outlineElement = undefined;
		_outlineStyle = undefined;
		off(window, 'keydown', restoreOutline);
	}
	
	
	var DomUtil = (Object.freeze || Object)({
		TRANSFORM: TRANSFORM,
		TRANSITION: TRANSITION,
		TRANSITION_END: TRANSITION_END,
		get: get,
		getStyle: getStyle,
		create: create$1,
		remove: remove,
		empty: empty,
		toFront: toFront,
		toBack: toBack,
		hasClass: hasClass,
		addClass: addClass,
		removeClass: removeClass,
		setClass: setClass,
		getClass: getClass,
		setOpacity: setOpacity,
		testProp: testProp,
		setTransform: setTransform,
		setPosition: setPosition,
		getPosition: getPosition,
		disableTextSelection: disableTextSelection,
		enableTextSelection: enableTextSelection,
		disableImageDrag: disableImageDrag,
		enableImageDrag: enableImageDrag,
		preventOutline: preventOutline,
		restoreOutline: restoreOutline
	});
	
	/*
	 * @class PosAnimation
	 * @aka L.PosAnimation
	 * @inherits Evented
	 * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
	 *
	 * @example
	 * ```js
	 * var fx = new L.PosAnimation();
	 * fx.run(el, [300, 500], 0.5);
	 * ```
	 *
	 * @constructor L.PosAnimation()
	 * Creates a `PosAnimation` object.
	 *
	 */
	
	var PosAnimation = Evented.extend({
	
		// @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
		// Run an animation of a given element to a new position, optionally setting
		// duration in seconds (`0.25` by default) and easing linearity factor (3rd
		// argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
		// `0.5` by default).
		run: function (el, newPos, duration, easeLinearity) {
			this.stop();
	
			this._el = el;
			this._inProgress = true;
			this._duration = duration || 0.25;
			this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
	
			this._startPos = getPosition(el);
			this._offset = newPos.subtract(this._startPos);
			this._startTime = +new Date();
	
			// @event start: Event
			// Fired when the animation starts
			this.fire('start');
	
			this._animate();
		},
	
		// @method stop()
		// Stops the animation (if currently running).
		stop: function () {
			if (!this._inProgress) { return; }
	
			this._step(true);
			this._complete();
		},
	
		_animate: function () {
			// animation loop
			this._animId = requestAnimFrame(this._animate, this);
			this._step();
		},
	
		_step: function (round) {
			var elapsed = (+new Date()) - this._startTime,
			    duration = this._duration * 1000;
	
			if (elapsed < duration) {
				this._runFrame(this._easeOut(elapsed / duration), round);
			} else {
				this._runFrame(1);
				this._complete();
			}
		},
	
		_runFrame: function (progress, round) {
			var pos = this._startPos.add(this._offset.multiplyBy(progress));
			if (round) {
				pos._round();
			}
			setPosition(this._el, pos);
	
			// @event step: Event
			// Fired continuously during the animation.
			this.fire('step');
		},
	
		_complete: function () {
			cancelAnimFrame(this._animId);
	
			this._inProgress = false;
			// @event end: Event
			// Fired when the animation ends.
			this.fire('end');
		},
	
		_easeOut: function (t) {
			return 1 - Math.pow(1 - t, this._easeOutPower);
		}
	});
	
	/*
	 * @class Map
	 * @aka L.Map
	 * @inherits Evented
	 *
	 * The central class of the API — it is used to create a map on a page and manipulate it.
	 *
	 * @example
	 *
	 * ```js
	 * // initialize the map on the "map" div with a given center and zoom
	 * var map = L.map('map', {
	 * 	center: [51.505, -0.09],
	 * 	zoom: 13
	 * });
	 * ```
	 *
	 */
	
	var Map = Evented.extend({
	
		options: {
			// @section Map State Options
			// @option crs: CRS = L.CRS.EPSG3857
			// The [Coordinate Reference System](#crs) to use. Don't change this if you're not
			// sure what it means.
			crs: EPSG3857,
	
			// @option center: LatLng = undefined
			// Initial geographic center of the map
			center: undefined,
	
			// @option zoom: Number = undefined
			// Initial map zoom level
			zoom: undefined,
	
			// @option minZoom: Number = *
			// Minimum zoom level of the map.
			// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
			// the lowest of their `minZoom` options will be used instead.
			minZoom: undefined,
	
			// @option maxZoom: Number = *
			// Maximum zoom level of the map.
			// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
			// the highest of their `maxZoom` options will be used instead.
			maxZoom: undefined,
	
			// @option layers: Layer[] = []
			// Array of layers that will be added to the map initially
			layers: [],
	
			// @option maxBounds: LatLngBounds = null
			// When this option is set, the map restricts the view to the given
			// geographical bounds, bouncing the user back if the user tries to pan
			// outside the view. To set the restriction dynamically, use
			// [`setMaxBounds`](#map-setmaxbounds) method.
			maxBounds: undefined,
	
			// @option renderer: Renderer = *
			// The default method for drawing vector layers on the map. `L.SVG`
			// or `L.Canvas` by default depending on browser support.
			renderer: undefined,
	
	
			// @section Animation Options
			// @option zoomAnimation: Boolean = true
			// Whether the map zoom animation is enabled. By default it's enabled
			// in all browsers that support CSS3 Transitions except Android.
			zoomAnimation: true,
	
			// @option zoomAnimationThreshold: Number = 4
			// Won't animate zoom if the zoom difference exceeds this value.
			zoomAnimationThreshold: 4,
	
			// @option fadeAnimation: Boolean = true
			// Whether the tile fade animation is enabled. By default it's enabled
			// in all browsers that support CSS3 Transitions except Android.
			fadeAnimation: true,
	
			// @option markerZoomAnimation: Boolean = true
			// Whether markers animate their zoom with the zoom animation, if disabled
			// they will disappear for the length of the animation. By default it's
			// enabled in all browsers that support CSS3 Transitions except Android.
			markerZoomAnimation: true,
	
			// @option transform3DLimit: Number = 2^23
			// Defines the maximum size of a CSS translation transform. The default
			// value should not be changed unless a web browser positions layers in
			// the wrong place after doing a large `panBy`.
			transform3DLimit: 8388608, // Precision limit of a 32-bit float
	
			// @section Interaction Options
			// @option zoomSnap: Number = 1
			// Forces the map's zoom level to always be a multiple of this, particularly
			// right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
			// By default, the zoom level snaps to the nearest integer; lower values
			// (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
			// means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
			zoomSnap: 1,
	
			// @option zoomDelta: Number = 1
			// Controls how much the map's zoom level will change after a
			// [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
			// or `-` on the keyboard, or using the [zoom controls](#control-zoom).
			// Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
			zoomDelta: 1,
	
			// @option trackResize: Boolean = true
			// Whether the map automatically handles browser window resize to update itself.
			trackResize: true
		},
	
		initialize: function (id, options) { // (HTMLElement or String, Object)
			options = setOptions(this, options);
	
			this._initContainer(id);
			this._initLayout();
	
			// hack for https://github.com/Leaflet/Leaflet/issues/1980
			this._onResize = bind(this._onResize, this);
	
			this._initEvents();
	
			if (options.maxBounds) {
				this.setMaxBounds(options.maxBounds);
			}
	
			if (options.zoom !== undefined) {
				this._zoom = this._limitZoom(options.zoom);
			}
	
			if (options.center && options.zoom !== undefined) {
				this.setView(toLatLng(options.center), options.zoom, {reset: true});
			}
	
			this._handlers = [];
			this._layers = {};
			this._zoomBoundLayers = {};
			this._sizeChanged = true;
	
			this.callInitHooks();
	
			// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
			this._zoomAnimated = TRANSITION && any3d && !mobileOpera &&
					this.options.zoomAnimation;
	
			// zoom transitions run with the same duration for all layers, so if one of transitionend events
			// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
			if (this._zoomAnimated) {
				this._createAnimProxy();
				on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
			}
	
			this._addLayers(this.options.layers);
		},
	
	
		// @section Methods for modifying map state
	
		// @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
		// Sets the view of the map (geographical center and zoom) with the given
		// animation options.
		setView: function (center, zoom, options) {
	
			zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
			center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
			options = options || {};
	
			this._stop();
	
			if (this._loaded && !options.reset && options !== true) {
	
				if (options.animate !== undefined) {
					options.zoom = extend({animate: options.animate}, options.zoom);
					options.pan = extend({animate: options.animate, duration: options.duration}, options.pan);
				}
	
				// try animating pan or zoom
				var moved = (this._zoom !== zoom) ?
					this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
					this._tryAnimatedPan(center, options.pan);
	
				if (moved) {
					// prevent resize handler call, the view will refresh after animation anyway
					clearTimeout(this._sizeTimer);
					return this;
				}
			}
	
			// animation didn't start, just reset the map view
			this._resetView(center, zoom);
	
			return this;
		},
	
		// @method setZoom(zoom: Number, options?: Zoom/pan options): this
		// Sets the zoom of the map.
		setZoom: function (zoom, options) {
			if (!this._loaded) {
				this._zoom = zoom;
				return this;
			}
			return this.setView(this.getCenter(), zoom, {zoom: options});
		},
	
		// @method zoomIn(delta?: Number, options?: Zoom options): this
		// Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
		zoomIn: function (delta, options) {
			delta = delta || (any3d ? this.options.zoomDelta : 1);
			return this.setZoom(this._zoom + delta, options);
		},
	
		// @method zoomOut(delta?: Number, options?: Zoom options): this
		// Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
		zoomOut: function (delta, options) {
			delta = delta || (any3d ? this.options.zoomDelta : 1);
			return this.setZoom(this._zoom - delta, options);
		},
	
		// @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
		// Zooms the map while keeping a specified geographical point on the map
		// stationary (e.g. used internally for scroll zoom and double-click zoom).
		// @alternative
		// @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
		// Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
		setZoomAround: function (latlng, zoom, options) {
			var scale = this.getZoomScale(zoom),
			    viewHalf = this.getSize().divideBy(2),
			    containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng),
	
			    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
			    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
	
			return this.setView(newCenter, zoom, {zoom: options});
		},
	
		_getBoundsCenterZoom: function (bounds, options) {
	
			options = options || {};
			bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
	
			var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
			    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),
	
			    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
	
			zoom = (typeof options.maxZoom === 'number') ? Math.min(options.maxZoom, zoom) : zoom;
	
			if (zoom === Infinity) {
				return {
					center: bounds.getCenter(),
					zoom: zoom
				};
			}
	
			var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),
	
			    swPoint = this.project(bounds.getSouthWest(), zoom),
			    nePoint = this.project(bounds.getNorthEast(), zoom),
			    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
	
			return {
				center: center,
				zoom: zoom
			};
		},
	
		// @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
		// Sets a map view that contains the given geographical bounds with the
		// maximum zoom level possible.
		fitBounds: function (bounds, options) {
	
			bounds = toLatLngBounds(bounds);
	
			if (!bounds.isValid()) {
				throw new Error('Bounds are not valid.');
			}
	
			var target = this._getBoundsCenterZoom(bounds, options);
			return this.setView(target.center, target.zoom, options);
		},
	
		// @method fitWorld(options?: fitBounds options): this
		// Sets a map view that mostly contains the whole world with the maximum
		// zoom level possible.
		fitWorld: function (options) {
			return this.fitBounds([[-90, -180], [90, 180]], options);
		},
	
		// @method panTo(latlng: LatLng, options?: Pan options): this
		// Pans the map to a given center.
		panTo: function (center, options) { // (LatLng)
			return this.setView(center, this._zoom, {pan: options});
		},
	
		// @method panBy(offset: Point, options?: Pan options): this
		// Pans the map by a given number of pixels (animated).
		panBy: function (offset, options) {
			offset = toPoint(offset).round();
			options = options || {};
	
			if (!offset.x && !offset.y) {
				return this.fire('moveend');
			}
			// If we pan too far, Chrome gets issues with tiles
			// and makes them disappear or appear in the wrong place (slightly offset) #2602
			if (options.animate !== true && !this.getSize().contains(offset)) {
				this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
				return this;
			}
	
			if (!this._panAnim) {
				this._panAnim = new PosAnimation();
	
				this._panAnim.on({
					'step': this._onPanTransitionStep,
					'end': this._onPanTransitionEnd
				}, this);
			}
	
			// don't fire movestart if animating inertia
			if (!options.noMoveStart) {
				this.fire('movestart');
			}
	
			// animate pan unless animate: false specified
			if (options.animate !== false) {
				addClass(this._mapPane, 'leaflet-pan-anim');
	
				var newPos = this._getMapPanePos().subtract(offset).round();
				this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
			} else {
				this._rawPanBy(offset);
				this.fire('move').fire('moveend');
			}
	
			return this;
		},
	
		// @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
		// Sets the view of the map (geographical center and zoom) performing a smooth
		// pan-zoom animation.
		flyTo: function (targetCenter, targetZoom, options) {
	
			options = options || {};
			if (options.animate === false || !any3d) {
				return this.setView(targetCenter, targetZoom, options);
			}
	
			this._stop();
	
			var from = this.project(this.getCenter()),
			    to = this.project(targetCenter),
			    size = this.getSize(),
			    startZoom = this._zoom;
	
			targetCenter = toLatLng(targetCenter);
			targetZoom = targetZoom === undefined ? startZoom : targetZoom;
	
			var w0 = Math.max(size.x, size.y),
			    w1 = w0 * this.getZoomScale(startZoom, targetZoom),
			    u1 = (to.distanceTo(from)) || 1,
			    rho = 1.42,
			    rho2 = rho * rho;
	
			function r(i) {
				var s1 = i ? -1 : 1,
				    s2 = i ? w1 : w0,
				    t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
				    b1 = 2 * s2 * rho2 * u1,
				    b = t1 / b1,
				    sq = Math.sqrt(b * b + 1) - b;
	
				    // workaround for floating point precision bug when sq = 0, log = -Infinite,
				    // thus triggering an infinite loop in flyTo
				    var log = sq < 0.000000001 ? -18 : Math.log(sq);
	
				return log;
			}
	
			function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
			function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
			function tanh(n) { return sinh(n) / cosh(n); }
	
			var r0 = r(0);
	
			function w(s) { return w0 * (cosh(r0) / cosh(r0 + rho * s)); }
			function u(s) { return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2; }
	
			function easeOut(t) { return 1 - Math.pow(1 - t, 1.5); }
	
			var start = Date.now(),
			    S = (r(1) - r0) / rho,
			    duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
	
			function frame() {
				var t = (Date.now() - start) / duration,
				    s = easeOut(t) * S;
	
				if (t <= 1) {
					this._flyToFrame = requestAnimFrame(frame, this);
	
					this._move(
						this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
						this.getScaleZoom(w0 / w(s), startZoom),
						{flyTo: true});
	
				} else {
					this
						._move(targetCenter, targetZoom)
						._moveEnd(true);
				}
			}
	
			this._moveStart(true);
	
			frame.call(this);
			return this;
		},
	
		// @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
		// Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
		// but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
		flyToBounds: function (bounds, options) {
			var target = this._getBoundsCenterZoom(bounds, options);
			return this.flyTo(target.center, target.zoom, options);
		},
	
		// @method setMaxBounds(bounds: Bounds): this
		// Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
		setMaxBounds: function (bounds) {
			bounds = toLatLngBounds(bounds);
	
			if (!bounds.isValid()) {
				this.options.maxBounds = null;
				return this.off('moveend', this._panInsideMaxBounds);
			} else if (this.options.maxBounds) {
				this.off('moveend', this._panInsideMaxBounds);
			}
	
			this.options.maxBounds = bounds;
	
			if (this._loaded) {
				this._panInsideMaxBounds();
			}
	
			return this.on('moveend', this._panInsideMaxBounds);
		},
	
		// @method setMinZoom(zoom: Number): this
		// Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
		setMinZoom: function (zoom) {
			this.options.minZoom = zoom;
	
			if (this._loaded && this.getZoom() < this.options.minZoom) {
				return this.setZoom(zoom);
			}
	
			return this;
		},
	
		// @method setMaxZoom(zoom: Number): this
		// Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
		setMaxZoom: function (zoom) {
			this.options.maxZoom = zoom;
	
			if (this._loaded && (this.getZoom() > this.options.maxZoom)) {
				return this.setZoom(zoom);
			}
	
			return this;
		},
	
		// @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
		// Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
		panInsideBounds: function (bounds, options) {
			this._enforcingBounds = true;
			var center = this.getCenter(),
			    newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
	
			if (!center.equals(newCenter)) {
				this.panTo(newCenter, options);
			}
	
			this._enforcingBounds = false;
			return this;
		},
	
		// @method invalidateSize(options: Zoom/Pan options): this
		// Checks if the map container size changed and updates the map if so —
		// call it after you've changed the map size dynamically, also animating
		// pan by default. If `options.pan` is `false`, panning will not occur.
		// If `options.debounceMoveend` is `true`, it will delay `moveend` event so
		// that it doesn't happen often even if the method is called many
		// times in a row.
	
		// @alternative
		// @method invalidateSize(animate: Boolean): this
		// Checks if the map container size changed and updates the map if so —
		// call it after you've changed the map size dynamically, also animating
		// pan by default.
		invalidateSize: function (options) {
			if (!this._loaded) { return this; }
	
			options = extend({
				animate: false,
				pan: true
			}, options === true ? {animate: true} : options);
	
			var oldSize = this.getSize();
			this._sizeChanged = true;
			this._lastCenter = null;
	
			var newSize = this.getSize(),
			    oldCenter = oldSize.divideBy(2).round(),
			    newCenter = newSize.divideBy(2).round(),
			    offset = oldCenter.subtract(newCenter);
	
			if (!offset.x && !offset.y) { return this; }
	
			if (options.animate && options.pan) {
				this.panBy(offset);
	
			} else {
				if (options.pan) {
					this._rawPanBy(offset);
				}
	
				this.fire('move');
	
				if (options.debounceMoveend) {
					clearTimeout(this._sizeTimer);
					this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
				} else {
					this.fire('moveend');
				}
			}
	
			// @section Map state change events
			// @event resize: ResizeEvent
			// Fired when the map is resized.
			return this.fire('resize', {
				oldSize: oldSize,
				newSize: newSize
			});
		},
	
		// @section Methods for modifying map state
		// @method stop(): this
		// Stops the currently running `panTo` or `flyTo` animation, if any.
		stop: function () {
			this.setZoom(this._limitZoom(this._zoom));
			if (!this.options.zoomSnap) {
				this.fire('viewreset');
			}
			return this._stop();
		},
	
		// @section Geolocation methods
		// @method locate(options?: Locate options): this
		// Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
		// event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
		// and optionally sets the map view to the user's location with respect to
		// detection accuracy (or to the world view if geolocation failed).
		// Note that, if your page doesn't use HTTPS, this method will fail in
		// modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
		// See `Locate options` for more details.
		locate: function (options) {
	
			options = this._locateOptions = extend({
				timeout: 10000,
				watch: false
				// setView: false
				// maxZoom: <Number>
				// maximumAge: 0
				// enableHighAccuracy: false
			}, options);
	
			if (!('geolocation' in navigator)) {
				this._handleGeolocationError({
					code: 0,
					message: 'Geolocation not supported.'
				});
				return this;
			}
	
			var onResponse = bind(this._handleGeolocationResponse, this),
			    onError = bind(this._handleGeolocationError, this);
	
			if (options.watch) {
				this._locationWatchId =
				        navigator.geolocation.watchPosition(onResponse, onError, options);
			} else {
				navigator.geolocation.getCurrentPosition(onResponse, onError, options);
			}
			return this;
		},
	
		// @method stopLocate(): this
		// Stops watching location previously initiated by `map.locate({watch: true})`
		// and aborts resetting the map view if map.locate was called with
		// `{setView: true}`.
		stopLocate: function () {
			if (navigator.geolocation && navigator.geolocation.clearWatch) {
				navigator.geolocation.clearWatch(this._locationWatchId);
			}
			if (this._locateOptions) {
				this._locateOptions.setView = false;
			}
			return this;
		},
	
		_handleGeolocationError: function (error) {
			var c = error.code,
			    message = error.message ||
			            (c === 1 ? 'permission denied' :
			            (c === 2 ? 'position unavailable' : 'timeout'));
	
			if (this._locateOptions.setView && !this._loaded) {
				this.fitWorld();
			}
	
			// @section Location events
			// @event locationerror: ErrorEvent
			// Fired when geolocation (using the [`locate`](#map-locate) method) failed.
			this.fire('locationerror', {
				code: c,
				message: 'Geolocation error: ' + message + '.'
			});
		},
	
		_handleGeolocationResponse: function (pos) {
			var lat = pos.coords.latitude,
			    lng = pos.coords.longitude,
			    latlng = new LatLng(lat, lng),
			    bounds = latlng.toBounds(pos.coords.accuracy),
			    options = this._locateOptions;
	
			if (options.setView) {
				var zoom = this.getBoundsZoom(bounds);
				this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
			}
	
			var data = {
				latlng: latlng,
				bounds: bounds,
				timestamp: pos.timestamp
			};
	
			for (var i in pos.coords) {
				if (typeof pos.coords[i] === 'number') {
					data[i] = pos.coords[i];
				}
			}
	
			// @event locationfound: LocationEvent
			// Fired when geolocation (using the [`locate`](#map-locate) method)
			// went successfully.
			this.fire('locationfound', data);
		},
	
		// TODO handler.addTo
		// TODO Appropiate docs section?
		// @section Other Methods
		// @method addHandler(name: String, HandlerClass: Function): this
		// Adds a new `Handler` to the map, given its name and constructor function.
		addHandler: function (name, HandlerClass) {
			if (!HandlerClass) { return this; }
	
			var handler = this[name] = new HandlerClass(this);
	
			this._handlers.push(handler);
	
			if (this.options[name]) {
				handler.enable();
			}
	
			return this;
		},
	
		// @method remove(): this
		// Destroys the map and clears all related event listeners.
		remove: function () {
	
			this._initEvents(true);
	
			if (this._containerId !== this._container._leaflet_id) {
				throw new Error('Map container is being reused by another instance');
			}
	
			try {
				// throws error in IE6-8
				delete this._container._leaflet_id;
				delete this._containerId;
			} catch (e) {
				/*eslint-disable */
				this._container._leaflet_id = undefined;
				/*eslint-enable */
				this._containerId = undefined;
			}
	
			remove(this._mapPane);
	
			if (this._clearControlPos) {
				this._clearControlPos();
			}
	
			this._clearHandlers();
	
			if (this._loaded) {
				// @section Map state change events
				// @event unload: Event
				// Fired when the map is destroyed with [remove](#map-remove) method.
				this.fire('unload');
			}
	
			var i;
			for (i in this._layers) {
				this._layers[i].remove();
			}
			for (i in this._panes) {
				remove(this._panes[i]);
			}
	
			this._layers = [];
			this._panes = [];
			delete this._mapPane;
			delete this._renderer;
	
			return this;
		},
	
		// @section Other Methods
		// @method createPane(name: String, container?: HTMLElement): HTMLElement
		// Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
		// then returns it. The pane is created as a child of `container`, or
		// as a child of the main map pane if not set.
		createPane: function (name, container) {
			var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
			    pane = create$1('div', className, container || this._mapPane);
	
			if (name) {
				this._panes[name] = pane;
			}
			return pane;
		},
	
		// @section Methods for Getting Map State
	
		// @method getCenter(): LatLng
		// Returns the geographical center of the map view
		getCenter: function () {
			this._checkIfLoaded();
	
			if (this._lastCenter && !this._moved()) {
				return this._lastCenter;
			}
			return this.layerPointToLatLng(this._getCenterLayerPoint());
		},
	
		// @method getZoom(): Number
		// Returns the current zoom level of the map view
		getZoom: function () {
			return this._zoom;
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the geographical bounds visible in the current map view
		getBounds: function () {
			var bounds = this.getPixelBounds(),
			    sw = this.unproject(bounds.getBottomLeft()),
			    ne = this.unproject(bounds.getTopRight());
	
			return new LatLngBounds(sw, ne);
		},
	
		// @method getMinZoom(): Number
		// Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
		getMinZoom: function () {
			return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
		},
	
		// @method getMaxZoom(): Number
		// Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
		getMaxZoom: function () {
			return this.options.maxZoom === undefined ?
				(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
				this.options.maxZoom;
		},
	
		// @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean): Number
		// Returns the maximum zoom level on which the given bounds fit to the map
		// view in its entirety. If `inside` (optional) is set to `true`, the method
		// instead returns the minimum zoom level on which the map view fits into
		// the given bounds in its entirety.
		getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
			bounds = toLatLngBounds(bounds);
			padding = toPoint(padding || [0, 0]);
	
			var zoom = this.getZoom() || 0,
			    min = this.getMinZoom(),
			    max = this.getMaxZoom(),
			    nw = bounds.getNorthWest(),
			    se = bounds.getSouthEast(),
			    size = this.getSize().subtract(padding),
			    boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(),
			    snap = any3d ? this.options.zoomSnap : 1,
			    scalex = size.x / boundsSize.x,
			    scaley = size.y / boundsSize.y,
			    scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
	
			zoom = this.getScaleZoom(scale, zoom);
	
			if (snap) {
				zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
				zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
			}
	
			return Math.max(min, Math.min(max, zoom));
		},
	
		// @method getSize(): Point
		// Returns the current size of the map container (in pixels).
		getSize: function () {
			if (!this._size || this._sizeChanged) {
				this._size = new Point(
					this._container.clientWidth || 0,
					this._container.clientHeight || 0);
	
				this._sizeChanged = false;
			}
			return this._size.clone();
		},
	
		// @method getPixelBounds(): Bounds
		// Returns the bounds of the current map view in projected pixel
		// coordinates (sometimes useful in layer and overlay implementations).
		getPixelBounds: function (center, zoom) {
			var topLeftPoint = this._getTopLeftPoint(center, zoom);
			return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
		},
	
		// TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
		// the map pane? "left point of the map layer" can be confusing, specially
		// since there can be negative offsets.
		// @method getPixelOrigin(): Point
		// Returns the projected pixel coordinates of the top left point of
		// the map layer (useful in custom layer and overlay implementations).
		getPixelOrigin: function () {
			this._checkIfLoaded();
			return this._pixelOrigin;
		},
	
		// @method getPixelWorldBounds(zoom?: Number): Bounds
		// Returns the world's bounds in pixel coordinates for zoom level `zoom`.
		// If `zoom` is omitted, the map's current zoom level is used.
		getPixelWorldBounds: function (zoom) {
			return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
		},
	
		// @section Other Methods
	
		// @method getPane(pane: String|HTMLElement): HTMLElement
		// Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
		getPane: function (pane) {
			return typeof pane === 'string' ? this._panes[pane] : pane;
		},
	
		// @method getPanes(): Object
		// Returns a plain object containing the names of all [panes](#map-pane) as keys and
		// the panes as values.
		getPanes: function () {
			return this._panes;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTML element that contains the map.
		getContainer: function () {
			return this._container;
		},
	
	
		// @section Conversion Methods
	
		// @method getZoomScale(toZoom: Number, fromZoom: Number): Number
		// Returns the scale factor to be applied to a map transition from zoom level
		// `fromZoom` to `toZoom`. Used internally to help with zoom animations.
		getZoomScale: function (toZoom, fromZoom) {
			// TODO replace with universal implementation after refactoring projections
			var crs = this.options.crs;
			fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
			return crs.scale(toZoom) / crs.scale(fromZoom);
		},
	
		// @method getScaleZoom(scale: Number, fromZoom: Number): Number
		// Returns the zoom level that the map would end up at, if it is at `fromZoom`
		// level and everything is scaled by a factor of `scale`. Inverse of
		// [`getZoomScale`](#map-getZoomScale).
		getScaleZoom: function (scale, fromZoom) {
			var crs = this.options.crs;
			fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
			var zoom = crs.zoom(scale * crs.scale(fromZoom));
			return isNaN(zoom) ? Infinity : zoom;
		},
	
		// @method project(latlng: LatLng, zoom: Number): Point
		// Projects a geographical coordinate `LatLng` according to the projection
		// of the map's CRS, then scales it according to `zoom` and the CRS's
		// `Transformation`. The result is pixel coordinate relative to
		// the CRS origin.
		project: function (latlng, zoom) {
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
		},
	
		// @method unproject(point: Point, zoom: Number): LatLng
		// Inverse of [`project`](#map-project).
		unproject: function (point, zoom) {
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.pointToLatLng(toPoint(point), zoom);
		},
	
		// @method layerPointToLatLng(point: Point): LatLng
		// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
		// returns the corresponding geographical coordinate (for the current zoom level).
		layerPointToLatLng: function (point) {
			var projectedPoint = toPoint(point).add(this.getPixelOrigin());
			return this.unproject(projectedPoint);
		},
	
		// @method latLngToLayerPoint(latlng: LatLng): Point
		// Given a geographical coordinate, returns the corresponding pixel coordinate
		// relative to the [origin pixel](#map-getpixelorigin).
		latLngToLayerPoint: function (latlng) {
			var projectedPoint = this.project(toLatLng(latlng))._round();
			return projectedPoint._subtract(this.getPixelOrigin());
		},
	
		// @method wrapLatLng(latlng: LatLng): LatLng
		// Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
		// map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
		// CRS's bounds.
		// By default this means longitude is wrapped around the dateline so its
		// value is between -180 and +180 degrees.
		wrapLatLng: function (latlng) {
			return this.options.crs.wrapLatLng(toLatLng(latlng));
		},
	
		// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
		// Returns a `LatLngBounds` with the same size as the given one, ensuring that
		// its center is within the CRS's bounds.
		// By default this means the center longitude is wrapped around the dateline so its
		// value is between -180 and +180 degrees, and the majority of the bounds
		// overlaps the CRS's bounds.
		wrapLatLngBounds: function (latlng) {
			return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
		},
	
		// @method distance(latlng1: LatLng, latlng2: LatLng): Number
		// Returns the distance between two geographical coordinates according to
		// the map's CRS. By default this measures distance in meters.
		distance: function (latlng1, latlng2) {
			return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
		},
	
		// @method containerPointToLayerPoint(point: Point): Point
		// Given a pixel coordinate relative to the map container, returns the corresponding
		// pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
		containerPointToLayerPoint: function (point) { // (Point)
			return toPoint(point).subtract(this._getMapPanePos());
		},
	
		// @method layerPointToContainerPoint(point: Point): Point
		// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
		// returns the corresponding pixel coordinate relative to the map container.
		layerPointToContainerPoint: function (point) { // (Point)
			return toPoint(point).add(this._getMapPanePos());
		},
	
		// @method containerPointToLatLng(point: Point): LatLng
		// Given a pixel coordinate relative to the map container, returns
		// the corresponding geographical coordinate (for the current zoom level).
		containerPointToLatLng: function (point) {
			var layerPoint = this.containerPointToLayerPoint(toPoint(point));
			return this.layerPointToLatLng(layerPoint);
		},
	
		// @method latLngToContainerPoint(latlng: LatLng): Point
		// Given a geographical coordinate, returns the corresponding pixel coordinate
		// relative to the map container.
		latLngToContainerPoint: function (latlng) {
			return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
		},
	
		// @method mouseEventToContainerPoint(ev: MouseEvent): Point
		// Given a MouseEvent object, returns the pixel coordinate relative to the
		// map container where the event took place.
		mouseEventToContainerPoint: function (e) {
			return getMousePosition(e, this._container);
		},
	
		// @method mouseEventToLayerPoint(ev: MouseEvent): Point
		// Given a MouseEvent object, returns the pixel coordinate relative to
		// the [origin pixel](#map-getpixelorigin) where the event took place.
		mouseEventToLayerPoint: function (e) {
			return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
		},
	
		// @method mouseEventToLatLng(ev: MouseEvent): LatLng
		// Given a MouseEvent object, returns geographical coordinate where the
		// event took place.
		mouseEventToLatLng: function (e) { // (MouseEvent)
			return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
		},
	
	
		// map initialization methods
	
		_initContainer: function (id) {
			var container = this._container = get(id);
	
			if (!container) {
				throw new Error('Map container not found.');
			} else if (container._leaflet_id) {
				throw new Error('Map container is already initialized.');
			}
	
			on(container, 'scroll', this._onScroll, this);
			this._containerId = stamp(container);
		},
	
		_initLayout: function () {
			var container = this._container;
	
			this._fadeAnimated = this.options.fadeAnimation && any3d;
	
			addClass(container, 'leaflet-container' +
				(touch ? ' leaflet-touch' : '') +
				(retina ? ' leaflet-retina' : '') +
				(ielt9 ? ' leaflet-oldie' : '') +
				(safari ? ' leaflet-safari' : '') +
				(this._fadeAnimated ? ' leaflet-fade-anim' : ''));
	
			var position = getStyle(container, 'position');
	
			if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
				container.style.position = 'relative';
			}
	
			this._initPanes();
	
			if (this._initControlPos) {
				this._initControlPos();
			}
		},
	
		_initPanes: function () {
			var panes = this._panes = {};
			this._paneRenderers = {};
	
			// @section
			//
			// Panes are DOM elements used to control the ordering of layers on the map. You
			// can access panes with [`map.getPane`](#map-getpane) or
			// [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
			// [`map.createPane`](#map-createpane) method.
			//
			// Every map has the following default panes that differ only in zIndex.
			//
			// @pane mapPane: HTMLElement = 'auto'
			// Pane that contains all other map panes
	
			this._mapPane = this.createPane('mapPane', this._container);
			setPosition(this._mapPane, new Point(0, 0));
	
			// @pane tilePane: HTMLElement = 200
			// Pane for `GridLayer`s and `TileLayer`s
			this.createPane('tilePane');
			// @pane overlayPane: HTMLElement = 400
			// Pane for vector overlays (`Path`s), like `Polyline`s and `Polygon`s
			this.createPane('shadowPane');
			// @pane shadowPane: HTMLElement = 500
			// Pane for overlay shadows (e.g. `Marker` shadows)
			this.createPane('overlayPane');
			// @pane markerPane: HTMLElement = 600
			// Pane for `Icon`s of `Marker`s
			this.createPane('markerPane');
			// @pane tooltipPane: HTMLElement = 650
			// Pane for tooltip.
			this.createPane('tooltipPane');
			// @pane popupPane: HTMLElement = 700
			// Pane for `Popup`s.
			this.createPane('popupPane');
	
			if (!this.options.markerZoomAnimation) {
				addClass(panes.markerPane, 'leaflet-zoom-hide');
				addClass(panes.shadowPane, 'leaflet-zoom-hide');
			}
		},
	
	
		// private methods that modify map state
	
		// @section Map state change events
		_resetView: function (center, zoom) {
			setPosition(this._mapPane, new Point(0, 0));
	
			var loading = !this._loaded;
			this._loaded = true;
			zoom = this._limitZoom(zoom);
	
			this.fire('viewprereset');
	
			var zoomChanged = this._zoom !== zoom;
			this
				._moveStart(zoomChanged)
				._move(center, zoom)
				._moveEnd(zoomChanged);
	
			// @event viewreset: Event
			// Fired when the map needs to redraw its content (this usually happens
			// on map zoom or load). Very useful for creating custom overlays.
			this.fire('viewreset');
	
			// @event load: Event
			// Fired when the map is initialized (when its center and zoom are set
			// for the first time).
			if (loading) {
				this.fire('load');
			}
		},
	
		_moveStart: function (zoomChanged) {
			// @event zoomstart: Event
			// Fired when the map zoom is about to change (e.g. before zoom animation).
			// @event movestart: Event
			// Fired when the view of the map starts changing (e.g. user starts dragging the map).
			if (zoomChanged) {
				this.fire('zoomstart');
			}
			return this.fire('movestart');
		},
	
		_move: function (center, zoom, data) {
			if (zoom === undefined) {
				zoom = this._zoom;
			}
			var zoomChanged = this._zoom !== zoom;
	
			this._zoom = zoom;
			this._lastCenter = center;
			this._pixelOrigin = this._getNewPixelOrigin(center);
	
			// @event zoom: Event
			// Fired repeatedly during any change in zoom level, including zoom
			// and fly animations.
			if (zoomChanged || (data && data.pinch)) {	// Always fire 'zoom' if pinching because #3530
				this.fire('zoom', data);
			}
	
			// @event move: Event
			// Fired repeatedly during any movement of the map, including pan and
			// fly animations.
			return this.fire('move', data);
		},
	
		_moveEnd: function (zoomChanged) {
			// @event zoomend: Event
			// Fired when the map has changed, after any animations.
			if (zoomChanged) {
				this.fire('zoomend');
			}
	
			// @event moveend: Event
			// Fired when the center of the map stops changing (e.g. user stopped
			// dragging the map).
			return this.fire('moveend');
		},
	
		_stop: function () {
			cancelAnimFrame(this._flyToFrame);
			if (this._panAnim) {
				this._panAnim.stop();
			}
			return this;
		},
	
		_rawPanBy: function (offset) {
			setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
		},
	
		_getZoomSpan: function () {
			return this.getMaxZoom() - this.getMinZoom();
		},
	
		_panInsideMaxBounds: function () {
			if (!this._enforcingBounds) {
				this.panInsideBounds(this.options.maxBounds);
			}
		},
	
		_checkIfLoaded: function () {
			if (!this._loaded) {
				throw new Error('Set map center and zoom first.');
			}
		},
	
		// DOM event handling
	
		// @section Interaction events
		_initEvents: function (remove$$1) {
			this._targets = {};
			this._targets[stamp(this._container)] = this;
	
			var onOff = remove$$1 ? off : on;
	
			// @event click: MouseEvent
			// Fired when the user clicks (or taps) the map.
			// @event dblclick: MouseEvent
			// Fired when the user double-clicks (or double-taps) the map.
			// @event mousedown: MouseEvent
			// Fired when the user pushes the mouse button on the map.
			// @event mouseup: MouseEvent
			// Fired when the user releases the mouse button on the map.
			// @event mouseover: MouseEvent
			// Fired when the mouse enters the map.
			// @event mouseout: MouseEvent
			// Fired when the mouse leaves the map.
			// @event mousemove: MouseEvent
			// Fired while the mouse moves over the map.
			// @event contextmenu: MouseEvent
			// Fired when the user pushes the right mouse button on the map, prevents
			// default browser context menu from showing if there are listeners on
			// this event. Also fired on mobile when the user holds a single touch
			// for a second (also called long press).
			// @event keypress: KeyboardEvent
			// Fired when the user presses a key from the keyboard while the map is focused.
			onOff(this._container, 'click dblclick mousedown mouseup ' +
				'mouseover mouseout mousemove contextmenu keypress', this._handleDOMEvent, this);
	
			if (this.options.trackResize) {
				onOff(window, 'resize', this._onResize, this);
			}
	
			if (any3d && this.options.transform3DLimit) {
				(remove$$1 ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
			}
		},
	
		_onResize: function () {
			cancelAnimFrame(this._resizeRequest);
			this._resizeRequest = requestAnimFrame(
			        function () { this.invalidateSize({debounceMoveend: true}); }, this);
		},
	
		_onScroll: function () {
			this._container.scrollTop  = 0;
			this._container.scrollLeft = 0;
		},
	
		_onMoveEnd: function () {
			var pos = this._getMapPanePos();
			if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
				// https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
				// a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
				this._resetView(this.getCenter(), this.getZoom());
			}
		},
	
		_findEventTargets: function (e, type) {
			var targets = [],
			    target,
			    isHover = type === 'mouseout' || type === 'mouseover',
			    src = e.target || e.srcElement,
			    dragging = false;
	
			while (src) {
				target = this._targets[stamp(src)];
				if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
					// Prevent firing click after you just dragged an object.
					dragging = true;
					break;
				}
				if (target && target.listens(type, true)) {
					if (isHover && !isExternalTarget(src, e)) { break; }
					targets.push(target);
					if (isHover) { break; }
				}
				if (src === this._container) { break; }
				src = src.parentNode;
			}
			if (!targets.length && !dragging && !isHover && isExternalTarget(src, e)) {
				targets = [this];
			}
			return targets;
		},
	
		_handleDOMEvent: function (e) {
			if (!this._loaded || skipped(e)) { return; }
	
			var type = e.type;
	
			if (type === 'mousedown' || type === 'keypress') {
				// prevents outline when clicking on keyboard-focusable element
				preventOutline(e.target || e.srcElement);
			}
	
			this._fireDOMEvent(e, type);
		},
	
		_mouseEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu'],
	
		_fireDOMEvent: function (e, type, targets) {
	
			if (e.type === 'click') {
				// Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
				// @event preclick: MouseEvent
				// Fired before mouse click on the map (sometimes useful when you
				// want something to happen on click before any existing click
				// handlers start running).
				var synth = extend({}, e);
				synth.type = 'preclick';
				this._fireDOMEvent(synth, synth.type, targets);
			}
	
			if (e._stopped) { return; }
	
			// Find the layer the event is propagating from and its parents.
			targets = (targets || []).concat(this._findEventTargets(e, type));
	
			if (!targets.length) { return; }
	
			var target = targets[0];
			if (type === 'contextmenu' && target.listens(type, true)) {
				preventDefault(e);
			}
	
			var data = {
				originalEvent: e
			};
	
			if (e.type !== 'keypress') {
				var isMarker = (target.options && 'icon' in target.options);
				data.containerPoint = isMarker ?
						this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
				data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
				data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
			}
	
			for (var i = 0; i < targets.length; i++) {
				targets[i].fire(type, data, true);
				if (data.originalEvent._stopped ||
					(targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1)) { return; }
			}
		},
	
		_draggableMoved: function (obj) {
			obj = obj.dragging && obj.dragging.enabled() ? obj : this;
			return (obj.dragging && obj.dragging.moved()) || (this.boxZoom && this.boxZoom.moved());
		},
	
		_clearHandlers: function () {
			for (var i = 0, len = this._handlers.length; i < len; i++) {
				this._handlers[i].disable();
			}
		},
	
		// @section Other Methods
	
		// @method whenReady(fn: Function, context?: Object): this
		// Runs the given function `fn` when the map gets initialized with
		// a view (center and zoom) and at least one layer, or immediately
		// if it's already initialized, optionally passing a function context.
		whenReady: function (callback, context) {
			if (this._loaded) {
				callback.call(context || this, {target: this});
			} else {
				this.on('load', callback, context);
			}
			return this;
		},
	
	
		// private methods for getting map state
	
		_getMapPanePos: function () {
			return getPosition(this._mapPane) || new Point(0, 0);
		},
	
		_moved: function () {
			var pos = this._getMapPanePos();
			return pos && !pos.equals([0, 0]);
		},
	
		_getTopLeftPoint: function (center, zoom) {
			var pixelOrigin = center && zoom !== undefined ?
				this._getNewPixelOrigin(center, zoom) :
				this.getPixelOrigin();
			return pixelOrigin.subtract(this._getMapPanePos());
		},
	
		_getNewPixelOrigin: function (center, zoom) {
			var viewHalf = this.getSize()._divideBy(2);
			return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
		},
	
		_latLngToNewLayerPoint: function (latlng, zoom, center) {
			var topLeft = this._getNewPixelOrigin(center, zoom);
			return this.project(latlng, zoom)._subtract(topLeft);
		},
	
		_latLngBoundsToNewLayerBounds: function (latLngBounds, zoom, center) {
			var topLeft = this._getNewPixelOrigin(center, zoom);
			return toBounds([
				this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
			]);
		},
	
		// layer point of the current center
		_getCenterLayerPoint: function () {
			return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
		},
	
		// offset of the specified place to the current center in pixels
		_getCenterOffset: function (latlng) {
			return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
		},
	
		// adjust center for view to get inside bounds
		_limitCenter: function (center, zoom, bounds) {
	
			if (!bounds) { return center; }
	
			var centerPoint = this.project(center, zoom),
			    viewHalf = this.getSize().divideBy(2),
			    viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
			    offset = this._getBoundsOffset(viewBounds, bounds, zoom);
	
			// If offset is less than a pixel, ignore.
			// This prevents unstable projections from getting into
			// an infinite loop of tiny offsets.
			if (offset.round().equals([0, 0])) {
				return center;
			}
	
			return this.unproject(centerPoint.add(offset), zoom);
		},
	
		// adjust offset for view to get inside bounds
		_limitOffset: function (offset, bounds) {
			if (!bounds) { return offset; }
	
			var viewBounds = this.getPixelBounds(),
			    newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
	
			return offset.add(this._getBoundsOffset(newBounds, bounds));
		},
	
		// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
		_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
			var projectedMaxBounds = toBounds(
			        this.project(maxBounds.getNorthEast(), zoom),
			        this.project(maxBounds.getSouthWest(), zoom)
			    ),
			    minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
			    maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),
	
			    dx = this._rebound(minOffset.x, -maxOffset.x),
			    dy = this._rebound(minOffset.y, -maxOffset.y);
	
			return new Point(dx, dy);
		},
	
		_rebound: function (left, right) {
			return left + right > 0 ?
				Math.round(left - right) / 2 :
				Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
		},
	
		_limitZoom: function (zoom) {
			var min = this.getMinZoom(),
			    max = this.getMaxZoom(),
			    snap = any3d ? this.options.zoomSnap : 1;
			if (snap) {
				zoom = Math.round(zoom / snap) * snap;
			}
			return Math.max(min, Math.min(max, zoom));
		},
	
		_onPanTransitionStep: function () {
			this.fire('move');
		},
	
		_onPanTransitionEnd: function () {
			removeClass(this._mapPane, 'leaflet-pan-anim');
			this.fire('moveend');
		},
	
		_tryAnimatedPan: function (center, options) {
			// difference between the new and current centers in pixels
			var offset = this._getCenterOffset(center)._floor();
	
			// don't animate too far unless animate: true specified in options
			if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }
	
			this.panBy(offset, options);
	
			return true;
		},
	
		_createAnimProxy: function () {
	
			var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
			this._panes.mapPane.appendChild(proxy);
	
			this.on('zoomanim', function (e) {
				var prop = TRANSFORM,
				    transform = this._proxy.style[prop];
	
				setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
	
				// workaround for case when transform is the same and so transitionend event is not fired
				if (transform === this._proxy.style[prop] && this._animatingZoom) {
					this._onZoomTransitionEnd();
				}
			}, this);
	
			this.on('load moveend', function () {
				var c = this.getCenter(),
				    z = this.getZoom();
				setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
			}, this);
	
			this._on('unload', this._destroyAnimProxy, this);
		},
	
		_destroyAnimProxy: function () {
			remove(this._proxy);
			delete this._proxy;
		},
	
		_catchTransitionEnd: function (e) {
			if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
				this._onZoomTransitionEnd();
			}
		},
	
		_nothingToAnimate: function () {
			return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
		},
	
		_tryAnimatedZoom: function (center, zoom, options) {
	
			if (this._animatingZoom) { return true; }
	
			options = options || {};
	
			// don't animate if disabled, not supported or zoom difference is too large
			if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
			        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }
	
			// offset is the pixel coords of the zoom origin relative to the current center
			var scale = this.getZoomScale(zoom),
			    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
	
			// don't animate if the zoom origin isn't within one screen from the current center, unless forced
			if (options.animate !== true && !this.getSize().contains(offset)) { return false; }
	
			requestAnimFrame(function () {
				this
				    ._moveStart(true)
				    ._animateZoom(center, zoom, true);
			}, this);
	
			return true;
		},
	
		_animateZoom: function (center, zoom, startAnim, noUpdate) {
			if (startAnim) {
				this._animatingZoom = true;
	
				// remember what center/zoom to set after animation
				this._animateToCenter = center;
				this._animateToZoom = zoom;
	
				addClass(this._mapPane, 'leaflet-zoom-anim');
			}
	
			// @event zoomanim: ZoomAnimEvent
			// Fired on every frame of a zoom animation
			this.fire('zoomanim', {
				center: center,
				zoom: zoom,
				noUpdate: noUpdate
			});
	
			// Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
			setTimeout(bind(this._onZoomTransitionEnd, this), 250);
		},
	
		_onZoomTransitionEnd: function () {
			if (!this._animatingZoom) { return; }
	
			removeClass(this._mapPane, 'leaflet-zoom-anim');
	
			this._animatingZoom = false;
	
			this._move(this._animateToCenter, this._animateToZoom);
	
			// This anim frame should prevent an obscure iOS webkit tile loading race condition.
			requestAnimFrame(function () {
				this._moveEnd(true);
			}, this);
		}
	});
	
	// @section
	
	// @factory L.map(id: String, options?: Map options)
	// Instantiates a map object given the DOM ID of a `<div>` element
	// and optionally an object literal with `Map options`.
	//
	// @alternative
	// @factory L.map(el: HTMLElement, options?: Map options)
	// Instantiates a map object given an instance of a `<div>` HTML element
	// and optionally an object literal with `Map options`.
	function createMap(id, options) {
		return new Map(id, options);
	}
	
	/*
	 * @class Control
	 * @aka L.Control
	 * @inherits Class
	 *
	 * L.Control is a base class for implementing map controls. Handles positioning.
	 * All other controls extend from this class.
	 */
	
	var Control = Class.extend({
		// @section
		// @aka Control options
		options: {
			// @option position: String = 'topright'
			// The position of the control (one of the map corners). Possible values are `'topleft'`,
			// `'topright'`, `'bottomleft'` or `'bottomright'`
			position: 'topright'
		},
	
		initialize: function (options) {
			setOptions(this, options);
		},
	
		/* @section
		 * Classes extending L.Control will inherit the following methods:
		 *
		 * @method getPosition: string
		 * Returns the position of the control.
		 */
		getPosition: function () {
			return this.options.position;
		},
	
		// @method setPosition(position: string): this
		// Sets the position of the control.
		setPosition: function (position) {
			var map = this._map;
	
			if (map) {
				map.removeControl(this);
			}
	
			this.options.position = position;
	
			if (map) {
				map.addControl(this);
			}
	
			return this;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTMLElement that contains the control.
		getContainer: function () {
			return this._container;
		},
	
		// @method addTo(map: Map): this
		// Adds the control to the given map.
		addTo: function (map) {
			this.remove();
			this._map = map;
	
			var container = this._container = this.onAdd(map),
			    pos = this.getPosition(),
			    corner = map._controlCorners[pos];
	
			addClass(container, 'leaflet-control');
	
			if (pos.indexOf('bottom') !== -1) {
				corner.insertBefore(container, corner.firstChild);
			} else {
				corner.appendChild(container);
			}
	
			return this;
		},
	
		// @method remove: this
		// Removes the control from the map it is currently active on.
		remove: function () {
			if (!this._map) {
				return this;
			}
	
			remove(this._container);
	
			if (this.onRemove) {
				this.onRemove(this._map);
			}
	
			this._map = null;
	
			return this;
		},
	
		_refocusOnMap: function (e) {
			// if map exists and event is not a keyboard event
			if (this._map && e && e.screenX > 0 && e.screenY > 0) {
				this._map.getContainer().focus();
			}
		}
	});
	
	var control = function (options) {
		return new Control(options);
	};
	
	/* @section Extension methods
	 * @uninheritable
	 *
	 * Every control should extend from `L.Control` and (re-)implement the following methods.
	 *
	 * @method onAdd(map: Map): HTMLElement
	 * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
	 *
	 * @method onRemove(map: Map)
	 * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
	 */
	
	/* @namespace Map
	 * @section Methods for Layers and Controls
	 */
	Map.include({
		// @method addControl(control: Control): this
		// Adds the given control to the map
		addControl: function (control) {
			control.addTo(this);
			return this;
		},
	
		// @method removeControl(control: Control): this
		// Removes the given control from the map
		removeControl: function (control) {
			control.remove();
			return this;
		},
	
		_initControlPos: function () {
			var corners = this._controlCorners = {},
			    l = 'leaflet-',
			    container = this._controlContainer =
			            create$1('div', l + 'control-container', this._container);
	
			function createCorner(vSide, hSide) {
				var className = l + vSide + ' ' + l + hSide;
	
				corners[vSide + hSide] = create$1('div', className, container);
			}
	
			createCorner('top', 'left');
			createCorner('top', 'right');
			createCorner('bottom', 'left');
			createCorner('bottom', 'right');
		},
	
		_clearControlPos: function () {
			for (var i in this._controlCorners) {
				remove(this._controlCorners[i]);
			}
			remove(this._controlContainer);
			delete this._controlCorners;
			delete this._controlContainer;
		}
	});
	
	/*
	 * @class Control.Layers
	 * @aka L.Control.Layers
	 * @inherits Control
	 *
	 * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control/)). Extends `Control`.
	 *
	 * @example
	 *
	 * ```js
	 * var baseLayers = {
	 * 	"Mapbox": mapbox,
	 * 	"OpenStreetMap": osm
	 * };
	 *
	 * var overlays = {
	 * 	"Marker": marker,
	 * 	"Roads": roadsLayer
	 * };
	 *
	 * L.control.layers(baseLayers, overlays).addTo(map);
	 * ```
	 *
	 * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
	 *
	 * ```js
	 * {
	 *     "<someName1>": layer1,
	 *     "<someName2>": layer2
	 * }
	 * ```
	 *
	 * The layer names can contain HTML, which allows you to add additional styling to the items:
	 *
	 * ```js
	 * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
	 * ```
	 */
	
	var Layers = Control.extend({
		// @section
		// @aka Control.Layers options
		options: {
			// @option collapsed: Boolean = true
			// If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
			collapsed: true,
			position: 'topright',
	
			// @option autoZIndex: Boolean = true
			// If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
			autoZIndex: true,
	
			// @option hideSingleBase: Boolean = false
			// If `true`, the base layers in the control will be hidden when there is only one.
			hideSingleBase: false,
	
			// @option sortLayers: Boolean = false
			// Whether to sort the layers. When `false`, layers will keep the order
			// in which they were added to the control.
			sortLayers: false,
	
			// @option sortFunction: Function = *
			// A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
			// that will be used for sorting the layers, when `sortLayers` is `true`.
			// The function receives both the `L.Layer` instances and their names, as in
			// `sortFunction(layerA, layerB, nameA, nameB)`.
			// By default, it sorts layers alphabetically by their name.
			sortFunction: function (layerA, layerB, nameA, nameB) {
				return nameA < nameB ? -1 : (nameB < nameA ? 1 : 0);
			}
		},
	
		initialize: function (baseLayers, overlays, options) {
			setOptions(this, options);
	
			this._layerControlInputs = [];
			this._layers = [];
			this._lastZIndex = 0;
			this._handlingClick = false;
	
			for (var i in baseLayers) {
				this._addLayer(baseLayers[i], i);
			}
	
			for (i in overlays) {
				this._addLayer(overlays[i], i, true);
			}
		},
	
		onAdd: function (map) {
			this._initLayout();
			this._update();
	
			this._map = map;
			map.on('zoomend', this._checkDisabledLayers, this);
	
			for (var i = 0; i < this._layers.length; i++) {
				this._layers[i].layer.on('add remove', this._onLayerChange, this);
			}
	
			return this._container;
		},
	
		addTo: function (map) {
			Control.prototype.addTo.call(this, map);
			// Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
			return this._expandIfNotCollapsed();
		},
	
		onRemove: function () {
			this._map.off('zoomend', this._checkDisabledLayers, this);
	
			for (var i = 0; i < this._layers.length; i++) {
				this._layers[i].layer.off('add remove', this._onLayerChange, this);
			}
		},
	
		// @method addBaseLayer(layer: Layer, name: String): this
		// Adds a base layer (radio button entry) with the given name to the control.
		addBaseLayer: function (layer, name) {
			this._addLayer(layer, name);
			return (this._map) ? this._update() : this;
		},
	
		// @method addOverlay(layer: Layer, name: String): this
		// Adds an overlay (checkbox entry) with the given name to the control.
		addOverlay: function (layer, name) {
			this._addLayer(layer, name, true);
			return (this._map) ? this._update() : this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Remove the given layer from the control.
		removeLayer: function (layer) {
			layer.off('add remove', this._onLayerChange, this);
	
			var obj = this._getLayer(stamp(layer));
			if (obj) {
				this._layers.splice(this._layers.indexOf(obj), 1);
			}
			return (this._map) ? this._update() : this;
		},
	
		// @method expand(): this
		// Expand the control container if collapsed.
		expand: function () {
			addClass(this._container, 'leaflet-control-layers-expanded');
			this._form.style.height = null;
			var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
			if (acceptableHeight < this._form.clientHeight) {
				addClass(this._form, 'leaflet-control-layers-scrollbar');
				this._form.style.height = acceptableHeight + 'px';
			} else {
				removeClass(this._form, 'leaflet-control-layers-scrollbar');
			}
			this._checkDisabledLayers();
			return this;
		},
	
		// @method collapse(): this
		// Collapse the control container if expanded.
		collapse: function () {
			removeClass(this._container, 'leaflet-control-layers-expanded');
			return this;
		},
	
		_initLayout: function () {
			var className = 'leaflet-control-layers',
			    container = this._container = create$1('div', className),
			    collapsed = this.options.collapsed;
	
			// makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
			container.setAttribute('aria-haspopup', true);
	
			disableClickPropagation(container);
			disableScrollPropagation(container);
	
			var form = this._form = create$1('form', className + '-list');
	
			if (collapsed) {
				this._map.on('click', this.collapse, this);
	
				if (!android) {
					on(container, {
						mouseenter: this.expand,
						mouseleave: this.collapse
					}, this);
				}
			}
	
			var link = this._layersLink = create$1('a', className + '-toggle', container);
			link.href = '#';
			link.title = 'Layers';
	
			if (touch) {
				on(link, 'click', stop);
				on(link, 'click', this.expand, this);
			} else {
				on(link, 'focus', this.expand, this);
			}
	
			if (!collapsed) {
				this.expand();
			}
	
			this._baseLayersList = create$1('div', className + '-base', form);
			this._separator = create$1('div', className + '-separator', form);
			this._overlaysList = create$1('div', className + '-overlays', form);
	
			container.appendChild(form);
		},
	
		_getLayer: function (id) {
			for (var i = 0; i < this._layers.length; i++) {
	
				if (this._layers[i] && stamp(this._layers[i].layer) === id) {
					return this._layers[i];
				}
			}
		},
	
		_addLayer: function (layer, name, overlay) {
			if (this._map) {
				layer.on('add remove', this._onLayerChange, this);
			}
	
			this._layers.push({
				layer: layer,
				name: name,
				overlay: overlay
			});
	
			if (this.options.sortLayers) {
				this._layers.sort(bind(function (a, b) {
					return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
				}, this));
			}
	
			if (this.options.autoZIndex && layer.setZIndex) {
				this._lastZIndex++;
				layer.setZIndex(this._lastZIndex);
			}
	
			this._expandIfNotCollapsed();
		},
	
		_update: function () {
			if (!this._container) { return this; }
	
			empty(this._baseLayersList);
			empty(this._overlaysList);
	
			this._layerControlInputs = [];
			var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
	
			for (i = 0; i < this._layers.length; i++) {
				obj = this._layers[i];
				this._addItem(obj);
				overlaysPresent = overlaysPresent || obj.overlay;
				baseLayersPresent = baseLayersPresent || !obj.overlay;
				baseLayersCount += !obj.overlay ? 1 : 0;
			}
	
			// Hide base layers section if there's only one layer.
			if (this.options.hideSingleBase) {
				baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
				this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
			}
	
			this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
	
			return this;
		},
	
		_onLayerChange: function (e) {
			if (!this._handlingClick) {
				this._update();
			}
	
			var obj = this._getLayer(stamp(e.target));
	
			// @namespace Map
			// @section Layer events
			// @event baselayerchange: LayersControlEvent
			// Fired when the base layer is changed through the [layer control](#control-layers).
			// @event overlayadd: LayersControlEvent
			// Fired when an overlay is selected through the [layer control](#control-layers).
			// @event overlayremove: LayersControlEvent
			// Fired when an overlay is deselected through the [layer control](#control-layers).
			// @namespace Control.Layers
			var type = obj.overlay ?
				(e.type === 'add' ? 'overlayadd' : 'overlayremove') :
				(e.type === 'add' ? 'baselayerchange' : null);
	
			if (type) {
				this._map.fire(type, obj);
			}
		},
	
		// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
		_createRadioElement: function (name, checked) {
	
			var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' +
					name + '"' + (checked ? ' checked="checked"' : '') + '/>';
	
			var radioFragment = document.createElement('div');
			radioFragment.innerHTML = radioHtml;
	
			return radioFragment.firstChild;
		},
	
		_addItem: function (obj) {
			var label = document.createElement('label'),
			    checked = this._map.hasLayer(obj.layer),
			    input;
	
			if (obj.overlay) {
				input = document.createElement('input');
				input.type = 'checkbox';
				input.className = 'leaflet-control-layers-selector';
				input.defaultChecked = checked;
			} else {
				input = this._createRadioElement('leaflet-base-layers', checked);
			}
	
			this._layerControlInputs.push(input);
			input.layerId = stamp(obj.layer);
	
			on(input, 'click', this._onInputClick, this);
	
			var name = document.createElement('span');
			name.innerHTML = ' ' + obj.name;
	
			// Helps from preventing layer control flicker when checkboxes are disabled
			// https://github.com/Leaflet/Leaflet/issues/2771
			var holder = document.createElement('div');
	
			label.appendChild(holder);
			holder.appendChild(input);
			holder.appendChild(name);
	
			var container = obj.overlay ? this._overlaysList : this._baseLayersList;
			container.appendChild(label);
	
			this._checkDisabledLayers();
			return label;
		},
	
		_onInputClick: function () {
			var inputs = this._layerControlInputs,
			    input, layer;
			var addedLayers = [],
			    removedLayers = [];
	
			this._handlingClick = true;
	
			for (var i = inputs.length - 1; i >= 0; i--) {
				input = inputs[i];
				layer = this._getLayer(input.layerId).layer;
	
				if (input.checked) {
					addedLayers.push(layer);
				} else if (!input.checked) {
					removedLayers.push(layer);
				}
			}
	
			// Bugfix issue 2318: Should remove all old layers before readding new ones
			for (i = 0; i < removedLayers.length; i++) {
				if (this._map.hasLayer(removedLayers[i])) {
					this._map.removeLayer(removedLayers[i]);
				}
			}
			for (i = 0; i < addedLayers.length; i++) {
				if (!this._map.hasLayer(addedLayers[i])) {
					this._map.addLayer(addedLayers[i]);
				}
			}
	
			this._handlingClick = false;
	
			this._refocusOnMap();
		},
	
		_checkDisabledLayers: function () {
			var inputs = this._layerControlInputs,
			    input,
			    layer,
			    zoom = this._map.getZoom();
	
			for (var i = inputs.length - 1; i >= 0; i--) {
				input = inputs[i];
				layer = this._getLayer(input.layerId).layer;
				input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
				                 (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);
	
			}
		},
	
		_expandIfNotCollapsed: function () {
			if (this._map && !this.options.collapsed) {
				this.expand();
			}
			return this;
		},
	
		_expand: function () {
			// Backward compatibility, remove me in 1.1.
			return this.expand();
		},
	
		_collapse: function () {
			// Backward compatibility, remove me in 1.1.
			return this.collapse();
		}
	
	});
	
	
	// @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
	// Creates an attribution control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
	var layers = function (baseLayers, overlays, options) {
		return new Layers(baseLayers, overlays, options);
	};
	
	/*
	 * @class Control.Zoom
	 * @aka L.Control.Zoom
	 * @inherits Control
	 *
	 * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
	 */
	
	var Zoom = Control.extend({
		// @section
		// @aka Control.Zoom options
		options: {
			position: 'topleft',
	
			// @option zoomInText: String = '+'
			// The text set on the 'zoom in' button.
			zoomInText: '+',
	
			// @option zoomInTitle: String = 'Zoom in'
			// The title set on the 'zoom in' button.
			zoomInTitle: 'Zoom in',
	
			// @option zoomOutText: String = '&#x2212;'
			// The text set on the 'zoom out' button.
			zoomOutText: '&#x2212;',
	
			// @option zoomOutTitle: String = 'Zoom out'
			// The title set on the 'zoom out' button.
			zoomOutTitle: 'Zoom out'
		},
	
		onAdd: function (map) {
			var zoomName = 'leaflet-control-zoom',
			    container = create$1('div', zoomName + ' leaflet-bar'),
			    options = this.options;
	
			this._zoomInButton  = this._createButton(options.zoomInText, options.zoomInTitle,
			        zoomName + '-in',  container, this._zoomIn);
			this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
			        zoomName + '-out', container, this._zoomOut);
	
			this._updateDisabled();
			map.on('zoomend zoomlevelschange', this._updateDisabled, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off('zoomend zoomlevelschange', this._updateDisabled, this);
		},
	
		disable: function () {
			this._disabled = true;
			this._updateDisabled();
			return this;
		},
	
		enable: function () {
			this._disabled = false;
			this._updateDisabled();
			return this;
		},
	
		_zoomIn: function (e) {
			if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
				this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			}
		},
	
		_zoomOut: function (e) {
			if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
				this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			}
		},
	
		_createButton: function (html, title, className, container, fn) {
			var link = create$1('a', className, container);
			link.innerHTML = html;
			link.href = '#';
			link.title = title;
	
			/*
			 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
			 */
			link.setAttribute('role', 'button');
			link.setAttribute('aria-label', title);
	
			disableClickPropagation(link);
			on(link, 'click', stop);
			on(link, 'click', fn, this);
			on(link, 'click', this._refocusOnMap, this);
	
			return link;
		},
	
		_updateDisabled: function () {
			var map = this._map,
			    className = 'leaflet-disabled';
	
			removeClass(this._zoomInButton, className);
			removeClass(this._zoomOutButton, className);
	
			if (this._disabled || map._zoom === map.getMinZoom()) {
				addClass(this._zoomOutButton, className);
			}
			if (this._disabled || map._zoom === map.getMaxZoom()) {
				addClass(this._zoomInButton, className);
			}
		}
	});
	
	// @namespace Map
	// @section Control options
	// @option zoomControl: Boolean = true
	// Whether a [zoom control](#control-zoom) is added to the map by default.
	Map.mergeOptions({
		zoomControl: true
	});
	
	Map.addInitHook(function () {
		if (this.options.zoomControl) {
			this.zoomControl = new Zoom();
			this.addControl(this.zoomControl);
		}
	});
	
	// @namespace Control.Zoom
	// @factory L.control.zoom(options: Control.Zoom options)
	// Creates a zoom control
	var zoom = function (options) {
		return new Zoom(options);
	};
	
	/*
	 * @class Control.Scale
	 * @aka L.Control.Scale
	 * @inherits Control
	 *
	 * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
	 *
	 * @example
	 *
	 * ```js
	 * L.control.scale().addTo(map);
	 * ```
	 */
	
	var Scale = Control.extend({
		// @section
		// @aka Control.Scale options
		options: {
			position: 'bottomleft',
	
			// @option maxWidth: Number = 100
			// Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
			maxWidth: 100,
	
			// @option metric: Boolean = True
			// Whether to show the metric scale line (m/km).
			metric: true,
	
			// @option imperial: Boolean = True
			// Whether to show the imperial scale line (mi/ft).
			imperial: true
	
			// @option updateWhenIdle: Boolean = false
			// If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
		},
	
		onAdd: function (map) {
			var className = 'leaflet-control-scale',
			    container = create$1('div', className),
			    options = this.options;
	
			this._addScales(options, className + '-line', container);
	
			map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
			map.whenReady(this._update, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
		},
	
		_addScales: function (options, className, container) {
			if (options.metric) {
				this._mScale = create$1('div', className, container);
			}
			if (options.imperial) {
				this._iScale = create$1('div', className, container);
			}
		},
	
		_update: function () {
			var map = this._map,
			    y = map.getSize().y / 2;
	
			var maxMeters = map.distance(
					map.containerPointToLatLng([0, y]),
					map.containerPointToLatLng([this.options.maxWidth, y]));
	
			this._updateScales(maxMeters);
		},
	
		_updateScales: function (maxMeters) {
			if (this.options.metric && maxMeters) {
				this._updateMetric(maxMeters);
			}
			if (this.options.imperial && maxMeters) {
				this._updateImperial(maxMeters);
			}
		},
	
		_updateMetric: function (maxMeters) {
			var meters = this._getRoundNum(maxMeters),
			    label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';
	
			this._updateScale(this._mScale, label, meters / maxMeters);
		},
	
		_updateImperial: function (maxMeters) {
			var maxFeet = maxMeters * 3.2808399,
			    maxMiles, miles, feet;
	
			if (maxFeet > 5280) {
				maxMiles = maxFeet / 5280;
				miles = this._getRoundNum(maxMiles);
				this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
	
			} else {
				feet = this._getRoundNum(maxFeet);
				this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
			}
		},
	
		_updateScale: function (scale, text, ratio) {
			scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
			scale.innerHTML = text;
		},
	
		_getRoundNum: function (num) {
			var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
			    d = num / pow10;
	
			d = d >= 10 ? 10 :
			    d >= 5 ? 5 :
			    d >= 3 ? 3 :
			    d >= 2 ? 2 : 1;
	
			return pow10 * d;
		}
	});
	
	
	// @factory L.control.scale(options?: Control.Scale options)
	// Creates an scale control with the given options.
	var scale = function (options) {
		return new Scale(options);
	};
	
	/*
	 * @class Control.Attribution
	 * @aka L.Control.Attribution
	 * @inherits Control
	 *
	 * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
	 */
	
	var Attribution = Control.extend({
		// @section
		// @aka Control.Attribution options
		options: {
			position: 'bottomright',
	
			// @option prefix: String = 'Leaflet'
			// The HTML text shown before the attributions. Pass `false` to disable.
			prefix: '<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
		},
	
		initialize: function (options) {
			setOptions(this, options);
	
			this._attributions = {};
		},
	
		onAdd: function (map) {
			map.attributionControl = this;
			this._container = create$1('div', 'leaflet-control-attribution');
			disableClickPropagation(this._container);
	
			// TODO ugly, refactor
			for (var i in map._layers) {
				if (map._layers[i].getAttribution) {
					this.addAttribution(map._layers[i].getAttribution());
				}
			}
	
			this._update();
	
			return this._container;
		},
	
		// @method setPrefix(prefix: String): this
		// Sets the text before the attributions.
		setPrefix: function (prefix) {
			this.options.prefix = prefix;
			this._update();
			return this;
		},
	
		// @method addAttribution(text: String): this
		// Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
		addAttribution: function (text) {
			if (!text) { return this; }
	
			if (!this._attributions[text]) {
				this._attributions[text] = 0;
			}
			this._attributions[text]++;
	
			this._update();
	
			return this;
		},
	
		// @method removeAttribution(text: String): this
		// Removes an attribution text.
		removeAttribution: function (text) {
			if (!text) { return this; }
	
			if (this._attributions[text]) {
				this._attributions[text]--;
				this._update();
			}
	
			return this;
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			var attribs = [];
	
			for (var i in this._attributions) {
				if (this._attributions[i]) {
					attribs.push(i);
				}
			}
	
			var prefixAndAttribs = [];
	
			if (this.options.prefix) {
				prefixAndAttribs.push(this.options.prefix);
			}
			if (attribs.length) {
				prefixAndAttribs.push(attribs.join(', '));
			}
	
			this._container.innerHTML = prefixAndAttribs.join(' | ');
		}
	});
	
	// @namespace Map
	// @section Control options
	// @option attributionControl: Boolean = true
	// Whether a [attribution control](#control-attribution) is added to the map by default.
	Map.mergeOptions({
		attributionControl: true
	});
	
	Map.addInitHook(function () {
		if (this.options.attributionControl) {
			new Attribution().addTo(this);
		}
	});
	
	// @namespace Control.Attribution
	// @factory L.control.attribution(options: Control.Attribution options)
	// Creates an attribution control.
	var attribution = function (options) {
		return new Attribution(options);
	};
	
	Control.Layers = Layers;
	Control.Zoom = Zoom;
	Control.Scale = Scale;
	Control.Attribution = Attribution;
	
	control.layers = layers;
	control.zoom = zoom;
	control.scale = scale;
	control.attribution = attribution;
	
	/*
		L.Handler is a base class for handler classes that are used internally to inject
		interaction features like dragging to classes like Map and Marker.
	*/
	
	// @class Handler
	// @aka L.Handler
	// Abstract class for map interaction handlers
	
	var Handler = Class.extend({
		initialize: function (map) {
			this._map = map;
		},
	
		// @method enable(): this
		// Enables the handler
		enable: function () {
			if (this._enabled) { return this; }
	
			this._enabled = true;
			this.addHooks();
			return this;
		},
	
		// @method disable(): this
		// Disables the handler
		disable: function () {
			if (!this._enabled) { return this; }
	
			this._enabled = false;
			this.removeHooks();
			return this;
		},
	
		// @method enabled(): Boolean
		// Returns `true` if the handler is enabled
		enabled: function () {
			return !!this._enabled;
		}
	
		// @section Extension methods
		// Classes inheriting from `Handler` must implement the two following methods:
		// @method addHooks()
		// Called when the handler is enabled, should add event hooks.
		// @method removeHooks()
		// Called when the handler is disabled, should remove the event hooks added previously.
	});
	
	var Mixin = {Events: Events};
	
	/*
	 * @class Draggable
	 * @aka L.Draggable
	 * @inherits Evented
	 *
	 * A class for making DOM elements draggable (including touch support).
	 * Used internally for map and marker dragging. Only works for elements
	 * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
	 *
	 * @example
	 * ```js
	 * var draggable = new L.Draggable(elementToDrag);
	 * draggable.enable();
	 * ```
	 */
	
	var START = touch ? 'touchstart mousedown' : 'mousedown';
	var END = {
		mousedown: 'mouseup',
		touchstart: 'touchend',
		pointerdown: 'touchend',
		MSPointerDown: 'touchend'
	};
	var MOVE = {
		mousedown: 'mousemove',
		touchstart: 'touchmove',
		pointerdown: 'touchmove',
		MSPointerDown: 'touchmove'
	};
	
	
	var Draggable = Evented.extend({
	
		options: {
			// @section
			// @aka Draggable options
			// @option clickTolerance: Number = 3
			// The max number of pixels a user can shift the mouse pointer during a click
			// for it to be considered a valid click (as opposed to a mouse drag).
			clickTolerance: 3
		},
	
		// @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
		// Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
		initialize: function (element, dragStartTarget, preventOutline$$1, options) {
			setOptions(this, options);
	
			this._element = element;
			this._dragStartTarget = dragStartTarget || element;
			this._preventOutline = preventOutline$$1;
		},
	
		// @method enable()
		// Enables the dragging ability
		enable: function () {
			if (this._enabled) { return; }
	
			on(this._dragStartTarget, START, this._onDown, this);
	
			this._enabled = true;
		},
	
		// @method disable()
		// Disables the dragging ability
		disable: function () {
			if (!this._enabled) { return; }
	
			// If we're currently dragging this draggable,
			// disabling it counts as first ending the drag.
			if (Draggable._dragging === this) {
				this.finishDrag();
			}
	
			off(this._dragStartTarget, START, this._onDown, this);
	
			this._enabled = false;
			this._moved = false;
		},
	
		_onDown: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
	
			this._moved = false;
	
			if (hasClass(this._element, 'leaflet-zoom-anim')) { return; }
	
			if (Draggable._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
			Draggable._dragging = this;  // Prevent dragging multiple objects at once.
	
			if (this._preventOutline) {
				preventOutline(this._element);
			}
	
			disableImageDrag();
			disableTextSelection();
	
			if (this._moving) { return; }
	
			// @event down: Event
			// Fired when a drag is about to start.
			this.fire('down');
	
			var first = e.touches ? e.touches[0] : e;
	
			this._startPoint = new Point(first.clientX, first.clientY);
	
			on(document, MOVE[e.type], this._onMove, this);
			on(document, END[e.type], this._onUp, this);
		},
	
		_onMove: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
	
			if (e.touches && e.touches.length > 1) {
				this._moved = true;
				return;
			}
	
			var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
			    newPoint = new Point(first.clientX, first.clientY),
			    offset = newPoint.subtract(this._startPoint);
	
			if (!offset.x && !offset.y) { return; }
			if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }
	
			preventDefault(e);
	
			if (!this._moved) {
				// @event dragstart: Event
				// Fired when a drag starts
				this.fire('dragstart');
	
				this._moved = true;
				this._startPos = getPosition(this._element).subtract(offset);
	
				addClass(document.body, 'leaflet-dragging');
	
				this._lastTarget = e.target || e.srcElement;
				// IE and Edge do not give the <use> element, so fetch it
				// if necessary
				if ((window.SVGElementInstance) && (this._lastTarget instanceof SVGElementInstance)) {
					this._lastTarget = this._lastTarget.correspondingUseElement;
				}
				addClass(this._lastTarget, 'leaflet-drag-target');
			}
	
			this._newPos = this._startPos.add(offset);
			this._moving = true;
	
			cancelAnimFrame(this._animRequest);
			this._lastEvent = e;
			this._animRequest = requestAnimFrame(this._updatePosition, this, true);
		},
	
		_updatePosition: function () {
			var e = {originalEvent: this._lastEvent};
	
			// @event predrag: Event
			// Fired continuously during dragging *before* each corresponding
			// update of the element's position.
			this.fire('predrag', e);
			setPosition(this._element, this._newPos);
	
			// @event drag: Event
			// Fired continuously during dragging.
			this.fire('drag', e);
		},
	
		_onUp: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
			this.finishDrag();
		},
	
		finishDrag: function () {
			removeClass(document.body, 'leaflet-dragging');
	
			if (this._lastTarget) {
				removeClass(this._lastTarget, 'leaflet-drag-target');
				this._lastTarget = null;
			}
	
			for (var i in MOVE) {
				off(document, MOVE[i], this._onMove, this);
				off(document, END[i], this._onUp, this);
			}
	
			enableImageDrag();
			enableTextSelection();
	
			if (this._moved && this._moving) {
				// ensure drag is not fired after dragend
				cancelAnimFrame(this._animRequest);
	
				// @event dragend: DragEndEvent
				// Fired when the drag ends.
				this.fire('dragend', {
					distance: this._newPos.distanceTo(this._startPos)
				});
			}
	
			this._moving = false;
			Draggable._dragging = false;
		}
	
	});
	
	/*
	 * @namespace LineUtil
	 *
	 * Various utility functions for polyine points processing, used by Leaflet internally to make polylines lightning-fast.
	 */
	
	// Simplify polyline with vertex reduction and Douglas-Peucker simplification.
	// Improves rendering performance dramatically by lessening the number of points to draw.
	
	// @function simplify(points: Point[], tolerance: Number): Point[]
	// Dramatically reduces the number of points in a polyline while retaining
	// its shape and returns a new array of simplified points, using the
	// [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
	// Used for a huge performance boost when processing/displaying Leaflet polylines for
	// each zoom level and also reducing visual noise. tolerance affects the amount of
	// simplification (lesser value means higher quality but slower and with more points).
	// Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
	function simplify(points, tolerance) {
		if (!tolerance || !points.length) {
			return points.slice();
		}
	
		var sqTolerance = tolerance * tolerance;
	
		    // stage 1: vertex reduction
		    points = _reducePoints(points, sqTolerance);
	
		    // stage 2: Douglas-Peucker simplification
		    points = _simplifyDP(points, sqTolerance);
	
		return points;
	}
	
	// @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
	// Returns the distance between point `p` and segment `p1` to `p2`.
	function pointToSegmentDistance(p, p1, p2) {
		return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
	}
	
	// @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
	// Returns the closest point from a point `p` on a segment `p1` to `p2`.
	function closestPointOnSegment(p, p1, p2) {
		return _sqClosestPointOnSegment(p, p1, p2);
	}
	
	// Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
	function _simplifyDP(points, sqTolerance) {
	
		var len = points.length,
		    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
		    markers = new ArrayConstructor(len);
	
		    markers[0] = markers[len - 1] = 1;
	
		_simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
	
		var i,
		    newPoints = [];
	
		for (i = 0; i < len; i++) {
			if (markers[i]) {
				newPoints.push(points[i]);
			}
		}
	
		return newPoints;
	}
	
	function _simplifyDPStep(points, markers, sqTolerance, first, last) {
	
		var maxSqDist = 0,
		index, i, sqDist;
	
		for (i = first + 1; i <= last - 1; i++) {
			sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
	
			if (sqDist > maxSqDist) {
				index = i;
				maxSqDist = sqDist;
			}
		}
	
		if (maxSqDist > sqTolerance) {
			markers[index] = 1;
	
			_simplifyDPStep(points, markers, sqTolerance, first, index);
			_simplifyDPStep(points, markers, sqTolerance, index, last);
		}
	}
	
	// reduce points that are too close to each other to a single point
	function _reducePoints(points, sqTolerance) {
		var reducedPoints = [points[0]];
	
		for (var i = 1, prev = 0, len = points.length; i < len; i++) {
			if (_sqDist(points[i], points[prev]) > sqTolerance) {
				reducedPoints.push(points[i]);
				prev = i;
			}
		}
		if (prev < len - 1) {
			reducedPoints.push(points[len - 1]);
		}
		return reducedPoints;
	}
	
	var _lastCode;
	
	// @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
	// Clips the segment a to b by rectangular bounds with the
	// [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
	// (modifying the segment points directly!). Used by Leaflet to only show polyline
	// points that are on the screen or near, increasing performance.
	function clipSegment(a, b, bounds, useLastCode, round) {
		var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds),
		    codeB = _getBitCode(b, bounds),
	
		    codeOut, p, newCode;
	
		    // save 2nd code to avoid calculating it on the next segment
		    _lastCode = codeB;
	
		while (true) {
			// if a,b is inside the clip window (trivial accept)
			if (!(codeA | codeB)) {
				return [a, b];
			}
	
			// if a,b is outside the clip window (trivial reject)
			if (codeA & codeB) {
				return false;
			}
	
			// other cases
			codeOut = codeA || codeB;
			p = _getEdgeIntersection(a, b, codeOut, bounds, round);
			newCode = _getBitCode(p, bounds);
	
			if (codeOut === codeA) {
				a = p;
				codeA = newCode;
			} else {
				b = p;
				codeB = newCode;
			}
		}
	}
	
	function _getEdgeIntersection(a, b, code, bounds, round) {
		var dx = b.x - a.x,
		    dy = b.y - a.y,
		    min = bounds.min,
		    max = bounds.max,
		    x, y;
	
		if (code & 8) { // top
			x = a.x + dx * (max.y - a.y) / dy;
			y = max.y;
	
		} else if (code & 4) { // bottom
			x = a.x + dx * (min.y - a.y) / dy;
			y = min.y;
	
		} else if (code & 2) { // right
			x = max.x;
			y = a.y + dy * (max.x - a.x) / dx;
	
		} else if (code & 1) { // left
			x = min.x;
			y = a.y + dy * (min.x - a.x) / dx;
		}
	
		return new Point(x, y, round);
	}
	
	function _getBitCode(p, bounds) {
		var code = 0;
	
		if (p.x < bounds.min.x) { // left
			code |= 1;
		} else if (p.x > bounds.max.x) { // right
			code |= 2;
		}
	
		if (p.y < bounds.min.y) { // bottom
			code |= 4;
		} else if (p.y > bounds.max.y) { // top
			code |= 8;
		}
	
		return code;
	}
	
	// square distance (to avoid unnecessary Math.sqrt calls)
	function _sqDist(p1, p2) {
		var dx = p2.x - p1.x,
		    dy = p2.y - p1.y;
		return dx * dx + dy * dy;
	}
	
	// return closest point on segment or distance to that point
	function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
		var x = p1.x,
		    y = p1.y,
		    dx = p2.x - x,
		    dy = p2.y - y,
		    dot = dx * dx + dy * dy,
		    t;
	
		if (dot > 0) {
			t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
	
			if (t > 1) {
				x = p2.x;
				y = p2.y;
			} else if (t > 0) {
				x += dx * t;
				y += dy * t;
			}
		}
	
		dx = p.x - x;
		dy = p.y - y;
	
		return sqDist ? dx * dx + dy * dy : new Point(x, y);
	}
	
	
	// @function isFlat(latlngs: LatLng[]): Boolean
	// Returns true if `latlngs` is a flat array, false is nested.
	function isFlat(latlngs) {
		return !isArray(latlngs[0]) || (typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined');
	}
	
	function _flat(latlngs) {
		console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
		return isFlat(latlngs);
	}
	
	
	var LineUtil = (Object.freeze || Object)({
		simplify: simplify,
		pointToSegmentDistance: pointToSegmentDistance,
		closestPointOnSegment: closestPointOnSegment,
		clipSegment: clipSegment,
		_getEdgeIntersection: _getEdgeIntersection,
		_getBitCode: _getBitCode,
		_sqClosestPointOnSegment: _sqClosestPointOnSegment,
		isFlat: isFlat,
		_flat: _flat
	});
	
	/*
	 * @namespace PolyUtil
	 * Various utility functions for polygon geometries.
	 */
	
	/* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
	 * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgeman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
	 * Used by Leaflet to only show polygon points that are on the screen or near, increasing
	 * performance. Note that polygon points needs different algorithm for clipping
	 * than polyline, so there's a seperate method for it.
	 */
	function clipPolygon(points, bounds, round) {
		var clippedPoints,
		    edges = [1, 4, 2, 8],
		    i, j, k,
		    a, b,
		    len, edge, p;
	
		for (i = 0, len = points.length; i < len; i++) {
			points[i]._code = _getBitCode(points[i], bounds);
		}
	
		// for each edge (left, bottom, right, top)
		for (k = 0; k < 4; k++) {
			edge = edges[k];
			clippedPoints = [];
	
			for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
				a = points[i];
				b = points[j];
	
				// if a is inside the clip window
				if (!(a._code & edge)) {
					// if b is outside the clip window (a->b goes out of screen)
					if (b._code & edge) {
						p = _getEdgeIntersection(b, a, edge, bounds, round);
						p._code = _getBitCode(p, bounds);
						clippedPoints.push(p);
					}
					clippedPoints.push(a);
	
				// else if b is inside the clip window (a->b enters the screen)
				} else if (!(b._code & edge)) {
					p = _getEdgeIntersection(b, a, edge, bounds, round);
					p._code = _getBitCode(p, bounds);
					clippedPoints.push(p);
				}
			}
			points = clippedPoints;
		}
	
		return points;
	}
	
	
	var PolyUtil = (Object.freeze || Object)({
		clipPolygon: clipPolygon
	});
	
	/*
	 * @namespace Projection
	 * @section
	 * Leaflet comes with a set of already defined Projections out of the box:
	 *
	 * @projection L.Projection.LonLat
	 *
	 * Equirectangular, or Plate Carree projection — the most simple projection,
	 * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
	 * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
	 * `EPSG:4326` and `Simple` CRS.
	 */
	
	var LonLat = {
		project: function (latlng) {
			return new Point(latlng.lng, latlng.lat);
		},
	
		unproject: function (point) {
			return new LatLng(point.y, point.x);
		},
	
		bounds: new Bounds([-180, -90], [180, 90])
	};
	
	/*
	 * @namespace Projection
	 * @projection L.Projection.Mercator
	 *
	 * Elliptical Mercator projection — more complex than Spherical Mercator. Takes into account that Earth is a geoid, not a perfect sphere. Used by the EPSG:3395 CRS.
	 */
	
	var Mercator = {
		R: 6378137,
		R_MINOR: 6356752.314245179,
	
		bounds: new Bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),
	
		project: function (latlng) {
			var d = Math.PI / 180,
			    r = this.R,
			    y = latlng.lat * d,
			    tmp = this.R_MINOR / r,
			    e = Math.sqrt(1 - tmp * tmp),
			    con = e * Math.sin(y);
	
			var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
			y = -r * Math.log(Math.max(ts, 1E-10));
	
			return new Point(latlng.lng * d * r, y);
		},
	
		unproject: function (point) {
			var d = 180 / Math.PI,
			    r = this.R,
			    tmp = this.R_MINOR / r,
			    e = Math.sqrt(1 - tmp * tmp),
			    ts = Math.exp(-point.y / r),
			    phi = Math.PI / 2 - 2 * Math.atan(ts);
	
			for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
				con = e * Math.sin(phi);
				con = Math.pow((1 - con) / (1 + con), e / 2);
				dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
				phi += dphi;
			}
	
			return new LatLng(phi * d, point.x * d / r);
		}
	};
	
	/*
	 * @class Projection
	
	 * An object with methods for projecting geographical coordinates of the world onto
	 * a flat surface (and back). See [Map projection](http://en.wikipedia.org/wiki/Map_projection).
	
	 * @property bounds: Bounds
	 * The bounds (specified in CRS units) where the projection is valid
	
	 * @method project(latlng: LatLng): Point
	 * Projects geographical coordinates into a 2D point.
	 * Only accepts actual `L.LatLng` instances, not arrays.
	
	 * @method unproject(point: Point): LatLng
	 * The inverse of `project`. Projects a 2D point into a geographical location.
	 * Only accepts actual `L.Point` instances, not arrays.
	
	 */
	
	
	
	
	var index = (Object.freeze || Object)({
		LonLat: LonLat,
		Mercator: Mercator,
		SphericalMercator: SphericalMercator
	});
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG3395
	 *
	 * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
	 */
	var EPSG3395 = extend({}, Earth, {
		code: 'EPSG:3395',
		projection: Mercator,
	
		transformation: (function () {
			var scale = 0.5 / (Math.PI * Mercator.R);
			return toTransformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG4326
	 *
	 * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
	 *
	 * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
	 * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
	 * with this CRS, ensure that there are two 256x256 pixel tiles covering the
	 * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
	 * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
	 */
	
	var EPSG4326 = extend({}, Earth, {
		code: 'EPSG:4326',
		projection: LonLat,
		transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
	});
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Simple
	 *
	 * A simple CRS that maps longitude and latitude into `x` and `y` directly.
	 * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
	 * axis should still be inverted (going from bottom to top). `distance()` returns
	 * simple euclidean distance.
	 */
	
	var Simple = extend({}, CRS, {
		projection: LonLat,
		transformation: toTransformation(1, 0, -1, 0),
	
		scale: function (zoom) {
			return Math.pow(2, zoom);
		},
	
		zoom: function (scale) {
			return Math.log(scale) / Math.LN2;
		},
	
		distance: function (latlng1, latlng2) {
			var dx = latlng2.lng - latlng1.lng,
			    dy = latlng2.lat - latlng1.lat;
	
			return Math.sqrt(dx * dx + dy * dy);
		},
	
		infinite: true
	});
	
	CRS.Earth = Earth;
	CRS.EPSG3395 = EPSG3395;
	CRS.EPSG3857 = EPSG3857;
	CRS.EPSG900913 = EPSG900913;
	CRS.EPSG4326 = EPSG4326;
	CRS.Simple = Simple;
	
	/*
	 * @class Layer
	 * @inherits Evented
	 * @aka L.Layer
	 * @aka ILayer
	 *
	 * A set of methods from the Layer base class that all Leaflet layers use.
	 * Inherits all methods, options and events from `L.Evented`.
	 *
	 * @example
	 *
	 * ```js
	 * var layer = L.Marker(latlng).addTo(map);
	 * layer.addTo(map);
	 * layer.remove();
	 * ```
	 *
	 * @event add: Event
	 * Fired after the layer is added to a map
	 *
	 * @event remove: Event
	 * Fired after the layer is removed from a map
	 */
	
	
	var Layer = Evented.extend({
	
		// Classes extending `L.Layer` will inherit the following options:
		options: {
			// @option pane: String = 'overlayPane'
			// By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
			pane: 'overlayPane',
	
			// @option attribution: String = null
			// String to be shown in the attribution control, describes the layer data, e.g. "© Mapbox".
			attribution: null,
	
			bubblingMouseEvents: true
		},
	
		/* @section
		 * Classes extending `L.Layer` will inherit the following methods:
		 *
		 * @method addTo(map: Map|LayerGroup): this
		 * Adds the layer to the given map or layer group.
		 */
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		// @method remove: this
		// Removes the layer from the map it is currently active on.
		remove: function () {
			return this.removeFrom(this._map || this._mapToAdd);
		},
	
		// @method removeFrom(map: Map): this
		// Removes the layer from the given map
		removeFrom: function (obj) {
			if (obj) {
				obj.removeLayer(this);
			}
			return this;
		},
	
		// @method getPane(name? : String): HTMLElement
		// Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
		getPane: function (name) {
			return this._map.getPane(name ? (this.options[name] || name) : this.options.pane);
		},
	
		addInteractiveTarget: function (targetEl) {
			this._map._targets[stamp(targetEl)] = this;
			return this;
		},
	
		removeInteractiveTarget: function (targetEl) {
			delete this._map._targets[stamp(targetEl)];
			return this;
		},
	
		// @method getAttribution: String
		// Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
		getAttribution: function () {
			return this.options.attribution;
		},
	
		_layerAdd: function (e) {
			var map = e.target;
	
			// check in case layer gets added and then removed before the map is ready
			if (!map.hasLayer(this)) { return; }
	
			this._map = map;
			this._zoomAnimated = map._zoomAnimated;
	
			if (this.getEvents) {
				var events = this.getEvents();
				map.on(events, this);
				this.once('remove', function () {
					map.off(events, this);
				}, this);
			}
	
			this.onAdd(map);
	
			if (this.getAttribution && map.attributionControl) {
				map.attributionControl.addAttribution(this.getAttribution());
			}
	
			this.fire('add');
			map.fire('layeradd', {layer: this});
		}
	});
	
	/* @section Extension methods
	 * @uninheritable
	 *
	 * Every layer should extend from `L.Layer` and (re-)implement the following methods.
	 *
	 * @method onAdd(map: Map): this
	 * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
	 *
	 * @method onRemove(map: Map): this
	 * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
	 *
	 * @method getEvents(): Object
	 * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
	 *
	 * @method getAttribution(): String
	 * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
	 *
	 * @method beforeAdd(map: Map): this
	 * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
	 */
	
	
	/* @namespace Map
	 * @section Layer events
	 *
	 * @event layeradd: LayerEvent
	 * Fired when a new layer is added to the map.
	 *
	 * @event layerremove: LayerEvent
	 * Fired when some layer is removed from the map
	 *
	 * @section Methods for Layers and Controls
	 */
	Map.include({
		// @method addLayer(layer: Layer): this
		// Adds the given layer to the map
		addLayer: function (layer) {
			if (!layer._layerAdd) {
				throw new Error('The provided object is not a Layer.');
			}
	
			var id = stamp(layer);
			if (this._layers[id]) { return this; }
			this._layers[id] = layer;
	
			layer._mapToAdd = this;
	
			if (layer.beforeAdd) {
				layer.beforeAdd(this);
			}
	
			this.whenReady(layer._layerAdd, layer);
	
			return this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Removes the given layer from the map.
		removeLayer: function (layer) {
			var id = stamp(layer);
	
			if (!this._layers[id]) { return this; }
	
			if (this._loaded) {
				layer.onRemove(this);
			}
	
			if (layer.getAttribution && this.attributionControl) {
				this.attributionControl.removeAttribution(layer.getAttribution());
			}
	
			delete this._layers[id];
	
			if (this._loaded) {
				this.fire('layerremove', {layer: layer});
				layer.fire('remove');
			}
	
			layer._map = layer._mapToAdd = null;
	
			return this;
		},
	
		// @method hasLayer(layer: Layer): Boolean
		// Returns `true` if the given layer is currently added to the map
		hasLayer: function (layer) {
			return !!layer && (stamp(layer) in this._layers);
		},
	
		/* @method eachLayer(fn: Function, context?: Object): this
		 * Iterates over the layers of the map, optionally specifying context of the iterator function.
		 * ```
		 * map.eachLayer(function(layer){
		 *     layer.bindPopup('Hello');
		 * });
		 * ```
		 */
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		_addLayers: function (layers) {
			layers = layers ? (isArray(layers) ? layers : [layers]) : [];
	
			for (var i = 0, len = layers.length; i < len; i++) {
				this.addLayer(layers[i]);
			}
		},
	
		_addZoomLimit: function (layer) {
			if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
				this._zoomBoundLayers[stamp(layer)] = layer;
				this._updateZoomLevels();
			}
		},
	
		_removeZoomLimit: function (layer) {
			var id = stamp(layer);
	
			if (this._zoomBoundLayers[id]) {
				delete this._zoomBoundLayers[id];
				this._updateZoomLevels();
			}
		},
	
		_updateZoomLevels: function () {
			var minZoom = Infinity,
			    maxZoom = -Infinity,
			    oldZoomSpan = this._getZoomSpan();
	
			for (var i in this._zoomBoundLayers) {
				var options = this._zoomBoundLayers[i].options;
	
				minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
				maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
			}
	
			this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
			this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
	
			// @section Map state change events
			// @event zoomlevelschange: Event
			// Fired when the number of zoomlevels on the map is changed due
			// to adding or removing a layer.
			if (oldZoomSpan !== this._getZoomSpan()) {
				this.fire('zoomlevelschange');
			}
	
			if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
				this.setZoom(this._layersMaxZoom);
			}
			if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
				this.setZoom(this._layersMinZoom);
			}
		}
	});
	
	/*
	 * @class LayerGroup
	 * @aka L.LayerGroup
	 * @inherits Layer
	 *
	 * Used to group several layers and handle them as one. If you add it to the map,
	 * any layers added or removed from the group will be added/removed on the map as
	 * well. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.layerGroup([marker1, marker2])
	 * 	.addLayer(polyline)
	 * 	.addTo(map);
	 * ```
	 */
	
	var LayerGroup = Layer.extend({
	
		initialize: function (layers) {
			this._layers = {};
	
			var i, len;
	
			if (layers) {
				for (i = 0, len = layers.length; i < len; i++) {
					this.addLayer(layers[i]);
				}
			}
		},
	
		// @method addLayer(layer: Layer): this
		// Adds the given layer to the group.
		addLayer: function (layer) {
			var id = this.getLayerId(layer);
	
			this._layers[id] = layer;
	
			if (this._map) {
				this._map.addLayer(layer);
			}
	
			return this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Removes the given layer from the group.
		// @alternative
		// @method removeLayer(id: Number): this
		// Removes the layer with the given internal ID from the group.
		removeLayer: function (layer) {
			var id = layer in this._layers ? layer : this.getLayerId(layer);
	
			if (this._map && this._layers[id]) {
				this._map.removeLayer(this._layers[id]);
			}
	
			delete this._layers[id];
	
			return this;
		},
	
		// @method hasLayer(layer: Layer): Boolean
		// Returns `true` if the given layer is currently added to the group.
		// @alternative
		// @method hasLayer(id: Number): Boolean
		// Returns `true` if the given internal ID is currently added to the group.
		hasLayer: function (layer) {
			return !!layer && (layer in this._layers || this.getLayerId(layer) in this._layers);
		},
	
		// @method clearLayers(): this
		// Removes all the layers from the group.
		clearLayers: function () {
			for (var i in this._layers) {
				this.removeLayer(this._layers[i]);
			}
			return this;
		},
	
		// @method invoke(methodName: String, …): this
		// Calls `methodName` on every layer contained in this group, passing any
		// additional parameters. Has no effect if the layers contained do not
		// implement `methodName`.
		invoke: function (methodName) {
			var args = Array.prototype.slice.call(arguments, 1),
			    i, layer;
	
			for (i in this._layers) {
				layer = this._layers[i];
	
				if (layer[methodName]) {
					layer[methodName].apply(layer, args);
				}
			}
	
			return this;
		},
	
		onAdd: function (map) {
			for (var i in this._layers) {
				map.addLayer(this._layers[i]);
			}
		},
	
		onRemove: function (map) {
			for (var i in this._layers) {
				map.removeLayer(this._layers[i]);
			}
		},
	
		// @method eachLayer(fn: Function, context?: Object): this
		// Iterates over the layers of the group, optionally specifying context of the iterator function.
		// ```js
		// group.eachLayer(function (layer) {
		// 	layer.bindPopup('Hello');
		// });
		// ```
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		// @method getLayer(id: Number): Layer
		// Returns the layer with the given internal ID.
		getLayer: function (id) {
			return this._layers[id];
		},
	
		// @method getLayers(): Layer[]
		// Returns an array of all the layers added to the group.
		getLayers: function () {
			var layers = [];
	
			for (var i in this._layers) {
				layers.push(this._layers[i]);
			}
			return layers;
		},
	
		// @method setZIndex(zIndex: Number): this
		// Calls `setZIndex` on every layer contained in this group, passing the z-index.
		setZIndex: function (zIndex) {
			return this.invoke('setZIndex', zIndex);
		},
	
		// @method getLayerId(layer: Layer): Number
		// Returns the internal ID for a layer
		getLayerId: function (layer) {
			return stamp(layer);
		}
	});
	
	
	// @factory L.layerGroup(layers?: Layer[])
	// Create a layer group, optionally given an initial set of layers.
	var layerGroup = function (layers) {
		return new LayerGroup(layers);
	};
	
	/*
	 * @class FeatureGroup
	 * @aka L.FeatureGroup
	 * @inherits LayerGroup
	 *
	 * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
	 *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
	 *  * Events are propagated to the `FeatureGroup`, so if the group has an event
	 * handler, it will handle events from any of the layers. This includes mouse events
	 * and custom events.
	 *  * Has `layeradd` and `layerremove` events
	 *
	 * @example
	 *
	 * ```js
	 * L.featureGroup([marker1, marker2, polyline])
	 * 	.bindPopup('Hello world!')
	 * 	.on('click', function() { alert('Clicked on a member of the group!'); })
	 * 	.addTo(map);
	 * ```
	 */
	
	var FeatureGroup = LayerGroup.extend({
	
		addLayer: function (layer) {
			if (this.hasLayer(layer)) {
				return this;
			}
	
			layer.addEventParent(this);
	
			LayerGroup.prototype.addLayer.call(this, layer);
	
			// @event layeradd: LayerEvent
			// Fired when a layer is added to this `FeatureGroup`
			return this.fire('layeradd', {layer: layer});
		},
	
		removeLayer: function (layer) {
			if (!this.hasLayer(layer)) {
				return this;
			}
			if (layer in this._layers) {
				layer = this._layers[layer];
			}
	
			layer.removeEventParent(this);
	
			LayerGroup.prototype.removeLayer.call(this, layer);
	
			// @event layerremove: LayerEvent
			// Fired when a layer is removed from this `FeatureGroup`
			return this.fire('layerremove', {layer: layer});
		},
	
		// @method setStyle(style: Path options): this
		// Sets the given path options to each layer of the group that has a `setStyle` method.
		setStyle: function (style) {
			return this.invoke('setStyle', style);
		},
	
		// @method bringToFront(): this
		// Brings the layer group to the top of all other layers
		bringToFront: function () {
			return this.invoke('bringToFront');
		},
	
		// @method bringToBack(): this
		// Brings the layer group to the top of all other layers
		bringToBack: function () {
			return this.invoke('bringToBack');
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
		getBounds: function () {
			var bounds = new LatLngBounds();
	
			for (var id in this._layers) {
				var layer = this._layers[id];
				bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
			}
			return bounds;
		}
	});
	
	// @factory L.featureGroup(layers: Layer[])
	// Create a feature group, optionally given an initial set of layers.
	var featureGroup = function (layers) {
		return new FeatureGroup(layers);
	};
	
	/*
	 * @class Icon
	 * @aka L.Icon
	 *
	 * Represents an icon to provide when creating a marker.
	 *
	 * @example
	 *
	 * ```js
	 * var myIcon = L.icon({
	 *     iconUrl: 'my-icon.png',
	 *     iconRetinaUrl: 'my-icon@2x.png',
	 *     iconSize: [38, 95],
	 *     iconAnchor: [22, 94],
	 *     popupAnchor: [-3, -76],
	 *     shadowUrl: 'my-icon-shadow.png',
	 *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
	 *     shadowSize: [68, 95],
	 *     shadowAnchor: [22, 94]
	 * });
	 *
	 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	 * ```
	 *
	 * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
	 *
	 */
	
	var Icon = Class.extend({
	
		/* @section
		 * @aka Icon options
		 *
		 * @option iconUrl: String = null
		 * **(required)** The URL to the icon image (absolute or relative to your script path).
		 *
		 * @option iconRetinaUrl: String = null
		 * The URL to a retina sized version of the icon image (absolute or relative to your
		 * script path). Used for Retina screen devices.
		 *
		 * @option iconSize: Point = null
		 * Size of the icon image in pixels.
		 *
		 * @option iconAnchor: Point = null
		 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
		 * will be aligned so that this point is at the marker's geographical location. Centered
		 * by default if size is specified, also can be set in CSS with negative margins.
		 *
		 * @option popupAnchor: Point = null
		 * The coordinates of the point from which popups will "open", relative to the icon anchor.
		 *
		 * @option shadowUrl: String = null
		 * The URL to the icon shadow image. If not specified, no shadow image will be created.
		 *
		 * @option shadowRetinaUrl: String = null
		 *
		 * @option shadowSize: Point = null
		 * Size of the shadow image in pixels.
		 *
		 * @option shadowAnchor: Point = null
		 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
		 * as iconAnchor if not specified).
		 *
		 * @option className: String = ''
		 * A custom class name to assign to both icon and shadow images. Empty by default.
		 */
	
		initialize: function (options) {
			setOptions(this, options);
		},
	
		// @method createIcon(oldIcon?: HTMLElement): HTMLElement
		// Called internally when the icon has to be shown, returns a `<img>` HTML element
		// styled according to the options.
		createIcon: function (oldIcon) {
			return this._createIcon('icon', oldIcon);
		},
	
		// @method createShadow(oldIcon?: HTMLElement): HTMLElement
		// As `createIcon`, but for the shadow beneath it.
		createShadow: function (oldIcon) {
			return this._createIcon('shadow', oldIcon);
		},
	
		_createIcon: function (name, oldIcon) {
			var src = this._getIconUrl(name);
	
			if (!src) {
				if (name === 'icon') {
					throw new Error('iconUrl not set in Icon options (see the docs).');
				}
				return null;
			}
	
			var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
			this._setIconStyles(img, name);
	
			return img;
		},
	
		_setIconStyles: function (img, name) {
			var options = this.options;
			var sizeOption = options[name + 'Size'];
	
			if (typeof sizeOption === 'number') {
				sizeOption = [sizeOption, sizeOption];
			}
	
			var size = toPoint(sizeOption),
			    anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor ||
			            size && size.divideBy(2, true));
	
			img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
	
			if (anchor) {
				img.style.marginLeft = (-anchor.x) + 'px';
				img.style.marginTop  = (-anchor.y) + 'px';
			}
	
			if (size) {
				img.style.width  = size.x + 'px';
				img.style.height = size.y + 'px';
			}
		},
	
		_createImg: function (src, el) {
			el = el || document.createElement('img');
			el.src = src;
			return el;
		},
	
		_getIconUrl: function (name) {
			return retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
		}
	});
	
	
	// @factory L.icon(options: Icon options)
	// Creates an icon instance with the given options.
	function icon(options) {
		return new Icon(options);
	}
	
	/*
	 * @miniclass Icon.Default (Icon)
	 * @aka L.Icon.Default
	 * @section
	 *
	 * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
	 * no icon is specified. Points to the blue marker image distributed with Leaflet
	 * releases.
	 *
	 * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
	 * (which is a set of `Icon options`).
	 *
	 * If you want to _completely_ replace the default icon, override the
	 * `L.Marker.prototype.options.icon` with your own icon instead.
	 */
	
	var IconDefault = Icon.extend({
	
		options: {
			iconUrl:       'marker-icon.png',
			iconRetinaUrl: 'marker-icon-2x.png',
			shadowUrl:     'marker-shadow.png',
			iconSize:    [25, 41],
			iconAnchor:  [12, 41],
			popupAnchor: [1, -34],
			tooltipAnchor: [16, -28],
			shadowSize:  [41, 41]
		},
	
		_getIconUrl: function (name) {
			if (!IconDefault.imagePath) {	// Deprecated, backwards-compatibility only
				IconDefault.imagePath = this._detectIconPath();
			}
	
			// @option imagePath: String
			// `Icon.Default` will try to auto-detect the absolute location of the
			// blue icon images. If you are placing these images in a non-standard
			// way, set this option to point to the right absolute path.
			return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
		},
	
		_detectIconPath: function () {
			var el = create$1('div',  'leaflet-default-icon-path', document.body);
			var path = getStyle(el, 'background-image') ||
			           getStyle(el, 'backgroundImage');	// IE8
	
			document.body.removeChild(el);
	
			if (path === null || path.indexOf('url') !== 0) {
				path = '';
			} else {
				path = path.replace(/^url\([\"\']?/, '').replace(/marker-icon\.png[\"\']?\)$/, '');
			}
	
			return path;
		}
	});
	
	/*
	 * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
	 */
	
	
	/* @namespace Marker
	 * @section Interaction handlers
	 *
	 * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
	 *
	 * ```js
	 * marker.dragging.disable();
	 * ```
	 *
	 * @property dragging: Handler
	 * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
	 */
	
	var MarkerDrag = Handler.extend({
		initialize: function (marker) {
			this._marker = marker;
		},
	
		addHooks: function () {
			var icon = this._marker._icon;
	
			if (!this._draggable) {
				this._draggable = new Draggable(icon, icon, true);
			}
	
			this._draggable.on({
				dragstart: this._onDragStart,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this).enable();
	
			addClass(icon, 'leaflet-marker-draggable');
		},
	
		removeHooks: function () {
			this._draggable.off({
				dragstart: this._onDragStart,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this).disable();
	
			if (this._marker._icon) {
				removeClass(this._marker._icon, 'leaflet-marker-draggable');
			}
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		_onDragStart: function () {
			// @section Dragging events
			// @event dragstart: Event
			// Fired when the user starts dragging the marker.
	
			// @event movestart: Event
			// Fired when the marker starts moving (because of dragging).
	
			this._oldLatLng = this._marker.getLatLng();
			this._marker
			    .closePopup()
			    .fire('movestart')
			    .fire('dragstart');
		},
	
		_onDrag: function (e) {
			var marker = this._marker,
			    shadow = marker._shadow,
			iconPos = getPosition(marker._icon),
			    latlng = marker._map.layerPointToLatLng(iconPos);
	
			// update shadow position
			if (shadow) {
				setPosition(shadow, iconPos);
			}
	
			marker._latlng = latlng;
			e.latlng = latlng;
			e.oldLatLng = this._oldLatLng;
	
			// @event drag: Event
			// Fired repeatedly while the user drags the marker.
			marker
			    .fire('move', e)
			    .fire('drag', e);
		},
	
		_onDragEnd: function (e) {
			// @event dragend: DragEndEvent
			// Fired when the user stops dragging the marker.
	
			// @event moveend: Event
			// Fired when the marker stops moving (because of dragging).
			delete this._oldLatLng;
			this._marker
			    .fire('moveend')
			    .fire('dragend', e);
		}
	});
	
	/*
	 * @class Marker
	 * @inherits Interactive layer
	 * @aka L.Marker
	 * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.marker([50.5, 30.5]).addTo(map);
	 * ```
	 */
	
	var Marker = Layer.extend({
	
		// @section
		// @aka Marker options
		options: {
			// @option icon: Icon = *
			// Icon instance to use for rendering the marker.
			// See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
			// If not specified, a common instance of `L.Icon.Default` is used.
			icon: new IconDefault(),
	
			// Option inherited from "Interactive layer" abstract class
			interactive: true,
	
			// @option draggable: Boolean = false
			// Whether the marker is draggable with mouse/touch or not.
			draggable: false,
	
			// @option keyboard: Boolean = true
			// Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
			keyboard: true,
	
			// @option title: String = ''
			// Text for the browser tooltip that appear on marker hover (no tooltip by default).
			title: '',
	
			// @option alt: String = ''
			// Text for the `alt` attribute of the icon image (useful for accessibility).
			alt: '',
	
			// @option zIndexOffset: Number = 0
			// By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
			zIndexOffset: 0,
	
			// @option opacity: Number = 1.0
			// The opacity of the marker.
			opacity: 1,
	
			// @option riseOnHover: Boolean = false
			// If `true`, the marker will get on top of others when you hover the mouse over it.
			riseOnHover: false,
	
			// @option riseOffset: Number = 250
			// The z-index offset used for the `riseOnHover` feature.
			riseOffset: 250,
	
			// @option pane: String = 'markerPane'
			// `Map pane` where the markers icon will be added.
			pane: 'markerPane',
	
			// @option bubblingMouseEvents: Boolean = false
			// When `true`, a mouse event on this marker will trigger the same event on the map
			// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
			bubblingMouseEvents: false
		},
	
		/* @section
		 *
		 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
		 */
	
		initialize: function (latlng, options) {
			setOptions(this, options);
			this._latlng = toLatLng(latlng);
		},
	
		onAdd: function (map) {
			this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
	
			if (this._zoomAnimated) {
				map.on('zoomanim', this._animateZoom, this);
			}
	
			this._initIcon();
			this.update();
		},
	
		onRemove: function (map) {
			if (this.dragging && this.dragging.enabled()) {
				this.options.draggable = true;
				this.dragging.removeHooks();
			}
			delete this.dragging;
	
			if (this._zoomAnimated) {
				map.off('zoomanim', this._animateZoom, this);
			}
	
			this._removeIcon();
			this._removeShadow();
		},
	
		getEvents: function () {
			return {
				zoom: this.update,
				viewreset: this.update
			};
		},
	
		// @method getLatLng: LatLng
		// Returns the current geographical position of the marker.
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setLatLng(latlng: LatLng): this
		// Changes the marker position to the given point.
		setLatLng: function (latlng) {
			var oldLatLng = this._latlng;
			this._latlng = toLatLng(latlng);
			this.update();
	
			// @event move: Event
			// Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
			return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
		},
	
		// @method setZIndexOffset(offset: Number): this
		// Changes the [zIndex offset](#marker-zindexoffset) of the marker.
		setZIndexOffset: function (offset) {
			this.options.zIndexOffset = offset;
			return this.update();
		},
	
		// @method setIcon(icon: Icon): this
		// Changes the marker icon.
		setIcon: function (icon) {
	
			this.options.icon = icon;
	
			if (this._map) {
				this._initIcon();
				this.update();
			}
	
			if (this._popup) {
				this.bindPopup(this._popup, this._popup.options);
			}
	
			return this;
		},
	
		getElement: function () {
			return this._icon;
		},
	
		update: function () {
	
			if (this._icon) {
				var pos = this._map.latLngToLayerPoint(this._latlng).round();
				this._setPos(pos);
			}
	
			return this;
		},
	
		_initIcon: function () {
			var options = this.options,
			    classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
			var icon = options.icon.createIcon(this._icon),
			    addIcon = false;
	
			// if we're not reusing the icon, remove the old one and init new one
			if (icon !== this._icon) {
				if (this._icon) {
					this._removeIcon();
				}
				addIcon = true;
	
				if (options.title) {
					icon.title = options.title;
				}
				if (options.alt) {
					icon.alt = options.alt;
				}
			}
	
			addClass(icon, classToAdd);
	
			if (options.keyboard) {
				icon.tabIndex = '0';
			}
	
			this._icon = icon;
	
			if (options.riseOnHover) {
				this.on({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				});
			}
	
			var newShadow = options.icon.createShadow(this._shadow),
			    addShadow = false;
	
			if (newShadow !== this._shadow) {
				this._removeShadow();
				addShadow = true;
			}
	
			if (newShadow) {
				addClass(newShadow, classToAdd);
				newShadow.alt = '';
			}
			this._shadow = newShadow;
	
	
			if (options.opacity < 1) {
				this._updateOpacity();
			}
	
	
			if (addIcon) {
				this.getPane().appendChild(this._icon);
			}
			this._initInteraction();
			if (newShadow && addShadow) {
				this.getPane('shadowPane').appendChild(this._shadow);
			}
		},
	
		_removeIcon: function () {
			if (this.options.riseOnHover) {
				this.off({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				});
			}
	
			remove(this._icon);
			this.removeInteractiveTarget(this._icon);
	
			this._icon = null;
		},
	
		_removeShadow: function () {
			if (this._shadow) {
				remove(this._shadow);
			}
			this._shadow = null;
		},
	
		_setPos: function (pos) {
			setPosition(this._icon, pos);
	
			if (this._shadow) {
				setPosition(this._shadow, pos);
			}
	
			this._zIndex = pos.y + this.options.zIndexOffset;
	
			this._resetZIndex();
		},
	
		_updateZIndex: function (offset) {
			this._icon.style.zIndex = this._zIndex + offset;
		},
	
		_animateZoom: function (opt) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
	
			this._setPos(pos);
		},
	
		_initInteraction: function () {
	
			if (!this.options.interactive) { return; }
	
			addClass(this._icon, 'leaflet-interactive');
	
			this.addInteractiveTarget(this._icon);
	
			if (MarkerDrag) {
				var draggable = this.options.draggable;
				if (this.dragging) {
					draggable = this.dragging.enabled();
					this.dragging.disable();
				}
	
				this.dragging = new MarkerDrag(this);
	
				if (draggable) {
					this.dragging.enable();
				}
			}
		},
	
		// @method setOpacity(opacity: Number): this
		// Changes the opacity of the marker.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			if (this._map) {
				this._updateOpacity();
			}
	
			return this;
		},
	
		_updateOpacity: function () {
			var opacity = this.options.opacity;
	
			setOpacity(this._icon, opacity);
	
			if (this._shadow) {
				setOpacity(this._shadow, opacity);
			}
		},
	
		_bringToFront: function () {
			this._updateZIndex(this.options.riseOffset);
		},
	
		_resetZIndex: function () {
			this._updateZIndex(0);
		},
	
		_getPopupAnchor: function () {
			return this.options.icon.options.popupAnchor || [0, 0];
		},
	
		_getTooltipAnchor: function () {
			return this.options.icon.options.tooltipAnchor || [0, 0];
		}
	});
	
	
	// factory L.marker(latlng: LatLng, options? : Marker options)
	
	// @factory L.marker(latlng: LatLng, options? : Marker options)
	// Instantiates a Marker object given a geographical point and optionally an options object.
	function marker(latlng, options) {
		return new Marker(latlng, options);
	}
	
	/*
	 * @class Path
	 * @aka L.Path
	 * @inherits Interactive layer
	 *
	 * An abstract class that contains options and constants shared between vector
	 * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
	 */
	
	var Path = Layer.extend({
	
		// @section
		// @aka Path options
		options: {
			// @option stroke: Boolean = true
			// Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
			stroke: true,
	
			// @option color: String = '#3388ff'
			// Stroke color
			color: '#3388ff',
	
			// @option weight: Number = 3
			// Stroke width in pixels
			weight: 3,
	
			// @option opacity: Number = 1.0
			// Stroke opacity
			opacity: 1,
	
			// @option lineCap: String= 'round'
			// A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
			lineCap: 'round',
	
			// @option lineJoin: String = 'round'
			// A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
			lineJoin: 'round',
	
			// @option dashArray: String = null
			// A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
			dashArray: null,
	
			// @option dashOffset: String = null
			// A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
			dashOffset: null,
	
			// @option fill: Boolean = depends
			// Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
			fill: false,
	
			// @option fillColor: String = *
			// Fill color. Defaults to the value of the [`color`](#path-color) option
			fillColor: null,
	
			// @option fillOpacity: Number = 0.2
			// Fill opacity.
			fillOpacity: 0.2,
	
			// @option fillRule: String = 'evenodd'
			// A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
			fillRule: 'evenodd',
	
			// className: '',
	
			// Option inherited from "Interactive layer" abstract class
			interactive: true,
	
			// @option bubblingMouseEvents: Boolean = true
			// When `true`, a mouse event on this path will trigger the same event on the map
			// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
			bubblingMouseEvents: true
		},
	
		beforeAdd: function (map) {
			// Renderer is set here because we need to call renderer.getEvents
			// before this.getEvents.
			this._renderer = map.getRenderer(this);
		},
	
		onAdd: function () {
			this._renderer._initPath(this);
			this._reset();
			this._renderer._addPath(this);
		},
	
		onRemove: function () {
			this._renderer._removePath(this);
		},
	
		// @method redraw(): this
		// Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
		redraw: function () {
			if (this._map) {
				this._renderer._updatePath(this);
			}
			return this;
		},
	
		// @method setStyle(style: Path options): this
		// Changes the appearance of a Path based on the options in the `Path options` object.
		setStyle: function (style) {
			setOptions(this, style);
			if (this._renderer) {
				this._renderer._updateStyle(this);
			}
			return this;
		},
	
		// @method bringToFront(): this
		// Brings the layer to the top of all path layers.
		bringToFront: function () {
			if (this._renderer) {
				this._renderer._bringToFront(this);
			}
			return this;
		},
	
		// @method bringToBack(): this
		// Brings the layer to the bottom of all path layers.
		bringToBack: function () {
			if (this._renderer) {
				this._renderer._bringToBack(this);
			}
			return this;
		},
	
		getElement: function () {
			return this._path;
		},
	
		_reset: function () {
			// defined in child classes
			this._project();
			this._update();
		},
	
		_clickTolerance: function () {
			// used when doing hit detection for Canvas layers
			return (this.options.stroke ? this.options.weight / 2 : 0) + (touch ? 10 : 0);
		}
	});
	
	/*
	 * @class CircleMarker
	 * @aka L.CircleMarker
	 * @inherits Path
	 *
	 * A circle of a fixed size with radius specified in pixels. Extends `Path`.
	 */
	
	var CircleMarker = Path.extend({
	
		// @section
		// @aka CircleMarker options
		options: {
			fill: true,
	
			// @option radius: Number = 10
			// Radius of the circle marker, in pixels
			radius: 10
		},
	
		initialize: function (latlng, options) {
			setOptions(this, options);
			this._latlng = toLatLng(latlng);
			this._radius = this.options.radius;
		},
	
		// @method setLatLng(latLng: LatLng): this
		// Sets the position of a circle marker to a new location.
		setLatLng: function (latlng) {
			this._latlng = toLatLng(latlng);
			this.redraw();
			return this.fire('move', {latlng: this._latlng});
		},
	
		// @method getLatLng(): LatLng
		// Returns the current geographical position of the circle marker
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setRadius(radius: Number): this
		// Sets the radius of a circle marker. Units are in pixels.
		setRadius: function (radius) {
			this.options.radius = this._radius = radius;
			return this.redraw();
		},
	
		// @method getRadius(): Number
		// Returns the current radius of the circle
		getRadius: function () {
			return this._radius;
		},
	
		setStyle : function (options) {
			var radius = options && options.radius || this._radius;
			Path.prototype.setStyle.call(this, options);
			this.setRadius(radius);
			return this;
		},
	
		_project: function () {
			this._point = this._map.latLngToLayerPoint(this._latlng);
			this._updateBounds();
		},
	
		_updateBounds: function () {
			var r = this._radius,
			    r2 = this._radiusY || r,
			    w = this._clickTolerance(),
			    p = [r + w, r2 + w];
			this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
		},
	
		_update: function () {
			if (this._map) {
				this._updatePath();
			}
		},
	
		_updatePath: function () {
			this._renderer._updateCircle(this);
		},
	
		_empty: function () {
			return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
		},
	
		// Needed by the `Canvas` renderer for interactivity
		_containsPoint: function (p) {
			return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
		}
	});
	
	
	// @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
	// Instantiates a circle marker object given a geographical point, and an optional options object.
	function circleMarker(latlng, options) {
		return new CircleMarker(latlng, options);
	}
	
	/*
	 * @class Circle
	 * @aka L.Circle
	 * @inherits CircleMarker
	 *
	 * A class for drawing circle overlays on a map. Extends `CircleMarker`.
	 *
	 * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
	 *
	 * @example
	 *
	 * ```js
	 * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
	 * ```
	 */
	
	var Circle = CircleMarker.extend({
	
		initialize: function (latlng, options, legacyOptions) {
			if (typeof options === 'number') {
				// Backwards compatibility with 0.7.x factory (latlng, radius, options?)
				options = extend({}, legacyOptions, {radius: options});
			}
			setOptions(this, options);
			this._latlng = toLatLng(latlng);
	
			if (isNaN(this.options.radius)) { throw new Error('Circle radius cannot be NaN'); }
	
			// @section
			// @aka Circle options
			// @option radius: Number; Radius of the circle, in meters.
			this._mRadius = this.options.radius;
		},
	
		// @method setRadius(radius: Number): this
		// Sets the radius of a circle. Units are in meters.
		setRadius: function (radius) {
			this._mRadius = radius;
			return this.redraw();
		},
	
		// @method getRadius(): Number
		// Returns the current radius of a circle. Units are in meters.
		getRadius: function () {
			return this._mRadius;
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the `LatLngBounds` of the path.
		getBounds: function () {
			var half = [this._radius, this._radiusY || this._radius];
	
			return new LatLngBounds(
				this._map.layerPointToLatLng(this._point.subtract(half)),
				this._map.layerPointToLatLng(this._point.add(half)));
		},
	
		setStyle: Path.prototype.setStyle,
	
		_project: function () {
	
			var lng = this._latlng.lng,
			    lat = this._latlng.lat,
			    map = this._map,
			    crs = map.options.crs;
	
			if (crs.distance === Earth.distance) {
				var d = Math.PI / 180,
				    latR = (this._mRadius / Earth.R) / d,
				    top = map.project([lat + latR, lng]),
				    bottom = map.project([lat - latR, lng]),
				    p = top.add(bottom).divideBy(2),
				    lat2 = map.unproject(p).lat,
				    lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
				            (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
	
				if (isNaN(lngR) || lngR === 0) {
					lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
				}
	
				this._point = p.subtract(map.getPixelOrigin());
				this._radius = isNaN(lngR) ? 0 : Math.max(Math.round(p.x - map.project([lat2, lng - lngR]).x), 1);
				this._radiusY = Math.max(Math.round(p.y - top.y), 1);
	
			} else {
				var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));
	
				this._point = map.latLngToLayerPoint(this._latlng);
				this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
			}
	
			this._updateBounds();
		}
	});
	
	// @factory L.circle(latlng: LatLng, options?: Circle options)
	// Instantiates a circle object given a geographical point, and an options object
	// which contains the circle radius.
	// @alternative
	// @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
	// Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
	// Do not use in new applications or plugins.
	function circle(latlng, options, legacyOptions) {
		return new Circle(latlng, options, legacyOptions);
	}
	
	/*
	 * @class Polyline
	 * @aka L.Polyline
	 * @inherits Path
	 *
	 * A class for drawing polyline overlays on a map. Extends `Path`.
	 *
	 * @example
	 *
	 * ```js
	 * // create a red polyline from an array of LatLng points
	 * var latlngs = [
	 * 	[45.51, -122.68],
	 * 	[37.77, -122.43],
	 * 	[34.04, -118.2]
	 * ];
	 *
	 * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
	 *
	 * // zoom the map to the polyline
	 * map.fitBounds(polyline.getBounds());
	 * ```
	 *
	 * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
	 *
	 * ```js
	 * // create a red polyline from an array of arrays of LatLng points
	 * var latlngs = [
	 * 	[[45.51, -122.68],
	 * 	 [37.77, -122.43],
	 * 	 [34.04, -118.2]],
	 * 	[[40.78, -73.91],
	 * 	 [41.83, -87.62],
	 * 	 [32.76, -96.72]]
	 * ];
	 * ```
	 */
	
	
	var Polyline = Path.extend({
	
		// @section
		// @aka Polyline options
		options: {
			// @option smoothFactor: Number = 1.0
			// How much to simplify the polyline on each zoom level. More means
			// better performance and smoother look, and less means more accurate representation.
			smoothFactor: 1.0,
	
			// @option noClip: Boolean = false
			// Disable polyline clipping.
			noClip: false
		},
	
		initialize: function (latlngs, options) {
			setOptions(this, options);
			this._setLatLngs(latlngs);
		},
	
		// @method getLatLngs(): LatLng[]
		// Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
		getLatLngs: function () {
			return this._latlngs;
		},
	
		// @method setLatLngs(latlngs: LatLng[]): this
		// Replaces all the points in the polyline with the given array of geographical points.
		setLatLngs: function (latlngs) {
			this._setLatLngs(latlngs);
			return this.redraw();
		},
	
		// @method isEmpty(): Boolean
		// Returns `true` if the Polyline has no LatLngs.
		isEmpty: function () {
			return !this._latlngs.length;
		},
	
		closestLayerPoint: function (p) {
			var minDistance = Infinity,
			    minPoint = null,
			    closest = _sqClosestPointOnSegment,
			    p1, p2;
	
			for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
				var points = this._parts[j];
	
				for (var i = 1, len = points.length; i < len; i++) {
					p1 = points[i - 1];
					p2 = points[i];
	
					var sqDist = closest(p, p1, p2, true);
	
					if (sqDist < minDistance) {
						minDistance = sqDist;
						minPoint = closest(p, p1, p2);
					}
				}
			}
			if (minPoint) {
				minPoint.distance = Math.sqrt(minDistance);
			}
			return minPoint;
		},
	
		// @method getCenter(): LatLng
		// Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
		getCenter: function () {
			// throws error when not yet added to map as this center calculation requires projected coordinates
			if (!this._map) {
				throw new Error('Must add layer to map before using getCenter()');
			}
	
			var i, halfDist, segDist, dist, p1, p2, ratio,
			    points = this._rings[0],
			    len = points.length;
	
			if (!len) { return null; }
	
			// polyline centroid algorithm; only uses the first ring if there are multiple
	
			for (i = 0, halfDist = 0; i < len - 1; i++) {
				halfDist += points[i].distanceTo(points[i + 1]) / 2;
			}
	
			// The line is so small in the current view that all points are on the same pixel.
			if (halfDist === 0) {
				return this._map.layerPointToLatLng(points[0]);
			}
	
			for (i = 0, dist = 0; i < len - 1; i++) {
				p1 = points[i];
				p2 = points[i + 1];
				segDist = p1.distanceTo(p2);
				dist += segDist;
	
				if (dist > halfDist) {
					ratio = (dist - halfDist) / segDist;
					return this._map.layerPointToLatLng([
						p2.x - ratio * (p2.x - p1.x),
						p2.y - ratio * (p2.y - p1.y)
					]);
				}
			}
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the `LatLngBounds` of the path.
		getBounds: function () {
			return this._bounds;
		},
	
		// @method addLatLng(latlng: LatLng, latlngs? LatLng[]): this
		// Adds a given point to the polyline. By default, adds to the first ring of
		// the polyline in case of a multi-polyline, but can be overridden by passing
		// a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
		addLatLng: function (latlng, latlngs) {
			latlngs = latlngs || this._defaultShape();
			latlng = toLatLng(latlng);
			latlngs.push(latlng);
			this._bounds.extend(latlng);
			return this.redraw();
		},
	
		_setLatLngs: function (latlngs) {
			this._bounds = new LatLngBounds();
			this._latlngs = this._convertLatLngs(latlngs);
		},
	
		_defaultShape: function () {
			return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
		},
	
		// recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
		_convertLatLngs: function (latlngs) {
			var result = [],
			    flat = isFlat(latlngs);
	
			for (var i = 0, len = latlngs.length; i < len; i++) {
				if (flat) {
					result[i] = toLatLng(latlngs[i]);
					this._bounds.extend(result[i]);
				} else {
					result[i] = this._convertLatLngs(latlngs[i]);
				}
			}
	
			return result;
		},
	
		_project: function () {
			var pxBounds = new Bounds();
			this._rings = [];
			this._projectLatlngs(this._latlngs, this._rings, pxBounds);
	
			var w = this._clickTolerance(),
			    p = new Point(w, w);
	
			if (this._bounds.isValid() && pxBounds.isValid()) {
				pxBounds.min._subtract(p);
				pxBounds.max._add(p);
				this._pxBounds = pxBounds;
			}
		},
	
		// recursively turns latlngs into a set of rings with projected coordinates
		_projectLatlngs: function (latlngs, result, projectedBounds) {
			var flat = latlngs[0] instanceof LatLng,
			    len = latlngs.length,
			    i, ring;
	
			if (flat) {
				ring = [];
				for (i = 0; i < len; i++) {
					ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
					projectedBounds.extend(ring[i]);
				}
				result.push(ring);
			} else {
				for (i = 0; i < len; i++) {
					this._projectLatlngs(latlngs[i], result, projectedBounds);
				}
			}
		},
	
		// clip polyline by renderer bounds so that we have less to render for performance
		_clipPoints: function () {
			var bounds = this._renderer._bounds;
	
			this._parts = [];
			if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
				return;
			}
	
			if (this.options.noClip) {
				this._parts = this._rings;
				return;
			}
	
			var parts = this._parts,
			    i, j, k, len, len2, segment, points;
	
			for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
				points = this._rings[i];
	
				for (j = 0, len2 = points.length; j < len2 - 1; j++) {
					segment = clipSegment(points[j], points[j + 1], bounds, j, true);
	
					if (!segment) { continue; }
	
					parts[k] = parts[k] || [];
					parts[k].push(segment[0]);
	
					// if segment goes out of screen, or it's the last one, it's the end of the line part
					if ((segment[1] !== points[j + 1]) || (j === len2 - 2)) {
						parts[k].push(segment[1]);
						k++;
					}
				}
			}
		},
	
		// simplify each clipped part of the polyline for performance
		_simplifyPoints: function () {
			var parts = this._parts,
			    tolerance = this.options.smoothFactor;
	
			for (var i = 0, len = parts.length; i < len; i++) {
				parts[i] = simplify(parts[i], tolerance);
			}
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			this._clipPoints();
			this._simplifyPoints();
			this._updatePath();
		},
	
		_updatePath: function () {
			this._renderer._updatePoly(this);
		},
	
		// Needed by the `Canvas` renderer for interactivity
		_containsPoint: function (p, closed) {
			var i, j, k, len, len2, part,
			    w = this._clickTolerance();
	
			if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }
	
			// hit detection for polylines
			for (i = 0, len = this._parts.length; i < len; i++) {
				part = this._parts[i];
	
				for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
					if (!closed && (j === 0)) { continue; }
	
					if (pointToSegmentDistance(p, part[k], part[j]) <= w) {
						return true;
					}
				}
			}
			return false;
		}
	});
	
	// @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
	// Instantiates a polyline object given an array of geographical points and
	// optionally an options object. You can create a `Polyline` object with
	// multiple separate lines (`MultiPolyline`) by passing an array of arrays
	// of geographic points.
	function polyline(latlngs, options) {
		return new Polyline(latlngs, options);
	}
	
	// Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
	Polyline._flat = _flat;
	
	/*
	 * @class Polygon
	 * @aka L.Polygon
	 * @inherits Polyline
	 *
	 * A class for drawing polygon overlays on a map. Extends `Polyline`.
	 *
	 * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
	 *
	 *
	 * @example
	 *
	 * ```js
	 * // create a red polygon from an array of LatLng points
	 * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
	 *
	 * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
	 *
	 * // zoom the map to the polygon
	 * map.fitBounds(polygon.getBounds());
	 * ```
	 *
	 * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
	 *
	 * ```js
	 * var latlngs = [
	 *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	 *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	 * ];
	 * ```
	 *
	 * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
	 *
	 * ```js
	 * var latlngs = [
	 *   [ // first polygon
	 *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	 *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	 *   ],
	 *   [ // second polygon
	 *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
	 *   ]
	 * ];
	 * ```
	 */
	
	var Polygon = Polyline.extend({
	
		options: {
			fill: true
		},
	
		isEmpty: function () {
			return !this._latlngs.length || !this._latlngs[0].length;
		},
	
		getCenter: function () {
			// throws error when not yet added to map as this center calculation requires projected coordinates
			if (!this._map) {
				throw new Error('Must add layer to map before using getCenter()');
			}
	
			var i, j, p1, p2, f, area, x, y, center,
			    points = this._rings[0],
			    len = points.length;
	
			if (!len) { return null; }
	
			// polygon centroid algorithm; only uses the first ring if there are multiple
	
			area = x = y = 0;
	
			for (i = 0, j = len - 1; i < len; j = i++) {
				p1 = points[i];
				p2 = points[j];
	
				f = p1.y * p2.x - p2.y * p1.x;
				x += (p1.x + p2.x) * f;
				y += (p1.y + p2.y) * f;
				area += f * 3;
			}
	
			if (area === 0) {
				// Polygon is so small that all points are on same pixel.
				center = points[0];
			} else {
				center = [x / area, y / area];
			}
			return this._map.layerPointToLatLng(center);
		},
	
		_convertLatLngs: function (latlngs) {
			var result = Polyline.prototype._convertLatLngs.call(this, latlngs),
			    len = result.length;
	
			// remove last point if it equals first one
			if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) {
				result.pop();
			}
			return result;
		},
	
		_setLatLngs: function (latlngs) {
			Polyline.prototype._setLatLngs.call(this, latlngs);
			if (isFlat(this._latlngs)) {
				this._latlngs = [this._latlngs];
			}
		},
	
		_defaultShape: function () {
			return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
		},
	
		_clipPoints: function () {
			// polygons need a different clipping algorithm so we redefine that
	
			var bounds = this._renderer._bounds,
			    w = this.options.weight,
			    p = new Point(w, w);
	
			// increase clip padding by stroke width to avoid stroke on clip edges
			bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
	
			this._parts = [];
			if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
				return;
			}
	
			if (this.options.noClip) {
				this._parts = this._rings;
				return;
			}
	
			for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
				clipped = clipPolygon(this._rings[i], bounds, true);
				if (clipped.length) {
					this._parts.push(clipped);
				}
			}
		},
	
		_updatePath: function () {
			this._renderer._updatePoly(this, true);
		},
	
		// Needed by the `Canvas` renderer for interactivity
		_containsPoint: function (p) {
			var inside = false,
			    part, p1, p2, i, j, k, len, len2;
	
			if (!this._pxBounds.contains(p)) { return false; }
	
			// ray casting algorithm for detecting if point is in polygon
			for (i = 0, len = this._parts.length; i < len; i++) {
				part = this._parts[i];
	
				for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
					p1 = part[j];
					p2 = part[k];
	
					if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
						inside = !inside;
					}
				}
			}
	
			// also check if it's on polygon stroke
			return inside || Polyline.prototype._containsPoint.call(this, p, true);
		}
	
	});
	
	
	// @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
	function polygon(latlngs, options) {
		return new Polygon(latlngs, options);
	}
	
	/*
	 * @class GeoJSON
	 * @aka L.GeoJSON
	 * @inherits FeatureGroup
	 *
	 * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
	 * GeoJSON data and display it on the map. Extends `FeatureGroup`.
	 *
	 * @example
	 *
	 * ```js
	 * L.geoJSON(data, {
	 * 	style: function (feature) {
	 * 		return {color: feature.properties.color};
	 * 	}
	 * }).bindPopup(function (layer) {
	 * 	return layer.feature.properties.description;
	 * }).addTo(map);
	 * ```
	 */
	
	var GeoJSON = FeatureGroup.extend({
	
		/* @section
		 * @aka GeoJSON options
		 *
		 * @option pointToLayer: Function = *
		 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
		 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
		 * The default is to spawn a default `Marker`:
		 * ```js
		 * function(geoJsonPoint, latlng) {
		 * 	return L.marker(latlng);
		 * }
		 * ```
		 *
		 * @option style: Function = *
		 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
		 * called internally when data is added.
		 * The default value is to not override any defaults:
		 * ```js
		 * function (geoJsonFeature) {
		 * 	return {}
		 * }
		 * ```
		 *
		 * @option onEachFeature: Function = *
		 * A `Function` that will be called once for each created `Feature`, after it has
		 * been created and styled. Useful for attaching events and popups to features.
		 * The default is to do nothing with the newly created layers:
		 * ```js
		 * function (feature, layer) {}
		 * ```
		 *
		 * @option filter: Function = *
		 * A `Function` that will be used to decide whether to include a feature or not.
		 * The default is to include all features:
		 * ```js
		 * function (geoJsonFeature) {
		 * 	return true;
		 * }
		 * ```
		 * Note: dynamically changing the `filter` option will have effect only on newly
		 * added data. It will _not_ re-evaluate already included features.
		 *
		 * @option coordsToLatLng: Function = *
		 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
		 * The default is the `coordsToLatLng` static method.
		 */
	
		initialize: function (geojson, options) {
			setOptions(this, options);
	
			this._layers = {};
	
			if (geojson) {
				this.addData(geojson);
			}
		},
	
		// @method addData( <GeoJSON> data ): this
		// Adds a GeoJSON object to the layer.
		addData: function (geojson) {
			var features = isArray(geojson) ? geojson : geojson.features,
			    i, len, feature;
	
			if (features) {
				for (i = 0, len = features.length; i < len; i++) {
					// only add this if geometry or geometries are set and not null
					feature = features[i];
					if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
						this.addData(feature);
					}
				}
				return this;
			}
	
			var options = this.options;
	
			if (options.filter && !options.filter(geojson)) { return this; }
	
			var layer = geometryToLayer(geojson, options);
			if (!layer) {
				return this;
			}
			layer.feature = asFeature(geojson);
	
			layer.defaultOptions = layer.options;
			this.resetStyle(layer);
	
			if (options.onEachFeature) {
				options.onEachFeature(geojson, layer);
			}
	
			return this.addLayer(layer);
		},
	
		// @method resetStyle( <Path> layer ): this
		// Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
		resetStyle: function (layer) {
			// reset any custom styles
			layer.options = extend({}, layer.defaultOptions);
			this._setLayerStyle(layer, this.options.style);
			return this;
		},
	
		// @method setStyle( <Function> style ): this
		// Changes styles of GeoJSON vector layers with the given style function.
		setStyle: function (style) {
			return this.eachLayer(function (layer) {
				this._setLayerStyle(layer, style);
			}, this);
		},
	
		_setLayerStyle: function (layer, style) {
			if (typeof style === 'function') {
				style = style(layer.feature);
			}
			if (layer.setStyle) {
				layer.setStyle(style);
			}
		}
	});
	
	// @section
	// There are several static functions which can be called without instantiating L.GeoJSON:
	
	// @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
	// Creates a `Layer` from a given GeoJSON feature. Can use a custom
	// [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
	// functions if provided as options.
	function geometryToLayer(geojson, options) {
	
		var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
		    coords = geometry ? geometry.coordinates : null,
		    layers = [],
		    pointToLayer = options && options.pointToLayer,
		    _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng,
		    latlng, latlngs, i, len;
	
		if (!coords && !geometry) {
			return null;
		}
	
		switch (geometry.type) {
		case 'Point':
			latlng = _coordsToLatLng(coords);
			return pointToLayer ? pointToLayer(geojson, latlng) : new Marker(latlng);
	
		case 'MultiPoint':
			for (i = 0, len = coords.length; i < len; i++) {
				latlng = _coordsToLatLng(coords[i]);
				layers.push(pointToLayer ? pointToLayer(geojson, latlng) : new Marker(latlng));
			}
			return new FeatureGroup(layers);
	
		case 'LineString':
		case 'MultiLineString':
			latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
			return new Polyline(latlngs, options);
	
		case 'Polygon':
		case 'MultiPolygon':
			latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
			return new Polygon(latlngs, options);
	
		case 'GeometryCollection':
			for (i = 0, len = geometry.geometries.length; i < len; i++) {
				var layer = geometryToLayer({
					geometry: geometry.geometries[i],
					type: 'Feature',
					properties: geojson.properties
				}, options);
	
				if (layer) {
					layers.push(layer);
				}
			}
			return new FeatureGroup(layers);
	
		default:
			throw new Error('Invalid GeoJSON object.');
		}
	}
	
	// @function coordsToLatLng(coords: Array): LatLng
	// Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
	// or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
	function coordsToLatLng(coords) {
		return new LatLng(coords[1], coords[0], coords[2]);
	}
	
	// @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
	// Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
	// `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
	// Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
	function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
		var latlngs = [];
	
		for (var i = 0, len = coords.length, latlng; i < len; i++) {
			latlng = levelsDeep ?
					coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) :
					(_coordsToLatLng || coordsToLatLng)(coords[i]);
	
			latlngs.push(latlng);
		}
	
		return latlngs;
	}
	
	// @function latLngToCoords(latlng: LatLng, precision?: Number): Array
	// Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
	function latLngToCoords(latlng, precision) {
		precision = typeof precision === 'number' ? precision : 6;
		return latlng.alt !== undefined ?
				[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision), formatNum(latlng.alt, precision)] :
				[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision)];
	}
	
	// @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
	// Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
	// `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
	function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
		var coords = [];
	
		for (var i = 0, len = latlngs.length; i < len; i++) {
			coords.push(levelsDeep ?
				latLngsToCoords(latlngs[i], levelsDeep - 1, closed, precision) :
				latLngToCoords(latlngs[i], precision));
		}
	
		if (!levelsDeep && closed) {
			coords.push(coords[0]);
		}
	
		return coords;
	}
	
	function getFeature(layer, newGeometry) {
		return layer.feature ?
				extend({}, layer.feature, {geometry: newGeometry}) :
				asFeature(newGeometry);
	}
	
	// @function asFeature(geojson: Object): Object
	// Normalize GeoJSON geometries/features into GeoJSON features.
	function asFeature(geojson) {
		if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
			return geojson;
		}
	
		return {
			type: 'Feature',
			properties: {},
			geometry: geojson
		};
	}
	
	var PointToGeoJSON = {
		toGeoJSON: function (precision) {
			return getFeature(this, {
				type: 'Point',
				coordinates: latLngToCoords(this.getLatLng(), precision)
			});
		}
	};
	
	// @namespace Marker
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
	Marker.include(PointToGeoJSON);
	
	// @namespace CircleMarker
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
	Circle.include(PointToGeoJSON);
	CircleMarker.include(PointToGeoJSON);
	
	
	// @namespace Polyline
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
	Polyline.include({
		toGeoJSON: function (precision) {
			var multi = !isFlat(this._latlngs);
	
			var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
	
			return getFeature(this, {
				type: (multi ? 'Multi' : '') + 'LineString',
				coordinates: coords
			});
		}
	});
	
	// @namespace Polygon
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
	Polygon.include({
		toGeoJSON: function (precision) {
			var holes = !isFlat(this._latlngs),
			    multi = holes && !isFlat(this._latlngs[0]);
	
			var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
	
			if (!holes) {
				coords = [coords];
			}
	
			return getFeature(this, {
				type: (multi ? 'Multi' : '') + 'Polygon',
				coordinates: coords
			});
		}
	});
	
	
	// @namespace LayerGroup
	LayerGroup.include({
		toMultiPoint: function (precision) {
			var coords = [];
	
			this.eachLayer(function (layer) {
				coords.push(layer.toGeoJSON(precision).geometry.coordinates);
			});
	
			return getFeature(this, {
				type: 'MultiPoint',
				coordinates: coords
			});
		},
	
		// @method toGeoJSON(): Object
		// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
		toGeoJSON: function (precision) {
	
			var type = this.feature && this.feature.geometry && this.feature.geometry.type;
	
			if (type === 'MultiPoint') {
				return this.toMultiPoint(precision);
			}
	
			var isGeometryCollection = type === 'GeometryCollection',
			    jsons = [];
	
			this.eachLayer(function (layer) {
				if (layer.toGeoJSON) {
					var json = layer.toGeoJSON(precision);
					if (isGeometryCollection) {
						jsons.push(json.geometry);
					} else {
						var feature = asFeature(json);
						// Squash nested feature collections
						if (feature.type === 'FeatureCollection') {
							jsons.push.apply(jsons, feature.features);
						} else {
							jsons.push(feature);
						}
					}
				}
			});
	
			if (isGeometryCollection) {
				return getFeature(this, {
					geometries: jsons,
					type: 'GeometryCollection'
				});
			}
	
			return {
				type: 'FeatureCollection',
				features: jsons
			};
		}
	});
	
	// @namespace GeoJSON
	// @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
	// Creates a GeoJSON layer. Optionally accepts an object in
	// [GeoJSON format](http://geojson.org/geojson-spec.html) to display on the map
	// (you can alternatively add it later with `addData` method) and an `options` object.
	function geoJSON(geojson, options) {
		return new GeoJSON(geojson, options);
	}
	
	// Backward compatibility.
	var geoJson = geoJSON;
	
	/*
	 * @class ImageOverlay
	 * @aka L.ImageOverlay
	 * @inherits Interactive layer
	 *
	 * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
	 * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
	 * L.imageOverlay(imageUrl, imageBounds).addTo(map);
	 * ```
	 */
	
	var ImageOverlay = Layer.extend({
	
		// @section
		// @aka ImageOverlay options
		options: {
			// @option opacity: Number = 1.0
			// The opacity of the image overlay.
			opacity: 1,
	
			// @option alt: String = ''
			// Text for the `alt` attribute of the image (useful for accessibility).
			alt: '',
	
			// @option interactive: Boolean = false
			// If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
			interactive: false,
	
			// @option crossOrigin: Boolean = false
			// If true, the image will have its crossOrigin attribute set to ''. This is needed if you want to access image pixel data.
			crossOrigin: false,
	
			// @option errorOverlayUrl: String = ''
			// URL to the overlay image to show in place of the overlay that failed to load.
			errorOverlayUrl: '',
	
			// @option zIndex: Number = 1
			// The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the tile layer.
			zIndex: 1,
	
			// @option className: String = ''
			// A custom class name to assign to the image. Empty by default.
			className: '',
		},
	
		initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
			this._url = url;
			this._bounds = toLatLngBounds(bounds);
	
			setOptions(this, options);
		},
	
		onAdd: function () {
			if (!this._image) {
				this._initImage();
	
				if (this.options.opacity < 1) {
					this._updateOpacity();
				}
			}
	
			if (this.options.interactive) {
				addClass(this._image, 'leaflet-interactive');
				this.addInteractiveTarget(this._image);
			}
	
			this.getPane().appendChild(this._image);
			this._reset();
		},
	
		onRemove: function () {
			remove(this._image);
			if (this.options.interactive) {
				this.removeInteractiveTarget(this._image);
			}
		},
	
		// @method setOpacity(opacity: Number): this
		// Sets the opacity of the overlay.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._image) {
				this._updateOpacity();
			}
			return this;
		},
	
		setStyle: function (styleOpts) {
			if (styleOpts.opacity) {
				this.setOpacity(styleOpts.opacity);
			}
			return this;
		},
	
		// @method bringToFront(): this
		// Brings the layer to the top of all overlays.
		bringToFront: function () {
			if (this._map) {
				toFront(this._image);
			}
			return this;
		},
	
		// @method bringToBack(): this
		// Brings the layer to the bottom of all overlays.
		bringToBack: function () {
			if (this._map) {
				toBack(this._image);
			}
			return this;
		},
	
		// @method setUrl(url: String): this
		// Changes the URL of the image.
		setUrl: function (url) {
			this._url = url;
	
			if (this._image) {
				this._image.src = url;
			}
			return this;
		},
	
		// @method setBounds(bounds: LatLngBounds): this
		// Update the bounds that this ImageOverlay covers
		setBounds: function (bounds) {
			this._bounds = toLatLngBounds(bounds);
	
			if (this._map) {
				this._reset();
			}
			return this;
		},
	
		getEvents: function () {
			var events = {
				zoom: this._reset,
				viewreset: this._reset
			};
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
	
			return events;
		},
	
		// @method: setZIndex(value: Number) : this
		// Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
		setZIndex: function (value) {
			this.options.zIndex = value;
			this._updateZIndex();
			return this;
		},
	
		// @method getBounds(): LatLngBounds
		// Get the bounds that this ImageOverlay covers
		getBounds: function () {
			return this._bounds;
		},
	
		// @method getElement(): HTMLElement
		// Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
		// used by this overlay.
		getElement: function () {
			return this._image;
		},
	
		_initImage: function () {
			var img = this._image = create$1('img',
					'leaflet-image-layer ' + (this._zoomAnimated ? 'leaflet-zoom-animated' : '') +
					 (this.options.className || ''));
	
			img.onselectstart = falseFn;
			img.onmousemove = falseFn;
	
			// @event load: Event
			// Fired when the ImageOverlay layer has loaded its image
			img.onload = bind(this.fire, this, 'load');
			img.onerror = bind(this._overlayOnError, this, 'error');
	
			if (this.options.crossOrigin) {
				img.crossOrigin = '';
			}
	
			if (this.options.zIndex) {
				this._updateZIndex();
			}
	
			img.src = this._url;
			img.alt = this.options.alt;
		},
	
		_animateZoom: function (e) {
			var scale = this._map.getZoomScale(e.zoom),
			    offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
	
			setTransform(this._image, offset, scale);
		},
	
		_reset: function () {
			var image = this._image,
			    bounds = new Bounds(
			        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
			        this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
			    size = bounds.getSize();
	
			setPosition(image, bounds.min);
	
			image.style.width  = size.x + 'px';
			image.style.height = size.y + 'px';
		},
	
		_updateOpacity: function () {
			setOpacity(this._image, this.options.opacity);
		},
	
		_updateZIndex: function () {
			if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) {
				this._image.style.zIndex = this.options.zIndex;
			}
		},
	
		_overlayOnError: function () {
			// @event error: Event
			// Fired when the ImageOverlay layer has loaded its image
			this.fire('error');
	
			var errorUrl = this.options.errorOverlayUrl;
			if (errorUrl && this._url !== errorUrl) {
				this._url = errorUrl;
				this._image.src = errorUrl;
			}
		}
	});
	
	// @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
	// Instantiates an image overlay object given the URL of the image and the
	// geographical bounds it is tied to.
	var imageOverlay = function (url, bounds, options) {
		return new ImageOverlay(url, bounds, options);
	};
	
	/*
	 * @class VideoOverlay
	 * @aka L.VideoOverlay
	 * @inherits ImageOverlay
	 *
	 * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
	 *
	 * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
	 * HTML5 element.
	 *
	 * @example
	 *
	 * ```js
	 * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
	 * 	videoBounds = [[ 32, -130], [ 13, -100]];
	 * L.VideoOverlay(videoUrl, videoBounds ).addTo(map);
	 * ```
	 */
	
	var VideoOverlay = ImageOverlay.extend({
	
		// @section
		// @aka VideoOverlay options
		options: {
			// @option autoplay: Boolean = true
			// Whether the video starts playing automatically when loaded.
			autoplay: true,
	
			// @option loop: Boolean = true
			// Whether the video will loop back to the beginning when played.
			loop: true
		},
	
		_initImage: function () {
			var wasElementSupplied = this._url.tagName === 'VIDEO';
			var vid = this._image = wasElementSupplied ? this._url : create$1('video');
	
			vid.class = vid.class || '';
			vid.class += 'leaflet-image-layer ' + (this._zoomAnimated ? 'leaflet-zoom-animated' : '');
	
			vid.onselectstart = falseFn;
			vid.onmousemove = falseFn;
	
			// @event load: Event
			// Fired when the video has finished loading the first frame
			vid.onloadeddata = bind(this.fire, this, 'load');
	
			if (wasElementSupplied) { return; }
	
			if (!isArray(this._url)) { this._url = [this._url]; }
	
			vid.autoplay = !!this.options.autoplay;
			vid.loop = !!this.options.loop;
			for (var i = 0; i < this._url.length; i++) {
				var source = create$1('source');
				source.src = this._url[i];
				vid.appendChild(source);
			}
		}
	
		// @method getElement(): HTMLVideoElement
		// Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
		// used by this overlay.
	});
	
	
	// @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
	// Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
	// geographical bounds it is tied to.
	
	function videoOverlay(video, bounds, options) {
		return new VideoOverlay(video, bounds, options);
	}
	
	/*
	 * @class DivOverlay
	 * @inherits Layer
	 * @aka L.DivOverlay
	 * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
	 */
	
	// @namespace DivOverlay
	var DivOverlay = Layer.extend({
	
		// @section
		// @aka DivOverlay options
		options: {
			// @option offset: Point = Point(0, 7)
			// The offset of the popup position. Useful to control the anchor
			// of the popup when opening it on some overlays.
			offset: [0, 7],
	
			// @option className: String = ''
			// A custom CSS class name to assign to the popup.
			className: '',
	
			// @option pane: String = 'popupPane'
			// `Map pane` where the popup will be added.
			pane: 'popupPane'
		},
	
		initialize: function (options, source) {
			setOptions(this, options);
	
			this._source = source;
		},
	
		onAdd: function (map) {
			this._zoomAnimated = map._zoomAnimated;
	
			if (!this._container) {
				this._initLayout();
			}
	
			if (map._fadeAnimated) {
				setOpacity(this._container, 0);
			}
	
			clearTimeout(this._removeTimeout);
			this.getPane().appendChild(this._container);
			this.update();
	
			if (map._fadeAnimated) {
				setOpacity(this._container, 1);
			}
	
			this.bringToFront();
		},
	
		onRemove: function (map) {
			if (map._fadeAnimated) {
				setOpacity(this._container, 0);
				this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
			} else {
				remove(this._container);
			}
		},
	
		// @namespace Popup
		// @method getLatLng: LatLng
		// Returns the geographical point of popup.
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setLatLng(latlng: LatLng): this
		// Sets the geographical point where the popup will open.
		setLatLng: function (latlng) {
			this._latlng = toLatLng(latlng);
			if (this._map) {
				this._updatePosition();
				this._adjustPan();
			}
			return this;
		},
	
		// @method getContent: String|HTMLElement
		// Returns the content of the popup.
		getContent: function () {
			return this._content;
		},
	
		// @method setContent(htmlContent: String|HTMLElement|Function): this
		// Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
		setContent: function (content) {
			this._content = content;
			this.update();
			return this;
		},
	
		// @method getElement: String|HTMLElement
		// Alias for [getContent()](#popup-getcontent)
		getElement: function () {
			return this._container;
		},
	
		// @method update: null
		// Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
		update: function () {
			if (!this._map) { return; }
	
			this._container.style.visibility = 'hidden';
	
			this._updateContent();
			this._updateLayout();
			this._updatePosition();
	
			this._container.style.visibility = '';
	
			this._adjustPan();
		},
	
		getEvents: function () {
			var events = {
				zoom: this._updatePosition,
				viewreset: this._updatePosition
			};
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
			return events;
		},
	
		// @method isOpen: Boolean
		// Returns `true` when the popup is visible on the map.
		isOpen: function () {
			return !!this._map && this._map.hasLayer(this);
		},
	
		// @method bringToFront: this
		// Brings this popup in front of other popups (in the same map pane).
		bringToFront: function () {
			if (this._map) {
				toFront(this._container);
			}
			return this;
		},
	
		// @method bringToBack: this
		// Brings this popup to the back of other popups (in the same map pane).
		bringToBack: function () {
			if (this._map) {
				toBack(this._container);
			}
			return this;
		},
	
		_updateContent: function () {
			if (!this._content) { return; }
	
			var node = this._contentNode;
			var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;
	
			if (typeof content === 'string') {
				node.innerHTML = content;
			} else {
				while (node.hasChildNodes()) {
					node.removeChild(node.firstChild);
				}
				node.appendChild(content);
			}
			this.fire('contentupdate');
		},
	
		_updatePosition: function () {
			if (!this._map) { return; }
	
			var pos = this._map.latLngToLayerPoint(this._latlng),
			    offset = toPoint(this.options.offset),
			    anchor = this._getAnchor();
	
			if (this._zoomAnimated) {
				setPosition(this._container, pos.add(anchor));
			} else {
				offset = offset.add(pos).add(anchor);
			}
	
			var bottom = this._containerBottom = -offset.y,
			    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
	
			// bottom position the popup in case the height of the popup changes (images loading etc)
			this._container.style.bottom = bottom + 'px';
			this._container.style.left = left + 'px';
		},
	
		_getAnchor: function () {
			return [0, 0];
		}
	
	});
	
	/*
	 * @class Popup
	 * @inherits DivOverlay
	 * @aka L.Popup
	 * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
	 * open popups while making sure that only one popup is open at one time
	 * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
	 *
	 * @example
	 *
	 * If you want to just bind a popup to marker click and then open it, it's really easy:
	 *
	 * ```js
	 * marker.bindPopup(popupContent).openPopup();
	 * ```
	 * Path overlays like polylines also have a `bindPopup` method.
	 * Here's a more complicated way to open a popup on a map:
	 *
	 * ```js
	 * var popup = L.popup()
	 * 	.setLatLng(latlng)
	 * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
	 * 	.openOn(map);
	 * ```
	 */
	
	
	// @namespace Popup
	var Popup = DivOverlay.extend({
	
		// @section
		// @aka Popup options
		options: {
			// @option maxWidth: Number = 300
			// Max width of the popup, in pixels.
			maxWidth: 300,
	
			// @option minWidth: Number = 50
			// Min width of the popup, in pixels.
			minWidth: 50,
	
			// @option maxHeight: Number = null
			// If set, creates a scrollable container of the given height
			// inside a popup if its content exceeds it.
			maxHeight: null,
	
			// @option autoPan: Boolean = true
			// Set it to `false` if you don't want the map to do panning animation
			// to fit the opened popup.
			autoPan: true,
	
			// @option autoPanPaddingTopLeft: Point = null
			// The margin between the popup and the top left corner of the map
			// view after autopanning was performed.
			autoPanPaddingTopLeft: null,
	
			// @option autoPanPaddingBottomRight: Point = null
			// The margin between the popup and the bottom right corner of the map
			// view after autopanning was performed.
			autoPanPaddingBottomRight: null,
	
			// @option autoPanPadding: Point = Point(5, 5)
			// Equivalent of setting both top left and bottom right autopan padding to the same value.
			autoPanPadding: [5, 5],
	
			// @option keepInView: Boolean = false
			// Set it to `true` if you want to prevent users from panning the popup
			// off of the screen while it is open.
			keepInView: false,
	
			// @option closeButton: Boolean = true
			// Controls the presence of a close button in the popup.
			closeButton: true,
	
			// @option autoClose: Boolean = true
			// Set it to `false` if you want to override the default behavior of
			// the popup closing when another popup is opened.
			autoClose: true,
	
			// @option closeOnClick: Boolean = *
			// Set it if you want to override the default behavior of the popup closing when user clicks
			// on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
	
			// @option className: String = ''
			// A custom CSS class name to assign to the popup.
			className: ''
		},
	
		// @namespace Popup
		// @method openOn(map: Map): this
		// Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
		openOn: function (map) {
			map.openPopup(this);
			return this;
		},
	
		onAdd: function (map) {
			DivOverlay.prototype.onAdd.call(this, map);
	
			// @namespace Map
			// @section Popup events
			// @event popupopen: PopupEvent
			// Fired when a popup is opened in the map
			map.fire('popupopen', {popup: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Popup events
				// @event popupopen: PopupEvent
				// Fired when a popup bound to this layer is opened
				this._source.fire('popupopen', {popup: this}, true);
				// For non-path layers, we toggle the popup when clicking
				// again the layer, so prevent the map to reopen it.
				if (!(this._source instanceof Path)) {
					this._source.on('preclick', stopPropagation);
				}
			}
		},
	
		onRemove: function (map) {
			DivOverlay.prototype.onRemove.call(this, map);
	
			// @namespace Map
			// @section Popup events
			// @event popupclose: PopupEvent
			// Fired when a popup in the map is closed
			map.fire('popupclose', {popup: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Popup events
				// @event popupclose: PopupEvent
				// Fired when a popup bound to this layer is closed
				this._source.fire('popupclose', {popup: this}, true);
				if (!(this._source instanceof Path)) {
					this._source.off('preclick', stopPropagation);
				}
			}
		},
	
		getEvents: function () {
			var events = DivOverlay.prototype.getEvents.call(this);
	
			if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
				events.preclick = this._close;
			}
	
			if (this.options.keepInView) {
				events.moveend = this._adjustPan;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closePopup(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-popup',
			    container = this._container = create$1('div',
				prefix + ' ' + (this.options.className || '') +
				' leaflet-zoom-animated');
	
			var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
			this._contentNode = create$1('div', prefix + '-content', wrapper);
	
			disableClickPropagation(wrapper);
			disableScrollPropagation(this._contentNode);
			on(wrapper, 'contextmenu', stopPropagation);
	
			this._tipContainer = create$1('div', prefix + '-tip-container', container);
			this._tip = create$1('div', prefix + '-tip', this._tipContainer);
	
			if (this.options.closeButton) {
				var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
				closeButton.href = '#close';
				closeButton.innerHTML = '&#215;';
	
				on(closeButton, 'click', this._onCloseButtonClick, this);
			}
		},
	
		_updateLayout: function () {
			var container = this._contentNode,
			    style = container.style;
	
			style.width = '';
			style.whiteSpace = 'nowrap';
	
			var width = container.offsetWidth;
			width = Math.min(width, this.options.maxWidth);
			width = Math.max(width, this.options.minWidth);
	
			style.width = (width + 1) + 'px';
			style.whiteSpace = '';
	
			style.height = '';
	
			var height = container.offsetHeight,
			    maxHeight = this.options.maxHeight,
			    scrolledClass = 'leaflet-popup-scrolled';
	
			if (maxHeight && height > maxHeight) {
				style.height = maxHeight + 'px';
				addClass(container, scrolledClass);
			} else {
				removeClass(container, scrolledClass);
			}
	
			this._containerWidth = this._container.offsetWidth;
		},
	
		_animateZoom: function (e) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
			    anchor = this._getAnchor();
			setPosition(this._container, pos.add(anchor));
		},
	
		_adjustPan: function () {
			if (!this.options.autoPan || (this._map._panAnim && this._map._panAnim._inProgress)) { return; }
	
			var map = this._map,
			    marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0,
			    containerHeight = this._container.offsetHeight + marginBottom,
			    containerWidth = this._containerWidth,
			    layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
	
			layerPos._add(getPosition(this._container));
	
			var containerPos = map.layerPointToContainerPoint(layerPos),
			    padding = toPoint(this.options.autoPanPadding),
			    paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding),
			    paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding),
			    size = map.getSize(),
			    dx = 0,
			    dy = 0;
	
			if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
				dx = containerPos.x + containerWidth - size.x + paddingBR.x;
			}
			if (containerPos.x - dx - paddingTL.x < 0) { // left
				dx = containerPos.x - paddingTL.x;
			}
			if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
				dy = containerPos.y + containerHeight - size.y + paddingBR.y;
			}
			if (containerPos.y - dy - paddingTL.y < 0) { // top
				dy = containerPos.y - paddingTL.y;
			}
	
			// @namespace Map
			// @section Popup events
			// @event autopanstart: Event
			// Fired when the map starts autopanning when opening a popup.
			if (dx || dy) {
				map
				    .fire('autopanstart')
				    .panBy([dx, dy]);
			}
		},
	
		_onCloseButtonClick: function (e) {
			this._close();
			stop(e);
		},
	
		_getAnchor: function () {
			// Where should we anchor the popup on the source layer?
			return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
		}
	
	});
	
	// @namespace Popup
	// @factory L.popup(options?: Popup options, source?: Layer)
	// Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
	var popup = function (options, source) {
		return new Popup(options, source);
	};
	
	
	/* @namespace Map
	 * @section Interaction Options
	 * @option closePopupOnClick: Boolean = true
	 * Set it to `false` if you don't want popups to close when user clicks the map.
	 */
	Map.mergeOptions({
		closePopupOnClick: true
	});
	
	
	// @namespace Map
	// @section Methods for Layers and Controls
	Map.include({
		// @method openPopup(popup: Popup): this
		// Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
		// @alternative
		// @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
		// Creates a popup with the specified content and options and opens it in the given point on a map.
		openPopup: function (popup, latlng, options) {
			if (!(popup instanceof Popup)) {
				popup = new Popup(options).setContent(popup);
			}
	
			if (latlng) {
				popup.setLatLng(latlng);
			}
	
			if (this.hasLayer(popup)) {
				return this;
			}
	
			if (this._popup && this._popup.options.autoClose) {
				this.closePopup();
			}
	
			this._popup = popup;
			return this.addLayer(popup);
		},
	
		// @method closePopup(popup?: Popup): this
		// Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
		closePopup: function (popup) {
			if (!popup || popup === this._popup) {
				popup = this._popup;
				this._popup = null;
			}
			if (popup) {
				this.removeLayer(popup);
			}
			return this;
		}
	});
	
	/*
	 * @namespace Layer
	 * @section Popup methods example
	 *
	 * All layers share a set of methods convenient for binding popups to it.
	 *
	 * ```js
	 * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
	 * layer.openPopup();
	 * layer.closePopup();
	 * ```
	 *
	 * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
	 */
	
	// @section Popup methods
	Layer.include({
	
		// @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
		// Binds a popup to the layer with the passed `content` and sets up the
		// necessary event listeners. If a `Function` is passed it will receive
		// the layer as the first argument and should return a `String` or `HTMLElement`.
		bindPopup: function (content, options) {
	
			if (content instanceof Popup) {
				setOptions(content, options);
				this._popup = content;
				content._source = this;
			} else {
				if (!this._popup || options) {
					this._popup = new Popup(options, this);
				}
				this._popup.setContent(content);
			}
	
			if (!this._popupHandlersAdded) {
				this.on({
					click: this._openPopup,
					keypress: this._onKeyPress,
					remove: this.closePopup,
					move: this._movePopup
				});
				this._popupHandlersAdded = true;
			}
	
			return this;
		},
	
		// @method unbindPopup(): this
		// Removes the popup previously bound with `bindPopup`.
		unbindPopup: function () {
			if (this._popup) {
				this.off({
					click: this._openPopup,
					keypress: this._onKeyPress,
					remove: this.closePopup,
					move: this._movePopup
				});
				this._popupHandlersAdded = false;
				this._popup = null;
			}
			return this;
		},
	
		// @method openPopup(latlng?: LatLng): this
		// Opens the bound popup at the specificed `latlng` or at the default popup anchor if no `latlng` is passed.
		openPopup: function (layer, latlng) {
			if (!(layer instanceof Layer)) {
				latlng = layer;
				layer = this;
			}
	
			if (layer instanceof FeatureGroup) {
				for (var id in this._layers) {
					layer = this._layers[id];
					break;
				}
			}
	
			if (!latlng) {
				latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
			}
	
			if (this._popup && this._map) {
				// set popup source to this layer
				this._popup._source = layer;
	
				// update the popup (content, layout, ect...)
				this._popup.update();
	
				// open the popup on the map
				this._map.openPopup(this._popup, latlng);
			}
	
			return this;
		},
	
		// @method closePopup(): this
		// Closes the popup bound to this layer if it is open.
		closePopup: function () {
			if (this._popup) {
				this._popup._close();
			}
			return this;
		},
	
		// @method togglePopup(): this
		// Opens or closes the popup bound to this layer depending on its current state.
		togglePopup: function (target) {
			if (this._popup) {
				if (this._popup._map) {
					this.closePopup();
				} else {
					this.openPopup(target);
				}
			}
			return this;
		},
	
		// @method isPopupOpen(): boolean
		// Returns `true` if the popup bound to this layer is currently open.
		isPopupOpen: function () {
			return (this._popup ? this._popup.isOpen() : false);
		},
	
		// @method setPopupContent(content: String|HTMLElement|Popup): this
		// Sets the content of the popup bound to this layer.
		setPopupContent: function (content) {
			if (this._popup) {
				this._popup.setContent(content);
			}
			return this;
		},
	
		// @method getPopup(): Popup
		// Returns the popup bound to this layer.
		getPopup: function () {
			return this._popup;
		},
	
		_openPopup: function (e) {
			var layer = e.layer || e.target;
	
			if (!this._popup) {
				return;
			}
	
			if (!this._map) {
				return;
			}
	
			// prevent map click
			stop(e);
	
			// if this inherits from Path its a vector and we can just
			// open the popup at the new location
			if (layer instanceof Path) {
				this.openPopup(e.layer || e.target, e.latlng);
				return;
			}
	
			// otherwise treat it like a marker and figure out
			// if we should toggle it open/closed
			if (this._map.hasLayer(this._popup) && this._popup._source === layer) {
				this.closePopup();
			} else {
				this.openPopup(layer, e.latlng);
			}
		},
	
		_movePopup: function (e) {
			this._popup.setLatLng(e.latlng);
		},
	
		_onKeyPress: function (e) {
			if (e.originalEvent.keyCode === 13) {
				this._openPopup(e);
			}
		}
	});
	
	/*
	 * @class Tooltip
	 * @inherits DivOverlay
	 * @aka L.Tooltip
	 * Used to display small texts on top of map layers.
	 *
	 * @example
	 *
	 * ```js
	 * marker.bindTooltip("my tooltip text").openTooltip();
	 * ```
	 * Note about tooltip offset. Leaflet takes two options in consideration
	 * for computing tooltip offseting:
	 * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
	 *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
	 *   move it to the bottom. Negatives will move to the left and top.
	 * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
	 *   should adapt this value if you use a custom icon.
	 */
	
	
	// @namespace Tooltip
	var Tooltip = DivOverlay.extend({
	
		// @section
		// @aka Tooltip options
		options: {
			// @option pane: String = 'tooltipPane'
			// `Map pane` where the tooltip will be added.
			pane: 'tooltipPane',
	
			// @option offset: Point = Point(0, 0)
			// Optional offset of the tooltip position.
			offset: [0, 0],
	
			// @option direction: String = 'auto'
			// Direction where to open the tooltip. Possible values are: `right`, `left`,
			// `top`, `bottom`, `center`, `auto`.
			// `auto` will dynamicaly switch between `right` and `left` according to the tooltip
			// position on the map.
			direction: 'auto',
	
			// @option permanent: Boolean = false
			// Whether to open the tooltip permanently or only on mouseover.
			permanent: false,
	
			// @option sticky: Boolean = false
			// If true, the tooltip will follow the mouse instead of being fixed at the feature center.
			sticky: false,
	
			// @option interactive: Boolean = false
			// If true, the tooltip will listen to the feature events.
			interactive: false,
	
			// @option opacity: Number = 0.9
			// Tooltip container opacity.
			opacity: 0.9
		},
	
		onAdd: function (map) {
			DivOverlay.prototype.onAdd.call(this, map);
			this.setOpacity(this.options.opacity);
	
			// @namespace Map
			// @section Tooltip events
			// @event tooltipopen: TooltipEvent
			// Fired when a tooltip is opened in the map.
			map.fire('tooltipopen', {tooltip: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Tooltip events
				// @event tooltipopen: TooltipEvent
				// Fired when a tooltip bound to this layer is opened.
				this._source.fire('tooltipopen', {tooltip: this}, true);
			}
		},
	
		onRemove: function (map) {
			DivOverlay.prototype.onRemove.call(this, map);
	
			// @namespace Map
			// @section Tooltip events
			// @event tooltipclose: TooltipEvent
			// Fired when a tooltip in the map is closed.
			map.fire('tooltipclose', {tooltip: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Tooltip events
				// @event tooltipclose: TooltipEvent
				// Fired when a tooltip bound to this layer is closed.
				this._source.fire('tooltipclose', {tooltip: this}, true);
			}
		},
	
		getEvents: function () {
			var events = DivOverlay.prototype.getEvents.call(this);
	
			if (touch && !this.options.permanent) {
				events.preclick = this._close;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closeTooltip(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-tooltip',
			    className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
			this._contentNode = this._container = create$1('div', className);
		},
	
		_updateLayout: function () {},
	
		_adjustPan: function () {},
	
		_setPosition: function (pos) {
			var map = this._map,
			    container = this._container,
			    centerPoint = map.latLngToContainerPoint(map.getCenter()),
			    tooltipPoint = map.layerPointToContainerPoint(pos),
			    direction = this.options.direction,
			    tooltipWidth = container.offsetWidth,
			    tooltipHeight = container.offsetHeight,
			    offset = toPoint(this.options.offset),
			    anchor = this._getAnchor();
	
			if (direction === 'top') {
				pos = pos.add(toPoint(-tooltipWidth / 2 + offset.x, -tooltipHeight + offset.y + anchor.y, true));
			} else if (direction === 'bottom') {
				pos = pos.subtract(toPoint(tooltipWidth / 2 - offset.x, -offset.y, true));
			} else if (direction === 'center') {
				pos = pos.subtract(toPoint(tooltipWidth / 2 + offset.x, tooltipHeight / 2 - anchor.y + offset.y, true));
			} else if (direction === 'right' || direction === 'auto' && tooltipPoint.x < centerPoint.x) {
				direction = 'right';
				pos = pos.add(toPoint(offset.x + anchor.x, anchor.y - tooltipHeight / 2 + offset.y, true));
			} else {
				direction = 'left';
				pos = pos.subtract(toPoint(tooltipWidth + anchor.x - offset.x, tooltipHeight / 2 - anchor.y - offset.y, true));
			}
	
			removeClass(container, 'leaflet-tooltip-right');
			removeClass(container, 'leaflet-tooltip-left');
			removeClass(container, 'leaflet-tooltip-top');
			removeClass(container, 'leaflet-tooltip-bottom');
			addClass(container, 'leaflet-tooltip-' + direction);
			setPosition(container, pos);
		},
	
		_updatePosition: function () {
			var pos = this._map.latLngToLayerPoint(this._latlng);
			this._setPosition(pos);
		},
	
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._container) {
				setOpacity(this._container, opacity);
			}
		},
	
		_animateZoom: function (e) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
			this._setPosition(pos);
		},
	
		_getAnchor: function () {
			// Where should we anchor the tooltip on the source layer?
			return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
		}
	
	});
	
	// @namespace Tooltip
	// @factory L.tooltip(options?: Tooltip options, source?: Layer)
	// Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
	var tooltip = function (options, source) {
		return new Tooltip(options, source);
	};
	
	// @namespace Map
	// @section Methods for Layers and Controls
	Map.include({
	
		// @method openTooltip(tooltip: Tooltip): this
		// Opens the specified tooltip.
		// @alternative
		// @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
		// Creates a tooltip with the specified content and options and open it.
		openTooltip: function (tooltip, latlng, options) {
			if (!(tooltip instanceof Tooltip)) {
				tooltip = new Tooltip(options).setContent(tooltip);
			}
	
			if (latlng) {
				tooltip.setLatLng(latlng);
			}
	
			if (this.hasLayer(tooltip)) {
				return this;
			}
	
			return this.addLayer(tooltip);
		},
	
		// @method closeTooltip(tooltip?: Tooltip): this
		// Closes the tooltip given as parameter.
		closeTooltip: function (tooltip) {
			if (tooltip) {
				this.removeLayer(tooltip);
			}
			return this;
		}
	
	});
	
	/*
	 * @namespace Layer
	 * @section Tooltip methods example
	 *
	 * All layers share a set of methods convenient for binding tooltips to it.
	 *
	 * ```js
	 * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
	 * layer.openTooltip();
	 * layer.closeTooltip();
	 * ```
	 */
	
	// @section Tooltip methods
	Layer.include({
	
		// @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
		// Binds a tooltip to the layer with the passed `content` and sets up the
		// necessary event listeners. If a `Function` is passed it will receive
		// the layer as the first argument and should return a `String` or `HTMLElement`.
		bindTooltip: function (content, options) {
	
			if (content instanceof Tooltip) {
				setOptions(content, options);
				this._tooltip = content;
				content._source = this;
			} else {
				if (!this._tooltip || options) {
					this._tooltip = new Tooltip(options, this);
				}
				this._tooltip.setContent(content);
	
			}
	
			this._initTooltipInteractions();
	
			if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
				this.openTooltip();
			}
	
			return this;
		},
	
		// @method unbindTooltip(): this
		// Removes the tooltip previously bound with `bindTooltip`.
		unbindTooltip: function () {
			if (this._tooltip) {
				this._initTooltipInteractions(true);
				this.closeTooltip();
				this._tooltip = null;
			}
			return this;
		},
	
		_initTooltipInteractions: function (remove$$1) {
			if (!remove$$1 && this._tooltipHandlersAdded) { return; }
			var onOff = remove$$1 ? 'off' : 'on',
			    events = {
				remove: this.closeTooltip,
				move: this._moveTooltip
			    };
			if (!this._tooltip.options.permanent) {
				events.mouseover = this._openTooltip;
				events.mouseout = this.closeTooltip;
				if (this._tooltip.options.sticky) {
					events.mousemove = this._moveTooltip;
				}
				if (touch) {
					events.click = this._openTooltip;
				}
			} else {
				events.add = this._openTooltip;
			}
			this[onOff](events);
			this._tooltipHandlersAdded = !remove$$1;
		},
	
		// @method openTooltip(latlng?: LatLng): this
		// Opens the bound tooltip at the specificed `latlng` or at the default tooltip anchor if no `latlng` is passed.
		openTooltip: function (layer, latlng) {
			if (!(layer instanceof Layer)) {
				latlng = layer;
				layer = this;
			}
	
			if (layer instanceof FeatureGroup) {
				for (var id in this._layers) {
					layer = this._layers[id];
					break;
				}
			}
	
			if (!latlng) {
				latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
			}
	
			if (this._tooltip && this._map) {
	
				// set tooltip source to this layer
				this._tooltip._source = layer;
	
				// update the tooltip (content, layout, ect...)
				this._tooltip.update();
	
				// open the tooltip on the map
				this._map.openTooltip(this._tooltip, latlng);
	
				// Tooltip container may not be defined if not permanent and never
				// opened.
				if (this._tooltip.options.interactive && this._tooltip._container) {
					addClass(this._tooltip._container, 'leaflet-clickable');
					this.addInteractiveTarget(this._tooltip._container);
				}
			}
	
			return this;
		},
	
		// @method closeTooltip(): this
		// Closes the tooltip bound to this layer if it is open.
		closeTooltip: function () {
			if (this._tooltip) {
				this._tooltip._close();
				if (this._tooltip.options.interactive && this._tooltip._container) {
					removeClass(this._tooltip._container, 'leaflet-clickable');
					this.removeInteractiveTarget(this._tooltip._container);
				}
			}
			return this;
		},
	
		// @method toggleTooltip(): this
		// Opens or closes the tooltip bound to this layer depending on its current state.
		toggleTooltip: function (target) {
			if (this._tooltip) {
				if (this._tooltip._map) {
					this.closeTooltip();
				} else {
					this.openTooltip(target);
				}
			}
			return this;
		},
	
		// @method isTooltipOpen(): boolean
		// Returns `true` if the tooltip bound to this layer is currently open.
		isTooltipOpen: function () {
			return this._tooltip.isOpen();
		},
	
		// @method setTooltipContent(content: String|HTMLElement|Tooltip): this
		// Sets the content of the tooltip bound to this layer.
		setTooltipContent: function (content) {
			if (this._tooltip) {
				this._tooltip.setContent(content);
			}
			return this;
		},
	
		// @method getTooltip(): Tooltip
		// Returns the tooltip bound to this layer.
		getTooltip: function () {
			return this._tooltip;
		},
	
		_openTooltip: function (e) {
			var layer = e.layer || e.target;
	
			if (!this._tooltip || !this._map) {
				return;
			}
			this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
		},
	
		_moveTooltip: function (e) {
			var latlng = e.latlng, containerPoint, layerPoint;
			if (this._tooltip.options.sticky && e.originalEvent) {
				containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
				layerPoint = this._map.containerPointToLayerPoint(containerPoint);
				latlng = this._map.layerPointToLatLng(layerPoint);
			}
			this._tooltip.setLatLng(latlng);
		}
	});
	
	/*
	 * @class DivIcon
	 * @aka L.DivIcon
	 * @inherits Icon
	 *
	 * Represents a lightweight icon for markers that uses a simple `<div>`
	 * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
	 *
	 * @example
	 * ```js
	 * var myIcon = L.divIcon({className: 'my-div-icon'});
	 * // you can set .my-div-icon styles in CSS
	 *
	 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	 * ```
	 *
	 * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
	 */
	
	var DivIcon = Icon.extend({
		options: {
			// @section
			// @aka DivIcon options
			iconSize: [12, 12], // also can be set through CSS
	
			// iconAnchor: (Point),
			// popupAnchor: (Point),
	
			// @option html: String = ''
			// Custom HTML code to put inside the div element, empty by default.
			html: false,
	
			// @option bgPos: Point = [0, 0]
			// Optional relative position of the background, in pixels
			bgPos: null,
	
			className: 'leaflet-div-icon'
		},
	
		createIcon: function (oldIcon) {
			var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
			    options = this.options;
	
			div.innerHTML = options.html !== false ? options.html : '';
	
			if (options.bgPos) {
				var bgPos = toPoint(options.bgPos);
				div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
			}
			this._setIconStyles(div, 'icon');
	
			return div;
		},
	
		createShadow: function () {
			return null;
		}
	});
	
	// @factory L.divIcon(options: DivIcon options)
	// Creates a `DivIcon` instance with the given options.
	function divIcon(options) {
		return new DivIcon(options);
	}
	
	Icon.Default = IconDefault;
	
	/*
	 * @class GridLayer
	 * @inherits Layer
	 * @aka L.GridLayer
	 *
	 * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
	 * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
	 *
	 *
	 * @section Synchronous usage
	 * @example
	 *
	 * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
	 *
	 * ```js
	 * var CanvasLayer = L.GridLayer.extend({
	 *     createTile: function(coords){
	 *         // create a <canvas> element for drawing
	 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	 *
	 *         // setup tile width and height according to the options
	 *         var size = this.getTileSize();
	 *         tile.width = size.x;
	 *         tile.height = size.y;
	 *
	 *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
	 *         var ctx = tile.getContext('2d');
	 *
	 *         // return the tile so it can be rendered on screen
	 *         return tile;
	 *     }
	 * });
	 * ```
	 *
	 * @section Asynchronous usage
	 * @example
	 *
	 * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
	 *
	 * ```js
	 * var CanvasLayer = L.GridLayer.extend({
	 *     createTile: function(coords, done){
	 *         var error;
	 *
	 *         // create a <canvas> element for drawing
	 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	 *
	 *         // setup tile width and height according to the options
	 *         var size = this.getTileSize();
	 *         tile.width = size.x;
	 *         tile.height = size.y;
	 *
	 *         // draw something asynchronously and pass the tile to the done() callback
	 *         setTimeout(function() {
	 *             done(error, tile);
	 *         }, 1000);
	 *
	 *         return tile;
	 *     }
	 * });
	 * ```
	 *
	 * @section
	 */
	
	
	var GridLayer = Layer.extend({
	
		// @section
		// @aka GridLayer options
		options: {
			// @option tileSize: Number|Point = 256
			// Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
			tileSize: 256,
	
			// @option opacity: Number = 1.0
			// Opacity of the tiles. Can be used in the `createTile()` function.
			opacity: 1,
	
			// @option updateWhenIdle: Boolean = (depends)
			// Load new tiles only when panning ends.
			// `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
			// `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
			// [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
			updateWhenIdle: mobile,
	
			// @option updateWhenZooming: Boolean = true
			// By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
			updateWhenZooming: true,
	
			// @option updateInterval: Number = 200
			// Tiles will not update more than once every `updateInterval` milliseconds when panning.
			updateInterval: 200,
	
			// @option zIndex: Number = 1
			// The explicit zIndex of the tile layer.
			zIndex: 1,
	
			// @option bounds: LatLngBounds = undefined
			// If set, tiles will only be loaded inside the set `LatLngBounds`.
			bounds: null,
	
			// @option minZoom: Number = 0
			// The minimum zoom level down to which this layer will be displayed (inclusive).
			minZoom: 0,
	
			// @option maxZoom: Number = undefined
			// The maximum zoom level up to which this layer will be displayed (inclusive).
			maxZoom: undefined,
	
			// @option maxNativeZoom: Number = undefined
			// Maximum zoom number the tile source has available. If it is specified,
			// the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
			// from `maxNativeZoom` level and auto-scaled.
			maxNativeZoom: undefined,
	
			// @option minNativeZoom: Number = undefined
			// Minimum zoom number the tile source has available. If it is specified,
			// the tiles on all zoom levels lower than `minNativeZoom` will be loaded
			// from `minNativeZoom` level and auto-scaled.
			minNativeZoom: undefined,
	
			// @option noWrap: Boolean = false
			// Whether the layer is wrapped around the antimeridian. If `true`, the
			// GridLayer will only be displayed once at low zoom levels. Has no
			// effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
			// in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
			// tiles outside the CRS limits.
			noWrap: false,
	
			// @option pane: String = 'tilePane'
			// `Map pane` where the grid layer will be added.
			pane: 'tilePane',
	
			// @option className: String = ''
			// A custom class name to assign to the tile layer. Empty by default.
			className: '',
	
			// @option keepBuffer: Number = 2
			// When panning the map, keep this many rows and columns of tiles before unloading them.
			keepBuffer: 2
		},
	
		initialize: function (options) {
			setOptions(this, options);
		},
	
		onAdd: function () {
			this._initContainer();
	
			this._levels = {};
			this._tiles = {};
	
			this._resetView();
			this._update();
		},
	
		beforeAdd: function (map) {
			map._addZoomLimit(this);
		},
	
		onRemove: function (map) {
			this._removeAllTiles();
			remove(this._container);
			map._removeZoomLimit(this);
			this._container = null;
			this._tileZoom = null;
		},
	
		// @method bringToFront: this
		// Brings the tile layer to the top of all tile layers.
		bringToFront: function () {
			if (this._map) {
				toFront(this._container);
				this._setAutoZIndex(Math.max);
			}
			return this;
		},
	
		// @method bringToBack: this
		// Brings the tile layer to the bottom of all tile layers.
		bringToBack: function () {
			if (this._map) {
				toBack(this._container);
				this._setAutoZIndex(Math.min);
			}
			return this;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTML element that contains the tiles for this layer.
		getContainer: function () {
			return this._container;
		},
	
		// @method setOpacity(opacity: Number): this
		// Changes the [opacity](#gridlayer-opacity) of the grid layer.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			this._updateOpacity();
			return this;
		},
	
		// @method setZIndex(zIndex: Number): this
		// Changes the [zIndex](#gridlayer-zindex) of the grid layer.
		setZIndex: function (zIndex) {
			this.options.zIndex = zIndex;
			this._updateZIndex();
	
			return this;
		},
	
		// @method isLoading: Boolean
		// Returns `true` if any tile in the grid layer has not finished loading.
		isLoading: function () {
			return this._loading;
		},
	
		// @method redraw: this
		// Causes the layer to clear all the tiles and request them again.
		redraw: function () {
			if (this._map) {
				this._removeAllTiles();
				this._update();
			}
			return this;
		},
	
		getEvents: function () {
			var events = {
				viewprereset: this._invalidateAll,
				viewreset: this._resetView,
				zoom: this._resetView,
				moveend: this._onMoveEnd
			};
	
			if (!this.options.updateWhenIdle) {
				// update tiles on move, but not more often than once per given interval
				if (!this._onMove) {
					this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
				}
	
				events.move = this._onMove;
			}
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
	
			return events;
		},
	
		// @section Extension methods
		// Layers extending `GridLayer` shall reimplement the following method.
		// @method createTile(coords: Object, done?: Function): HTMLElement
		// Called only internally, must be overriden by classes extending `GridLayer`.
		// Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
		// is specified, it must be called when the tile has finished loading and drawing.
		createTile: function () {
			return document.createElement('div');
		},
	
		// @section
		// @method getTileSize: Point
		// Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
		getTileSize: function () {
			var s = this.options.tileSize;
			return s instanceof Point ? s : new Point(s, s);
		},
	
		_updateZIndex: function () {
			if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
				this._container.style.zIndex = this.options.zIndex;
			}
		},
	
		_setAutoZIndex: function (compare) {
			// go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
	
			var layers = this.getPane().children,
			    edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
	
			for (var i = 0, len = layers.length, zIndex; i < len; i++) {
	
				zIndex = layers[i].style.zIndex;
	
				if (layers[i] !== this._container && zIndex) {
					edgeZIndex = compare(edgeZIndex, +zIndex);
				}
			}
	
			if (isFinite(edgeZIndex)) {
				this.options.zIndex = edgeZIndex + compare(-1, 1);
				this._updateZIndex();
			}
		},
	
		_updateOpacity: function () {
			if (!this._map) { return; }
	
			// IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
			if (ielt9) { return; }
	
			setOpacity(this._container, this.options.opacity);
	
			var now = +new Date(),
			    nextFrame = false,
			    willPrune = false;
	
			for (var key in this._tiles) {
				var tile = this._tiles[key];
				if (!tile.current || !tile.loaded) { continue; }
	
				var fade = Math.min(1, (now - tile.loaded) / 200);
	
				setOpacity(tile.el, fade);
				if (fade < 1) {
					nextFrame = true;
				} else {
					if (tile.active) {
						willPrune = true;
					} else {
						this._onOpaqueTile(tile);
					}
					tile.active = true;
				}
			}
	
			if (willPrune && !this._noPrune) { this._pruneTiles(); }
	
			if (nextFrame) {
				cancelAnimFrame(this._fadeFrame);
				this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
			}
		},
	
		_onOpaqueTile: falseFn,
	
		_initContainer: function () {
			if (this._container) { return; }
	
			this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
			this._updateZIndex();
	
			if (this.options.opacity < 1) {
				this._updateOpacity();
			}
	
			this.getPane().appendChild(this._container);
		},
	
		_updateLevels: function () {
	
			var zoom = this._tileZoom,
			    maxZoom = this.options.maxZoom;
	
			if (zoom === undefined) { return undefined; }
	
			for (var z in this._levels) {
				if (this._levels[z].el.children.length || z === zoom) {
					this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
					this._onUpdateLevel(z);
				} else {
					remove(this._levels[z].el);
					this._removeTilesAtZoom(z);
					this._onRemoveLevel(z);
					delete this._levels[z];
				}
			}
	
			var level = this._levels[zoom],
			    map = this._map;
	
			if (!level) {
				level = this._levels[zoom] = {};
	
				level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
				level.el.style.zIndex = maxZoom;
	
				level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
				level.zoom = zoom;
	
				this._setZoomTransform(level, map.getCenter(), map.getZoom());
	
				// force the browser to consider the newly added element for transition
				falseFn(level.el.offsetWidth);
	
				this._onCreateLevel(level);
			}
	
			this._level = level;
	
			return level;
		},
	
		_onUpdateLevel: falseFn,
	
		_onRemoveLevel: falseFn,
	
		_onCreateLevel: falseFn,
	
		_pruneTiles: function () {
			if (!this._map) {
				return;
			}
	
			var key, tile;
	
			var zoom = this._map.getZoom();
			if (zoom > this.options.maxZoom ||
				zoom < this.options.minZoom) {
				this._removeAllTiles();
				return;
			}
	
			for (key in this._tiles) {
				tile = this._tiles[key];
				tile.retain = tile.current;
			}
	
			for (key in this._tiles) {
				tile = this._tiles[key];
				if (tile.current && !tile.active) {
					var coords = tile.coords;
					if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
						this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
					}
				}
			}
	
			for (key in this._tiles) {
				if (!this._tiles[key].retain) {
					this._removeTile(key);
				}
			}
		},
	
		_removeTilesAtZoom: function (zoom) {
			for (var key in this._tiles) {
				if (this._tiles[key].coords.z !== zoom) {
					continue;
				}
				this._removeTile(key);
			}
		},
	
		_removeAllTiles: function () {
			for (var key in this._tiles) {
				this._removeTile(key);
			}
		},
	
		_invalidateAll: function () {
			for (var z in this._levels) {
				remove(this._levels[z].el);
				this._onRemoveLevel(z);
				delete this._levels[z];
			}
			this._removeAllTiles();
	
			this._tileZoom = null;
		},
	
		_retainParent: function (x, y, z, minZoom) {
			var x2 = Math.floor(x / 2),
			    y2 = Math.floor(y / 2),
			    z2 = z - 1,
			    coords2 = new Point(+x2, +y2);
			coords2.z = +z2;
	
			var key = this._tileCoordsToKey(coords2),
			    tile = this._tiles[key];
	
			if (tile && tile.active) {
				tile.retain = true;
				return true;
	
			} else if (tile && tile.loaded) {
				tile.retain = true;
			}
	
			if (z2 > minZoom) {
				return this._retainParent(x2, y2, z2, minZoom);
			}
	
			return false;
		},
	
		_retainChildren: function (x, y, z, maxZoom) {
	
			for (var i = 2 * x; i < 2 * x + 2; i++) {
				for (var j = 2 * y; j < 2 * y + 2; j++) {
	
					var coords = new Point(i, j);
					coords.z = z + 1;
	
					var key = this._tileCoordsToKey(coords),
					    tile = this._tiles[key];
	
					if (tile && tile.active) {
						tile.retain = true;
						continue;
	
					} else if (tile && tile.loaded) {
						tile.retain = true;
					}
	
					if (z + 1 < maxZoom) {
						this._retainChildren(i, j, z + 1, maxZoom);
					}
				}
			}
		},
	
		_resetView: function (e) {
			var animating = e && (e.pinch || e.flyTo);
			this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
		},
	
		_animateZoom: function (e) {
			this._setView(e.center, e.zoom, true, e.noUpdate);
		},
	
		_clampZoom: function (zoom) {
			var options = this.options;
	
			if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) {
				return options.minNativeZoom;
			}
	
			if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) {
				return options.maxNativeZoom;
			}
	
			return zoom;
		},
	
		_setView: function (center, zoom, noPrune, noUpdate) {
			var tileZoom = this._clampZoom(Math.round(zoom));
			if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
			    (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
				tileZoom = undefined;
			}
	
			var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);
	
			if (!noUpdate || tileZoomChanged) {
	
				this._tileZoom = tileZoom;
	
				if (this._abortLoading) {
					this._abortLoading();
				}
	
				this._updateLevels();
				this._resetGrid();
	
				if (tileZoom !== undefined) {
					this._update(center);
				}
	
				if (!noPrune) {
					this._pruneTiles();
				}
	
				// Flag to prevent _updateOpacity from pruning tiles during
				// a zoom anim or a pinch gesture
				this._noPrune = !!noPrune;
			}
	
			this._setZoomTransforms(center, zoom);
		},
	
		_setZoomTransforms: function (center, zoom) {
			for (var i in this._levels) {
				this._setZoomTransform(this._levels[i], center, zoom);
			}
		},
	
		_setZoomTransform: function (level, center, zoom) {
			var scale = this._map.getZoomScale(zoom, level.zoom),
			    translate = level.origin.multiplyBy(scale)
			        .subtract(this._map._getNewPixelOrigin(center, zoom)).round();
	
			if (any3d) {
				setTransform(level.el, translate, scale);
			} else {
				setPosition(level.el, translate);
			}
		},
	
		_resetGrid: function () {
			var map = this._map,
			    crs = map.options.crs,
			    tileSize = this._tileSize = this.getTileSize(),
			    tileZoom = this._tileZoom;
	
			var bounds = this._map.getPixelWorldBounds(this._tileZoom);
			if (bounds) {
				this._globalTileRange = this._pxBoundsToTileRange(bounds);
			}
	
			this._wrapX = crs.wrapLng && !this.options.noWrap && [
				Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
				Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
			];
			this._wrapY = crs.wrapLat && !this.options.noWrap && [
				Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
				Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
			];
		},
	
		_onMoveEnd: function () {
			if (!this._map || this._map._animatingZoom) { return; }
	
			this._update();
		},
	
		_getTiledPixelBounds: function (center) {
			var map = this._map,
			    mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
			    scale = map.getZoomScale(mapZoom, this._tileZoom),
			    pixelCenter = map.project(center, this._tileZoom).floor(),
			    halfSize = map.getSize().divideBy(scale * 2);
	
			return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
		},
	
		// Private method to load tiles in the grid's active zoom level according to map bounds
		_update: function (center) {
			var map = this._map;
			if (!map) { return; }
			var zoom = this._clampZoom(map.getZoom());
	
			if (center === undefined) { center = map.getCenter(); }
			if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom
	
			var pixelBounds = this._getTiledPixelBounds(center),
			    tileRange = this._pxBoundsToTileRange(pixelBounds),
			    tileCenter = tileRange.getCenter(),
			    queue = [],
			    margin = this.options.keepBuffer,
			    noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
			                              tileRange.getTopRight().add([margin, -margin]));
	
			// Sanity check: panic if the tile range contains Infinity somewhere.
			if (!(isFinite(tileRange.min.x) &&
			      isFinite(tileRange.min.y) &&
			      isFinite(tileRange.max.x) &&
			      isFinite(tileRange.max.y))) { throw new Error('Attempted to load an infinite number of tiles'); }
	
			for (var key in this._tiles) {
				var c = this._tiles[key].coords;
				if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) {
					this._tiles[key].current = false;
				}
			}
	
			// _update just loads more tiles. If the tile zoom level differs too much
			// from the map's, let _setView reset levels and prune old tiles.
			if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }
	
			// create a queue of coordinates to load tiles from
			for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
				for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
					var coords = new Point(i, j);
					coords.z = this._tileZoom;
	
					if (!this._isValidTile(coords)) { continue; }
	
					if (!this._tiles[this._tileCoordsToKey(coords)]) {
						queue.push(coords);
					}
				}
			}
	
			// sort tile queue to load tiles in order of their distance to center
			queue.sort(function (a, b) {
				return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
			});
	
			if (queue.length !== 0) {
				// if it's the first batch of tiles to load
				if (!this._loading) {
					this._loading = true;
					// @event loading: Event
					// Fired when the grid layer starts loading tiles.
					this.fire('loading');
				}
	
				// create DOM fragment to append tiles in one batch
				var fragment = document.createDocumentFragment();
	
				for (i = 0; i < queue.length; i++) {
					this._addTile(queue[i], fragment);
				}
	
				this._level.el.appendChild(fragment);
			}
		},
	
		_isValidTile: function (coords) {
			var crs = this._map.options.crs;
	
			if (!crs.infinite) {
				// don't load tile if it's out of bounds and not wrapped
				var bounds = this._globalTileRange;
				if ((!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
				    (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))) { return false; }
			}
	
			if (!this.options.bounds) { return true; }
	
			// don't load tile if it doesn't intersect the bounds in options
			var tileBounds = this._tileCoordsToBounds(coords);
			return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
		},
	
		_keyToBounds: function (key) {
			return this._tileCoordsToBounds(this._keyToTileCoords(key));
		},
	
		// converts tile coordinates to its geographical bounds
		_tileCoordsToBounds: function (coords) {
	
			var map = this._map,
			    tileSize = this.getTileSize(),
	
			    nwPoint = coords.scaleBy(tileSize),
			    sePoint = nwPoint.add(tileSize),
	
			    nw = map.unproject(nwPoint, coords.z),
			    se = map.unproject(sePoint, coords.z),
			    bounds = new LatLngBounds(nw, se);
	
			if (!this.options.noWrap) {
				map.wrapLatLngBounds(bounds);
			}
	
			return bounds;
		},
	
		// converts tile coordinates to key for the tile cache
		_tileCoordsToKey: function (coords) {
			return coords.x + ':' + coords.y + ':' + coords.z;
		},
	
		// converts tile cache key to coordinates
		_keyToTileCoords: function (key) {
			var k = key.split(':'),
			    coords = new Point(+k[0], +k[1]);
			coords.z = +k[2];
			return coords;
		},
	
		_removeTile: function (key) {
			var tile = this._tiles[key];
			if (!tile) { return; }
	
			remove(tile.el);
	
			delete this._tiles[key];
	
			// @event tileunload: TileEvent
			// Fired when a tile is removed (e.g. when a tile goes off the screen).
			this.fire('tileunload', {
				tile: tile.el,
				coords: this._keyToTileCoords(key)
			});
		},
	
		_initTile: function (tile) {
			addClass(tile, 'leaflet-tile');
	
			var tileSize = this.getTileSize();
			tile.style.width = tileSize.x + 'px';
			tile.style.height = tileSize.y + 'px';
	
			tile.onselectstart = falseFn;
			tile.onmousemove = falseFn;
	
			// update opacity on tiles in IE7-8 because of filter inheritance problems
			if (ielt9 && this.options.opacity < 1) {
				setOpacity(tile, this.options.opacity);
			}
	
			// without this hack, tiles disappear after zoom on Chrome for Android
			// https://github.com/Leaflet/Leaflet/issues/2078
			if (android && !android23) {
				tile.style.WebkitBackfaceVisibility = 'hidden';
			}
		},
	
		_addTile: function (coords, container) {
			var tilePos = this._getTilePos(coords),
			    key = this._tileCoordsToKey(coords);
	
			var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
	
			this._initTile(tile);
	
			// if createTile is defined with a second argument ("done" callback),
			// we know that tile is async and will be ready later; otherwise
			if (this.createTile.length < 2) {
				// mark tile as ready, but delay one frame for opacity animation to happen
				requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
			}
	
			setPosition(tile, tilePos);
	
			// save tile in cache
			this._tiles[key] = {
				el: tile,
				coords: coords,
				current: true
			};
	
			container.appendChild(tile);
			// @event tileloadstart: TileEvent
			// Fired when a tile is requested and starts loading.
			this.fire('tileloadstart', {
				tile: tile,
				coords: coords
			});
		},
	
		_tileReady: function (coords, err, tile) {
			if (!this._map) { return; }
	
			if (err) {
				// @event tileerror: TileErrorEvent
				// Fired when there is an error loading a tile.
				this.fire('tileerror', {
					error: err,
					tile: tile,
					coords: coords
				});
			}
	
			var key = this._tileCoordsToKey(coords);
	
			tile = this._tiles[key];
			if (!tile) { return; }
	
			tile.loaded = +new Date();
			if (this._map._fadeAnimated) {
				setOpacity(tile.el, 0);
				cancelAnimFrame(this._fadeFrame);
				this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
			} else {
				tile.active = true;
				this._pruneTiles();
			}
	
			if (!err) {
				addClass(tile.el, 'leaflet-tile-loaded');
	
				// @event tileload: TileEvent
				// Fired when a tile loads.
				this.fire('tileload', {
					tile: tile.el,
					coords: coords
				});
			}
	
			if (this._noTilesToLoad()) {
				this._loading = false;
				// @event load: Event
				// Fired when the grid layer loaded all visible tiles.
				this.fire('load');
	
				if (ielt9 || !this._map._fadeAnimated) {
					requestAnimFrame(this._pruneTiles, this);
				} else {
					// Wait a bit more than 0.2 secs (the duration of the tile fade-in)
					// to trigger a pruning.
					setTimeout(bind(this._pruneTiles, this), 250);
				}
			}
		},
	
		_getTilePos: function (coords) {
			return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
		},
	
		_wrapCoords: function (coords) {
			var newCoords = new Point(
				this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x,
				this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
			newCoords.z = coords.z;
			return newCoords;
		},
	
		_pxBoundsToTileRange: function (bounds) {
			var tileSize = this.getTileSize();
			return new Bounds(
				bounds.min.unscaleBy(tileSize).floor(),
				bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
		},
	
		_noTilesToLoad: function () {
			for (var key in this._tiles) {
				if (!this._tiles[key].loaded) { return false; }
			}
			return true;
		}
	});
	
	// @factory L.gridLayer(options?: GridLayer options)
	// Creates a new instance of GridLayer with the supplied options.
	function gridLayer(options) {
		return new GridLayer(options);
	}
	
	/*
	 * @class TileLayer
	 * @inherits GridLayer
	 * @aka L.TileLayer
	 * Used to load and display tile layers on the map. Extends `GridLayer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar'}).addTo(map);
	 * ```
	 *
	 * @section URL template
	 * @example
	 *
	 * A string of the following form:
	 *
	 * ```
	 * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
	 * ```
	 *
	 * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
	 *
	 * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
	 *
	 * ```
	 * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
	 * ```
	 */
	
	
	var TileLayer = GridLayer.extend({
	
		// @section
		// @aka TileLayer options
		options: {
			// @option minZoom: Number = 0
			// The minimum zoom level down to which this layer will be displayed (inclusive).
			minZoom: 0,
	
			// @option maxZoom: Number = 18
			// The maximum zoom level up to which this layer will be displayed (inclusive).
			maxZoom: 18,
	
			// @option subdomains: String|String[] = 'abc'
			// Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
			subdomains: 'abc',
	
			// @option errorTileUrl: String = ''
			// URL to the tile image to show in place of the tile that failed to load.
			errorTileUrl: '',
	
			// @option zoomOffset: Number = 0
			// The zoom number used in tile URLs will be offset with this value.
			zoomOffset: 0,
	
			// @option tms: Boolean = false
			// If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
			tms: false,
	
			// @option zoomReverse: Boolean = false
			// If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
			zoomReverse: false,
	
			// @option detectRetina: Boolean = false
			// If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
			detectRetina: false,
	
			// @option crossOrigin: Boolean = false
			// If true, all tiles will have their crossOrigin attribute set to ''. This is needed if you want to access tile pixel data.
			crossOrigin: false
		},
	
		initialize: function (url, options) {
	
			this._url = url;
	
			options = setOptions(this, options);
	
			// detecting retina displays, adjusting tileSize and zoom levels
			if (options.detectRetina && retina && options.maxZoom > 0) {
	
				options.tileSize = Math.floor(options.tileSize / 2);
	
				if (!options.zoomReverse) {
					options.zoomOffset++;
					options.maxZoom--;
				} else {
					options.zoomOffset--;
					options.minZoom++;
				}
	
				options.minZoom = Math.max(0, options.minZoom);
			}
	
			if (typeof options.subdomains === 'string') {
				options.subdomains = options.subdomains.split('');
			}
	
			// for https://github.com/Leaflet/Leaflet/issues/137
			if (!android) {
				this.on('tileunload', this._onTileRemove);
			}
		},
	
		// @method setUrl(url: String, noRedraw?: Boolean): this
		// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
		setUrl: function (url, noRedraw) {
			this._url = url;
	
			if (!noRedraw) {
				this.redraw();
			}
			return this;
		},
	
		// @method createTile(coords: Object, done?: Function): HTMLElement
		// Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
		// to return an `<img>` HTML element with the appropiate image URL given `coords`. The `done`
		// callback is called when the tile has been loaded.
		createTile: function (coords, done) {
			var tile = document.createElement('img');
	
			on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
			on(tile, 'error', bind(this._tileOnError, this, done, tile));
	
			if (this.options.crossOrigin) {
				tile.crossOrigin = '';
			}
	
			/*
			 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
			 http://www.w3.org/TR/WCAG20-TECHS/H67
			*/
			tile.alt = '';
	
			/*
			 Set role="presentation" to force screen readers to ignore this
			 https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
			*/
			tile.setAttribute('role', 'presentation');
	
			tile.src = this.getTileUrl(coords);
	
			return tile;
		},
	
		// @section Extension methods
		// @uninheritable
		// Layers extending `TileLayer` might reimplement the following method.
		// @method getTileUrl(coords: Object): String
		// Called only internally, returns the URL for a tile given its coordinates.
		// Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
		getTileUrl: function (coords) {
			var data = {
				r: retina ? '@2x' : '',
				s: this._getSubdomain(coords),
				x: coords.x,
				y: coords.y,
				z: this._getZoomForUrl()
			};
			if (this._map && !this._map.options.crs.infinite) {
				var invertedY = this._globalTileRange.max.y - coords.y;
				if (this.options.tms) {
					data['y'] = invertedY;
				}
				data['-y'] = invertedY;
			}
	
			return template(this._url, extend(data, this.options));
		},
	
		_tileOnLoad: function (done, tile) {
			// For https://github.com/Leaflet/Leaflet/issues/3332
			if (ielt9) {
				setTimeout(bind(done, this, null, tile), 0);
			} else {
				done(null, tile);
			}
		},
	
		_tileOnError: function (done, tile, e) {
			var errorUrl = this.options.errorTileUrl;
			if (errorUrl && tile.src !== errorUrl) {
				tile.src = errorUrl;
			}
			done(e, tile);
		},
	
		_onTileRemove: function (e) {
			e.tile.onload = null;
		},
	
		_getZoomForUrl: function () {
			var zoom = this._tileZoom,
			maxZoom = this.options.maxZoom,
			zoomReverse = this.options.zoomReverse,
			zoomOffset = this.options.zoomOffset;
	
			if (zoomReverse) {
				zoom = maxZoom - zoom;
			}
	
			return zoom + zoomOffset;
		},
	
		_getSubdomain: function (tilePoint) {
			var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
			return this.options.subdomains[index];
		},
	
		// stops loading all tiles in the background layer
		_abortLoading: function () {
			var i, tile;
			for (i in this._tiles) {
				if (this._tiles[i].coords.z !== this._tileZoom) {
					tile = this._tiles[i].el;
	
					tile.onload = falseFn;
					tile.onerror = falseFn;
	
					if (!tile.complete) {
						tile.src = emptyImageUrl;
						remove(tile);
					}
				}
			}
		}
	});
	
	
	// @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
	// Instantiates a tile layer object given a `URL template` and optionally an options object.
	
	function tileLayer(url, options) {
		return new TileLayer(url, options);
	}
	
	/*
	 * @class TileLayer.WMS
	 * @inherits TileLayer
	 * @aka L.TileLayer.WMS
	 * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
	 *
	 * @example
	 *
	 * ```js
	 * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
	 * 	layers: 'nexrad-n0r-900913',
	 * 	format: 'image/png',
	 * 	transparent: true,
	 * 	attribution: "Weather data © 2012 IEM Nexrad"
	 * });
	 * ```
	 */
	
	var TileLayerWMS = TileLayer.extend({
	
		// @section
		// @aka TileLayer.WMS options
		// If any custom options not documented here are used, they will be sent to the
		// WMS server as extra parameters in each request URL. This can be useful for
		// [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
		defaultWmsParams: {
			service: 'WMS',
			request: 'GetMap',
	
			// @option layers: String = ''
			// **(required)** Comma-separated list of WMS layers to show.
			layers: '',
	
			// @option styles: String = ''
			// Comma-separated list of WMS styles.
			styles: '',
	
			// @option format: String = 'image/jpeg'
			// WMS image format (use `'image/png'` for layers with transparency).
			format: 'image/jpeg',
	
			// @option transparent: Boolean = false
			// If `true`, the WMS service will return images with transparency.
			transparent: false,
	
			// @option version: String = '1.1.1'
			// Version of the WMS service to use
			version: '1.1.1'
		},
	
		options: {
			// @option crs: CRS = null
			// Coordinate Reference System to use for the WMS requests, defaults to
			// map CRS. Don't change this if you're not sure what it means.
			crs: null,
	
			// @option uppercase: Boolean = false
			// If `true`, WMS request parameter keys will be uppercase.
			uppercase: false
		},
	
		initialize: function (url, options) {
	
			this._url = url;
	
			var wmsParams = extend({}, this.defaultWmsParams);
	
			// all keys that are not TileLayer options go to WMS params
			for (var i in options) {
				if (!(i in this.options)) {
					wmsParams[i] = options[i];
				}
			}
	
			options = setOptions(this, options);
	
			wmsParams.width = wmsParams.height = options.tileSize * (options.detectRetina && retina ? 2 : 1);
	
			this.wmsParams = wmsParams;
		},
	
		onAdd: function (map) {
	
			this._crs = this.options.crs || map.options.crs;
			this._wmsVersion = parseFloat(this.wmsParams.version);
	
			var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
			this.wmsParams[projectionKey] = this._crs.code;
	
			TileLayer.prototype.onAdd.call(this, map);
		},
	
		getTileUrl: function (coords) {
	
			var tileBounds = this._tileCoordsToBounds(coords),
			    nw = this._crs.project(tileBounds.getNorthWest()),
			    se = this._crs.project(tileBounds.getSouthEast()),
	
			    bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ?
				    [se.y, nw.x, nw.y, se.x] :
				    [nw.x, se.y, se.x, nw.y]).join(','),
	
			    url = TileLayer.prototype.getTileUrl.call(this, coords);
	
			return url +
				getParamString(this.wmsParams, url, this.options.uppercase) +
				(this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
		},
	
		// @method setParams(params: Object, noRedraw?: Boolean): this
		// Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
		setParams: function (params, noRedraw) {
	
			extend(this.wmsParams, params);
	
			if (!noRedraw) {
				this.redraw();
			}
	
			return this;
		}
	});
	
	
	// @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
	// Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
	function tileLayerWMS(url, options) {
		return new TileLayerWMS(url, options);
	}
	
	TileLayer.WMS = TileLayerWMS;
	tileLayer.wms = tileLayerWMS;
	
	/*
	 * @class Renderer
	 * @inherits Layer
	 * @aka L.Renderer
	 *
	 * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
	 * DOM container of the renderer, its bounds, and its zoom animation.
	 *
	 * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
	 * itself can be added or removed to the map. All paths use a renderer, which can
	 * be implicit (the map will decide the type of renderer and use it automatically)
	 * or explicit (using the [`renderer`](#path-renderer) option of the path).
	 *
	 * Do not use this class directly, use `SVG` and `Canvas` instead.
	 *
	 * @event update: Event
	 * Fired when the renderer updates its bounds, center and zoom, for example when
	 * its map has moved
	 */
	
	var Renderer = Layer.extend({
	
		// @section
		// @aka Renderer options
		options: {
			// @option padding: Number = 0.1
			// How much to extend the clip area around the map view (relative to its size)
			// e.g. 0.1 would be 10% of map view in each direction
			padding: 0.1
		},
	
		initialize: function (options) {
			setOptions(this, options);
			stamp(this);
			this._layers = this._layers || {};
		},
	
		onAdd: function () {
			if (!this._container) {
				this._initContainer(); // defined by renderer implementations
	
				if (this._zoomAnimated) {
					addClass(this._container, 'leaflet-zoom-animated');
				}
			}
	
			this.getPane().appendChild(this._container);
			this._update();
			this.on('update', this._updatePaths, this);
		},
	
		onRemove: function () {
			this.off('update', this._updatePaths, this);
			this._destroyContainer();
		},
	
		getEvents: function () {
			var events = {
				viewreset: this._reset,
				zoom: this._onZoom,
				moveend: this._update,
				zoomend: this._onZoomEnd
			};
			if (this._zoomAnimated) {
				events.zoomanim = this._onAnimZoom;
			}
			return events;
		},
	
		_onAnimZoom: function (ev) {
			this._updateTransform(ev.center, ev.zoom);
		},
	
		_onZoom: function () {
			this._updateTransform(this._map.getCenter(), this._map.getZoom());
		},
	
		_updateTransform: function (center, zoom) {
			var scale = this._map.getZoomScale(zoom, this._zoom),
			    position = getPosition(this._container),
			    viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
			    currentCenterPoint = this._map.project(this._center, zoom),
			    destCenterPoint = this._map.project(center, zoom),
			    centerOffset = destCenterPoint.subtract(currentCenterPoint),
	
			    topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);
	
			if (any3d) {
				setTransform(this._container, topLeftOffset, scale);
			} else {
				setPosition(this._container, topLeftOffset);
			}
		},
	
		_reset: function () {
			this._update();
			this._updateTransform(this._center, this._zoom);
	
			for (var id in this._layers) {
				this._layers[id]._reset();
			}
		},
	
		_onZoomEnd: function () {
			for (var id in this._layers) {
				this._layers[id]._project();
			}
		},
	
		_updatePaths: function () {
			for (var id in this._layers) {
				this._layers[id]._update();
			}
		},
	
		_update: function () {
			// Update pixel bounds of renderer container (for positioning/sizing/clipping later)
			// Subclasses are responsible of firing the 'update' event.
			var p = this.options.padding,
			    size = this._map.getSize(),
			    min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
	
			this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
	
			this._center = this._map.getCenter();
			this._zoom = this._map.getZoom();
		}
	});
	
	/*
	 * @class Canvas
	 * @inherits Renderer
	 * @aka L.Canvas
	 *
	 * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	 * Inherits `Renderer`.
	 *
	 * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
	 * available in all web browsers, notably IE8, and overlapping geometries might
	 * not display properly in some edge cases.
	 *
	 * @example
	 *
	 * Use Canvas by default for all paths in the map:
	 *
	 * ```js
	 * var map = L.map('map', {
	 * 	renderer: L.canvas()
	 * });
	 * ```
	 *
	 * Use a Canvas renderer with extra padding for specific vector geometries:
	 *
	 * ```js
	 * var map = L.map('map');
	 * var myRenderer = L.canvas({ padding: 0.5 });
	 * var line = L.polyline( coordinates, { renderer: myRenderer } );
	 * var circle = L.circle( center, { renderer: myRenderer } );
	 * ```
	 */
	
	var Canvas = Renderer.extend({
		getEvents: function () {
			var events = Renderer.prototype.getEvents.call(this);
			events.viewprereset = this._onViewPreReset;
			return events;
		},
	
		_onViewPreReset: function () {
			// Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
			this._postponeUpdatePaths = true;
		},
	
		onAdd: function () {
			Renderer.prototype.onAdd.call(this);
	
			// Redraw vectors since canvas is cleared upon removal,
			// in case of removing the renderer itself from the map.
			this._draw();
		},
	
		_initContainer: function () {
			var container = this._container = document.createElement('canvas');
	
			on(container, 'mousemove', throttle(this._onMouseMove, 32, this), this);
			on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
			on(container, 'mouseout', this._handleMouseOut, this);
	
			this._ctx = container.getContext('2d');
		},
	
		_destroyContainer: function () {
			delete this._ctx;
			remove(this._container);
			off(this._container);
			delete this._container;
		},
	
		_updatePaths: function () {
			if (this._postponeUpdatePaths) { return; }
	
			var layer;
			this._redrawBounds = null;
			for (var id in this._layers) {
				layer = this._layers[id];
				layer._update();
			}
			this._redraw();
		},
	
		_update: function () {
			if (this._map._animatingZoom && this._bounds) { return; }
	
			this._drawnLayers = {};
	
			Renderer.prototype._update.call(this);
	
			var b = this._bounds,
			    container = this._container,
			    size = b.getSize(),
			    m = retina ? 2 : 1;
	
			setPosition(container, b.min);
	
			// set canvas size (also clearing it); use double size on retina
			container.width = m * size.x;
			container.height = m * size.y;
			container.style.width = size.x + 'px';
			container.style.height = size.y + 'px';
	
			if (retina) {
				this._ctx.scale(2, 2);
			}
	
			// translate so we use the same path coordinates after canvas element moves
			this._ctx.translate(-b.min.x, -b.min.y);
	
			// Tell paths to redraw themselves
			this.fire('update');
		},
	
		_reset: function () {
			Renderer.prototype._reset.call(this);
	
			if (this._postponeUpdatePaths) {
				this._postponeUpdatePaths = false;
				this._updatePaths();
			}
		},
	
		_initPath: function (layer) {
			this._updateDashArray(layer);
			this._layers[stamp(layer)] = layer;
	
			var order = layer._order = {
				layer: layer,
				prev: this._drawLast,
				next: null
			};
			if (this._drawLast) { this._drawLast.next = order; }
			this._drawLast = order;
			this._drawFirst = this._drawFirst || this._drawLast;
		},
	
		_addPath: function (layer) {
			this._requestRedraw(layer);
		},
	
		_removePath: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (next) {
				next.prev = prev;
			} else {
				this._drawLast = prev;
			}
			if (prev) {
				prev.next = next;
			} else {
				this._drawFirst = next;
			}
	
			delete layer._order;
	
			delete this._layers[L.stamp(layer)];
	
			this._requestRedraw(layer);
		},
	
		_updatePath: function (layer) {
			// Redraw the union of the layer's old pixel
			// bounds and the new pixel bounds.
			this._extendRedrawBounds(layer);
			layer._project();
			layer._update();
			// The redraw will extend the redraw bounds
			// with the new pixel bounds.
			this._requestRedraw(layer);
		},
	
		_updateStyle: function (layer) {
			this._updateDashArray(layer);
			this._requestRedraw(layer);
		},
	
		_updateDashArray: function (layer) {
			if (layer.options.dashArray) {
				var parts = layer.options.dashArray.split(','),
				    dashArray = [],
				    i;
				for (i = 0; i < parts.length; i++) {
					dashArray.push(Number(parts[i]));
				}
				layer.options._dashArray = dashArray;
			}
		},
	
		_requestRedraw: function (layer) {
			if (!this._map) { return; }
	
			this._extendRedrawBounds(layer);
			this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
		},
	
		_extendRedrawBounds: function (layer) {
			if (layer._pxBounds) {
				var padding = (layer.options.weight || 0) + 1;
				this._redrawBounds = this._redrawBounds || new Bounds();
				this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
				this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
			}
		},
	
		_redraw: function () {
			this._redrawRequest = null;
	
			if (this._redrawBounds) {
				this._redrawBounds.min._floor();
				this._redrawBounds.max._ceil();
			}
	
			this._clear(); // clear layers in redraw bounds
			this._draw(); // draw layers
	
			this._redrawBounds = null;
		},
	
		_clear: function () {
			var bounds = this._redrawBounds;
			if (bounds) {
				var size = bounds.getSize();
				this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
			} else {
				this._ctx.clearRect(0, 0, this._container.width, this._container.height);
			}
		},
	
		_draw: function () {
			var layer, bounds = this._redrawBounds;
			this._ctx.save();
			if (bounds) {
				var size = bounds.getSize();
				this._ctx.beginPath();
				this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
				this._ctx.clip();
			}
	
			this._drawing = true;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (!bounds || (layer._pxBounds && layer._pxBounds.intersects(bounds))) {
					layer._updatePath();
				}
			}
	
			this._drawing = false;
	
			this._ctx.restore();  // Restore state before clipping.
		},
	
		_updatePoly: function (layer, closed) {
			if (!this._drawing) { return; }
	
			var i, j, len2, p,
			    parts = layer._parts,
			    len = parts.length,
			    ctx = this._ctx;
	
			if (!len) { return; }
	
			this._drawnLayers[layer._leaflet_id] = layer;
	
			ctx.beginPath();
	
			for (i = 0; i < len; i++) {
				for (j = 0, len2 = parts[i].length; j < len2; j++) {
					p = parts[i][j];
					ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
				}
				if (closed) {
					ctx.closePath();
				}
			}
	
			this._fillStroke(ctx, layer);
	
			// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
		},
	
		_updateCircle: function (layer) {
	
			if (!this._drawing || layer._empty()) { return; }
	
			var p = layer._point,
			    ctx = this._ctx,
			    r = layer._radius,
			    s = (layer._radiusY || r) / r;
	
			this._drawnLayers[layer._leaflet_id] = layer;
	
			if (s !== 1) {
				ctx.save();
				ctx.scale(1, s);
			}
	
			ctx.beginPath();
			ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
	
			if (s !== 1) {
				ctx.restore();
			}
	
			this._fillStroke(ctx, layer);
		},
	
		_fillStroke: function (ctx, layer) {
			var options = layer.options;
	
			if (options.fill) {
				ctx.globalAlpha = options.fillOpacity;
				ctx.fillStyle = options.fillColor || options.color;
				ctx.fill(options.fillRule || 'evenodd');
			}
	
			if (options.stroke && options.weight !== 0) {
				if (ctx.setLineDash) {
					ctx.setLineDash(layer.options && layer.options._dashArray || []);
				}
				ctx.globalAlpha = options.opacity;
				ctx.lineWidth = options.weight;
				ctx.strokeStyle = options.color;
				ctx.lineCap = options.lineCap;
				ctx.lineJoin = options.lineJoin;
				ctx.stroke();
			}
		},
	
		// Canvas obviously doesn't have mouse events for individual drawn objects,
		// so we emulate that by calculating what's under the mouse on mousemove/click manually
	
		_onClick: function (e) {
			var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (layer.options.interactive && layer._containsPoint(point) && !this._map._draggableMoved(layer)) {
					clickedLayer = layer;
				}
			}
			if (clickedLayer)  {
				fakeStop(e);
				this._fireEvent([clickedLayer], e);
			}
		},
	
		_onMouseMove: function (e) {
			if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }
	
			var point = this._map.mouseEventToLayerPoint(e);
			this._handleMouseHover(e, point);
		},
	
	
		_handleMouseOut: function (e) {
			var layer = this._hoveredLayer;
			if (layer) {
				// if we're leaving the layer, fire mouseout
				removeClass(this._container, 'leaflet-interactive');
				this._fireEvent([layer], e, 'mouseout');
				this._hoveredLayer = null;
			}
		},
	
		_handleMouseHover: function (e, point) {
			var layer, candidateHoveredLayer;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (layer.options.interactive && layer._containsPoint(point)) {
					candidateHoveredLayer = layer;
				}
			}
	
			if (candidateHoveredLayer !== this._hoveredLayer) {
				this._handleMouseOut(e);
	
				if (candidateHoveredLayer) {
					addClass(this._container, 'leaflet-interactive'); // change cursor
					this._fireEvent([candidateHoveredLayer], e, 'mouseover');
					this._hoveredLayer = candidateHoveredLayer;
				}
			}
	
			if (this._hoveredLayer) {
				this._fireEvent([this._hoveredLayer], e);
			}
		},
	
		_fireEvent: function (layers, e, type) {
			this._map._fireDOMEvent(e, type || e.type, layers);
		},
	
		_bringToFront: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (next) {
				next.prev = prev;
			} else {
				// Already last
				return;
			}
			if (prev) {
				prev.next = next;
			} else if (next) {
				// Update first entry unless this is the
				// signle entry
				this._drawFirst = next;
			}
	
			order.prev = this._drawLast;
			this._drawLast.next = order;
	
			order.next = null;
			this._drawLast = order;
	
			this._requestRedraw(layer);
		},
	
		_bringToBack: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (prev) {
				prev.next = next;
			} else {
				// Already first
				return;
			}
			if (next) {
				next.prev = prev;
			} else if (prev) {
				// Update last entry unless this is the
				// signle entry
				this._drawLast = prev;
			}
	
			order.prev = null;
	
			order.next = this._drawFirst;
			this._drawFirst.prev = order;
			this._drawFirst = order;
	
			this._requestRedraw(layer);
		}
	});
	
	// @factory L.canvas(options?: Renderer options)
	// Creates a Canvas renderer with the given options.
	function canvas$1(options) {
		return canvas ? new Canvas(options) : null;
	}
	
	/*
	 * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
	 */
	
	
	var vmlCreate = (function () {
		try {
			document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
			return function (name) {
				return document.createElement('<lvml:' + name + ' class="lvml">');
			};
		} catch (e) {
			return function (name) {
				return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
			};
		}
	})();
	
	
	/*
	 * @class SVG
	 *
	 * Although SVG is not available on IE7 and IE8, these browsers support [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language), and the SVG renderer will fall back to VML in this case.
	 *
	 * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
	 * with old versions of Internet Explorer.
	 */
	
	// mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
	var vmlMixin = {
	
		_initContainer: function () {
			this._container = create$1('div', 'leaflet-vml-container');
		},
	
		_update: function () {
			if (this._map._animatingZoom) { return; }
			Renderer.prototype._update.call(this);
			this.fire('update');
		},
	
		_initPath: function (layer) {
			var container = layer._container = vmlCreate('shape');
	
			addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
	
			container.coordsize = '1 1';
	
			layer._path = vmlCreate('path');
			container.appendChild(layer._path);
	
			this._updateStyle(layer);
			this._layers[stamp(layer)] = layer;
		},
	
		_addPath: function (layer) {
			var container = layer._container;
			this._container.appendChild(container);
	
			if (layer.options.interactive) {
				layer.addInteractiveTarget(container);
			}
		},
	
		_removePath: function (layer) {
			var container = layer._container;
			remove(container);
			layer.removeInteractiveTarget(container);
			delete this._layers[stamp(layer)];
		},
	
		_updateStyle: function (layer) {
			var stroke = layer._stroke,
			    fill = layer._fill,
			    options = layer.options,
			    container = layer._container;
	
			container.stroked = !!options.stroke;
			container.filled = !!options.fill;
	
			if (options.stroke) {
				if (!stroke) {
					stroke = layer._stroke = vmlCreate('stroke');
				}
				container.appendChild(stroke);
				stroke.weight = options.weight + 'px';
				stroke.color = options.color;
				stroke.opacity = options.opacity;
	
				if (options.dashArray) {
					stroke.dashStyle = isArray(options.dashArray) ?
					    options.dashArray.join(' ') :
					    options.dashArray.replace(/( *, *)/g, ' ');
				} else {
					stroke.dashStyle = '';
				}
				stroke.endcap = options.lineCap.replace('butt', 'flat');
				stroke.joinstyle = options.lineJoin;
	
			} else if (stroke) {
				container.removeChild(stroke);
				layer._stroke = null;
			}
	
			if (options.fill) {
				if (!fill) {
					fill = layer._fill = vmlCreate('fill');
				}
				container.appendChild(fill);
				fill.color = options.fillColor || options.color;
				fill.opacity = options.fillOpacity;
	
			} else if (fill) {
				container.removeChild(fill);
				layer._fill = null;
			}
		},
	
		_updateCircle: function (layer) {
			var p = layer._point.round(),
			    r = Math.round(layer._radius),
			    r2 = Math.round(layer._radiusY || r);
	
			this._setPath(layer, layer._empty() ? 'M0 0' :
					'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + (65535 * 360));
		},
	
		_setPath: function (layer, path) {
			layer._path.v = path;
		},
	
		_bringToFront: function (layer) {
			toFront(layer._container);
		},
	
		_bringToBack: function (layer) {
			toBack(layer._container);
		}
	};
	
	var create$2 = vml ? vmlCreate : svgCreate;
	
	/*
	 * @class SVG
	 * @inherits Renderer
	 * @aka L.SVG
	 *
	 * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
	 * Inherits `Renderer`.
	 *
	 * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
	 * available in all web browsers, notably Android 2.x and 3.x.
	 *
	 * Although SVG is not available on IE7 and IE8, these browsers support
	 * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
	 * (a now deprecated technology), and the SVG renderer will fall back to VML in
	 * this case.
	 *
	 * @example
	 *
	 * Use SVG by default for all paths in the map:
	 *
	 * ```js
	 * var map = L.map('map', {
	 * 	renderer: L.svg()
	 * });
	 * ```
	 *
	 * Use a SVG renderer with extra padding for specific vector geometries:
	 *
	 * ```js
	 * var map = L.map('map');
	 * var myRenderer = L.svg({ padding: 0.5 });
	 * var line = L.polyline( coordinates, { renderer: myRenderer } );
	 * var circle = L.circle( center, { renderer: myRenderer } );
	 * ```
	 */
	
	var SVG = Renderer.extend({
	
		getEvents: function () {
			var events = Renderer.prototype.getEvents.call(this);
			events.zoomstart = this._onZoomStart;
			return events;
		},
	
		_initContainer: function () {
			this._container = create$2('svg');
	
			// makes it possible to click through svg root; we'll reset it back in individual paths
			this._container.setAttribute('pointer-events', 'none');
	
			this._rootGroup = create$2('g');
			this._container.appendChild(this._rootGroup);
		},
	
		_destroyContainer: function () {
			remove(this._container);
			off(this._container);
			delete this._container;
			delete this._rootGroup;
		},
	
		_onZoomStart: function () {
			// Drag-then-pinch interactions might mess up the center and zoom.
			// In this case, the easiest way to prevent this is re-do the renderer
			//   bounds and padding when the zooming starts.
			this._update();
		},
	
		_update: function () {
			if (this._map._animatingZoom && this._bounds) { return; }
	
			Renderer.prototype._update.call(this);
	
			var b = this._bounds,
			    size = b.getSize(),
			    container = this._container;
	
			// set size of svg-container if changed
			if (!this._svgSize || !this._svgSize.equals(size)) {
				this._svgSize = size;
				container.setAttribute('width', size.x);
				container.setAttribute('height', size.y);
			}
	
			// movement: update container viewBox so that we don't have to change coordinates of individual layers
			setPosition(container, b.min);
			container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));
	
			this.fire('update');
		},
	
		// methods below are called by vector layers implementations
	
		_initPath: function (layer) {
			var path = layer._path = create$2('path');
	
			// @namespace Path
			// @option className: String = null
			// Custom class name set on an element. Only for SVG renderer.
			if (layer.options.className) {
				addClass(path, layer.options.className);
			}
	
			if (layer.options.interactive) {
				addClass(path, 'leaflet-interactive');
			}
	
			this._updateStyle(layer);
			this._layers[stamp(layer)] = layer;
		},
	
		_addPath: function (layer) {
			if (!this._rootGroup) { this._initContainer(); }
			this._rootGroup.appendChild(layer._path);
			layer.addInteractiveTarget(layer._path);
		},
	
		_removePath: function (layer) {
			remove(layer._path);
			layer.removeInteractiveTarget(layer._path);
			delete this._layers[stamp(layer)];
		},
	
		_updatePath: function (layer) {
			layer._project();
			layer._update();
		},
	
		_updateStyle: function (layer) {
			var path = layer._path,
			    options = layer.options;
	
			if (!path) { return; }
	
			if (options.stroke) {
				path.setAttribute('stroke', options.color);
				path.setAttribute('stroke-opacity', options.opacity);
				path.setAttribute('stroke-width', options.weight);
				path.setAttribute('stroke-linecap', options.lineCap);
				path.setAttribute('stroke-linejoin', options.lineJoin);
	
				if (options.dashArray) {
					path.setAttribute('stroke-dasharray', options.dashArray);
				} else {
					path.removeAttribute('stroke-dasharray');
				}
	
				if (options.dashOffset) {
					path.setAttribute('stroke-dashoffset', options.dashOffset);
				} else {
					path.removeAttribute('stroke-dashoffset');
				}
			} else {
				path.setAttribute('stroke', 'none');
			}
	
			if (options.fill) {
				path.setAttribute('fill', options.fillColor || options.color);
				path.setAttribute('fill-opacity', options.fillOpacity);
				path.setAttribute('fill-rule', options.fillRule || 'evenodd');
			} else {
				path.setAttribute('fill', 'none');
			}
		},
	
		_updatePoly: function (layer, closed) {
			this._setPath(layer, pointsToPath(layer._parts, closed));
		},
	
		_updateCircle: function (layer) {
			var p = layer._point,
			    r = layer._radius,
			    r2 = layer._radiusY || r,
			    arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
	
			// drawing a circle with two half-arcs
			var d = layer._empty() ? 'M0 0' :
					'M' + (p.x - r) + ',' + p.y +
					arc + (r * 2) + ',0 ' +
					arc + (-r * 2) + ',0 ';
	
			this._setPath(layer, d);
		},
	
		_setPath: function (layer, path) {
			layer._path.setAttribute('d', path);
		},
	
		// SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
		_bringToFront: function (layer) {
			toFront(layer._path);
		},
	
		_bringToBack: function (layer) {
			toBack(layer._path);
		}
	});
	
	if (vml) {
		SVG.include(vmlMixin);
	}
	
	// @factory L.svg(options?: Renderer options)
	// Creates a SVG renderer with the given options.
	function svg$1(options) {
		return svg || vml ? new SVG(options) : null;
	}
	
	Map.include({
		// @namespace Map; @method getRenderer(layer: Path): Renderer
		// Returns the instance of `Renderer` that should be used to render the given
		// `Path`. It will ensure that the `renderer` options of the map and paths
		// are respected, and that the renderers do exist on the map.
		getRenderer: function (layer) {
			// @namespace Path; @option renderer: Renderer
			// Use this specific instance of `Renderer` for this path. Takes
			// precedence over the map's [default renderer](#map-renderer).
			var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
	
			if (!renderer) {
				// @namespace Map; @option preferCanvas: Boolean = false
				// Whether `Path`s should be rendered on a `Canvas` renderer.
				// By default, all `Path`s are rendered in a `SVG` renderer.
				renderer = this._renderer = (this.options.preferCanvas && canvas$1()) || svg$1();
			}
	
			if (!this.hasLayer(renderer)) {
				this.addLayer(renderer);
			}
			return renderer;
		},
	
		_getPaneRenderer: function (name) {
			if (name === 'overlayPane' || name === undefined) {
				return false;
			}
	
			var renderer = this._paneRenderers[name];
			if (renderer === undefined) {
				renderer = (SVG && svg$1({pane: name})) || (Canvas && canvas$1({pane: name}));
				this._paneRenderers[name] = renderer;
			}
			return renderer;
		}
	});
	
	/*
	 * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
	 */
	
	/*
	 * @class Rectangle
	 * @aka L.Retangle
	 * @inherits Polygon
	 *
	 * A class for drawing rectangle overlays on a map. Extends `Polygon`.
	 *
	 * @example
	 *
	 * ```js
	 * // define rectangle geographical bounds
	 * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
	 *
	 * // create an orange rectangle
	 * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
	 *
	 * // zoom the map to the rectangle bounds
	 * map.fitBounds(bounds);
	 * ```
	 *
	 */
	
	
	var Rectangle = Polygon.extend({
		initialize: function (latLngBounds, options) {
			Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
		},
	
		// @method setBounds(latLngBounds: LatLngBounds): this
		// Redraws the rectangle with the passed bounds.
		setBounds: function (latLngBounds) {
			return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
		},
	
		_boundsToLatLngs: function (latLngBounds) {
			latLngBounds = toLatLngBounds(latLngBounds);
			return [
				latLngBounds.getSouthWest(),
				latLngBounds.getNorthWest(),
				latLngBounds.getNorthEast(),
				latLngBounds.getSouthEast()
			];
		}
	});
	
	
	// @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
	function rectangle(latLngBounds, options) {
		return new Rectangle(latLngBounds, options);
	}
	
	SVG.create = create$2;
	SVG.pointsToPath = pointsToPath;
	
	GeoJSON.geometryToLayer = geometryToLayer;
	GeoJSON.coordsToLatLng = coordsToLatLng;
	GeoJSON.coordsToLatLngs = coordsToLatLngs;
	GeoJSON.latLngToCoords = latLngToCoords;
	GeoJSON.latLngsToCoords = latLngsToCoords;
	GeoJSON.getFeature = getFeature;
	GeoJSON.asFeature = asFeature;
	
	/*
	 * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
	 * (zoom to a selected bounding box), enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @option boxZoom: Boolean = true
		// Whether the map can be zoomed to a rectangular area specified by
		// dragging the mouse while pressing the shift key.
		boxZoom: true
	});
	
	var BoxZoom = Handler.extend({
		initialize: function (map) {
			this._map = map;
			this._container = map._container;
			this._pane = map._panes.overlayPane;
			this._resetStateTimeout = 0;
			map.on('unload', this._destroy, this);
		},
	
		addHooks: function () {
			on(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		removeHooks: function () {
			off(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		moved: function () {
			return this._moved;
		},
	
		_destroy: function () {
			remove(this._pane);
			delete this._pane;
		},
	
		_resetState: function () {
			this._resetStateTimeout = 0;
			this._moved = false;
		},
	
		_clearDeferredResetState: function () {
			if (this._resetStateTimeout !== 0) {
				clearTimeout(this._resetStateTimeout);
				this._resetStateTimeout = 0;
			}
		},
	
		_onMouseDown: function (e) {
			if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }
	
			// Clear the deferred resetState if it hasn't executed yet, otherwise it
			// will interrupt the interaction and orphan a box element in the container.
			this._clearDeferredResetState();
			this._resetState();
	
			disableTextSelection();
			disableImageDrag();
	
			this._startPoint = this._map.mouseEventToContainerPoint(e);
	
			on(document, {
				contextmenu: stop,
				mousemove: this._onMouseMove,
				mouseup: this._onMouseUp,
				keydown: this._onKeyDown
			}, this);
		},
	
		_onMouseMove: function (e) {
			if (!this._moved) {
				this._moved = true;
	
				this._box = create$1('div', 'leaflet-zoom-box', this._container);
				addClass(this._container, 'leaflet-crosshair');
	
				this._map.fire('boxzoomstart');
			}
	
			this._point = this._map.mouseEventToContainerPoint(e);
	
			var bounds = new Bounds(this._point, this._startPoint),
			    size = bounds.getSize();
	
			setPosition(this._box, bounds.min);
	
			this._box.style.width  = size.x + 'px';
			this._box.style.height = size.y + 'px';
		},
	
		_finish: function () {
			if (this._moved) {
				remove(this._box);
				removeClass(this._container, 'leaflet-crosshair');
			}
	
			enableTextSelection();
			enableImageDrag();
	
			off(document, {
				contextmenu: stop,
				mousemove: this._onMouseMove,
				mouseup: this._onMouseUp,
				keydown: this._onKeyDown
			}, this);
		},
	
		_onMouseUp: function (e) {
			if ((e.which !== 1) && (e.button !== 1)) { return; }
	
			this._finish();
	
			if (!this._moved) { return; }
			// Postpone to next JS tick so internal click event handling
			// still see it as "moved".
			this._clearDeferredResetState();
			this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
	
			var bounds = new LatLngBounds(
			        this._map.containerPointToLatLng(this._startPoint),
			        this._map.containerPointToLatLng(this._point));
	
			this._map
				.fitBounds(bounds)
				.fire('boxzoomend', {boxZoomBounds: bounds});
		},
	
		_onKeyDown: function (e) {
			if (e.keyCode === 27) {
				this._finish();
			}
		}
	});
	
	// @section Handlers
	// @property boxZoom: Handler
	// Box (shift-drag with mouse) zoom handler.
	Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
	
	/*
	 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	
	Map.mergeOptions({
		// @option doubleClickZoom: Boolean|String = true
		// Whether the map can be zoomed in by double clicking on it and
		// zoomed out by double clicking while holding shift. If passed
		// `'center'`, double-click zoom will zoom to the center of the
		//  view regardless of where the mouse was.
		doubleClickZoom: true
	});
	
	var DoubleClickZoom = Handler.extend({
		addHooks: function () {
			this._map.on('dblclick', this._onDoubleClick, this);
		},
	
		removeHooks: function () {
			this._map.off('dblclick', this._onDoubleClick, this);
		},
	
		_onDoubleClick: function (e) {
			var map = this._map,
			    oldZoom = map.getZoom(),
			    delta = map.options.zoomDelta,
			    zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
	
			if (map.options.doubleClickZoom === 'center') {
				map.setZoom(zoom);
			} else {
				map.setZoomAround(e.containerPoint, zoom);
			}
		}
	});
	
	// @section Handlers
	//
	// Map properties include interaction handlers that allow you to control
	// interaction behavior in runtime, enabling or disabling certain features such
	// as dragging or touch zoom (see `Handler` methods). For example:
	//
	// ```js
	// map.doubleClickZoom.disable();
	// ```
	//
	// @property doubleClickZoom: Handler
	// Double click zoom handler.
	Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
	
	/*
	 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @option dragging: Boolean = true
		// Whether the map be draggable with mouse/touch or not.
		dragging: true,
	
		// @section Panning Inertia Options
		// @option inertia: Boolean = *
		// If enabled, panning of the map will have an inertia effect where
		// the map builds momentum while dragging and continues moving in
		// the same direction for some time. Feels especially nice on touch
		// devices. Enabled by default unless running on old Android devices.
		inertia: !android23,
	
		// @option inertiaDeceleration: Number = 3000
		// The rate with which the inertial movement slows down, in pixels/second².
		inertiaDeceleration: 3400, // px/s^2
	
		// @option inertiaMaxSpeed: Number = Infinity
		// Max speed of the inertial movement, in pixels/second.
		inertiaMaxSpeed: Infinity, // px/s
	
		// @option easeLinearity: Number = 0.2
		easeLinearity: 0.2,
	
		// TODO refactor, move to CRS
		// @option worldCopyJump: Boolean = false
		// With this option enabled, the map tracks when you pan to another "copy"
		// of the world and seamlessly jumps to the original one so that all overlays
		// like markers and vector layers are still visible.
		worldCopyJump: false,
	
		// @option maxBoundsViscosity: Number = 0.0
		// If `maxBounds` is set, this option will control how solid the bounds
		// are when dragging the map around. The default value of `0.0` allows the
		// user to drag outside the bounds at normal speed, higher values will
		// slow down map dragging outside bounds, and `1.0` makes the bounds fully
		// solid, preventing the user from dragging outside the bounds.
		maxBoundsViscosity: 0.0
	});
	
	var Drag = Handler.extend({
		addHooks: function () {
			if (!this._draggable) {
				var map = this._map;
	
				this._draggable = new Draggable(map._mapPane, map._container);
	
				this._draggable.on({
					dragstart: this._onDragStart,
					drag: this._onDrag,
					dragend: this._onDragEnd
				}, this);
	
				this._draggable.on('predrag', this._onPreDragLimit, this);
				if (map.options.worldCopyJump) {
					this._draggable.on('predrag', this._onPreDragWrap, this);
					map.on('zoomend', this._onZoomEnd, this);
	
					map.whenReady(this._onZoomEnd, this);
				}
			}
			addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
			this._draggable.enable();
			this._positions = [];
			this._times = [];
		},
	
		removeHooks: function () {
			removeClass(this._map._container, 'leaflet-grab');
			removeClass(this._map._container, 'leaflet-touch-drag');
			this._draggable.disable();
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		moving: function () {
			return this._draggable && this._draggable._moving;
		},
	
		_onDragStart: function () {
			var map = this._map;
	
			map._stop();
			if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
				var bounds = toLatLngBounds(this._map.options.maxBounds);
	
				this._offsetLimit = toBounds(
					this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
					this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1)
						.add(this._map.getSize()));
	
				this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
			} else {
				this._offsetLimit = null;
			}
	
			map
			    .fire('movestart')
			    .fire('dragstart');
	
			if (map.options.inertia) {
				this._positions = [];
				this._times = [];
			}
		},
	
		_onDrag: function (e) {
			if (this._map.options.inertia) {
				var time = this._lastTime = +new Date(),
				    pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
	
				this._positions.push(pos);
				this._times.push(time);
	
				if (time - this._times[0] > 50) {
					this._positions.shift();
					this._times.shift();
				}
			}
	
			this._map
			    .fire('move', e)
			    .fire('drag', e);
		},
	
		_onZoomEnd: function () {
			var pxCenter = this._map.getSize().divideBy(2),
			    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
	
			this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
			this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
		},
	
		_viscousLimit: function (value, threshold) {
			return value - (value - threshold) * this._viscosity;
		},
	
		_onPreDragLimit: function () {
			if (!this._viscosity || !this._offsetLimit) { return; }
	
			var offset = this._draggable._newPos.subtract(this._draggable._startPos);
	
			var limit = this._offsetLimit;
			if (offset.x < limit.min.x) { offset.x = this._viscousLimit(offset.x, limit.min.x); }
			if (offset.y < limit.min.y) { offset.y = this._viscousLimit(offset.y, limit.min.y); }
			if (offset.x > limit.max.x) { offset.x = this._viscousLimit(offset.x, limit.max.x); }
			if (offset.y > limit.max.y) { offset.y = this._viscousLimit(offset.y, limit.max.y); }
	
			this._draggable._newPos = this._draggable._startPos.add(offset);
		},
	
		_onPreDragWrap: function () {
			// TODO refactor to be able to adjust map pane position after zoom
			var worldWidth = this._worldWidth,
			    halfWidth = Math.round(worldWidth / 2),
			    dx = this._initialWorldOffset,
			    x = this._draggable._newPos.x,
			    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
			    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
			    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
	
			this._draggable._absPos = this._draggable._newPos.clone();
			this._draggable._newPos.x = newX;
		},
	
		_onDragEnd: function (e) {
			var map = this._map,
			    options = map.options,
	
			    noInertia = !options.inertia || this._times.length < 2;
	
			map.fire('dragend', e);
	
			if (noInertia) {
				map.fire('moveend');
	
			} else {
	
				var direction = this._lastPos.subtract(this._positions[0]),
				    duration = (this._lastTime - this._times[0]) / 1000,
				    ease = options.easeLinearity,
	
				    speedVector = direction.multiplyBy(ease / duration),
				    speed = speedVector.distanceTo([0, 0]),
	
				    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
				    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),
	
				    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
				    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
	
				if (!offset.x && !offset.y) {
					map.fire('moveend');
	
				} else {
					offset = map._limitOffset(offset, map.options.maxBounds);
	
					requestAnimFrame(function () {
						map.panBy(offset, {
							duration: decelerationDuration,
							easeLinearity: ease,
							noMoveStart: true,
							animate: true
						});
					});
				}
			}
		}
	});
	
	// @section Handlers
	// @property dragging: Handler
	// Map dragging handler (by both mouse and touch).
	Map.addInitHook('addHandler', 'dragging', Drag);
	
	/*
	 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
	 */
	
	// @namespace Map
	// @section Keyboard Navigation Options
	Map.mergeOptions({
		// @option keyboard: Boolean = true
		// Makes the map focusable and allows users to navigate the map with keyboard
		// arrows and `+`/`-` keys.
		keyboard: true,
	
		// @option keyboardPanDelta: Number = 80
		// Amount of pixels to pan when pressing an arrow key.
		keyboardPanDelta: 80
	});
	
	var Keyboard = Handler.extend({
	
		keyCodes: {
			left:    [37],
			right:   [39],
			down:    [40],
			up:      [38],
			zoomIn:  [187, 107, 61, 171],
			zoomOut: [189, 109, 54, 173]
		},
	
		initialize: function (map) {
			this._map = map;
	
			this._setPanDelta(map.options.keyboardPanDelta);
			this._setZoomDelta(map.options.zoomDelta);
		},
	
		addHooks: function () {
			var container = this._map._container;
	
			// make the container focusable by tabbing
			if (container.tabIndex <= 0) {
				container.tabIndex = '0';
			}
	
			on(container, {
				focus: this._onFocus,
				blur: this._onBlur,
				mousedown: this._onMouseDown
			}, this);
	
			this._map.on({
				focus: this._addHooks,
				blur: this._removeHooks
			}, this);
		},
	
		removeHooks: function () {
			this._removeHooks();
	
			off(this._map._container, {
				focus: this._onFocus,
				blur: this._onBlur,
				mousedown: this._onMouseDown
			}, this);
	
			this._map.off({
				focus: this._addHooks,
				blur: this._removeHooks
			}, this);
		},
	
		_onMouseDown: function () {
			if (this._focused) { return; }
	
			var body = document.body,
			    docEl = document.documentElement,
			    top = body.scrollTop || docEl.scrollTop,
			    left = body.scrollLeft || docEl.scrollLeft;
	
			this._map._container.focus();
	
			window.scrollTo(left, top);
		},
	
		_onFocus: function () {
			this._focused = true;
			this._map.fire('focus');
		},
	
		_onBlur: function () {
			this._focused = false;
			this._map.fire('blur');
		},
	
		_setPanDelta: function (panDelta) {
			var keys = this._panKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.left.length; i < len; i++) {
				keys[codes.left[i]] = [-1 * panDelta, 0];
			}
			for (i = 0, len = codes.right.length; i < len; i++) {
				keys[codes.right[i]] = [panDelta, 0];
			}
			for (i = 0, len = codes.down.length; i < len; i++) {
				keys[codes.down[i]] = [0, panDelta];
			}
			for (i = 0, len = codes.up.length; i < len; i++) {
				keys[codes.up[i]] = [0, -1 * panDelta];
			}
		},
	
		_setZoomDelta: function (zoomDelta) {
			var keys = this._zoomKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.zoomIn.length; i < len; i++) {
				keys[codes.zoomIn[i]] = zoomDelta;
			}
			for (i = 0, len = codes.zoomOut.length; i < len; i++) {
				keys[codes.zoomOut[i]] = -zoomDelta;
			}
		},
	
		_addHooks: function () {
			on(document, 'keydown', this._onKeyDown, this);
		},
	
		_removeHooks: function () {
			off(document, 'keydown', this._onKeyDown, this);
		},
	
		_onKeyDown: function (e) {
			if (e.altKey || e.ctrlKey || e.metaKey) { return; }
	
			var key = e.keyCode,
			    map = this._map,
			    offset;
	
			if (key in this._panKeys) {
	
				if (map._panAnim && map._panAnim._inProgress) { return; }
	
				offset = this._panKeys[key];
				if (e.shiftKey) {
					offset = toPoint(offset).multiplyBy(3);
				}
	
				map.panBy(offset);
	
				if (map.options.maxBounds) {
					map.panInsideBounds(map.options.maxBounds);
				}
	
			} else if (key in this._zoomKeys) {
				map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
	
			} else if (key === 27 && map._popup) {
				map.closePopup();
	
			} else {
				return;
			}
	
			stop(e);
		}
	});
	
	// @section Handlers
	// @section Handlers
	// @property keyboard: Handler
	// Keyboard navigation handler.
	Map.addInitHook('addHandler', 'keyboard', Keyboard);
	
	/*
	 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @section Mousewheel options
		// @option scrollWheelZoom: Boolean|String = true
		// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
		// it will zoom to the center of the view regardless of where the mouse was.
		scrollWheelZoom: true,
	
		// @option wheelDebounceTime: Number = 40
		// Limits the rate at which a wheel can fire (in milliseconds). By default
		// user can't zoom via wheel more often than once per 40 ms.
		wheelDebounceTime: 40,
	
		// @option wheelPxPerZoomLevel: Number = 60
		// How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
		// mean a change of one full zoom level. Smaller values will make wheel-zooming
		// faster (and vice versa).
		wheelPxPerZoomLevel: 60
	});
	
	var ScrollWheelZoom = Handler.extend({
		addHooks: function () {
			on(this._map._container, 'mousewheel', this._onWheelScroll, this);
	
			this._delta = 0;
		},
	
		removeHooks: function () {
			off(this._map._container, 'mousewheel', this._onWheelScroll, this);
		},
	
		_onWheelScroll: function (e) {
			var delta = getWheelDelta(e);
	
			var debounce = this._map.options.wheelDebounceTime;
	
			this._delta += delta;
			this._lastMousePos = this._map.mouseEventToContainerPoint(e);
	
			if (!this._startTime) {
				this._startTime = +new Date();
			}
	
			var left = Math.max(debounce - (+new Date() - this._startTime), 0);
	
			clearTimeout(this._timer);
			this._timer = setTimeout(bind(this._performZoom, this), left);
	
			stop(e);
		},
	
		_performZoom: function () {
			var map = this._map,
			    zoom = map.getZoom(),
			    snap = this._map.options.zoomSnap || 0;
	
			map._stop(); // stop panning and fly animations if any
	
			// map the delta with a sigmoid function to -4..4 range leaning on -1..1
			var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
			    d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
			    d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
			    delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
	
			this._delta = 0;
			this._startTime = null;
	
			if (!delta) { return; }
	
			if (map.options.scrollWheelZoom === 'center') {
				map.setZoom(zoom + delta);
			} else {
				map.setZoomAround(this._lastMousePos, zoom + delta);
			}
		}
	});
	
	// @section Handlers
	// @property scrollWheelZoom: Handler
	// Scroll wheel zoom handler.
	Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
	
	/*
	 * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @section Touch interaction options
		// @option tap: Boolean = true
		// Enables mobile hacks for supporting instant taps (fixing 200ms click
		// delay on iOS/Android) and touch holds (fired as `contextmenu` events).
		tap: true,
	
		// @option tapTolerance: Number = 15
		// The max number of pixels a user can shift his finger during touch
		// for it to be considered a valid tap.
		tapTolerance: 15
	});
	
	var Tap = Handler.extend({
		addHooks: function () {
			on(this._map._container, 'touchstart', this._onDown, this);
		},
	
		removeHooks: function () {
			off(this._map._container, 'touchstart', this._onDown, this);
		},
	
		_onDown: function (e) {
			if (!e.touches) { return; }
	
			preventDefault(e);
	
			this._fireClick = true;
	
			// don't simulate click or track longpress if more than 1 touch
			if (e.touches.length > 1) {
				this._fireClick = false;
				clearTimeout(this._holdTimeout);
				return;
			}
	
			var first = e.touches[0],
			    el = first.target;
	
			this._startPos = this._newPos = new Point(first.clientX, first.clientY);
	
			// if touching a link, highlight it
			if (el.tagName && el.tagName.toLowerCase() === 'a') {
				addClass(el, 'leaflet-active');
			}
	
			// simulate long hold but setting a timeout
			this._holdTimeout = setTimeout(bind(function () {
				if (this._isTapValid()) {
					this._fireClick = false;
					this._onUp();
					this._simulateEvent('contextmenu', first);
				}
			}, this), 1000);
	
			this._simulateEvent('mousedown', first);
	
			on(document, {
				touchmove: this._onMove,
				touchend: this._onUp
			}, this);
		},
	
		_onUp: function (e) {
			clearTimeout(this._holdTimeout);
	
			off(document, {
				touchmove: this._onMove,
				touchend: this._onUp
			}, this);
	
			if (this._fireClick && e && e.changedTouches) {
	
				var first = e.changedTouches[0],
				    el = first.target;
	
				if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
					removeClass(el, 'leaflet-active');
				}
	
				this._simulateEvent('mouseup', first);
	
				// simulate click if the touch didn't move too much
				if (this._isTapValid()) {
					this._simulateEvent('click', first);
				}
			}
		},
	
		_isTapValid: function () {
			return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
		},
	
		_onMove: function (e) {
			var first = e.touches[0];
			this._newPos = new Point(first.clientX, first.clientY);
			this._simulateEvent('mousemove', first);
		},
	
		_simulateEvent: function (type, e) {
			var simulatedEvent = document.createEvent('MouseEvents');
	
			simulatedEvent._simulated = true;
			e.target._simulatedClick = true;
	
			simulatedEvent.initMouseEvent(
			        type, true, true, window, 1,
			        e.screenX, e.screenY,
			        e.clientX, e.clientY,
			        false, false, false, false, 0, null);
	
			e.target.dispatchEvent(simulatedEvent);
		}
	});
	
	// @section Handlers
	// @property tap: Handler
	// Mobile touch hacks (quick tap and touch hold) handler.
	if (touch && !pointer) {
		Map.addInitHook('addHandler', 'tap', Tap);
	}
	
	/*
	 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @section Touch interaction options
		// @option touchZoom: Boolean|String = *
		// Whether the map can be zoomed by touch-dragging with two fingers. If
		// passed `'center'`, it will zoom to the center of the view regardless of
		// where the touch events (fingers) were. Enabled for touch-capable web
		// browsers except for old Androids.
		touchZoom: touch && !android23,
	
		// @option bounceAtZoomLimits: Boolean = true
		// Set it to false if you don't want the map to zoom beyond min/max zoom
		// and then bounce back when pinch-zooming.
		bounceAtZoomLimits: true
	});
	
	var TouchZoom = Handler.extend({
		addHooks: function () {
			addClass(this._map._container, 'leaflet-touch-zoom');
			on(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		removeHooks: function () {
			removeClass(this._map._container, 'leaflet-touch-zoom');
			off(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		_onTouchStart: function (e) {
			var map = this._map;
			if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }
	
			var p1 = map.mouseEventToContainerPoint(e.touches[0]),
			    p2 = map.mouseEventToContainerPoint(e.touches[1]);
	
			this._centerPoint = map.getSize()._divideBy(2);
			this._startLatLng = map.containerPointToLatLng(this._centerPoint);
			if (map.options.touchZoom !== 'center') {
				this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
			}
	
			this._startDist = p1.distanceTo(p2);
			this._startZoom = map.getZoom();
	
			this._moved = false;
			this._zooming = true;
	
			map._stop();
	
			on(document, 'touchmove', this._onTouchMove, this);
			on(document, 'touchend', this._onTouchEnd, this);
	
			preventDefault(e);
		},
	
		_onTouchMove: function (e) {
			if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }
	
			var map = this._map,
			    p1 = map.mouseEventToContainerPoint(e.touches[0]),
			    p2 = map.mouseEventToContainerPoint(e.touches[1]),
			    scale = p1.distanceTo(p2) / this._startDist;
	
			this._zoom = map.getScaleZoom(scale, this._startZoom);
	
			if (!map.options.bounceAtZoomLimits && (
				(this._zoom < map.getMinZoom() && scale < 1) ||
				(this._zoom > map.getMaxZoom() && scale > 1))) {
				this._zoom = map._limitZoom(this._zoom);
			}
	
			if (map.options.touchZoom === 'center') {
				this._center = this._startLatLng;
				if (scale === 1) { return; }
			} else {
				// Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
				var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
				if (scale === 1 && delta.x === 0 && delta.y === 0) { return; }
				this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
			}
	
			if (!this._moved) {
				map._moveStart(true);
				this._moved = true;
			}
	
			cancelAnimFrame(this._animRequest);
	
			var moveFn = bind(map._move, map, this._center, this._zoom, {pinch: true, round: false});
			this._animRequest = requestAnimFrame(moveFn, this, true);
	
			preventDefault(e);
		},
	
		_onTouchEnd: function () {
			if (!this._moved || !this._zooming) {
				this._zooming = false;
				return;
			}
	
			this._zooming = false;
			cancelAnimFrame(this._animRequest);
	
			off(document, 'touchmove', this._onTouchMove);
			off(document, 'touchend', this._onTouchEnd);
	
			// Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
			if (this._map.options.zoomAnimation) {
				this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
			} else {
				this._map._resetView(this._center, this._map._limitZoom(this._zoom));
			}
		}
	});
	
	// @section Handlers
	// @property touchZoom: Handler
	// Touch zoom handler.
	Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
	
	Map.BoxZoom = BoxZoom;
	Map.DoubleClickZoom = DoubleClickZoom;
	Map.Drag = Drag;
	Map.Keyboard = Keyboard;
	Map.ScrollWheelZoom = ScrollWheelZoom;
	Map.Tap = Tap;
	Map.TouchZoom = TouchZoom;
	
	// misc
	
	var oldL = window.L;
	function noConflict() {
		window.L = oldL;
		return this;
	}
	
	// Always export us to window global (see #2364)
	window.L = exports;
	
	Object.freeze = freeze;
	
	exports.version = version;
	exports.noConflict = noConflict;
	exports.Control = Control;
	exports.control = control;
	exports.Browser = Browser;
	exports.Evented = Evented;
	exports.Mixin = Mixin;
	exports.Util = Util;
	exports.Class = Class;
	exports.Handler = Handler;
	exports.extend = extend;
	exports.bind = bind;
	exports.stamp = stamp;
	exports.setOptions = setOptions;
	exports.DomEvent = DomEvent;
	exports.DomUtil = DomUtil;
	exports.PosAnimation = PosAnimation;
	exports.Draggable = Draggable;
	exports.LineUtil = LineUtil;
	exports.PolyUtil = PolyUtil;
	exports.Point = Point;
	exports.point = toPoint;
	exports.Bounds = Bounds;
	exports.bounds = toBounds;
	exports.Transformation = Transformation;
	exports.transformation = toTransformation;
	exports.Projection = index;
	exports.LatLng = LatLng;
	exports.latLng = toLatLng;
	exports.LatLngBounds = LatLngBounds;
	exports.latLngBounds = toLatLngBounds;
	exports.CRS = CRS;
	exports.GeoJSON = GeoJSON;
	exports.geoJSON = geoJSON;
	exports.geoJson = geoJson;
	exports.Layer = Layer;
	exports.LayerGroup = LayerGroup;
	exports.layerGroup = layerGroup;
	exports.FeatureGroup = FeatureGroup;
	exports.featureGroup = featureGroup;
	exports.ImageOverlay = ImageOverlay;
	exports.imageOverlay = imageOverlay;
	exports.VideoOverlay = VideoOverlay;
	exports.videoOverlay = videoOverlay;
	exports.DivOverlay = DivOverlay;
	exports.Popup = Popup;
	exports.popup = popup;
	exports.Tooltip = Tooltip;
	exports.tooltip = tooltip;
	exports.Icon = Icon;
	exports.icon = icon;
	exports.DivIcon = DivIcon;
	exports.divIcon = divIcon;
	exports.Marker = Marker;
	exports.marker = marker;
	exports.TileLayer = TileLayer;
	exports.tileLayer = tileLayer;
	exports.GridLayer = GridLayer;
	exports.gridLayer = gridLayer;
	exports.SVG = SVG;
	exports.svg = svg$1;
	exports.Renderer = Renderer;
	exports.Canvas = Canvas;
	exports.canvas = canvas$1;
	exports.Path = Path;
	exports.CircleMarker = CircleMarker;
	exports.circleMarker = circleMarker;
	exports.Circle = Circle;
	exports.circle = circle;
	exports.Polyline = Polyline;
	exports.polyline = polyline;
	exports.Polygon = Polygon;
	exports.polygon = polygon;
	exports.Rectangle = Rectangle;
	exports.rectangle = rectangle;
	exports.Map = Map;
	exports.map = createMap;
	
	})));
	//# sourceMappingURL=leaflet-src.js.map


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(630), __esModule: true };

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(619);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(621);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(618);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(250);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(250);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.throttle = exports.debounce = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.onPageEditing = onPageEditing;
	exports.filterAttributes = filterAttributes;
	exports.isTouchDevice = isTouchDevice;
	exports.capitalizeFirstLetter = capitalizeFirstLetter;
	exports.scrollTo = scrollTo;
	exports.scrollIntoView = scrollIntoView;
	exports.groupBy = groupBy;
	exports.projectIsActive = projectIsActive;
	exports.markerIcon = markerIcon;
	exports.presentDomain = presentDomain;
	exports.isAndroidBrowser = isAndroidBrowser;
	exports.addLogoToPrintProjects = addLogoToPrintProjects;
	exports.GTMTrackingForEpiFormsHandler = GTMTrackingForEpiFormsHandler;
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function onPageEditing(property) {
	    var _ref;
	
	    // TODO: Not ready for primetime
	    //if((typeof window !== 'undefined' && window.EPiEditMode) || (typeof global !== 'undefined' && global.EPiEditMode)) {
	    //}
	
	    if (!property) return null;
	
	    return _ref = {}, _defineProperty(_ref, "data-epi-property-name", property), _defineProperty(_ref, "data-epi-use-mvc", "True"), _ref;
	}
	
	function filterAttributes(props, match) {
	    var newProps = {};
	
	    Object.keys(props).map(function (prop) {
	        if (prop.match(match) && props[prop]) {
	            newProps[prop] = props[prop];
	        }
	    });
	
	    return newProps;
	}
	
	function isTouchDevice() {
	    if (typeof document !== 'undefined') {
	        return 'ontouchstart' in document.documentElement;
	    }
	
	    return false;
	}
	
	// https://stackoverflow.com/a/1026087
	function capitalizeFirstLetter(string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	function getElementY(query) {
	    return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top;
	}
	
	function scrollTo(element, duration) {
	    var startingY = window.pageYOffset;
	    var elementY = getElementY(element);
	    // If element is close to page's bottom then window will scroll only to some position above the element.
	    var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
	    var diff = targetY - startingY;
	    // Easing function: easeInOutCubic
	    // From: https://gist.github.com/gre/1650294
	    var easing = function easing(t) {
	        return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
	    };
	    var start;
	
	    if (!diff) return;
	
	    // Bootstrap our animation - it will get called right before next frame shall be rendered.
	    window.requestAnimationFrame(function step(timestamp) {
	        if (!start) start = timestamp;
	        // Elapsed miliseconds since start of scrolling.
	        var time = timestamp - start;
	        // Get percent of completion in range [0, 1].
	        var percent = Math.min(time / duration, 1);
	        // Apply the easing.
	        // It can cause bad-looking slow frames in browser performance tool, so be careful.
	        percent = easing(percent);
	
	        window.scrollTo(0, startingY + diff * percent);
	
	        // Proceed with animation as long as we wanted it to.
	        if (time < duration) {
	            window.requestAnimationFrame(step);
	        }
	    });
	}
	
	function scrollIntoView(target, element, duration, callback) {
	    var axisY = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	    var params = {
	        current: 'scrollTop',
	        offset: 'offsetTop'
	    };
	    if (!axisY) {
	        params = {
	            current: 'scrollLeft',
	            offset: 'offsetLeft'
	        };
	    }
	    if (!element) {
	        console.error("no element?");
	        return false;
	    }
	    var startingAxis = target[params.current];
	    var targetAxis = element[params.offset];
	    var diff = targetAxis - startingAxis;
	    // Easing function: easeInOutCubic
	    // From: https://gist.github.com/gre/1650294
	    var easing = function easing(t) {
	        return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
	    };
	    var start;
	
	    if (!diff) return false;
	    // Bootstrap our animation - it will get called right before next frame shall be rendered.
	    window.__scrollIntoViewID = window.requestAnimationFrame(function step(timestamp) {
	        if (!start) start = timestamp;
	        // Elapsed miliseconds since start of scrolling.
	        var time = timestamp - start;
	        // Get percent of completion in range [0, 1].
	        var percent = Math.min(time / duration, 1);
	        // Apply the easing.
	        // It can cause bad-looking slow frames in browser performance tool, so be careful.
	        percent = easing(percent);
	
	        if (axisY) target.scrollTo(0, startingAxis + diff * percent);else target.scrollTo(startingAxis + diff * percent, target.scrollTop); // default to current scrollTop
	
	        // Proceed with animation as long as we wanted it to.
	        if (time < duration) {
	            window.__scrollIntoViewID = window.requestAnimationFrame(step);
	        } else {
	            if (typeof callback === "function") {
	                callback();
	            }
	        }
	    });
	    return true;
	}
	
	var debounce = exports.debounce = function debounce(callback, wait) {
	    var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	    var timeout = null;
	    var callbackArgs = null;
	
	    var later = function later() {
	        callback.apply(context, callbackArgs);
	    };
	
	    return function () {
	        callbackArgs = arguments;
	        clearTimeout(timeout);
	        timeout = setTimeout(later, wait);
	    };
	};
	
	var throttle = exports.throttle = function throttle(callback, wait) {
	    var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	    var timeout = null;
	    var callbackArgs = null;
	
	    var later = function later() {
	        callback.apply(context, callbackArgs);
	        timeout = setTimeout(function () {
	            timeout = null;
	        }, wait);
	    };
	
	    return function () {
	        if (!timeout) {
	            callbackArgs = arguments;
	            later();
	        }
	    };
	};
	
	function groupBy(array, f, sourceArray) {
	    var groups = {};
	    array.forEach(function (o) {
	        var group = f(o);
	        // elements without groups
	        if (group === null) {
	            var groupName = "item_" + o.key;
	            groups[groupName] = _extends({}, o);
	            return;
	        }
	        // add object to each group they're a member of
	        group.forEach(function (i) {
	            var source = sourceArray.filter(function (s) {
	                return i.toString() === s.key.toString();
	            })[0];
	            var groupName = "group_" + i;
	            groups[groupName] = groups[groupName] || _extends({}, source, { items: [] });
	            // clone company into group
	            groups[groupName].items.push(_extends({}, o));
	        });
	    });
	
	    return Object.keys(groups).map(function (group) {
	        return groups[group];
	    });
	}
	
	function projectIsActive(project) {
	    var now = Date.now();
	    var projectStart = project.projectStart,
	        projectEnd = project.projectEnd;
	
	    return now > Date.parse(projectStart) && now < Date.parse(projectEnd);
	}
	
	function markerIcon(project) {
	    var _cn;
	
	    var emphasize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Marker";
	
	    var active = project && projectIsActive(project);
	
	    var alt = project ? project.title : title;
	
	    return __webpack_require__(8).divIcon({
	        className: (0, _classnames2.default)((_cn = {}, _defineProperty(_cn, "map-marker", !emphasize), _defineProperty(_cn, "map-marker-active", active), _cn)),
	        iconAnchor: emphasize ? [24, 56] : [9, 9],
	        iconSize: emphasize ? [48, 56] : [18, 18],
	        popupAnchor: emphasize ? [24, 0] : [0, -27],
	        html: emphasize ? "<div><img alt=\"" + alt + "\" src=\"" + __webpack_require__(154) + "\" /></div>" : "<div></div>"
	    });
	}
	
	function presentDomain(domain) {
	    if (typeof domain !== 'string') return domain;
	
	    domain = domain.replace("http://", "");
	    domain = domain.replace("https://", "");
	    domain = domain.replace("www.", "");
	    domain = domain.split("/");
	
	    return domain[0];
	}
	
	function isAndroidBrowser() {
	    if (typeof navigator === "undefined" || !navigator.userAgent) return false;
	
	    var _navigator = navigator,
	        userAgent = _navigator.userAgent;
	
	
	    if (userAgent.indexOf('Android') === -1) return false;
	    if (userAgent.indexOf('SamsungBrowser') > -1) return true;
	
	    var chromeRegex = /Chrome\/([\d]+)/;
	    var chromeVersion = chromeRegex.exec(userAgent);
	    if (chromeVersion && chromeVersion[1] < 58) return true;
	
	    return false;
	}
	
	function addLogoToPrintProjects() {
	    var projects = document.querySelectorAll('.project.print');
	    for (var i = 0; i < projects.length; i++) {
	        var image = new Image(50, 50);
	        image.src = __webpack_require__(83);
	        image.style = "width: 50px; height: 50px; margin: 0 0 .5cm; display: block;";
	        projects[i].insertBefore(image, projects[i].firstChild);
	    }
	}
	
	function GTMTrackingForEpiFormsHandler() {
	    var formDataValues = getFormDataValues();
	    if (formDataValues && typeof $$epiforms !== 'undefined') {
	        $$epiforms(document).ready(function handleFormEvents() {
	            $$epiforms(".EPiServerForms").on("formsSubmitted", function (event) {
	                handleFormSubmitted(event, formDataValues);
	            });
	        });
	    }
	}
	
	function getFormDataValues() {
	    var formDataValues = [];
	
	    var hiddenElements = getGTMTrackingHiddenElements();
	
	    if (hiddenElements) {
	        for (var i = 0; i < hiddenElements.length; i++) {
	            var input = hiddenElements[i];
	            if (input) {
	
	                var formGuid = input.form.id;
	
	                for (var j = 0; j < formDataValues.length; j++) {
	                    if (formDataValues[j].formGuid === formGuid) {
	                        continue;
	                    }
	                }
	
	                formDataValues.push({
	                    formGuid: formGuid
	                });
	            }
	        }
	    }
	
	    return formDataValues;
	}
	
	function getGTMTrackingHiddenElements() {
	    var fieldType = 'GTMTrackingForEpiFormsField';
	    var matchingElements = [];
	
	    var allElements = document.getElementsByName(fieldType);
	    for (var i = 0, n = allElements.length; i < n; i++) {
	        matchingElements.push(allElements[i]);
	    }
	    return matchingElements;
	}
	
	function handleFormSubmitted(event, formDataValues) {
	    if (event.isFinalizedSubmission && event.isSuccess && formDataValues) {
	
	        for (var i = 0; i < formDataValues.length; i++) {
	            if (formDataValues[i] && formDataValues[i].formGuid === event.delegateTarget.id) {
	
	                var formName = event.workingFormInfo.Name;
	
	                window.dataLayer = window.dataLayer || [];
	
	                var data = {
	                    'event': 'form_submit',
	                    'form_name': formName
	                };
	
	                window.dataLayer.push(data);
	
	                formDataValues.pop(formDataValues[i]);
	
	                break;
	            }
	        }
	    }
	}
	
	function checkUserType() {
	    if (typeof document !== 'undefined') {
	        var touchEndHappened = false;
	
	        if (!('classList' in document.documentElement) && Object.defineProperty && typeof HTMLElement !== 'undefined') {
	            Object.defineProperty(HTMLElement.prototype, 'classList', {
	                get: function get() {
	                    var self = this;
	                    function update(fn) {
	                        return function (value) {
	                            var classes = self.className.split(/\s+/),
	                                index = classes.indexOf(value);
	
	                            fn(classes, index, value);
	                            self.className = classes.join(' ');
	                        };
	                    }
	
	                    var ret = {
	                        add: update(function (classes, index, value) {
	                            ~index || classes.push(value);
	                        }),
	
	                        remove: update(function (classes, index) {
	                            ~index && classes.splice(index, 1);
	                        }),
	
	                        toggle: update(function (classes, index, value) {
	                            ~index ? classes.splice(index, 1) : classes.push(value);
	                        }),
	
	                        contains: function contains(value) {
	                            return !!~self.className.split(/\s+/).indexOf(value);
	                        },
	
	                        item: function item(i) {
	                            return self.className.split(/\s+/)[i] || null;
	                        }
	                    };
	
	                    Object.defineProperty(ret, 'length', {
	                        get: function get() {
	                            return self.className.split(/\s+/).length;
	                        }
	                    });
	
	                    return ret;
	                }
	            });
	        }
	
	        var onMouseDown = function onMouseDown() {
	            if (touchEndHappened) {
	                return;
	            }
	
	            document.documentElement.classList.add('mouse-user');
	            document.documentElement.classList.add('no-touchevents');
	            document.documentElement.classList.remove('touchevents');
	        };
	
	        var onTouchEnd = function onTouchEnd() {
	            touchEndHappened = true;
	            setTimeout(function () {
	                touchEndHappened = false;
	            }, 100);
	        };
	
	        var onTouchStart = function onTouchStart() {
	            document.documentElement.classList.add('mouse-user');
	            document.documentElement.classList.add('touchevents');
	            document.documentElement.classList.remove('no-touchevents');
	        };
	
	        document.addEventListener('touchstart', onTouchStart);
	        document.addEventListener('touchend', onTouchEnd);
	        document.addEventListener('mousedown', onMouseDown);
	
	        var keyCodeWhiteList = [9, 33, 34, 35, 36, 37, 38, 39, 40];
	
	        document.addEventListener('keydown', function (e) {
	            if (keyCodeWhiteList.indexOf(e.which) !== -1) {
	                document.documentElement.classList.remove('mouse-user');
	            }
	        });
	    }
	}
	
	checkUserType();

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMProperty = __webpack_require__(72);
	var ReactDOMComponentFlags = __webpack_require__(306);
	
	var invariant = __webpack_require__(4);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]);

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OnPageEditing = exports.default = undefined;
	
	var _OnPageEditing2 = __webpack_require__(543);
	
	var _OnPageEditing3 = _interopRequireDefault(_OnPageEditing2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _OnPageEditing3.default;
	exports.OnPageEditing = _OnPageEditing3.default;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var THEMES = {
	    zebra: 0,
	    yellow: 1,
	    darkgray: 2,
	    illustration: 3,
	    lightgray: 4,
	    white: 5,
	    zebraBlue: 6
	};
	
	module.exports.default = module.exports.THEMES = THEMES;
	
	module.exports.getThemeClassNames = function (css, theme) {
	    var classNames = {};
	    Object.keys(THEMES).map(function (s) {
	        if (css[s]) {
	            classNames = _extends({}, classNames, _defineProperty({}, css[s], theme === THEMES[s]));
	        }
	    });
	    return classNames;
	};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var ReactCurrentOwner = __webpack_require__(29);
	
	var warning = __webpack_require__(6);
	var canDefineProperty = __webpack_require__(97);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(95);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Link = {};
	
	Link.propTypes = {
	    url: _propTypes2.default.string,
	    linkText: _propTypes2.default.string,
	    openInNewWindow: _propTypes2.default.bool
	};
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FluidImage = exports.default = undefined;
	
	var _FluidImage2 = __webpack_require__(461);
	
	var _FluidImage3 = _interopRequireDefault(_FluidImage2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FluidImage3.default;
	exports.FluidImage = _FluidImage3.default;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _OnScreen = __webpack_require__(544);
	
	var _OnScreen2 = _interopRequireDefault(_OnScreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _OnScreen2.default;
	module.exports = exports["default"];

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__(620);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
	
	  if (desc === undefined) {
	    var parent = (0, _getPrototypeOf2.default)(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(282);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(15);
	
	var CallbackQueue = __webpack_require__(304);
	var PooledClass = __webpack_require__(55);
	var ReactFeatureFlags = __webpack_require__(312);
	var ReactReconciler = __webpack_require__(56);
	var Transaction = __webpack_require__(112);
	
	var invariant = __webpack_require__(4);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.0' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 37 */
9,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Media = undefined;
	
	var _Media = __webpack_require__(533);
	
	Object.defineProperty(exports, 'Media', {
	  enumerable: true,
	  get: function get() {
	    return _Media.Media;
	  }
	});
	
	var _Media2 = _interopRequireDefault(_Media);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Media2.default;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var PooledClass = __webpack_require__(55);
	
	var emptyFunction = __webpack_require__(19);
	var warning = __webpack_require__(6);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var ReactBaseClasses = __webpack_require__(94);
	var ReactChildren = __webpack_require__(204);
	var ReactDOMFactories = __webpack_require__(205);
	var ReactElement = __webpack_require__(24);
	var ReactPropTypes = __webpack_require__(206);
	var ReactVersion = __webpack_require__(207);
	
	var createReactClass = __webpack_require__(208);
	var onlyChild = __webpack_require__(211);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(255);
	var defined = __webpack_require__(136);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(32);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _pick2 = __webpack_require__(951);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _isEqual2 = __webpack_require__(296);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _MapLayer2 = __webpack_require__(57);
	
	var _MapLayer3 = _interopRequireDefault(_MapLayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OPTIONS = ['stroke', 'color', 'weight', 'opacity', 'fill', 'fillColor', 'fillOpacity', 'fillRule', 'dashArray', 'lineCap', 'lineJoin', 'clickable', 'pointerEvents', 'className'];
	
	var Path = function (_MapLayer) {
	  (0, _inherits3.default)(Path, _MapLayer);
	
	  function Path() {
	    (0, _classCallCheck3.default)(this, Path);
	    return (0, _possibleConstructorReturn3.default)(this, (Path.__proto__ || (0, _getPrototypeOf2.default)(Path)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Path, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      (0, _get3.default)(Path.prototype.__proto__ || (0, _getPrototypeOf2.default)(Path.prototype), 'componentDidUpdate', this).call(this, prevProps);
	      this.setStyleIfChanged(prevProps, this.props);
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popupContainer: this.leafletElement
	      };
	    }
	  }, {
	    key: 'getPathOptions',
	    value: function getPathOptions(props) {
	      return (0, _pick3.default)(props, OPTIONS);
	    }
	  }, {
	    key: 'setStyle',
	    value: function setStyle() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      this.leafletElement.setStyle(options);
	    }
	  }, {
	    key: 'setStyleIfChanged',
	    value: function setStyleIfChanged(fromProps, toProps) {
	      var nextStyle = this.getPathOptions(toProps);
	      if (!(0, _isEqual3.default)(nextStyle, this.getPathOptions(fromProps))) {
	        this.setStyle(nextStyle);
	      }
	    }
	  }]);
	  return Path;
	}(_MapLayer3.default);
	
	Path.childContextTypes = {
	  children: _children2.default,
	  popupContainer: _propTypes2.default.object
	};
	exports.default = Path;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.oneOfType([
	// [number, number]
	_propTypes2.default.arrayOf(_propTypes2.default.number),
	// {lat: number, lng: number}
	_propTypes2.default.shape({
	  lat: _propTypes2.default.number,
	  lng: _propTypes2.default.number
	}),
	// {lat: number, lon: number}
	_propTypes2.default.shape({
	  lat: _propTypes2.default.number,
	  lon: _propTypes2.default.number
	})]);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.instanceOf(_leaflet.Map);

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkButton = {};
	
	LinkButton.propTypes = {
	    url: _propTypes2.default.string,
	    text: _propTypes2.default.string,
	    target: _propTypes2.default.oneOf(["_blank"]),
	    isActive: _propTypes2.default.bool
	};
	
	exports.default = LinkButton;
	module.exports = exports["default"];

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(61)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(41);
	var core = __webpack_require__(35);
	var ctx = __webpack_require__(252);
	var hide = __webpack_require__(62);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(80);
	var IE8_DOM_DEFINE = __webpack_require__(254);
	var toPrimitive = __webpack_require__(148);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(48) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(864),
	    getValue = __webpack_require__(903);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36),
	    now = __webpack_require__(950),
	    toNumber = __webpack_require__(955);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(975);


/***/ }),
/* 55 */
[1291, 9],
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(995);
	var ReactInstrumentation = __webpack_require__(28);
	
	var warning = __webpack_require__(6);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(32);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _layerContainer = __webpack_require__(74);
	
	var _layerContainer2 = _interopRequireDefault(_layerContainer);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _MapComponent2 = __webpack_require__(91);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapLayer = function (_MapComponent) {
	  (0, _inherits3.default)(MapLayer, _MapComponent);
	
	  function MapLayer() {
	    (0, _classCallCheck3.default)(this, MapLayer);
	    return (0, _possibleConstructorReturn3.default)(this, (MapLayer.__proto__ || (0, _getPrototypeOf2.default)(MapLayer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MapLayer, [{
	    key: 'createLeafletElement',
	
	
	    // eslint-disable-next-line no-unused-vars
	    value: function createLeafletElement(props) {
	      throw new Error('createLeafletElement() must be implemented');
	    }
	
	    // eslint-disable-next-line no-unused-vars
	
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {}
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      (0, _get3.default)(MapLayer.prototype.__proto__ || (0, _getPrototypeOf2.default)(MapLayer.prototype), 'componentWillMount', this).call(this);
	      this.leafletElement = this.createLeafletElement(this.props);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get3.default)(MapLayer.prototype.__proto__ || (0, _getPrototypeOf2.default)(MapLayer.prototype), 'componentDidMount', this).call(this);
	      this.layerContainer.addLayer(this.leafletElement);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.updateLeafletElement(prevProps, this.props);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _get3.default)(MapLayer.prototype.__proto__ || (0, _getPrototypeOf2.default)(MapLayer.prototype), 'componentWillUnmount', this).call(this);
	      this.layerContainer.removeLayer(this.leafletElement);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return Array.isArray(this.props.children) ? _react2.default.createElement(
	        'div',
	        { style: { display: 'none' } },
	        this.props.children
	      ) : this.props.children || null;
	    }
	  }, {
	    key: 'layerContainer',
	    get: function get() {
	      return this.context.layerContainer || this.context.map;
	    }
	  }]);
	  return MapLayer;
	}(_MapComponent3.default);
	
	MapLayer.propTypes = {
	  children: _children2.default
	};
	MapLayer.contextTypes = {
	  layerContainer: _layerContainer2.default,
	  map: _map2.default,
	  pane: _propTypes2.default.string
	};
	exports.default = MapLayer;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DropdownFilter = __webpack_require__(432);
	
	var _DropdownFilter2 = _interopRequireDefault(_DropdownFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DropdownFilter2.default;
	module.exports = exports['default'];

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _ImageIcon = __webpack_require__(486);
	
	var _ImageIcon2 = _interopRequireDefault(_ImageIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ImageIcon2.default;
	module.exports = exports['default'];

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _InvestorLinkButton = __webpack_require__(124);
	
	var _InvestorLinkButton2 = _interopRequireDefault(_InvestorLinkButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InvestorLinkButton2.default;
	module.exports = exports['default'];

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(51);
	var createDesc = __webpack_require__(101);
	module.exports = __webpack_require__(48) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(145)('wks');
	var uid = __webpack_require__(102);
	var Symbol = __webpack_require__(41).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(33);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(64),
	    getRawTag = __webpack_require__(902),
	    objectToString = __webpack_require__(930);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(27),
	    isKey = __webpack_require__(166),
	    stringToPath = __webpack_require__(942),
	    toString = __webpack_require__(301);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(108);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(273),
	    baseKeys = __webpack_require__(867),
	    isArrayLike = __webpack_require__(171);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(53),
	    isObject = __webpack_require__(36);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(181);
	var setInnerHTML = __webpack_require__(114);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(189);
	var setTextContent = __webpack_require__(327);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.oneOf(['topleft', 'topright', 'bottomleft', 'bottomright']);

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.shape({
	  addLayer: _propTypes2.default.func.isRequired,
	  removeLayer: _propTypes2.default.func.isRequired
	});

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _utils = __webpack_require__(16);
	
	__webpack_require__(694);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Button = function Button(_ref) {
	    var _cn;
	
	    var children = _ref.children,
	        className = _ref.className,
	        disabled = _ref.disabled,
	        href = _ref.href,
	        white = _ref.white,
	        primary = _ref.primary,
	        secondary = _ref.secondary,
	        tertiary = _ref.tertiary,
	        flat = _ref.flat,
	        light = _ref.light,
	        target = _ref.target,
	        icon = _ref.icon,
	        title = _ref.title,
	        onClick = _ref.onClick,
	        type = _ref.type,
	        gray = _ref.gray,
	        yellow = _ref.yellow,
	        blue = _ref.blue,
	        block = _ref.block,
	        download = _ref.download,
	        compact = _ref.compact,
	        _ref$isActive = _ref.isActive,
	        isActive = _ref$isActive === undefined ? false : _ref$isActive,
	        props = _objectWithoutProperties(_ref, ['children', 'className', 'disabled', 'href', 'white', 'primary', 'secondary', 'tertiary', 'flat', 'light', 'target', 'icon', 'title', 'onClick', 'type', 'gray', 'yellow', 'blue', 'block', 'download', 'compact', 'isActive']);
	
	    var classNames = (0, _classnames2.default)('btn', className, (_cn = {}, _defineProperty(_cn, 'white', white), _defineProperty(_cn, 'primary', primary), _defineProperty(_cn, 'secondary', secondary), _defineProperty(_cn, 'tertiary', tertiary), _defineProperty(_cn, 'light', light), _defineProperty(_cn, 'icon', icon), _defineProperty(_cn, 'hasText', !!children), _defineProperty(_cn, 'flat', flat), _defineProperty(_cn, 'gray', gray), _defineProperty(_cn, 'yellow', yellow), _defineProperty(_cn, 'blue-bg', blue), _defineProperty(_cn, 'block', block), _defineProperty(_cn, 'compact', compact), _defineProperty(_cn, 'active', isActive), _cn));
	
	    var Component = href ? "a" : "button";
	
	    return _react2.default.createElement(
	        Component,
	        _extends({
	            className: classNames,
	            disabled: disabled,
	            href: href,
	            onClick: onClick,
	            target: target,
	            title: title,
	            type: type,
	            download: download,
	            rel: target && target === "_blank" ? "noopener noreferrer" : null
	        }, (0, _utils.filterAttributes)(props, /^data-/)),
	        icon && _react2.default.createElement(_Icon2.default, { icon: icon }),
	        _react2.default.createElement(
	            'span',
	            { className: 'btn-text' },
	            children
	        )
	    );
	};
	
	Button.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    href: _propTypes2.default.string,
	    white: _propTypes2.default.bool,
	    primary: _propTypes2.default.bool,
	    secondary: _propTypes2.default.bool,
	    tertiary: _propTypes2.default.bool,
	    light: _propTypes2.default.bool,
	    flat: _propTypes2.default.bool,
	    target: _propTypes2.default.string,
	    icon: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    onClick: _propTypes2.default.func,
	    type: _propTypes2.default.string,
	    gray: _propTypes2.default.bool,
	    yellow: _propTypes2.default.bool,
	    blue: _propTypes2.default.bool,
	    block: _propTypes2.default.bool,
	    download: _propTypes2.default.bool,
	    compact: _propTypes2.default.bool,
	    isActive: _propTypes2.default.bool
	};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Map = exports.default = undefined;
	
	var _Map2 = __webpack_require__(529);
	
	var _Map3 = _interopRequireDefault(_Map2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Map3.default;
	exports.Map = _Map3.default;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Image = {};
	
	Image.propTypes = {
	    url: _propTypes2.default.string,
	    altText: _propTypes2.default.string
	};
	
	exports.default = Image;
	module.exports = exports['default'];

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _ProjectCard = __webpack_require__(552);
	
	var _ProjectCard2 = _interopRequireDefault(_ProjectCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProjectCard2.default;
	module.exports = exports['default'];

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(617);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(81);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(259);
	var enumBugKeys = __webpack_require__(137);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	module.exports = "/Public/build/3a080c940926767980a7f93a94febb55.svg";

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(160),
	    baseAssignValue = __webpack_require__(275);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var EventPluginRegistry = __webpack_require__(182);
	var EventPluginUtils = __webpack_require__(183);
	var ReactErrorUtils = __webpack_require__(187);
	
	var accumulateInto = __webpack_require__(321);
	var forEachAccumulated = __webpack_require__(322);
	var invariant = __webpack_require__(4);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(87);
	var EventPluginUtils = __webpack_require__(183);
	
	var accumulateInto = __webpack_require__(321);
	var forEachAccumulated = __webpack_require__(322);
	var warning = __webpack_require__(6);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(39);
	
	var getEventTarget = __webpack_require__(192);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(79);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reduce2 = __webpack_require__(953);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _keys2 = __webpack_require__(69);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _forEach2 = __webpack_require__(293);
	
	var _forEach3 = _interopRequireDefault(_forEach2);
	
	var _clone2 = __webpack_require__(943);
	
	var _clone3 = _interopRequireDefault(_clone2);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EVENTS_RE = /^on(.+)$/i;
	
	var MapComponent = function (_Component) {
	  (0, _inherits3.default)(MapComponent, _Component);
	
	  function MapComponent(props, context) {
	    (0, _classCallCheck3.default)(this, MapComponent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MapComponent.__proto__ || (0, _getPrototypeOf2.default)(MapComponent)).call(this, props, context));
	
	    _this._leafletEvents = {};
	    return _this;
	  }
	
	  (0, _createClass3.default)(MapComponent, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this._leafletEvents = this.extractLeafletEvents(this.props);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.bindLeafletEvents(this._leafletEvents);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var next = this.extractLeafletEvents(nextProps);
	      this._leafletEvents = this.bindLeafletEvents(next, this._leafletEvents);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var el = this.leafletElement;
	      if (!el) return;
	
	      (0, _forEach3.default)(this._leafletEvents, function (cb, ev) {
	        el.off(ev, cb);
	      });
	    }
	  }, {
	    key: 'extractLeafletEvents',
	    value: function extractLeafletEvents(props) {
	      return (0, _reduce3.default)((0, _keys3.default)(props), function (res, prop) {
	        if (EVENTS_RE.test(prop)) {
	          var _key = prop.replace(EVENTS_RE, function (match, p) {
	            return p.toLowerCase();
	          });
	          if (props[prop]) {
	            res[_key] = props[prop];
	          }
	        }
	        return res;
	      }, {});
	    }
	  }, {
	    key: 'bindLeafletEvents',
	    value: function bindLeafletEvents() {
	      var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var prev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var el = this.leafletElement;
	      if (!el || !el.on) return {};
	
	      var diff = (0, _clone3.default)(prev);
	      (0, _forEach3.default)(prev, function (cb, ev) {
	        if (!next[ev] || cb !== next[ev]) {
	          delete diff[ev];
	          el.off(ev, cb);
	        }
	      });
	
	      (0, _forEach3.default)(next, function (cb, ev) {
	        if (!prev[ev] || cb !== prev[ev]) {
	          diff[ev] = cb;
	          el.on(ev, cb);
	        }
	      });
	
	      return diff;
	    }
	  }, {
	    key: 'fireLeafletEvent',
	    value: function fireLeafletEvent(type, data) {
	      var el = this.leafletElement;
	      if (el) el.fire(type, data);
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var pane = props.pane || this.context.pane;
	      return pane ? (0, _extends3.default)({}, props, { pane: pane }) : props;
	    }
	  }]);
	  return MapComponent;
	}(_react.Component);
	
	exports.default = MapComponent;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _controlPosition = __webpack_require__(73);
	
	var _controlPosition2 = _interopRequireDefault(_controlPosition);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapControl = function (_Component) {
	  (0, _inherits3.default)(MapControl, _Component);
	
	  function MapControl() {
	    (0, _classCallCheck3.default)(this, MapControl);
	    return (0, _possibleConstructorReturn3.default)(this, (MapControl.__proto__ || (0, _getPrototypeOf2.default)(MapControl)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MapControl, [{
	    key: 'createLeafletElement',
	
	
	    // eslint-disable-next-line no-unused-vars
	    value: function createLeafletElement(props) {
	      throw new Error('createLeafletElement() must be implemented');
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.position !== fromProps.position) {
	        this.leafletElement.setPosition(toProps.position);
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.leafletElement = this.createLeafletElement(this.props);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.leafletElement.addTo(this.context.map);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.updateLeafletElement(prevProps, this.props);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.leafletElement.remove();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return MapControl;
	}(_react.Component);
	
	MapControl.propTypes = {
	  position: _controlPosition2.default
	};
	MapControl.contextTypes = {
	  map: _map2.default
	};
	exports.default = MapControl;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _latlngList = __webpack_require__(116);
	
	var _latlngList2 = _interopRequireDefault(_latlngList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_leaflet.LatLngBounds), _latlngList2.default]);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37),
	    _assign = __webpack_require__(15);
	
	var ReactNoopUpdateQueue = __webpack_require__(96);
	
	var canDefineProperty = __webpack_require__(97);
	var emptyObject = __webpack_require__(43);
	var invariant = __webpack_require__(4);
	var lowPriorityWarning = __webpack_require__(210);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(6);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _ContactBlock = __webpack_require__(408);
	
	var _ContactBlock2 = _interopRequireDefault(_ContactBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ContactBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.track = track;
	function track(event, event_name) {
	    if (!window.dataLayer) {
	        return console.error('window.dataLayer is undefined - Is GTM enabled?');
	    }
	
	    try {
	        if (window.dataLayer && Array.isArray(window.dataLayer)) {
	
	            if (typeof event_name === 'string') {
	                window.dataLayer.push({
	                    event: event,
	                    event_name: event_name
	                });
	            } else if ((typeof event_name === 'undefined' ? 'undefined' : _typeof(event_name)) === 'object') {
	                window.dataLayer.push(_extends({
	                    event: event
	                }, event_name));
	            }
	        }
	
	        if (window.location.hostname === 'localhost') {
	            console.info(window.dataLayer);
	        }
	    } catch (e) {
	        console.error('Tracking error', e);
	    }
	}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(916),
	    listCacheDelete = __webpack_require__(917),
	    listCacheGet = __webpack_require__(918),
	    listCacheHas = __webpack_require__(919),
	    listCacheSet = __webpack_require__(920);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(168);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(66),
	    toKey = __webpack_require__(67);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(914);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(52);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(65),
	    isObjectLike = __webpack_require__(68);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(178);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var EventPluginRegistry = __webpack_require__(182);
	var ReactEventEmitterMixin = __webpack_require__(988);
	var ViewportMetrics = __webpack_require__(320);
	
	var getVendorPrefixedEventName = __webpack_require__(1019);
	var isEventSupported = __webpack_require__(194);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(90);
	var ViewportMetrics = __webpack_require__(320);
	
	var getEventModifierState = __webpack_require__(191);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(23);
	var DOMNamespaces = __webpack_require__(181);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(189);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ZoomControl = exports.WMSTileLayer = exports.VideoOverlay = exports.Tooltip = exports.TileLayer = exports.ScaleControl = exports.Rectangle = exports.Popup = exports.Polyline = exports.Polygon = exports.Path = exports.Pane = exports.Marker = exports.MapLayer = exports.MapControl = exports.MapComponent = exports.Map = exports.LayersControl = exports.LayerGroup = exports.ImageOverlay = exports.GridLayer = exports.GeoJSON = exports.FeatureGroup = exports.CircleMarker = exports.Circle = exports.AttributionControl = exports.PropTypes = undefined;
	
	var _propTypes = __webpack_require__(1045);
	
	var _PropTypes = _interopRequireWildcard(_propTypes);
	
	var _AttributionControl2 = __webpack_require__(1024);
	
	var _AttributionControl3 = _interopRequireDefault(_AttributionControl2);
	
	var _Circle2 = __webpack_require__(1025);
	
	var _Circle3 = _interopRequireDefault(_Circle2);
	
	var _CircleMarker2 = __webpack_require__(1026);
	
	var _CircleMarker3 = _interopRequireDefault(_CircleMarker2);
	
	var _FeatureGroup2 = __webpack_require__(1027);
	
	var _FeatureGroup3 = _interopRequireDefault(_FeatureGroup2);
	
	var _GeoJSON2 = __webpack_require__(1028);
	
	var _GeoJSON3 = _interopRequireDefault(_GeoJSON2);
	
	var _GridLayer2 = __webpack_require__(198);
	
	var _GridLayer3 = _interopRequireDefault(_GridLayer2);
	
	var _ImageOverlay2 = __webpack_require__(1029);
	
	var _ImageOverlay3 = _interopRequireDefault(_ImageOverlay2);
	
	var _LayerGroup2 = __webpack_require__(1030);
	
	var _LayerGroup3 = _interopRequireDefault(_LayerGroup2);
	
	var _LayersControl2 = __webpack_require__(1031);
	
	var _LayersControl3 = _interopRequireDefault(_LayersControl2);
	
	var _Map2 = __webpack_require__(1032);
	
	var _Map3 = _interopRequireDefault(_Map2);
	
	var _MapComponent2 = __webpack_require__(91);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	var _MapControl2 = __webpack_require__(92);
	
	var _MapControl3 = _interopRequireDefault(_MapControl2);
	
	var _MapLayer2 = __webpack_require__(57);
	
	var _MapLayer3 = _interopRequireDefault(_MapLayer2);
	
	var _Marker2 = __webpack_require__(1033);
	
	var _Marker3 = _interopRequireDefault(_Marker2);
	
	var _Pane2 = __webpack_require__(1034);
	
	var _Pane3 = _interopRequireDefault(_Pane2);
	
	var _Path2 = __webpack_require__(44);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	var _Polygon2 = __webpack_require__(1035);
	
	var _Polygon3 = _interopRequireDefault(_Polygon2);
	
	var _Polyline2 = __webpack_require__(1036);
	
	var _Polyline3 = _interopRequireDefault(_Polyline2);
	
	var _Popup2 = __webpack_require__(1037);
	
	var _Popup3 = _interopRequireDefault(_Popup2);
	
	var _Rectangle2 = __webpack_require__(1038);
	
	var _Rectangle3 = _interopRequireDefault(_Rectangle2);
	
	var _ScaleControl2 = __webpack_require__(1039);
	
	var _ScaleControl3 = _interopRequireDefault(_ScaleControl2);
	
	var _TileLayer2 = __webpack_require__(1040);
	
	var _TileLayer3 = _interopRequireDefault(_TileLayer2);
	
	var _Tooltip2 = __webpack_require__(1041);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _VideoOverlay2 = __webpack_require__(1042);
	
	var _VideoOverlay3 = _interopRequireDefault(_VideoOverlay2);
	
	var _WMSTileLayer2 = __webpack_require__(1043);
	
	var _WMSTileLayer3 = _interopRequireDefault(_WMSTileLayer2);
	
	var _ZoomControl2 = __webpack_require__(1044);
	
	var _ZoomControl3 = _interopRequireDefault(_ZoomControl2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.PropTypes = _PropTypes;
	exports.AttributionControl = _AttributionControl3.default;
	exports.Circle = _Circle3.default;
	exports.CircleMarker = _CircleMarker3.default;
	exports.FeatureGroup = _FeatureGroup3.default;
	exports.GeoJSON = _GeoJSON3.default;
	exports.GridLayer = _GridLayer3.default;
	exports.ImageOverlay = _ImageOverlay3.default;
	exports.LayerGroup = _LayerGroup3.default;
	exports.LayersControl = _LayersControl3.default;
	exports.Map = _Map3.default;
	exports.MapComponent = _MapComponent3.default;
	exports.MapControl = _MapControl3.default;
	exports.MapLayer = _MapLayer3.default;
	exports.Marker = _Marker3.default;
	exports.Pane = _Pane3.default;
	exports.Path = _Path3.default;
	exports.Polygon = _Polygon3.default;
	exports.Polyline = _Polyline3.default;
	exports.Popup = _Popup3.default;
	exports.Rectangle = _Rectangle3.default;
	exports.ScaleControl = _ScaleControl3.default;
	exports.TileLayer = _TileLayer3.default;
	exports.Tooltip = _Tooltip3.default;
	exports.VideoOverlay = _VideoOverlay3.default;
	exports.WMSTileLayer = _WMSTileLayer3.default;
	exports.ZoomControl = _ZoomControl3.default;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _latlng = __webpack_require__(45);
	
	var _latlng2 = _interopRequireDefault(_latlng);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.arrayOf(_latlng2.default);

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(54));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	
	  return onDemandSlides;
	}; // return list of slides that need to be present
	
	
	exports.getOnDemandLazySlides = getOnDemandLazySlides;
	
	var getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	
	  return requiredSlides;
	}; // startIndex that needs to be present
	
	
	exports.getRequiredLazySlides = getRequiredLazySlides;
	
	var lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	
	exports.lazyStartIndex = lazyStartIndex;
	
	var lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	
	exports.lazyEndIndex = lazyEndIndex;
	
	var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	
	exports.lazySlidesOnLeft = lazySlidesOnLeft;
	
	var lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	}; // get width of an element
	
	
	exports.lazySlidesOnRight = lazySlidesOnRight;
	
	var getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	
	exports.getWidth = getWidth;
	
	var getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	
	exports.getHeight = getHeight;
	
	var getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	}; // whether or not we can go next
	
	
	exports.getSwipeDirection = getSwipeDirection;
	
	var canGoNext = function canGoNext(spec) {
	  var canGo = true;
	
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	
	  return canGo;
	}; // given an object and a list of keys, return new object with given keys
	
	
	exports.canGoNext = canGoNext;
	
	var extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	}; // get initialized state
	
	
	exports.extractObject = extractObject;
	
	var initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react.default.Children.count(spec.children);
	
	  var listWidth = Math.ceil(getWidth(_reactDom.default.findDOMNode(spec.listRef)));
	  var trackWidth = Math.ceil(getWidth(_reactDom.default.findDOMNode(spec.trackRef)));
	  var slideWidth;
	
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	
	  var slideHeight = _reactDom.default.findDOMNode(spec.listRef) && getHeight(_reactDom.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides({
	    currentSlide: currentSlide,
	    lazyLoadedList: lazyLoadedList
	  }, spec);
	  lazyLoadedList.concat(slidesToLoad);
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	exports.initializedState = initializedState;
	
	var slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide,
	      animationLeft,
	      finalLeft;
	  var state = {},
	      nextState = {};
	
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList
	    };
	    nextState = {
	      animating: false
	    };
	  } else {
	    finalSlide = animationSlide;
	
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	
	    animationLeft = getTrackLeft(_objectSpread({}, spec, {
	      slideIndex: animationSlide
	    }));
	    finalLeft = getTrackLeft(_objectSpread({}, spec, {
	      slideIndex: finalSlide
	    }));
	
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread({}, spec, {
	      currentSlide: animationSlide
	    })));
	
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread({}, spec, {
	          left: finalLeft
	        })),
	        lazyLoadedList: lazyLoadedList
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_objectSpread({}, spec, {
	          left: animationLeft
	        })),
	        lazyLoadedList: lazyLoadedList
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread({}, spec, {
	          left: finalLeft
	        })),
	        swipeLeft: null
	      };
	    }
	  }
	
	  return {
	    state: state,
	    nextState: nextState
	  };
	};
	
	exports.slideHandler = slideHandler;
	
	var changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	
	    if (infinite) {
	      var direction = siblingDirection(_objectSpread({}, spec, {
	        targetSlide: targetSlide
	      }));
	
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  }
	
	  return targetSlide;
	};
	
	exports.changeSlide = changeSlide;
	
	var keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	exports.keyHandler = keyHandler;
	
	var swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	
	exports.swipeStart = swipeStart;
	
	var swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return {
	      scrolling: true
	    };
	  }
	
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	
	  state = _objectSpread({}, state, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_objectSpread({}, spec, {
	      left: swipeLeft
	    }))
	  });
	
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	
	  return state;
	};
	
	exports.swipeMove = swipeMove;
	
	var swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      currentSlide = spec.currentSlide,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.
	
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	
	  if (scrolling) {
	    return state;
	  }
	
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	
	    var slideCount, newSlide;
	
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = currentSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	
	      case "right":
	      case "down":
	        newSlide = currentSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	
	      default:
	        slideCount = currentSlide;
	    }
	
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_objectSpread({}, spec, {
	      left: currentLeft
	    }));
	  }
	
	  return state;
	};
	
	exports.swipeEnd = swipeEnd;
	
	var getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	
	  return indexes;
	};
	
	exports.getNavigableIndexes = getNavigableIndexes;
	
	var checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	
	      prevNavigable = navigables[n];
	    }
	  }
	
	  return index;
	};
	
	exports.checkNavigable = checkNavigable;
	
	var getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	
	  if (spec.swipeToSlide) {
	    var swipedSlide;
	
	    var slickList = _reactDom.default.findDOMNode(spec.listRef);
	
	    var slides = slickList.querySelectorAll(".slick-slide");
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	exports.getSlideCount = getSlideCount;
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	exports.checkSpecKeys = checkSpecKeys;
	
	var getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _objectSpread({}, style, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	
	  if (spec.fade) style = {
	    opacity: 1
	  };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight; // Fallback for IE8
	
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackCSS = getTrackCSS;
	
	var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined
	
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackAnimateCSS = getTrackAnimateCSS;
	
	var getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    } // shift current slide to center of the frame
	
	
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	
	    var trackElem = _reactDom.default.findDOMNode(trackRef);
	
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	exports.getTrackLeft = getTrackLeft;
	
	var getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	exports.getPreClones = getPreClones;
	
	var getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  return spec.slideCount;
	};
	
	exports.getPostClones = getPostClones;
	
	var getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	
	exports.getTotalSlides = getTotalSlides;
	
	var siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	
	    return "left";
	  }
	};
	
	exports.siblingDirection = siblingDirection;
	
	var slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	
	  if (rtl) {
	    return 0;
	  }
	
	  return slidesToShow - 1;
	};
	
	exports.slidesOnRight = slidesOnRight;
	
	var slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	
	  return 0;
	};
	
	exports.slidesOnLeft = slidesOnLeft;
	
	var canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};
	
	exports.canUseDOM = canUseDOM;

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CuriousBlock = exports.default = undefined;
	
	var _CuriousBlock2 = __webpack_require__(413);
	
	var _CuriousBlock3 = _interopRequireDefault(_CuriousBlock2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CuriousBlock3.default;
	exports.CuriousBlock = _CuriousBlock3.default;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Icon = function Icon(_ref) {
	    var className = _ref.className,
	        icon = _ref.icon,
	        props = _objectWithoutProperties(_ref, ['className', 'icon']);
	
	    return _react2.default.createElement(
	        'svg',
	        _extends({
	            className: className,
	            focusable: 'false'
	        }, (0, _utils.filterAttributes)(props, /^data-/)),
	        _react2.default.createElement('use', { xlinkHref: '#icon-' + icon })
	    );
	};
	
	Icon.propTypes = {
	    className: _propTypes2.default.string,
	    icon: _propTypes2.default.string.isRequired
	};
	
	exports.default = Icon;
	module.exports = exports['default'];

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Image = __webpack_require__(487);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Image2.default;
	module.exports = exports['default'];

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ButtonBase = __webpack_require__(127);
	
	var _ButtonBase2 = _interopRequireDefault(_ButtonBase);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var themes = {
	    ghost: 'ghost',
	    light: 'light'
	};
	
	var InvestorLinkButton = function InvestorLinkButton(_ref) {
	    var _cn;
	
	    var className = _ref.className,
	        _ref$openInNewWindow = _ref.openInNewWindow,
	        openInNewWindow = _ref$openInNewWindow === undefined ? false : _ref$openInNewWindow,
	        url = _ref.url,
	        text = _ref.text,
	        tabindex = _ref.tabindex,
	        iconName = _ref.iconName,
	        rightIconName = _ref.rightIconName,
	        download = _ref.download,
	        _ref$theme = _ref.theme,
	        theme = _ref$theme === undefined ? themes.light : _ref$theme,
	        isActive = _ref.isActive,
	        iconOnlyOnTablet = _ref.iconOnlyOnTablet,
	        onClick = _ref.onClick;
	
	    var RootTag = url ? 'a' : 'button';
	
	    return _react2.default.createElement(
	        RootTag,
	        {
	            href: url,
	            className: (0, _classnames2.default)('investor-link-button', (_cn = {}, _defineProperty(_cn, className, className), _defineProperty(_cn, 'investor-link-button_theme-' + theme, theme), _defineProperty(_cn, 'investor-link-button_active', isActive), _defineProperty(_cn, 'investor-link-button_icon-only-mobile', iconOnlyOnTablet), _cn)),
	            target: openInNewWindow ? '_blank' : null,
	            rel: openInNewWindow ? 'nofollow noopener' : null,
	            tabIndex: tabindex,
	            download: download,
	            onClick: onClick
	        },
	        iconName && _react2.default.createElement(_Icon2.default, { icon: iconName, className: 'investor-link-button__icon' }),
	        _react2.default.createElement(
	            'span',
	            {
	                className: (0, _classnames2.default)("investor-link-button__text", {
	                    "hidden-mobile-and-tablet": iconOnlyOnTablet
	                })
	            },
	            text
	        ),
	        rightIconName && _react2.default.createElement(_Icon2.default, { icon: rightIconName, className: 'investor-link-button__icon investor-link-button__icon_right' })
	    );
	};
	
	InvestorLinkButton.propTypes = Object.assign({}, _ButtonBase2.default.propTypes, {
	    download: _propTypes2.default.bool,
	    className: _propTypes2.default.string,
	    iconName: _propTypes2.default.string,
	    theme: _propTypes2.default.oneOf(Object.values(themes)),
	    rightIconName: _propTypes2.default.string,
	    isActive: _propTypes2.default.bool,
	    iconOnlyOnTablet: _propTypes2.default.bool,
	    onClick: _propTypes2.default.func
	});
	
	exports.default = InvestorLinkButton;
	module.exports = exports['default'];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _InvestorLink = __webpack_require__(504);
	
	var _InvestorLink2 = _interopRequireDefault(_InvestorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InvestorLink2.default;
	module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _MediaWrapper = __webpack_require__(532);
	
	var _MediaWrapper2 = _interopRequireDefault(_MediaWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MediaWrapper2.default;
	module.exports = exports["default"];

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonBase = {};
	
	ButtonBase.propTypes = {
	    url: _propTypes2.default.string,
	    text: _propTypes2.default.string,
	    tabindex: _propTypes2.default.number,
	    openInNewWindow: _propTypes2.default.bool,
	    onClick: _propTypes2.default.func
	};
	
	exports.default = ButtonBase;
	module.exports = exports['default'];

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _PaginatorBlock = __webpack_require__(545);
	
	var _PaginatorBlock2 = _interopRequireDefault(_PaginatorBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PaginatorBlock2.default;
	module.exports = exports["default"];

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPlx = __webpack_require__(332);
	
	var _reactPlx2 = _interopRequireDefault(_reactPlx);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var plxData = function plxData(start, startOffset, end, duration, hide) {
	    return [{
	        start: start,
	        end: end,
	        startOffset: startOffset,
	        duration: duration,
	        properties: [{
	            startValue: hide ? 1 : 0,
	            endValue: hide ? 0 : 1,
	            property: "opacity"
	        }]
	    }];
	};
	
	var AnimateOpacity = function AnimateOpacity(_ref) {
	    var children = _ref.children,
	        start = _ref.start,
	        startOffset = _ref.startOffset,
	        end = _ref.end,
	        duration = _ref.duration,
	        hide = _ref.hide,
	        className = _ref.className;
	
	    return _react2.default.createElement(
	        "span",
	        null,
	        start ? _react2.default.createElement(
	            _reactPlx2.default,
	            {
	                parallaxData: plxData(start, startOffset, end, duration, hide),
	                className: className
	            },
	            children
	        ) : children
	    );
	};
	AnimateOpacity.defaultProps = {
	    startOffset: 0,
	    style: {}
	};
	
	AnimateOpacity.propTypes = {
	    children: _propTypes2.default.node,
	    start: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    startOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    end: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    hide: _propTypes2.default.bool,
	    className: _propTypes2.default.string
	};
	
	exports.default = AnimateOpacity;
	module.exports = exports["default"];

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProjectMarkers = exports.default = undefined;
	
	var _ProjectMarkers2 = __webpack_require__(558);
	
	var _ProjectMarkers3 = _interopRequireDefault(_ProjectMarkers2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProjectMarkers3.default;
	exports.ProjectMarkers = _ProjectMarkers3.default;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Published = __webpack_require__(561);
	
	var _Published2 = _interopRequireDefault(_Published);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Published2.default;
	module.exports = exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _QuoteBlock = __webpack_require__(562);
	
	var _QuoteBlock2 = _interopRequireDefault(_QuoteBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _QuoteBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TableBlock = __webpack_require__(582);
	
	var _TableBlock2 = _interopRequireDefault(_TableBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TableBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VideoListBlock = exports.default = undefined;
	
	var _VideoListBlock2 = __webpack_require__(595);
	
	var _VideoListBlock3 = _interopRequireDefault(_VideoListBlock2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _VideoListBlock3.default;
	exports.VideoListBlock = _VideoListBlock3.default;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getData = __webpack_require__(344);
	
	var _getData2 = _interopRequireDefault(_getData);
	
	var _messenger = __webpack_require__(614);
	
	var _messenger2 = _interopRequireDefault(_messenger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultFetchOptions = {
	    headers: {
	        Accept: 'application/json',
	        'Content-Type': 'application/json'
	    },
	    credentials: 'include'
	};
	
	function parseResponse(response) {
	    return response.json().then(function (json) {
	        return { json: json, response: response };
	    });
	}
	
	function handleUserMessages(_ref) {
	    var json = _ref.json,
	        response = _ref.response;
	
	    if (json.messageToUser) {
	        if (json.success) {
	            _messenger2.default.sendMessage({ message: json.messageToUser });
	        } else {
	            _messenger2.default.sendErrorMessage({ message: json.messageToUser });
	        }
	    }
	
	    return { json: json, response: response };
	}
	
	function handleNotOk(_ref2) {
	    var json = _ref2.json,
	        response = _ref2.response;
	
	    // NOTE: `response.ok` is true when the returned status is in the inclusive range 200-299.
	    if (!response.ok && !json.messageToUser) {
	        var error = new Error(response.statusText);
	
	        error.name = response.status + ' on ' + response.url;
	
	        throw error;
	    }
	
	    return { json: json, response: response };
	}
	
	function handleResponse(_ref3) {
	    var json = _ref3.json;
	
	    return json.payload || json;
	}
	
	function handleFetchError(error) {
	    _messenger2.default.sendErrorMessage({
	        message: (0, _getData2.default)('generic-error-message') || 'Noe gikk galt. Vennligst prøv igjen senere.'
	    });
	
	    return Promise.reject(error);
	}
	
	function request(url, options) {
	    return fetch(url, options).then(parseResponse).then(handleUserMessages).then(handleNotOk).then(handleResponse).catch(handleFetchError);
	}
	
	function post(endpoint, data) {
	    return request(endpoint, Object.assign({}, defaultFetchOptions, {
	        body: data,
	        method: 'post'
	    }));
	}
	
	function get(endpoint) {
	    return request(endpoint, defaultFetchOptions);
	}
	
	function execute(endpoint, data) {
	    if (endpoint.indexOf('data/static-site') !== -1) {
	        return new Promise(function (resolve) {
	            setTimeout(function () {
	                resolve(request(endpoint, defaultFetchOptions));
	            }, 1000);
	        });
	    }
	
	    return post(endpoint, JSON.stringify(data));
	}
	
	exports.default = {
	    execute: execute,
	    get: get
	};
	module.exports = exports['default'];

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(80);
	var dPs = __webpack_require__(645);
	var enumBugKeys = __webpack_require__(137);
	var IE_PROTO = __webpack_require__(144)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(253)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(638).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(100);
	var createDesc = __webpack_require__(101);
	var toIObject = __webpack_require__(42);
	var toPrimitive = __webpack_require__(148);
	var has = __webpack_require__(50);
	var IE8_DOM_DEFINE = __webpack_require__(254);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(48) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 142 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(51).f;
	var has = __webpack_require__(50);
	var TAG = __webpack_require__(63)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(145)('keys');
	var uid = __webpack_require__(102);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(41);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 146 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(136);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(81);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(41);
	var core = __webpack_require__(35);
	var LIBRARY = __webpack_require__(139);
	var wksExt = __webpack_require__(150);
	var defineProperty = __webpack_require__(51).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(63);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var emptyObject = __webpack_require__(43);
	var _invariant = __webpack_require__(4);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 152 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	module.exports = "/Public/build/ec96269fcd574853a6c560b6b584c6ba.png";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(52),
	    root = __webpack_require__(33);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(921),
	    mapCacheDelete = __webpack_require__(922),
	    mapCacheGet = __webpack_require__(923),
	    mapCacheHas = __webpack_require__(924),
	    mapCacheSet = __webpack_require__(925);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(103),
	    stackClear = __webpack_require__(937),
	    stackDelete = __webpack_require__(938),
	    stackGet = __webpack_require__(939),
	    stackHas = __webpack_require__(940),
	    stackSet = __webpack_require__(941);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 158 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(275),
	    eq = __webpack_require__(168);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(862),
	    isObjectLike = __webpack_require__(68);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(271);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(290);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(852),
	    stubArray = __webpack_require__(300);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 165 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(27),
	    isSymbol = __webpack_require__(108);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 167 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 169 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(861),
	    isObjectLike = __webpack_require__(68);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(173),
	    isLength = __webpack_require__(174);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(33),
	    stubFalse = __webpack_require__(954);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119)(module)))

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(65),
	    isObject = __webpack_require__(36);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 174 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(85)))

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(19);
	var invariant = __webpack_require__(4);
	var ReactPropTypesSecret = __webpack_require__(86);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(19);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(6);
	
	var ReactPropTypesSecret = __webpack_require__(86);
	var checkPropTypes = __webpack_require__(176);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(959)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function() {
	  root.requestAnimationFrame = raf
	  root.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(71);
	var Danger = __webpack_require__(967);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactInstrumentation = __webpack_require__(28);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(189);
	var setInnerHTML = __webpack_require__(114);
	var setTextContent = __webpack_require__(327);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactErrorUtils = __webpack_require__(187);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(6);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactPropTypesSecret = __webpack_require__(993);
	var propTypesFactory = __webpack_require__(109);
	
	var React = __webpack_require__(40);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(6);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactInstanceMap = __webpack_require__(89);
	var ReactInstrumentation = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(34);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(6);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(15);
	
	var ReactCompositeComponent = __webpack_require__(974);
	var ReactEmptyComponent = __webpack_require__(311);
	var ReactHostComponent = __webpack_require__(313);
	
	var getNextDebugID = __webpack_require__(1076);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(6);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(23);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var emptyFunction = __webpack_require__(19);
	var warning = __webpack_require__(6);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _decorator = __webpack_require__(1023);
	
	var _decorator2 = _interopRequireDefault(_decorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMPONENTS = ['AttributionControl', 'Circle', 'CircleMarker', 'FeatureGroup', 'GeoJSON', 'GridLayer', 'ImageOverlay', 'LayerGroup', 'LayersControl', 'Map', 'MapComponent', 'MapControl', 'MapLayer', 'Marker', 'Pane', 'Path', 'Polygon', 'Polyline', 'Popup', 'Rectangle', 'ScaleControl', 'TileLayer', 'Tooltip', 'WMSTileLayer', 'ZoomControl'];
	
	var COMPONENT_MAP = COMPONENTS.reduce(function (map, name) {
		map[name] = (0, _decorator2.default)(name);
		return map;
	}, {});
	
	module.exports = COMPONENT_MAP;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(79);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(32);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _MapLayer2 = __webpack_require__(57);
	
	var _MapLayer3 = _interopRequireDefault(_MapLayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GridLayer = function (_MapLayer) {
	  (0, _inherits3.default)(GridLayer, _MapLayer);
	
	  function GridLayer() {
	    (0, _classCallCheck3.default)(this, GridLayer);
	    return (0, _possibleConstructorReturn3.default)(this, (GridLayer.__proto__ || (0, _getPrototypeOf2.default)(GridLayer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GridLayer, [{
	    key: 'getOptions',
	    value: function getOptions(props) {
	      var options = (0, _get3.default)(GridLayer.prototype.__proto__ || (0, _getPrototypeOf2.default)(GridLayer.prototype), 'getOptions', this).call(this, props);
	      var map = this.context.map;
	      return map ? (0, _extends3.default)({
	        maxZoom: map.options.maxZoom,
	        minZoom: map.options.minZoom
	      }, options) : options;
	    }
	  }, {
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      return (0, _leaflet.gridLayer)(this.getOptions(props));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      var opacity = toProps.opacity,
	          zIndex = toProps.zIndex;
	
	      if (opacity !== fromProps.opacity) {
	        this.leafletElement.setOpacity(opacity);
	      }
	      if (zIndex !== fromProps.zIndex) {
	        this.leafletElement.setZIndex(zIndex);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return GridLayer;
	}(_MapLayer3.default);
	
	GridLayer.propTypes = {
	  children: _children2.default,
	  opacity: _propTypes2.default.number,
	  zIndex: _propTypes2.default.number
	};
	exports.default = GridLayer;

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),
/* 202 */
184,
/* 203 */
[1291, 37],
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(203);
	var ReactElement = __webpack_require__(24);
	
	var emptyFunction = __webpack_require__(19);
	var traverseAllChildren = __webpack_require__(212);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(24);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(24),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(109);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.1';

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(94),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(24),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(96);
	var factory = __webpack_require__(151);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var ReactElement = __webpack_require__(24);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var REACT_ELEMENT_TYPE = __webpack_require__(95);
	
	var getIteratorFn = __webpack_require__(209);
	var invariant = __webpack_require__(4);
	var KeyEscapeUtils = __webpack_require__(202);
	var warning = __webpack_require__(6);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	function fromQueryString(queryString) {
	  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '?';
	
	  if (!queryString) {
	    return {};
	  }
	
	  return queryString.replace(prefix, '').split('&').reduce(function (accumulator, currentPair) {
	    var data = currentPair.split('=');
	
	    if (data.length === 2) {
	      accumulator[decodeURIComponent(data[0])] = decodeURIComponent(data[1]);
	    }
	
	    return accumulator;
	  }, {});
	}
	
	var _default = fromQueryString;
	exports["default"] = _default;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _fromQueryString = _interopRequireDefault(__webpack_require__(213));
	
	var _toQueryString = _interopRequireDefault(__webpack_require__(350));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function replaceQueryParameters(url, query) {
	  var urlFragments = url.split('?');
	  var baseUrl = urlFragments[0];
	  var originalQueryString = urlFragments[1];
	  var originalQuery = (0, _fromQueryString["default"])(originalQueryString);
	  var newQuery = Object.assign({}, originalQuery, query);
	  return "".concat(baseUrl).concat((0, _toQueryString["default"])(newQuery));
	}
	
	var _default = replaceQueryParameters;
	exports["default"] = _default;

/***/ }),
/* 215 */,
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Banner = __webpack_require__(388);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Banner2.default;
	module.exports = exports['default'];

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BoardMember = exports.default = undefined;
	
	var _BoardMember2 = __webpack_require__(393);
	
	var _BoardMember3 = _interopRequireDefault(_BoardMember2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BoardMember3.default;
	exports.BoardMember = _BoardMember3.default;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(693);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Breadcrumbs = function Breadcrumbs(_ref) {
	    var items = _ref.items,
	        className = _ref.className,
	        _ref$color = _ref.color,
	        color = _ref$color === undefined ? "white" : _ref$color;
	
	    return items && items.length > 0 && _react2.default.createElement(
	        'ul',
	        { className: (0, _classnames2.default)('breadcrumbs', className, _defineProperty({}, 'breadcrumbs_color-' + color + ' ', color)) },
	        items.map(function (link, index) {
	            return _react2.default.createElement(
	                'li',
	                { key: index, className: 'breadcrumbs__item' },
	                _react2.default.createElement(
	                    'a',
	                    { href: link.url, className: 'breadcrumbs__link' },
	                    link.linkText
	                )
	            );
	        })
	    );
	};
	
	Breadcrumbs.propTypes = {
	    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        url: _propTypes2.default.string,
	        linkText: _propTypes2.default.string
	    })),
	    className: _propTypes2.default.string,
	    color: _propTypes2.default.oneOf(["white", "dark-grey"])
	};
	
	exports.default = Breadcrumbs;
	module.exports = exports['default'];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CategoriesNavigation = __webpack_require__(398);
	
	var _CategoriesNavigation2 = _interopRequireDefault(_CategoriesNavigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CategoriesNavigation2.default;
	module.exports = exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.VIEW_TYPES = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _debounce = __webpack_require__(53);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _reactCollapse = __webpack_require__(961);
	
	var _reactCollapse2 = _interopRequireDefault(_reactCollapse);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Map = __webpack_require__(76);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _DepartmentMarker = __webpack_require__(421);
	
	var _DepartmentMarker2 = _interopRequireDefault(_DepartmentMarker);
	
	var _tracking = __webpack_require__(99);
	
	var _DepartmentInformationPageModule = __webpack_require__(747);
	
	var _DepartmentInformationPageModule2 = _interopRequireDefault(_DepartmentInformationPageModule);
	
	var _DepartmentInformationBillingUnit = __webpack_require__(418);
	
	var _DepartmentInformationBillingUnit2 = _interopRequireDefault(_DepartmentInformationBillingUnit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VIEW_TYPES = exports.VIEW_TYPES = {
	    full: 'Full',
	    list: 'List'
	};
	
	var DepartmentInformationPage = function (_React$Component) {
	    _inherits(DepartmentInformationPage, _React$Component);
	
	    function DepartmentInformationPage() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, DepartmentInformationPage);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DepartmentInformationPage.__proto__ || Object.getPrototypeOf(DepartmentInformationPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            isExpanded: _this.props.isBillingUnitsListExpanded,
	            isDesktop: true,
	            isBillingUnitsListExpanded: _this.props.isBillingUnitsListExpanded
	        }, _this.toggleExpand = function () {
	            _this.setState({ isExpanded: !_this.state.isExpanded }, function () {
	                (0, _tracking.track)('list_expansion', _this.props.heading);
	            });
	        }, _this.toggleBillingsExpand = function (e) {
	            e.preventDefault();
	            _this.setState({ isBillingUnitsListExpanded: !_this.state.isBillingUnitsListExpanded });
	        }, _this.getIsDesktop = function () {
	            _this.setState({ isDesktop: typeof window !== 'undefined' && window.matchMedia('(min-width: 1024px)').matches });
	        }, _this.debouncedGetIsDesktop = (0, _debounce2.default)(_this.getIsDesktop, 500), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(DepartmentInformationPage, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.isBillingUnitsListExpanded !== this.props.isBillingUnitsListExpanded && this.props.isBillingUnitsListExpanded !== undefined) {
	                this.setState({
	                    isExpanded: this.props.isBillingUnitsListExpanded,
	                    isBillingUnitsListExpanded: this.props.isBillingUnitsListExpanded
	                });
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getIsDesktop();
	
	            typeof window !== 'undefined' && window.addEventListener('resize', this.debouncedGetIsDesktop);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            typeof window !== 'undefined' && window.removeEventListener('resize', this.debouncedGetIsDesktop);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _cn, _cn6;
	
	            var _props = this.props,
	                readMoreEHF = _props.readMoreEHF,
	                heading = _props.heading,
	                internalUrl = _props.internalUrl,
	                phone = _props.phone,
	                emailAddress = _props.emailAddress,
	                streetAddressLine1 = _props.streetAddressLine1,
	                streetAddressLine2 = _props.streetAddressLine2,
	                postalAddressLine1 = _props.postalAddressLine1,
	                postalAddressLine2 = _props.postalAddressLine2,
	                mapTitle = _props.mapTitle,
	                location = _props.location,
	                zoomLevel = _props.zoomLevel,
	                externalUrl = _props.externalUrl,
	                style = _props.style,
	                view = _props.view,
	                phoneAndEmailLabel = _props.phoneAndEmailLabel,
	                streetAddressLabel = _props.streetAddressLabel,
	                postalAddressLabel = _props.postalAddressLabel,
	                invoiceLabel = _props.invoiceLabel,
	                orgNoLabel = _props.orgNoLabel,
	                invoiceEhfLabel = _props.invoiceEhfLabel,
	                invoiceEhfLinkText = _props.invoiceEhfLinkText,
	                sendEmailLabel = _props.sendEmailLabel,
	                sendInvoiceEmailLabel = _props.sendInvoiceEmailLabel,
	                tileLayer = _props.tileLayer,
	                lang = _props.lang,
	                billingUnits = _props.billingUnits,
	                allContactPersonsUrl = _props.allContactPersonsUrl;
	            var _state = this.state,
	                isBillingUnitsListExpanded = _state.isBillingUnitsListExpanded,
	                isExpanded = _state.isExpanded,
	                isDesktop = _state.isDesktop;
	
	
	            var classNames = (0, _classnames2.default)(_DepartmentInformationPageModule2.default.block, (_cn = {}, _defineProperty(_cn, _DepartmentInformationPageModule2.default.list, view === VIEW_TYPES.list), _defineProperty(_cn, _DepartmentInformationPageModule2.default.full, view === VIEW_TYPES.full), _defineProperty(_cn, _DepartmentInformationPageModule2.default.yellow, isExpanded && view !== VIEW_TYPES.full), _cn));
	
	            var expandedContent = (0, _classnames2.default)(_DepartmentInformationPageModule2.default.businessInfo);
	
	            var expandableContent = [_react2.default.createElement(
	                'div',
	                { key: 'visitationaddress', className: (0, _classnames2.default)(_DepartmentInformationPageModule2.default.visitationAdress, _defineProperty({}, _DepartmentInformationPageModule2.default.noMobileSpace, !(postalAddressLine1 || postalAddressLine2)))
	                },
	                _react2.default.createElement(
	                    'h4',
	                    { className: (0, _classnames2.default)(_defineProperty({}, _DepartmentInformationPageModule2.default.invisibleHeader, !(streetAddressLine1 || streetAddressLine2)))
	                    },
	                    streetAddressLabel
	                ),
	                streetAddressLine1 && _react2.default.createElement(
	                    'p',
	                    null,
	                    streetAddressLine1
	                ),
	                streetAddressLine2 && _react2.default.createElement(
	                    'p',
	                    null,
	                    streetAddressLine2
	                )
	            ), _react2.default.createElement(
	                'div',
	                { key: 'postaddress', className: (0, _classnames2.default)(_DepartmentInformationPageModule2.default.postAdress, _defineProperty({}, _DepartmentInformationPageModule2.default.noMobileSpace, !(postalAddressLine1 || postalAddressLine2)))
	                },
	                _react2.default.createElement(
	                    'h4',
	                    { className: (0, _classnames2.default)(_defineProperty({}, _DepartmentInformationPageModule2.default.invisibleHeader, !(postalAddressLine1 || postalAddressLine2)))
	                    },
	                    postalAddressLabel
	                ),
	                postalAddressLine1 && _react2.default.createElement(
	                    'p',
	                    null,
	                    postalAddressLine1
	                ),
	                postalAddressLine2 && _react2.default.createElement(
	                    'p',
	                    null,
	                    postalAddressLine2
	                )
	            ), billingUnits && billingUnits.length > 0 ? _react2.default.createElement(
	                'div',
	                {
	                    key: 'invoice',
	                    className: (0, _classnames2.default)(_DepartmentInformationPageModule2.default.invoice, (_cn6 = {}, _defineProperty(_cn6, _DepartmentInformationPageModule2.default.noMobileSpace, true), _defineProperty(_cn6, _DepartmentInformationPageModule2.default.noMobileSpace, !(billingUnits[0].billingName || billingUnits[0].organizationNumber || billingUnits[0].invoiceEmailAddress)), _cn6))
	                },
	                invoiceLabel && _react2.default.createElement(
	                    'h4',
	                    null,
	                    invoiceLabel
	                ),
	                billingUnits.length > 1 ? _react2.default.createElement(
	                    'button',
	                    {
	                        onClick: this.toggleBillingsExpand,
	                        className: _DepartmentInformationPageModule2.default['toggle-billing-units-button']
	
	                    },
	                    _react2.default.createElement(_Icon2.default, {
	                        icon: isBillingUnitsListExpanded ? "minus" : "plus",
	                        className: _DepartmentInformationPageModule2.default['toggle-billing-units-button-icon']
	                    }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: _DepartmentInformationPageModule2.default['toggle-billing-units-button-text'] },
	                        isBillingUnitsListExpanded ? lang.showLessLabel : lang.showMoreLabel,
	                        '  '
	                    )
	                ) : _react2.default.createElement(_DepartmentInformationBillingUnit2.default, {
	                    organizationNumber: billingUnits[0].organizationNumber,
	                    invoiceAsEHF: billingUnits[0].invoiceAsEHF,
	                    invoiceEmailAddress: billingUnits[0].invoiceEmailAddress,
	                    billingName: billingUnits[0].billingName,
	                    invoiceEhfLabel: invoiceEhfLabel,
	                    orgNoLabel: orgNoLabel,
	                    readMoreEHF: readMoreEHF,
	                    invoiceEhfLinkText: invoiceEhfLinkText,
	                    heading: heading,
	                    sendInvoiceEmailLabel: sendInvoiceEmailLabel,
	                    invoiceAsEHFNoText: lang.invoiceAsEHFNoText,
	                    invoiceAsEHFYesText: lang.invoiceAsEHFYesText
	                })
	            ) : null];
	
	            var coordinates = location && location.split(",").map(parseFloat);
	
	            return _react2.default.createElement(
	                'div',
	                { className: classNames, style: style },
	                view === VIEW_TYPES.full && [mapTitle && _react2.default.createElement(
	                    'h2',
	                    { className: _DepartmentInformationPageModule2.default.contactHeading, key: 'contact' },
	                    mapTitle
	                ), location && _react2.default.createElement(
	                    'div',
	                    { className: _DepartmentInformationPageModule2.default.map, key: 'map' },
	                    _react2.default.createElement(
	                        _Map2.default,
	                        { center: coordinates, tileLayer: tileLayer, zoomLevel: zoomLevel },
	                        _react2.default.createElement(_DepartmentMarker2.default, { position: coordinates })
	                    )
	                )],
	                _react2.default.createElement(
	                    'div',
	                    { className: expandedContent },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DepartmentInformationPageModule2.default.businessInfoWrapper },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: _DepartmentInformationPageModule2.default.heading },
	                            externalUrl || internalUrl ? _react2.default.createElement(
	                                'a',
	                                { href: externalUrl ? externalUrl : internalUrl },
	                                heading,
	                                externalUrl && _react2.default.createElement(_Icon2.default, { icon: 'share', className: (0, _classnames2.default)(_DepartmentInformationPageModule2.default.inlineIcon, _DepartmentInformationPageModule2.default['external-icon']) })
	                            ) : heading
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _DepartmentInformationPageModule2.default.expandableContent },
	                            _react2.default.createElement(
	                                'div',
	                                { className: (0, _classnames2.default)(_DepartmentInformationPageModule2.default.contactInfo, _defineProperty({}, _DepartmentInformationPageModule2.default.noMobileSpace, !(phone || emailAddress)))
	                                },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { className: (0, _classnames2.default)(_defineProperty({}, _DepartmentInformationPageModule2.default.invisibleHeader, !(phone || emailAddress)))
	                                    },
	                                    phoneAndEmailLabel
	                                ),
	                                phone && _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-name': heading, href: 'tel:' + phone },
	                                        phone
	                                    )
	                                ),
	                                emailAddress && _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { 'data-name': heading, href: 'mailto:' + emailAddress },
	                                        sendEmailLabel || emailAddress
	                                    )
	                                ),
	                                allContactPersonsUrl && _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: allContactPersonsUrl },
	                                        lang.allContactPersonsLinkText
	                                    )
	                                )
	                            ),
	                            isDesktop ? expandableContent : _react2.default.createElement(
	                                _reactCollapse2.default,
	                                { isOpened: isExpanded },
	                                expandableContent
	                            )
	                        ),
	                        billingUnits && billingUnits.length > 1 && _react2.default.createElement(
	                            _reactCollapse2.default,
	                            {
	                                isOpened: isDesktop ? isBillingUnitsListExpanded : isBillingUnitsListExpanded && isExpanded
	                            },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _DepartmentInformationPageModule2.default.expandableBillingContent },
	                                billingUnits.map(function (billing, i) {
	                                    return _react2.default.createElement(
	                                        'div',
	                                        { key: i, className: _DepartmentInformationPageModule2.default['billing-column'] },
	                                        _react2.default.createElement(_DepartmentInformationBillingUnit2.default, {
	                                            billingName: billing.billingName,
	                                            organizationNumber: billing.organizationNumber,
	                                            invoiceAsEHF: billing.invoiceAsEHF,
	                                            invoiceEmailAddress: billing.invoiceEmailAddress,
	                                            invoiceEhfLabel: invoiceEhfLabel,
	                                            orgNoLabel: orgNoLabel,
	                                            readMoreEHF: readMoreEHF,
	                                            invoiceEhfLinkText: invoiceEhfLinkText,
	                                            heading: heading,
	                                            invoiceAsEHFNoText: lang.invoiceAsEHFNoText,
	                                            invoiceAsEHFYesText: lang.invoiceAsEHFYesText,
	                                            sendInvoiceEmailLabel: sendInvoiceEmailLabel
	                                        })
	                                    );
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _DepartmentInformationPageModule2.default.toggler },
	                            _react2.default.createElement(_Button2.default, {
	                                className: _DepartmentInformationPageModule2.default.togglerButton,
	                                onClick: this.toggleExpand,
	                                icon: isExpanded ? "close" : "zoom-in",
	                                isActive: isExpanded
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DepartmentInformationPage;
	}(_react2.default.Component);
	
	DepartmentInformationPage.propTypes = {
	    heading: _propTypes2.default.string,
	    internalUrl: _propTypes2.default.string,
	    view: _propTypes2.default.oneOf(Object.values(VIEW_TYPES)).isRequired,
	    readMoreEHF: _propTypes2.default.string,
	    phone: _propTypes2.default.string,
	    emailAddress: _propTypes2.default.string,
	    streetAddressLine1: _propTypes2.default.string,
	    streetAddressLine2: _propTypes2.default.string,
	    postalAddressLine1: _propTypes2.default.string,
	    postalAddressLine2: _propTypes2.default.string,
	    mapTitle: _propTypes2.default.string,
	    location: _propTypes2.default.string,
	    zoomLevel: _propTypes2.default.number,
	    externalUrl: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    phoneAndEmailLabel: _propTypes2.default.string.isRequired,
	    streetAddressLabel: _propTypes2.default.string.isRequired,
	    postalAddressLabel: _propTypes2.default.string.isRequired,
	    invoiceLabel: _propTypes2.default.string.isRequired,
	    orgNoLabel: _propTypes2.default.string.isRequired,
	    invoiceEhfLabel: _propTypes2.default.string.isRequired,
	    invoiceEhfLinkText: _propTypes2.default.string.isRequired,
	    sendEmailLabel: _propTypes2.default.string,
	    sendInvoiceEmailLabel: _propTypes2.default.string,
	    tileLayer: _propTypes2.default.string,
	    lang: _propTypes2.default.shape({
	        showMoreLabel: _propTypes2.default.string.isRequired,
	        showLessLabel: _propTypes2.default.string.isRequired,
	        invoiceAsEHFNoText: _propTypes2.default.string.isRequired,
	        allContactPersonsLinkText: _propTypes2.default.string.isRequired
	    }).isRequired,
	    billingUnits: _propTypes2.default.arrayOf(_propTypes2.default.shape(_DepartmentInformationBillingUnit2.default.propTypes)),
	    businessAreas: _propTypes2.default.arrayOf(_propTypes2.default.string),
	    allContactPersonsUrl: _propTypes2.default.string,
	    isBillingUnitsListExpanded: _propTypes2.default.bool
	};
	DepartmentInformationPage.defaultProps = {
	    theme: 0,
	    view: "List"
	};
	exports.default = DepartmentInformationPage;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _EventCard = __webpack_require__(435);
	
	var _EventCard2 = _interopRequireDefault(_EventCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _EventCard2.default;
	module.exports = exports['default'];

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FancyImage = __webpack_require__(436);
	
	var _FancyImage2 = _interopRequireDefault(_FancyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FancyImage2.default;
	module.exports = exports['default'];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FeatureArticleTag = __webpack_require__(439);
	
	var _FeatureArticleTag2 = _interopRequireDefault(_FeatureArticleTag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FeatureArticleTag2.default;
	module.exports = exports["default"];

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FeatureImageHeaderContent = __webpack_require__(446);
	
	var _FeatureImageHeaderContent2 = _interopRequireDefault(_FeatureImageHeaderContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FeatureImageHeaderContent2.default;
	module.exports = exports["default"];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(270);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__(701);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FitText = function (_React$Component) {
	    _inherits(FitText, _React$Component);
	
	    function FitText(props) {
	        _classCallCheck(this, FitText);
	
	        var _this = _possibleConstructorReturn(this, (FitText.__proto__ || Object.getPrototypeOf(FitText)).call(this, props));
	
	        _this.setTextContainerRef = function (ref) {
	            _this.textContainerRef = ref;
	        };
	
	        _this.setLongestWordContainerRef = function (ref) {
	            _this.longestWordContainerRef = ref;
	        };
	
	        _this.state = {
	            fontSize: 16,
	            lineHeight: 24,
	            maxFontSize: 32,
	            minFontSize: _this.props.minFontSize
	        };
	        _this.textContainerRef = null;
	        _this.longestWordContainerRef = null;
	        _this.updateFont = (0, _lodash2.default)(_this.updateFont.bind(_this), 100);
	        _this.updateMaxFontSize = _this.updateMaxFontSize.bind(_this);
	        return _this;
	    }
	
	    _createClass(FitText, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.updateMaxFontSize();
	            this.updateLongestWord();
	            this.updateFont();
	            window.addEventListener('resize', this.updateMaxFontSize);
	            window.addEventListener('resize', this.updateFont);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.updateMaxFontSize);
	            window.removeEventListener('resize', this.updateFont);
	        }
	    }, {
	        key: 'updateMaxFontSize',
	        value: function updateMaxFontSize() {
	            var _this2 = this;
	
	            var container = this.textContainerRef;
	            if (!container) return;
	
	            var longestWordContainer = this.longestWordContainerRef;
	            longestWordContainer.style.fontSize = '';
	
	            var computedStyle = window.getComputedStyle(longestWordContainer);
	            var fontSize = Math.round(parseFloat(computedStyle.getPropertyValue('font-size')));
	
	            this.setState({ maxFontSize: fontSize }, function () {
	                _this2.updateFont();
	            });
	        }
	    }, {
	        key: 'updateLongestWord',
	        value: function updateLongestWord() {
	            var longestWordContainer = this.longestWordContainerRef;
	            var text = this.props.text;
	            var words = text.split(' ');
	
	            var longestWord = '';
	            var longestWordWidth = 0;
	
	            words.forEach(function (word) {
	                longestWordContainer.textContent = word;
	                var width = longestWordContainer.offsetWidth;
	                if (width > longestWordWidth) {
	                    longestWordWidth = width;
	                    longestWord = word;
	                }
	            });
	            this.longestWordContainerRef.textContent = longestWord;
	        }
	    }, {
	        key: 'updateFont',
	        value: function updateFont() {
	            var container = this.textContainerRef;
	            var longestWordContainer = this.longestWordContainerRef;
	            if (!container || !this.longestWordContainerRef) return;
	
	            container.style.opacity = '0';
	
	            var _state = this.state,
	                maxFontSize = _state.maxFontSize,
	                minFontSize = _state.minFontSize;
	
	            var computedStyle = window.getComputedStyle(container);
	            var fontSize = parseFloat(computedStyle.getPropertyValue('font-size'));
	
	            var currentFontSize = fontSize > maxFontSize ? maxFontSize : fontSize;
	            longestWordContainer.style.fontSize = currentFontSize + 'px';
	            var maxWidth = container.offsetWidth;
	
	            var longestWordWidth = 0;
	            longestWordWidth = longestWordContainer.offsetWidth;
	
	            var _props = this.props,
	                forMobileOnly = _props.forMobileOnly,
	                mobileBreakpoint = _props.mobileBreakpoint;
	
	            var screenWidth = window.innerWidth;
	
	            if (forMobileOnly && screenWidth >= mobileBreakpoint) {
	                container.removeAttribute('style');
	                container.style.opacity = '1';
	                return;
	            }
	
	            if (longestWordWidth > maxWidth) {
	                while (longestWordWidth > maxWidth && currentFontSize > minFontSize) {
	                    currentFontSize--;
	                    longestWordContainer.style.fontSize = currentFontSize + 'px';
	                    longestWordWidth = longestWordContainer.offsetWidth;
	                }
	            } else {
	                while (longestWordWidth < maxWidth && currentFontSize < maxFontSize) {
	                    currentFontSize++;
	                    longestWordContainer.style.fontSize = currentFontSize + 'px';
	                    longestWordWidth = longestWordContainer.offsetWidth;
	                }
	                currentFontSize--;
	            }
	            var currentFontSizeRounded = Math.floor(currentFontSize);
	            container.style.fontSize = currentFontSizeRounded + 'px';
	            var lineHeight = Math.ceil(currentFontSize * 1.5);
	            this.setState({ fontSize: currentFontSizeRounded, lineHeight: lineHeight });
	            container.style.lineHeight = lineHeight + 'px';
	            container.style.opacity = '1';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var lineHeight = this.state.lineHeight;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'fit-text' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'fit-text__longest-word', 'aria-hidden': 'true' },
	                    _react2.default.createElement('span', { className: 'fit-text__longest-word-container', ref: this.setLongestWordContainerRef })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: 'fit-text__text',
	                        ref: this.setTextContainerRef,
	                        style: { lineHeight: lineHeight + 'px' }
	                    },
	                    this.props.text
	                )
	            );
	        }
	    }]);
	
	    return FitText;
	}(_react2.default.Component);
	
	FitText.propTypes = {
	    text: _propTypes2.default.string.isRequired,
	    forMobileOnly: _propTypes2.default.bool,
	    mobileBreakpoint: _propTypes2.default.number,
	    minFontSize: _propTypes2.default.number
	};
	
	FitText.defaultProps = {
	    forMobileOnly: true,
	    mobileBreakpoint: 480,
	    minFontSize: 12
	};
	
	exports.default = FitText;
	module.exports = exports['default'];

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Header = __webpack_require__(481);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Header2.default;
	module.exports = exports['default'];

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _HighlightedProjectBlock = __webpack_require__(482);
	
	var _HighlightedProjectBlock2 = _interopRequireDefault(_HighlightedProjectBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HighlightedProjectBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _ImageBlock = __webpack_require__(485);
	
	var _ImageBlock2 = _interopRequireDefault(_ImageBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ImageBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _InfographicListBlock = __webpack_require__(488);
	
	var _InfographicListBlock2 = _interopRequireDefault(_InfographicListBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InfographicListBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Infographic = __webpack_require__(489);
	
	var _Infographic2 = _interopRequireDefault(_Infographic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Infographic2.default;
	module.exports = exports['default'];

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _InvestorReport = __webpack_require__(513);
	
	var _InvestorReport2 = _interopRequireDefault(_InvestorReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InvestorReport2.default;
	module.exports = exports['default'];

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _LanguageSelector = __webpack_require__(516);
	
	var _LanguageSelector2 = _interopRequireDefault(_LanguageSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LanguageSelector2.default;
	module.exports = exports['default'];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _ListSearchForm = __webpack_require__(523);
	
	var _ListSearchForm2 = _interopRequireDefault(_ListSearchForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ListSearchForm2.default;
	module.exports = exports['default'];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _MapLocationBlock = __webpack_require__(528);
	
	var _MapLocationBlock2 = _interopRequireDefault(_MapLocationBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MapLocationBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnchorLink = {};
	
	AnchorLink.propTypes = {
	    anchorId: _propTypes2.default.string,
	    text: _propTypes2.default.string
	};
	
	exports.default = AnchorLink;
	module.exports = exports['default'];

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Image = __webpack_require__(77);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFigure = {};
	
	ImageFigure.propTypes = Object.assign({}, _Image2.default.propTypes, {
	    caption: _propTypes2.default.string,
	    photographer: _propTypes2.default.string
	});
	
	exports.default = ImageFigure;
	module.exports = exports['default'];

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Link = __webpack_require__(26);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _AnchorLink = __webpack_require__(235);
	
	var _AnchorLink2 = _interopRequireDefault(_AnchorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvestorMenuLink = {};
	
	InvestorMenuLink.propTypes = Object.assign({}, _Link2.default.propTypes, {
	    isActive: _propTypes2.default.bool,
	    secondaryMenu: _propTypes2.default.shape({
	        links: _propTypes2.default.arrayOf(_propTypes2.default.shape(_AnchorLink2.default.propTypes))
	    })
	});
	
	exports.default = InvestorMenuLink;
	module.exports = exports['default'];

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _NewImageBlock = __webpack_require__(539);
	
	var _NewImageBlock2 = _interopRequireDefault(_NewImageBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NewImageBlock2.default;
	module.exports = exports["default"];

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _NewsListBlock = __webpack_require__(542);
	
	var _NewsListBlock2 = _interopRequireDefault(_NewsListBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NewsListBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _ProjectListPage = __webpack_require__(557);
	
	var _ProjectListPage2 = _interopRequireDefault(_ProjectListPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProjectListPage2.default;
	module.exports = exports['default'];

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RelatedArticles = __webpack_require__(565);
	
	var _RelatedArticles2 = _interopRequireDefault(_RelatedArticles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RelatedArticles2.default;
	module.exports = exports['default'];

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SearchForm = __webpack_require__(570);
	
	var _SearchForm2 = _interopRequireDefault(_SearchForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SearchForm2.default;
	module.exports = exports['default'];

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SliderListBlock = __webpack_require__(577);
	
	var _SliderListBlock2 = _interopRequireDefault(_SliderListBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SliderListBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Sticky = __webpack_require__(578);
	
	var _Sticky2 = _interopRequireDefault(_Sticky);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Sticky2.default;
	module.exports = exports['default'];

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SupportingMenu = __webpack_require__(579);
	
	var _SupportingMenu2 = _interopRequireDefault(_SupportingMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SupportingMenu2.default;
	module.exports = exports['default'];

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _VacancyCard = __webpack_require__(593);
	
	var _VacancyCard2 = _interopRequireDefault(_VacancyCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _VacancyCard2.default;
	module.exports = exports['default'];

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _VacancyListBlock = __webpack_require__(594);
	
	var _VacancyListBlock2 = _interopRequireDefault(_VacancyListBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _VacancyListBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WebcamBlock = exports.default = undefined;
	
	var _WebcamBlock2 = __webpack_require__(604);
	
	var _WebcamBlock3 = _interopRequireDefault(_WebcamBlock2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _WebcamBlock3.default;
	exports.WebcamBlock = _WebcamBlock3.default;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fromQueryString = __webpack_require__(213);
	
	var _fromQueryString2 = _interopRequireDefault(_fromQueryString);
	
	var _replaceQueryParameters = __webpack_require__(214);
	
	var _replaceQueryParameters2 = _interopRequireDefault(_replaceQueryParameters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _inQueryStringArrayDelimiter = '~';
	
	var _getUndefinedIfEmpty = function _getUndefinedIfEmpty(value) {
	    return !value || value === '' || value.length === 0 ? undefined : value;
	};
	
	var getFilterSelectedValues = function getFilterSelectedValues(filter, activeFilter) {
	    var activeFilterItem = filter.items.find(function (item) {
	        return item.key == activeFilter;
	    });
	    return activeFilterItem ? activeFilterItem.key : null;
	};
	
	var createQuery = function createQuery() {
	    return new Object();
	};
	
	var setQueryValue = function setQueryValue(query, name, value) {
	    query[name] = _getUndefinedIfEmpty(value);
	};
	
	var setToQueryFilterOptions = function setToQueryFilterOptions(query, filter, name, activeFilter) {
	    if (!filter) {
	        return;
	    }
	
	    setQueryValue(query, name, getFilterSelectedValues(filter, activeFilter));
	};
	
	var setToQueryTextInputValue = function setToQueryTextInputValue(query, name) {
	    var currentValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	    setQueryValue(query, name, currentValue);
	};
	
	var updatePageQueryString = function updatePageQueryString(query) {
	    query = _extends({}, query);
	    for (var key in query) {
	        var value = query[key];
	        if (Array.isArray(value)) query[key] = value.join(_inQueryStringArrayDelimiter);
	    }
	    var newUrl = (0, _replaceQueryParameters2.default)(window.location.toString(), query);
	    window.history.replaceState({}, document.title, newUrl);
	};
	
	var fillQueryFromPageQueryString = function fillQueryFromPageQueryString(query) {
	    var parsedQuery = (0, _fromQueryString2.default)(window.location.search.replace(/\+/g, ' '));
	    for (var key in parsedQuery) {
	        var value = parsedQuery[key];
	        if (value.includes(_inQueryStringArrayDelimiter)) parsedQuery[key] = value.split(_inQueryStringArrayDelimiter);
	    }
	    Object.assign(query, parsedQuery);
	};
	
	exports.default = {
	    createQuery: createQuery,
	    setQueryValue: setQueryValue,
	    getFilterSelectedValues: getFilterSelectedValues,
	    setToQueryFilterOptions: setToQueryFilterOptions,
	    setToQueryTextInputValue: setToQueryTextInputValue,
	    updatePageQueryString: updatePageQueryString,
	    fillQueryFromPageQueryString: fillQueryFromPageQueryString
	};
	module.exports = exports['default'];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(623);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(622);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(634);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(81);
	var document = __webpack_require__(41).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(48) && !__webpack_require__(61)(function () {
	  return Object.defineProperty(__webpack_require__(253)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(251);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(139);
	var $export = __webpack_require__(49);
	var redefine = __webpack_require__(261);
	var hide = __webpack_require__(62);
	var has = __webpack_require__(50);
	var Iterators = __webpack_require__(138);
	var $iterCreate = __webpack_require__(640);
	var setToStringTag = __webpack_require__(143);
	var getPrototypeOf = __webpack_require__(258);
	var ITERATOR = __webpack_require__(63)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(259);
	var hiddenKeys = __webpack_require__(137).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(50);
	var toObject = __webpack_require__(147);
	var IE_PROTO = __webpack_require__(144)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(50);
	var toIObject = __webpack_require__(42);
	var arrayIndexOf = __webpack_require__(636)(false);
	var IE_PROTO = __webpack_require__(144)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(49);
	var core = __webpack_require__(35);
	var fails = __webpack_require__(61);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(62);


/***/ }),
/* 262 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	module.exports = exports['default'];

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),
/* 264 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_3S-8lZ17jVpvnIUB3Lv1X1","tabs-sticky":"_1HBStZatO1wpLRucS0ZuOa","tabs-scroll-container":"_3pVgeyY3DfLJ-FPB36s_fk","tabs-container":"wq9SHEQBLzZVnlG8JuWoH","tabs":"_1HKr97XnUMgeO6kf--VPRz","tab":"_2YK8sQjr0HGfIpK3BQdYD2","no-results":"I1NzMzPIFA-svEopqv0fA","tab-button":"_3qUTC5IOA67Rzc_LmQsDbk","active":"_3qN_64Fd29wRdSsfdwU2wv","grayed-out":"_2T0mP4dBFY7objjSp1DLB6","search":"_2oxI1Oi-ccxCBSAIt19TkE","search-form":"_1gWonw0_xpBI2HbamsVT_8"};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(19);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	module.exports = "/Public/build/c12d6eed43d097f0d3e3e2e630bd5a98.svg";

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	module.exports = "/Public/build/67e051c7f491a0c8008be44863593d15.svg";

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(33);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 272 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(879),
	    isArguments = __webpack_require__(170),
	    isArray = __webpack_require__(27),
	    isBuffer = __webpack_require__(172),
	    isIndex = __webpack_require__(165),
	    isTypedArray = __webpack_require__(297);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 274 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(279);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(157),
	    arrayEach = __webpack_require__(272),
	    assignValue = __webpack_require__(160),
	    baseAssign = __webpack_require__(854),
	    baseAssignIn = __webpack_require__(855),
	    cloneBuffer = __webpack_require__(885),
	    copyArray = __webpack_require__(892),
	    copySymbols = __webpack_require__(893),
	    copySymbolsIn = __webpack_require__(894),
	    getAllKeys = __webpack_require__(283),
	    getAllKeysIn = __webpack_require__(284),
	    getTag = __webpack_require__(286),
	    initCloneArray = __webpack_require__(910),
	    initCloneByTag = __webpack_require__(911),
	    initCloneObject = __webpack_require__(912),
	    isArray = __webpack_require__(27),
	    isBuffer = __webpack_require__(172),
	    isObject = __webpack_require__(36),
	    keys = __webpack_require__(69);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(859),
	    createBaseEach = __webpack_require__(896);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(158),
	    isArray = __webpack_require__(27);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(52);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(847),
	    arraySome = __webpack_require__(853),
	    cacheHas = __webpack_require__(883);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(945),
	    overRest = __webpack_require__(931),
	    setToString = __webpack_require__(935);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(278),
	    getSymbols = __webpack_require__(164),
	    keys = __webpack_require__(69);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(278),
	    getSymbolsIn = __webpack_require__(285),
	    keysIn = __webpack_require__(298);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(158),
	    getPrototype = __webpack_require__(163),
	    getSymbols = __webpack_require__(164),
	    stubArray = __webpack_require__(300);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(843),
	    Map = __webpack_require__(155),
	    Promise = __webpack_require__(845),
	    Set = __webpack_require__(846),
	    WeakMap = __webpack_require__(848),
	    baseGetTag = __webpack_require__(65),
	    toSource = __webpack_require__(292);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 288 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 290 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 292 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(272),
	    baseEach = __webpack_require__(277),
	    castFunction = __webpack_require__(884),
	    isArray = __webpack_require__(27);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(105);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(860),
	    hasPath = __webpack_require__(904);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(161);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(865),
	    baseUnary = __webpack_require__(881),
	    nodeUtil = __webpack_require__(929);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(273),
	    baseKeysIn = __webpack_require__(868),
	    isArrayLike = __webpack_require__(171);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(274),
	    baseClone = __webpack_require__(276),
	    baseUnset = __webpack_require__(882),
	    castPath = __webpack_require__(66),
	    copyObject = __webpack_require__(84),
	    customOmitClone = __webpack_require__(898),
	    flatRest = __webpack_require__(281),
	    getAllKeysIn = __webpack_require__(284);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ }),
/* 300 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(880);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Collapse = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(1050);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SPRING_PRECISION = 1;
	
	var WAITING = 'WAITING';
	var RESIZING = 'RESIZING';
	var RESTING = 'RESTING';
	var IDLING = 'IDLING';
	
	var noop = function noop() {
	  return null;
	};
	var css = {
	  collapse: 'ReactCollapse--collapse',
	  content: 'ReactCollapse--content'
	};
	
	var Collapse = exports.Collapse = function (_React$PureComponent) {
	  _inherits(Collapse, _React$PureComponent);
	
	  function Collapse(props) {
	    _classCallCheck(this, Collapse);
	
	    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      currentState: IDLING,
	      from: 0,
	      to: 0
	    };
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          isOpened = _props.isOpened,
	          forceInitialAnimation = _props.forceInitialAnimation,
	          onRest = _props.onRest;
	
	      if (isOpened) {
	        var to = this.getTo();
	        if (forceInitialAnimation) {
	          var from = this.wrapper.clientHeight;
	          this.setState({ currentState: RESIZING, from: from, to: to });
	        } else {
	          this.setState({ currentState: IDLING, from: to, to: to });
	        }
	      }
	      onRest();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hasNestedCollapse) {
	        // For nested collapses we do not need to change to waiting state
	        // and should keep `height:auto`
	        // Because children will be animated and height will not jump anyway
	        // See https://github.com/nkbt/react-collapse/issues/76 for more details
	        if (nextProps.isOpened !== this.props.isOpened) {
	          // Still go to WAITING state if own isOpened was changed
	          this.setState({ currentState: WAITING });
	        }
	      } else if (this.state.currentState === IDLING && (nextProps.isOpened || this.props.isOpened)) {
	        this.setState({ currentState: WAITING });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(_, prevState) {
	      var _props2 = this.props,
	          isOpened = _props2.isOpened,
	          onRest = _props2.onRest,
	          onMeasure = _props2.onMeasure;
	
	
	      if (this.state.currentState === IDLING) {
	        onRest();
	        return;
	      }
	
	      if (prevState.to !== this.state.to) {
	        onMeasure({ height: this.state.to, width: this.content.clientWidth });
	      }
	
	      var from = this.wrapper.clientHeight;
	      var to = isOpened ? this.getTo() : 0;
	
	      if (from !== to) {
	        this.setState({ currentState: RESIZING, from: from, to: to });
	        return;
	      }
	
	      if (this.state.currentState === RESTING || this.state.currentState === WAITING) {
	        this.setState({ currentState: IDLING, from: from, to: to });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      cancelAnimationFrame(this.raf);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_reactMotion.Motion, _extends({}, this.getMotionProps(), {
	        onRest: this.onRest,
	        children: this.renderContent }));
	    }
	  }]);
	
	  return Collapse;
	}(_react2.default.PureComponent);
	
	Collapse.propTypes = {
	  isOpened: _propTypes2.default.bool.isRequired,
	  springConfig: _propTypes2.default.objectOf(_propTypes2.default.number),
	  forceInitialAnimation: _propTypes2.default.bool,
	
	  hasNestedCollapse: _propTypes2.default.bool,
	
	  fixedHeight: _propTypes2.default.number,
	
	  theme: _propTypes2.default.objectOf(_propTypes2.default.string),
	  style: _propTypes2.default.object,
	
	  onRender: _propTypes2.default.func,
	  onRest: _propTypes2.default.func,
	  onMeasure: _propTypes2.default.func,
	
	  children: _propTypes2.default.node.isRequired
	};
	Collapse.defaultProps = {
	  forceInitialAnimation: false,
	  hasNestedCollapse: false,
	  fixedHeight: -1,
	  style: {},
	  theme: css,
	  onRender: noop,
	  onRest: noop,
	  onMeasure: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onContentRef = function (content) {
	    _this2.content = content;
	  };
	
	  this.onWrapperRef = function (wrapper) {
	    _this2.wrapper = wrapper;
	  };
	
	  this.onRest = function () {
	    _this2.raf = requestAnimationFrame(_this2.setResting);
	  };
	
	  this.setResting = function () {
	    _this2.setState({ currentState: RESTING });
	  };
	
	  this.getTo = function () {
	    var fixedHeight = _this2.props.fixedHeight;
	
	    return fixedHeight > -1 ? fixedHeight : _this2.content.clientHeight;
	  };
	
	  this.getWrapperStyle = function (height) {
	    if (_this2.state.currentState === IDLING && _this2.state.to) {
	      var fixedHeight = _this2.props.fixedHeight;
	
	      if (fixedHeight > -1) {
	        return { overflow: 'hidden', height: fixedHeight };
	      }
	      return { height: 'auto' };
	    }
	
	    if (_this2.state.currentState === WAITING && !_this2.state.to) {
	      return { overflow: 'hidden', height: 0 };
	    }
	
	    return { overflow: 'hidden', height: Math.max(0, height) };
	  };
	
	  this.getMotionProps = function () {
	    var springConfig = _this2.props.springConfig;
	
	
	    return _this2.state.currentState === IDLING ? {
	      // When completely stable, instantly jump to the position
	      defaultStyle: { height: _this2.state.to },
	      style: { height: _this2.state.to }
	    } : {
	      // Otherwise, animate
	      defaultStyle: { height: _this2.state.from },
	      style: { height: (0, _reactMotion.spring)(_this2.state.to, _extends({ precision: SPRING_PRECISION }, springConfig)) }
	    };
	  };
	
	  this.renderContent = function (_ref) {
	    var height = _ref.height;
	
	    // eslint-disable-line
	    var _props3 = _this2.props,
	        _isOpened = _props3.isOpened,
	        _springConfig = _props3.springConfig,
	        _forceInitialAnimation = _props3.forceInitialAnimation,
	        _hasNestedCollapse = _props3.hasNestedCollapse,
	        _fixedHeight = _props3.fixedHeight,
	        theme = _props3.theme,
	        style = _props3.style,
	        onRender = _props3.onRender,
	        _onRest = _props3.onRest,
	        _onMeasure = _props3.onMeasure,
	        children = _props3.children,
	        props = _objectWithoutProperties(_props3, ['isOpened', 'springConfig', 'forceInitialAnimation', 'hasNestedCollapse', 'fixedHeight', 'theme', 'style', 'onRender', 'onRest', 'onMeasure', 'children']);
	
	    var _state = _this2.state,
	        from = _state.from,
	        to = _state.to;
	
	    // DANGEROUS, use with caution, never do setState with it
	
	    onRender({ current: height, from: from, to: to });
	
	    return _react2.default.createElement(
	      'div',
	      _extends({
	        ref: _this2.onWrapperRef,
	        className: theme.collapse,
	        style: _extends({}, _this2.getWrapperStyle(Math.max(0, height)), style)
	      }, props),
	      _react2.default.createElement(
	        'div',
	        { ref: _this2.onContentRef, className: theme.content },
	        children
	      )
	    );
	  };
	};

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(55);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(72);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactInstrumentation = __webpack_require__(28);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1020);
	var warning = __webpack_require__(6);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(196);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var LinkedValueUtils = __webpack_require__(185);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactUpdates = __webpack_require__(34);
	
	var warning = __webpack_require__(6);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var ReactUpdates = __webpack_require__(34);
	var Transaction = __webpack_require__(112);
	
	var emptyFunction = __webpack_require__(19);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(962);
	var BeforeInputEventPlugin = __webpack_require__(964);
	var ChangeEventPlugin = __webpack_require__(966);
	var DefaultEventPluginOrder = __webpack_require__(968);
	var EnterLeaveEventPlugin = __webpack_require__(969);
	var HTMLDOMPropertyConfig = __webpack_require__(971);
	var ReactComponentBrowserEnvironment = __webpack_require__(973);
	var ReactDOMComponent = __webpack_require__(976);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactDOMEmptyComponent = __webpack_require__(977);
	var ReactDOMTreeTraversal = __webpack_require__(986);
	var ReactDOMTextComponent = __webpack_require__(984);
	var ReactDefaultBatchingStrategy = __webpack_require__(309);
	var ReactEventListener = __webpack_require__(989);
	var ReactInjection = __webpack_require__(990);
	var ReactReconcileTransaction = __webpack_require__(994);
	var SVGDOMPropertyConfig = __webpack_require__(999);
	var SelectEventPlugin = __webpack_require__(1000);
	var SimpleEventPlugin = __webpack_require__(1001);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(982);
	
	var containsNode = __webpack_require__(824);
	var focusNode = __webpack_require__(266);
	var getActiveElement = __webpack_require__(267);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1012);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMLazyTree = __webpack_require__(71);
	var DOMProperty = __webpack_require__(72);
	var React = __webpack_require__(40);
	var ReactBrowserEventEmitter = __webpack_require__(110);
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactDOMContainerInfo = __webpack_require__(307);
	var ReactDOMFeatureFlags = __webpack_require__(978);
	var ReactFeatureFlags = __webpack_require__(312);
	var ReactInstanceMap = __webpack_require__(89);
	var ReactInstrumentation = __webpack_require__(28);
	var ReactMarkupChecksum = __webpack_require__(315);
	var ReactReconciler = __webpack_require__(56);
	var ReactUpdateQueue = __webpack_require__(188);
	var ReactUpdates = __webpack_require__(34);
	
	var emptyObject = __webpack_require__(43);
	var instantiateReactComponent = __webpack_require__(193);
	var invariant = __webpack_require__(4);
	var setInnerHTML = __webpack_require__(114);
	var shouldUpdateReactComponent = __webpack_require__(195);
	var warning = __webpack_require__(6);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var React = __webpack_require__(40);
	
	var invariant = __webpack_require__(4);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var PooledClass = __webpack_require__(55);
	var Transaction = __webpack_require__(112);
	var ReactInstrumentation = __webpack_require__(28);
	var ReactServerUpdateQueue = __webpack_require__(998);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 319 */
207,
/* 320 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(317);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(23);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(17);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  delete inst._wrapperState.valueTracker;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(23);
	var escapeTextContentForBrowser = __webpack_require__(113);
	var setInnerHTML = __webpack_require__(114);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var REACT_ELEMENT_TYPE = __webpack_require__(987);
	
	var getIteratorFn = __webpack_require__(1017);
	var invariant = __webpack_require__(4);
	var KeyEscapeUtils = __webpack_require__(184);
	var warning = __webpack_require__(6);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(983);


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _latlng = __webpack_require__(45);
	
	var _latlng2 = _interopRequireDefault(_latlng);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.shape({
	  center: _latlng2.default,
	  zoom: _propTypes2.default.number
	});

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScrollManager = undefined;
	
	var _windowScrollManager = __webpack_require__(340);
	
	var _windowScrollManager2 = _interopRequireDefault(_windowScrollManager);
	
	var _Plx = __webpack_require__(1053);
	
	var _Plx2 = _interopRequireDefault(_Plx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Plx2.default;
	exports.ScrollManager = _windowScrollManager2.default;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = __webpack_require__(1);
	
	var _events = __webpack_require__(1067);
	
	var _find = _interopRequireDefault(__webpack_require__(1068));
	
	var _getClosestTransformedParent = _interopRequireDefault(__webpack_require__(1069));
	
	var _rect = __webpack_require__(1070);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var buildTopStyles = function buildTopStyles(container, props) {
	  var bottomOffset = props.bottomOffset,
	      hideOnBoundaryHit = props.hideOnBoundaryHit;
	  var top = container.top,
	      height = container.height,
	      width = container.width,
	      boundaryBottom = container.boundaryBottom; // above boundary
	
	  if (hideOnBoundaryHit || top + height + bottomOffset < boundaryBottom) {
	    return {
	      top: top + "px",
	      width: width + "px",
	      position: 'fixed'
	    };
	  } // reaching boundary
	
	
	  if (!hideOnBoundaryHit && boundaryBottom > 0) {
	    return {
	      top: boundaryBottom - height - bottomOffset + "px",
	      width: width + "px",
	      position: 'fixed'
	    };
	  } // below boundary
	
	
	  return {
	    width: width + "px",
	    bottom: bottomOffset + "px",
	    position: 'absolute'
	  };
	};
	
	var buildBottomStyles = function buildBottomStyles(container, props) {
	  var bottomOffset = props.bottomOffset,
	      hideOnBoundaryHit = props.hideOnBoundaryHit;
	  var bottom = container.bottom,
	      height = container.height,
	      width = container.width,
	      boundaryTop = container.boundaryTop;
	
	  if (hideOnBoundaryHit || bottom - height - bottomOffset > boundaryTop) {
	    return {
	      width: width + "px",
	      top: bottom - height + "px",
	      position: 'fixed'
	    };
	  }
	
	  return {
	    width: width + "px",
	    top: bottomOffset + "px",
	    position: 'absolute'
	  };
	};
	
	var buildStickyStyle = function buildStickyStyle(mode, props, container) {
	  return (mode === 'top' ? buildTopStyles : buildBottomStyles)(container, props);
	};
	
	var isEqual = function isEqual(obj1, obj2) {
	  var styles1 = obj1.wrapperStyles;
	  var styles2 = obj2.wrapperStyles;
	
	  if (obj1.isFixed !== obj2.isFixed || obj1.height !== obj2.height || !styles1 && styles2 || styles1 && !styles2) {
	    return false;
	  }
	
	  if (!styles2) {
	    // we need this condition to make Flow happy
	    return true;
	  }
	
	  for (var field in styles1) {
	    if (styles1.hasOwnProperty(field) && styles1[field] !== styles2[field]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	var Sticky = /*#__PURE__*/function (_Component) {
	  _inheritsLoose(Sticky, _Component);
	
	  function Sticky() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	    _this.holderEl = null;
	    _this.wrapperEl = null;
	    _this.el = null;
	    _this.scrollEl = null;
	    _this.boundaryEl = null;
	    _this.disabled = false;
	    _this.checkPositionIntervalId = void 0;
	    _this.lastMinHeight = void 0;
	    _this.state = {
	      isFixed: false,
	      wrapperStyles: null,
	      holderStyles: null,
	      height: 0
	    };
	
	    _this.holderRef = function (holderEl) {
	      if (holderEl === _this.holderEl) {
	        return;
	      }
	
	      _this.holderEl = holderEl;
	    };
	
	    _this.wrapperRef = function (wrapperEl) {
	      if (wrapperEl === _this.wrapperEl) {
	        return;
	      }
	
	      _this.wrapperEl = wrapperEl;
	
	      _this.updateScrollEl();
	
	      _this.updateBoundaryEl();
	    };
	
	    _this.checkPosition = function () {
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          holderEl = _assertThisInitialize.holderEl,
	          wrapperEl = _assertThisInitialize.wrapperEl,
	          boundaryEl = _assertThisInitialize.boundaryEl,
	          scrollEl = _assertThisInitialize.scrollEl,
	          disabled = _assertThisInitialize.disabled;
	
	      if (!scrollEl || !holderEl || !wrapperEl) {
	        console.error("Missing required elements:", {
	          scrollEl: scrollEl,
	          holderEl: holderEl,
	          wrapperEl: wrapperEl
	        });
	        return;
	      }
	
	      var _this$props = _this.props,
	          mode = _this$props.mode,
	          onFixedToggle = _this$props.onFixedToggle,
	          offsetTransforms = _this$props.offsetTransforms,
	          isIOSFixEnabled = _this$props.isIOSFixEnabled,
	          dontUpdateHolderHeightWhenSticky = _this$props.dontUpdateHolderHeightWhenSticky;
	
	      if (disabled) {
	        if (_this.state.isFixed) {
	          _this.setState({
	            isFixed: false,
	            wrapperStyles: {}
	          });
	        }
	
	        return;
	      }
	
	      if (!holderEl.getBoundingClientRect || !wrapperEl.getBoundingClientRect) {
	        return;
	      }
	
	      var holderRect = holderEl.getBoundingClientRect();
	      var wrapperRect = wrapperEl.getBoundingClientRect();
	      var boundaryRect = boundaryEl ? (0, _rect.getRect)(boundaryEl) : _rect.infiniteRect;
	      var scrollRect = (0, _rect.getRect)(scrollEl);
	
	      var isFixed = _this.isFixed(holderRect, wrapperRect, boundaryRect, scrollRect);
	
	      var offsets = null;
	
	      if (offsetTransforms && isFixed) {
	        var closestTransformedParent = (0, _getClosestTransformedParent.default)(scrollEl);
	
	        if (closestTransformedParent) {
	          offsets = (0, _rect.getRect)(closestTransformedParent);
	        }
	      }
	
	      var minHeight = _this.state.isFixed && dontUpdateHolderHeightWhenSticky && _this.lastMinHeight ? _this.lastMinHeight : wrapperRect.height;
	      _this.lastMinHeight = minHeight; // To ensure that this component becomes sticky immediately on mobile devices instead
	      // of disappearing until the scroll event completes, we add `transform: translateZ(0)`
	      // to 'kick' rendering of this element to the GPU
	      // @see http://stackoverflow.com/questions/32875046
	
	      var iosRenderingFixStyles = isIOSFixEnabled ? {
	        transform: 'translateZ(0)',
	        WebkitTransform: 'translateZ(0)'
	      } : null;
	      var newState = {
	        isFixed: isFixed,
	        height: wrapperRect.height,
	        holderStyles: {
	          minHeight: minHeight + "px"
	        },
	        wrapperStyles: isFixed ? _extends({}, iosRenderingFixStyles, buildStickyStyle(mode, _this.props, {
	          boundaryTop: mode === 'bottom' ? boundaryRect.top : 0,
	          boundaryBottom: mode === 'top' ? boundaryRect.bottom : 0,
	          top: mode === 'top' ? scrollRect.top - (offsets ? offsets.top : 0) : 0,
	          bottom: mode === 'bottom' ? scrollRect.bottom - (offsets ? offsets.bottom : 0) : 0,
	          width: holderRect.width,
	          height: wrapperRect.height
	        })) : iosRenderingFixStyles
	      };
	
	      if (isFixed !== _this.state.isFixed && onFixedToggle && typeof onFixedToggle === 'function') {
	        onFixedToggle(isFixed);
	      }
	
	      if (!isEqual(_this.state, newState)) {
	        _this.setState(newState);
	      }
	    };
	
	    return _this;
	  }
	
	  var _proto = Sticky.prototype;
	
	  _proto.isFixed = function isFixed(holderRect, wrapperRect, boundaryRect, scrollRect) {
	    var _this$props2 = this.props,
	        hideOnBoundaryHit = _this$props2.hideOnBoundaryHit,
	        bottomOffset = _this$props2.bottomOffset,
	        topOffset = _this$props2.topOffset,
	        mode = _this$props2.mode;
	
	    if (this.disabled) {
	      return false;
	    }
	
	    if (hideOnBoundaryHit && boundaryRect && !(0, _rect.isIntersecting)(boundaryRect, scrollRect, topOffset, bottomOffset)) {
	      return false;
	    }
	
	    var hideOffset = hideOnBoundaryHit ? wrapperRect.height + bottomOffset : 0;
	
	    if (mode === 'top') {
	      return holderRect.top + topOffset < scrollRect.top && scrollRect.top + hideOffset <= boundaryRect.bottom;
	    }
	
	    return holderRect.bottom - topOffset > scrollRect.bottom && scrollRect.bottom - hideOffset >= boundaryRect.top;
	  };
	
	  _proto.updateScrollEl = function updateScrollEl() {
	    if (!this.wrapperEl) {
	      return;
	    }
	
	    if (this.scrollEl) {
	      (0, _events.unlisten)(this.scrollEl, ['scroll'], this.checkPosition);
	      this.scrollEl = null;
	    }
	
	    var scrollElement = this.props.scrollElement;
	
	    if (typeof scrollElement === 'string') {
	      this.scrollEl = (0, _find.default)(scrollElement, this.wrapperEl);
	    } else {
	      this.scrollEl = scrollElement;
	    }
	
	    if (this.scrollEl) {
	      (0, _events.listen)(this.scrollEl, ['scroll'], this.checkPosition);
	    } else {
	      console.error('Cannot find scrollElement ' + (typeof scrollElement === 'string' ? scrollElement : 'unknown'));
	    }
	  };
	
	  _proto.updateBoundaryEl = function updateBoundaryEl() {
	    if (!this.wrapperEl) {
	      return;
	    }
	
	    var boundaryElement = this.props.boundaryElement;
	    this.boundaryEl = (0, _find.default)(boundaryElement, this.wrapperEl);
	
	    if (this.boundaryEl === window || this.boundaryEl === document) {
	      // such objects can't be used as boundary
	      // and in fact there is no point in such a case
	      this.boundaryEl = null;
	    }
	  };
	
	  _proto.initialize = function initialize() {
	    var _this$props3 = this.props,
	        positionRecheckInterval = _this$props3.positionRecheckInterval,
	        disabled = _this$props3.disabled;
	    this.disabled = disabled; // we should always listen to window events because they will affect the layout of the whole page
	
	    (0, _events.listen)(window, ['scroll', 'resize', 'pageshow', 'load'], this.checkPosition);
	    this.checkPosition();
	
	    if (positionRecheckInterval) {
	      this.checkPositionIntervalId = setInterval(this.checkPosition, positionRecheckInterval);
	    }
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(_ref) {
	    var scrollElement = _ref.scrollElement,
	        boundaryElement = _ref.boundaryElement,
	        disabled = _ref.disabled;
	
	    if (scrollElement !== this.props.scrollElement) {
	      this.updateScrollEl();
	    }
	
	    if (boundaryElement !== this.props.boundaryElement) {
	      this.updateBoundaryEl();
	    }
	
	    if (disabled !== this.props.disabled) {
	      this.disabled = this.props.disabled;
	      this.checkPosition();
	    }
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.initialize();
	
	    if (this.wrapperEl === null) {
	      console.error("Wrapper element is missing, please make sure that you have assigned refs correctly");
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    if (this.scrollEl) {
	      (0, _events.unlisten)(this.scrollEl, ['scroll'], this.checkPosition);
	    }
	
	    (0, _events.unlisten)(window, ['scroll', 'resize', 'pageshow', 'load'], this.checkPosition);
	    this.boundaryEl = null;
	    this.scrollEl = null;
	    clearInterval(this.checkPositionIntervalId);
	  };
	
	  _proto.render = function render() {
	    var holderRef = this.holderRef,
	        wrapperRef = this.wrapperRef;
	    var _this$state = this.state,
	        isFixed = _this$state.isFixed,
	        wrapperStyles = _this$state.wrapperStyles,
	        holderStyles = _this$state.holderStyles;
	    return this.props.children({
	      holderRef: holderRef,
	      wrapperRef: wrapperRef,
	      isFixed: isFixed,
	      wrapperStyles: wrapperStyles,
	      holderStyles: holderStyles
	    });
	  };
	
	  return Sticky;
	}(_react.Component);
	
	Sticky.defaultProps = {
	  mode: 'top',
	  topOffset: 0,
	  bottomOffset: 0,
	  isIOSFixEnabled: true,
	  disabled: false,
	  onFixedToggle: null,
	  boundaryElement: null,
	  scrollElement: 'window',
	  dontUpdateHolderHeightWhenSticky: false
	};
	var _default = Sticky;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(625);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(339);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(1075);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(37);
	
	var ReactCurrentOwner = __webpack_require__(29);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(6);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	var scroll = __webpack_require__(1082);
	
	function calculateScrollOffset(elem, additionalOffset, alignment) {
	  var body = document.body,
	      html = document.documentElement;
	
	  var elemRect = elem.getBoundingClientRect();
	  var clientHeight = html.clientHeight;
	  var documentHeight = Math.max( body.scrollHeight, body.offsetHeight,
	                                 html.clientHeight, html.scrollHeight, html.offsetHeight );
	
	  additionalOffset = additionalOffset || 0;
	
	  var scrollPosition;
	  if (alignment === 'bottom') {
	    scrollPosition = elemRect.bottom - clientHeight;
	  } else if (alignment === 'middle') {
	    scrollPosition = elemRect.bottom - clientHeight / 2 - elemRect.height / 2;
	  } else { // top and default
	    scrollPosition = elemRect.top;
	  }
	
	  var maxScrollPosition = documentHeight - clientHeight;
	  return Math.min(scrollPosition + additionalOffset + window.pageYOffset,
	                  maxScrollPosition);
	}
	
	module.exports = function (elem, options) {
	  options = options || {};
	  if (typeof elem === 'string') elem = document.querySelector(elem);
	  if (elem) return scroll(0, calculateScrollOffset(elem, options.offset, options.align), options);
	};


/***/ }),
/* 338 */
/***/ (function(module, exports) {

	/*!
	  * Stickyfill – `position: sticky` polyfill
	  * v. 2.1.0 | https://github.com/wilddeer/stickyfill
	  * MIT License
	  */
	
	;(function(window, document) {
	    'use strict';
	    
	    /*
	     * 1. Check if the browser supports `position: sticky` natively or is too old to run the polyfill.
	     *    If either of these is the case set `seppuku` flag. It will be checked later to disable key features
	     *    of the polyfill, but the API will remain functional to avoid breaking things.
	     */
	    
	    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	    
	    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	    
	    var seppuku = false;
	    
	    var isWindowDefined = typeof window !== 'undefined';
	    
	    // The polyfill can’t function properly without `window` or `window.getComputedStyle`.
	    if (!isWindowDefined || !window.getComputedStyle) seppuku = true;
	    // Dont’t get in a way if the browser supports `position: sticky` natively.
	    else {
	            (function () {
	                var testNode = document.createElement('div');
	    
	                if (['', '-webkit-', '-moz-', '-ms-'].some(function (prefix) {
	                    try {
	                        testNode.style.position = prefix + 'sticky';
	                    } catch (e) {}
	    
	                    return testNode.style.position != '';
	                })) seppuku = true;
	            })();
	        }
	    
	    /*
	     * 2. “Global” vars used across the polyfill
	     */
	    var isInitialized = false;
	    
	    // Check if Shadow Root constructor exists to make further checks simpler
	    var shadowRootExists = typeof ShadowRoot !== 'undefined';
	    
	    // Last saved scroll position
	    var scroll = {
	        top: null,
	        left: null
	    };
	    
	    // Array of created Sticky instances
	    var stickies = [];
	    
	    /*
	     * 3. Utility functions
	     */
	    function extend(targetObj, sourceObject) {
	        for (var key in sourceObject) {
	            if (sourceObject.hasOwnProperty(key)) {
	                targetObj[key] = sourceObject[key];
	            }
	        }
	    }
	    
	    function parseNumeric(val) {
	        return parseFloat(val) || 0;
	    }
	    
	    function getDocOffsetTop(node) {
	        var docOffsetTop = 0;
	    
	        while (node) {
	            docOffsetTop += node.offsetTop;
	            node = node.offsetParent;
	        }
	    
	        return docOffsetTop;
	    }
	    
	    /*
	     * 4. Sticky class
	     */
	    
	    var Sticky = function () {
	        function Sticky(node) {
	            _classCallCheck(this, Sticky);
	    
	            if (!(node instanceof HTMLElement)) throw new Error('First argument must be HTMLElement');
	            if (stickies.some(function (sticky) {
	                return sticky._node === node;
	            })) throw new Error('Stickyfill is already applied to this node');
	    
	            this._node = node;
	            this._stickyMode = null;
	            this._active = false;
	    
	            stickies.push(this);
	    
	            this.refresh();
	        }
	    
	        _createClass(Sticky, [{
	            key: 'refresh',
	            value: function refresh() {
	                if (seppuku || this._removed) return;
	                if (this._active) this._deactivate();
	    
	                var node = this._node;
	    
	                /*
	                 * 1. Save node computed props
	                 */
	                var nodeComputedStyle = getComputedStyle(node);
	                var nodeComputedProps = {
	                    position: nodeComputedStyle.position,
	                    top: nodeComputedStyle.top,
	                    display: nodeComputedStyle.display,
	                    marginTop: nodeComputedStyle.marginTop,
	                    marginBottom: nodeComputedStyle.marginBottom,
	                    marginLeft: nodeComputedStyle.marginLeft,
	                    marginRight: nodeComputedStyle.marginRight,
	                    cssFloat: nodeComputedStyle.cssFloat
	                };
	    
	                /*
	                 * 2. Check if the node can be activated
	                 */
	                if (isNaN(parseFloat(nodeComputedProps.top)) || nodeComputedProps.display == 'table-cell' || nodeComputedProps.display == 'none') return;
	    
	                this._active = true;
	    
	                /*
	                 * 3. Check if the current node position is `sticky`. If it is, it means that the browser supports sticky positioning,
	                 *    but the polyfill was force-enabled. We set the node’s position to `static` before continuing, so that the node
	                 *    is in it’s initial position when we gather its params.
	                 */
	                var originalPosition = node.style.position;
	                if (nodeComputedStyle.position == 'sticky' || nodeComputedStyle.position == '-webkit-sticky') node.style.position = 'static';
	    
	                /*
	                 * 4. Get necessary node parameters
	                 */
	                var referenceNode = node.parentNode;
	                var parentNode = shadowRootExists && referenceNode instanceof ShadowRoot ? referenceNode.host : referenceNode;
	                var nodeWinOffset = node.getBoundingClientRect();
	                var parentWinOffset = parentNode.getBoundingClientRect();
	                var parentComputedStyle = getComputedStyle(parentNode);
	    
	                this._parent = {
	                    node: parentNode,
	                    styles: {
	                        position: parentNode.style.position
	                    },
	                    offsetHeight: parentNode.offsetHeight
	                };
	                this._offsetToWindow = {
	                    left: nodeWinOffset.left,
	                    right: document.documentElement.clientWidth - nodeWinOffset.right
	                };
	                this._offsetToParent = {
	                    top: nodeWinOffset.top - parentWinOffset.top - parseNumeric(parentComputedStyle.borderTopWidth),
	                    left: nodeWinOffset.left - parentWinOffset.left - parseNumeric(parentComputedStyle.borderLeftWidth),
	                    right: -nodeWinOffset.right + parentWinOffset.right - parseNumeric(parentComputedStyle.borderRightWidth)
	                };
	                this._styles = {
	                    position: originalPosition,
	                    top: node.style.top,
	                    bottom: node.style.bottom,
	                    left: node.style.left,
	                    right: node.style.right,
	                    width: node.style.width,
	                    marginTop: node.style.marginTop,
	                    marginLeft: node.style.marginLeft,
	                    marginRight: node.style.marginRight
	                };
	    
	                var nodeTopValue = parseNumeric(nodeComputedProps.top);
	                this._limits = {
	                    start: nodeWinOffset.top + window.pageYOffset - nodeTopValue,
	                    end: parentWinOffset.top + window.pageYOffset + parentNode.offsetHeight - parseNumeric(parentComputedStyle.borderBottomWidth) - node.offsetHeight - nodeTopValue - parseNumeric(nodeComputedProps.marginBottom)
	                };
	    
	                /*
	                 * 5. Ensure that the node will be positioned relatively to the parent node
	                 */
	                var parentPosition = parentComputedStyle.position;
	    
	                if (parentPosition != 'absolute' && parentPosition != 'relative') {
	                    parentNode.style.position = 'relative';
	                }
	    
	                /*
	                 * 6. Recalc node position.
	                 *    It’s important to do this before clone injection to avoid scrolling bug in Chrome.
	                 */
	                this._recalcPosition();
	    
	                /*
	                 * 7. Create a clone
	                 */
	                var clone = this._clone = {};
	                clone.node = document.createElement('div');
	    
	                // Apply styles to the clone
	                extend(clone.node.style, {
	                    width: nodeWinOffset.right - nodeWinOffset.left + 'px',
	                    height: nodeWinOffset.bottom - nodeWinOffset.top + 'px',
	                    marginTop: nodeComputedProps.marginTop,
	                    marginBottom: nodeComputedProps.marginBottom,
	                    marginLeft: nodeComputedProps.marginLeft,
	                    marginRight: nodeComputedProps.marginRight,
	                    cssFloat: nodeComputedProps.cssFloat,
	                    padding: 0,
	                    border: 0,
	                    borderSpacing: 0,
	                    fontSize: '1em',
	                    position: 'static'
	                });
	    
	                referenceNode.insertBefore(clone.node, node);
	                clone.docOffsetTop = getDocOffsetTop(clone.node);
	            }
	        }, {
	            key: '_recalcPosition',
	            value: function _recalcPosition() {
	                if (!this._active || this._removed) return;
	    
	                var stickyMode = scroll.top <= this._limits.start ? 'start' : scroll.top >= this._limits.end ? 'end' : 'middle';
	    
	                if (this._stickyMode == stickyMode) return;
	    
	                switch (stickyMode) {
	                    case 'start':
	                        extend(this._node.style, {
	                            position: 'absolute',
	                            left: this._offsetToParent.left + 'px',
	                            right: this._offsetToParent.right + 'px',
	                            top: this._offsetToParent.top + 'px',
	                            bottom: 'auto',
	                            width: 'auto',
	                            marginLeft: 0,
	                            marginRight: 0,
	                            marginTop: 0
	                        });
	                        break;
	    
	                    case 'middle':
	                        extend(this._node.style, {
	                            position: 'fixed',
	                            left: this._offsetToWindow.left + 'px',
	                            right: this._offsetToWindow.right + 'px',
	                            top: this._styles.top,
	                            bottom: 'auto',
	                            width: 'auto',
	                            marginLeft: 0,
	                            marginRight: 0,
	                            marginTop: 0
	                        });
	                        break;
	    
	                    case 'end':
	                        extend(this._node.style, {
	                            position: 'absolute',
	                            left: this._offsetToParent.left + 'px',
	                            right: this._offsetToParent.right + 'px',
	                            top: 'auto',
	                            bottom: 0,
	                            width: 'auto',
	                            marginLeft: 0,
	                            marginRight: 0
	                        });
	                        break;
	                }
	    
	                this._stickyMode = stickyMode;
	            }
	        }, {
	            key: '_fastCheck',
	            value: function _fastCheck() {
	                if (!this._active || this._removed) return;
	    
	                if (Math.abs(getDocOffsetTop(this._clone.node) - this._clone.docOffsetTop) > 1 || Math.abs(this._parent.node.offsetHeight - this._parent.offsetHeight) > 1) this.refresh();
	            }
	        }, {
	            key: '_deactivate',
	            value: function _deactivate() {
	                var _this = this;
	    
	                if (!this._active || this._removed) return;
	    
	                this._clone.node.parentNode.removeChild(this._clone.node);
	                delete this._clone;
	    
	                extend(this._node.style, this._styles);
	                delete this._styles;
	    
	                // Check whether element’s parent node is used by other stickies.
	                // If not, restore parent node’s styles.
	                if (!stickies.some(function (sticky) {
	                    return sticky !== _this && sticky._parent && sticky._parent.node === _this._parent.node;
	                })) {
	                    extend(this._parent.node.style, this._parent.styles);
	                }
	                delete this._parent;
	    
	                this._stickyMode = null;
	                this._active = false;
	    
	                delete this._offsetToWindow;
	                delete this._offsetToParent;
	                delete this._limits;
	            }
	        }, {
	            key: 'remove',
	            value: function remove() {
	                var _this2 = this;
	    
	                this._deactivate();
	    
	                stickies.some(function (sticky, index) {
	                    if (sticky._node === _this2._node) {
	                        stickies.splice(index, 1);
	                        return true;
	                    }
	                });
	    
	                this._removed = true;
	            }
	        }]);
	    
	        return Sticky;
	    }();
	    
	    /*
	     * 5. Stickyfill API
	     */
	    
	    
	    var Stickyfill = {
	        stickies: stickies,
	        Sticky: Sticky,
	    
	        forceSticky: function forceSticky() {
	            seppuku = false;
	            init();
	    
	            this.refreshAll();
	        },
	        addOne: function addOne(node) {
	            // Check whether it’s a node
	            if (!(node instanceof HTMLElement)) {
	                // Maybe it’s a node list of some sort?
	                // Take first node from the list then
	                if (node.length && node[0]) node = node[0];else return;
	            }
	    
	            // Check if Stickyfill is already applied to the node
	            // and return existing sticky
	            for (var i = 0; i < stickies.length; i++) {
	                if (stickies[i]._node === node) return stickies[i];
	            }
	    
	            // Create and return new sticky
	            return new Sticky(node);
	        },
	        add: function add(nodeList) {
	            // If it’s a node make an array of one node
	            if (nodeList instanceof HTMLElement) nodeList = [nodeList];
	            // Check if the argument is an iterable of some sort
	            if (!nodeList.length) return;
	    
	            // Add every element as a sticky and return an array of created Sticky instances
	            var addedStickies = [];
	    
	            var _loop = function _loop(i) {
	                var node = nodeList[i];
	    
	                // If it’s not an HTMLElement – create an empty element to preserve 1-to-1
	                // correlation with input list
	                if (!(node instanceof HTMLElement)) {
	                    addedStickies.push(void 0);
	                    return 'continue';
	                }
	    
	                // If Stickyfill is already applied to the node
	                // add existing sticky
	                if (stickies.some(function (sticky) {
	                    if (sticky._node === node) {
	                        addedStickies.push(sticky);
	                        return true;
	                    }
	                })) return 'continue';
	    
	                // Create and add new sticky
	                addedStickies.push(new Sticky(node));
	            };
	    
	            for (var i = 0; i < nodeList.length; i++) {
	                var _ret2 = _loop(i);
	    
	                if (_ret2 === 'continue') continue;
	            }
	    
	            return addedStickies;
	        },
	        refreshAll: function refreshAll() {
	            stickies.forEach(function (sticky) {
	                return sticky.refresh();
	            });
	        },
	        removeOne: function removeOne(node) {
	            // Check whether it’s a node
	            if (!(node instanceof HTMLElement)) {
	                // Maybe it’s a node list of some sort?
	                // Take first node from the list then
	                if (node.length && node[0]) node = node[0];else return;
	            }
	    
	            // Remove the stickies bound to the nodes in the list
	            stickies.some(function (sticky) {
	                if (sticky._node === node) {
	                    sticky.remove();
	                    return true;
	                }
	            });
	        },
	        remove: function remove(nodeList) {
	            // If it’s a node make an array of one node
	            if (nodeList instanceof HTMLElement) nodeList = [nodeList];
	            // Check if the argument is an iterable of some sort
	            if (!nodeList.length) return;
	    
	            // Remove the stickies bound to the nodes in the list
	    
	            var _loop2 = function _loop2(i) {
	                var node = nodeList[i];
	    
	                stickies.some(function (sticky) {
	                    if (sticky._node === node) {
	                        sticky.remove();
	                        return true;
	                    }
	                });
	            };
	    
	            for (var i = 0; i < nodeList.length; i++) {
	                _loop2(i);
	            }
	        },
	        removeAll: function removeAll() {
	            while (stickies.length) {
	                stickies[0].remove();
	            }
	        }
	    };
	    
	    /*
	     * 6. Setup events (unless the polyfill was disabled)
	     */
	    function init() {
	        if (isInitialized) {
	            return;
	        }
	    
	        isInitialized = true;
	    
	        // Watch for scroll position changes and trigger recalc/refresh if needed
	        function checkScroll() {
	            if (window.pageXOffset != scroll.left) {
	                scroll.top = window.pageYOffset;
	                scroll.left = window.pageXOffset;
	    
	                Stickyfill.refreshAll();
	            } else if (window.pageYOffset != scroll.top) {
	                scroll.top = window.pageYOffset;
	                scroll.left = window.pageXOffset;
	    
	                // recalc position for all stickies
	                stickies.forEach(function (sticky) {
	                    return sticky._recalcPosition();
	                });
	            }
	        }
	    
	        checkScroll();
	        window.addEventListener('scroll', checkScroll);
	    
	        // Watch for window resizes and device orientation changes and trigger refresh
	        window.addEventListener('resize', Stickyfill.refreshAll);
	        window.addEventListener('orientationchange', Stickyfill.refreshAll);
	    
	        //Fast dirty check for layout changes every 500ms
	        var fastCheckTimer = void 0;
	    
	        function startFastCheckTimer() {
	            fastCheckTimer = setInterval(function () {
	                stickies.forEach(function (sticky) {
	                    return sticky._fastCheck();
	                });
	            }, 500);
	        }
	    
	        function stopFastCheckTimer() {
	            clearInterval(fastCheckTimer);
	        }
	    
	        var docHiddenKey = void 0;
	        var visibilityChangeEventName = void 0;
	    
	        if ('hidden' in document) {
	            docHiddenKey = 'hidden';
	            visibilityChangeEventName = 'visibilitychange';
	        } else if ('webkitHidden' in document) {
	            docHiddenKey = 'webkitHidden';
	            visibilityChangeEventName = 'webkitvisibilitychange';
	        }
	    
	        if (visibilityChangeEventName) {
	            if (!document[docHiddenKey]) startFastCheckTimer();
	    
	            document.addEventListener(visibilityChangeEventName, function () {
	                if (document[docHiddenKey]) {
	                    stopFastCheckTimer();
	                } else {
	                    startFastCheckTimer();
	                }
	            });
	        } else startFastCheckTimer();
	    }
	    
	    if (!seppuku) init();
	    
	    /*
	     * 7. Expose Stickyfill
	     */
	    if (typeof module != 'undefined' && module.exports) {
	        module.exports = Stickyfill;
	    } else if (isWindowDefined) {
	        window.Stickyfill = Stickyfill;
	    }
	    
	})(window, document);

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	(function() {
	  var instance = null;
	  var instancesCount = 0;
	  var ticking = false;
	
	  var EVENT_NAME = 'window-scroll';
	
	  var isWindowDefined = typeof window !== 'undefined';
	
	  // ------------------------------------------------
	  // Passive events support detection
	  // ------------------------------------------------
	  function detectPassiveEvents() {
	    if (isWindowDefined && typeof window.addEventListener === 'function') {
	      var passive = false;
	      var options = Object.defineProperty({}, 'passive', {
	        get: function() { passive = true; }
	      });
	      // note: have to set and remove a no-op listener instead of null
	      // (which was used previously), because Edge v15 throws an error
	      // when providing a null callback.
	      // https://github.com/rafrex/detect-passive-events/pull/3
	      var noop = function() {};
	      window.addEventListener('TEST_PASSIVE_EVENT_SUPPORT', noop, options);
	      window.removeEventListener('TEST_PASSIVE_EVENT_SUPPORT', noop, options);
	
	      return passive;
	    }
	
	    return false;
	  }
	
	  var supportsPassiveEvents = detectPassiveEvents();
	
	  // ------------------------------------------------
	  // Custom Event detection
	  // ------------------------------------------------
	  var supportsCustomEvents = isWindowDefined && typeof window.CustomEvent === 'function';
	
	  // ------------------------------------------------
	  // Scroll manager
	  // ------------------------------------------------
	  function ScrollManager() {
	    if (typeof window === 'undefined') {
	      // Silently return null if it is used on server
	      return null;
	    }
	
	    // Increase reference count
	    instancesCount++;
	
	    // If singleton instance exists, return it rather than creating a new one
	    if (instance) {
	      return instance;
	    }
	
	    // Save singleton instance
	    instance = this;
	
	    // Bind handlers
	    this.handleScroll = this.handleScroll.bind(this);
	
	    // Use passive listener when supported with fallback to capture option
	    this.eventListenerOptions = supportsPassiveEvents ? { passive: true } : true;
	
	    // Add scroll listener
	    window.addEventListener('scroll', this.handleScroll, this.eventListenerOptions);
	  }
	
	  ScrollManager.prototype.removeListener = function() {
	    instancesCount--;
	
	    // There is not components listening to our event
	    if (instancesCount === 0) {
	      this.destroy();
	    }
	  };
	
	  ScrollManager.prototype.destroy = function() {
	    // Remove event listener
	    window.removeEventListener('scroll', this.handleScroll, this.eventListenerOptions);
	
	    // Clear singleton instance and count
	    instance = null;
	    instancesCount = 0;
	  };
	
	  ScrollManager.prototype.getScrollPosition = function() {
	    // Get scroll position, with IE fallback
	    var scrollPositionY = window.scrollY || document.documentElement.scrollTop;
	    var scrollPositionX = window.scrollX || document.documentElement.scrollLeft;
	
	    // Disable overscrolling in safari
	    if (scrollPositionY < 0) {
	      scrollPositionY = 0;
	    }
	    if (scrollPositionX < 0) {
	      scrollPositionX = 0;
	    }
	
	    return {
	      // Alias for scrollPositionY for backwards compatibility
	      scrollPosition: scrollPositionY,
	      scrollPositionY: scrollPositionY,
	      scrollPositionX: scrollPositionX
	    };
	  };
	
	  ScrollManager.prototype.handleScroll = function() {
	    // Fire the event only once per requestAnimationFrame
	    if (!ticking) {
	      ticking = true;
	
	      var event;
	
	      if (supportsCustomEvents) {
	        event = new CustomEvent(EVENT_NAME, {
	          detail: this.getScrollPosition()
	        });
	      } else {
	        event = document.createEvent('CustomEvent');
	        event.initCustomEvent(EVENT_NAME, false, false, this.getScrollPosition());
	      }
	
	      window.dispatchEvent(event);
	
	      window.requestAnimationFrame(function() {
	        ticking = false;
	      });
	    }
	  };
	
	  if (typeof module !== 'undefined' && module.exports) {
	    ScrollManager.default = ScrollManager;
	    module.exports = ScrollManager;
	  } else if (true) { // eslint-disable-line no-undef
	    // register as 'window-scroll-manager', consistent with npm package name
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { // eslint-disable-line no-undef
	      return ScrollManager;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    window.ScrollManager = ScrollManager;
	  }
	}).call(this);


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./32px/ID-card-32px.svg": 1086,
		"./32px/bar-chart-up-32px.svg": 1087,
		"./32px/bill-2-32px.svg": 1088,
		"./32px/binoculars-32px.svg": 1089,
		"./32px/bulb-idea-32px.svg": 1090,
		"./32px/chat-3-32px.svg": 1091,
		"./32px/coins-2-32px.svg": 1092,
		"./32px/construction-helmet-32px.svg": 1093,
		"./32px/diploma-3-32px.svg": 1094,
		"./32px/discount-star-32px.svg": 1095,
		"./32px/document-pencil-32px.svg": 1096,
		"./32px/fag-og-ledelse-32px.svg": 1097,
		"./32px/graduation-cap-32px.svg": 1098,
		"./32px/graph-2-32px.svg": 1099,
		"./32px/graph-up-32px.svg": 1100,
		"./32px/hammer-32px.svg": 1101,
		"./32px/heart-32px.svg": 1102,
		"./32px/innovasjon-32px.svg": 1103,
		"./32px/klima-og-miljo-32px.svg": 1104,
		"./32px/leaf-32px.svg": 1105,
		"./32px/medal-1-32px.svg": 1106,
		"./32px/people-32px.svg": 1107,
		"./32px/piggy-bank-32px.svg": 1108,
		"./32px/samarbeid-32px.svg": 1109,
		"./32px/shacking-hands-32px.svg": 1110,
		"./32px/soccer-shoe-32px.svg": 1111,
		"./32px/stethoscope-32px.svg": 1112,
		"./32px/strategien-32px.svg": 1113,
		"./32px/sun-32px.svg": 1114,
		"./32px/supercar-32px.svg": 1115,
		"./32px/tractor-32px.svg": 1116,
		"./32px/umbrella-open-32px.svg": 1117,
		"./32px/vo-anlegg-32px.svg": 1118,
		"./32px/vo-bygg-32px.svg": 1119,
		"./32px/vo-eiendom-32px.svg": 1120,
		"./32px/vo-energi-32px.svg": 1121,
		"./32px/vo-miljo-32px.svg": 1122,
		"./32px/vo-offshore-32px.svg": 1123,
		"./32px/volleyball-32px.svg": 1124,
		"./32px/wall-32px.svg": 1125,
		"./48px/ID-card-48px.svg": 1126,
		"./48px/bar-chart-up-48px.svg": 1127,
		"./48px/bill-2-48px.svg": 1128,
		"./48px/binoculars-48px.svg": 1129,
		"./48px/bulb-idea-48px.svg": 1130,
		"./48px/chat-3-48px.svg": 1131,
		"./48px/coins-2-48px.svg": 1132,
		"./48px/construction-helmet-48px.svg": 1133,
		"./48px/diploma-3-48px.svg": 1134,
		"./48px/discount-star-48px.svg": 1135,
		"./48px/document-pencil-48px.svg": 1136,
		"./48px/fag-og-ledelse-48px.svg": 1137,
		"./48px/graduation-cap-48px.svg": 1138,
		"./48px/graph-2-48px.svg": 1139,
		"./48px/graph-up-48px.svg": 1140,
		"./48px/hammer-48px.svg": 1141,
		"./48px/heart-48px.svg": 1142,
		"./48px/innovasjon-48px.svg": 1143,
		"./48px/klima-og-miljo-48px.svg": 1144,
		"./48px/leaf-48px.svg": 1145,
		"./48px/medal-1-48px.svg": 1146,
		"./48px/people-48px.svg": 1147,
		"./48px/piggy-bank-48px.svg": 1148,
		"./48px/samarbeid-48px.svg": 1149,
		"./48px/shaking-hands-48px.svg": 1150,
		"./48px/soccer-shoes-48px.svg": 1151,
		"./48px/step-circle-01-48px.svg": 1152,
		"./48px/step-circle-02-48px.svg": 1153,
		"./48px/step-circle-03-48px.svg": 1154,
		"./48px/step-circle-04-48px.svg": 1155,
		"./48px/step-circle-05-48px.svg": 1156,
		"./48px/step-circle-06-48px.svg": 1157,
		"./48px/step-circle-07-48px.svg": 1158,
		"./48px/step-circle-08-48px.svg": 1159,
		"./48px/step-circle-09-48px.svg": 1160,
		"./48px/step-circle-10-48px.svg": 1161,
		"./48px/step-pyramid-00-48px.svg": 1162,
		"./48px/step-pyramid-01-48px.svg": 1163,
		"./48px/step-pyramid-02-48px.svg": 1164,
		"./48px/step-pyramid-03-48px.svg": 1165,
		"./48px/stethoscope-48px.svg": 1166,
		"./48px/strategien-48px.svg": 1167,
		"./48px/sun-48px.svg": 1168,
		"./48px/supercar-48px.svg": 1169,
		"./48px/tractor-48px.svg": 1170,
		"./48px/umbrella-open-48px.svg": 1171,
		"./48px/vo-anlegg-48px.svg": 1172,
		"./48px/vo-bygg-48px.svg": 1173,
		"./48px/vo-eiendom-48px.svg": 1174,
		"./48px/vo-energi-48px.svg": 1175,
		"./48px/vo-miljo-48px.svg": 1176,
		"./48px/vo-offshore-48px.svg": 1177,
		"./48px/volleyball-48px.svg": 1178,
		"./48px/wall-48px.svg": 1179,
		"./60px/ID-card-60px.svg": 1180,
		"./60px/bar-chart-up-60px.svg": 1181,
		"./60px/bill-2-60px.svg": 1182,
		"./60px/binoculars-60px.svg": 1183,
		"./60px/bulb-idea-60px.svg": 1184,
		"./60px/chat-3-60px.svg": 1185,
		"./60px/coins-2-60px.svg": 1186,
		"./60px/construction-helmet-60px.svg": 1187,
		"./60px/diploma-3-60px.svg": 1188,
		"./60px/discount-star-60px.svg": 1189,
		"./60px/document-pencil-60px.svg": 1190,
		"./60px/fag-og-ledelse-60px.svg": 1191,
		"./60px/graduation-cap-60px.svg": 1192,
		"./60px/graph-2-60px.svg": 1193,
		"./60px/graph-up-60px.svg": 1194,
		"./60px/hammer-60px.svg": 1195,
		"./60px/heart-60px.svg": 1196,
		"./60px/innovasjon-60px.svg": 1197,
		"./60px/klima-og-miljo-60px.svg": 1198,
		"./60px/leaf-60px.svg": 1199,
		"./60px/medal-1-60px.svg": 1200,
		"./60px/people-60px.svg": 1201,
		"./60px/piggy-bank-60px.svg": 1202,
		"./60px/samarbeid-60px.svg": 1203,
		"./60px/shacking-hands-60px.svg": 1204,
		"./60px/soccer-shoe-60px.svg": 1205,
		"./60px/step-circle-01-60px.svg": 1206,
		"./60px/step-circle-02-60px.svg": 1207,
		"./60px/step-circle-03-60px.svg": 1208,
		"./60px/step-circle-04-60px.svg": 1209,
		"./60px/step-circle-05-60px.svg": 1210,
		"./60px/step-circle-06-60px.svg": 1211,
		"./60px/step-circle-07-60px.svg": 1212,
		"./60px/step-circle-08-60px.svg": 1213,
		"./60px/step-circle-09-60px.svg": 1214,
		"./60px/step-circle-10-60px.svg": 1215,
		"./60px/stethoscope-60px.svg": 1216,
		"./60px/strategien-60px.svg": 1217,
		"./60px/sun-60px.svg": 1218,
		"./60px/supercar-60px.svg": 1219,
		"./60px/tractor-60px.svg": 1220,
		"./60px/umbrella-open-60px.svg": 1221,
		"./60px/vo-anlegg-60px.svg": 1222,
		"./60px/vo-bygg-60px.svg": 1223,
		"./60px/vo-eiendom-60px.svg": 1224,
		"./60px/vo-energi-60px.svg": 1225,
		"./60px/vo-miljo-60px.svg": 1226,
		"./60px/vo-offshore-60px.svg": 1227,
		"./60px/volleyball-60px.svg": 1228,
		"./60px/wall-60px.svg": 1229,
		"./BusinessAreas/fag-og-ledelse.svg": 1230,
		"./BusinessAreas/innovasjon.svg": 1231,
		"./BusinessAreas/klima-og-miljo.svg": 1232,
		"./BusinessAreas/samarbeid.svg": 1233,
		"./BusinessAreas/strategien.svg": 1234,
		"./BusinessAreas/vo-anlegg-60px.svg": 1235,
		"./BusinessAreas/vo-bygg-60px.svg": 1236,
		"./BusinessAreas/vo-eiendom-60px.svg": 1237,
		"./BusinessAreas/vo-energi-60px.svg": 1238,
		"./BusinessAreas/vo-miljo-60px.svg": 1239,
		"./BusinessAreas/vo-offshore-60px.svg": 1240,
		"./Strategies/fag-og-ledelse.svg": 1241,
		"./Strategies/innovasjon.svg": 1242,
		"./Strategies/klima-og-miljo.svg": 1243,
		"./Strategies/samarbeid.svg": 1244,
		"./arrow-down.svg": 1245,
		"./arrow-grey-left.svg": 1246,
		"./arrow-grey-light-close.svg": 1247,
		"./arrow-grey-light-left.svg": 1248,
		"./arrow-grey-light-right.svg": 1249,
		"./arrow-grey-right.svg": 1250,
		"./arrow-left.svg": 1251,
		"./arrow-line-left.svg": 1252,
		"./arrow-line-long-right.svg": 1253,
		"./arrow-line-right.svg": 1254,
		"./arrow-line-top.svg": 1255,
		"./arrow-right.svg": 1256,
		"./arrows.svg": 1257,
		"./binoculars.svg": 1258,
		"./briefcase.svg": 1259,
		"./calendar-add.svg": 1260,
		"./calendar.svg": 1261,
		"./camera-tripod-24px.svg": 1262,
		"./checkmark.svg": 1263,
		"./close.svg": 1264,
		"./download.svg": 1265,
		"./email.svg": 1266,
		"./facebook.svg": 1267,
		"./filetable.svg": 1268,
		"./grid.svg": 1269,
		"./hamburger.svg": 1270,
		"./icon-share.svg": 1271,
		"./instagram.svg": 1272,
		"./linkedin.svg": 1273,
		"./list.svg": 1274,
		"./location.svg": 1275,
		"./magnifier.svg": 1276,
		"./map.svg": 1277,
		"./minus-circle.svg": 1278,
		"./minus.svg": 1279,
		"./pdf.svg": 1280,
		"./plus-circle.svg": 1281,
		"./plus.svg": 1282,
		"./printer.svg": 1283,
		"./search.svg": 1284,
		"./share.svg": 1285,
		"./twitter.svg": 1286,
		"./youtube.svg": 1287,
		"./zoom-in.svg": 1288,
		"./zoom-out.svg": 1289
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 341;


/***/ }),
/* 342 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	function anyToKebab(s) {
	  if ('string' !== typeof s) {
	    return s;
	  }
	
	  var result = '',
	      i = 0,
	      len = s.length;
	
	  for (; i < len; i++) {
	    var lowerCased = s[i].toLowerCase();
	    var upperCased = s[i].toUpperCase();
	
	    if (lowerCased !== upperCased && s[i] === upperCased) {
	      result += '-' + lowerCased;
	    } else {
	      result += lowerCased;
	    }
	  }
	
	  return result[0] !== '-' ? result : result.substr(1);
	}
	
	var _default = anyToKebab;
	exports["default"] = _default;

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = filterObject;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function filterObject() {
	  var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var predicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	    return true;
	  };
	  return Object.entries(object).reduce(function (accumulator, _ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        key = _ref2[0],
	        value = _ref2[1];
	
	    return predicate(key, value) ? Object.assign(accumulator, _defineProperty({}, key, value)) : accumulator;
	  }, {});
	}

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _anyToKebab = _interopRequireDefault(__webpack_require__(342));
	
	var _isRunningOnClient = _interopRequireDefault(__webpack_require__(345));
	
	var _kebabToCamel = _interopRequireDefault(__webpack_require__(346));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getData(dataAttributeName) {
	  if (!_isRunningOnClient["default"]) {
	    return;
	  }
	
	  var kebabedName = (0, _anyToKebab["default"])(dataAttributeName);
	  var node = document.querySelector("[data-".concat(kebabedName, "]"));
	
	  if (!node) {
	    return;
	  }
	
	  return node.dataset[(0, _kebabToCamel["default"])(kebabedName)];
	}
	
	var _default = getData;
	exports["default"] = _default;

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var isRunningOnClient = typeof window !== 'undefined' && window.document ? true : false;
	var _default = isRunningOnClient;
	exports["default"] = _default;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _kebabToPascal = _interopRequireDefault(__webpack_require__(347));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function kebabToCamel(s) {
	  if ('string' !== typeof s) {
	    return s;
	  }
	
	  var p = (0, _kebabToPascal["default"])(s);
	  return p.substr(0, 1).toLowerCase() + p.substring(1);
	}
	
	var _default = kebabToCamel;
	exports["default"] = _default;

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	function kebabToPascal(s) {
	  if ('string' !== typeof s || s.length === 0) {
	    return s;
	  }
	
	  var result = s.substr(0, 1).toUpperCase(),
	      i = 1,
	      len = s.length;
	
	  for (; i < len; i++) {
	    if (s[i] === '-' && i + 1 !== len) {
	      result += s[i + 1].toUpperCase();
	      i++;
	    } else result += s[i].toLowerCase();
	  }
	
	  return result[0] !== '-' ? result : result.substr(1);
	}
	
	var _default = kebabToPascal;
	exports["default"] = _default;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = stripPropertiesWithValue;
	
	var _filterObject = _interopRequireDefault(__webpack_require__(343));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function stripPropertiesWithValue(object, valueToStrip) {
	  return (0, _filterObject["default"])(object, function (_key, value) {
	    return value !== valueToStrip;
	  });
	}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _stripPropertiesWithValue = _interopRequireDefault(__webpack_require__(348));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function stripUndefined(object) {
	  return (0, _stripPropertiesWithValue["default"])(object, undefined);
	}
	
	var _default = stripUndefined;
	exports["default"] = _default;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _stripUndefined = _interopRequireDefault(__webpack_require__(349));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var defaultOptions = {
	  encode: true,
	  prefix: '?'
	};
	
	var getOptionsToUse = function getOptionsToUse(options) {
	  // NOTE: For backwards compatibility with previous API
	  if (typeof options === 'boolean') {
	    return Object.assign({}, defaultOptions, {
	      encode: options
	    });
	  }
	
	  return Object.assign({}, defaultOptions, (0, _stripUndefined["default"])(options));
	};
	
	function toQueryString(queryObject) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var optionsToUse = getOptionsToUse(options);
	  return Object.keys(queryObject).filter(function (key) {
	    return queryObject[key] !== undefined;
	  }).reduce(function (accumulator, currentKey, currentIndex) {
	    var currentValue = queryObject[currentKey];
	
	    if (currentValue !== undefined) {
	      var separator = currentIndex === 0 ? optionsToUse.prefix : '&';
	
	      var _ref = optionsToUse.encode ? [encodeURIComponent(currentKey), encodeURIComponent(currentValue)] : [currentKey, currentValue],
	          _ref2 = _slicedToArray(_ref, 2),
	          key = _ref2[0],
	          value = _ref2[1];
	
	      accumulator = "".concat(accumulator).concat(separator).concat(key, "=").concat(value);
	    }
	
	    return accumulator;
	  }, '');
	}
	
	var _default = toQueryString;
	exports["default"] = _default;

/***/ }),
/* 351 */,
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _AnchorMenu = __webpack_require__(379);
	
	var _AnchorMenu2 = _interopRequireDefault(_AnchorMenu);
	
	var _Footer = __webpack_require__(463);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(226);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _HeaderImageBlock = __webpack_require__(480);
	
	var _HeaderImageBlock2 = _interopRequireDefault(_HeaderImageBlock);
	
	var _FeatureMediaHeader = __webpack_require__(456);
	
	var _FeatureMediaHeader2 = _interopRequireDefault(_FeatureMediaHeader);
	
	var _LinkGroupListBlock = __webpack_require__(518);
	
	var _LinkGroupListBlock2 = _interopRequireDefault(_LinkGroupListBlock);
	
	var _FeatureListBlock = __webpack_require__(452);
	
	var _FeatureListBlock2 = _interopRequireDefault(_FeatureListBlock);
	
	var _TabListBlock = __webpack_require__(581);
	
	var _TabListBlock2 = _interopRequireDefault(_TabListBlock);
	
	var _VideoListBlock = __webpack_require__(134);
	
	var _VideoListBlock2 = _interopRequireDefault(_VideoListBlock);
	
	var _TextBlock = __webpack_require__(584);
	
	var _TextBlock2 = _interopRequireDefault(_TextBlock);
	
	var _InfographicListBlock = __webpack_require__(229);
	
	var _InfographicListBlock2 = _interopRequireDefault(_InfographicListBlock);
	
	var _ContactBlock = __webpack_require__(98);
	
	var _ContactBlock2 = _interopRequireDefault(_ContactBlock);
	
	var _ImageBlock = __webpack_require__(228);
	
	var _ImageBlock2 = _interopRequireDefault(_ImageBlock);
	
	var _QuoteBlock = __webpack_require__(132);
	
	var _QuoteBlock2 = _interopRequireDefault(_QuoteBlock);
	
	var _Icons = __webpack_require__(484);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	var _TimelineBlock = __webpack_require__(586);
	
	var _TimelineBlock2 = _interopRequireDefault(_TimelineBlock);
	
	var _EventCard = __webpack_require__(221);
	
	var _EventCard2 = _interopRequireDefault(_EventCard);
	
	var _ProjectListBlock = __webpack_require__(556);
	
	var _ProjectListBlock2 = _interopRequireDefault(_ProjectListBlock);
	
	var _DepartmentInformationBlock = __webpack_require__(415);
	
	var _DepartmentInformationBlock2 = _interopRequireDefault(_DepartmentInformationBlock);
	
	var _ProjectInfoBlock = __webpack_require__(554);
	
	var _ProjectInfoBlock2 = _interopRequireDefault(_ProjectInfoBlock);
	
	var _VacancyListBlock = __webpack_require__(247);
	
	var _VacancyListBlock2 = _interopRequireDefault(_VacancyListBlock);
	
	var _CollaboratorLinksBlock = __webpack_require__(402);
	
	var _CollaboratorLinksBlock2 = _interopRequireDefault(_CollaboratorLinksBlock);
	
	var _SectionMenuBlock = __webpack_require__(574);
	
	var _SectionMenuBlock2 = _interopRequireDefault(_SectionMenuBlock);
	
	var _LinkListBlock = __webpack_require__(520);
	
	var _LinkListBlock2 = _interopRequireDefault(_LinkListBlock);
	
	var _NewsListBlock = __webpack_require__(239);
	
	var _NewsListBlock2 = _interopRequireDefault(_NewsListBlock);
	
	var _ArticleListBlock = __webpack_require__(383);
	
	var _ArticleListBlock2 = _interopRequireDefault(_ArticleListBlock);
	
	var _BusinessAreaListBlock = __webpack_require__(397);
	
	var _BusinessAreaListBlock2 = _interopRequireDefault(_BusinessAreaListBlock);
	
	var _VacanciesFilter = __webpack_require__(592);
	
	var _VacanciesFilter2 = _interopRequireDefault(_VacanciesFilter);
	
	var _HMSBlock = __webpack_require__(476);
	
	var _HMSBlock2 = _interopRequireDefault(_HMSBlock);
	
	var _SearchResultsBlock = __webpack_require__(572);
	
	var _SearchResultsBlock2 = _interopRequireDefault(_SearchResultsBlock);
	
	var _TableBlock = __webpack_require__(133);
	
	var _TableBlock2 = _interopRequireDefault(_TableBlock);
	
	var _DocumentListBlock = __webpack_require__(431);
	
	var _DocumentListBlock2 = _interopRequireDefault(_DocumentListBlock);
	
	var _DepartmentInformationListBlock = __webpack_require__(417);
	
	var _DepartmentInformationListBlock2 = _interopRequireDefault(_DepartmentInformationListBlock);
	
	var _FullscreenListBlock = __webpack_require__(465);
	
	var _FullscreenListBlock2 = _interopRequireDefault(_FullscreenListBlock);
	
	var _PressReleaseBlock = __webpack_require__(549);
	
	var _PressReleaseBlock2 = _interopRequireDefault(_PressReleaseBlock);
	
	var _WebcamBlock = __webpack_require__(248);
	
	var _WebcamBlock2 = _interopRequireDefault(_WebcamBlock);
	
	var _WebcamBlockBody = __webpack_require__(603);
	
	var _WebcamBlockBody2 = _interopRequireDefault(_WebcamBlockBody);
	
	var _DocumentFilterListBlock = __webpack_require__(429);
	
	var _DocumentFilterListBlock2 = _interopRequireDefault(_DocumentFilterListBlock);
	
	var _ProjectListPage = __webpack_require__(240);
	
	var _ProjectListPage2 = _interopRequireDefault(_ProjectListPage);
	
	var _BoardBlock = __webpack_require__(392);
	
	var _BoardBlock2 = _interopRequireDefault(_BoardBlock);
	
	var _GalleryBlock = __webpack_require__(467);
	
	var _GalleryBlock2 = _interopRequireDefault(_GalleryBlock);
	
	var _MapBlock = __webpack_require__(527);
	
	var _MapBlock2 = _interopRequireDefault(_MapBlock);
	
	var _MapLocationBlock = __webpack_require__(234);
	
	var _MapLocationBlock2 = _interopRequireDefault(_MapLocationBlock);
	
	var _ActiveProjectsMapBlock = __webpack_require__(354);
	
	var _ActiveProjectsMapBlock2 = _interopRequireDefault(_ActiveProjectsMapBlock);
	
	var _CuriousBlock = __webpack_require__(121);
	
	var _CuriousBlock2 = _interopRequireDefault(_CuriousBlock);
	
	var _CookieBlock = __webpack_require__(412);
	
	var _CookieBlock2 = _interopRequireDefault(_CookieBlock);
	
	var _YoutubeVideoBlock = __webpack_require__(606);
	
	var _YoutubeVideoBlock2 = _interopRequireDefault(_YoutubeVideoBlock);
	
	var _BusinessAreaBlock = __webpack_require__(395);
	
	var _BusinessAreaBlock2 = _interopRequireDefault(_BusinessAreaBlock);
	
	var _BannersListBlock = __webpack_require__(390);
	
	var _BannersListBlock2 = _interopRequireDefault(_BannersListBlock);
	
	var _Banner = __webpack_require__(216);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _TopText = __webpack_require__(588);
	
	var _TopText2 = _interopRequireDefault(_TopText);
	
	var _SearchFormInline = __webpack_require__(569);
	
	var _SearchFormInline2 = _interopRequireDefault(_SearchFormInline);
	
	var _ShortcutsBlock = __webpack_require__(576);
	
	var _ShortcutsBlock2 = _interopRequireDefault(_ShortcutsBlock);
	
	var _RelatedArticles = __webpack_require__(241);
	
	var _RelatedArticles2 = _interopRequireDefault(_RelatedArticles);
	
	var _FeatureArticlesFilter = __webpack_require__(445);
	
	var _FeatureArticlesFilter2 = _interopRequireDefault(_FeatureArticlesFilter);
	
	var _FeatureArticleTextBlock = __webpack_require__(441);
	
	var _FeatureArticleTextBlock2 = _interopRequireDefault(_FeatureArticleTextBlock);
	
	var _FeatureArticleVacancyBlock = __webpack_require__(443);
	
	var _FeatureArticleVacancyBlock2 = _interopRequireDefault(_FeatureArticleVacancyBlock);
	
	var _FeatureLandingPageHeader = __webpack_require__(450);
	
	var _FeatureLandingPageHeader2 = _interopRequireDefault(_FeatureLandingPageHeader);
	
	var _FeatureArticleHeader = __webpack_require__(438);
	
	var _FeatureArticleHeader2 = _interopRequireDefault(_FeatureArticleHeader);
	
	var _HighlightedProjectBlock = __webpack_require__(227);
	
	var _HighlightedProjectBlock2 = _interopRequireDefault(_HighlightedProjectBlock);
	
	var _TopicAreasNavigationBlock = __webpack_require__(590);
	
	var _TopicAreasNavigationBlock2 = _interopRequireDefault(_TopicAreasNavigationBlock);
	
	var _RelatedArticleBlock = __webpack_require__(564);
	
	var _RelatedArticleBlock2 = _interopRequireDefault(_RelatedArticleBlock);
	
	var _DoYouHaveQuestionsBlock = __webpack_require__(425);
	
	var _DoYouHaveQuestionsBlock2 = _interopRequireDefault(_DoYouHaveQuestionsBlock);
	
	var _CategoriesNavigation = __webpack_require__(219);
	
	var _CategoriesNavigation2 = _interopRequireDefault(_CategoriesNavigation);
	
	var _DidntFindAnswer = __webpack_require__(423);
	
	var _DidntFindAnswer2 = _interopRequireDefault(_DidntFindAnswer);
	
	var _Breadcrumbs = __webpack_require__(218);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _VisitOurWebsiteBlock = __webpack_require__(601);
	
	var _VisitOurWebsiteBlock2 = _interopRequireDefault(_VisitOurWebsiteBlock);
	
	var _ContactsList = __webpack_require__(410);
	
	var _ContactsList2 = _interopRequireDefault(_ContactsList);
	
	var _CompanyList = __webpack_require__(407);
	
	var _CompanyList2 = _interopRequireDefault(_CompanyList);
	
	var _GroupedLinksBlock = __webpack_require__(474);
	
	var _GroupedLinksBlock2 = _interopRequireDefault(_GroupedLinksBlock);
	
	var _FeatureMediaBlock = __webpack_require__(454);
	
	var _FeatureMediaBlock2 = _interopRequireDefault(_FeatureMediaBlock);
	
	var _InvestorHeader = __webpack_require__(503);
	
	var _InvestorHeader2 = _interopRequireDefault(_InvestorHeader);
	
	var _NewImageBlock = __webpack_require__(238);
	
	var _NewImageBlock2 = _interopRequireDefault(_NewImageBlock);
	
	var _InvestorBoardMembersBlock = __webpack_require__(495);
	
	var _InvestorBoardMembersBlock2 = _interopRequireDefault(_InvestorBoardMembersBlock);
	
	var _ArticleTeaser = __webpack_require__(387);
	
	var _ArticleTeaser2 = _interopRequireDefault(_ArticleTeaser);
	
	var _InvestorDoubleReportBlock = __webpack_require__(497);
	
	var _InvestorDoubleReportBlock2 = _interopRequireDefault(_InvestorDoubleReportBlock);
	
	var _InvestorReport = __webpack_require__(231);
	
	var _InvestorReport2 = _interopRequireDefault(_InvestorReport);
	
	var _InvestorFinancialCalendarBlock = __webpack_require__(499);
	
	var _InvestorFinancialCalendarBlock2 = _interopRequireDefault(_InvestorFinancialCalendarBlock);
	
	var _InvestorPageHeading = __webpack_require__(512);
	
	var _InvestorPageHeading2 = _interopRequireDefault(_InvestorPageHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	    AnchorMenu: _AnchorMenu2.default,
	    Footer: _Footer2.default,
	    Header: _Header2.default,
	    HeaderImageBlock: _HeaderImageBlock2.default,
	    LinkGroupListBlock: _LinkGroupListBlock2.default,
	    FeatureMediaHeader: _FeatureMediaHeader2.default,
	    FeatureListBlock: _FeatureListBlock2.default,
	    FeatureLandingPageHeader: _FeatureLandingPageHeader2.default,
	    TabListBlock: _TabListBlock2.default,
	    VideoListBlock: _VideoListBlock2.default,
	    TextBlock: _TextBlock2.default,
	    InfographicListBlock: _InfographicListBlock2.default,
	    ContactBlock: _ContactBlock2.default,
	    ImageBlock: _ImageBlock2.default,
	    QuoteBlock: _QuoteBlock2.default,
	    Icons: _Icons2.default,
	    TimelineBlock: _TimelineBlock2.default,
	    EventCard: _EventCard2.default,
	    ProjectListBlock: _ProjectListBlock2.default,
	    ProjectInfoBlock: _ProjectInfoBlock2.default,
	    DepartmentInformationBlock: _DepartmentInformationBlock2.default,
	    VacancyListBlock: _VacancyListBlock2.default,
	    CollaboratorLinksBlock: _CollaboratorLinksBlock2.default,
	    SectionMenuBlock: _SectionMenuBlock2.default,
	    LinkListBlock: _LinkListBlock2.default,
	    NewsListBlock: _NewsListBlock2.default,
	    ArticleListBlock: _ArticleListBlock2.default,
	    BusinessAreaListBlock: _BusinessAreaListBlock2.default,
	    VacanciesFilter: _VacanciesFilter2.default,
	    SearchResultsBlock: _SearchResultsBlock2.default,
	    HMSBlock: _HMSBlock2.default,
	    TableBlock: _TableBlock2.default,
	    DocumentListBlock: _DocumentListBlock2.default,
	    DepartmentInformationListBlock: _DepartmentInformationListBlock2.default,
	    FullscreenListBlock: _FullscreenListBlock2.default,
	    PressReleaseBlock: _PressReleaseBlock2.default,
	    WebcamBlock: _WebcamBlock2.default,
	    WebcamBlockBody: _WebcamBlockBody2.default,
	    DocumentFilterListBlock: _DocumentFilterListBlock2.default,
	    ProjectListPage: _ProjectListPage2.default,
	    BoardBlock: _BoardBlock2.default,
	    GalleryBlock: _GalleryBlock2.default,
	    MapBlock: _MapBlock2.default,
	    MapLocationBlock: _MapLocationBlock2.default,
	    ActiveProjectsMapBlock: _ActiveProjectsMapBlock2.default,
	    CuriousBlock: _CuriousBlock2.default,
	    CookieBlock: _CookieBlock2.default,
	    YoutubeVideoBlock: _YoutubeVideoBlock2.default,
	    BusinessAreaBlock: _BusinessAreaBlock2.default,
	    BannersListBlock: _BannersListBlock2.default,
	    Banner: _Banner2.default,
	    TopText: _TopText2.default,
	    SearchFormInline: _SearchFormInline2.default,
	    ShortcutsBlock: _ShortcutsBlock2.default,
	    RelatedArticles: _RelatedArticles2.default,
	    FeatureArticlesFilter: _FeatureArticlesFilter2.default,
	    FeatureArticleTextBlock: _FeatureArticleTextBlock2.default,
	    FeatureArticleVacancyBlock: _FeatureArticleVacancyBlock2.default,
	    FeatureArticleHeader: _FeatureArticleHeader2.default,
	    HighlightedProjectBlock: _HighlightedProjectBlock2.default,
	    TopicAreasNavigationBlock: _TopicAreasNavigationBlock2.default,
	    RelatedArticleBlock: _RelatedArticleBlock2.default,
	    DoYouHaveQuestionsBlock: _DoYouHaveQuestionsBlock2.default,
	    CategoriesNavigation: _CategoriesNavigation2.default,
	    DidntFindAnswer: _DidntFindAnswer2.default,
	    Breadcrumbs: _Breadcrumbs2.default,
	    VisitOurWebsiteBlock: _VisitOurWebsiteBlock2.default,
	    ContactsList: _ContactsList2.default,
	    CompanyList: _CompanyList2.default,
	    GroupedLinksBlock: _GroupedLinksBlock2.default,
	    FeatureMediaBlock: _FeatureMediaBlock2.default,
	    InvestorHeader: _InvestorHeader2.default,
	    NewImageBlock: _NewImageBlock2.default,
	    InvestorBoardMembersBlock: _InvestorBoardMembersBlock2.default,
	    ArticleTeaser: _ArticleTeaser2.default,
	    InvestorDoubleReportBlock: _InvestorDoubleReportBlock2.default,
	    InvestorReport: _InvestorReport2.default,
	    InvestorFinancialCalendarBlock: _InvestorFinancialCalendarBlock2.default,
	    InvestorPageHeading: _InvestorPageHeading2.default
	}; // todo: fix "export default from" syntax and use automatically gathered components 
	// import Components from './components';
	
	// export default Components;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Map = __webpack_require__(76);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _ProjectMarkers = __webpack_require__(130);
	
	var _ProjectMarkers2 = _interopRequireDefault(_ProjectMarkers);
	
	var _ActiveProjectsMapBlockModule = __webpack_require__(730);
	
	var _ActiveProjectsMapBlockModule2 = _interopRequireDefault(_ActiveProjectsMapBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActiveProjectsMapBlock = function (_React$PureComponent) {
	    _inherits(ActiveProjectsMapBlock, _React$PureComponent);
	
	    function ActiveProjectsMapBlock() {
	        _classCallCheck(this, ActiveProjectsMapBlock);
	
	        return _possibleConstructorReturn(this, (ActiveProjectsMapBlock.__proto__ || Object.getPrototypeOf(ActiveProjectsMapBlock)).apply(this, arguments));
	    }
	
	    _createClass(ActiveProjectsMapBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                header = _props.header,
	                maxClusterRadius = _props.maxClusterRadius,
	                projects = _props.projects,
	                projectStatusLabel = _props.projectStatusLabel,
	                projectsLink = _props.projectsLink,
	                projectsLinkHeading = _props.projectsLinkHeading,
	                tileLayer = _props.tileLayer;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _ActiveProjectsMapBlockModule2.default.block },
	                header && _react2.default.createElement(
	                    'header',
	                    { className: _ActiveProjectsMapBlockModule2.default.header },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'block-title-large' },
	                        header
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ActiveProjectsMapBlockModule2.default.map },
	                    _react2.default.createElement(
	                        _Map2.default,
	                        {
	                            center: [61.606396, 21.225586],
	                            fitMarkers: true,
	                            zoomLevel: 1,
	                            tileLayer: tileLayer
	                        },
	                        _react2.default.createElement(_ProjectMarkers2.default, {
	                            filterSearch: function filterSearch() {
	                                return true;
	                            },
	                            maxClusterRadius: maxClusterRadius,
	                            projects: projects || [],
	                            projectStatusLabel: projectStatusLabel
	                        })
	                    )
	                ),
	                projectsLinkHeading && projectsLink && _react2.default.createElement(
	                    'div',
	                    { className: _ActiveProjectsMapBlockModule2.default.seeAll },
	                    _react2.default.createElement(
	                        _Button2.default,
	                        { href: projectsLink, light: true, secondary: true },
	                        projectsLinkHeading
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ActiveProjectsMapBlock;
	}(_react2.default.PureComponent);
	
	ActiveProjectsMapBlock.propTypes = {
	    header: _propTypes2.default.string,
	    maxClusterRadius: _propTypes2.default.number.isRequired,
	    projects: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        location: _propTypes2.default.string.isRequired
	    })),
	    projectStatusLabel: _propTypes2.default.string.isRequired,
	    projectsLink: _propTypes2.default.string,
	    projectsLinkHeading: _propTypes2.default.string,
	    tileLayer: _propTypes2.default.string
	};
	ActiveProjectsMapBlock.defaultProps = {
	    maxClusterRadius: 40
	};
	exports.default = ActiveProjectsMapBlock;
	module.exports = exports['default'];

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ActiveProjectsMapBlock = __webpack_require__(353);
	
	var _ActiveProjectsMapBlock2 = _interopRequireDefault(_ActiveProjectsMapBlock);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _ActiveProjectsMapBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cross = __webpack_require__(836);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	var _AnchorMenuModule = __webpack_require__(731);
	
	var _AnchorMenuModule2 = _interopRequireDefault(_AnchorMenuModule);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _scrollToElement = __webpack_require__(337);
	
	var _scrollToElement2 = _interopRequireDefault(_scrollToElement);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _throttle = __webpack_require__(70);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MobileToggle = function MobileToggle(_ref) {
	    var onClick = _ref.onClick,
	        isActiveOnMobile = _ref.isActiveOnMobile,
	        openText = _ref.openText,
	        closeText = _ref.closeText;
	
	    var buttonText = _react2.default.createElement(
	        "div",
	        { className: _AnchorMenuModule2.default.toggle, onClick: onClick },
	        _react2.default.createElement(
	            "span",
	            { className: _AnchorMenuModule2.default.toggleText },
	            openText,
	            _react2.default.createElement(_Icon2.default, { icon: "arrow-down", className: _AnchorMenuModule2.default.arrow })
	        )
	    );
	
	    var crossIcon = _react2.default.createElement(
	        "div",
	        { className: _AnchorMenuModule2.default.toggle, onClick: onClick },
	        _react2.default.createElement("img", { className: _AnchorMenuModule2.default.toggleCross, alt: closeText, src: _cross2.default })
	    );
	
	    return isActiveOnMobile ? crossIcon : buttonText;
	};
	
	function getAllElementsWithAttribute(attribute) {
	    var matchingElements = [];
	    var allElements = document.getElementsByTagName("*");
	    for (var i = 0, n = allElements.length; i < n; i++) {
	        if (allElements[i].getAttribute(attribute) !== null) {
	            matchingElements.push(allElements[i]);
	        }
	    }
	    return matchingElements;
	}
	
	var AnchorMenu = function (_React$PureComponent) {
	    _inherits(AnchorMenu, _React$PureComponent);
	
	    function AnchorMenu(props) {
	        _classCallCheck(this, AnchorMenu);
	
	        var _this = _possibleConstructorReturn(this, (AnchorMenu.__proto__ || Object.getPrototypeOf(AnchorMenu)).call(this, props));
	
	        _this.scrollToAnchor = function (target) {
	            var selector = "[data-block=\"" + target + "\"]";
	            var element = document.querySelector(selector);
	            var body = document.body;
	
	            body.classList.add("anchor-is-scrolling");
	            _this.setState({ scrollingItem: target });
	            _this.setState({ active: target });
	
	            if (target && element) {
	                window.history.pushState(null, null, "#" + target);
	                (0, _scrollToElement2.default)(selector, {
	                    offset: -69,
	                    ease: "linear",
	                    duration: 500
	                });
	            }
	
	            _this.setState({ isActiveOnMobile: false });
	        };
	
	        _this.handleOnClick = function (e) {
	            e.preventDefault();
	            var target = e.currentTarget.dataset.target;
	
	            _this.scrollToAnchor(target);
	        };
	
	        _this.scrollToAnchorOnPageLoad = function () {
	            var hash = window.location.hash.slice(1);
	
	            if (hash) {
	                setTimeout(function () {
	                    _this.scrollToAnchor(hash);
	                }, 500);
	            }
	        };
	
	        _this.handleScroll = (0, _throttle2.default)(function () {
	            var active = null;
	            var el = getAllElementsWithAttribute('data-block');
	            var selectedItem = _this.state.scrollingItem;
	            var body = document.body;
	            var header = document.querySelector('.site-header');
	            var $this = _this;
	            var $mainContainer = document.querySelector('#main');
	            var $footer = document.querySelector('.footer');
	            var siteHeight = $mainContainer.offsetHeight + $footer.offsetHeight;
	            var windowOffsetPlusMenuHeight = window.pageYOffset + 70;
	            var vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	            var logoWasClicked = body.classList.contains("logo-is-clicked");
	
	            var disableHeaderAnimation = function disableHeaderAnimation() {
	                body.classList.remove("anchor-is-scrolling");
	                header.classList.add("scroll-down");
	                body.classList.remove("logo-is-clicked");
	            };
	
	            if (logoWasClicked) {
	                setTimeout(function () {
	                    return disableHeaderAnimation();
	                }, 0);
	            } else {
	                if (selectedItem) {
	                    var selector = "[data-block=\"" + selectedItem + "\"]";
	                    var element = document.querySelector(selector);
	                    $this.setState({ active: selectedItem });
	
	                    if (element.offsetTop <= windowOffsetPlusMenuHeight && windowOffsetPlusMenuHeight <= element.offsetTop + element.offsetHeight || window.pageYOffset - 70 === siteHeight - vh) {
	                        $this.setState({ active: selectedItem });
	                        $this.setState({ scrollingItem: false });
	
	                        //timeout (0) to follow sequence
	                        setTimeout(function () {
	                            return disableHeaderAnimation();
	                        }, 0);
	                    }
	                } else {
	                    for (var i = 0; i < el.length; i++) {
	                        active = el[i].getAttribute('data-block');
	                        if (window.pageYOffset + 70 >= el[i].offsetTop && window.pageYOffset + 70 < el[i].offsetTop + el[i].offsetHeight) {
	                            break;
	                        } else {
	                            active = null;
	                        }
	                    }
	
	                    _this.setState({ active: active });
	                }
	            }
	        }, 0);
	
	
	        _this.state = {
	            isActiveOnMobile: false,
	            active: null,
	            scrollingItem: null
	        };
	
	        _this.activeOnMobile = _this.activeOnMobile.bind(_this);
	        _this.handleOnClick = _this.handleOnClick.bind(_this);
	        _this.handleScroll - _this.handleScroll.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        return _this;
	    }
	
	    _createClass(AnchorMenu, [{
	        key: "activeOnMobile",
	        value: function activeOnMobile() {
	            this.setState({ isActiveOnMobile: !this.state.isActiveOnMobile });
	        }
	    }, {
	        key: "scrollToTop",
	        value: function scrollToTop(speed) {
	            var body = document.body;
	            body.classList.add("logo-is-clicked");
	
	            (0, _scrollToElement2.default)(".site", {
	                offset: 0,
	                ease: "linear",
	                duration: speed
	            });
	
	            this.setState({ isActiveOnMobile: false });
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            typeof window !== 'undefined' && window.addEventListener("scroll", this.handleScroll);
	            this.scrollToAnchorOnPageLoad();
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            typeof window !== 'undefined' && window.removeEventListener("scroll", this.handleScroll);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                logo = _props.logo,
	                logoFallbackText = _props.logoFallbackText,
	                anchorHeading = _props.anchorHeading,
	                anchors = _props.anchors,
	                goToTopButtonText = _props.goToTopButtonText;
	            var _state = this.state,
	                isActiveOnMobile = _state.isActiveOnMobile,
	                active = _state.active;
	
	
	            var menuClassName = (0, _classnames2.default)(_AnchorMenuModule2.default.menu, {
	                activeMobile: isActiveOnMobile
	            });
	
	            return logo || logoFallbackText || anchors || goToTopButtonText ? _react2.default.createElement(
	                "nav",
	                { className: menuClassName },
	                _react2.default.createElement(
	                    "div",
	                    { className: _AnchorMenuModule2.default.inner },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _AnchorMenuModule2.default.header },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _AnchorMenuModule2.default.logo },
	                            _react2.default.createElement(
	                                "button",
	                                {
	                                    title: goToTopButtonText,
	                                    className: (0, _classnames2.default)("scroll-button"),
	                                    onClick: function onClick() {
	                                        _this2.scrollToTop(500);
	                                    }
	                                },
	                                logo ? _react2.default.createElement("img", { alt: logo.altText ? logo.altText : '', src: logo.url, className: _AnchorMenuModule2.default.logoImage }) : _react2.default.createElement(
	                                    "h2",
	                                    { className: _AnchorMenuModule2.default.logoFallbackText },
	                                    logoFallbackText
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(MobileToggle, {
	                            onClick: this.activeOnMobile,
	                            isActiveOnMobile: isActiveOnMobile,
	                            openText: anchorHeading,
	                            closeText: "close"
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "strong",
	                        { className: _AnchorMenuModule2.default.anchorsHeading },
	                        anchorHeading
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _AnchorMenuModule2.default.listWrapper },
	                        _react2.default.createElement(
	                            "ul",
	                            { className: _AnchorMenuModule2.default.list },
	                            anchors && anchors.map(function (l) {
	                                return _react2.default.createElement(
	                                    "li",
	                                    { key: l.blockId },
	                                    _react2.default.createElement(
	                                        "button",
	                                        {
	                                            "data-target": l.blockId,
	                                            onClick: _this2.handleOnClick,
	                                            className: (0, _classnames2.default)(_AnchorMenuModule2.default.button, _defineProperty({}, _AnchorMenuModule2.default.active, active == l.blockId))
	                                        },
	                                        l.title
	                                    )
	                                );
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _AnchorMenuModule2.default.scrollToTop },
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                title: goToTopButtonText,
	                                className: (0, _classnames2.default)("scroll-button"),
	                                onClick: function onClick() {
	                                    _this2.scrollToTop(500);
	                                }
	                            },
	                            goToTopButtonText
	                        )
	                    )
	                )
	            ) : null;
	        }
	    }]);
	
	    return AnchorMenu;
	}(_react2.default.PureComponent);
	
	AnchorMenu.propTypes = {
	    goToTopButtonText: _propTypes2.default.string,
	    logoFallbackText: _propTypes2.default.string,
	    logo: _propTypes2.default.shape({
	        url: _propTypes2.default.string,
	        altText: _propTypes2.default.string
	    }),
	    anchorHeading: _propTypes2.default.string,
	    anchors: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        blockId: _propTypes2.default.number.isRequired,
	        title: _propTypes2.default.string.isRequired
	    })).isRequired
	};
	exports.default = AnchorMenu;
	module.exports = exports["default"];

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AnchorMenu = __webpack_require__(378);
	
	var _AnchorMenu2 = _interopRequireDefault(_AnchorMenu);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _AnchorMenu2.default;
	module.exports = exports['default'];

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _OnScreen = __webpack_require__(31);
	
	var _OnScreen2 = _interopRequireDefault(_OnScreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Polyfill for IE and Safari < 9 
	
	/**
	 * Number.isFinite
	 * Copyright (c) 2014 marlun78
	 * MIT License, https://gist.github.com/marlun78/bd0800cf5e8053ba9f83
	 * 
	 * Spec: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.isfinite
	 */
	if (typeof Number.isFinite !== 'function') {
	    Number.isFinite = function isFinite(value) {
	        // 1. If Type(number) is not Number, return false.
	        if (typeof value !== 'number') {
	            return false;
	        }
	        // 2. If number is NaN, +∞, or −∞, return false.
	        if (value !== value || value === Infinity || value === -Infinity) {
	            return false;
	        }
	        // 3. Otherwise, return true.
	        return true;
	    };
	}
	
	var formatNumber = function formatNumber(num) {
	    if (Number.isFinite(num)) num = num.toString();
	
	    return num.replace('.', ',');
	};
	
	function generateNumberDifferences(oldValue, newValue) {
	    var steps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
	
	    var values = [];
	
	    var diff = oldValue - newValue;
	
	    for (var i = 1; i <= steps; i++) {
	        values.push((oldValue - diff / (steps + 1) * i).toFixed(2));
	    }
	
	    return values;
	}
	
	var AnimatedNumber = function (_React$PureComponent) {
	    _inherits(AnimatedNumber, _React$PureComponent);
	
	    function AnimatedNumber() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AnimatedNumber);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnimatedNumber.__proto__ || Object.getPrototypeOf(AnimatedNumber)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            outputValue: null
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AnimatedNumber, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref2) {
	            var _this2 = this;
	
	            var onScreen = _ref2.onScreen;
	
	            if (onScreen) {
	                var diffArray = generateNumberDifferences(0, this.props.children, 30),
	                    width = this.numberEl.offsetWidth;
	
	                this.setState({
	                    width: width,
	                    outputValue: this.props.children
	                }, function () {
	                    for (var i = 0; i < diffArray.length; i++) {
	                        _this2._setOutputValue(diffArray[i], (i + 1) * 25);
	                    }_this2._setOutputValue(null, (diffArray.length + 1) * 25);
	                });
	            }
	        }
	    }, {
	        key: '_setOutputValue',
	        value: function _setOutputValue(outputValue, timeout) {
	            var _this3 = this;
	
	            typeof window !== 'undefined' && window.setTimeout(function () {
	                return _this3.setState({ outputValue: outputValue });
	            }, timeout);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _props = this.props,
	                children = _props.children,
	                className = _props.className,
	                onScreen = _props.onScreen,
	                prefix = _props.prefix,
	                suffix = _props.suffix,
	                style = _props.style,
	                visibleClassName = _props.visibleClassName;
	            var outputValue = this.state.outputValue;
	
	
	            var value = children && formatNumber(children);
	
	            if (outputValue) {
	                value = formatNumber(outputValue);
	            }
	
	            return _react2.default.createElement(
	                'span',
	                {
	                    className: (0, _classnames2.default)(className, onScreen && visibleClassName),
	                    ref: function ref(s) {
	                        return _this4.numberEl = s;
	                    },
	                    style: _extends({}, style, {
	                        width: this.state.width
	                    })
	                },
	                '' + (prefix || "") + value + (suffix || "")
	            );
	        }
	    }]);
	
	    return AnimatedNumber;
	}(_react2.default.PureComponent);
	
	AnimatedNumber.propTypes = {
	    children: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    onScreen: _propTypes2.default.bool,
	    visibleClassName: _propTypes2.default.string,
	    prefix: _propTypes2.default.string,
	    suffix: _propTypes2.default.string,
	    style: _propTypes2.default.object
	};
	AnimatedNumber.defaultProps = {
	    colors: false
	};
	exports.default = (0, _OnScreen2.default)(AnimatedNumber);
	module.exports = exports['default'];

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AnimatedNumber = __webpack_require__(380);
	
	var _AnimatedNumber2 = _interopRequireDefault(_AnimatedNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AnimatedNumber2.default;
	module.exports = exports["default"];

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NewsListBlock = __webpack_require__(239);
	
	var _NewsListBlock2 = _interopRequireDefault(_NewsListBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArticleListBlock = function ArticleListBlock(props) {
	  return _react2.default.createElement(_NewsListBlock2.default, props);
	};
	
	exports.default = ArticleListBlock;
	module.exports = exports['default'];

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ArticleListBlock = exports.default = undefined;
	
	var _ArticleListBlock2 = __webpack_require__(382);
	
	var _ArticleListBlock3 = _interopRequireDefault(_ArticleListBlock2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ArticleListBlock3.default;
	exports.ArticleListBlock = _ArticleListBlock3.default;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ArticleTagsModule = __webpack_require__(732);
	
	var _ArticleTagsModule2 = _interopRequireDefault(_ArticleTagsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArticleTags = function ArticleTags(_ref) {
	    var tags = _ref.tags;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _ArticleTagsModule2.default.IEWrapper },
	        _react2.default.createElement(
	            "div",
	            { className: _ArticleTagsModule2.default.ArticleTags },
	            _react2.default.createElement(
	                "div",
	                { className: _ArticleTagsModule2.default.iconWrapper },
	                _react2.default.createElement(_Icon2.default, { icon: "arrows", className: _ArticleTagsModule2.default.icon })
	            ),
	            tags && _react2.default.createElement(
	                "div",
	                { className: _ArticleTagsModule2.default.tags },
	                tags
	            )
	        )
	    );
	};
	
	ArticleTags.propTypes = {
	    tags: _propTypes2.default.string.isRequired
	};
	
	exports.default = ArticleTags;
	module.exports = exports["default"];

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _ArticleTags = __webpack_require__(384);
	
	var _ArticleTags2 = _interopRequireDefault(_ArticleTags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ArticleTags2.default;
	module.exports = exports['default'];

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Published = __webpack_require__(131);
	
	var _Published2 = _interopRequireDefault(_Published);
	
	var _FluidImage = __webpack_require__(30);
	
	var _FluidImage2 = _interopRequireDefault(_FluidImage);
	
	var _Image = __webpack_require__(123);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(692);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArticleTeaser = function ArticleTeaser(_ref) {
	    var url = _ref.url,
	        heading = _ref.heading,
	        image = _ref.image,
	        published = _ref.published,
	        publishedLabel = _ref.publishedLabel;
	
	    return _react2.default.createElement(
	        "div",
	        { className: "article-teaser" },
	        _react2.default.createElement(
	            "a",
	            { className: "article-teaser__link", href: url },
	            _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)("article-teaser__image-holder", {
	                        "article-teaser__image-holder_no-image": !image
	                    }) },
	                image ? _react2.default.createElement(_FluidImage2.default, {
	                    className: "article-teaser__image",
	                    image: image.url,
	                    altText: image.altText,
	                    visible: true
	                }) : null
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "article-teaser__heading-holder" },
	                _react2.default.createElement(
	                    "h3",
	                    { className: "article-teaser__heading" },
	                    heading
	                )
	            ),
	            published && _react2.default.createElement(_Published2.default, { label: publishedLabel, date: published, className: "article-teaser__published-date" })
	        )
	    );
	};
	
	ArticleTeaser.propTypes = {
	    image: _propTypes2.default.shape(_Image2.default.propTypes),
	    published: _propTypes2.default.string,
	    url: _propTypes2.default.string.isRequired,
	    heading: _propTypes2.default.string.isRequired,
	    publishedLabel: _propTypes2.default.string
	};
	
	exports.default = ArticleTeaser;
	module.exports = exports["default"];

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _ArticleTeaser = __webpack_require__(386);
	
	var _ArticleTeaser2 = _interopRequireDefault(_ArticleTeaser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ArticleTeaser2.default;
	module.exports = exports['default'];

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(38);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _BannerModule = __webpack_require__(733);
	
	var _BannerModule2 = _interopRequireDefault(_BannerModule);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Banner = function (_React$Component) {
	  _inherits(Banner, _React$Component);
	
	  function Banner() {
	    _classCallCheck(this, Banner);
	
	    return _possibleConstructorReturn(this, (Banner.__proto__ || Object.getPrototypeOf(Banner)).apply(this, arguments));
	  }
	
	  _createClass(Banner, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          version = _props.version,
	          backgroundVideo = _props.backgroundVideo,
	          backgroundImage = _props.backgroundImage,
	          backgroundImageMobile = _props.backgroundImageMobile,
	          backgroundImageAlt = _props.backgroundImageAlt,
	          bubbleColor = _props.bubbleColor,
	          bubbleText = _props.bubbleText,
	          quotationColor = _props.quotationColor,
	          quotationText = _props.quotationText,
	          button = _props.button;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_BannerModule2.default.banner, version) },
	        _react2.default.createElement(_Media.Media, {
	          image: backgroundImage,
	          imageMobile: backgroundImageMobile,
	          video: backgroundVideo,
	          alt: backgroundImageAlt ? backgroundImageAlt : ''
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: _BannerModule2.default.banner__quotation },
	          bubbleText && _react2.default.createElement(
	            "div",
	            { className: (0, _classnames2.default)(_BannerModule2.default.banner__bubble, bubbleColor) },
	            _react2.default.createElement(
	              "div",
	              { className: _BannerModule2.default.banner__bubbleContainer },
	              _react2.default.createElement("div", { className: _BannerModule2.default.banner__bubbleBorderTop }),
	              _react2.default.createElement("div", { className: _BannerModule2.default.banner__bubbleBorderBottom }),
	              version === "small-quotation-big-speech-bubble" && quotationText && _react2.default.createElement(
	                "div",
	                { className: _BannerModule2.default.banner__quotationTextContainer },
	                _react2.default.createElement(
	                  "div",
	                  { className: (0, _classnames2.default)(_BannerModule2.default.banner__quotationText, quotationColor) },
	                  quotationText.line1 && _react2.default.createElement(
	                    "div",
	                    null,
	                    quotationText.line1
	                  ),
	                  quotationText.line2 && _react2.default.createElement(
	                    "div",
	                    null,
	                    quotationText.line2
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: _BannerModule2.default.banner__bubbleText },
	                bubbleText.line1 && _react2.default.createElement(
	                  "div",
	                  null,
	                  bubbleText.line1
	                ),
	                bubbleText.line2 && _react2.default.createElement(
	                  "div",
	                  null,
	                  bubbleText.line2
	                )
	              )
	            )
	          ),
	          quotationText && version === "big-quotation-small-speech-bubble" && _react2.default.createElement(
	            "div",
	            { className: _BannerModule2.default.banner__quotationTextContainer },
	            _react2.default.createElement(
	              "div",
	              { className: (0, _classnames2.default)(_BannerModule2.default.banner__quotationText, quotationColor) },
	              quotationText.line1 && _react2.default.createElement(
	                "div",
	                null,
	                quotationText.line1
	              ),
	              quotationText.line2 && _react2.default.createElement(
	                "div",
	                null,
	                quotationText.line2
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _BannerModule2.default.banner__linkContainer },
	          _react2.default.createElement(
	            "div",
	            null,
	            button && button.url && button.linkText ? _react2.default.createElement(
	              _Button2.default,
	              { tertiary: true, href: button.url },
	              button.linkText
	            ) : ""
	          )
	        )
	      );
	    }
	  }]);
	
	  return Banner;
	}(_react2.default.Component);
	
	Banner.propTypes = {
	  version: _propTypes2.default.oneOf(["big-quotation-small-speech-bubble", "small-quotation-big-speech-bubble"]),
	  backgroundVideo: _Media.Media && _Media.Media.propTypes.video,
	  backgroundImage: _Media.Media && _Media.Media.propTypes.image,
	  backgroundImageMobile: _Media.Media && _Media.Media.propTypes.imageMobile,
	  backgroundImageAlt: _propTypes2.default.string,
	  bubbleColor: _propTypes2.default.oneOf(["yellow", "white", "gray"]),
	  bubbleText: _propTypes2.default.shape({
	    line1: _propTypes2.default.string,
	    line2: _propTypes2.default.string
	  }),
	  quotationColor: _propTypes2.default.oneOf(["white", "gray"]),
	  quotationText: _propTypes2.default.shape({
	    line1: _propTypes2.default.string,
	    line2: _propTypes2.default.string
	  }),
	  button: _propTypes2.default.shape({
	    linkText: _propTypes2.default.string,
	    url: _propTypes2.default.string
	  })
	};
	Banner.defaultProps = {};
	exports.default = Banner;
	module.exports = exports["default"];

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _BannersListBlockModule = __webpack_require__(734);
	
	var _BannersListBlockModule2 = _interopRequireDefault(_BannersListBlockModule);
	
	var _reactSlick = __webpack_require__(1061);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _Banner = __webpack_require__(216);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	__webpack_require__(679);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BannersListBlock = function (_React$Component) {
	  _inherits(BannersListBlock, _React$Component);
	
	  function BannersListBlock() {
	    _classCallCheck(this, BannersListBlock);
	
	    return _possibleConstructorReturn(this, (BannersListBlock.__proto__ || Object.getPrototypeOf(BannersListBlock)).apply(this, arguments));
	  }
	
	  _createClass(BannersListBlock, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          banners = _props.banners,
	          autoplaySpeed = _props.autoplaySpeed,
	          speed = _props.speed;
	
	
	      var classNames = (0, _classnames2.default)(_BannersListBlockModule2.default.block, _BannersListBlockModule2.default.bg);
	
	      var sliderItems = banners && banners.map(function (banner, i) {
	        return _react2.default.createElement(_Banner2.default, _extends({}, banner, { key: i }));
	      });
	
	      var sliderSettings = {
	        dots: false,
	        arrows: true,
	        infinite: true,
	        speed: speed,
	        autoplaySpeed: autoplaySpeed,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        autoplay: true,
	        pauseOnHover: false,
	        fade: true,
	        draggable: true,
	        cssEase: "cubic-bezier(0,0,0.9,1)"
	      };
	
	      return _react2.default.createElement(
	        "div",
	        { className: classNames },
	        _react2.default.createElement(
	          _reactSlick2.default,
	          sliderSettings,
	          sliderItems
	        )
	      );
	    }
	  }]);
	
	  return BannersListBlock;
	}(_react2.default.Component);
	
	BannersListBlock.propTypes = {
	  banners: _propTypes2.default.array,
	  autoplaySpeed: _propTypes2.default.number,
	  speed: _propTypes2.default.number
	};
	BannersListBlock.defaultProps = {
	  autoplaySpeed: 6000,
	  speed: 800
	};
	exports.default = BannersListBlock;
	module.exports = exports["default"];

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _BannersListBlock = __webpack_require__(389);
	
	var _BannersListBlock2 = _interopRequireDefault(_BannersListBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BannersListBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BoardMember = __webpack_require__(217);
	
	var _BoardMember2 = _interopRequireDefault(_BoardMember);
	
	var _OnPageEditing = __webpack_require__(21);
	
	var _OnPageEditing2 = _interopRequireDefault(_OnPageEditing);
	
	var _BoardBlockModule = __webpack_require__(735);
	
	var _BoardBlockModule2 = _interopRequireDefault(_BoardBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoardBlock = function (_React$PureComponent) {
	    _inherits(BoardBlock, _React$PureComponent);
	
	    function BoardBlock() {
	        _classCallCheck(this, BoardBlock);
	
	        return _possibleConstructorReturn(this, (BoardBlock.__proto__ || Object.getPrototypeOf(BoardBlock)).apply(this, arguments));
	    }
	
	    _createClass(BoardBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                downloadImageLabel = _props.downloadImageLabel,
	                heading = _props.heading,
	                items = _props.items;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _BoardBlockModule2.default.block },
	                _react2.default.createElement(
	                    'div',
	                    { className: _BoardBlockModule2.default.content },
	                    _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { property: 'Heading' },
	                        _react2.default.createElement(
	                            'header',
	                            { className: _BoardBlockModule2.default.header },
	                            heading && _react2.default.createElement(
	                                'h2',
	                                { className: 'block-title-large' },
	                                heading
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { property: 'Items' },
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _BoardBlockModule2.default.items },
	                            items.map(function (item, key) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: key },
	                                    _react2.default.createElement(_BoardMember2.default, _extends({
	                                        downloadImageLabel: downloadImageLabel
	                                    }, item))
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BoardBlock;
	}(_react2.default.PureComponent);
	
	BoardBlock.propTypes = {
	    downloadImageLabel: _propTypes2.default.string.isRequired,
	    heading: _propTypes2.default.string.isRequired,
	    items: _propTypes2.default.arrayOf(_propTypes2.default.shape(_BoardMember2.default.propTypes))
	};
	exports.default = BoardBlock;
	module.exports = exports['default'];

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BoardBlock = exports.default = undefined;
	
	var _BoardBlock2 = __webpack_require__(391);
	
	var _BoardBlock3 = _interopRequireDefault(_BoardBlock2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BoardBlock3.default;
	exports.BoardBlock = _BoardBlock3.default;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FluidImage = __webpack_require__(30);
	
	var _FluidImage2 = _interopRequireDefault(_FluidImage);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _BoardMemberModule = __webpack_require__(736);
	
	var _BoardMemberModule2 = _interopRequireDefault(_BoardMemberModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoardMember = function (_React$PureComponent) {
	    _inherits(BoardMember, _React$PureComponent);
	
	    function BoardMember() {
	        _classCallCheck(this, BoardMember);
	
	        return _possibleConstructorReturn(this, (BoardMember.__proto__ || Object.getPrototypeOf(BoardMember)).apply(this, arguments));
	    }
	
	    _createClass(BoardMember, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                name = _props.name,
	                title = _props.title,
	                text = _props.text,
	                image = _props.image,
	                downloadImageUrl = _props.downloadImageUrl,
	                downloadImageLabel = _props.downloadImageLabel,
	                className = _props.className;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_BoardMemberModule2.default.member, _defineProperty({}, className, className)) },
	                _react2.default.createElement(
	                    'div',
	                    { className: _BoardMemberModule2.default.image },
	                    _react2.default.createElement(_FluidImage2.default, { image: image, altText: name ? name : '', className: _BoardMemberModule2.default.memberImage }),
	                    downloadImageUrl && downloadImageLabel && _react2.default.createElement(
	                        _Button2.default,
	                        {
	                            block: true,
	                            href: downloadImageUrl,
	                            secondary: true,
	                            target: '_blank',
	                            className: _BoardMemberModule2.default.button
	                        },
	                        downloadImageLabel
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _BoardMemberModule2.default.info },
	                    _react2.default.createElement(
	                        'h3',
	                        { className: _BoardMemberModule2.default.name },
	                        name
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: _BoardMemberModule2.default.title },
	                        title
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: _BoardMemberModule2.default.text },
	                        text
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BoardMember;
	}(_react2.default.PureComponent);
	
	BoardMember.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    title: _propTypes2.default.string.isRequired,
	    text: _propTypes2.default.string.isRequired,
	    image: _propTypes2.default.string.isRequired,
	    downloadImageUrl: _propTypes2.default.string,
	    downloadImageLabel: _propTypes2.default.string.isRequired,
	    className: _propTypes2.default.string
	};
	exports.default = BoardMember;
	module.exports = exports['default'];

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _OnPageEditing = __webpack_require__(21);
	
	var _OnPageEditing2 = _interopRequireDefault(_OnPageEditing);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _BusinessAreaBlockModule = __webpack_require__(737);
	
	var _BusinessAreaBlockModule2 = _interopRequireDefault(_BusinessAreaBlockModule);
	
	var _LinkButton = __webpack_require__(47);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BusinessAreaBlock = function (_React$Component) {
	    _inherits(BusinessAreaBlock, _React$Component);
	
	    function BusinessAreaBlock(props) {
	        _classCallCheck(this, BusinessAreaBlock);
	
	        var _this = _possibleConstructorReturn(this, (BusinessAreaBlock.__proto__ || Object.getPrototypeOf(BusinessAreaBlock)).call(this, props));
	
	        _this.state = {
	            currentArea: _this.props.links[0].title,
	            currentIndex: 0,
	            topSrc: false,
	            bottomSrc: false,
	            bottomOpacity: 0,
	            isDesktop: false
	        };
	        return _this;
	    }
	
	    _createClass(BusinessAreaBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                heading = _props.heading,
	                intro = _props.intro,
	                links = _props.links;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _BusinessAreaBlockModule2.default.block },
	                _react2.default.createElement(
	                    'div',
	                    { className: _BusinessAreaBlockModule2.default.inner },
	                    _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { property: 'Heading' },
	                        heading && _react2.default.createElement(
	                            'h2',
	                            { className: _BusinessAreaBlockModule2.default.heading },
	                            heading
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { property: 'Intro' },
	                        intro && _react2.default.createElement(
	                            'div',
	                            { className: _BusinessAreaBlockModule2.default.intro },
	                            intro
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { property: 'BusinessAreas' },
	                        links && _react2.default.createElement(
	                            'ul',
	                            { className: _BusinessAreaBlockModule2.default.links },
	                            links.map(function (link) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { className: _BusinessAreaBlockModule2.default['links-item'], key: link.text.toString() },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: link.url, className: (0, _classnames2.default)(_BusinessAreaBlockModule2.default.link) },
	                                        link.icon && _react2.default.createElement(_Icon2.default, { className: _BusinessAreaBlockModule2.default['link-icon'], icon: link.icon }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: _BusinessAreaBlockModule2.default['link-text'] },
	                                            link.text
	                                        )
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BusinessAreaBlock;
	}(_react2.default.Component);
	
	BusinessAreaBlock.propTypes = {
	    heading: _propTypes2.default.string.isRequired,
	    intro: _propTypes2.default.string,
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape(Object.assign({}, _LinkButton2.default.propTypes, {
	        icon: _propTypes2.default.string
	    }))).isRequired
	};
	exports.default = BusinessAreaBlock;
	module.exports = exports['default'];

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BusinessAreaBlock = exports.default = undefined;
	
	var _BusinessAreaBlock2 = __webpack_require__(394);
	
	var _BusinessAreaBlock3 = _interopRequireDefault(_BusinessAreaBlock2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BusinessAreaBlock3.default;
	exports.BusinessAreaBlock = _BusinessAreaBlock3.default;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(38);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _OnPageEditing = __webpack_require__(21);
	
	var _OnPageEditing2 = _interopRequireDefault(_OnPageEditing);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _BusinessAreaListBlockModule = __webpack_require__(738);
	
	var _BusinessAreaListBlockModule2 = _interopRequireDefault(_BusinessAreaListBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BusinessAreaListBlock = function (_React$Component) {
	    _inherits(BusinessAreaListBlock, _React$Component);
	
	    function BusinessAreaListBlock() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, BusinessAreaListBlock);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BusinessAreaListBlock.__proto__ || Object.getPrototypeOf(BusinessAreaListBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            topSrc: false,
	            bottomSrc: false,
	            bottomOpacity: 0
	        }, _this.componentDidMount = function () {
	            _this.setBackgroundImage(0);
	            _this.startLoop();
	        }, _this.componentWillUnmount = function () {
	            clearTimeout(_this.timeout);
	            clearInterval(_this.interval);
	        }, _this.startLoop = function () {
	            if (_this.props.links.length > 1) _this.interval = setInterval(_this.updateBackgroundImage, _this.props.loopDuration);
	        }, _this.updateBackgroundImage = function () {
	            _this.setBackgroundImage((_this.state.topSrc + 1) % _this.props.links.length);
	        }, _this.setBackgroundImage = function (target) {
	            if (target >= 0 && target < _this.props.links.length) _this.crossFade(target);
	        }, _this._onMouseOver = function (e) {
	            var target = parseInt(e.currentTarget.dataset.index, 10);
	            clearInterval(_this.interval);
	            clearTimeout(_this.timeout);
	            _this.setBackgroundImage(target);
	        }, _this._onMouseOut = function () {
	            _this.timeout = setTimeout(function () {
	                _this.startLoop();
	            }, 5000);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(BusinessAreaListBlock, [{
	        key: 'crossFade',
	        value: function crossFade(newIndex) {
	            var _this2 = this;
	
	            var oldIndex = this.state.topSrc;
	            if (newIndex !== oldIndex) {
	                // cancel out animation if any is running
	                this.setState({ bottomSrc: false, topSrc: false }, function () {
	                    return _this2.setState({
	
	                        bottomSrc: oldIndex,
	                        topSrc: newIndex,
	                        bottomOpacity: 0.99
	                    }, function () {
	                        clearTimeout(_this2.fadeTimeout);
	                        _this2.fadeTimeout = setTimeout(function () {
	                            return _this2.setState({ bottomOpacity: 0 });
	                        }, 20);
	                    });
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                heading = _props.heading,
	                links = _props.links,
	                fadeDuration = _props.fadeDuration;
	            var _state = this.state,
	                topSrc = _state.topSrc,
	                bottomSrc = _state.bottomSrc,
	                bottomOpacity = _state.bottomOpacity;
	
	
	            var classNames = (0, _classnames2.default)(_BusinessAreaListBlockModule2.default.block, _BusinessAreaListBlockModule2.default.bg);
	
	            return _react2.default.createElement(
	                'div',
	                { className: classNames },
	                topSrc !== false && _react2.default.createElement(_Media2.default, {
	                    image: this.props.links[topSrc].backgroundImage,
	                    imageMobile: this.props.links[topSrc].backgroundImageMobile ? this.props.links[topSrc].backgroundImageMobile : this.props.links[topSrc].backgroundImage,
	                    alt: heading,
	                    onScreen: true // fixed issue with onScreen being reset every time the component is re-rendered
	                }),
	                bottomSrc !== false && _react2.default.createElement(_Media2.default, {
	                    image: this.props.links[bottomSrc].backgroundImage,
	                    imageMobile: this.props.links[bottomSrc].backgroundImageMobile ? this.props.links[bottomSrc].backgroundImageMobile : this.props.links[bottomSrc].backgroundImage,
	                    alt: heading,
	                    onScreen: true // fixed issue with onScreen being reset every time the component is re-rendered
	                    , style: _extends({
	                        opacity: bottomOpacity,
	                        transition: 'opacity ' + fadeDuration / 1000 + 's ease'
	                    })
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: _BusinessAreaListBlockModule2.default.content },
	                    _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { property: 'Heading' },
	                        heading && _react2.default.createElement(
	                            'h2',
	                            { className: _BusinessAreaListBlockModule2.default.heading },
	                            heading
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { property: 'BusinessAreas' },
	                        links && _react2.default.createElement(
	                            'ul',
	                            { className: _BusinessAreaListBlockModule2.default.links },
	                            links.map(function (link, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index, onMouseOver: _this3._onMouseOver, onMouseOut: _this3._onMouseOut, 'data-index': index },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { className: (0, _classnames2.default)(_BusinessAreaListBlockModule2.default.link, _defineProperty({}, _BusinessAreaListBlockModule2.default.active, index === topSrc)), href: link.href },
	                                        link.icon && _react2.default.createElement(_Icon2.default, { icon: link.icon }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            link.title
	                                        )
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BusinessAreaListBlock;
	}(_react2.default.Component);
	
	BusinessAreaListBlock.propTypes = {
	    heading: _propTypes2.default.string.isRequired,
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        href: _propTypes2.default.string,
	        target: _propTypes2.default.string,
	        icon: _propTypes2.default.string,
	        title: _propTypes2.default.string,
	        backgroundImage: _Media2.default.propTypes.image
	    })).isRequired,
	    loopDuration: _propTypes2.default.number,
	    fadeDuration: _propTypes2.default.number
	};
	BusinessAreaListBlock.defaultProps = {
	    loopDuration: 5000,
	    fadeDuration: 500
	};
	exports.default = BusinessAreaListBlock;
	module.exports = exports['default'];

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _BusinessAreaListBlock = __webpack_require__(396);
	
	var _BusinessAreaListBlock2 = _interopRequireDefault(_BusinessAreaListBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BusinessAreaListBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(75);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CategoriesNavigationModule = __webpack_require__(739);
	
	var _CategoriesNavigationModule2 = _interopRequireDefault(_CategoriesNavigationModule);
	
	var _LinkButton = __webpack_require__(47);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoriesNavigation = function CategoriesNavigation(_ref) {
	    var categories = _ref.categories;
	    return categories && categories.length > 0 ? _react2.default.createElement(
	        'div',
	        { className: _CategoriesNavigationModule2.default.block },
	        _react2.default.createElement(
	            'div',
	            { className: _CategoriesNavigationModule2.default['categories-container'] },
	            _react2.default.createElement(
	                'ul',
	                { className: _CategoriesNavigationModule2.default['categories-list'] },
	                categories.map(function (category, i) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: i, className: _CategoriesNavigationModule2.default['categories-list-item'] },
	                        _react2.default.createElement(
	                            _Button2.default,
	                            { href: category.url, target: category.target, isActive: category.isActive, secondary: true, className: _CategoriesNavigationModule2.default['category-button'] },
	                            category.text
	                        )
	                    );
	                })
	            )
	        )
	    ) : null;
	};
	
	CategoriesNavigation.propTypes = {
	    categories: _propTypes2.default.arrayOf(_propTypes2.default.shape(_LinkButton2.default.propTypes))
	};
	
	exports.default = CategoriesNavigation;
	module.exports = exports['default'];

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _CheckboxModule = __webpack_require__(740);
	
	var _CheckboxModule2 = _interopRequireDefault(_CheckboxModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Checkbox = function (_React$Component) {
	    _inherits(Checkbox, _React$Component);
	
	    function Checkbox(props) {
	        _classCallCheck(this, Checkbox);
	
	        var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this));
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            _this.setState({ active: nextProps.checked });
	        };
	
	        _this.toggle = function () {
	            _this.setState({ active: !_this.state.active });
	        };
	
	        _this._handleClick = function (e) {
	            e.preventDefault();
	
	            _this.toggle();
	            _this.props.onChange && _this.props.onChange();
	        };
	
	        _this.state = {
	            active: props.checked
	        };
	        return _this;
	    }
	
	    _createClass(Checkbox, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                id = _props.id,
	                children = _props.children,
	                tabbable = _props.tabbable,
	                onChange = _props.onChange;
	            var active = this.state.active;
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    'data-id': id,
	                    onClick: this._handleClick,
	                    onChange: onChange,
	                    onKeyDown: function onKeyDown(e) {
	                        var code = e.which;
	                        // 13 = Return, 32 = Space
	                        if (code === 13 || code === 32) {
	                            e.stopPropagation();
	                            e.preventDefault();
	                            onChange(e);
	                        }
	                    },
	                    tabIndex: tabbable ? 0 : -1,
	                    className: (0, _classnames2.default)(_CheckboxModule2.default.block, _defineProperty({}, _CheckboxModule2.default['active'], active)) },
	                _react2.default.createElement(
	                    'span',
	                    { className: _CheckboxModule2.default.check },
	                    _react2.default.createElement(_Icon2.default, { icon: 'checkmark' })
	                ),
	                children
	            );
	        }
	    }]);
	
	    return Checkbox;
	}(_react2.default.Component);
	
	Checkbox.propTypes = {
	    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    children: _propTypes2.default.node,
	    onChange: _propTypes2.default.func,
	    tabbable: _propTypes2.default.bool,
	    checked: _propTypes2.default.bool
	};
	Checkbox.defaultProps = {
	    checked: false,
	    tabbable: true
	};
	exports.default = Checkbox;
	module.exports = exports['default'];

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Checkbox = __webpack_require__(399);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Checkbox2.default;
	module.exports = exports['default'];

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _CollaboratorLinksBlockModule = __webpack_require__(741);
	
	var _CollaboratorLinksBlockModule2 = _interopRequireDefault(_CollaboratorLinksBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollaboratorLinksBlock = function CollaboratorLinksBlock(_ref) {
	    var heading = _ref.heading,
	        collaborators = _ref.collaborators,
	        readMoreText = _ref.readMoreText,
	        readMoreLink = _ref.readMoreLink;
	
	
	    return _react2.default.createElement(
	        'div',
	        { className: _CollaboratorLinksBlockModule2.default.block },
	        _react2.default.createElement(
	            'div',
	            { className: _CollaboratorLinksBlockModule2.default.container },
	            heading && _react2.default.createElement(
	                'h2',
	                { className: _CollaboratorLinksBlockModule2.default.heading },
	                heading
	            ),
	            collaborators && _react2.default.createElement(
	                'ul',
	                { className: _CollaboratorLinksBlockModule2.default.collaborators },
	                collaborators.map(function (a, index) {
	                    var WrapperTag = a.link ? 'a' : 'div';
	                    return _react2.default.createElement(
	                        'li',
	                        { key: index, className: _CollaboratorLinksBlockModule2.default.collaborators__item },
	                        _react2.default.createElement(
	                            WrapperTag,
	                            { className: _CollaboratorLinksBlockModule2.default.collaborators__content, href: a.link },
	                            _react2.default.createElement(
	                                'span',
	                                { className: _CollaboratorLinksBlockModule2.default.collaborators__title },
	                                a.title
	                            ),
	                            a.isExternal && _react2.default.createElement(_Icon2.default, { icon: 'icon-share', className: _CollaboratorLinksBlockModule2.default.icon })
	                        )
	                    );
	                })
	            ),
	            readMoreLink && readMoreText && _react2.default.createElement(
	                'a',
	                { href: readMoreLink, className: _CollaboratorLinksBlockModule2.default.readMore },
	                readMoreText
	            )
	        )
	    );
	};
	
	CollaboratorLinksBlock.propTypes = {
	    heading: _propTypes2.default.string,
	    collaborators: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        title: _propTypes2.default.string,
	        link: _propTypes2.default.string,
	        isExternal: _propTypes2.default.bool
	    })),
	    readMoreText: _propTypes2.default.string,
	    readMoreLink: _propTypes2.default.string
	};
	
	exports.default = CollaboratorLinksBlock;
	module.exports = exports['default'];

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CollaboratorLinksBlock = __webpack_require__(401);
	
	var _CollaboratorLinksBlock2 = _interopRequireDefault(_CollaboratorLinksBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CollaboratorLinksBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(695);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Collapse = function (_React$PureComponent) {
	    _inherits(Collapse, _React$PureComponent);
	
	    function Collapse() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Collapse);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            isExpanded: false,
	            height: 0
	        }, _this.toggleExpand = function () {
	            _this.setState(function (prevState) {
	                return {
	                    isExpanded: !prevState.isExpanded
	                };
	            }, function () {
	                _this.setState({
	                    height: _this.state.isExpanded ? _this.contentRef.scrollHeight : 0
	                });
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Collapse, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.contentRef = this.contentRef || null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                expandLabel = _props.expandLabel,
	                collapseLabel = _props.collapseLabel,
	                children = _props.children;
	            var _state = this.state,
	                isExpanded = _state.isExpanded,
	                height = _state.height;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'collapse' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'collapse__toggle-btn-holder' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            onClick: this.toggleExpand,
	                            'aria-expanded': isExpanded,
	                            className: 'collapse__toggle-btn'
	                        },
	                        isExpanded ? collapseLabel : expandLabel,
	                        _react2.default.createElement(_Icon2.default, {
	                            icon: isExpanded ? "minus-circle" : "plus-circle",
	                            className: 'collapse__toggle-btn-icon'
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: 'collapse__content',
	                        ref: function ref(el) {
	                            return _this2.contentRef = el;
	                        },
	                        style: {
	                            overflow: 'hidden',
	                            transition: 'height 0.3s ease',
	                            height: height + 'px'
	                        },
	                        'aria-hidden': !isExpanded
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'collapse__indent-wrapper' },
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Collapse;
	}(_react2.default.PureComponent);
	
	Collapse.propTypes = {
	    expandLabel: _propTypes2.default.string.isRequired,
	    collapseLabel: _propTypes2.default.string.isRequired,
	    children: _propTypes2.default.node
	};
	exports.default = Collapse;
	module.exports = exports['default'];

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Collapse = __webpack_require__(403);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Collapse2.default;
	module.exports = exports['default'];

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CompanyListModule = __webpack_require__(264);
	
	var _CompanyListModule2 = _interopRequireDefault(_CompanyListModule);
	
	var _DepartmentInformationPage = __webpack_require__(220);
	
	var _DepartmentInformationPage2 = _interopRequireDefault(_DepartmentInformationPage);
	
	var _ListSearchForm = __webpack_require__(233);
	
	var _ListSearchForm2 = _interopRequireDefault(_ListSearchForm);
	
	var _CompanyListTab = __webpack_require__(406);
	
	var _CompanyListTab2 = _interopRequireDefault(_CompanyListTab);
	
	var _reactStickyEl = __webpack_require__(1071);
	
	var _reactStickyEl2 = _interopRequireDefault(_reactStickyEl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var bodyClass = "company-tabs-sticky";
	var SEARCH_QUERY_PARAM_NAME = "q";
	
	var CompanyList = function (_React$Component) {
	    _inherits(CompanyList, _React$Component);
	
	    function CompanyList(props) {
	        _classCallCheck(this, CompanyList);
	
	        var _this = _possibleConstructorReturn(this, (CompanyList.__proto__ || Object.getPrototypeOf(CompanyList)).call(this, props));
	
	        _this.onHashChange = function () {
	            var newHash = window.location.hash.slice(1);
	            _this.setState({
	                activeBusinessArea: newHash || null
	            });
	        };
	
	        _this.onTouchStart = function (e) {
	            _this.setState({
	                startX: e.touches[0].clientX
	            });
	        };
	
	        _this.scrollToCompanyList = function () {
	            if (_this.swipeableContainer) {
	                var offset = _this.offsetMarker.offsetHeight - 1;
	                var elementPosition = _this.swipeableContainer.getBoundingClientRect().top + window.scrollY;
	
	                window.scrollTo({
	                    top: elementPosition - offset,
	                    behavior: 'smooth'
	                });
	            }
	        };
	
	        _this.onTabsSticky = function (isSticky) {
	            if (isSticky) {
	                document.body.classList.add(bodyClass);
	                _this.scrollToCompanyList();
	            } else {
	                document.body.classList.remove(bodyClass);
	            }
	        };
	
	        _this.setActiveBusinessArea = function (businessArea) {
	            _this.setState({
	                activeBusinessArea: businessArea
	            });
	
	            var queryString = window.location.search || '';
	
	            if (businessArea === null) {
	                window.history.replaceState({}, document.title, '' + window.location.pathname + queryString);
	            } else {
	                var newUrl = '' + window.location.pathname + queryString + '#' + businessArea;
	                if (history.pushState) {
	                    history.pushState(null, null, newUrl);
	                } else {
	                    location.hash = businessArea;
	                }
	            }
	
	            if (document.body.classList.contains(bodyClass)) {
	                _this.scrollToCompanyList();
	            }
	        };
	
	        _this.getActiveBusinessAreaIndex = function (value) {
	            var array = _this.props.businessAreaTabs;
	            var key = 'businessArea';
	            for (var i = 0; i < array.length; i++) {
	                if (array[i][key] === value) {
	                    return i;
	                }
	            }
	            return null;
	        };
	
	        _this.scrollToElement = function (id) {
	            var element = document.getElementById(id);
	            if (element) {
	                element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
	            }
	        };
	
	        _this.setActiveBusinessAreaAndScrollToElement = function (businessArea) {
	            _this.setActiveBusinessArea(businessArea);
	            _this.scrollToElement(businessArea);
	        };
	
	        _this.setActiveNextBusinessArea = function () {
	            if (_this.state.activeBusinessArea) {
	                var currentIndex = _this.getActiveBusinessAreaIndex(_this.state.activeBusinessArea);
	
	                if (currentIndex + 1 < _this.props.businessAreaTabs.length) {
	                    _this.setActiveBusinessAreaAndScrollToElement(_this.props.businessAreaTabs[currentIndex + 1].businessArea);
	                }
	            } else {
	                _this.setActiveBusinessAreaAndScrollToElement(_this.props.businessAreaTabs[0].businessArea);
	            }
	        };
	
	        _this.setActivePrevBusinessArea = function () {
	            if (_this.state.activeBusinessArea) {
	                var currentIndex = _this.getActiveBusinessAreaIndex(_this.state.activeBusinessArea);
	
	                if (currentIndex == 0) {
	                    _this.setActiveBusinessArea(null);
	                    _this.scrollToElement('allBusinessAreas');
	                } else {
	                    _this.setActiveBusinessAreaAndScrollToElement(_this.props.businessAreaTabs[currentIndex - 1].businessArea);
	                }
	            }
	        };
	
	        _this.onTouchEnd = function (e) {
	            var startX = _this.state.startX;
	
	            var endX = e.changedTouches[0].clientX;
	            var deltaX = endX - startX;
	            var swipeThreshold = 50;
	
	            if (deltaX > swipeThreshold) {
	                _this.setActivePrevBusinessArea();
	            } else if (deltaX < -swipeThreshold) {
	                _this.setActiveNextBusinessArea();
	            }
	        };
	
	        _this.onSearchFormSubmit = function (searchValue) {
	            var searchParams = new URLSearchParams(window.location.search);
	
	            if (searchValue) {
	                searchParams.set(SEARCH_QUERY_PARAM_NAME, searchValue);
	            } else {
	                searchParams.delete(SEARCH_QUERY_PARAM_NAME);
	            }
	
	            var newUrl = '' + window.location.pathname + (searchParams.toString() ? '?' + searchParams.toString() : '') + window.location.hash;
	            window.history.replaceState({}, '', newUrl);
	            _this.setActiveBusinessArea(null);
	            _this.setState({ searchQuery: searchValue });
	        };
	
	        _this.checkIfBillingUnitMatchedSearch = function (billingUnit, searchQuery) {
	            return billingUnit.billingName && billingUnit.billingName.toLowerCase().includes(searchQuery.toLowerCase());
	        };
	
	        _this.calculateCurrentListResults = function () {
	            var _this$state = _this.state,
	                searchQuery = _this$state.searchQuery,
	                activeBusinessArea = _this$state.activeBusinessArea;
	            var companies = _this.props.companies;
	
	
	            var totalMatches = 0;
	
	            var filteredCompanies = companies.filter(function (company) {
	                var matchesHeading = searchQuery ? company.heading && company.heading.toLowerCase().includes(searchQuery.toLowerCase()) : true;
	
	                if (matchesHeading) {
	                    totalMatches += 1;
	                }
	
	                var matchesBillingUnits = false;
	                if (searchQuery && company.billingUnits && company.billingUnits.length > 0) {
	                    for (var i = 0; i < company.billingUnits.length; i++) {
	                        var billingUnit = company.billingUnits[i];
	                        if (_this.checkIfBillingUnitMatchedSearch(billingUnit, searchQuery)) {
	                            matchesBillingUnits = true;
	                            totalMatches += 1;
	                        }
	                    }
	                }
	
	                return matchesHeading || matchesBillingUnits;
	            }).map(function (company) {
	                var hasBillingUnitMatch = false;
	                if (searchQuery && company.billingUnits) {
	                    for (var i = 0; i < company.billingUnits.length; i++) {
	                        var billingUnit = company.billingUnits[i];
	                        if (_this.checkIfBillingUnitMatchedSearch(billingUnit, searchQuery)) {
	                            hasBillingUnitMatch = true;
	                            break;
	                        }
	                    }
	                }
	
	                return _extends({}, company, {
	                    hasBillingUnitMatch: hasBillingUnitMatch
	                });
	            }).filter(function (company) {
	                return activeBusinessArea === null || company.businessAreas && company.businessAreas.indexOf(activeBusinessArea) !== -1;
	            });
	
	            _this.setState({
	                filteredCompanies: filteredCompanies,
	                totalMatches: totalMatches
	            });
	        };
	
	        _this.state = {
	            activeBusinessArea: null,
	            startX: null,
	            searchQuery: "",
	            searchQueryMatchedCompanies: [],
	            filteredCompanies: [],
	            businessAreaCounts: {}
	        };
	        return _this;
	    }
	
	    _createClass(CompanyList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var searchParams = new URLSearchParams(window.location.search);
	            var searchQuery = searchParams.get(SEARCH_QUERY_PARAM_NAME) || '';
	            var initialHash = window.location.hash.slice(1);
	
	            this.setState({
	                searchQuery: searchQuery,
	                activeBusinessArea: initialHash || null
	            }, this.calculateCurrentListResults);
	
	            this.swipeableContainer.addEventListener('touchstart', this.onTouchStart);
	            this.swipeableContainer.addEventListener('touchend', this.onTouchEnd);
	
	            window.addEventListener("hashchange", this.onHashChange);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(_, prevState) {
	            if (prevState.searchQuery !== this.state.searchQuery || prevState.activeBusinessArea !== this.state.activeBusinessArea) {
	                this.calculateCurrentListResults();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.swipeableContainer.removeEventListener('touchstart', this.onTouchStart);
	            this.swipeableContainer.removeEventListener('touchend', this.onTouchEnd);
	
	            window.removeEventListener("hashchange", this.onHashChange);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                businessAreaTabs = _props.businessAreaTabs,
	                lang = _props.lang;
	            var _state = this.state,
	                activeBusinessArea = _state.activeBusinessArea,
	                searchQuery = _state.searchQuery,
	                filteredCompanies = _state.filteredCompanies,
	                totalMatches = _state.totalMatches;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _CompanyListModule2.default.block },
	                _react2.default.createElement(
	                    'div',
	                    { className: _CompanyListModule2.default.search },
	                    _react2.default.createElement(_ListSearchForm2.default, {
	                        searchInputLabel: lang.searchInputLabel,
	                        searchButtonAriaLabel: lang.searchButtonAriaLabel,
	                        searchInputPlaceholder: lang.searchInputPlaceholder,
	                        searchParamName: SEARCH_QUERY_PARAM_NAME,
	                        defaultValue: searchQuery,
	                        totalListItemsCount: totalMatches,
	                        listItemsCount: totalMatches,
	                        searchHitsText: lang.searchHitsText,
	                        noResultsText: lang.noResultsText,
	                        noSearchHitsTextDisplayed: !searchQuery,
	                        onFormSubmit: this.onSearchFormSubmit,
	                        className: _CompanyListModule2.default['search-form']
	                    })
	                ),
	                _react2.default.createElement(
	                    _reactStickyEl2.default,
	                    {
	                        stickyClassName: _CompanyListModule2.default['tabs-sticky'],
	                        onFixedToggle: this.onTabsSticky
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: _CompanyListModule2.default['tabs-scroll-container'],
	                            ref: function ref(el) {
	                                return _this2.offsetMarker = el;
	                            }
	                        },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _CompanyListModule2.default['tabs-container'] },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _CompanyListModule2.default.tabs },
	                                _react2.default.createElement(_CompanyListTab2.default, {
	                                    onClick: function onClick(e) {
	                                        e.preventDefault();
	                                        _this2.setActiveBusinessArea(null);
	                                    },
	                                    name: lang.allBusinessAreasTabText,
	                                    isActive: !activeBusinessArea,
	                                    businessArea: 'allBusinessAreas'
	                                }),
	                                businessAreaTabs && businessAreaTabs.map(function (tab) {
	                                    return _react2.default.createElement(_CompanyListTab2.default, {
	                                        key: tab.businessArea,
	                                        businessArea: tab.businessArea,
	                                        name: tab.name,
	                                        onClick: function onClick(e) {
	                                            e.preventDefault();
	                                            _this2.setActiveBusinessArea(tab.businessArea);
	                                        },
	                                        isActive: activeBusinessArea === tab.businessArea
	                                    });
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        ref: function ref(el) {
	                            return _this2.swipeableContainer = el;
	                        },
	                        className: _CompanyListModule2.default['swipable-container']
	                    },
	                    filteredCompanies && filteredCompanies.map(function (company) {
	                        return _react2.default.createElement(_DepartmentInformationPage2.default, _extends({
	                            key: company.contentId,
	                            isBillingUnitsListExpanded: company.hasBillingUnitMatch
	                        }, company));
	                    }),
	                    filteredCompanies && filteredCompanies.length === 0 && _react2.default.createElement(
	                        'div',
	                        { className: _CompanyListModule2.default['no-results'] },
	                        lang.noResultsText
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CompanyList;
	}(_react2.default.Component);
	
	CompanyList.propTypes = {
	    businessAreaTabs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        name: _propTypes2.default.string,
	        businessArea: _propTypes2.default.string.isRequired
	    })),
	    lang: _propTypes2.default.shape({
	        allBusinessAreasTabText: _propTypes2.default.string.isRequired,
	        noResultsText: _propTypes2.default.string.isRequired,
	        searchInputLabel: _propTypes2.default.string.isRequired,
	        searchButtonAriaLabel: _propTypes2.default.string.isRequired,
	        searchInputPlaceholder: _propTypes2.default.string.isRequired,
	        searchHitsText: _propTypes2.default.string.isRequired
	    }).isRequired,
	    companies: _propTypes2.default.arrayOf(_propTypes2.default.shape(_DepartmentInformationPage2.default.propTypes))
	};
	exports.default = CompanyList;
	module.exports = exports['default'];

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CompanyListModule = __webpack_require__(264);
	
	var _CompanyListModule2 = _interopRequireDefault(_CompanyListModule);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CompanyListTab = function CompanyListTab(_ref) {
	    var _cn;
	
	    var businessArea = _ref.businessArea,
	        name = _ref.name,
	        _ref$onClick = _ref.onClick,
	        onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	        _ref$isActive = _ref.isActive,
	        isActive = _ref$isActive === undefined ? false : _ref$isActive,
	        _ref$isGrayedOut = _ref.isGrayedOut,
	        isGrayedOut = _ref$isGrayedOut === undefined ? false : _ref$isGrayedOut;
	    return _react2.default.createElement(
	        'li',
	        { className: _CompanyListModule2.default.tab, id: businessArea },
	        _react2.default.createElement(
	            'button',
	            {
	                className: (0, _classnames2.default)(_CompanyListModule2.default['tab-button'], (_cn = {}, _defineProperty(_cn, _CompanyListModule2.default['active'], isActive), _defineProperty(_cn, _CompanyListModule2.default['grayed-out'], isGrayedOut), _cn)),
	                disabled: isActive,
	                onClick: onClick
	            },
	            name
	        )
	    );
	};
	
	CompanyListTab.propTypes = {
	    businessArea: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    onClick: _propTypes2.default.func,
	    isActive: _propTypes2.default.bool,
	    isGrayedOut: _propTypes2.default.bool
	};
	
	exports.default = CompanyListTab;
	module.exports = exports['default'];

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CompanyList = __webpack_require__(405);
	
	var _CompanyList2 = _interopRequireDefault(_CompanyList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CompanyList2.default;
	module.exports = exports['default'];

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ContactPerson = __webpack_require__(536);
	
	var _ContactPerson2 = _interopRequireDefault(_ContactPerson);
	
	var _FluidImage = __webpack_require__(30);
	
	var _FluidImage2 = _interopRequireDefault(_FluidImage);
	
	var _OnPageEditing = __webpack_require__(21);
	
	var _OnPageEditing2 = _interopRequireDefault(_OnPageEditing);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _LinkButton = __webpack_require__(47);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _ContactBlockModule = __webpack_require__(742);
	
	var _ContactBlockModule2 = _interopRequireDefault(_ContactBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function name(person) {
	    return person.firstName + ' ' + person.lastName;
	}
	
	var Person = function Person(_ref) {
	    var _classNames2;
	
	    var onPageEditing = _ref.onPageEditing,
	        person = _ref.person,
	        contactLength = _ref.contactLength,
	        size = _ref.size,
	        sendEmailLabel = _ref.sendEmailLabel,
	        hideEmailAddress = _ref.hideEmailAddress,
	        small = _ref.small;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_ContactBlockModule2.default['person-block'], _defineProperty({}, _ContactBlockModule2.default['left-aligned'], contactLength <= 2)) },
	        _react2.default.createElement(
	            _OnPageEditing2.default,
	            { active: onPageEditing, property: 'ProfilePicture' },
	            person.profilePicture && _react2.default.createElement(_FluidImage2.default, {
	                altText: name(person),
	                className: (0, _classnames2.default)(_ContactBlockModule2.default.circle, _ContactBlockModule2.default["circle-" + size]),
	                image: person.profilePicture
	            })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_ContactBlockModule2.default['info'], (_classNames2 = {}, _defineProperty(_classNames2, _ContactBlockModule2.default['left-aligned'], contactLength <= 2 && !small), _defineProperty(_classNames2, _ContactBlockModule2.default['no-image'], !person.profilePicture), _classNames2)) },
	            _react2.default.createElement(
	                'div',
	                { className: _ContactBlockModule2.default['detailed-info'] },
	                _react2.default.createElement(
	                    'p',
	                    { className: _ContactBlockModule2.default.name },
	                    _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { active: onPageEditing, component: 'span', property: 'FirstName' },
	                        person.firstName
	                    ),
	                    ' ',
	                    _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { active: onPageEditing, component: 'span', property: 'LastName' },
	                        person.lastName
	                    )
	                ),
	                _react2.default.createElement(
	                    _OnPageEditing2.default,
	                    { active: onPageEditing, property: 'Title' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: _ContactBlockModule2.default.title },
	                        person.title
	                    )
	                ),
	                _react2.default.createElement(
	                    _OnPageEditing2.default,
	                    { active: onPageEditing, property: 'Department' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: _ContactBlockModule2.default.department },
	                        person.department
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _ContactBlockModule2.default['contact-info'] },
	                !hideEmailAddress && _react2.default.createElement(
	                    _OnPageEditing2.default,
	                    { active: onPageEditing, property: 'EmailAddress' },
	                    person.emailAddress && _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-name': name(person), href: 'mailto:' + person.emailAddress },
	                            sendEmailLabel || person.emailAddress
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _OnPageEditing2.default,
	                    { active: onPageEditing, property: 'Phone' },
	                    person.phone && _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { 'data-name': name(person), href: 'tel:' + person.phone },
	                            person.phone
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	Person.propTypes = Object.assign({}, _ContactPerson2.default.propTypes);
	
	var ContactBlock = function ContactBlock(_ref2) {
	    var className = _ref2.className,
	        blockId = _ref2.blockId,
	        contentType = _ref2.contentType,
	        heading = _ref2.heading,
	        contacts = _ref2.contacts,
	        small = _ref2.small,
	        sendEmailLabel = _ref2.sendEmailLabel,
	        hideEmailAddress = _ref2.hideEmailAddress,
	        seeAllLink = _ref2.seeAllLink;
	
	    var size = small || contacts.length > 1 ? "medium" : "large";
	
	    return _react2.default.createElement(
	        'div',
	        {
	            className: (0, _classnames2.default)(_ContactBlockModule2.default.contacts, className, _defineProperty({}, _ContactBlockModule2.default.small, small)),
	            'data-block': blockId
	        },
	        _react2.default.createElement(
	            _OnPageEditing2.default,
	            { active: contentType === 'ContactPersonListBlock', property: 'Heading' },
	            heading && _react2.default.createElement(
	                'h2',
	                { className: _ContactBlockModule2.default.heading },
	                heading
	            )
	        ),
	        _react2.default.createElement(
	            _OnPageEditing2.default,
	            { active: contentType === 'ContactPersonListBlock', property: 'Contacts' },
	            _react2.default.createElement(
	                'ul',
	                { className: _ContactBlockModule2.default['block-wrapper'] },
	                contacts.map(function (person, i) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: i },
	                        _react2.default.createElement(Person, {
	                            contactLength: contacts.length,
	                            onPageEditing: contentType !== 'ContactPersonListBlock',
	                            person: person,
	                            size: size,
	                            sendEmailLabel: sendEmailLabel,
	                            hideEmailAddress: hideEmailAddress,
	                            small: small
	                        })
	                    );
	                })
	            )
	        ),
	        _react2.default.createElement(
	            _OnPageEditing2.default,
	            { active: contentType === 'ContactPersonListBlock', property: 'SeeAllLink' },
	            seeAllLink && _react2.default.createElement(
	                _Button2.default,
	                {
	                    className: _ContactBlockModule2.default['see-all-link'],
	                    secondary: true,
	                    href: seeAllLink.url
	                },
	                seeAllLink.text
	            )
	        )
	    );
	};
	
	ContactBlock.propTypes = {
	    className: _propTypes2.default.string,
	    blockId: _propTypes2.default.number,
	    contentType: _propTypes2.default.string,
	    heading: _propTypes2.default.string,
	    contacts: _propTypes2.default.arrayOf(_propTypes2.default.shape(_ContactPerson2.default.propTypes)).isRequired,
	    small: _propTypes2.default.bool,
	    sendEmailLabel: _propTypes2.default.string.isRequired,
	    hideEmailAddress: _propTypes2.default.bool,
	    seeAllLink: _propTypes2.default.shape(_LinkButton2.default.propTypes)
	};
	
	exports.default = ContactBlock;
	module.exports = exports['default'];

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DropdownFilter = __webpack_require__(58);
	
	var _DropdownFilter2 = _interopRequireDefault(_DropdownFilter);
	
	var _ContactsListModule = __webpack_require__(743);
	
	var _ContactsListModule2 = _interopRequireDefault(_ContactsListModule);
	
	var _formHelper = __webpack_require__(249);
	
	var _formHelper2 = _interopRequireDefault(_formHelper);
	
	var _ContactBlock = __webpack_require__(98);
	
	var _ContactBlock2 = _interopRequireDefault(_ContactBlock);
	
	var _ListSearchForm = __webpack_require__(233);
	
	var _ListSearchForm2 = _interopRequireDefault(_ListSearchForm);
	
	var _Button = __webpack_require__(75);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _apiHelper = __webpack_require__(135);
	
	var _apiHelper2 = _interopRequireDefault(_apiHelper);
	
	var _replaceQueryParameters = __webpack_require__(214);
	
	var _replaceQueryParameters2 = _interopRequireDefault(_replaceQueryParameters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEARCH_NAME = "q";
	var FILTER_NAME = "company";
	
	var ContactsList = function (_React$Component) {
	    _inherits(ContactsList, _React$Component);
	
	    function ContactsList(props) {
	        _classCallCheck(this, ContactsList);
	
	        var _this = _possibleConstructorReturn(this, (ContactsList.__proto__ || Object.getPrototypeOf(ContactsList)).call(this, props));
	
	        _this.buildInitQuery = function () {
	            var query = _formHelper2.default.createQuery();
	            _formHelper2.default.fillQueryFromPageQueryString(query);
	            return query;
	        };
	
	        _this.onFilterChange = function (e, activeIndex) {
	            var query = _this.state.query;
	            _formHelper2.default.setToQueryFilterOptions(query, _this.props.companiesFilter, FILTER_NAME, activeIndex);
	
	            _this.setState({ query: query, page: 1 }, function () {
	                _this.loadContacts();
	            });
	
	            _formHelper2.default.updatePageQueryString(query);
	        };
	
	        _this.onFormSubmit = function (searchValue) {
	            var query = _this.state.query;
	            _formHelper2.default.setToQueryTextInputValue(query, SEARCH_NAME, searchValue);
	
	            _this.setState({ query: query, page: 1 }, function () {
	                _this.loadContacts();
	            });
	            _formHelper2.default.updatePageQueryString(query);
	        };
	
	        _this.loadContacts = function () {
	            _this.setState({
	                isLoading: true,
	                showError: false
	            });
	            var ENDPOINT = _this.props.loadItemsEndpoint;
	            var query = Object.assign({}, _this.state.query);
	            query = Object.assign(query, { page: _this.state.page, pageSize: _this.props.pageSize });
	            var searchEndpoint = ENDPOINT.indexOf('data/static-site') !== -1 ? ENDPOINT : (0, _replaceQueryParameters2.default)(ENDPOINT, query);
	            _apiHelper2.default.get(searchEndpoint).then(function (response) {
	                var loadedContacts = response.contacts ? response.contacts : [];
	
	                _this.setState(function (prevState) {
	                    return {
	                        isLoading: false,
	                        listItems: _this.state.page == 1 ? [].concat(_toConsumableArray(loadedContacts)) : [].concat(_toConsumableArray(prevState.listItems), _toConsumableArray(loadedContacts)),
	                        totalCount: response.totalCount
	                    };
	                });
	            }).catch(function () {
	                _this.setState({
	                    isLoading: false,
	                    showError: true
	                });
	            });
	        };
	
	        _this.onLoadMore = function () {
	            _this.setState({ page: _this.state.page + 1 }, function () {
	                _this.loadContacts();
	            });
	        };
	
	        _this.state = {
	            query: {},
	            listItems: [],
	            isLoading: true,
	            showError: false,
	            page: 1,
	            totalCount: null
	        };
	        return _this;
	    }
	
	    _createClass(ContactsList, [{
	        key: 'checkKeyMatchFilterKeys',
	        value: function checkKeyMatchFilterKeys(keyToCheck, itemsArray) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = itemsArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var item = _step.value;
	
	                    if (item.key === keyToCheck) {
	                        return true;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return false;
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (typeof window !== 'undefined') {
	                var initQuery = this.buildInitQuery();
	                this.setState({ query: initQuery });
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadContacts();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                companiesFilter = _props.companiesFilter,
	                lang = _props.lang;
	            var _state = this.state,
	                listItems = _state.listItems,
	                showError = _state.showError,
	                totalCount = _state.totalCount,
	                isLoading = _state.isLoading,
	                query = _state.query;
	
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: _ContactsListModule2.default.wrapper
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)(_ContactsListModule2.default.filter) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)(_ContactsListModule2.default['filter-container'], isLoading ? _ContactsListModule2.default['loading'] : null) },
	                        _react2.default.createElement(_DropdownFilter2.default, _extends({}, companiesFilter, {
	                            name: FILTER_NAME,
	                            onSelect: this.onFilterChange,
	                            yellow: true,
	                            multy: false,
	                            className: _ContactsListModule2.default.companies,
	                            active: this.checkKeyMatchFilterKeys(Number(query[FILTER_NAME]), companiesFilter.items) ? Number(query[FILTER_NAME]) : null
	                        }))
	                    )
	                ),
	                _react2.default.createElement(_ListSearchForm2.default, {
	                    searchInputLabel: lang.searchInputLabel,
	                    searchButtonAriaLabel: lang.searchButtonText,
	                    searchInputPlaceholder: lang.searchInputPlaceholder,
	                    searchParamName: SEARCH_NAME,
	                    defaultValue: query[SEARCH_NAME],
	                    isLoading: isLoading,
	                    totalListItemsCount: totalCount,
	                    listItemsCount: listItems.length,
	                    searchHitsText: lang.searchHitsText,
	                    noResultsText: lang.noResultsText,
	                    onFormSubmit: this.onFormSubmit
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContactsListModule2.default['contacts-list'] },
	                    _react2.default.createElement(_ContactBlock2.default, {
	                        heading: null,
	                        sendEmailLabel: lang.sendEmailLabel,
	                        contacts: listItems,
	                        small: true,
	                        className: 'contact-block_in-contacts-list'
	                    }),
	                    listItems && listItems.length > 0 && totalCount && listItems.length < totalCount && _react2.default.createElement(
	                        _Button2.default,
	                        {
	                            className: _ContactsListModule2.default['load-more-button'],
	                            secondary: true,
	                            onClick: this.onLoadMore,
	                            disabled: isLoading
	                        },
	                        lang.loadMoreButtonText
	                    ),
	                    showError && lang.errorMessage && _react2.default.createElement(
	                        'div',
	                        { className: _ContactsListModule2.default.error },
	                        lang.errorMessage
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ContactsList;
	}(_react2.default.Component);
	
	ContactsList.propTypes = {
	    companiesFilter: _propTypes2.default.shape(_DropdownFilter2.default.propTypes),
	    loadItemsEndpoint: _propTypes2.default.string,
	    pageSize: _propTypes2.default.number,
	    lang: _propTypes2.default.shape({
	        loadMoreButtonText: _propTypes2.default.string.isRequired,
	        sendEmailLabel: _propTypes2.default.string.isRequired,
	        searchInputPlaceholder: _propTypes2.default.string.isRequired,
	        searchInputLabel: _propTypes2.default.string.isRequired,
	        searchButtonText: _propTypes2.default.string.isRequired,
	        errorMessage: _propTypes2.default.string.isRequired,
	        noResultsText: _propTypes2.default.string.isRequired,
	        searchHitsText: _propTypes2.default.string.isRequired
	    }).isRequired
	};
	exports.default = ContactsList;
	module.exports = exports['default'];

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _ContactsList = __webpack_require__(409);
	
	var _ContactsList2 = _interopRequireDefault(_ContactsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ContactsList2.default;
	module.exports = exports['default'];

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _CookieBlockModule = __webpack_require__(744);
	
	var _CookieBlockModule2 = _interopRequireDefault(_CookieBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CookieBlock = function (_React$PureComponent) {
	    _inherits(CookieBlock, _React$PureComponent);
	
	    function CookieBlock() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, CookieBlock);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CookieBlock.__proto__ || Object.getPrototypeOf(CookieBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            firstVisit: false
	        }, _this.close = function () {
	            localStorage.setItem('af-cookies', 'true');
	
	            _this.setState({
	                firstVisit: false
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(CookieBlock, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!localStorage.getItem('af-cookies')) {
	                this.setState({
	                    firstVisit: true
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                text = _props.text,
	                linkText = _props.linkText,
	                url = _props.url;
	
	
	            if (!this.state.firstVisit) return null;
	
	            return _react2.default.createElement(
	                'div',
	                { className: _CookieBlockModule2.default.block },
	                _react2.default.createElement(
	                    'div',
	                    { className: _CookieBlockModule2.default.content },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        text,
	                        ' ',
	                        _react2.default.createElement(
	                            'a',
	                            { target: '_blank', href: url },
	                            linkText
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _CookieBlockModule2.default['icon-container'], onClick: this.close },
	                    _react2.default.createElement(_Icon2.default, { className: _CookieBlockModule2.default.icon, icon: 'close' })
	                )
	            );
	        }
	    }]);
	
	    return CookieBlock;
	}(_react2.default.PureComponent);
	
	CookieBlock.propTypes = {
	    text: _propTypes2.default.string.isRequired,
	    linkText: _propTypes2.default.string.isRequired,
	    url: _propTypes2.default.string.isRequired
	};
	exports.default = CookieBlock;
	module.exports = exports['default'];

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CookieBlock = __webpack_require__(411);
	
	var _CookieBlock2 = _interopRequireDefault(_CookieBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CookieBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CuriousBlockModule = __webpack_require__(745);
	
	var _CuriousBlockModule2 = _interopRequireDefault(_CuriousBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CuriousBlock = function (_React$PureComponent) {
	    _inherits(CuriousBlock, _React$PureComponent);
	
	    function CuriousBlock() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, CuriousBlock);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CuriousBlock.__proto__ || Object.getPrototypeOf(CuriousBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            shown: false
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(CuriousBlock, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                className = _props.className,
	                text = _props.text,
	                link = _props.link,
	                linkText = _props.linkText,
	                icon = _props.icon;
	            var shown = this.state.shown;
	
	            var iconToShow = icon ? icon : 'binoculars';
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: (0, _classnames2.default)(_CuriousBlockModule2.default.block, className, _defineProperty({}, _CuriousBlockModule2.default.shown, shown))
	                },
	                _react2.default.createElement(
	                    "button",
	                    { onClick: function onClick() {
	                            return _this2.setState({ shown: !shown });
	                        } },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(_Icon2.default, {
	                            className: (0, _classnames2.default)(_CuriousBlockModule2.default.icon, _defineProperty({}, _CuriousBlockModule2.default.large, icon && !shown)),
	                            icon: shown ? "close" : iconToShow
	                        })
	                    )
	                ),
	                shown && _react2.default.createElement(
	                    "div",
	                    { className: _CuriousBlockModule2.default.tooltip },
	                    _react2.default.createElement(_Icon2.default, { className: (0, _classnames2.default)(_CuriousBlockModule2.default.tooltipIcon, _defineProperty({}, _CuriousBlockModule2.default.large, icon)), icon: iconToShow }),
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        text
	                    ),
	                    link && linkText && _react2.default.createElement(
	                        "p",
	                        { className: _CuriousBlockModule2.default.link },
	                        _react2.default.createElement(
	                            _Button2.default,
	                            { secondary: true, blue: true, href: link },
	                            linkText
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CuriousBlock;
	}(_react2.default.PureComponent);
	
	CuriousBlock.propTypes = {
	    className: _propTypes2.default.string.isRequied,
	    text: _propTypes2.default.string.isRequired,
	    link: _propTypes2.default.string,
	    linkText: _propTypes2.default.string,
	    icon: _propTypes2.default.string
	};
	exports.default = CuriousBlock;
	module.exports = exports["default"];

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _OnPageEditing = __webpack_require__(21);
	
	var _OnPageEditing2 = _interopRequireDefault(_OnPageEditing);
	
	var _DepartmentInformationBlockModule = __webpack_require__(746);
	
	var _DepartmentInformationBlockModule2 = _interopRequireDefault(_DepartmentInformationBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DepartmentInformationBlock = function (_React$Component) {
	    _inherits(DepartmentInformationBlock, _React$Component);
	
	    function DepartmentInformationBlock() {
	        _classCallCheck(this, DepartmentInformationBlock);
	
	        return _possibleConstructorReturn(this, (DepartmentInformationBlock.__proto__ || Object.getPrototypeOf(DepartmentInformationBlock)).apply(this, arguments));
	    }
	
	    _createClass(DepartmentInformationBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                heading = _props.heading,
	                intro = _props.intro,
	                image = _props.image,
	                link = _props.link,
	                readMoreLabel = _props.readMoreLabel;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _DepartmentInformationBlockModule2.default.block },
	                _react2.default.createElement(
	                    'div',
	                    { className: _DepartmentInformationBlockModule2.default.wrapper },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DepartmentInformationBlockModule2.default.content },
	                        _react2.default.createElement(
	                            _OnPageEditing2.default,
	                            { property: 'Heading' },
	                            _react2.default.createElement(
	                                'h2',
	                                { className: _DepartmentInformationBlockModule2.default.heading },
	                                link ? _react2.default.createElement(
	                                    'a',
	                                    { className: _DepartmentInformationBlockModule2.default.headingLink, href: link },
	                                    heading
	                                ) : { heading: heading }
	                            )
	                        ),
	                        intro && _react2.default.createElement(
	                            'p',
	                            null,
	                            intro
	                        ),
	                        _react2.default.createElement(
	                            _OnPageEditing2.default,
	                            { property: 'Link' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: _DepartmentInformationBlockModule2.default.link },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: link },
	                                    readMoreLabel
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DepartmentInformationBlockModule2.default.image },
	                        image && _react2.default.createElement('img', { src: image, alt: heading ? heading : '' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DepartmentInformationBlock;
	}(_react2.default.Component);
	
	DepartmentInformationBlock.propTypes = {
	    heading: _propTypes2.default.string.isRequired,
	    intro: _propTypes2.default.string.isRequired,
	    image: _propTypes2.default.string.isRequired,
	    link: _propTypes2.default.string.isRequired,
	    readMoreLabel: _propTypes2.default.string.isRequired
	};
	exports.default = DepartmentInformationBlock;
	module.exports = exports['default'];

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DepartmentInformationBlock = __webpack_require__(414);
	
	var _DepartmentInformationBlock2 = _interopRequireDefault(_DepartmentInformationBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DepartmentInformationBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DepartmentInformationPage = __webpack_require__(419);
	
	var _DepartmentInformationPage2 = _interopRequireDefault(_DepartmentInformationPage);
	
	var _PaginatorBlock = __webpack_require__(128);
	
	var _PaginatorBlock2 = _interopRequireDefault(_PaginatorBlock);
	
	var _tracking = __webpack_require__(99);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DepartmentInformationListBlock = function (_React$Component) {
	    _inherits(DepartmentInformationListBlock, _React$Component);
	
	    function DepartmentInformationListBlock() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, DepartmentInformationListBlock);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DepartmentInformationListBlock.__proto__ || Object.getPrototypeOf(DepartmentInformationListBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            currentPage: 1
	        }, _this._handlePageChange = function (page) {
	            return _this.setState({ currentPage: page }, function () {
	                (0, _tracking.track)('list_expansion', 'DepartmentInformationListBlock - Page ' + page);
	            });
	        }, _this._shouldBeVisible = function (index) {
	            var currentPage = _this.state.currentPage;
	            var blocksPerPage = _this.props.blocksPerPage;
	
	
	            var firstVisible = (currentPage - 1) * blocksPerPage;
	            var lastVisible = firstVisible + (blocksPerPage - 1);
	
	            return index >= firstVisible && index <= lastVisible;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(DepartmentInformationListBlock, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                departments = _props.departments,
	                blocksPerPage = _props.blocksPerPage,
	                pagerLabels = _props.pagerLabels;
	            var currentPage = this.state.currentPage;
	
	
	            var hasDepartments = departments && departments.length > 0;
	            var hasPagination = (departments && departments.length) > blocksPerPage;
	
	            var pages = hasPagination && Math.ceil(departments.length / blocksPerPage);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    hasDepartments && departments.map(function (department, index) {
	                        return _react2.default.createElement(_DepartmentInformationPage2.default, _extends({
	                            key: index
	                        }, department, {
	                            style: { display: _this2._shouldBeVisible(index) ? null : 'none' }
	                        }));
	                    })
	                ),
	                hasPagination && _react2.default.createElement(_PaginatorBlock2.default, {
	                    pages: pages,
	                    currentPage: currentPage,
	                    onPageChange: this._handlePageChange,
	                    prevButtonLabel: pagerLabels && pagerLabels.prevButton ? pagerLabels.prevButton : null,
	                    nextButtonLabel: pagerLabels && pagerLabels.nextButton ? pagerLabels.nextButton : null
	                })
	            );
	        }
	    }]);
	
	    return DepartmentInformationListBlock;
	}(_react2.default.Component);
	
	DepartmentInformationListBlock.propTypes = {
	    departments: _propTypes2.default.array.isRequired,
	    blocksPerPage: _propTypes2.default.number.isRequired,
	    pagerLabels: _propTypes2.default.shape({
	        prevButton: _propTypes2.default.string,
	        nextButton: _propTypes2.default.string
	    })
	};
	exports.default = DepartmentInformationListBlock;
	module.exports = exports['default'];

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DepartmentInformationListBlock = __webpack_require__(416);
	
	var _DepartmentInformationListBlock2 = _interopRequireDefault(_DepartmentInformationListBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DepartmentInformationListBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DepartmentInformationBillingUnit = function DepartmentInformationBillingUnit(_ref) {
	    var billingName = _ref.billingName,
	        organizationNumber = _ref.organizationNumber,
	        invoiceAsEHF = _ref.invoiceAsEHF,
	        invoiceEmailAddress = _ref.invoiceEmailAddress,
	        invoiceEhfLabel = _ref.invoiceEhfLabel,
	        orgNoLabel = _ref.orgNoLabel,
	        heading = _ref.heading,
	        sendInvoiceEmailLabel = _ref.sendInvoiceEmailLabel,
	        invoiceAsEHFYesText = _ref.invoiceAsEHFYesText,
	        invoiceAsEHFNoText = _ref.invoiceAsEHFNoText;
	    return _react2.default.createElement(
	        'div',
	        null,
	        billingName && _react2.default.createElement(
	            'strong',
	            { className: 'billing-name' },
	            billingName
	        ),
	        organizationNumber && _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'billing-line' },
	                orgNoLabel && _react2.default.createElement(
	                    'span',
	                    { className: 'billing-label' },
	                    orgNoLabel,
	                    ':'
	                ),
	                organizationNumber
	            )
	        ),
	        invoiceEmailAddress && _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'billing-line flex-wrap' },
	                sendInvoiceEmailLabel && _react2.default.createElement(
	                    'span',
	                    { className: 'billing-label' },
	                    sendInvoiceEmailLabel,
	                    ':'
	                ),
	                invoiceEmailAddress && _react2.default.createElement(
	                    'a',
	                    { 'data-name': heading, href: 'mailto:' + invoiceEmailAddress },
	                    invoiceEmailAddress
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'billing-line' },
	                invoiceEhfLabel && _react2.default.createElement(
	                    'span',
	                    { className: 'billing-label' },
	                    invoiceEhfLabel,
	                    ':'
	                ),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    invoiceAsEHF ? invoiceAsEHFYesText : invoiceAsEHFNoText
	                )
	            )
	        )
	    );
	};
	
	DepartmentInformationBillingUnit.propTypes = {
	    billingName: _propTypes2.default.string,
	    organizationNumber: _propTypes2.default.string,
	    invoiceAsEHF: _propTypes2.default.bool.isRequired,
	    invoiceAsEHFYesText: _propTypes2.default.string,
	    invoiceAsEHFNoText: _propTypes2.default.string,
	    invoiceEmailAddress: _propTypes2.default.string,
	    invoiceEhfLabel: _propTypes2.default.string,
	    orgNoLabel: _propTypes2.default.string,
	    invoiceEhfLinkText: _propTypes2.default.string,
	    heading: _propTypes2.default.string,
	    sendInvoiceEmailLabel: _propTypes2.default.string
	};
	
	exports.default = DepartmentInformationBillingUnit;
	module.exports = exports['default'];

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DepartmentInformationPage = exports.default = undefined;
	
	var _DepartmentInformationPage2 = __webpack_require__(220);
	
	var _DepartmentInformationPage3 = _interopRequireDefault(_DepartmentInformationPage2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DepartmentInformationPage3.default;
	exports.DepartmentInformationPage = _DepartmentInformationPage3.default;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLeafletUniversal = __webpack_require__(197);
	
	var _selskapGul42x49px = __webpack_require__(837);
	
	var _selskapGul42x49px2 = _interopRequireDefault(_selskapGul42x49px);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var icon = function icon() {
	    if (typeof window === 'undefined') return {};
	
	    var L = __webpack_require__(8);
	
	    return L.divIcon({
	        html: '<img src="' + _selskapGul42x49px2.default + '" />',
	        className: 'department-marker',
	        iconAnchor: [21, 49],
	        iconSize: [42, 49]
	    });
	};
	
	var DepartmentMarker = function DepartmentMarker(_ref) {
	    var position = _ref.position;
	    return _react2.default.createElement(_reactLeafletUniversal.Marker, { icon: icon(), position: position });
	};
	
	DepartmentMarker.propTypes = {
	    position: _propTypes2.default.array
	};
	
	exports.default = DepartmentMarker;
	module.exports = exports['default'];

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DepartmentMarker = __webpack_require__(420);
	
	var _DepartmentMarker2 = _interopRequireDefault(_DepartmentMarker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DepartmentMarker2.default;
	module.exports = exports['default'];

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LinkButton = __webpack_require__(47);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _Button = __webpack_require__(75);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DidntFindAnswerModule = __webpack_require__(748);
	
	var _DidntFindAnswerModule2 = _interopRequireDefault(_DidntFindAnswerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DidntFindAnswer = function DidntFindAnswer(_ref) {
	    var lang = _ref.lang,
	        formLink = _ref.formLink;
	
	    return formLink ? _react2.default.createElement(
	        'div',
	        { className: _DidntFindAnswerModule2.default.block },
	        _react2.default.createElement(
	            'div',
	            { className: _DidntFindAnswerModule2.default.text },
	            lang.didntFindAnswerText
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _DidntFindAnswerModule2.default['link-container'] },
	            _react2.default.createElement(
	                _Button2.default,
	                { className: _DidntFindAnswerModule2.default.link, secondary: true, href: formLink.url, target: formLink.target },
	                formLink.text
	            )
	        )
	    ) : null;
	};
	
	DidntFindAnswer.propTypes = {
	    lang: _propTypes2.default.shape({
	        didntFindAnswerText: _propTypes2.default.string.isRequired
	    }).isRequired,
	    formLink: _propTypes2.default.shape(_LinkButton2.default.propTypes)
	};
	
	exports.default = DidntFindAnswer;
	module.exports = exports['default'];

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DidntFindAnswer = __webpack_require__(422);
	
	var _DidntFindAnswer2 = _interopRequireDefault(_DidntFindAnswer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DidntFindAnswer2.default;
	module.exports = exports['default'];

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DoYouHaveQuestionsBlockModule = __webpack_require__(749);
	
	var _DoYouHaveQuestionsBlockModule2 = _interopRequireDefault(_DoYouHaveQuestionsBlockModule);
	
	var _LinkButton = __webpack_require__(47);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _CategoriesNavigation = __webpack_require__(219);
	
	var _CategoriesNavigation2 = _interopRequireDefault(_CategoriesNavigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DoYouHaveQuestionsBlock = function DoYouHaveQuestionsBlock(_ref) {
	    var heading = _ref.heading,
	        introHtml = _ref.introHtml,
	        categories = _ref.categories;
	    return _react2.default.createElement(
	        'div',
	        { className: _DoYouHaveQuestionsBlockModule2.default.block },
	        heading && _react2.default.createElement(
	            'h2',
	            { className: _DoYouHaveQuestionsBlockModule2.default.heading },
	            heading
	        ),
	        introHtml && _react2.default.createElement('div', { className: _DoYouHaveQuestionsBlockModule2.default.intro, dangerouslySetInnerHTML: { __html: introHtml } }),
	        categories && _react2.default.createElement(_CategoriesNavigation2.default, { categories: categories })
	    );
	};
	
	DoYouHaveQuestionsBlock.propTypes = {
	    heading: _propTypes2.default.string.isRequired,
	    introHtml: _propTypes2.default.string,
	    categories: _propTypes2.default.arrayOf(_propTypes2.default.shape(_LinkButton2.default.propTypes))
	};
	
	exports.default = DoYouHaveQuestionsBlock;
	module.exports = exports['default'];

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DoYouHaveQuestionsBlock = __webpack_require__(424);
	
	var _DoYouHaveQuestionsBlock2 = _interopRequireDefault(_DoYouHaveQuestionsBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DoYouHaveQuestionsBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Link = __webpack_require__(522);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _DocumentBlockModule = __webpack_require__(750);
	
	var _DocumentBlockModule2 = _interopRequireDefault(_DocumentBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DocumentBlock = function (_React$PureComponent) {
	    _inherits(DocumentBlock, _React$PureComponent);
	
	    function DocumentBlock() {
	        _classCallCheck(this, DocumentBlock);
	
	        return _possibleConstructorReturn(this, (DocumentBlock.__proto__ || Object.getPrototypeOf(DocumentBlock)).apply(this, arguments));
	    }
	
	    _createClass(DocumentBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                title = _props.title,
	                readMoreLink = _props.readMoreLink,
	                readMoreText = _props.readMoreText,
	                thumbnailImage = _props.thumbnailImage,
	                pdfLink = _props.pdfLink,
	                pdfLinkText = _props.pdfLinkText,
	                webcastLink = _props.webcastLink,
	                webcastLinkText = _props.webcastLinkText,
	                presentationLink = _props.presentationLink,
	                presentationLinkText = _props.presentationLinkText,
	                xbrlLink = _props.xbrlLink,
	                xbrlLinkText = _props.xbrlLinkText;
	
	
	            var hasPdf = pdfLink && pdfLinkText;
	            var hasWebcast = webcastLink && webcastLinkText;
	            var hasPresentation = presentationLink && presentationLinkText;
	            var hasReadMore = readMoreLink && readMoreText;
	            var hasXbrlLink = xbrlLink && xbrlLinkText;
	
	            return _react2.default.createElement(
	                'div',
	                { className: _DocumentBlockModule2.default.document },
	                _react2.default.createElement(
	                    'div',
	                    { className: _DocumentBlockModule2.default.image },
	                    thumbnailImage && _react2.default.createElement('img', { src: thumbnailImage, alt: title ? title : '' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _DocumentBlockModule2.default.content },
	                    _react2.default.createElement(
	                        'h3',
	                        { className: _DocumentBlockModule2.default.title },
	                        title
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _DocumentBlockModule2.default.links },
	                        hasPdf && _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _Link2.default,
	                                {
	                                    className: _DocumentBlockModule2.default.link,
	                                    href: pdfLink,
	                                    icon: 'arrow-grey-light-right',
	                                    target: '_blank'
	                                },
	                                pdfLinkText
	                            )
	                        ),
	                        hasWebcast && _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _Link2.default,
	                                {
	                                    className: _DocumentBlockModule2.default.link,
	                                    href: webcastLink,
	                                    icon: 'arrow-grey-light-right',
	                                    target: '_blank'
	                                },
	                                webcastLinkText
	                            )
	                        ),
	                        hasPresentation && _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _Link2.default,
	                                {
	                                    className: _DocumentBlockModule2.default.link,
	                                    href: presentationLink,
	                                    icon: 'arrow-grey-light-right',
	                                    target: '_blank'
	                                },
	                                presentationLinkText
	                            )
	                        ),
	                        hasXbrlLink && _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _Link2.default,
	                                {
	                                    className: _DocumentBlockModule2.default.link,
	                                    href: xbrlLink,
	                                    icon: 'arrow-grey-light-right',
	                                    target: '_blank'
	                                },
	                                xbrlLinkText
	                            )
	                        ),
	                        hasReadMore && _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _Link2.default,
	                                {
	                                    className: _DocumentBlockModule2.default.link,
	                                    href: readMoreLink,
	                                    icon: 'arrow-grey-light-right',
	                                    download: true
	                                },
	                                readMoreText
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DocumentBlock;
	}(_react2.default.PureComponent);
	
	DocumentBlock.propTypes = {
	    "title": _propTypes2.default.string,
	    "readMoreLink": _propTypes2.default.string,
	    "readMoreText": _propTypes2.default.string,
	    "thumbnailImage": _propTypes2.default.string,
	    "pdfLink": _propTypes2.default.string,
	    "webcastLink": _propTypes2.default.string,
	    "presentationLink": _propTypes2.default.string,
	    "pdfLinkText": _propTypes2.default.string,
	    "webcastLinkText": _propTypes2.default.string,
	    "presentationLinkText": _propTypes2.default.string,
	    "xbrlLink": _propTypes2.default.string,
	    "xbrlLinkText": _propTypes2.default.string,
	    "blockId": _propTypes2.default.number,
	    "contentType": _propTypes2.default.string
	};
	exports.default = DocumentBlock;
	module.exports = exports['default'];

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DocumentBlock = exports.default = undefined;
	
	var _DocumentBlock2 = __webpack_require__(426);
	
	var _DocumentBlock3 = _interopRequireDefault(_DocumentBlock2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DocumentBlock3.default;
	exports.DocumentBlock = _DocumentBlock3.default;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PaginatorBlock = __webpack_require__(128);
	
	var _PaginatorBlock2 = _interopRequireDefault(_PaginatorBlock);
	
	var _DocumentFilterListBlockModule = __webpack_require__(751);
	
	var _DocumentFilterListBlockModule2 = _interopRequireDefault(_DocumentFilterListBlockModule);
	
	var _debounce = __webpack_require__(53);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DropdownFilter = __webpack_require__(58);
	
	var _DropdownFilter2 = _interopRequireDefault(_DropdownFilter);
	
	var _TableBlock = __webpack_require__(133);
	
	var _TableBlock2 = _interopRequireDefault(_TableBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEBOUNCE_DURATION = 500;
	
	var DocumentFilterListBlock = function (_React$Component) {
	    _inherits(DocumentFilterListBlock, _React$Component);
	
	    function DocumentFilterListBlock(props) {
	        _classCallCheck(this, DocumentFilterListBlock);
	
	        var _this = _possibleConstructorReturn(this, (DocumentFilterListBlock.__proto__ || Object.getPrototypeOf(DocumentFilterListBlock)).call(this));
	
	        _this.state = {
	            year: "",
	            type: "",
	            page: 1
	        };
	
	        _this.pageChange = function (page) {
	            _this.setState({
	                page: page
	            }, _this._debouncedFilterItems);
	        };
	
	        _this._yearFilter = function (e, value) {
	            _this.setState({
	                page: 1, // reset page
	                year: value
	            }, _this._debouncedFilterItems);
	        };
	
	        _this._typeFilter = function (e, value) {
	            _this.setState({
	                page: 1, // reset page
	                type: value
	            }, _this._debouncedFilterItems);
	        };
	
	        _this._filterItems = function () {
	            var filter = _extends({}, _this.state);
	            delete filter.documents;
	
	            function search() {
	                var _this2 = this;
	
	                var finalUrl = this.props.apiUrl + "?" + Object.keys(filter).map(function (item) {
	                    return item + "=" + filter[item];
	                }).join("&");
	                window.fetch(finalUrl, {
	                    headers: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json'
	                    },
	                    credentials: 'same-origin',
	                    method: 'GET'
	                }).then(function (res) {
	                    if (!res.ok) {
	                        _this2.setState({
	                            searching: false
	                        });
	
	                        return console.error(res);
	                    }
	
	                    res.json().then(function (json) {
	                        _this2.setState({
	                            documents: json,
	                            searching: false
	                        });
	                    });
	                }).catch(function (err) {
	                    console.error(err);
	
	                    _this2.setState({
	                        searching: false
	                    });
	                });
	            }
	
	            _this.setState({
	                searching: true
	            }, search);
	        };
	
	        _this._debouncedFilterItems = (0, _debounce2.default)(_this._filterItems, DEBOUNCE_DURATION);
	
	        _this.types = Object.keys(props.availableTypes).map(function (o) {
	            return {
	                "key": o,
	                "value": props.availableTypes[o]
	            };
	        });
	        _this.state = _extends({}, _this.state, {
	            documents: props.documents,
	            pageSize: props.defaultPageSize
	        });
	        return _this;
	    }
	
	    _createClass(DocumentFilterListBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                anchorId = _props.anchorId,
	                yearsHeading = _props.yearsHeading,
	                years = _props.years,
	                typeHeading = _props.typeHeading,
	                filterHeading = _props.filterHeading,
	                pagerLabels = _props.pagerLabels,
	                heading = _props.heading;
	            var _state = this.state,
	                documents = _state.documents,
	                page = _state.page,
	                pageSize = _state.pageSize;
	
	
	            var pageCount = Math.ceil(documents.totalCount / pageSize);
	
	            return _react2.default.createElement(
	                'div',
	                { className: _DocumentFilterListBlockModule2.default.block, id: anchorId },
	                heading && _react2.default.createElement(
	                    'h2',
	                    { className: _DocumentFilterListBlockModule2.default.blockHeading },
	                    heading
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _DocumentFilterListBlockModule2.default.filters },
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(_DropdownFilter2.default, {
	                                className: _DocumentFilterListBlockModule2.default.filter,
	                                heading: yearsHeading,
	                                items: years,
	                                onSelect: this._yearFilter
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(_DropdownFilter2.default, {
	                                className: _DocumentFilterListBlockModule2.default.filter,
	                                heading: typeHeading,
	                                items: this.types,
	                                onSelect: this._typeFilter
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _Button2.default,
	                                { secondary: true, compact: true, onClick: this._debouncedFilterItems },
	                                filterHeading
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _DocumentFilterListBlockModule2.default["list-outer"] },
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)(_DocumentFilterListBlockModule2.default.list, _defineProperty({}, _DocumentFilterListBlockModule2.default.searching, this.state.searching)) },
	                        _react2.default.createElement(_TableBlock2.default, { data: documents.items.map(function (item, index) {
	                                if (index === 0) {
	                                    return item;
	                                }
	                                return _extends({}, item, {
	                                    "title": item.link ? "<a href=" + item.link + " target='_blank'>" + item.title + "</a>" : item.title
	                                });
	                            }), keys: ["publishedDate", "title"] })
	                    ),
	                    _react2.default.createElement(_PaginatorBlock2.default, {
	                        pages: pageCount,
	                        currentPage: page,
	                        onPageChange: this.pageChange,
	                        prevButtonLabel: pagerLabels && pagerLabels.prevButton ? pagerLabels.prevButton : null,
	                        nextButtonLabel: pagerLabels && pagerLabels.nextButton ? pagerLabels.nextButton : null
	                    })
	                )
	            );
	        }
	    }]);
	
	    return DocumentFilterListBlock;
	}(_react2.default.Component);
	
	DocumentFilterListBlock.propTypes = {
	    apiUrl: _propTypes2.default.string.isRequired,
	    heading: _propTypes2.default.string,
	    years: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        key: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	        value: _propTypes2.default.string
	    })),
	    yearsHeading: _propTypes2.default.string,
	    divisions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        key: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	        value: _propTypes2.default.string
	    })),
	    typeHeading: _propTypes2.default.string,
	    availableTypes: _propTypes2.default.object,
	
	    filterHeading: _propTypes2.default.string,
	
	    defaultPageSize: _propTypes2.default.number.isRequired,
	    documents: _propTypes2.default.shape({
	        items: _propTypes2.default.array,
	        totalCount: _propTypes2.default.number
	    }),
	    language: _propTypes2.default.string,
	    anchorId: _propTypes2.default.string,
	    blockId: _propTypes2.default.number,
	    contentType: _propTypes2.default.string,
	    pagerLabels: _propTypes2.default.shape({
	        prevButton: _propTypes2.default.string,
	        nextButton: _propTypes2.default.string
	    })
	};
	DocumentFilterListBlock.defaultProps = {
	    language: 'no'
	};
	exports.default = DocumentFilterListBlock;
	module.exports = exports['default'];

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DocumentFilterListBlock = __webpack_require__(428);
	
	var _DocumentFilterListBlock2 = _interopRequireDefault(_DocumentFilterListBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DocumentFilterListBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Block = __webpack_require__(613);
	
	var _Block2 = _interopRequireDefault(_Block);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DocumentBlock = __webpack_require__(427);
	
	var _DocumentBlock2 = _interopRequireDefault(_DocumentBlock);
	
	var _OnPageEditing = __webpack_require__(21);
	
	var _OnPageEditing2 = _interopRequireDefault(_OnPageEditing);
	
	var _DocumentListBlockModule = __webpack_require__(752);
	
	var _DocumentListBlockModule2 = _interopRequireDefault(_DocumentListBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DocumentListBlock = function (_React$PureComponent) {
	    _inherits(DocumentListBlock, _React$PureComponent);
	
	    function DocumentListBlock() {
	        _classCallCheck(this, DocumentListBlock);
	
	        return _possibleConstructorReturn(this, (DocumentListBlock.__proto__ || Object.getPrototypeOf(DocumentListBlock)).apply(this, arguments));
	    }
	
	    _createClass(DocumentListBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                readMoreLink = _props.readMoreLink,
	                readMoreText = _props.readMoreText,
	                documents = _props.documents,
	                blockId = _props.blockId;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _DocumentListBlockModule2.default.block, 'data-block': blockId },
	                _react2.default.createElement(
	                    _OnPageEditing2.default,
	                    { property: 'Documents' },
	                    documents && documents.length > 0 && _react2.default.createElement(
	                        'ul',
	                        { className: _DocumentListBlockModule2.default.documents },
	                        documents.map(function (doc) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: doc.blockId },
	                                _react2.default.createElement(_DocumentBlock2.default, doc)
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _OnPageEditing2.default,
	                    { property: 'ReadMoreLink' },
	                    readMoreLink && readMoreText && _react2.default.createElement(
	                        'p',
	                        { className: _DocumentListBlockModule2.default.readmore },
	                        _react2.default.createElement(
	                            _Button2.default,
	                            {
	                                href: readMoreLink,
	                                secondary: true
	                            },
	                            readMoreText
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DocumentListBlock;
	}(_react2.default.PureComponent);
	
	DocumentListBlock.propTypes = {
	    "heading": _propTypes2.default.string,
	    "readMoreLink": _propTypes2.default.string,
	    "readMoreText": _propTypes2.default.string,
	    "documents": _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        "title": _propTypes2.default.string,
	        "readMoreLink": _propTypes2.default.string,
	        "readMoreText": _propTypes2.default.string,
	        "thumbnailImage": _propTypes2.default.string,
	        "pdfLink": _propTypes2.default.string,
	        "webcastLink": _propTypes2.default.string,
	        "presentationLink": _propTypes2.default.string,
	        "pdfLinkText": _propTypes2.default.string,
	        "webcastLinkText": _propTypes2.default.string,
	        "presentationLinkText": _propTypes2.default.string,
	        "blockId": _propTypes2.default.number,
	        "contentType": _propTypes2.default.string
	    })),
	    "blockId": _propTypes2.default.number,
	    "contentType": _propTypes2.default.string
	};
	exports.default = (0, _Block2.default)(DocumentListBlock);
	module.exports = exports['default'];

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DocumentListBlock = exports.default = undefined;
	
	var _DocumentListBlock2 = __webpack_require__(430);
	
	var _DocumentListBlock3 = _interopRequireDefault(_DocumentListBlock2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DocumentListBlock3.default;
	exports.DocumentListBlock = _DocumentListBlock3.default;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Checkbox = __webpack_require__(400);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DropdownFilterModule = __webpack_require__(753);
	
	var _DropdownFilterModule2 = _interopRequireDefault(_DropdownFilterModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropdownItem = function (_React$PureComponent) {
	    _inherits(DropdownItem, _React$PureComponent);
	
	    function DropdownItem() {
	        _classCallCheck(this, DropdownItem);
	
	        return _possibleConstructorReturn(this, (DropdownItem.__proto__ || Object.getPrototypeOf(DropdownItem)).apply(this, arguments));
	    }
	
	    _createClass(DropdownItem, [{
	        key: 'render',
	        value: function render() {
	            var _cn;
	
	            var _props = this.props,
	                id = _props.id,
	                value = _props.value,
	                active = _props.active,
	                group = _props.group,
	                zebra = _props.zebra,
	                tabbable = _props.tabbable,
	                checkable = _props.checkable,
	                onClick = _props.onClick;
	
	            return _react2.default.createElement(
	                'li',
	                {
	                    'data-id': id,
	                    'data-state': active ? 1 : 0,
	                    onClick: onClick,
	                    onKeyDown: function onKeyDown(e) {
	                        var code = e.which;
	                        // 13 = Return, 32 = Space
	                        if (code === 13 || code === 32) {
	                            e.stopPropagation();
	                            e.preventDefault();
	                            onClick(e);
	                        }
	                    },
	                    tabIndex: tabbable ? 0 : -1,
	                    className: (0, _classnames2.default)((_cn = {}, _defineProperty(_cn, _DropdownFilterModule2.default['dropdown-group'], group), _defineProperty(_cn, _DropdownFilterModule2.default['dropdown-item'], !group), _defineProperty(_cn, _DropdownFilterModule2.default['dropdown-check'], checkable), _defineProperty(_cn, _DropdownFilterModule2.default['active'], active), _defineProperty(_cn, _DropdownFilterModule2.default['zebra'], zebra), _cn))
	                },
	                checkable ? _react2.default.createElement(
	                    _Checkbox2.default,
	                    { checked: active, tabbable: false },
	                    value
	                ) : value
	            );
	        }
	    }]);
	
	    return DropdownItem;
	}(_react2.default.PureComponent);
	
	DropdownItem.propTypes = {
	    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    value: _propTypes2.default.string,
	    onClick: _propTypes2.default.func,
	    tabbable: _propTypes2.default.bool,
	    active: _propTypes2.default.bool,
	    checkable: _propTypes2.default.bool,
	    group: _propTypes2.default.bool,
	    zebra: _propTypes2.default.bool
	};
	DropdownItem.defaultProps = {
	    tabbable: false,
	    active: false,
	    group: false,
	    zebra: false
	};
	
	var DropdownFilter = function (_React$Component) {
	    _inherits(DropdownFilter, _React$Component);
	
	    function DropdownFilter(props) {
	        _classCallCheck(this, DropdownFilter);
	
	        var _this2 = _possibleConstructorReturn(this, (DropdownFilter.__proto__ || Object.getPrototypeOf(DropdownFilter)).call(this));
	
	        _initialiseProps.call(_this2);
	
	        _this2.state = {
	            isOpen: false,
	            active: _this2.parseIncomingActiveProp(props)
	        };
	        return _this2;
	    }
	
	    _createClass(DropdownFilter, [{
	        key: 'render',
	        value: function render() {
	            var _this3 = this,
	                _cn2;
	
	            var _props2 = this.props,
	                heading = _props2.heading,
	                prefix = _props2.prefix,
	                items = _props2.items,
	                multi = _props2.multi,
	                multiLabel = _props2.multiLabel,
	                onSelect = _props2.onSelect,
	                className = _props2.className,
	                yellow = _props2.yellow; // get active (as activeProp) to exclude it from ...rest
	
	            var _state = this.state,
	                isOpen = _state.isOpen,
	                active = _state.active;
	
	
	            var activeItems = this.getActiveItems();
	
	            var displayHeading = multi ? _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'span',
	                    { className: _DropdownFilterModule2.default.number },
	                    active.length
	                ),
	                ' ',
	                multiLabel
	            ) : !active.length ? "-" : activeItems[active[0]] && activeItems[active[0]].value !== undefined ? activeItems[active[0]].value : "-";
	
	            var item = function item(o, i) {
	                // if this is an item group
	                if (o.items) {
	                    return [_react2.default.createElement(DropdownItem, _extends({}, o, {
	                        group: true,
	                        key: "group_" + o.key + "_" + i
	                    }))].concat(_toConsumableArray(o.items.map(item)));
	                }
	                return _react2.default.createElement(DropdownItem, _extends({}, o, {
	                    tabbable: true,
	                    key: o.key + "_" + i,
	                    id: o.key,
	                    active: typeof activeItems[o.key] !== "undefined",
	                    checkable: multi,
	                    onClick: _this3._handleItemClick,
	                    zebra: i % 2 === 0
	                }));
	            };
	
	            var list = items.map(item);
	            return _react2.default.createElement(
	                'div',
	                {
	                    tabIndex: '0',
	                    className: (0, _classnames2.default)(_DropdownFilterModule2.default.block, className, (_cn2 = {}, _defineProperty(_cn2, _DropdownFilterModule2.default['open'], isOpen), _defineProperty(_cn2, _DropdownFilterModule2.default['single'], !multi), _defineProperty(_cn2, _DropdownFilterModule2.default['multi'], multi), _defineProperty(_cn2, _DropdownFilterModule2.default.yellow, yellow), _cn2)),
	                    ref: function ref(t) {
	                        return _this3.node = t;
	                    },
	                    onClick: this.open,
	                    onKeyDown: function onKeyDown(e) {
	                        var code = e.which;
	                        // 27 = Esc, 13 = Return, 32 = Space
	                        if (code === 13 || code === 32) {
	                            e.preventDefault();
	                            _this3.toggle();
	                        }
	                        if (code === 27 && _this3.state.isOpen) {
	                            e.preventDefault();
	                            _this3.close();
	                        }
	                    },
	                    onSelect: onSelect
	                },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    heading
	                ),
	                isOpen && _react2.default.createElement('div', { onClick: this.close, className: _DropdownFilterModule2.default.overlay }),
	                _react2.default.createElement(
	                    'div',
	                    { className: _DropdownFilterModule2.default.dropdown },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            prefix && _react2.default.createElement(
	                                'span',
	                                null,
	                                prefix
	                            ),
	                            displayHeading
	                        ),
	                        _react2.default.createElement(_Icon2.default, { icon: 'arrow-down', className: (0, _classnames2.default)(_DropdownFilterModule2.default.arrow, _defineProperty({}, _DropdownFilterModule2.default['open'], isOpen)) })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'ul',
	                            { className: (0, _classnames2.default)(_defineProperty({}, _DropdownFilterModule2.default['open'], isOpen)) },
	                            list
	                        ),
	                        _react2.default.createElement(_Button2.default, { icon: 'arrow-down', className: _DropdownFilterModule2.default.close, onClick: this.close })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DropdownFilter;
	}(_react2.default.Component);
	
	DropdownFilter.propTypes = {
	    heading: _propTypes2.default.string.isRequired,
	    prefix: _propTypes2.default.string,
	    items: _propTypes2.default.array.isRequired,
	    onSelect: _propTypes2.default.func,
	    multi: _propTypes2.default.bool,
	    multiLabel: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    active: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.array]),
	    yellow: _propTypes2.default.bool,
	    name: _propTypes2.default.string
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this4 = this;
	
	    this.componentWillUpdate = function (props) {
	        // set new active from props
	        if (_this4.props.active !== props.active) {
	            _this4.setState({ active: _this4.parseIncomingActiveProp(props) });
	        }
	    };
	
	    this.componentDidUpdate = function (prevProps, prevState) {
	        var active = _this4.state.active;
	        // add click outside listener
	        if (prevState.isOpen !== _this4.state.isOpen) {
	            if (_this4.state.isOpen === true) {
	                document && document.addEventListener("click", _this4._handleOutsideclick);
	                // set focus to first active element
	                if (active.length) _this4.node.querySelector("li[data-id='" + active[0] + "']").focus();
	            } else {
	                document && document.removeEventListener("click", _this4._handleOutsideclick);
	            }
	        }
	    };
	
	    this.componentWillUnmount = function () {
	        document && document.removeEventListener("click", _this4._handleOutsideclick);
	    };
	
	    this.parseIncomingActiveProp = function (props) {
	        var newActive = props.active;
	        if (props.multi) {
	            newActive = props.active ? props.active.map(function (obj) {
	                if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === "object") {
	                    return obj.key.toString();
	                }
	                return obj.toString();
	            }) : [];
	
	            // override if all exists
	            if (newActive.indexOf("") >= 0) {
	                newActive = props.items.map(function (i) {
	                    return i.key.toString();
	                });
	            }
	        } else {
	            if (typeof props.active === 'string' || typeof props.active === 'number') {
	                newActive = [props.active];
	            } else if (props.items.length) {
	                newActive = [props.items[0].key];
	            } else {
	                newActive = [""];
	            }
	        }
	        return newActive;
	    };
	
	    this.getActiveItems = function () {
	        var items = _this4.props.items;
	        var active = _this4.state.active;
	
	        var values = {};
	        items.forEach(function (i) {
	            if (i.items) {
	                i.items.forEach(function (sub) {
	                    if (active.filter(function (a) {
	                        return sub.key.toString() === a.toString();
	                    }).length) {
	                        values[sub.key.toString()] = sub;
	                    }
	                });
	            } else {
	                if (active.filter(function (a) {
	                    return i.key.toString() === a.toString();
	                }).length) {
	                    values[i.key.toString()] = i;
	                }
	            }
	        });
	
	        return values;
	    };
	
	    this.toggle = function () {
	        _this4.setState({ isOpen: !_this4.state.isOpen });
	    };
	
	    this.open = function () {
	        if (_this4.state.isOpen) {
	            return;
	        }
	        _this4.setState({ isOpen: true });
	    };
	
	    this.close = function () {
	        if (!_this4.state.isOpen) {
	            return;
	        }
	        _this4.setState({ isOpen: false });
	        _this4.node.focus();
	    };
	
	    this._handleOutsideclick = function (e) {
	        if (e && _this4.node.contains(e.target)) {
	            e.stopPropagation();
	            e.preventDefault();
	            return;
	        }
	        _this4.close();
	    };
	
	    this._handleItemClick = function (e) {
	        e.preventDefault();
	        var active = _this4.state.active;
	        var _props3 = _this4.props,
	            items = _props3.items,
	            multi = _props3.multi,
	            name = _props3.name;
	        var _e$currentTarget$data = e.currentTarget.dataset,
	            currentId = _e$currentTarget$data.id,
	            currentActive = _e$currentTarget$data.state;
	
	
	        var exists = active.indexOf(currentId.toString());
	
	        // 'All' toggle checkbox
	        if (currentId === "" || currentId == 0) {
	            if (currentActive == "0") {
	                active = items.map(function (i) {
	                    return i.key && i.key.toString();
	                });
	            } else {
	                active = [];
	            }
	        }
	
	        // autoclose if we click the same element again - unless this is a multi selector
	        if (multi) {
	            // add or remove item from active list
	            if (currentId !== "") {
	                if (exists > -1) {
	                    // remove
	                    active.splice(exists, 1);
	                } else {
	                    // add
	                    active.push(currentId.toString());
	                }
	            }
	
	            // handle "all" marking
	            var allPos = active.indexOf("");
	            if (allPos > -1 && active.length < items.length) {
	                active.splice(allPos, 1);
	            } else if (allPos === -1 && active.length === items.length - 1) {
	                active.push("");
	            }
	        } else {
	            if (exists > -1) {
	                _this4.close();
	                return;
	            }
	            active = [currentId.toString()];
	        }
	
	        _this4.setState({ active: active });
	
	        // don't autoclose when multi selector
	        if (!multi) {
	            _this4.close();
	        }
	        // trigger onSelect function
	        _this4.props.onSelect && _this4.props.onSelect(e, multi ? active : active[0], name); // multi - entire array. single - only return the id
	    };
	
	    this._handleBlur = function (e) {
	        e.preventDefault();
	        _this4.close();
	    };
	};
	
	exports.default = DropdownFilter;
	module.exports = exports['default'];

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames4 = __webpack_require__(3);
	
	var _classnames5 = _interopRequireDefault(_classnames4);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DropdownMenuModule = __webpack_require__(754);
	
	var _DropdownMenuModule2 = _interopRequireDefault(_DropdownMenuModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdditionalInfo = function AdditionalInfo(_ref) {
	    var number = _ref.number,
	        text = _ref.text;
	
	    return _react2.default.createElement(
	        'div',
	        { className: _DropdownMenuModule2.default["dropdown-additional-info"] },
	        _react2.default.createElement(
	            'span',
	            null,
	            number
	        ),
	        text
	    );
	};
	
	AdditionalInfo.propTypes = {
	    number: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    text: _propTypes2.default.string
	};
	
	var LinkList = function (_React$Component) {
	    _inherits(LinkList, _React$Component);
	
	    function LinkList(props) {
	        _classCallCheck(this, LinkList);
	
	        var _this = _possibleConstructorReturn(this, (LinkList.__proto__ || Object.getPrototypeOf(LinkList)).call(this, props));
	
	        _this.state = {
	            open: false
	        };
	
	        _this.link = function () {
	            return _react2.default.createElement(
	                'a',
	                { href: _this.props.link },
	                _this.props.linkText
	            );
	        };
	
	        _this.link = _this.link.bind(_this);
	        _this.generateTitle = _this.generateTitle.bind(_this);
	        return _this;
	    }
	
	    _createClass(LinkList, [{
	        key: 'generateTitle',
	        value: function generateTitle() {
	            var _props = this.props,
	                mobile = _props.mobile,
	                link = _props.link,
	                linkText = _props.linkText;
	
	
	            var classNames = (0, _classnames5.default)(_DropdownMenuModule2.default['dropdown-title'], _defineProperty({}, _DropdownMenuModule2.default['dropdown-header-link'], link && !mobile));
	
	            if (mobile) {
	                return _react2.default.createElement(
	                    'h2',
	                    { className: classNames },
	                    linkText
	                );
	            } else {
	                return _react2.default.createElement(
	                    'h2',
	                    { className: classNames },
	                    link ? this.link() : linkText
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                isActive = _props2.isActive,
	                menuItems = _props2.menuItems;
	
	
	            var classNames = (0, _classnames5.default)(_DropdownMenuModule2.default['link-list'], _defineProperty({}, _DropdownMenuModule2.default['active'], isActive));
	
	            return _react2.default.createElement(
	                'ul',
	                { className: classNames },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    this.generateTitle()
	                ),
	                menuItems && menuItems.map(function (l, i) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: i },
	                        _react2.default.createElement(
	                            'a',
	                            { href: l.href, target: l.target },
	                            l.text
	                        )
	                    );
	                })
	            );
	        }
	    }]);
	
	    return LinkList;
	}(_react2.default.Component);
	
	LinkList.propTypes = {
	    mobile: _propTypes2.default.bool,
	    isActive: _propTypes2.default.bool.isRequired,
	    link: _propTypes2.default.string,
	    linkText: _propTypes2.default.string,
	    menuItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        href: _propTypes2.default.string,
	        language: _propTypes2.default.string,
	        target: _propTypes2.default.string,
	        text: _propTypes2.default.string,
	        title: _propTypes2.default.string
	    }))
	};
	
	var DropdownSubmenu = function (_React$PureComponent) {
	    _inherits(DropdownSubmenu, _React$PureComponent);
	
	    function DropdownSubmenu() {
	        _classCallCheck(this, DropdownSubmenu);
	
	        return _possibleConstructorReturn(this, (DropdownSubmenu.__proto__ || Object.getPrototypeOf(DropdownSubmenu)).apply(this, arguments));
	    }
	
	    _createClass(DropdownSubmenu, [{
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props,
	                columns = _props3.columns,
	                mobile = _props3.mobile,
	                isActive = _props3.isActive;
	
	
	            return _react2.default.createElement(
	                'li',
	                { className: _DropdownMenuModule2.default.submenu },
	                columns.map(function (c, i) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: i },
	                        _react2.default.createElement(LinkList, _extends({
	                            key: i,
	                            mobile: mobile,
	                            isActive: isActive,
	                            additional: undefined
	                        }, c))
	                    );
	                })
	            );
	        }
	    }]);
	
	    return DropdownSubmenu;
	}(_react2.default.PureComponent);
	
	DropdownSubmenu.propTypes = {
	    columns: _propTypes2.default.array.isRequired,
	    mobile: _propTypes2.default.bool.isRequired,
	    isActive: _propTypes2.default.bool.isRequired
	};
	
	var DropdownMenu = function (_React$PureComponent2) {
	    _inherits(DropdownMenu, _React$PureComponent2);
	
	    function DropdownMenu() {
	        _classCallCheck(this, DropdownMenu);
	
	        return _possibleConstructorReturn(this, (DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).apply(this, arguments));
	    }
	
	    _createClass(DropdownMenu, [{
	        key: 'render',
	        value: function render() {
	            var _props4 = this.props,
	                columns = _props4.columns,
	                isActive = _props4.isActive,
	                mobile = _props4.mobile,
	                topMenuLink = _props4.topMenuLink,
	                closeMenu = _props4.closeMenu,
	                closeMenuLabel = _props4.closeMenuLabel;
	
	
	            var classNames = (0, _classnames5.default)(_DropdownMenuModule2.default['column-container-wrapper'], _defineProperty({}, _DropdownMenuModule2.default['open'], isActive));
	
	            return _react2.default.createElement(
	                'div',
	                { className: classNames },
	                topMenuLink ? _react2.default.createElement(
	                    'a',
	                    { className: _DropdownMenuModule2.default["header-link"], href: topMenuLink.link },
	                    topMenuLink.linkText
	                ) : undefined,
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    columns.map(function (l, i) {
	                        return _react2.default.createElement(DropdownSubmenu, {
	                            key: i,
	                            columns: l,
	                            mobile: mobile,
	                            isActive: isActive
	                        });
	                    })
	                ),
	                _react2.default.createElement(
	                    'button',
	                    {
	                        className: _DropdownMenuModule2.default.close,
	                        onClick: closeMenu,
	                        title: closeMenuLabel
	                    },
	                    _react2.default.createElement(_Icon2.default, { className: _DropdownMenuModule2.default.closeIcon, icon: 'close' })
	                )
	            );
	        }
	    }]);
	
	    return DropdownMenu;
	}(_react2.default.PureComponent);
	
	DropdownMenu.propTypes = {
	    columns: _propTypes2.default.array,
	    isActive: _propTypes2.default.bool.isRequired,
	    mobile: _propTypes2.default.bool.isRequired,
	    topMenuLink: _propTypes2.default.shape({
	        linkText: _propTypes2.default.string.isRequired,
	        link: _propTypes2.default.string.isRequired
	    }),
	    closeMenu: _propTypes2.default.func.isRequired,
	    closeMenuLabel: _propTypes2.default.string.isRequired
	};
	exports.default = DropdownMenu;
	module.exports = exports['default'];

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DropdownMenu = __webpack_require__(433);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DropdownMenu2.default;
	module.exports = exports['default'];

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(696);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Media = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventCard = function (_React$Component) {
	    _inherits(EventCard, _React$Component);
	
	    function EventCard() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, EventCard);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EventCard.__proto__ || Object.getPrototypeOf(EventCard)).call.apply(_ref, [this].concat(args))), _this), _this._getMonth = function (thedate) {
	            var monthNames = _this.props.monthNames;
	            var theDate = thedate.split(".");
	            var newDate = monthNames[parseInt(theDate[1]) - 1] + " " + theDate[2];
	            return newDate;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(EventCard, [{
	        key: 'render',
	        value: function render() {
	            var event = this.props.event;
	            var closeLabel = this.props.closeLabel;
	            var link = this.props.link;
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)("event-card", {
	                        "event-card_no-image": !event.image
	                    }) },
	                event.image && _react2.default.createElement(
	                    'div',
	                    { className: 'event-card__image' },
	                    _react2.default.createElement(_Media.Media, {
	                        image: event.image,
	                        alt: event.title ? event.title : ''
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'event-card__text-content' },
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'title' },
	                        event.title
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'event-card__date' },
	                        this._getMonth(event.date)
	                    ),
	                    event.description && _react2.default.createElement(
	                        'p',
	                        { className: 'event-card__area' },
	                        event.description
	                    ),
	                    this.props.close && _react2.default.createElement(
	                        'button',
	                        {
	                            className: 'event-card-close',
	                            onClick: this.props.close
	                        },
	                        _react2.default.createElement(_Icon2.default, { icon: 'close' }),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            closeLabel
	                        )
	                    ),
	                    link && link.href && _react2.default.createElement(
	                        'a',
	                        {
	                            href: link.href,
	                            title: link.title,
	                            target: link.target ? link.target : null,
	                            rel: link.target && link.target === "_blank" ? "noopener noreferrer" : null
	                        },
	                        link.text
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EventCard;
	}(_react2.default.Component);
	
	EventCard.propTypes = {
	    event: _propTypes2.default.shape({
	        image: _propTypes2.default.string,
	        title: _propTypes2.default.string,
	        date: _propTypes2.default.string,
	        area: _propTypes2.default.string
	    }).isRequired,
	    close: _propTypes2.default.function,
	    closeLabel: _propTypes2.default.string,
	    monthNames: _propTypes2.default.array.isRequired,
	    link: _propTypes2.default.shape({
	        href: _propTypes2.default.string.isRequired,
	        target: _propTypes2.default.string,
	        text: _propTypes2.default.string.isRequired,
	        title: _propTypes2.default.string
	    })
	};
	exports.default = EventCard;
	module.exports = exports['default'];

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectFitImages = __webpack_require__(957);
	
	var _objectFitImages2 = _interopRequireDefault(_objectFitImages);
	
	var _FancyImageModule = __webpack_require__(755);
	
	var _FancyImageModule2 = _interopRequireDefault(_FancyImageModule);
	
	var _Sticky = __webpack_require__(244);
	
	var _Sticky2 = _interopRequireDefault(_Sticky);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var themes = {
	    fixed: "-theme-fixed",
	    sticky: "-theme-sticky",
	    full: "-theme-full",
	    roundedCorners: "-theme-rounded-corners"
	};
	
	var gradients = {
	    section: "-gradient-section",
	    feature: "-gradient-feature"
	};
	
	var FancyImage = function (_React$Component) {
	    _inherits(FancyImage, _React$Component);
	
	    function FancyImage() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, FancyImage);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FancyImage.__proto__ || Object.getPrototypeOf(FancyImage)).call.apply(_ref, [this].concat(args))), _this), _this.themeConditions = function (theme, imageMobile, isMobile) {
	            if (theme === themes.full) return imageMobile && isMobile;
	            return theme;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(FancyImage, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            (0, _objectFitImages2.default)("img." + _FancyImageModule2.default.image);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _cn;
	
	            var _props = this.props,
	                theme = _props.theme,
	                gradient = _props.gradient,
	                alt = _props.alt,
	                isMobile = _props.isMobile,
	                image = _props.image,
	                imageMobile = _props.imageMobile;
	
	            var src = isMobile ? imageMobile || image : image;
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: (0, _classnames2.default)(_FancyImageModule2.default.imageWrapper, (_cn = {}, _defineProperty(_cn, _FancyImageModule2.default.gradient, gradient), _defineProperty(_cn, _FancyImageModule2.default[gradient], gradient), _defineProperty(_cn, _FancyImageModule2.default[theme], this.themeConditions(theme, imageMobile, isMobile)), _cn))
	                },
	                _react2.default.createElement(_Sticky2.default, { type: "img", props: {
	                        src: src,
	                        alt: alt,
	                        className: (0, _classnames2.default)(_FancyImageModule2.default.image, _defineProperty({}, _FancyImageModule2.default[gradient], gradient))
	                    },
	                    isSticky: theme === "-theme-sticky" })
	            );
	        }
	    }]);
	
	    return FancyImage;
	}(_react2.default.Component);
	
	FancyImage.propTypes = {
	    alt: _propTypes2.default.string,
	    image: _propTypes2.default.string.isRequired,
	    imageMobile: _propTypes2.default.string,
	    theme: _propTypes2.default.string,
	    gradient: _propTypes2.default.string,
	    isMobile: _propTypes2.default.bool
	};
	FancyImage.defaultProps = {
	    alt: ""
	};
	
	
	FancyImage.themes = themes;
	
	FancyImage.gradients = gradients;
	
	exports.default = FancyImage;
	module.exports = exports["default"];

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(697);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__(226);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _featureArticleLogo = __webpack_require__(268);
	
	var _featureArticleLogo2 = _interopRequireDefault(_featureArticleLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeatureArticleHeader = function (_React$Component) {
	    _inherits(FeatureArticleHeader, _React$Component);
	
	    function FeatureArticleHeader() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, FeatureArticleHeader);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FeatureArticleHeader.__proto__ || Object.getPrototypeOf(FeatureArticleHeader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            isLastScrollUp: false,
	            lastScrollChangePosition: 0,
	            startAnimation: true
	        }, _this.handleNavigation = function (e) {
	            var window = e.currentTarget;
	            var isScrollUp = _this.prev > window.scrollY;
	
	            if (isScrollUp !== _this.state.isLastScrollUp) {
	                _this.setState({ lastScrollChangePosition: window.scrollY });
	            } else {
	                if (_this.state.lastScrollChangePosition - window.scrollY > 50) {
	                    _this.setState({ startAnimation: true });
	                } else if (_this.state.lastScrollChangePosition - window.scrollY < -50) {
	                    _this.setState({ startAnimation: false });
	                }
	            }
	            _this.setState({ isLastScrollUp: isScrollUp });
	
	            _this.prev = window.scrollY;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(FeatureArticleHeader, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.prev = window.scrollY;
	            this.setState({ lastScrollChangePosition: window.scrollY });
	            window.addEventListener('scroll', function (e) {
	                return _this2.handleNavigation(e);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.props.hideAfPosten) return _react2.default.createElement(_Header2.default, this.props.menu);
	            return _react2.default.createElement(
	                'div',
	                { className: 'feature-article-header' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'feature-article-header__header', style: !this.state.startAnimation ? { marginTop: '-70px' } : null },
	                    _react2.default.createElement(_Header2.default, this.props.menu)
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { className: 'feature-article-header__feature-header', href: this.props.urlToLandingPage },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'feature-article-header__feature-logo-wrapper' },
	                        _react2.default.createElement('img', { className: 'feature-article-header__feature-logo', src: _featureArticleLogo2.default, alt: 'AF-Posten' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FeatureArticleHeader;
	}(_react2.default.Component);
	
	FeatureArticleHeader.propTypes = {
	    menu: _propTypes2.default.object,
	    urlToLandingPage: _propTypes2.default.string,
	    hideAfPosten: _propTypes2.default.bool
	};
	exports.default = FeatureArticleHeader;
	module.exports = exports['default'];

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FeatureArticleHeader = __webpack_require__(437);
	
	var _FeatureArticleHeader2 = _interopRequireDefault(_FeatureArticleHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FeatureArticleHeader2.default;
	module.exports = exports['default'];

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FeatureArticleTagModule = __webpack_require__(756);
	
	var _FeatureArticleTagModule2 = _interopRequireDefault(_FeatureArticleTagModule);
	
	var _featureArticleLogo = __webpack_require__(268);
	
	var _featureArticleLogo2 = _interopRequireDefault(_featureArticleLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Featurearticletag = function Featurearticletag() {
	    console.log("featuerarticletag");
	    return _react2.default.createElement(
	        "div",
	        { className: _FeatureArticleTagModule2.default.featureArticleTag },
	        _react2.default.createElement("img", { src: _featureArticleLogo2.default, alt: "AF-posten artikkel" })
	    );
	};
	
	Featurearticletag.propTypes = {};
	
	exports.default = Featurearticletag;
	module.exports = exports["default"];

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(698);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeatureArticleTextBlock = function FeatureArticleTextBlock(_ref) {
	    var title = _ref.title,
	        text = _ref.text,
	        children = _ref.children;
	
	
	    return text || children ? _react2.default.createElement(
	        "div",
	        { className: "feature-article-text-block" },
	        _react2.default.createElement(
	            "div",
	            { className: "feature-article-text-block__content" },
	            title && _react2.default.createElement(
	                "h2",
	                null,
	                title
	            ),
	            children ? _react2.default.createElement(
	                "div",
	                { className: "feature-article-text-block__text" },
	                children
	            ) : text ? _react2.default.createElement("div", { className: "feature-article-text-block__text", dangerouslySetInnerHTML: { __html: text } }) : null
	        )
	    ) : null;
	};
	
	FeatureArticleTextBlock.propTypes = {
	    title: _propTypes2.default.string,
	    text: _propTypes2.default.string
	};
	
	exports.default = FeatureArticleTextBlock;
	module.exports = exports["default"];

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FeatureArticleTextBlock = __webpack_require__(440);
	
	var _FeatureArticleTextBlock2 = _interopRequireDefault(_FeatureArticleTextBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FeatureArticleTextBlock2.default;
	module.exports = exports["default"];

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _VacancyCard = __webpack_require__(246);
	
	var _VacancyCard2 = _interopRequireDefault(_VacancyCard);
	
	__webpack_require__(699);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FeatureArticleVacancyBlock = function FeatureArticleVacancyBlock(_ref) {
	    var inRichText = _ref.inRichText,
	        rest = _objectWithoutProperties(_ref, ['inRichText']);
	
	    return _react2.default.createElement(
	        'div',
	        {
	            className: (0, _classnames2.default)("feature-article-vacancy-block", _defineProperty({}, "feature-article-vacancy-block_in-rich-text", inRichText))
	        },
	        _react2.default.createElement(_VacancyCard2.default, rest)
	    );
	};
	
	FeatureArticleVacancyBlock.propTypes = _extends({}, _VacancyCard2.default.propTypes, {
	    inRichText: _propTypes2.default.bool
	});
	
	exports.default = FeatureArticleVacancyBlock;
	module.exports = exports['default'];

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FeatureArticleVacancyBlock = __webpack_require__(442);
	
	var _FeatureArticleVacancyBlock2 = _interopRequireDefault(_FeatureArticleVacancyBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FeatureArticleVacancyBlock2.default;
	module.exports = exports["default"];

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FeatureArticlesFilterModule = __webpack_require__(757);
	
	var _FeatureArticlesFilterModule2 = _interopRequireDefault(_FeatureArticlesFilterModule);
	
	var _debounce = __webpack_require__(53);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DropdownFilter = __webpack_require__(58);
	
	var _DropdownFilter2 = _interopRequireDefault(_DropdownFilter);
	
	var _RelatedArticles = __webpack_require__(241);
	
	var _RelatedArticles2 = _interopRequireDefault(_RelatedArticles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEBOUNCE_DURATION = 500;
	
	var FeatureArticlesFilter = function (_React$Component) {
	    _inherits(FeatureArticlesFilter, _React$Component);
	
	    function FeatureArticlesFilter() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, FeatureArticlesFilter);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FeatureArticlesFilter.__proto__ || Object.getPrototypeOf(FeatureArticlesFilter)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            year: undefined,
	            division: _this.props.initialDivision,
	            articleList: _this.props.articleList,
	            language: _this.props.language,
	            rootPage: _this.props.rootPage,
	            searching: false,
	            numberOfArticlesShown: _this.props.numberOfArticlesShown,
	            numberOfArticlesToAdd: _this.props.numberOfArticlesToAdd,
	            hasMoreArticles: false
	        }, _this.showMoreArticles = function () {
	            _this.setState(function (state) {
	                return { numberOfArticlesShown: state.numberOfArticlesShown + _this.state.numberOfArticlesToAdd };
	            });
	        }, _this._yearFilter = function (e, value) {
	            _this.setState({
	                year: value ? value : undefined
	            }, _this._debouncedFilterItems);
	        }, _this._divisionFilter = function (e, value) {
	            _this.setState({
	                division: value
	            }, _this._debouncedFilterItems);
	        }, _this._filterItems = function () {
	            var filter = _extends({}, _this.state);
	
	            var search = function search() {
	                window.fetch(_this.props.apiUrl, {
	                    headers: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json'
	                    },
	                    credentials: 'same-origin',
	                    method: 'POST',
	                    body: JSON.stringify(filter)
	                }).then(function (res) {
	                    if (!res.ok) {
	                        _this.setState({
	                            searching: false
	                        });
	
	                        return console.error(res);
	                    }
	
	                    res.json().then(function (json) {
	                        _this.setState({
	                            articleList: json,
	                            searching: false
	                        });
	                    });
	                }).catch(function (err) {
	                    console.error(err);
	
	                    _this.setState({
	                        searching: false
	                    });
	                });
	            };
	
	            _this.setState({
	                searching: true
	            }, search);
	        }, _this._debouncedFilterItems = (0, _debounce2.default)(_this._filterItems, DEBOUNCE_DURATION), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(FeatureArticlesFilter, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                years = _props.years,
	                yearsHeading = _props.yearsHeading,
	                divisions = _props.divisions,
	                divisionsHeading = _props.divisionsHeading;
	            var _state = this.state,
	                articleList = _state.articleList,
	                division = _state.division,
	                numberOfArticlesShown = _state.numberOfArticlesShown;
	
	
	            var articlesToShow = _react2.default.createElement(_RelatedArticles2.default, _extends({}, articleList, { hasMoreArticles: this.state.numberOfArticlesShown >= articleList.articles.length ? false : true, showMoreArticles: this.showMoreArticles, articles: articleList.articles.slice(0, numberOfArticlesShown).map(function (item) {
	                    return _extends({}, item);
	                }), keys: ["date", "title", "division"] }));
	
	            return _react2.default.createElement(
	                'div',
	                { className: _FeatureArticlesFilterModule2.default.block },
	                _react2.default.createElement(
	                    'div',
	                    { className: _FeatureArticlesFilterModule2.default.filters },
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(_DropdownFilter2.default, { heading: yearsHeading, items: years, onSelect: this._yearFilter })
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(_DropdownFilter2.default, { active: division, heading: divisionsHeading, items: divisions, onSelect: this._divisionFilter })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _FeatureArticlesFilterModule2.default["list-outer"] },
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)(_FeatureArticlesFilterModule2.default.list, _defineProperty({}, _FeatureArticlesFilterModule2.default.searching, this.state.searching)) },
	                        articlesToShow
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FeatureArticlesFilter;
	}(_react2.default.Component);
	
	FeatureArticlesFilter.propTypes = {
	    apiUrl: _propTypes2.default.string.isRequired,
	    years: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        key: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	        value: _propTypes2.default.string
	    })),
	    yearsHeading: _propTypes2.default.string,
	    divisions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        key: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	        value: _propTypes2.default.string
	    })),
	    divisionsHeading: _propTypes2.default.string,
	    articleList: _propTypes2.default.shape({
	        blockId: _propTypes2.default.number,
	        articles: _propTypes2.default.array,
	        publishedLabel: _propTypes2.default.string,
	        showMoreButtonText: _propTypes2.default.string
	    }),
	    initialDivision: _propTypes2.default.number,
	    language: _propTypes2.default.string,
	    rootPage: _propTypes2.default.number,
	    numberOfArticlesShown: _propTypes2.default.number,
	    numberOfArticlesToAdd: _propTypes2.default.number
	
	};
	exports.default = FeatureArticlesFilter;
	module.exports = exports['default'];

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FeatureArticlesFilter = __webpack_require__(444);
	
	var _FeatureArticlesFilter2 = _interopRequireDefault(_FeatureArticlesFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FeatureArticlesFilter2.default;
	module.exports = exports['default'];

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FeatureImageHeaderContentModule = __webpack_require__(758);
	
	var _FeatureImageHeaderContentModule2 = _interopRequireDefault(_FeatureImageHeaderContentModule);
	
	var _ArticleTags = __webpack_require__(385);
	
	var _ArticleTags2 = _interopRequireDefault(_ArticleTags);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _AnimateOpacity = __webpack_require__(129);
	
	var _AnimateOpacity2 = _interopRequireDefault(_AnimateOpacity);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CuriousBlock = __webpack_require__(121);
	
	var _CuriousBlock2 = _interopRequireDefault(_CuriousBlock);
	
	var _PublishedDate = __webpack_require__(560);
	
	var _PublishedDate2 = _interopRequireDefault(_PublishedDate);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FitText = __webpack_require__(225);
	
	var _FitText2 = _interopRequireDefault(_FitText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getAnimationData = function getAnimationData(shouldAnimate) {
	    if (!shouldAnimate) return {};
	    return {
	        textAnimationData: { start: 100, end: 250 },
	        bylineAnimationData: { start: 250, end: 400 },
	        iconAnimationData: { start: 300, end: 360, hide: true }
	    };
	};
	
	var FeatureImageHeaderContent = function FeatureImageHeaderContent(_ref) {
	    var tags = _ref.tags,
	        title = _ref.title,
	        text = _ref.text,
	        bylines = _ref.bylines,
	        showIcon = _ref.showIcon,
	        shouldAnimate = _ref.shouldAnimate,
	        icon = _ref.icon,
	        isLandingPage = _ref.isLandingPage,
	        buttonText = _ref.buttonText,
	        buttonUrl = _ref.buttonUrl,
	        curious = _ref.curious,
	        publishedDate = _ref.publishedDate;
	
	    var _getAnimationData = getAnimationData(shouldAnimate),
	        textAnimationData = _getAnimationData.textAnimationData,
	        bylineAnimationData = _getAnimationData.bylineAnimationData,
	        iconAnimationData = _getAnimationData.iconAnimationData;
	
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_FeatureImageHeaderContentModule2.default.featureImageHeaderContent, _defineProperty({}, _FeatureImageHeaderContentModule2.default.isLandingPage, isLandingPage)) },
	        _react2.default.createElement(
	            "div",
	            null,
	            tags && _react2.default.createElement(_ArticleTags2.default, { tags: tags, icon: icon }),
	            title && _react2.default.createElement(
	                "h1",
	                { className: _FeatureImageHeaderContentModule2.default.title },
	                _react2.default.createElement(_FitText2.default, { text: title })
	            ),
	            _react2.default.createElement(
	                _AnimateOpacity2.default,
	                _extends({}, textAnimationData, { className: _FeatureImageHeaderContentModule2.default.invisible }),
	                _react2.default.createElement(
	                    "p",
	                    { className: _FeatureImageHeaderContentModule2.default.text },
	                    text
	                )
	            ),
	            bylines && bylines.length && _react2.default.createElement(
	                _AnimateOpacity2.default,
	                _extends({}, bylineAnimationData, {
	                    className: _FeatureImageHeaderContentModule2.default.invisible
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: _FeatureImageHeaderContentModule2.default.bylines },
	                    bylines.map(function (byline) {
	                        return _react2.default.createElement(
	                            "div",
	                            { key: byline.text },
	                            byline.type && _react2.default.createElement(
	                                "b",
	                                { className: _FeatureImageHeaderContentModule2.default.bylineType },
	                                byline.type
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                byline.text
	                            )
	                        );
	                    })
	                )
	            ),
	            publishedDate && _react2.default.createElement(
	                _AnimateOpacity2.default,
	                _extends({}, bylineAnimationData, { className: _FeatureImageHeaderContentModule2.default.invisible }),
	                _react2.default.createElement(_PublishedDate2.default, _extends({ className: _FeatureImageHeaderContentModule2.default.date }, publishedDate))
	            ),
	            isLandingPage && _react2.default.createElement(
	                "div",
	                { className: _FeatureImageHeaderContentModule2.default.button },
	                _react2.default.createElement(
	                    _Button2.default,
	                    { tertiary: true, href: buttonUrl },
	                    buttonText
	                )
	            ),
	            showIcon && _react2.default.createElement(
	                _AnimateOpacity2.default,
	                iconAnimationData,
	                _react2.default.createElement(
	                    "div",
	                    { className: _FeatureImageHeaderContentModule2.default.iconWrapper },
	                    _react2.default.createElement(_Icon2.default, { icon: "arrow-down", className: _FeatureImageHeaderContentModule2.default.icon })
	                )
	            ),
	            curious && curious.text && _react2.default.createElement(_CuriousBlock2.default, _extends({}, curious, { className: _FeatureImageHeaderContentModule2.default.curious }))
	        )
	    );
	};
	
	FeatureImageHeaderContent.propTypes = {
	    tags: _propTypes2.default.string,
	    icon: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    text: _propTypes2.default.string,
	    bylines: _propTypes2.default.array,
	    showIcon: _propTypes2.default.bool,
	    shouldAnimate: _propTypes2.default.bool,
	    isLandingPage: _propTypes2.default.bool,
	    buttonText: _propTypes2.default.string,
	    buttonUrl: _propTypes2.default.string,
	    curious: _CuriousBlock2.default.propTypes,
	    publishedDate: _propTypes2.default.shape(_PublishedDate2.default.propTypes)
	};
	
	exports.default = FeatureImageHeaderContent;
	module.exports = exports["default"];

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPlx = __webpack_require__(332);
	
	var _reactPlx2 = _interopRequireDefault(_reactPlx);
	
	var _FeatureImageQuoteContentModule = __webpack_require__(759);
	
	var _FeatureImageQuoteContentModule2 = _interopRequireDefault(_FeatureImageQuoteContentModule);
	
	var _AnimateOpacity = __webpack_require__(129);
	
	var _AnimateOpacity2 = _interopRequireDefault(_AnimateOpacity);
	
	var _QuoteBlock = __webpack_require__(132);
	
	var _QuoteBlock2 = _interopRequireDefault(_QuoteBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var plxData = function plxData(element) {
	    return [{
	        start: element || "self",
	        startOffset: "40vh",
	        duration: "40vh",
	        properties: [{
	            startValue: 250,
	            endValue: 0,
	            property: "translateY"
	        }]
	    }];
	};
	
	var FeatureImageQuoteContent = function (_React$Component) {
	    _inherits(FeatureImageQuoteContent, _React$Component);
	
	    function FeatureImageQuoteContent() {
	        _classCallCheck(this, FeatureImageQuoteContent);
	
	        return _possibleConstructorReturn(this, (FeatureImageQuoteContent.__proto__ || Object.getPrototypeOf(FeatureImageQuoteContent)).apply(this, arguments));
	    }
	
	    _createClass(FeatureImageQuoteContent, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.forceUpdate();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                "div",
	                { className: _FeatureImageQuoteContentModule2.default.featureImageQuoteContent, ref: function ref(ele) {
	                        return _this2.element = ele;
	                    } },
	                _react2.default.createElement(
	                    _AnimateOpacity2.default,
	                    {
	                        start: "self",
	                        startOffset: "50vh",
	                        duration: "40vh",
	                        className: _FeatureImageQuoteContentModule2.default.darkFilter
	                    },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _FeatureImageQuoteContentModule2.default.quoteWrapper },
	                        _react2.default.createElement(
	                            _reactPlx2.default,
	                            { parallaxData: plxData(this.element) },
	                            this.props.quote && _react2.default.createElement(_QuoteBlock2.default, this.props.quote)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FeatureImageQuoteContent;
	}(_react2.default.Component);
	
	FeatureImageQuoteContent.propTypes = {
	    quote: _propTypes2.default.object.isRequired
	};
	exports.default = FeatureImageQuoteContent;
	module.exports = exports["default"];

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FeatureImageQuoteContent = __webpack_require__(447);
	
	var _FeatureImageQuoteContent2 = _interopRequireDefault(_FeatureImageQuoteContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FeatureImageQuoteContent2.default;
	module.exports = exports["default"];

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FeatureLandingPageHeaderModule = __webpack_require__(760);
	
	var _FeatureLandingPageHeaderModule2 = _interopRequireDefault(_FeatureLandingPageHeaderModule);
	
	var _featureArticleLogoColor = __webpack_require__(834);
	
	var _featureArticleLogoColor2 = _interopRequireDefault(_featureArticleLogoColor);
	
	var _FeatureImageHeaderContent = __webpack_require__(224);
	
	var _FeatureImageHeaderContent2 = _interopRequireDefault(_FeatureImageHeaderContent);
	
	var _MediaWrapper = __webpack_require__(126);
	
	var _MediaWrapper2 = _interopRequireDefault(_MediaWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeatureLandingPageHeader = function FeatureLandingPageHeader(_ref) {
	    var media = _ref.media,
	        content = _ref.content,
	        logoAltText = _ref.logoAltText;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _FeatureLandingPageHeaderModule2.default.featureLandingPageHeader },
	        _react2.default.createElement(
	            "div",
	            { className: _FeatureLandingPageHeaderModule2.default.logo },
	            _react2.default.createElement("img", { alt: logoAltText, src: _featureArticleLogoColor2.default })
	        ),
	        _react2.default.createElement(
	            _MediaWrapper2.default,
	            {
	                media: media,
	                gradient: _MediaWrapper2.default.gradients.feature,
	                theme: _MediaWrapper2.default.themes.roundedCorners,
	                isLandingPage: true
	            },
	            _react2.default.createElement(_FeatureImageHeaderContent2.default, _extends({ isLandingPage: true }, content))
	        )
	    );
	};
	
	FeatureLandingPageHeader.propTypes = {
	    media: _propTypes2.default.shape({ isSticky: _propTypes2.default.bool }),
	    content: _propTypes2.default.object,
	    logoAltText: _propTypes2.default.string
	};
	
	exports.default = FeatureLandingPageHeader;
	module.exports = exports["default"];

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FeatureLandingPageHeader = __webpack_require__(449);
	
	var _FeatureLandingPageHeader2 = _interopRequireDefault(_FeatureLandingPageHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FeatureLandingPageHeader2.default;
	module.exports = exports["default"];

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ImageIcon = __webpack_require__(59);
	
	var _ImageIcon2 = _interopRequireDefault(_ImageIcon);
	
	var _OnPageEditing = __webpack_require__(21);
	
	var _OnPageEditing2 = _interopRequireDefault(_OnPageEditing);
	
	var _FeatureListBlockModule = __webpack_require__(761);
	
	var _FeatureListBlockModule2 = _interopRequireDefault(_FeatureListBlockModule);
	
	var _themes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Content = function Content(_ref) {
	    var icon = _ref.icon,
	        iconNew = _ref.iconNew,
	        title = _ref.title,
	        subtitle = _ref.subtitle,
	        description = _ref.description,
	        link = _ref.link,
	        onPageEditing = _ref.onPageEditing;
	    return _react2.default.createElement(
	        'div',
	        { className: _FeatureListBlockModule2.default.item },
	        iconNew ? _react2.default.createElement(_ImageIcon2.default, iconNew) : icon ? _react2.default.createElement(_Icon2.default, { icon: icon }) : null,
	        _react2.default.createElement(
	            _OnPageEditing2.default,
	            { active: onPageEditing, property: 'Title' },
	            !icon && _react2.default.createElement(
	                'p',
	                { className: _FeatureListBlockModule2.default.title },
	                title
	            )
	        ),
	        _react2.default.createElement(
	            _OnPageEditing2.default,
	            { active: onPageEditing, property: 'Subtitle' },
	            subtitle && _react2.default.createElement(
	                'h3',
	                { className: _FeatureListBlockModule2.default.heading },
	                link ? _react2.default.createElement(
	                    'a',
	                    { href: link },
	                    subtitle
	                ) : subtitle
	            )
	        ),
	        _react2.default.createElement(
	            _OnPageEditing2.default,
	            { active: onPageEditing, property: 'Description' },
	            _react2.default.createElement('div', {
	                className: (0, _classnames2.default)(_FeatureListBlockModule2.default.wysiwyg, "wysiwyg"),
	                dangerouslySetInnerHTML: { __html: description }
	            })
	        )
	    );
	};
	
	Content.propTypes = {
	    title: _propTypes2.default.string,
	    subtitle: _propTypes2.default.string.isRequired,
	    description: _propTypes2.default.string.isRequired,
	    iconNew: _propTypes2.default.shape(_ImageIcon2.default.propTypes),
	    icon: _propTypes2.default.string,
	    link: _propTypes2.default.string,
	    contentType: _propTypes2.default.string,
	    blockId: _propTypes2.default.number,
	    onPageEditing: _propTypes2.default.bool
	};
	
	var FeatureListBlock = function FeatureListBlock(_ref2) {
	    var blockId = _ref2.blockId,
	        heading = _ref2.heading,
	        text = _ref2.text,
	        features = _ref2.features,
	        contentType = _ref2.contentType,
	        theme = _ref2.theme;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_FeatureListBlockModule2.default.block, (0, _themes.getThemeClassNames)(_FeatureListBlockModule2.default, theme)), 'data-block': blockId },
	        _react2.default.createElement(
	            'div',
	            { className: _FeatureListBlockModule2.default.wrapper },
	            (heading || text) && _react2.default.createElement(
	                'header',
	                null,
	                _react2.default.createElement(
	                    _OnPageEditing2.default,
	                    { active: contentType === 'FeatureListBlock', property: 'Heading' },
	                    heading && _react2.default.createElement(
	                        'h2',
	                        null,
	                        heading
	                    )
	                ),
	                _react2.default.createElement(
	                    _OnPageEditing2.default,
	                    { active: contentType === 'FeatureListBlock', property: 'Text' },
	                    text && _react2.default.createElement(
	                        'p',
	                        null,
	                        text
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _OnPageEditing2.default,
	                { active: contentType === 'FeatureListBlock', property: 'Features' },
	                _react2.default.createElement(
	                    'ul',
	                    { className: _FeatureListBlockModule2.default.content },
	                    features && features.map(function (a) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: a.blockId },
	                            _react2.default.createElement(Content, _extends({
	                                onPageEditing: contentType !== 'FeatureListBlock'
	                            }, a))
	                        );
	                    })
	                )
	            )
	        )
	    );
	};
	
	FeatureListBlock.propTypes = {
	    blockId: _propTypes2.default.number,
	    contentType: _propTypes2.default.string,
	    heading: _propTypes2.default.string,
	    text: _propTypes2.default.string,
	    features: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        title: _propTypes2.default.string,
	        subtitle: _propTypes2.default.string.isRequired,
	        description: _propTypes2.default.string.isRequired,
	        icon: _propTypes2.default.string,
	        link: _propTypes2.default.string,
	        contentType: _propTypes2.default.string,
	        blockId: _propTypes2.default.number
	    })).isRequired,
	    theme: _propTypes2.default.oneOf(Object.keys(_themes.THEMES).map(function (s) {
	        return _themes.THEMES[s];
	    }))
	};
	
	FeatureListBlock.defaultProps = {
	    theme: _themes.THEMES.zebra
	};
	
	exports.default = FeatureListBlock;
	module.exports = exports['default'];

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FeatureListBlock = __webpack_require__(451);
	
	var _FeatureListBlock2 = _interopRequireDefault(_FeatureListBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FeatureListBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.VIDEO_LABELS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FeatureImageQuoteContent = __webpack_require__(448);
	
	var _FeatureImageQuoteContent2 = _interopRequireDefault(_FeatureImageQuoteContent);
	
	var _FeatureMediaWithCaption = __webpack_require__(458);
	
	var _FeatureMediaWithCaption2 = _interopRequireDefault(_FeatureMediaWithCaption);
	
	var _QuoteBlock = __webpack_require__(132);
	
	var _QuoteBlock2 = _interopRequireDefault(_QuoteBlock);
	
	var _Video = __webpack_require__(538);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _MediaWrapper = __webpack_require__(126);
	
	var _MediaWrapper2 = _interopRequireDefault(_MediaWrapper);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(700);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var VIDEO_LABELS = exports.VIDEO_LABELS = {
	    DESKTOP: "desktop",
	    MOBILE: "mobile"
	};
	
	var FeatureMediaBlock = function FeatureMediaBlock(_ref) {
	    var media = _ref.media,
	        text = _ref.text,
	        quote = _ref.quote;
	
	    var isVideoMedia = media && media.video;
	    var isText = text && !isVideoMedia;
	    var isQuote = quote && !text && !isVideoMedia;
	
	    var mediaObj = isVideoMedia ? _extends({}, media, {
	        video: [_extends({}, media.video, {
	            label: VIDEO_LABELS.DESKTOP
	        }), _extends({}, media.videoMobile, {
	            label: VIDEO_LABELS.MOBILE
	        })]
	    }) : media;
	
	    return _react2.default.createElement(
	        _MediaWrapper2.default,
	        {
	            media: mediaObj,
	            stickyDuration: isQuote ? 100 : null,
	            theme: isQuote ? _MediaWrapper2.default.themes.sticky : null,
	            className: (0, _classnames2.default)('feature-media-block', _defineProperty({}, 'feature-media-block_with-video', isVideoMedia))
	        },
	        isText && _react2.default.createElement(_FeatureMediaWithCaption2.default, { text: text }),
	        isQuote && _react2.default.createElement(_FeatureImageQuoteContent2.default, { quote: quote })
	    );
	};
	
	FeatureMediaBlock.propTypes = {
	    media: _propTypes2.default.shape({
	        video: _propTypes2.default.shape(_Video2.default.propTypes),
	        videoMobile: _propTypes2.default.shape(_Video2.default.propTypes),
	        image: _propTypes2.default.string,
	        imageMobile: _propTypes2.default.string,
	        alt: _propTypes2.default.string
	    }),
	    text: _propTypes2.default.string,
	    quote: _propTypes2.default.shape(_QuoteBlock2.default.propTypes)
	};
	
	exports.default = FeatureMediaBlock;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FeatureMediaBlock = __webpack_require__(453);
	
	var _FeatureMediaBlock2 = _interopRequireDefault(_FeatureMediaBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FeatureMediaBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FeatureMediaHeaderModule = __webpack_require__(762);
	
	var _FeatureMediaHeaderModule2 = _interopRequireDefault(_FeatureMediaHeaderModule);
	
	var _FeatureImageHeaderContent = __webpack_require__(224);
	
	var _FeatureImageHeaderContent2 = _interopRequireDefault(_FeatureImageHeaderContent);
	
	var _MediaWrapper = __webpack_require__(126);
	
	var _MediaWrapper2 = _interopRequireDefault(_MediaWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeatureMediaHeader = function FeatureMediaHeader(_ref) {
	    var media = _ref.media,
	        content = _ref.content;
	
	    return _react2.default.createElement(
	        _MediaWrapper2.default,
	        {
	            media: media,
	            stickyDuration: 30,
	            theme: _MediaWrapper2.default.themes.fixed,
	            gradient: _MediaWrapper2.default.gradients.feature,
	            bottomAligned: true
	        },
	        _react2.default.createElement(_FeatureImageHeaderContent2.default, _extends({}, content, {
	            showIcon: true,
	            shouldAnimate: true
	        }))
	    );
	};
	
	FeatureMediaHeader.propTypes = {
	    media: _propTypes2.default.shape({ isSticky: _propTypes2.default.bool }),
	    content: _propTypes2.default.object
	};
	
	exports.default = FeatureMediaHeader;
	module.exports = exports["default"];

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FeatureMediaHeader = __webpack_require__(455);
	
	var _FeatureMediaHeader2 = _interopRequireDefault(_FeatureMediaHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FeatureMediaHeader2.default;
	module.exports = exports["default"];

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FeatureMediaWithCaptionModule = __webpack_require__(763);
	
	var _FeatureMediaWithCaptionModule2 = _interopRequireDefault(_FeatureMediaWithCaptionModule);
	
	var _AnimateOpacity = __webpack_require__(129);
	
	var _AnimateOpacity2 = _interopRequireDefault(_AnimateOpacity);
	
	var _Sticky = __webpack_require__(244);
	
	var _Sticky2 = _interopRequireDefault(_Sticky);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeatureMediaWithCaption = function FeatureMediaWithCaption(_ref) {
	    var text = _ref.text;
	
	    return _react2.default.createElement(
	        _AnimateOpacity2.default,
	        {
	            start: "self",
	            startOffset: "25vh",
	            duration: "25vh",
	            className: _FeatureMediaWithCaptionModule2.default.animationWrapper
	        },
	        _react2.default.createElement(
	            _Sticky2.default,
	            { type: "div", props: { className: _FeatureMediaWithCaptionModule2.default.captionWrapper }, isSticky: true, isAtBottom: true },
	            _react2.default.createElement(
	                "p",
	                { className: _FeatureMediaWithCaptionModule2.default.caption },
	                text
	            )
	        )
	    );
	};
	
	FeatureMediaWithCaption.propTypes = {
	    text: _propTypes2.default.string
	};
	
	exports.default = FeatureMediaWithCaption;
	module.exports = exports["default"];

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FeatureMediaWithCaption = __webpack_require__(457);
	
	var _FeatureMediaWithCaption2 = _interopRequireDefault(_FeatureMediaWithCaption);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FeatureMediaWithCaption2.default;
	module.exports = exports["default"];

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _FilterToggleButtonModule = __webpack_require__(764);
	
	var _FilterToggleButtonModule2 = _interopRequireDefault(_FilterToggleButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterToggleButton = function (_React$PureComponent) {
	    _inherits(FilterToggleButton, _React$PureComponent);
	
	    function FilterToggleButton() {
	        _classCallCheck(this, FilterToggleButton);
	
	        return _possibleConstructorReturn(this, (FilterToggleButton.__proto__ || Object.getPrototypeOf(FilterToggleButton)).apply(this, arguments));
	    }
	
	    _createClass(FilterToggleButton, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                activeFilters = _props.activeFilters,
	                label = _props.label,
	                onClick = _props.onClick,
	                open = _props.open;
	
	
	            return _react2.default.createElement(
	                'button',
	                {
	                    className: (0, _classnames2.default)(_FilterToggleButtonModule2.default.button, 'filter', _defineProperty({}, _FilterToggleButtonModule2.default.open, open)),
	                    onClick: onClick
	                },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        label
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: _FilterToggleButtonModule2.default.filters },
	                        activeFilters
	                    ),
	                    _react2.default.createElement(_Icon2.default, { className: _FilterToggleButtonModule2.default.arrow, icon: 'arrow-down' })
	                )
	            );
	        }
	    }]);
	
	    return FilterToggleButton;
	}(_react2.default.PureComponent);
	
	FilterToggleButton.propTypes = {
	    activeFilters: _propTypes2.default.number.isRequired,
	    label: _propTypes2.default.string.isRequired,
	    onClick: _propTypes2.default.func.isRequired,
	    open: _propTypes2.default.bool.isRequired
	};
	exports.default = FilterToggleButton;
	module.exports = exports['default'];

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilterToggleButton = exports.default = undefined;
	
	var _FilterToggleButton2 = __webpack_require__(459);
	
	var _FilterToggleButton3 = _interopRequireDefault(_FilterToggleButton2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FilterToggleButton3.default;
	exports.FilterToggleButton = _FilterToggleButton3.default;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(16);
	
	var _FluidImageModule = __webpack_require__(765);
	
	var _FluidImageModule2 = _interopRequireDefault(_FluidImageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FluidImage = function FluidImage(_ref) {
	    var altText = _ref.altText,
	        className = _ref.className,
	        image = _ref.image,
	        visible = _ref.visible,
	        props = _objectWithoutProperties(_ref, ['altText', 'className', 'image', 'visible']);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({
	            className: (0, _classnames2.default)(_FluidImageModule2.default.image, className, _defineProperty({}, _FluidImageModule2.default.visible, visible)),
	            style: {
	                backgroundImage: visible && image && 'url(\'' + image + '\')'
	            }
	        }, (0, _utils.filterAttributes)(props, /^data-/)),
	        visible && _react2.default.createElement('img', { src: image, alt: altText ? altText : '' })
	    );
	};
	
	FluidImage.propTypes = {
	    altText: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    image: _propTypes2.default.string.isRequired,
	    visible: _propTypes2.default.bool.isRequired
	};
	
	FluidImage.defaultProps = {
	    visible: true
	};
	
	exports.default = FluidImage;
	module.exports = exports['default'];

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _AnimatedNumber = __webpack_require__(381);
	
	var _AnimatedNumber2 = _interopRequireDefault(_AnimatedNumber);
	
	var _utils = __webpack_require__(16);
	
	var _FooterModule = __webpack_require__(766);
	
	var _FooterModule2 = _interopRequireDefault(_FooterModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Footer = function Footer(_ref) {
	    var _cn;
	
	    var linkGroup = _ref.linkGroup,
	        followUs = _ref.followUs,
	        stock = _ref.stock;
	    return _react2.default.createElement(
	        'footer',
	        _extends({ className: (0, _classnames2.default)("footer", _FooterModule2.default.footer) }, (0, _utils.onPageEditing)('FooterContent')),
	        _react2.default.createElement(
	            'div',
	            { className: _FooterModule2.default.container },
	            linkGroup && _react2.default.createElement(
	                'div',
	                { className: _FooterModule2.default["slink-group"] },
	                linkGroup.heading && _react2.default.createElement(
	                    'a',
	                    {
	                        className: _FooterModule2.default["logo-link"],
	                        href: linkGroup.headingAsLink
	                    },
	                    linkGroup.heading
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: _FooterModule2.default.links },
	                    linkGroup.linkCollection && linkGroup.linkCollection.map(function (link, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: index },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: link.href,
	                                    target: link.target,
	                                    title: link.title
	                                },
	                                link.text
	                            )
	                        );
	                    })
	                )
	            ),
	            stock && _react2.default.createElement(
	                'div',
	                { className: _FooterModule2.default.stock },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    stock.heading + ' '
	                ),
	                _react2.default.createElement(
	                    _AnimatedNumber2.default,
	                    {
	                        className: _FooterModule2.default["stock-value"],
	                        visibleClassName: _FooterModule2.default["is-visible"]
	                    },
	                    stock.value.toFixed(2)
	                ),
	                _react2.default.createElement(
	                    _AnimatedNumber2.default,
	                    {
	                        className: (0, _classnames2.default)(_FooterModule2.default["stock-difference"], (_cn = {}, _defineProperty(_cn, _FooterModule2.default["stock-difference-positive"], stock.differencePercent >= 0), _defineProperty(_cn, _FooterModule2.default["stock-difference-negative"], stock.differencePercent < 0), _cn)),
	                        visibleClassName: _FooterModule2.default["is-visible"],
	                        suffix: '%'
	                    },
	                    stock.differencePercent.toFixed(2)
	                )
	            ),
	            _react2.default.createElement(
	                'ul',
	                { className: _FooterModule2.default.social },
	                followUs.heading && _react2.default.createElement(
	                    'li',
	                    { className: _FooterModule2.default.followUsLabel },
	                    followUs.heading
	                ),
	                followUs.socialLinks && followUs.socialLinks.socialLinkBlock.map(function (link, index) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: link.blockId || index },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                className: link.options.socialLinkStyle,
	                                href: link.options.link,
	                                target: link.options.openInNewWindow ? "_blank" : null,
	                                title: (0, _utils.capitalizeFirstLetter)(link.options.socialLinkStyle)
	                            },
	                            _react2.default.createElement(_Icon2.default, { icon: link.options.socialLinkStyle }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                link.options.socialLinkStyle
	                            )
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	Footer.propTypes = {
	    stock: _propTypes2.default.shape({
	        heading: _propTypes2.default.string.isRequired,
	        value: _propTypes2.default.number.isRequired,
	        differencePercent: _propTypes2.default.number.isRequired
	    }),
	    linkGroup: _propTypes2.default.shape({
	        heading: _propTypes2.default.string,
	        headingAsLink: _propTypes2.default.string,
	        linkCollection: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	            href: _propTypes2.default.string.isRequired,
	            language: _propTypes2.default.string,
	            target: _propTypes2.default.string,
	            text: _propTypes2.default.string,
	            title: _propTypes2.default.string
	        }))
	    }).isRequired,
	    followUs: _propTypes2.default.shape({
	        heading: _propTypes2.default.string,
	        socialLinks: _propTypes2.default.shape({
	            socialLinkBlock: _propTypes2.default.array
	        })
	    }).isRequired,
	    followUsLabel: _propTypes2.default.string
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Footer = __webpack_require__(462);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Footer2.default;
	module.exports = exports['default'];

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _throttle = __webpack_require__(70);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _FullscreenListBlockModule = __webpack_require__(767);
	
	var _FullscreenListBlockModule2 = _interopRequireDefault(_FullscreenListBlockModule);
	
	var _utils = __webpack_require__(16);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* globals Components */
	
	
	//import Components from 'constants/components';
	
	var FullscreenListBlock = function (_React$Component) {
	    _inherits(FullscreenListBlock, _React$Component);
	
	    function FullscreenListBlock(props) {
	        _classCallCheck(this, FullscreenListBlock);
	
	        var _this = _possibleConstructorReturn(this, (FullscreenListBlock.__proto__ || Object.getPrototypeOf(FullscreenListBlock)).call(this, props));
	
	        _this.state = {
	            active: 0
	        };
	        _this._handleScroll = (0, _throttle2.default)(function () {
	            if (_this.sliding) {
	                return;
	            }
	            var active = 0;
	            for (var i = 0; i < _this.list.childNodes.length; i++) {
	                var rect = _this.list.childNodes[i].getBoundingClientRect();
	
	                // console.log(i, rect.top, rect.bottom);
	                if (rect.bottom > _this.list.offsetHeight / 2) {
	                    // console.log(rect);
	                    active = i;
	                    break;
	                }
	            }
	
	            _this.setState({ active: active });
	        }, 50);
	
	        _this.setActive = function (e) {
	            e.preventDefault();
	            var id = e.currentTarget.dataset.id;
	
	            _this.setActiveId(parseInt(id, 10));
	        };
	
	        _this.setActiveId = function (id) {
	            if (id >= _this.list.childNodes.length || id < 0) {
	                return;
	            }
	            _this.sliding = true;
	            _this.setState({ active: id }, function () {
	                (0, _utils.scrollIntoView)(_this.list, _this.list.childNodes[id], _this.slideDurationSetting, function () {
	                    _this.sliding = false;
	                });
	            });
	        };
	
	        _this.sliding = false;
	        _this.scrollTop = 0;
	
	        _this.sections = props.sections;
	        _this.slideDurationSetting = props.duration;
	        return _this;
	    }
	
	    _createClass(FullscreenListBlock, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var active = this.state.active;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_FullscreenListBlockModule2.default.block) },
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)(_FullscreenListBlockModule2.default.list, "fullscreen-list"),
	                        ref: function ref(node) {
	                            return _this2.list = node;
	                        },
	                        onScroll: this._handleScroll
	                    },
	                    this.sections.map(function (section, index) {
	                        // Dynamically fetch component from contentType
	                        var Component = Components[section.contentType];
	                        if (!Component) {
	                            console.error('Components.' + section.contentType + ' is not defined');
	                            return null;
	                        }
	
	                        return _react2.default.createElement(
	                            'section',
	                            { key: index },
	                            _react2.default.createElement(
	                                'div',
	                                { className: section.contentType == "ArticleListBlock" || section.contentType == "InfographicListBlock" ? _FullscreenListBlockModule2.default.adaptiveHeightContainer : null },
	                                _react2.default.createElement(Component, _extends({
	                                    frontpage: true
	                                }, section)),
	                                index === 0 && _react2.default.createElement(_Button2.default, { icon: "arrow-down", className: _FullscreenListBlockModule2.default["scroll-button"], onClick: function onClick() {
	                                        _this2.setActiveId(1);
	                                    } })
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)(_FullscreenListBlockModule2.default.indicators), ref: function ref(node) {
	                            return _this2.indicators = node;
	                        } },
	                    this.sections.map(function (section, index) {
	                        return _react2.default.createElement('a', {
	                            href: '#',
	                            onClick: _this2.setActive,
	                            key: index,
	                            'data-id': index,
	                            className: (0, _classnames2.default)(_FullscreenListBlockModule2.default.indicator, _defineProperty({}, _FullscreenListBlockModule2.default.active, active.toString() === index.toString())) });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return FullscreenListBlock;
	}(_react2.default.Component);
	
	FullscreenListBlock.propTypes = {
	    sections: _propTypes2.default.array,
	    duration: _propTypes2.default.number
	};
	FullscreenListBlock.defaultProps = {
	    duration: 400
	};
	exports.default = FullscreenListBlock;
	module.exports = exports['default'];

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FullscreenListBlock = __webpack_require__(464);
	
	var _FullscreenListBlock2 = _interopRequireDefault(_FullscreenListBlock);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _FullscreenListBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GalleryItem = __webpack_require__(469);
	
	var _GalleryItem2 = _interopRequireDefault(_GalleryItem);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _OnPageEditing = __webpack_require__(21);
	
	var _OnPageEditing2 = _interopRequireDefault(_OnPageEditing);
	
	var _GalleryBlockModule = __webpack_require__(768);
	
	var _GalleryBlockModule2 = _interopRequireDefault(_GalleryBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GalleryBlock = function (_React$PureComponent) {
	    _inherits(GalleryBlock, _React$PureComponent);
	
	    function GalleryBlock() {
	        _classCallCheck(this, GalleryBlock);
	
	        return _possibleConstructorReturn(this, (GalleryBlock.__proto__ || Object.getPrototypeOf(GalleryBlock)).apply(this, arguments));
	    }
	
	    _createClass(GalleryBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                heading = _props.heading,
	                items = _props.items,
	                link = _props.link;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _GalleryBlockModule2.default.block },
	                _react2.default.createElement(
	                    'div',
	                    { className: _GalleryBlockModule2.default.content },
	                    _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { property: 'Heading' },
	                        _react2.default.createElement(
	                            'header',
	                            { className: _GalleryBlockModule2.default.header },
	                            heading && _react2.default.createElement(
	                                'h2',
	                                { className: 'block-title-large' },
	                                heading
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { property: 'Items' },
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _GalleryBlockModule2.default.items },
	                            items.map(function (item, key) {
	
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: key },
	                                    _react2.default.createElement(_GalleryItem2.default, item)
	                                );
	                            })
	                        )
	                    ),
	                    link && _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { property: 'Link' },
	                        _react2.default.createElement(
	                            'footer',
	                            { className: _GalleryBlockModule2.default.footer },
	                            _react2.default.createElement(
	                                _Button2.default,
	                                {
	                                    block: true,
	                                    href: link.url,
	                                    secondary: true,
	                                    target: '_blank'
	                                },
	                                link.label
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return GalleryBlock;
	}(_react2.default.PureComponent);
	
	GalleryBlock.propTypes = {
	    heading: _propTypes2.default.string.isRequired,
	    items: _propTypes2.default.arrayOf(_propTypes2.default.shape(_GalleryItem2.default.propTypes)),
	    link: _propTypes2.default.shape({
	        url: _propTypes2.default.string.isRequired,
	        label: _propTypes2.default.string.isRequired
	    })
	};
	exports.default = GalleryBlock;
	module.exports = exports['default'];

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GalleryBlock = exports.default = undefined;
	
	var _GalleryBlock2 = __webpack_require__(466);
	
	var _GalleryBlock3 = _interopRequireDefault(_GalleryBlock2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _GalleryBlock3.default;
	exports.GalleryBlock = _GalleryBlock3.default;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _GalleryItemModule = __webpack_require__(769);
	
	var _GalleryItemModule2 = _interopRequireDefault(_GalleryItemModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LogoBlock = function (_React$PureComponent) {
	    _inherits(LogoBlock, _React$PureComponent);
	
	    function LogoBlock() {
	        _classCallCheck(this, LogoBlock);
	
	        return _possibleConstructorReturn(this, (LogoBlock.__proto__ || Object.getPrototypeOf(LogoBlock)).apply(this, arguments));
	    }
	
	    _createClass(LogoBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                name = _props.name,
	                description = _props.description,
	                text = _props.text,
	                image = _props.image,
	                downloadImages = _props.downloadImages;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _GalleryItemModule2.default.item },
	                _react2.default.createElement(
	                    'div',
	                    { className: _GalleryItemModule2.default.image },
	                    _react2.default.createElement('img', { src: image, alt: name ? name : '' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _GalleryItemModule2.default.info },
	                    _react2.default.createElement(
	                        'h3',
	                        { className: _GalleryItemModule2.default.name },
	                        name
	                    ),
	                    description && _react2.default.createElement(
	                        'p',
	                        { className: _GalleryItemModule2.default.description },
	                        description
	                    ),
	                    text && _react2.default.createElement(
	                        'p',
	                        { className: _GalleryItemModule2.default.text },
	                        text
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _GalleryItemModule2.default.buttons },
	                    downloadImages.map(function (item, index) {
	                        return _react2.default.createElement(
	                            _Button2.default,
	                            {
	                                key: "button-" + index,
	                                href: item.url,
	                                block: true,
	                                secondary: true,
	                                download: true,
	                                target: '_blank'
	                            },
	                            item.label
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return LogoBlock;
	}(_react2.default.PureComponent);
	
	LogoBlock.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    description: _propTypes2.default.string.isRequired,
	    text: _propTypes2.default.string.isRequired,
	    image: _propTypes2.default.string.isRequired,
	    downloadImages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        url: _propTypes2.default.string.isRequired,
	        label: _propTypes2.default.string.isRequired
	    }))
	};
	exports.default = LogoBlock;
	module.exports = exports['default'];

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GalleryItem = exports.default = undefined;
	
	var _GalleryItem2 = __webpack_require__(468);
	
	var _GalleryItem3 = _interopRequireDefault(_GalleryItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _GalleryItem3.default;
	exports.GalleryItem = _GalleryItem3.default;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _GoToReachMeeProfileModule = __webpack_require__(770);
	
	var _GoToReachMeeProfileModule2 = _interopRequireDefault(_GoToReachMeeProfileModule);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _LinkButton = __webpack_require__(47);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _themes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GoToReachMeeProfile = function (_React$PureComponent) {
	    _inherits(GoToReachMeeProfile, _React$PureComponent);
	
	    function GoToReachMeeProfile() {
	        _classCallCheck(this, GoToReachMeeProfile);
	
	        return _possibleConstructorReturn(this, (GoToReachMeeProfile.__proto__ || Object.getPrototypeOf(GoToReachMeeProfile)).apply(this, arguments));
	    }
	
	    _createClass(GoToReachMeeProfile, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                text = _props.text,
	                button1 = _props.button1,
	                button2 = _props.button2,
	                theme = _props.theme;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_GoToReachMeeProfileModule2.default.block, (0, _themes.getThemeClassNames)(_GoToReachMeeProfileModule2.default, theme)), 'data-epi-property-name': 'GoToReachmeeProfile' },
	                _react2.default.createElement(
	                    'div',
	                    { className: _GoToReachMeeProfileModule2.default.content },
	                    _react2.default.createElement(
	                        'p',
	                        { className: _GoToReachMeeProfileModule2.default.text },
	                        text
	                    ),
	                    button1 && _react2.default.createElement(
	                        _Button2.default,
	                        { href: button1.url, target: button1.target, className: _GoToReachMeeProfileModule2.default.button },
	                        button1.text
	                    ),
	                    button2 && _react2.default.createElement(
	                        _Button2.default,
	                        { href: button2.url, target: button2.target, className: _GoToReachMeeProfileModule2.default.button },
	                        button2.text
	                    )
	                )
	            );
	        }
	    }]);
	
	    return GoToReachMeeProfile;
	}(_react2.default.PureComponent);
	
	GoToReachMeeProfile.propTypes = {
	    text: _propTypes2.default.string,
	    button1: _propTypes2.default.shape(_LinkButton2.default.propTypes),
	    button2: _propTypes2.default.shape(_LinkButton2.default.propTypes),
	    theme: _propTypes2.default.oneOf(Object.keys(_themes.THEMES).map(function (s) {
	        return _themes.THEMES[s];
	    }))
	};
	exports.default = GoToReachMeeProfile;
	module.exports = exports['default'];

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GoToReachMeeProfile = __webpack_require__(470);
	
	var _GoToReachMeeProfile2 = _interopRequireDefault(_GoToReachMeeProfile);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _GoToReachMeeProfile2.default;
	module.exports = exports['default'];

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Link = __webpack_require__(26);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _GroupWithLinksBlockModule = __webpack_require__(771);
	
	var _GroupWithLinksBlockModule2 = _interopRequireDefault(_GroupWithLinksBlockModule);
	
	var _themes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupWithLinksBlock = function GroupWithLinksBlock(_ref) {
	    var groupName = _ref.groupName,
	        links = _ref.links,
	        theme = _ref.theme,
	        _ref$headingTagLevel = _ref.headingTagLevel,
	        headingTagLevel = _ref$headingTagLevel === undefined ? 3 : _ref$headingTagLevel;
	
	    var HeadingTag = 'h' + headingTagLevel;
	    return _react2.default.createElement(
	        'div',
	        { className: _GroupWithLinksBlockModule2.default.block },
	        groupName && _react2.default.createElement(
	            HeadingTag,
	            { className: _GroupWithLinksBlockModule2.default.heading },
	            groupName
	        ),
	        links && _react2.default.createElement(
	            'ul',
	            { className: _GroupWithLinksBlockModule2.default.list },
	            links.map(function (link, index) {
	                return _react2.default.createElement(
	                    'li',
	                    { key: index, className: _GroupWithLinksBlockModule2.default.listItem },
	                    _react2.default.createElement(
	                        _Button2.default,
	                        _extends({
	                            secondary: true,
	                            href: link.url,
	                            target: link.openInNewWindow ? '_blank' : null
	                        }, { light: theme === _themes.THEMES.darkgray }, {
	                            className: _GroupWithLinksBlockModule2.default.link
	                        }),
	                        link.linkText
	                    )
	                );
	            })
	        )
	    );
	};
	
	GroupWithLinksBlock.propTypes = {
	    groupName: _propTypes2.default.string,
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape(_Link2.default.propTypes)),
	    theme: _propTypes2.default.oneOf(Object.values(_themes.THEMES)),
	    headingTagLevel: _propTypes2.default.oneOf([2, 3])
	};
	
	GroupWithLinksBlock.propTypesMeta = {
	    theme: 'exclude',
	    headingTagLevel: 'exclude'
	};
	
	exports.default = GroupWithLinksBlock;
	module.exports = exports['default'];

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ImageIcon = __webpack_require__(59);
	
	var _ImageIcon2 = _interopRequireDefault(_ImageIcon);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _GroupedLinksBlockModule = __webpack_require__(772);
	
	var _GroupedLinksBlockModule2 = _interopRequireDefault(_GroupedLinksBlockModule);
	
	var _GroupWithLinksBlock = __webpack_require__(472);
	
	var _GroupWithLinksBlock2 = _interopRequireDefault(_GroupWithLinksBlock);
	
	var _themes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupedLinksBlock = function (_React$Component) {
	    _inherits(GroupedLinksBlock, _React$Component);
	
	    function GroupedLinksBlock() {
	        _classCallCheck(this, GroupedLinksBlock);
	
	        return _possibleConstructorReturn(this, (GroupedLinksBlock.__proto__ || Object.getPrototypeOf(GroupedLinksBlock)).apply(this, arguments));
	    }
	
	    _createClass(GroupedLinksBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                heading = _props.heading,
	                text = _props.text,
	                items = _props.items,
	                theme = _props.theme,
	                icon = _props.icon,
	                iconNew = _props.iconNew,
	                blockId = _props.blockId;
	
	
	            var classNames = (0, _classnames2.default)(_GroupedLinksBlockModule2.default.block, _extends({}, (0, _themes.getThemeClassNames)(_GroupedLinksBlockModule2.default, theme)));
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: classNames,
	                    'data-block': blockId
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: _GroupedLinksBlockModule2.default['block-content'] },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _GroupedLinksBlockModule2.default['list-content'] },
	                        iconNew ? _react2.default.createElement(
	                            'div',
	                            { className: _GroupedLinksBlockModule2.default.icon },
	                            _react2.default.createElement(_ImageIcon2.default, iconNew)
	                        ) : icon ? _react2.default.createElement(
	                            'div',
	                            { className: _GroupedLinksBlockModule2.default.icon },
	                            _react2.default.createElement(_Icon2.default, { icon: icon })
	                        ) : null,
	                        heading && _react2.default.createElement(
	                            'h2',
	                            { className: _GroupedLinksBlockModule2.default.heading },
	                            heading
	                        ),
	                        text && _react2.default.createElement(
	                            'p',
	                            { className: _GroupedLinksBlockModule2.default.text },
	                            text
	                        ),
	                        items && _react2.default.createElement(
	                            'ul',
	                            { className: _GroupedLinksBlockModule2.default.list },
	                            items.map(function (item, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index, className: _GroupedLinksBlockModule2.default.listItem },
	                                    _react2.default.createElement(_GroupWithLinksBlock2.default, _extends({}, item, {
	                                        theme: theme,
	                                        headingTagLevel: heading ? 3 : 2
	                                    }))
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return GroupedLinksBlock;
	}(_react2.default.Component);
	
	GroupedLinksBlock.propTypes = {
	    heading: _propTypes2.default.string.isRequired,
	    text: _propTypes2.default.string,
	    items: _propTypes2.default.arrayOf(_propTypes2.default.shape(_GroupWithLinksBlock2.default.propTypes)),
	    icon: _propTypes2.default.string,
	    iconNew: _propTypes2.default.shape(_ImageIcon2.default.propTypes),
	    theme: _propTypes2.default.oneOf(Object.values(_themes.THEMES)),
	    blockId: _propTypes2.default.number
	};
	GroupedLinksBlock.defaultProps = {
	    theme: 0
	};
	exports.default = GroupedLinksBlock;
	module.exports = exports['default'];

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _GroupedLinksBlock = __webpack_require__(473);
	
	var _GroupedLinksBlock2 = _interopRequireDefault(_GroupedLinksBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _GroupedLinksBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _HMSSlide = __webpack_require__(478);
	
	var _HMSSlide2 = _interopRequireDefault(_HMSSlide);
	
	var _HMSBlockModule = __webpack_require__(773);
	
	var _HMSBlockModule2 = _interopRequireDefault(_HMSBlockModule);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HMSBlock = function (_React$Component) {
	    _inherits(HMSBlock, _React$Component);
	
	    function HMSBlock() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, HMSBlock);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HMSBlock.__proto__ || Object.getPrototypeOf(HMSBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            active: 0
	        }, _this._handleIndicatorClick = function (e) {
	            e.preventDefault();
	            var index = parseInt(e.currentTarget.dataset.index),
	                forward = index > _this.state.active;
	
	            if (_this.state.active === index) return;
	
	            _this.setState({ active: index, forward: forward });
	        }, _this._handleNavigationClick = function (e) {
	            e.preventDefault();
	            var direction = e.currentTarget.dataset.direction;
	
	
	            if (direction === "next") {
	                if (_this.props.slides.length <= _this.state.active + 1) return;
	                _this.setState({ active: _this.state.active + 1, forward: true });
	            } else if (direction === "prev") {
	                if (_this.state.active - 1 < 0) return;
	                _this.setState({ active: _this.state.active - 1, forward: false });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(HMSBlock, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var slides = this.props.slides;
	            var _state = this.state,
	                active = _state.active,
	                forward = _state.forward;
	
	
	            if (!slides) return null;
	
	            return _react2.default.createElement(
	                'div',
	                { className: _HMSBlockModule2.default.block },
	                _react2.default.createElement(
	                    'div',
	                    { className: _HMSBlockModule2.default["slides-wrapper"] },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _HMSBlockModule2.default.slides, style: { transform: 'translateX(-' + active * 100 + '%)' } },
	                        slides.map(function (slide, index) {
	                            return _react2.default.createElement(_HMSSlide2.default, _extends({ key: index }, slide));
	                        })
	                    )
	                ),
	                slides.length > 1 && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _HMSBlockModule2.default.nav, key: 'nav' },
	                        !active == 0 && _react2.default.createElement(
	                            'button',
	                            {
	                                type: 'button',
	                                'data-direction': 'prev',
	                                onClick: this._handleNavigationClick,
	                                className: _HMSBlockModule2.default["nav-prev"]
	                            },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Previous'
	                            )
	                        ),
	                        !(active == slides.length - 1) && _react2.default.createElement(
	                            'button',
	                            {
	                                type: 'button',
	                                'data-direction': 'next',
	                                onClick: this._handleNavigationClick,
	                                className: _HMSBlockModule2.default["nav-next"]
	                            },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Next'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _HMSBlockModule2.default["nav-indicators"], key: 'indicators' },
	                        slides.map(function (slide, index) {
	                            var _cn;
	
	                            return _react2.default.createElement(
	                                'li',
	                                { key: index },
	                                _react2.default.createElement(
	                                    'button',
	                                    {
	                                        'data-index': index,
	                                        type: 'button',
	                                        onClick: _this2._handleIndicatorClick,
	                                        className: (0, _classnames2.default)((_cn = {}, _defineProperty(_cn, _HMSBlockModule2.default.active, active === index), _defineProperty(_cn, _HMSBlockModule2.default["direction-forward"], forward), _cn))
	                                    },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        index + 1
	                                    )
	                                )
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HMSBlock;
	}(_react2.default.Component);
	
	HMSBlock.propTypes = {
	    slides: _propTypes2.default.array
	};
	exports.default = HMSBlock;
	module.exports = exports['default'];

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _HMSBlock = __webpack_require__(475);
	
	var _HMSBlock2 = _interopRequireDefault(_HMSBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HMSBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _HMSSlideModule = __webpack_require__(774);
	
	var _HMSSlideModule2 = _interopRequireDefault(_HMSSlideModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HMSSlide = function (_React$Component) {
	    _inherits(HMSSlide, _React$Component);
	
	    function HMSSlide() {
	        _classCallCheck(this, HMSSlide);
	
	        return _possibleConstructorReturn(this, (HMSSlide.__proto__ || Object.getPrototypeOf(HMSSlide)).apply(this, arguments));
	    }
	
	    _createClass(HMSSlide, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                heading = _props.heading,
	                description = _props.description,
	                illustration = _props.illustration,
	                illustrationAltText = _props.illustrationAltText,
	                readMore = _props.readMore,
	                readMoreText = _props.readMoreText;
	
	
	            return _react2.default.createElement(
	                'li',
	                { className: (0, _classnames2.default)(_HMSSlideModule2.default.block) },
	                _react2.default.createElement(
	                    'div',
	                    { className: _HMSSlideModule2.default.innerBlock },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _HMSSlideModule2.default.image },
	                        _react2.default.createElement('img', {
	                            alt: illustrationAltText ? illustrationAltText : '',
	                            src: illustration
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _HMSSlideModule2.default.text },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            heading
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            description
	                        ),
	                        readMore && _react2.default.createElement(
	                            _Button2.default,
	                            { className: _HMSSlideModule2.default.readmore, href: readMore, secondary: true },
	                            readMoreText
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HMSSlide;
	}(_react2.default.Component);
	
	HMSSlide.propTypes = {
	    heading: _propTypes2.default.string,
	    description: _propTypes2.default.string,
	    illustration: _propTypes2.default.string,
	    illustrationAltText: _propTypes2.default.string,
	    readMore: _propTypes2.default.string,
	    readMoreText: _propTypes2.default.string
	};
	exports.default = HMSSlide;
	module.exports = exports['default'];

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _HMSSlide = __webpack_require__(477);
	
	var _HMSSlide2 = _interopRequireDefault(_HMSSlide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HMSSlide2.default;
	module.exports = exports['default'];

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _HeaderImageBlockModule = __webpack_require__(775);
	
	var _HeaderImageBlockModule2 = _interopRequireDefault(_HeaderImageBlockModule);
	
	var _Media = __webpack_require__(38);
	
	var _CuriousBlock = __webpack_require__(121);
	
	var _CuriousBlock2 = _interopRequireDefault(_CuriousBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var HeaderImageBlock = function HeaderImageBlock(_ref) {
	    var heading = _ref.heading,
	        backgroundVideo = _ref.backgroundVideo,
	        image = _ref.image,
	        text = _ref.text,
	        showText = _ref.showText,
	        links = _ref.links,
	        logo = _ref.logo,
	        curious = _ref.curious;
	    return _react2.default.createElement(
	        'header',
	        {
	            className: (0, _classnames2.default)(_HeaderImageBlockModule2.default.header, _defineProperty({}, _HeaderImageBlockModule2.default.hasCurious, curious && curious.text))
	        },
	        _react2.default.createElement(
	            'div',
	            { className: _HeaderImageBlockModule2.default.image },
	            _react2.default.createElement(_Media.Media, {
	                image: image.url,
	                video: backgroundVideo,
	                alt: image.altText
	            })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _HeaderImageBlockModule2.default.text },
	            logo && logo.url && _react2.default.createElement('img', { className: _HeaderImageBlockModule2.default.logo, src: logo.url, alt: logo.altText ? logo.altText : '' }),
	            heading && _react2.default.createElement(
	                'h1',
	                { className: _HeaderImageBlockModule2.default.heading },
	                heading
	            ),
	            showText && text && _react2.default.createElement(
	                'p',
	                { className: _HeaderImageBlockModule2.default.intro },
	                text
	            ),
	            links && _react2.default.createElement(
	                'ul',
	                { className: _HeaderImageBlockModule2.default.linksList },
	                links.map(function (link, index) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: index, className: _HeaderImageBlockModule2.default.linksItem },
	                        _react2.default.createElement(
	                            _Button2.default,
	                            _extends({ white: true }, link),
	                            link.text
	                        )
	                    );
	                })
	            ),
	            curious && curious.text && _react2.default.createElement(_CuriousBlock2.default, _extends({}, curious, { className: _HeaderImageBlockModule2.default.curious }))
	        )
	    );
	};
	
	HeaderImageBlock.propTypes = {
	    logo: _propTypes2.default.shape({
	        url: _propTypes2.default.string,
	        altText: _propTypes2.default.string
	    }),
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        href: _propTypes2.default.string,
	        target: _propTypes2.default.string,
	        text: _propTypes2.default.string
	    })),
	    heading: _propTypes2.default.string,
	    text: _propTypes2.default.string,
	    showText: _propTypes2.default.bool,
	    backgroundVideo: _Media.Media && _Media.Media.propTypes.video,
	    image: _propTypes2.default.shape({
	        url: _propTypes2.default.string,
	        altText: _propTypes2.default.string
	    }),
	    curious: _CuriousBlock2.default.propTypes
	};
	
	exports.default = HeaderImageBlock;
	module.exports = exports['default'];

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _HeaderImageBlock = __webpack_require__(479);
	
	var _HeaderImageBlock2 = _interopRequireDefault(_HeaderImageBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HeaderImageBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _MainNav = __webpack_require__(525);
	
	var _MainNav2 = _interopRequireDefault(_MainNav);
	
	var _SupportingMenu = __webpack_require__(245);
	
	var _SupportingMenu2 = _interopRequireDefault(_SupportingMenu);
	
	var _MobileMenu = __webpack_require__(535);
	
	var _MobileMenu2 = _interopRequireDefault(_MobileMenu);
	
	var _hamburger = __webpack_require__(835);
	
	var _hamburger2 = _interopRequireDefault(_hamburger);
	
	var _cross = __webpack_require__(838);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	var _logo = __webpack_require__(83);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	__webpack_require__(702);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Icon = function Icon(_ref) {
	    var onClick = _ref.onClick,
	        isActiveOnMobile = _ref.isActiveOnMobile;
	
	    var hamburgerIcon = _react2.default.createElement(
	        'div',
	        { className: 'col mobile hamburger', onClick: onClick },
	        _react2.default.createElement('img', { alt: 'Toggle menu', src: _hamburger2.default })
	    );
	
	    var crossIcon = _react2.default.createElement(
	        'div',
	        { className: 'col mobile cross', onClick: onClick },
	        _react2.default.createElement('img', { alt: 'Close menu', src: _cross2.default })
	    );
	
	    return isActiveOnMobile ? crossIcon : hamburgerIcon;
	};
	
	var Logo = function Logo(_ref2) {
	    var logo = _ref2.logo,
	        logoMobile = _ref2.logoMobile,
	        isVisible = _ref2.isVisible,
	        title = _ref2.title,
	        logoLink = _ref2.logoLink;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'logo-col' },
	        isVisible && _react2.default.createElement(
	            'a',
	            { className: 'logo', href: logoLink, title: title },
	            _react2.default.createElement('img', { src: logo, alt: 'AF Gruppen', className: 'logo-image-desktop' }),
	            _react2.default.createElement('img', { src: logoMobile, alt: 'AF Gruppen', className: 'logo-image-mobile' })
	        )
	    );
	};
	
	Logo.propTypes = {
	    logo: _propTypes2.default.string.isRequired,
	    logoMobile: _propTypes2.default.string.isRequired,
	    isVisible: _propTypes2.default.bool.isRequired,
	    title: _propTypes2.default.string.isRequired,
	    logoLink: _propTypes2.default.string.isRequired
	};
	
	var Header = function (_React$PureComponent) {
	    _inherits(Header, _React$PureComponent);
	
	    function Header(props) {
	        _classCallCheck(this, Header);
	
	        var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	        _this._handleCurtainClick = function (e) {
	            if (e.target === e.currentTarget) {
	                _this.setState({ isActive: null });
	            }
	        };
	
	        _this.state = {
	            isActive: null,
	            isActiveOnMobile: false,
	            scrollDown: false,
	            lastScrollTop: 0
	        };
	
	        _this.onClick = _this.onClick.bind(_this);
	        _this.activeOnMobile = _this.activeOnMobile.bind(_this);
	        _this.updateDimensions = _this.updateDimensions.bind(_this);
	        _this.handleTopHeader = _this.handleTopHeader.bind(_this);
	        _this.closeCurtain = _this.closeCurtain.bind(_this);
	        return _this;
	    }
	
	    _createClass(Header, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var frontPage = document.getElementsByClassName('fullscreen-list');
	
	            this.updateDimensions();
	            typeof window !== 'undefined' && window.addEventListener("resize", this.updateDimensions);
	            typeof window !== 'undefined' && window.addEventListener("scroll", this.handleTopHeader);
	
	            typeof window !== 'undefined' && typeof frontPage[0] !== 'undefined' && frontPage[0].addEventListener('scroll', function () {
	                _this2.handleTopHeader(frontPage[0]);
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            typeof window !== 'undefined' && window.removeEventListener("resize", this.updateDimensions);
	            typeof window !== 'undefined' && window.removeEventListener("scroll", this.handleTopHeader);
	        }
	    }, {
	        key: 'updateDimensions',
	        value: function updateDimensions() {
	            if (typeof window !== 'undefined' && window.innerWidth > 1024) {
	                this.setState({ isActiveOnMobile: false });
	            }
	        }
	    }, {
	        key: 'handleTopHeader',
	        value: function handleTopHeader(e) {
	            var _this3 = this;
	
	            var st = void 0;
	            var bodyClass = "header-is-hidden";
	            if (e.currentTarget == window) {
	                st = window.pageYOffset || document.documentElement.scrollTop;
	            } else {
	                st = e.scrollTop;
	            }
	
	            if (st > 70 && st > this.state.lastScrollTop) {
	                this.setState({ "scrollDown": true });
	                document.body.classList.add(bodyClass);
	            } else {
	                this.setState({ "scrollDown": false });
	                document.body.classList.remove(bodyClass);
	            }
	
	            setTimeout(function () {
	                return _this3.setState({ "lastScrollTop": st <= 0 ? 0 : st });
	            }, 100); //IE11 always returns the same numbers so needs some delay
	        }
	    }, {
	        key: 'onClick',
	        value: function onClick(id) {
	            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            this.setState({ isActive: this.state.isActive === id ? null : id }, callback);
	        }
	    }, {
	        key: 'closeCurtain',
	        value: function closeCurtain() {
	            this.setState({ isActive: null, isActiveOnMobile: false });
	        }
	    }, {
	        key: 'activeOnMobile',
	        value: function activeOnMobile() {
	            this.setState({ isActiveOnMobile: !this.state.isActiveOnMobile });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                header = _props.header,
	                searchLink = _props.searchLink,
	                languages = _props.languages,
	                startpageLinkLabel = _props.startpageLinkLabel,
	                searchLabel = _props.searchLabel,
	                inputPlaceholder = _props.inputPlaceholder,
	                logoImageUrl = _props.logoImageUrl,
	                logoImageUrlMobile = _props.logoImageUrlMobile,
	                logoLink = _props.logoLink,
	                closeMenuLabel = _props.closeMenuLabel,
	                openQuickSearchFormBtnAriaLabel = _props.openQuickSearchFormBtnAriaLabel,
	                closeQuickSearchFormBtnAriaLabel = _props.closeQuickSearchFormBtnAriaLabel;
	            var isActive = this.state.isActive;
	
	
	            var withCustomLogo = logoImageUrl || logoImageUrlMobile;
	
	            var topHeaderClassNames = (0, _classnames2.default)('top-header', {
	                'mobile': this.state.isActiveOnMobile,
	                'with-custom-logo': withCustomLogo
	            });
	
	            var headerClassNames = (0, _classnames2.default)('site-header', {
	                'scroll-down': this.state.scrollDown,
	                'activeMobile': this.state.isActiveOnMobile,
	                'active': this.state.isActive
	            });
	
	            var logo = logoImageUrl ? logoImageUrl : logoImageUrlMobile ? logoImageUrlMobile : _logo2.default;
	            var logoMobile = logoImageUrlMobile ? logoImageUrlMobile : logoImageUrl ? logoImageUrl : _logo2.default;
	
	            return _react2.default.createElement(
	                'header',
	                { className: headerClassNames },
	                isActive !== null && _react2.default.createElement('div', { className: 'header-curtain', onClick: this._handleCurtainClick }),
	                _react2.default.createElement(
	                    'div',
	                    { className: topHeaderClassNames },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'top-header-wrapper' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'top-header-content' },
	                            _react2.default.createElement(Logo, {
	                                logo: logo,
	                                logoMobile: logoMobile,
	                                isVisible: true,
	                                title: startpageLinkLabel,
	                                logoLink: logoLink
	                            }),
	                            _react2.default.createElement(Icon, {
	                                onClick: this.activeOnMobile,
	                                isActiveOnMobile: false
	                            }),
	                            _react2.default.createElement(_MainNav2.default, {
	                                menu: header.menu,
	                                onClick: this.onClick,
	                                isActiveOnMobile: false,
	                                isActive: this.state.isActive,
	                                closeMenuLabel: closeMenuLabel
	                            }),
	                            _react2.default.createElement(_SupportingMenu2.default, {
	                                menu: header.supportingMenu,
	                                searchLink: searchLink,
	                                searchLabel: searchLabel,
	                                languages: languages,
	                                onClick: this.onClick,
	                                isActiveOnMobile: false,
	                                isActive: this.state.isActive,
	                                inputPlaceholder: inputPlaceholder,
	                                withCustomLogo: withCustomLogo ? true : false,
	                                openQuickSearchFormBtnAriaLabel: openQuickSearchFormBtnAriaLabel,
	                                closeQuickSearchFormBtnAriaLabel: closeQuickSearchFormBtnAriaLabel
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(_MobileMenu2.default, _extends({
	                    closeMenu: this.closeCurtain,
	                    open: this.state.isActiveOnMobile,
	                    searchLabel: searchLabel,
	                    searchLink: searchLink,
	                    languages: languages,
	                    withCustomLogo: withCustomLogo ? true : false,
	                    openQuickSearchFormBtnAriaLabel: openQuickSearchFormBtnAriaLabel,
	                    closeQuickSearchFormBtnAriaLabel: closeQuickSearchFormBtnAriaLabel
	                }, header))
	            );
	        }
	    }]);
	
	    return Header;
	}(_react2.default.PureComponent);
	
	Header.propTypes = {
	    header: _propTypes2.default.object,
	    searchLink: _propTypes2.default.string,
	    inputPlaceholder: _propTypes2.default.string,
	    languages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        isActive: _propTypes2.default.bool.isRequired,
	        link: _propTypes2.default.string.isRequired,
	        text: _propTypes2.default.string.isRequired
	    })).isRequired,
	    startpageLinkLabel: _propTypes2.default.string.isRequired,
	    logoImageUrl: _propTypes2.default.string,
	    logoImageUrlMobile: _propTypes2.default.string,
	    logoLink: _propTypes2.default.string.isRequired,
	    searchLabel: _propTypes2.default.string.isRequired,
	    closeMenuLabel: _propTypes2.default.string.isRequired,
	    openQuickSearchFormBtnAriaLabel: _propTypes2.default.string.isRequired,
	    closeQuickSearchFormBtnAriaLabel: _propTypes2.default.string.isRequired
	};
	
	
	var HeaderPropConverter = function HeaderPropConverter(_ref3) {
	    var header = _ref3.header,
	        languages = _ref3.languages,
	        searchLink = _ref3.searchLink,
	        startpageLinkLabel = _ref3.startpageLinkLabel,
	        searchLabel = _ref3.searchLabel,
	        inputPlaceholder = _ref3.inputPlaceholder,
	        logoImageUrl = _ref3.logoImageUrl,
	        logoImageUrlMobile = _ref3.logoImageUrlMobile,
	        logoLink = _ref3.logoLink,
	        closeMenuLabel = _ref3.closeMenuLabel,
	        openQuickSearchFormBtnAriaLabel = _ref3.openQuickSearchFormBtnAriaLabel,
	        closeQuickSearchFormBtnAriaLabel = _ref3.closeQuickSearchFormBtnAriaLabel;
	
	    var newHeaderProps = {
	        menu: [],
	        supportingMenu: header.supportingMenu
	    };
	
	    {
	        header.menu && header.menu.map(function (num, i) {
	            var rest = _objectWithoutProperties(header.menu[i], []);
	
	            var link = num.link;
	            var linkText = num.linkText;
	            var columns = [];
	
	            ['first', 'second', 'third', 'fourth'].forEach(function (key) {
	                if (rest[key + 'Column'] && rest[key + 'Column'].subMenuBlock) {
	                    columns.push(rest[key + 'Column'].subMenuBlock);
	                }
	            });
	
	            newHeaderProps.menu.push({
	                link: link,
	                linkText: linkText,
	                columns: columns
	            });
	        });
	    }
	
	    return _react2.default.createElement(Header, {
	        header: newHeaderProps,
	        languages: languages,
	        searchLink: searchLink,
	        startpageLinkLabel: startpageLinkLabel,
	        searchLabel: searchLabel,
	        inputPlaceholder: inputPlaceholder,
	        logoImageUrl: logoImageUrl,
	        logoImageUrlMobile: logoImageUrlMobile,
	        logoLink: logoLink,
	        closeMenuLabel: closeMenuLabel,
	        openQuickSearchFormBtnAriaLabel: openQuickSearchFormBtnAriaLabel,
	        closeQuickSearchFormBtnAriaLabel: closeQuickSearchFormBtnAriaLabel
	    });
	};
	
	HeaderPropConverter.propTypes = {
	    header: _propTypes2.default.object.isRequired,
	    languages: _propTypes2.default.array.isRequired,
	    searchLink: _propTypes2.default.string.isRequired,
	    startpageLinkLabel: _propTypes2.default.string.isRequired,
	    searchLabel: _propTypes2.default.string.isRequired,
	    inputPlaceholder: _propTypes2.default.string,
	    logoImageUrl: _propTypes2.default.string,
	    logoImageUrlMobile: _propTypes2.default.string,
	    logoLink: _propTypes2.default.string.isRequired,
	    closeMenuLabel: _propTypes2.default.string.isRequired,
	    openQuickSearchFormBtnAriaLabel: _propTypes2.default.string.isRequired,
	    closeQuickSearchFormBtnAriaLabel: _propTypes2.default.string.isRequired
	};
	
	exports.default = HeaderPropConverter;
	module.exports = exports['default'];

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(38);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _HighlightedProjectBlockModule = __webpack_require__(776);
	
	var _HighlightedProjectBlockModule2 = _interopRequireDefault(_HighlightedProjectBlockModule);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _utils = __webpack_require__(16);
	
	var _OnScreen = __webpack_require__(31);
	
	var _OnScreen2 = _interopRequireDefault(_OnScreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HighlightedProjectBlock = function (_React$Component) {
	    _inherits(HighlightedProjectBlock, _React$Component);
	
	    function HighlightedProjectBlock() {
	        _classCallCheck(this, HighlightedProjectBlock);
	
	        return _possibleConstructorReturn(this, (HighlightedProjectBlock.__proto__ || Object.getPrototypeOf(HighlightedProjectBlock)).apply(this, arguments));
	    }
	
	    _createClass(HighlightedProjectBlock, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                onScreen = _props.onScreen,
	                useExternalUrl = _props.useExternalUrl,
	                blockId = _props.blockId,
	                inList = _props.inList,
	                heading = _props.heading,
	                view = _props.view,
	                project = _props.project;
	
	
	            var Component = "a";
	            if (useExternalUrl) {
	                Component = "div";
	            }
	
	            return heading || project ? _react2.default.createElement(
	                "div",
	                {
	                    className: (0, _classnames2.default)(_HighlightedProjectBlockModule2.default.block, _defineProperty({}, _HighlightedProjectBlockModule2.default.inList, inList)),
	                    "data-block": blockId
	                },
	                heading && !inList && _react2.default.createElement(
	                    "h2",
	                    { className: "block-title-large" },
	                    heading
	                ),
	                project && _react2.default.createElement(
	                    Component,
	                    {
	                        className: (0, _classnames2.default)(_HighlightedProjectBlockModule2.default.imageArea, _defineProperty({}, _HighlightedProjectBlockModule2.default["is-on-screen"], onScreen)),
	                        "data-block": blockId,
	                        href: Component === "a" && project.link
	                    },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _HighlightedProjectBlockModule2.default.inner },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _HighlightedProjectBlockModule2.default.imageWrapper },
	                            _react2.default.createElement(_Media.Media, {
	                                className: _HighlightedProjectBlockModule2.default.image,
	                                image: project.backgroundImage,
	                                alt: project.backgroundImageAlt ? project.backgroundImageAlt : ""
	                            }),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _HighlightedProjectBlockModule2.default.textContent },
	                                project.heading && _react2.default.createElement(
	                                    "h2",
	                                    { className: _HighlightedProjectBlockModule2.default.projectHeading },
	                                    project.heading
	                                ),
	                                view === "default" && project.text && _react2.default.createElement(
	                                    "p",
	                                    { className: _HighlightedProjectBlockModule2.default.text },
	                                    project.text
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _HighlightedProjectBlockModule2.default.button },
	                                    useExternalUrl && project.externalUrl && _react2.default.createElement(
	                                        _Button2.default,
	                                        { href: project.externalUrl },
	                                        (0, _utils.presentDomain)(project.externalUrl),
	                                        _react2.default.createElement(_Icon2.default, {
	                                            className: (0, _classnames2.default)(_HighlightedProjectBlockModule2.default.icon, _HighlightedProjectBlockModule2.default.darkgray),
	                                            icon: "share"
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            ) : null;
	        }
	    }]);
	
	    return HighlightedProjectBlock;
	}(_react2.default.Component);
	
	HighlightedProjectBlock.propTypes = {
	    onScreen: _propTypes2.default.bool,
	    blockId: _propTypes2.default.number,
	    inList: _propTypes2.default.bool,
	    heading: _propTypes2.default.string,
	    useExternalUrl: _propTypes2.default.bool.isRequired,
	    view: _propTypes2.default.oneOf(["default", "grid", "list"]).isRequired,
	    project: _propTypes2.default.shape({
	        text: _propTypes2.default.string,
	        externalUrl: _propTypes2.default.string,
	        link: _propTypes2.default.string,
	        heading: _propTypes2.default.string,
	        backgroundImage: _Media.Media && _Media.Media.propTypes.image,
	        backgroundImageAlt: _propTypes2.default.string
	    })
	};
	HighlightedProjectBlock.defaultProps = {
	    useExternalUrl: false,
	    view: "default"
	};
	exports.default = (0, _OnScreen2.default)(HighlightedProjectBlock);
	module.exports = exports["default"];

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var req = __webpack_require__(341);
	
	var icons = {};
	
	req.keys().forEach(function (filename) {
	    var id = filename.replace('./', '').replace('.svg', '');
	    icons[id] = req(filename);
	});
	
	var Icons = function Icons() {
	    return _react2.default.createElement(
	        'svg',
	        { 'data-svg': 'sprite', style: { display: 'none' }, xmlns: 'http://www.w3.org/2000/svg' },
	        Object.keys(icons).map(function (icon) {
	            var Component = icons[icon];
	            return _react2.default.createElement(Component, { className: 'symbol-icon', key: icon, id: 'icon-' + icon });
	        })
	    );
	};
	
	exports.default = Icons;
	module.exports = exports['default'];

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Icons = __webpack_require__(483);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Icons2.default;
	module.exports = exports['default'];

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ImageBlockModule = __webpack_require__(777);
	
	var _ImageBlockModule2 = _interopRequireDefault(_ImageBlockModule);
	
	var _SliderListBlock = __webpack_require__(243);
	
	var _SliderListBlock2 = _interopRequireDefault(_SliderListBlock);
	
	var _Image = __webpack_require__(123);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ImageItem = function ImageItem(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Image2.default, _extends({}, props, { image: props })),
	        props.text && _react2.default.createElement(
	            'div',
	            { className: _ImageBlockModule2.default.caption },
	            props.text
	        )
	    );
	};
	ImageItem.propTypes = {
	    image: _propTypes2.default.string,
	    text: _propTypes2.default.string,
	    altText: _propTypes2.default.string
	};
	ImageItem.defaultProps = {
	    images: []
	};
	
	var ImageBlock = function ImageBlock(_ref) {
	    var images = _ref.images,
	        rest = _objectWithoutProperties(_ref, ['images']);
	
	    return (
	        // Note: This component is designed to display images in a carousel, if you need to use a standard Image block, consider using NewImageBlock
	        _react2.default.createElement(_SliderListBlock2.default, _extends({
	            data: images
	        }, rest, {
	            Component: ImageItem,
	            className: _ImageBlockModule2.default.block,
	            selector: 'img[data-active="true"]'
	        }))
	    );
	};
	
	ImageBlock.propTypes = {
	    images: _propTypes2.default.array,
	    size: _propTypes2.default.oneOf(['large', 'small']).isRequired
	};
	ImageBlock.defaultProps = {
	    images: [],
	    size: 'large'
	};
	
	exports.default = ImageBlock;
	module.exports = exports['default'];

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Image = __webpack_require__(77);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageIcon = function ImageIcon(_ref) {
	    var className = _ref.className,
	        url = _ref.url,
	        altText = _ref.altText;
	    return _react2.default.createElement('img', { className: className, src: url, alt: altText });
	};
	
	ImageIcon.propTypes = Object.assign({}, _Image2.default.propTypes, {
	    className: _propTypes2.default.string
	});
	
	exports.default = ImageIcon;
	module.exports = exports['default'];

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ImageModule = __webpack_require__(778);
	
	var _ImageModule2 = _interopRequireDefault(_ImageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Image = function (_React$Component) {
	    _inherits(Image, _React$Component);
	
	    function Image() {
	        _classCallCheck(this, Image);
	
	        return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
	    }
	
	    _createClass(Image, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                active = _props.active,
	                image = _props.image,
	                onLoad = _props.onLoad;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _ImageModule2.default.image },
	                _react2.default.createElement('img', {
	                    alt: image.altText ? image.altText : '',
	                    'data-active': active,
	                    onLoad: onLoad,
	                    src: image.image
	                })
	            );
	        }
	    }]);
	
	    return Image;
	}(_react2.default.Component);
	
	Image.propTypes = {
	    active: _propTypes2.default.bool.isRequired,
	    image: _propTypes2.default.shape({
	        image: _propTypes2.default.string.isRequired,
	        altText: _propTypes2.default.string.isRequired
	    }),
	    onLoad: _propTypes2.default.func
	};
	exports.default = Image;
	module.exports = exports['default'];

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(16);
	
	var _InfographicListBlockModule = __webpack_require__(779);
	
	var _InfographicListBlockModule2 = _interopRequireDefault(_InfographicListBlockModule);
	
	var _Infographic = __webpack_require__(230);
	
	var _Infographic2 = _interopRequireDefault(_Infographic);
	
	var _themes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InfographicListBlock = function InfographicListBlock(_ref) {
	    var heading = _ref.heading,
	        graphics = _ref.graphics,
	        blockId = _ref.blockId,
	        contentType = _ref.contentType,
	        theme = _ref.theme;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_InfographicListBlockModule2.default.block, (0, _themes.getThemeClassNames)(_InfographicListBlockModule2.default, theme)), 'data-block': blockId },
	        heading && _react2.default.createElement(
	            'h2',
	            _extends({ className: (0, _classnames2.default)("block-title-large", _InfographicListBlockModule2.default.heading) }, (0, _utils.onPageEditing)("Heading")),
	            heading
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _InfographicListBlockModule2.default.wrapper },
	            _react2.default.createElement(
	                'ul',
	                _extends({
	                    className: _InfographicListBlockModule2.default.list
	                }, (0, _utils.onPageEditing)(contentType === "InfographicListBlock" && "Graphics")),
	                graphics && graphics.map(function (fact, index) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: index },
	                        _react2.default.createElement(_Infographic2.default, _extends({}, fact, { theme: theme }))
	                    );
	                })
	            )
	        )
	    );
	};
	
	InfographicListBlock.propTypes = {
	    heading: _propTypes2.default.string,
	    graphics: _propTypes2.default.array,
	    blockId: _propTypes2.default.number,
	    contentType: _propTypes2.default.string,
	    theme: _propTypes2.default.oneOf(Object.keys(_themes.THEMES).map(function (s) {
	        return _themes.THEMES[s];
	    }))
	};
	
	InfographicListBlock.defaultProps = {
	    graphics: [],
	    theme: _themes.THEMES.zebra
	};
	
	exports.default = InfographicListBlock;
	module.exports = exports['default'];

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(16);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ImageIcon = __webpack_require__(59);
	
	var _ImageIcon2 = _interopRequireDefault(_ImageIcon);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _OnScreen = __webpack_require__(31);
	
	var _OnScreen2 = _interopRequireDefault(_OnScreen);
	
	var _InfographicModule = __webpack_require__(780);
	
	var _InfographicModule2 = _interopRequireDefault(_InfographicModule);
	
	var _themes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Infographic = function (_React$Component) {
	    _inherits(Infographic, _React$Component);
	
	    function Infographic() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Infographic);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Infographic.__proto__ || Object.getPrototypeOf(Infographic)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            animate: false
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Infographic, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (typeof window !== 'undefined' && window.matchMedia("(min-width: 1191px)").matches) {
	                this.setState({ animate: true });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _cn;
	
	            var overlaySize = 300;
	            var _props = this.props,
	                number = _props.number,
	                description = _props.description,
	                icon = _props.icon,
	                iconNew = _props.iconNew,
	                unit = _props.unit,
	                link = _props.link,
	                linkText = _props.linkText,
	                linkStyle = _props.linkStyle,
	                onScreen = _props.onScreen,
	                theme = _props.theme;
	
	            var finalLinkStyle = linkStyle ? linkStyle : { primary: true };
	
	            var btnStyle = _extends({}, finalLinkStyle, {
	                gray: theme === _themes.THEMES.yellow,
	                light: theme === _themes.THEMES.darkgray
	            });
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)(_InfographicModule2.default.card, (0, _themes.getThemeClassNames)(_InfographicModule2.default, theme), (_cn = {}, _defineProperty(_cn, _InfographicModule2.default['is-visible'], onScreen), _defineProperty(_cn, _InfographicModule2.default['has-animation'], this.state.animate), _cn))
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: _InfographicModule2.default.circle },
	                    this.state.animate && _react2.default.createElement(
	                        'svg',
	                        {
	                            className: (0, _classnames2.default)(_InfographicModule2.default["circle-overlay"], _defineProperty({}, _InfographicModule2.default["circle-overlay-hidden"], onScreen)),
	                            width: overlaySize,
	                            height: overlaySize,
	                            viewBox: '0 0 ' + overlaySize + ' ' + overlaySize,
	                            style: { enableBackground: 'new 0 0 ' + overlaySize + ' ' + overlaySize },
	                            x: '0px', y: '0px', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', xmlSpace: 'preserve'
	                        },
	                        _react2.default.createElement('circle', {
	                            r: overlaySize / 2,
	                            cx: overlaySize / 2,
	                            cy: overlaySize / 2,
	                            strokeDasharray: Math.PI * overlaySize,
	                            strokeDashoffset: onScreen ? -Math.PI * overlaySize : 0
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _InfographicModule2.default.content },
	                        _react2.default.createElement(
	                            'p',
	                            _extends({}, (0, _utils.onPageEditing)('Number'), {
	                                className: (0, _classnames2.default)(_InfographicModule2.default.number, _defineProperty({}, _InfographicModule2.default.small, number && number.length >= 4))
	                            }),
	                            number
	                        ),
	                        (unit || iconNew || icon) && _react2.default.createElement(
	                            'p',
	                            { className: _InfographicModule2.default.unit },
	                            iconNew ? _react2.default.createElement(_ImageIcon2.default, _extends({
	                                className: (0, _classnames2.default)(_InfographicModule2.default.icon, _defineProperty({}, _InfographicModule2.default['icon-number'], !!number))
	                            }, iconNew)) : icon ? _react2.default.createElement(_Icon2.default, {
	                                className: (0, _classnames2.default)(_InfographicModule2.default.icon, _defineProperty({}, _InfographicModule2.default['icon-number'], !!number)),
	                                icon: icon
	                            }) : null,
	                            unit && _react2.default.createElement(
	                                'span',
	                                _extends({}, (0, _utils.onPageEditing)('Unit'), { className: _InfographicModule2.default["unit-text"] }),
	                                unit
	                            )
	                        )
	                    )
	                ),
	                description && _react2.default.createElement(
	                    'h3',
	                    _extends({ className: _InfographicModule2.default.description }, (0, _utils.onPageEditing)('Description')),
	                    description
	                ),
	                link && _react2.default.createElement(
	                    _Button2.default,
	                    _extends({}, btnStyle, { className: _InfographicModule2.default.button, title: linkText, href: link }, (0, _utils.onPageEditing)('Link')),
	                    _react2.default.createElement(
	                        'span',
	                        (0, _utils.onPageEditing)('LinkText'),
	                        linkText
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Infographic;
	}(_react2.default.Component);
	
	Infographic.propTypes = {
	    number: _propTypes2.default.string,
	    description: _propTypes2.default.string,
	    icon: _propTypes2.default.string,
	    iconNew: _propTypes2.default.shape(_ImageIcon2.default.propTypes),
	    unit: _propTypes2.default.string,
	    link: _propTypes2.default.string,
	    linkText: _propTypes2.default.string,
	    linkStyle: _propTypes2.default.object,
	    onScreen: _propTypes2.default.bool,
	    theme: _propTypes2.default.oneOf(Object.keys(_themes.THEMES).map(function (s) {
	        return _themes.THEMES[s];
	    }))
	};
	Infographic.defaultProps = {
	    linkStyle: {
	        secondary: true
	    }
	};
	exports.default = (0, _OnScreen2.default)(Infographic);
	module.exports = exports['default'];

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ImageIcon = __webpack_require__(59);
	
	var _ImageIcon2 = _interopRequireDefault(_ImageIcon);
	
	var _InfographicsCardModule = __webpack_require__(781);
	
	var _InfographicsCardModule2 = _interopRequireDefault(_InfographicsCardModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfographicsCard = function (_React$PureComponent) {
	    _inherits(InfographicsCard, _React$PureComponent);
	
	    function InfographicsCard() {
	        _classCallCheck(this, InfographicsCard);
	
	        return _possibleConstructorReturn(this, (InfographicsCard.__proto__ || Object.getPrototypeOf(InfographicsCard)).apply(this, arguments));
	    }
	
	    _createClass(InfographicsCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                number = _props.number,
	                unit = _props.unit,
	                description = _props.description,
	                icon = _props.icon,
	                iconNew = _props.iconNew;
	
	
	            var numberFormatted = number && _react2.default.createElement(
	                'strong',
	                null,
	                number
	            );
	            var unitFormatted = unit && _react2.default.createElement(
	                'strong',
	                null,
	                unit
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { className: _InfographicsCardModule2.default.card },
	                iconNew ? _react2.default.createElement(_ImageIcon2.default, iconNew) : icon ? _react2.default.createElement(_Icon2.default, { icon: icon }) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: _InfographicsCardModule2.default.text },
	                    numberFormatted,
	                    unitFormatted,
	                    ' ' + description
	                )
	            );
	        }
	    }]);
	
	    return InfographicsCard;
	}(_react2.default.PureComponent);
	
	InfographicsCard.propTypes = {
	    "number": _propTypes2.default.string.isRequired,
	    "unit": _propTypes2.default.string,
	    "description": _propTypes2.default.string,
	    "icon": _propTypes2.default.string.isRequired,
	    "iconNew": _propTypes2.default.string.isRequired
	};
	exports.default = InfographicsCard;
	module.exports = exports['default'];

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfographicsCard = exports.default = undefined;
	
	var _InfographicsCard2 = __webpack_require__(490);
	
	var _InfographicsCard3 = _interopRequireDefault(_InfographicsCard2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InfographicsCard3.default;
	exports.InfographicsCard = _InfographicsCard3.default;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(703);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var textTypes = ['text', 'password', 'email'];
	var choiceTypes = ['radio', 'checkbox'];
	
	var Input = function Input(_ref) {
	    var _cn;
	
	    var className = _ref.className,
	        choices = _ref.choices,
	        disabled = _ref.disabled,
	        error = _ref.error,
	        focus = _ref.focus,
	        id = _ref.id,
	        label = _ref.label,
	        name = _ref.name,
	        style = _ref.style,
	        type = _ref.type,
	        value = _ref.value,
	        placeholder = _ref.placeholder,
	        onKeyDown = _ref.onKeyDown,
	        onChange = _ref.onChange,
	        _ref$useValueAttr = _ref.useValueAttr,
	        useValueAttr = _ref$useValueAttr === undefined ? false : _ref$useValueAttr;
	
	    var isTextInput = textTypes.indexOf(type) >= 0;
	    var isChoiceInput = choiceTypes.indexOf(type) >= 0;
	
	    return _react2.default.createElement(
	        'div',
	        {
	            className: (0, _classnames2.default)('Form__Element', className, (_cn = {}, _defineProperty(_cn, 'input-disabled', disabled), _defineProperty(_cn, 'FormTextBox', isTextInput), _defineProperty(_cn, 'FormChoice', isChoiceInput), _defineProperty(_cn, 'ValidationFail', error), _cn)),
	            style: style
	        },
	        label && isTextInput && _react2.default.createElement(
	            'label',
	            { className: 'Form__Element__Caption', htmlFor: id },
	            label
	        ),
	        label && isChoiceInput && _react2.default.createElement(
	            'span',
	            { className: 'Form__Element__Caption' },
	            label
	        ),
	        isTextInput && _react2.default.createElement('input', _extends({}, useValueAttr ? { value: value } : { defaultValue: value }, {
	            disabled: disabled,
	            className: (0, _classnames2.default)('FormTextbox__Input', _defineProperty({}, 'focus', focus)),
	            id: id,
	            name: name,
	            onChange: onChange,
	            onKeyDown: onKeyDown,
	            placeholder: placeholder,
	            type: type
	        })),
	        isChoiceInput && choices && choices.map(function (choice) {
	            return _react2.default.createElement(
	                'label',
	                { key: choice.value },
	                _react2.default.createElement('input', {
	                    className: (0, _classnames2.default)('FormChoice__input', {
	                        'FormChoice__input--Checkbox': type === 'checkbox',
	                        'FormChoice__input--Radio': type === 'radio'
	                    }),
	                    name: name,
	                    type: type,
	                    value: choice.value
	                }),
	                choice.label
	            );
	        }),
	        error && _react2.default.createElement(
	            'span',
	            { className: 'Form__Element__ValidationError' },
	            _react2.default.createElement(
	                'svg',
	                { width: '19px', height: '19px', viewBox: '0 0 19 19', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    'Warning'
	                ),
	                _react2.default.createElement('path', { d: 'M9.5,19 C4.2619375,19 0,14.7386563 0,9.5 C0,4.2619375 4.2619375,0 9.5,0 C14.7380625,0 19,4.2619375 19,9.5 C19,14.7386563 14.7380625,19 9.5,19 Z M9.5,1.1875 C4.91625,1.1875 1.1875,4.91625 1.1875,9.5 C1.1875,14.0831563 4.91625,17.8125 9.5,17.8125 C14.08375,17.8125 17.8125,14.0831563 17.8125,9.5 C17.8125,4.91625 14.08375,1.1875 9.5,1.1875 Z M9.5,14.84375 C9.345625,14.84375 9.19065625,14.7784375 9.0784375,14.6715625 C8.97096875,14.55875 8.90625,14.404375 8.90625,14.25 C8.90625,14.095625 8.97096875,13.94125 9.0784375,13.8284375 C9.298125,13.60875 9.701875,13.60875 9.9215625,13.8284375 C10.0284375,13.94125 10.09375,14.095625 10.09375,14.25 C10.09375,14.404375 10.0284375,14.55875 9.9215625,14.6715625 C9.80815625,14.7784375 9.654375,14.84375 9.5,14.84375 Z M9.5,12.46875 C9.17165625,12.46875 8.90625,12.2033438 8.90625,11.875 L8.90625,4.75 C8.90625,4.42165625 9.17165625,4.15684375 9.5,4.15684375 C9.82834375,4.15684375 10.09375,4.42165625 10.09375,4.75 L10.09375,11.875 C10.09375,12.2033438 9.82834375,12.46875 9.5,12.46875 Z', id: 'Shape' })
	            ),
	            error
	        )
	    );
	};
	
	Input.propTypes = {
	    className: _propTypes2.default.string,
	    choices: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        label: _propTypes2.default.string,
	        value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	    })),
	    disabled: _propTypes2.default.bool,
	    name: _propTypes2.default.string,
	    id: _propTypes2.default.string,
	    focus: _propTypes2.default.bool,
	    label: _propTypes2.default.string,
	    type: _propTypes2.default.oneOf(textTypes.concat(choiceTypes)).isRequired,
	    value: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    error: _propTypes2.default.string,
	    placeholder: _propTypes2.default.string,
	    onKeyDown: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    useValueAttr: _propTypes2.default.bool
	};
	
	Input.propTypesMeta = {
	    useValueAttr: 'exclude'
	};
	
	exports.default = Input;
	module.exports = exports['default'];

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Input = __webpack_require__(492);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Input2.default;
	module.exports = exports['default'];

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BoardMember = __webpack_require__(217);
	
	var _BoardMember2 = _interopRequireDefault(_BoardMember);
	
	__webpack_require__(704);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvestorBoardMembersBlock = function InvestorBoardMembersBlock(_ref) {
	    var heading = _ref.heading,
	        items = _ref.items,
	        anchorId = _ref.anchorId,
	        lang = _ref.lang;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'investor-board-members-block', id: anchorId },
	        _react2.default.createElement(
	            'div',
	            { className: 'investor-board-members-block__container' },
	            heading && _react2.default.createElement(
	                'h2',
	                { className: 'investor-board-members-block__heading' },
	                heading
	            ),
	            items && items.length > 0 ? _react2.default.createElement(
	                'ul',
	                { className: 'investor-board-members-block__list' },
	                items.map(function (item, key) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: key, className: 'investor-board-members-block__item' },
	                        _react2.default.createElement(_BoardMember2.default, _extends({}, item, {
	                            // BE: Recommended BoardMember image size: 884x628px
	                            downloadImageLabel: lang.downloadImageLabel,
	                            className: 'board-member_in-investor-board'
	                        }))
	                    );
	                })
	            ) : null
	        )
	    );
	};
	
	InvestorBoardMembersBlock.propTypes = {
	    heading: _propTypes2.default.string,
	    anchorId: _propTypes2.default.string,
	    items: _propTypes2.default.arrayOf(_propTypes2.default.shape(_BoardMember2.default.propTypes)),
	    lang: _propTypes2.default.shape({
	        downloadImageLabel: _propTypes2.default.string.isRequired
	    }).isRequired
	};
	
	exports.default = InvestorBoardMembersBlock;
	module.exports = exports['default'];

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _InvestorBoardMembersBlock = __webpack_require__(494);
	
	var _InvestorBoardMembersBlock2 = _interopRequireDefault(_InvestorBoardMembersBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InvestorBoardMembersBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InvestorReport = __webpack_require__(231);
	
	var _InvestorReport2 = _interopRequireDefault(_InvestorReport);
	
	__webpack_require__(705);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvestorDoubleReportBlock = function InvestorDoubleReportBlock(_ref) {
	    var heading = _ref.heading,
	        reports = _ref.reports,
	        anchorId = _ref.anchorId;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'investor-double-report-block', id: anchorId },
	        _react2.default.createElement(
	            'div',
	            { className: 'investor-double-report-block__container' },
	            heading && _react2.default.createElement(
	                'h2',
	                { className: 'investor-double-report-block__heading' },
	                heading
	            ),
	            reports && reports.length > 0 ? _react2.default.createElement(
	                'div',
	                { className: 'investor-double-report-block__reports' },
	                reports.map(function (report, index) {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'investor-double-report-block__item', key: index },
	                        _react2.default.createElement(_InvestorReport2.default, report)
	                    );
	                })
	            ) : null
	        )
	    );
	};
	
	InvestorDoubleReportBlock.propTypes = {
	    heading: _propTypes2.default.string,
	    reports: _propTypes2.default.arrayOf(_propTypes2.default.shape(_InvestorReport2.default.propTypes)),
	    anchorId: _propTypes2.default.string
	};
	
	exports.default = InvestorDoubleReportBlock;
	module.exports = exports['default'];

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _InvestorDoubleReportBlock = __webpack_require__(496);
	
	var _InvestorDoubleReportBlock2 = _interopRequireDefault(_InvestorDoubleReportBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InvestorDoubleReportBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InvestorFinancialEvent = __webpack_require__(501);
	
	var _InvestorFinancialEvent2 = _interopRequireDefault(_InvestorFinancialEvent);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(706);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvestorFinancialCalendarBlock = function InvestorFinancialCalendarBlock(_ref) {
	    var heading = _ref.heading,
	        events = _ref.events,
	        anchorId = _ref.anchorId;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'investor-financial-calendar-block', id: anchorId },
	        _react2.default.createElement(
	            'div',
	            { className: 'investor-financial-calendar-block__container' },
	            heading && _react2.default.createElement(
	                'h2',
	                { className: 'investor-financial-calendar-block__heading' },
	                heading
	            ),
	            events && events.length > 0 ? _react2.default.createElement(
	                'div',
	                { className: 'investor-financial-calendar-block__events' },
	                events.map(function (event, index) {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'investor-financial-calendar-block__event-item', key: index },
	                        _react2.default.createElement(_InvestorFinancialEvent2.default, _extends({}, event, { isHighlighted: index === 0 })),
	                        index !== events.length - 1 && _react2.default.createElement(
	                            'div',
	                            { className: 'investor-financial-calendar-block__event-item-arrow-holder' },
	                            _react2.default.createElement(_Icon2.default, { icon: 'arrow-line-long-right', className: 'investor-financial-calendar-block__event-item-arrow' })
	                        )
	                    );
	                })
	            ) : null
	        )
	    );
	};
	
	InvestorFinancialCalendarBlock.propTypes = {
	    heading: _propTypes2.default.string,
	    events: _propTypes2.default.arrayOf(_propTypes2.default.shape(_InvestorFinancialEvent2.default.propTypes)),
	    anchorId: _propTypes2.default.string
	};
	
	exports.default = InvestorFinancialCalendarBlock;
	module.exports = exports['default'];

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _InvestorFinancialCalendarBlock = __webpack_require__(498);
	
	var _InvestorFinancialCalendarBlock2 = _interopRequireDefault(_InvestorFinancialCalendarBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InvestorFinancialCalendarBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(707);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvestorFinancialEvent = function InvestorFinancialEvent(_ref) {
	    var title = _ref.title,
	        day = _ref.day,
	        month = _ref.month,
	        date = _ref.date,
	        time = _ref.time,
	        metaDate = _ref.metaDate,
	        metaTime = _ref.metaTime,
	        isHighlighted = _ref.isHighlighted;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'investor-financial-event' },
	        _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)("investor-financial-event__date-box", {
	                    "investor-financial-event__date-box_highlighted": isHighlighted
	                }) },
	            _react2.default.createElement(
	                'span',
	                { className: 'investor-financial-event__day' },
	                day
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: 'investor-financial-event__month' },
	                month
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'investor-financial-event__info' },
	            title && _react2.default.createElement(
	                'div',
	                { className: 'investor-financial-event__title-holder' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'investor-financial-event__title' },
	                    title
	                )
	            ),
	            _react2.default.createElement(
	                'time',
	                { dateTime: metaDate, className: 'investor-financial-event__date' },
	                date
	            ),
	            _react2.default.createElement(
	                'time',
	                { dateTime: metaTime, className: 'investor-financial-event__date' },
	                time
	            )
	        )
	    );
	};
	
	InvestorFinancialEvent.propTypes = {
	    title: _propTypes2.default.string,
	    day: _propTypes2.default.string,
	    month: _propTypes2.default.string,
	    date: _propTypes2.default.string,
	    time: _propTypes2.default.string,
	    metaDate: _propTypes2.default.string,
	    metaTime: _propTypes2.default.string,
	    isHighlighted: _propTypes2.default.bool // FE only
	};
	
	exports.default = InvestorFinancialEvent;
	module.exports = exports['default'];

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _InvestorFinancialEvent = __webpack_require__(500);
	
	var _InvestorFinancialEvent2 = _interopRequireDefault(_InvestorFinancialEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InvestorFinancialEvent2.default;
	module.exports = exports['default'];

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InvestorLogo = __webpack_require__(506);
	
	var _InvestorLogo2 = _interopRequireDefault(_InvestorLogo);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _InvestorMainMenu = __webpack_require__(510);
	
	var _InvestorMainMenu2 = _interopRequireDefault(_InvestorMainMenu);
	
	var _InvestorMainMenuMobile = __webpack_require__(508);
	
	var _InvestorMainMenuMobile2 = _interopRequireDefault(_InvestorMainMenuMobile);
	
	var _InvestorSecondaryMenu = __webpack_require__(515);
	
	var _InvestorSecondaryMenu2 = _interopRequireDefault(_InvestorSecondaryMenu);
	
	var _LanguageSelector = __webpack_require__(232);
	
	var _LanguageSelector2 = _interopRequireDefault(_LanguageSelector);
	
	var _SearchForm = __webpack_require__(242);
	
	var _SearchForm2 = _interopRequireDefault(_SearchForm);
	
	var _InvestorLink = __webpack_require__(125);
	
	var _InvestorLink2 = _interopRequireDefault(_InvestorLink);
	
	var _Link = __webpack_require__(26);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LanguageLink = __webpack_require__(537);
	
	var _LanguageLink2 = _interopRequireDefault(_LanguageLink);
	
	var _logo = __webpack_require__(83);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(708);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SCROLL_THRESHOLD = 70;
	var MOBILE_MENU_OPENED_CLASSNAME = "investor-page-mobile-menu-opened";
	
	var InvestorHeader = function (_React$PureComponent) {
	    _inherits(InvestorHeader, _React$PureComponent);
	
	    function InvestorHeader(props) {
	        _classCallCheck(this, InvestorHeader);
	
	        var _this = _possibleConstructorReturn(this, (InvestorHeader.__proto__ || Object.getPrototypeOf(InvestorHeader)).call(this, props));
	
	        _this.state = {
	            isHeaderHidden: false,
	            isMobileMenuOpened: false,
	            isActive: null,
	            disableScrollBehavior: false
	        };
	
	        _this.handleScroll = function () {
	            if (_this.state.disableScrollBehavior) {
	                return;
	            }
	
	            var isHeaderHidden = window.scrollY > window.lastScrollY && window.scrollY > SCROLL_THRESHOLD && !_this.state.isMobileMenuOpened;
	
	            if (_this.state.isHeaderHidden !== isHeaderHidden) {
	                _this.setState({ isHeaderHidden: isHeaderHidden });
	            }
	
	            _this.bodyElement.classList.toggle("investor-header-hidden", isHeaderHidden);
	
	            window.lastScrollY = window.scrollY;
	        };
	
	        _this.handleKeyDown = function (event) {
	            if (event.key === "Escape") {
	                _this.setState({ isActive: null });
	            }
	        };
	
	        _this.handleSearchButtonClick = function (id) {
	            _this.setState({
	                isActive: _this.state.isActive === id ? null : id
	            });
	        };
	
	        _this.handleCurtainClick = function () {
	            _this.setState({ isActive: null });
	        };
	
	        _this.handleToggleMobileMenu = function () {
	            _this.setState(function (prevState) {
	                var isMobileMenuOpened = !prevState.isMobileMenuOpened;
	                _this.bodyElement.classList.toggle(MOBILE_MENU_OPENED_CLASSNAME, isMobileMenuOpened);
	
	                return { isMobileMenuOpened: isMobileMenuOpened };
	            });
	        };
	
	        _this.allowHeaderHidingOnScrollHandler = function (allowed) {
	            _this.setState({ disableScrollBehavior: !allowed });
	        };
	
	        return _this;
	    }
	
	    _createClass(InvestorHeader, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.bodyElement = document.body;
	            window.addEventListener("scroll", this.handleScroll);
	            window.addEventListener("keydown", this.handleKeyDown);
	
	            window.lastScrollY = 0;
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            window.removeEventListener("scroll", this.handleScroll);
	            window.removeEventListener("keydown", this.handleKeyDown);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                logoLink = _props.logoLink,
	                logoAltText = _props.logoAltText,
	                investorLogo = _props.investorLogo,
	                mainMenu = _props.mainMenu,
	                languages = _props.languages,
	                quickSearch = _props.quickSearch,
	                lang = _props.lang,
	                backToMainSite = _props.backToMainSite,
	                pageHeading = _props.pageHeading,
	                secondaryMenu = _props.secondaryMenu;
	            var _state = this.state,
	                isHeaderHidden = _state.isHeaderHidden,
	                isMobileMenuOpened = _state.isMobileMenuOpened,
	                isActive = _state.isActive;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: "investor-header" },
	                _react2.default.createElement(
	                    "header",
	                    {
	                        className: (0, _classnames2.default)("investor-header__header-element", {
	                            "investor-header__header-element_hidden": isHeaderHidden,
	                            "investor-header__header-element_mobile-menu-opened": isMobileMenuOpened,
	                            "investor-header__header-element_active": isActive
	                        })
	                    },
	                    isActive !== null && _react2.default.createElement("div", {
	                        className: "investor-header__curtain",
	                        onClick: this.handleCurtainClick
	                    }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "investor-header__bg-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "investor-header__main-content" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "investor-header__logos" },
	                                _react2.default.createElement(_InvestorLogo2.default, {
	                                    url: logoLink,
	                                    image: {
	                                        url: _logo2.default,
	                                        altText: logoAltText
	                                    }
	                                }),
	                                investorLogo && _react2.default.createElement(
	                                    "a",
	                                    {
	                                        className: "investor-header__investor-logo",
	                                        href: investorLogo.url,
	                                        target: investorLogo.openInNewWindow ? "_blank" : null
	                                    },
	                                    investorLogo.linkText
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "button",
	                                {
	                                    className: "investor-header__mobile-menu-toggle",
	                                    onClick: this.handleToggleMobileMenu
	                                },
	                                _react2.default.createElement(_Icon2.default, {
	                                    icon: "hamburger",
	                                    className: "investor-header__mobile-menu-toggle-icon"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "investor-header__actions-area" },
	                                backToMainSite && _react2.default.createElement(
	                                    "div",
	                                    { className: "investor-header__back-navigation-link-holder investor-header__back-navigation-link-holder_mobile" },
	                                    _react2.default.createElement(_InvestorLink2.default, _extends({}, backToMainSite, {
	                                        leftIconName: "arrow-line-left",
	                                        className: "investor-header__back-navigation-link investor-header__back-navigation-link_light"
	                                    }))
	                                ),
	                                mainMenu && _react2.default.createElement(_InvestorMainMenu2.default, _extends({}, mainMenu, {
	                                    className: "investor-header__main-menu",
	                                    onLinkClick: this.handleToggleMobileMenu
	                                })),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "investor-header__actions" },
	                                    languages && languages.length > 0 ? _react2.default.createElement(_LanguageSelector2.default, {
	                                        languages: languages,
	                                        isActive: isActive,
	                                        className: "investor-header__language-selector",
	                                        handleSelectorClick: function handleSelectorClick() {
	                                            return _this2.handleSearchButtonClick("language");
	                                        }
	                                    }) : null,
	                                    quickSearch && _react2.default.createElement(_SearchForm2.default, {
	                                        inputPlaceholder: lang.searchHint,
	                                        isActive: isActive,
	                                        searchLabel: lang.searchLabel,
	                                        searchLink: quickSearch.searchPageUrl,
	                                        openQuickSearchFormBtnAriaLabel: lang.openQuickSearchFormBtnAriaLabel,
	                                        closeQuickSearchFormBtnAriaLabel: lang.closeQuickSearchFormBtnAriaLabel,
	                                        className: "investor-header__search-form",
	                                        searchClassName: "investor-header__search",
	                                        handleSearchButtonClick: function handleSearchButtonClick() {
	                                            return _this2.handleSearchButtonClick("search");
	                                        }
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    secondaryMenu && _react2.default.createElement(_InvestorSecondaryMenu2.default, _extends({}, secondaryMenu, { isHeaderHidden: isHeaderHidden, allowHeaderHidingOnScroll: this.allowHeaderHidingOnScrollHandler }))
	                ),
	                backToMainSite && !secondaryMenu && _react2.default.createElement(
	                    "div",
	                    { className: "investor-header__back-navigation-link-holder" },
	                    _react2.default.createElement(_InvestorLink2.default, _extends({}, backToMainSite, {
	                        leftIconName: "arrow-line-left",
	                        className: "investor-header__back-navigation-link"
	                    }))
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "investor-header__page-info" },
	                    pageHeading && _react2.default.createElement(
	                        "h1",
	                        { className: "investor-header__heading" },
	                        pageHeading
	                    ),
	                    mainMenu && !secondaryMenu && _react2.default.createElement(_InvestorMainMenuMobile2.default, mainMenu)
	                )
	            );
	        }
	    }]);
	
	    return InvestorHeader;
	}(_react2.default.PureComponent);
	
	InvestorHeader.propTypes = {
	    logoLink: _propTypes2.default.string.isRequired,
	    logoAltText: _propTypes2.default.string.isRequired,
	    investorLogo: _propTypes2.default.shape(_Link2.default.propTypes),
	    backToMainSite: _propTypes2.default.shape(_Link2.default.propTypes),
	    pageHeading: _propTypes2.default.string,
	    mainMenu: _propTypes2.default.shape(_InvestorMainMenu2.default.propTypes),
	    secondaryMenu: _propTypes2.default.shape(_InvestorSecondaryMenu2.default.propTypes),
	    languages: _propTypes2.default.arrayOf(_propTypes2.default.shape(_LanguageLink2.default.propTypes)),
	    quickSearch: _propTypes2.default.shape({
	        searchPageUrl: _propTypes2.default.string.isRequired
	    }),
	    lang: _propTypes2.default.shape({
	        openQuickSearchFormBtnAriaLabel: _propTypes2.default.string.isRequired,
	        closeQuickSearchFormBtnAriaLabel: _propTypes2.default.string.isRequired,
	        searchHint: _propTypes2.default.string.isRequired,
	        searchLabel: _propTypes2.default.string.isRequired
	    }).isRequired
	};
	exports.default = InvestorHeader;
	module.exports = exports["default"];

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _InvestorHeader = __webpack_require__(502);
	
	var _InvestorHeader2 = _interopRequireDefault(_InvestorHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InvestorHeader2.default;
	module.exports = exports["default"];

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Link = __webpack_require__(26);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(709);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InvestorLink = function InvestorLink(_ref) {
	    var className = _ref.className,
	        _ref$openInNewWindow = _ref.openInNewWindow,
	        openInNewWindow = _ref$openInNewWindow === undefined ? false : _ref$openInNewWindow,
	        url = _ref.url,
	        linkText = _ref.linkText,
	        tabindex = _ref.tabindex,
	        iconName = _ref.iconName,
	        leftIconName = _ref.leftIconName,
	        download = _ref.download,
	        _ref$onFocus = _ref.onFocus,
	        onFocus = _ref$onFocus === undefined ? function () {} : _ref$onFocus,
	        _ref$onBlur = _ref.onBlur,
	        onBlur = _ref$onBlur === undefined ? function () {} : _ref$onBlur,
	        _ref$onClick = _ref.onClick,
	        onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;
	    return _react2.default.createElement(
	        'a',
	        {
	            href: url,
	            className: (0, _classnames2.default)('investor-link', _defineProperty({}, className, className)),
	            target: openInNewWindow ? '_blank' : null,
	            rel: openInNewWindow ? 'nofollow noopener noreferrer' : null,
	            tabIndex: tabindex,
	            download: download,
	            onFocus: onFocus,
	            onBlur: onBlur,
	            onClick: onClick
	        },
	        leftIconName && _react2.default.createElement(_Icon2.default, { icon: leftIconName, className: 'investor-link__icon investor-link__icon_left' }),
	        linkText && _react2.default.createElement(
	            'span',
	            { className: 'investor-link__text' },
	            linkText
	        ),
	        iconName && _react2.default.createElement(_Icon2.default, { icon: iconName, className: 'investor-link__icon' })
	    );
	};
	
	InvestorLink.propTypes = Object.assign({}, _Link2.default.propTypes, {
	    download: _propTypes2.default.bool,
	    className: _propTypes2.default.string, // FE only
	    tabindex: _propTypes2.default.number, // FE only
	    onFocus: _propTypes2.default.func, // FE only
	    onBlur: _propTypes2.default.func, // FE only
	    onClick: _propTypes2.default.func // FE only
	});
	
	exports.default = InvestorLink;
	module.exports = exports['default'];

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Image = __webpack_require__(77);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(710);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvestorLogo = function InvestorLogo(_ref) {
	    var className = _ref.className,
	        url = _ref.url,
	        image = _ref.image,
	        imageClass = _ref.imageClass;
	
	    var RootTag = url ? 'a' : 'div';
	
	    var rootTagProps = _extends({}, url && {
	        href: url
	    }, {
	        className: (0, _classnames2.default)('investor-logo', className)
	    });
	
	    return _react2.default.createElement(
	        RootTag,
	        rootTagProps,
	        image && _react2.default.createElement('img', {
	            alt: image.altText ? image.altText : '',
	            className: (0, _classnames2.default)('investor-logo__image', imageClass),
	            src: image.url
	        })
	    );
	};
	
	InvestorLogo.propTypes = {
	    className: _propTypes2.default.string,
	    imageClass: _propTypes2.default.string,
	    url: _propTypes2.default.string,
	    image: _propTypes2.default.shape(_Image2.default.propTypes)
	};
	
	exports.default = InvestorLogo;
	module.exports = exports['default'];

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _InvestorLogo = __webpack_require__(505);
	
	var _InvestorLogo2 = _interopRequireDefault(_InvestorLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InvestorLogo2.default;
	module.exports = exports['default'];

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InvestorMenuLink = __webpack_require__(237);
	
	var _InvestorMenuLink2 = _interopRequireDefault(_InvestorMenuLink);
	
	var _InvestorLinkButton = __webpack_require__(60);
	
	var _InvestorLinkButton2 = _interopRequireDefault(_InvestorLinkButton);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(711);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InvestorMainMenuMobile = function (_React$PureComponent) {
	    _inherits(InvestorMainMenuMobile, _React$PureComponent);
	
	    function InvestorMainMenuMobile() {
	        _classCallCheck(this, InvestorMainMenuMobile);
	
	        return _possibleConstructorReturn(this, (InvestorMainMenuMobile.__proto__ || Object.getPrototypeOf(InvestorMainMenuMobile)).apply(this, arguments));
	    }
	
	    _createClass(InvestorMainMenuMobile, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                links = _props.links,
	                className = _props.className;
	
	
	            if (!links || links.length === 0) return null;
	
	            return _react2.default.createElement(
	                'nav',
	                { className: (0, _classnames2.default)('investor-main-menu-mobile', className) },
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'investor-main-menu-mobile__list' },
	                    links.map(function (link, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: index, className: 'investor-main-menu-mobile__item' },
	                            _react2.default.createElement(_InvestorLinkButton2.default, {
	                                url: link.url,
	                                text: link.linkText,
	                                className: (0, _classnames2.default)('investor-main-menu-mobile__link', {
	                                    'investor-main-menu-mobile__link_active': link.isActive
	                                }),
	                                rightIconName: 'arrow-line-right'
	                            })
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return InvestorMainMenuMobile;
	}(_react2.default.PureComponent);
	
	InvestorMainMenuMobile.propTypes = {
	    className: _propTypes2.default.string,
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape(_InvestorMenuLink2.default.propTypes)).isRequired
	};
	
	exports.default = InvestorMainMenuMobile;
	module.exports = exports['default'];

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _InvestorMainMenuMobile = __webpack_require__(507);
	
	var _InvestorMainMenuMobile2 = _interopRequireDefault(_InvestorMainMenuMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InvestorMainMenuMobile2.default;
	module.exports = exports['default'];

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InvestorMenuLink = __webpack_require__(237);
	
	var _InvestorMenuLink2 = _interopRequireDefault(_InvestorMenuLink);
	
	var _InvestorLink = __webpack_require__(125);
	
	var _InvestorLink2 = _interopRequireDefault(_InvestorLink);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(712);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InvestorMainMenu = function (_React$PureComponent) {
	    _inherits(InvestorMainMenu, _React$PureComponent);
	
	    function InvestorMainMenu() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, InvestorMainMenu);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InvestorMainMenu.__proto__ || Object.getPrototypeOf(InvestorMainMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            activeIndex: null
	        }, _this.toggleSubmenu = function (index) {
	            _this.setState(function (prevState) {
	                return {
	                    activeIndex: prevState.activeIndex === index ? null : index
	                };
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(InvestorMainMenu, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                links = _props.links,
	                className = _props.className,
	                lang = _props.lang,
	                onLinkClick = _props.onLinkClick;
	            var activeIndex = this.state.activeIndex;
	
	
	            if (!links || links.length === 0) return null;
	
	            return _react2.default.createElement(
	                'nav',
	                { className: (0, _classnames2.default)('investor-main-menu', className), 'aria-label': lang.mainMenuAriaLabel },
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'investor-main-menu__list' },
	                    links.map(function (link, index) {
	                        var isOpened = activeIndex === index;
	                        var hasSecondaryMenu = link.secondaryMenu && link.secondaryMenu.links && link.secondaryMenu.links.length > 0;
	
	                        return _react2.default.createElement(
	                            'li',
	                            { key: index, className: 'investor-main-menu__item' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'investor-main-menu__item-holder' },
	                                _react2.default.createElement(_InvestorLink2.default, _extends({}, link, {
	                                    className: (0, _classnames2.default)('investor-main-menu__link', {
	                                        'investor-main-menu__link_active': link.isActive
	                                    }),
	                                    onClick: onLinkClick
	                                })),
	                                hasSecondaryMenu && _react2.default.createElement(
	                                    'button',
	                                    {
	                                        className: (0, _classnames2.default)('investor-main-menu__submenu-toggle-button', {
	                                            'investor-main-menu__submenu-toggle-button_opened': isOpened
	                                        }),
	                                        onClick: function onClick() {
	                                            return _this2.toggleSubmenu(index);
	                                        },
	                                        'aria-expanded': isOpened,
	                                        'aria-controls': 'submenu-' + index
	                                    },
	                                    _react2.default.createElement('span', {
	                                        className: (0, _classnames2.default)('investor-main-menu__submenu-toggle-button-icon', {
	                                            'investor-main-menu__submenu-toggle-button-icon_opened': isOpened
	                                        })
	                                    })
	                                )
	                            ),
	                            hasSecondaryMenu && _react2.default.createElement(
	                                'ul',
	                                {
	                                    id: 'submenu-' + index,
	                                    className: (0, _classnames2.default)('investor-main-menu__submenu-list', {
	                                        'investor-main-menu__submenu-list_opened': isOpened
	                                    })
	                                },
	                                link.secondaryMenu.links.map(function (sublink, subIndex) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        {
	                                            key: subIndex,
	                                            className: 'investor-main-menu__submenu-item'
	                                        },
	                                        _react2.default.createElement(_InvestorLink2.default, {
	                                            url: link.url + '#' + sublink.anchorId,
	                                            linkText: sublink.text,
	                                            openInNewWindow: link.openInNewWindow,
	                                            className: 'investor-main-menu__submenu-link',
	                                            onClick: onLinkClick
	                                        })
	                                    );
	                                })
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return InvestorMainMenu;
	}(_react2.default.PureComponent);
	
	InvestorMainMenu.propTypes = {
	    className: _propTypes2.default.string,
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape(_InvestorMenuLink2.default.propTypes)).isRequired,
	    lang: _propTypes2.default.shape({
	        mainMenuAriaLabel: _propTypes2.default.string.isRequired
	    }).isRequired,
	    onLinkClick: _propTypes2.default.func
	};
	
	exports.default = InvestorMainMenu;
	module.exports = exports['default'];

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _InvestorMainMenu = __webpack_require__(509);
	
	var _InvestorMainMenu2 = _interopRequireDefault(_InvestorMainMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InvestorMainMenu2.default;
	module.exports = exports['default'];

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(713);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvestorPageHeading = function InvestorPageHeading(_ref) {
	    var heading = _ref.heading,
	        anchorId = _ref.anchorId,
	        isNarrow = _ref.isNarrow;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'investor-page-heading', id: anchorId },
	        _react2.default.createElement(
	            'h1',
	            { className: (0, _classnames2.default)("investor-page-heading__heading", {
	                    "investor-page-heading__heading_narrow": isNarrow
	                }) },
	            heading
	        )
	    );
	};
	
	InvestorPageHeading.propTypes = {
	    heading: _propTypes2.default.string,
	    anchorId: _propTypes2.default.string,
	    isNarrow: _propTypes2.default.bool
	};
	
	exports.default = InvestorPageHeading;
	module.exports = exports['default'];

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _InvestorPageHeading = __webpack_require__(511);
	
	var _InvestorPageHeading2 = _interopRequireDefault(_InvestorPageHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InvestorPageHeading2.default;
	module.exports = exports['default'];

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InvestorLink = __webpack_require__(125);
	
	var _InvestorLink2 = _interopRequireDefault(_InvestorLink);
	
	var _FluidImage = __webpack_require__(30);
	
	var _FluidImage2 = _interopRequireDefault(_FluidImage);
	
	var _Link = __webpack_require__(26);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Image = __webpack_require__(77);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	__webpack_require__(714);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DOWNLOADABLE_EXTENSIONS = ['.zip'];
	
	var InvestorReport = function InvestorReport(_ref) {
	    var title = _ref.title,
	        year = _ref.year,
	        links = _ref.links,
	        image = _ref.image;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'investor-report' },
	        image && _react2.default.createElement(
	            'div',
	            { className: 'investor-report__cover-image-holder' },
	            _react2.default.createElement(_FluidImage2.default, {
	                className: 'investor-report__cover-image',
	                image: image.url,
	                altText: image.altText,
	                visible: true
	            })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'investor-report__top-info' },
	            title && _react2.default.createElement(
	                'h2',
	                { className: 'investor-report__title' },
	                title
	            ),
	            year && _react2.default.createElement(
	                'span',
	                { className: 'investor-report__year' },
	                year
	            )
	        ),
	        links && links.length > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'investor-report__links' },
	            links.map(function (link, index) {
	                var isDownloadable = link.url && DOWNLOADABLE_EXTENSIONS.some(function (ext) {
	                    return link.url.indexOf(ext) > -1;
	                });
	
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'investor-report__link-holder', key: index },
	                    _react2.default.createElement(_InvestorLink2.default, _extends({}, link, {
	                        leftIconName: isDownloadable ? "download" : null,
	                        iconName: isDownloadable ? null : "arrow-line-right",
	                        className: 'investor-report__link',
	                        download: isDownloadable,
	                        openInNewWindow: !isDownloadable
	                    }))
	                );
	            })
	        ) : null
	    );
	};
	
	InvestorReport.propTypes = {
	    title: _propTypes2.default.string,
	    year: _propTypes2.default.string,
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape(_Link2.default.propTypes)),
	    image: _propTypes2.default.shape(_Image2.default.propTypes)
	};
	
	exports.default = InvestorReport;
	module.exports = exports['default'];

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AnchorLink = __webpack_require__(235);
	
	var _AnchorLink2 = _interopRequireDefault(_AnchorLink);
	
	var _Link = __webpack_require__(26);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _InvestorLinkButton = __webpack_require__(60);
	
	var _InvestorLinkButton2 = _interopRequireDefault(_InvestorLinkButton);
	
	var _scrollUtils = __webpack_require__(615);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(715);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var INVESTOR_PAGE_SECONDARY_MENU_STICKY_CLASSNAME = 'investor-page-sticky-secondary-menu';
	var ANCHOR_SCROLL_ANIMATION_DURATION = 800;
	var INVESTOR_HEADER_HEIGHT = 70; // Should be synchronized with SCSS variable $header-height
	var INVESTOR_SECONDARY_MENU_HEIGHT = 84; // Should be synchronized with SCSS variable $investor-secondary-menu-height
	var SCROLL_TO_EXTRA_OFFSET = 30;
	var HIGHLIGHT_ACTIVE_ANCHOR_DISTANCE_THRESHOLD = 250;
	
	var InvestorSecondaryMenu = function (_React$PureComponent) {
	    _inherits(InvestorSecondaryMenu, _React$PureComponent);
	
	    function InvestorSecondaryMenu() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, InvestorSecondaryMenu);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InvestorSecondaryMenu.__proto__ || Object.getPrototypeOf(InvestorSecondaryMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            isScrolled: false,
	            activeAnchorId: null,
	            isCurrentlyNavigatingToAnchorSection: false
	        }, _this.menuRef = null, _this.pageElement = null, _this.staticPosition = null, _this.handlePageLoad = function () {
	            var links = _this.props.links;
	
	            var hash = window.location.hash.slice(1);
	
	            if (hash && links && links.length > 0) {
	                setTimeout(function () {
	                    _this.scrollToAnchor(hash);
	                }, 100);
	            }
	        }, _this.handleScroll = function () {
	            if (_this.staticPosition !== null) {
	                var isScrolled = window.scrollY >= _this.staticPosition;
	
	                if (isScrolled !== _this.state.isScrolled) {
	                    _this.setState({ isScrolled: isScrolled });
	                }
	            }
	
	            _this.syncActiveAnchorToScrollPosition();
	        }, _this.setMenuRef = function (element) {
	            _this.menuRef = element;
	        }, _this.setMenuListRef = function (element) {
	            _this.menuListRef = element;
	        }, _this.syncActiveAnchorToScrollPosition = function () {
	            var links = _this.props.links;
	
	
	            if (_this.state.isCurrentlyNavigatingToAnchorSection) {
	                return;
	            }
	
	            var activeId = null;
	
	            for (var index = 0; index < links.length; index++) {
	                var anchorLink = links[index];
	                var anchorElement = document.getElementById(anchorLink.anchorId);
	                var rect = anchorElement ? anchorElement.getBoundingClientRect() : null;
	
	                if (!rect) {
	                    break;
	                }
	
	                if (rect.top <= HIGHLIGHT_ACTIVE_ANCHOR_DISTANCE_THRESHOLD) {
	                    var nextTargetLink = links[index + 1];
	                    var nextTargetElement = nextTargetLink ? document.getElementById(nextTargetLink.anchorId) : null;
	                    if (!nextTargetElement || nextTargetElement && nextTargetElement.getBoundingClientRect().top > HIGHLIGHT_ACTIVE_ANCHOR_DISTANCE_THRESHOLD) {
	                        activeId = anchorLink.anchorId;
	                        break;
	                    }
	                }
	            }
	
	            _this.setState({
	                activeAnchorId: activeId
	            });
	        }, _this.scrollToAnchor = function (id) {
	            var _this$props = _this.props,
	                links = _this$props.links,
	                isHeaderHidden = _this$props.isHeaderHidden;
	
	
	            if (_this.anchorLinkClickTimeoutRef) {
	                clearTimeout(_this.anchorLinkClickTimeoutRef);
	            }
	
	            _this.setState({ isCurrentlyNavigatingToAnchorSection: true });
	
	            var targetAnchorLink = links.find(function (link) {
	                return link.anchorId === id;
	            });
	
	            if (targetAnchorLink) {
	                var targetElement = document.getElementById(targetAnchorLink.anchorId);
	
	                if (targetElement) {
	                    var scrollOffset = INVESTOR_SECONDARY_MENU_HEIGHT + SCROLL_TO_EXTRA_OFFSET;
	
	                    if (!isHeaderHidden) {
	                        scrollOffset += INVESTOR_HEADER_HEIGHT;
	                    }
	
	                    _this.props.allowHeaderHidingOnScroll(false);
	
	                    (0, _scrollUtils.scrollToBlock)(targetElement, scrollOffset);
	                }
	            }
	
	            _this.setState({ activeAnchorId: id });
	
	            _this.anchorLinkClickTimeoutRef = setTimeout(function () {
	                _this.setState({ isCurrentlyNavigatingToAnchorSection: false }, function () {
	                    if (!_this.state.isCurrentlyNavigatingToAnchorSection) {
	                        _this.props.allowHeaderHidingOnScroll(true);
	                    }
	                });
	            }, ANCHOR_SCROLL_ANIMATION_DURATION);
	        }, _this.handleHashChange = function () {
	            var hash = window.location.hash.slice(1);
	            if (hash) {
	                _this.scrollToAnchor(hash);
	            }
	        }, _this.onAnchorLinkClick = function (e, id) {
	            e.preventDefault();
	            window.history.pushState(null, null, '#' + id);
	            window.dispatchEvent(new Event("hashchange"));
	        }, _this.scrollToTop = function (e) {
	            e.preventDefault();
	            window.scrollTo({ top: 0, behavior: 'smooth' });
	            history.pushState("", document.title, window.location.pathname + window.location.search);
	        }, _this.scrollActiveAnchorItemIntoView = function () {
	            if (!_this.menuListRef || !_this.state.activeAnchorId) return;
	
	            var listElement = _this.menuListRef;
	            var items = listElement.querySelectorAll('.investor-secondary-menu__link');
	
	            var activeItem = Array.from(items).find(function (item) {
	                var itemHref = item.getAttribute('href');
	                if (!itemHref) return null;
	                return itemHref.slice(1) === _this.state.activeAnchorId;
	            });
	
	            if (listElement && activeItem) {
	                var listRect = listElement.getBoundingClientRect();
	                var activeRect = activeItem.getBoundingClientRect();
	
	                var offsetLeft = activeRect.left - listRect.left + listElement.scrollLeft;
	                var scrollTo = offsetLeft - listElement.clientWidth / 2 + activeRect.width / 2;
	
	                listElement.scrollTo({
	                    left: scrollTo,
	                    behavior: "smooth"
	                });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(InvestorSecondaryMenu, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.originalScrollRestoration = window.history.scrollRestoration;
	            window.history.scrollRestoration = 'manual';
	
	            this.pageElement = document.querySelector('.site');
	            if (this.menuRef) {
	                this.staticPosition = this.menuRef.offsetTop;
	            }
	
	            this.syncActiveAnchorToScrollPosition();
	
	            window.addEventListener('load', this.handlePageLoad);
	            window.addEventListener('scroll', this.handleScroll);
	            window.addEventListener('hashchange', this.handleHashChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.originalScrollRestoration) {
	                window.history.scrollRestoration = this.originalScrollRestoration;
	            }
	
	            window.removeEventListener('load', this.handlePageLoad);
	            window.removeEventListener('scroll', this.handleScroll);
	            window.removeEventListener('hashchange', this.handleHashChange);
	
	            if (this.pageElement) {
	                this.pageElement.classList.remove(INVESTOR_PAGE_SECONDARY_MENU_STICKY_CLASSNAME);
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(_, prevState) {
	            var _state = this.state,
	                isScrolled = _state.isScrolled,
	                activeAnchorId = _state.activeAnchorId;
	
	
	            if (isScrolled !== prevState.isScrolled && this.pageElement) {
	                this.pageElement.classList.toggle(INVESTOR_PAGE_SECONDARY_MENU_STICKY_CLASSNAME, isScrolled);
	            }
	
	            if (activeAnchorId !== prevState.activeAnchorId) {
	                this.scrollActiveAnchorItemIntoView();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                links = _props.links,
	                className = _props.className,
	                isHeaderHidden = _props.isHeaderHidden,
	                backToInvestorLink = _props.backToInvestorLink,
	                lang = _props.lang;
	            var _state2 = this.state,
	                activeAnchorId = _state2.activeAnchorId,
	                isScrolled = _state2.isScrolled;
	
	
	            if (!links || links.length === 0) return null;
	
	            return _react2.default.createElement(
	                'nav',
	                {
	                    ref: this.setMenuRef,
	                    className: (0, _classnames2.default)('investor-secondary-menu', className, {
	                        'investor-secondary-menu_scrolled': isHeaderHidden
	                    }),
	                    'aria-label': lang.secondaryMenuAriaLabel
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'investor-secondary-menu__container' },
	                    backToInvestorLink && _react2.default.createElement(_InvestorLinkButton2.default, {
	                        url: backToInvestorLink.url,
	                        text: isScrolled ? lang.backToTopLabel : backToInvestorLink.linkText,
	                        openInNewWindow: backToInvestorLink.openInNewWindow,
	                        theme: 'ghost',
	                        iconOnlyOnTablet: true,
	                        className: 'investor-secondary-menu__nav-link',
	                        iconName: isScrolled ? "arrow-line-top" : "arrow-line-left",
	                        onClick: isScrolled ? this.scrollToTop : null
	                    }),
	                    _react2.default.createElement(
	                        'ul',
	                        { ref: this.setMenuListRef, className: 'investor-secondary-menu__list' },
	                        links.map(function (link, index) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: index, className: 'investor-secondary-menu__item' },
	                                _react2.default.createElement(_InvestorLinkButton2.default, {
	                                    url: '#' + link.anchorId,
	                                    text: link.text,
	                                    className: (0, _classnames2.default)('investor-secondary-menu__link', {
	                                        'investor-secondary-menu__link_active': link.isActive
	                                    }),
	                                    isActive: activeAnchorId === link.anchorId,
	                                    onClick: function onClick(e) {
	                                        return _this2.onAnchorLinkClick(e, link.anchorId);
	                                    }
	                                })
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InvestorSecondaryMenu;
	}(_react2.default.PureComponent);
	
	InvestorSecondaryMenu.propTypes = {
	    className: _propTypes2.default.string,
	    isHeaderHidden: _propTypes2.default.bool,
	    backToInvestorLink: _propTypes2.default.shape(_Link2.default.propTypes),
	    lang: _propTypes2.default.shape({
	        backToTopLabel: _propTypes2.default.string.isRequired,
	        secondaryMenuAriaLabel: _propTypes2.default.string.isRequired
	    }).isRequired,
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape(_AnchorLink2.default.propTypes)).isRequired,
	    allowHeaderHidingOnScroll: _propTypes2.default.func
	};
	exports.default = InvestorSecondaryMenu;
	module.exports = exports['default'];

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _InvestorSecondaryMenu = __webpack_require__(514);
	
	var _InvestorSecondaryMenu2 = _interopRequireDefault(_InvestorSecondaryMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InvestorSecondaryMenu2.default;
	module.exports = exports['default'];

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	__webpack_require__(716);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LanguageList = function (_React$Component) {
	    _inherits(LanguageList, _React$Component);
	
	    function LanguageList() {
	        _classCallCheck(this, LanguageList);
	
	        return _possibleConstructorReturn(this, (LanguageList.__proto__ || Object.getPrototypeOf(LanguageList)).apply(this, arguments));
	    }
	
	    _createClass(LanguageList, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var isOpen = this.props.isOpen;
	            var languagelist = this.languagelist;
	
	
	            if (isOpen) {
	                var ul = languagelist.getElementsByTagName('ul')[0];
	                languagelist.style.height = ul.offsetHeight + 'px';
	            } else if (languagelist) {
	                languagelist.removeAttribute('style');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                isOpen = _props.isOpen,
	                languages = _props.languages;
	
	
	            var classNames = (0, _classnames3.default)('language-list', {
	                'open': isOpen,
	                'closed': !isOpen
	            });
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: classNames,
	                    ref: function ref(node) {
	                        return _this2.languagelist = node;
	                    }
	                },
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    languages.map(function (l, i) {
	                        return _react2.default.createElement(
	                            'li',
	                            { className: l.active ? 'selected' : undefined, key: i },
	                            _react2.default.createElement(
	                                'a',
	                                { href: l.link },
	                                l.text
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return LanguageList;
	}(_react2.default.Component);
	
	LanguageList.propTypes = {
	    height: _propTypes2.default.number,
	    isOpen: _propTypes2.default.bool.isRequired,
	    languages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        link: _propTypes2.default.string.isRequired,
	        text: _propTypes2.default.string.isRequired
	    })).isRequired
	};
	
	var LanguageSelector = function (_React$PureComponent) {
	    _inherits(LanguageSelector, _React$PureComponent);
	
	    function LanguageSelector() {
	        var _ref;
	
	        var _temp, _this3, _ret;
	
	        _classCallCheck(this, LanguageSelector);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = LanguageSelector.__proto__ || Object.getPrototypeOf(LanguageSelector)).call.apply(_ref, [this].concat(args))), _this3), _this3.state = {
	            height: 0
	        }, _temp), _possibleConstructorReturn(_this3, _ret);
	    }
	
	    _createClass(LanguageSelector, [{
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                languages = _props2.languages,
	                isActive = _props2.isActive,
	                className = _props2.className;
	            var height = this.state.height;
	
	
	            if (!languages || languages.length === 0) return null;
	
	            var classNames = (0, _classnames3.default)('language-link', {
	                'open': isActive === 'language'
	            });
	
	            var selectedLanguage = languages.find(function (language) {
	                return language.isActive;
	            }) || languages[0];
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames3.default)('language-wrapper', _defineProperty({}, '' + className, className)) },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        className: classNames,
	                        onClick: this.props.handleSelectorClick
	                    },
	                    selectedLanguage.text
	                ),
	                _react2.default.createElement(LanguageList, {
	                    height: height,
	                    languages: languages,
	                    isOpen: isActive === 'language'
	                })
	            );
	        }
	    }]);
	
	    return LanguageSelector;
	}(_react2.default.PureComponent);
	
	LanguageSelector.propTypes = {
	    isActive: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
	    languages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        link: _propTypes2.default.string.isRequired,
	        text: _propTypes2.default.string.isRequired
	    })).isRequired,
	    className: _propTypes2.default.string,
	    handleSelectorClick: _propTypes2.default.func
	};
	exports.default = LanguageSelector;
	module.exports = exports['default'];

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(16);
	
	var _LinkGroupListBlockModule = __webpack_require__(782);
	
	var _LinkGroupListBlockModule2 = _interopRequireDefault(_LinkGroupListBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var LinkGroupListBlock = function LinkGroupListBlock(_ref) {
	    var blockId = _ref.blockId,
	        heading = _ref.heading,
	        backgroundImage = _ref.backgroundImage,
	        linkGroups = _ref.linkGroups;
	    return _react2.default.createElement(
	        'div',
	        {
	            className: (0, _classnames2.default)(_LinkGroupListBlockModule2.default.block, _defineProperty({}, _LinkGroupListBlockModule2.default.background, backgroundImage)),
	            'data-block': blockId
	        },
	        heading && _react2.default.createElement(
	            'div',
	            _extends({ className: _LinkGroupListBlockModule2.default.heading }, (0, _utils.onPageEditing)('Heading')),
	            _react2.default.createElement(
	                'h3',
	                { className: 'block-title-large' },
	                heading
	            )
	        ),
	        linkGroups.length > 0 && _react2.default.createElement(
	            'div',
	            _extends({ className: _LinkGroupListBlockModule2.default.wrapper }, (0, _utils.onPageEditing)('LinkGroups')),
	            linkGroups.map(function (g, i) {
	                return _react2.default.createElement(
	                    'nav',
	                    { className: _LinkGroupListBlockModule2.default.group, key: i },
	                    g.headingAsLink ? _react2.default.createElement(
	                        'a',
	                        { href: g.headingAsLink },
	                        g.heading
	                    ) : g.heading && _react2.default.createElement(
	                        'p',
	                        null,
	                        g.heading
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _LinkGroupListBlockModule2.default.links },
	                        g.linkCollection !== null && g.linkCollection.map(function (l) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: l.text },
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        href: l.href,
	                                        target: l.target
	                                    },
	                                    l.text
	                                )
	                            );
	                        })
	                    )
	                );
	            })
	        )
	    );
	};
	
	LinkGroupListBlock.propTypes = {
	    blockId: _propTypes2.default.number.isRequired,
	    heading: _propTypes2.default.string,
	    backgroundImage: _propTypes2.default.bool,
	    linkGroups: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        heading: _propTypes2.default.string,
	        headingAsLink: _propTypes2.default.string,
	        linkCollection: _propTypes2.default.any
	    })).isRequired
	};
	
	exports.default = LinkGroupListBlock;
	module.exports = exports['default'];

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _LinkGroupListBlock = __webpack_require__(517);
	
	var _LinkGroupListBlock2 = _interopRequireDefault(_LinkGroupListBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LinkGroupListBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ImageIcon = __webpack_require__(59);
	
	var _ImageIcon2 = _interopRequireDefault(_ImageIcon);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Media = __webpack_require__(38);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LinkListBlockModule = __webpack_require__(783);
	
	var _LinkListBlockModule2 = _interopRequireDefault(_LinkListBlockModule);
	
	var _themes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinkListBlock = function (_React$Component) {
	    _inherits(LinkListBlock, _React$Component);
	
	    function LinkListBlock(props) {
	        _classCallCheck(this, LinkListBlock);
	
	        var _this = _possibleConstructorReturn(this, (LinkListBlock.__proto__ || Object.getPrototypeOf(LinkListBlock)).call(this));
	
	        _this._handlePlayClick = function () {
	            return _this.setState({ playing: true });
	        };
	
	        var theme = props.theme;
	
	        // override theme for video block
	        if (props.backgroundVideo && props.backgroundVideo.length > 0) {
	            theme = _themes.THEMES.darkgray;
	        }
	
	        _this.state = {
	            theme: theme
	        };
	        return _this;
	    }
	
	    _createClass(LinkListBlock, [{
	        key: 'render',
	        value: function render() {
	            var _extends2;
	
	            var _props = this.props,
	                heading = _props.heading,
	                text = _props.text,
	                links = _props.links,
	                icon = _props.icon,
	                iconNew = _props.iconNew,
	                size = _props.size,
	                backgroundVideo = _props.backgroundVideo,
	                backgroundImage = _props.backgroundImage,
	                blockId = _props.blockId;
	            var theme = this.state.theme;
	
	
	            var classNames = (0, _classnames2.default)(_LinkListBlockModule2.default.block, _extends({}, (0, _themes.getThemeClassNames)(_LinkListBlockModule2.default, theme), (_extends2 = {}, _defineProperty(_extends2, _LinkListBlockModule2.default.bg, theme === _themes.THEMES.illustration), _defineProperty(_extends2, _LinkListBlockModule2.default.tall, size), _defineProperty(_extends2, _LinkListBlockModule2.default.video, backgroundVideo && backgroundVideo.length > 0), _extends2)));
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: classNames,
	                    'data-block': blockId
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: _LinkListBlockModule2.default['block-content'] },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _LinkListBlockModule2.default['list-content'] },
	                        iconNew ? _react2.default.createElement(
	                            'div',
	                            { className: _LinkListBlockModule2.default.icon },
	                            _react2.default.createElement(_ImageIcon2.default, iconNew)
	                        ) : icon ? _react2.default.createElement(
	                            'div',
	                            { className: _LinkListBlockModule2.default.icon },
	                            _react2.default.createElement(_Icon2.default, { icon: icon })
	                        ) : null,
	                        heading && _react2.default.createElement(
	                            'h2',
	                            { className: _LinkListBlockModule2.default.heading },
	                            heading
	                        ),
	                        text && _react2.default.createElement(
	                            'p',
	                            { className: _LinkListBlockModule2.default.text },
	                            text
	                        ),
	                        links && _react2.default.createElement(
	                            'ul',
	                            { className: _LinkListBlockModule2.default.links },
	                            links.map(function (link, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                        _Button2.default,
	                                        _extends({ secondary: true }, link, { light: theme === _themes.THEMES.darkgray }),
	                                        link.text
	                                    )
	                                );
	                            })
	                        )
	                    ),
	                    backgroundVideo && backgroundVideo.length > 0 && _react2.default.createElement(
	                        'div',
	                        { className: _LinkListBlockModule2.default.videoplayer },
	                        _react2.default.createElement(_Media2.default, { video: backgroundVideo, image: backgroundImage })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LinkListBlock;
	}(_react2.default.Component);
	
	LinkListBlock.propTypes = {
	    heading: _propTypes2.default.string.isRequired,
	    text: _propTypes2.default.string,
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        href: _propTypes2.default.string,
	        language: _propTypes2.default.string,
	        target: _propTypes2.default.string,
	        text: _propTypes2.default.string,
	        title: _propTypes2.default.string
	    })),
	    icon: _propTypes2.default.string,
	    iconNew: _propTypes2.default.shape(_ImageIcon2.default.propTypes),
	    theme: _propTypes2.default.oneOf(Object.values(_themes.THEMES)),
	    size: _propTypes2.default.number,
	    backgroundVideo: _Media2.default.propTypes.video,
	    backgroundImage: _Media2.default.propTypes.image,
	    blockId: _propTypes2.default.number
	};
	LinkListBlock.defaultProps = {
	    theme: 0
	};
	exports.default = LinkListBlock;
	module.exports = exports['default'];

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _LinkListBlock = __webpack_require__(519);
	
	var _LinkListBlock2 = _interopRequireDefault(_LinkListBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LinkListBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LinkModule = __webpack_require__(784);
	
	var _LinkModule2 = _interopRequireDefault(_LinkModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Link = function (_React$PureComponent) {
	    _inherits(Link, _React$PureComponent);
	
	    function Link() {
	        _classCallCheck(this, Link);
	
	        return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
	    }
	
	    _createClass(Link, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                children = _props.children,
	                icon = _props.icon,
	                href = _props.href,
	                target = _props.target,
	                download = _props.download;
	
	
	            return _react2.default.createElement(
	                'span',
	                { className: (0, _classnames2.default)(_LinkModule2.default.link, className) },
	                icon && _react2.default.createElement(_Icon2.default, { className: _LinkModule2.default.icon, icon: icon }),
	                _react2.default.createElement(
	                    'a',
	                    {
	                        href: href,
	                        target: target,
	                        download: download,
	                        rel: target === "_blank" && "noopener noreferrer"
	                    },
	                    children
	                )
	            );
	        }
	    }]);
	
	    return Link;
	}(_react2.default.PureComponent);
	
	Link.propTypes = {
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.string.isRequired,
	    icon: _propTypes2.default.string,
	    download: _propTypes2.default.bool,
	    href: _propTypes2.default.string.isRequired,
	    target: _propTypes2.default.oneOf(["_blank"])
	};
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Link = exports.default = undefined;
	
	var _Link2 = __webpack_require__(521);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Link3.default;
	exports.Link = _Link3.default;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stringHelper = __webpack_require__(616);
	
	var _stringHelper2 = _interopRequireDefault(_stringHelper);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ListSearchFormModule = __webpack_require__(785);
	
	var _ListSearchFormModule2 = _interopRequireDefault(_ListSearchFormModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListSearchForm = function (_React$Component) {
	    _inherits(ListSearchForm, _React$Component);
	
	    function ListSearchForm() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ListSearchForm);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ListSearchForm.__proto__ || Object.getPrototypeOf(ListSearchForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            searchQuery: _this.props.defaultValue || ''
	        }, _this.handleInputChange = function (e) {
	            _this.setState({ searchQuery: e.target.value });
	        }, _this.handleFormSubmit = function (e) {
	            e.preventDefault();
	            _this.props.onFormSubmit(_this.state.searchQuery);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ListSearchForm, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.defaultValue !== this.props.defaultValue) {
	                this.setState({ searchQuery: this.props.defaultValue || '' });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                searchInputLabel = _props.searchInputLabel,
	                searchButtonAriaLabel = _props.searchButtonAriaLabel,
	                searchInputPlaceholder = _props.searchInputPlaceholder,
	                searchParamName = _props.searchParamName,
	                isLoading = _props.isLoading,
	                totalListItemsCount = _props.totalListItemsCount,
	                listItemsCount = _props.listItemsCount,
	                searchHitsText = _props.searchHitsText,
	                noResultsText = _props.noResultsText,
	                noSearchHitsTextDisplayed = _props.noSearchHitsTextDisplayed,
	                className = _props.className;
	            var searchQuery = this.state.searchQuery;
	
	
	            return _react2.default.createElement(
	                'form',
	                {
	                    onSubmit: this.handleFormSubmit,
	                    role: 'search'
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)(_ListSearchFormModule2.default.search, className) },
	                    _react2.default.createElement(
	                        'label',
	                        { className: _ListSearchFormModule2.default.label, htmlFor: 'searchInput', tabIndex: '-1' },
	                        searchInputLabel
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ListSearchFormModule2.default.container },
	                        _react2.default.createElement('input', {
	                            type: 'search',
	                            name: searchParamName,
	                            placeholder: searchInputPlaceholder,
	                            className: _ListSearchFormModule2.default.input,
	                            id: 'searchInput',
	                            value: searchQuery,
	                            onChange: this.handleInputChange
	                        }),
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                className: _ListSearchFormModule2.default.button,
	                                'aria-label': searchButtonAriaLabel,
	                                disabled: isLoading
	                            },
	                            _react2.default.createElement(_Icon2.default, { icon: 'search', className: _ListSearchFormModule2.default.icon })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: _ListSearchFormModule2.default['search-result-text'] },
	                        noSearchHitsTextDisplayed ? null : listItemsCount > 0 ? _stringHelper2.default.format(searchHitsText, totalListItemsCount) : noResultsText
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ListSearchForm;
	}(_react2.default.Component);
	
	ListSearchForm.propTypes = {
	    searchButtonAriaLabel: _propTypes2.default.string,
	    searchInputLabel: _propTypes2.default.string,
	    searchInputPlaceholder: _propTypes2.default.string,
	    searchParamName: _propTypes2.default.string,
	    defaultValue: _propTypes2.default.string,
	    isLoading: _propTypes2.default.bool,
	    totalListItemsCount: _propTypes2.default.number,
	    listItemsCount: _propTypes2.default.number,
	    searchHitsText: _propTypes2.default.string,
	    noResultsText: _propTypes2.default.string,
	    noSearchHitsTextDisplayed: _propTypes2.default.bool,
	    onFormSubmit: _propTypes2.default.func,
	    className: _propTypes2.default.string
	};
	ListSearchForm.defaultProps = {
	    theme: 0,
	    onFormSubmit: function onFormSubmit() {}
	};
	exports.default = ListSearchForm;
	module.exports = exports['default'];

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DropdownMenu = __webpack_require__(434);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	__webpack_require__(717);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuLink = function (_React$PureComponent) {
	    _inherits(MenuLink, _React$PureComponent);
	
	    function MenuLink(props) {
	        _classCallCheck(this, MenuLink);
	
	        var _this = _possibleConstructorReturn(this, (MenuLink.__proto__ || Object.getPrototypeOf(MenuLink)).call(this, props));
	
	        _this._handleOnClick = function (e) {
	            e.preventDefault();
	            _this.props.onClick(_this.props.id);
	        };
	
	        return _this;
	    }
	
	    _createClass(MenuLink, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                linkText = _props.linkText,
	                link = _props.link,
	                columns = _props.columns,
	                dropdown = _props.dropdown,
	                isActive = _props.isActive,
	                wasActive = _props.wasActive,
	                mobile = _props.mobile,
	                closeMenuLabel = _props.closeMenuLabel;
	
	
	            if (!linkText) return null;
	
	            var topMenuLink = link ? { linkText: linkText, link: link } : null;
	
	            return _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    {
	                        className: (0, _classnames2.default)({
	                            'dropdown': dropdown,
	                            'active': isActive
	                        }),
	                        href: link || "#",
	                        onClick: columns.length > 0 ? this._handleOnClick : null
	                    },
	                    linkText
	                ),
	                dropdown && _react2.default.createElement(_DropdownMenu2.default, {
	                    columns: columns,
	                    isActive: isActive,
	                    wasActive: wasActive,
	                    mobile: mobile,
	                    topMenuLink: topMenuLink,
	                    closeMenu: this._handleOnClick,
	                    closeMenuLabel: closeMenuLabel
	                })
	            );
	        }
	    }]);
	
	    return MenuLink;
	}(_react2.default.PureComponent);
	
	MenuLink.propTypes = {
	    dropdown: _propTypes2.default.bool.isRequired,
	    columns: _propTypes2.default.array,
	    isActive: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
	    mobile: _propTypes2.default.bool.isRequired,
	    onClick: _propTypes2.default.func.isRequired,
	    id: _propTypes2.default.number.isRequired,
	    link: _propTypes2.default.string,
	    linkText: _propTypes2.default.string,
	    wasActive: _propTypes2.default.bool,
	    closeMenuLabel: _propTypes2.default.string.isRequired
	};
	
	var MainNav = function (_React$PureComponent2) {
	    _inherits(MainNav, _React$PureComponent2);
	
	    function MainNav() {
	        _classCallCheck(this, MainNav);
	
	        return _possibleConstructorReturn(this, (MainNav.__proto__ || Object.getPrototypeOf(MainNav)).apply(this, arguments));
	    }
	
	    _createClass(MainNav, [{
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                menu = _props2.menu,
	                onClick = _props2.onClick,
	                isActiveOnMobile = _props2.isActiveOnMobile,
	                isActive = _props2.isActive,
	                closeMenuLabel = _props2.closeMenuLabel;
	
	
	            var classNames = (0, _classnames2.default)('menu', {
	                'open': isActiveOnMobile
	            });
	
	            return _react2.default.createElement(
	                'nav',
	                { className: classNames, role: 'navigation' },
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'top-header-menu' },
	                    menu.map(function (l, i) {
	                        return _react2.default.createElement(MenuLink, _extends({
	                            key: i,
	                            id: i,
	                            dropdown: l.columns.length > 0,
	                            onClick: onClick,
	                            isActive: isActive === i ? true : false,
	                            mobile: isActiveOnMobile,
	                            closeMenuLabel: closeMenuLabel
	                        }, l));
	                    })
	                )
	            );
	        }
	    }]);
	
	    return MainNav;
	}(_react2.default.PureComponent);
	
	MainNav.propTypes = {
	    menu: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        columns: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.shape({
	            link: _propTypes2.default.string,
	            linkText: _propTypes2.default.string,
	            menuItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	                href: _propTypes2.default.string,
	                language: _propTypes2.default.string,
	                target: _propTypes2.default.string,
	                text: _propTypes2.default.string,
	                title: _propTypes2.default.string
	            }))
	        })))
	    })).isRequired,
	    onClick: _propTypes2.default.func.isRequired,
	    isActiveOnMobile: _propTypes2.default.bool.isRequired,
	    isActive: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
	    closeMenuLabel: _propTypes2.default.string.isRequired
	};
	exports.default = MainNav;
	module.exports = exports['default'];

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _MainNav = __webpack_require__(524);
	
	var _MainNav2 = _interopRequireDefault(_MainNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MainNav2.default;
	module.exports = exports['default'];

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Marker = __webpack_require__(531);
	
	var _Marker2 = _interopRequireDefault(_Marker);
	
	var _Map = __webpack_require__(76);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _MapBlockModule = __webpack_require__(786);
	
	var _MapBlockModule2 = _interopRequireDefault(_MapBlockModule);
	
	var _valgtProsjekt42x49px = __webpack_require__(839);
	
	var _valgtProsjekt42x49px2 = _interopRequireDefault(_valgtProsjekt42x49px);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapBlock = function (_React$Component) {
	    _inherits(MapBlock, _React$Component);
	
	    function MapBlock() {
	        _classCallCheck(this, MapBlock);
	
	        return _possibleConstructorReturn(this, (MapBlock.__proto__ || Object.getPrototypeOf(MapBlock)).apply(this, arguments));
	    }
	
	    _createClass(MapBlock, [{
	        key: '_getProjectName',
	        value: function _getProjectName() {
	            var name = "Marker";
	
	            if (typeof document !== 'undefined' && document.querySelector) {
	                var meta = document.querySelector('meta[property="og:title"]');
	                if (meta) {
	                    name = meta.content;
	                }
	            }
	
	            return name;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                address = _props.address,
	                location = _props.location,
	                zoomLevel = _props.zoomLevel,
	                projectAddressLabel = _props.projectAddressLabel,
	                projectStatusLabel = _props.projectStatusLabel,
	                projects = _props.projects,
	                tileLayer = _props.tileLayer;
	
	
	            if (!location) return null;
	
	            var center = location.split(',').map(parseFloat);
	
	            return _react2.default.createElement(
	                'div',
	                { className: _MapBlockModule2.default.block },
	                _react2.default.createElement(
	                    'div',
	                    { className: _MapBlockModule2.default.map },
	                    _react2.default.createElement(
	                        _Map2.default,
	                        {
	                            center: center,
	                            zoomLevel: zoomLevel,
	                            style: {
	                                position: 'absolute'
	                            },
	                            tileLayer: tileLayer
	                        },
	                        _react2.default.createElement(_Marker2.default, {
	                            marker: 'project-current',
	                            location: location,
	                            emphasize: true,
	                            title: this._getProjectName()
	                        }),
	                        projects && projects.map(function (p) {
	                            return _react2.default.createElement(_Marker2.default, {
	                                key: p.location,
	                                project: _extends({}, p, {
	                                    projectStatusLabel: projectStatusLabel
	                                }),
	                                location: p.location,
	                                title: p.name
	                            });
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _MapBlockModule2.default.address },
	                    _react2.default.createElement('img', { alt: 'AF Gruppen', className: _MapBlockModule2.default.icon, src: _valgtProsjekt42x49px2.default }),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        projectAddressLabel && _react2.default.createElement(
	                            'span',
	                            { className: _MapBlockModule2.default.label },
	                            '' + projectAddressLabel
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            address
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MapBlock;
	}(_react2.default.Component);
	
	MapBlock.propTypes = {
	    "address": _propTypes2.default.string.isRequired,
	    "location": _propTypes2.default.string.isRequired,
	    "zoomLevel": _propTypes2.default.number.isRequired,
	    "projectAddressLabel": _propTypes2.default.string,
	    "projectStatusLabel": _propTypes2.default.string,
	    "projects": _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        "location": _propTypes2.default.string.isRequired
	    })),
	    "tileLayer": _propTypes2.default.string
	};
	exports.default = MapBlock;
	module.exports = exports['default'];

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MapBlock = __webpack_require__(526);
	
	var _MapBlock2 = _interopRequireDefault(_MapBlock);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _MapBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(16);
	
	var _ProjectMarkers = __webpack_require__(130);
	
	var _ProjectMarkers2 = _interopRequireDefault(_ProjectMarkers);
	
	var _SliderListBlock = __webpack_require__(243);
	
	var _SliderListBlock2 = _interopRequireDefault(_SliderListBlock);
	
	var _ProjectCard = __webpack_require__(78);
	
	var _ProjectCard2 = _interopRequireDefault(_ProjectCard);
	
	var _Map = __webpack_require__(76);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _MapLocationBlockModule = __webpack_require__(787);
	
	var _MapLocationBlockModule2 = _interopRequireDefault(_MapLocationBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var L = typeof window !== 'undefined' ? __webpack_require__(8) : { latLng: function latLng() {} };
	
	var ProjectsBlock = function (_React$Component) {
	    _inherits(ProjectsBlock, _React$Component);
	
	    function ProjectsBlock() {
	        _classCallCheck(this, ProjectsBlock);
	
	        return _possibleConstructorReturn(this, (ProjectsBlock.__proto__ || Object.getPrototypeOf(ProjectsBlock)).apply(this, arguments));
	    }
	
	    _createClass(ProjectsBlock, [{
	        key: 'activeChanged',
	        value: function activeChanged() {
	            var _this2 = this;
	
	            return function (item) {
	                // trigger callback
	                _this2 && _this2.props && _this2.props.callback && _this2.props.callback.apply(null, [item]);
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var projects = this.props.projects;
	
	            return _react2.default.createElement(_SliderListBlock2.default, { data: projects, callback: this.activeChanged(), Component: _ProjectCard2.default, mode: 'horizontal-list' });
	        }
	    }]);
	
	    return ProjectsBlock;
	}(_react2.default.Component);
	
	ProjectsBlock.propTypes = {
	    projects: _propTypes2.default.array,
	    active: _propTypes2.default.number,
	    callback: _propTypes2.default.func
	};
	
	var MapLocationBlock = function (_React$Component2) {
	    _inherits(MapLocationBlock, _React$Component2);
	
	    function MapLocationBlock() {
	        var _ref;
	
	        var _temp, _this3, _ret;
	
	        _classCallCheck(this, MapLocationBlock);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = MapLocationBlock.__proto__ || Object.getPrototypeOf(MapLocationBlock)).call.apply(_ref, [this].concat(args))), _this3), _this3.flyTo = function (target) {
	            var map = _this3.map.leaflet.leafletElement;
	            if (!target) {
	                target = map.getSize().divideBy(2);
	            }
	            var targetPoint = target.subtract([_this3.projects.clientWidth, 0]),
	                targetLatLng = map.containerPointToLatLng(targetPoint);
	
	            map.flyTo(targetLatLng);
	        }, _temp), _possibleConstructorReturn(_this3, _ret);
	    }
	
	    _createClass(MapLocationBlock, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this4 = this;
	
	            setTimeout(function () {
	                if (_this4.props.projects.length > 0) {
	                    _this4.flyTo();
	                }
	            }, 1);
	        }
	    }, {
	        key: 'projectChanged',
	        value: function projectChanged() {
	            var _this5 = this;
	
	            return function (item) {
	                var map = _this5.map.leaflet.leafletElement;
	                var latlng = item.location.trim().split(",");
	                var zoom = parseInt(item.zoomLevel, 10);
	                if (latlng.length == 2) {
	                    var targetLatLng = L.latLng(parseFloat(latlng[0]), parseFloat(latlng[1]));
	
	                    // Add offset
	
	                    // mobile
	                    var sub = [0, -map._container.clientHeight / 5];
	                    // desktop
	                    if (typeof window !== "undefined" && window.matchMedia("(min-width: 960px)").matches) {
	                        sub = [map._container.clientWidth / 5, 0];
	                    }
	
	                    var targetPoint = map.project(targetLatLng, zoom).subtract(sub);
	                    targetLatLng = map.unproject(targetPoint, zoom);
	
	                    map.flyTo(targetLatLng, zoom);
	                } else {
	                    console.error("Couldn't parse coordinates", item.location);
	                }
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var _props = this.props,
	                header = _props.header,
	                projectsLinkHeading = _props.projectsLinkHeading,
	                projectsLink = _props.projectsLink,
	                projects = _props.projects,
	                tileLayer = _props.tileLayer;
	
	
	            var initialProject = projects.length && projects[0];
	            var initialLocation = initialProject ? initialProject.location.split(',').map(parseFloat) : [64.2869407, 8.784715];
	            var initialZoom = initialProject ? parseInt(initialProject.zoomLevel, 10) : 10;
	
	            return _react2.default.createElement(
	                'div',
	                { className: _MapLocationBlockModule2.default.block },
	                _react2.default.createElement(
	                    'div',
	                    { className: _MapLocationBlockModule2.default.map, id: 'project-list' },
	                    _react2.default.createElement(
	                        _Map2.default,
	                        {
	                            ref: function ref(node) {
	                                return _this6.map = node;
	                            },
	                            center: initialLocation,
	                            zoomLevel: initialZoom,
	                            useZoom: false,
	                            useScroll: false,
	                            style: {
	                                position: 'absolute'
	                            },
	                            options: {
	                                dragging: false,
	                                touchZoom: false,
	                                doubleClickZoom: false,
	                                scrollWheelZoom: false,
	                                boxZoom: false,
	                                keyboard: false,
	                                tap: false
	                            },
	                            tileLayer: tileLayer
	                        },
	                        _react2.default.createElement(_ProjectMarkers2.default, {
	                            projects: projects,
	                            projectStatusLabel: "TOOD status label"
	                            //onMarkerClick={(e,b) => { console.log(e,b)}}
	                            , filterSearch: function filterSearch() {
	                                return true;
	                            },
	                            options: {
	                                disableClusteringAtZoom: 10
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _MapLocationBlockModule2.default["call-to-action"] },
	                        _react2.default.createElement(
	                            _Button2.default,
	                            { tertiary: true, href: projectsLink },
	                            projectsLinkHeading
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { ref: function ref(node) {
	                            return _this6.projects = node;
	                        }, className: _MapLocationBlockModule2.default.projects },
	                    header && _react2.default.createElement(
	                        'h1',
	                        _extends({ className: (0, _classnames2.default)("block-title-large", _MapLocationBlockModule2.default.heading) }, (0, _utils.onPageEditing)("Heading")),
	                        header
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)("project-list", _MapLocationBlockModule2.default["project-list"]) },
	                        projects && projects.length > 0 && _react2.default.createElement(ProjectsBlock, {
	                            projects: projects,
	                            callback: this.projectChanged()
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _MapLocationBlockModule2.default["call-to-action"] },
	                            _react2.default.createElement(
	                                _Button2.default,
	                                { tertiary: true, href: projectsLink },
	                                projectsLinkHeading
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MapLocationBlock;
	}(_react2.default.Component);
	
	MapLocationBlock.propTypes = {
	    "header": _propTypes2.default.string,
	    "projectsLinkHeading": _propTypes2.default.string,
	    "projectsLink": _propTypes2.default.string,
	    "projects": _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        "id": _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	        "name": _propTypes2.default.string.isRequired,
	        "location": _propTypes2.default.string.isRequired,
	        "image": _propTypes2.default.string.isRequired,
	        "zoomLevel": _propTypes2.default.number.isRequired,
	        "division": _propTypes2.default.string,
	        "text": _propTypes2.default.string
	    })),
	    "tileLayer": _propTypes2.default.string
	};
	exports.default = MapLocationBlock;
	module.exports = exports['default'];

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _server = __webpack_require__(329);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _reactLeafletUniversal = __webpack_require__(197);
	
	var _get = __webpack_require__(294);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _utils = __webpack_require__(16);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	__webpack_require__(718);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	if (typeof window !== 'undefined') {
	    var L = __webpack_require__(8);
	
	    delete L.Icon.Default.prototype._getIconUrl;
	
	    L.Icon.Default.mergeOptions({
	        iconAnchor: [9, 9],
	        iconSize: [18, 18],
	        iconRetinaUrl: __webpack_require__(269),
	        iconUrl: __webpack_require__(269),
	        shadowUrl: null
	    });
	}
	
	var Map = function (_React$PureComponent) {
	    _inherits(Map, _React$PureComponent);
	
	    function Map(props) {
	        _classCallCheck(this, Map);
	
	        var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));
	
	        _this.map = null;
	        return _this;
	    }
	
	    _createClass(Map, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            setTimeout(function () {
	                _this2.leaflet && _this2.leaflet.leafletElement.invalidateSize();
	
	                // Fixes issue with dragging still hijacking tap scroll
	                // on mobile
	                if (!_this2.props.dragging) {
	                    var tap = (0, _get2.default)(_this2.leaflet, 'leafletElement.tap');
	                    tap && tap.disable();
	                }
	
	                if (_this2.props.fitMarkers) {
	                    _this2.leaflet.leafletElement.eachLayer(function (layer) {
	                        if (layer._markerCluster) {
	                            _this2.leaflet.leafletElement.fitBounds(layer.getBounds());
	                        }
	                    });
	                }
	            }, 1);
	
	            if (window.matchMedia) {
	                var mediaQueryList = window.matchMedia('print');
	                mediaQueryList.addListener(function (mql) {
	                    if (mql.matches) {
	                        _this2.leaflet && _this2.leaflet.leafletElement.invalidateSize();
	                    }
	                });
	            }
	        }
	    }, {
	        key: '_zoomText',
	        value: function _zoomText(type) {
	            return _server2.default.renderToStaticMarkup(_react2.default.createElement(_Icon2.default, { icon: 'zoom-' + type }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                center = _props.center,
	                children = _props.children,
	                dragging = _props.dragging,
	                zoomLevel = _props.zoomLevel,
	                useZoom = _props.useZoom,
	                options = _props.options,
	                tileLayer = _props.tileLayer;
	
	
	            return _react2.default.createElement(
	                _reactLeafletUniversal.Map,
	                _extends({
	                    leafletRef: function leafletRef(node) {
	                        return _this3.leaflet = node;
	                    },
	                    ref: function ref(node) {
	                        return _this3.map = node;
	                    },
	                    attributionControl: false,
	                    dragging: dragging,
	                    center: center,
	                    maxZoom: 18,
	                    minZoom: 4,
	                    zoom: zoomLevel,
	                    scrollWheelZoom: false,
	                    zoomControl: false,
	                    style: {
	                        position: 'absolute',
	                        top: 0,
	                        left: 0,
	                        right: 0,
	                        bottom: 0,
	                        zIndex: 0,
	                        overflow: 'hidden'
	                    }
	                }, options),
	                _react2.default.createElement(_reactLeafletUniversal.TileLayer, { url: tileLayer, useCache: true }),
	                children,
	                useZoom && _react2.default.createElement(_reactLeafletUniversal.ZoomControl, {
	                    zoomInText: this._zoomText('in'),
	                    zoomOutText: this._zoomText('out'),
	                    position: 'bottomright'
	                })
	            );
	        }
	    }]);
	
	    return Map;
	}(_react2.default.PureComponent);
	
	Map.propTypes = {
	    center: _propTypes2.default.array.isRequired,
	    children: _propTypes2.default.node,
	    dragging: _propTypes2.default.bool.isRequired,
	    zoomLevel: _propTypes2.default.number.isRequired,
	    options: _propTypes2.default.object,
	    useZoom: _propTypes2.default.bool,
	    useScroll: _propTypes2.default.bool,
	    tileLayer: _propTypes2.default.string.isRequired,
	    fitMarkers: _propTypes2.default.bool.isRequired
	};
	Map.defaultProps = {
	    center: [64.0655524, 13.7175499],
	    dragging: !(0, _utils.isTouchDevice)(),
	    zoomLevel: 5,
	    useZoom: true,
	    options: {},
	    fitMarkers: false
	};
	exports.default = Map;
	module.exports = exports['default'];

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLeafletUniversal = __webpack_require__(197);
	
	var _utils = __webpack_require__(16);
	
	var _ProjectCard = __webpack_require__(78);
	
	var _ProjectCard2 = _interopRequireDefault(_ProjectCard);
	
	__webpack_require__(719);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Marker = function (_React$Component) {
	    _inherits(Marker, _React$Component);
	
	    function Marker() {
	        _classCallCheck(this, Marker);
	
	        return _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).apply(this, arguments));
	    }
	
	    _createClass(Marker, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                emphasize = _props.emphasize,
	                location = _props.location,
	                project = _props.project,
	                title = _props.title;
	
	
	            return _react2.default.createElement(
	                _reactLeafletUniversal.Marker,
	                {
	                    icon: (0, _utils.markerIcon)(project, emphasize, title),
	                    position: location.split(",").map(parseFloat)
	                },
	                children,
	                project && _react2.default.createElement(
	                    _reactLeafletUniversal.Popup,
	                    null,
	                    _react2.default.createElement(_ProjectCard2.default, _extends({}, project, {
	                        address: null,
	                        compact: true,
	                        view: 'grid',
	                        displayText: false
	                    }))
	                )
	            );
	        }
	    }]);
	
	    return Marker;
	}(_react2.default.Component);
	
	Marker.propTypes = {
	    location: _propTypes2.default.string.isRequired,
	    project: _propTypes2.default.object,
	    children: _propTypes2.default.node,
	    emphasize: _propTypes2.default.bool,
	    title: _propTypes2.default.string.isRequired
	};
	exports.default = Marker;
	module.exports = exports['default'];

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Marker = exports.default = undefined;
	
	var _Marker2 = __webpack_require__(530);
	
	var _Marker3 = _interopRequireDefault(_Marker2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Marker3.default;
	exports.Marker = _Marker3.default;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(38);
	
	var _MediaWrapperModule = __webpack_require__(788);
	
	var _MediaWrapperModule2 = _interopRequireDefault(_MediaWrapperModule);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MediaWrapper = function MediaWrapper(_ref) {
	    var children = _ref.children,
	        media = _ref.media,
	        stickyDuration = _ref.stickyDuration,
	        theme = _ref.theme,
	        gradient = _ref.gradient,
	        isLandingPage = _ref.isLandingPage,
	        hasGradient = _ref.hasGradient,
	        className = _ref.className,
	        bottomAligned = _ref.bottomAligned;
	
	    var fixedStyle = stickyDuration ? { height: 100 + stickyDuration + "vh" } : {};
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_MediaWrapperModule2.default.mediaWrapper, className, _defineProperty({}, _MediaWrapperModule2.default.isLandingPage, isLandingPage)),
	            style: fixedStyle },
	        _react2.default.createElement(_Media.Media, _extends({}, media, { gradient: gradient, theme: theme, hasGradient: hasGradient })),
	        _react2.default.createElement(
	            "div",
	            {
	                className: (0, _classnames2.default)(_MediaWrapperModule2.default.childWrapper, _defineProperty({}, _MediaWrapperModule2.default.bottomAligned, bottomAligned))
	            },
	            children
	        )
	    );
	};
	
	MediaWrapper.themes = _Media.Media.themes;
	MediaWrapper.gradients = _Media.Media.gradients;
	
	MediaWrapper.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
	    theme: _propTypes2.default.string,
	    media: _propTypes2.default.object,
	    gradient: _propTypes2.default.string,
	    stickyDuration: _propTypes2.default.number,
	    isLandingPage: _propTypes2.default.bool,
	    hasGradient: _propTypes2.default.bool,
	    bottomAligned: _propTypes2.default.bool,
	    className: _propTypes2.default.string
	};
	
	exports.default = MediaWrapper;
	module.exports = exports["default"];

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Media = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _debounce = __webpack_require__(53);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _OnScreen = __webpack_require__(31);
	
	var _OnScreen2 = _interopRequireDefault(_OnScreen);
	
	var _FancyImage = __webpack_require__(222);
	
	var _FancyImage2 = _interopRequireDefault(_FancyImage);
	
	var _Video = __webpack_require__(599);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _MediaModule = __webpack_require__(789);
	
	var _MediaModule2 = _interopRequireDefault(_MediaModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Media = exports.Media = function (_React$Component) {
	    _inherits(Media, _React$Component);
	
	    function Media() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Media);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Media.__proto__ || Object.getPrototypeOf(Media)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            isMobile: false
	        }, _this._debouncedUpdatePredicate = (0, _debounce2.default)(function () {
	            _this.setState({
	                isMobile: window && window.innerWidth < 960
	            });
	        }, 300), _this.componentWillUnmount = function () {
	            window.removeEventListener("resize", _this._debouncedUpdatePredicate);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Media, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this._debouncedUpdatePredicate();
	
	            window.addEventListener("resize", this._debouncedUpdatePredicate);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _cn;
	
	            var _props = this.props,
	                onScreen = _props.onScreen,
	                video = _props.video,
	                style = _props.style,
	                alt = _props.alt,
	                image = _props.image,
	                imageMobile = _props.imageMobile,
	                theme = _props.theme,
	                gradient = _props.gradient,
	                className = _props.className,
	                hasGradient = _props.hasGradient;
	            var isMobile = this.state.isMobile;
	
	            var imageProps = {
	                alt: alt || "",
	                image: image,
	                imageMobile: imageMobile,
	                theme: theme,
	                isMobile: isMobile,
	                gradient: gradient
	            };
	            return _react2.default.createElement(
	                "div",
	                {
	                    style: style,
	                    className: (0, _classnames2.default)(_MediaModule2.default.media, (_cn = {}, _defineProperty(_cn, _MediaModule2.default.visible, onScreen), _defineProperty(_cn, className, className), _cn))
	                },
	                onScreen && (video && video.length > 0 ? _react2.default.createElement(_Video2.default, {
	                    videos: video,
	                    isMobile: isMobile,
	                    fallbackImage: imageProps,
	                    isFixed: theme === _FancyImage2.default.themes.fixed,
	                    hasGradient: hasGradient
	                }) : image && _react2.default.createElement(_FancyImage2.default, imageProps))
	            );
	        }
	    }]);
	
	    return Media;
	}(_react2.default.Component);
	
	Media.propTypes = {
	    video: _propTypes2.default.array,
	    image: _propTypes2.default.string,
	    imageMobile: _propTypes2.default.string,
	    alt: _propTypes2.default.string,
	    onScreen: _propTypes2.default.bool,
	    style: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    theme: _propTypes2.default.string,
	    gradient: _propTypes2.default.string,
	    hasGradient: _propTypes2.default.bool
	};
	Media.themes = _FancyImage2.default.themes;
	Media.gradients = _FancyImage2.default.gradients;
	Media.defaultProps = {
	    onScreen: true,
	    hasGradient: true
	};
	exports.default = (0, _OnScreen2.default)(Media);

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPortal = __webpack_require__(1057);
	
	var _reactPortal2 = _interopRequireDefault(_reactPortal);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SupportingMenu = __webpack_require__(245);
	
	var _SupportingMenu2 = _interopRequireDefault(_SupportingMenu);
	
	var _cross = __webpack_require__(840);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	var _MobileMenuModule = __webpack_require__(790);
	
	var _MobileMenuModule2 = _interopRequireDefault(_MobileMenuModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockMenu = function (_React$Component) {
	    _inherits(BlockMenu, _React$Component);
	
	    function BlockMenu() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, BlockMenu);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BlockMenu.__proto__ || Object.getPrototypeOf(BlockMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            open: false
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(BlockMenu, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                link = _props.link,
	                linkText = _props.linkText,
	                menuItems = _props.menuItems;
	            var open = this.state.open;
	
	
	            return _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'header',
	                    null,
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        link ? _react2.default.createElement(
	                            'a',
	                            { href: link },
	                            linkText
	                        ) : linkText
	                    ),
	                    menuItems && menuItems.length > 0 && _react2.default.createElement(
	                        'button',
	                        { onClick: function onClick() {
	                                return _this2.setState({ open: !open });
	                            } },
	                        open ? '-' : '+'
	                    )
	                ),
	                menuItems && menuItems.length > 0 && _react2.default.createElement(
	                    'ul',
	                    { className: _MobileMenuModule2.default.yadda, style: { display: open ? 'block' : 'none' } },
	                    menuItems.map(function (item, i) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: i },
	                            _react2.default.createElement(
	                                'a',
	                                { href: item.href },
	                                item.text
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return BlockMenu;
	}(_react2.default.Component);
	
	BlockMenu.propTypes = {
	    link: _propTypes2.default.string,
	    linkText: _propTypes2.default.string,
	    menuItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        href: _propTypes2.default.string,
	        text: _propTypes2.default.string
	    }))
	};
	
	var MobileMenu = function (_React$PureComponent) {
	    _inherits(MobileMenu, _React$PureComponent);
	
	    function MobileMenu() {
	        var _ref2;
	
	        var _temp2, _this3, _ret2;
	
	        _classCallCheck(this, MobileMenu);
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = MobileMenu.__proto__ || Object.getPrototypeOf(MobileMenu)).call.apply(_ref2, [this].concat(args))), _this3), _this3.state = {
	            active: null
	        }, _this3._handleOnClick = function (e) {
	            var index = e.currentTarget.dataset.index;
	            var active = _this3.state.active;
	
	
	            if (active == index) {
	                _this3.setState({ active: null });
	            } else {
	                _this3.setState({ active: index });
	            }
	        }, _this3.onClick = function (id) {
	            _this3.setState({ isActive: _this3.state.isActive === id ? null : id });
	        }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	    }
	
	    _createClass(MobileMenu, [{
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _props2 = this.props,
	                menu = _props2.menu,
	                supportingMenu = _props2.supportingMenu,
	                open = _props2.open,
	                closeMenu = _props2.closeMenu,
	                searchLink = _props2.searchLink,
	                languages = _props2.languages,
	                searchLabel = _props2.searchLabel,
	                withCustomLogo = _props2.withCustomLogo,
	                openQuickSearchFormBtnAriaLabel = _props2.openQuickSearchFormBtnAriaLabel,
	                closeQuickSearchFormBtnAriaLabel = _props2.closeQuickSearchFormBtnAriaLabel;
	            var _state = this.state,
	                isActive = _state.isActive,
	                active = _state.active;
	
	
	            return _react2.default.createElement(
	                _reactPortal2.default,
	                { isOpened: open },
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)(_MobileMenuModule2.default.menu, {
	                            "with-custom-logo": withCustomLogo
	                        })
	                    },
	                    _react2.default.createElement(
	                        'nav',
	                        null,
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            menu.map(function (m, i) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: i, className: _MobileMenuModule2.default.item },
	                                    _react2.default.createElement(
	                                        'header',
	                                        null,
	                                        _react2.default.createElement(
	                                            'h1',
	                                            null,
	                                            m.link ? _react2.default.createElement(
	                                                'a',
	                                                { href: m.link },
	                                                m.linkText
	                                            ) : m.linkText
	                                        ),
	                                        m.columns && m.columns.length > 0 && _react2.default.createElement(
	                                            'button',
	                                            {
	                                                'data-index': i,
	                                                onClick: _this4._handleOnClick
	                                            },
	                                            active == i ? '-' : '+'
	                                        )
	                                    ),
	                                    m.columns && m.columns.length > 0 && m.columns.map(function (column, ci) {
	                                        return _react2.default.createElement(
	                                            'ul',
	                                            { key: ci, style: { display: active == i ? 'block' : 'none' } },
	                                            column.map(function (block, i) {
	                                                return _react2.default.createElement(BlockMenu, _extends({
	                                                    key: i
	                                                }, block));
	                                            })
	                                        );
	                                    })
	                                );
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(_SupportingMenu2.default, {
	                        menu: supportingMenu,
	                        searchLabel: searchLabel,
	                        searchLink: searchLink,
	                        languages: languages,
	                        onClick: this.onClick,
	                        isActiveOnMobile: true,
	                        isActive: isActive,
	                        withCustomLogo: withCustomLogo,
	                        openQuickSearchFormBtnAriaLabel: openQuickSearchFormBtnAriaLabel,
	                        closeQuickSearchFormBtnAriaLabel: closeQuickSearchFormBtnAriaLabel
	                    }),
	                    _react2.default.createElement(
	                        'button',
	                        { className: _MobileMenuModule2.default.close, onClick: closeMenu },
	                        _react2.default.createElement('img', { src: _cross2.default })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MobileMenu;
	}(_react2.default.PureComponent);
	
	MobileMenu.propTypes = {
	    open: _propTypes2.default.bool.isRequired,
	    closeMenu: _propTypes2.default.func.isRequired,
	    menu: _propTypes2.default.array,
	    supportingMenu: _propTypes2.default.array,
	    searchLink: _propTypes2.default.string.isRequired,
	    languages: _propTypes2.default.array,
	    searchLabel: _propTypes2.default.string.isRequired,
	    withCustomLogo: _propTypes2.default.bool,
	    openQuickSearchFormBtnAriaLabel: _propTypes2.default.string.isRequired,
	    closeQuickSearchFormBtnAriaLabel: _propTypes2.default.string.isRequired
	};
	exports.default = MobileMenu;
	module.exports = exports['default'];

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _MobileMenu = __webpack_require__(534);
	
	var _MobileMenu2 = _interopRequireDefault(_MobileMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MobileMenu2.default;
	module.exports = exports['default'];

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPerson = {};
	
	ContactPerson.propTypes = {
	    onPageEditing: _propTypes2.default.bool,
	    person: _propTypes2.default.shape({
	        firstName: _propTypes2.default.string,
	        lastName: _propTypes2.default.string,
	        emailAddress: _propTypes2.default.string,
	        title: _propTypes2.default.string,
	        profilePicture: _propTypes2.default.string,
	        department: _propTypes2.default.string,
	        phone: _propTypes2.default.string
	    }),
	    contactLength: _propTypes2.default.number,
	    size: _propTypes2.default.string,
	    sendEmailLabel: _propTypes2.default.string,
	    hideEmailAddress: _propTypes2.default.bool,
	    small: _propTypes2.default.bool
	};
	
	exports.default = ContactPerson;
	module.exports = exports['default'];

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Link = __webpack_require__(26);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LanguageLink = {};
	
	LanguageLink.propTypes = Object.assign({}, _Link2.default.propTypes, {
	    isActive: _propTypes2.default.bool
	});
	
	exports.default = LanguageLink;
	module.exports = exports['default'];

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Video = {};
	
	Video.propTypes = {
	    src: _propTypes2.default.string,
	    poster: _propTypes2.default.string
	};
	
	exports.default = Video;
	module.exports = exports['default'];

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ImageFigure = __webpack_require__(236);
	
	var _ImageFigure2 = _interopRequireDefault(_ImageFigure);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(720);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NewImageBlock = function NewImageBlock(_ref) {
	    var _cn;
	
	    var image = _ref.image,
	        inRichText = _ref.inRichText,
	        className = _ref.className;
	
	    {/* BE: Recommended width of the image in the content area is 2400px */}
	    {/* BE: Recommended width of the image in the rich text block is 1560px */}
	    return image ? _react2.default.createElement(
	        'div',
	        {
	            className: (0, _classnames2.default)("new-image-block", (_cn = {}, _defineProperty(_cn, className, className), _defineProperty(_cn, "new-image-block_in-rich-text", inRichText), _cn))
	        },
	        _react2.default.createElement(
	            'figure',
	            { className: 'new-image-block__container' },
	            _react2.default.createElement('img', { src: image.url, alt: image.altText, className: 'new-image-block__image' }),
	            (image.caption || image.photographer) && _react2.default.createElement(
	                'figcaption',
	                { className: 'new-image-block__caption' },
	                image.caption && _react2.default.createElement(
	                    'span',
	                    { className: 'new-image-block__caption-text' },
	                    image.caption
	                ),
	                image.photographer && _react2.default.createElement(
	                    'span',
	                    { className: 'new-image-block__caption-photographer' },
	                    image.photographer
	                )
	            )
	        )
	    ) : null;
	};
	
	NewImageBlock.propTypes = {
	    className: _propTypes2.default.string,
	    inRichText: _propTypes2.default.bool,
	    image: _propTypes2.default.shape(_ImageFigure2.default.propTypes).isRequired
	};
	
	exports.default = NewImageBlock;
	module.exports = exports['default'];

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _NewsBlockModule = __webpack_require__(791);
	
	var _NewsBlockModule2 = _interopRequireDefault(_NewsBlockModule);
	
	var _FluidImage = __webpack_require__(30);
	
	var _FluidImage2 = _interopRequireDefault(_FluidImage);
	
	var _OnScreen = __webpack_require__(31);
	
	var _OnScreen2 = _interopRequireDefault(_OnScreen);
	
	var _Published = __webpack_require__(131);
	
	var _Published2 = _interopRequireDefault(_Published);
	
	var _FeatureArticleTag = __webpack_require__(223);
	
	var _FeatureArticleTag2 = _interopRequireDefault(_FeatureArticleTag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NewsBlock = function NewsBlock(_ref) {
	    var _cn;
	
	    var image = _ref.image,
	        title = _ref.title,
	        intro = _ref.intro,
	        link = _ref.link,
	        published = _ref.published,
	        publishedLabel = _ref.publishedLabel,
	        frontpage = _ref.frontpage,
	        horizontal = _ref.horizontal,
	        onScreen = _ref.onScreen,
	        shouldHaveFeatureArticleTag = _ref.shouldHaveFeatureArticleTag;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_NewsBlockModule2.default['news-block'], (_cn = {}, _defineProperty(_cn, _NewsBlockModule2.default.frontpage, frontpage), _defineProperty(_cn, _NewsBlockModule2.default.horizontal, horizontal), _cn)) },
	        _react2.default.createElement(
	            'a',
	            { className: _NewsBlockModule2.default.link, href: link },
	            _react2.default.createElement(_FluidImage2.default, {
	                className: _NewsBlockModule2.default.image,
	                image: image,
	                visible: onScreen
	            }),
	            shouldHaveFeatureArticleTag && _react2.default.createElement(_FeatureArticleTag2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _NewsBlockModule2.default.text },
	            _react2.default.createElement(
	                'a',
	                { href: link, className: _NewsBlockModule2.default.heading },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    title
	                )
	            ),
	            intro && _react2.default.createElement(
	                'p',
	                { className: _NewsBlockModule2.default.paragraph },
	                intro
	            ),
	            published && _react2.default.createElement(_Published2.default, { label: publishedLabel, date: published })
	        )
	    );
	};
	
	NewsBlock.propTypes = {
	    image: _propTypes2.default.string.isRequired,
	    title: _propTypes2.default.string.isRequired,
	    intro: _propTypes2.default.string,
	    published: _propTypes2.default.string,
	    link: _propTypes2.default.string.isRequired,
	    publishedLabel: _propTypes2.default.string,
	    blockId: _propTypes2.default.number,
	    frontpage: _propTypes2.default.bool.isRequired,
	    onScreen: _propTypes2.default.bool.isRequired,
	    horizontal: _propTypes2.default.bool,
	    shouldHaveFeatureArticleTag: _propTypes2.default.bool
	};
	
	NewsBlock.defaultProps = {
	    frontpage: false
	};
	
	exports.default = (0, _OnScreen2.default)(NewsBlock);
	module.exports = exports['default'];

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _NewsBlock = __webpack_require__(540);
	
	var _NewsBlock2 = _interopRequireDefault(_NewsBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NewsBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _NewsBlock = __webpack_require__(541);
	
	var _NewsBlock2 = _interopRequireDefault(_NewsBlock);
	
	var _OnPageEditing = __webpack_require__(21);
	
	var _OnPageEditing2 = _interopRequireDefault(_OnPageEditing);
	
	var _NewsListBlockModule = __webpack_require__(792);
	
	var _NewsListBlockModule2 = _interopRequireDefault(_NewsListBlockModule);
	
	var _themes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NewsListBlock = function NewsListBlock(_ref) {
	    var _cn;
	
	    var blockId = _ref.blockId,
	        header = _ref.header,
	        description = _ref.description,
	        readMoreLink = _ref.readMoreLink,
	        readMoreText = _ref.readMoreText,
	        articles = _ref.articles,
	        publishedLabel = _ref.publishedLabel,
	        theme = _ref.theme,
	        showReadMore = _ref.showReadMore,
	        frontpage = _ref.frontpage,
	        horizontal = _ref.horizontal;
	    return _react2.default.createElement(
	        'div',
	        {
	            className: (0, _classnames2.default)(_NewsListBlockModule2.default['newslist-block'], (0, _themes.getThemeClassNames)(_NewsListBlockModule2.default, theme), (_cn = {}, _defineProperty(_cn, _NewsListBlockModule2.default.frontpage, frontpage), _defineProperty(_cn, _NewsListBlockModule2.default.horizontal, horizontal), _cn)),
	            'data-block': blockId
	        },
	        _react2.default.createElement(
	            'header',
	            null,
	            _react2.default.createElement(
	                _OnPageEditing2.default,
	                { property: 'Header' },
	                _react2.default.createElement(
	                    'h2',
	                    { className: _NewsListBlockModule2.default['block-heading'] },
	                    header
	                )
	            ),
	            _react2.default.createElement(
	                _OnPageEditing2.default,
	                { property: 'Description' },
	                description && _react2.default.createElement(
	                    'p',
	                    { className: _NewsListBlockModule2.default.description },
	                    description
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'ul',
	            { className: _NewsListBlockModule2.default.articles },
	            articles.length > 0 && articles.map(function (news, i) {
	                return _react2.default.createElement(
	                    'li',
	                    { key: i },
	                    _react2.default.createElement(_NewsBlock2.default, _extends({
	                        key: i,
	                        publishedLabel: publishedLabel,
	                        frontpage: frontpage,
	                        horizontal: horizontal
	                    }, news))
	                );
	            })
	        ),
	        _react2.default.createElement(
	            _OnPageEditing2.default,
	            { property: 'ReadMoreLink' },
	            showReadMore && readMoreText && readMoreLink && _react2.default.createElement(
	                _Button2.default,
	                _extends({ href: readMoreLink, secondary: true }, { light: theme === _themes.THEMES.darkgray }),
	                readMoreText
	            )
	        )
	    );
	};
	
	NewsListBlock.propTypes = {
	    frontpage: _propTypes2.default.bool.isRequired,
	    blockId: _propTypes2.default.number.isRequired,
	    header: _propTypes2.default.string,
	    description: _propTypes2.default.string,
	    readMoreLink: _propTypes2.default.string,
	    readMoreText: _propTypes2.default.string,
	    articles: _propTypes2.default.array.isRequired,
	    publishedLabel: _propTypes2.default.string,
	    theme: _propTypes2.default.oneOf(Object.keys(_themes.THEMES).map(function (s) {
	        return _themes.THEMES[s];
	    })),
	    showReadMore: _propTypes2.default.bool.isRequired,
	    horizontal: _propTypes2.default.bool
	};
	
	NewsListBlock.defaultProps = {
	    showReadMore: true,
	    theme: 0,
	    horizontal: false,
	    frontpage: false
	};
	
	exports.default = NewsListBlock;
	module.exports = exports['default'];

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OnPageEditing = function (_React$PureComponent) {
	    _inherits(OnPageEditing, _React$PureComponent);
	
	    function OnPageEditing() {
	        _classCallCheck(this, OnPageEditing);
	
	        return _possibleConstructorReturn(this, (OnPageEditing.__proto__ || Object.getPrototypeOf(OnPageEditing)).apply(this, arguments));
	    }
	
	    _createClass(OnPageEditing, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.debug && this.node) {
	                this.node.setAttribute('style', 'border: solid 1px #26caff');
	            }
	        }
	    }, {
	        key: '_dataProps',
	        value: function _dataProps() {
	            var _this2 = this;
	
	            return {
	                "ref": function ref(node) {
	                    return _this2.node = node;
	                },
	                "data-epi-property-name": this.props.property,
	                "data-epi-use-mvc": "True",
	                "data-epi-property-edittype": this.props.editType || null
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                active = _props.active,
	                children = _props.children,
	                property = _props.property,
	                component = _props.component;
	
	
	            if (!children) return null;
	
	            if (component) {
	                return _react2.default.createElement(component, _extends({}, this._dataProps()), children);
	            }
	
	            if (active && property && !!children) {
	                return _react2.default.cloneElement(children, _extends({}, this._dataProps()));
	            }
	
	            return children;
	        }
	    }]);
	
	    return OnPageEditing;
	}(_react2.default.PureComponent);
	
	OnPageEditing.defaultProps = {
	    active: true,
	    debug: false
	};
	OnPageEditing.propTypes = {
	    active: _propTypes2.default.bool.isRequired,
	    children: _propTypes2.default.any,
	    component: _propTypes2.default.string,
	    debug: _propTypes2.default.bool.isRequired,
	    editType: _propTypes2.default.string,
	    property: _propTypes2.default.string.isRequired
	};
	exports.default = OnPageEditing;
	module.exports = exports['default'];

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _throttle = __webpack_require__(70);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function OnScreen(WrappedComponent) {
	    var OnScreenWrapper = function (_React$PureComponent) {
	        _inherits(OnScreenWrapper, _React$PureComponent);
	
	        function OnScreenWrapper() {
	            var _ref;
	
	            var _temp, _this, _ret;
	
	            _classCallCheck(this, OnScreenWrapper);
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OnScreenWrapper.__proto__ || Object.getPrototypeOf(OnScreenWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	                onScreen: false
	            }, _this.isElementInViewport = function (el) {
	                var rect = el.getBoundingClientRect();
	                var windowHeight = typeof window !== "undefined" && window.innerHeight || document && document.documentElement.clientHeight;
	                var windowWidth = typeof window !== "undefined" && window.innerWidth || document && document.documentElement.clientWidth;
	
	                // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
	                var vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
	                var horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
	
	                return vertInView && horInView;
	            }, _this.scrollHandler = (0, _throttle2.default)(function () {
	                if (_this.unmounting || !_this.component) {
	                    return;
	                }
	
	                if (_this.isElementInViewport(_this.component)) {
	                    _this._isInViewport();
	                }
	            }, 300), _this._isInViewport = function () {
	                _this.setState({ onScreen: true });
	                window.removeEventListener("scroll", _this.scrollHandler, true);
	                window.removeEventListener("OnScreenTrigger", _this.scrollHandler, true);
	            }, _temp), _possibleConstructorReturn(_this, _ret);
	        }
	
	        _createClass(OnScreenWrapper, [{
	            key: "componentDidMount",
	            value: function componentDidMount() {
	                var _this2 = this;
	
	                this.unmounting = false;
	
	                window.addEventListener("OnScreenTrigger", this.scrollHandler, true);
	                window.addEventListener("scroll", this.scrollHandler, true);
	                // Make scroll handler run before scrolling starts in order to show elements already on the screen
	                this.scrollHandler();
	
	                if (window.matchMedia) {
	                    var mediaQueryList = window.matchMedia("print");
	                    mediaQueryList.addListener(function (mql) {
	                        if (mql.matches && !_this2.state.onScreen) {
	                            _this2._isInViewport();
	                        }
	                    });
	                }
	
	                window.onbeforeprint = function () {
	                    return !_this2.state.onScreen && _this2._isInViewport();
	                };
	            }
	        }, {
	            key: "componentWillUnmount",
	            value: function componentWillUnmount() {
	                this.unmounting = true;
	                if (typeof window !== "undefined") {
	                    window.removeEventListener("scroll", this.scrollHandler);
	                    window.removeEventListener("OnScreenTrigger", this.scrollHandler, true);
	                }
	            }
	        }, {
	            key: "render",
	            value: function render() {
	                var _this3 = this;
	
	                return _react2.default.createElement(
	                    "span",
	                    { ref: function ref(s) {
	                            return _this3.component = s;
	                        } },
	                    _react2.default.createElement(WrappedComponent, _extends({
	                        onScreen: this.state.onScreen
	                    }, this.props))
	                );
	            }
	        }]);
	
	        return OnScreenWrapper;
	    }(_react2.default.PureComponent);
	
	    var _WrappedComponent$pro = WrappedComponent.propTypes,
	        onScreen = _WrappedComponent$pro.onScreen,
	        propTypes = _objectWithoutProperties(_WrappedComponent$pro, ["onScreen"]);
	
	    if (WrappedComponent.propTypes) {
	        OnScreenWrapper.propTypes = propTypes;
	    }
	    if (WrappedComponent.themes) {
	        OnScreenWrapper.themes = WrappedComponent.themes;
	    }
	    if (WrappedComponent.gradients) {
	        OnScreenWrapper.gradients = WrappedComponent.gradients;
	    }
	
	    return OnScreenWrapper;
	}
	
	exports.default = OnScreen;
	module.exports = exports["default"];

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PaginatorBlockModule = __webpack_require__(793);
	
	var _PaginatorBlockModule2 = _interopRequireDefault(_PaginatorBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaginatorBlock = function (_React$Component) {
	    _inherits(PaginatorBlock, _React$Component);
	
	    function PaginatorBlock(props) {
	        _classCallCheck(this, PaginatorBlock);
	
	        var _this = _possibleConstructorReturn(this, (PaginatorBlock.__proto__ || Object.getPrototypeOf(PaginatorBlock)).call(this, props));
	
	        _this._handleClick = function (e) {
	            var page = e.currentTarget.dataset.page;
	
	            _this.props.onPageChange(parseInt(page));
	        };
	
	        return _this;
	    }
	
	    _createClass(PaginatorBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                pages = _props.pages,
	                currentPage = _props.currentPage,
	                prevButtonLabel = _props.prevButtonLabel,
	                nextButtonLabel = _props.nextButtonLabel;
	
	
	            var maxVisiblePagesAmount = 5;
	            var pagesAmount = pages;
	            var currentPageIndex = currentPage;
	
	            var allPagesAreVisibe = maxVisiblePagesAmount >= pagesAmount;
	            var visibilityRange = Math.floor(maxVisiblePagesAmount / 2);
	            var leftBoundary = currentPageIndex <= visibilityRange + 1;
	            var rightBoundary = currentPageIndex >= pagesAmount - visibilityRange;
	
	            var paginationArray = [];
	
	            for (var pageIndex = 1; pageIndex < pagesAmount + 1; pageIndex++) {
	                var visible = false;
	
	                if (allPagesAreVisibe) {
	                    visible = true;
	                } else if (leftBoundary) {
	
	                    visible = pageIndex <= maxVisiblePagesAmount;
	                } else if (rightBoundary) {
	                    visible = pageIndex > pagesAmount - maxVisiblePagesAmount;
	                } else {
	                    visible = Math.abs(currentPageIndex - pageIndex) <= visibilityRange;
	                }
	
	                var li = void 0;
	
	                if (visible) {
	
	                    li = _react2.default.createElement(
	                        'li',
	                        { key: pageIndex, className: 'pagination__item' },
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                className: (0, _classnames2.default)("pagination__button", {
	                                    "pagination__button_active": pageIndex === currentPageIndex
	                                }),
	                                'data-page': pageIndex,
	                                onClick: pageIndex === currentPageIndex ? null : this._handleClick
	                            },
	                            pageIndex
	                        )
	                    );
	                }
	
	                paginationArray.push(li);
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: _PaginatorBlockModule2.default.block },
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'pagination' },
	                    !allPagesAreVisibe && !leftBoundary && _react2.default.createElement(
	                        'li',
	                        { className: 'pagination__item pagination__item_prev' },
	                        _react2.default.createElement('button', {
	                            className: 'pagination__button pagination__button_prev',
	                            'data-page': currentPage - 1,
	                            onClick: this._handleClick,
	                            'aria-label': prevButtonLabel ? prevButtonLabel : "Previous"
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pagination__button-dots' },
	                            '...'
	                        )
	                    ),
	                    paginationArray,
	                    !allPagesAreVisibe && !rightBoundary && _react2.default.createElement(
	                        'li',
	                        { className: 'pagination__item pagination__item_prev' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pagination__button-dots' },
	                            '...'
	                        ),
	                        _react2.default.createElement('button', {
	                            className: 'pagination__button pagination__button_next',
	                            'data-page': currentPage + 1,
	                            onClick: this._handleClick,
	                            'aria-label': nextButtonLabel ? nextButtonLabel : "Next"
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PaginatorBlock;
	}(_react2.default.Component);
	
	PaginatorBlock.propTypes = {
	    pages: _propTypes2.default.number,
	    currentPage: _propTypes2.default.number,
	    onPageChange: _propTypes2.default.func.isRequired,
	    prevButtonLabel: _propTypes2.default.string,
	    nextButtonLabel: _propTypes2.default.string
	};
	exports.default = PaginatorBlock;
	module.exports = exports['default'];

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PhotoCreditModule = __webpack_require__(794);
	
	var _PhotoCreditModule2 = _interopRequireDefault(_PhotoCreditModule);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var PhotoCredit = function PhotoCredit(_ref) {
	    var label = _ref.label,
	        text = _ref.text,
	        className = _ref.className;
	
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_PhotoCreditModule2.default.photographer, _defineProperty({}, className, className)) },
	        label && _react2.default.createElement(
	            "span",
	            null,
	            label,
	            ":",
	            ' '
	        ),
	        text
	    );
	};
	
	PhotoCredit.propTypes = {
	    label: _propTypes2.default.string,
	    text: _propTypes2.default.string,
	    className: _propTypes2.default.string
	};
	
	exports.default = PhotoCredit;
	module.exports = exports["default"];

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _PhotoCredit = __webpack_require__(546);
	
	var _PhotoCredit2 = _interopRequireDefault(_PhotoCredit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PhotoCredit2.default;
	module.exports = exports['default'];

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PaginatorBlock = __webpack_require__(128);
	
	var _PaginatorBlock2 = _interopRequireDefault(_PaginatorBlock);
	
	var _PressReleaseBlockModule = __webpack_require__(795);
	
	var _PressReleaseBlockModule2 = _interopRequireDefault(_PressReleaseBlockModule);
	
	var _debounce = __webpack_require__(53);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Media = __webpack_require__(38);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _DropdownFilter = __webpack_require__(58);
	
	var _DropdownFilter2 = _interopRequireDefault(_DropdownFilter);
	
	var _TableBlock = __webpack_require__(133);
	
	var _TableBlock2 = _interopRequireDefault(_TableBlock);
	
	var _ContactBlock = __webpack_require__(98);
	
	var _ContactBlock2 = _interopRequireDefault(_ContactBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEBOUNCE_DURATION = 500;
	
	var PressReleaseBlock = function (_React$Component) {
	    _inherits(PressReleaseBlock, _React$Component);
	
	    function PressReleaseBlock() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PressReleaseBlock);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PressReleaseBlock.__proto__ || Object.getPrototypeOf(PressReleaseBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            month: undefined,
	            year: undefined,
	            division: _this.props.initialDivision,
	            articles: _this.props.articles,
	            page: 1,
	            pageSize: _this.props.defaultPageSize,
	            language: _this.props.language,
	            searching: false
	        }, _this.pageChange = function (page) {
	            _this.setState({
	                page: page
	            }, _this._debouncedFilterItems);
	        }, _this._yearFilter = function (e, value) {
	            _this.setState({
	                page: 1,
	                year: value ? value : undefined
	            }, _this._debouncedFilterItems);
	        }, _this._monthFilter = function (e, value) {
	            _this.setState({
	                page: 1,
	                month: value ? value : undefined
	            }, _this._debouncedFilterItems);
	        }, _this._divisionFilter = function (e, value) {
	            _this.setState({
	                page: 1,
	                division: value
	            }, _this._debouncedFilterItems);
	        }, _this._filterItems = function () {
	            var filter = _extends({}, _this.state);
	
	            var search = function search() {
	                window.fetch(_this.props.apiUrl, {
	                    headers: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json'
	                    },
	                    credentials: 'same-origin',
	                    method: 'POST',
	                    body: JSON.stringify(filter)
	                }).then(function (res) {
	                    if (!res.ok) {
	                        _this.setState({
	                            searching: false
	                        });
	
	                        return console.error(res);
	                    }
	
	                    res.json().then(function (json) {
	                        _this.setState({
	                            articles: json,
	                            searching: false
	                        });
	                    });
	                }).catch(function (err) {
	                    console.error(err);
	
	                    _this.setState({
	                        searching: false
	                    });
	                });
	            };
	
	            _this.setState({
	                searching: true
	            }, search);
	        }, _this._debouncedFilterItems = (0, _debounce2.default)(_this._filterItems, DEBOUNCE_DURATION), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PressReleaseBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                parentHeading = _props.parentHeading,
	                parentLink = _props.parentLink,
	                heading = _props.heading,
	                months = _props.months,
	                monthsHeading = _props.monthsHeading,
	                years = _props.years,
	                yearsHeading = _props.yearsHeading,
	                divisions = _props.divisions,
	                divisionsHeading = _props.divisionsHeading,
	                filterHeading = _props.filterHeading,
	                image = _props.image,
	                contactsHeading = _props.contactsHeading,
	                contacts = _props.contacts,
	                pagerLabels = _props.pagerLabels;
	            var _state = this.state,
	                articles = _state.articles,
	                division = _state.division,
	                page = _state.page,
	                pageSize = _state.pageSize;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _PressReleaseBlockModule2.default.block },
	                _react2.default.createElement(
	                    'div',
	                    { className: _PressReleaseBlockModule2.default.header },
	                    _react2.default.createElement(_Media2.default, { image: image, alt: heading }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _PressReleaseBlockModule2.default.inner },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _PressReleaseBlockModule2.default.content },
	                            _react2.default.createElement(
	                                'a',
	                                { href: parentLink },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    parentHeading
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h1',
	                                null,
	                                heading
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _PressReleaseBlockModule2.default.filters },
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(_DropdownFilter2.default, { yellow: true, heading: monthsHeading, items: months, onSelect: this._monthFilter })
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(_DropdownFilter2.default, { yellow: true, heading: yearsHeading, items: years, onSelect: this._yearFilter })
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(_DropdownFilter2.default, { yellow: true, active: division, heading: divisionsHeading, items: divisions, onSelect: this._divisionFilter })
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _Button2.default,
	                                { secondary: true, onClick: this._debouncedFilterItems },
	                                filterHeading
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _PressReleaseBlockModule2.default["list-outer"] },
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)(_PressReleaseBlockModule2.default.list, _defineProperty({}, _PressReleaseBlockModule2.default.searching, this.state.searching)) },
	                        _react2.default.createElement(_TableBlock2.default, { data: articles.items.map(function (item) {
	                                return _extends({}, item, {
	                                    "title": item.link ? "<a href=" + item.link + ">" + item.title + "</a>" : item.title
	                                });
	                            }), keys: ["date", "title", "division"] })
	                    ),
	                    _react2.default.createElement(_PaginatorBlock2.default, {
	                        pages: Math.ceil(articles.totalCount / pageSize),
	                        currentPage: page, onPageChange: this.pageChange,
	                        prevButtonLabel: pagerLabels && pagerLabels.prevButton ? pagerLabels.prevButton : null,
	                        nextButtonLabel: pagerLabels && pagerLabels.nextButton ? pagerLabels.nextButton : null
	                    })
	                ),
	                _react2.default.createElement(_ContactBlock2.default, { heading: contactsHeading, contacts: contacts })
	            );
	        }
	    }]);
	
	    return PressReleaseBlock;
	}(_react2.default.Component);
	
	PressReleaseBlock.propTypes = {
	    parentHeading: _propTypes2.default.string,
	    parentLink: _propTypes2.default.string,
	    heading: _propTypes2.default.string,
	    apiUrl: _propTypes2.default.string.isRequired,
	    months: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        key: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	        value: _propTypes2.default.string
	    })),
	    monthsHeading: _propTypes2.default.string,
	    years: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        key: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	        value: _propTypes2.default.string
	    })),
	    yearsHeading: _propTypes2.default.string,
	    divisions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        key: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	        value: _propTypes2.default.string
	    })),
	    divisionsHeading: _propTypes2.default.string,
	    filterHeading: _propTypes2.default.string,
	    articles: _propTypes2.default.shape({
	        items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	            title: _propTypes2.default.string,
	            date: _propTypes2.default.string,
	            division: _propTypes2.default.string,
	            link: _propTypes2.default.string
	        })),
	        totalCount: _propTypes2.default.number
	    }),
	    initialDivision: _propTypes2.default.number,
	    language: _propTypes2.default.string,
	    defaultPageSize: _propTypes2.default.number,
	    image: _Media2.default.propTypes.image,
	    contactsHeading: _propTypes2.default.string,
	    contacts: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	        firstName: _propTypes2.default.string,
	        lastName: _propTypes2.default.string,
	        emailAddress: _propTypes2.default.string,
	
	        title: _propTypes2.default.string,
	        profilePicture: _propTypes2.default.string,
	        department: _propTypes2.default.string,
	        phone: _propTypes2.default.string,
	        externalSystemId: _propTypes2.default.string
	    })),
	    pagerLabels: _propTypes2.default.shape({
	        prevButton: _propTypes2.default.string,
	        nextButton: _propTypes2.default.string
	    })
	
	};
	exports.default = PressReleaseBlock;
	module.exports = exports['default'];

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _PressReleaseBlock = __webpack_require__(548);
	
	var _PressReleaseBlock2 = _interopRequireDefault(_PressReleaseBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PressReleaseBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FluidImage = __webpack_require__(30);
	
	var _FluidImage2 = _interopRequireDefault(_FluidImage);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _OnScreen = __webpack_require__(31);
	
	var _OnScreen2 = _interopRequireDefault(_OnScreen);
	
	var _ProjectCardSliderModule = __webpack_require__(796);
	
	var _ProjectCardSliderModule2 = _interopRequireDefault(_ProjectCardSliderModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectCardSlider = function (_React$PureComponent) {
	    _inherits(ProjectCardSlider, _React$PureComponent);
	
	    function ProjectCardSlider() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ProjectCardSlider);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProjectCardSlider.__proto__ || Object.getPrototypeOf(ProjectCardSlider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            activeSlide: 0
	        }, _this._handleSlideClick = function (e) {
	            var activeSlide = _this.state.activeSlide;
	            var direction = e.currentTarget.dataset.direction;
	
	
	            e.stopPropagation();
	            e.preventDefault();
	
	            if (direction === 'prev') {
	                var prevSlide = activeSlide - 1;
	                return _this.setState({
	                    activeSlide: prevSlide < 0 ? 2 : prevSlide // -1 > 2
	                });
	            } else if (direction === 'next') {
	                var nextSlide = activeSlide + 1;
	                return _this.setState({
	                    activeSlide: nextSlide > 2 ? 0 : nextSlide // 3 > 0
	                });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ProjectCardSlider, [{
	        key: '_calculateTimeline',
	        value: function _calculateTimeline() {
	            var _props = this.props,
	                projectStart = _props.projectStart,
	                projectEnd = _props.projectEnd;
	
	
	            if (!projectStart || !projectEnd) return {};
	
	            var now = Date.now();
	            var start = Date.parse(projectStart);
	            var end = Date.parse(projectEnd);
	
	            var duration = end - start;
	            var progress = (now - start) / duration * 100;
	
	            var past = progress <= 100 ? progress : 100;
	
	            return {
	                past: past,
	                future: 100 - past
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _cn;
	
	            var _props2 = this.props,
	                compact = _props2.compact,
	                image = _props2.image,
	                projectEndFormatted = _props2.projectEndFormatted,
	                projectStartFormatted = _props2.projectStartFormatted,
	                features = _props2.features,
	                projectStatusLabel = _props2.projectStatusLabel,
	                onScreen = _props2.onScreen;
	            var activeSlide = this.state.activeSlide;
	
	
	            var timeline = this._calculateTimeline();
	
	            var feature = features && features[0];
	
	            return _react2.default.createElement(
	                'nav',
	                { className: (0, _classnames2.default)(_ProjectCardSliderModule2.default.slide, (_cn = {}, _defineProperty(_cn, _ProjectCardSliderModule2.default.compact, compact), _defineProperty(_cn, _ProjectCardSliderModule2.default.featureActive, activeSlide === 2), _cn)) },
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        { style: { display: activeSlide !== 0 ? 'none' : null } },
	                        _react2.default.createElement(_FluidImage2.default, {
	                            className: _ProjectCardSliderModule2.default.image,
	                            image: image,
	                            visible: onScreen
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: (0, _classnames2.default)(_ProjectCardSliderModule2.default.timeline, "timeline-block"), style: { display: activeSlide !== 1 ? 'none' : null } },
	                        _react2.default.createElement(
	                            'header',
	                            null,
	                            projectStatusLabel
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'timeline' },
	                            _react2.default.createElement('ul', { className: 'past', style: { width: timeline.past + "%" } }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'present' },
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'dot' },
	                                    _react2.default.createElement('li', null),
	                                    _react2.default.createElement('li', null),
	                                    _react2.default.createElement('li', null)
	                                )
	                            ),
	                            _react2.default.createElement('ul', { className: 'future', style: { width: timeline.future + "%" } })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                projectStartFormatted
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                projectEndFormatted
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: _ProjectCardSliderModule2.default.feature, style: { display: activeSlide !== 2 ? 'none' : null } },
	                        feature && [_react2.default.createElement(
	                            'h3',
	                            { key: 'title' },
	                            feature.title
	                        ), _react2.default.createElement(
	                            'span',
	                            { key: 'subtitle' },
	                            feature.subtitle
	                        )]
	                    )
	                ),
	                _react2.default.createElement(
	                    'button',
	                    {
	                        className: _ProjectCardSliderModule2.default.prev,
	                        'data-direction': 'prev',
	                        onClick: this._handleSlideClick
	                    },
	                    _react2.default.createElement(_Icon2.default, { icon: 'arrow-grey-light-left' })
	                ),
	                _react2.default.createElement(
	                    'button',
	                    {
	                        className: _ProjectCardSliderModule2.default.next,
	                        'data-direction': 'next',
	                        onClick: this._handleSlideClick
	                    },
	                    _react2.default.createElement(_Icon2.default, { icon: 'arrow-grey-light-right' })
	                )
	            );
	        }
	    }]);
	
	    return ProjectCardSlider;
	}(_react2.default.PureComponent);
	
	ProjectCardSlider.propTypes = {
	    image: _propTypes2.default.string,
	    compact: _propTypes2.default.bool.isRequired,
	    projectEnd: _propTypes2.default.string,
	    projectEndFormatted: _propTypes2.default.string,
	    projectStart: _propTypes2.default.string,
	    projectStartFormatted: _propTypes2.default.string,
	    features: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        title: _propTypes2.default.string.isRequired,
	        subtitle: _propTypes2.default.string.isRequired
	    })),
	    projectStatusLabel: _propTypes2.default.string.isRequired,
	    onScreen: _propTypes2.default.bool
	};
	ProjectCardSlider.defaultProps = {
	    compact: false
	};
	exports.default = (0, _OnScreen2.default)(ProjectCardSlider);
	module.exports = exports['default'];

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _ProjectCardSlider = __webpack_require__(550);
	
	var _ProjectCardSlider2 = _interopRequireDefault(_ProjectCardSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProjectCardSlider2.default;
	module.exports = exports['default'];

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FluidImage = __webpack_require__(30);
	
	var _FluidImage2 = _interopRequireDefault(_FluidImage);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ProjectCardSlider = __webpack_require__(551);
	
	var _ProjectCardSlider2 = _interopRequireDefault(_ProjectCardSlider);
	
	var _utils = __webpack_require__(16);
	
	var _ProjectCardModule = __webpack_require__(797);
	
	var _ProjectCardModule2 = _interopRequireDefault(_ProjectCardModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectCard = function (_React$PureComponent) {
	    _inherits(ProjectCard, _React$PureComponent);
	
	    function ProjectCard() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ProjectCard);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProjectCard.__proto__ || Object.getPrototypeOf(ProjectCard)).call.apply(_ref, [this].concat(args))), _this), _this._getProjectUrl = function () {
	            var _this$props = _this.props,
	                view = _this$props.view,
	                link = _this$props.link,
	                externalUrl = _this$props.externalUrl,
	                useExternalUrl = _this$props.useExternalUrl;
	
	            // We don't need a link when the component
	            // is not a <a> tag
	
	            if (view !== 'default') return null;
	
	            if (useExternalUrl && externalUrl) return externalUrl;
	
	            return link;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ProjectCard, [{
	        key: 'render',
	        value: function render() {
	            var _cn;
	
	            var _props = this.props,
	                id = _props.id,
	                image = _props.image,
	                name = _props.name,
	                link = _props.link,
	                division = _props.division,
	                text = _props.text,
	                onMouseEnter = _props.onMouseEnter,
	                onMouseLeave = _props.onMouseLeave,
	                view = _props.view,
	                compact = _props.compact,
	                onLocationClick = _props.onLocationClick,
	                projectStatusLabel = _props.projectStatusLabel,
	                projectStart = _props.projectStart,
	                projectEnd = _props.projectEnd,
	                projectStartFormatted = _props.projectStartFormatted,
	                projectEndFormatted = _props.projectEndFormatted,
	                features = _props.features,
	                region = _props.region,
	                useExternalUrl = _props.useExternalUrl,
	                externalUrl = _props.externalUrl;
	
	            // If we display the project in the ProjectFilter
	            // we don't want the card to be a link
	
	            var Component = "a";
	            if (view !== 'default' || useExternalUrl) {
	                Component = "div";
	            }
	
	            return _react2.default.createElement(
	                Component,
	                {
	                    className: (0, _classnames2.default)("card", _ProjectCardModule2.default.card, (_cn = {}, _defineProperty(_cn, _ProjectCardModule2.default.compact, compact), _defineProperty(_cn, _ProjectCardModule2.default.list, view === 'list'), _defineProperty(_cn, _ProjectCardModule2.default.hasImage, !!image), _cn)),
	                    'data-project-id': id,
	                    href: Component === "a" && this._getProjectUrl(),
	                    onMouseEnter: onMouseEnter,
	                    onMouseLeave: onMouseLeave
	                },
	                view === 'grid' && _react2.default.createElement(_ProjectCardSlider2.default, {
	                    compact: compact,
	                    image: image,
	                    features: features,
	                    projectStatusLabel: projectStatusLabel,
	                    projectEnd: projectEnd,
	                    projectEndFormatted: projectEndFormatted,
	                    projectStart: projectStart,
	                    projectStartFormatted: projectStartFormatted
	                }),
	                view !== 'grid' && image && _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)("image-wrapper", _ProjectCardModule2.default.imageWrapper) },
	                    _react2.default.createElement(_FluidImage2.default, {
	                        altText: name,
	                        className: _ProjectCardModule2.default.image,
	                        image: image
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)("info", _ProjectCardModule2.default.info) },
	                    view === 'default' ? _react2.default.createElement(
	                        'p',
	                        { className: _ProjectCardModule2.default.name },
	                        name
	                    ) : _react2.default.createElement(
	                        'a',
	                        { className: _ProjectCardModule2.default.name, href: link },
	                        name
	                    ),
	                    view === 'default' && [_react2.default.createElement(
	                        'p',
	                        { className: (0, _classnames2.default)("address", _ProjectCardModule2.default.address), key: 'address' },
	                        division || String.fromCharCode(160)
	                    ), text && _react2.default.createElement(
	                        'p',
	                        { className: (0, _classnames2.default)("text", _ProjectCardModule2.default.text), key: 'text' },
	                        text
	                    )],
	                    view !== 'default' && _react2.default.createElement(
	                        'ul',
	                        { className: _ProjectCardModule2.default.details },
	                        division && _react2.default.createElement(
	                            'li',
	                            { className: _ProjectCardModule2.default.division },
	                            _react2.default.createElement(_Icon2.default, { icon: 'briefcase' }),
	                            division
	                        ),
	                        region && _react2.default.createElement(
	                            'li',
	                            { className: _ProjectCardModule2.default.region },
	                            _react2.default.createElement(_Icon2.default, { icon: 'location' }),
	                            onLocationClick ? _react2.default.createElement(
	                                'button',
	                                { 'data-project': id, onClick: onLocationClick },
	                                region
	                            ) : _react2.default.createElement(
	                                'span',
	                                null,
	                                region
	                            )
	                        )
	                    ),
	                    useExternalUrl && externalUrl && _react2.default.createElement(
	                        _Button2.default,
	                        {
	                            block: true,
	                            className: _ProjectCardModule2.default.externalUrl,
	                            href: externalUrl,
	                            secondary: true
	                        },
	                        (0, _utils.presentDomain)(externalUrl)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProjectCard;
	}(_react2.default.PureComponent);
	
	ProjectCard.propTypes = {
	    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	    image: _propTypes2.default.string,
	    name: _propTypes2.default.string.isRequired,
	    address: _propTypes2.default.string,
	    location: _propTypes2.default.string,
	    division: _propTypes2.default.string,
	    projectStatusLabel: _propTypes2.default.string,
	    projectStart: _propTypes2.default.string,
	    projectStartFormatted: _propTypes2.default.string,
	    projectEnd: _propTypes2.default.string,
	    projectEndFormatted: _propTypes2.default.string,
	    link: _propTypes2.default.string,
	    text: _propTypes2.default.string,
	    externalUrl: _propTypes2.default.string,
	    useExternalUrl: _propTypes2.default.bool.isRequired,
	    onMouseEnter: _propTypes2.default.func,
	    onMouseLeave: _propTypes2.default.func,
	    view: _propTypes2.default.oneOf(["default", "grid", "list"]).isRequired,
	    compact: _propTypes2.default.bool.isRequired,
	    onLocationClick: _propTypes2.default.func,
	    features: _propTypes2.default.array,
	    region: _propTypes2.default.string
	};
	ProjectCard.defaultProps = {
	    useExternalUrl: false,
	    view: "default",
	    compact: false
	};
	exports.default = ProjectCard;
	module.exports = exports['default'];

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ProjectInfoBlockModule = __webpack_require__(798);
	
	var _ProjectInfoBlockModule2 = _interopRequireDefault(_ProjectInfoBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatUrl(url) {
	    return url.replace('http://', '').replace('https://', '').replace(/\/$/, '');
	}
	
	var Section = function Section(_ref) {
	    var title = _ref.title,
	        text = _ref.text,
	        url = _ref.url,
	        urls = _ref.urls;
	    return _react2.default.createElement(
	        'div',
	        { className: _ProjectInfoBlockModule2.default.info },
	        _react2.default.createElement(
	            'strong',
	            null,
	            title + ': '
	        ),
	        text && _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: text } }),
	        url && _react2.default.createElement(
	            'a',
	            { href: url, target: '_blank', rel: 'noopener noreferrer' },
	            formatUrl(url)
	        ),
	        urls && _react2.default.createElement(
	            'ul',
	            null,
	            urls.map(function (u, index) {
	                return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            key: index,
	                            href: u.href,
	                            target: u.target,
	                            title: u.title
	                        },
	                        u.text
	                    )
	                );
	            })
	        )
	    );
	};
	
	Section.propTypes = {
	    title: _propTypes2.default.string.isRequired,
	    text: _propTypes2.default.string,
	    url: _propTypes2.default.string,
	    urls: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        href: _propTypes2.default.string.isRequired,
	        target: _propTypes2.default.string,
	        text: _propTypes2.default.string.isRequired,
	        title: _propTypes2.default.string
	    }))
	};
	
	// Remove sections that has an empty text, url and urls value
	var filterEmptySections = function filterEmptySections(s) {
	    return s.text || s.url || s.urls;
	};
	
	var ProjectInfoBlock = function ProjectInfoBlock(_ref2) {
	    var sections = _ref2.sections;
	    return _react2.default.createElement(
	        'div',
	        { className: _ProjectInfoBlockModule2.default.block },
	        _react2.default.createElement(
	            'div',
	            { className: _ProjectInfoBlockModule2.default.column },
	            sections.filter(filterEmptySections).map(function (section) {
	                return _react2.default.createElement(Section, _extends({
	                    key: section.title
	                }, section));
	            })
	        )
	    );
	};
	
	ProjectInfoBlock.propTypes = {
	    sections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        title: _propTypes2.default.string.isRequired,
	        text: _propTypes2.default.string,
	        url: _propTypes2.default.string
	    })).isRequired
	};
	
	exports.default = ProjectInfoBlock;
	module.exports = exports['default'];

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _ProjectInfoBlock = __webpack_require__(553);
	
	var _ProjectInfoBlock2 = _interopRequireDefault(_ProjectInfoBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProjectInfoBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ProjectListBlockModule = __webpack_require__(799);
	
	var _ProjectListBlockModule2 = _interopRequireDefault(_ProjectListBlockModule);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _OnPageEditing = __webpack_require__(21);
	
	var _OnPageEditing2 = _interopRequireDefault(_OnPageEditing);
	
	var _ProjectCard = __webpack_require__(78);
	
	var _ProjectCard2 = _interopRequireDefault(_ProjectCard);
	
	var _HighlightedProjectBlock = __webpack_require__(227);
	
	var _HighlightedProjectBlock2 = _interopRequireDefault(_HighlightedProjectBlock);
	
	var _themes = __webpack_require__(22);
	
	var _OnScreen = __webpack_require__(31);
	
	var _OnScreen2 = _interopRequireDefault(_OnScreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var HighlightedProjectBlockType = _propTypes2.default.instanceOf(_HighlightedProjectBlock2.default);
	
	function projectPropertiesRemapper(props) {
	    return _extends({}, props, {
	        address: props.location
	    });
	}
	
	var ProjectListBlock = function ProjectListBlock(_ref) {
	    var highlightedProject = _ref.highlightedProject,
	        blockId = _ref.blockId,
	        heading = _ref.heading,
	        link = _ref.link,
	        linkText = _ref.linkText,
	        onScreen = _ref.onScreen,
	        projects = _ref.projects,
	        showExternalUrls = _ref.showExternalUrls,
	        theme = _ref.theme;
	    return _react2.default.createElement(
	        'div',
	        {
	            className: (0, _classnames2.default)(_ProjectListBlockModule2.default.block, (0, _themes.getThemeClassNames)(_ProjectListBlockModule2.default, theme)),
	            'data-block': blockId
	        },
	        heading && _react2.default.createElement(
	            _OnPageEditing2.default,
	            { property: 'Heading' },
	            _react2.default.createElement(
	                'h2',
	                { className: (0, _classnames2.default)("block-title-large", _ProjectListBlockModule2.default.heading) },
	                heading
	            )
	        ),
	        highlightedProject && _react2.default.createElement(_HighlightedProjectBlock2.default, _extends({}, highlightedProject, { inList: true })),
	        _react2.default.createElement(
	            _OnPageEditing2.default,
	            { property: 'Projects' },
	            _react2.default.createElement(
	                'ul',
	                { className: _ProjectListBlockModule2.default.list },
	                projects.map(function (project, index) {
	                    var _cn;
	
	                    return _react2.default.createElement(
	                        'li',
	                        { key: index, className: (0, _classnames2.default)(_ProjectListBlockModule2.default.project, (_cn = {}, _defineProperty(_cn, _ProjectListBlockModule2.default["is-on-screen"], onScreen), _defineProperty(_cn, _ProjectListBlockModule2.default["external"], showExternalUrls), _cn)) },
	                        _react2.default.createElement(_ProjectCard2.default, _extends({}, projectPropertiesRemapper(project), {
	                            useExternalUrl: showExternalUrls
	                        }))
	                    );
	                })
	            )
	        ),
	        link && linkText && _react2.default.createElement(
	            _OnPageEditing2.default,
	            { property: 'LinkToMoreContent' },
	            _react2.default.createElement(
	                'div',
	                { className: _ProjectListBlockModule2.default.button },
	                _react2.default.createElement(
	                    _Button2.default,
	                    _extends({ secondary: true, href: link, target: '_blank' }, { light: theme === _themes.THEMES.darkgray }),
	                    linkText
	                )
	            )
	        )
	    );
	};
	
	ProjectListBlock.propTypes = {
	    highlightedProject: _propTypes2.default.shape({ HighlightedProjectBlockType: HighlightedProjectBlockType }),
	    blockId: _propTypes2.default.number,
	    heading: _propTypes2.default.string,
	    link: _propTypes2.default.string,
	    linkText: _propTypes2.default.string,
	    onScreen: _propTypes2.default.bool,
	    projects: _propTypes2.default.array.isRequired,
	    showExternalUrls: _propTypes2.default.bool.isRequired,
	    theme: _propTypes2.default.oneOf(Object.keys(_themes.THEMES).map(function (s) {
	        return _themes.THEMES[s];
	    }))
	};
	
	ProjectListBlock.defaultProps = {
	    showExternalUrls: false,
	    theme: _themes.THEMES.darkgray
	};
	
	exports.default = (0, _OnScreen2.default)(ProjectListBlock);
	module.exports = exports['default'];

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _ProjectListBlock = __webpack_require__(555);
	
	var _ProjectListBlock2 = _interopRequireDefault(_ProjectListBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProjectListBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DropdownFilter = __webpack_require__(58);
	
	var _DropdownFilter2 = _interopRequireDefault(_DropdownFilter);
	
	var _Map = __webpack_require__(76);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Input = __webpack_require__(493);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _ProjectMarkers = __webpack_require__(130);
	
	var _ProjectMarkers2 = _interopRequireDefault(_ProjectMarkers);
	
	var _RightNowBox = __webpack_require__(567);
	
	var _RightNowBox2 = _interopRequireDefault(_RightNowBox);
	
	var _ProjectCard = __webpack_require__(78);
	
	var _ProjectCard2 = _interopRequireDefault(_ProjectCard);
	
	var _FilterToggleButton = __webpack_require__(460);
	
	var _FilterToggleButton2 = _interopRequireDefault(_FilterToggleButton);
	
	var _ProjectListPageModule = __webpack_require__(800);
	
	var _ProjectListPageModule2 = _interopRequireDefault(_ProjectListPageModule);
	
	var _formHelper = __webpack_require__(249);
	
	var _formHelper2 = _interopRequireDefault(_formHelper);
	
	var _apiHelper = __webpack_require__(135);
	
	var _apiHelper2 = _interopRequireDefault(_apiHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import content from 'content/projects/list';
	
	var SEARCH_NAME = "q";
	
	function remapZeroKeyToEmptyString(object) {
	    if (object.key === 0) {
	        return {
	            key: "",
	            value: object.value
	        };
	    }
	
	    return object;
	}
	
	var ProjectListPage = function (_React$Component) {
	    _inherits(ProjectListPage, _React$Component);
	
	    function ProjectListPage(props) {
	        _classCallCheck(this, ProjectListPage);
	
	        // TODO: Refactor prop structure between all usecases
	        // for multi dropdown ({key:0} vs. {key:""})
	        var _this = _possibleConstructorReturn(this, (ProjectListPage.__proto__ || Object.getPrototypeOf(ProjectListPage)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        _this.statuses = props.statuses;
	        _this.divisions = props.divisions;
	        _this.regions = props.regions;
	        _this.projectCategories = props.projectCategories.map(remapZeroKeyToEmptyString);
	        _this.companies = props.companies.map(remapZeroKeyToEmptyString);
	        _this.selectedCustomers = props.selectedCustomers;
	        return _this;
	    }
	
	    _createClass(ProjectListPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // Fix map position issue on mockup
	            // Cause: style-loader ?
	            if (window.location.hostname === "localhost") {
	                window.addEventListener('DOMContentLoaded', function () {
	                    window.setTimeout(function () {
	                        window.dispatchEvent(new Event('resize'));
	                    });
	                });
	            }
	
	            this.setFiltersFromQuery();
	        }
	    }, {
	        key: 'setFiltersFromQuery',
	        value: function setFiltersFromQuery() {
	            var query = this.state.query;
	            var division = query.division,
	                status = query.status,
	                region = query.region,
	                category = query.category,
	                company = query.company,
	                customer = query.customer,
	                q = query.q;
	
	            var updatedFilters = {};
	            var isSearchDefined = q !== undefined;
	
	            if (division) updatedFilters['division'] = division;
	            if (status) updatedFilters['status'] = status;
	            if (region) updatedFilters['region'] = region;
	            if (category) updatedFilters['category'] = Array.isArray(category) ? category : [category];
	            if (company) updatedFilters['company'] = Array.isArray(company) ? company : [company];
	            if (customer) updatedFilters['customer'] = customer;
	
	            if (Object.keys(updatedFilters).length > 0) {
	                this.setState(function (prevState) {
	                    return {
	                        filters: _extends({}, prevState.filters, updatedFilters),
	                        search: isSearchDefined,
	                        searchValue: isSearchDefined ? q : prevState.searchValue
	                    };
	                }, this._filterItems);
	            } else {
	                this.setState({
	                    projects: this.props.projects.items,
	                    search: isSearchDefined,
	                    searchValue: isSearchDefined ? q : ''
	                });
	            }
	        }
	    }, {
	        key: '_getDefaultFilter',
	        value: function _getDefaultFilter() {
	            return {
	                category: [],
	                company: [],
	                language: this.props.language,
	                pageSize: this.props.pageSize
	            };
	        }
	    }, {
	        key: '_getMarker',
	        value: function _getMarker(project) {
	            if (project.id === this.state.project) return "project-hover";
	
	            return project.completed ? "project-done" : "project-active";
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (typeof window !== 'undefined') {
	                var initQuery = this.buildInitQuery();
	                this.setState({ query: initQuery });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this,
	                _cn,
	                _cn5;
	
	            var _props = this.props,
	                header = _props.header,
	                searchPlaceholder = _props.searchPlaceholder,
	                rightNowLabel = _props.rightNowLabel,
	                resetFilterLabel = _props.resetFilterLabel,
	                mapLabel = _props.mapLabel,
	                resultsLabel = _props.resultsLabel,
	                webcamList = _props.webcamList,
	                infographicList = _props.infographicList,
	                projectStatusLabel = _props.projectStatusLabel,
	                filterLabel = _props.filterLabel,
	                statusLabel = _props.statusLabel,
	                divisionLabel = _props.divisionLabel,
	                regionsLabel = _props.regionsLabel,
	                projectCategoriesLabel = _props.projectCategoriesLabel,
	                projectCategoriesMultiLabel = _props.projectCategoriesMultiLabel,
	                companiesMultiLabel = _props.companiesMultiLabel,
	                companiesLabel = _props.companiesLabel,
	                selectedCustomersLabel = _props.selectedCustomersLabel,
	                printLabel = _props.printLabel,
	                mapCenterLocation = _props.mapCenterLocation,
	                defaultZoomLevel = _props.defaultZoomLevel,
	                tileLayer = _props.tileLayer;
	            var state = this.state;
	
	
	            var infographics = infographicList && infographicList.graphics && infographicList.graphics.infographicBlock;
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: _ProjectListPageModule2.default.wrapper,
	                    id: 'project-list',
	                    ref: function ref(node) {
	                        return _this2.wrapper = node;
	                    }
	                },
	                _react2.default.createElement(
	                    'header',
	                    null,
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        header
	                    ),
	                    (webcamList && webcamList.length > 0 || infographics && infographics.length > 0) && _react2.default.createElement(_RightNowBox2.default, {
	                        className: _ProjectListPageModule2.default.rightNow,
	                        header: rightNowLabel,
	                        webcams: webcamList,
	                        infographics: infographics
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)(_ProjectListPageModule2.default.filters, _ProjectListPageModule2.default.primaryFilters) },
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        this.statuses && this.statuses.length > 0 && _react2.default.createElement(
	                            'li',
	                            { 'data-filter': 'status' },
	                            _react2.default.createElement(_DropdownFilter2.default, {
	                                active: state.filters.status,
	                                heading: statusLabel,
	                                items: this.statuses,
	                                onSelect: this._handleFilter,
	                                yellow: true,
	                                name: 'status',
	                                className: 'status'
	                            })
	                        ),
	                        this.divisions && this.divisions.length > 0 && _react2.default.createElement(
	                            'li',
	                            { 'data-filter': 'division' },
	                            _react2.default.createElement(_DropdownFilter2.default, {
	                                active: state.filters.division,
	                                heading: divisionLabel,
	                                items: this.divisions,
	                                onSelect: this._handleFilter,
	                                yellow: true,
	                                name: 'division',
	                                className: 'business-area'
	                            })
	                        ),
	                        this.regions && this.regions.length > 0 && _react2.default.createElement(
	                            'li',
	                            { 'data-filter': 'region' },
	                            _react2.default.createElement(_DropdownFilter2.default, {
	                                active: state.filters.region,
	                                heading: regionsLabel,
	                                items: this.regions,
	                                onSelect: this._handleFilter,
	                                yellow: true,
	                                name: 'region',
	                                className: 'geography'
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: _ProjectListPageModule2.default.filterButtonColumn },
	                            _react2.default.createElement(_FilterToggleButton2.default, {
	                                activeFilters: this._getActualActiveFilters(),
	                                label: filterLabel,
	                                onClick: this._toggleSecondaryFilters,
	                                open: this.state.secondaryFilters
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)(_ProjectListPageModule2.default.filters, _ProjectListPageModule2.default.secondaryFilters),
	                        style: { display: !this.state.secondaryFilters && 'none' }
	                    },
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        this.divisions && this.divisions.length > 0 && _react2.default.createElement(
	                            'li',
	                            { 'data-filter': 'division' },
	                            _react2.default.createElement(_DropdownFilter2.default, {
	                                active: state.filters.division,
	                                heading: divisionLabel,
	                                items: this.divisions,
	                                onSelect: this._handleFilter,
	                                yellow: true,
	                                name: 'division',
	                                className: 'business-area'
	                            })
	                        ),
	                        this.regions && this.regions.length > 0 && _react2.default.createElement(
	                            'li',
	                            { 'data-filter': 'region' },
	                            _react2.default.createElement(_DropdownFilter2.default, {
	                                active: state.filters.region,
	                                heading: regionsLabel,
	                                items: this.regions,
	                                onSelect: this._handleFilter,
	                                yellow: true,
	                                name: 'region',
	                                className: 'geography'
	                            })
	                        ),
	                        this.projectCategories && this.projectCategories.length > 0 && _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(_DropdownFilter2.default, {
	                                active: state.filters.category,
	                                heading: projectCategoriesLabel,
	                                items: this.projectCategories,
	                                onSelect: this._handleFilter,
	                                yellow: true,
	                                multi: true,
	                                multiLabel: projectCategoriesMultiLabel,
	                                name: 'category',
	                                className: 'project-category'
	                            })
	                        ),
	                        this.companies && this.companies.length > 0 && _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(_DropdownFilter2.default, {
	                                active: state.filters.company,
	                                heading: companiesLabel,
	                                items: this.companies,
	                                onSelect: this._handleFilter,
	                                yellow: true,
	                                multi: true,
	                                multiLabel: companiesMultiLabel,
	                                name: 'company',
	                                className: 'unit'
	                            })
	                        ),
	                        this.selectedCustomers && this.selectedCustomers.length > 0 && _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(_DropdownFilter2.default, {
	                                active: state.filters.customer,
	                                heading: selectedCustomersLabel,
	                                items: this.selectedCustomers,
	                                onSelect: this._handleFilter,
	                                yellow: true,
	                                name: 'customer',
	                                className: 'customer'
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: _ProjectListPageModule2.default.resetFilters },
	                            _react2.default.createElement(
	                                _Button2.default,
	                                { onClick: this._handleResetFilter, yellow: true, className: 'reset-filter' },
	                                resetFilterLabel
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: _ProjectListPageModule2.default.closeFilters },
	                            _react2.default.createElement(
	                                'button',
	                                { onClick: this._toggleSecondaryFilters },
	                                _react2.default.createElement(_Icon2.default, { icon: 'close' })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)(_ProjectListPageModule2.default.content, (_cn = {}, _defineProperty(_cn, _ProjectListPageModule2.default.mapActive, this.state.mobile === "map"), _defineProperty(_cn, _ProjectListPageModule2.default.resultsActive, this.state.mobile === "results"), _cn)) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ProjectListPageModule2.default.projects },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _ProjectListPageModule2.default.options },
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: _ProjectListPageModule2.default.search, ref: function ref(node) {
	                                            return _this2.search = node;
	                                        } },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            onClick: this._toggleSearch,
	                                            ref: function ref(node) {
	                                                return _this2.searchToggle = node;
	                                            }
	                                        },
	                                        _react2.default.createElement(_Icon2.default, {
	                                            className: this.state.search ? _ProjectListPageModule2.default.searchActive : "",
	                                            icon: 'magnifier'
	                                        })
	                                    ),
	                                    _react2.default.createElement(_Input2.default, {
	                                        className: (0, _classnames2.default)(_ProjectListPageModule2.default.searchInput, _defineProperty({}, _ProjectListPageModule2.default.searchActive, this.state.search)),
	                                        id: 'project-search',
	                                        onKeyDown: this._handleSearchKeyDown,
	                                        onChange: this._handleSearchChange,
	                                        placeholder: searchPlaceholder,
	                                        style: { display: !this.state.search && 'none' },
	                                        type: 'text',
	                                        value: this.state.searchValue,
	                                        useValueAttr: true
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: _ProjectListPageModule2.default.display },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'data-view': 'grid',
	                                            onClick: this._handleViewClick
	                                        },
	                                        _react2.default.createElement(_Icon2.default, {
	                                            className: (0, _classnames2.default)(_defineProperty({}, _ProjectListPageModule2.default.active, this.state.view === "grid")),
	                                            icon: 'grid'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'data-view': 'list',
	                                            onClick: this._handleViewClick
	                                        },
	                                        _react2.default.createElement(_Icon2.default, {
	                                            className: (0, _classnames2.default)(_defineProperty({}, _ProjectListPageModule2.default.active, this.state.view === "list")),
	                                            icon: 'list'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'a',
	                                        {
	                                            className: _ProjectListPageModule2.default.print,
	                                            href: this._getPrintUrl(),
	                                            rel: 'noopener noreferrer',
	                                            target: '_blank'
	                                        },
	                                        _react2.default.createElement(_Icon2.default, { icon: 'printer' }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            printLabel
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: (0, _classnames2.default)(_ProjectListPageModule2.default.list, (_cn5 = {}, _defineProperty(_cn5, _ProjectListPageModule2.default.grid, state.view === "grid"), _defineProperty(_cn5, _ProjectListPageModule2.default.searching, state.searching), _cn5)) },
	                                state.projects && state.projects.filter(this._filterSearch).map(function (project) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        { key: project.id },
	                                        _react2.default.createElement(_ProjectCard2.default, _extends({}, project, {
	                                            projectStatusLabel: projectStatusLabel,
	                                            view: _this2.state.view,
	                                            onLocationClick: _this2._handleLocationClick
	                                            //onMouseEnter={this._handleMouseEnter} TODO: Optimize renders
	                                            //onMouseLeave={this._handleMouseLeave} TODO: Optimize renders
	                                            , displayText: false
	                                        }))
	                                    );
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ProjectListPageModule2.default.map },
	                        _react2.default.createElement(
	                            _Map2.default,
	                            {
	                                center: mapCenterLocation && mapCenterLocation.split(",").map(parseFloat),
	                                zoomLevel: defaultZoomLevel,
	                                tileLayer: tileLayer
	                            },
	                            _react2.default.createElement(_ProjectMarkers2.default, {
	                                filterSearch: this._filterSearch,
	                                onMarkerClick: this._handleMarkerClick,
	                                projects: state.projects,
	                                projectStatusLabel: projectStatusLabel,
	                                searchValue: this.state.searchValue
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ProjectListPageModule2.default.mapToggle },
	                    _react2.default.createElement(
	                        _Button2.default,
	                        {
	                            icon: this.state.mobile === "map" ? "grid" : "map",
	                            onClick: this._mapToggle
	                        },
	                        this.state.mobile === "map" ? resultsLabel : mapLabel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProjectListPage;
	}(_react2.default.Component);
	
	ProjectListPage.propTypes = {
	    "apiUrl": _propTypes2.default.string.isRequired,
	    "header": _propTypes2.default.any,
	    "searchPlaceholder": _propTypes2.default.any,
	    "rightNowLabel": _propTypes2.default.any,
	    "webcamList": _propTypes2.default.array.isRequired,
	    "infographicList": _propTypes2.default.object,
	    "projectStatusLabel": _propTypes2.default.string,
	    "resetFilterLabel": _propTypes2.default.string.isRequired,
	    "mapLabel": _propTypes2.default.string.isRequired,
	    "resultsLabel": _propTypes2.default.string.isRequired,
	    "filterLabel": _propTypes2.default.string.isRequired,
	    "statusLabel": _propTypes2.default.string.isRequired,
	    "divisionLabel": _propTypes2.default.string.isRequired,
	    "regionsLabel": _propTypes2.default.string.isRequired,
	    "projectCategoriesLabel": _propTypes2.default.string.isRequired,
	    "projectCategoriesMultiLabel": _propTypes2.default.string.isRequired,
	    "companiesMultiLabel": _propTypes2.default.string.isRequired,
	    "companiesLabel": _propTypes2.default.string.isRequired,
	    "selectedCustomersLabel": _propTypes2.default.string.isRequired,
	    "printLabel": _propTypes2.default.string.isRequired,
	    "statuses": _propTypes2.default.any,
	    "divisions": _propTypes2.default.any,
	    "regions": _propTypes2.default.any,
	    "projectCategories": _propTypes2.default.any,
	    "companies": _propTypes2.default.any,
	    "selectedCustomers": _propTypes2.default.any,
	    "projects": _propTypes2.default.any,
	    "mapCenterLocation": _propTypes2.default.string.isRequired,
	    "defaultZoomLevel": _propTypes2.default.number.isRequired,
	    "language": _propTypes2.default.string.isRequired,
	    "pageSize": _propTypes2.default.number.isRequired,
	    "tileLayer": _propTypes2.default.string
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this3 = this;
	
	    this.state = {
	        query: {},
	        filters: this._getDefaultFilter(),
	        projects: [],
	        secondaryFilters: false,
	        project: null,
	        view: 'grid',
	        search: false,
	        searchValue: "",
	        mobile: "results",
	        searching: false
	    };
	
	    this.buildInitQuery = function () {
	        var query = _formHelper2.default.createQuery();
	        _formHelper2.default.fillQueryFromPageQueryString(query);
	        return query;
	    };
	
	    this._handleResetFilter = function () {
	        var resetQuery = {};
	        var newUrl = window.location.pathname;
	        window.history.replaceState(null, null, newUrl);
	
	        _this3.setState({
	            filters: _this3._getDefaultFilter(),
	            query: resetQuery,
	            projects: _this3.props.projects.items
	        });
	    };
	
	    this._handleMouseEnter = function (e) {
	        return _this3.setState({
	            project: parseInt(e.currentTarget.dataset.projectId)
	        });
	    };
	
	    this._handleMouseLeave = function () {
	        return _this3.setState({ project: null });
	    };
	
	    this._toggleSecondaryFilters = function () {
	        return _this3.setState({
	            secondaryFilters: !_this3.state.secondaryFilters
	        });
	    };
	
	    this._toggleSearch = function () {
	        return _this3.setState({
	            search: !_this3.state.search
	        }, function () {
	            if (_this3.state.search && _this3.search) {
	                var input = _this3.search.querySelector('input');
	                input.focus();
	            }
	        });
	    };
	
	    this._handleViewClick = function (e) {
	        return _this3.setState({
	            view: e.currentTarget.dataset.view
	        });
	    };
	
	    this._handleSearchChange = function (e) {
	        e.preventDefault();
	        var inputValue = e.target.value;
	        _this3.setState(function (prevState) {
	            return {
	                searchValue: inputValue,
	                query: _extends({}, prevState.query, _defineProperty({}, SEARCH_NAME, inputValue))
	            };
	        }, function () {
	            _formHelper2.default.updatePageQueryString(_this3.state.query);
	            window.dispatchEvent(new Event("OnScreenTrigger"));
	        });
	    };
	
	    this._handleSearchKeyDown = function (e) {
	        // If ESC is pressed in the search box
	        // clear the search field and hide it
	        // and set focus back to the search toggle button
	
	        if (e.keyCode === 27) {
	            _this3.setState(function (prevState) {
	                return {
	                    search: false,
	                    searchValue: "",
	                    query: _extends({}, prevState.query, _defineProperty({}, SEARCH_NAME, ''))
	                };
	            }, function () {
	                _formHelper2.default.updatePageQueryString(_this3.state.query);
	                _this3.searchToggle.focus();
	            });
	        }
	    };
	
	    this._handleLocationClick = function (e) {
	        _this3.wrapper.dispatchEvent(new CustomEvent('project', {
	            "detail": parseInt(e.currentTarget.dataset.project)
	        }));
	    };
	
	    this._handleFilter = function (e, value, filter) {
	        _this3.setState(function (prevState) {
	            var updatedFilters = _extends({}, prevState.filters, _defineProperty({}, filter, value));
	
	            if (filter) {
	                var query = _extends({}, prevState.query);
	                _formHelper2.default.setQueryValue(query, filter, value);
	                _formHelper2.default.updatePageQueryString(query);
	                return { filters: updatedFilters, query: query };
	            }
	
	            return { filters: updatedFilters };
	        }, _this3._filterItems);
	    };
	
	    this._prepareFilter = function () {
	        var filters = _this3.state.filters;
	
	
	        var newFilter = _extends({}, filters);
	
	        Object.keys(newFilter).forEach(function (key) {
	            if (Array.isArray(newFilter[key])) {
	                // If "All" is included send an empty array
	                if (newFilter[key].includes("")) {
	                    newFilter[key] = [];
	                } else {
	                    newFilter[key] = newFilter[key].map(function (v) {
	                        return parseInt(v);
	                    }).filter(function (v) {
	                        return v > 0;
	                    });
	                }
	            }
	        });
	
	        return newFilter;
	    };
	
	    this._filterItems = function () {
	        _this3.setState({
	            searching: true
	        });
	        _apiHelper2.default.execute(_this3.props.apiUrl, _this3._prepareFilter()).then(function (response) {
	
	            if (response && response.items) {
	                _this3.setState({
	                    projects: response.items
	                }, function () {
	                    window.dispatchEvent(new Event("OnScreenTrigger"));
	                });
	            } else {
	                console.error(response);
	            }
	
	            _this3.setState({
	                searching: false
	            });
	        }).catch(function (err) {
	            console.error(err);
	
	            _this3.setState({
	                searching: false
	            });
	        });
	    };
	
	    this._filterSearch = function (project) {
	        var searchValue = _this3.state.searchValue;
	
	
	        if (searchValue && searchValue.length < 3) return true;
	
	        return project.name.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1;
	    };
	
	    this._mapToggle = function () {
	        return _this3.setState(function (state) {
	            return {
	                mobile: state.mobile === "map" ? "results" : "map"
	            };
	        }, function () {
	            // Fixes map layout on mobile hopefully
	            window.dispatchEvent(new Event('resize'));
	        });
	    };
	
	    this._getActualActiveFilters = function () {
	        var state = _this3.state;
	
	
	        var count = 0;
	
	        for (var filter in state.filters) {
	            if (filter === 'language' || filter === 'pageSize') continue;
	            if (Array.isArray(state.filters[filter]) && state.filters[filter].length === 0) continue;
	            if (state.filters[filter] === 0) continue;
	            if (state.filters[filter] === "0") continue;
	
	            count++;
	        }
	
	        return count;
	    };
	
	    this._getPrintUrl = function () {
	        var state = _this3.state,
	            props = _this3.props;
	
	
	        var projects = state.projects.filter(_this3._filterSearch);
	        return props.printProjectsUrl + '?ids=' + projects.map(function (p) {
	            return p.id;
	        }).join(',');
	    };
	};
	
	exports.default = ProjectListPage;
	module.exports = exports['default'];

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(16);
	
	var _ProjectCard = __webpack_require__(78);
	
	var _ProjectCard2 = _interopRequireDefault(_ProjectCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectMarkers = function (_React$PureComponent) {
	    _inherits(ProjectMarkers, _React$PureComponent);
	
	    function ProjectMarkers() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ProjectMarkers);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProjectMarkers.__proto__ || Object.getPrototypeOf(ProjectMarkers)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            render: false
	        }, _this._handleProjectEvent = function (e) {
	            if (!_this.cluster || !_this.cluster.getLayers) return;
	
	            var markers = _this.cluster.getLayers();
	            var marker = markers.find(function (m) {
	                return m.options.project == e.detail;
	            });
	
	            if (marker) {
	                _this.cluster.zoomToShowLayer(marker, function () {
	                    if (!marker.isPopupOpen()) {
	                        marker.fire('click');
	                    }
	                });
	            } else {
	                console.error('Failed to find project marker with id', e.detail);
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ProjectMarkers, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.MarkerClusterGroup = __webpack_require__(1022).default;
	            this.Marker = __webpack_require__(115).Marker;
	            this.Popup = __webpack_require__(115).Popup;
	
	            var projectList = document.getElementById('project-list');
	
	            if (projectList) {
	                projectList.addEventListener('project', this._handleProjectEvent);
	            }
	
	            this.setState({
	                render: true
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                projects = _props.projects,
	                projectStatusLabel = _props.projectStatusLabel,
	                filterSearch = _props.filterSearch,
	                options = _props.options,
	                maxClusterRadius = _props.maxClusterRadius;
	            var render = this.state.render;
	
	
	            if (!render) return null;
	
	            var MarkerClusterGroup = this.MarkerClusterGroup;
	            var Marker = this.Marker;
	            var Popup = this.Popup;
	
	            return _react2.default.createElement(
	                MarkerClusterGroup,
	                {
	                    options: _extends({
	                        maxClusterRadius: maxClusterRadius,
	                        iconCreateFunction: this._clusterIcon,
	                        showCoverageOnHover: false
	                    }, options),
	                    ref: function ref(node) {
	                        return _this2.cluster = node && node.leafletElement;
	                    }
	                },
	                projects && projects.filter(function (p) {
	                    return p.location;
	                }).filter(filterSearch).map(function (p) {
	                    return _react2.default.createElement(
	                        Marker,
	                        {
	                            key: p.id,
	                            icon: (0, _utils.markerIcon)(p),
	                            position: p.location.split(",").map(parseFloat),
	                            project: p.id
	                        },
	                        _react2.default.createElement(
	                            Popup,
	                            null,
	                            _react2.default.createElement(_ProjectCard2.default, _extends({}, p, {
	                                address: null,
	                                compact: true,
	                                view: 'grid',
	                                displayText: false,
	                                projectStatusLabel: projectStatusLabel
	                            }))
	                        )
	                    );
	                })
	            );
	        }
	    }]);
	
	    return ProjectMarkers;
	}(_react2.default.PureComponent);
	
	ProjectMarkers.propTypes = {
	    clickedProject: _propTypes2.default.number,
	    onMarkerClick: _propTypes2.default.func,
	    projects: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        location: _propTypes2.default.string
	    })).isRequired,
	    projectStatusLabel: _propTypes2.default.string.isRequired,
	    filterSearch: _propTypes2.default.func.isRequired,
	    options: _propTypes2.default.object,
	    maxClusterRadius: _propTypes2.default.number
	};
	ProjectMarkers.defaultProps = {
	    options: {},
	    maxClusterRadius: 80
	};
	exports.default = ProjectMarkers;
	module.exports = exports['default'];

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(721);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PublishedDate = function PublishedDate(_ref) {
	    var meta = _ref.meta,
	        display = _ref.display,
	        className = _ref.className;
	    return _react2.default.createElement(
	        'time',
	        { className: (0, _classnames2.default)("published-date", className), dateTime: meta },
	        display
	    );
	};
	
	PublishedDate.propTypes = {
	    meta: _propTypes2.default.string,
	    display: _propTypes2.default.string,
	    className: _propTypes2.default.string
	};
	
	exports.default = PublishedDate;
	module.exports = exports['default'];

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _PublishedDate = __webpack_require__(559);
	
	var _PublishedDate2 = _interopRequireDefault(_PublishedDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PublishedDate2.default;
	module.exports = exports['default'];

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PublishedModule = __webpack_require__(801);
	
	var _PublishedModule2 = _interopRequireDefault(_PublishedModule);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Published = function Published(_ref) {
	    var _cn;
	
	    var label = _ref.label,
	        date = _ref.date,
	        isFeatureArticle = _ref.isFeatureArticle,
	        className = _ref.className;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_PublishedModule2.default.published, (_cn = {}, _defineProperty(_cn, _PublishedModule2.default["-is-feature-article"], isFeatureArticle), _defineProperty(_cn, className, className), _cn)) },
	        _react2.default.createElement(_Icon2.default, { className: _PublishedModule2.default.icon, icon: 'calendar' }),
	        _react2.default.createElement(
	            'p',
	            { className: _PublishedModule2.default.text },
	            label,
	            ' ',
	            date
	        )
	    );
	};
	
	Published.propTypes = {
	    className: _propTypes2.default.string,
	    label: _propTypes2.default.string,
	    date: _propTypes2.default.string,
	    isFeatureArticle: _propTypes2.default.bool
	};
	exports.default = Published;
	module.exports = exports['default'];

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _quoteThemes = __webpack_require__(609);
	
	var _utils = __webpack_require__(16);
	
	var _QuoteBlockModule = __webpack_require__(802);
	
	var _QuoteBlockModule2 = _interopRequireDefault(_QuoteBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuoteBlock = function QuoteBlock(_ref) {
	  var quote = _ref.quote,
	      author = _ref.author,
	      _ref$theme = _ref.theme,
	      theme = _ref$theme === undefined ? _quoteThemes.QUOTETHEMES.yellow : _ref$theme;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_QuoteBlockModule2.default.block, (0, _quoteThemes.getQuoteThemeClassNames)(_QuoteBlockModule2.default, theme))
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _QuoteBlockModule2.default.container },
	      _react2.default.createElement(
	        'blockquote',
	        _extends({ className: _QuoteBlockModule2.default.quote }, (0, _utils.onPageEditing)('Quote')),
	        quote
	      ),
	      _react2.default.createElement(
	        'div',
	        _extends({ className: _QuoteBlockModule2.default.author }, (0, _utils.onPageEditing)('Author')),
	        author
	      )
	    )
	  );
	};
	
	QuoteBlock.propTypes = {
	  quote: _propTypes2.default.string,
	  author: _propTypes2.default.string,
	  theme: _propTypes2.default.oneOf(Object.keys(_quoteThemes.QUOTETHEMES).map(function (s) {
	    return _quoteThemes.QUOTETHEMES[s];
	  }))
	};
	
	exports.default = QuoteBlock;
	module.exports = exports['default'];

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.backgroundColor = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _OnScreen = __webpack_require__(31);
	
	var _OnScreen2 = _interopRequireDefault(_OnScreen);
	
	__webpack_require__(803);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var backgroundColor = exports.backgroundColor = {
	    white: 'white',
	    gray: 'gray'
	};
	
	var RelatedArticleBlock = function RelatedArticleBlock(_ref) {
	    var _cn, _cn2;
	
	    var title = _ref.title,
	        heading = _ref.heading,
	        category = _ref.category,
	        link = _ref.link,
	        backgroundColor = _ref.backgroundColor,
	        isExternal = _ref.isExternal,
	        place = _ref.place,
	        inRichText = _ref.inRichText;
	
	    var ContainerElement = link ? 'a' : 'div';
	
	    return _react2.default.createElement(
	        'div',
	        {
	            className: (0, _classnames2.default)('related-article-block', (_cn = {}, _defineProperty(_cn, 'related-article-block_place_' + place, place), _defineProperty(_cn, "related-article-block_in-rich-text", inRichText), _cn))
	        },
	        _react2.default.createElement(
	            ContainerElement,
	            _extends({
	                className: (0, _classnames2.default)('related-article-block__container', (_cn2 = {}, _defineProperty(_cn2, 'related-article-block__container_theme_' + backgroundColor, backgroundColor), _defineProperty(_cn2, 'related-article-block__container_place_' + place, place), _cn2))
	            }, link && _extends({
	                href: link
	            }, isExternal && { target: "_blank" })),
	            _react2.default.createElement(
	                'div',
	                { className: 'related-article-block__content' },
	                title && _react2.default.createElement(
	                    'span',
	                    { className: 'related-article-block__title' },
	                    title
	                ),
	                heading && _react2.default.createElement(
	                    'p',
	                    { className: 'related-article-block__heading' },
	                    heading
	                ),
	                category && _react2.default.createElement(
	                    'span',
	                    { className: 'related-article-block__category' },
	                    category
	                )
	            ),
	            link && _react2.default.createElement(
	                'div',
	                { className: 'related-article-block__icon-container' },
	                _react2.default.createElement(_Icon2.default, { icon: isExternal ? "share" : "arrow-right", className: 'related-article-block__icon' })
	            )
	        )
	    );
	};
	
	RelatedArticleBlock.defaultProps = {
	    backgroundColor: backgroundColor.gray
	};
	
	RelatedArticleBlock.propTypes = {
	    title: _propTypes2.default.string,
	    heading: _propTypes2.default.string,
	    category: _propTypes2.default.string,
	    link: _propTypes2.default.string,
	    isExternal: _propTypes2.default.bool,
	    backgroundColor: _propTypes2.default.oneOf(Object.values(backgroundColor)),
	    place: _propTypes2.default.oneOf(['feature-article']),
	    inRichText: _propTypes2.default.bool
	};
	
	exports.default = (0, _OnScreen2.default)(RelatedArticleBlock);

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RelatedArticleBlock = __webpack_require__(563);
	
	var _RelatedArticleBlock2 = _interopRequireDefault(_RelatedArticleBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RelatedArticleBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _RelatedArticlesModule = __webpack_require__(804);
	
	var _RelatedArticlesModule2 = _interopRequireDefault(_RelatedArticlesModule);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _OnPageEditing = __webpack_require__(21);
	
	var _OnPageEditing2 = _interopRequireDefault(_OnPageEditing);
	
	var _themes = __webpack_require__(22);
	
	var _OnScreen = __webpack_require__(31);
	
	var _OnScreen2 = _interopRequireDefault(_OnScreen);
	
	var _FluidImage = __webpack_require__(30);
	
	var _FluidImage2 = _interopRequireDefault(_FluidImage);
	
	var _Published = __webpack_require__(131);
	
	var _Published2 = _interopRequireDefault(_Published);
	
	var _FeatureArticleTag = __webpack_require__(223);
	
	var _FeatureArticleTag2 = _interopRequireDefault(_FeatureArticleTag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var RelatedArticles = function RelatedArticles(_ref) {
	    var blockId = _ref.blockId,
	        heading = _ref.heading,
	        link = _ref.link,
	        linkText = _ref.linkText,
	        onScreen = _ref.onScreen,
	        articles = _ref.articles,
	        theme = _ref.theme,
	        showMoreArticles = _ref.showMoreArticles,
	        showMoreButtonText = _ref.showMoreButtonText,
	        hasMoreArticles = _ref.hasMoreArticles,
	        featureArticleListPageLink = _ref.featureArticleListPageLink;
	    return _react2.default.createElement(
	        'div',
	        {
	            className: (0, _classnames2.default)(_RelatedArticlesModule2.default.block, (0, _themes.getThemeClassNames)(_RelatedArticlesModule2.default, theme)),
	            'data-block': blockId
	        },
	        heading && _react2.default.createElement(
	            _OnPageEditing2.default,
	            { property: 'Heading' },
	            _react2.default.createElement(
	                'h2',
	                { className: (0, _classnames2.default)("block-title-large", _RelatedArticlesModule2.default.heading) },
	                heading,
	                featureArticleListPageLink && featureArticleListPageLink.url && _react2.default.createElement(
	                    'a',
	                    {
	                        className: _RelatedArticlesModule2.default.featureArticleListPageLink,
	                        href: featureArticleListPageLink.url,
	                        target: featureArticleListPageLink.openInNewWindow ? "_blank" : null,
	                        rel: featureArticleListPageLink.openInNewWindow ? "noopener noreferrer" : null
	                    },
	                    featureArticleListPageLink.linkText
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _OnPageEditing2.default,
	            { property: 'Articles' },
	            _react2.default.createElement(
	                'ul',
	                { className: _RelatedArticlesModule2.default.list },
	                articles && articles.map(function (article, index) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: index, className: (0, _classnames2.default)(_RelatedArticlesModule2.default.article, _defineProperty({}, _RelatedArticlesModule2.default["is-on-screen"], onScreen)) },
	                        _react2.default.createElement(
	                            'a',
	                            { href: article.link, className: _RelatedArticlesModule2.default.articleLink },
	                            _react2.default.createElement(
	                                'div',
	                                { className: (0, _classnames2.default)("image-wrapper", _RelatedArticlesModule2.default.imageWrapper) },
	                                article.image && _react2.default.createElement(_FluidImage2.default, {
	                                    altText: article.imageAltText,
	                                    className: _RelatedArticlesModule2.default.image,
	                                    image: article.image
	                                }),
	                                article.shouldHaveFeatureArticleTag && _react2.default.createElement(_FeatureArticleTag2.default, null)
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _RelatedArticlesModule2.default.info },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: _RelatedArticlesModule2.default.articleHeading },
	                                    article.title
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _RelatedArticlesModule2.default.publishedContainer },
	                                    article.published && _react2.default.createElement(
	                                        'div',
	                                        { className: _RelatedArticlesModule2.default.articlePublished },
	                                        _react2.default.createElement(_Published2.default, { isFeatureArticle: article.tag && article.published && true, date: article.published })
	                                    ),
	                                    article.tag && article.published && _react2.default.createElement(
	                                        'span',
	                                        { className: _RelatedArticlesModule2.default.divider },
	                                        ' - '
	                                    ),
	                                    article.tag && _react2.default.createElement(
	                                        'p',
	                                        { className: _RelatedArticlesModule2.default.articleTag },
	                                        article.tag
	                                    )
	                                )
	                            )
	                        )
	                    );
	                })
	            )
	        ),
	        link && linkText ? _react2.default.createElement(
	            _OnPageEditing2.default,
	            { property: 'LinkToMoreContent' },
	            _react2.default.createElement(
	                'div',
	                { className: _RelatedArticlesModule2.default.button },
	                _react2.default.createElement(
	                    _Button2.default,
	                    _extends({ secondary: true, href: link, target: '_blank' }, { light: theme === _themes.THEMES.darkgray }),
	                    linkText
	                )
	            )
	        ) : showMoreArticles && showMoreButtonText && _react2.default.createElement(
	            'div',
	            { className: _RelatedArticlesModule2.default.button },
	            _react2.default.createElement(
	                _Button2.default,
	                _extends({ disabled: hasMoreArticles ? false : true, secondary: true, onClick: showMoreArticles }, { light: theme === _themes.THEMES.darkgray }),
	                showMoreButtonText
	            )
	        )
	    );
	};
	
	RelatedArticles.propTypes = {
	    blockId: _propTypes2.default.number,
	    heading: _propTypes2.default.string,
	    link: _propTypes2.default.string,
	    linkText: _propTypes2.default.string,
	    onScreen: _propTypes2.default.bool,
	    articles: _propTypes2.default.array,
	    theme: _propTypes2.default.oneOf(Object.keys(_themes.THEMES).map(function (s) {
	        return _themes.THEMES[s];
	    })),
	    showMoreArticles: _propTypes2.default.func,
	    showMoreButtonText: _propTypes2.default.string,
	    hasMoreArticles: _propTypes2.default.bool,
	    shouldHaveFeatureArticleTag: _propTypes2.default.bool,
	    featureArticleListPageLink: _propTypes2.default.shape({
	        url: _propTypes2.default.string.isRequired,
	        linkText: _propTypes2.default.string.isRequired,
	        openInNewWindow: _propTypes2.default.bool.isRequired
	    })
	};
	
	RelatedArticles.defaultProps = {
	    theme: _themes.THEMES.lightgray
	};
	
	exports.default = (0, _OnScreen2.default)(RelatedArticles);
	module.exports = exports['default'];

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _InfographicsCard = __webpack_require__(491);
	
	var _InfographicsCard2 = _interopRequireDefault(_InfographicsCard);
	
	var _WebcamBlock = __webpack_require__(248);
	
	var _WebcamBlock2 = _interopRequireDefault(_WebcamBlock);
	
	var _RightNowBoxModule = __webpack_require__(805);
	
	var _RightNowBoxModule2 = _interopRequireDefault(_RightNowBoxModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RightNowBox = function (_React$PureComponent) {
	    _inherits(RightNowBox, _React$PureComponent);
	
	    function RightNowBox() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, RightNowBox);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RightNowBox.__proto__ || Object.getPrototypeOf(RightNowBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            infographic: 0,
	            webcam: 0
	        }, _this._nextWebcam = function () {
	            return _this.setState(function (state) {
	                return {
	                    webcam: state.webcam + 1 >= _this.props.webcams.length ? 0 : state.webcam + 1
	                };
	            });
	        }, _this._prevWebcam = function () {
	            return _this.setState(function (state) {
	                return {
	                    webcam: state.webcam == 0 ? _this.props.webcams.length - 1 : state.webcam - 1
	                };
	            });
	        }, _this._nextInfographic = function () {
	            return _this.setState(function (state) {
	                return {
	                    infographic: state.infographic + 1 >= _this.props.infographics.length ? 0 : state.infographic + 1
	                };
	            });
	        }, _this._prevInfographic = function () {
	            return _this.setState(function (state) {
	                return {
	                    infographic: state.infographic == 0 ? _this.props.infographics.length - 1 : state.infographic - 1
	                };
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(RightNowBox, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                header = _props.header,
	                webcams = _props.webcams,
	                infographics = _props.infographics;
	            var _state = this.state,
	                infographic = _state.infographic,
	                webcam = _state.webcam;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_RightNowBoxModule2.default.box, className) },
	                header && _react2.default.createElement(
	                    'h2',
	                    { className: _RightNowBoxModule2.default.header },
	                    header
	                ),
	                webcams && webcams.length > 0 && _react2.default.createElement(
	                    'div',
	                    { className: _RightNowBoxModule2.default.webcams },
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        webcams.map(function (w, i) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: i, style: { display: i !== webcam ? 'none' : null } },
	                                _react2.default.createElement(_WebcamBlock2.default, w)
	                            );
	                        })
	                    ),
	                    webcams.length > 1 && _react2.default.createElement(
	                        'nav',
	                        null,
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'button',
	                                    { onClick: this._prevWebcam },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'arrow-grey-light-left' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: _RightNowBoxModule2.default.indicators },
	                                webcams.map(function (w, i) {
	                                    return _react2.default.createElement(
	                                        'div',
	                                        {
	                                            className: i === webcam ? _RightNowBoxModule2.default.active : null,
	                                            key: i
	                                        },
	                                        'Webcam ' + (i + 1)
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'button',
	                                    { onClick: this._nextWebcam },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'arrow-grey-light-right' })
	                                )
	                            )
	                        )
	                    )
	                ),
	                infographics && infographics.length > 0 && _react2.default.createElement(
	                    'div',
	                    { className: _RightNowBoxModule2.default.infographics },
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        infographics.map(function (info, i) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: i, style: { display: i !== infographic ? 'none' : null } },
	                                _react2.default.createElement(_InfographicsCard2.default, info)
	                            );
	                        })
	                    ),
	                    infographics.length > 1 && _react2.default.createElement(
	                        'nav',
	                        null,
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'button',
	                                    { onClick: this._prevInfographic },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'arrow-grey-light-left' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: _RightNowBoxModule2.default.indicators },
	                                infographics.map(function (_, i) {
	                                    return _react2.default.createElement(
	                                        'div',
	                                        {
	                                            className: i === infographic ? _RightNowBoxModule2.default.active : null,
	                                            key: i
	                                        },
	                                        'Infographic ' + (i + 1)
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'button',
	                                    { onClick: this._nextInfographic },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'arrow-grey-light-right' })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RightNowBox;
	}(_react2.default.PureComponent);
	
	RightNowBox.propTypes = {
	    className: _propTypes2.default.string,
	    header: _propTypes2.default.string.isRequired,
	    webcams: _propTypes2.default.array,
	    infographics: _propTypes2.default.array
	};
	exports.default = RightNowBox;
	module.exports = exports['default'];

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RightNowBox = exports.default = undefined;
	
	var _RightNowBox2 = __webpack_require__(566);
	
	var _RightNowBox3 = _interopRequireDefault(_RightNowBox2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RightNowBox3.default;
	exports.RightNowBox = _RightNowBox3.default;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(722);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchForm = function (_React$PureComponent) {
	    _inherits(SearchForm, _React$PureComponent);
	
	    function SearchForm() {
	        _classCallCheck(this, SearchForm);
	
	        return _possibleConstructorReturn(this, (SearchForm.__proto__ || Object.getPrototypeOf(SearchForm)).apply(this, arguments));
	    }
	
	    _createClass(SearchForm, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'search-form-inline' },
	                _react2.default.createElement(
	                    'form',
	                    { className: 'search-form-inline-wrapper', action: this.props.baseUrl, method: 'get' },
	                    _react2.default.createElement('input', { type: 'text', placeholder: this.props.inputPlaceholder, name: 'query', id: 'inline-search', className: 'search-form-inline-input' })
	                )
	            );
	        }
	    }]);
	
	    return SearchForm;
	}(_react2.default.PureComponent);
	
	SearchForm.propTypes = {
	    inputPlaceholder: _propTypes2.default.string,
	    baseUrl: _propTypes2.default.string
	};
	exports.default = SearchForm;
	module.exports = exports['default'];

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SearchFormInline = __webpack_require__(568);
	
	var _SearchFormInline2 = _interopRequireDefault(_SearchFormInline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SearchFormInline2.default;
	module.exports = exports['default'];

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames3 = __webpack_require__(3);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	__webpack_require__(723);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchForm = function (_React$PureComponent) {
	    _inherits(SearchForm, _React$PureComponent);
	
	    function SearchForm() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SearchForm);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchForm.__proto__ || Object.getPrototypeOf(SearchForm)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	            e.stopPropagation();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SearchForm, [{
	        key: 'render',
	        value: function render() {
	            var classNames = (0, _classnames4.default)('search-container', {
	                'open': this.props.isActive === 'search',
	                'open-wrapper': this.props.isActive === 'search'
	            });
	
	            var searchClassNames = (0, _classnames4.default)('search', _defineProperty({
	                'open': this.props.isActive === 'search',
	                'with-custom-logo': this.props.withCustomLogo
	            }, '' + this.props.searchClassName, this.props.searchClassName));
	
	            var searchFormClassNames = (0, _classnames4.default)('search-form', _defineProperty({
	                'with-custom-logo': this.props.withCustomLogo
	            }, '' + this.props.className, this.props.className));
	
	            return _react2.default.createElement(
	                'div',
	                { className: searchFormClassNames },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        className: searchClassNames,
	                        onClick: this.props.handleSearchButtonClick,
	                        'aria-label': this.props.isActive ? this.props.closeQuickSearchFormBtnAriaLabel : this.props.openQuickSearchFormBtnAriaLabel
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'search-icon' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'text' },
	                            this.props.searchLabel
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: classNames },
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'search-form-wrapper', action: this.props.searchLink, method: 'get', onClick: this.handleClick },
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'global-menu-search' },
	                            this.props.searchLabel
	                        ),
	                        _react2.default.createElement('input', { type: 'text', placeholder: this.props.inputPlaceholder, name: 'query', id: 'global-menu-search' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SearchForm;
	}(_react2.default.PureComponent);
	
	SearchForm.propTypes = {
	    isActive: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
	    inputPlaceholder: _propTypes2.default.string,
	    searchLink: _propTypes2.default.string,
	    searchLabel: _propTypes2.default.string.isRequired,
	    withCustomLogo: _propTypes2.default.bool,
	    openQuickSearchFormBtnAriaLabel: _propTypes2.default.string,
	    closeQuickSearchFormBtnAriaLabel: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    searchClassName: _propTypes2.default.string,
	    handleSearchButtonClick: _propTypes2.default.func
	};
	exports.default = SearchForm;
	module.exports = exports['default'];

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(724);
	
	var _apiHelper = __webpack_require__(135);
	
	var _apiHelper2 = _interopRequireDefault(_apiHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import cn from 'classnames';
	
	var SearchResultsBlock = function (_React$Component) {
	    _inherits(SearchResultsBlock, _React$Component);
	
	    function SearchResultsBlock() {
	        _classCallCheck(this, SearchResultsBlock);
	
	        return _possibleConstructorReturn(this, (SearchResultsBlock.__proto__ || Object.getPrototypeOf(SearchResultsBlock)).apply(this, arguments));
	    }
	
	    _createClass(SearchResultsBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                title = _props.title,
	                searchTerm = _props.searchTerm,
	                pageIndex = _props.pageIndex,
	                pagesCount = _props.pagesCount,
	                totalItemsCount = _props.totalItemsCount,
	                numberHitsText = _props.numberHitsText,
	                results = _props.results,
	                baseUrl = _props.baseUrl,
	                inputPlaceholder = _props.inputPlaceholder,
	                pagerLabels = _props.pagerLabels;
	
	
	            var handleLinkClick = function handleLinkClick(trackUrl, e) {
	                if (trackUrl) {
	                    var defaultBehaviour = e.ctrlKey;
	                    if (!defaultBehaviour) {
	                        e.preventDefault();
	                    }
	                    var href = e.currentTarget.href;
	                    _apiHelper2.default.execute(trackUrl, {}).then(function (_response) {
	                        if (!defaultBehaviour) {
	                            window.location.href = href;
	                        }
	                    });
	                }
	            };
	
	            var maxVisiblePagesAmount = 5;
	            var pagesAmount = pagesCount;
	            var currentPageIndex = pageIndex;
	
	            var allPagesAreVisible = maxVisiblePagesAmount >= pagesAmount;
	            var visibilityRange = Math.floor(maxVisiblePagesAmount / 2);
	            var leftBoundary = currentPageIndex <= visibilityRange + 1;
	            var rightBoundary = currentPageIndex >= pagesAmount - visibilityRange;
	
	            var paginationChildren = [];
	
	            for (var _pageIndex = 1; _pageIndex < pagesAmount + 1; _pageIndex++) {
	                var visible = false;
	
	                if (allPagesAreVisible) {
	                    visible = true;
	                } else if (leftBoundary) {
	
	                    visible = _pageIndex <= maxVisiblePagesAmount;
	                } else if (rightBoundary) {
	                    visible = _pageIndex > pagesAmount - maxVisiblePagesAmount;
	                } else {
	                    visible = Math.abs(currentPageIndex - _pageIndex) <= visibilityRange;
	                }
	
	                var li = void 0;
	
	                if (visible) {
	
	                    li = _react2.default.createElement(
	                        'li',
	                        { key: _pageIndex, className: 'pagination__item' },
	                        _pageIndex === currentPageIndex ? _react2.default.createElement(
	                            'span',
	                            { className: 'pagination__button pagination__button_active' },
	                            _pageIndex
	                        ) : _react2.default.createElement(
	                            'a',
	                            { href: baseUrl + "?query=" + searchTerm + "&page=" + _pageIndex, className: 'pagination__button' },
	                            _pageIndex
	                        )
	                    );
	                }
	
	                paginationChildren.push(li);
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'search-results-block' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'search-container' },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        title
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'search-form' },
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'search-form-wrapper', method: 'get', action: baseUrl },
	                            _react2.default.createElement('input', { type: 'text', placeholder: inputPlaceholder, id: 'search-results-form', name: 'query' })
	                        )
	                    ),
	                    totalItemsCount > 0 && _react2.default.createElement(
	                        'div',
	                        { className: 'search-container-hits-text' },
	                        numberHitsText
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'results-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'results-content' },
	                        totalItemsCount > 0 && _react2.default.createElement(
	                            'ul',
	                            { className: 'results' },
	                            results.map(function (result, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: result.url, onClick: function onClick(e) {
	                                                return handleLinkClick(result.trackUrl, e);
	                                            } },
	                                        _react2.default.createElement(
	                                            'h2',
	                                            null,
	                                            result.title
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'ingress' },
	                                        result.ingress
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        result.type,
	                                        ' | ',
	                                        result.businessArea
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'last-updated' },
	                                        result.date,
	                                        _react2.default.createElement('br', null),
	                                        result.categories
	                                    )
	                                );
	                            })
	                        ),
	                        pagesCount > 1 && _react2.default.createElement(
	                            'ul',
	                            { className: 'pagination pagination_in-search-block' },
	                            !allPagesAreVisible && !leftBoundary && _react2.default.createElement(
	                                'li',
	                                { className: 'pagination__item pagination__item_prev' },
	                                _react2.default.createElement('a', { href: baseUrl + "?query=" + searchTerm + "&page=" + (pageIndex - 1), className: 'pagination__button pagination__button_prev', 'aria-label': pagerLabels && pagerLabels.prevButton ? pagerLabels.prevButton : null }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'pagination__button-dots' },
	                                    '...'
	                                )
	                            ),
	                            paginationChildren,
	                            !allPagesAreVisible && !rightBoundary && _react2.default.createElement(
	                                'li',
	                                { className: 'pagination__item pagination__item_next' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'pagination__button-dots' },
	                                    '...'
	                                ),
	                                _react2.default.createElement('a', { className: 'pagination__button pagination__button_next', href: baseUrl + "?query=" + searchTerm + "&page=" + (pageIndex + 1), 'aria-label': pagerLabels && pagerLabels.nextButton ? pagerLabels.nextButton : null })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SearchResultsBlock;
	}(_react2.default.Component);
	
	SearchResultsBlock.propTypes = {
	    title: _propTypes2.default.string,
	    searchTerm: _propTypes2.default.string,
	    pageIndex: _propTypes2.default.number,
	    pagesCount: _propTypes2.default.number,
	    pageSize: _propTypes2.default.number,
	    totalItemsCount: _propTypes2.default.number,
	    numberHitsText: _propTypes2.default.string,
	    baseUrl: _propTypes2.default.string,
	    pagerLabels: _propTypes2.default.shape({
	        prevButton: _propTypes2.default.string,
	        nextButton: _propTypes2.default.string
	    }),
	    results: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        title: _propTypes2.default.string,
	        url: _propTypes2.default.string,
	        ingress: _propTypes2.default.string,
	        date: _propTypes2.default.string,
	        categories: _propTypes2.default.string,
	        trackUrl: _propTypes2.default.string
	    })),
	    noResults: _propTypes2.default.object,
	    inputPlaceholder: _propTypes2.default.string
	};
	exports.default = SearchResultsBlock;
	module.exports = exports['default'];

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SearchResultsBlock = __webpack_require__(571);
	
	var _SearchResultsBlock2 = _interopRequireDefault(_SearchResultsBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SearchResultsBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Media = __webpack_require__(38);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _PhotoCredit = __webpack_require__(547);
	
	var _PhotoCredit2 = _interopRequireDefault(_PhotoCredit);
	
	var _SectionMenuBlockModule = __webpack_require__(806);
	
	var _SectionMenuBlockModule2 = _interopRequireDefault(_SectionMenuBlockModule);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Breadcrumbs = __webpack_require__(218);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _buttonThemes = __webpack_require__(607);
	
	var _introThemes = __webpack_require__(608);
	
	var _FitText = __webpack_require__(225);
	
	var _FitText2 = _interopRequireDefault(_FitText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SectionMenuBlock = function (_React$Component) {
	    _inherits(SectionMenuBlock, _React$Component);
	
	    function SectionMenuBlock() {
	        _classCallCheck(this, SectionMenuBlock);
	
	        return _possibleConstructorReturn(this, (SectionMenuBlock.__proto__ || Object.getPrototypeOf(SectionMenuBlock)).apply(this, arguments));
	    }
	
	    _createClass(SectionMenuBlock, [{
	        key: "render",
	        value: function render() {
	            var _cn;
	
	            var _props = this.props,
	                longDescription = _props.longDescription,
	                backgroundVideo = _props.backgroundVideo,
	                backgroundImage = _props.backgroundImage,
	                backgroundImageMobile = _props.backgroundImageMobile,
	                icon = _props.icon,
	                header = _props.header,
	                size = _props.size,
	                menuItems = _props.menuItems,
	                breadcrumb = _props.breadcrumb,
	                menuTitle = _props.menuTitle,
	                menuButtonsTheme = _props.menuButtonsTheme,
	                introTheme = _props.introTheme,
	                photoCredit = _props.photoCredit;
	
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    {
	                        className: (0, _classnames2.default)(_SectionMenuBlockModule2.default[size], _SectionMenuBlockModule2.default["header"], (_cn = {}, _defineProperty(_cn, _SectionMenuBlockModule2.default["background-image"], backgroundVideo || backgroundImage), _defineProperty(_cn, _SectionMenuBlockModule2.default["solid"], !backgroundImage), _defineProperty(_cn, _SectionMenuBlockModule2.default.whiteIntro, introTheme === _introThemes.INTROTHEMES.white), _cn))
	                    },
	                    _react2.default.createElement(_Media.Media, {
	                        image: backgroundImage,
	                        imageMobile: backgroundImageMobile,
	                        video: backgroundVideo,
	                        alt: header,
	                        theme: _Media.Media.themes.full,
	                        gradient: _Media.Media.gradients.section,
	                        className: backgroundImageMobile ? "media--has-mobile-image" : "media--no-mobile-image"
	                    }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _SectionMenuBlockModule2.default["inner"] },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _SectionMenuBlockModule2.default["content-top"] },
	                            size === "small" && _react2.default.createElement(_Breadcrumbs2.default, { items: breadcrumb }),
	                            icon && size === "large" && _react2.default.createElement(_Icon2.default, { icon: icon, className: _SectionMenuBlockModule2.default["icon"] }),
	                            header && _react2.default.createElement(
	                                "h1",
	                                null,
	                                _react2.default.createElement(_FitText2.default, { text: header })
	                            ),
	                            size === "small" && _react2.default.createElement(
	                                "div",
	                                null,
	                                menuItems && _react2.default.createElement(
	                                    "ul",
	                                    { className: _SectionMenuBlockModule2.default["buttons"] },
	                                    menuItems.map(function (button, index) {
	                                        return _react2.default.createElement(
	                                            "li",
	                                            { key: index },
	                                            button.url && button.linkText ? _react2.default.createElement(
	                                                _Button2.default,
	                                                _extends({ tertiary: menuButtonsTheme === _buttonThemes.THEMES.yellow }, { blue: menuButtonsTheme === _buttonThemes.THEMES.blue }, {
	                                                    className: "btn--in-section-menu-block",
	                                                    href: button.url
	                                                }),
	                                                button.linkText
	                                            ) : ""
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        size === "large" && _react2.default.createElement(
	                            "div",
	                            { className: _SectionMenuBlockModule2.default["buttons-header"] },
	                            menuTitle
	                        )
	                    ),
	                    size === "large" && _react2.default.createElement(
	                        "div",
	                        null,
	                        menuItems && _react2.default.createElement(
	                            "div",
	                            { className: _SectionMenuBlockModule2.default["content-bottom"] },
	                            _react2.default.createElement(
	                                "ul",
	                                { className: _SectionMenuBlockModule2.default["buttons"] },
	                                menuItems.map(function (button, index) {
	                                    return _react2.default.createElement(
	                                        "li",
	                                        { key: index },
	                                        button.url && button.linkText ? _react2.default.createElement(
	                                            _Button2.default,
	                                            _extends({ tertiary: menuButtonsTheme === _buttonThemes.THEMES.yellow }, { blue: menuButtonsTheme === _buttonThemes.THEMES.blue }, {
	                                                className: "btn--in-section-menu-block",
	                                                href: button.url
	                                            }),
	                                            button.linkText
	                                        ) : ""
	                                    );
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    {
	                        className: (0, _classnames2.default)(_SectionMenuBlockModule2.default.text, (0, _introThemes.getIntroThemeClassNames)(_SectionMenuBlockModule2.default, introTheme))
	                    },
	                    photoCredit && _react2.default.createElement(
	                        "div",
	                        { className: _SectionMenuBlockModule2.default.photoCreditContainer },
	                        _react2.default.createElement(_PhotoCredit2.default, _extends({}, photoCredit, { className: _SectionMenuBlockModule2.default.photoCredit }))
	                    ),
	                    longDescription && _react2.default.createElement("div", {
	                        className: _SectionMenuBlockModule2.default.description,
	                        dangerouslySetInnerHTML: {
	                            __html: longDescription
	                        }
	                    })
	                )
	            );
	        }
	    }]);
	
	    return SectionMenuBlock;
	}(_react2.default.Component);
	
	SectionMenuBlock.propTypes = {
	    longDescription: _propTypes2.default.string,
	    photoCredit: _propTypes2.default.shape(_PhotoCredit2.default.propTypes),
	    backgroundVideo: _Media.Media && _Media.Media.propTypes.video,
	    backgroundImage: _Media.Media && _Media.Media.propTypes.image,
	    backgroundImageMobile: _Media.Media && _Media.Media.propTypes.imageMobile,
	    icon: _propTypes2.default.string,
	    header: _propTypes2.default.string.isRequired,
	    size: _propTypes2.default.string,
	    menuItems: _propTypes2.default.array,
	    breadcrumb: _propTypes2.default.array,
	    menuTitle: _propTypes2.default.string,
	    menuButtonsTheme: _propTypes2.default.oneOf(Object.keys(_buttonThemes.THEMES).map(function (s) {
	        return _buttonThemes.THEMES[s];
	    })),
	    introTheme: _propTypes2.default.oneOf(Object.keys(_introThemes.INTROTHEMES).map(function (s) {
	        return _introThemes.INTROTHEMES[s];
	    }))
	};
	SectionMenuBlock.defaultProps = {
	    menuButtonsTheme: _buttonThemes.THEMES.yellow,
	    introTheme: _introThemes.INTROTHEMES.grey
	};
	exports.default = SectionMenuBlock;
	module.exports = exports["default"];

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SectionMenuBlock = __webpack_require__(573);
	
	var _SectionMenuBlock2 = _interopRequireDefault(_SectionMenuBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SectionMenuBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(16);
	
	var _ShortcutsBlockModule = __webpack_require__(807);
	
	var _ShortcutsBlockModule2 = _interopRequireDefault(_ShortcutsBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShortcutsBlock = function ShortcutsBlock(_ref) {
	    var links = _ref.links,
	        heading = _ref.heading;
	    return _react2.default.createElement(
	        'div',
	        { className: _ShortcutsBlockModule2.default.block },
	        _react2.default.createElement(
	            'div',
	            { className: _ShortcutsBlockModule2.default.container },
	            heading && _react2.default.createElement(
	                'div',
	                (0, _utils.onPageEditing)('Heading'),
	                _react2.default.createElement(
	                    'h3',
	                    { className: _ShortcutsBlockModule2.default.heading },
	                    heading
	                )
	            ),
	            links && links.length > 0 && _react2.default.createElement(
	                'ul',
	                _extends({ className: _ShortcutsBlockModule2.default.shortcuts }, (0, _utils.onPageEditing)('LinkGroups')),
	                links.map(function (l, i) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: i, className: _ShortcutsBlockModule2.default.shortcut },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: l.href,
	                                target: l.target,
	                                title: l.title,
	                                className: _ShortcutsBlockModule2.default.shortcutLink
	                            },
	                            l.text
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	ShortcutsBlock.propTypes = {
	    heading: _propTypes2.default.string,
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        href: _propTypes2.default.string,
	        target: _propTypes2.default.string,
	        title: _propTypes2.default.string,
	        text: _propTypes2.default.string
	    }))
	};
	
	exports.default = ShortcutsBlock;
	module.exports = exports['default'];

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _ShortcutsBlock = __webpack_require__(575);
	
	var _ShortcutsBlock2 = _interopRequireDefault(_ShortcutsBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ShortcutsBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _throttle = __webpack_require__(70);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _debounce = __webpack_require__(53);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _utils = __webpack_require__(16);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SliderListBlockModule = __webpack_require__(808);
	
	var _SliderListBlockModule2 = _interopRequireDefault(_SliderListBlockModule);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SliderListBlock = function (_React$Component) {
	    _inherits(SliderListBlock, _React$Component);
	
	    function SliderListBlock() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SliderListBlock);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SliderListBlock.__proto__ || Object.getPrototypeOf(SliderListBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            active: 0,
	            forward: true,
	            loaded: false
	        }, _this._handleIndicatorClick = function (e) {
	            e.preventDefault();
	            var index = parseInt(e.currentTarget.dataset.index),
	                forward = index > _this.state.active;
	
	            if (_this.state.active === index) return;
	
	            _this.setState({ active: index, forward: forward }, _this._postSetState);
	        }, _this._handleNavigationClick = function (e) {
	            e.preventDefault();
	            var direction = e.currentTarget.dataset.direction;
	
	
	            if (direction === "next") {
	                if (_this.props.data.length <= _this.state.active + 1) return;
	                _this.setState({ active: _this.state.active + 1, forward: true }, _this._postSetState);
	            } else if (direction === "prev") {
	                if (_this.state.active - 1 < 0) return;
	                _this.setState({ active: _this.state.active - 1, forward: false }, _this._postSetState);
	            }
	        }, _this._dataLoaded = function (e) {
	            var image = e.currentTarget;
	
	            if (image.dataset.active === "true") {
	                _this.setState({ height: image.height, loaded: true });
	            }
	        }, _this._postSetState = (0, _throttle2.default)(function () {
	            if (_this.block) {
	                var element = _this.block.querySelector(_this.props.selector);
	
	                if (element) {
	                    _this.setState({ height: element.clientHeight });
	                }
	
	                // // scroll to active element
	                _this._debouncedSlideTo();
	            }
	        }, 100), _this._debouncedSlideTo = (0, _debounce2.default)(function () {
	            if ((0, _utils.scrollIntoView)(_this.wrapper, _this.wrapper.firstChild.childNodes[_this.state.active], _this.slideDurationSetting, _this.slideTimeout, false)) {
	                _this.sliding = true;
	            }
	        }, 250), _this.slideTimeout = function () {
	            setTimeout(function () {
	                if (_this.sliding) {
	                    _this.sliding = false;
	                    cancelAnimationFrame(window.__scrollIntoViewID);
	                }
	            }, 50);
	        }, _this._moveStart = function (e) {
	            if (_this.props.mode === 'default' || _this.sliding) {
	                return;
	            }
	            _this._x = parseFloat(e.clientX || e.touches[0].clientX).toFixed(2);
	        }, _this._move = function (e) {
	            if (_this.props.mode === 'default' || _this.sliding) {
	                return;
	            }
	            var currX = parseFloat(e.clientX || e.touches[0].clientX).toFixed(2);
	            _this.direction = currX - _this._x > 0 ? -1 : 1;
	        }, _this._moveEnd = function () {
	            if (_this.props.mode === 'default' || _this.sliding) {
	                return;
	            }
	            var newActive = Math.max(0, Math.min(_this.props.data.length - 1, _this.state.active + _this.direction));
	            _this.setState({
	                active: newActive
	            }, _this._debouncedSlideTo);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SliderListBlock, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // Don't add event listener for an empty imageblock
	            if (this.props.data.length > 0) {
	                typeof window !== 'undefined' && window.addEventListener("resize", this._postSetState);
	
	                // DOMContentLoaded event should fix onLoad event not triggering
	                // for server side rendered images (that are cached)
	                typeof window !== 'undefined' && window.addEventListener("DOMContentLoaded", this._postSetState);
	
	                this._postSetState();
	            }
	            this.slideDurationSetting = this.props.duration;
	            this.scrollLeft = 0;
	            this.sliding = false;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.props.callback && this.props.callback.apply(null, [this.props.data[this.state.active]]);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _cn,
	                _this2 = this;
	
	            var _props = this.props,
	                data = _props.data,
	                size = _props.size,
	                Component = _props.Component,
	                className = _props.className,
	                mode = _props.mode,
	                rest = _objectWithoutProperties(_props, ['data', 'size', 'Component', 'className', 'mode']);
	
	            var _state = this.state,
	                active = _state.active,
	                loaded = _state.loaded,
	                forward = _state.forward;
	
	
	            if (!data || data.length === 0) return null;
	
	            var carousel = data.length > 1;
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)("slider-list-block", _SliderListBlockModule2.default.container, className, (_cn = {}, _defineProperty(_cn, _SliderListBlockModule2.default.carousel, carousel), _defineProperty(_cn, _SliderListBlockModule2.default.condensed, size === 'small'), _defineProperty(_cn, _SliderListBlockModule2.default["theme-" + rest.theme], true), _defineProperty(_cn, _SliderListBlockModule2.default['mode-' + mode], true), _cn)),
	                    ref: function ref(node) {
	                        return _this2.block = node;
	                    }
	                },
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: _SliderListBlockModule2.default["slide-wrapper"],
	                        ref: function ref(node) {
	                            return _this2.wrapper = node;
	                        },
	                        onScroll: this._handleScroll,
	                        onTouchStart: this._moveStart,
	                        onTouchMove: this._move,
	                        onTouchEnd: this._moveEnd,
	                        onMouseDown: this._moveStart,
	                        onMouseMove: this._move,
	                        onMouseUp: this._moveEnd
	                    },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _SliderListBlockModule2.default.slides },
	                        data.map(function (item, index) {
	                            return _react2.default.createElement(
	                                'li',
	                                {
	                                    className: active === index ? (0, _classnames2.default)("active", _SliderListBlockModule2.default.active) : null,
	                                    'data-active': active === index,
	                                    key: index
	                                },
	                                _react2.default.createElement(Component, _extends({
	                                    active: active === index,
	                                    key: index,
	                                    ref: function ref(node) {
	                                        return _this2.activeNode = node;
	                                    },
	                                    onLoad: _this2._dataLoaded,
	                                    size: size
	                                }, rest, item))
	                            );
	                        }),
	                        mode === 'horizontal-list' && _react2.default.createElement('li', { className: _SliderListBlockModule2.default['last-hidden-list-item'] })
	                    )
	                ),
	                loaded && _react2.default.createElement('div', {
	                    className: _SliderListBlockModule2.default.shadow,
	                    style: { transform: 'translateY(calc(' + this.state.height + 'px - 100% - 10px))' }
	                }),
	                data.length > 1 && [_react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)("nav", _SliderListBlockModule2.default.nav),
	                        key: 'nav',
	                        style: { transform: 'translateY(' + this.state.height / 2 + 'px)' }
	                    },
	                    !active == 0 && _react2.default.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            'data-direction': 'prev',
	                            onClick: this._handleNavigationClick,
	                            className: (0, _classnames2.default)("nav-prev", _SliderListBlockModule2.default["nav-prev"])
	                        },
	                        _react2.default.createElement(_Icon2.default, { icon: 'arrow-grey-right' }),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Previous'
	                        )
	                    ),
	                    !(active == data.length - 1) && _react2.default.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            'data-direction': 'next',
	                            onClick: this._handleNavigationClick,
	                            className: (0, _classnames2.default)("nav-next", _SliderListBlockModule2.default["nav-next"])
	                        },
	                        _react2.default.createElement(_Icon2.default, { icon: 'arrow-grey-left' }),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Next'
	                        )
	                    )
	                ), _react2.default.createElement(
	                    'ul',
	                    {
	                        className: (0, _classnames2.default)("nav-indicators", _SliderListBlockModule2.default["nav-indicators"]),
	                        key: 'indicators',
	                        style: { transform: 'translateY(' + this.state.height + 'px)' }
	                    },
	                    data.map(function (image, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: index },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    'data-index': index,
	                                    type: 'button',
	                                    onClick: _this2._handleIndicatorClick,
	                                    className: '\n                                        ' + (active === index ? (0, _classnames2.default)("active", _SliderListBlockModule2.default.active) : null) + '\n                                        ' + (forward ? _SliderListBlockModule2.default["direction-forward"] : null) + '\n                                    '
	                                },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    index + 1
	                                )
	                            )
	                        );
	                    })
	                )]
	            );
	        }
	    }]);
	
	    return SliderListBlock;
	}(_react2.default.Component);
	
	SliderListBlock.propTypes = {
	    data: _propTypes2.default.array,
	    size: _propTypes2.default.oneOf(['large', 'small']).isRequired,
	    callback: _propTypes2.default.func,
	    Component: _propTypes2.default.func,
	    className: _propTypes2.default.string,
	    selector: _propTypes2.default.string.isRequired,
	    theme: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    mode: _propTypes2.default.oneOf(['default', 'horizontal-list']),
	    duration: _propTypes2.default.number
	};
	SliderListBlock.defaultProps = {
	    size: 'large',
	    selector: '[data-active="true"]',
	    mode: 'default',
	    duration: 400
	};
	exports.default = SliderListBlock;
	module.exports = exports['default'];

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stickyPolyfill = typeof window !== 'undefined' && window.document ? __webpack_require__(338) : {};
	
	var Sticky = function (_React$Component) {
	    _inherits(Sticky, _React$Component);
	
	    function Sticky() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Sticky);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            style: {}
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Sticky, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            if (this.props.isAtBottom) {
	                var height = this.stickyRef.getBoundingClientRect().height;
	                var top = "calc(100% - " + height + "px)";
	                this.setState({ style: { top: top } }, function () {
	                    var stickyPolyfill = typeof window !== 'undefined' && window.document ? __webpack_require__(338) : {};
	                    stickyPolyfill.addOne(_this2.stickyRef);
	                });
	                return;
	            }
	            if (this.props.isSticky) {
	                stickyPolyfill.addOne(this.stickyRef);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                type = _props.type,
	                props = _props.props,
	                children = _props.children;
	
	            return _react2.default.createElement(type, _extends({}, props, { ref: function ref(el) {
	                    return _this3.stickyRef = el;
	                }, style: this.state.style }), children);
	        }
	    }]);
	
	    return Sticky;
	}(_react2.default.Component);
	
	Sticky.propTypes = {
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
	    props: _propTypes2.default.object,
	    type: _propTypes2.default.string,
	    isSticky: _propTypes2.default.bool,
	    isAtBottom: _propTypes2.default.bool,
	    stickySelector: _propTypes2.default.string
	};
	Sticky.defaultPropTypes = {
	    isAtBottom: false
	};
	exports.default = Sticky;
	module.exports = exports["default"];

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SearchForm = __webpack_require__(242);
	
	var _SearchForm2 = _interopRequireDefault(_SearchForm);
	
	var _LanguageSelector = __webpack_require__(232);
	
	var _LanguageSelector2 = _interopRequireDefault(_LanguageSelector);
	
	__webpack_require__(725);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubMenuLink = function SubMenuLink(_ref) {
	    var link = _ref.link,
	        linkText = _ref.linkText;
	
	    if (!linkText) return null;
	
	    return _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	            'a',
	            {
	                className: 'submenu-link',
	                href: link
	            },
	            linkText
	        )
	    );
	};
	
	SubMenuLink.propTypes = {
	    link: _propTypes2.default.string,
	    linkText: _propTypes2.default.string
	};
	
	var SupportingMenu = function SupportingMenu(_ref2) {
	    var menu = _ref2.menu,
	        searchLink = _ref2.searchLink,
	        searchLabel = _ref2.searchLabel,
	        languages = _ref2.languages,
	        onClick = _ref2.onClick,
	        isActive = _ref2.isActive,
	        isActiveOnMobile = _ref2.isActiveOnMobile,
	        inputPlaceholder = _ref2.inputPlaceholder,
	        withCustomLogo = _ref2.withCustomLogo,
	        openQuickSearchFormBtnAriaLabel = _ref2.openQuickSearchFormBtnAriaLabel,
	        closeQuickSearchFormBtnAriaLabel = _ref2.closeQuickSearchFormBtnAriaLabel;
	
	    var handleClickLanguage = function handleClickLanguage() {
	        onClick('language');
	    };
	
	    var handleClickSearch = function handleClickSearch() {
	        var searchResultsForm = document && document.getElementById('search-results-form');
	        if (searchResultsForm === null) {
	            onClick('search', function () {
	                document && document.getElementById('global-menu-search').focus();
	            });
	        } else {
	            searchResultsForm.focus();
	        }
	    };
	
	    var classNames = (0, _classnames2.default)('submenu', {
	        'open': isActiveOnMobile
	    });
	
	    return _react2.default.createElement(
	        'nav',
	        { className: classNames, role: 'navigation' },
	        _react2.default.createElement(
	            'ul',
	            { className: (0, _classnames2.default)('top-header-secondary-menu', {
	                    'with-custom-logo': withCustomLogo
	                }) },
	            menu && menu.map(function (l, i) {
	                return _react2.default.createElement(SubMenuLink, _extends({ key: i }, l));
	            }),
	            _react2.default.createElement('li', { className: 'divider' }),
	            _react2.default.createElement(
	                'li',
	                { onClick: handleClickLanguage },
	                _react2.default.createElement(_LanguageSelector2.default, { languages: languages, isActive: isActive })
	            ),
	            _react2.default.createElement(
	                'li',
	                { className: 'search', onClick: handleClickSearch },
	                _react2.default.createElement(_SearchForm2.default, {
	                    inputPlaceholder: inputPlaceholder,
	                    isActive: isActive,
	                    searchLabel: searchLabel,
	                    searchLink: searchLink,
	                    openQuickSearchFormBtnAriaLabel: openQuickSearchFormBtnAriaLabel,
	                    closeQuickSearchFormBtnAriaLabel: closeQuickSearchFormBtnAriaLabel,
	                    withCustomLogo: withCustomLogo
	                })
	            )
	        )
	    );
	};
	
	SupportingMenu.propTypes = {
	    menu: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        link: _propTypes2.default.string,
	        linkText: _propTypes2.default.string
	    })),
	    searchLink: _propTypes2.default.string.isRequired,
	    searchLabel: _propTypes2.default.string.isRequired,
	    languages: _propTypes2.default.array,
	    onClick: _propTypes2.default.func,
	    isActive: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
	    isActiveOnMobile: _propTypes2.default.bool,
	    inputPlaceholder: _propTypes2.default.string,
	    openQuickSearchFormBtnAriaLabel: _propTypes2.default.string,
	    closeQuickSearchFormBtnAriaLabel: _propTypes2.default.string,
	    withCustomLogo: _propTypes2.default.bool
	};
	
	exports.default = SupportingMenu;
	module.exports = exports['default'];

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactTransitionGroup = __webpack_require__(1074);
	
	var _throttle = __webpack_require__(70);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _utils = __webpack_require__(16);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ContactBlock = __webpack_require__(98);
	
	var _ContactBlock2 = _interopRequireDefault(_ContactBlock);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ImageIcon = __webpack_require__(59);
	
	var _ImageIcon2 = _interopRequireDefault(_ImageIcon);
	
	var _ImageBlock = __webpack_require__(228);
	
	var _ImageBlock2 = _interopRequireDefault(_ImageBlock);
	
	var _VideoListBlock = __webpack_require__(134);
	
	var _VideoListBlock2 = _interopRequireDefault(_VideoListBlock);
	
	var _Infographic = __webpack_require__(230);
	
	var _Infographic2 = _interopRequireDefault(_Infographic);
	
	var _InfographicListBlock = __webpack_require__(229);
	
	var _InfographicListBlock2 = _interopRequireDefault(_InfographicListBlock);
	
	var _tracking = __webpack_require__(99);
	
	var _TabListBlockModule = __webpack_require__(809);
	
	var _TabListBlockModule2 = _interopRequireDefault(_TabListBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabListBlock = function (_React$Component) {
	    _inherits(TabListBlock, _React$Component);
	
	    function TabListBlock() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TabListBlock);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TabListBlock.__proto__ || Object.getPrototypeOf(TabListBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            active: _this.props.firstOpen ? 0 : null,
	            tabIndicatorLeft: null,
	            tabIndicatorWidth: null
	        }, _this._checkIfPageWithScroll = function () {
	            if (window.innerWidth > document.body.clientWidth) {
	                document.body.classList.add("pageWithScroll");
	            } else {
	                document.body.classList.remove("pageWithScroll");
	            }
	        }, _this._handleResize = (0, _throttle2.default)(function () {
	            _this._setActiveIndicatorStyle(_this.state.active);
	        }, 100), _this._setActiveIndicatorStyle = function (tabId) {
	            if (!_this.navTabs[tabId]) return;
	
	            _this.setState({
	                tabIndicatorLeft: _this.navTabs[tabId].offsetLeft - _this.list.scrollLeft,
	                tabIndicatorWidth: _this.navTabs[tabId].offsetWidth
	            });
	        }, _this._handleBenefitClick = function (e) {
	            e.preventDefault();
	            var id = e.currentTarget.dataset.id;
	
	
	            if (_this.state.active === parseInt(id)) {
	                // This "tab" is already opened, close the list
	                _this.setState({ active: null });
	            } else {
	                var active = parseInt(id);
	                var tab = _this.props.tabs[active];
	
	                // GA Tracking
	                (0, _tracking.track)('tab_selection', (_this.props.heading || "") + ' - ' + (tab.title || tab.heading));
	
	                _this.setState({ active: active });
	            }
	
	            _this._setActiveIndicatorStyle(id);
	        }, _this.navTabs = {}, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TabListBlock, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            setTimeout(function () {
	                _this2._setActiveIndicatorStyle(_this2.state.active);
	            }, 1);
	
	            this._checkIfPageWithScroll();
	
	            window.addEventListener('resize', function () {
	                _this2._handleResize();
	                _this2._checkIfPageWithScroll();
	            });
	        }
	    }, {
	        key: '_renderBlock',
	        value: function _renderBlock(content, index) {
	            if (content.length <= 0) {
	                return null;
	            }
	            var block = content[0];
	            var contentType = block.contentType;
	            switch (contentType) {
	                case 'ContactPersonListBlock':
	                    return _react2.default.createElement(_ContactBlock2.default, _extends({}, block, { key: index }));
	                case 'ContactPersonBlock':
	                    return _react2.default.createElement(_ContactBlock2.default, { contacts: [block], key: index });
	
	                case 'VideoListBlock':
	                    return _react2.default.createElement(_VideoListBlock2.default, _extends({}, block, { key: index }));
	                case 'YoutubeVideoBlock':
	                    return _react2.default.createElement(_VideoListBlock2.default, { videos: [block], key: index, blockId: block.blockId });
	
	                case 'InfographicListBlock':
	                    return _react2.default.createElement(_InfographicListBlock2.default, _extends({}, block, { key: index }));
	                case 'InfographicBlock':
	                    return _react2.default.createElement(_Infographic2.default, _extends({}, block, { key: index }));
	
	                case 'ImageListBlock':
	                    return _react2.default.createElement(_ImageBlock2.default, _extends({}, block, { key: index }));
	                case 'ImageBlock':
	                    return _react2.default.createElement(_ImageBlock2.default, { images: [block], key: index });
	            }
	        }
	    }, {
	        key: '_onPageEdit',
	        value: function _onPageEdit(type, property) {
	            if (type === 'tab' && this.props.contentType !== 'TabListBlock') {
	                return (0, _utils.onPageEditing)(property);
	            } else if (type === 'list' && this.props.contentType === 'TabListBlock') {
	                return (0, _utils.onPageEditing)(property);
	            }
	
	            return null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                blockId = _props.blockId,
	                heading = _props.heading,
	                intro = _props.intro,
	                tabs = _props.tabs,
	                readMoreLabel = _props.readMoreLabel;
	            var _state = this.state,
	                active = _state.active,
	                tabIndicatorLeft = _state.tabIndicatorLeft,
	                tabIndicatorWidth = _state.tabIndicatorWidth;
	
	
	            var tabsWithIcon = tabs.filter(function (x) {
	                return x.iconNew || x.icon;
	            });
	            var noItemsWithIcons = tabsWithIcon.length === 0 ? true : false;
	
	            return _react2.default.createElement(
	                'div',
	                { className: _TabListBlockModule2.default.block, 'data-block': blockId },
	                _react2.default.createElement(
	                    'header',
	                    { className: _TabListBlockModule2.default.header },
	                    _react2.default.createElement(
	                        'h2',
	                        _extends({
	                            className: 'block-title-large'
	                        }, this._onPageEdit("list", "Heading")),
	                        heading
	                    ),
	                    intro && _react2.default.createElement(
	                        'p',
	                        _extends({ className: 'ingress' }, this._onPageEdit("list", "Intro")),
	                        intro
	                    ),
	                    tabs && _react2.default.createElement(
	                        'nav',
	                        _extends({}, this._onPageEdit("list", "Tabs"), { onScroll: this._handleResize }),
	                        _react2.default.createElement(
	                            'ul',
	                            { ref: function ref(node) {
	                                    return _this3.list = node;
	                                }, className: noItemsWithIcons ? _TabListBlockModule2.default.noIcons : null },
	                            tabs.map(function (b, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    {
	                                        className: _TabListBlockModule2.default.tab,
	                                        key: index
	                                    },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: _TabListBlockModule2.default.tabInner },
	                                        _react2.default.createElement(
	                                            'button',
	                                            {
	                                                ref: function ref(b) {
	                                                    return _this3.navTabs[index] = b;
	                                                },
	                                                className: (0, _classnames2.default)(_TabListBlockModule2.default.button, _defineProperty({}, _TabListBlockModule2.default.active, index == active)),
	                                                'data-id': index,
	                                                onClick: _this3._handleBenefitClick,
	                                                type: 'button'
	                                            },
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: _TabListBlockModule2.default.iconWrapper },
	                                                b.iconNew ? _react2.default.createElement(_ImageIcon2.default, b.iconNew) : b.icon ? _react2.default.createElement(_Icon2.default, { icon: b.icon }) : null
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                b.title || b.heading
	                                            )
	                                        )
	                                    )
	                                );
	                            })
	                        ),
	                        active !== null && !!tabIndicatorLeft && !!tabIndicatorWidth && _react2.default.createElement('div', {
	                            className: _TabListBlockModule2.default["active-tab-indicator"],
	                            style: {
	                                transform: 'translateX(' + tabIndicatorLeft + 'px)',
	                                width: this.state.tabIndicatorWidth
	                            }
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactTransitionGroup.CSSTransitionGroup,
	                    {
	                        className: _TabListBlockModule2.default["tabs-wrapper"],
	                        transitionName: {
	                            enter: _TabListBlockModule2.default["enter"],
	                            enterActive: _TabListBlockModule2.default["enter-active"],
	                            leave: _TabListBlockModule2.default["leave"],
	                            leaveActive: _TabListBlockModule2.default["leave-active"]
	                        },
	                        transitionEnterTimeout: 300,
	                        transitionLeaveTimeout: 300
	                    },
	                    tabs && tabs.map(function (tab, index) {
	                        return active !== index ? null : _react2.default.createElement(
	                            'div',
	                            { key: index, className: (0, _classnames2.default)(_TabListBlockModule2.default.wrapper, _defineProperty({}, _TabListBlockModule2.default.noSide, !tab.content || tab.content.length === 0)) },
	                            tab.content && tab.content.length > 0 && _react2.default.createElement(
	                                'div',
	                                _extends({ className: _TabListBlockModule2.default.side }, _this3._onPageEdit("tab", "Content")),
	                                _this3._renderBlock.apply(_this3, [tab.content, index])
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TabListBlockModule2.default.content },
	                                _react2.default.createElement(
	                                    'h3',
	                                    _extends({ className: 'h2' }, _this3._onPageEdit("tab", "Heading")),
	                                    tab.heading || tab.title
	                                ),
	                                _react2.default.createElement('p', _extends({
	                                    className: _TabListBlockModule2.default.intro,
	                                    dangerouslySetInnerHTML: { __html: tab.intro }
	                                }, _this3._onPageEdit("tab", "Intro"))),
	                                _react2.default.createElement('div', _extends({
	                                    className: _TabListBlockModule2.default.text,
	                                    dangerouslySetInnerHTML: { __html: tab.text }
	                                }, _this3._onPageEdit("tab", "text"))),
	                                tab.link && _react2.default.createElement(
	                                    'p',
	                                    _extends({ className: _TabListBlockModule2.default.readMore }, _this3._onPageEdit("tab", "ReadMore")),
	                                    _react2.default.createElement(
	                                        _Button2.default,
	                                        { secondary: true, href: tab.link },
	                                        tab.linkText ? tab.linkText : readMoreLabel
	                                    )
	                                )
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TabListBlock;
	}(_react2.default.Component);
	
	TabListBlock.propTypes = {
	    blockId: _propTypes2.default.number.isRequired,
	    firstOpen: _propTypes2.default.bool.isRequired,
	    heading: _propTypes2.default.string,
	    intro: _propTypes2.default.string,
	    tabs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        blockId: _propTypes2.default.number,
	        heading: _propTypes2.default.string.isRequired,
	        title: _propTypes2.default.string,
	        icon: _propTypes2.default.string,
	        intro: _propTypes2.default.string,
	        text: _propTypes2.default.string,
	        content: _propTypes2.default.array,
	        contentType: _propTypes2.default.string,
	        link: _propTypes2.default.string,
	        linkText: _propTypes2.default.string
	    })).isRequired,
	    readMoreLabel: _propTypes2.default.string.isRequired,
	    contentType: _propTypes2.default.string
	};
	exports.default = TabListBlock;
	module.exports = exports['default'];

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TabListBlock = __webpack_require__(580);
	
	var _TabListBlock2 = _interopRequireDefault(_TabListBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TabListBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _throttle = __webpack_require__(70);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TableBlockModule = __webpack_require__(810);
	
	var _TableBlockModule2 = _interopRequireDefault(_TableBlockModule);
	
	var _OnPageEditing = __webpack_require__(21);
	
	var _OnPageEditing2 = _interopRequireDefault(_OnPageEditing);
	
	var _themes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getRow = function getRow(data) {
	    return data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? Object.keys(data).sort() : [];
	};
	var getHeaderColumns = function getHeaderColumns(data, keys) {
	    return keys.map(function (key, i) {
	        return typeof data[key] === "string" ? _react2.default.createElement('th', { key: i, dangerouslySetInnerHTML: { __html: data[key] } }) : _react2.default.createElement(
	            'th',
	            { key: i },
	            data[key]
	        );
	    });
	};
	var getColumns = function getColumns(data, keys) {
	    return keys.map(function (key, i) {
	        return typeof data[key] === "string" ? _react2.default.createElement('td', { key: i, dangerouslySetInnerHTML: { __html: data[key] } }) : _react2.default.createElement(
	            'td',
	            { key: i },
	            data[key]
	        );
	    });
	};
	
	var TableBlock = function (_React$Component) {
	    _inherits(TableBlock, _React$Component);
	
	    function TableBlock(props) {
	        _classCallCheck(this, TableBlock);
	
	        var _this = _possibleConstructorReturn(this, (TableBlock.__proto__ || Object.getPrototypeOf(TableBlock)).call(this, props));
	
	        _this.state = {
	            hasOverflowScroll: false,
	            hadScrollInteraction: false
	        };
	        _this.handleResize = (0, _throttle2.default)(function () {
	            _this.checkOverflowScroll();
	        }, 500);
	
	        _this.handleScroll = function () {
	            if (_this.tableContainer.scrollLeft > 0) {
	                _this.setState({ hadScrollInteraction: true });
	            }
	        };
	
	        _this.checkOverflowScroll = function () {
	            if (!_this.tableContainer) return;
	
	            _this.setState({
	                hasOverflowScroll: _this.tableContainer.scrollWidth > _this.tableContainer.offsetWidth
	            });
	        };
	
	        _this.rows = props.data && _this._filterArray(props.data);
	        return _this;
	    }
	
	    _createClass(TableBlock, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.checkOverflowScroll();
	
	            this.tableContainer.addEventListener("scroll", this.handleScroll);
	            typeof window !== 'undefined' && window.addEventListener("resize", this.handleResize);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(props) {
	            if (props.data !== this.props.data) {
	                this.rows = this._filterArray(props.data);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.tableContainer.removeEventListener("scroll", this.handleScroll);
	            typeof window !== 'undefined' && window.removeEventListener("resize", this.handleResize);
	        }
	    }, {
	        key: '_filterArray',
	        value: function _filterArray(data) {
	            if (!Array.isArray(data[0])) return data;
	            if (data.length === 0) return data;
	
	            // When we get a multidimensional array it will
	            // contain 10 cells per row which might contain
	            // empty cells so we need to find last cell which
	            // has a value so we can filter out all extraneous
	            // empty cells
	
	            var foundIndex = -1;
	            var rows = [];
	
	            for (var i = data[0].length - 1; i >= 0; i--) {
	                for (var x = 0; x < data.length; x++) {
	                    if (data[x][i]) {
	                        foundIndex = i;
	                        break;
	                    }
	                }
	
	                if (foundIndex !== -1) {
	                    rows = data.map(function (row) {
	                        return row.filter(function (cell, index) {
	                            return index <= foundIndex;
	                        });
	                    });
	                    break;
	                }
	            }
	
	            return rows;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _cn,
	                _this2 = this;
	
	            var _props = this.props,
	                heading = _props.heading,
	                text = _props.text,
	                theme = _props.theme,
	                readMoreLink = _props.readMoreLink,
	                readMoreText = _props.readMoreText,
	                keys = _props.keys,
	                rightAlign = _props.rightAlign;
	
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)(_TableBlockModule2.default.block, (0, _themes.getThemeClassNames)(_TableBlockModule2.default, theme)),
	                    'data-block-type': 'TableBlock'
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)(_TableBlockModule2.default.content, (_cn = {}, _defineProperty(_cn, _TableBlockModule2.default["has-overflow"], this.state.hasOverflowScroll), _defineProperty(_cn, _TableBlockModule2.default["had-interaction"], this.state.hadScrollInteraction), _cn)) },
	                    heading && _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { property: 'Heading' },
	                        _react2.default.createElement('h2', {
	                            className: (0, _classnames2.default)(_TableBlockModule2.default.heading, "block-title-large"),
	                            dangerouslySetInnerHTML: { __html: heading }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            ref: function ref(d) {
	                                return _this2.tableContainer = d;
	                            },
	                            className: _TableBlockModule2.default["table-swipe"]
	                        },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _TableBlockModule2.default["swipe-hint"] },
	                            _react2.default.createElement('div', { className: _TableBlockModule2.default["swipe-hint-hand"] }),
	                            _react2.default.createElement('div', { className: _TableBlockModule2.default["swipe-hint-trail"] })
	                        ),
	                        _react2.default.createElement(
	                            _OnPageEditing2.default,
	                            { property: 'Data' },
	                            _react2.default.createElement(
	                                'table',
	                                { className: (0, _classnames2.default)(_defineProperty({}, _TableBlockModule2.default.rightAlign, rightAlign)) },
	                                _react2.default.createElement(
	                                    'thead',
	                                    null,
	                                    this.rows && [this.rows[0]].map(function (v, i) {
	                                        return _react2.default.createElement(
	                                            'tr',
	                                            { key: i },
	                                            getHeaderColumns(v, keys || getRow(v))
	                                        );
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'tbody',
	                                    null,
	                                    this.rows && this.rows.filter(function (o, i) {
	                                        return i > 0;
	                                    }).map(function (v, i) {
	                                        return _react2.default.createElement(
	                                            'tr',
	                                            { key: i },
	                                            getColumns(v, keys || getRow(v))
	                                        );
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    text && _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { property: 'Text' },
	                        _react2.default.createElement(
	                            'p',
	                            { className: _TableBlockModule2.default["table-text"] },
	                            text
	                        )
	                    ),
	                    readMoreText && readMoreLink && _react2.default.createElement(
	                        'p',
	                        { className: _TableBlockModule2.default.readMore },
	                        _react2.default.createElement(
	                            _Button2.default,
	                            { secondary: true, href: readMoreLink },
	                            readMoreText
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TableBlock;
	}(_react2.default.Component);
	
	TableBlock.propTypes = {
	    heading: _propTypes2.default.string,
	    text: _propTypes2.default.string,
	    data: _propTypes2.default.array.isRequired,
	    theme: _propTypes2.default.oneOf(Object.keys(_themes.THEMES).map(function (s) {
	        return _themes.THEMES[s];
	    })),
	    readMoreText: _propTypes2.default.string,
	    readMoreLink: _propTypes2.default.string,
	    keys: _propTypes2.default.array,
	    rightAlign: _propTypes2.default.bool.isRequired
	};
	TableBlock.defaultProps = {
	    theme: 0,
	    rightAlign: false
	};
	exports.default = TableBlock;
	module.exports = exports['default'];

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ImageFigure = __webpack_require__(236);
	
	var _ImageFigure2 = _interopRequireDefault(_ImageFigure);
	
	var _NewImageBlock = __webpack_require__(238);
	
	var _NewImageBlock2 = _interopRequireDefault(_NewImageBlock);
	
	var _Collapse = __webpack_require__(404);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(726);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TextBlock = function TextBlock(_ref) {
	    var _cn;
	
	    var heading = _ref.heading,
	        image = _ref.image,
	        text = _ref.text,
	        textExpandable = _ref.textExpandable,
	        blockId = _ref.blockId,
	        anchorId = _ref.anchorId,
	        className = _ref.className,
	        place = _ref.place,
	        lang = _ref.lang;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)("text-block", (_cn = {}, _defineProperty(_cn, className, className), _defineProperty(_cn, 'text-block_place_' + place, place), _cn)), 'data-block': blockId, id: anchorId },
	        heading && _react2.default.createElement(
	            'h2',
	            { className: 'text-block__heading' },
	            heading
	        ),
	        image && _react2.default.createElement(_NewImageBlock2.default, {
	            image: image,
	            inRichText: true,
	            className: 'text-block__image'
	        }),
	        text && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: text } }),
	        textExpandable && _react2.default.createElement(
	            _Collapse2.default,
	            { expandLabel: lang.expandLabel, collapseLabel: lang.collapseLabel },
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: textExpandable } })
	        )
	    );
	};
	
	TextBlock.propTypes = {
	    className: _propTypes2.default.string,
	    heading: _propTypes2.default.string,
	    image: _propTypes2.default.shape(_ImageFigure2.default.propTypes),
	    text: _propTypes2.default.string,
	    textExpandable: _propTypes2.default.string,
	    blockId: _propTypes2.default.number,
	    anchorId: _propTypes2.default.string,
	    place: _propTypes2.default.oneOf(['investor-page']),
	    lang: _propTypes2.default.shape({
	        expandLabel: _propTypes2.default.string.isRequired,
	        collapseLabel: _propTypes2.default.string.isRequired
	    })
	};
	
	exports.default = TextBlock;
	module.exports = exports['default'];

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TextBlock = __webpack_require__(583);
	
	var _TextBlock2 = _interopRequireDefault(_TextBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _OnScreen = __webpack_require__(31);
	
	var _OnScreen2 = _interopRequireDefault(_OnScreen);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _EventCard = __webpack_require__(221);
	
	var _EventCard2 = _interopRequireDefault(_EventCard);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _scrollToElement = __webpack_require__(337);
	
	var _scrollToElement2 = _interopRequireDefault(_scrollToElement);
	
	__webpack_require__(727);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimelineBlock = function (_React$Component) {
	    _inherits(TimelineBlock, _React$Component);
	
	    function TimelineBlock() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TimelineBlock);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimelineBlock.__proto__ || Object.getPrototypeOf(TimelineBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            active: -1,
	            on: false
	        }, _this._getDateStamp = function (oldDate) {
	            // 26-02-2012";
	            if (!oldDate) return;
	            var theDate = oldDate.split(".");
	            //var newDate = theDate[1] + "." + theDate[0] + "." + theDate[2];
	            //var newDate = theDate[0] + "/" + theDate[1] + "/" + theDate[2];
	
	            // return (new Date(newDate).getTime());
	            return new Date(theDate[2], theDate[1] - 1, theDate[0]).getTime();
	        }, _this._futureFilter = function (event) {
	            if (_this._getDateStamp(event.date) >= Date.now()) {
	                return event;
	            }
	        }, _this._pastFilter = function (event) {
	            return Date.parse(event.dateAndTime) < Date.now();
	        }, _this._handleNavigationClick = function (e) {
	            e.preventDefault();
	            var direction = e.currentTarget.dataset.direction;
	
	            if (direction === "next") {
	                if (_this.props.milestoneList.length <= _this.state.active + 1) return;
	                _this.setState({ active: _this.state.active + 1 });
	            } else if (direction === "prev") {
	                if (_this.state.active - 1 < 0) return;
	                _this.setState({ active: _this.state.active - 1 });
	            }
	        }, _this._handleIndicatorClick = function (e) {
	            e.preventDefault();
	            var id = e.currentTarget.dataset.id;
	
	
	            var active = id - 1;
	
	            if (_this.state.active == active) {
	                return _this.setState({
	                    active: -1,
	                    on: false
	                });
	            }
	
	            _this.setState({
	                active: active,
	                on: true
	            });
	
	            var intViewportHeight = window.innerHeight;
	            var scrollOffset = intViewportHeight > 760 ? -intViewportHeight + 120 : -575;
	            (0, _scrollToElement2.default)(e.currentTarget, {
	                offset: scrollOffset,
	                ease: "linear",
	                duration: 500
	            });
	        }, _this._getPastPercent = function () {
	            var betweenStartAndEnd = _this._getDateStamp(_this.props.projectEnd) - _this._getDateStamp(_this.props.projectStart);
	            var betweenStartAndToday = Date.now() - _this._getDateStamp(_this.props.projectStart);
	            var percentBefore = betweenStartAndToday / betweenStartAndEnd * 100;
	            if (percentBefore < 0) {
	                percentBefore = 0;
	            }
	            if (percentBefore > 100) {
	                percentBefore = 100;
	            }
	            return percentBefore;
	        }, _this._getPastDatePercent = function (event) {
	            var timeline = _this._getDateStamp(_this.props.projectEnd) - _this._getDateStamp(_this.props.projectStart);
	            var startToEvent = _this._getDateStamp(event.date) - _this._getDateStamp(_this.props.projectStart);
	            var percent = startToEvent / timeline * 100;
	            if (percent < 0) {
	                percent = 0;
	            }
	            if (percent > 100) {
	                percent = 100;
	            }
	            return percent;
	        }, _this._getFutureDatePercent = function (event) {
	            var timeline = _this._getDateStamp(_this.props.projectEnd) - Date.now();
	            var endToEvent = _this._getDateStamp(_this.props.projectEnd) - _this._getDateStamp(event.date);
	            var percent = endToEvent / timeline * 100;
	            if (percent < 0) {
	                percent = 0;
	            }
	            if (percent > 100) {
	                percent = 100;
	            }
	
	            return percent;
	        }, _this._getMonth = function (thedate) {
	            var monthNames = _this.props.shortMonthNames; //["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"];
	            var theDate = thedate.split(".");
	            var newDate = monthNames[parseInt(theDate[1]) - 1] + " " + theDate[2];
	            return newDate;
	        }, _this._close = function () {
	            _this.setState({
	                on: false
	            });
	        }, _this._toggleOn = function () {
	            if (_this.state.on == true) {
	                _this.setState({
	                    on: false
	                });
	            }
	            if (_this.state.on == false) {
	                if (_this.state.active === -1) {
	                    _this.setState({
	                        on: true,
	                        active: 0
	                    });
	                } else {
	                    _this.setState({
	                        on: true
	                    });
	                }
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    // _pastFilter = e => {
	
	
	    _createClass(TimelineBlock, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                hideTimelineLabel = _props.hideTimelineLabel,
	                showTimelineLabel = _props.showTimelineLabel,
	                onScreen = _props.onScreen;
	
	
	            var projectStatusLabel = this.props.projectStatusLabel;
	            var nextLabel = this.props.nextLabel;
	            var prevLabel = this.props.prevLabel;
	            var closeLabel = this.props.closeLabel;
	            var events = this.props.milestoneList;
	            var active = this.state.active;
	            var startDate = this.props.projectStart;
	            var endDate = this.props.projectEnd;
	            var shortMonthNames = this.props.shortMonthNames;
	            var fullMonthNames = this.props.fullMonthNames;
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)("timeline-block", {
	                        "active": this.state.on,
	                        'is-visible': onScreen
	                    }) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'timeline-block-content' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'title' },
	                        projectStatusLabel
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal', id: 'timeline-modal' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'cards-frame' },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'cards', style: { transform: 'translateX(-' + active * 100 + '%)' } },
	                                events.map(function (event, index) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        { key: index },
	                                        _react2.default.createElement(_EventCard2.default, { event: event, close: _this2._close, closeLabel: closeLabel, monthNames: fullMonthNames, link: event.link })
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'nav' },
	                                active > 0 && _react2.default.createElement(
	                                    'button',
	                                    {
	                                        type: 'button',
	                                        className: 'prev',
	                                        'data-direction': 'prev',
	                                        onClick: this._handleNavigationClick
	                                    },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'arrow-left' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        prevLabel
	                                    )
	                                ),
	                                !(active == events.length - 1) && _react2.default.createElement(
	                                    'button',
	                                    {
	                                        type: 'button',
	                                        className: 'next',
	                                        'data-direction': 'next',
	                                        onClick: this._handleNavigationClick
	                                    },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'arrow-right' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        nextLabel
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'button',
	                                    {
	                                        className: 'close',
	                                        onClick: this._close
	                                    },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'close' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        closeLabel
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'timeline' },
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'past', style: { width: this._getPastPercent() + '%' } },
	                            this.props.milestoneList.filter(this._pastFilter).map(function (event) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    {
	                                        key: event.id + 1,
	                                        style: { left: _this2._getPastDatePercent(event) + '%' }
	                                    },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'data-id': event.id + 1,
	                                            onClick: _this2._handleIndicatorClick,
	                                            className: active === _this2.props.milestoneList.indexOf(event) && _this2.state.on ? "active" : null
	                                        },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            event.title
	                                        )
	                                    )
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'present' },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'dot' },
	                                _react2.default.createElement('li', null),
	                                _react2.default.createElement('li', null),
	                                _react2.default.createElement('li', null)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'future', style: { width: 100 - this._getPastPercent() + '%' } },
	                            this.props.milestoneList.filter(this._futureFilter).map(function (event) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    {
	                                        key: event.id + 1,
	                                        style: { right: _this2._getFutureDatePercent(event) + '%' }
	                                    },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'data-id': event.id + 1,
	                                            onClick: _this2._handleIndicatorClick,
	                                            className: active === _this2.props.milestoneList.indexOf(event) && _this2.state.on ? "active" : null
	                                        },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            event.title
	                                        )
	                                    )
	                                );
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'timeline-dates' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'start' },
	                            this._getMonth(startDate)
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'end' },
	                            this._getMonth(endDate)
	                        )
	                    ),
	                    this.props.milestoneList && this.props.milestoneList.length > 0 && _react2.default.createElement(
	                        _Button2.default,
	                        {
	                            className: (0, _classnames2.default)("timeline-toggle-btn", _defineProperty({}, "active", this.state.on)),
	                            onClick: this._toggleOn,
	                            light: true,
	                            secondary: true,
	                            type: 'button'
	                        },
	                        this.state.on ? hideTimelineLabel : showTimelineLabel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TimelineBlock;
	}(_react2.default.Component);
	
	TimelineBlock.propTypes = {
	    projectStatusLabel: _propTypes2.default.string,
	    nextLabel: _propTypes2.default.string,
	    prevLabel: _propTypes2.default.string,
	    closeLabel: _propTypes2.default.string,
	    shortMonthNames: _propTypes2.default.array.isRequired,
	    fullMonthNames: _propTypes2.default.array.isRequired,
	    milestoneList: _propTypes2.default.array.isRequired,
	    projectStart: _propTypes2.default.string,
	    projectEnd: _propTypes2.default.string,
	    showTimelineLabel: _propTypes2.default.string.isRequired,
	    hideTimelineLabel: _propTypes2.default.string.isRequired,
	    onScreen: _propTypes2.default.bool
	};
	exports.default = (0, _OnScreen2.default)(TimelineBlock);
	module.exports = exports['default'];

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TimelineBlock = __webpack_require__(585);
	
	var _TimelineBlock2 = _interopRequireDefault(_TimelineBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TimelineBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TopTextModule = __webpack_require__(811);
	
	var _TopTextModule2 = _interopRequireDefault(_TopTextModule);
	
	var _themes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopText = function (_React$Component) {
	  _inherits(TopText, _React$Component);
	
	  function TopText() {
	    _classCallCheck(this, TopText);
	
	    return _possibleConstructorReturn(this, (TopText.__proto__ || Object.getPrototypeOf(TopText)).apply(this, arguments));
	  }
	
	  _createClass(TopText, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          text = _props.text,
	          theme = _props.theme;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_TopTextModule2.default.block, (0, _themes.getThemeClassNames)(_TopTextModule2.default, theme)) },
	        _react2.default.createElement("div", {
	          className: (0, _classnames2.default)(_TopTextModule2.default.text, "top-text"),
	          dangerouslySetInnerHTML: { __html: text }
	        })
	      );
	    }
	  }]);
	
	  return TopText;
	}(_react2.default.Component);
	
	TopText.propTypes = {
	  text: _propTypes2.default.string,
	  theme: _propTypes2.default.oneOf(Object.keys(_themes.THEMES).map(function (s) {
	    return _themes.THEMES[s];
	  }))
	};
	TopText.defaultProps = {
	  theme: _themes.THEMES.lightgray
	};
	exports.default = TopText;
	module.exports = exports["default"];

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TopText = __webpack_require__(587);
	
	var _TopText2 = _interopRequireDefault(_TopText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TopText2.default;
	module.exports = exports['default'];

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _topicAreasThemes = __webpack_require__(610);
	
	var _TopicAreasNavigationBlockModule = __webpack_require__(812);
	
	var _TopicAreasNavigationBlockModule2 = _interopRequireDefault(_TopicAreasNavigationBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TopicAreasNavigationBlock = function TopicAreasNavigationBlock(_ref) {
	  var blockId = _ref.blockId,
	      heading = _ref.heading,
	      _ref$theme = _ref.theme,
	      theme = _ref$theme === undefined ? _topicAreasThemes.TOPICAREASTHEMES.lightGrey : _ref$theme,
	      items = _ref.items;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_TopicAreasNavigationBlockModule2.default.block, (0, _topicAreasThemes.getTopicAreasThemeClassNames)(_TopicAreasNavigationBlockModule2.default, theme)),
	      'data-block': blockId
	    },
	    heading && _react2.default.createElement(
	      'h2',
	      { className: (0, _classnames2.default)("block-title-large", _TopicAreasNavigationBlockModule2.default.heading) },
	      heading
	    ),
	    items && _react2.default.createElement(
	      'ul',
	      { className: _TopicAreasNavigationBlockModule2.default.items },
	      items.map(function (item, index) {
	        return _react2.default.createElement(
	          'li',
	          { className: _TopicAreasNavigationBlockModule2.default.item, key: index },
	          _react2.default.createElement(
	            'a',
	            {
	              className: (0, _classnames2.default)(_TopicAreasNavigationBlockModule2.default.link, _defineProperty({}, _TopicAreasNavigationBlockModule2.default.active, item.isActive)),
	              href: item.link.url,
	              target: item.link.openInNewWindow ? "_blank" : null,
	              rel: item.link.openInNewWindow ? "noopener noreferrer" : null
	            },
	            item.icon && _react2.default.createElement(_Icon2.default, { icon: item.icon, className: _TopicAreasNavigationBlockModule2.default.icon }),
	            _react2.default.createElement(
	              'span',
	              { className: _TopicAreasNavigationBlockModule2.default.linkText },
	              item.link.linkText
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	TopicAreasNavigationBlock.propTypes = {
	  blockId: _propTypes2.default.number.isRequired,
	  heading: _propTypes2.default.string,
	  theme: _propTypes2.default.oneOf(Object.keys(_topicAreasThemes.TOPICAREASTHEMES).map(function (s) {
	    return _topicAreasThemes.TOPICAREASTHEMES[s];
	  })),
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    icon: _propTypes2.default.string,
	    isActive: _propTypes2.default.bool,
	    link: _propTypes2.default.shape({
	      url: _propTypes2.default.string.isRequired,
	      linkText: _propTypes2.default.string.isRequired,
	      openInNewWindow: _propTypes2.default.bool.isRequired
	    })
	  }))
	};
	
	exports.default = TopicAreasNavigationBlock;
	module.exports = exports['default'];

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TopicAreasNavigationBlock = __webpack_require__(589);
	
	var _TopicAreasNavigationBlock2 = _interopRequireDefault(_TopicAreasNavigationBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TopicAreasNavigationBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(16);
	
	var _DropdownFilter = __webpack_require__(58);
	
	var _DropdownFilter2 = _interopRequireDefault(_DropdownFilter);
	
	var _VacancyListBlock = __webpack_require__(247);
	
	var _VacancyListBlock2 = _interopRequireDefault(_VacancyListBlock);
	
	var _GoToReachMeeProfile = __webpack_require__(471);
	
	var _GoToReachMeeProfile2 = _interopRequireDefault(_GoToReachMeeProfile);
	
	var _VacanciesFilterModule = __webpack_require__(813);
	
	var _VacanciesFilterModule2 = _interopRequireDefault(_VacanciesFilterModule);
	
	var _themes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VacanciesFilter = function (_React$Component) {
	    _inherits(VacanciesFilter, _React$Component);
	
	    function VacanciesFilter(props) {
	        _classCallCheck(this, VacanciesFilter);
	
	        var _this = _possibleConstructorReturn(this, (VacanciesFilter.__proto__ || Object.getPrototypeOf(VacanciesFilter)).call(this, props));
	
	        _this._handleRegionClick = function (e, active) {
	            _this.setState({ regionFilter: active, businessAreaFilter: "", unitFilter: "", jobTypeFilter: "" });
	        };
	
	        _this._handleBusinessAreaClick = function (e, active) {
	            e.preventDefault();
	
	            _this.setState({ businessAreaFilter: active, unitFilter: "", jobTypeFilter: "" });
	        };
	
	        _this._handleUnitClick = function (e, active) {
	            e.preventDefault();
	
	            _this.setState({ businessAreaFilter: "", unitFilter: active, jobTypeFilter: "" });
	        };
	
	        _this._handleJobTypeClick = function (e, active) {
	            e.preventDefault();
	
	            _this.setState({ businessAreaFilter: "", unitFilter: "", jobTypeFilter: active });
	        };
	
	        _this.groupUnits = function () {
	            var _this$props = _this.props,
	                businessAreas = _this$props.businessAreas,
	                units = _this$props.units;
	
	            return (0, _utils.groupBy)(units, function (i) {
	                if (i.businessAreas && i.businessAreas.length) {
	                    return i.businessAreas;
	                }
	                return null;
	            }, businessAreas);
	        };
	
	        _this.state = {
	            regionFilter: props.regionFilter || props.regions[0].key,
	            businessAreaFilter: props.businessAreaFilter || "",
	            unitFilter: props.unitFilter || "",
	            jobTypeFilter: props.jobTypeFilter || ""
	        };
	        return _this;
	    }
	
	    _createClass(VacanciesFilter, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                regionsLabel = _props.regionsLabel,
	                regions = _props.regions,
	                businessAreasLabel = _props.businessAreasLabel,
	                businessAreas = _props.businessAreas,
	                unitsLabel = _props.unitsLabel,
	                vacancies = _props.vacancies,
	                goToReachmeeProfile = _props.goToReachmeeProfile,
	                jobTypesLabel = _props.jobTypesLabel,
	                jobTypes = _props.jobTypes;
	            var _state = this.state,
	                regionFilter = _state.regionFilter,
	                businessAreaFilter = _state.businessAreaFilter,
	                unitFilter = _state.unitFilter,
	                jobTypeFilter = _state.jobTypeFilter;
	
	
	            var filteredByRegion = vacancies.filter(function (v) {
	                if (v && v.regionId) {
	                    return regionFilter === "" || v.regionId.toString() === regionFilter.toString();
	                }
	                return false;
	            });
	
	            var filteredVacancies = filteredByRegion.filter(function (v) {
	                return businessAreaFilter === "" && unitFilter === "" && jobTypeFilter === "" || businessAreaFilter !== "" && v.businessAreaId.toString() === businessAreaFilter || unitFilter !== "" && v.unitId.toString() === unitFilter || jobTypeFilter !== "" && v.jobTypeId.toString() === jobTypeFilter;
	            });
	
	            return _react2.default.createElement(
	                'nav',
	                { className: _VacanciesFilterModule2.default.block },
	                _react2.default.createElement(
	                    'header',
	                    { className: _VacanciesFilterModule2.default.header },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            filteredByRegion.length
	                        ),
	                        _react2.default.createElement(_DropdownFilter2.default, {
	                            className: _VacanciesFilterModule2.default['dropdown-block'],
	                            heading: regionsLabel,
	                            items: regions,
	                            active: regionFilter,
	                            onSelect: this._handleRegionClick
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { className: _VacanciesFilterModule2.default.content },
	                    _react2.default.createElement(_DropdownFilter2.default, {
	                        heading: jobTypesLabel,
	                        items: jobTypes,
	                        active: jobTypeFilter,
	                        onSelect: this._handleJobTypeClick }),
	                    _react2.default.createElement(_DropdownFilter2.default, {
	                        heading: businessAreasLabel,
	                        items: businessAreas,
	                        active: businessAreaFilter,
	                        onSelect: this._handleBusinessAreaClick }),
	                    _react2.default.createElement(_DropdownFilter2.default, {
	                        heading: unitsLabel,
	                        items: this.groupUnits(),
	                        active: unitFilter,
	                        onSelect: this._handleUnitClick })
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { className: (0, _classnames2.default)(_VacanciesFilterModule2.default.list) },
	                    _react2.default.createElement(_VacancyListBlock2.default, {
	                        blockId: 200,
	                        vacancies: filteredVacancies,
	                        theme: _themes.THEMES.zebra,
	                        displayImages: true
	                    }),
	                    _react2.default.createElement(_GoToReachMeeProfile2.default, _extends({ theme: _themes.THEMES.zebra }, goToReachmeeProfile))
	                )
	            );
	        }
	    }]);
	
	    return VacanciesFilter;
	}(_react2.default.Component);
	
	VacanciesFilter.propTypes = {
	    regionFilter: _propTypes2.default.string,
	    businessAreaFilter: _propTypes2.default.string,
	    unitFilter: _propTypes2.default.string,
	    jobTypeFilter: _propTypes2.default.string,
	
	    regionsLabel: _propTypes2.default.string.isRequired,
	    businessAreasLabel: _propTypes2.default.string.isRequired,
	    unitsLabel: _propTypes2.default.string.isRequired,
	    jobTypesLabel: _propTypes2.default.string.isRequired,
	
	    regions: _propTypes2.default.array.isRequired,
	    businessAreas: _propTypes2.default.array.isRequired,
	    units: _propTypes2.default.array.isRequired,
	    jobTypes: _propTypes2.default.array.isRequired,
	    vacancies: _propTypes2.default.array.isRequired,
	    goToReachmeeProfile: _propTypes2.default.shape({
	        text: _propTypes2.default.string,
	        url: _propTypes2.default.string,
	        linkText: _propTypes2.default.string
	    })
	};
	exports.default = VacanciesFilter;
	module.exports = exports['default'];

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _VacanciesFilter = __webpack_require__(591);
	
	var _VacanciesFilter2 = _interopRequireDefault(_VacanciesFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _VacanciesFilter2.default;
	module.exports = exports['default'];

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FluidImage = __webpack_require__(30);
	
	var _FluidImage2 = _interopRequireDefault(_FluidImage);
	
	var _vacancyCardThemes = __webpack_require__(611);
	
	__webpack_require__(728);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var VacancyCard = function VacancyCard(_ref) {
	    var _cn;
	
	    var name = _ref.name,
	        location = _ref.location,
	        categories = _ref.categories,
	        deadline = _ref.deadline,
	        image = _ref.image,
	        link = _ref.link,
	        displayImage = _ref.displayImage,
	        theme = _ref.theme,
	        className = _ref.className,
	        onScreen = _ref.onScreen;
	    return _react2.default.createElement(
	        'a',
	        {
	            className: (0, _classnames2.default)("vacancy-card", (_cn = {}, _defineProperty(_cn, 'vacancy-card_theme_' + _vacancyCardThemes.VACANCYCARDTHEMES[theme], theme), _defineProperty(_cn, className, className), _cn)),
	            href: link, 'data-card': 'vacancy'
	        },
	        _react2.default.createElement(
	            'div',
	            { className: 'vacancy-card__content' },
	            _react2.default.createElement(
	                'p',
	                { className: 'vacancy-card__title' },
	                name
	            ),
	            _react2.default.createElement(
	                'ul',
	                { className: 'vacancy-card__info' },
	                location && _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(_Icon2.default, { icon: 'location' }),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        location
	                    )
	                ),
	                categories && _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(_Icon2.default, { icon: 'briefcase' }),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        categories
	                    )
	                ),
	                deadline && _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(_Icon2.default, { icon: 'calendar' }),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        deadline
	                    )
	                )
	            )
	        ),
	        image && displayImage && _react2.default.createElement(
	            'div',
	            { className: 'vacancy-card__image-wrapper' },
	            _react2.default.createElement(_FluidImage2.default, {
	                className: 'vacancy-card__image',
	                image: image,
	                visible: onScreen
	            })
	        ),
	        !displayImage && _react2.default.createElement(
	            'div',
	            { className: 'vacancy-card__arrow' },
	            _react2.default.createElement(_Icon2.default, { icon: 'arrow-right' })
	        )
	    );
	};
	
	VacancyCard.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	    image: _propTypes2.default.string,
	    location: _propTypes2.default.string,
	    categories: _propTypes2.default.string,
	    deadline: _propTypes2.default.string,
	    link: _propTypes2.default.string.isRequired,
	    displayImage: _propTypes2.default.bool.isRequired,
	    className: _propTypes2.default.string,
	    onScreen: _propTypes2.default.bool.isRequired,
	    theme: _propTypes2.default.oneOf(Object.values(_vacancyCardThemes.VACANCYCARDTHEMES))
	};
	
	VacancyCard.defaultProps = {
	    displayImage: true,
	    onScreen: true,
	    theme: _vacancyCardThemes.VACANCYCARDTHEMES.default
	};
	
	exports.default = VacancyCard;
	module.exports = exports['default'];

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _VacancyCard = __webpack_require__(246);
	
	var _VacancyCard2 = _interopRequireDefault(_VacancyCard);
	
	var _Button = __webpack_require__(7);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _OnScreen = __webpack_require__(31);
	
	var _OnScreen2 = _interopRequireDefault(_OnScreen);
	
	var _VacancyListBlockModule = __webpack_require__(814);
	
	var _VacancyListBlockModule2 = _interopRequireDefault(_VacancyListBlockModule);
	
	var _themes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var VacancyListBlock = function VacancyListBlock(_ref) {
	    var blockId = _ref.blockId,
	        heading = _ref.heading,
	        onScreen = _ref.onScreen,
	        vacancies = _ref.vacancies,
	        link = _ref.link,
	        linkText = _ref.linkText,
	        theme = _ref.theme,
	        displayImages = _ref.displayImages,
	        totalCount = _ref.totalCount;
	    return _react2.default.createElement(
	        'div',
	        {
	            className: (0, _classnames2.default)(_VacancyListBlockModule2.default.block, (0, _themes.getThemeClassNames)(_VacancyListBlockModule2.default, theme)),
	            'data-block': blockId,
	            tabIndex: '-1'
	        },
	        _react2.default.createElement(
	            'div',
	            { className: _VacancyListBlockModule2.default.content },
	            typeof totalCount !== "undefined" && (totalCount === -1 && heading && _react2.default.createElement('h2', {
	                className: (0, _classnames2.default)("h1", _VacancyListBlockModule2.default.heading),
	                dangerouslySetInnerHTML: { __html: heading }
	            }) || totalCount !== -1 && _react2.default.createElement(
	                'h2',
	                { className: (0, _classnames2.default)("h1", _VacancyListBlockModule2.default.heading) },
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    totalCount
	                ),
	                ' ',
	                heading
	            )),
	            _react2.default.createElement(
	                'ul',
	                null,
	                vacancies && vacancies.map(function (v) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: v.id, className: (0, _classnames2.default)(_defineProperty({}, _VacancyListBlockModule2.default["is-on-screen"], onScreen)) },
	                        _react2.default.createElement(_VacancyCard2.default, _extends({}, v, {
	                            onScreen: onScreen,
	                            displayImage: displayImages
	                        }))
	                    );
	                })
	            ),
	            link && _react2.default.createElement(
	                'div',
	                { className: _VacancyListBlockModule2.default['see-all'] },
	                _react2.default.createElement(
	                    _Button2.default,
	                    { href: link },
	                    linkText
	                )
	            )
	        )
	    );
	};
	
	VacancyListBlock.defaultProps = {
	    theme: 1, // default yellow,
	    displayImages: true
	};
	
	VacancyListBlock.propTypes = {
	    blockId: _propTypes2.default.number,
	    heading: _propTypes2.default.string,
	    totalCount: _propTypes2.default.number,
	    onScreen: _propTypes2.default.bool,
	    vacancies: _propTypes2.default.array.isRequired,
	    link: _propTypes2.default.string,
	    linkText: _propTypes2.default.string,
	    theme: _propTypes2.default.oneOf(Object.keys(_themes.THEMES).map(function (s) {
	        return _themes.THEMES[s];
	    })),
	    displayImages: _propTypes2.default.bool.isRequired
	};
	
	exports.default = (0, _OnScreen2.default)(VacancyListBlock);
	module.exports = exports['default'];

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FluidImage = __webpack_require__(30);
	
	var _FluidImage2 = _interopRequireDefault(_FluidImage);
	
	var _VideoPlayer = __webpack_require__(597);
	
	var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);
	
	var _OnPageEditing = __webpack_require__(21);
	
	var _OnPageEditing2 = _interopRequireDefault(_OnPageEditing);
	
	var _tracking = __webpack_require__(99);
	
	var _VideoListBlockModule = __webpack_require__(815);
	
	var _VideoListBlockModule2 = _interopRequireDefault(_VideoListBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoListBlock = function (_React$Component) {
	    _inherits(VideoListBlock, _React$Component);
	
	    function VideoListBlock() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, VideoListBlock);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VideoListBlock.__proto__ || Object.getPrototypeOf(VideoListBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            selected: 0,
	            playing: false
	        }, _this._handlePlayClick = function () {
	            var video = _this.props.videos[_this.state.selected];
	
	            // GA tracking
	            (0, _tracking.track)('youTubeTrack', {
	                videoAction: 'play',
	                videoUrl: 'http://youtube.com/watch?v=' + video.youtubeVideoId,
	                videoTitle: video.title
	            });
	
	            _this.setState({ playing: true });
	        }, _this._handleClick = function (e) {
	            var selected = parseInt(e.currentTarget.dataset.video);
	            var video = _this.props.videos[selected];
	
	            // GA tracking
	            (0, _tracking.track)('video_selection', video.title + ' - ' + (video.subtitle || ""));
	
	            _this.setState({
	                playing: false,
	                selected: selected
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(VideoListBlock, [{
	        key: 'render',
	        value: function render() {
	            var _cn,
	                _this2 = this;
	
	            var _props = this.props,
	                header = _props.header,
	                intro = _props.intro,
	                size = _props.size,
	                blockId = _props.blockId,
	                contentType = _props.contentType,
	                videos = _props.videos,
	                squaredThumbnails = _props.squaredThumbnails,
	                playVideoLabel = _props.playVideoLabel,
	                isFullHeight = _props.isFullHeight;
	            var _state = this.state,
	                selected = _state.selected,
	                playing = _state.playing;
	
	
	            var activeVideo = videos[selected];
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)(_VideoListBlockModule2.default.block, (_cn = {}, _defineProperty(_cn, _VideoListBlockModule2.default.playing, playing), _defineProperty(_cn, _VideoListBlockModule2.default.condensed, size === 'small'), _cn)),
	                    'data-block': blockId,
	                    'data-block-type': 'VideoListBlock'
	                },
	                (header || intro) && _react2.default.createElement(
	                    'header',
	                    { className: _VideoListBlockModule2.default.header },
	                    _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { property: 'Header' },
	                        header && _react2.default.createElement(
	                            'h2',
	                            { className: _VideoListBlockModule2.default['block-heading'] },
	                            header
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { property: 'Intro' },
	                        intro && _react2.default.createElement(
	                            'p',
	                            { className: _VideoListBlockModule2.default['block-intro'] },
	                            intro
	                        )
	                    )
	                ),
	                activeVideo && _react2.default.createElement(_VideoPlayer2.default, _extends({}, activeVideo, {
	                    playing: playing,
	                    onPageEditing: contentType !== 'VideoListBlock',
	                    onPlay: this._handlePlayClick,
	                    playVideoLabel: playVideoLabel,
	                    theme: isFullHeight ? _VideoPlayer2.default.themes.full : undefined
	                })),
	                videos.length > 1 && _react2.default.createElement(
	                    _OnPageEditing2.default,
	                    { property: 'VideoList' },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _VideoListBlockModule2.default.videos },
	                        videos.map(function (v, i) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: i, className: _VideoListBlockModule2.default.video },
	                                _react2.default.createElement(
	                                    'button',
	                                    {
	                                        className: (0, _classnames2.default)(_defineProperty({}, _VideoListBlockModule2.default.active, i === selected)),
	                                        'data-video': i,
	                                        onClick: _this2._handleClick
	                                    },
	                                    _react2.default.createElement(_FluidImage2.default, {
	                                        className: (0, _classnames2.default)(_VideoListBlockModule2.default.preview, _defineProperty({}, _VideoListBlockModule2.default.squared, squaredThumbnails)),
	                                        image: v.previewImage
	                                    }),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: _VideoListBlockModule2.default.subtitle },
	                                        v.subtitle
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: _VideoListBlockModule2.default.description },
	                                        v.description
	                                    )
	                                )
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return VideoListBlock;
	}(_react2.default.Component);
	
	VideoListBlock.propTypes = {
	    header: _propTypes2.default.string,
	    intro: _propTypes2.default.string,
	    size: _propTypes2.default.oneOf(['large', 'small']).isRequired,
	    blockId: _propTypes2.default.number.isRequired,
	    contentType: _propTypes2.default.string,
	    videos: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        title: _propTypes2.default.string,
	        subtitle: _propTypes2.default.string,
	        description: _propTypes2.default.string,
	        youtubeVideoId: _propTypes2.default.string,
	        previewImage: _propTypes2.default.string,
	        previewImageMobile: _propTypes2.default.string
	    })).isRequired,
	    squaredThumbnails: _propTypes2.default.bool.isRequired,
	    playVideoLabel: _propTypes2.default.string.isRequired,
	    isFullHeight: _propTypes2.default.bool
	};
	VideoListBlock.defaultProps = {
	    size: 'large',
	    squaredThumbnails: false
	};
	exports.default = VideoListBlock;
	module.exports = exports['default'];

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _OnPageEditing = __webpack_require__(21);
	
	var _OnPageEditing2 = _interopRequireDefault(_OnPageEditing);
	
	var _VideoPlayerModule = __webpack_require__(816);
	
	var _VideoPlayerModule2 = _interopRequireDefault(_VideoPlayerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var themes = {
	    full: "-theme-full",
	    default: "-theme-default"
	};
	
	var VideoPlayer = function (_React$PureComponent) {
	    _inherits(VideoPlayer, _React$PureComponent);
	
	    function VideoPlayer() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, VideoPlayer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VideoPlayer.__proto__ || Object.getPrototypeOf(VideoPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            isPortrait: false
	        }, _this.checkScreenOriantation = function () {
	            if (typeof window !== "undefined") {
	                _this.setState({ isPortrait: window.innerHeight > window.innerWidth && window.innerWidth < 560 ? true : false });
	            }
	        }, _this.componentDidMount = function () {
	            _this.checkScreenOriantation();
	            window.addEventListener("resize", _this.checkScreenOriantation);
	        }, _this.componentWillUnmount = function () {
	            window.removeEventListener("resize", _this.checkScreenOriantation);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(VideoPlayer, [{
	        key: "render",
	        value: function render() {
	            var _cn;
	
	            var _props = this.props,
	                previewImage = _props.previewImage,
	                previewImageMobile = _props.previewImageMobile,
	                youtubeVideoId = _props.youtubeVideoId,
	                onPlay = _props.onPlay,
	                onPageEditing = _props.onPageEditing,
	                playing = _props.playing,
	                title = _props.title,
	                playVideoLabel = _props.playVideoLabel,
	                theme = _props.theme;
	
	
	            var poster = previewImageMobile && this.state.isPortrait ? previewImageMobile : previewImage;
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: (0, _classnames2.default)(_VideoPlayerModule2.default.video, (_cn = {}, _defineProperty(_cn, _VideoPlayerModule2.default.playing, playing), _defineProperty(_cn, _VideoPlayerModule2.default[theme], theme), _cn)),
	                    style: poster ? {
	                        backgroundImage: "url(" + poster + ")"
	                    } : null
	                },
	                _react2.default.createElement(
	                    "button",
	                    {
	                        className: _VideoPlayerModule2.default.play,
	                        onClick: onPlay,
	                        type: "button"
	                    },
	                    (playVideoLabel || "") + " " + title
	                ),
	                _react2.default.createElement(
	                    _OnPageEditing2.default,
	                    { active: onPageEditing, property: "Title" },
	                    title && _react2.default.createElement(
	                        "p",
	                        { className: _VideoPlayerModule2.default.title },
	                        title
	                    )
	                ),
	                playing && _react2.default.createElement("iframe", {
	                    allowFullScreen: true,
	                    className: _VideoPlayerModule2.default.iframe,
	                    frameBorder: "0",
	                    src: "https://www.youtube.com/embed/" + youtubeVideoId + "?autoplay=1&rel=0&showinfo=0"
	                })
	            );
	        }
	    }]);
	
	    return VideoPlayer;
	}(_react2.default.PureComponent);
	
	VideoPlayer.propTypes = {
	    playing: _propTypes2.default.bool.isRequired,
	    onPlay: _propTypes2.default.func.isRequired,
	    onPageEditing: _propTypes2.default.bool.isRequired,
	    previewImage: _propTypes2.default.string,
	    previewImageMobile: _propTypes2.default.string,
	    youtubeVideoId: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    playVideoLabel: _propTypes2.default.string.isRequired,
	    theme: _propTypes2.default.oneOf(Object.keys(themes).map(function (key) {
	        return themes[key];
	    }))
	};
	VideoPlayer.defaultProps = {
	    theme: themes.default,
	    onPageEditing: false
	};
	VideoPlayer.themes = themes;
	exports.default = VideoPlayer;
	module.exports = exports["default"];

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _VideoPlayer = __webpack_require__(596);
	
	var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _VideoPlayer2.default;
	module.exports = exports['default'];

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FancyImage = __webpack_require__(222);
	
	var _FancyImage2 = _interopRequireDefault(_FancyImage);
	
	var _videoModule = __webpack_require__(817);
	
	var _videoModule2 = _interopRequireDefault(_videoModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Video = function (_React$Component) {
	    _inherits(Video, _React$Component);
	
	    function Video() {
	        _classCallCheck(this, Video);
	
	        return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
	    }
	
	    _createClass(Video, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this,
	                _cn;
	
	            var video = this.props.videos.find(function (v) {
	                return v.label === (_this2.props.isMobile ? "mobile" : "desktop");
	            }) || this.props.videos[0];
	
	            if (!video) return _react2.default.createElement(_FancyImage2.default, this.props.fallbackImage);
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: (0, _classnames2.default)(_videoModule2.default.videoWrapper, "video-wrapper", (_cn = {}, _defineProperty(_cn, _videoModule2.default.fixed, this.props.isFixed), _defineProperty(_cn, _videoModule2.default.hasGradient, this.props.hasGradient), _cn))
	                },
	                video.poster && _react2.default.createElement("div", {
	                    className: _videoModule2.default.videoBg,
	                    style: {
	                        backgroundImage: "url(" + video.poster + ")"
	                    }
	                }),
	                _react2.default.createElement("video", {
	                    className: _videoModule2.default.video,
	                    loop: true,
	                    muted: "true",
	                    autoPlay: true,
	                    playsInline: true,
	                    src: video.src
	                })
	            );
	        }
	    }]);
	
	    return Video;
	}(_react2.default.Component);
	
	Video.propTypes = {
	    videos: _propTypes2.default.array,
	    isMobile: _propTypes2.default.bool,
	    test: _propTypes2.default.bool,
	    fallbackImage: _propTypes2.default.object,
	    isFixed: _propTypes2.default.bool,
	    hasGradient: _propTypes2.default.bool
	};
	exports.default = Video;
	module.exports = exports["default"];

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Video = __webpack_require__(598);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Video2.default;
	module.exports = exports['default'];

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LinkButton = __webpack_require__(47);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _Image = __webpack_require__(77);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _VisitOurWebsiteBlockModule = __webpack_require__(818);
	
	var _VisitOurWebsiteBlockModule2 = _interopRequireDefault(_VisitOurWebsiteBlockModule);
	
	var _Button = __webpack_require__(75);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var VisitOurWebsiteBlock = function VisitOurWebsiteBlock(_ref) {
	    var lang = _ref.lang,
	        logo = _ref.logo,
	        link = _ref.link;
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_VisitOurWebsiteBlockModule2.default.block, _defineProperty({}, _VisitOurWebsiteBlockModule2.default['no-logo'], !logo)) },
	        _react2.default.createElement(
	            'div',
	            { className: _VisitOurWebsiteBlockModule2.default.container },
	            logo && _react2.default.createElement(
	                'div',
	                { className: _VisitOurWebsiteBlockModule2.default['logo-container'] },
	                _react2.default.createElement('img', { className: _VisitOurWebsiteBlockModule2.default.logo, src: logo.url, alt: logo.altText ? logo.altText : '' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _VisitOurWebsiteBlockModule2.default['text-container'] },
	                _react2.default.createElement(
	                    'h2',
	                    { className: _VisitOurWebsiteBlockModule2.default['name'] },
	                    lang.visitOurWebsiteLabel
	                ),
	                link && link.url && _react2.default.createElement(
	                    _Button2.default,
	                    {
	                        className: _VisitOurWebsiteBlockModule2.default['button'],
	                        href: link.url,
	                        target: link.target,
	                        secondary: true
	                    },
	                    link.text
	                )
	            )
	        )
	    );
	};
	
	VisitOurWebsiteBlock.propTypes = {
	    lang: _propTypes2.default.shape({
	        visitOurWebsiteLabel: _propTypes2.default.string.isRequired
	    }).isRequired,
	    logo: _propTypes2.default.shape(_Image2.default.propTypes),
	    link: _propTypes2.default.shape(_LinkButton2.default.propTypes)
	};
	
	exports.default = VisitOurWebsiteBlock;
	module.exports = exports['default'];

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _VisitOurWebsiteBlock = __webpack_require__(600);
	
	var _VisitOurWebsiteBlock2 = _interopRequireDefault(_VisitOurWebsiteBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _VisitOurWebsiteBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Image = __webpack_require__(123);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _WebcamBlockBodyModule = __webpack_require__(819);
	
	var _WebcamBlockBodyModule2 = _interopRequireDefault(_WebcamBlockBodyModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WebcamBlockBody = function (_React$PureComponent) {
	    _inherits(WebcamBlockBody, _React$PureComponent);
	
	    function WebcamBlockBody() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WebcamBlockBody);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WebcamBlockBody.__proto__ || Object.getPrototypeOf(WebcamBlockBody)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            failed: false
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(WebcamBlockBody, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var image = new Image();
	            image.onerror = function () {
	                _this2.setState({ failed: true });
	            };
	            image.src = this.props.webcamImage.image;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                webcamImage = _props.webcamImage,
	                text = _props.text,
	                webcamErrorLabel = _props.webcamErrorLabel,
	                anchorName = _props.anchorName;
	            var failed = this.state.failed;
	
	
	            return _react2.default.createElement(
	                'section',
	                { className: _WebcamBlockBodyModule2.default.block, id: anchorName },
	                !failed && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _WebcamBlockBodyModule2.default.image },
	                        _react2.default.createElement(_Image2.default, { image: webcamImage })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _WebcamBlockBodyModule2.default.icon },
	                        _react2.default.createElement(_Icon2.default, { icon: 'camera-tripod-24px' })
	                    )
	                ),
	                failed && _react2.default.createElement(
	                    'div',
	                    { className: _WebcamBlockBodyModule2.default.failed },
	                    _react2.default.createElement(_Icon2.default, { icon: 'camera-tripod-24px' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _WebcamBlockBodyModule2.default.failedlabel },
	                        webcamErrorLabel
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _WebcamBlockBodyModule2.default.caption },
	                    text
	                )
	            );
	        }
	    }]);
	
	    return WebcamBlockBody;
	}(_react2.default.PureComponent);
	
	WebcamBlockBody.propTypes = {
	    "webcamImage": _propTypes2.default.object,
	    "text": _propTypes2.default.string,
	    "webcamErrorLabel": _propTypes2.default.string,
	    "anchorName": _propTypes2.default.string
	};
	exports.default = WebcamBlockBody;
	module.exports = exports['default'];

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _WebcamBlockBody = __webpack_require__(602);
	
	var _WebcamBlockBody2 = _interopRequireDefault(_WebcamBlockBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _WebcamBlockBody2.default;
	module.exports = exports['default'];

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FluidImage = __webpack_require__(30);
	
	var _FluidImage2 = _interopRequireDefault(_FluidImage);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _WebcamBlockModule = __webpack_require__(820);
	
	var _WebcamBlockModule2 = _interopRequireDefault(_WebcamBlockModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WebcamBlock = function (_React$PureComponent) {
	    _inherits(WebcamBlock, _React$PureComponent);
	
	    function WebcamBlock() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WebcamBlock);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WebcamBlock.__proto__ || Object.getPrototypeOf(WebcamBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            failed: false
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(WebcamBlock, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var image = new Image();
	            image.onerror = function () {
	                _this2.setState({ failed: true });
	            };
	            image.src = this.props.webcamImageUrl;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                title = _props.title,
	                webcamImageUrl = _props.webcamImageUrl,
	                webcamErrorLabel = _props.webcamErrorLabel,
	                projectLink = _props.projectLink,
	                anchorName = _props.anchorName;
	            var failed = this.state.failed;
	
	
	            var anchor = '';
	
	            if (anchorName) {
	                anchor = '#' + anchorName;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: _WebcamBlockModule2.default.block },
	                projectLink && _react2.default.createElement(
	                    'a',
	                    { href: projectLink + anchor, className: _WebcamBlockModule2.default.link },
	                    !failed && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_FluidImage2.default, {
	                            className: _WebcamBlockModule2.default.image,
	                            image: webcamImageUrl
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _WebcamBlockModule2.default.icon },
	                            _react2.default.createElement(_Icon2.default, { icon: 'camera-tripod-24px' })
	                        )
	                    ),
	                    failed && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: (0, _classnames2.default)(_WebcamBlockModule2.default.image, _WebcamBlockModule2.default.failed) },
	                            _react2.default.createElement(_Icon2.default, { icon: 'camera-tripod-24px' }),
	                            webcamErrorLabel
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _WebcamBlockModule2.default.icon },
	                            _react2.default.createElement(_Icon2.default, { icon: 'camera-tripod-24px' })
	                        )
	                    )
	                ),
	                !projectLink && _react2.default.createElement(
	                    'div',
	                    null,
	                    !failed && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_FluidImage2.default, {
	                            className: _WebcamBlockModule2.default.image,
	                            image: webcamImageUrl
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _WebcamBlockModule2.default.icon },
	                            _react2.default.createElement(_Icon2.default, { icon: 'camera-tripod-24px' })
	                        )
	                    ),
	                    failed && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: (0, _classnames2.default)(_WebcamBlockModule2.default.image, _WebcamBlockModule2.default.failed) },
	                            _react2.default.createElement(_Icon2.default, { icon: 'camera-tripod-24px' }),
	                            webcamErrorLabel
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _WebcamBlockModule2.default.icon },
	                            _react2.default.createElement(_Icon2.default, { icon: 'camera-tripod-24px' })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { className: _WebcamBlockModule2.default.title },
	                    title
	                )
	            );
	        }
	    }]);
	
	    return WebcamBlock;
	}(_react2.default.PureComponent);
	
	WebcamBlock.propTypes = {
	    "title": _propTypes2.default.string.isRequired,
	    "webcamImageUrl": _propTypes2.default.string.isRequired,
	    "webcamErrorLabel": _propTypes2.default.string.isRequired,
	    "projectLink": _propTypes2.default.string.isRequired,
	    "contentType": _propTypes2.default.string,
	    "blockId": _propTypes2.default.oneOf([_propTypes2.default.number, _propTypes2.default.string])
	};
	exports.default = WebcamBlock;
	module.exports = exports['default'];

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _VideoListBlock = __webpack_require__(134);
	
	var _VideoListBlock2 = _interopRequireDefault(_VideoListBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import cn from 'classnames';
	
	var YoutubeVideoBlock = function (_React$Component) {
	    _inherits(YoutubeVideoBlock, _React$Component);
	
	    function YoutubeVideoBlock() {
	        _classCallCheck(this, YoutubeVideoBlock);
	
	        return _possibleConstructorReturn(this, (YoutubeVideoBlock.__proto__ || Object.getPrototypeOf(YoutubeVideoBlock)).apply(this, arguments));
	    }
	
	    _createClass(YoutubeVideoBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                size = _props.size,
	                blockId = _props.blockId,
	                contentType = _props.contentType,
	                playVideoLabel = _props.playVideoLabel,
	                isFullHeight = _props.isFullHeight;
	            var _props2 = this.props,
	                title = _props2.title,
	                subtitle = _props2.subtitle,
	                description = _props2.description,
	                youtubeVideoId = _props2.youtubeVideoId,
	                previewImage = _props2.previewImage,
	                previewImageMobile = _props2.previewImageMobile;
	
	            var video = { title: title, subtitle: subtitle, description: description, youtubeVideoId: youtubeVideoId, previewImage: previewImage, previewImageMobile: previewImageMobile };
	            var videos = [video];
	
	            var videoListModel = {
	                size: size,
	                blockId: blockId,
	                contentType: contentType,
	                videos: videos,
	                playVideoLabel: playVideoLabel,
	                isFullHeight: isFullHeight
	            };
	            {/* BE: previewImageMobile image recommended size is 560x996px */}
	            return _react2.default.createElement(_VideoListBlock2.default, videoListModel);
	        }
	    }]);
	
	    return YoutubeVideoBlock;
	}(_react2.default.Component);
	
	YoutubeVideoBlock.propTypes = {
	    size: _propTypes2.default.string,
	    blockId: _propTypes2.default.number.isRequired,
	    contentType: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    subtitle: _propTypes2.default.string,
	    description: _propTypes2.default.string,
	    youtubeVideoId: _propTypes2.default.string.isRequired,
	    previewImage: _propTypes2.default.string,
	    previewImageMobile: _propTypes2.default.string,
	    playVideoLabel: _propTypes2.default.string.isRequired,
	    isFullHeight: _propTypes2.default.bool
	};
	exports.default = YoutubeVideoBlock;
	module.exports = exports['default'];

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _YoutubeVideoBlock = __webpack_require__(605);
	
	var _YoutubeVideoBlock2 = _interopRequireDefault(_YoutubeVideoBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _YoutubeVideoBlock2.default;
	module.exports = exports['default'];

/***/ }),
/* 607 */
/***/ (function(module, exports) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var THEMES = {
	    yellow: 0,
	    blue: 1
	};
	
	module.exports.default = module.exports.THEMES = THEMES;
	
	module.exports.getThemeClassNames = function (css, theme) {
	    var classNames = {};
	    Object.keys(THEMES).map(function (s) {
	        if (css[s]) {
	            classNames = _extends({}, classNames, _defineProperty({}, css[s], theme === THEMES[s]));
	        }
	    });
	    return classNames;
	};

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var INTROTHEMES = {
	    grey: 0,
	    white: 1
	};
	
	module.exports.default = module.exports.INTROTHEMES = INTROTHEMES;
	
	module.exports.getIntroThemeClassNames = function (css, theme) {
	    var classNames = {};
	    Object.keys(INTROTHEMES).map(function (s) {
	        if (css[s]) {
	            classNames = _extends({}, classNames, _defineProperty({}, css[s], theme === INTROTHEMES[s]));
	        }
	    });
	    return classNames;
	};

/***/ }),
/* 609 */
/***/ (function(module, exports) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var QUOTETHEMES = {
	    yellow: 0,
	    blue: 1
	};
	
	module.exports.default = module.exports.QUOTETHEMES = QUOTETHEMES;
	
	module.exports.getQuoteThemeClassNames = function (css, theme) {
	    var classNames = {};
	    Object.keys(QUOTETHEMES).map(function (s) {
	        if (css[s]) {
	            classNames = _extends({}, classNames, _defineProperty({}, css[s], theme === QUOTETHEMES[s]));
	        }
	    });
	    return classNames;
	};

/***/ }),
/* 610 */
/***/ (function(module, exports) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TOPICAREASTHEMES = {
	    lightGrey: 0,
	    yellow: 1,
	    blue: 2
	};
	
	module.exports.default = module.exports.TOPICAREASTHEMES = TOPICAREASTHEMES;
	
	module.exports.getTopicAreasThemeClassNames = function (css, theme) {
	    var classNames = {};
	    Object.keys(TOPICAREASTHEMES).map(function (s) {
	        if (css[s]) {
	            classNames = _extends({}, classNames, _defineProperty({}, css[s], theme === TOPICAREASTHEMES[s]));
	        }
	    });
	    return classNames;
	};

/***/ }),
/* 611 */
/***/ (function(module, exports) {

	'use strict';
	
	var VACANCYCARDTHEMES = {
	    yellow: 'yellow',
	    white: 'white',
	    default: 'default'
	};
	
	module.exports.default = module.exports.VACANCYCARDTHEMES = VACANCYCARDTHEMES;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = Block;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _OnPageEditing = __webpack_require__(21);
	
	var _OnPageEditing2 = _interopRequireDefault(_OnPageEditing);
	
	var _BlockModule = __webpack_require__(821);
	
	var _BlockModule2 = _interopRequireDefault(_BlockModule);
	
	var _themes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultOptions = {
	    heading: true,
	    headingComponent: "h2"
	};
	
	function Block(WrappedComponent, providedOptions) {
	    var _class, _temp;
	
	    var options = Object.assign(defaultOptions, providedOptions);
	    return _temp = _class = function (_React$Component) {
	        _inherits(HOCBlock, _React$Component);
	
	        function HOCBlock() {
	            _classCallCheck(this, HOCBlock);
	
	            return _possibleConstructorReturn(this, (HOCBlock.__proto__ || Object.getPrototypeOf(HOCBlock)).apply(this, arguments));
	        }
	
	        _createClass(HOCBlock, [{
	            key: 'render',
	            value: function render() {
	                var heading = options.heading && this.props.heading;
	                var theme = this.props.theme;
	
	                return _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)(_BlockModule2.default.block, (0, _themes.getThemeClassNames)(_BlockModule2.default, theme))
	                    },
	                    [heading && _react2.default.createElement(
	                        _OnPageEditing2.default,
	                        { key: 'heading', property: 'Heading' },
	                        _react2.default.createElement(options.headingComponent, { className: _BlockModule2.default.heading }, heading)
	                    ), _react2.default.createElement(WrappedComponent, _extends({
	                        key: 'Component'
	                    }, this.props))]
	                );
	            }
	        }]);
	
	        return HOCBlock;
	    }(_react2.default.Component), _class.propTypes = {
	        heading: _propTypes2.default.string,
	        theme: _propTypes2.default.oneOf(Object.keys(_themes.THEMES).map(function (s) {
	            return _themes.THEMES[s];
	        }))
	    }, _class.defaultProps = {
	        theme: _themes.THEMES.zebra
	    }, _temp;
	}
	module.exports = exports['default'];

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Block = __webpack_require__(612);
	
	var _Block2 = _interopRequireDefault(_Block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Block2.default;
	module.exports = exports['default'];

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _pubsubJs = __webpack_require__(958);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var errorMessageTopic = 'error-message';
	var messageTopic = 'message';
	
	function onTopic(topic, func) {
	    if (typeof func !== 'function') {
	        return;
	    }
	
	    return _pubsubJs2.default.subscribe(topic, function (topic, _ref) {
	        var message = _ref.message;
	
	        func({ message: message });
	    });
	}
	
	function send(topic, _ref2) {
	    var message = _ref2.message;
	
	    _pubsubJs2.default.publish(topic, { message: message });
	}
	
	var onErrorMessage = function onErrorMessage(func) {
	    return onTopic(errorMessageTopic, func);
	};
	
	var onMessage = function onMessage(func) {
	    return onTopic(messageTopic, func);
	};
	
	var sendErrorMessage = function sendErrorMessage(_ref3) {
	    var message = _ref3.message;
	    return send(errorMessageTopic, { message: message });
	};
	
	var sendMessage = function sendMessage(_ref4) {
	    var message = _ref4.message;
	    return send(messageTopic, { message: message });
	};
	
	exports.default = {
	    onErrorMessage: onErrorMessage,
	    onMessage: onMessage,
	    sendErrorMessage: sendErrorMessage,
	    sendMessage: sendMessage
	};
	module.exports = exports['default'];

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var scrollToBlock = exports.scrollToBlock = function scrollToBlock(targetBlock) {
	    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    if (targetBlock) {
	        var targetOffset = offset ? offset : 0;
	
	        var y = targetBlock.getBoundingClientRect().top + window.scrollY - targetOffset;
	
	        window.scrollTo({ top: y, behavior: 'smooth' });
	    }
	};

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function format(string) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return string.replace(/{(\d+)}/g, function (match, number) {
	    return typeof args[number] !== 'undefined' ? args[number] : '';
	  });
	}
	
	exports.default = {
	  format: format
	};
	module.exports = exports['default'];

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(626), __esModule: true };

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(627), __esModule: true };

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(628), __esModule: true };

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(629), __esModule: true };

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(631), __esModule: true };

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(632), __esModule: true };

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(633), __esModule: true };

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	/**
	 * https://github.com/gre/bezier-easing
	 * BezierEasing - use bezier curve for transition easing function
	 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	 */
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	var NEWTON_ITERATIONS = 4;
	var NEWTON_MIN_SLOPE = 0.001;
	var SUBDIVISION_PRECISION = 0.0000001;
	var SUBDIVISION_MAX_ITERATIONS = 10;
	
	var kSplineTableSize = 11;
	var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	var float32ArraySupported = typeof Float32Array === 'function';
	
	function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	function C (aA1)      { return 3.0 * aA1; }
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }
	
	function binarySubdivide (aX, aA, aB, mX1, mX2) {
	  var currentX, currentT, i = 0;
	  do {
	    currentT = aA + (aB - aA) / 2.0;
	    currentX = calcBezier(currentT, mX1, mX2) - aX;
	    if (currentX > 0.0) {
	      aB = currentT;
	    } else {
	      aA = currentT;
	    }
	  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	  return currentT;
	}
	
	function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	   var currentSlope = getSlope(aGuessT, mX1, mX2);
	   if (currentSlope === 0.0) {
	     return aGuessT;
	   }
	   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	   aGuessT -= currentX / currentSlope;
	 }
	 return aGuessT;
	}
	
	function LinearEasing (x) {
	  return x;
	}
	
	module.exports = function bezier (mX1, mY1, mX2, mY2) {
	  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
	    throw new Error('bezier x values must be in [0, 1] range');
	  }
	
	  if (mX1 === mY1 && mX2 === mY2) {
	    return LinearEasing;
	  }
	
	  // Precompute samples table
	  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	  for (var i = 0; i < kSplineTableSize; ++i) {
	    sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	  }
	
	  function getTForX (aX) {
	    var intervalStart = 0.0;
	    var currentSample = 1;
	    var lastSample = kSplineTableSize - 1;
	
	    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	      intervalStart += kSampleStepSize;
	    }
	    --currentSample;
	
	    // Interpolate to provide an initial guess for t
	    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	    var guessForT = intervalStart + dist * kSampleStepSize;
	
	    var initialSlope = getSlope(guessForT, mX1, mX2);
	    if (initialSlope >= NEWTON_MIN_SLOPE) {
	      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	    } else if (initialSlope === 0.0) {
	      return guessForT;
	    } else {
	      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	    }
	  }
	
	  return function BezierEasing (x) {
	    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	    if (x === 0) {
	      return 0;
	    }
	    if (x === 1) {
	      return 1;
	    }
	    return calcBezier(getTForX(x), mY1, mY2);
	  };
	};


/***/ }),
/* 625 */
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(652);
	module.exports = __webpack_require__(35).Object.assign;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(653);
	var $Object = __webpack_require__(35).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(654);
	var $Object = __webpack_require__(35).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(655);
	var $Object = __webpack_require__(35).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(656);
	module.exports = __webpack_require__(35).Object.getPrototypeOf;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(657);
	module.exports = __webpack_require__(35).Object.setPrototypeOf;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(660);
	__webpack_require__(658);
	__webpack_require__(661);
	__webpack_require__(662);
	module.exports = __webpack_require__(35).Symbol;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(659);
	__webpack_require__(663);
	module.exports = __webpack_require__(150).f('iterator');


/***/ }),
/* 634 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 635 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(42);
	var toLength = __webpack_require__(650);
	var toAbsoluteIndex = __webpack_require__(649);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(82);
	var gOPS = __webpack_require__(142);
	var pIE = __webpack_require__(100);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(41).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(251);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(140);
	var descriptor = __webpack_require__(101);
	var setToStringTag = __webpack_require__(143);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(62)(IteratorPrototype, __webpack_require__(63)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(82);
	var toIObject = __webpack_require__(42);
	module.exports = function (object, el) {
	  var O = toIObject(object);
	  var keys = getKeys(O);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) if (O[key = keys[index++]] === el) return key;
	};


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(102)('meta');
	var isObject = __webpack_require__(81);
	var has = __webpack_require__(50);
	var setDesc = __webpack_require__(51).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(61)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(82);
	var gOPS = __webpack_require__(142);
	var pIE = __webpack_require__(100);
	var toObject = __webpack_require__(147);
	var IObject = __webpack_require__(255);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(61)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(51);
	var anObject = __webpack_require__(80);
	var getKeys = __webpack_require__(82);
	
	module.exports = __webpack_require__(48) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(42);
	var gOPN = __webpack_require__(257).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(81);
	var anObject = __webpack_require__(80);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(252)(Function.call, __webpack_require__(141).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(146);
	var defined = __webpack_require__(136);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(146);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(146);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(635);
	var step = __webpack_require__(641);
	var Iterators = __webpack_require__(138);
	var toIObject = __webpack_require__(42);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(256)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(49);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(644) });


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(49);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(140) });


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(49);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(48), 'Object', { defineProperty: __webpack_require__(51).f });


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(42);
	var $getOwnPropertyDescriptor = __webpack_require__(141).f;
	
	__webpack_require__(260)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(147);
	var $getPrototypeOf = __webpack_require__(258);
	
	__webpack_require__(260)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(49);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(647).set });


/***/ }),
/* 658 */
/***/ (function(module, exports) {



/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(648)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(256)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(41);
	var has = __webpack_require__(50);
	var DESCRIPTORS = __webpack_require__(48);
	var $export = __webpack_require__(49);
	var redefine = __webpack_require__(261);
	var META = __webpack_require__(643).KEY;
	var $fails = __webpack_require__(61);
	var shared = __webpack_require__(145);
	var setToStringTag = __webpack_require__(143);
	var uid = __webpack_require__(102);
	var wks = __webpack_require__(63);
	var wksExt = __webpack_require__(150);
	var wksDefine = __webpack_require__(149);
	var keyOf = __webpack_require__(642);
	var enumKeys = __webpack_require__(637);
	var isArray = __webpack_require__(639);
	var anObject = __webpack_require__(80);
	var toIObject = __webpack_require__(42);
	var toPrimitive = __webpack_require__(148);
	var createDesc = __webpack_require__(101);
	var _create = __webpack_require__(140);
	var gOPNExt = __webpack_require__(646);
	var $GOPD = __webpack_require__(141);
	var $DP = __webpack_require__(51);
	var $keys = __webpack_require__(82);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(257).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(100).f = $propertyIsEnumerable;
	  __webpack_require__(142).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(139)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key) {
	    if (isSymbol(key)) return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(62)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(149)('asyncIterator');


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(149)('observable');


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(651);
	var global = __webpack_require__(41);
	var hide = __webpack_require__(62);
	var Iterators = __webpack_require__(138);
	var TO_STRING_TAG = __webpack_require__(63)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClass;
	
	var _hasClass = __webpack_require__(665);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
	}
	module.exports = exports['default'];

/***/ }),
/* 665 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasClass;
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
	}
	module.exports = exports["default"];

/***/ }),
/* 666 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;
	
	var _inDOM = __webpack_require__(262);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = 'transform';
	var prefix = void 0,
	    transitionEnd = void 0,
	    animationEnd = void 0;
	var transitionProperty = void 0,
	    transitionDuration = void 0,
	    transitionTiming = void 0,
	    transitionDelay = void 0;
	var animationName = void 0,
	    animationDuration = void 0,
	    animationTiming = void 0,
	    animationDelay = void 0;
	
	if (_inDOM2.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	
	
	  exports.transform = transform = prefix + '-' + transform;
	  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
	  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
	  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
	  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';
	
	  exports.animationName = animationName = prefix + '-animation-name';
	  exports.animationDuration = animationDuration = prefix + '-animation-duration';
	  exports.animationTiming = animationTiming = prefix + '-animation-delay';
	  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
	}
	
	exports.transform = transform;
	exports.transitionProperty = transitionProperty;
	exports.transitionTiming = transitionTiming;
	exports.transitionDelay = transitionDelay;
	exports.transitionDuration = transitionDuration;
	exports.transitionEnd = transitionEnd;
	exports.animationName = animationName;
	exports.animationDuration = animationDuration;
	exports.animationTiming = animationTiming;
	exports.animationDelay = animationDelay;
	exports.animationEnd = animationEnd;
	exports.default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	
	  var vendorMap = {
	    O: function O(e) {
	      return 'o' + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return 'webkit' + e;
	    },
	    ms: function ms(e) {
	      return 'MS' + e;
	    }
	  };
	
	  var vendors = Object.keys(vendorMap);
	
	  var transitionEnd = void 0,
	      animationEnd = void 0;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + 'TransitionProperty' in style) {
	      prefix = '-' + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	
	  style = null;
	
	  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
	}

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(262);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf = void 0;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM2.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	exports.default = compatRaf;
	module.exports = exports['default'];

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(671);
	var each = __webpack_require__(263).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(669);
	var Util = __webpack_require__(263);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),
/* 671 */
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(670);
	module.exports = new MediaQueryDispatch();


/***/ }),
/* 673 */,
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Components"] = __webpack_require__(352);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["React"] = __webpack_require__(1);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["ReactDOM"] = __webpack_require__(54);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["ReactDOMServer"] = __webpack_require__(329);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 678 */
152,
/* 679 */
152,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */
152,
/* 693 */
152,
/* 694 */
152,
/* 695 */
152,
/* 696 */
152,
/* 697 */
152,
/* 698 */
152,
/* 699 */
152,
/* 700 */
152,
/* 701 */
152,
/* 702 */
152,
/* 703 */
152,
/* 704 */
152,
/* 705 */
152,
/* 706 */
152,
/* 707 */
152,
/* 708 */
152,
/* 709 */
152,
/* 710 */
152,
/* 711 */
152,
/* 712 */
152,
/* 713 */
152,
/* 714 */
152,
/* 715 */
152,
/* 716 */
152,
/* 717 */
152,
/* 718 */
152,
/* 719 */
152,
/* 720 */
152,
/* 721 */
152,
/* 722 */
152,
/* 723 */
152,
/* 724 */
152,
/* 725 */
152,
/* 726 */
152,
/* 727 */
152,
/* 728 */
152,
/* 729 */
152,
/* 730 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_3bj3Nqx3yImsFmwNQzsXbI","header":"vUfTg4FGveQIQpePTwlhO","map":"_1AJFKAwBkMnJL4aV4j-biv","seeAll":"_2TMiPoqsXrGUy7wFUm1pUc"};

/***/ }),
/* 731 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menu":"_1eDQEUlmT1kEj7mgBBGrSH","inner":"_3k-KWWAtjCIoVp1ZPc3giH","scrollToTop":"_1u1CDb5gBp6EYdDaXCbXy-","logo":"_1Wn9UbTD-dqRdnIZmLxWi1","logoFallbackText":"_2fr_fpPzhljvp6F-ubjPQT","logoImage":"_3IdTXrwfy0MfZfd_4ieVif","anchorsHeading":"_3BSVo-iNSMQ1tHQzEHxEkQ","listWrapper":"_1yX7aACIHnzRAdMtEVtNkf","list":"_2pbojlHopnoV0FDkaO__7J","header":"_2Os6cZAmvWJ5MuU51cp2TU","toggle":"YSfIOXuqxuLRS6ltE8irT","toggleText":"_2AMKMThv-Pb7PD4WYYhFn2","toggleCross":"_3RV9CiHGtbOEfojDDX_iSg","arrow":"_1Sr08WHEGaodxF41_5rrrk","button":"_1Lm84-8TS9cNSrYWpvNpUj","active":"_2R8F3q7bt69wUhkK47OF9Y"};

/***/ }),
/* 732 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ArticleTags":"S0bWnMdXNML1METhHAFL2","IEWrapper":"_1MDMeAKjmiRr7JiCZKJ2AC","iconWrapper":"RUnxoxCOQ5-NYYSEhk86a","icon":"_16RejmYeK9yO_u-sR_H62H","tags":"_3U5nEp5043sT_MD2j6IiVf"};

/***/ }),
/* 733 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"banner":"_2aGnwweNAmf7burJA8u6w_","banner__quotation":"_2YO6jpDJKVJ3H9ZsnCEWE8","banner__quotationText":"_3cTB9nMk5smvPV1ptGpcGx","banner__bubble":"_1q-5z492ui5S6DRAJTAlO2","banner__bubbleContainer":"_2Hbxc3SiUpMtfTxsZh4B5V","banner__bubbleText":"_2iGhUf3Pf8uYqwDnon2J_k","banner__quotationTextContainer":"_2VPlehjSshxuZNvv1ryO4G","banner__bubbleBorderTop":"Dg9ecbwv6rAIKTWL5LfiY","banner__bubbleBorderBottom":"_2bj6ZdqZec9a6zH1aoJGq8","banner__linkContainer":"UQejaTL7jGDLpPPlxR-hN"};

/***/ }),
/* 734 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_1kq2NDaX9ClrQd7SaPdeP_","bg":"jGjg6eLtkC7I2YgGFZqfJ"};

/***/ }),
/* 735 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_1aP6ECcZGORX9K-_ZTLYUU","header":"l4meEJ1K-QC0SHNGgKPcH","content":"_2ZfDyOySI9JqwSVZXMOJJs","items":"_14ZLrgixZODS8-awtU1BEn","readMore":"_2MO6ihu7oEdLMYZYKP9oF_"};

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"member":"IavVHY_JT_XmmXunohnrL","image":"_2paf0b0ee1KTPSjZj_G4l7","memberImage":"_1fHxap-_sNioZ-Nf5JzQhc","info":"_1UNkMA41wGIyo7afFC4jST","name":"_1E-zd8fh04fUPPMS1uehkv","title":"_2NDkXZ8e2QFgNTUsRHw7xF","text":"OmVoUGLXavado93aj5LF9","button":"BgTAyVvmss7VMnelCUJKx"};

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_1yyxvkDr9bAZG-Dprz36u7","inner":"_26qxwzSZS_yDaOwhovpwQX","heading":"_3EcrQrILMWnD_jrEtdjpzZ","intro":"_3JUpGocdQuYM7V-H05MCFo","links":"_1jVkzBa87n-AZrIXFBWSJN","links-item":"_3bNkeq-5R6-qTL6GnE7X7d","link":"_3RML2PHqxjXG7k_X2PLeS2","link-icon":"_2EXmZLlfq96eXYDMGWXWLS","link-text":"_2glpqclFRk1sySQXc3vvox"};

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"tNtf2HVyVXcNoFgNzo89o","links":"_1L75s97kpUOES1K2VxrQKB","link":"_2Ymc4AgVFb1yo4uaIbaF9b","zebra":"_3r1ozrv7ndEyQiv6rDOMFk","yellow":"_33cEQsMuwe460Y4CooP0ms","darkgray":"_2B4LKQ0yNfayklteC4RgiT","bg":"_2ytJpXd2eCsPQIKRPSnpE7","heading":"_3UhqNahc5UsTgts4HmuoZS","active":"YAT6DHqdOBDdeTqjNxJLk","content":"_2zMjdrYoR8VdQF26Ik9TRz"};

/***/ }),
/* 739 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_2hUETOee8sfe-Qt9TbIWp-","content":"_3pzobmS8-8ioDXkPPoRHZy","text":"_3LCDSHzy39waLfID58wgtw","heading":"_1MTn36vTQUEajiLaqPCAjD","intro":"xuXmHWmO0kEPBKzrpOAOE","categories-container":"_1565ullg1CbnHiatJGnY8N","categories-list":"jViIn0pTmVqkWiVhbrDHk","category-button":"_3DhACy7fvjQX1QZGmrmYPE","categories-list-item":"v1ldfOpGxD6t0JKDj2oIK"};

/***/ }),
/* 740 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_2DLtJqn_48hVdeElBced6V","check":"_20crIypl14w5x1dR99vzpR","active":"_16HnabTomv9eGvB7wi2Z-O"};

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"RrUu30g5qIbjJJOThA1zt","heading":"ek3TaJr9uxAM4iHDvS-iY","container":"xIz91GdjQDQ9EZSpd-p8l","collaborators":"_3s97xczDUm2Gw0DJrCO514","collaborators__item":"_1SN4xNZ_O2ApSGaigD9Rwu","collaborators__title":"_1XNFPI9yaO38coZ04dBCwg","collaborators__content":"djVQUK3lVHEVIYzuTKSxc","icon":"KjUfUDReTDnpObI92Hhlw","readMore":"_2bAv1nbz0TWpm1qJ85Zk0"};

/***/ }),
/* 742 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"heading":"_1Mrh8jduDjm0kA9TRb3iPv","small":"_3jSQn4jTun1pxot9n9S-nO","block-wrapper":"_2Se63j5c7hCjGPEMxXh3C5","contacts":"tsH3cUnceVBE6nAHcuyQS","circle":"_2bq753ztGbYUyEBaUG5J8H","circle-large":"E4mRiCNgTc50oAniO0Zhi","person-block":"_3MUFuyeAo3bq3H0EiY9D94","left-aligned":"t9HbfD4DRKhZ7GKe3CWkP","info":"_3WKctNLs1PjJboy4YxdYpN","name":"_20sZq49X0p3xE16AQWp_xm","title":"_1gVmSMtB6Uop4XXTkenaou","department":"_3xVpirxUY22WYtdnaILxCk","contact-info":"_3eKeFt8GK4NaLk19zUMK5F","no-image":"_32BavEoJgfbe9E3nk7uk5t","detailed-info":"VXbp2M1Lukr_loREdCRKB","see-all-link":"_2-lhLTOQmWksApOlh-RZwX"};

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"filter":"_2j5jTK13RK13uN449Lj5kt","filter-container":"_3NS3uWpb1CO6gIl4pWdqfw","loading":"_1c3WBzMdXpMfljgFtZRUen","companies":"_284JPoPjYn8HSRDHk28zM2","contacts-list":"_3yhKMxRETEF3vXTtWlbf8i","load-more-button":"_1wF8tsnano3650UMz6ATPX","error":"_3J8ozq_QXCzrP309IQzv-8"};

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_3nD0SodYxxV9CbagODf7qB","content":"jwCMoJvtGu_Y0sazUNeY","icon-container":"_1MrUM23je3Fy6XXI4XsJly"};

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_1kSmnujPlXneZIOO8GSe1T","inner":"lddjDK9WMOYmUs0LNzF1B","outer":"_2YdAiN112Hpa0Q_gtPW_Qp","shown":"_9yhSgFTRGqXafEUVKHeSp","icon":"_1M66zonMtQ4E06DhjFxwQd","tooltip":"_2g_wj9fCSieBZeDfNMDR6O","tooltipIcon":"_3HDSvH5NuH_24oXWCn9jul","large":"_3SDQL6xEtey9Jsbs5FB9uH","link":"_19WNlTaxQQld4A9wlergxY"};

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_2WUQVy4isZNXwXqQRVCxeq","wrapper":"_1YQQD4rlulTFbn9yt4O18k","content":"_1hdBjPbXZYUdBh2Yn8zt0r","link":"qZXg_7MaC-gktHxd7521P","headingLink":"_3znZKWbdv9tPDmb1UFKSr4","heading":"_3_FFevfLQXA66bd82Gdman","image":"_2bd6wZ7p9w10pbWf4GgHhd"};

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_1YnrcPVMsd8hEg78dnTaTH","full":"_36Mwz6_ebbTmRYI5K3WMax","contactHeading":"_2J5lOr3cHXF8nryagIJDUt","businessInfo":"_1L7wEnraP5NsktPDtoIT-s","heading":"_3lRZqWpNK5XkLwNtIZyPGw","inlineIcon":"_2PU9e3UESknBQ-dGmal2Hk","map":"_1f13fgb-Tpym-g0nNAtLfm","list":"zdGU9slWGLXxhKgw4B9Ue","siteUrl":"_1k7tXIiMhCjGRNAKgH0XTl","yellow":"_3i9w7ybGTuGPWrDLMGDUoY","external-icon":"OUEFqIe3NvygO4FQlCDLu","businessInfoWrapper":"_2lrVj1M-tAcwI2x5KFe5hW","toggler":"_1j3knzWe5as5Hxj4Vjq0PU","togglerButton":"_3f6bOGUdmniLcUESWavPHp","expandableContent":"_335zr-CPKZfLs1joUg1TYJ","expandableBillingContent":"_1_R-XUmoB8vjn5L6MEE6n4","billing-column":"kfLL1Qifm5-wSvxnyrA_p","contactInfo":"_2IanomZVlozYvJD21Xf0DY","invoice":"_2LvBSmq9cJn5sL2Boch_jA","postAdress":"HCpvemvriauQDpdsD-nYg","visitationAdress":"_2C-FE1mRdbfYeI2T-VpSI_","logoContainer":"_2E8Vjwg_YaZ9Kkqr2HVHW7","logoImageWrapper":"_3X2mIbqjjYsKtBM4tAsu7F","logoImageWrapperEmpty":"_2VXcNlGi480V9wCNiWdZ6o","noMobileSpace":"xIxQASrzTEXY96jlfURfI","invisibleHeader":"vTsWA-lkUQle6c2M3Mper","toggle-billing-units-button":"_15KGrhzvtTg3RNrcd_rTaX","toggle-billing-units-button-icon":"_26gFh1scCJB1Q9jt6PK-Vm","toggle-billing-units-button-text":"_2qsIkTropvClIbuee3BAas"};

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"gTMTVDcuHv009EWHQpnii","link":"_1mcshSv3xcbdU9Hc9nRcis","text":"_1JeJc6_OPwYEWjw_6o5BQt","link-container":"_2OY5RTouu6TzPPPbs7TzNy"};

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_35r0Hiw5mAG4HyDr32epW8","text":"_3AbLitX-6qi05ul10we8DD","heading":"_14WUzMddIG6UMpN6Kmd7Zj","intro":"_2WslV20ulCmvojKMp_qEaq"};

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"document":"_263-suCTCWngibKHHORqqv","image":"_1Tog5O1OptfJgUvuzN6lCb","content":"_3O1SJYRyGfhIV0pdKun2v3","links":"SBboOT9nb_qqvHG-0PB0O","title":"_1lhgf3AtIBindZ3PCX9-Ic","pdf":"_1cp1F39Hs8doVPFHMq7O2T"};

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"blockHeading":"ZbeEkkSTr0bDnglX8Jnat","filters":"_2B4TM3BmmzNPjnBppuzLwQ","filter":"_3Jb-vNAqytuwmlFIW1awRN","list-outer":"HcNuKrqlmy9TPMzUfErD6","list":"h8X6ZFcCpJQxB1lGrlp5M","searching":"_2sD061N6E41Savf--Iui1f"};

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"documents":"_1EnlsW4zy8i85JYjM2R4Bg","readmore":"_1qn5g2o1_aSAb1QS_pnT8m"};

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_3YsvCP4XJ-Yg5t9QYj25KY","open":"_3kCfeYR6eucg-Cc9gAKtJb","yellow":"VVIWLvJwv6kmw4RYvz4bM","dropdown":"_2pwINaI7VAwJYoQalVG2mI","overlay":"_3QSMKkRwled7x-hPncJFFi","arrow":"_1XUNhNNY8yZwQ0HjSlAD3C","close":"_1cMfz4-f3cH3IQ6udJdjsG","dropdown-item":"_1iK0PyonUm-S-S5YQ0Z1bH","zebra":"_2Eq96kRUAl68uA1hxHcf1x","single":"zmfvtF9d1Rm1O4c1T-i1X","active":"_1WjLCeBfKKkDEW7IsO4V1a","dropdown-group":"_1Tz-Gqfk41PLOmKSH4Q0rz","dropdown-check":"_3tzDU_DoQOuiFHel9B_y3B","number":"_1w4Z7q6jB7iQ9ocrIJkw3t"};

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"column-container-wrapper":"_2LNzzTsYMkUCIEz8HyBgFa","dropdown-title":"_2V_c18twhoY699IRa-C5jr","open":"_3FeN-Kg4W4fKKt6-72Sq57","header-link":"_2V36IEQMbe5YZASIoZLSYC","link-list":"_3FhwT7cB4Rw8scsrK-Fi-i","level-two":"_2CFMayZJoHBfweiBK779h-","dropdown":"_27G54lrJTnhPtQsOuzgrnw","dropdown-header-link":"_3_EWb_EJFQH_1l9YA92Cnr","dropdown-additional-info":"_1P07Go7U47r9Go_zEmPCoS","submenu":"_3XyJlnNIMvfyi7eAzM2lv2","close":"_61NvGFtrvBJQGjHsrtAIU","closeIcon":"_2RB5222t6bQiPaa8x9xHRE"};

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"imageWrapper":"_1ty9-uB6uU2Y4sAU31_a_5","-theme-rounded-corners":"_2elgrrzz-q8yhvd7aYtTz","image":"_2beiEX6j8jhvwvxUNM1g3N","-theme-full":"_34C0s_8iuMhM8162pmjfO7","-theme-fixed":"_3cj1k8ZENQvoOrH5dSCQi7","gradient":"_3UFEMHX08hPmtDeXLaTjgN","-gradient-section":"_2cl-fo5RdAS2ZLrfvG2qZh","-gradient-feature":"H4ZrRxypBAvogoMNYx4B"};

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"featureArticleTag":"_2dF6mFk1y2v8kznOdM45-V"};

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_1dcLFzap20puFTgvj2OQzG","inner":"_1yiMRrElA9ch3UKnbliw-l","filters":"leBvTHmjrXz0OfO9ZCwbl","list-outer":"_21CX84KUT3y-QiVGe_-crg","list":"_3soKewEN5DOeAOat-Ww7WD","searching":"_2h1I_4ZpsIV3SDMoZUGSNI"};

/***/ }),
/* 758 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"featureImageHeaderContent":"_1KtkP4Fvu9HBKDs98UoIZi","isLandingPage":"_3HXF4O8XYn_U2rmsBX4oyI","title":"_3A9Suj5XC7PQ5Wh3JLIw6e","text":"_1R3BAqRa1Wjformc4HiHCl","date":"xNbPXLjB_onMJKluYSMhk","bylines":"_20RQ83JmzL41IDSQxOLKAX","bylineType":"_23MQ5mEglvO0mMZEFKhnDA","iconWrapper":"_2renY4Ev4qk2BLWWSDoGYE","jumping":"lnfSB-m7QB05fKHPT7AF4","icon":"_18llnjXU1Z8CDKf3w7pnBa","invisible":"_1b_njuuQ4iWHITxPj36Jst","curious":"_3KdSh32tpU1a6JalaoEMd1"};

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"featureImageQuoteContent":"_1KPD_SzL-sGX-os2A2jOPb","darkFilter":"_1_Blkz-4tJWaF-QofurA_A","quoteWrapper":"_3NOW1RRMZga40tgM2arziQ"};

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"featureLandingPageHeader":"EN1nxdbGNTg210D9zomHv","logo":"_2nw11TbRTa0WuzcpGlmJk0"};

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_3t9fvPIOGMxlu4Js6lQWQt","zebra":"XjDYPXYXEGtoKNHjzIJy2","yellow":"EpKF3XQyixN3E6Ts-THn6","darkgray":"_1GRYqwHgzWz1YI2Ks3ksvK","lightgray":"_3-HSr-XYjn_fd-nj5zqpIU","white":"_13QVvJzvbpP1npyP_ZJMRA","wrapper":"_2t7__QJR2_UGpoOHcU00ps","content":"_1dy8yNDTyBy9un4vS2_NcJ","heading":"_3KxDbHX52yQUIQsIhPaUTo","linkedArticle":"_1_h04TiyUVxYcLajeRqfFU","item":"_36lPKBExrEUb4b_2CU42Ri","wysiwyg":"_3jGPdM2urjBore1SMyym20","title":"_2FPNIl6fZ11mEOCFd5Cgtz"};

/***/ }),
/* 762 */
152,
/* 763 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"animationWrapper":"_322h79yWb0Ilxh1I7GxUNF","captionWrapper":"_1yPjyJQ05nmj_E6__C_EjM","caption":"_1OwNjzs8eYnodZLkLZgyyX"};

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_1Fa_fvtpH6--iRTMMQQTrA","open":"_1SEs2CfIdMrMR5N5I11zgM","arrow":"_3wYak3YcODeHTbiaafowwI","filters":"_1oENjADyunCroDoMMLPk_D"};

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"image":"_2TbIa0jIhXxIpIDa27Z09e","visible":"_37tlB18oscau5gNr2I7EuC"};

/***/ }),
/* 766 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"footer":"_1ceHCMu9om14DBUbjo89zl","container":"sehj05HTttWxqPDcsQMPq","slink-group":"IYHB4zwP13BKMv8LHFega","links":"Ol_Q8PHlWFLWgg1dCEBVJ","social":"_3g6ukn58k0QaB8mT2-VaOL","logo-link":"cyIyyNvRCtvCZvNru3Fc1","followUsLabel":"_1XaLfJS91xcggLsYD7rQ6R","stock":"_2Gj0T4uTA1fbppeeXC0ASp","stock-value":"_24771MkMYOdKsz8UdTAnSC","stock-difference":"utvFcKnHe10pJvPioda9O","is-visible":"YGHGNDNGFZs_-1T8uF70T","stock-difference-positive":"_1jb73g7cMk9Muc2yYI8S3k"};

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_2wvu5DWKSwJetUoL5B1EJN","list":"_2rppe_CZlefs-5c1NNOYeL","scroll-button":"_1QoY8xRTtuoOsGBsedvlX_","adaptiveHeightContainer":"_2UVInocKJWuy3ZGe1A21Co","indicators":"_2y18fRq5Z9GNqNOhMX_wTN","indicator":"_2lh78zapWbJgvecFCjL8Sf","active":"WHI5S7hBSiUxe8wcLkwKJ"};

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_3_P_0EhdNrKus0ktQYnxo6","header":"T01dEFdp_FuH2SdrE8tuW","content":"mrlPsbPJ5jzn3U6sR0cuK","items":"_1KOC6g6aMwwqE1PCcgvBB4","readMore":"_3JJroHFKyCOu06NgBdoLlN","footer":"znFY24_lUxQY38p4tLC1j"};

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"item":"_3uccF_6U9Gm8JCbcl2zZA","image":"_30gCkxz6kXLiIdrPSMNYAB","info":"_3imyb9yUto2PsOj-49kIBg","buttons":"_1RoF9GI_GH-Gi8UbidDgDW","name":"_3aZw8ieLNm8TbZlNx7Zof1","description":"iUHrE3rIo-QUKpjJbDneU","text":"_1FuxjBV0_JD8lXYt4fOuq-"};

/***/ }),
/* 770 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_2Gvw35bHVFP6xcb-wBQjhA","content":"_3wAhz6jo0-BdwYfWBM75bX","text":"_122Ovs_73f3s0DFTbT9ZWo","yellow":"_1ZkpRXtrIR-dQfTmWN_tid","darkgray":"UQ2zmjG85L0xiA03B8w7k","lightgray":"_13__7gvkagxgjiXPR5aPOb","white":"_1M0hp3bYbvnjDNpy5BA3yH","button":"HzYA_P0tknTwOzPznFkz","zebra":"u9MTo35te3JlaMP3ruTrM"};

/***/ }),
/* 771 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_28YR2U1nJIvQ6dIGYNn6wM","heading":"_3Nn8vMbAzybV0iRObMV14j","list":"_1f4CJnnTlGM_kF-kbtO3t","link":"_1aHYqsiApP6cnX50IEeaWV","listItem":"_28oSiEK_fMlNlSPueTnLlg"};

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_3rv2NC-2czlTSB-0-z4uxE","block-content":"_1yLY0I-1yJcYW67UszaP44","list-content":"_2O1jX1il5p1vN-TmP41q88","heading":"YEMQRlU9a-OhS3tSTRdQW","text":"_3Fg3Re_MYSRfvKiFYGbwqJ","zebra":"_1PoWPSQr3emxDz6yvGL_jO","yellow":"_2rM1cSVw2V4iMR7-GnxYfA","darkgray":"V-WsIIoQVFptr39AVHp7k","list":"_3zXfJNv9whuatUSOs2yHH8","listItem":"_1NjsPjtovJUK5_p6LirI-5","icon":"_2vItupI323Voj3S0tpmHU3"};

/***/ }),
/* 773 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"nav":"_1HmbcR1ZJ-_wzTLWj0tNgu","nav-prev":"_1kvRWHoI5C_T7aiBpRdwV0","nav-next":"_1fl01RKPRHY_3_Ytfy0lUP","block":"_1wtKvvIpXWbKevVzHu_DRw","slides":"_38c23rz0BiCrWLxpyQqBqT","slides-wrapper":"_1QXjtk01Yk8vWiMBgLGrMk","nav-indicators":"_1S96T2kU27Y6qmBaQ_u3-A","active":"_2jkV5JoNEl_moXP7azOesV","direction-forward":"_38RMc_kvCN2_3nkF6Pc14l"};

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"OsGKnQJGrN05ZDKKmFEhH","innerBlock":"_3j8hCyGUKSDtPAudXihlIA","image":"_13LFZUBJfddhe6UxoFFtDR","text":"_8gfKlAC15FCvvZlN93H0w","readmore":"_2QxMNP6fQqtsv9Dv9IttW"};

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"tQZV0-tgvIS9Vap9_l82C","scale-in":"_2zupuQHXhGlX9hkKFL6ct0","page-content":"W8bdZlZe-wAzdwgD4EQlW","image":"_3Z5fNrOPvB5QetdcE4dvbB","text":"_2ZiLAL3wLzh_fKHOEuJ9wv","intro":"g-S3m1CYpi39llbKtq6EU","slide-up":"_3XMnqDzBShqcxjMDY7_2hL","heading":"_1QrGpY7a78C19cLrDGXjFF","logo":"NI7b8IdIC576WwWxUJQw6","linksList":"_Cpxg-HAFD4ISVN2fBOCf","linksItem":"_3QSYwhha41MRVq9j9uGjYl","curious":"bl-URf-cR0c2UHl7bwPXA","hasCurious":"_3dqnBQmNRqXrVggEKkUSnB"};

/***/ }),
/* 776 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"imageArea":"_2GAAcYD2eBc7639YnBcLZO","is-on-screen":"_3_OqsU1uHEa1yDPpxY2l0e","image":"hKFbEgXFBefQNkFiOTt3P","block":"_2htH0S04cq7ghXHlUXhNab","inList":"LbLUlDSdNCJtnaRGC5imG","textContent":"_2DSCn_rOhIJr_ucKWYfIZd","projectHeading":"_3h2gJMwV52TWtRnszE5ABC","text":"_26paTFeCQyR-mGbda4GRsl","button":"du37SouANEkcSwZf4t16p","icon":"VilJxYqRk0lFh_WOlJhqn","darkgray":"_2jfQG_10ClmvBse4GXOzgz","inner":"_14rGVRhE03mnicbbF3NkOQ","imageWrapper":"_30bd8AZf2qlku9iXGycqzK"};

/***/ }),
/* 777 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_2XkMiMycnGnKN6hCEAvbDW","caption":"VIVZLLEqmOqzQmWqwL_pn","carousel":"_27veRyUj9h1ZJ_L-tJey2A","dummy":"_1nHquYqYbsdBzmtGlo5Ban"};

/***/ }),
/* 778 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"image":"_2WIlTwMFfHrfeZt_sO1bUa"};

/***/ }),
/* 779 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_2rlA2h_sfKF24xTn4bfsYs","zebra":"_2kYQZ6XlE_XLmhqSFTQAnq","zebraBlue":"_3if_UXiGiJD-jsp650VBmQ","list":"_2s6CLEaiqcAijGS6Fp3jan","yellow":"_7o5wNk0R1ui-F0NDYaAy1","darkgray":"_34ulKr3DQjtypAWffXhVjO","wrapper":"XA6RlfLpJjn28lObZL6q3","heading":"_2aSK9734ckuh9IEeawFvTP"};

/***/ }),
/* 780 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"card":"_1lxMuoxnJJTgOg67yk3LBY","circle":"_3VDgrCmSOiSI-VxW0VrNVN","small":"pHZgeRJcvsaTJrcf2kUDW","yellow":"_3uvHauOaVlkY7piMqfMUhl","darkgray":"_2yqie7YCiGDR-lCgwMs-w6","circle-content":"Ka-jOwoQ58zYXARfH9J2x","circle-overlay":"hvHibnujOiRtVEhVeZQke","circle-overlay-hidden":"_2t-OOlWSBq0fUdrsYja5HQ","content":"_2jWFtZNaRz5UyfZCHFeGVb","has-animation":"_3eMEPyjx8NTglB9BY1gLu5","number":"ytJBmDwxOGTXybIktj13z","unit-text":"_3HU_fqTl3cJscA962VR_aN","icon":"_1_TLP-bQaI2ScQHc9LK8nE","description":"Al6Wj0cNXa76B0gJZkvO9","is-visible":"_3Zrr8Tq2Ce7Mcnju0MseA2","unit":"_1sjlI4pbnVMRnk9ToRtPWv","icon-number":"HPkKWi06mAoNJafFouS8K","button":"_2qEjcPs4CHgj-5QIWloU0f","zebraBlue":"P1_YZ2uDGLV_SO6mxsr02","active":"_2yB0YSUzsRVg25uDg367p8"};

/***/ }),
/* 781 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"card":"_1rE-7gA3tctQFoC7u69qkp","text":"_2rQCTx2PcuxMvT1tV73uC0"};

/***/ }),
/* 782 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_6Pe2m-WvL4vDtSDlAjL0X","background":"_2Kdq7QWNYL-a4Z7_X7tY-a","heading":"_2GQ7j9tlSzppZaIqc71c92","wrapper":"exTA1A0eYS_ETwiqXLVno","group":"_3ajQkZtRSDBHnVbYCG_aZ-","links":"_1S_5yRv_IeTnk1C-DHZjJ8"};

/***/ }),
/* 783 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_2U5nf1NS2rH5LMXUX9S1xj","bg":"_2QNMy3jEbf9RTzmrIzX6ky","tall":"oTAklofnkkOkykGU_s4rg","block-content":"_1_pdZdwv6eHTAQGTUI0diw","list-content":"_21W_ZYkaPD13gQQjAyDcKx","heading":"_1Wqq9YS78MlPkNnLHfEGn7","text":"O99bYyr_QK0sYjGSBErjq","zebra":"_2_huAt1ManTdmQwhAxaKGO","yellow":"_1Gp6RDtxM9zlq4MlUJei_G","darkgray":"_15M_MqetFsw_-tap_xm-yc","video":"NvHv69fpphOZiWdoKAvl4","links":"_2OEj6Af7K6zGEa5YeLABrY","videoplayer":"NRA-9dTCT2mwmINpgqCa0","icon":"_2ZaXKPniLteMeeTJQXRJBM"};

/***/ }),
/* 784 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"_1bYT5TPpRiWFNCTaRF4Olo"};

/***/ }),
/* 785 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loading":"_0k4LL1UjgGuJaCBsCB2y","search":"_2kN37Lb-hacupijNjubCv6","label":"_3Vid6a3Mn63Pl1tPlEHNlq","container":"_1LchriA1o6QMS6WtX_rVLL","input":"b_H1XxgSilyJc5Cy9skJ9","button":"_3JjoN_DDdVCgj1xIKsDd3X","icon":"_2S1TxF128uilOlT4JRmjKr","search-result-text":"va8vSlEq_IyWftsiYMnbV","no-results-text":"_3lGAqIXGURlyPaG0igmQ_e","error":"_17YfYjcF5RyNFBlfgKtaxz"};

/***/ }),
/* 786 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"j6kqZ5GFXEVjNhlxyIIhr","map":"_3WN0aXCpvRc6rfq0DCAt6h","address":"_3QQgBN8Uk6JOUStZqb-r93","icon":"xmLCWOBgxV6kfCkBunMsc","marker":"_3YTNSTejoGZ5EkjY12zsRL","iconDone":"El5u8bFfIDWnl7fnQnEHH","label":"_2mLGdPWv2vjIMtCB2_0Wl9"};

/***/ }),
/* 787 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_2oP0V_zc1KDyBLxZt9ESIz","map":"_2X52O6Yh0kn3hPva3IlTmy","call-to-action":"_2cycdbsD7AKonD6YrgGfHn","marker":"_3gu00cZeTB8bJOhHkiYK29","heading":"xWOW7mY-nS1zVBWchJbR_","projects":"_2nvpAKNkuJrnRcCfr9KKbN"};

/***/ }),
/* 788 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mediaWrapper":"_33w2hGrMVFtelTBK8tHMLb","isLandingPage":"iAcj6whDcI2DSbi7_WvS4","childWrapper":"_3aMrjROwlp_qmvgVzhFApY","bottomAligned":"_18wUHCyLZjBsnNQfA-QEpF"};

/***/ }),
/* 789 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"cover":"bzTxDXWxt3nLUoglTFmwN","media":"_103BmLwQgqPYbeQeYA1BmI","visible":"_2WgAQryCbU2NX4hmbty6_s","VideoAppear":"jtpJRZcBiy9Y1HEvqv4T4"};

/***/ }),
/* 790 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menu":"_2QncI5Bf_8d25LTmYFtQqV","close":"_1mmt08_e3snTSfKfBC-F1s","item":"_2VJNWOFtBdcl2nIHuJyVg1","menuItems":"_4jHtta7VykFNBQ5CkU3cP","yadda":"_3PmVwGt-JebgfYMewmdoRo"};

/***/ }),
/* 791 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"news-block":"_3CnfvS5fxFoibIrCHDD0Rd","frontpage":"_2C1PeoWnch2RmyH0aKDP8F","horizontal":"QKORg33EWKa81JpKrxW9l","text":"_1qSJuvSKqTlTybjXDblxO0","heading":"w1RKPzz7tFRR-qqY9l9ay","paragraph":"nYa_p999EABXG92_gMrph","link":"_3CyXkiPq2CEH7MPmMbz4kk","image":"_3tUV5iLaqF_S6WB0A8A-yS"};

/***/ }),
/* 792 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block-heading":"lwBC8pQvQNetIPgu8Grzf","newslist-block":"_3ziAt4r525MPmTs6IHsxL","frontpage":"_1HguSpzsPo4BBemxbuWE6q","horizontal":"_3GW3NliXx5hfJlzex7K0Ca","zebra":"_1ES-5awjvQq4jnXnwe1JYk","yellow":"Zb3vwYD730IOH-aTkERME","darkgray":"_34dNYbD53fVs1-HVj91ctQ","heading":"_1vqAf8yr9dbhKM5223gLNJ","description":"_3BGJ6T8Az_VB_JBVGGaSHV","articles":"nJbdIcd_EzjuLUYMS_t-u","button":"Dl-Xyqt8Evm0-d3YOl-IB"};

/***/ }),
/* 793 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pagination__button_prev":"_1-NAmhKaq5FcuiWjRc1KlT","pagination__button_next":"_39qzUgSFcTvtXIgqo67xID","pagination":"_3ys5pxBhekm1q4qTfGuPUC","pagination_in-search-block":"_2gtXJ7prC8EIdS_yKLt84a","pagination__item":"_2tggERO0EJAfJTlAsMk-EP","pagination__item_prev":"xFaiG9CAk13Coeoh76mXO","pagination__item_next":"_2yr2PQ4wWEr_OstYpMNOqN","pagination__button":"_1sm_hu1PLCsoCkHwoaDMsQ","pagination__button_active":"KFBL0frfwi-13VHG0nVIg","pagination__button-dots":"g9O2MUBjWMJgbuAuXT-Q4"};

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"photographer":"Nrd0PDrgV5BaJ_H-Bvh4I"};

/***/ }),
/* 795 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_3BgrllUJ_71tzvfslL7Rfo","inner":"mIB_2yGgkSFxMY4swPgOz","filters":"_1Q24944j9lxRt3y3eYaD7H","list-outer":"_2kzKpygJPXhjIbW4CZNzSQ","list":"_3vAhThcPVJJi2RGoOZ2oSB","searching":"_2qNBKiNBJskgH_Uzn2GQJD"};

/***/ }),
/* 796 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"slide":"_34pqt9RDU21PBHPWNcLI5u","compact":"_18znKLrWqZl3bJiF4spDU8","image":"_1F64aDzZdfWzRYv7gYpcGP","prev":"_1Yi1joFBu4LM-C7o6Ym1Kd","next":"_2jiwJB8ZkA3GFwhOWwQ40f","featureActive":"_2gS8I19kbvKBfNEvVlHmSv","feature":"_1IrtAMmqPZDxH7NglnJABA","timeline":"_2IZw9JYyGfx9fG21l-Ogdl"};

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"card":"_1xlmjLp93Nioi_SPEBfSuc","compact":"z3RuoXWUxM9T0AX-j2vOK","image":"_3yqW9_s7dv8B6hyjNscVpP","list":"_3fFdKGnqAziXKUhKJFPPM8","imageWrapper":"_3Ay3Hzhvm5svpdZ--ci-F4","info":"_3Lmssp0Bzdch7XV8yTniEF","hasImage":"LUEApNWb72XhsAVYvnYwd","name":"_3pIVK9OgK7eGMukjKLLFCv","address":"_3QfrQYCCensLA1w2BwD9oR","text":"_1NQwIa_mp0KxOZbToXA9BG","details":"PSz7nYs5be0KQs0xZ9PkN","region":"_2Zd2yb_6Rmlwwv1n9XsVNQ","division":"_3AVaXDtjc28mhNQKgmSuyM","externalUrl":"_2W2hrA2yPCl3xpAUT0nhoa"};

/***/ }),
/* 798 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_3WvNtwVzT4K-ThiD4iHKSd","column":"_1AOnJDTfchdzHO_jiz0S8c","info":"_3cZIsGn3oAxCSlWYQ2ag5R"};

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_3W6lBmp93rZAtImL3K6YIi","zebra":"_1dX5UdeUbd_X_nd3BC7vrl","yellow":"_3riBHnvZbfgM2oP9GgIDuO","darkgray":"Kuzn3-nRYT9dnEmE6e4Cm","lightgray":"bYLVTds1kKXB3exUCIovv","heading":"_3okRH4etTO06sJuGx6rzzI","list":"_37cK3NJmfoIfFIQvu5Ut_2","project":"_2nThfuaiw_ooqbmV2jAH0E","is-on-screen":"_1zeRNYVYmGPSx8QYIY98U9","external":"_16g7akpF74_WLUM5eAC9Dj","button":"_1jRctxewW2u8V5HSz_Vies"};

/***/ }),
/* 800 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"UWjbDlGFzkIplS32xCc3j","rightNow":"_1Qbk8AjrW9AdNSNLAsx6wC","filters":"_2kzgD_xbaXWRkwOeggIjcg","filterButtonColumn":"LhsONLun5KhyzWCGxFigs","primaryFilters":"_5m6sZHTIcPmd_CBwZW4Mb","secondaryFilters":"_2QWaQuG8qsvcTjslqSJIwp","resetFilters":"nGnR7nW18V27LcHqH3cnh","closeFilters":"_2fISvxUfd1pZQAxYww5W_M","content":"_6UsQrmdWqQUmCQfqzV1n1","projects":"_3Bo7RWBMAdIyNWVuF5jeSJ","map":"_2IC_1klHiPatEhk6Wg0YOL","mapActive":"_3zAzopZt38WgfhYOO1zC1C","resultsActive":"_2nXIWHL-PKv5fNWusq-g8u","mapToggle":"_30TcQvBLeH-EDA9OTE3bA7","list":"_2yrW6fsbv2ctoUrCkewmZz","grid":"_1Eja5iIg_SYV7jRZDyxBJw","searching":"_14x2WQAj_TKmN-2FaY0EYY","options":"_5T_18kC1HWgj84IS1Smbn","active":"C4WYIC7K0dHuNuZpI7kFo","search":"_2ohUb44QnQv8jzCZ9iXiZY","searchActive":"_2uCgxrz5Q9ooHH-B5olle-","searchInput":"HJdz24RR61wb9f_mRrUgh","display":"_14OxMmffQrrqUIyP94LHPe","print":"_33QznPpU_uVQBwLmZjLsSH"};

/***/ }),
/* 801 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"published":"osN8lNJKpGXvGC59Lcz8_","frontpage":"_33h23eSoZsQXJESy31FHLf","horizontal":"_3zRh5N9DYa3vw-ThSQ0jSa","-is-feature-article":"j3ppM1ldJC6SjnsNJXxB1","icon":"r3UTXDtRpSmP_CnBzvg85","text":"_3-c_nXIMx-xgeLcPZASoCn"};

/***/ }),
/* 802 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_2lvWnbdfs5g5Yn5lbOjHql","block":"_2FIfP--316VjX6VM_h8oRK","withImage":"_3On2bXdHKhehEeyk4b49BZ","quote":"_1NS0N_W-HZ2Zpr67Eqqcj9","yellow":"_20eBTSDWMdnPM1YxgitFky","blue":"_1EFnX8kGgf5wwDkGnYZHfG","author":"ymGGWbN3fGTdZb1ExK2OV"};

/***/ }),
/* 803 */
152,
/* 804 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_3_yLI-JGqgY9Lv8GLRV_s9","yellow":"_23Ec9FdZl1pFqBW6Q083WN","darkgray":"_2t7xSKaAo5RX0eV-_iBm9","lightgray":"_1yv-XEPuK1BBbDjdB3B8OI","heading":"_2mlaQb55ST8gDDNcKDqfer","list":"_2QqM3d3OExvzVm06aKlM7Y","featureArticleListPageLink":"_2aN4wuR0xaLSPz3eFcUm8t","article":"_2iXdORtACFRNlRPSVFUxdM","is-on-screen":"RWDKVSGOXEmQVOzQK7fUy","button":"_1eoDj1G590hzqkyqHphLi5","articleLink":"_2DocbXWjz7kGciyTqzszar","image":"_2Qpy7fuuqScohMGmqKQnqr","imageWrapper":"-bJiYXjrmzLMGsCeuplHV","articleIntro":"kkPceMBCnsoHO0fG1jFsO","info":"_327CsSoVt4nDohwifTOTEt","publishedContainer":"_2KHYItJmseg9NBvt8JMPew","articleHeading":"Y59m4a_-fvHsovU68ZlUg","articleTag":"_4yEJNZP7iP4o2PEzyc91M","divider":"_1uzaGg06u_47jJrPWwkEHT","articlePublished":"_2rNvYjKrGkcjj9ZhR_TXkD"};

/***/ }),
/* 805 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"box":"_9hwGjwaGJ3kAzPCVhX4Dk","header":"MeyEYcdjFShtQYgUrJPJf","webcams":"_3i55AN8NLhaEIZFCSyhEK-","infographics":"_3T-wUsXZfJXD0NPIxyu0zi","indicators":"_2ouMlPSz6pUPhc5Rm-XcaT","active":"_3iI2-g9D1OqUmfF1POut3J"};

/***/ }),
/* 806 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_3LYW8iwnx2wniEC1B0-EX7","large":"_1udIP9QxP_cBXEr5W-8rJv","content-top":"_1aca5VQ32a8-s7ye4kod1C","buttons-header":"_3QZGqWBfnSr64-WqwHFNNB","text":"_33dFVFcoHfEXSmg-1V75eF","content-bottom":"l0SO47ALuwTe1f8KHhMXu","solid":"-SBUNrYdoKCz0W6XeZbGx","background-image":"_2cjC-1gKQchOUSj-uT5bou","small":"_3DGpUjQM2r8Ovo_KRzRbPw","buttons":"_1z437AoEyKAjPyCmNGSc7X","inner":"bYfp-HLiVM-OVCV4nd6T3","icon":"_1O0YftRVq12WqDU57gUGCV","grey":"rJUvWO1li9g81WyyS2IjY","white":"_3EzwGxXo1a-R9p8tBRBGTZ","description":"COXEOjqKP-GY_RSdFLYkf","photoCreditContainer":"Vc38vbEtiVfsgvXzE-knT","breadcrumb":"_3KS49JWoVG4rKcal0hHKLb","photoCredit":"KGPMHU7NLiNUrzoxz59DM"};

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_11p-YQ8no6eCpERzryRW0R","container":"_3pw_yrFp0ecgzfS7z6TUln","heading":"_232c8PbqRvN8xypTmyCqz5","shortcuts":"_1_1Sz7wQjXOCJtQFcK3YgS","shortcut":"_37gMEaBs3O_5QpobCiHEqa","shortcutLink":"_2K-clJnVWc3CwZ0nLPOpPt"};

/***/ }),
/* 808 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_1e3N3kmFyJaebmferuTQsS","condensed":"_2SmD3YGcTRgEKxOz7rk4wP","theme-1":"_3wdF4VU4ZSqma7Qi_hGY1j","nav-indicators":"_2j09HRWCam31do7_n30R6x","nav":"_1M70EQPlEbH5eryxTXjyI1","mode-horizontal-list":"_3KeLT82eXY1qb-uK-vqkfN","slide-wrapper":"VYfbUuvIvzgsi4v3bvEsH","slides":"_87j7IJI4pJryYXDtfvUST","last-hidden-list-item":"fwlPPHWIQdPXkGizxcqNA","carousel":"_2Wzx9QWAwTLin4r1l8f77o","active":"OfzE7RO8mt8FNiLLd5DRd","dummy":"_5MUaFTTXf2OhrdLzN-vlA","nav-prev":"_1w5zmE-4J9Gb_jcGRWCJp","nav-next":"_3-NTjf3V1gzIxMrnWNcehW","shadow":"_39XsgLx9pl5g2fhLUC_4z1","direction-forward":"_2DREx3-iAbfnj3kZHn2FlE"};

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_1Hj4rF4H6N6XS5j_PtK8tJ","header":"_3Gq2_Pnj-uewGliDlWQ7qF","tab":"_8hOD_6KOltSFaOIp_LTEz","tabInner":"_1HucVHF6xRP3-LYW2tsI-6","noIcons":"_30ECK-NxbVpOfZ7w3x0idZ","iconWrapper":"_355Lqp90nTnM-c-NwbcVAq","button":"xS_EIpHLAvAHBYKqZJfJZ","active":"_2bnSb8upDpJmLmuw5oZAJM","active-tab-indicator":"_1OajJTLrvGDG7yN6I3aObB","tabs-wrapper":"_3OxYRTsxdhzZiKEc_u_jPD","wrapper":"_2i_81vYAa6S-AjGHR7NgWg","enter-active":"_3NEXKJJi2jlXIZSQ5k5CxQ","leave-active":"_6wg1Xp0XO4bs_vImkuiuW","enter":"_3F5tsrMgOKvbADVR2i-iD_","leave":"gEn-eDgbUFDk_dAo3m0eS","content":"TDRYkGY1AR_W4WY7PAaZ0","intro":"_3ZC9rqxzNSGIMx22Tfh2qT","text":"_1_-3FR3ZtJtLCW65lnaeD1","side":"RUQE1IhDrLG-f0oxReDKf","noSide":"_1ifeRURGRw6OlGW0pux1Xs","readMore":"v95ZC4BYSI6lBEEbsIueT"};

/***/ }),
/* 810 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_1UDEzLPR4p7pE5Z8k4H1qs","zebra":"_7jGdwkdxIiyOuBUZKGP0e","content":"_1sF77spDpM8qMqEznLUQzD","has-overflow":"lOMa1zgla9Y9oSIpIZoR_","yellow":"_2xFdNhcxmOZg-dU_00Kx62","darkgray":"_3tTV-NaDw764obK509XEod","table-text":"HULV2DmPi7tsT5VINO31z","heading":"_1fsIyjeFBWA5iX1GIVs-kP","had-interaction":"_1w-YTVuV4MUfY-S9bYGQh_","swipe-hint":"_1Bp5yPW3-Sb-ciYW5Rv9gN","table-swipe":"_2odlz3YM54K9wXlLV284BT","swipe-hint-hand":"RnEYHx_pS2LHk3yOdaqjg","swipe-hint-trail":"_1LdoAphEO7ROgLUDLAmsuM","readMore":"_1wH6W-p1Y_fdPHuCbe9v6t","rightAlign":"_19E9FzGJhapovfwukOOwoc"};

/***/ }),
/* 811 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_3Fuclxytg6VzMM1IP_5uxO","yellow":"_1hgUj30y04AEQV4mBbhMqH","lightgray":"_1YGJRJXqXj9E7EFexmSnJ3","text":"_1rsGoXAxDwYr0wODsa9kXH"};

/***/ }),
/* 812 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_3uSm0hukCpgrfl--zTmXEw","heading":"KlA51ptJHOmrf8QHiBNPh","lightGrey":"_2pzmRQQHuHcjjrsJr9i4kJ","yellow":"_1QzEexmjP_sv6Bo60142lo","blue":"_24jUFTbZV7AyQmJyBqsVmL","items":"_10C5zH0rJ6cdAT-Dk-nnfI","item":"_2JiLx8eb6RTpdG0kdd9WnH","link":"_137va5i2HY614P9nzYUjbJ","active":"_1_9HcUyAjP6BxgmgdsV7I2","linkText":"_26xD18bRDvhKqDeqHGA-UN"};

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"WZmAHP4KISUmOCxT84D9J","header":"_3xL9XkHahPjitv8nyj4EIq","content":"_2aBGNFWbQfvmkMFqV8N89m","dropdown-block":"_15RrXUdvlHqiouqxIpmwTm","list":"_1Dz7Oe6Mot_w8UdTYr06sv"};

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"gAEmnF7XyshVH3bGeYhw4","heading":"qElo13ogQd25VTC707gyN","zebra":"_38sROKXuwY1YVWUkaY9Rr_","yellow":"_4WWGrjEvt5AY6AVY_1rYj","darkgray":"_70GX8UU531PyqcJ8N3-gR","lightgray":"_2tAvcQbPvj-TB4F-zIec1x","white":"_1anfP6Jdk6QBUiZS4pp8GX","content":"_2cF7XpAA1loN62TPSTlBAb","is-on-screen":"_2EJ6BrTQK_O9QIU-XmvxUK","see-all":"_3HH-stvjd_xlIz2c6lYzLG"};

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_1MZ-xr28-8mUSeIAcC8bbO","header":"_3OSkwiPcKs4huNtue2FcIm","block-heading":"_1hIiuktCiWfuktR86CziaB","block-intro":"_2mG06ytrQD84UVbFUitUy3","condensed":"UeYeYCu9w3BJm_9N4lfJN","videos":"_1Rjd29OgH8V9XBg9jU0QIU","playing":"zil55q6cyE4EnzuGJ6Taf","video":"GTlZgu9odjWoZad6RTtBs","preview":"_1tk2jMkwVWk4VhLPco4V4L","squared":"bQWjjTzXG1wG5F2ZW4zT9","active":"_1TuxH4fwrJ_zTQn2DpOhdS","subtitle":"_3DYwEYTBxLq9WjyAddKAb5","description":"_2XEJ_G7ca3viFEybCL5H9x"};

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"video":"_3_Cs19JQmHf5KmPV-tWQsk","-theme-default":"_2lHz9ZRXwgr599o2cblx-G","-theme-full":"_2mFLAzPK5mcS-uM_c916sA","iframe":"_2xhritz__qOevOZKvzVy7f","appear":"_2Xd2oOjbW3JSpfX-Zykk2w","play":"_1_Be-WSceYr8qQDsOKsVSR","title":"_2WWQDmQrCPqsOAEe3bl-HO"};

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"videoBg":"_2ubF6kLXEPwi2Jy1DqWPU1","video":"_1FGKaFXUMPLsKF3Bbmqtrm","videoWrapper":"_29Ej1lI3Al1l_AVTZ5WgPt","fixed":"s-lzJpQRKVrlxualWwTT","hasGradient":"_2TKTqgyXlDMov_Pds9KXZO"};

/***/ }),
/* 818 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_2FGWpLJu7wZtmgEgj2j6aH","container":"_14DAt1-tACZmobHJv8oX6_","no-logo":"_2ttsdZ60Tm1TmH7AEeQQWS","logo-container":"_2K0lNcywMYH9CYOHUdEZIe","logo":"_3UfI2nHJV6nhK8KfWld821","text-container":"_7WMPuDAiWdUs27Su-dP3d","name":"_2i7sgp-gmYQ6ht-jtAirxq","container-no-logo":"f4fM-kAUqu0f8t6xCfJU8","button":"_398m38GtQw7amTNeMmr-My"};

/***/ }),
/* 819 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_1J-GBsP9rg0epMQpcvTlgF","image":"Wc3hKKO_vJJjvIfCnXod_","failed":"_1phW4fuxKH4wmVulmiSydn","failedlabel":"U8D1gpvZO1fB3BwP1O8F-","icon":"_2UViBgcH_NNFroUaGBHwyJ","caption":"_1beYMFWs8X7bBrrOQNoqeD"};

/***/ }),
/* 820 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"ltA5FbeS3ETcIGmlBCJ4F","image":"bKGaQU9Ims4b1CNueM9fE","icon":"pkbToR0i_oHbC1x_L0-gR","title":"_1K2uaO9-eVfm6yVOlzJP8h","failed":"IJJIDRL5eRkUkpbblpJqO","link":"_3BeKbWDp1opDEpElxBMfND"};

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"_30B6qpusP8GBORWL57B7Jq","zebra":"_1terNCycY-L0z7QJztyF_c","yellow":"_1qlcID_4hImEYMOMjjkpbk","darkgray":"_20wJItjHxINfbLGbh01lpT","lightgray":"_1zd_MQw-B01KlcNP5-gSfc","white":"_2g8f23c2TZiL0DKzYE1DtZ","heading":"_2gCPxMmD74Y9ceVnOjj2k0"};

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(822);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(832);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(23);
	
	var createArrayFromMixed = __webpack_require__(825);
	var getMarkupWrap = __webpack_require__(827);
	var invariant = __webpack_require__(4);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(23);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 829 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(829);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(831);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 833 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 834 */
/***/ (function(module, exports) {

	module.exports = "/Public/build/72c916ce98494e0acd48991392013a3f.svg";

/***/ }),
/* 835 */
/***/ (function(module, exports) {

	module.exports = "/Public/build/ce16c801ec3b27a0fb27d8004dca846a.svg";

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	module.exports = "/Public/build/059664639a7e8f561d125bbd1500c583.svg";

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	module.exports = "/Public/build/a809f46c2d312d752ddb9d83471dd2b3.svg";

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	module.exports = "/Public/build/68bafba75f4d07e401ca6ad12ec57b76.svg";

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	module.exports = "/Public/build/e0dd1d3c52031d6413758fd195936562.svg";

/***/ }),
/* 840 */
838,
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(1085);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	/*
	 Leaflet.markercluster, Provides Beautiful Animated Marker Clustering functionality for Leaflet, a JS library for interactive maps.
	 https://github.com/Leaflet/Leaflet.markercluster
	 (c) 2012-2013, Dave Leaver, smartrak
	*/
	!function(e,t,i){L.MarkerClusterGroup=L.FeatureGroup.extend({options:{maxClusterRadius:80,iconCreateFunction:null,spiderfyOnMaxZoom:!0,showCoverageOnHover:!0,zoomToBoundsOnClick:!0,singleMarkerMode:!1,disableClusteringAtZoom:null,removeOutsideVisibleBounds:!0,animate:!0,animateAddingMarkers:!1,spiderfyDistanceMultiplier:1,spiderLegPolylineOptions:{weight:1.5,color:"#222",opacity:.5},chunkedLoading:!1,chunkInterval:200,chunkDelay:50,chunkProgress:null,polygonOptions:{}},initialize:function(e){L.Util.setOptions(this,e),this.options.iconCreateFunction||(this.options.iconCreateFunction=this._defaultIconCreateFunction),this._featureGroup=L.featureGroup(),this._featureGroup.addEventParent(this),this._nonPointGroup=L.featureGroup(),this._nonPointGroup.addEventParent(this),this._inZoomAnimation=0,this._needsClustering=[],this._needsRemoving=[],this._currentShownBounds=null,this._queue=[],this._childMarkerEventHandlers={dragstart:this._childMarkerDragStart,move:this._childMarkerMoved,dragend:this._childMarkerDragEnd};var t=L.DomUtil.TRANSITION&&this.options.animate;L.extend(this,t?this._withAnimation:this._noAnimation),this._markerCluster=t?L.MarkerCluster:L.MarkerClusterNonAnimated},addLayer:function(e){if(e instanceof L.LayerGroup)return this.addLayers([e]);if(!e.getLatLng)return this._nonPointGroup.addLayer(e),this.fire("layeradd",{layer:e}),this;if(!this._map)return this._needsClustering.push(e),this.fire("layeradd",{layer:e}),this;if(this.hasLayer(e))return this;this._unspiderfy&&this._unspiderfy(),this._addLayer(e,this._maxZoom),this.fire("layeradd",{layer:e}),this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons();var t=e,i=this._zoom;if(e.__parent)for(;t.__parent._zoom>=i;)t=t.__parent;return this._currentShownBounds.contains(t.getLatLng())&&(this.options.animateAddingMarkers?this._animationAddLayer(e,t):this._animationAddLayerNonAnimated(e,t)),this},removeLayer:function(e){return e instanceof L.LayerGroup?this.removeLayers([e]):e.getLatLng?this._map?e.__parent?(this._unspiderfy&&(this._unspiderfy(),this._unspiderfyLayer(e)),this._removeLayer(e,!0),this.fire("layerremove",{layer:e}),this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),e.off(this._childMarkerEventHandlers,this),this._featureGroup.hasLayer(e)&&(this._featureGroup.removeLayer(e),e.clusterShow&&e.clusterShow()),this):this:(!this._arraySplice(this._needsClustering,e)&&this.hasLayer(e)&&this._needsRemoving.push({layer:e,latlng:e._latlng}),this.fire("layerremove",{layer:e}),this):(this._nonPointGroup.removeLayer(e),this.fire("layerremove",{layer:e}),this)},addLayers:function(e,t){if(!L.Util.isArray(e))return this.addLayer(e);var i,n=this._featureGroup,r=this._nonPointGroup,s=this.options.chunkedLoading,o=this.options.chunkInterval,a=this.options.chunkProgress,h=e.length,l=0,_=!0;if(this._map){var u=(new Date).getTime(),d=L.bind(function(){for(var c=(new Date).getTime();h>l;l++){if(s&&0===l%200){var p=(new Date).getTime()-c;if(p>o)break}if(i=e[l],i instanceof L.LayerGroup)_&&(e=e.slice(),_=!1),this._extractNonGroupLayers(i,e),h=e.length;else if(i.getLatLng){if(!this.hasLayer(i)&&(this._addLayer(i,this._maxZoom),t||this.fire("layeradd",{layer:i}),i.__parent&&2===i.__parent.getChildCount())){var f=i.__parent.getAllChildMarkers(),m=f[0]===i?f[1]:f[0];n.removeLayer(m)}}else r.addLayer(i),t||this.fire("layeradd",{layer:i})}a&&a(l,h,(new Date).getTime()-u),l===h?(this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),this._topClusterLevel._recursivelyAddChildrenToMap(null,this._zoom,this._currentShownBounds)):setTimeout(d,this.options.chunkDelay)},this);d()}else for(var c=this._needsClustering;h>l;l++)i=e[l],i instanceof L.LayerGroup?(_&&(e=e.slice(),_=!1),this._extractNonGroupLayers(i,e),h=e.length):i.getLatLng?this.hasLayer(i)||c.push(i):r.addLayer(i);return this},removeLayers:function(e){var t,i,n=e.length,r=this._featureGroup,s=this._nonPointGroup,o=!0;if(!this._map){for(t=0;n>t;t++)i=e[t],i instanceof L.LayerGroup?(o&&(e=e.slice(),o=!1),this._extractNonGroupLayers(i,e),n=e.length):(this._arraySplice(this._needsClustering,i),s.removeLayer(i),this.hasLayer(i)&&this._needsRemoving.push({layer:i,latlng:i._latlng}),this.fire("layerremove",{layer:i}));return this}if(this._unspiderfy){this._unspiderfy();var a=e.slice(),h=n;for(t=0;h>t;t++)i=a[t],i instanceof L.LayerGroup?(this._extractNonGroupLayers(i,a),h=a.length):this._unspiderfyLayer(i)}for(t=0;n>t;t++)i=e[t],i instanceof L.LayerGroup?(o&&(e=e.slice(),o=!1),this._extractNonGroupLayers(i,e),n=e.length):i.__parent?(this._removeLayer(i,!0,!0),this.fire("layerremove",{layer:i}),r.hasLayer(i)&&(r.removeLayer(i),i.clusterShow&&i.clusterShow())):(s.removeLayer(i),this.fire("layerremove",{layer:i}));return this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),this._topClusterLevel._recursivelyAddChildrenToMap(null,this._zoom,this._currentShownBounds),this},clearLayers:function(){return this._map||(this._needsClustering=[],delete this._gridClusters,delete this._gridUnclustered),this._noanimationUnspiderfy&&this._noanimationUnspiderfy(),this._featureGroup.clearLayers(),this._nonPointGroup.clearLayers(),this.eachLayer(function(e){e.off(this._childMarkerEventHandlers,this),delete e.__parent},this),this._map&&this._generateInitialClusters(),this},getBounds:function(){var e=new L.LatLngBounds;this._topClusterLevel&&e.extend(this._topClusterLevel._bounds);for(var t=this._needsClustering.length-1;t>=0;t--)e.extend(this._needsClustering[t].getLatLng());return e.extend(this._nonPointGroup.getBounds()),e},eachLayer:function(e,t){var i,n,r,s=this._needsClustering.slice(),o=this._needsRemoving;for(this._topClusterLevel&&this._topClusterLevel.getAllChildMarkers(s),n=s.length-1;n>=0;n--){for(i=!0,r=o.length-1;r>=0;r--)if(o[r].layer===s[n]){i=!1;break}i&&e.call(t,s[n])}this._nonPointGroup.eachLayer(e,t)},getLayers:function(){var e=[];return this.eachLayer(function(t){e.push(t)}),e},getLayer:function(e){var t=null;return e=parseInt(e,10),this.eachLayer(function(i){L.stamp(i)===e&&(t=i)}),t},hasLayer:function(e){if(!e)return!1;var t,i=this._needsClustering;for(t=i.length-1;t>=0;t--)if(i[t]===e)return!0;for(i=this._needsRemoving,t=i.length-1;t>=0;t--)if(i[t].layer===e)return!1;return!(!e.__parent||e.__parent._group!==this)||this._nonPointGroup.hasLayer(e)},zoomToShowLayer:function(e,t){"function"!=typeof t&&(t=function(){});var i=function(){!e._icon&&!e.__parent._icon||this._inZoomAnimation||(this._map.off("moveend",i,this),this.off("animationend",i,this),e._icon?t():e.__parent._icon&&(this.once("spiderfied",t,this),e.__parent.spiderfy()))};e._icon&&this._map.getBounds().contains(e.getLatLng())?t():e.__parent._zoom<Math.round(this._map._zoom)?(this._map.on("moveend",i,this),this._map.panTo(e.getLatLng())):(this._map.on("moveend",i,this),this.on("animationend",i,this),e.__parent.zoomToBounds())},onAdd:function(e){this._map=e;var t,i,n;if(!isFinite(this._map.getMaxZoom()))throw"Map has no maxZoom specified";for(this._featureGroup.addTo(e),this._nonPointGroup.addTo(e),this._gridClusters||this._generateInitialClusters(),this._maxLat=e.options.crs.projection.MAX_LATITUDE,t=0,i=this._needsRemoving.length;i>t;t++)n=this._needsRemoving[t],n.newlatlng=n.layer._latlng,n.layer._latlng=n.latlng;for(t=0,i=this._needsRemoving.length;i>t;t++)n=this._needsRemoving[t],this._removeLayer(n.layer,!0),n.layer._latlng=n.newlatlng;this._needsRemoving=[],this._zoom=Math.round(this._map._zoom),this._currentShownBounds=this._getExpandedVisibleBounds(),this._map.on("zoomend",this._zoomEnd,this),this._map.on("moveend",this._moveEnd,this),this._spiderfierOnAdd&&this._spiderfierOnAdd(),this._bindEvents(),i=this._needsClustering,this._needsClustering=[],this.addLayers(i,!0)},onRemove:function(e){e.off("zoomend",this._zoomEnd,this),e.off("moveend",this._moveEnd,this),this._unbindEvents(),this._map._mapPane.className=this._map._mapPane.className.replace(" leaflet-cluster-anim",""),this._spiderfierOnRemove&&this._spiderfierOnRemove(),delete this._maxLat,this._hideCoverage(),this._featureGroup.remove(),this._nonPointGroup.remove(),this._featureGroup.clearLayers(),this._map=null},getVisibleParent:function(e){for(var t=e;t&&!t._icon;)t=t.__parent;return t||null},_arraySplice:function(e,t){for(var i=e.length-1;i>=0;i--)if(e[i]===t)return e.splice(i,1),!0},_removeFromGridUnclustered:function(e,t){for(var i=this._map,n=this._gridUnclustered,r=Math.floor(this._map.getMinZoom());t>=r&&n[t].removeObject(e,i.project(e.getLatLng(),t));t--);},_childMarkerDragStart:function(e){e.target.__dragStart=e.target._latlng},_childMarkerMoved:function(e){if(!this._ignoreMove&&!e.target.__dragStart){var t=e.target._popup&&e.target._popup.isOpen();this._moveChild(e.target,e.oldLatLng,e.latlng),t&&e.target.openPopup()}},_moveChild:function(e,t,i){e._latlng=t,this.removeLayer(e),e._latlng=i,this.addLayer(e)},_childMarkerDragEnd:function(e){e.target.__dragStart&&this._moveChild(e.target,e.target.__dragStart,e.target._latlng),delete e.target.__dragStart},_removeLayer:function(e,t,i){var n=this._gridClusters,r=this._gridUnclustered,s=this._featureGroup,o=this._map,a=Math.floor(this._map.getMinZoom());t&&this._removeFromGridUnclustered(e,this._maxZoom);var h,l=e.__parent,_=l._markers;for(this._arraySplice(_,e);l&&(l._childCount--,l._boundsNeedUpdate=!0,!(l._zoom<a));)t&&l._childCount<=1?(h=l._markers[0]===e?l._markers[1]:l._markers[0],n[l._zoom].removeObject(l,o.project(l._cLatLng,l._zoom)),r[l._zoom].addObject(h,o.project(h.getLatLng(),l._zoom)),this._arraySplice(l.__parent._childClusters,l),l.__parent._markers.push(h),h.__parent=l.__parent,l._icon&&(s.removeLayer(l),i||s.addLayer(h))):l._iconNeedsUpdate=!0,l=l.__parent;delete e.__parent},_isOrIsParent:function(e,t){for(;t;){if(e===t)return!0;t=t.parentNode}return!1},fire:function(e,t,i){if(t&&t.layer instanceof L.MarkerCluster){if(t.originalEvent&&this._isOrIsParent(t.layer._icon,t.originalEvent.relatedTarget))return;e="cluster"+e}L.FeatureGroup.prototype.fire.call(this,e,t,i)},listens:function(e,t){return L.FeatureGroup.prototype.listens.call(this,e,t)||L.FeatureGroup.prototype.listens.call(this,"cluster"+e,t)},_defaultIconCreateFunction:function(e){var t=e.getChildCount(),i=" marker-cluster-";return i+=10>t?"small":100>t?"medium":"large",new L.DivIcon({html:"<div><span>"+t+"</span></div>",className:"marker-cluster"+i,iconSize:new L.Point(40,40)})},_bindEvents:function(){var e=this._map,t=this.options.spiderfyOnMaxZoom,i=this.options.showCoverageOnHover,n=this.options.zoomToBoundsOnClick;(t||n)&&this.on("clusterclick",this._zoomOrSpiderfy,this),i&&(this.on("clustermouseover",this._showCoverage,this),this.on("clustermouseout",this._hideCoverage,this),e.on("zoomend",this._hideCoverage,this))},_zoomOrSpiderfy:function(e){for(var t=e.layer,i=t;1===i._childClusters.length;)i=i._childClusters[0];i._zoom===this._maxZoom&&i._childCount===t._childCount&&this.options.spiderfyOnMaxZoom?t.spiderfy():this.options.zoomToBoundsOnClick&&t.zoomToBounds(),e.originalEvent&&13===e.originalEvent.keyCode&&this._map._container.focus()},_showCoverage:function(e){var t=this._map;this._inZoomAnimation||(this._shownPolygon&&t.removeLayer(this._shownPolygon),e.layer.getChildCount()>2&&e.layer!==this._spiderfied&&(this._shownPolygon=new L.Polygon(e.layer.getConvexHull(),this.options.polygonOptions),t.addLayer(this._shownPolygon)))},_hideCoverage:function(){this._shownPolygon&&(this._map.removeLayer(this._shownPolygon),this._shownPolygon=null)},_unbindEvents:function(){var e=this.options.spiderfyOnMaxZoom,t=this.options.showCoverageOnHover,i=this.options.zoomToBoundsOnClick,n=this._map;(e||i)&&this.off("clusterclick",this._zoomOrSpiderfy,this),t&&(this.off("clustermouseover",this._showCoverage,this),this.off("clustermouseout",this._hideCoverage,this),n.off("zoomend",this._hideCoverage,this))},_zoomEnd:function(){this._map&&(this._mergeSplitClusters(),this._zoom=Math.round(this._map._zoom),this._currentShownBounds=this._getExpandedVisibleBounds())},_moveEnd:function(){if(!this._inZoomAnimation){var e=this._getExpandedVisibleBounds();this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),this._zoom,e),this._topClusterLevel._recursivelyAddChildrenToMap(null,Math.round(this._map._zoom),e),this._currentShownBounds=e}},_generateInitialClusters:function(){var e=Math.ceil(this._map.getMaxZoom()),t=Math.floor(this._map.getMinZoom()),i=this.options.maxClusterRadius,n=i;"function"!=typeof i&&(n=function(){return i}),null!==this.options.disableClusteringAtZoom&&(e=this.options.disableClusteringAtZoom-1),this._maxZoom=e,this._gridClusters={},this._gridUnclustered={};for(var r=e;r>=t;r--)this._gridClusters[r]=new L.DistanceGrid(n(r)),this._gridUnclustered[r]=new L.DistanceGrid(n(r));this._topClusterLevel=new this._markerCluster(this,t-1)},_addLayer:function(e,t){var i,n,r=this._gridClusters,s=this._gridUnclustered,o=Math.floor(this._map.getMinZoom());for(this.options.singleMarkerMode&&this._overrideMarkerIcon(e),e.on(this._childMarkerEventHandlers,this);t>=o;t--){i=this._map.project(e.getLatLng(),t);var a=r[t].getNearObject(i);if(a)return a._addChild(e),e.__parent=a,void 0;if(a=s[t].getNearObject(i)){var h=a.__parent;h&&this._removeLayer(a,!1);var l=new this._markerCluster(this,t,a,e);r[t].addObject(l,this._map.project(l._cLatLng,t)),a.__parent=l,e.__parent=l;var _=l;for(n=t-1;n>h._zoom;n--)_=new this._markerCluster(this,n,_),r[n].addObject(_,this._map.project(a.getLatLng(),n));return h._addChild(_),this._removeFromGridUnclustered(a,t),void 0}s[t].addObject(e,i)}this._topClusterLevel._addChild(e),e.__parent=this._topClusterLevel},_refreshClustersIcons:function(){this._featureGroup.eachLayer(function(e){e instanceof L.MarkerCluster&&e._iconNeedsUpdate&&e._updateIcon()})},_enqueue:function(e){this._queue.push(e),this._queueTimeout||(this._queueTimeout=setTimeout(L.bind(this._processQueue,this),300))},_processQueue:function(){for(var e=0;e<this._queue.length;e++)this._queue[e].call(this);this._queue.length=0,clearTimeout(this._queueTimeout),this._queueTimeout=null},_mergeSplitClusters:function(){var e=Math.round(this._map._zoom);this._processQueue(),this._zoom<e&&this._currentShownBounds.intersects(this._getExpandedVisibleBounds())?(this._animationStart(),this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),this._zoom,this._getExpandedVisibleBounds()),this._animationZoomIn(this._zoom,e)):this._zoom>e?(this._animationStart(),this._animationZoomOut(this._zoom,e)):this._moveEnd()},_getExpandedVisibleBounds:function(){return this.options.removeOutsideVisibleBounds?L.Browser.mobile?this._checkBoundsMaxLat(this._map.getBounds()):this._checkBoundsMaxLat(this._map.getBounds().pad(1)):this._mapBoundsInfinite},_checkBoundsMaxLat:function(e){var t=this._maxLat;return t!==i&&(e.getNorth()>=t&&(e._northEast.lat=1/0),e.getSouth()<=-t&&(e._southWest.lat=-1/0)),e},_animationAddLayerNonAnimated:function(e,t){if(t===e)this._featureGroup.addLayer(e);else if(2===t._childCount){t._addToMap();var i=t.getAllChildMarkers();this._featureGroup.removeLayer(i[0]),this._featureGroup.removeLayer(i[1])}else t._updateIcon()},_extractNonGroupLayers:function(e,t){var i,n=e.getLayers(),r=0;for(t=t||[];r<n.length;r++)i=n[r],i instanceof L.LayerGroup?this._extractNonGroupLayers(i,t):t.push(i);return t},_overrideMarkerIcon:function(e){var t=e.options.icon=this.options.iconCreateFunction({getChildCount:function(){return 1},getAllChildMarkers:function(){return[e]}});return t}}),L.MarkerClusterGroup.include({_mapBoundsInfinite:new L.LatLngBounds(new L.LatLng(-1/0,-1/0),new L.LatLng(1/0,1/0))}),L.MarkerClusterGroup.include({_noAnimation:{_animationStart:function(){},_animationZoomIn:function(e,t){this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),e),this._topClusterLevel._recursivelyAddChildrenToMap(null,t,this._getExpandedVisibleBounds()),this.fire("animationend")},_animationZoomOut:function(e,t){this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),e),this._topClusterLevel._recursivelyAddChildrenToMap(null,t,this._getExpandedVisibleBounds()),this.fire("animationend")},_animationAddLayer:function(e,t){this._animationAddLayerNonAnimated(e,t)}},_withAnimation:{_animationStart:function(){this._map._mapPane.className+=" leaflet-cluster-anim",this._inZoomAnimation++},_animationZoomIn:function(e,t){var i,n=this._getExpandedVisibleBounds(),r=this._featureGroup,s=Math.floor(this._map.getMinZoom());this._ignoreMove=!0,this._topClusterLevel._recursively(n,e,s,function(s){var o,a=s._latlng,h=s._markers;for(n.contains(a)||(a=null),s._isSingleParent()&&e+1===t?(r.removeLayer(s),s._recursivelyAddChildrenToMap(null,t,n)):(s.clusterHide(),s._recursivelyAddChildrenToMap(a,t,n)),i=h.length-1;i>=0;i--)o=h[i],n.contains(o._latlng)||r.removeLayer(o)}),this._forceLayout(),this._topClusterLevel._recursivelyBecomeVisible(n,t),r.eachLayer(function(e){e instanceof L.MarkerCluster||!e._icon||e.clusterShow()}),this._topClusterLevel._recursively(n,e,t,function(e){e._recursivelyRestoreChildPositions(t)}),this._ignoreMove=!1,this._enqueue(function(){this._topClusterLevel._recursively(n,e,s,function(e){r.removeLayer(e),e.clusterShow()}),this._animationEnd()})},_animationZoomOut:function(e,t){this._animationZoomOutSingle(this._topClusterLevel,e-1,t),this._topClusterLevel._recursivelyAddChildrenToMap(null,t,this._getExpandedVisibleBounds()),this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),e,this._getExpandedVisibleBounds())},_animationAddLayer:function(e,t){var i=this,n=this._featureGroup;n.addLayer(e),t!==e&&(t._childCount>2?(t._updateIcon(),this._forceLayout(),this._animationStart(),e._setPos(this._map.latLngToLayerPoint(t.getLatLng())),e.clusterHide(),this._enqueue(function(){n.removeLayer(e),e.clusterShow(),i._animationEnd()})):(this._forceLayout(),i._animationStart(),i._animationZoomOutSingle(t,this._map.getMaxZoom(),this._zoom)))}},_animationZoomOutSingle:function(e,t,i){var n=this._getExpandedVisibleBounds(),r=Math.floor(this._map.getMinZoom());e._recursivelyAnimateChildrenInAndAddSelfToMap(n,r,t+1,i);var s=this;this._forceLayout(),e._recursivelyBecomeVisible(n,i),this._enqueue(function(){if(1===e._childCount){var o=e._markers[0];this._ignoreMove=!0,o.setLatLng(o.getLatLng()),this._ignoreMove=!1,o.clusterShow&&o.clusterShow()}else e._recursively(n,i,r,function(e){e._recursivelyRemoveChildrenFromMap(n,r,t+1)});s._animationEnd()})},_animationEnd:function(){this._map&&(this._map._mapPane.className=this._map._mapPane.className.replace(" leaflet-cluster-anim","")),this._inZoomAnimation--,this.fire("animationend")},_forceLayout:function(){L.Util.falseFn(t.body.offsetWidth)}}),L.markerClusterGroup=function(e){return new L.MarkerClusterGroup(e)},L.MarkerCluster=L.Marker.extend({initialize:function(e,t,i,n){L.Marker.prototype.initialize.call(this,i?i._cLatLng||i.getLatLng():new L.LatLng(0,0),{icon:this}),this._group=e,this._zoom=t,this._markers=[],this._childClusters=[],this._childCount=0,this._iconNeedsUpdate=!0,this._boundsNeedUpdate=!0,this._bounds=new L.LatLngBounds,i&&this._addChild(i),n&&this._addChild(n)},getAllChildMarkers:function(e){e=e||[];for(var t=this._childClusters.length-1;t>=0;t--)this._childClusters[t].getAllChildMarkers(e);for(var i=this._markers.length-1;i>=0;i--)e.push(this._markers[i]);return e},getChildCount:function(){return this._childCount},zoomToBounds:function(e){for(var t,i=this._childClusters.slice(),n=this._group._map,r=n.getBoundsZoom(this._bounds),s=this._zoom+1,o=n.getZoom();i.length>0&&r>s;){s++;var a=[];for(t=0;t<i.length;t++)a=a.concat(i[t]._childClusters);i=a}r>s?this._group._map.setView(this._latlng,s):o>=r?this._group._map.setView(this._latlng,o+1):this._group._map.fitBounds(this._bounds,e)},getBounds:function(){var e=new L.LatLngBounds;return e.extend(this._bounds),e},_updateIcon:function(){this._iconNeedsUpdate=!0,this._icon&&this.setIcon(this)},createIcon:function(){return this._iconNeedsUpdate&&(this._iconObj=this._group.options.iconCreateFunction(this),this._iconNeedsUpdate=!1),this._iconObj.createIcon()},createShadow:function(){return this._iconObj.createShadow()},_addChild:function(e,t){this._iconNeedsUpdate=!0,this._boundsNeedUpdate=!0,this._setClusterCenter(e),e instanceof L.MarkerCluster?(t||(this._childClusters.push(e),e.__parent=this),this._childCount+=e._childCount):(t||this._markers.push(e),this._childCount++),this.__parent&&this.__parent._addChild(e,!0)},_setClusterCenter:function(e){this._cLatLng||(this._cLatLng=e._cLatLng||e._latlng)},_resetBounds:function(){var e=this._bounds;e._southWest&&(e._southWest.lat=1/0,e._southWest.lng=1/0),e._northEast&&(e._northEast.lat=-1/0,e._northEast.lng=-1/0)},_recalculateBounds:function(){var e,t,i,n,r=this._markers,s=this._childClusters,o=0,a=0,h=this._childCount;if(0!==h){for(this._resetBounds(),e=0;e<r.length;e++)i=r[e]._latlng,this._bounds.extend(i),o+=i.lat,a+=i.lng;for(e=0;e<s.length;e++)t=s[e],t._boundsNeedUpdate&&t._recalculateBounds(),this._bounds.extend(t._bounds),i=t._wLatLng,n=t._childCount,o+=i.lat*n,a+=i.lng*n;this._latlng=this._wLatLng=new L.LatLng(o/h,a/h),this._boundsNeedUpdate=!1}},_addToMap:function(e){e&&(this._backupLatlng=this._latlng,this.setLatLng(e)),this._group._featureGroup.addLayer(this)},_recursivelyAnimateChildrenIn:function(e,t,i){this._recursively(e,this._group._map.getMinZoom(),i-1,function(e){var i,n,r=e._markers;for(i=r.length-1;i>=0;i--)n=r[i],n._icon&&(n._setPos(t),n.clusterHide())},function(e){var i,n,r=e._childClusters;for(i=r.length-1;i>=0;i--)n=r[i],n._icon&&(n._setPos(t),n.clusterHide())})},_recursivelyAnimateChildrenInAndAddSelfToMap:function(e,t,i,n){this._recursively(e,n,t,function(r){r._recursivelyAnimateChildrenIn(e,r._group._map.latLngToLayerPoint(r.getLatLng()).round(),i),r._isSingleParent()&&i-1===n?(r.clusterShow(),r._recursivelyRemoveChildrenFromMap(e,t,i)):r.clusterHide(),r._addToMap()})},_recursivelyBecomeVisible:function(e,t){this._recursively(e,this._group._map.getMinZoom(),t,null,function(e){e.clusterShow()})},_recursivelyAddChildrenToMap:function(e,t,i){this._recursively(i,this._group._map.getMinZoom()-1,t,function(n){if(t!==n._zoom)for(var r=n._markers.length-1;r>=0;r--){var s=n._markers[r];i.contains(s._latlng)&&(e&&(s._backupLatlng=s.getLatLng(),s.setLatLng(e),s.clusterHide&&s.clusterHide()),n._group._featureGroup.addLayer(s))}},function(t){t._addToMap(e)})},_recursivelyRestoreChildPositions:function(e){for(var t=this._markers.length-1;t>=0;t--){var i=this._markers[t];i._backupLatlng&&(i.setLatLng(i._backupLatlng),delete i._backupLatlng)}if(e-1===this._zoom)for(var n=this._childClusters.length-1;n>=0;n--)this._childClusters[n]._restorePosition();else for(var r=this._childClusters.length-1;r>=0;r--)this._childClusters[r]._recursivelyRestoreChildPositions(e)},_restorePosition:function(){this._backupLatlng&&(this.setLatLng(this._backupLatlng),delete this._backupLatlng)},_recursivelyRemoveChildrenFromMap:function(e,t,i,n){var r,s;this._recursively(e,t-1,i-1,function(e){for(s=e._markers.length-1;s>=0;s--)r=e._markers[s],n&&n.contains(r._latlng)||(e._group._featureGroup.removeLayer(r),r.clusterShow&&r.clusterShow())},function(e){for(s=e._childClusters.length-1;s>=0;s--)r=e._childClusters[s],n&&n.contains(r._latlng)||(e._group._featureGroup.removeLayer(r),r.clusterShow&&r.clusterShow())})},_recursively:function(e,t,i,n,r){var s,o,a=this._childClusters,h=this._zoom;if(h>=t&&(n&&n(this),r&&h===i&&r(this)),t>h||i>h)for(s=a.length-1;s>=0;s--)o=a[s],e.intersects(o._bounds)&&o._recursively(e,t,i,n,r)},_isSingleParent:function(){return this._childClusters.length>0&&this._childClusters[0]._childCount===this._childCount}}),L.Marker.include({clusterHide:function(){return this.options.opacityWhenUnclustered=this.options.opacity||1,this.setOpacity(0)},clusterShow:function(){var e=this.setOpacity(this.options.opacity||this.options.opacityWhenUnclustered);return delete this.options.opacityWhenUnclustered,e}}),L.DistanceGrid=function(e){this._cellSize=e,this._sqCellSize=e*e,this._grid={},this._objectPoint={}},L.DistanceGrid.prototype={addObject:function(e,t){var i=this._getCoord(t.x),n=this._getCoord(t.y),r=this._grid,s=r[n]=r[n]||{},o=s[i]=s[i]||[],a=L.Util.stamp(e);this._objectPoint[a]=t,o.push(e)},updateObject:function(e,t){this.removeObject(e),this.addObject(e,t)},removeObject:function(e,t){var i,n,r=this._getCoord(t.x),s=this._getCoord(t.y),o=this._grid,a=o[s]=o[s]||{},h=a[r]=a[r]||[];for(delete this._objectPoint[L.Util.stamp(e)],i=0,n=h.length;n>i;i++)if(h[i]===e)return h.splice(i,1),1===n&&delete a[r],!0},eachObject:function(e,t){var i,n,r,s,o,a,h,l=this._grid;for(i in l){o=l[i];for(n in o)for(a=o[n],r=0,s=a.length;s>r;r++)h=e.call(t,a[r]),h&&(r--,s--)}},getNearObject:function(e){var t,i,n,r,s,o,a,h,l=this._getCoord(e.x),_=this._getCoord(e.y),u=this._objectPoint,d=this._sqCellSize,c=null;for(t=_-1;_+1>=t;t++)if(r=this._grid[t])for(i=l-1;l+1>=i;i++)if(s=r[i])for(n=0,o=s.length;o>n;n++)a=s[n],h=this._sqDist(u[L.Util.stamp(a)],e),d>h&&(d=h,c=a);return c},_getCoord:function(e){return Math.floor(e/this._cellSize)},_sqDist:function(e,t){var i=t.x-e.x,n=t.y-e.y;return i*i+n*n}},function(){L.QuickHull={getDistant:function(e,t){var i=t[1].lat-t[0].lat,n=t[0].lng-t[1].lng;return n*(e.lat-t[0].lat)+i*(e.lng-t[0].lng)},findMostDistantPointFromBaseLine:function(e,t){var i,n,r,s=0,o=null,a=[];for(i=t.length-1;i>=0;i--)n=t[i],r=this.getDistant(n,e),r>0&&(a.push(n),r>s&&(s=r,o=n));return{maxPoint:o,newPoints:a}},buildConvexHull:function(e,t){var i=[],n=this.findMostDistantPointFromBaseLine(e,t);return n.maxPoint?(i=i.concat(this.buildConvexHull([e[0],n.maxPoint],n.newPoints)),i=i.concat(this.buildConvexHull([n.maxPoint,e[1]],n.newPoints))):[e[0]]},getConvexHull:function(e){var t,i=!1,n=!1,r=!1,s=!1,o=null,a=null,h=null,l=null,_=null,u=null;for(t=e.length-1;t>=0;t--){var d=e[t];(i===!1||d.lat>i)&&(o=d,i=d.lat),(n===!1||d.lat<n)&&(a=d,n=d.lat),(r===!1||d.lng>r)&&(h=d,r=d.lng),(s===!1||d.lng<s)&&(l=d,s=d.lng)}n!==i?(u=a,_=o):(u=l,_=h);var c=[].concat(this.buildConvexHull([u,_],e),this.buildConvexHull([_,u],e));return c}}}(),L.MarkerCluster.include({getConvexHull:function(){var e,t,i=this.getAllChildMarkers(),n=[];for(t=i.length-1;t>=0;t--)e=i[t].getLatLng(),n.push(e);return L.QuickHull.getConvexHull(n)}}),L.MarkerCluster.include({_2PI:2*Math.PI,_circleFootSeparation:25,_circleStartAngle:Math.PI/6,_spiralFootSeparation:28,_spiralLengthStart:11,_spiralLengthFactor:5,_circleSpiralSwitchover:9,spiderfy:function(){if(this._group._spiderfied!==this&&!this._group._inZoomAnimation){var e,t=this.getAllChildMarkers(),i=this._group,n=i._map,r=n.latLngToLayerPoint(this._latlng);this._group._unspiderfy(),this._group._spiderfied=this,t.length>=this._circleSpiralSwitchover?e=this._generatePointsSpiral(t.length,r):(r.y+=10,e=this._generatePointsCircle(t.length,r)),this._animationSpiderfy(t,e)}},unspiderfy:function(e){this._group._inZoomAnimation||(this._animationUnspiderfy(e),this._group._spiderfied=null)},_generatePointsCircle:function(e,t){var i,n,r=this._group.options.spiderfyDistanceMultiplier*this._circleFootSeparation*(2+e),s=r/this._2PI,o=this._2PI/e,a=[];for(a.length=e,i=e-1;i>=0;i--)n=this._circleStartAngle+i*o,a[i]=new L.Point(t.x+s*Math.cos(n),t.y+s*Math.sin(n))._round();return a},_generatePointsSpiral:function(e,t){var i,n=this._group.options.spiderfyDistanceMultiplier,r=n*this._spiralLengthStart,s=n*this._spiralFootSeparation,o=n*this._spiralLengthFactor*this._2PI,a=0,h=[];for(h.length=e,i=e-1;i>=0;i--)a+=s/r+5e-4*i,h[i]=new L.Point(t.x+r*Math.cos(a),t.y+r*Math.sin(a))._round(),r+=o/a;return h},_noanimationUnspiderfy:function(){var e,t,i=this._group,n=i._map,r=i._featureGroup,s=this.getAllChildMarkers();for(i._ignoreMove=!0,this.setOpacity(1),t=s.length-1;t>=0;t--)e=s[t],r.removeLayer(e),e._preSpiderfyLatlng&&(e.setLatLng(e._preSpiderfyLatlng),delete e._preSpiderfyLatlng),e.setZIndexOffset&&e.setZIndexOffset(0),e._spiderLeg&&(n.removeLayer(e._spiderLeg),delete e._spiderLeg);i.fire("unspiderfied",{cluster:this,markers:s}),i._ignoreMove=!1,i._spiderfied=null}}),L.MarkerClusterNonAnimated=L.MarkerCluster.extend({_animationSpiderfy:function(e,t){var i,n,r,s,o=this._group,a=o._map,h=o._featureGroup,l=this._group.options.spiderLegPolylineOptions;for(o._ignoreMove=!0,i=0;i<e.length;i++)s=a.layerPointToLatLng(t[i]),n=e[i],r=new L.Polyline([this._latlng,s],l),a.addLayer(r),n._spiderLeg=r,n._preSpiderfyLatlng=n._latlng,n.setLatLng(s),n.setZIndexOffset&&n.setZIndexOffset(1e6),h.addLayer(n);this.setOpacity(.3),o._ignoreMove=!1,o.fire("spiderfied",{cluster:this,markers:e})},_animationUnspiderfy:function(){this._noanimationUnspiderfy()}}),L.MarkerCluster.include({_animationSpiderfy:function(e,t){var n,r,s,o,a,h,l=this,_=this._group,u=_._map,d=_._featureGroup,c=this._latlng,p=u.latLngToLayerPoint(c),f=L.Path.SVG,m=L.extend({},this._group.options.spiderLegPolylineOptions),g=m.opacity;for(g===i&&(g=L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity),f?(m.opacity=0,m.className=(m.className||"")+" leaflet-cluster-spider-leg"):m.opacity=g,_._ignoreMove=!0,n=0;n<e.length;n++)r=e[n],h=u.layerPointToLatLng(t[n]),s=new L.Polyline([c,h],m),u.addLayer(s),r._spiderLeg=s,f&&(o=s._path,a=o.getTotalLength()+.1,o.style.strokeDasharray=a,o.style.strokeDashoffset=a),r.setZIndexOffset&&r.setZIndexOffset(1e6),r.clusterHide&&r.clusterHide(),d.addLayer(r),r._setPos&&r._setPos(p);for(_._forceLayout(),_._animationStart(),n=e.length-1;n>=0;n--)h=u.layerPointToLatLng(t[n]),r=e[n],r._preSpiderfyLatlng=r._latlng,r.setLatLng(h),r.clusterShow&&r.clusterShow(),f&&(s=r._spiderLeg,o=s._path,o.style.strokeDashoffset=0,s.setStyle({opacity:g}));this.setOpacity(.3),_._ignoreMove=!1,setTimeout(function(){_._animationEnd(),_.fire("spiderfied",{cluster:l,markers:e})},200)},_animationUnspiderfy:function(e){var t,i,n,r,s,o,a=this,h=this._group,l=h._map,_=h._featureGroup,u=e?l._latLngToNewLayerPoint(this._latlng,e.zoom,e.center):l.latLngToLayerPoint(this._latlng),d=this.getAllChildMarkers(),c=L.Path.SVG;for(h._ignoreMove=!0,h._animationStart(),this.setOpacity(1),i=d.length-1;i>=0;i--)t=d[i],t._preSpiderfyLatlng&&(t.closePopup(),t.setLatLng(t._preSpiderfyLatlng),delete t._preSpiderfyLatlng,o=!0,t._setPos&&(t._setPos(u),o=!1),t.clusterHide&&(t.clusterHide(),o=!1),o&&_.removeLayer(t),c&&(n=t._spiderLeg,r=n._path,s=r.getTotalLength()+.1,r.style.strokeDashoffset=s,n.setStyle({opacity:0})));h._ignoreMove=!1,setTimeout(function(){var e=0;for(i=d.length-1;i>=0;i--)t=d[i],t._spiderLeg&&e++;for(i=d.length-1;i>=0;i--)t=d[i],t._spiderLeg&&(t.clusterShow&&t.clusterShow(),t.setZIndexOffset&&t.setZIndexOffset(0),e>1&&_.removeLayer(t),l.removeLayer(t._spiderLeg),delete t._spiderLeg);h._animationEnd(),h.fire("unspiderfied",{cluster:a,markers:d})},200)}}),L.MarkerClusterGroup.include({_spiderfied:null,unspiderfy:function(){this._unspiderfy.apply(this,arguments)},_spiderfierOnAdd:function(){this._map.on("click",this._unspiderfyWrapper,this),this._map.options.zoomAnimation&&this._map.on("zoomstart",this._unspiderfyZoomStart,this),this._map.on("zoomend",this._noanimationUnspiderfy,this),L.Browser.touch||this._map.getRenderer(this)},_spiderfierOnRemove:function(){this._map.off("click",this._unspiderfyWrapper,this),this._map.off("zoomstart",this._unspiderfyZoomStart,this),this._map.off("zoomanim",this._unspiderfyZoomAnim,this),this._map.off("zoomend",this._noanimationUnspiderfy,this),this._noanimationUnspiderfy()},_unspiderfyZoomStart:function(){this._map&&this._map.on("zoomanim",this._unspiderfyZoomAnim,this)},_unspiderfyZoomAnim:function(e){L.DomUtil.hasClass(this._map._mapPane,"leaflet-touching")||(this._map.off("zoomanim",this._unspiderfyZoomAnim,this),this._unspiderfy(e))},_unspiderfyWrapper:function(){this._unspiderfy()},_unspiderfy:function(e){this._spiderfied&&this._spiderfied.unspiderfy(e)
	},_noanimationUnspiderfy:function(){this._spiderfied&&this._spiderfied._noanimationUnspiderfy()},_unspiderfyLayer:function(e){e._spiderLeg&&(this._featureGroup.removeLayer(e),e.clusterShow&&e.clusterShow(),e.setZIndexOffset&&e.setZIndexOffset(0),this._map.removeLayer(e._spiderLeg),delete e._spiderLeg)}}),L.MarkerClusterGroup.include({refreshClusters:function(e){return e?e instanceof L.MarkerClusterGroup?e=e._topClusterLevel.getAllChildMarkers():e instanceof L.LayerGroup?e=e._layers:e instanceof L.MarkerCluster?e=e.getAllChildMarkers():e instanceof L.Marker&&(e=[e]):e=this._topClusterLevel.getAllChildMarkers(),this._flagParentsIconsNeedUpdate(e),this._refreshClustersIcons(),this.options.singleMarkerMode&&this._refreshSingleMarkerModeMarkers(e),this},_flagParentsIconsNeedUpdate:function(e){var t,i;for(t in e)for(i=e[t].__parent;i;)i._iconNeedsUpdate=!0,i=i.__parent},_refreshSingleMarkerModeMarkers:function(e){var t,i;for(t in e)i=e[t],this.hasLayer(i)&&i.setIcon(this._overrideMarkerIcon(i))}}),L.Marker.include({refreshIconOptions:function(e,t){var i=this.options.icon;return L.setOptions(i,e),this.setIcon(i),t&&this.__parent&&this.__parent._group.refreshClusters(this),this}})}(window,document);

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(52),
	    root = __webpack_require__(33);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(905),
	    hashDelete = __webpack_require__(906),
	    hashGet = __webpack_require__(907),
	    hashHas = __webpack_require__(908),
	    hashSet = __webpack_require__(909);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(52),
	    root = __webpack_require__(33);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(52),
	    root = __webpack_require__(33);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(156),
	    setCacheAdd = __webpack_require__(933),
	    setCacheHas = __webpack_require__(934);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(52),
	    root = __webpack_require__(33);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 849 */
/***/ (function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ }),
/* 850 */
/***/ (function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ }),
/* 851 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 852 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 853 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(84),
	    keys = __webpack_require__(69);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(84),
	    keysIn = __webpack_require__(298);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(158),
	    isFlattenable = __webpack_require__(913);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(897);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(858),
	    keys = __webpack_require__(69);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 860 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(65),
	    isObjectLike = __webpack_require__(68);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(157),
	    equalArrays = __webpack_require__(280),
	    equalByTag = __webpack_require__(899),
	    equalObjects = __webpack_require__(900),
	    getTag = __webpack_require__(286),
	    isArray = __webpack_require__(27),
	    isBuffer = __webpack_require__(172),
	    isTypedArray = __webpack_require__(297);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(157),
	    baseIsEqual = __webpack_require__(161);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(173),
	    isMasked = __webpack_require__(915),
	    isObject = __webpack_require__(36),
	    toSource = __webpack_require__(292);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(65),
	    isLength = __webpack_require__(174),
	    isObjectLike = __webpack_require__(68);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(869),
	    baseMatchesProperty = __webpack_require__(870),
	    identity = __webpack_require__(169),
	    isArray = __webpack_require__(27),
	    property = __webpack_require__(952);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(167),
	    nativeKeys = __webpack_require__(927);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36),
	    isPrototype = __webpack_require__(167),
	    nativeKeysIn = __webpack_require__(928);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(863),
	    getMatchData = __webpack_require__(901),
	    matchesStrictComparable = __webpack_require__(289);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(161),
	    get = __webpack_require__(294),
	    hasIn = __webpack_require__(295),
	    isKey = __webpack_require__(166),
	    isStrictComparable = __webpack_require__(287),
	    matchesStrictComparable = __webpack_require__(289),
	    toKey = __webpack_require__(67);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(872),
	    hasIn = __webpack_require__(295);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(105),
	    baseSet = __webpack_require__(876),
	    castPath = __webpack_require__(66);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ }),
/* 873 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(105);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 875 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(160),
	    castPath = __webpack_require__(66),
	    isIndex = __webpack_require__(165),
	    isObject = __webpack_require__(36),
	    toKey = __webpack_require__(67);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(944),
	    defineProperty = __webpack_require__(279),
	    identity = __webpack_require__(169);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 878 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 879 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(64),
	    arrayMap = __webpack_require__(274),
	    isArray = __webpack_require__(27),
	    isSymbol = __webpack_require__(108);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 881 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(66),
	    last = __webpack_require__(948),
	    parent = __webpack_require__(932),
	    toKey = __webpack_require__(67);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ }),
/* 883 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(169);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(33);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119)(module)))

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(162);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(849),
	    arrayReduce = __webpack_require__(159),
	    mapToArray = __webpack_require__(288);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ }),
/* 888 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(850),
	    arrayReduce = __webpack_require__(159),
	    setToArray = __webpack_require__(291);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(64);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(162);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 892 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(84),
	    getSymbols = __webpack_require__(164);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(84),
	    getSymbolsIn = __webpack_require__(285);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(33);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(171);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 897 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(946);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(64),
	    Uint8Array = __webpack_require__(271),
	    eq = __webpack_require__(168),
	    equalArrays = __webpack_require__(280),
	    mapToArray = __webpack_require__(288),
	    setToArray = __webpack_require__(291);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(283);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(287),
	    keys = __webpack_require__(69);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(64);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 903 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(66),
	    isArguments = __webpack_require__(170),
	    isArray = __webpack_require__(27),
	    isIndex = __webpack_require__(165),
	    isLength = __webpack_require__(174),
	    toKey = __webpack_require__(67);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(107);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 906 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(107);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(107);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(107);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 910 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(162),
	    cloneDataView = __webpack_require__(886),
	    cloneMap = __webpack_require__(887),
	    cloneRegExp = __webpack_require__(888),
	    cloneSet = __webpack_require__(889),
	    cloneSymbol = __webpack_require__(890),
	    cloneTypedArray = __webpack_require__(891);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(856),
	    getPrototype = __webpack_require__(163),
	    isPrototype = __webpack_require__(167);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(64),
	    isArguments = __webpack_require__(170),
	    isArray = __webpack_require__(27);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 914 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(895);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 916 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(104);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(104);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(104);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(104);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(844),
	    ListCache = __webpack_require__(103),
	    Map = __webpack_require__(155);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(106);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(106);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(106);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(106);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(949);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(290);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 928 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(282);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119)(module)))

/***/ }),
/* 930 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(851);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(105),
	    baseSlice = __webpack_require__(878);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ }),
/* 933 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 934 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(877),
	    shortOut = __webpack_require__(936);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 936 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(103);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 938 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 939 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 940 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(103),
	    Map = __webpack_require__(155),
	    MapCache = __webpack_require__(156);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(926);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(276);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = clone;


/***/ }),
/* 944 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(857);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(65),
	    getPrototype = __webpack_require__(163),
	    isObjectLike = __webpack_require__(68);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 947 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ }),
/* 948 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(156);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(33);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(871),
	    flatRest = __webpack_require__(281);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(873),
	    basePropertyDeep = __webpack_require__(874),
	    isKey = __webpack_require__(166),
	    toKey = __webpack_require__(67);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(159),
	    baseEach = __webpack_require__(277),
	    baseIteratee = __webpack_require__(866),
	    baseReduce = __webpack_require__(875),
	    isArray = __webpack_require__(27);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ }),
/* 954 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36),
	    isSymbol = __webpack_require__(108);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(301);
	
	/** Used to generate unique IDs. */
	var idCounter = 0;
	
	/**
	 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {string} [prefix=''] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return toString(prefix) + id;
	}
	
	module.exports = uniqueId;


/***/ }),
/* 957 */
/***/ (function(module, exports) {

	/*! npm.im/object-fit-images 3.2.4 */
	'use strict';
	
	var OFI = 'bfred-it:object-fit-images';
	var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
	var testImg = typeof Image === 'undefined' ? {style: {'object-position': 1}} : new Image();
	var supportsObjectFit = 'object-fit' in testImg.style;
	var supportsObjectPosition = 'object-position' in testImg.style;
	var supportsOFI = 'background-size' in testImg.style;
	var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
	var nativeGetAttribute = testImg.getAttribute;
	var nativeSetAttribute = testImg.setAttribute;
	var autoModeEnabled = false;
	
	function createPlaceholder(w, h) {
		return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
	}
	
	function polyfillCurrentSrc(el) {
		if (el.srcset && !supportsCurrentSrc && window.picturefill) {
			var pf = window.picturefill._;
			// parse srcset with picturefill where currentSrc isn't available
			if (!el[pf.ns] || !el[pf.ns].evaled) {
				// force synchronous srcset parsing
				pf.fillImg(el, {reselect: true});
			}
	
			if (!el[pf.ns].curSrc) {
				// force picturefill to parse srcset
				el[pf.ns].supported = false;
				pf.fillImg(el, {reselect: true});
			}
	
			// retrieve parsed currentSrc, if any
			el.currentSrc = el[pf.ns].curSrc || el.src;
		}
	}
	
	function getStyle(el) {
		var style = getComputedStyle(el).fontFamily;
		var parsed;
		var props = {};
		while ((parsed = propRegex.exec(style)) !== null) {
			props[parsed[1]] = parsed[2];
		}
		return props;
	}
	
	function setPlaceholder(img, width, height) {
		// Default: fill width, no height
		var placeholder = createPlaceholder(width || 1, height || 0);
	
		// Only set placeholder if it's different
		if (nativeGetAttribute.call(img, 'src') !== placeholder) {
			nativeSetAttribute.call(img, 'src', placeholder);
		}
	}
	
	function onImageReady(img, callback) {
		// naturalWidth is only available when the image headers are loaded,
		// this loop will poll it every 100ms.
		if (img.naturalWidth) {
			callback(img);
		} else {
			setTimeout(onImageReady, 100, img, callback);
		}
	}
	
	function fixOne(el) {
		var style = getStyle(el);
		var ofi = el[OFI];
		style['object-fit'] = style['object-fit'] || 'fill'; // default value
	
		// Avoid running where unnecessary, unless OFI had already done its deed
		if (!ofi.img) {
			// fill is the default behavior so no action is necessary
			if (style['object-fit'] === 'fill') {
				return;
			}
	
			// Where object-fit is supported and object-position isn't (Safari < 10)
			if (
				!ofi.skipTest && // unless user wants to apply regardless of browser support
				supportsObjectFit && // if browser already supports object-fit
				!style['object-position'] // unless object-position is used
			) {
				return;
			}
		}
	
		// keep a clone in memory while resetting the original to a blank
		if (!ofi.img) {
			ofi.img = new Image(el.width, el.height);
			ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
			ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;
	
			// preserve for any future cloneNode calls
			// https://github.com/bfred-it/object-fit-images/issues/53
			nativeSetAttribute.call(el, "data-ofi-src", el.src);
			if (el.srcset) {
				nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
			}
	
			setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);
	
			// remove srcset because it overrides src
			if (el.srcset) {
				el.srcset = '';
			}
			try {
				keepSrcUsable(el);
			} catch (err) {
				if (window.console) {
					console.warn('https://bit.ly/ofi-old-browser');
				}
			}
		}
	
		polyfillCurrentSrc(ofi.img);
	
		el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
		el.style.backgroundPosition = style['object-position'] || 'center';
		el.style.backgroundRepeat = 'no-repeat';
		el.style.backgroundOrigin = 'content-box';
	
		if (/scale-down/.test(style['object-fit'])) {
			onImageReady(ofi.img, function () {
				if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
					el.style.backgroundSize = 'contain';
				} else {
					el.style.backgroundSize = 'auto';
				}
			});
		} else {
			el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
		}
	
		onImageReady(ofi.img, function (img) {
			setPlaceholder(el, img.naturalWidth, img.naturalHeight);
		});
	}
	
	function keepSrcUsable(el) {
		var descriptors = {
			get: function get(prop) {
				return el[OFI].img[prop ? prop : 'src'];
			},
			set: function set(value, prop) {
				el[OFI].img[prop ? prop : 'src'] = value;
				nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
				fixOne(el);
				return value;
			}
		};
		Object.defineProperty(el, 'src', descriptors);
		Object.defineProperty(el, 'currentSrc', {
			get: function () { return descriptors.get('currentSrc'); }
		});
		Object.defineProperty(el, 'srcset', {
			get: function () { return descriptors.get('srcset'); },
			set: function (ss) { return descriptors.set(ss, 'srcset'); }
		});
	}
	
	function hijackAttributes() {
		function getOfiImageMaybe(el, name) {
			return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
		}
		if (!supportsObjectPosition) {
			HTMLImageElement.prototype.getAttribute = function (name) {
				return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
			};
	
			HTMLImageElement.prototype.setAttribute = function (name, value) {
				return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
			};
		}
	}
	
	function fix(imgs, opts) {
		var startAutoMode = !autoModeEnabled && !imgs;
		opts = opts || {};
		imgs = imgs || 'img';
	
		if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
			return false;
		}
	
		// use imgs as a selector or just select all images
		if (imgs === 'img') {
			imgs = document.getElementsByTagName('img');
		} else if (typeof imgs === 'string') {
			imgs = document.querySelectorAll(imgs);
		} else if (!('length' in imgs)) {
			imgs = [imgs];
		}
	
		// apply fix to all
		for (var i = 0; i < imgs.length; i++) {
			imgs[i][OFI] = imgs[i][OFI] || {
				skipTest: opts.skipTest
			};
			fixOne(imgs[i]);
		}
	
		if (startAutoMode) {
			document.body.addEventListener('load', function (e) {
				if (e.target.tagName === 'IMG') {
					fix(e.target, {
						skipTest: opts.skipTest
					});
				}
			}, true);
			autoModeEnabled = true;
			imgs = 'img'; // reset to a generic selector for watchMQ
		}
	
		// if requested, watch media queries for object-fit change
		if (opts.watchMQ) {
			window.addEventListener('resize', fix.bind(null, imgs, {
				skipTest: opts.skipTest
			}));
		}
	}
	
	fix.supportsObjectFit = supportsObjectFit;
	fix.supportsObjectPosition = supportsObjectPosition;
	
	hijackAttributes();
	
	module.exports = fix;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 * Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
	 * License: MIT - http://mrgnrdrck.mit-license.org
	 *
	 * https://github.com/mroderick/PubSubJS
	 */
	
	(function (root, factory){
	    'use strict';
	
	    var PubSub = {};
	
	    if (root.PubSub) {
	        PubSub = root.PubSub;
	        console.warn("PubSub already loaded, using existing version");
	    } else {
	        root.PubSub = PubSub;
	        factory(PubSub);
	    }
	    // CommonJS and Node.js module support
	    if (true){
	        if (module !== undefined && module.exports) {
	            exports = module.exports = PubSub; // Node.js specific `module.exports`
	        }
	        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
	        module.exports = exports = PubSub; // CommonJS
	    }
	    // AMD support
	    /* eslint-disable no-undef */
	    else if (typeof define === 'function' && define.amd){
	        define(function() { return PubSub; });
	        /* eslint-enable no-undef */
	    }
	
	}(( typeof window === 'object' && window ) || this, function (PubSub){
	    'use strict';
	
	    var messages = {},
	        lastUid = -1,
	        ALL_SUBSCRIBING_MSG = '*';
	
	    function hasKeys(obj){
	        var key;
	
	        for (key in obj){
	            if ( Object.prototype.hasOwnProperty.call(obj, key) ){
	                return true;
	            }
	        }
	        return false;
	    }
	
	    /**
	     * Returns a function that throws the passed exception, for use as argument for setTimeout
	     * @alias throwException
	     * @function
	     * @param { Object } ex An Error object
	     */
	    function throwException( ex ){
	        return function reThrowException(){
	            throw ex;
	        };
	    }
	
	    function callSubscriberWithDelayedExceptions( subscriber, message, data ){
	        try {
	            subscriber( message, data );
	        } catch( ex ){
	            setTimeout( throwException( ex ), 0);
	        }
	    }
	
	    function callSubscriberWithImmediateExceptions( subscriber, message, data ){
	        subscriber( message, data );
	    }
	
	    function deliverMessage( originalMessage, matchedMessage, data, immediateExceptions ){
	        var subscribers = messages[matchedMessage],
	            callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions,
	            s;
	
	        if ( !Object.prototype.hasOwnProperty.call( messages, matchedMessage ) ) {
	            return;
	        }
	
	        for (s in subscribers){
	            if ( Object.prototype.hasOwnProperty.call(subscribers, s)){
	                callSubscriber( subscribers[s], originalMessage, data );
	            }
	        }
	    }
	
	    function createDeliveryFunction( message, data, immediateExceptions ){
	        return function deliverNamespaced(){
	            var topic = String( message ),
	                position = topic.lastIndexOf( '.' );
	
	            // deliver the message as it is now
	            deliverMessage(message, message, data, immediateExceptions);
	
	            // trim the hierarchy and deliver message to each level
	            while( position !== -1 ){
	                topic = topic.substr( 0, position );
	                position = topic.lastIndexOf('.');
	                deliverMessage( message, topic, data, immediateExceptions );
	            }
	
	            deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
	        };
	    }
	
	    function hasDirectSubscribersFor( message ) {
	        var topic = String( message ),
	            found = Boolean(Object.prototype.hasOwnProperty.call( messages, topic ) && hasKeys(messages[topic]));
	
	        return found;
	    }
	
	    function messageHasSubscribers( message ){
	        var topic = String( message ),
	            found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG),
	            position = topic.lastIndexOf( '.' );
	
	        while ( !found && position !== -1 ){
	            topic = topic.substr( 0, position );
	            position = topic.lastIndexOf( '.' );
	            found = hasDirectSubscribersFor(topic);
	        }
	
	        return found;
	    }
	
	    function publish( message, data, sync, immediateExceptions ){
	        message = (typeof message === 'symbol') ? message.toString() : message;
	
	        var deliver = createDeliveryFunction( message, data, immediateExceptions ),
	            hasSubscribers = messageHasSubscribers( message );
	
	        if ( !hasSubscribers ){
	            return false;
	        }
	
	        if ( sync === true ){
	            deliver();
	        } else {
	            setTimeout( deliver, 0 );
	        }
	        return true;
	    }
	
	    /**
	     * Publishes the message, passing the data to it's subscribers
	     * @function
	     * @alias publish
	     * @param { String } message The message to publish
	     * @param {} data The data to pass to subscribers
	     * @return { Boolean }
	     */
	    PubSub.publish = function( message, data ){
	        return publish( message, data, false, PubSub.immediateExceptions );
	    };
	
	    /**
	     * Publishes the message synchronously, passing the data to it's subscribers
	     * @function
	     * @alias publishSync
	     * @param { String } message The message to publish
	     * @param {} data The data to pass to subscribers
	     * @return { Boolean }
	     */
	    PubSub.publishSync = function( message, data ){
	        return publish( message, data, true, PubSub.immediateExceptions );
	    };
	
	    /**
	     * Subscribes the passed function to the passed message. Every returned token is unique and should be stored if you need to unsubscribe
	     * @function
	     * @alias subscribe
	     * @param { String } message The message to subscribe to
	     * @param { Function } func The function to call when a new message is published
	     * @return { String }
	     */
	    PubSub.subscribe = function( message, func ){
	        if ( typeof func !== 'function'){
	            return false;
	        }
	
	        message = (typeof message === 'symbol') ? message.toString() : message;
	
	        // message is not registered yet
	        if ( !Object.prototype.hasOwnProperty.call( messages, message ) ){
	            messages[message] = {};
	        }
	
	        // forcing token as String, to allow for future expansions without breaking usage
	        // and allow for easy use as key names for the 'messages' object
	        var token = 'uid_' + String(++lastUid);
	        messages[message][token] = func;
	
	        // return token for unsubscribing
	        return token;
	    };
	
	    PubSub.subscribeAll = function( func ){
	        return PubSub.subscribe(ALL_SUBSCRIBING_MSG, func);
	    };
	
	    /**
	     * Subscribes the passed function to the passed message once
	     * @function
	     * @alias subscribeOnce
	     * @param { String } message The message to subscribe to
	     * @param { Function } func The function to call when a new message is published
	     * @return { PubSub }
	     */
	    PubSub.subscribeOnce = function( message, func ){
	        var token = PubSub.subscribe( message, function(){
	            // before func apply, unsubscribe message
	            PubSub.unsubscribe( token );
	            func.apply( this, arguments );
	        });
	        return PubSub;
	    };
	
	    /**
	     * Clears all subscriptions
	     * @function
	     * @public
	     * @alias clearAllSubscriptions
	     */
	    PubSub.clearAllSubscriptions = function clearAllSubscriptions(){
	        messages = {};
	    };
	
	    /**
	     * Clear subscriptions by the topic
	     * @function
	     * @public
	     * @alias clearAllSubscriptions
	     * @return { int }
	     */
	    PubSub.clearSubscriptions = function clearSubscriptions(topic){
	        var m;
	        for (m in messages){
	            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
	                delete messages[m];
	            }
	        }
	    };
	
	    /**
	       Count subscriptions by the topic
	     * @function
	     * @public
	     * @alias countSubscriptions
	     * @return { Array }
	    */
	    PubSub.countSubscriptions = function countSubscriptions(topic){
	        var m;
	        // eslint-disable-next-line no-unused-vars
	        var token;
	        var count = 0;
	        for (m in messages) {
	            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
	                for (token in messages[m]) {
	                    count++;
	                }
	                break;
	            }
	        }
	        return count;
	    };
	
	
	    /**
	       Gets subscriptions by the topic
	     * @function
	     * @public
	     * @alias getSubscriptions
	    */
	    PubSub.getSubscriptions = function getSubscriptions(topic){
	        var m;
	        var list = [];
	        for (m in messages){
	            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
	                list.push(m);
	            }
	        }
	        return list;
	    };
	
	    /**
	     * Removes subscriptions
	     *
	     * - When passed a token, removes a specific subscription.
	     *
		 * - When passed a function, removes all subscriptions for that function
	     *
		 * - When passed a topic, removes all subscriptions for that topic (hierarchy)
	     * @function
	     * @public
	     * @alias subscribeOnce
	     * @param { String | Function } value A token, function or topic to unsubscribe from
	     * @example // Unsubscribing with a token
	     * var token = PubSub.subscribe('mytopic', myFunc);
	     * PubSub.unsubscribe(token);
	     * @example // Unsubscribing with a function
	     * PubSub.unsubscribe(myFunc);
	     * @example // Unsubscribing from a topic
	     * PubSub.unsubscribe('mytopic');
	     */
	    PubSub.unsubscribe = function(value){
	        var descendantTopicExists = function(topic) {
	                var m;
	                for ( m in messages ){
	                    if ( Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0 ){
	                        // a descendant of the topic exists:
	                        return true;
	                    }
	                }
	
	                return false;
	            },
	            isTopic    = typeof value === 'string' && ( Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value) ),
	            isToken    = !isTopic && typeof value === 'string',
	            isFunction = typeof value === 'function',
	            result = false,
	            m, message, t;
	
	        if (isTopic){
	            PubSub.clearSubscriptions(value);
	            return;
	        }
	
	        for ( m in messages ){
	            if ( Object.prototype.hasOwnProperty.call( messages, m ) ){
	                message = messages[m];
	
	                if ( isToken && message[value] ){
	                    delete message[value];
	                    result = value;
	                    // tokens are unique, so we can just stop here
	                    break;
	                }
	
	                if (isFunction) {
	                    for ( t in message ){
	                        if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value){
	                            delete message[t];
	                            result = true;
	                        }
	                    }
	                }
	            }
	        }
	
	        return result;
	    };
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119)(module)))

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(85)))

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UnmountClosed = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnmountClosed = exports.UnmountClosed = function (_React$PureComponent) {
	  _inherits(UnmountClosed, _React$PureComponent);
	
	  function UnmountClosed(props) {
	    _classCallCheck(this, UnmountClosed);
	
	    var _this = _possibleConstructorReturn(this, (UnmountClosed.__proto__ || Object.getPrototypeOf(UnmountClosed)).call(this, props));
	
	    _this.componentWillReceiveProps = function (_ref) {
	      var isOpened = _ref.isOpened;
	
	      if (!_this.props.isOpened && isOpened) {
	        _this.setState({
	          forceInitialAnimation: true,
	          shouldUnmount: false
	        });
	      }
	    };
	
	    _this.onRest = function () {
	      var _this$props = _this.props,
	          isOpened = _this$props.isOpened,
	          onRest = _this$props.onRest;
	
	
	      if (!isOpened) {
	        _this.setState({ shouldUnmount: true });
	      }
	      if (onRest) {
	        onRest.apply(undefined, arguments);
	      }
	    };
	
	    _this.state = {
	      shouldUnmount: !_this.props.isOpened,
	      forceInitialAnimation: !_this.props.isOpened
	    };
	    return _this;
	  }
	
	  _createClass(UnmountClosed, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isOpened = _props.isOpened,
	          _onRest = _props.onRest,
	          props = _objectWithoutProperties(_props, ['isOpened', 'onRest']);
	
	      var _state = this.state,
	          forceInitialAnimation = _state.forceInitialAnimation,
	          shouldUnmount = _state.shouldUnmount;
	
	
	      return shouldUnmount ? null : _react2.default.createElement(_Collapse.Collapse, _extends({
	        forceInitialAnimation: forceInitialAnimation,
	        isOpened: isOpened,
	        onRest: this.onRest
	      }, props));
	    }
	  }]);
	
	  return UnmountClosed;
	}(_react2.default.PureComponent);
	
	UnmountClosed.propTypes = {
	  isOpened: _propTypes2.default.bool.isRequired,
	  onRest: _propTypes2.default.func
	};

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(302),
	    Collapse = _require.Collapse;
	
	var _require2 = __webpack_require__(960),
	    UnmountClosed = _require2.UnmountClosed;
	
	UnmountClosed.Collapse = Collapse;
	UnmountClosed.UnmountClosed = UnmountClosed;
	
	module.exports = UnmountClosed;

/***/ }),
/* 962 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(17);
	
	var focusNode = __webpack_require__(266);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(88);
	var ExecutionEnvironment = __webpack_require__(23);
	var FallbackCompositionState = __webpack_require__(970);
	var SyntheticCompositionEvent = __webpack_require__(1004);
	var SyntheticInputEvent = __webpack_require__(1007);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(303);
	var ExecutionEnvironment = __webpack_require__(23);
	var ReactInstrumentation = __webpack_require__(28);
	
	var camelizeStyleName = __webpack_require__(823);
	var dangerousStyleValue = __webpack_require__(1013);
	var hyphenateStyleName = __webpack_require__(830);
	var memoizeStringOnly = __webpack_require__(833);
	var warning = __webpack_require__(6);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(87);
	var EventPropagators = __webpack_require__(88);
	var ExecutionEnvironment = __webpack_require__(23);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactUpdates = __webpack_require__(34);
	var SyntheticEvent = __webpack_require__(39);
	
	var inputValueTracking = __webpack_require__(325);
	var getEventTarget = __webpack_require__(192);
	var isEventSupported = __webpack_require__(194);
	var isTextInputElement = __webpack_require__(326);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMLazyTree = __webpack_require__(71);
	var ExecutionEnvironment = __webpack_require__(23);
	
	var createNodesFromMarkup = __webpack_require__(826);
	var emptyFunction = __webpack_require__(19);
	var invariant = __webpack_require__(4);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 968 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(88);
	var ReactDOMComponentTree = __webpack_require__(17);
	var SyntheticMouseEvent = __webpack_require__(111);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var PooledClass = __webpack_require__(55);
	
	var getTextContentAccessor = __webpack_require__(324);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(72);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(56);
	
	var instantiateReactComponent = __webpack_require__(193);
	var KeyEscapeUtils = __webpack_require__(184);
	var shouldUpdateReactComponent = __webpack_require__(195);
	var traverseAllChildren = __webpack_require__(328);
	var warning = __webpack_require__(6);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(336);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(85)))

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(180);
	var ReactDOMIDOperations = __webpack_require__(979);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(15);
	
	var React = __webpack_require__(40);
	var ReactComponentEnvironment = __webpack_require__(186);
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactErrorUtils = __webpack_require__(187);
	var ReactInstanceMap = __webpack_require__(89);
	var ReactInstrumentation = __webpack_require__(28);
	var ReactNodeTypes = __webpack_require__(317);
	var ReactReconciler = __webpack_require__(56);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(43);
	var invariant = __webpack_require__(4);
	var shallowEqual = __webpack_require__(153);
	var shouldUpdateReactComponent = __webpack_require__(195);
	var warning = __webpack_require__(6);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactDefaultInjection = __webpack_require__(310);
	var ReactMount = __webpack_require__(316);
	var ReactReconciler = __webpack_require__(56);
	var ReactUpdates = __webpack_require__(34);
	var ReactVersion = __webpack_require__(319);
	
	var findDOMNode = __webpack_require__(1014);
	var getHostComponentFromComposite = __webpack_require__(323);
	var renderSubtreeIntoContainer = __webpack_require__(1021);
	var warning = __webpack_require__(6);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(15);
	
	var AutoFocusUtils = __webpack_require__(963);
	var CSSPropertyOperations = __webpack_require__(965);
	var DOMLazyTree = __webpack_require__(71);
	var DOMNamespaces = __webpack_require__(181);
	var DOMProperty = __webpack_require__(72);
	var DOMPropertyOperations = __webpack_require__(305);
	var EventPluginHub = __webpack_require__(87);
	var EventPluginRegistry = __webpack_require__(182);
	var ReactBrowserEventEmitter = __webpack_require__(110);
	var ReactDOMComponentFlags = __webpack_require__(306);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactDOMInput = __webpack_require__(980);
	var ReactDOMOption = __webpack_require__(981);
	var ReactDOMSelect = __webpack_require__(308);
	var ReactDOMTextarea = __webpack_require__(985);
	var ReactInstrumentation = __webpack_require__(28);
	var ReactMultiChild = __webpack_require__(991);
	var ReactServerRenderingTransaction = __webpack_require__(318);
	
	var emptyFunction = __webpack_require__(19);
	var escapeTextContentForBrowser = __webpack_require__(113);
	var invariant = __webpack_require__(4);
	var isEventSupported = __webpack_require__(194);
	var shallowEqual = __webpack_require__(153);
	var inputValueTracking = __webpack_require__(325);
	var validateDOMNesting = __webpack_require__(196);
	var warning = __webpack_require__(6);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var DOMLazyTree = __webpack_require__(71);
	var ReactDOMComponentTree = __webpack_require__(17);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 978 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(180);
	var ReactDOMComponentTree = __webpack_require__(17);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(15);
	
	var DOMPropertyOperations = __webpack_require__(305);
	var LinkedValueUtils = __webpack_require__(185);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactUpdates = __webpack_require__(34);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(6);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var React = __webpack_require__(40);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactDOMSelect = __webpack_require__(308);
	
	var warning = __webpack_require__(6);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(23);
	
	var getNodeForCharacterOffset = __webpack_require__(1018);
	var getTextContentAccessor = __webpack_require__(324);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(310);
	var ReactServerRendering = __webpack_require__(997);
	var ReactVersion = __webpack_require__(319);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(15);
	
	var DOMChildrenOperations = __webpack_require__(180);
	var DOMLazyTree = __webpack_require__(71);
	var ReactDOMComponentTree = __webpack_require__(17);
	
	var escapeTextContentForBrowser = __webpack_require__(113);
	var invariant = __webpack_require__(4);
	var validateDOMNesting = __webpack_require__(196);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(15);
	
	var LinkedValueUtils = __webpack_require__(185);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactUpdates = __webpack_require__(34);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(6);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 987 */
95,
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(87);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var EventListener = __webpack_require__(265);
	var ExecutionEnvironment = __webpack_require__(23);
	var PooledClass = __webpack_require__(55);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactUpdates = __webpack_require__(34);
	
	var getEventTarget = __webpack_require__(192);
	var getUnboundedScrollPosition = __webpack_require__(828);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(72);
	var EventPluginHub = __webpack_require__(87);
	var EventPluginUtils = __webpack_require__(183);
	var ReactComponentEnvironment = __webpack_require__(186);
	var ReactEmptyComponent = __webpack_require__(311);
	var ReactBrowserEventEmitter = __webpack_require__(110);
	var ReactHostComponent = __webpack_require__(313);
	var ReactUpdates = __webpack_require__(34);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactComponentEnvironment = __webpack_require__(186);
	var ReactInstanceMap = __webpack_require__(89);
	var ReactInstrumentation = __webpack_require__(28);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactReconciler = __webpack_require__(56);
	var ReactChildReconciler = __webpack_require__(972);
	
	var emptyFunction = __webpack_require__(19);
	var flattenChildren = __webpack_require__(1015);
	var invariant = __webpack_require__(4);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 993 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var CallbackQueue = __webpack_require__(304);
	var PooledClass = __webpack_require__(55);
	var ReactBrowserEventEmitter = __webpack_require__(110);
	var ReactInputSelection = __webpack_require__(314);
	var ReactInstrumentation = __webpack_require__(28);
	var Transaction = __webpack_require__(112);
	var ReactUpdateQueue = __webpack_require__(188);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(992);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 996 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var React = __webpack_require__(40);
	var ReactDOMContainerInfo = __webpack_require__(307);
	var ReactDefaultBatchingStrategy = __webpack_require__(309);
	var ReactInstrumentation = __webpack_require__(28);
	var ReactMarkupChecksum = __webpack_require__(315);
	var ReactReconciler = __webpack_require__(56);
	var ReactServerBatchingStrategy = __webpack_require__(996);
	var ReactServerRenderingTransaction = __webpack_require__(318);
	var ReactUpdates = __webpack_require__(34);
	
	var emptyObject = __webpack_require__(43);
	var instantiateReactComponent = __webpack_require__(193);
	var invariant = __webpack_require__(4);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(188);
	
	var warning = __webpack_require__(6);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 999 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(88);
	var ExecutionEnvironment = __webpack_require__(23);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactInputSelection = __webpack_require__(314);
	var SyntheticEvent = __webpack_require__(39);
	
	var getActiveElement = __webpack_require__(267);
	var isTextInputElement = __webpack_require__(326);
	var shallowEqual = __webpack_require__(153);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var EventListener = __webpack_require__(265);
	var EventPropagators = __webpack_require__(88);
	var ReactDOMComponentTree = __webpack_require__(17);
	var SyntheticAnimationEvent = __webpack_require__(1002);
	var SyntheticClipboardEvent = __webpack_require__(1003);
	var SyntheticEvent = __webpack_require__(39);
	var SyntheticFocusEvent = __webpack_require__(1006);
	var SyntheticKeyboardEvent = __webpack_require__(1008);
	var SyntheticMouseEvent = __webpack_require__(111);
	var SyntheticDragEvent = __webpack_require__(1005);
	var SyntheticTouchEvent = __webpack_require__(1009);
	var SyntheticTransitionEvent = __webpack_require__(1010);
	var SyntheticUIEvent = __webpack_require__(90);
	var SyntheticWheelEvent = __webpack_require__(1011);
	
	var emptyFunction = __webpack_require__(19);
	var getEventCharCode = __webpack_require__(190);
	var invariant = __webpack_require__(4);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(39);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(39);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(39);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(111);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(90);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(39);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(90);
	
	var getEventCharCode = __webpack_require__(190);
	var getEventKey = __webpack_require__(1016);
	var getEventModifierState = __webpack_require__(191);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(90);
	
	var getEventModifierState = __webpack_require__(191);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(39);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(111);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(303);
	var warning = __webpack_require__(6);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(17);
	var ReactInstanceMap = __webpack_require__(89);
	
	var getHostComponentFromComposite = __webpack_require__(323);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(6);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(184);
	var traverseAllChildren = __webpack_require__(328);
	var warning = __webpack_require__(6);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(336);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(85)))

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(190);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 1017 */
209,
/* 1018 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(23);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(113);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(316);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function _classCallCheck(e,r){if(!(e instanceof r))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(e,r){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!r||"object"!=typeof r&&"function"!=typeof r?e:r}function _inherits(e,r){if("function"!=typeof r&&null!==r)throw new TypeError("Super expression must either be null or a function, not "+typeof r);e.prototype=Object.create(r&&r.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),r&&(Object.setPrototypeOf?Object.setPrototypeOf(e,r):e.__proto__=r)}function isArraysEqual(e,r){return JSON.stringify(e)===JSON.stringify(r)}Object.defineProperty(exports,"__esModule",{value:!0});var _createClass=function(){function e(e,r){for(var t=0;t<r.length;t++){var a=r[t];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(r,t,a){return t&&e(r.prototype,t),a&&e(r,a),r}}(),_react=__webpack_require__(1),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(2),_propTypes2=_interopRequireDefault(_propTypes),_reactLeaflet=__webpack_require__(115),_leaflet=__webpack_require__(8),_leaflet2=_interopRequireDefault(_leaflet);__webpack_require__(842),__webpack_require__(678);var MarkerClusterGroup=function(e){function r(){return _classCallCheck(this,r),_possibleConstructorReturn(this,(r.__proto__||Object.getPrototypeOf(r)).apply(this,arguments))}return _inherits(r,_reactLeaflet.LayerGroup),_createClass(r,[{key:"componentWillMount",value:function(){this.leafletElement=_leaflet2.default.markerClusterGroup(this.props.options),this.props.markers.length&&this.addLayersWithMarkersFromProps(this.props.markers),this.props.wrapperOptions.enableDefaultStyle&&(this.context.map._container.className+=" marker-cluster-styled"),!this.props.wrapperOptions.disableDefaultAnimation&&(this.context.map._container.className+=" marker-cluster-animated"),this.initEventListeners(this.leafletElement)}},{key:"componentWillReceiveProps",value:function(e){e.markers.length&&!isArraysEqual(this.props.markers,e.markers)&&(this.layerContainer.removeLayer(this.leafletElement),this.leafletElement.clearLayers(),this.addLayersWithMarkersFromProps(e.markers))}},{key:"removeMarkersWithSameCoordinates",value:function(e){var r=[e[0]];return e.forEach(function(e){JSON.stringify(r).includes(JSON.stringify(e))||r.push(e)}),r}},{key:"addLayersWithMarkersFromProps",value:function(e){var r=this.props.markerOptions?Object.assign({},this.props.markerOptions):{},t=[];(this.props.wrapperOptions.removeDuplicates?this.removeMarkersWithSameCoordinates(e):e).forEach(function(e){var a=e.options?Object.assign({},e.options):null,o=_leaflet2.default.marker([e.lat,e.lng],a||r);e.popup&&o.bindPopup(e.popup),e.tooltip&&o.bindTooltip(e.tooltip),t.push(o)}),this.leafletElement.addLayers(t),!this.props.children&&this.layerContainer.addLayer(this.leafletElement)}},{key:"initEventListeners",value:function(e){var r=this;this.props.onMarkerClick&&e.on("click",function(e){r.props.onMarkerClick(e.layer)}),this.props.onClusterClick&&e.on("clusterclick",function(e){r.props.onClusterClick(e.layer)}),this.props.onPopupClose&&e.on("popupclose",function(e){r.props.onPopupClose(e.popup)})}},{key:"addLayersWithReactLeafletMarkers",value:function(){var e=this,r=[];return _react.Children.map(this.props.children,function(t,a){return(0,_react.cloneElement)(t,{ref:function(t){t&&(r.push(t.leafletElement),a!==e.props.children.length-1&&Array.isArray(e.props.children)||(e.leafletElement.addLayers(r),e.layerContainer.addLayer(e.leafletElement)))},key:"react-leaflet-marker-"+a})})}},{key:"getLeafletElement",value:function(){return this.leafletElement}},{key:"render",value:function(){return this.props.children?_react2.default.createElement("section",{className:"marker-cluster-group"},this.addLayersWithReactLeafletMarkers()):null}}]),r}();exports.default=MarkerClusterGroup,MarkerClusterGroup.propTypes={markers:_propTypes2.default.arrayOf(_propTypes2.default.object),children:_propTypes2.default.node,options:_propTypes2.default.object,markerOptions:_propTypes2.default.object,wrapperOptions:_propTypes2.default.object,onMarkerClick:_propTypes2.default.func,onClusterClick:_propTypes2.default.func,onPopupClose:_propTypes2.default.func},MarkerClusterGroup.defaultProps={markers:[],wrapperOptions:{}};


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(79);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.default = decorate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var node = _react.PropTypes.node,
	    func = _react.PropTypes.func;
	function decorate(componentName) {
		var Decorated = function (_Component) {
			(0, _inherits3.default)(Decorated, _Component);
	
			function Decorated(props) {
				(0, _classCallCheck3.default)(this, Decorated);
	
				var _this = (0, _possibleConstructorReturn3.default)(this, (Decorated.__proto__ || (0, _getPrototypeOf2.default)(Decorated)).call(this, props));
	
				_this.state = { loaded: false };
				_this.constructor.displayName = 'Wrapped' + componentName;
				return _this;
			}
	
			(0, _createClass3.default)(Decorated, [{
				key: 'componentDidMount',
				value: function componentDidMount() {
					this.setState({ loaded: true });
					this.ClientComponent = __webpack_require__(115)[componentName];
				}
			}, {
				key: 'render',
				value: function render() {
					if (!this.state.loaded) return null;
	
					var ClientComponent = this.ClientComponent;
					var _props = this.props,
					    children = _props.children,
					    leafletRef = _props.leafletRef,
					    rest = (0, _objectWithoutProperties3.default)(_props, ['children', 'leafletRef']);
	
	
					return _react2.default.createElement(
						ClientComponent,
						(0, _extends3.default)({}, rest, { ref: leafletRef }),
						children
					);
				}
			}]);
			return Decorated;
		}(_react.Component);
	
		Decorated.propTypes = {
			children: node,
			leafletRef: func
		};
	
		return Decorated;
	}
	module.exports = exports['default'];

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _controlPosition = __webpack_require__(73);
	
	var _controlPosition2 = _interopRequireDefault(_controlPosition);
	
	var _MapControl2 = __webpack_require__(92);
	
	var _MapControl3 = _interopRequireDefault(_MapControl2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AttributionControl = function (_MapControl) {
	  (0, _inherits3.default)(AttributionControl, _MapControl);
	
	  function AttributionControl() {
	    (0, _classCallCheck3.default)(this, AttributionControl);
	    return (0, _possibleConstructorReturn3.default)(this, (AttributionControl.__proto__ || (0, _getPrototypeOf2.default)(AttributionControl)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AttributionControl, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      return _leaflet.control.attribution(props);
	    }
	  }]);
	  return AttributionControl;
	}(_MapControl3.default);
	
	AttributionControl.propTypes = {
	  position: _controlPosition2.default,
	  prefix: _propTypes2.default.string
	};
	exports.default = AttributionControl;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _latlng = __webpack_require__(45);
	
	var _latlng2 = _interopRequireDefault(_latlng);
	
	var _Path2 = __webpack_require__(44);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Circle = function (_Path) {
	  (0, _inherits3.default)(Circle, _Path);
	
	  function Circle() {
	    (0, _classCallCheck3.default)(this, Circle);
	    return (0, _possibleConstructorReturn3.default)(this, (Circle.__proto__ || (0, _getPrototypeOf2.default)(Circle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Circle, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var center = props.center,
	          radius = props.radius,
	          options = (0, _objectWithoutProperties3.default)(props, ['center', 'radius']);
	
	      return (0, _leaflet.circle)(center, radius, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.center !== fromProps.center) {
	        this.leafletElement.setLatLng(toProps.center);
	      }
	      if (toProps.radius !== fromProps.radius) {
	        this.leafletElement.setRadius(toProps.radius);
	      }
	    }
	  }]);
	  return Circle;
	}(_Path3.default);
	
	Circle.propTypes = {
	  center: _latlng2.default.isRequired,
	  children: _children2.default,
	  radius: _propTypes2.default.number.isRequired
	};
	exports.default = Circle;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _latlng = __webpack_require__(45);
	
	var _latlng2 = _interopRequireDefault(_latlng);
	
	var _Path2 = __webpack_require__(44);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleMarker = function (_Path) {
	  (0, _inherits3.default)(CircleMarker, _Path);
	
	  function CircleMarker() {
	    (0, _classCallCheck3.default)(this, CircleMarker);
	    return (0, _possibleConstructorReturn3.default)(this, (CircleMarker.__proto__ || (0, _getPrototypeOf2.default)(CircleMarker)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircleMarker, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var center = props.center,
	          options = (0, _objectWithoutProperties3.default)(props, ['center']);
	
	      return (0, _leaflet.circleMarker)(center, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.center !== fromProps.center) {
	        this.leafletElement.setLatLng(toProps.center);
	      }
	      if (toProps.radius !== fromProps.radius) {
	        this.leafletElement.setRadius(toProps.radius);
	      }
	    }
	  }]);
	  return CircleMarker;
	}(_Path3.default);
	
	CircleMarker.propTypes = {
	  center: _latlng2.default.isRequired,
	  children: _children2.default,
	  radius: _propTypes2.default.number
	};
	exports.default = CircleMarker;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(32);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _layerContainer = __webpack_require__(74);
	
	var _layerContainer2 = _interopRequireDefault(_layerContainer);
	
	var _Path2 = __webpack_require__(44);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeatureGroup = function (_Path) {
	  (0, _inherits3.default)(FeatureGroup, _Path);
	
	  function FeatureGroup() {
	    (0, _classCallCheck3.default)(this, FeatureGroup);
	    return (0, _possibleConstructorReturn3.default)(this, (FeatureGroup.__proto__ || (0, _getPrototypeOf2.default)(FeatureGroup)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FeatureGroup, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        layerContainer: this.leafletElement,
	        popupContainer: this.leafletElement
	      };
	    }
	  }, {
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      return (0, _leaflet.featureGroup)(this.getOptions(props));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get3.default)(FeatureGroup.prototype.__proto__ || (0, _getPrototypeOf2.default)(FeatureGroup.prototype), 'componentDidMount', this).call(this);
	      this.setStyle(this.props);
	    }
	  }]);
	  return FeatureGroup;
	}(_Path3.default);
	
	FeatureGroup.childContextTypes = {
	  children: _children2.default,
	  layerContainer: _layerContainer2.default,
	  popupContainer: _propTypes2.default.object
	};
	exports.default = FeatureGroup;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isFunction2 = __webpack_require__(173);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _Path2 = __webpack_require__(44);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GeoJSON = function (_Path) {
	  (0, _inherits3.default)(GeoJSON, _Path);
	
	  function GeoJSON() {
	    (0, _classCallCheck3.default)(this, GeoJSON);
	    return (0, _possibleConstructorReturn3.default)(this, (GeoJSON.__proto__ || (0, _getPrototypeOf2.default)(GeoJSON)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GeoJSON, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var data = props.data,
	          options = (0, _objectWithoutProperties3.default)(props, ['data']);
	
	      return (0, _leaflet.geoJSON)(data, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if ((0, _isFunction3.default)(toProps.style)) {
	        this.setStyle(toProps.style);
	      } else {
	        this.setStyleIfChanged(fromProps, toProps);
	      }
	    }
	  }]);
	  return GeoJSON;
	}(_Path3.default);
	
	GeoJSON.propTypes = {
	  children: _children2.default,
	  data: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]).isRequired
	};
	exports.default = GeoJSON;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bounds = __webpack_require__(93);
	
	var _bounds2 = _interopRequireDefault(_bounds);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _MapLayer2 = __webpack_require__(57);
	
	var _MapLayer3 = _interopRequireDefault(_MapLayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageOverlay = function (_MapLayer) {
	  (0, _inherits3.default)(ImageOverlay, _MapLayer);
	
	  function ImageOverlay() {
	    (0, _classCallCheck3.default)(this, ImageOverlay);
	    return (0, _possibleConstructorReturn3.default)(this, (ImageOverlay.__proto__ || (0, _getPrototypeOf2.default)(ImageOverlay)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ImageOverlay, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popupContainer: this.leafletElement
	      };
	    }
	  }, {
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var bounds = props.bounds,
	          url = props.url,
	          options = (0, _objectWithoutProperties3.default)(props, ['bounds', 'url']);
	
	      return (0, _leaflet.imageOverlay)(url, bounds, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.url !== fromProps.url) {
	        this.leafletElement.setUrl(toProps.url);
	      }
	      if (toProps.bounds !== fromProps.bounds) {
	        this.leafletElement.setBounds((0, _leaflet.latLngBounds)(toProps.bounds));
	      }
	      if (toProps.opacity !== fromProps.opacity) {
	        this.leafletElement.setOpacity(toProps.opacity);
	      }
	      if (toProps.zIndex !== fromProps.zIndex) {
	        this.leafletElement.setZIndex(toProps.zIndex);
	      }
	    }
	  }]);
	  return ImageOverlay;
	}(_MapLayer3.default);
	
	ImageOverlay.propTypes = {
	  attribution: _propTypes2.default.string,
	  bounds: _bounds2.default.isRequired,
	  children: _children2.default,
	  opacity: _propTypes2.default.number,
	  url: _propTypes2.default.string.isRequired,
	  zIndex: _propTypes2.default.number
	};
	ImageOverlay.childContextTypes = {
	  popupContainer: _propTypes2.default.object
	};
	exports.default = ImageOverlay;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _layerContainer = __webpack_require__(74);
	
	var _layerContainer2 = _interopRequireDefault(_layerContainer);
	
	var _MapLayer2 = __webpack_require__(57);
	
	var _MapLayer3 = _interopRequireDefault(_MapLayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LayerGroup = function (_MapLayer) {
	  (0, _inherits3.default)(LayerGroup, _MapLayer);
	
	  function LayerGroup() {
	    (0, _classCallCheck3.default)(this, LayerGroup);
	    return (0, _possibleConstructorReturn3.default)(this, (LayerGroup.__proto__ || (0, _getPrototypeOf2.default)(LayerGroup)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LayerGroup, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        layerContainer: this.leafletElement
	      };
	    }
	  }, {
	    key: 'createLeafletElement',
	    value: function createLeafletElement() {
	      return (0, _leaflet.layerGroup)(this.getOptions());
	    }
	  }]);
	  return LayerGroup;
	}(_MapLayer3.default);
	
	LayerGroup.childContextTypes = {
	  layerContainer: _layerContainer2.default
	};
	exports.default = LayerGroup;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _get2 = __webpack_require__(32);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(79);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _children2 = __webpack_require__(18);
	
	var _children3 = _interopRequireDefault(_children2);
	
	var _controlPosition = __webpack_require__(73);
	
	var _controlPosition2 = _interopRequireDefault(_controlPosition);
	
	var _layerContainer = __webpack_require__(74);
	
	var _layerContainer2 = _interopRequireDefault(_layerContainer);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _MapControl2 = __webpack_require__(92);
	
	var _MapControl3 = _interopRequireDefault(_MapControl2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var baseControlledLayerPropTypes = {
	  checked: _propTypes2.default.bool,
	  children: _propTypes2.default.node.isRequired,
	  removeLayer: _propTypes2.default.func,
	  removeLayerControl: _propTypes2.default.func
	};
	
	var controlledLayerPropTypes = (0, _extends3.default)({}, baseControlledLayerPropTypes, {
	  addBaseLayer: _propTypes2.default.func,
	  addOverlay: _propTypes2.default.func,
	  name: _propTypes2.default.string.isRequired
	
	  // Abtract class for layer container, extended by BaseLayer and Overlay
	});
	var ControlledLayer = function (_Component) {
	  (0, _inherits3.default)(ControlledLayer, _Component);
	
	  function ControlledLayer() {
	    (0, _classCallCheck3.default)(this, ControlledLayer);
	    return (0, _possibleConstructorReturn3.default)(this, (ControlledLayer.__proto__ || (0, _getPrototypeOf2.default)(ControlledLayer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ControlledLayer, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        layerContainer: {
	          addLayer: this.addLayer.bind(this),
	          removeLayer: this.removeLayer.bind(this)
	        }
	      };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var checked = _ref.checked;
	
	      // Handle dynamically (un)checking the layer => adding/removing from the map
	      if (checked && !this.props.checked) {
	        this.context.map.addLayer(this.layer);
	      } else if (this.props.checked && !checked) {
	        this.context.map.removeLayer(this.layer);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.removeLayerControl(this.layer);
	    }
	  }, {
	    key: 'addLayer',
	    value: function addLayer() {
	      throw new Error('Must be implemented in extending class');
	    }
	  }, {
	    key: 'removeLayer',
	    value: function removeLayer(layer) {
	      this.props.removeLayer(layer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	  return ControlledLayer;
	}(_react.Component);
	
	ControlledLayer.propTypes = baseControlledLayerPropTypes;
	ControlledLayer.contextTypes = {
	  map: _map2.default
	};
	ControlledLayer.childContextTypes = {
	  layerContainer: _layerContainer2.default
	};
	
	var BaseLayer = function (_ControlledLayer) {
	  (0, _inherits3.default)(BaseLayer, _ControlledLayer);
	
	  function BaseLayer() {
	    (0, _classCallCheck3.default)(this, BaseLayer);
	    return (0, _possibleConstructorReturn3.default)(this, (BaseLayer.__proto__ || (0, _getPrototypeOf2.default)(BaseLayer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BaseLayer, [{
	    key: 'addLayer',
	    value: function addLayer(layer) {
	      this.layer = layer; // Keep layer reference to handle dynamic changes of props
	      var _props = this.props,
	          addBaseLayer = _props.addBaseLayer,
	          checked = _props.checked,
	          name = _props.name;
	
	      addBaseLayer(layer, name, checked);
	    }
	  }]);
	  return BaseLayer;
	}(ControlledLayer);
	
	BaseLayer.propTypes = controlledLayerPropTypes;
	
	var Overlay = function (_ControlledLayer2) {
	  (0, _inherits3.default)(Overlay, _ControlledLayer2);
	
	  function Overlay() {
	    (0, _classCallCheck3.default)(this, Overlay);
	    return (0, _possibleConstructorReturn3.default)(this, (Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Overlay, [{
	    key: 'addLayer',
	    value: function addLayer(layer) {
	      this.layer = layer; // Keep layer reference to handle dynamic changes of props
	      var _props2 = this.props,
	          addOverlay = _props2.addOverlay,
	          checked = _props2.checked,
	          name = _props2.name;
	
	      addOverlay(layer, name, checked);
	    }
	  }]);
	  return Overlay;
	}(ControlledLayer);
	
	Overlay.propTypes = controlledLayerPropTypes;
	
	var LayersControl = function (_MapControl) {
	  (0, _inherits3.default)(LayersControl, _MapControl);
	
	  function LayersControl() {
	    (0, _classCallCheck3.default)(this, LayersControl);
	    return (0, _possibleConstructorReturn3.default)(this, (LayersControl.__proto__ || (0, _getPrototypeOf2.default)(LayersControl)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LayersControl, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var _children = props.children,
	          options = (0, _objectWithoutProperties3.default)(props, ['children']);
	
	      return _leaflet.control.layers(undefined, undefined, options);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      (0, _get3.default)(LayersControl.prototype.__proto__ || (0, _getPrototypeOf2.default)(LayersControl.prototype), 'componentWillMount', this).call(this);
	      this.controlProps = {
	        addBaseLayer: this.addBaseLayer.bind(this),
	        addOverlay: this.addOverlay.bind(this),
	        removeLayer: this.removeLayer.bind(this),
	        removeLayerControl: this.removeLayerControl.bind(this)
	      };
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this5 = this;
	
	      setTimeout(function () {
	        (0, _get3.default)(LayersControl.prototype.__proto__ || (0, _getPrototypeOf2.default)(LayersControl.prototype), 'componentWillUnmount', _this5).call(_this5);
	      }, 0);
	    }
	  }, {
	    key: 'addBaseLayer',
	    value: function addBaseLayer(layer, name) {
	      var checked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (checked) {
	        this.context.map.addLayer(layer);
	      }
	      this.leafletElement.addBaseLayer(layer, name);
	    }
	  }, {
	    key: 'addOverlay',
	    value: function addOverlay(layer, name) {
	      var checked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (checked) {
	        this.context.map.addLayer(layer);
	      }
	      this.leafletElement.addOverlay(layer, name);
	    }
	  }, {
	    key: 'removeLayer',
	    value: function removeLayer(layer) {
	      this.context.map.removeLayer(layer);
	    }
	  }, {
	    key: 'removeLayerControl',
	    value: function removeLayerControl(layer) {
	      this.leafletElement.removeLayer(layer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var children = _react.Children.map(this.props.children, function (child) {
	        return child ? (0, _react.cloneElement)(child, _this6.controlProps) : null;
	      });
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'none' } },
	        children
	      );
	    }
	  }]);
	  return LayersControl;
	}(_MapControl3.default);
	
	LayersControl.propTypes = {
	  baseLayers: _propTypes2.default.object,
	  children: _children3.default,
	  overlays: _propTypes2.default.object,
	  position: _controlPosition2.default
	};
	LayersControl.contextTypes = {
	  layerContainer: _layerContainer2.default,
	  map: _map2.default
	};
	exports.default = LayersControl;
	
	
	LayersControl.BaseLayer = BaseLayer;
	LayersControl.Overlay = Overlay;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(32);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _omit2 = __webpack_require__(299);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _isUndefined2 = __webpack_require__(947);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _leaflet = __webpack_require__(8);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bounds = __webpack_require__(93);
	
	var _bounds2 = _interopRequireDefault(_bounds);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _latlng = __webpack_require__(45);
	
	var _latlng2 = _interopRequireDefault(_latlng);
	
	var _layerContainer = __webpack_require__(74);
	
	var _layerContainer2 = _interopRequireDefault(_layerContainer);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _viewport = __webpack_require__(330);
	
	var _viewport2 = _interopRequireDefault(_viewport);
	
	var _MapComponent2 = __webpack_require__(91);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OTHER_PROPS = ['children', 'className', 'id', 'style', 'useFlyTo', 'whenReady'];
	
	var normalizeCenter = function normalizeCenter(pos) {
	  return Array.isArray(pos) ? pos : [pos.lat, pos.lon ? pos.lon : pos.lng];
	};
	
	var Map = function (_MapComponent) {
	  (0, _inherits3.default)(Map, _MapComponent);
	
	  function Map(props, context) {
	    (0, _classCallCheck3.default)(this, Map);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Map.__proto__ || (0, _getPrototypeOf2.default)(Map)).call(this, props, context));
	
	    _this.viewport = {
	      center: undefined,
	      zoom: undefined
	    };
	    _this._updating = false;
	
	    _this.onViewportChange = function () {
	      var center = _this.leafletElement.getCenter();
	      _this.viewport = {
	        center: center ? [center.lat, center.lng] : undefined,
	        zoom: _this.leafletElement.getZoom()
	      };
	      if (_this.props.onViewportChange && !_this._updating) {
	        _this.props.onViewportChange(_this.viewport);
	      }
	    };
	
	    _this.onViewportChanged = function () {
	      if (_this.props.onViewportChanged && !_this._updating) {
	        _this.props.onViewportChanged(_this.viewport);
	      }
	    };
	
	    _this.bindContainer = function (container) {
	      _this.container = container;
	    };
	
	    _this.className = props.className;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Map, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        layerContainer: this.leafletElement,
	        map: this.leafletElement
	      };
	    }
	  }, {
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var viewport = props.viewport,
	          options = (0, _objectWithoutProperties3.default)(props, ['viewport']);
	
	      if (viewport) {
	        if (viewport.center) {
	          options.center = viewport.center;
	        }
	        if (typeof viewport.zoom === 'number') {
	          options.zoom = viewport.zoom;
	        }
	      }
	      return _leaflet2.default.map(this.container, options);
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      this._updating = true;
	
	      var animate = toProps.animate,
	          bounds = toProps.bounds,
	          boundsOptions = toProps.boundsOptions,
	          center = toProps.center,
	          className = toProps.className,
	          maxBounds = toProps.maxBounds,
	          useFlyTo = toProps.useFlyTo,
	          viewport = toProps.viewport,
	          zoom = toProps.zoom;
	
	
	      if (className !== fromProps.className) {
	        if (fromProps.className) {
	          _leaflet2.default.DomUtil.removeClass(this.container, fromProps.className);
	        }
	        if (className) {
	          _leaflet2.default.DomUtil.addClass(this.container, className);
	        }
	      }
	
	      if (viewport && viewport !== fromProps.viewport) {
	        var c = viewport.center ? viewport.center : center;
	        var z = viewport.zoom ? viewport.zoom : zoom;
	        if (useFlyTo) {
	          this.leafletElement.flyTo(c, z, { animate: animate });
	        } else {
	          this.leafletElement.setView(c, z, { animate: animate });
	        }
	      } else if (center && this.shouldUpdateCenter(center, fromProps.center)) {
	        if (useFlyTo) {
	          this.leafletElement.flyTo(center, zoom, { animate: animate });
	        } else {
	          this.leafletElement.setView(center, zoom, { animate: animate });
	        }
	      } else if (typeof zoom === 'number' && zoom !== fromProps.zoom) {
	        if (fromProps.zoom) {
	          this.leafletElement.setZoom(zoom);
	        } else {
	          this.leafletElement.setView(center, zoom);
	        }
	      }
	
	      if (maxBounds && this.shouldUpdateBounds(maxBounds, fromProps.maxBounds)) {
	        this.leafletElement.setMaxBounds(maxBounds);
	      }
	
	      if (bounds && (this.shouldUpdateBounds(bounds, fromProps.bounds) || boundsOptions !== fromProps.boundsOptions)) {
	        if (useFlyTo) {
	          this.leafletElement.flyToBounds(bounds, boundsOptions);
	        } else {
	          this.leafletElement.fitBounds(bounds, boundsOptions);
	        }
	      }
	
	      this._updating = false;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var props = (0, _omit3.default)(this.props, OTHER_PROPS);
	      this.leafletElement = this.createLeafletElement(props);
	
	      this.leafletElement.on('move', this.onViewportChange);
	      this.leafletElement.on('moveend', this.onViewportChanged);
	
	      if (!(0, _isUndefined3.default)(props.bounds)) {
	        this.leafletElement.fitBounds(props.bounds, props.boundsOptions);
	      }
	
	      if (this.props.whenReady) {
	        this.leafletElement.whenReady(this.props.whenReady);
	      }
	
	      (0, _get3.default)(Map.prototype.__proto__ || (0, _getPrototypeOf2.default)(Map.prototype), 'componentDidMount', this).call(this);
	      this.forceUpdate(); // Re-render now that leafletElement is created
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.updateLeafletElement(prevProps, this.props);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _get3.default)(Map.prototype.__proto__ || (0, _getPrototypeOf2.default)(Map.prototype), 'componentWillUnmount', this).call(this);
	      this.leafletElement.off('move', this.onViewportChange);
	      this.leafletElement.off('moveend', this.onViewportChanged);
	      this.leafletElement.remove();
	    }
	  }, {
	    key: 'shouldUpdateCenter',
	    value: function shouldUpdateCenter(next, prev) {
	      if (!prev) return true;
	      next = normalizeCenter(next);
	      prev = normalizeCenter(prev);
	      return next[0] !== prev[0] || next[1] !== prev[1];
	    }
	  }, {
	    key: 'shouldUpdateBounds',
	    value: function shouldUpdateBounds(next, prev) {
	      if (!prev) return true;
	      next = _leaflet2.default.latLngBounds(next);
	      prev = _leaflet2.default.latLngBounds(prev);
	      return !next.equals(prev);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var map = this.leafletElement;
	      var children = map ? this.props.children : null;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: this.className,
	          id: this.props.id,
	          ref: this.bindContainer,
	          style: this.props.style },
	        children
	      );
	    }
	  }]);
	  return Map;
	}(_MapComponent3.default);
	
	Map.propTypes = {
	  animate: _propTypes2.default.bool,
	  bounds: _bounds2.default,
	  boundsOptions: _propTypes2.default.object,
	  center: _latlng2.default,
	  children: _children2.default,
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  maxBounds: _bounds2.default,
	  maxZoom: _propTypes2.default.number,
	  minZoom: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  useFlyTo: _propTypes2.default.bool,
	  viewport: _viewport2.default,
	  whenReady: _propTypes2.default.func,
	  zoom: _propTypes2.default.number
	};
	Map.defaultProps = {
	  animate: false,
	  useFlyTo: false
	};
	Map.childContextTypes = {
	  layerContainer: _layerContainer2.default,
	  map: _map2.default
	};
	exports.default = Map;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _latlng = __webpack_require__(45);
	
	var _latlng2 = _interopRequireDefault(_latlng);
	
	var _MapLayer2 = __webpack_require__(57);
	
	var _MapLayer3 = _interopRequireDefault(_MapLayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Marker = function (_MapLayer) {
	  (0, _inherits3.default)(Marker, _MapLayer);
	
	  function Marker() {
	    (0, _classCallCheck3.default)(this, Marker);
	    return (0, _possibleConstructorReturn3.default)(this, (Marker.__proto__ || (0, _getPrototypeOf2.default)(Marker)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Marker, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popupContainer: this.leafletElement
	      };
	    }
	  }, {
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var position = props.position,
	          options = (0, _objectWithoutProperties3.default)(props, ['position']);
	
	      return (0, _leaflet.marker)(position, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.position !== fromProps.position) {
	        this.leafletElement.setLatLng(toProps.position);
	      }
	      if (toProps.icon !== fromProps.icon) {
	        this.leafletElement.setIcon(toProps.icon);
	      }
	      if (toProps.zIndexOffset !== fromProps.zIndexOffset) {
	        this.leafletElement.setZIndexOffset(toProps.zIndexOffset);
	      }
	      if (toProps.opacity !== fromProps.opacity) {
	        this.leafletElement.setOpacity(toProps.opacity);
	      }
	      if (toProps.draggable !== fromProps.draggable) {
	        if (toProps.draggable) {
	          this.leafletElement.dragging.enable();
	        } else {
	          this.leafletElement.dragging.disable();
	        }
	      }
	    }
	  }]);
	  return Marker;
	}(_MapLayer3.default);
	
	Marker.propTypes = {
	  children: _children2.default,
	  icon: _propTypes2.default.instanceOf(_leaflet.Icon),
	  opacity: _propTypes2.default.number,
	  position: _latlng2.default.isRequired,
	  zIndexOffset: _propTypes2.default.number
	};
	Marker.childContextTypes = {
	  popupContainer: _propTypes2.default.object
	};
	exports.default = Marker;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _uniqueId2 = __webpack_require__(956);
	
	var _uniqueId3 = _interopRequireDefault(_uniqueId2);
	
	var _omit2 = __webpack_require__(299);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _forEach2 = __webpack_require__(293);
	
	var _forEach3 = _interopRequireDefault(_forEach2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(339);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LEAFLET_PANES = ['tile', 'shadow', 'overlay', 'map', 'marker', 'tooltip', 'popup'];
	
	var isLeafletPane = function isLeafletPane(name) {
	  return LEAFLET_PANES.indexOf(name.replace(/-*pane/gi, '')) !== -1;
	};
	
	var paneStyles = {
	  position: 'absolute',
	  top: 0,
	  right: 0,
	  bottom: 0,
	  left: 0
	};
	
	var Pane = function (_Component) {
	  (0, _inherits3.default)(Pane, _Component);
	
	  function Pane() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Pane);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Pane.__proto__ || (0, _getPrototypeOf2.default)(Pane)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      name: undefined
	    }, _this.setStyle = function () {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props,
	          style = _ref2.style,
	          className = _ref2.className;
	
	      var pane = _this.getPane(_this.state.name);
	      if (pane) {
	        if (className) {
	          pane.classList.add(className);
	        }
	        if (style) {
	          (0, _forEach3.default)(style, function (value, key) {
	            pane.style[key] = value;
	          });
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Pane, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        pane: this.state.name
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.createPane(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.state.name) {
	        // Do nothing if this.state.name is undefined due to errors or
	        // an invalid props.name value
	        return;
	      }
	
	      // If the 'name' prop has changed the current pane is unmounted and a new
	      // pane is created.
	      if (nextProps.name !== this.props.name) {
	        this.removePane();
	        this.createPane(nextProps);
	      } else {
	        // Remove the previous css class name from the pane if it has changed.
	        // setStyle will take care of adding in the updated className
	        if (this.props.className && nextProps.className !== this.props.className) {
	          var _pane = this.getPane();
	          if (_pane) _pane.classList.remove(this.props.className);
	        }
	
	        // Update the pane's DOM node style and class
	        this.setStyle(nextProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removePane();
	    }
	  }, {
	    key: 'createPane',
	    value: function createPane(props) {
	      var map = this.context.map;
	      var name = props.name || 'pane-' + (0, _uniqueId3.default)();
	
	      if (map && map.createPane) {
	        var isDefault = isLeafletPane(name);
	        var existing = isDefault || this.getPane(name);
	
	        if (!existing) {
	          map.createPane(name, this.getParentPane());
	        } else {
	          var message = isDefault ? 'You must use a unique name for a pane that is not a default leaflet pane (' + name + ')' : 'A pane with this name already exists. (' + name + ')';
	           false ? (0, _warning2.default)(false, message) : void 0;
	        }
	
	        this.setState({ name: name }, this.setStyle);
	      }
	    }
	  }, {
	    key: 'removePane',
	    value: function removePane() {
	      // Remove the created pane
	      var name = this.state.name;
	
	      if (name) {
	        var _pane2 = this.getPane(name);
	        if (_pane2 && _pane2.remove) _pane2.remove();
	
	        var map = this.context.map;
	        if (map && map._panes) {
	          map._panes = (0, _omit3.default)(map._panes, name);
	          map._paneRenderers = (0, _omit3.default)(map._paneRenderers, name);
	        }
	
	        this.setState({ name: undefined });
	      }
	    }
	  }, {
	    key: 'getParentPane',
	    value: function getParentPane() {
	      return this.getPane(this.props.pane || this.context.pane);
	    }
	  }, {
	    key: 'getPane',
	    value: function getPane(name) {
	      return name ? this.context.map.getPane(name) : undefined;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.state.name ? _react2.default.createElement(
	        'div',
	        { style: paneStyles },
	        this.props.children
	      ) : null;
	    }
	  }]);
	  return Pane;
	}(_react.Component);
	
	Pane.propTypes = {
	  name: _propTypes2.default.string,
	  children: _children2.default,
	  map: _map2.default,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  pane: _propTypes2.default.string
	};
	Pane.contextTypes = {
	  map: _map2.default,
	  pane: _propTypes2.default.string
	};
	Pane.childContextTypes = {
	  pane: _propTypes2.default.string
	};
	exports.default = Pane;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _latlngList = __webpack_require__(116);
	
	var _latlngList2 = _interopRequireDefault(_latlngList);
	
	var _Path2 = __webpack_require__(44);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var multiLatLngListType = _propTypes2.default.arrayOf(_latlngList2.default);
	
	var Polygon = function (_Path) {
	  (0, _inherits3.default)(Polygon, _Path);
	
	  function Polygon() {
	    (0, _classCallCheck3.default)(this, Polygon);
	    return (0, _possibleConstructorReturn3.default)(this, (Polygon.__proto__ || (0, _getPrototypeOf2.default)(Polygon)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Polygon, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var positions = props.positions,
	          options = (0, _objectWithoutProperties3.default)(props, ['positions']);
	
	      return (0, _leaflet.polygon)(positions, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.positions !== fromProps.positions) {
	        this.leafletElement.setLatLngs(toProps.positions);
	      }
	      this.setStyleIfChanged(fromProps, toProps);
	    }
	  }]);
	  return Polygon;
	}(_Path3.default);
	
	Polygon.propTypes = {
	  children: _children2.default,
	  popupContainer: _propTypes2.default.object,
	  positions: _propTypes2.default.oneOfType([_latlngList2.default, multiLatLngListType, _propTypes2.default.arrayOf(multiLatLngListType)]).isRequired
	};
	exports.default = Polygon;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _latlngList = __webpack_require__(116);
	
	var _latlngList2 = _interopRequireDefault(_latlngList);
	
	var _Path2 = __webpack_require__(44);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Polyline = function (_Path) {
	  (0, _inherits3.default)(Polyline, _Path);
	
	  function Polyline() {
	    (0, _classCallCheck3.default)(this, Polyline);
	    return (0, _possibleConstructorReturn3.default)(this, (Polyline.__proto__ || (0, _getPrototypeOf2.default)(Polyline)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Polyline, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var positions = props.positions,
	          options = (0, _objectWithoutProperties3.default)(props, ['positions']);
	
	      return (0, _leaflet.polyline)(positions, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.positions !== fromProps.positions) {
	        this.leafletElement.setLatLngs(toProps.positions);
	      }
	      this.setStyleIfChanged(fromProps, toProps);
	    }
	  }]);
	  return Polyline;
	}(_Path3.default);
	
	Polyline.propTypes = {
	  children: _children2.default,
	  positions: _propTypes2.default.oneOfType([_latlngList2.default, _propTypes2.default.arrayOf(_latlngList2.default)]).isRequired
	};
	exports.default = Polyline;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(79);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(32);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(54);
	
	var _latlng = __webpack_require__(45);
	
	var _latlng2 = _interopRequireDefault(_latlng);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _MapComponent2 = __webpack_require__(91);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Popup = function (_MapComponent) {
	  (0, _inherits3.default)(Popup, _MapComponent);
	
	  function Popup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Popup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Popup.__proto__ || (0, _getPrototypeOf2.default)(Popup)).call.apply(_ref, [this].concat(args))), _this), _this.onPopupOpen = function (_ref2) {
	      var popup = _ref2.popup;
	
	      if (popup === _this.leafletElement) {
	        _this.renderPopupContent();
	        if (_this.props.onOpen) {
	          _this.props.onOpen();
	        }
	      }
	    }, _this.onPopupClose = function (_ref3) {
	      var popup = _ref3.popup;
	
	      if (popup === _this.leafletElement) {
	        _this.removePopupContent();
	        if (_this.props.onClose) {
	          _this.props.onClose();
	        }
	      }
	    }, _this.renderPopupContent = function () {
	      if (_this.props.children) {
	        (0, _reactDom.render)(_react.Children.only(_this.props.children), _this.leafletElement._contentNode);
	        _this.leafletElement.update();
	        if (_this.props.autoPan !== false) {
	          if (_this.leafletElement._map && _this.leafletElement._map._panAnim) {
	            _this.leafletElement._map._panAnim = undefined;
	          }
	          _this.leafletElement._adjustPan();
	        }
	      } else {
	        _this.removePopupContent();
	      }
	    }, _this.removePopupContent = function () {
	      if (_this.leafletElement._contentNode) {
	        (0, _reactDom.unmountComponentAtNode)(_this.leafletElement._contentNode);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Popup, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return (0, _extends3.default)({}, (0, _get3.default)(Popup.prototype.__proto__ || (0, _getPrototypeOf2.default)(Popup.prototype), 'getOptions', this).call(this, props), {
	        autoPan: false
	      });
	    }
	  }, {
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var _children = props.children,
	          options = (0, _objectWithoutProperties3.default)(props, ['children']);
	
	      return (0, _leaflet.popup)(this.getOptions(options), this.context.popupContainer);
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.position !== fromProps.position) {
	        this.leafletElement.setLatLng(toProps.position);
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      (0, _get3.default)(Popup.prototype.__proto__ || (0, _getPrototypeOf2.default)(Popup.prototype), 'componentWillMount', this).call(this);
	      this.leafletElement = this.createLeafletElement(this.props);
	      this.leafletElement.options.autoPan = this.props.autoPan !== false;
	
	      this.context.map.on({
	        popupopen: this.onPopupOpen,
	        popupclose: this.onPopupClose
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var position = this.props.position;
	      var _context = this.context,
	          map = _context.map,
	          popupContainer = _context.popupContainer;
	
	      var el = this.leafletElement;
	
	      if (popupContainer) {
	        // Attach to container component
	        popupContainer.bindPopup(el);
	      } else {
	        // Attach to a Map
	        if (position) {
	          el.setLatLng(position);
	        }
	        el.openOn(map);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      this.updateLeafletElement(prevProps, this.props);
	
	      if (this.leafletElement.isOpen()) {
	        this.renderPopupContent();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removePopupContent();
	
	      this.context.map.off({
	        popupopen: this.onPopupOpen,
	        popupclose: this.onPopupClose
	      });
	      this.context.map.removeLayer(this.leafletElement);
	
	      (0, _get3.default)(Popup.prototype.__proto__ || (0, _getPrototypeOf2.default)(Popup.prototype), 'componentWillUnmount', this).call(this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return Popup;
	}(_MapComponent3.default);
	
	Popup.propTypes = {
	  children: _propTypes2.default.node,
	  onClose: _propTypes2.default.func,
	  onOpen: _propTypes2.default.func,
	  position: _latlng2.default
	};
	Popup.contextTypes = {
	  map: _map2.default,
	  popupContainer: _propTypes2.default.object,
	  pane: _propTypes2.default.string
	};
	exports.default = Popup;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bounds = __webpack_require__(93);
	
	var _bounds2 = _interopRequireDefault(_bounds);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _Path2 = __webpack_require__(44);
	
	var _Path3 = _interopRequireDefault(_Path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Rectangle = function (_Path) {
	  (0, _inherits3.default)(Rectangle, _Path);
	
	  function Rectangle() {
	    (0, _classCallCheck3.default)(this, Rectangle);
	    return (0, _possibleConstructorReturn3.default)(this, (Rectangle.__proto__ || (0, _getPrototypeOf2.default)(Rectangle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Rectangle, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var bounds = props.bounds,
	          options = (0, _objectWithoutProperties3.default)(props, ['bounds']);
	
	      return (0, _leaflet.rectangle)(bounds, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.bounds !== fromProps.bounds) {
	        this.leafletElement.setBounds(toProps.bounds);
	      }
	      this.setStyleIfChanged(fromProps, toProps);
	    }
	  }]);
	  return Rectangle;
	}(_Path3.default);
	
	Rectangle.propTypes = {
	  children: _children2.default,
	  bounds: _bounds2.default.isRequired,
	  popupContainer: _propTypes2.default.object
	};
	exports.default = Rectangle;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _controlPosition = __webpack_require__(73);
	
	var _controlPosition2 = _interopRequireDefault(_controlPosition);
	
	var _MapControl2 = __webpack_require__(92);
	
	var _MapControl3 = _interopRequireDefault(_MapControl2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleControl = function (_MapControl) {
	  (0, _inherits3.default)(ScaleControl, _MapControl);
	
	  function ScaleControl() {
	    (0, _classCallCheck3.default)(this, ScaleControl);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleControl.__proto__ || (0, _getPrototypeOf2.default)(ScaleControl)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleControl, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      return _leaflet.control.scale(props);
	    }
	  }]);
	  return ScaleControl;
	}(_MapControl3.default);
	
	ScaleControl.propTypes = {
	  imperial: _propTypes2.default.bool,
	  maxWidth: _propTypes2.default.number,
	  metric: _propTypes2.default.bool,
	  position: _controlPosition2.default,
	  updateWhenIdle: _propTypes2.default.bool
	};
	exports.default = ScaleControl;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(32);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _GridLayer2 = __webpack_require__(198);
	
	var _GridLayer3 = _interopRequireDefault(_GridLayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TileLayer = function (_GridLayer) {
	  (0, _inherits3.default)(TileLayer, _GridLayer);
	
	  function TileLayer() {
	    (0, _classCallCheck3.default)(this, TileLayer);
	    return (0, _possibleConstructorReturn3.default)(this, (TileLayer.__proto__ || (0, _getPrototypeOf2.default)(TileLayer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TileLayer, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var url = props.url,
	          options = (0, _objectWithoutProperties3.default)(props, ['url']);
	
	      return (0, _leaflet.tileLayer)(url, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      (0, _get3.default)(TileLayer.prototype.__proto__ || (0, _getPrototypeOf2.default)(TileLayer.prototype), 'updateLeafletElement', this).call(this, fromProps, toProps);
	      if (toProps.url !== fromProps.url) {
	        this.leafletElement.setUrl(toProps.url);
	      }
	    }
	  }]);
	  return TileLayer;
	}(_GridLayer3.default);
	
	TileLayer.propTypes = {
	  children: _children2.default,
	  opacity: _propTypes2.default.number,
	  url: _propTypes2.default.string.isRequired,
	  zIndex: _propTypes2.default.number
	};
	exports.default = TileLayer;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(32);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(54);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _MapComponent2 = __webpack_require__(91);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tooltip = function (_MapComponent) {
	  (0, _inherits3.default)(Tooltip, _MapComponent);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.onTooltipOpen = function (_ref2) {
	      var tooltip = _ref2.tooltip;
	
	      if (tooltip === _this.leafletElement) {
	        _this.renderTooltipContent();
	        if (_this.props.onOpen) {
	          _this.props.onOpen();
	        }
	      }
	    }, _this.onTooltipClose = function (_ref3) {
	      var tooltip = _ref3.tooltip;
	
	      if (tooltip === _this.leafletElement) {
	        _this.removeTooltipContent();
	        if (_this.props.onClose) {
	          _this.props.onClose();
	        }
	      }
	    }, _this.renderTooltipContent = function () {
	      if (_this.props.children) {
	        (0, _reactDom.render)(_react.Children.only(_this.props.children), _this.leafletElement._contentNode);
	        _this.leafletElement.update();
	      } else {
	        _this.removeTooltipContent();
	      }
	    }, _this.removeTooltipContent = function () {
	      if (_this.leafletElement._contentNode) {
	        (0, _reactDom.unmountComponentAtNode)(_this.leafletElement._contentNode);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tooltip, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var _children = props.children,
	          options = (0, _objectWithoutProperties3.default)(props, ['children']);
	
	      return (0, _leaflet.tooltip)(this.getOptions(options), this.context.popupContainer);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      (0, _get3.default)(Tooltip.prototype.__proto__ || (0, _getPrototypeOf2.default)(Tooltip.prototype), 'componentWillMount', this).call(this);
	      this.leafletElement = this.createLeafletElement(this.props);
	
	      this.context.popupContainer.on({
	        tooltipopen: this.onTooltipOpen,
	        tooltipclose: this.onTooltipClose
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.context.popupContainer.bindTooltip(this.leafletElement);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.leafletElement.isOpen()) {
	        this.renderTooltipContent();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.context.popupContainer.off({
	        tooltipopen: this.onTooltipOpen,
	        tooltipclose: this.onTooltipClose
	      });
	      this.context.map.removeLayer(this.leafletElement);
	      (0, _get3.default)(Tooltip.prototype.__proto__ || (0, _getPrototypeOf2.default)(Tooltip.prototype), 'componentWillUnmount', this).call(this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return Tooltip;
	}(_MapComponent3.default);
	
	Tooltip.propTypes = {
	  children: _propTypes2.default.node,
	  onClose: _propTypes2.default.func,
	  onOpen: _propTypes2.default.func
	};
	Tooltip.contextTypes = {
	  map: _map2.default,
	  popupContainer: _propTypes2.default.object,
	  pane: _propTypes2.default.string
	};
	exports.default = Tooltip;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(32);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bounds = __webpack_require__(93);
	
	var _bounds2 = _interopRequireDefault(_bounds);
	
	var _MapLayer2 = __webpack_require__(57);
	
	var _MapLayer3 = _interopRequireDefault(_MapLayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoOverlay = function (_MapLayer) {
	  (0, _inherits3.default)(VideoOverlay, _MapLayer);
	
	  function VideoOverlay() {
	    (0, _classCallCheck3.default)(this, VideoOverlay);
	    return (0, _possibleConstructorReturn3.default)(this, (VideoOverlay.__proto__ || (0, _getPrototypeOf2.default)(VideoOverlay)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(VideoOverlay, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var bounds = props.bounds,
	          url = props.url,
	          options = (0, _objectWithoutProperties3.default)(props, ['bounds', 'url']);
	
	      return (0, _leaflet.videoOverlay)(url, bounds, this.getOptions(options));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _get3.default)(VideoOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(VideoOverlay.prototype), 'componentDidMount', this).call(this);
	      if (this.props.play) {
	        this.leafletElement.getElement().play();
	      }
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      if (toProps.url !== fromProps.url) {
	        this.leafletElement.setUrl(toProps.url);
	      }
	      if (toProps.bounds !== fromProps.bounds) {
	        this.leafletElement.setBounds((0, _leaflet.latLngBounds)(toProps.bounds));
	      }
	      if (toProps.opacity !== fromProps.opacity) {
	        this.leafletElement.setOpacity(toProps.opacity);
	      }
	      if (toProps.zIndex !== fromProps.zIndex) {
	        this.leafletElement.setZIndex(toProps.zIndex);
	      }
	      if (toProps.play && !fromProps.play) {
	        this.leafletElement.getElement().play();
	      } else if (!toProps.play && fromProps.play) {
	        this.leafletElement.getElement().pause();
	      }
	    }
	  }]);
	  return VideoOverlay;
	}(_MapLayer3.default);
	
	VideoOverlay.propTypes = {
	  attribution: _propTypes2.default.string,
	  bounds: _bounds2.default.isRequired,
	  opacity: _propTypes2.default.number,
	  play: _propTypes2.default.bool,
	  url: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  zIndex: _propTypes2.default.number
	};
	exports.default = VideoOverlay;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(20);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(32);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isEqual2 = __webpack_require__(296);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _children = __webpack_require__(18);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _GridLayer2 = __webpack_require__(198);
	
	var _GridLayer3 = _interopRequireDefault(_GridLayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WMSTileLayer = function (_GridLayer) {
	  (0, _inherits3.default)(WMSTileLayer, _GridLayer);
	
	  function WMSTileLayer() {
	    (0, _classCallCheck3.default)(this, WMSTileLayer);
	    return (0, _possibleConstructorReturn3.default)(this, (WMSTileLayer.__proto__ || (0, _getPrototypeOf2.default)(WMSTileLayer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(WMSTileLayer, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      var url = props.url,
	          options = (0, _objectWithoutProperties3.default)(props, ['url']);
	
	      return _leaflet.tileLayer.wms(url, this.getOptions(options));
	    }
	  }, {
	    key: 'updateLeafletElement',
	    value: function updateLeafletElement(fromProps, toProps) {
	      (0, _get3.default)(WMSTileLayer.prototype.__proto__ || (0, _getPrototypeOf2.default)(WMSTileLayer.prototype), 'updateLeafletElement', this).call(this, fromProps, toProps);
	
	      var prevUrl = fromProps.url,
	          _po = fromProps.opacity,
	          _pz = fromProps.zIndex,
	          prevParams = (0, _objectWithoutProperties3.default)(fromProps, ['url', 'opacity', 'zIndex']);
	      var url = toProps.url,
	          _o = toProps.opacity,
	          _z = toProps.zIndex,
	          params = (0, _objectWithoutProperties3.default)(toProps, ['url', 'opacity', 'zIndex']);
	
	
	      if (url !== prevUrl) {
	        this.leafletElement.setUrl(url);
	      }
	      if (!(0, _isEqual3.default)(params, prevParams)) {
	        this.leafletElement.setParams(params);
	      }
	    }
	  }]);
	  return WMSTileLayer;
	}(_GridLayer3.default);
	
	WMSTileLayer.propTypes = {
	  children: _children2.default,
	  opacity: _propTypes2.default.number,
	  url: _propTypes2.default.string.isRequired,
	  zIndex: _propTypes2.default.number
	};
	exports.default = WMSTileLayer;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _leaflet = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _controlPosition = __webpack_require__(73);
	
	var _controlPosition2 = _interopRequireDefault(_controlPosition);
	
	var _MapControl2 = __webpack_require__(92);
	
	var _MapControl3 = _interopRequireDefault(_MapControl2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ZoomControl = function (_MapControl) {
	  (0, _inherits3.default)(ZoomControl, _MapControl);
	
	  function ZoomControl() {
	    (0, _classCallCheck3.default)(this, ZoomControl);
	    return (0, _possibleConstructorReturn3.default)(this, (ZoomControl.__proto__ || (0, _getPrototypeOf2.default)(ZoomControl)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ZoomControl, [{
	    key: 'createLeafletElement',
	    value: function createLeafletElement(props) {
	      return _leaflet.control.zoom(props);
	    }
	  }]);
	  return ZoomControl;
	}(_MapControl3.default);
	
	ZoomControl.propTypes = {
	  position: _controlPosition2.default,
	  zoomInText: _propTypes2.default.string,
	  zoomInTitle: _propTypes2.default.string,
	  zoomOutText: _propTypes2.default.string,
	  zoomOutTitle: _propTypes2.default.string
	};
	exports.default = ZoomControl;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.viewport = exports.map = exports.layerContainer = exports.latlngList = exports.latlng = exports.controlPosition = exports.children = exports.bounds = undefined;
	
	var _bounds2 = __webpack_require__(93);
	
	var _bounds3 = _interopRequireDefault(_bounds2);
	
	var _children2 = __webpack_require__(18);
	
	var _children3 = _interopRequireDefault(_children2);
	
	var _controlPosition2 = __webpack_require__(73);
	
	var _controlPosition3 = _interopRequireDefault(_controlPosition2);
	
	var _latlng2 = __webpack_require__(45);
	
	var _latlng3 = _interopRequireDefault(_latlng2);
	
	var _latlngList2 = __webpack_require__(116);
	
	var _latlngList3 = _interopRequireDefault(_latlngList2);
	
	var _layerContainer2 = __webpack_require__(74);
	
	var _layerContainer3 = _interopRequireDefault(_layerContainer2);
	
	var _map2 = __webpack_require__(46);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _viewport2 = __webpack_require__(330);
	
	var _viewport3 = _interopRequireDefault(_viewport2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.bounds = _bounds3.default;
	exports.children = _children3.default;
	exports.controlPosition = _controlPosition3.default;
	exports.latlng = _latlng3.default;
	exports.latlngList = _latlngList3.default;
	exports.layerContainer = _layerContainer3.default;
	exports.map = _map3.default;
	exports.viewport = _viewport3.default;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(199);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(117);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(201);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(175);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(179);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(200);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(199);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(117);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(201);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(175);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(179);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(200);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(199);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(117);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(201);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(1049);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(175);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(179);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(200);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(1046);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(1047);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(1048);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(1052);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(331);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(117);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(1051);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(331);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1055);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bezierEasing = __webpack_require__(624);
	
	var _bezierEasing2 = _interopRequireDefault(_bezierEasing);
	
	var _windowScrollManager = __webpack_require__(340);
	
	var _windowScrollManager2 = _interopRequireDefault(_windowScrollManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Check if code is running in the browser (important for universal rendering)
	var WINDOW_EXISTS = typeof window !== 'undefined';
	
	// Regex that checks for numbers in string
	// formatted as "{number}{unit}" where unit is "px", "vh", "%" or none
	var START_END_DURATION_REGEX = /^-?\d+(\.\d+)?(px|vh|%)?$/;
	
	var DEFAULT_UNIT = 'px';
	var DEFAULT_ANGLE_UNIT = 'deg';
	var ANGLE_PROPERTIES = ['rotate', 'rotateX', 'rotateY', 'rotateZ', 'skew', 'skewX', 'skewY', 'skewZ', 'hueRotate'];
	
	var EASINGS = {
	  ease: [0.25, 0.1, 0.25, 1.0],
	  easeIn: [0.42, 0.0, 1.00, 1.0],
	  easeOut: [0.00, 0.0, 0.58, 1.0],
	  easeInOut: [0.42, 0.0, 0.58, 1.0],
	  easeInSine: [0.47, 0, 0.745, 0.715],
	  easeOutSine: [0.39, 0.575, 0.565, 1],
	  easeInOutSine: [0.445, 0.05, 0.55, 0.95],
	  easeInQuad: [0.55, 0.085, 0.68, 0.53],
	  easeOutQuad: [0.25, 0.46, 0.45, 0.94],
	  easeInOutQuad: [0.455, 0.03, 0.515, 0.955],
	  easeInCubic: [0.55, 0.055, 0.675, 0.19],
	  easeOutCubic: [0.215, 0.61, 0.355, 1],
	  easeInOutCubic: [0.645, 0.045, 0.355, 1],
	  easeInQuart: [0.895, 0.03, 0.685, 0.22],
	  easeOutQuart: [0.165, 0.84, 0.44, 1],
	  easeInOutQuart: [0.77, 0, 0.175, 1],
	  easeInQuint: [0.755, 0.05, 0.855, 0.06],
	  easeOutQuint: [0.23, 1, 0.32, 1],
	  easeInOutQuint: [0.86, 0, 0.07, 1],
	  easeInExpo: [0.95, 0.05, 0.795, 0.035],
	  easeOutExpo: [0.19, 1, 0.22, 1],
	  easeInOutExpo: [1, 0, 0, 1],
	  easeInCirc: [0.6, 0.04, 0.98, 0.335],
	  easeOutCirc: [0.075, 0.82, 0.165, 1],
	  easeInOutCirc: [0.785, 0.135, 0.15, 0.86]
	};
	
	// Color regexes
	
	// 0 - 199 | 200 - 249 | 250 - 255
	var REGEX_0_255 = '(1?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])';
	// 0.0 - 1.9999...
	var REGEX_0_1 = '([01](\\.\\d+)?)';
	// 00 - FF
	var REGEX_TWO_HEX_DIGITS = '([a-f\\d]{2})';
	
	var HEX_REGEX = new RegExp('^#' + REGEX_TWO_HEX_DIGITS + REGEX_TWO_HEX_DIGITS + REGEX_TWO_HEX_DIGITS + '$', 'i');
	var RGB_REGEX = new RegExp('^rgb\\(' + REGEX_0_255 + ',' + REGEX_0_255 + ',' + REGEX_0_255 + '\\)$', 'i');
	var RGBA_REGEX = new RegExp('^rgba\\(' + REGEX_0_255 + ',' + REGEX_0_255 + ',' + REGEX_0_255 + ',' + REGEX_0_1 + '\\)$', 'i');
	
	var SCROLL_OFFSET = 50;
	
	var RESIZE_DEBOUNCE_TIMEOUT = 150;
	
	// CSS transform map
	var TRANSFORM_MAP = {
	  rotate: function rotate(value) {
	    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_ANGLE_UNIT;
	    return 'rotate(' + value + unit + ')';
	  },
	  rotateX: function rotateX(value) {
	    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_ANGLE_UNIT;
	    return 'rotateX(' + value + unit + ')';
	  },
	  rotateY: function rotateY(value) {
	    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_ANGLE_UNIT;
	    return 'rotateY(' + value + unit + ')';
	  },
	  rotateZ: function rotateZ(value) {
	    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_ANGLE_UNIT;
	    return 'rotateZ(' + value + unit + ')';
	  },
	  scale: function scale(value) {
	    return 'scale(' + value + ')';
	  },
	  scaleX: function scaleX(value) {
	    return 'scaleX(' + value + ')';
	  },
	  scaleY: function scaleY(value) {
	    return 'scaleY(' + value + ')';
	  },
	  scaleZ: function scaleZ(value) {
	    return 'scaleZ(' + value + ')';
	  },
	  skew: function skew(value) {
	    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_UNIT;
	    return 'skew(' + value + unit + ')';
	  },
	  skewX: function skewX(value) {
	    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_UNIT;
	    return 'skewX(' + value + unit + ')';
	  },
	  skewY: function skewY(value) {
	    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_UNIT;
	    return 'skewY(' + value + unit + ')';
	  },
	  skewZ: function skewZ(value) {
	    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_UNIT;
	    return 'skewZ(' + value + unit + ')';
	  },
	  translateX: function translateX(value) {
	    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_UNIT;
	    return 'translateX(' + value + unit + ')';
	  },
	  translateY: function translateY(value) {
	    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_UNIT;
	    return 'translateY(' + value + unit + ')';
	  },
	  translateZ: function translateZ(value) {
	    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_UNIT;
	    return 'translateZ(' + value + unit + ')';
	  }
	};
	
	// Order of CSS transforms matters
	var ORDER_OF_TRANSFORMS = ['translateX', 'translateY', 'translateZ', 'skew', 'skewX', 'skewY', 'skewZ', 'rotate', 'rotateX', 'rotateY', 'rotateZ', 'scale', 'scaleX', 'scaleY', 'scaleZ'];
	
	// CSS properties that use color values
	var COLOR_PROPERTIES = ['backgroundColor', 'borderBottomColor', 'borderColor', 'borderLeftColor', 'borderRightColor', 'borderTopColor', 'color', 'fill', 'stroke'];
	
	// CSS filter map
	// blur()
	// brightness()
	// contrast()
	// grayscale()
	// hue-rotate()
	// invert()
	// opacity() // use opacityFilter
	// saturate()
	// sepia()
	
	// Not supported
	// drop-shadow()
	// url()
	var FILTER_MAP = {
	  blur: function blur(value) {
	    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_UNIT;
	    return 'blur(' + value + unit + ')';
	  },
	  brightness: function brightness(value) {
	    return 'brightness(' + value + ')';
	  },
	  contrast: function contrast(value) {
	    return 'contrast(' + value + ')';
	  },
	  grayscale: function grayscale(value) {
	    return 'grayscale(' + value + ')';
	  },
	  hueRotate: function hueRotate(value) {
	    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_ANGLE_UNIT;
	    return 'hue-rotate(' + value + unit + ')';
	  },
	  invert: function invert(value) {
	    return 'invert(' + value + ')';
	  },
	  opacityFilter: function opacityFilter(value) {
	    return 'opacity(' + value + ')';
	  },
	  saturate: function saturate(value) {
	    return 'saturate(' + value + ')';
	  },
	  sepia: function sepia(value) {
	    return 'sepia(' + value + ')';
	  }
	};
	
	var FILTER_PROPERTIES = ['blur', 'brightness', 'contrast', 'grayscale', 'hueRotate', 'invert', 'opacityFilter', 'saturate', 'sepia'];
	
	// Props to be removed from passing directly to the component element
	var PROPS_TO_OMIT = ['animateWhenNotInViewport', 'children', 'className', 'freeze', 'parallaxData', 'style', 'tagName', 'onPlxStart', 'onPlxEnd'];
	
	// Get element's top offset
	function getElementTop(el) {
	  var top = 0;
	  var element = el;
	
	  do {
	    top += element.offsetTop || 0;
	    element = element.offsetParent;
	  } while (element);
	
	  return top;
	}
	
	// Returns CSS unit
	function getUnit(property, unit) {
	  var propertyUnit = unit || DEFAULT_UNIT;
	
	  if (ANGLE_PROPERTIES.indexOf(property) >= 0) {
	    propertyUnit = unit || DEFAULT_ANGLE_UNIT;
	  }
	
	  return propertyUnit;
	}
	
	// Takes string value (in px/vh/%) and returns number
	function getValueInPx(value, maxScroll) {
	  var floatValue = parseFloat(value);
	  var unit = value.match(START_END_DURATION_REGEX)[2] || null;
	  var vh = window.innerHeight / 100;
	  var valueInPx = value;
	
	  switch (unit) {
	    case 'vh':
	      valueInPx = vh * floatValue;
	      break;
	    case '%':
	      valueInPx = maxScroll * floatValue / 100;
	      break;
	    default:
	      valueInPx = floatValue;
	  }
	
	  return valueInPx;
	}
	
	// Takes start/end/duration props
	// and return number (in pixels) based on prop type (number, string, dom element)
	function convertPropToPixels(propName, propValue, maxScroll) {
	  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	  var propValueInPx = propValue;
	  var isElement = propValue instanceof HTMLElement;
	  var keyCodes = {
	    ZERO: 48,
	    NINE: 57
	  };
	
	  if (typeof propValue === 'number') {
	    propValueInPx = propValue;
	  } else if (START_END_DURATION_REGEX.test(propValue)) {
	    propValueInPx = getValueInPx(propValue, maxScroll);
	  } else if (isElement || typeof propValue === 'string' && (propValue.charCodeAt(0) < keyCodes.ZERO || propValue.charCodeAt(0) > keyCodes.NINE)) {
	    var element = isElement ? propValue : document.querySelector(propValue);
	
	    if (!element) {
	      console.warn('Plx, ERROR: ' + propName + ' selector matches no elements: "' + propValue + '"'); // eslint-disable-line
	      return null;
	    }
	
	    if (propName === 'start' || propName === 'end') {
	      // START or END
	      // Element enters the viewport
	      propValueInPx = getElementTop(element) - window.innerHeight;
	    } else if (propName === 'duration') {
	      // DURATION
	      // Height of the element
	      propValueInPx = element.offsetHeight;
	    }
	  } else {
	    console.warn('Plx, ERROR: "' + propValue + '" is not a valid ' + propName + ' value, check documenation'); // eslint-disable-line
	    return null;
	  }
	
	  // Transform offset to px
	  var offsetInPx = 0;
	
	  if (typeof offset === 'number') {
	    offsetInPx = offset;
	  } else if (START_END_DURATION_REGEX.test(offset)) {
	    offsetInPx = getValueInPx(offset, maxScroll);
	  }
	  // Add offset
	  propValueInPx += offsetInPx;
	
	  if (propValueInPx < 0) {
	    propValueInPx = 0;
	  }
	
	  return propValueInPx;
	}
	
	// Convers color in hex format into object { r, g, b, a }
	function hexToObject(hex) {
	  // Convert #abc to #aabbcc
	  var color = hex.length === 4 ? '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3] : hex;
	  var result = HEX_REGEX.exec(color);
	
	  // Safety check, if color is in the wrong format
	  if (!result) {
	    console.warn('Plx, ERROR: hex color is not in the right format: "' + hex + '"'); // eslint-disable-line no-console
	    return null;
	  }
	
	  // All color functions are returning { r, g, b, a } object
	  return {
	    r: parseInt(result[1], 16),
	    g: parseInt(result[2], 16),
	    b: parseInt(result[3], 16),
	    a: 1
	  };
	}
	
	// Convers color in rgb format into object { r, g, b, a }
	function rgbToObject(rgb) {
	  var isRgba = rgb.toLowerCase().indexOf('rgba') === 0;
	  var color = rgb.replace(/ /g, '');
	  var result = isRgba ? RGBA_REGEX.exec(color) : RGB_REGEX.exec(color);
	
	  // Safety check, if color is in the wrong format
	  if (!result) {
	    console.warn('Plx, ERROR: rgb or rgba color is not in the right format: "' + rgb + '"'); // eslint-disable-line
	    return null;
	  }
	
	  // All color functions are returning { r, g, b, a } object
	  return {
	    r: parseInt(result[1], 10),
	    g: parseInt(result[2], 10),
	    b: parseInt(result[3], 10),
	    a: isRgba ? parseFloat(result[4]) : 1
	  };
	}
	
	// Calculates the current value for parallaxing property
	function parallax(scrollPosition, start, duration, startValue, endValue, easing) {
	  var min = startValue;
	  var max = endValue;
	  var invert = startValue > endValue;
	
	  // Safety check, if "startValue" is in the wrong format
	  if (typeof startValue !== 'number') {
	    console.warn('Plx, ERROR: startValue is not a number (type: "' + (typeof endValue === 'undefined' ? 'undefined' : _typeof(endValue)) + '", value: "' + endValue + '")'); // eslint-disable-line
	    return null;
	  }
	
	  // Safety check, if "endValue" is in the wrong format
	  if (typeof endValue !== 'number') {
	    console.warn('Plx, ERROR: endValue is not a number (type: "' + (typeof endValue === 'undefined' ? 'undefined' : _typeof(endValue)) + '", value: "' + endValue + '")'); // eslint-disable-line
	    return null;
	  }
	
	  // Safety check, if "duration" is in the wrong format
	  if (typeof duration !== 'number' || duration === 0) {
	    console.warn('Plx, ERROR: duration is zero or not a number (type: "' + (typeof duration === 'undefined' ? 'undefined' : _typeof(duration)) + '", value: "' + duration + '")'); // eslint-disable-line
	    return null;
	  }
	
	  if (invert) {
	    min = endValue;
	    max = startValue;
	  }
	
	  var percentage = (scrollPosition - start) / duration;
	
	  if (percentage > 1) {
	    percentage = 1;
	  } else if (percentage < 0) {
	    percentage = 0;
	  }
	
	  // Apply easing
	  if (easing) {
	    var easingPropType = typeof easing === 'undefined' ? 'undefined' : _typeof(easing);
	    if (easingPropType === 'object' && easing.length === 4) {
	      percentage = (0, _bezierEasing2.default)(easing[0], easing[1], easing[2], easing[3])(percentage);
	    } else if (easingPropType === 'string' && EASINGS[easing]) {
	      percentage = (0, _bezierEasing2.default)(EASINGS[easing][0], EASINGS[easing][1], EASINGS[easing][2], EASINGS[easing][3])(percentage);
	    } else if (easingPropType === 'function') {
	      percentage = easing(percentage);
	    }
	  }
	
	  var value = percentage * (max - min);
	
	  if (invert) {
	    value = max - value;
	  } else {
	    value += min;
	  }
	
	  return Math.floor(value * 100) / 100;
	}
	
	// Calculates current value for color parallax
	function colorParallax(scrollPosition, start, duration, startValue, endValue, easing) {
	  var startObject = null;
	  var endObject = null;
	
	  if (startValue[0].toLowerCase() === 'r') {
	    startObject = rgbToObject(startValue);
	  } else {
	    startObject = hexToObject(startValue);
	  }
	
	  if (endValue[0].toLowerCase() === 'r') {
	    endObject = rgbToObject(endValue);
	  } else {
	    endObject = hexToObject(endValue);
	  }
	
	  if (startObject && endObject) {
	    var r = parallax(scrollPosition, start, duration, startObject.r, endObject.r, easing);
	    var g = parallax(scrollPosition, start, duration, startObject.g, endObject.g, easing);
	    var b = parallax(scrollPosition, start, duration, startObject.b, endObject.b, easing);
	    var a = parallax(scrollPosition, start, duration, startObject.a, endObject.a, easing);
	
	    return 'rgba(' + parseInt(r, 10) + ', ' + parseInt(g, 10) + ', ' + parseInt(b, 10) + ', ' + a + ')';
	  }
	
	  return null;
	}
	
	// Applies property parallax to the style object
	function applyProperty(scrollPosition, propertyData, startPosition, duration, style, easing) {
	  var startValue = propertyData.startValue,
	      endValue = propertyData.endValue,
	      property = propertyData.property,
	      unit = propertyData.unit;
	
	  // If property is one of the color properties
	  // Use it's parallax method
	
	  var isColor = COLOR_PROPERTIES.indexOf(property) > -1;
	  var parallaxMethod = isColor ? colorParallax : parallax;
	
	  // Get new CSS value
	  var value = parallaxMethod(scrollPosition, startPosition, duration, startValue, endValue, easing);
	
	  // Get transform function
	  var transformMethod = TRANSFORM_MAP[property];
	  var filterMethod = FILTER_MAP[property];
	  var newStyle = style;
	
	  if (transformMethod) {
	    // Get CSS unit
	    var propertyUnit = getUnit(property, unit);
	    // Transforms, apply value to transform function
	    newStyle.transform[property] = transformMethod(value, propertyUnit);
	  } else if (filterMethod) {
	    // Get CSS unit
	    var _propertyUnit = getUnit(property, unit);
	    // Filters, apply value to filter function
	    newStyle.filter[property] = filterMethod(value, _propertyUnit);
	  } else {
	    // All other properties
	    newStyle[property] = value;
	
	    // Add unit if it is passed
	    if (unit) {
	      newStyle[property] += unit;
	    }
	  }
	
	  return newStyle;
	}
	
	// Returns CSS classes based on animation state
	function getClasses(lastSegmentScrolledBy, isInSegment, parallaxData) {
	  var cssClasses = null;
	
	  if (lastSegmentScrolledBy === null) {
	    cssClasses = 'Plx--above';
	  } else if (lastSegmentScrolledBy === parallaxData.length - 1 && !isInSegment) {
	    cssClasses = 'Plx--below';
	  } else if (lastSegmentScrolledBy !== null && isInSegment) {
	    var segmentName = parallaxData[lastSegmentScrolledBy].name || lastSegmentScrolledBy;
	
	    cssClasses = 'Plx--active Plx--in Plx--in-' + segmentName;
	  } else if (lastSegmentScrolledBy !== null && !isInSegment) {
	    var _segmentName = parallaxData[lastSegmentScrolledBy].name || lastSegmentScrolledBy;
	    var nextSegmentName = parallaxData[lastSegmentScrolledBy + 1].name || lastSegmentScrolledBy + 1;
	
	    cssClasses = 'Plx--active Plx--between Plx--between-' + _segmentName + '-and-' + nextSegmentName;
	  }
	
	  return cssClasses;
	}
	
	// Checks if class contains 'active'
	function checkIfActive(classes) {
	  return classes.indexOf('Plx--active') > -1;
	}
	
	// Omits "keysToOmit" from "object"
	function omit(object, keysToOmit) {
	  var result = {};
	
	  Object.keys(object).forEach(function (key) {
	    if (keysToOmit.indexOf(key) === -1) {
	      result[key] = object[key];
	    }
	  });
	
	  return result;
	}
	
	// Main update function
	// Returns new state object based on props and scroll position
	function getNewState(scrollPosition, props, state, element) {
	  var animateWhenNotInViewport = props.animateWhenNotInViewport,
	      disabled = props.disabled,
	      freeze = props.freeze,
	      parallaxData = props.parallaxData;
	  var showElement = state.showElement,
	      plxStyle = state.plxStyle,
	      plxStateClasses = state.plxStateClasses;
	
	  // Do nothing if animation is disabled, frozen
	  // or if element is not rendered yet
	
	  if (freeze && showElement || !element || disabled) {
	    return null;
	  }
	
	  // Check if element is in viewport
	  // Small offset is added to prevent page jumping
	  if (!animateWhenNotInViewport) {
	    var rect = element.getBoundingClientRect();
	    var isTopAboveBottomEdge = rect.top < window.innerHeight + SCROLL_OFFSET;
	    var isBottomBelowTopEdge = rect.top + rect.height > -SCROLL_OFFSET;
	
	    if (!isTopAboveBottomEdge || !isBottomBelowTopEdge) {
	      return null;
	    }
	  }
	
	  var newState = {};
	
	  // Style to be applied to our element
	  var newStyle = {
	    transform: {},
	    filter: {}
	  };
	
	  // This means "componentDidMount" did happen and that we should show our element
	  if (!showElement) {
	    newState.showElement = true;
	  }
	
	  var appliedProperties = [];
	  var segments = [];
	  var isInSegment = false;
	  var lastSegmentScrolledBy = null;
	  var bodyHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
	  var maxScroll = bodyHeight - window.innerHeight;
	
	  var _loop = function _loop(i) {
	    var _parallaxData$i = parallaxData[i],
	        duration = _parallaxData$i.duration,
	        easing = _parallaxData$i.easing,
	        endOffset = _parallaxData$i.endOffset,
	        properties = _parallaxData$i.properties,
	        startOffset = _parallaxData$i.startOffset;
	
	
	    var start = parallaxData[i].start === 'self' ? element : parallaxData[i].start;
	    var end = parallaxData[i].end === 'self' ? element : parallaxData[i].end;
	
	    var startInPx = convertPropToPixels('start', start, maxScroll, startOffset);
	    var durationInPx = null;
	    var endInPx = null;
	
	    // End has higher priority than duration
	    if (typeof end !== 'undefined') {
	      endInPx = convertPropToPixels('end', end, maxScroll, endOffset);
	      durationInPx = endInPx - startInPx;
	    } else {
	      durationInPx = convertPropToPixels('duration', duration, maxScroll);
	      endInPx = startInPx + durationInPx;
	    }
	
	    // If segment is below scroll position skip it
	    if (scrollPosition < startInPx) {
	      return 'break';
	    }
	
	    var isScrolledByStart = scrollPosition >= startInPx;
	
	    if (isScrolledByStart) {
	      lastSegmentScrolledBy = i;
	    }
	
	    // If active segment exists, apply his properties
	    if (scrollPosition >= startInPx && scrollPosition <= endInPx) {
	      isInSegment = true;
	
	      properties.forEach(function (propertyData) {
	        // eslint-disable-line no-loop-func
	        var property = propertyData.property;
	
	        // Save which properties are applied to the active segment
	        // So they are not re-applied for other segments
	
	        appliedProperties.push(property);
	
	        // Apply property style
	        newStyle = applyProperty(scrollPosition, propertyData, startInPx, durationInPx, newStyle, easing);
	      });
	    } else {
	      // Push non active segments above the scroll position to separate array
	      // This way "durationInPx" and "startInPx" are not calculated again
	      // and segments below scroll position are skipped in the next step
	      segments.push({
	        easing: easing,
	        durationInPx: durationInPx,
	        properties: properties,
	        startInPx: startInPx
	      });
	    }
	  };
	
	  for (var i = 0; i < parallaxData.length; i++) {
	    var _ret = _loop(i);
	
	    if (_ret === 'break') break;
	  }
	
	  // These are only segments that are completly above scroll position
	  segments.forEach(function (data) {
	    var easing = data.easing,
	        durationInPx = data.durationInPx,
	        properties = data.properties,
	        startInPx = data.startInPx;
	
	
	    properties.forEach(function (propertyData) {
	      var property = propertyData.property;
	
	      // Skip propery that was changed for active segment
	
	      if (appliedProperties.indexOf(property) > -1) {
	        return;
	      }
	
	      // These styles that are the ones changed by segments
	      // that are above active segment
	      newStyle = applyProperty(scrollPosition, propertyData, startInPx, durationInPx, newStyle, easing);
	    });
	  });
	
	  // Sort transforms by ORDER_OF_TRANSFORMS
	  // as order of CSS transforms matters
	  var transformsOrdered = [];
	
	  ORDER_OF_TRANSFORMS.forEach(function (transformKey) {
	    if (newStyle.transform[transformKey]) {
	      transformsOrdered.push(newStyle.transform[transformKey]);
	    }
	  });
	
	  // Concat transforms and add webkit prefix
	  newStyle.transform = transformsOrdered.join(' ');
	  newStyle.WebkitTransform = newStyle.transform;
	
	  var filtersArray = [];
	  FILTER_PROPERTIES.forEach(function (filterKey) {
	    if (newStyle.filter[filterKey]) {
	      filtersArray.push(newStyle.filter[filterKey]);
	    }
	  });
	
	  // Concat filters and add webkit prefix
	  newStyle.filter = filtersArray.join(' ');
	  newStyle.WebkitFilter = newStyle.filter;
	
	  // "Stupid" check if style should be updated
	  if (JSON.stringify(plxStyle) !== JSON.stringify(newStyle)) {
	    newState.plxStyle = newStyle;
	  }
	
	  // Adding state class
	  var newPlxStateClasses = getClasses(lastSegmentScrolledBy, isInSegment, parallaxData);
	
	  if (newPlxStateClasses !== plxStateClasses) {
	    newState.plxStateClasses = newPlxStateClasses;
	  }
	
	  if (Object.keys(newState).length) {
	    return newState;
	  }
	
	  return null;
	}
	
	var Plx = function (_Component) {
	  _inherits(Plx, _Component);
	
	  function Plx(props) {
	    _classCallCheck(this, Plx);
	
	    // Binding handlers
	    var _this = _possibleConstructorReturn(this, (Plx.__proto__ || Object.getPrototypeOf(Plx)).call(this, props));
	
	    _this.handleScrollChange = _this.handleScrollChange.bind(_this);
	    _this.handleResize = _this.handleResize.bind(_this);
	
	    _this.state = {
	      element: null,
	      showElement: false,
	      plxStateClasses: '',
	      plxStyle: {}
	    };
	
	    // Skipping type checking as PropTypes will give a warning if the props aren't functions
	    _this.plxStartEnabled = _this.props.onPlxStart !== null;
	    _this.plxEndEnabled = _this.props.onPlxEnd !== null;
	    return _this;
	  }
	
	  _createClass(Plx, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Get scroll manager singleton
	      this.scrollManager = new _windowScrollManager2.default();
	      // Add listeners
	      window.addEventListener('window-scroll', this.handleScrollChange);
	      window.addEventListener('resize', this.handleResize);
	
	      this.update();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var wasActive = checkIfActive(prevState.plxStateClasses);
	      var isActive = checkIfActive(this.state.plxStateClasses);
	      if (prevProps !== this.props) {
	        this.update();
	      }
	      if ((this.plxStartEnabled || this.plxEndEnabled) && prevState.plxStateClasses !== this.state.plxStateClasses) {
	        if (this.plxStartEnabled && !wasActive && isActive) {
	          this.props.onPlxStart();
	        } else if (this.plxEndEnabled && wasActive && !isActive) {
	          this.props.onPlxEnd();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('window-scroll', this.handleScrollChange);
	      window.removeEventListener('resize', this.handleResize);
	
	      clearTimeout(this.resizeDebounceTimeoutID);
	      this.resizeDebounceTimeoutID = null;
	
	      if (this.scrollManager) {
	        this.scrollManager.removeListener();
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this2 = this;
	
	      var scrollPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var currentScrollPosition = scrollPosition === null ? this.scrollManager.getScrollPosition().scrollPositionY : scrollPosition;
	
	      var newState = getNewState(currentScrollPosition, this.props, this.state, this.element);
	
	      if (newState) {
	        requestAnimationFrame(function () {
	          return _this2.setState(newState);
	        });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      var _this3 = this;
	
	      clearTimeout(this.resizeDebounceTimeoutID);
	      this.resizeDebounceTimeoutID = setTimeout(function () {
	        _this3.update();
	      }, RESIZE_DEBOUNCE_TIMEOUT);
	    }
	  }, {
	    key: 'handleScrollChange',
	    value: function handleScrollChange(e) {
	      this.update(e.detail.scrollPositionY);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          style = _props.style,
	          tagName = _props.tagName;
	      var _state = this.state,
	          showElement = _state.showElement,
	          plxStyle = _state.plxStyle,
	          plxStateClasses = _state.plxStateClasses;
	
	
	      var Tag = tagName;
	
	      var elementStyle = style;
	
	      if (!disabled) {
	        elementStyle = _extends({}, style, plxStyle, {
	          // Hide element before until it is rendered
	          // This prevents jumps if page is scrolled and then refreshed
	          visibility: showElement ? null : 'hidden'
	        });
	      }
	
	      return _react2.default.createElement(
	        Tag,
	        _extends({}, omit(this.props, PROPS_TO_OMIT), {
	          className: 'Plx ' + plxStateClasses + ' ' + className,
	          style: elementStyle,
	          ref: function ref(el) {
	            return _this4.element = el;
	          }
	        }),
	        children
	      );
	    }
	  }]);
	
	  return Plx;
	}(_react.Component);
	
	exports.default = Plx;
	
	
	var propertiesItemType = _propTypes2.default.shape({
	  startValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  endValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  property: _propTypes2.default.string.isRequired,
	  unit: _propTypes2.default.string
	});
	
	// Check for the universal rendering
	// HTMLElement in the proptypes breaks on server
	// https://github.com/Stanko/react-plx/issues/25
	var SafeHTMLElement = WINDOW_EXISTS ? window.HTMLElement : {};
	
	var parallaxDataType = _propTypes2.default.shape({
	  start: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.instanceOf(SafeHTMLElement)]).isRequired,
	  startOffset: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  duration: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.instanceOf(SafeHTMLElement)]),
	  end: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.instanceOf(SafeHTMLElement)]),
	  endOffset: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  properties: _propTypes2.default.arrayOf(propertiesItemType).isRequired,
	  easing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.func]),
	  name: _propTypes2.default.string
	});
	
	Plx.propTypes = {
	  animateWhenNotInViewport: _propTypes2.default.bool,
	  children: _propTypes2.default.any,
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  freeze: _propTypes2.default.bool,
	  parallaxData: _propTypes2.default.arrayOf(parallaxDataType),
	  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object])),
	  tagName: _propTypes2.default.string,
	  onPlxStart: _propTypes2.default.func,
	  onPlxEnd: _propTypes2.default.func
	};
	
	Plx.defaultProps = {
	  animateWhenNotInViewport: false,
	  children: null,
	  className: '',
	  disabled: false,
	  freeze: false,
	  parallaxData: [],
	  style: {},
	  tagName: 'div',
	  onPlxStart: null,
	  onPlxEnd: null
	};

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1056);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1054)();
	}


/***/ }),
/* 1056 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(54);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));
	
	    _this.state = { active: false };
	    _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    _this.portal = null;
	    _this.node = null;
	    return _this;
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('mouseup', this.handleOutsideMouseClick);
	        document.addEventListener('touchstart', this.handleOutsideMouseClick);
	      }
	
	      if (this.props.isOpened) {
	        this.openPortal();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      // portal's 'is open' state is handled through the prop isOpened
	      if (typeof newProps.isOpened !== 'undefined') {
	        if (newProps.isOpened) {
	          if (this.state.active) {
	            this.renderPortal(newProps);
	          } else {
	            this.openPortal(newProps);
	          }
	        }
	        if (!newProps.isOpened && this.state.active) {
	          this.closePortal();
	        }
	      }
	
	      // portal handles its own 'is open' state
	      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
	        this.renderPortal(newProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
	        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
	      }
	
	      this.closePortal(true);
	    }
	  }, {
	    key: 'handleWrapperClick',
	    value: function handleWrapperClick(e) {
	      e.preventDefault();
	      e.stopPropagation();
	      if (this.state.active) {
	        return;
	      }
	      this.openPortal();
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      this.setState({ active: true });
	      this.renderPortal(props);
	      this.props.onOpen(this.node);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      var _this2 = this;
	
	      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var resetPortalState = function resetPortalState() {
	        if (_this2.node) {
	          _reactDom2.default.unmountComponentAtNode(_this2.node);
	          document.body.removeChild(_this2.node);
	        }
	        _this2.portal = null;
	        _this2.node = null;
	        if (isUnmounted !== true) {
	          _this2.setState({ active: false });
	        }
	      };
	
	      if (this.state.active) {
	        if (this.props.beforeClose) {
	          this.props.beforeClose(this.node, resetPortalState);
	        } else {
	          resetPortalState();
	        }
	
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	
	      var root = (0, _reactDom.findDOMNode)(this.portal);
	      if (root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	
	      e.stopPropagation();
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.node) {
	        this.node = document.createElement('div');
	        document.body.appendChild(this.node);
	      }
	
	      var children = props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof props.children.type === 'function') {
	        children = _react2.default.cloneElement(props.children, { closePortal: this.closePortal });
	      }
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.openByClickOn) {
	        return _react2.default.cloneElement(this.props.openByClickOn, { onClick: this.handleWrapperClick });
	      }
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	exports.default = Portal;
	
	
	Portal.propTypes = {
	  children: _propTypes2.default.element.isRequired,
	  openByClickOn: _propTypes2.default.element,
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOutsideClick: _propTypes2.default.bool,
	  isOpened: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  beforeClose: _propTypes2.default.func,
	  onUpdate: _propTypes2.default.func
	};
	
	Portal.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {},
	  onUpdate: function onUpdate() {}
	};
	module.exports = exports['default'];


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NextArrow = exports.PrevArrow = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _innerSliderUtils = __webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PrevArrow =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PrevArrow).apply(this, arguments));
	  }
	
	  _createClass(PrevArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var prevClasses = {
	        "slick-arrow": true,
	        "slick-prev": true
	      };
	      var prevHandler = this.clickHandler.bind(this, {
	        message: "previous"
	      });
	
	      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	        prevClasses["slick-disabled"] = true;
	        prevHandler = null;
	      }
	
	      var prevArrowProps = {
	        key: "0",
	        "data-role": "none",
	        className: (0, _classnames.default)(prevClasses),
	        style: {
	          display: "block"
	        },
	        onClick: prevHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var prevArrow;
	
	      if (this.props.prevArrow) {
	        prevArrow = _react.default.cloneElement(this.props.prevArrow, _objectSpread({}, prevArrowProps, customProps));
	      } else {
	        prevArrow = _react.default.createElement("button", _extends({
	          key: "0",
	          type: "button"
	        }, prevArrowProps), " ", "Previous");
	      }
	
	      return prevArrow;
	    }
	  }]);
	
	  return PrevArrow;
	}(_react.default.PureComponent);
	
	exports.PrevArrow = PrevArrow;
	
	var NextArrow =
	/*#__PURE__*/
	function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(NextArrow).apply(this, arguments));
	  }
	
	  _createClass(NextArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var nextClasses = {
	        "slick-arrow": true,
	        "slick-next": true
	      };
	      var nextHandler = this.clickHandler.bind(this, {
	        message: "next"
	      });
	
	      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	        nextClasses["slick-disabled"] = true;
	        nextHandler = null;
	      }
	
	      var nextArrowProps = {
	        key: "1",
	        "data-role": "none",
	        className: (0, _classnames.default)(nextClasses),
	        style: {
	          display: "block"
	        },
	        onClick: nextHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var nextArrow;
	
	      if (this.props.nextArrow) {
	        nextArrow = _react.default.cloneElement(this.props.nextArrow, _objectSpread({}, nextArrowProps, customProps));
	      } else {
	        nextArrow = _react.default.createElement("button", _extends({
	          key: "1",
	          type: "button"
	        }, nextArrowProps), " ", "Next");
	      }
	
	      return nextArrow;
	    }
	  }]);
	
	  return NextArrow;
	}(_react.default.PureComponent);
	
	exports.NextArrow = NextArrow;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react.default.createElement("ul", {
	      style: {
	        display: "block"
	      }
	    }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react.default.createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	var _default = defaultProps;
	exports.default = _default;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dots = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Dots).apply(this, arguments));
	  }
	
	  _createClass(Dots, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      // In Autoplay the focus stays on clicked button even after transition
	      // to next slide. That only goes away by click somewhere outside
	      e.preventDefault();
	      this.props.clickHandler(options);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var dotCount = getDotCount({
	        slideCount: this.props.slideCount,
	        slidesToScroll: this.props.slidesToScroll,
	        slidesToShow: this.props.slidesToShow,
	        infinite: this.props.infinite
	      }); // Apply join & split to Array to pre-fill it for IE8
	      //
	      // Credit: http://stackoverflow.com/a/13735425/1849458
	
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
	        var leftBound = i * _this.props.slidesToScroll;
	        var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
	        var className = (0, _classnames.default)({
	          "slick-active": _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
	        });
	        var dotOptions = {
	          message: "dots",
	          index: i,
	          slidesToScroll: _this.props.slidesToScroll,
	          currentSlide: _this.props.currentSlide
	        };
	
	        var onClick = _this.clickHandler.bind(_this, dotOptions);
	
	        return _react.default.createElement("li", {
	          key: i,
	          className: className
	        }, _react.default.cloneElement(_this.props.customPaging(i), {
	          onClick: onClick
	        }));
	      });
	      return _react.default.cloneElement(this.props.appendDots(dots), _objectSpread({
	        className: this.props.dotsClass
	      }, mouseEvents));
	    }
	  }]);
	
	  return Dots;
	}(_react.default.PureComponent);
	
	exports.Dots = Dots;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _slider = _interopRequireDefault(__webpack_require__(1064));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _slider.default;
	exports.default = _default;

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false,
	  // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: {
	    startX: 0,
	    startY: 0,
	    curX: 0,
	    curY: 0
	  },
	  trackStyle: {},
	  trackWidth: 0
	};
	var _default = initialState;
	exports.default = _default;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InnerSlider = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(54));
	
	var _initialState = _interopRequireDefault(__webpack_require__(1062));
	
	var _lodash = _interopRequireDefault(__webpack_require__(270));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _innerSliderUtils = __webpack_require__(118);
	
	var _track = __webpack_require__(1065);
	
	var _dots = __webpack_require__(1060);
	
	var _arrows = __webpack_require__(1058);
	
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(1077));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InnerSlider =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  function InnerSlider(props) {
	    var _this;
	
	    _classCallCheck(this, InnerSlider);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(InnerSlider).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listRefHandler", function (ref) {
	      return _this.list = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "trackRefHandler", function (ref) {
	      return _this.track = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "adaptHeight", function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
	
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillMount", function () {
	      _this.ssrInit();
	
	      _this.props.onInit && _this.props.onInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidMount", function () {
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props);
	
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	
	      _this.ro = new _resizeObserverPolyfill.default(function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	
	
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	
	      _this.ro.observe(_this.list);
	
	      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      }); // To support server-side rendering
	
	      if (!window) {
	        return;
	      }
	
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillUnmount", function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	
	        _this.callbackTimers = [];
	      }
	
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillReceiveProps", function (nextProps) {
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, nextProps, _this.state);
	
	      var setTrackStyle = false;
	
	      var _arr = Object.keys(_this.props);
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var key = _arr[_i];
	
	        if (!nextProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	
	        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
	          continue;
	        }
	
	        if (nextProps[key] !== _this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react.default.Children.count(nextProps.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react.default.Children.count(nextProps.children) - nextProps.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	
	        if (nextProps.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidUpdate", function () {
	      _this.checkImagesLoad();
	
	      _this.props.onReInit && _this.props.onReInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      } // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	
	
	      _this.adaptHeight();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWindowResized", function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash.default)(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	
	      _this.debouncedResize();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resizeWindow", function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      if (!_reactDom.default.findDOMNode(_this.track)) return;
	
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props, _this.state);
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      }); // animating state should be cleared while resizing, otherwise autoplay stops working
	
	
	      _this.setState({
	        animating: false
	      });
	
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateState", function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _objectSpread({}, spec, updatedState, {
	        slideIndex: updatedState.currentSlide
	      });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _objectSpread({}, spec, {
	        left: targetLeft
	      });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	
	      if (setTrackStyle || _react.default.Children.count(_this.props.children) !== _react.default.Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	
	      _this.setState(updatedState, callback);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "ssrInit", function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	
	        for (var _i2 = 0; _i2 < postClones; _i2++) {
	          _trackWidth += childrenWidths[_i2];
	        }
	
	        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
	          _trackLeft += childrenWidths[_i3];
	        }
	
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	
	        if (_this.props.centerMode) {
	          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
	          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
	        }
	
	        _this.setState({
	          trackStyle: _trackStyle
	        });
	
	        return;
	      }
	
	      var childrenCount = _react.default.Children.count(_this.props.children);
	
	      var spec = _objectSpread({}, _this.props, _this.state, {
	        slideCount: childrenCount
	      });
	
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	
	      _this.setState({
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "checkImagesLoad", function () {
	      var images = document.querySelectorAll(".slick-slide img");
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "progressiveLazyLoad", function () {
	      var slidesToLoad = [];
	
	      var spec = _objectSpread({}, _this.props, _this.state);
	
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slideHandler", function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange; // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread({
	        index: index
	      }, _this.props, _this.state, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	
	      _this.setState(state, function () {
	        asNavFor && asNavFor.innerSlider.state.currentSlide !== _this.state.currentSlide && asNavFor.innerSlider.slideHandler(index);
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({
	                animating: animating
	              });
	            }, 10));
	
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "changeSlide", function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _objectSpread({}, _this.props, _this.state);
	
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clickHandler", function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "keyHandler", function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({
	        message: dir
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectHandler", function (options) {
	      _this.changeSlide(options);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "disableBodyScroll", function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	
	      window.ontouchmove = preventDefault;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "enableBodyScroll", function () {
	      window.ontouchmove = null;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "swipeStart", function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "swipeMove", function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "swipeEnd", function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	
	      _this.setState(state);
	
	      if (triggerSlideHandler === undefined) return;
	
	      _this.slideHandler(triggerSlideHandler);
	
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPrev", function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "previous"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickNext", function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "next"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "play", function () {
	      var nextIndex;
	
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_objectSpread({}, _this.props, _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "autoPlay", function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	
	      _this.setState({
	        autoplaying: "playing"
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "pause", function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (pauseType === "paused") {
	        _this.setState({
	          autoplaying: "paused"
	        });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "focused"
	          });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "hovered"
	          });
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDotsOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDotsLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTrackOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTrackLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSlideFocus", function () {
	      return _this.props.autoplay && _this.pause("focused");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSlideBlur", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
	      var className = (0, _classnames.default)("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	
	      var spec = _objectSpread({}, _this.props, _this.state);
	
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	      trackProps = _objectSpread({}, trackProps, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
	      });
	      var dots;
	
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	        dotProps = _objectSpread({}, dotProps, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = _react.default.createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = _react.default.createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = _react.default.createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _objectSpread({}, verticalHeightStyle, centerPaddingStyle);
	
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.swipeEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr"
	      };
	
	      if (_this.props.unslick) {
	        listProps = {
	          className: "slick-list"
	        };
	        innerSliderProps = {
	          className: className
	        };
	      }
	
	      return _react.default.createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", _react.default.createElement("div", _extends({
	        ref: _this.listRefHandler
	      }, listProps), _react.default.createElement(_track.Track, _extends({
	        ref: _this.trackRefHandler
	      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
	    });
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _objectSpread({}, _initialState.default, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react.default.Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    return _this;
	  }
	
	  return InnerSlider;
	}(_react.default.Component);
	
	exports.InnerSlider = InnerSlider;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _innerSlider = __webpack_require__(1063);
	
	var _json2mq = _interopRequireDefault(__webpack_require__(841));
	
	var _defaultProps = _interopRequireDefault(__webpack_require__(1059));
	
	var _innerSliderUtils = __webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(672);
	
	var Slider =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    var _this;
	
	    _classCallCheck(this, Slider);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "innerSliderRefHandler", function (ref) {
	      return _this.innerSlider = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPrev", function () {
	      return _this.innerSlider.slickPrev();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickNext", function () {
	      return _this.innerSlider.slickNext();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPause", function () {
	      return _this.innerSlider.pause("paused");
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPlay", function () {
	      return _this.innerSlider.autoPlay("play");
	    });
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: "media",
	    value: function media(query, handler) {
	      // javascript handler for  css media query
	      enquire.register(query, handler);
	
	      this._responsiveMediaHandlers.push({
	        query: query,
	        handler: handler
	      });
	    } // handles responsive breakpoints
	
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      // performance monitoring
	      //if (process.env.NODE_ENV !== 'production') {
	      //const { whyDidYouUpdate } = require('why-did-you-update')
	      //whyDidYouUpdate(React)
	      //}
	      if (this.props.responsive) {
	        var breakpoints = this.props.responsive.map(function (breakpt) {
	          return breakpt.breakpoint;
	        }); // sort them in increasing order of their numerical value
	
	        breakpoints.sort(function (x, y) {
	          return x - y;
	        });
	        breakpoints.forEach(function (breakpoint, index) {
	          // media query for each breakpoint
	          var bQuery;
	
	          if (index === 0) {
	            bQuery = (0, _json2mq.default)({
	              minWidth: 0,
	              maxWidth: breakpoint
	            });
	          } else {
	            bQuery = (0, _json2mq.default)({
	              minWidth: breakpoints[index - 1] + 1,
	              maxWidth: breakpoint
	            });
	          } // when not using server side rendering
	
	
	          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	            _this2.setState({
	              breakpoint: breakpoint
	            });
	          });
	        }); // Register media query for full screen. Need to support resize from small to large
	        // convert javascript object to media query string
	
	        var query = (0, _json2mq.default)({
	          minWidth: breakpoints.slice(-1)[0]
	        });
	        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	          _this2.setState({
	            breakpoint: null
	          });
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._responsiveMediaHandlers.forEach(function (obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var settings;
	      var newProps;
	
	      if (this.state.breakpoint) {
	        newProps = this.props.responsive.filter(function (resp) {
	          return resp.breakpoint === _this3.state.breakpoint;
	        });
	        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread({}, _defaultProps.default, this.props, newProps[0].settings);
	      } else {
	        settings = _objectSpread({}, _defaultProps.default, this.props);
	      } // force scrolling by one if centerMode is on
	
	
	      if (settings.centerMode) {
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToScroll = 1;
	      } // force showing one slide and scrolling by one if the fade mode is on
	
	
	      if (settings.fade) {
	        if (settings.slidesToShow > 1 && ("production") !== "production") {
	          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
	        }
	
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToShow = 1;
	        settings.slidesToScroll = 1;
	      } // makes sure that children is an array, even when there is only 1 child
	
	
	      var children = _react.default.Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
	      // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	
	
	      children = children.filter(function (child) {
	        if (typeof child === "string") {
	          return !!child.trim();
	        }
	
	        return !!child;
	      }); // rows and slidesPerRow logic is handled here
	
	      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	        settings.variableWidth = false;
	      }
	
	      var newChildren = [];
	      var currentWidth = null;
	
	      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	        var newSlide = [];
	
	        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	          var row = [];
	
	          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	            if (settings.variableWidth && children[k].props.style) {
	              currentWidth = children[k].props.style.width;
	            }
	
	            if (k >= children.length) break;
	            row.push(_react.default.cloneElement(children[k], {
	              key: 100 * i + 10 * j + k,
	              tabIndex: -1,
	              style: {
	                width: "".concat(100 / settings.slidesPerRow, "%"),
	                display: "inline-block"
	              }
	            }));
	          }
	
	          newSlide.push(_react.default.createElement("div", {
	            key: 10 * i + j
	          }, row));
	        }
	
	        if (settings.variableWidth) {
	          newChildren.push(_react.default.createElement("div", {
	            key: i,
	            style: {
	              width: currentWidth
	            }
	          }, newSlide));
	        } else {
	          newChildren.push(_react.default.createElement("div", {
	            key: i
	          }, newSlide));
	        }
	      }
	
	      if (settings === "unslick") {
	        var className = "regular slider " + (this.props.className || "");
	        return _react.default.createElement("div", {
	          className: className
	        }, newChildren);
	      } else if (newChildren.length <= settings.slidesToShow) {
	        settings.unslick = true;
	      }
	
	      return _react.default.createElement(_innerSlider.InnerSlider, _extends({
	        ref: this.innerSliderRefHandler
	      }, settings), newChildren);
	    }
	  }]);
	
	  return Slider;
	}(_react.default.Component);
	
	exports.default = Slider;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Track = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _innerSliderUtils = __webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	
	  var slickCurrent = index === spec.currentSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	
	  var childrenCount = _react.default.Children.count(spec.children);
	
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react.default.Children.forEach(spec.children, function (elem, index) {
	    var child;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    }; // in case of lazyLoad, whether or not we want to fetch the slide
	
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react.default.createElement("div", null);
	    }
	
	    var childStyle = getSlideStyle(_objectSpread({}, spec, {
	      index: index
	    }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_objectSpread({}, spec, {
	      index: index
	    })); // push a cloned element of the desired slide
	
	    slides.push(_react.default.cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames.default)(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _objectSpread({
	        outline: "none"
	      }, child.props.style || {}, childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    })); // if slide needs to be precloned or postcloned
	
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	
	        if (key >= startIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread({}, spec, {
	          index: key
	        }));
	        preCloneSlides.push(_react.default.cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	
	        if (key < endIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread({}, spec, {
	          index: key
	        }));
	        postCloneSlides.push(_react.default.cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Track).apply(this, arguments));
	  }
	
	  _createClass(Track, [{
	    key: "render",
	    value: function render() {
	      var slides = renderSlides(this.props);
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      return _react.default.createElement("div", _extends({
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents), slides);
	    }
	  }]);
	
	  return Track;
	}(_react.default.PureComponent);
	
	exports.Track = Track;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _renderPropsVersion = _interopRequireDefault(__webpack_require__(333));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function Sticky(props) {
	  var mode = props.mode,
	      onFixedToggle = props.onFixedToggle,
	      hideOnBoundaryHit = props.hideOnBoundaryHit,
	      offsetTransforms = props.offsetTransforms,
	      disabled = props.disabled,
	      boundaryElement = props.boundaryElement,
	      scrollElement = props.scrollElement,
	      bottomOffset = props.bottomOffset,
	      topOffset = props.topOffset,
	      positionRecheckInterval = props.positionRecheckInterval,
	      children = props.children,
	      isIOSFixEnabled = props.isIOSFixEnabled,
	      dontUpdateHolderHeightWhenSticky = props.dontUpdateHolderHeightWhenSticky,
	      wrapperClassName = props.wrapperClassName,
	      stickyClassName = props.stickyClassName,
	      stickyStyle = props.stickyStyle,
	      rest = _objectWithoutPropertiesLoose(props, ["mode", "onFixedToggle", "hideOnBoundaryHit", "offsetTransforms", "disabled", "boundaryElement", "scrollElement", "bottomOffset", "topOffset", "positionRecheckInterval", "children", "isIOSFixEnabled", "dontUpdateHolderHeightWhenSticky", "wrapperClassName", "stickyClassName", "stickyStyle"]);
	
	  return /*#__PURE__*/_react.default.createElement(_renderPropsVersion.default, {
	    mode: mode,
	    onFixedToggle: onFixedToggle,
	    hideOnBoundaryHit: hideOnBoundaryHit,
	    offsetTransforms: offsetTransforms,
	    disabled: disabled,
	    boundaryElement: boundaryElement,
	    scrollElement: scrollElement,
	    bottomOffset: bottomOffset,
	    topOffset: topOffset,
	    positionRecheckInterval: positionRecheckInterval,
	    isIOSFixEnabled: isIOSFixEnabled,
	    dontUpdateHolderHeightWhenSticky: dontUpdateHolderHeightWhenSticky
	  }, function (_ref) {
	    var isFixed = _ref.isFixed,
	        wrapperStyles = _ref.wrapperStyles,
	        wrapperRef = _ref.wrapperRef,
	        holderStyles = _ref.holderStyles,
	        holderRef = _ref.holderRef;
	    return /*#__PURE__*/_react.default.createElement("div", _extends({}, rest, {
	      ref: holderRef,
	      style: holderStyles
	    }), /*#__PURE__*/_react.default.createElement("div", _extends({}, rest, {
	      className: wrapperClassName + " " + (isFixed ? stickyClassName : ''),
	      style: // $FlowFixMe - flow does not like when we merge 2 inexact objects
	      isFixed ? _extends({}, wrapperStyles, stickyStyle) : wrapperStyles,
	      ref: wrapperRef
	    }), children));
	  });
	}
	
	Sticky.defaultProps = {
	  stickyClassName: 'sticky',
	  wrapperClassName: '',
	  stickyStyle: {}
	};
	var _default = Sticky;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.listen = listen;
	exports.unlisten = unlisten;
	////////////////////////////////////////////////////////////////////////////////////////
	// Small helpers that provide an easy and efficient way to add/remove event listeners //
	////////////////////////////////////////////////////////////////////////////////////////
	var elementsWithListeners = [];
	var registeredListeners = [];
	
	function createListener(el) {
	  return {
	    el: el,
	    callbacks: {},
	    realCallbacks: {},
	    realListenersCnt: 0
	  };
	}
	
	function addCallback(listener, event, cb) {
	  if (listener.callbacks[event]) {
	    if (listener.callbacks[event].indexOf(cb) === -1) {
	      listener.callbacks[event].push(cb);
	    }
	
	    return;
	  }
	
	  listener.callbacks[event] = [cb];
	
	  listener.realCallbacks[event] = function (e) {
	    for (var i = 0, l = listener.callbacks[event].length; i < l; i += 1) {
	      listener.callbacks[event][i](e);
	    }
	  };
	
	  listener.el.addEventListener(event, listener.realCallbacks[event]);
	  listener.realListenersCnt += 1;
	}
	
	function removeCallback(listener, event, cb) {
	  if (!listener.callbacks[event]) {
	    return;
	  }
	
	  var idx = listener.callbacks[event].indexOf(cb);
	
	  if (idx === -1) {
	    return;
	  }
	
	  listener.callbacks[event].splice(idx, 1);
	
	  if (listener.callbacks[event].length > 0) {
	    return;
	  } // no more listeners, lets clean up
	
	
	  listener.el.removeEventListener(event, listener.realCallbacks[event]);
	  delete listener.callbacks[event];
	  delete listener.realCallbacks[event];
	  listener.realListenersCnt -= 1;
	}
	
	function addListener(el, event, cb) {
	  var idx = elementsWithListeners.indexOf(el);
	
	  if (idx === -1) {
	    idx = elementsWithListeners.length;
	    elementsWithListeners.push(el);
	    registeredListeners.push(createListener(el));
	  }
	
	  var listener = registeredListeners[idx];
	  addCallback(listener, event, cb);
	}
	
	function removeListener(el, event, cb) {
	  var idx = elementsWithListeners.indexOf(el);
	
	  if (idx === -1) {
	    return;
	  }
	
	  var listener = registeredListeners[idx];
	  removeCallback(listener, event, cb);
	
	  if (listener.realListenersCnt > 0) {
	    return;
	  } // no more listeners lets clean up
	
	
	  elementsWithListeners.splice(idx, 1);
	  registeredListeners.splice(idx, 1);
	}
	/**
	 * Subscribe cb to events list
	 * @param  {HTMLElement}   el       target element
	 * @param  {Array}         events   array of event names
	 * @param  {Function} cb   callback that should be called
	 */
	
	
	function listen(el, events, cb) {
	  for (var i = 0, l = events.length; i < l; i += 1) {
	    addListener(el, events[i], cb);
	  }
	}
	/**
	 * Unsubscribe cb from events list
	 * @param  {HTMLElement}   el       target element
	 * @param  {Array}         events   array of event names
	 * @param  {Function} cb   callback that should be unsubscribed
	 */
	
	
	function unlisten(el, events, cb) {
	  for (var i = 0, l = events.length; i < l; i += 1) {
	    removeListener(el, events[i], cb);
	  }
	}

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = find;
	var basicSelectors = {};
	
	if (typeof document !== 'undefined') {
	  basicSelectors.body = document.body;
	  basicSelectors.window = window;
	  basicSelectors.document = document;
	}
	
	var matchesMethodName = function () {
	  if (typeof document !== 'undefined' && document.body) {
	    var body = document.body;
	    return typeof body.matches === 'function' ? 'matches' : // $FlowFixMe - flow doesn't like vendors, so do I, but we have to support such case
	    typeof body.webkitMatchesSelector === 'function' ? 'webkitMatchesSelector' : //webkit
	    // $FlowFixMe - see above
	    typeof body.mozMatchesSelector === 'function' ? 'mozMatchesSelector' : //mozilla
	    // $FlowFixMe - see above
	    typeof body.msMatchesSelector === 'function' ? 'msMatchesSelector' : //ie
	    // $FlowFixMe - see above
	    typeof body.oMatchesSelector === 'function' ? 'oMatchesSelector' : //old opera
	    null;
	  }
	
	  return null;
	}();
	
	function find(selector, el) {
	  if (!selector) {
	    return null;
	  }
	
	  if (basicSelectors.hasOwnProperty(selector)) {
	    return basicSelectors[selector];
	  } // select by id
	
	
	  if (selector[0] === '#') {
	    return document.getElementById(selector.slice(1));
	  }
	
	  if (matchesMethodName === null) {
	    return null;
	  }
	
	  var temp = el; // eslint-disable-next-line no-cond-assign
	
	  while (temp = temp.parentElement) {
	    // $FlowFixMe - flow does not approve it, but it works fine :)
	    if (temp[matchesMethodName](selector)) {
	      return temp || null;
	    }
	  } // nothing has been found :(
	
	
	  return null;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getClosestTransformedParent;
	
	function getClosestTransformedParent(el) {
	  do {
	    var style = window.getComputedStyle(el);
	    if (style.transform !== 'none' || style.webkitTransform !== 'none') return el; // $FlowFixMe - it's fine
	
	    el = el.parentElement || el.parentNode;
	  } while (el !== null && el.nodeType === 1);
	
	  return null;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.getRect = getRect;
	exports.isIntersecting = isIntersecting;
	exports.infiniteRect = void 0;
	var infiniteRect = {
	  top: -Infinity,
	  bottom: Infinity,
	  height: Infinity,
	  left: -Infinity,
	  right: Infinity,
	  width: Infinity
	};
	exports.infiniteRect = infiniteRect;
	
	function getRect(el) {
	  if (el && typeof el.getBoundingClientRect === 'function') {
	    return el.getBoundingClientRect();
	  }
	
	  if (el === window || el === document) {
	    return {
	      top: 0,
	      left: 0,
	      bottom: window.innerHeight,
	      height: window.innerHeight,
	      width: window.innerWidth,
	      right: window.innerWidth
	    };
	  }
	
	  return {
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    width: 0,
	    height: 0
	  };
	}
	
	function isIntersecting(r1, r2, topOffset, bottomOffset) {
	  var r1Top = r1.top + topOffset,
	      r1Bottom = r1.bottom + bottomOffset;
	  return r1Top >= r2.top && r1Top <= r2.bottom || r1Bottom >= r2.top && r1Bottom <= r2.bottom || r1Bottom >= r2.bottom && r1Top <= r2.top;
	}

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _renderPropsVersion = _interopRequireDefault(__webpack_require__(333));
	
	exports.RenderPropSticky = _renderPropsVersion.default;
	
	var _basicVersion = _interopRequireDefault(__webpack_require__(1066));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _basicVersion.default;
	exports.default = _default;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(334);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(1073);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(335);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(664);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(666);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(668);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(667);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(54);
	
	var _PropTypes = __webpack_require__(335);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CSSTransitionGroup = __webpack_require__(1072);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _TransitionGroup = __webpack_require__(334);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  TransitionGroup: _TransitionGroup2.default,
	  CSSTransitionGroup: _CSSTransitionGroup2.default
	};

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

	// easing functions from "Tween.js"
	exports.linear = function(n){
	  return n;
	};
	
	exports.inQuad = function(n){
	  return n * n;
	};
	
	exports.outQuad = function(n){
	  return n * (2 - n);
	};
	
	exports.inOutQuad = function(n){
	  n *= 2;
	  if (n < 1) return 0.5 * n * n;
	  return - 0.5 * (--n * (n - 2) - 1);
	};
	
	exports.inCube = function(n){
	  return n * n * n;
	};
	
	exports.outCube = function(n){
	  return --n * n * n + 1;
	};
	
	exports.inOutCube = function(n){
	  n *= 2;
	  if (n < 1) return 0.5 * n * n * n;
	  return 0.5 * ((n -= 2 ) * n * n + 2);
	};
	
	exports.inQuart = function(n){
	  return n * n * n * n;
	};
	
	exports.outQuart = function(n){
	  return 1 - (--n * n * n * n);
	};
	
	exports.inOutQuart = function(n){
	  n *= 2;
	  if (n < 1) return 0.5 * n * n * n * n;
	  return -0.5 * ((n -= 2) * n * n * n - 2);
	};
	
	exports.inQuint = function(n){
	  return n * n * n * n * n;
	}
	
	exports.outQuint = function(n){
	  return --n * n * n * n * n + 1;
	}
	
	exports.inOutQuint = function(n){
	  n *= 2;
	  if (n < 1) return 0.5 * n * n * n * n * n;
	  return 0.5 * ((n -= 2) * n * n * n * n + 2);
	};
	
	exports.inSine = function(n){
	  return 1 - Math.cos(n * Math.PI / 2 );
	};
	
	exports.outSine = function(n){
	  return Math.sin(n * Math.PI / 2);
	};
	
	exports.inOutSine = function(n){
	  return .5 * (1 - Math.cos(Math.PI * n));
	};
	
	exports.inExpo = function(n){
	  return 0 == n ? 0 : Math.pow(1024, n - 1);
	};
	
	exports.outExpo = function(n){
	  return 1 == n ? n : 1 - Math.pow(2, -10 * n);
	};
	
	exports.inOutExpo = function(n){
	  if (0 == n) return 0;
	  if (1 == n) return 1;
	  if ((n *= 2) < 1) return .5 * Math.pow(1024, n - 1);
	  return .5 * (-Math.pow(2, -10 * (n - 1)) + 2);
	};
	
	exports.inCirc = function(n){
	  return 1 - Math.sqrt(1 - n * n);
	};
	
	exports.outCirc = function(n){
	  return Math.sqrt(1 - (--n * n));
	};
	
	exports.inOutCirc = function(n){
	  n *= 2
	  if (n < 1) return -0.5 * (Math.sqrt(1 - n * n) - 1);
	  return 0.5 * (Math.sqrt(1 - (n -= 2) * n) + 1);
	};
	
	exports.inBack = function(n){
	  var s = 1.70158;
	  return n * n * (( s + 1 ) * n - s);
	};
	
	exports.outBack = function(n){
	  var s = 1.70158;
	  return --n * n * ((s + 1) * n + s) + 1;
	};
	
	exports.inOutBack = function(n){
	  var s = 1.70158 * 1.525;
	  if ( ( n *= 2 ) < 1 ) return 0.5 * ( n * n * ( ( s + 1 ) * n - s ) );
	  return 0.5 * ( ( n -= 2 ) * n * ( ( s + 1 ) * n + s ) + 2 );
	};
	
	exports.inBounce = function(n){
	  return 1 - exports.outBounce(1 - n);
	};
	
	exports.outBounce = function(n){
	  if ( n < ( 1 / 2.75 ) ) {
	    return 7.5625 * n * n;
	  } else if ( n < ( 2 / 2.75 ) ) {
	    return 7.5625 * ( n -= ( 1.5 / 2.75 ) ) * n + 0.75;
	  } else if ( n < ( 2.5 / 2.75 ) ) {
	    return 7.5625 * ( n -= ( 2.25 / 2.75 ) ) * n + 0.9375;
	  } else {
	    return 7.5625 * ( n -= ( 2.625 / 2.75 ) ) * n + 0.984375;
	  }
	};
	
	exports.inOutBounce = function(n){
	  if (n < .5) return exports.inBounce(n * 2) * .5;
	  return exports.outBounce(n * 2 - 1) * .5 + .5;
	};
	
	exports.inElastic = function(n){
	  var s, a = 0.1, p = 0.4;
	  if ( n === 0 ) return 0;
	  if ( n === 1 ) return 1;
	  if ( !a || a < 1 ) { a = 1; s = p / 4; }
	  else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
	  return - ( a * Math.pow( 2, 10 * ( n -= 1 ) ) * Math.sin( ( n - s ) * ( 2 * Math.PI ) / p ) );
	};
	
	exports.outElastic = function(n){
	  var s, a = 0.1, p = 0.4;
	  if ( n === 0 ) return 0;
	  if ( n === 1 ) return 1;
	  if ( !a || a < 1 ) { a = 1; s = p / 4; }
	  else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
	  return ( a * Math.pow( 2, - 10 * n) * Math.sin( ( n - s ) * ( 2 * Math.PI ) / p ) + 1 );
	};
	
	exports.inOutElastic = function(n){
	  var s, a = 0.1, p = 0.4;
	  if ( n === 0 ) return 0;
	  if ( n === 1 ) return 1;
	  if ( !a || a < 1 ) { a = 1; s = p / 4; }
	  else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
	  if ( ( n *= 2 ) < 1 ) return - 0.5 * ( a * Math.pow( 2, 10 * ( n -= 1 ) ) * Math.sin( ( n - s ) * ( 2 * Math.PI ) / p ) );
	  return a * Math.pow( 2, -10 * ( n -= 1 ) ) * Math.sin( ( n - s ) * ( 2 * Math.PI ) / p ) * 0.5 + 1;
	};
	
	// aliases
	exports['in-quad'] = exports.inQuad;
	exports['out-quad'] = exports.outQuad;
	exports['in-out-quad'] = exports.inOutQuad;
	exports['in-cube'] = exports.inCube;
	exports['out-cube'] = exports.outCube;
	exports['in-out-cube'] = exports.inOutCube;
	exports['in-quart'] = exports.inQuart;
	exports['out-quart'] = exports.outQuart;
	exports['in-out-quart'] = exports.inOutQuart;
	exports['in-quint'] = exports.inQuint;
	exports['out-quint'] = exports.outQuint;
	exports['in-out-quint'] = exports.inOutQuint;
	exports['in-sine'] = exports.inSine;
	exports['out-sine'] = exports.outSine;
	exports['in-out-sine'] = exports.inOutSine;
	exports['in-expo'] = exports.inExpo;
	exports['out-expo'] = exports.outExpo;
	exports['in-out-expo'] = exports.inOutExpo;
	exports['in-circ'] = exports.inCirc;
	exports['out-circ'] = exports.outCirc;
	exports['in-out-circ'] = exports.inOutCirc;
	exports['in-back'] = exports.inBack;
	exports['out-back'] = exports.outBack;
	exports['in-out-back'] = exports.inOutBack;
	exports['in-bounce'] = exports.inBounce;
	exports['out-bounce'] = exports.outBounce;
	exports['in-out-bounce'] = exports.inOutBounce;
	exports['in-elastic'] = exports.inElastic;
	exports['out-elastic'] = exports.outElastic;
	exports['in-out-elastic'] = exports.inOutElastic;


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	
	  // Remove event specific arrays for event types that no
	  // one is subscribed for to avoid memory leak.
	  if (callbacks.length === 0) {
	    delete this._callbacks['$' + event];
	  }
	
	  return this;
	};
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};
	
	if (true) {
	  module.exports = Emitter;
	}


/***/ }),
/* 1080 */
959,
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1080)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	var Tween = __webpack_require__(1083);
	var raf = __webpack_require__(1081);
	
	function scroll() {
	  var y = window.pageYOffset || document.documentElement.scrollTop;
	  var x = window.pageXOffset || document.documentElement.scrollLeft;
	  return { top: y, left: x };
	}
	
	function scrollTo(x, y, options) {
	  options = options || {};
	
	  // start position
	  var start = scroll();
	
	  // setup tween
	  var tween = Tween(start)
	    .ease(options.ease || 'out-circ')
	    .to({ top: y, left: x })
	    .duration(options.duration || 1000);
	
	  // scroll
	  tween.update(function(o){
	    window.scrollTo(o.left | 0, o.top | 0);
	  });
	
	  // handle end
	  tween.on('end', function(){
	    animate = function(){};
	  });
	
	  // animate
	  function animate() {
	    raf(animate);
	    tween.update();
	  }
	
	  animate();
	
	  return tween;
	}
	
	module.exports = scrollTo;


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	var ease = __webpack_require__(1078);
	var Emitter = __webpack_require__(1079);
	
	function extend(obj, src) {
	  for (var key in src) {
	    if (src.hasOwnProperty(key)) obj[key] = src[key];
	  }
	  return obj;
	}
	
	function Tween(obj) {
	  if (!(this instanceof Tween)) return new Tween(obj);
	  this._from = obj;
	  this.ease('linear');
	  this.duration(500);
	}
	
	Emitter(Tween.prototype);
	
	Tween.prototype.reset = function(){
	  this.isArray = Object.prototype.toString.call(this._from) === '[object Array]';
	  this._curr = extend({}, this._from);
	  this._done = false;
	  this._start = Date.now();
	  return this;
	};
	
	Tween.prototype.to = function(obj){
	  this.reset();
	  this._to = obj;
	  return this;
	};
	
	Tween.prototype.duration = function(ms){
	  this._duration = ms;
	  return this;
	};
	
	Tween.prototype.ease = function(fn){
	  fn = 'function' == typeof fn ? fn : ease[fn];
	  if (!fn) throw new TypeError('invalid easing function');
	  this._ease = fn;
	  return this;
	};
	
	Tween.prototype.stop = function(){
	  this.stopped = true;
	  this._done = true;
	  this.emit('stop');
	  this.emit('end');
	  return this;
	};
	
	Tween.prototype.step = function(){
	  if (this._done) return;
	
	  var duration = this._duration;
	  var now = Date.now();
	  var delta = now - this._start;
	  var done = delta >= duration;
	
	  if (done) {
	    this._from = this._to;
	    this._update(this._to);
	    this._done = true;
	    this.emit('end');
	    return this;
	  }
	
	  var from = this._from;
	  var to = this._to;
	  var curr = this._curr;
	  var fn = this._ease;
	  var p = (now - this._start) / duration;
	  var n = fn(p);
	
	  if (this.isArray) {
	    for (var i = 0; i < from.length; ++i) {
	      curr[i] = from[i] + (to[i] - from[i]) * n;
	    }
	
	    this._update(curr);
	    return this;
	  }
	
	  for (var k in from) {
	    curr[k] = from[k] + (to[k] - from[k]) * n;
	  }
	
	  this._update(curr);
	  return this;
	};
	
	Tween.prototype.update = function(fn){
	  if (0 == arguments.length) return this.step();
	  this._update = fn;
	  return this;
	};
	
	module.exports = Tween;


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * smoothscroll polyfill - v0.3.5
	 * https://iamdustan.github.io/smoothscroll
	 * 2016 (c) Dustan Kasten, Jeremias Menichelli - MIT License
	 */
	
	(function(w, d, undefined) {
	  'use strict';
	
	  /*
	   * aliases
	   * w: window global object
	   * d: document
	   * undefined: undefined
	   */
	
	  // polyfill
	  function polyfill() {
	    // return when scrollBehavior interface is supported
	    if ('scrollBehavior' in d.documentElement.style) {
	      return;
	    }
	
	    /*
	     * globals
	     */
	    var Element = w.HTMLElement || w.Element;
	    var SCROLL_TIME = 468;
	
	    /*
	     * object gathering original scroll methods
	     */
	    var original = {
	      scroll: w.scroll || w.scrollTo,
	      scrollBy: w.scrollBy,
	      elScroll: Element.prototype.scroll || scrollElement,
	      scrollIntoView: Element.prototype.scrollIntoView
	    };
	
	    /*
	     * define timing method
	     */
	    var now = w.performance && w.performance.now
	      ? w.performance.now.bind(w.performance) : Date.now;
	
	    /**
	     * changes scroll position inside an element
	     * @method scrollElement
	     * @param {Number} x
	     * @param {Number} y
	     */
	    function scrollElement(x, y) {
	      this.scrollLeft = x;
	      this.scrollTop = y;
	    }
	
	    /**
	     * returns result of applying ease math function to a number
	     * @method ease
	     * @param {Number} k
	     * @returns {Number}
	     */
	    function ease(k) {
	      return 0.5 * (1 - Math.cos(Math.PI * k));
	    }
	
	    /**
	     * indicates if a smooth behavior should be applied
	     * @method shouldBailOut
	     * @param {Number|Object} x
	     * @returns {Boolean}
	     */
	    function shouldBailOut(x) {
	      if (typeof x !== 'object'
	            || x === null
	            || x.behavior === undefined
	            || x.behavior === 'auto'
	            || x.behavior === 'instant') {
	        // first arg not an object/null
	        // or behavior is auto, instant or undefined
	        return true;
	      }
	
	      if (typeof x === 'object'
	            && x.behavior === 'smooth') {
	        // first argument is an object and behavior is smooth
	        return false;
	      }
	
	      // throw error when behavior is not supported
	      throw new TypeError('behavior not valid');
	    }
	
	    /**
	     * finds scrollable parent of an element
	     * @method findScrollableParent
	     * @param {Node} el
	     * @returns {Node} el
	     */
	    function findScrollableParent(el) {
	      var isBody;
	      var hasScrollableSpace;
	      var hasVisibleOverflow;
	
	      do {
	        el = el.parentNode;
	
	        // set condition variables
	        isBody = el === d.body;
	        hasScrollableSpace =
	          el.clientHeight < el.scrollHeight ||
	          el.clientWidth < el.scrollWidth;
	        hasVisibleOverflow =
	          w.getComputedStyle(el, null).overflow === 'visible';
	      } while (!isBody && !(hasScrollableSpace && !hasVisibleOverflow));
	
	      isBody = hasScrollableSpace = hasVisibleOverflow = null;
	
	      return el;
	    }
	
	    /**
	     * self invoked function that, given a context, steps through scrolling
	     * @method step
	     * @param {Object} context
	     */
	    function step(context) {
	      var time = now();
	      var value;
	      var currentX;
	      var currentY;
	      var elapsed = (time - context.startTime) / SCROLL_TIME;
	
	      // avoid elapsed times higher than one
	      elapsed = elapsed > 1 ? 1 : elapsed;
	
	      // apply easing to elapsed time
	      value = ease(elapsed);
	
	      currentX = context.startX + (context.x - context.startX) * value;
	      currentY = context.startY + (context.y - context.startY) * value;
	
	      context.method.call(context.scrollable, currentX, currentY);
	
	      // scroll more if we have not reached our destination
	      if (currentX !== context.x || currentY !== context.y) {
	        w.requestAnimationFrame(step.bind(w, context));
	      }
	    }
	
	    /**
	     * scrolls window with a smooth behavior
	     * @method smoothScroll
	     * @param {Object|Node} el
	     * @param {Number} x
	     * @param {Number} y
	     */
	    function smoothScroll(el, x, y) {
	      var scrollable;
	      var startX;
	      var startY;
	      var method;
	      var startTime = now();
	
	      // define scroll context
	      if (el === d.body) {
	        scrollable = w;
	        startX = w.scrollX || w.pageXOffset;
	        startY = w.scrollY || w.pageYOffset;
	        method = original.scroll;
	      } else {
	        scrollable = el;
	        startX = el.scrollLeft;
	        startY = el.scrollTop;
	        method = scrollElement;
	      }
	
	      // scroll looping over a frame
	      step({
	        scrollable: scrollable,
	        method: method,
	        startTime: startTime,
	        startX: startX,
	        startY: startY,
	        x: x,
	        y: y
	      });
	    }
	
	    /*
	     * ORIGINAL METHODS OVERRIDES
	     */
	
	    // w.scroll and w.scrollTo
	    w.scroll = w.scrollTo = function() {
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0])) {
	        original.scroll.call(
	          w,
	          arguments[0].left || arguments[0],
	          arguments[0].top || arguments[1]
	        );
	        return;
	      }
	
	      // LET THE SMOOTHNESS BEGIN!
	      smoothScroll.call(
	        w,
	        d.body,
	        ~~arguments[0].left,
	        ~~arguments[0].top
	      );
	    };
	
	    // w.scrollBy
	    w.scrollBy = function() {
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0])) {
	        original.scrollBy.call(
	          w,
	          arguments[0].left || arguments[0],
	          arguments[0].top || arguments[1]
	        );
	        return;
	      }
	
	      // LET THE SMOOTHNESS BEGIN!
	      smoothScroll.call(
	        w,
	        d.body,
	        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
	        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
	      );
	    };
	
	    // Element.prototype.scroll and Element.prototype.scrollTo
	    Element.prototype.scroll = Element.prototype.scrollTo = function() {
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0])) {
	        original.elScroll.call(
	            this,
	            arguments[0].left || arguments[0],
	            arguments[0].top || arguments[1]
	        );
	        return;
	      }
	
	      var left = arguments[0].left;
	      var top = arguments[0].top;
	
	      // LET THE SMOOTHNESS BEGIN!
	      smoothScroll.call(
	          this,
	          this,
	          typeof left === 'number' ? left : this.scrollLeft,
	          typeof top === 'number' ? top : this.scrollTop
	      );
	    };
	
	    // Element.prototype.scrollBy
	    Element.prototype.scrollBy = function() {
	      var arg0 = arguments[0];
	
	      if (typeof arg0 === 'object') {
	        this.scroll({
	          left: arg0.left + this.scrollLeft,
	          top: arg0.top + this.scrollTop,
	          behavior: arg0.behavior
	        });
	      } else {
	        this.scroll(
	          this.scrollLeft + arg0,
	          this.scrollTop + arguments[1]
	        );
	      }
	    };
	
	    // Element.prototype.scrollIntoView
	    Element.prototype.scrollIntoView = function() {
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0])) {
	        original.scrollIntoView.call(
	          this,
	          arguments[0] === undefined ? true : arguments[0]
	        );
	        return;
	      }
	
	      // LET THE SMOOTHNESS BEGIN!
	      var scrollableParent = findScrollableParent(this);
	      var parentRects = scrollableParent.getBoundingClientRect();
	      var clientRects = this.getBoundingClientRect();
	
	      if (scrollableParent !== d.body) {
	        // reveal element inside parent
	        smoothScroll.call(
	          this,
	          scrollableParent,
	          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
	          scrollableParent.scrollTop + clientRects.top - parentRects.top
	        );
	        // reveal parent in viewport
	        w.scrollBy({
	          left: parentRects.left,
	          top: parentRects.top,
	          behavior: 'smooth'
	        });
	      } else {
	        // reveal element in viewport
	        w.scrollBy({
	          left: clientRects.left,
	          top: clientRects.top,
	          behavior: 'smooth'
	        });
	      }
	    };
	  }
	
	  if (true) {
	    // commonjs
	    module.exports = { polyfill: polyfill };
	  } else {
	    // global
	    polyfill();
	  }
	})(window, document);


/***/ }),
/* 1085 */
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function IDCard32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M30 30H2c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2h11V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v5h11c1.103 0 2 .897 2 2v20c0 1.103-.897 2-2 2zM17 2h-2v6h2V2zm13 6H19v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V8H2v20h28V8zM9.071 22.64c.023-.061.061-.112.096-.168.033-.053.061-.108.104-.155.051-.054.113-.093.174-.135.039-.027.067-.064.111-.086l2.999-1.487a5.693 5.693 0 0 1-.551-2.582c0-.007-.004-.013-.004-.019l.002-3.001c0-.03.014-.055.017-.084.003-.034-.008-.067-.001-.101.012-.066.042-.125.06-.189.002-.006.003-.014.006-.02.446-1.609 2.327-2.603 3.916-2.603h.006c1.587 0 3.464.993 3.91 2.603l.006.021c.018.064.048.122.06.188.007.035-.004.067-.001.102.003.029.017.053.017.083L20 18.008c0 .006-.004.012-.004.019a5.689 5.689 0 0 1-.546 2.573l2.997 1.498c.044.022.073.06.112.087.06.042.121.08.171.133.043.048.071.102.105.156.034.055.071.106.094.168.026.067.032.138.043.21.007.048.028.091.028.14v1c0 1.103-.897 2-2 2H11c-1.103 0-2-.897-2-2v-1c0-.05.022-.094.029-.142.01-.072.016-.142.042-.21zM21 23.992v-.382l-3.318-1.658c-.045-.015-.085-.043-.128-.064l-.002-.001-.001-.001c-.072-.036-.145-.068-.208-.123-.033-.029-.049-.068-.077-.1-.022-.023-.038-.049-.058-.075a.985.985 0 0 1-.133-.236c-.018-.045-.026-.091-.037-.138a1.01 1.01 0 0 1-.028-.211c0-.068.012-.134.025-.202.012-.054.022-.105.043-.157.012-.032.011-.067.027-.099.027-.054.072-.09.107-.137.013-.018.017-.04.032-.057.837-.962.754-2.247.754-2.26-.002-.021.007-.039.007-.06-.001-.008-.005-.015-.005-.023l-.002-2.851c-.135-.526-1.053-1.149-1.998-1.149-.944.001-1.863.624-1.998 1.15L14 18.008c0 .007-.004.013-.004.02 0 .02.008.037.007.057-.003.047-.07 1.321.753 2.266.03.034.04.077.064.113.024.036.058.06.077.099.011.022.009.047.018.069.027.065.041.13.053.199.011.061.023.12.023.181a1 1 0 0 1-.026.189.938.938 0 0 1-.048.182c-.024.058-.058.109-.093.163a1.019 1.019 0 0 1-.121.158c-.018.018-.026.042-.046.059-.039.034-.086.049-.129.076-.03.019-.05.048-.083.065L11 23.612v.38h10z","key":1})]);
	}
	
	IDCard32px.displayName = "IDCard32px";
	
	IDCard32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 30"};
	
	module.exports = IDCard32px;
	
	IDCard32px.default = IDCard32px;


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function BarChartUp32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31.725 3.179c-.01.051-.005.102-.024.152L29.717 8.81a.993.993 0 0 1-1.271.596.998.998 0 0 1-.593-1.277l1.197-3.305L1.403 16.855a.995.995 0 0 1-.789-1.828L28.19 3.028l-2.749-1.104a1 1 0 0 1-.553-1.296.994.994 0 0 1 1.289-.555l4.957 1.991h.001l.003.001c.028.012.047.035.073.049a.978.978 0 0 1 .247.16 1 1 0 0 1 .218.315l.004.006c.015.035.012.072.023.108.026.086.053.171.055.262.002.074-.019.143-.033.214zM1.009 20.921h3.968c.548 0 .963.439.963.989v9c0 .55-.415.968-.963.968H1.009a.992.992 0 0 1-.992-.995v-8.966c0-.55.443-.996.992-.996zm.931 8.989l2.045-.024v-6.972L1.94 22.91v7zm7.005-11.978h3.968c.548 0 .992.447.992.997v11.954c0 .55-.444.995-.992.995H8.945a.993.993 0 0 1-.992-.995V18.929c0-.55.444-.997.992-.997zm.992 11.954h1.984v-9.961H9.937v9.961zm6.944-14.941h3.968c.549 0 .992.445.992.995v14.943c0 .55-.443.995-.992.995h-3.968c-.548 0-.941-.418-.941-.968v-15c0-.55.393-.965.941-.965zm.992 14.941l2.067.024v-13l-2.067.027v12.949zm6.944-17.93h3.968c.549 0 .992.446.992.996v17.931c0 .55-.443.995-.992.995h-3.968c-.548 0-.877-.418-.877-.968v-18c0-.55.329-.954.877-.954zm.992 17.93l2.131.024v-16l-2.131.038v15.938z","key":1})]);
	}
	
	BarChartUp32px.displayName = "BarChartUp32px";
	
	BarChartUp32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 31.78 31.88"};
	
	module.exports = BarChartUp32px;
	
	BarChartUp32px.default = BarChartUp32px;


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Bill232px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M23.98 11.075v18.859a1.998 1.998 0 0 1-1.998 1.995H1.997a1.998 1.998 0 0 1-1.998-1.995V1.998C-.001.897.895.003 1.997.003h10.992c.045 0 .084.02.128.026a.771.771 0 0 1 .127.025c.172.046.331.12.452.242l9.883 9.867c.032.023.048.061.076.087.03.027.052.058.078.088.154.176.267.388.267.64 0 .034-.016.063-.02.097zm-9.992-7.666V9.98h6.581l-6.581-6.571zm7.994 8.566h-8.993c-.552 0-1-.446-1-.997V1.94H2l-.003 27.994h19.985V11.975zM4.995 15.966h7.994a.998.998 0 1 1 0 1.995H4.995a.998.998 0 1 1 0-1.995zm0 3.991h7.994a.998.998 0 1 1 0 1.995H4.995a.998.998 0 1 1 0-1.995zm0 3.991h7.994a.998.998 0 1 1 0 1.995H4.995a.998.998 0 1 1 0-1.995zm11.991-7.982h1.998a.998.998 0 1 1 0 1.995h-1.998a.998.998 0 1 1 0-1.995zm0 3.991h1.998a.997.997 0 1 1 0 1.995h-1.998a.998.998 0 1 1 0-1.995zm0 3.991h1.998a.997.997 0 1 1 0 1.995h-1.998a.999.999 0 0 1 0-1.995z","key":1})]);
	}
	
	Bill232px.displayName = "Bill232px";
	
	Bill232px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 24 31.94"};
	
	module.exports = Bill232px;
	
	Bill232px.default = Bill232px;


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Binoculars32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M25 28c-3.857 0-6.996-3.137-6.999-6.994L18 21.003v-4.986l-3.988.02L14 21.003l-.001.003C13.996 24.863 10.857 28 7 28c-3.859 0-7-3.141-7-7 0-.49.053-.968.149-1.43v-.01l4.04-15.929c.001-.007.006-.011.008-.017.001-.006-.001-.012.001-.019A5.03 5.03 0 0 1 9 0c2.757 0 5 2.243 5 5v3.037l4-.029V5.003v-.002V5c0-2.757 2.243-5 5-5a5.025 5.025 0 0 1 4.8 3.597l.001.017c.002.006.007.01.009.017l4.039 15.929v.003c.097.464.151.944.151 1.437 0 3.859-3.141 7-7 7zM2.1 20.008A5.006 5.006 0 0 0 7 26c2.757 0 5-2.243 5-5s-2.243-5-5-5a5.006 5.006 0 0 0-4.886 3.955l-.014.053zm23.776-15.86A3.012 3.012 0 0 0 23 2c-1.654 0-3 1.346-3 3v4a1 1 0 0 1-.992 1l-6 .045H13a1.002 1.002 0 0 1-1-1V5.003v-.002V5c0-1.654-1.346-3-3-3a3.019 3.019 0 0 0-2.88 2.153L3.357 15.052A6.926 6.926 0 0 1 7 14c1.959 0 3.728.814 5 2.117v-.07c0-1.101.895-2.002 1.997-2.01l3.978-.029h.014c.535 0 1.037.207 1.417.584.383.38.594.886.594 1.425v.1A6.969 6.969 0 0 1 25 14c1.338 0 2.577.397 3.641 1.05L25.876 4.148zm4.025 15.871l-.024-.094C29.383 17.684 27.387 16 25 16c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5c0-.336-.036-.663-.099-.981z","key":1})]);
	}
	
	Binoculars32px.displayName = "Binoculars32px";
	
	Binoculars32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 28"};
	
	module.exports = Binoculars32px;
	
	Binoculars32px.default = Binoculars32px;


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function BulbIdea32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31 12.941h-2a.998.998 0 1 1 0-1.994h2a.998.998 0 1 1 0 1.994zm-3.293-8.269a.996.996 0 0 1-.707.292.996.996 0 0 1-.707-1.702l3-2.991a1 1 0 0 1 1.414 0 .994.994 0 0 1 0 1.41l-3 2.991zM21.31 21.117c-.158.193-.31.918-.312 1.507v5.385a.904.904 0 0 1-.013.156c-.203 1.287-1.508 3.722-4.986 3.722-3.479 0-4.783-2.435-4.986-3.722a.904.904 0 0 1-.013-.156v-5.387c-.002-.588-.154-1.312-.312-1.507C7.621 18.796 6 15.763 6 12.34c0-5.717 4.485-10.368 9.999-10.368s9.999 4.651 9.999 10.368c0 3.423-1.621 6.456-4.688 8.777zm-5.311 8.775c2.426 0 2.921-1.629 2.999-1.977v-2.487c-.99.335-1.956.48-2.844.48-1.247 0-2.338-.248-3.154-.512v2.516c.086.371.6 1.98 2.999 1.98zm0-25.925C11.588 3.967 8 7.723 8 12.34c0 3.529 2.148 5.879 3.95 7.228.027.02.053.042.077.064.903.829.973 2.499.973 2.99v.655c1.033.43 3.475 1.174 5.998.017v-.672c0-.491.07-2.16.972-2.991a.814.814 0 0 1 .078-.065c1.803-1.349 3.95-3.696 3.95-7.226 0-4.617-3.588-8.373-7.999-8.373zM5 4.964a.996.996 0 0 1-.707-.292l-3-2.991a.994.994 0 0 1 0-1.41 1 1 0 0 1 1.414 0l3 2.991A.996.996 0 1 1 5 4.964zm-2 5.983a.998.998 0 1 1 0 1.994H1a.998.998 0 1 1 0-1.994h2zm1.293 8.269a1.003 1.003 0 0 1 1.414 0 .994.994 0 0 1 0 1.41l-3 2.992a1 1 0 0 1-1.414 0 .994.994 0 0 1 0-1.41l3-2.992zm23.414 0l3 2.992a.994.994 0 0 1 0 1.41 1 1 0 0 1-1.414 0l-3-2.992a.994.994 0 0 1 0-1.41 1.003 1.003 0 0 1 1.414 0z","key":1})]);
	}
	
	BulbIdea32px.displayName = "BulbIdea32px";
	
	BulbIdea32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 31.88"};
	
	module.exports = BulbIdea32px;
	
	BulbIdea32px.default = BulbIdea32px;


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Chat332px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31.301 30.954a.999.999 0 0 1-1.12-.381L26.979 26H12.075A3.078 3.078 0 0 1 9 22.926V20a1 1 0 0 1 2 0v2.926c0 .592.482 1.074 1.075 1.074H27.5c.03 0 .055.014.085.017.068.006.131.02.197.04a.875.875 0 0 1 .329.171c.054.043.102.087.147.14.018.022.044.034.061.059l1.681 2.4V12.076c0-.593-.482-1.076-1.075-1.076H26a1 1 0 0 1 0-2h2.925A3.079 3.079 0 0 1 32 12.076V30a1 1 0 0 1-.699.954zM19.925 17H5.021l-3.202 4.573A.999.999 0 0 1 0 21V3c0-1.682 1.351-3 3.075-3h16.85C21.649 0 23 1.318 23 3v10.926A3.078 3.078 0 0 1 19.925 17zM21 3c0-.57-.462-1-1.075-1H3.075C2.462 2 2 2.43 2 3v14.828l1.681-2.401c.016-.024.042-.036.061-.058a.953.953 0 0 1 .149-.142c.049-.039.098-.074.152-.103.056-.029.113-.048.175-.067a.958.958 0 0 1 .2-.04c.028-.002.053-.017.082-.017h15.425c.593 0 1.075-.482 1.075-1.074V3z","key":1})]);
	}
	
	Chat332px.displayName = "Chat332px";
	
	Chat332px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 31"};
	
	module.exports = Chat332px;
	
	Chat332px.default = Chat332px;


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Coins232px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M23 32a8.977 8.977 0 0 1-3.107-.568A.994.994 0 0 1 19 32H3a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h2v-3H4a1 1 0 0 1-1-1v-4H1a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h2V7H2a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1v4h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-2v2.946A9.028 9.028 0 0 1 23 14c4.963 0 9 4.037 9 9s-4.037 9-9 9zM4 27v3h13.352a8.945 8.945 0 0 1-2.398-3H4zm10.059-5H7v3h7.234A8.988 8.988 0 0 1 14 23c0-.34.024-.67.059-1zM5 20h9.536a8.968 8.968 0 0 1 1.445-2.626 2.66 2.66 0 0 1 .312-.371l.002-.003H5v3zm-3-8v3h15v-3H2zM18 2H3v3h15V2zm2 8V7H5v3h15zm3 6a6.987 6.987 0 0 0-5.249 2.371 1.496 1.496 0 0 0-.172.202c-.85 1.063-1.365 2.273-1.527 3.553a7.064 7.064 0 0 0 .458 3.504 6.948 6.948 0 0 0 2.112 2.827A7.016 7.016 0 0 0 23 30c3.859 0 7-3.14 7-7s-3.141-7-7-7zm0 12a5.019 5.019 0 0 1-4.637-3.124 5.044 5.044 0 0 1-.327-2.494 5.009 5.009 0 0 1 1.065-2.509c.036-.051.11-.143.192-.225C20.195 18.618 21.563 18 23 18c2.757 0 5 2.243 5 5s-2.243 5-5 5zm0-8c-.862 0-1.683.37-2.249 1.014-.01.014-.082.1-.092.113a2.993 2.993 0 0 0 .462 4.21A3.012 3.012 0 0 0 23 26c1.654 0 3-1.346 3-3s-1.346-3-3-3z","key":1})]);
	}
	
	Coins232px.displayName = "Coins232px";
	
	Coins232px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 32"};
	
	module.exports = Coins232px;
	
	Coins232px.default = Coins232px;


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ConstructionHelmet32px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"construction-helmet-32px"),React.createElement("path",{"d":"M6.3 24c-2 0-4.3-.1-5.3-.7A1.5 1.5 0 0 1 .3 22a1.5 1.5 0 0 1 .7-1.2 18.3 18.3 0 0 1 2.6-9.5l.2-.2c2.8-4 8.9-4.4 9.2-4.4a13.4 13.4 0 0 1 12.1 6.2 17.9 17.9 0 0 1 1.5 5 3 3 0 0 0 .2.8h.2c3.2.8 4.4 1.3 4.8 2.1a1.2 1.2 0 0 1 .1 1h-.1a3.3 3.3 0 0 1-3.2 1.6h-1.3a50.5 50.5 0 0 0-5.6-.3l-13 .8zm-4.2-1.5zm.8-.6a35.1 35.1 0 0 0 5.7.1l13.1-.8a53.5 53.5 0 0 1 5.8.3h1.9l-2.9-.9h-.4c-1.2-.3-1.5-2-1.5-2.5a16.2 16.2 0 0 0-1.2-4.3 11.5 11.5 0 0 0-10.2-5.2c-.1 0-5.6.4-7.8 3.7l-.2.2A16.6 16.6 0 0 0 3 21.3a1 1 0 0 1-.1.5zm-.9-.2zm24.6-2.9z","key":1})]);
	}
	
	ConstructionHelmet32px.displayName = "ConstructionHelmet32px";
	
	ConstructionHelmet32px.defaultProps = {"viewBox":"0 0 32 32"};
	
	module.exports = ConstructionHelmet32px;
	
	ConstructionHelmet32px.default = ConstructionHelmet32px;


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Diploma332px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31 21.962h-2a.999.999 0 1 1 0-1.996h1V2.002H2V20.03h13c.553 0 1 .383 1 .933a.999.999 0 0 1-1 .999H1c-.553 0-1-.447-1-.999V1.004a.999.999 0 0 1 1-.998h30c.553 0 1 .447 1 .998v19.959a.999.999 0 0 1-1 .999zm-9-10.979c2.757 0 5 2.239 5 4.991a4.934 4.934 0 0 1-1.005 2.969c0 .009.005.016.005.025v5.988a1 1 0 0 1-1.555.83L22 24.159l-2.445 1.627a1.002 1.002 0 0 1-1.555-.83v-5.988c0-.009.005-.016.005-.025A4.934 4.934 0 0 1 17 15.974a5.001 5.001 0 0 1 5-4.991zm0 1.997a3 3 0 0 0-3 2.994 3 3 0 0 0 6 0 3 3 0 0 0-3-2.994zm-.555 9.149a1.004 1.004 0 0 1 1.11 0l1.445.962v-2.55a4.983 4.983 0 0 1-2 .422 4.979 4.979 0 0 1-2-.422v2.55l1.445-.962zM15 10.03c.553 0 1 .403 1 .953a.999.999 0 0 1-1 .999H9c-.553 0-1-.447-1-.999 0-.55.447-.953 1-.953h6zM5 7.99c-.553 0-1-.447-1-.998 0-.551.447-.962 1-.962h22c.553 0 1 .411 1 .962a.999.999 0 0 1-1 .998H5z","key":1})]);
	}
	
	Diploma332px.displayName = "Diploma332px";
	
	Diploma332px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 25.97"};
	
	module.exports = Diploma332px;
	
	Diploma332px.default = Diploma332px;


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function DiscountStar32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M29.864 15.88l1.812 3.538a.991.991 0 0 1-.344 1.285l-3.339 2.158-.199 3.969a.992.992 0 0 1-.942.941l-3.969.2-2.157 3.338a.994.994 0 0 1-1.287.345l-3.538-1.812-3.537 1.812a.992.992 0 0 1-1.287-.345L8.92 27.971l-3.969-.2a.992.992 0 0 1-.942-.941l-.199-3.969-3.339-2.158a.991.991 0 0 1-.344-1.285l1.812-3.538-1.812-3.538a.992.992 0 0 1 .344-1.286L3.81 8.898l.199-3.969a.993.993 0 0 1 .942-.941l3.969-.2L11.077.45a.992.992 0 0 1 1.287-.344l3.537 1.811L19.439.106a.992.992 0 0 1 1.287.344l2.157 3.338 3.969.2c.51.026.916.433.942.941l.199 3.969 3.339 2.158a.992.992 0 0 1 .344 1.286l-1.812 3.538zm-1.998-.453l1.633-3.191-3.011-1.946a.998.998 0 0 1-.453-.784l-.179-3.58-3.58-.18a.99.99 0 0 1-.784-.453l-1.946-3.011-3.192 1.635a.996.996 0 0 1-.905 0l-3.192-1.635-1.946 3.011a.99.99 0 0 1-.784.453l-3.58.18-.18 3.58a.995.995 0 0 1-.452.784l-3.012 1.946 1.634 3.191a.99.99 0 0 1 0 .905l-1.634 3.191 3.012 1.946a.996.996 0 0 1 .452.784l.18 3.58 3.58.18a.993.993 0 0 1 .784.453l1.946 3.011 3.192-1.634a.987.987 0 0 1 .905 0l3.192 1.634 1.946-3.011a.993.993 0 0 1 .784-.453l3.58-.18.179-3.58a1 1 0 0 1 .453-.784l3.011-1.946-1.633-3.191a.984.984 0 0 1 0-.905zm-7.001 7.403c-1.67 0-2.978-1.745-2.978-3.971 0-2.227 1.308-3.971 2.978-3.971 1.671 0 2.979 1.744 2.979 3.971 0 2.226-1.308 3.971-2.979 3.971zm0-5.956c-.395 0-.993.791-.993 1.985 0 1.193.598 1.985.993 1.985.396 0 .993-.792.993-1.985 0-1.194-.597-1.985-.993-1.985zm-6.008 5.277a.991.991 0 1 1-1.882-.628l3.971-11.912a.991.991 0 1 1 1.882.627l-3.971 11.913zm-3.919-5.277c-1.671 0-2.979-1.745-2.979-3.971 0-2.227 1.308-3.971 2.979-3.971 1.67 0 2.978 1.744 2.978 3.971 0 2.226-1.308 3.971-2.978 3.971zm0-5.957c-.396 0-.993.792-.993 1.986 0 1.193.597 1.985.993 1.985.395 0 .992-.792.992-1.985 0-1.194-.597-1.986-.992-1.986z","key":1})]);
	}
	
	DiscountStar32px.displayName = "DiscountStar32px";
	
	DiscountStar32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 31.79 31.75"};
	
	module.exports = DiscountStar32px;
	
	DiscountStar32px.default = DiscountStar32px;


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function DocumentPencil32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31.885 6.989v.003l-.002 19.11v.009c0 .083-.028.157-.047.235-.012.048-.009.098-.029.145l-.001.005-.003.005-1.986 4.815a.994.994 0 0 1-1.84 0l-1.992-4.825a.98.98 0 0 1 .045-.831V7.443a.977.977 0 0 1-.121-.452.98.98 0 0 1 .121-.453V3.455a.98.98 0 0 1-.121-.453c0-1.65 1.34-2.993 2.988-2.993a2.993 2.993 0 0 1 2.986 2.993c0 .018-.009.034-.01.052.001.021.012.039.012.061v3.874zM30.03 3.481a.97.97 0 0 1-.139-.479.995.995 0 1 0-1.99 0c0 .02-.01.037-.012.057.002.019.012.036.012.056v2.878h2.129V3.481zm0 4.507h-2.129v17.925l.996 2.41 1.07-2.594c.015-.036.044-.06.063-.094V7.988zm-7.11 3.093V29.94a1.997 1.997 0 0 1-1.992 1.995H2.002A1.997 1.997 0 0 1 .01 29.94V2.005C.01.904.904.009 2.002.009h9.961c.022 0 .04.011.061.012.09.006.178.023.263.053.032.012.064.02.095.034a.994.994 0 0 1 .28.189l.006.005 9.852 9.867c.032.023.048.061.077.087.029.027.05.058.076.087.153.176.267.388.267.641 0 .034-.016.063-.02.097zM2.002 29.94l19.028.03V11.982h-9.067c-.551 0-.933-.461-.933-1.012v-9h-9l-.028 27.97zM12.959 3.415v6.571h6.56l-6.56-6.571z","key":1})]);
	}
	
	DocumentPencil32px.displayName = "DocumentPencil32px";
	
	DocumentPencil32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 31.91 31.94"};
	
	module.exports = DocumentPencil32px;
	
	DocumentPencil32px.default = DocumentPencil32px;


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function FagOgLedelse32px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 fag og ledelse"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M26.317 6.814a.5.5 0 0 1 .626-.33c5.212 1.62 8.94 4.812 9.521 10.099l.033.333c.102 1.233.315 1.668 1.306 2.182l.062.031H39a.5.5 0 0 1 .492.41l.008.09v4.157a.5.5 0 0 1-.299.457l-.143.045-.058.009-.067.001-.542-.018c-1.424-.052-2.543.038-3.714.44-3.245 1.12-5.582 1.504-8.623 1.568l-.888.01h-1.754c-4.152.004-6.567-.25-10.159-1.42l-.475-.158-.32-.102c-.952-.284-1.892-.37-3.014-.348l-.923.028-.09-.003-.035-.007-.063-.017a.5.5 0 0 1-.372-.4l-.007-.085v-4.124a.5.5 0 0 1 .41-.492l.09-.008H9.59l.062-.03c.939-.488 1.18-.904 1.29-1.993l.017-.188c.332-4.203 2.683-7.174 6.365-9.143a.5.5 0 1 1 .471.882c-3.301 1.766-5.407 4.353-5.807 7.997l-.033.345c-.135 1.621-.544 2.355-2.027 3.08a.502.502 0 0 1-.144.045l-.075.005h-.754v3.121l.072-.002c1.409-.052 2.555.026 3.75.388l.327.106c3.266 1.103 5.468 1.445 8.803 1.51l.986.012H25.5c3.212-.029 5.524-.375 8.85-1.522 1.206-.415 2.336-.532 3.7-.505l.449.013v-3.154h-.753a.499.499 0 0 1-.15-.022l-.07-.028c-1.418-.694-1.854-1.395-2.008-2.873l-.019-.207c-.418-4.994-3.88-8.014-8.853-9.56a.5.5 0 0 1-.33-.625z","key":0}),React.createElement("path",{"d":"M26.696 4.648a.5.5 0 0 1 .488.391l.012.087.626 14.449a.5.5 0 0 1-.987.132l-.012-.089-.606-13.971h-5.014l-.605 13.971a.5.5 0 0 1-.43.474l-.091.004a.5.5 0 0 1-.474-.431l-.004-.09.627-14.449a.5.5 0 0 1 .412-.47l.087-.008zM35.885 23.625a.5.5 0 0 1 .702.08c.177.222.43.604.68 1.112.735 1.486.946 3.049.287 4.531-.377.85-1.028 1.62-1.973 2.294l-.085.058-.063.304c-.087.403-.201.85-.345 1.333a18.975 18.975 0 0 1-1.712 4.041c-2.138 3.72-5.312 5.974-9.682 5.974s-7.544-2.254-9.682-5.974a18.975 18.975 0 0 1-1.712-4.041 19.079 19.079 0 0 1-.275-1.023l-.133-.611-.046-.03c-1.949-1.345-2.641-3.08-2.338-4.963l.039-.218a.5.5 0 0 1 .98.196c-.329 1.648.243 3.11 2.09 4.297a.5.5 0 0 1 .223.342l.042.227.05.237c.082.38.19.803.326 1.26a17.981 17.981 0 0 0 1.62 3.829c1.975 3.434 4.845 5.472 8.816 5.472s6.84-2.038 8.815-5.472a17.981 17.981 0 0 0 1.62-3.828c.103-.343.189-.667.26-.968l.095-.42.054-.28.01-.057a.5.5 0 0 1 .219-.34c.934-.613 1.543-1.3 1.873-2.044.518-1.166.347-2.438-.269-3.682a6.434 6.434 0 0 0-.397-.694l-.103-.15-.066-.09a.5.5 0 0 1 .08-.702z","key":1})])]);
	}
	
	FagOgLedelse32px.displayName = "FagOgLedelse32px";
	
	FagOgLedelse32px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = FagOgLedelse32px;
	
	FagOgLedelse32px.default = FagOgLedelse32px;


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function GraduationCap32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M29 21.941c-1.102 0-2-.897-2-1.997 0-.736.405-1.373 1-1.72v-7.543l-4.019 2.293c.003.033.019.062.019.095v9.87c0 .038-.018.071-.022.109a1.038 1.038 0 0 1-.04.198 1.056 1.056 0 0 1-.182.327.982.982 0 0 1-.149.139c-.029.023-.047.055-.08.075-.141.088-3.524 2.147-8.527 2.147-5.003 0-8.386-2.059-8.527-2.147-.033-.02-.051-.052-.08-.075a.94.94 0 0 1-.371-.664c-.004-.037-.022-.07-.022-.109v-9.87c0-.033.016-.062.019-.095L.504 9.827a.995.995 0 0 1 0-1.733l14-7.988c.306-.175.685-.175.992 0l14 7.988a.996.996 0 0 1 .504.867c0 .017-.012.031-.013.049.001.023.013.043.013.066v9.148c.595.347 1 .984 1 1.72 0 1.1-.897 1.997-2 1.997zm-7 .403v-8.24l-6.504 3.711a.996.996 0 0 1-.992 0L8 14.104v8.237c1.004.502 3.578 1.597 7 1.597 3.442 0 6.001-1.092 7-1.594zM15 2.123L3.016 8.961 15 15.798l11.984-6.837L15 2.123z","key":1})]);
	}
	
	GraduationCap32px.displayName = "GraduationCap32px";
	
	GraduationCap32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 31 25.94"};
	
	module.exports = GraduationCap32px;
	
	GraduationCap32px.default = GraduationCap32px;


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Graph232px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31 22H1a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v19h29a1 1 0 1 1 0 2zM26 7c-.224 0-.436-.045-.637-.114l-5.402 4.727A2.003 2.003 0 0 1 18 14c-1.103 0-2-.897-2-2 0-.178.031-.347.074-.511l-2.127-2.127-4.984 4.272c.022.119.037.241.037.366 0 1.103-.898 2-2 2-1.103 0-2-.897-2-2s.897-2 2-2c.231 0 .45.047.657.12l5.692-4.879c.042-.036.092-.049.137-.077.059-.036.114-.076.178-.099.059-.021.118-.025.179-.035.066-.01.13-.025.197-.022.062.002.12.021.181.035.064.015.127.024.187.051.061.027.111.071.166.111.044.031.094.049.133.088l2.781 2.782c.165-.044.334-.075.512-.075.224 0 .436.045.637.114l5.402-4.727A2.002 2.002 0 0 1 26 3c1.102 0 2 .897 2 2s-.898 2-2 2z","key":1})]);
	}
	
	Graph232px.displayName = "Graph232px";
	
	Graph232px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 22"};
	
	module.exports = Graph232px;
	
	Graph232px.default = Graph232px;


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function GraphUp32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31 22H1a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v19h29a1 1 0 1 1 0 2zM27 9a1 1 0 0 1-1-1V6.328l-7.342 6.425c-.058.051-.127.079-.192.114-.036.02-.068.048-.105.063-.117.045-.238.07-.361.07a1 1 0 0 1-.39-.082c-.043-.019-.077-.054-.117-.078-.069-.041-.141-.074-.2-.133l-3.346-3.345-6.297 5.397a.995.995 0 0 1-1.409-.108 1 1 0 0 1 .108-1.41l7-6c.042-.035.092-.049.137-.076.059-.037.114-.077.179-.1.058-.021.117-.025.178-.035.066-.01.13-.025.197-.022.062.002.121.021.182.035.063.015.126.024.186.051.061.027.111.071.166.111.044.031.094.049.133.088l3.338 3.339L24.482 5H23a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1z","key":1})]);
	}
	
	GraphUp32px.displayName = "GraphUp32px";
	
	GraphUp32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 22"};
	
	module.exports = GraphUp32px;
	
	GraphUp32px.default = GraphUp32px;


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Hammer32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M33 8.996c0 .265-.105.52-.293.707l-4 3.997a.993.993 0 0 1-.707.293.993.993 0 0 1-.707-.293l-3.797-3.794-8.091 8.09.302.303a.998.998 0 0 1 .241 1.023l-1 2.998a1.004 1.004 0 0 1-.241.391l-9 8.995a.997.997 0 0 1-1.414 0l-4-3.998a.996.996 0 0 1 0-1.414l9-8.996c.11-.11.244-.192.391-.242l3-.999a1 1 0 0 1 1.023.242l.284.283 8.091-8.09-6.789-6.785A1 1 0 0 1 16-.001h8a1 1 0 0 1 .707.294l2.789 2.787.797-.797a.999.999 0 1 1 1.414 1.414l-.797.797 3.797 3.794c.188.188.293.443.293.708zM12.729 18.15l-2.189.73-8.125 8.121L5 29.585l8.126-8.122.73-2.187-1.127-1.126zM23.586 2h-5.17L28 11.579l2.585-2.583L23.586 2z","key":1})]);
	}
	
	Hammer32px.displayName = "Hammer32px";
	
	Hammer32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 33 32"};
	
	module.exports = Hammer32px;
	
	Hammer32px.default = Hammer32px;


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Heart32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M29.852 14.506c-.006.007-.007.016-.014.023L18.257 27.185a2.805 2.805 0 0 1-2.097.946h-.001a2.847 2.847 0 0 1-2.101-.949L2.485 14.529c-.006-.006-.008-.014-.013-.021-3.296-3.337-3.285-8.719.045-12.035 3.326-3.309 8.722-3.327 12.074-.06l.001.001 1.568 1.31 1.57-1.311.003-.002c3.353-3.265 8.747-3.247 12.073.062 3.326 3.316 3.338 8.696.046 12.033zM28.378 3.894c-2.562-2.546-6.726-2.545-9.285.002-.01.01-.025.014-.036.024-.012.011-.017.025-.029.035l-2.22 1.853c-.048.04-.106.061-.159.091-.037.02-.069.045-.107.06a.998.998 0 0 1-.382.083h-.001-.001a.997.997 0 0 1-.381-.083c-.039-.015-.072-.041-.109-.062-.053-.03-.109-.05-.158-.09l-2.216-1.852c-.011-.01-.016-.024-.027-.035-.011-.01-.026-.013-.037-.024-2.562-2.549-6.728-2.547-9.285 0a6.526 6.526 0 0 0 0 9.245c.006.006.007.013.013.019.006.006.014.008.02.015l11.577 12.656a.794.794 0 0 0 1.205.005l11.585-12.661c.006-.007.014-.009.02-.015s.007-.013.013-.019a6.532 6.532 0 0 0 0-9.247z","key":1})]);
	}
	
	Heart32px.displayName = "Heart32px";
	
	Heart32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32.35 28.12"};
	
	module.exports = Heart32px;
	
	Heart32px.default = Heart32px;


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Innovasjon32px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 innovasjon"),React.createElement("g",{"clipRule":"evenodd","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M17.826 34.078a.5.5 0 0 1 .5-.5h11.348a.5.5 0 0 1 .5.5v5.453c0 .852-.664 1.517-1.516 1.517h-9.316a1.498 1.498 0 0 1-1.516-1.517zm1 .5v4.953c0 .3.217.517.516.517h9.316c.3 0 .516-.217.516-.517v-4.953z","key":0}),React.createElement("path",{"d":"M21.51 40.081a.5.5 0 0 1 .5.5c0 1.113.894 2.007 2.007 2.007a2.001 2.001 0 0 0 2.007-2.007.5.5 0 1 1 1 0 3.001 3.001 0 0 1-3.007 3.007 3.001 3.001 0 0 1-3.007-3.007.5.5 0 0 1 .5-.5zM23.483 5.421c-7.08.264-12.753 6.1-12.753 13.244a13.23 13.23 0 0 0 6.365 11.327c1.111.674 1.731 1.895 1.731 3.171v.38h4.657v-7.121c0-.951.95-1.53 1.793-1.213a2.749 2.749 0 0 0 1.145.273c1.08 0 1.94-.86 1.94-1.94 0-1.078-.86-1.938-1.94-1.938-.31 0-.71.106-1.131.268-.89.38-1.807-.298-1.807-1.209V16.7c0-.197-.195-.36-.429-.282a3.742 3.742 0 0 1-1.51.342c-1.631 0-2.939-1.308-2.939-2.94s1.308-2.938 2.939-2.938c.5 0 1.044.162 1.5.338a.3.3 0 0 0 .438-.279zm-4.976 29.123a.5.5 0 0 1-.681-.466v-.915c0-.96-.464-1.84-1.25-2.316A14.23 14.23 0 0 1 9.73 18.665c0-7.864 6.389-14.253 14.253-14.253a.5.5 0 0 1 .5.5v6.03c0 .91-.918 1.587-1.807 1.208-.42-.162-.822-.268-1.132-.268-1.079 0-1.939.86-1.939 1.939s.86 1.939 1.939 1.939a2.75 2.75 0 0 0 1.146-.273c.843-.317 1.793.262 1.793 1.213v3.963a.299.299 0 0 0 .438.279c.456-.175 1-.338 1.5-.338a2.929 2.929 0 0 1 2.94 2.939 2.929 2.929 0 0 1-2.94 2.939 3.742 3.742 0 0 1-1.51-.342c-.233-.079-.428.085-.428.282v7.622a.5.5 0 0 1-.5.5z","key":1}),React.createElement("path",{"d":"M23.517 4.912a.5.5 0 0 1 .5-.5c7.864 0 14.253 6.389 14.253 14.253 0 5.16-2.739 9.69-6.846 12.182-.786.477-1.25 1.357-1.25 2.316v.915a.5.5 0 0 1-.5.5h-5.657a.5.5 0 1 1 0-1h5.157v-.415c0-1.276.62-2.497 1.731-3.171a13.23 13.23 0 0 0 6.365-11.327c0-7.312-5.941-13.253-13.253-13.253a.5.5 0 0 1-.5-.5z","key":2})])]);
	}
	
	Innovasjon32px.displayName = "Innovasjon32px";
	
	Innovasjon32px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = Innovasjon32px;
	
	Innovasjon32px.default = Innovasjon32px;


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function KlimaOgMiljo32px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 klima og miljø"),React.createElement("g",{"clipRule":"evenodd","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M35.253 13.191l-.498-.048-.051-.497a.5.5 0 0 1 .549.545zm-4.697 17.415c-2.395 3.392-5.202 4.766-7.903 4.789-2.676.022-5.153-1.283-6.918-3.066l.71-.703c1.623 1.639 3.854 2.789 6.2 2.769 2.321-.02 4.85-1.186 7.095-4.366.812-1.15 1.509-2.773 2.095-4.592.584-1.812 1.05-3.787 1.409-5.62a80.002 80.002 0 0 0 .947-6.107 89.536 89.536 0 0 0-6.306.986c-1.872.365-3.875.828-5.685 1.397-1.818.571-3.402 1.238-4.463 1.996-2.507 1.807-3.678 3.967-3.959 6.079-.282 2.124.33 4.248 1.475 5.975l-.833.553c-1.259-1.898-1.952-4.262-1.633-6.66.32-2.41 1.656-4.806 4.366-6.76h.001c1.192-.851 2.897-1.556 4.747-2.137 1.858-.584 3.9-1.055 5.793-1.424a90.701 90.701 0 0 1 6.861-1.053l.11-.012.028-.003.01-.001.052.497.498.048-.001.01-.003.028-.01.106-.045.404a80.953 80.953 0 0 1-.97 6.272c-.363 1.855-.837 3.87-1.437 5.733-.598 1.855-1.332 3.59-2.23 4.862z","key":0}),React.createElement("path",{"d":"M19.319 28.376a.5.5 0 0 1 .543-.453l6.74.61a.5.5 0 1 1-.09.995l-6.74-.61a.5.5 0 0 1-.453-.542zM23.653 23.956a.5.5 0 0 1 .526-.472l4.404.237a.5.5 0 1 1-.054.999l-4.404-.238a.5.5 0 0 1-.472-.526z","key":1}),React.createElement("path",{"d":"M29.926 18.108a.5.5 0 0 1 0 .707L13.158 35.583a.5.5 0 0 1-.707-.707l16.767-16.768a.5.5 0 0 1 .708 0zM23.577 18.47a.5.5 0 0 1 .532.467l.135 2.032a.5.5 0 0 1-.998.066l-.135-2.032a.5.5 0 0 1 .466-.532zM18.752 20.437a.5.5 0 0 1 .546.45l.406 4.268a.5.5 0 0 1-.995.095l-.407-4.268a.5.5 0 0 1 .45-.545zM36.28 33.476a.5.5 0 0 1 .5.5v4.14h4.14a.5.5 0 1 1 0 1h-4.64a.5.5 0 0 1-.5-.5v-4.64a.5.5 0 0 1 .5-.5zM6.613 9.417a.5.5 0 0 1 .5-.5h4.607a.5.5 0 0 1 .5.5v4.607a.5.5 0 1 1-1 0V9.917H7.113a.5.5 0 0 1-.5-.5z","key":2}),React.createElement("path",{"d":"M16.3 5.875a19.617 19.617 0 0 1 7.717-1.565c10.879 0 19.707 8.828 19.707 19.707 0 6.013-2.678 11.366-6.917 14.98a.5.5 0 1 1-.649-.76c4.026-3.433 6.566-8.512 6.566-14.22 0-10.327-8.38-18.707-18.707-18.707-2.608 0-5.082.528-7.324 1.484a.5.5 0 1 1-.392-.92zM11.896 9.091a.5.5 0 0 1-.053.705C7.85 13.23 5.31 18.31 5.31 24.017c0 10.326 8.38 18.707 18.707 18.707 2.608 0 5.082-.528 7.324-1.484a.5.5 0 0 1 .392.92 19.617 19.617 0 0 1-7.716 1.564c-10.879 0-19.707-8.828-19.707-19.707 0-6.013 2.677-11.365 6.881-14.98a.5.5 0 0 1 .705.054z","key":3})])]);
	}
	
	KlimaOgMiljo32px.displayName = "KlimaOgMiljo32px";
	
	KlimaOgMiljo32px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = KlimaOgMiljo32px;
	
	KlimaOgMiljo32px.default = KlimaOgMiljo32px;


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Leaf32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M26.66 19.673c-3.221 3.424-7.691 5.16-13.286 5.16h-.002c-2.445-.001-5.145-.35-8.019-1.016-2.983 4.268-3.357 7.025-3.364 7.082a1.001 1.001 0 0 1-1.111.878.997.997 0 0 1-.89-1.097c.03-.265.468-3.562 4.029-8.475-.076-2.389.046-11.211 5.527-17.038C14.263.151 21.683-1.232 31.398 1.14a1 1 0 0 1 .762.891c.033.446.754 10.996-5.5 17.642zm3.519-16.778C21.594.95 15.104 2.179 11.02 6.518c-3.717 3.951-4.693 9.618-4.926 13.081 2.128-2.46 4.987-5.201 8.846-8.098V7.22c0-.549.592-1.256 1.149-1.256.556 0 .851.707.851 1.256v2.836c2.767-1.942 5.974-3.94 9.714-5.957a1.011 1.011 0 0 1 1.366.395.986.986 0 0 1-.4 1.347c-4.244 2.289-7.775 4.546-10.734 6.715-.075.19-.229.286-.454.329a66.969 66.969 0 0 0-2.964 2.335h8.472c.556 0 1.195.125 1.195.674s-.639 1.326-1.195 1.326H11.2c-1.863 1.732-3.35 3.361-4.539 4.852 2.403.506 4.66.774 6.712.775h.001c5.013 0 8.986-1.522 11.811-4.525 4.781-5.081 5.035-13.017 4.994-15.427z","key":1})]);
	}
	
	Leaf32px.displayName = "Leaf32px";
	
	Leaf32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32.19 31.78"};
	
	module.exports = Leaf32px;
	
	Leaf32px.default = Leaf32px;


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Medal132px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M27.724 6.825a.908.908 0 0 1-.008.37.965.965 0 0 1-.063.195c-.012.028-.012.059-.027.087L21.542 18.42c.81 1.387 1.257 2.941 1.257 4.555 0 4.958-3.999 8.993-8.915 8.993-4.916 0-8.915-4.035-8.915-8.993 0-1.615.448-3.17 1.257-4.555L.143 7.477C.127 7.449.127 7.418.115 7.39a.962.962 0 0 1-.062-.195.883.883 0 0 1-.009-.37.938.938 0 0 1 .053-.195c.011-.029.009-.06.023-.089L3.092.546c.011-.023.036-.033.049-.055a.978.978 0 0 1 .253-.283.81.81 0 0 1 .109-.075.968.968 0 0 1 .38-.12c.022-.002.039-.018.061-.019.009-.001.016.002.025.002l.009-.002h19.317c.101 0 .194.029.286.058.082-.018.156-.061.243-.058.363.013.69.225.852.552l2.972 5.995c.014.029.012.06.024.089a.935.935 0 0 1 .052.195zM13.884 29.97c3.823 0 6.934-3.138 6.934-6.995a7.023 7.023 0 0 0-1.231-3.98 6.934 6.934 0 0 0-4.259-2.867 7.183 7.183 0 0 0-2.9.003 6.93 6.93 0 0 0-4.247 2.865 7.023 7.023 0 0 0-1.231 3.979c0 3.857 3.111 6.995 6.934 6.995zm1.126-15.885l3.554-6.098h-9.36l3.541 6.076c.759-.096 1.515-.069 2.265.022zM2.127 6.961l5.406 9.724a8.984 8.984 0 0 1 3.215-2.104L4.049 3.085 2.127 6.961zm5.912-.972h11.69l2.329-3.997H5.71l2.329 3.997zm15.68-2.904l-6.688 11.477a8.945 8.945 0 0 1 3.206 2.121l5.404-9.722-1.922-3.876z","key":1})]);
	}
	
	Medal132px.displayName = "Medal132px";
	
	Medal132px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 27.75 31.97"};
	
	module.exports = Medal132px;
	
	Medal132px.default = Medal132px;


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function People32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M32 21a1 1 0 0 1-1 1h-1.117l-.891 7.124A1 1 0 0 1 28 30h-4a1 1 0 0 1-.97-.757l-1-4a1.002 1.002 0 0 1 .727-1.214 1.002 1.002 0 0 1 1.213.729L24.781 28h2.336l.891-7.124c.006-.047.031-.086.044-.131.017-.065.032-.127.062-.186a.917.917 0 0 1 .111-.165c.037-.047.071-.093.116-.133a.96.96 0 0 1 .172-.116c.05-.029.097-.057.152-.077a.96.96 0 0 1 .208-.042c.044-.006.082-.026.127-.026h1v-2.938c0-.011.006-.02.006-.031S30 17.011 30 17c0-2.417-1.051-5-4-5a1 1 0 0 1 0-2.001c3.589 0 6 2.814 6 7.001 0 .011-.006.02-.006.031s.006.02.006.031V21zM22 6c0-2.205 1.794-4 4-4s4 1.795 4 4a4.003 4.003 0 0 1-4 3.999c-2.206 0-4-1.793-4-3.999zm4 2c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2zm-3 7c0 .011-.006.02-.006.031s.006.021.006.032V21a1 1 0 0 1-1 1h-2.095l-.91 9.099A1 1 0 0 1 18 32h-4a1 1 0 0 1-.995-.901L12.095 22H10a1 1 0 0 1-1-1v-5.937c0-.011.006-.021.006-.032S9 15.011 9 15c0-3.86 3.14-7 7-7s7 3.14 7 7zm-7-5.001c-2.757 0-5 2.244-5 5.001 0 .011-.006.02-.006.031s.006.021.006.032V20h2c.05 0 .092.021.14.028.07.01.138.017.203.042.058.021.107.054.159.085.058.035.115.066.164.111.047.042.081.092.119.143.039.052.079.1.108.159.028.06.041.124.058.189.013.049.039.092.044.143l.91 9.1h2.19l.91-9.1c.005-.052.031-.094.044-.143.017-.065.029-.129.058-.188.029-.062.071-.112.112-.166.036-.047.068-.095.112-.135.052-.048.112-.082.174-.118.049-.029.094-.06.148-.08.067-.025.138-.032.21-.042.047-.007.088-.028.137-.028h2v-4.937c0-.011.006-.021.006-.032S21 15.011 21 15a5.007 5.007 0 0 0-5-5.001zM12 4c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4-4-1.794-4-4zm4 2c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2zM6 9.999C3.794 9.999 2 8.206 2 6c0-2.205 1.794-4 4-4s4 1.795 4 4a4.003 4.003 0 0 1-4 3.999zM6 4c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm1 7a1 1 0 0 1-1 1c-2.949 0-4 2.583-4 5 0 .011-.006.02-.006.031s.006.02.006.031V20h1c.045 0 .084.02.128.026.07.009.137.017.202.041.06.021.112.052.166.084.055.032.109.063.157.106.05.043.088.093.128.146.038.049.075.097.104.153.03.061.046.125.064.192.012.044.037.082.043.128L4.883 28h2.336l.811-3.242c.134-.537.68-.861 1.213-.729.535.135.861.678.727 1.214l-1 4A1 1 0 0 1 8 30H4a1 1 0 0 1-.992-.876L2.117 22H1a1 1 0 0 1-1-1v-3.938c0-.011.006-.02.006-.031S0 17.011 0 17c0-4.187 2.411-7.001 6-7.001.552 0 1 .449 1 1.001z","key":1})]);
	}
	
	People32px.displayName = "People32px";
	
	People32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 32"};
	
	module.exports = People32px;
	
	People32px.default = People32px;


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function PiggyBank32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31 21.977h-1.603c-.658 1.613-1.848 3.083-3.437 4.247l1.106 3.036a.998.998 0 0 1-.597 1.281l-3.759 1.366a1 1 0 0 1-1.281-.596l-.986-2.703a16.614 16.614 0 0 1-6.769.026l-.976 2.676a.994.994 0 0 1-1.281.597l-3.759-1.366a1 1 0 0 1-.598-1.281l1.079-2.959c-2.386-1.703-3.827-4.016-4.085-6.515C.885 19.496 0 16.58 0 14.984a1 1 0 1 1 2 0c.005.44.154 2.514 2.102 2.803.771-4.948 6.256-8.798 12.898-8.798 1.485 0 2.945.194 4.35.578 2.892-2.85 6.716-2.569 6.715-2.568.412.03.768.31.888.705a.995.995 0 0 1-.337 1.078c-.056.047-1.449 1.204-1.761 3.685 1.153 1.031 2.018 2.229 2.542 3.516H31c.553 0 1 .447 1 .999v3.996a.999.999 0 0 1-1 .999zm-1-3.996h-1.308a1 1 0 0 1-.957-.71c-.401-1.326-1.285-2.572-2.555-3.606a.999.999 0 0 1-.367-.837c.093-1.488.502-2.668.967-3.556-1.064.295-2.33.89-3.37 2.083a1 1 0 0 1-1.056.296A14.406 14.406 0 0 0 17 10.987c-6.065 0-11 3.586-11 7.993 0 2.331 1.412 4.547 3.875 6.077a.998.998 0 0 1 .411 1.189l-1.005 2.759 1.88.683.937-2.57a1 1 0 0 1 1.193-.625c2.462.645 5.071.636 7.523-.03a1 1 0 0 1 1.203.622l.949 2.603 1.88-.683-.954-2.616a.943.943 0 0 1-.055-.098c-.223-.459-.086-1.003.345-1.274 1.785-1.124 3.048-2.661 3.553-4.329a1 1 0 0 1 .957-.709H30v-1.998zm-7.481-2.997h2v1.998h-2v-1.998zm-4.796-6.991a.999.999 0 0 1-.807-1.16c.057-.312.084-.587.084-.841a4.003 4.003 0 0 0-4-3.997c-2.206 0-4 1.793-4 3.997 0 .795.305 1.699.816 2.42a.998.998 0 1 1-1.632 1.155C7.432 8.505 7 7.202 7 5.992a6.004 6.004 0 0 1 6-5.995c3.309 0 6 2.689 6 5.995 0 .375-.038.766-.115 1.196a.994.994 0 0 1-1.162.805z","key":1})]);
	}
	
	PiggyBank32px.displayName = "PiggyBank32px";
	
	PiggyBank32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 31.97"};
	
	module.exports = PiggyBank32px;
	
	PiggyBank32px.default = PiggyBank32px;


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Samarbeid32px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 samarbeid"),React.createElement("g",{"clipRule":"evenodd","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M22.657 36.878c-.679-.646-1.738-.635-2.368-.004l-1.008 1.008c-.645.677-.635 1.733-.008 2.365.678.646 1.738.634 2.368.003l1.008-1.007c.645-.677.635-1.734.008-2.365zm-3.076-.711c1.03-1.03 2.715-1.02 3.771-.007l.008.007c1.03 1.03 1.02 2.715.007 3.771l-.007.008-1.012 1.011c-1.03 1.03-2.714 1.02-3.77.008l-.008-.008c-1.03-1.03-1.02-2.714-.008-3.77l.007-.008 1.012-1.012.333.333z","key":0}),React.createElement("path",{"d":"M19.621 33.806c-.678-.646-1.738-.634-2.368-.003l-2.562 2.561c-.645.677-.634 1.734-.007 2.365.678.646 1.737.634 2.368.004l2.561-2.562c.645-.677.635-1.733.008-2.365zm-3.075-.71c1.03-1.03 2.714-1.02 3.77-.008l.009.007c1.03 1.031 1.02 2.715.007 3.772l-.007.007-2.566 2.566c-1.03 1.03-2.715 1.02-3.771.007l-.008-.007c-1.03-1.03-1.02-2.715-.007-3.771l.007-.008z","key":1}),React.createElement("path",{"d":"M16.55 30.735c-.678-.646-1.738-.634-2.368-.004l-2.562 2.562c-.656.688-.659 1.74-.012 2.36.679.65 1.74.64 2.372.008l2.562-2.562c.645-.676.635-1.733.008-2.364zm-3.075-.711c1.03-1.03 2.714-1.02 3.77-.007l.008.007c1.03 1.03 1.02 2.715.008 3.771l-.008.008-2.566 2.565c-1.03 1.03-2.714 1.02-3.77.008-1.087-1.041-1.018-2.732-.016-3.779l.008-.007z","key":2}),React.createElement("path",{"d":"M13.515 27.7c-.679-.647-1.738-.635-2.369-.004l-1.802 1.803c-.645.676-.635 1.733-.008 2.364.678.646 1.737.635 2.368.004l1.803-1.803c.645-.677.635-1.733.008-2.365zm-3.076-.711c1.03-1.03 2.715-1.02 3.771-.008l.008.008c1.03 1.03 1.02 2.714.007 3.77l-.007.008-1.807 1.807c-1.03 1.03-2.714 1.02-3.77.007l-.009-.007c-1.03-1.03-1.02-2.715-.007-3.771l.007-.008zM25.58 34.794a.5.5 0 0 1 .707 0l3.938 3.939c.631.63 1.69.642 2.368-.004.629-.632.638-1.692-.01-2.368a.5.5 0 0 1 .721-.692c1.013 1.056 1.023 2.74-.007 3.77l-.008.008c-1.056 1.013-2.74 1.023-3.77-.007l-3.94-3.939a.5.5 0 0 1 0-.707z","key":3}),React.createElement("path",{"d":"M28.651 31.722a.5.5 0 0 1 .707 0l3.94 3.94c.63.63 1.69.641 2.367-.005.627-.63.638-1.687-.007-2.364l-.755-.755a.5.5 0 1 1 .707-.707l.766.766c1.013 1.057 1.023 2.74-.007 3.771l-.008.008c-1.056 1.012-2.74 1.023-3.77-.008l-3.94-3.939a.5.5 0 0 1 0-.707zM28.044 37.208a.5.5 0 0 1 .707.015c1.013 1.056 1.023 2.74-.007 3.77l-.007.008c-1.057 1.012-2.741 1.023-3.772-.007l-1.806-1.807a.5.5 0 1 1 .707-.707l1.807 1.806c.63.631 1.69.643 2.368-.003.628-.633.637-1.692-.012-2.369a.5.5 0 0 1 .015-.706z","key":4}),React.createElement("path",{"d":"M31.723 28.651a.5.5 0 0 1 .707 0l3.18 3.18c.72.72 1.94.64 2.556-.252.43-.65.306-1.578-.264-2.149a.5.5 0 0 1 .707-.707c.874.874 1.111 2.328.388 3.414l-.004.006a2.665 2.665 0 0 1-4.09.395l-3.18-3.18a.5.5 0 0 1 0-.707zM40.48 6.64a.5.5 0 0 1-.06.705l-6.881 5.785L43.7 25.265l2.978-2.497a.5.5 0 1 1 .642.766l-3.36 2.818a.5.5 0 0 1-.705-.062l-10.804-12.9a.5.5 0 0 1 .061-.704l7.263-6.107a.5.5 0 0 1 .705.061zM7.266 6.423a.5.5 0 0 1 .705-.06l7.516 6.323a.5.5 0 0 1 .061.704L4.744 26.29a.5.5 0 0 1-.705.062L.68 23.534a.5.5 0 0 1 .642-.767L4.3 25.264 14.46 13.13 7.327 7.128a.5.5 0 0 1-.06-.705z","key":5}),React.createElement("path",{"d":"M33.141 14.675c.389-.08.653-.182.744-.245l.574.82c-.27.189-.711.322-1.117.405a5.595 5.595 0 0 1-1.314.118h-8.046c-1.07 0-2.105.397-3.296 1.588l-1.41 1.41c-.345.345-.54.798-.54 1.272v5.926c0 .158.102.259.26.259h.758a2.569 2.569 0 0 0 2.572-2.571v-1.518a.5.5 0 0 1 .146-.354c2.508-2.508 6.619-2.508 9.127 0l6.54 6.541 4.275-3.606.644.764-4.625 3.903a.5.5 0 0 1-.676-.029l-6.866-6.866c-2.069-2.069-5.437-2.116-7.565-.14v1.304a3.569 3.569 0 0 1-3.572 3.572h-.759a1.24 1.24 0 0 1-1.259-1.259v-5.926c0-.754.311-1.458.833-1.98l1.41-1.409c1.338-1.339 2.616-1.88 4.003-1.88h8.083a4.59 4.59 0 0 0 1.076-.1zM9.46 28.665l-4.228-3.541.642-.767 4.228 3.541z","key":6}),React.createElement("path",{"d":"M14.209 14.193c.681.533 1.348.544 2.185.544h3.216c.664 0 1.187.234 1.559.453a6.723 6.723 0 0 1 .442.287c.056.038.09.06.113.072l.009.005a.272.272 0 0 0-.065-.017l-.141.99a.845.845 0 0 1-.284-.101 2.512 2.512 0 0 1-.19-.118 15.921 15.921 0 0 1-.08-.055c-.097-.066-.195-.133-.312-.201-.287-.17-.631-.315-1.051-.315h-3.25c-.819 0-1.8 0-2.768-.757z","key":7})])]);
	}
	
	Samarbeid32px.displayName = "Samarbeid32px";
	
	Samarbeid32px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = Samarbeid32px;
	
	Samarbeid32px.default = Samarbeid32px;


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ShackingHands32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31 22.014h-2.467l.158.264a.968.968 0 0 1 .073.148c.418 1.066.62 3.377-1.609 4.492-.806.404-1.478.547-2.026.547-.437 0-.768-.101-1.052-.225a3.191 3.191 0 0 1-1.204 1.136c-.933.508-1.695.683-2.304.683a2.52 2.52 0 0 1-1.332-.36 3.38 3.38 0 0 1-1.04.797c-.798.399-1.511.548-2.118.548-.806 0-1.414-.262-1.802-.548-.31.37-.707.7-1.206.979-.664.373-1.291.523-1.857.523a3.205 3.205 0 0 1-2.664-1.446l-3.784-5.378c-.639-.895-1.922-2.16-2.766-2.16H1a1 1 0 0 1-1-1.001V6.003a1 1 0 0 1 1-1h4c.105-.014.482-.183.785-.32C7.092 4.096 9.525 3.001 14 3.001c.159 0 .305.046.438.112l.589-.621c1.565-1.66 2.35-2.493 4.036-2.493H21c3.342 0 4.517.794 6.142 1.892l.413.278c3.046 2.033 4.108 3.083 4.152 3.127.187.187.293.442.293.707v15.01a1 1 0 0 1-1 1.001zM5 7.004H2v13.008c2.203 0 4.181 2.699 4.398 3.007l3.815 5.423c.212.313.779.904 1.882.287.467-.263.759-.558.866-.879l.004-.008-3.775-5.214a1 1 0 0 1 1.619-1.174l4.676 6.456c.128.076.709.351 1.818-.204.397-.199.548-.417.613-.563l-3.744-5.542a1 1 0 0 1 1.656-1.121l4.437 6.567c.054.027.575.157 1.653-.429.279-.153.633-.429.6-1.022l-3.35-5.029a1 1 0 1 1 1.664-1.11l3.953 5.934c.131.088.589.181 1.476-.263 1.018-.509.774-1.566.663-1.909L18.779 9.586c-.814.72-2.062 1.713-3.35 2.324-2.647 1.257-4.665 1.463-6.005.617C8.506 11.945 8 10.916 8 9.627c0-.996.764-1.573 1.919-2.446a31.981 31.981 0 0 0 2.578-2.13c-3.079.197-4.806.969-5.893 1.458-.638.288-1.1.495-1.604.495zm25-.556c-.473-.406-1.559-1.283-3.555-2.614l-.422-.284C24.496 2.519 23.729 2.001 21 2.001h-1.937c-.767 0-1.066.257-2.581 1.864a81.857 81.857 0 0 1-1.806 1.873c-1.458 1.459-2.668 2.373-3.552 3.04-.461.349-.979.74-1.123.932.012.396.111.884.491 1.125.328.207 1.382.548 4.079-.732 1.836-.872 3.693-2.776 3.711-2.795a1 1 0 0 1 1.576.183l7.48 12.521H30V6.448z","key":1})]);
	}
	
	ShackingHands32px.displayName = "ShackingHands32px";
	
	ShackingHands32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 31"};
	
	module.exports = ShackingHands32px;
	
	ShackingHands32px.default = ShackingHands32px;


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function SoccerShoe32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M28.949 14h-2.001v1a.998.998 0 1 1-1.995 0v-1h-1.996v1a.998.998 0 1 1-1.996 0v-1h-1.995v1a.998.998 0 1 1-1.996 0v-1H9.985v1a.998.998 0 1 1-1.995 0v-1H5.994v1a.998.998 0 1 1-1.995 0v-1.004c-1.306-.01-2.271-.342-2.939-1.024-1.127-1.148-1.098-2.888-1.064-4.903C.001 7.723.007 7.365.007 7c0-4.252 1.567-7 3.992-7 1.319 0 2.014.607 2.573 1.093C7.13 1.58 7.613 2 8.988 2c1.526 0 2.163-.511 2.837-1.052C12.38.504 13.008 0 13.977 0c1.066 0 1.846.637 2.75 1.374.919.751 2.064 1.685 4.025 2.504 1.004.419 2.173.843 3.41 1.292 4.821 1.749 7.776 2.918 7.776 4.83 0 1.496 0 4-2.989 4zM15.466 2.925C14.743 2.334 14.317 2 13.977 2c-.246 0-.444.14-.905.51C12.288 3.138 11.213 4 8.988 4 6.867 4 5.94 3.193 5.262 2.602 4.803 2.201 4.571 2 3.999 2 2.703 2 2.003 4.576 2.003 7c0 .377-.006.745-.012 1.101-.026 1.566-.049 2.918.491 3.469.281.285.81.43 1.574.43h6.164l5.735-8.684c-.166-.133-.341-.27-.489-.391zm2.12 1.546L12.613 12h1.598l4.532-6.862c-.42-.221-.805-.445-1.157-.667zm2.985 1.483c-.016.033-.019.069-.04.101L16.605 12h1.599l3.662-5.547a71.412 71.412 0 0 1-1.295-.499zm3.204 1.204c-.013.023-.014.05-.03.073L20.597 12h8.352c.782 0 .993 0 .993-2-.324-.699-3.858-2.004-6.167-2.842z","key":1})]);
	}
	
	SoccerShoe32px.displayName = "SoccerShoe32px";
	
	SoccerShoe32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 31.94 16"};
	
	module.exports = SoccerShoe32px;
	
	SoccerShoe32px.default = SoccerShoe32px;


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Stethoscope32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M28 22.874v1.115c0 4.994-3.738 7.977-10 7.977-5.299 0-9-4.102-9-9.975v-2.124C2.433 18.533 0 4.341 0 3.093 0 .857 2.531.097 4.027 0A1.004 1.004 0 0 1 5.09.932a1.001 1.001 0 0 1-.931 1.062C3.731 2.023 2 2.313 2 3.093 2 5.09 5.029 17.98 10 17.98s8-12.89 8-14.887c0-.78-1.729-1.07-2.157-1.099A1.001 1.001 0 0 1 14.914.93 1.01 1.01 0 0 1 15.975 0C17.47.097 20 .857 20 3.093c0 1.248-2.431 15.456-9 16.785v2.113c0 4.697 2.879 7.977 7 7.977 2.987 0 8-.777 8-5.979v-1.115a5.006 5.006 0 0 1-4-4.894 5.004 5.004 0 0 1 5-4.996c2.757 0 5 2.242 5 4.996a5.006 5.006 0 0 1-4 4.894zm-1-7.891c-1.654 0-3 1.344-3 2.997a3.002 3.002 0 0 0 3 2.997c1.654 0 3-1.344 3-2.997a3.002 3.002 0 0 0-3-2.997z","key":1})]);
	}
	
	Stethoscope32px.displayName = "Stethoscope32px";
	
	Stethoscope32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 31.97"};
	
	module.exports = Stethoscope32px;
	
	Stethoscope32px.default = Stethoscope32px;


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Strategien32px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 strategien"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M47.603 22.138v1.07l-10.38 18.797H35.73l10.286-18.583v-.062h-9.08v-1.222zM.397 29.198v-.917l1.905-1.895c5.746-5.41 8.254-8.19 8.254-11.614 0-2.262-.984-4.493-4.476-4.493-1.969 0-3.493.978-4.381 1.712l-.604-1.009a7.978 7.978 0 0 1 5.27-1.987c4.286 0 5.746 3.118 5.746 5.471 0 3.913-2.952 7.06-8.127 11.982l-1.46 1.436v.061h10.159v1.253zM31.096 22.138H25.19V9.332h-1.238l-10.064 13.05v.978h9.841v5.838h1.46v-5.837h5.874l.38-.612zM23.73 14.1v8.038H15.7v-.061l6.444-8.252c.476-.703.953-1.376 1.587-2.507l.096.03a38.51 38.51 0 0 0-.096 2.752z","key":0}),React.createElement("path",{"d":"M30.746 29.229a.956.956 0 0 1-.285-.061c-.254-.153-.35-.49-.191-.734l3.524-5.685-3.524-5.685c-.159-.244-.063-.58.19-.733a.578.578 0 0 1 .762.183l3.683 5.96a.566.566 0 0 1 0 .55l-3.683 5.96c-.127.153-.285.245-.476.245zM47.603 22.138v1.07l-10.38 18.797H35.73l10.286-18.583v-.062h-9.08v-1.222zM.397 29.198v-.917l1.905-1.895c5.746-5.41 8.254-8.19 8.254-11.614 0-2.262-.984-4.493-4.476-4.493-1.969 0-3.493.978-4.381 1.712l-.604-1.009a7.978 7.978 0 0 1 5.27-1.987c4.286 0 5.746 3.118 5.746 5.471 0 3.913-2.952 7.06-8.127 11.982l-1.46 1.436v.061h10.159v1.253z","key":1}),React.createElement("path",{"d":"M31.096 22.138H25.19V9.332h-1.238l-10.064 13.05v.978h9.841v5.838h1.46v-5.837h5.874l.38-.612zM23.73 14.1v8.038H15.7v-.061l6.444-8.252c.476-.703.953-1.376 1.587-2.507l.096.03a38.51 38.51 0 0 0-.096 2.752z","key":2}),React.createElement("path",{"d":"M30.746 29.229a.956.956 0 0 1-.285-.061c-.254-.153-.35-.49-.191-.734l3.524-5.685-3.524-5.685c-.159-.244-.063-.58.19-.733a.578.578 0 0 1 .762.183l3.683 5.96a.566.566 0 0 1 0 .55l-3.683 5.96c-.127.153-.285.245-.476.245z","key":3})])]);
	}
	
	Strategien32px.displayName = "Strategien32px";
	
	Strategien32px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = Strategien32px;
	
	Strategien32px.default = Strategien32px;


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Sun32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31 17h-6a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2zm-7.293-7.793a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l4-4a.999.999 0 1 1 1.414 1.414l-4 4zM16 21.5c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zm0-10c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zM16 8a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1zM9 9.5a.997.997 0 0 1-.707-.293l-4-4a.999.999 0 1 1 1.414-1.414l4 4A.999.999 0 0 1 9 9.5zM8 16a1 1 0 0 1-1 1H1a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1zm.293 5.793a.999.999 0 1 1 1.414 1.414l-4 4a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l4-4zM16 24a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1zm7.707-2.207l4 4a.999.999 0 1 1-1.414 1.414l-4-4a.999.999 0 1 1 1.414-1.414z","key":1})]);
	}
	
	Sun32px.displayName = "Sun32px";
	
	Sun32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 32"};
	
	module.exports = Sun32px;
	
	Sun32px.default = Sun32px;


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Supercar32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31 19.241V21a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-1H10v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1.759a2.942 2.942 0 0 1-1-2.202v-4.29c0-2.582 1.545-4.651 4.028-5.609a.976.976 0 0 1 .078-.587l2-4C7.046.671 11.835 0 16.003 0c.392 0 9.629.029 10.892 2.552l2.024 5.053C30.847 8.7 32 10.541 32 12.749v4.29c0 .878-.391 1.659-1 2.202zM21.747 18a8.359 8.359 0 0 1-.814-1.417A1.673 1.673 0 0 0 19.668 16h-7.336a1.67 1.67 0 0 0-1.265.583A8.398 8.398 0 0 1 10.253 18h11.494zM25.11 3.467C24.566 2.927 21.149 2 16.003 2c-5.436 0-7.851 1.07-8.115 1.459L6.314 6.608C7.954 6.418 12.023 6 16 6c5.007 0 10.173.664 10.391.692l.01.003-1.291-3.228zM30 12.749c0-2.073-1.502-3.637-3.919-4.082C26.07 8.667 20.869 8 16 8c-4.874 0-10.081.668-10.133.675C3.499 9.092 2 10.655 2 12.749v4.29c0 .53.431.961.961.961H7c1.104 0 2.075-1.825 2.275-2.313.033-.079.075-.153.125-.221A3.681 3.681 0 0 1 12.332 14h7.336a3.68 3.68 0 0 1 2.931 1.466c.051.068.093.142.126.221C22.973 16.286 23.926 18 25 18h4.039c.53 0 .961-.431.961-.961v-4.29zm-1.684.2l-3 1a.999.999 0 0 1-.632-1.898l3-1a1 1 0 1 1 .632 1.898zM7 14a.995.995 0 0 1-.316-.051l-3-1a1 1 0 0 1 .632-1.898l3 1A1 1 0 0 1 7 14z","key":1})]);
	}
	
	Supercar32px.displayName = "Supercar32px";
	
	Supercar32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 22"};
	
	module.exports = Supercar32px;
	
	Supercar32px.default = Supercar32px;


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Tractor32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M30.867 21.153a.998.998 0 0 1-.985.847h-1.021a4.963 4.963 0 0 1 1.021 3c0 2.757-2.234 5-4.979 5-2.746 0-4.98-2.243-4.98-5 0-1.13.39-2.162 1.022-3h-3.064c.028.332.05.664.05 1 0 .552-.445 1-.996 1a.997.997 0 0 1-.995-1c0-.315-.018-.626-.048-.933A8.949 8.949 0 0 0 6.976 14a8.85 8.85 0 0 0-5.357 1.788.992.992 0 0 1-1.394-.202 1.003 1.003 0 0 1 .201-1.4 10.836 10.836 0 0 1 3.563-1.744V1c0-.552.445-1 .996-1h9.959c.401 0 .764.243.919.616l4.748 11.441 3.296.477V10c0-1.654 1.34-3 2.988-3 .55 0 .995.448.995 1s-.445 1-.995 1a.998.998 0 0 0-.996 1v2.822l5.121.74c.264.038.501.18.659.395.158.215.224.484.183.748l-.995 6.448zM24.903 28a2.997 2.997 0 0 0 2.987-3c0-1.654-1.34-3-2.987-3a2.997 2.997 0 0 0-2.988 3c0 1.654 1.34 3 2.988 3zM14.279 2H5.91v10h12.519l-4.15-10zm5.724 11.989L20 13.988c-.02.001-.037.012-.057.012h-6.669a10.954 10.954 0 0 1 4.24 6h11.515l.71-4.603-9.736-1.408zM6.976 16c3.844 0 6.972 3.14 6.972 7s-3.128 7-6.972 7C3.133 30 .005 26.86.005 23s3.128-7 6.971-7zm0 12c2.746 0 4.98-2.243 4.98-5s-2.234-5-4.98-5c-2.745 0-4.979 2.243-4.979 5s2.234 5 4.979 5z","key":1})]);
	}
	
	Tractor32px.displayName = "Tractor32px";
	
	Tractor32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 31.85 30"};
	
	module.exports = Tractor32px;
	
	Tractor32px.default = Tractor32px;


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function UmbrellaOpen32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M32 13.806C32 14.842 31.138 16 29.984 16H17v10.963C17 29.74 14.745 32 11.973 32 9.185 32 7 29.803 7 27a1 1 0 1 1 2 0c0 1.682 1.306 3 2.973 3A3.036 3.036 0 0 0 15 26.963V16H2.016C.828 16 0 14.869 0 13.854 0 6.399 7.388 2.359 15 2.032V1a1 1 0 1 1 2 0v1.032c7.612.325 15 4.349 15 11.774zM16 4C10.372 4 2 6.624 2 13.854a.307.307 0 0 0 .104.164l13.852-.009c.015-.001.028-.009.044-.009.015 0 .028.008.044.009L29.9 14a.415.415 0 0 0 .1-.195C30 6.611 21.628 4 16 4z","key":1})]);
	}
	
	UmbrellaOpen32px.displayName = "UmbrellaOpen32px";
	
	UmbrellaOpen32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 32"};
	
	module.exports = UmbrellaOpen32px;
	
	UmbrellaOpen32px.default = UmbrellaOpen32px;


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoAnlegg32px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M16 30a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1zm15.8-2.5a1 1 0 0 1-.8.5l-.5-.2L19.7 21H17v1a1 1 0 0 1-2 0v-1h-2.7L1.5 27.8a1 1 0 1 1-1-1.6l1.5-1V16a14 14 0 0 1 28 0v9.2l1.5 1a1 1 0 0 1 .3 1.3zM4 23.9l7-4.5V16a5 5 0 0 1 10 0v3.4l7 4.5V16a12 12 0 0 0-24 0zM19 19v-3a3 3 0 0 0-6 0v3z"}));
	}
	
	VoAnlegg32px.displayName = "VoAnlegg32px";
	
	VoAnlegg32px.defaultProps = {"viewBox":"0 0 32 32"};
	
	module.exports = VoAnlegg32px;
	
	VoAnlegg32px.default = VoAnlegg32px;


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoBygg32px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M31 17h-2V9.7h-.1v-.3h-.5L10.2 4.3 10 2.9a1 1 0 0 0-2 0l-.2 1.7L.5 9.2A1 1 0 0 0 1 11h5.8L4.1 30H3a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2h-1.1l-2.7-19H27v6h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zM4.5 9l2.9-1.8L7.1 9zm7.4 21H6.2l2.7-19h.3zm-1-21l-.4-2.6L20.3 9zM30 22h-4v-3h4zm-20 2a1 1 0 1 1-1-1 1 1 0 0 1 1 1z"}));
	}
	
	VoBygg32px.displayName = "VoBygg32px";
	
	VoBygg32px.defaultProps = {"viewBox":"0 0 32 32"};
	
	module.exports = VoBygg32px;
	
	VoBygg32px.default = VoBygg32px;


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoEiendom32px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M31.47 18.66a.98.98 0 0 1-.656.249.983.983 0 0 1-.745-.338l-1.242-1.412V29.88a1.993 1.993 0 0 1-1.987 1.994H4.989a1.993 1.993 0 0 1-1.987-1.994V17.159L1.76 18.571a.986.986 0 0 1-1.401.089.999.999 0 0 1-.088-1.407L15.169.299c.379-.43 1.112-.43 1.49 0l14.899 16.954a.999.999 0 0 1-.088 1.407zm-4.53-3.648L15.914 2.466 4.94 14.953V29.94h22V15.012zm-14.005-.092a3.92 3.92 0 0 1 2.979 1.383 3.923 3.923 0 0 1 2.98-1.383c2.191 0 3.973 1.828 3.973 4.073 0 1.047-.459 2.148-1.229 2.944-.006.007-.015.009-.022.015-.007.007-.009.017-.016.024l-5.011 4.647a.993.993 0 0 1-1.349 0l-5.011-4.647c-.007-.007-.009-.016-.016-.023-.007-.007-.016-.009-.022-.016-.77-.796-1.229-1.897-1.229-2.944 0-2.245 1.781-4.073 3.973-4.073zm2.979 9.613l4.305-3.993c.402-.419.662-1.025.662-1.547 0-1.146-.892-2.078-1.987-2.078-1.095 0-1.986.932-1.986 2.078a.995.995 0 0 1-1.987 0c0-1.146-.891-2.078-1.986-2.078s-1.987.932-1.987 2.078c0 .522.259 1.127.661 1.547l4.305 3.993z"}));
	}
	
	VoEiendom32px.displayName = "VoEiendom32px";
	
	VoEiendom32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 31.82 31.88"};
	
	module.exports = VoEiendom32px;
	
	VoEiendom32px.default = VoEiendom32px;


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoEnergi32px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M13 32h-.4a1 1 0 0 1-.6-1.1L13.8 19H8a1 1 0 0 1-.8-1.6l13-17a1 1 0 0 1 1.8.8L20.2 13H26a1 1 0 0 1 .8 1.6l-13 17a1 1 0 0 1-.8.4zm-3-15h5a1 1 0 0 1 1 1.2l-1.4 9.1L24 15h-5a1 1 0 0 1-1-1.2l1.4-9.1z"}));
	}
	
	VoEnergi32px.displayName = "VoEnergi32px";
	
	VoEnergi32px.defaultProps = {"viewBox":"0 0 32 32"};
	
	module.exports = VoEnergi32px;
	
	VoEnergi32px.default = VoEnergi32px;


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoMiljo32px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M31.691 27.494a.996.996 0 0 1-.865.506h-11.5l1.275 1.297A1.003 1.003 0 0 1 19.894 31a.986.986 0 0 1-.707-.297l-2.986-3.035a1.008 1.008 0 0 1 .007-1.415l2.986-2.965a.994.994 0 0 1 1.408.009 1.005 1.005 0 0 1-.009 1.415L19.295 26h9.781l-5.008-8.451a1.003 1.003 0 0 1 .346-1.371.991.991 0 0 1 1.364.347l5.903 9.963c.183.309.187.693.01 1.006zm-8.19-13.848a.98.98 0 0 1-.494.701.988.988 0 0 1-.468.118c-.003 0-.006-.003-.01-.003l-.009.003a.987.987 0 0 1-.253-.033l-4.06-1.073a.998.998 0 0 1-.709-1.22.991.991 0 0 1 1.215-.713l1.877.495-4.728-8.894-5.065 8.487a.989.989 0 0 1-1.364.343 1.002 1.002 0 0 1-.341-1.372l5.968-10c.184-.308.503-.48.877-.485a.995.995 0 0 1 .853.528l5.416 10.191.426-1.636a1 1 0 0 1 1.215-.715c.531.141.85.687.711 1.221l-1.057 4.057zm-14.1 1.101l1.062 4.082a1.002 1.002 0 0 1-.963 1.253.997.997 0 0 1-.962-.747l-.483-1.856L2.782 26H12.93c.55 0 .994.447.994 1 0 .553-.444 1-.994 1H.991a.987.987 0 0 1-.433-.11c-.03-.015-.062-.023-.092-.041-.032-.02-.05-.052-.079-.075a1.006 1.006 0 0 1-.146-.138 1.075 1.075 0 0 1-.181-.326.961.961 0 0 1-.041-.207c-.004-.036-.021-.066-.021-.103 0-.025.013-.046.014-.071a.962.962 0 0 1 .041-.203c.019-.064.038-.124.068-.182.012-.023.013-.049.027-.072l6.101-9.861-1.666.44a1 1 0 0 1-.505-1.934l4.088-1.079a.964.964 0 0 1 .279-.021.973.973 0 0 1 .495.12c.227.134.394.353.461.61z"}));
	}
	
	VoMiljo32px.displayName = "VoMiljo32px";
	
	VoMiljo32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 31.82 31"};
	
	module.exports = VoMiljo32px;
	
	VoMiljo32px.default = VoMiljo32px;


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoOffshore32px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M31 30h-3a4.8 4.8 0 0 1-2-.4V26h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4.4l7-6.3a1 1 0 0 0-1-1.7l-10.2 3.8L18 3.9a1 1 0 0 0-1-.9h-1V1a1 1 0 0 0-2 0v2h-1a1 1 0 0 0-1 .9l-1.3 11.4a1 1 0 0 0-.7-.3H2a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h1.9v4H1a1 1 0 0 0 0 2h16a9 9 0 0 0 6-2.3 6.6 6.6 0 0 0 5 2.3h3a1 1 0 0 0 0-2zm-5.6-14.3L20.6 20h-.7l-.3-2.2zM13.9 5h2.2l1.8 15h-5.8zM3 17h6v4a1 1 0 0 0 1 1h17v2H3zm2.9 13v-4H8v4zm4.1 0v-4h10v3.3a7.6 7.6 0 0 1-3 .7zm12.1-2.4V26h2v1.6a1 1 0 0 0-2 0zM6 19a1 1 0 1 1-1-1 1 1 0 0 1 1 1z"}));
	}
	
	VoOffshore32px.displayName = "VoOffshore32px";
	
	VoOffshore32px.defaultProps = {"viewBox":"0 0 32 32"};
	
	module.exports = VoOffshore32px;
	
	VoOffshore32px.default = VoOffshore32px;


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Volleyball32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31.846 16.215a.835.835 0 0 1-.007.132C31.653 25.008 24.592 32 15.923 32c-2.863 0-5.546-.773-7.87-2.106a.946.946 0 0 1-.277-.169C3.122 26.929-.011 21.831-.011 16c0-6.371 3.738-11.869 9.119-14.441a.954.954 0 0 1 .193-.093A15.759 15.759 0 0 1 15.923 0c6.201 0 11.573 3.583 14.205 8.789.02.045.049.084.062.131A15.925 15.925 0 0 1 31.857 16c0 .073-.01.143-.011.215zM15.138 29.958a18.076 18.076 0 0 0 7.259-14.83c-2.819.04-4.711.938-5.481 1.395.047 1.847-.4 7.321-6.622 12.274a13.818 13.818 0 0 0 4.844 1.161zm-6.771-2.21c1.588-1.168 2.791-2.374 3.707-3.547-2.117-1.257-7.56-5.199-9.208-13.032A13.902 13.902 0 0 0 1.981 16c0 4.923 2.549 9.251 6.386 11.748zm.301-23.68a14.112 14.112 0 0 0-4.244 4.086c.001.003.003.005.003.009.682 8.951 6.874 13.259 8.778 14.38 1.601-2.735 1.742-5.072 1.72-5.983-1.531-1.014-5.771-4.517-6.257-12.492zM15.923 2c-1.875 0-3.663.379-5.297 1.056.043 1.932.326 3.582.742 4.988 2.298-1.161 8.155-3.417 15.205-1.045C24.014 3.95 20.196 2 15.923 2zM28.48 9.95c-7.694-3.859-14.378-1.067-16.413-.011 1.259 2.809 3.007 4.289 3.833 4.867 1.068-.629 3.6-1.804 7.286-1.67.008-.001.014-.006.021-.007.049-.005.095.011.143.013 1.871.087 4.028.507 6.447 1.512A13.915 13.915 0 0 0 28.48 9.95zm-4.089 5.295c.039 2.679-.529 9.134-6.019 14.528 6.246-1.119 11.057-6.425 11.45-12.92-2.019-.931-3.832-1.407-5.431-1.608z","key":1})]);
	}
	
	Volleyball32px.displayName = "Volleyball32px";
	
	Volleyball32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 31.84 32"};
	
	module.exports = Volleyball32px;
	
	Volleyball32px.default = Volleyball32px;


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Wall32px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31 23H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v6h4a1 1 0 0 1 1 1v6h4a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1zm-19-2h8v-5h-8v5zm3-7V9H7v5h8zM2 21h8v-5H2v5zm0-7h3V9H2v5zm0-7h8V2H2v5zm18-5h-8v5h8V2zm5 7h-8v5h8V9zm5 7h-8v5h8v-5z","key":1})]);
	}
	
	Wall32px.displayName = "Wall32px";
	
	Wall32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 23"};
	
	module.exports = Wall32px;
	
	Wall32px.default = Wall32px;


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function IDCard48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M45.467 44H2.533A2.542 2.542 0 0 1 0 41.455V10.544a2.542 2.542 0 0 1 2.533-2.545H20v-7a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v7h17.467A2.542 2.542 0 0 1 48 10.544v30.911A2.542 2.542 0 0 1 45.467 44zM26 2h-4v10.001h4V2zm20 8.544a.546.546 0 0 0-.533-.544H28v3.001c0 .552-.448 1.001-1 1.001h-6c-.552 0-1-.449-1-1.001V10H2.533a.546.546 0 0 0-.533.544v30.911c0 .295.244.544.533.544h42.934a.546.546 0 0 0 .533-.544V10.544zM31.5 37.999h-15A2.502 2.502 0 0 1 14 35.5v-1.501c0-.05.021-.093.029-.142.011-.074.017-.149.044-.218.024-.061.063-.111.097-.165.035-.054.062-.11.106-.157.054-.057.12-.095.185-.138.039-.026.067-.062.111-.083l5.326-2.523c-.927-1.801-.911-3.643-.892-4.045-.001-.01-.006-.019-.006-.029L19.002 22c0-.026.013-.048.015-.074.002-.031-.009-.061-.003-.093.379-2.254 2.809-3.779 4.885-3.829.033-.002.067-.004.101-.004 2.097 0 4.601 1.54 4.986 3.834.006.032-.005.061-.003.093.002.025.015.047.015.073L29 26.499c0 .01-.006.018-.006.028.019.401.035 2.244-.892 4.046l5.326 2.523c.044.021.072.057.111.083.065.043.131.081.184.138.045.047.072.103.106.156.035.055.074.105.098.166.027.069.033.142.044.216.007.049.029.093.029.144V35.5a2.503 2.503 0 0 1-2.5 2.499zm-5.262-6.095c-.027-.013-.043-.036-.068-.051-.038-.022-.08-.034-.115-.062-.026-.019-.038-.048-.06-.069a.918.918 0 0 1-.133-.153.922.922 0 0 1-.154-.34.996.996 0 0 1-.029-.187 1.063 1.063 0 0 1 .061-.382c.011-.029.009-.06.022-.089.016-.033.045-.055.064-.086.02-.031.025-.067.048-.097 1.248-1.614 1.123-3.792 1.121-3.814-.002-.021.008-.04.008-.061-.001-.004-.003-.008-.003-.013l-.002-4.387c-.221-1.092-1.581-2.077-2.922-2.113a.967.967 0 0 1-.076.004c-1.342 0-2.776 1.019-2.998 2.111L21 26.5l-.002.011c-.001.02.009.038.007.059-.001.022-.133 2.197 1.12 3.818.024.03.029.066.049.098.019.031.048.052.064.085.013.029.011.06.022.089a.967.967 0 0 1 .048.196.974.974 0 0 1 .012.186.972.972 0 0 1-.028.186.947.947 0 0 1-.06.182 1.012 1.012 0 0 1-.094.158.925.925 0 0 1-.133.154c-.023.021-.035.05-.06.069-.036.028-.077.04-.115.062-.025.015-.041.038-.068.051L16 34.632v.868c0 .27.229.5.5.5h15c.271 0 .5-.23.5-.5v-.868l-5.762-2.728z","key":1})]);
	}
	
	IDCard48px.displayName = "IDCard48px";
	
	IDCard48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 44"};
	
	module.exports = IDCard48px;
	
	IDCard48px.default = IDCard48px;


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function BarChartUp48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M46.974 48.875h-6.975a1 1 0 0 1-.997-1.005V17.726c0-.555.447-.788.998-.788h7c.551 0 .971.233.971.788V47.87a1 1 0 0 1-.997 1.005zM41 18.939l-.005 27.927h4.982L46 18.939h-5zm3.739-7.024a.999.999 0 0 1-.921.62 1.007 1.007 0 0 1-.921-1.39l2.283-5.543L1.52 24.677a.995.995 0 0 1-.395.084.998.998 0 0 1-.916-.606 1.01 1.01 0 0 1 .518-1.322L44.184 3.847l-4.8-1.89a1.006 1.006 0 0 1-.565-1.301.994.994 0 0 1 1.292-.57l7.226 2.846c.249.098.449.294.554.542.105.249.106.53.004.779l-3.156 7.662zM1 31.939h7a1 1 0 0 1 1 1v15c0 .555-.348.936-.899.936H1.124c-.551 0-1.124-.381-1.124-.936v-15a1 1 0 0 1 1-1zm1 15h5v-13H2v13zm12-20h7a1 1 0 0 1 1 1v20c0 .555-.391.936-.941.936h-6.978c-.551 0-1.081-.381-1.081-.936v-20a1 1 0 0 1 1-1zm1 20h5v-18h-5v18zm12-25h7c.551 0 1.013.257 1.013.812V47.87a1 1 0 0 1-.997 1.005h-6.977a1 1 0 0 1-.997-1.005V22.751c0-.555.407-.812.958-.812zm1 25h5V23.938h-5v23.001z","key":1})]);
	}
	
	BarChartUp48px.displayName = "BarChartUp48px";
	
	BarChartUp48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 48.88"};
	
	module.exports = BarChartUp48px;
	
	BarChartUp48px.default = BarChartUp48px;


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Bill248px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M35.963 13.171c.003.03.018.055.018.085v31.682a3 3 0 0 1-2.999 2.996H2.998a3 3 0 0 1-2.999-2.996V3.005A3 3 0 0 1 2.998.01h19.625c.088 0 .166.028.248.05.299-.036.603.022.823.242l11.885 11.872a.998.998 0 0 1 .421.816c0 .064-.025.12-.037.181zM23.987 3.418v8.573h8.581l-8.581-8.573zm9.995 10.57H22.987a.998.998 0 0 1-.999-.998V2.007H2.998a1 1 0 0 0-1 .998v41.933a1 1 0 0 0 1 .999h29.984a1 1 0 0 0 1-.999v-30.95zM28.984 37.95h-2.998a.999.999 0 1 1 0-1.997h2.998a.999.999 0 1 1 0 1.997zm0-5.991h-2.998a.998.998 0 1 1 0-1.996h2.998a.998.998 0 1 1 0 1.996zm0-5.99h-2.998a.999.999 0 1 1 0-1.997h2.998a.999.999 0 1 1 0 1.997zM20.988 37.95H6.995a.998.998 0 1 1 0-1.997h13.993a.999.999 0 1 1 0 1.997zm0-5.991H6.995a.998.998 0 1 1 0-1.996h13.993a.998.998 0 1 1 0 1.996zm0-5.99H6.995a.998.998 0 1 1 0-1.997h13.993a.999.999 0 1 1 0 1.997z","key":1})]);
	}
	
	Bill248px.displayName = "Bill248px";
	
	Bill248px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 36 47.94"};
	
	module.exports = Bill248px;
	
	Bill248px.default = Bill248px;


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Binoculars48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M38 41.971c-5.514 0-10-4.493-10-10.016 0-.26.019-.515.039-.769-.013-.065-.039-.125-.039-.194v-6.129c0-.495-.404-.882-.921-.882h-6.158c-.517 0-.921.387-.921.882v7.131c0 .005-.003.008-.003.013-.028 5.499-4.501 9.964-9.997 9.964-5.514 0-10-4.493-10-10.016 0-.856.119-1.682.322-2.475.003-.019-.003-.036.001-.055L6.026 5.157c.003-.009.01-.016.012-.025.002-.009 0-.017.002-.026a7.16 7.16 0 0 1 6.837-5.131c3.857 0 7.001 3.088 7.112 6.925.001.019.011.034.011.053V12h8V6.953c0-.019.01-.034.011-.053.111-3.837 3.255-6.925 7.112-6.925a7.16 7.16 0 0 1 6.837 5.131c.003.009 0 .018.002.026.003.01.009.016.012.025l5.703 24.268c.004.019-.002.036.001.055.203.793.322 1.619.322 2.475 0 5.523-4.486 10.016-10 10.016zm-28-2.003c4.411 0 8-3.596 8-8.013 0-4.42-3.589-8.014-8-8.014s-8 3.594-8 8.014c0 4.417 3.589 8.013 8 8.013zM40.036 5.656a5.146 5.146 0 0 0-4.913-3.678A5.132 5.132 0 0 0 30 7.109v5.854a1 1 0 0 1-1 1.001H19a1 1 0 0 1-1-1.001V7.109a5.132 5.132 0 0 0-5.123-5.131 5.146 5.146 0 0 0-4.913 3.679L3.588 24.278A9.945 9.945 0 0 1 10 21.938c3.273 0 6.174 1.591 8 4.033v-1.108c0-1.617 1.283-2.885 2.921-2.885h6.158c1.638 0 2.921 1.268 2.921 2.885v1.108c1.825-2.442 4.727-4.033 8-4.033 2.439 0 4.674.882 6.412 2.34L40.036 5.656zM38 23.941c-4.411 0-8 3.594-8 8.014 0 4.417 3.589 8.013 8 8.013s8-3.596 8-8.013c0-4.42-3.589-8.014-8-8.014z","key":1})]);
	}
	
	Binoculars48px.displayName = "Binoculars48px";
	
	Binoculars48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 42"};
	
	module.exports = Binoculars48px;
	
	Binoculars48px.default = Binoculars48px;


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function BulbIdea48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M47 18.909h-3c-.553 0-1-.402-1-.953 0-.551.447-1.047 1-1.047h3c.553 0 1 .496 1 1.047 0 .551-.447.953-1 .953zM41.707 5.687a.997.997 0 0 1-1.414 0 .995.995 0 0 1 0-1.411l4-3.992a1 1 0 0 1 1.414 0 .995.995 0 0 1 0 1.411l-4 3.992zm-9.809 25.99c-.734.662-.901 2.088-.901 2.535v8.267a.964.964 0 0 1-.012.152c-.282 1.823-2.105 5.267-6.987 5.267-4.881 0-6.705-3.444-6.987-5.267a.964.964 0 0 1-.012-.152v-8.264c-.004-.474-.175-1.849-.91-2.547-4.636-3.49-7.091-8.04-7.091-13.17 0-8.553 6.729-15.512 15-15.512s15 6.959 15 15.512c0 5.135-2.458 9.688-7.1 13.179zm-7.9 14.225c4.084 0 4.88-2.925 4.999-3.514v-4.407a12.466 12.466 0 0 1-4.773.944c-2.173 0-4.014-.53-5.225-.995v4.46c.115.571.905 3.512 4.999 3.512zm0-40.92c-7.168 0-13 6.063-13 13.516 0 5.692 3.461 9.468 6.365 11.633.017.013.025.031.04.045.014.012.032.015.045.028 1.506 1.408 1.551 3.745 1.551 4.008v1.56c1.423.66 5.654 2.214 9.998.005v-1.565c0-.269.045-2.659 1.567-4.023.012-.01.026-.013.038-.022.013-.011.018-.026.032-.036 2.903-2.165 6.364-5.941 6.364-11.633 0-7.453-5.832-13.516-13-13.516zM3.707 35.629a.997.997 0 0 1-1.414 0 .995.995 0 0 1 0-1.411l4-3.992a1 1 0 0 1 1.414 0 .994.994 0 0 1 0 1.41l-4 3.993zM6.999 5.98a.997.997 0 0 1-.707-.293l-4-3.992a.995.995 0 0 1 0-1.411 1 1 0 0 1 1.414 0l4 3.992a.997.997 0 1 1-.707 1.704zM5 17.956c0 .551-.447.953-1 .953H1c-.553 0-1-.402-1-.953 0-.551.447-1.047 1-1.047h3c.553 0 1 .496 1 1.047zm36.708 12.27l4 3.992a.995.995 0 0 1 0 1.411.997.997 0 0 1-1.414 0l-4-3.993a.994.994 0 0 1 0-1.41 1 1 0 0 1 1.414 0z","key":1})]);
	}
	
	BulbIdea48px.displayName = "BulbIdea48px";
	
	BulbIdea48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 47.91"};
	
	module.exports = BulbIdea48px;
	
	BulbIdea48px.default = BulbIdea48px;


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Chat348px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M47.292 47.956a1 1 0 0 1-1.121-.397L41.073 40H18c-2.306 0-4-1.836-4-4.143V30a1 1 0 1 1 2 0v5.857c0 1.204.978 2.183 2.182 2.183h23.451c.032 0 .059.015.091.018a1.038 1.038 0 0 1 .373.111.967.967 0 0 1 .152.103c.055.044.103.09.147.144.02.024.048.038.066.065L46 43.728V19.182A2.184 2.184 0 0 0 43.818 17H39a1 1 0 1 1 0-2.001h4.818A4.188 4.188 0 0 1 48 19.182V47a1 1 0 0 1-.708.956zM30 24.999H6.926l-5.097 7.559A1 1 0 0 1 0 31.999V4.181A4.187 4.187 0 0 1 4.182-.001h25.636A4.187 4.187 0 0 1 34 4.181v16.676c0 2.306-1.694 4.142-4 4.142zm2-20.818A2.184 2.184 0 0 0 29.818 2H4.182A2.183 2.183 0 0 0 2 4.181v24.547l3.538-5.247c.018-.027.046-.041.066-.066a.974.974 0 0 1 .145-.142c.05-.04.099-.075.155-.105a.996.996 0 0 1 .172-.069.982.982 0 0 1 .201-.041c.031-.003.058-.018.09-.018h23.451c1.203 0 2.182-.98 2.182-2.183V4.181z","key":1})]);
	}
	
	Chat348px.displayName = "Chat348px";
	
	Chat348px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 48"};
	
	module.exports = Chat348px;
	
	Chat348px.default = Chat348px;


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Coins248px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M34 43.998c-.809 0-1.605-.091-2.389-.228a.978.978 0 0 1-.611.228H5c-.553 0-1-.447-1-.999v-6.001a.999.999 0 0 1 1-.999h4v-4.001H6c-.553 0-1-.447-1-.999v-5H1a1 1 0 0 1-1-1v-6.001a.999.999 0 0 1 1-.999h5v-4H3a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h3v-5a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-3v3.999h3a1 1 0 0 1 1 1.001v2.999c7.72 0 14 6.281 14 14 0 7.721-6.28 14-14 14zM6 37.999v4h20.772c-.118-.071-.227-.158-.343-.232-.239-.155-.477-.31-.707-.479-.156-.115-.306-.238-.457-.36a13.176 13.176 0 0 1-.627-.529c-.15-.135-.294-.276-.438-.418a14.638 14.638 0 0 1-.559-.582 15.058 15.058 0 0 1-.404-.468 15.74 15.74 0 0 1-.499-.643c-.072-.099-.153-.188-.223-.289H6zm15.354-2c-.019-.039-.029-.082-.047-.122-.25-.54-.462-1.096-.64-1.663-.064-.201-.108-.406-.162-.61a13.908 13.908 0 0 1-.281-1.277c-.019-.111-.057-.217-.073-.329H11v4.001h10.354zM7 29.998h13c0-.606.053-1.206.131-1.802a13.864 13.864 0 0 1 .429-2.087c.01-.037.013-.074.024-.11H7v3.999zm-5-9.999v4h19.35c.196-.416.417-.818.652-1.21.043-.072.093-.14.137-.212.318-.509.666-.997 1.047-1.459.041-.05.077-.103.119-.152.284-.335.581-.659.896-.967H2zm2-12v3.999h24V7.999H4zm28-2v-4H8v4h24zm0 8H8v4h18.796a13.97 13.97 0 0 1 1.236-.662c.031-.014.064-.024.095-.039.443-.205.896-.384 1.356-.541.163-.055.328-.098.492-.147.338-.102.678-.194 1.023-.269.187-.04.373-.075.56-.108.148-.025.294-.064.442-.085v-2.149zm2 4c-.299 0-.589.007-.88.043a11.667 11.667 0 0 0-5.506 1.802l-.049.029a11.972 11.972 0 0 0-3.818 3.885 11.933 11.933 0 0 0-.819 1.615l-.004.008v.001A11.977 11.977 0 0 0 22 29.998c0 .272.011.535.039.798.014.067.03.132.03.203 0 .011-.003.02-.006.03.012.136.039.269.055.404.039.33.075.661.14.986.095.462.214.918.361 1.363.045.138.11.269.16.406.118.317.234.634.378.94.072.152.163.295.241.444.157.299.31.602.494.887v.001h.001c.211.331.437.65.676.956a11.856 11.856 0 0 0 6.658 4.258c.899.217 1.83.325 2.773.325 6.617 0 12-5.383 12-12.001 0-6.616-5.383-11.999-12-11.999zm0 21a8.945 8.945 0 0 1-2.077-.243 8.922 8.922 0 0 1-5.504-3.909 8.935 8.935 0 0 1-1.385-4.161 5.688 5.688 0 0 1-.034-.688c0-1.192.233-2.357.693-3.461a8.913 8.913 0 0 1 3.462-4.118l.053-.034a8.85 8.85 0 0 1 4.106-1.353c.193-.025.435-.033.686-.033 4.963 0 9 4.037 9 8.999 0 4.963-4.037 9.001-9 9.001zm0-16.001c-.169 0-.333.004-.497.025a6.823 6.823 0 0 0-3.272 1.081 6.93 6.93 0 0 0-2.691 3.2 6.982 6.982 0 0 0-.54 2.694c0 .169.005.332.024.496a6.894 6.894 0 0 0 1.08 3.274 6.94 6.94 0 0 0 4.279 3.043 7.037 7.037 0 0 0 1.617.187c3.859 0 7-3.14 7-7 0-3.859-3.141-7-7-7z","key":1})]);
	}
	
	Coins248px.displayName = "Coins248px";
	
	Coins248px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 44"};
	
	module.exports = Coins248px;
	
	Coins248px.default = Coins248px;


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ConstructionHelmet48px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M8.8 36.5c-2.9 0-6.5-.2-7.9-1a1.8 1.8 0 0 1-.9-1.6 2 2 0 0 1 1.2-1.6c0-2.4.3-9.1 4-14.6l.3-.3c4.2-6 13.5-6.7 13.9-6.7 12-.7 17.9 8.9 18.1 9.3a27.3 27.3 0 0 1 2.2 7.6 3.6 3.6 0 0 0 .5 1.7h.5c4.7 1.2 6.6 2 7.1 3a1.4 1.4 0 0 1 .1 1.1h-.1a4.5 4.5 0 0 1-4.4 2.1l-2.1-.2a78.9 78.9 0 0 0-8.7-.5c-3.4.1-20 1.2-20.2 1.2zm-6.4-2.6c1.9.6 6.7.6 10 .4.7 0 16.8-1.1 20.3-1.2a82.9 82.9 0 0 1 8.9.5l2 .2a2.7 2.7 0 0 0 2.1-.7 25.3 25.3 0 0 0-5.5-1.8h-.6c-1.6-.4-1.9-2.7-1.9-3.4a25.9 25.9 0 0 0-2-6.9 18.3 18.3 0 0 0-16.3-8.2c-.1 0-8.9.6-12.5 6l-.2.3c-3.6 5.6-3.6 12.5-3.5 13.8a1 1 0 0 1-.6 1zm37.8-4.6z"}));
	}
	
	ConstructionHelmet48px.displayName = "ConstructionHelmet48px";
	
	ConstructionHelmet48px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = ConstructionHelmet48px;
	
	ConstructionHelmet48px.default = ConstructionHelmet48px;


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Diploma348px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M47 31.952h-3a1 1 0 1 1 0-1.998h2V1.988H2V30h20c.553 0 1 .401 1 .953 0 .551-.447 1.047-1 1.047H1c-.553 0-1-.496-1-1.047V.989A.999.999 0 0 1 1-.01h46c.553 0 1 .447 1 .999v29.964a1 1 0 0 1-1 .999zm-14-16.98c3.859 0 7 3.137 7 6.992 0 1.31-.369 2.533-1 3.582v11.4a1.002 1.002 0 0 1-1.515.856l-4.484-2.688-4.486 2.688a1.004 1.004 0 0 1-1.008.013.997.997 0 0 1-.507-.869v-11.4a6.926 6.926 0 0 1-1-3.582c0-3.855 3.141-6.992 7-6.992zm0 1.998c-2.757 0-5 2.241-5 4.994a5.003 5.003 0 0 0 5 4.994c2.757 0 5-2.241 5-4.994a5.003 5.003 0 0 0-5-4.994zm-.514 16.123a.997.997 0 0 1 1.03 0L37 35.182v-7.489a6.962 6.962 0 0 1-8 0v7.489l3.486-2.089zm-11.485-19.12a.999.999 0 1 1 0 1.998H11a.999.999 0 1 1 0-1.998h10.001zM6 8.979a.998.998 0 0 1 1-.998h34a.998.998 0 1 1 0 1.997H7c-.553 0-1-.447-1-.999z","key":1})]);
	}
	
	Diploma348px.displayName = "Diploma348px";
	
	Diploma348px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 37.97"};
	
	module.exports = Diploma348px;
	
	Diploma348px.default = Diploma348px;


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function DiscountStar48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M44.75 23.872l2.908 5.679a.996.996 0 0 1-.345 1.29l-5.359 3.464-.32 6.371a.995.995 0 0 1-.944.944l-6.372.32-3.463 5.359a.994.994 0 0 1-1.29.346l-5.678-2.91-5.679 2.91a.998.998 0 0 1-1.29-.346l-3.463-5.359-6.372-.32a.995.995 0 0 1-.944-.944l-.32-6.371L.46 30.841a.996.996 0 0 1-.345-1.29l2.908-5.679-2.908-5.678a.996.996 0 0 1 .345-1.29l5.359-3.463.32-6.372a.996.996 0 0 1 .944-.944l6.372-.32L16.918.446A.994.994 0 0 1 18.208.1l5.679 2.91L29.565.1a.995.995 0 0 1 1.29.346l3.463 5.359 6.372.32a.996.996 0 0 1 .944.944l.32 6.372 5.359 3.463a.996.996 0 0 1 .345 1.29l-2.908 5.678zm-4.304-9.036a1 1 0 0 1-.454-.786l-.3-5.983-5.982-.301a.994.994 0 0 1-.786-.453l-3.252-5.031-5.332 2.732a1 1 0 0 1-.907 0l-5.332-2.732-3.252 5.031a.994.994 0 0 1-.786.453l-5.982.301-.3 5.983a1 1 0 0 1-.454.786l-5.031 3.251 2.731 5.332a.988.988 0 0 1 0 .907l-2.731 5.331 5.031 3.252c.268.175.437.466.454.786l.3 5.983 5.982.301c.32.016.612.184.786.453l3.252 5.031 5.332-2.732a.996.996 0 0 1 .907 0l5.332 2.732 3.252-5.031a.994.994 0 0 1 .786-.453l5.982-.301.3-5.983c.017-.32.186-.611.454-.786l5.031-3.252-2.731-5.331a.988.988 0 0 1 0-.907l2.731-5.332-5.031-3.251zm-8.597 17.993c-2.196 0-3.982-2.231-3.982-4.975 0-2.743 1.786-4.976 3.982-4.976 2.193 0 3.978 2.233 3.978 4.976 0 2.744-1.785 4.975-3.978 4.975zm0-7.961c-1.079 0-1.992 1.368-1.992 2.986s.913 2.985 1.992 2.985c1.078 0 1.988-1.367 1.988-2.985 0-1.618-.91-2.986-1.988-2.986zm-10.004 8.276a.996.996 0 1 1-1.887-.63l5.97-17.91a.993.993 0 1 1 1.887.629l-5.97 17.911zm-5.919-8.276c-2.195 0-3.98-2.232-3.98-4.974 0-2.744 1.785-4.976 3.98-4.976 2.195 0 3.98 2.232 3.98 4.976 0 2.742-1.785 4.974-3.98 4.974zm0-7.96c-1.079 0-1.99 1.368-1.99 2.986 0 1.617.911 2.984 1.99 2.984s1.99-1.367 1.99-2.984c0-1.618-.911-2.986-1.99-2.986z","key":1})]);
	}
	
	DiscountStar48px.displayName = "DiscountStar48px";
	
	DiscountStar48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 47.75 47.75"};
	
	module.exports = DiscountStar48px;
	
	DiscountStar48px.default = DiscountStar48px;


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function DocumentPencil48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M45.598 40.534l-2.792 6.778a.995.995 0 0 1-1.84.001l-2.887-7.005a.84.84 0 0 1-.022-.053l-.076-.185a.992.992 0 0 1 .019-.793V10.402a.989.989 0 0 1-.095-.413c0-.149.037-.286.095-.413V4.413a.98.98 0 0 1-.095-.412A3.992 3.992 0 0 1 41.886.007c2.025 0 3.683 1.532 3.929 3.5a.607.607 0 0 1 .185.431v36c0 .292-.167.48-.402.596zM44 4.46a.97.97 0 0 1-.126-.459 1.996 1.996 0 0 0-1.988-1.998c-1.097 0-1.99.897-1.99 1.998 0 .03-.015.055-.017.085.002.029.017.054.017.084v4.82H44V4.46zm0 6.527h-4.104v28.502l1.99 4.828 2.063-5.01c.012-.03.036-.048.051-.076V10.987zm-10.074 6.08v27.867a2.994 2.994 0 0 1-2.985 2.995H2.975a2.994 2.994 0 0 1-2.986-2.995V2.999A2.994 2.994 0 0 1 2.975.004h14.031c.023 0 .043.012.066.013a.965.965 0 0 1 .254.052c.034.012.067.02.1.036A.98.98 0 0 1 17.7.29l.011.009 15.813 15.864c.031.021.046.058.073.083.034.031.06.066.089.102.149.174.258.382.258.629 0 .032-.015.059-.018.09zM1.98 2.999v41.935a1 1 0 0 0 .995.999h27.966c.548 0 1.059-.444 1.059-.995v-27H17c-.55 0-.99-.409-.99-.961V1.939H3c-.549 0-1.02.51-1.02 1.06zm16.021.414v12.566h12.526L18.001 3.413z","key":1})]);
	}
	
	DocumentPencil48px.displayName = "DocumentPencil48px";
	
	DocumentPencil48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 46 47.94"};
	
	module.exports = DocumentPencil48px;
	
	DocumentPencil48px.default = DocumentPencil48px;


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function FagOgLedelse48px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 fag og ledelse"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M26.317 6.814a.5.5 0 0 1 .626-.33c5.212 1.62 8.94 4.812 9.521 10.099l.033.333c.102 1.233.315 1.668 1.306 2.182l.062.031H39a.5.5 0 0 1 .492.41l.008.09v4.157a.5.5 0 0 1-.299.457l-.143.045-.058.009-.067.001-.542-.018c-1.424-.052-2.543.038-3.714.44-3.245 1.12-5.582 1.504-8.623 1.568l-.888.01h-1.754c-4.152.004-6.567-.25-10.159-1.42l-.475-.158-.32-.102c-.952-.284-1.892-.37-3.014-.348l-.923.028-.09-.003-.035-.007-.063-.017a.5.5 0 0 1-.372-.4l-.007-.085v-4.124a.5.5 0 0 1 .41-.492l.09-.008H9.59l.062-.03c.939-.488 1.18-.904 1.29-1.993l.017-.188c.332-4.203 2.683-7.174 6.365-9.143a.5.5 0 1 1 .471.882c-3.301 1.766-5.407 4.353-5.807 7.997l-.033.345c-.135 1.621-.544 2.355-2.027 3.08a.502.502 0 0 1-.144.045l-.075.005h-.754v3.121l.072-.002c1.409-.052 2.555.026 3.75.388l.327.106c3.266 1.103 5.468 1.445 8.803 1.51l.986.012H25.5c3.212-.029 5.524-.375 8.85-1.522 1.206-.415 2.336-.532 3.7-.505l.449.013v-3.154h-.753a.499.499 0 0 1-.15-.022l-.07-.028c-1.418-.694-1.854-1.395-2.008-2.873l-.019-.207c-.418-4.994-3.88-8.014-8.853-9.56a.5.5 0 0 1-.33-.625z","key":0}),React.createElement("path",{"d":"M26.696 4.648a.5.5 0 0 1 .488.391l.012.087.626 14.449a.5.5 0 0 1-.987.132l-.012-.089-.606-13.971h-5.014l-.605 13.971a.5.5 0 0 1-.43.474l-.091.004a.5.5 0 0 1-.474-.431l-.004-.09.627-14.449a.5.5 0 0 1 .412-.47l.087-.008zM35.885 23.625a.5.5 0 0 1 .702.08c.177.222.43.604.68 1.112.735 1.486.946 3.049.287 4.531-.377.85-1.028 1.62-1.973 2.294l-.085.058-.063.304c-.087.403-.201.85-.345 1.333a18.975 18.975 0 0 1-1.712 4.041c-2.138 3.72-5.312 5.974-9.682 5.974s-7.544-2.254-9.682-5.974a18.975 18.975 0 0 1-1.712-4.041 19.079 19.079 0 0 1-.275-1.023l-.133-.611-.046-.03c-1.949-1.345-2.641-3.08-2.338-4.963l.039-.218a.5.5 0 0 1 .98.196c-.329 1.648.243 3.11 2.09 4.297a.5.5 0 0 1 .223.342l.042.227.05.237c.082.38.19.803.326 1.26a17.981 17.981 0 0 0 1.62 3.829c1.975 3.434 4.845 5.472 8.816 5.472s6.84-2.038 8.815-5.472a17.981 17.981 0 0 0 1.62-3.828c.103-.343.189-.667.26-.968l.095-.42.054-.28.01-.057a.5.5 0 0 1 .219-.34c.934-.613 1.543-1.3 1.873-2.044.518-1.166.347-2.438-.269-3.682a6.434 6.434 0 0 0-.397-.694l-.103-.15-.066-.09a.5.5 0 0 1 .08-.702z","key":1})])]);
	}
	
	FagOgLedelse48px.displayName = "FagOgLedelse48px";
	
	FagOgLedelse48px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = FagOgLedelse48px;
	
	FagOgLedelse48px.default = FagOgLedelse48px;


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function GraduationCap48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M48 30.946a3.002 3.002 0 0 1-3 2.996c-1.654 0-3-1.344-3-2.996 0-1.301.839-2.399 2-2.813V15.715l-7.041 4.156c.015.067.041.13.041.201v15.983a.994.994 0 0 1-.956.99c-1.449.73-6.303 2.891-13.044 2.891-6.741 0-11.596-2.161-13.044-2.891a.994.994 0 0 1-.956-.99V20.072c0-.071.026-.134.041-.201l-8.55-5.047a.997.997 0 0 1 0-1.719L22.492.119a1.003 1.003 0 0 1 1.018 0l22 12.986c.403.06.49.344.49.834v.022l.001.003-.001.004v14.165c1.162.414 2 1.512 2 2.813zM35 35.33V21.028L23.51 27.81a1.01 1.01 0 0 1-1.018 0L11 21.027V35.33c1.452.702 5.951 2.608 12 2.608 6.048 0 10.548-1.906 12-2.608zM23.001 2.139L2.966 13.964 23.001 25.79l20.034-11.826L23.001 2.139zm22.418 27.907c-.022.002-.033.016-.057.016-.138 0-.292-.036-.446-.098a.992.992 0 0 0-.916.982 1 1 0 0 0 2 0c0-.4-.24-.741-.581-.9z","key":1})]);
	}
	
	GraduationCap48px.displayName = "GraduationCap48px";
	
	GraduationCap48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 39.94"};
	
	module.exports = GraduationCap48px;
	
	GraduationCap48px.default = GraduationCap48px;


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Graph248px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M47 31.999H1a1 1 0 0 1-1-1v-30a1 1 0 1 1 2 0v29h45a1 1 0 1 1 0 2zM41.5 8.998a3.464 3.464 0 0 1-1.764-.494l-9.086 7.497c.218.456.35.96.35 1.498 0 1.93-1.57 3.5-3.5 3.5s-3.5-1.57-3.5-3.5c0-.558.144-1.079.377-1.548l-2.31-2.34a3.453 3.453 0 0 1-1.567.388 3.47 3.47 0 0 1-1.422-.309l-6.39 5.381c.197.437.312.919.312 1.428 0 1.929-1.57 3.5-3.5 3.5S6 22.428 6 20.499s1.57-3.5 3.5-3.5c.693 0 1.336.209 1.881.558l6.169-5.193a3.463 3.463 0 0 1-.55-1.865c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 .635-.183 1.223-.48 1.737l2.225 2.253a3.454 3.454 0 0 1 1.755-.49c.663 0 1.276.196 1.805.517l9.067-7.48A3.446 3.446 0 0 1 38 5.498c0-1.929 1.57-3.5 3.5-3.5s3.5 1.571 3.5 3.5c0 1.931-1.57 3.5-3.5 3.5zm-32 10.001c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zm11-10.001c-.827 0-1.5.673-1.5 1.501 0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5c0-.828-.673-1.501-1.5-1.501zm7 7.001c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zm14-12c-.827 0-1.5.673-1.5 1.499 0 .828.673 1.501 1.5 1.501S43 6.326 43 5.498c0-.826-.673-1.499-1.5-1.499z","key":1})]);
	}
	
	Graph248px.displayName = "Graph248px";
	
	Graph248px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 32"};
	
	module.exports = Graph248px;
	
	Graph248px.default = Graph248px;


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function GraphUp48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M47 31.999H1a1 1 0 0 1-1-1V.998a.999.999 0 1 1 2 0v29.001h45a1 1 0 1 1 0 2zm-6-20a1 1 0 0 1-1-1V7.292L27.681 18.731c-.006.006-.014.007-.02.013-.004.004-.006.009-.011.013-.054.047-.117.072-.178.105-.042.023-.079.056-.123.072a.98.98 0 0 1-.751-.021c-.041-.019-.073-.055-.112-.079-.076-.047-.155-.086-.218-.155-.005-.005-.006-.012-.011-.018-.005-.005-.011-.006-.016-.011l-5.364-6.259-10.244 8.382a1 1 0 1 1-1.266-1.548l11-9c.052-.042.113-.059.17-.089.057-.031.11-.072.171-.091.065-.02.132-.017.2-.023.06-.006.12-.022.18-.017.066.006.127.034.191.053.059.017.12.024.176.052.068.035.123.093.183.144.039.033.086.054.121.094l.011.014.004.003.002.004 5.306 6.189 11.372-10.56H35a.999.999 0 1 1 0-1.999h6l.018.003c.081.002.157.027.235.048.049.013.101.014.146.034.046.02.083.058.127.085.067.043.137.081.192.138.004.004.01.006.014.011.034.036.048.082.075.122.044.063.091.123.12.195.027.07.032.143.043.216.008.05.03.095.03.148v6a1 1 0 0 1-1 1z","key":1})]);
	}
	
	GraphUp48px.displayName = "GraphUp48px";
	
	GraphUp48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 32"};
	
	module.exports = GraphUp48px;
	
	GraphUp48px.default = GraphUp48px;


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Hammer48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M50.998 14c0 .266-.105.52-.293.707l-5.999 6a1.001 1.001 0 0 1-1.416 0l-7.291-7.291-11.575 11.578.254.254a1 1 0 0 1 .214 1.098l-2.97 7.04c-.05.119-.123.226-.214.319L7.709 47.702a.994.994 0 0 1-1.415 0l-6-5.999a1 1 0 0 1 0-1.417l13.998-13.998a.965.965 0 0 1 .307-.208l6.968-3.045a.997.997 0 0 1 1.109.209l.332.333L34.583 12 24.292 1.709A1.001 1.001 0 0 1 25 0h11.998c.265 0 .52.106.708.293l4.748 4.747.829-.83a1.001 1.001 0 1 1 1.416 1.417l-.829.83 6.835 6.834a.999.999 0 0 1 .293.709zM22.303 25.704l-.002-.002-.002-.002-.556-.556-6.169 2.694L2.418 40.995l4.584 4.582 13.153-13.152 2.631-6.238-.483-.483zM36.584 2.003h-9.166l16.58 16.578L48.581 14 36.584 2.003z","key":1})]);
	}
	
	Hammer48px.displayName = "Hammer48px";
	
	Hammer48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 51 48"};
	
	module.exports = Hammer48px;
	
	Hammer48px.default = Hammer48px;


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Heart48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M43.99 21.362l-.003.006-17.44 19.36c-.73.818-1.715 1.271-2.771 1.271h-.002c-1.055 0-2.04-.454-2.771-1.275L3.569 21.368a.02.02 0 0 1-.004-.006C-1.23 16.47-1.22 8.546 3.601 3.67A12.254 12.254 0 0 1 12.37-.001c3.312 0 6.427 1.304 8.769 3.671.004.004.005.009.008.012.004.004.009.005.013.009l2.616 2.804 2.619-2.804c.004-.004.009-.005.013-.009.003-.004.004-.008.008-.012a12.256 12.256 0 0 1 8.769-3.671c3.313 0 6.427 1.304 8.77 3.671 4.816 4.876 4.826 12.801.035 17.692zm-1.441-16.28a10.29 10.29 0 0 0-7.364-3.083c-2.774 0-5.383 1.09-7.349 3.069L24.499 8.64c-.007.007-.017.01-.024.017-.008.008-.011.018-.019.026-.06.057-.133.089-.202.128-.036.021-.067.052-.105.067a.987.987 0 0 1-.373.076.987.987 0 0 1-.373-.076c-.038-.015-.068-.046-.105-.066-.069-.039-.141-.072-.202-.129-.008-.008-.011-.018-.018-.026-.008-.007-.017-.01-.025-.017l-3.325-3.564a10.293 10.293 0 0 0-7.358-3.077 10.295 10.295 0 0 0-7.365 3.083C.942 9.193.942 15.88 5.005 19.989c.006.006.008.015.014.021.005.006.013.007.018.014l17.438 19.36c.355.398.815.614 1.3.614h.001c.486 0 .947-.216 1.299-.611l17.443-19.363c.005-.006.012-.008.017-.013.006-.007.008-.015.014-.021 4.06-4.11 4.06-10.797 0-14.908z","key":1})]);
	}
	
	Heart48px.displayName = "Heart48px";
	
	Heart48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 47.59 42"};
	
	module.exports = Heart48px;
	
	Heart48px.default = Heart48px;


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Innovasjon48px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 innovasjon"),React.createElement("g",{"clipRule":"evenodd","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M17.826 34.078a.5.5 0 0 1 .5-.5h11.348a.5.5 0 0 1 .5.5v5.453c0 .852-.664 1.517-1.516 1.517h-9.316a1.498 1.498 0 0 1-1.516-1.517zm1 .5v4.953c0 .3.217.517.516.517h9.316c.3 0 .516-.217.516-.517v-4.953z","key":0}),React.createElement("path",{"d":"M21.51 40.081a.5.5 0 0 1 .5.5c0 1.113.894 2.007 2.007 2.007a2.001 2.001 0 0 0 2.007-2.007.5.5 0 1 1 1 0 3.001 3.001 0 0 1-3.007 3.007 3.001 3.001 0 0 1-3.007-3.007.5.5 0 0 1 .5-.5zM23.483 5.421c-7.08.264-12.753 6.1-12.753 13.244a13.23 13.23 0 0 0 6.365 11.327c1.111.674 1.731 1.895 1.731 3.171v.38h4.657v-7.121c0-.951.95-1.53 1.793-1.213a2.749 2.749 0 0 0 1.145.273c1.08 0 1.94-.86 1.94-1.94 0-1.078-.86-1.938-1.94-1.938-.31 0-.71.106-1.131.268-.89.38-1.807-.298-1.807-1.209V16.7c0-.197-.195-.36-.429-.282a3.742 3.742 0 0 1-1.51.342c-1.631 0-2.939-1.308-2.939-2.94s1.308-2.938 2.939-2.938c.5 0 1.044.162 1.5.338a.3.3 0 0 0 .438-.279zm-4.976 29.123a.5.5 0 0 1-.681-.466v-.915c0-.96-.464-1.84-1.25-2.316A14.23 14.23 0 0 1 9.73 18.665c0-7.864 6.389-14.253 14.253-14.253a.5.5 0 0 1 .5.5v6.03c0 .91-.918 1.587-1.807 1.208-.42-.162-.822-.268-1.132-.268-1.079 0-1.939.86-1.939 1.939s.86 1.939 1.939 1.939a2.75 2.75 0 0 0 1.146-.273c.843-.317 1.793.262 1.793 1.213v3.963a.299.299 0 0 0 .438.279c.456-.175 1-.338 1.5-.338a2.929 2.929 0 0 1 2.94 2.939 2.929 2.929 0 0 1-2.94 2.939 3.742 3.742 0 0 1-1.51-.342c-.233-.079-.428.085-.428.282v7.622a.5.5 0 0 1-.5.5z","key":1}),React.createElement("path",{"d":"M23.517 4.912a.5.5 0 0 1 .5-.5c7.864 0 14.253 6.389 14.253 14.253 0 5.16-2.739 9.69-6.846 12.182-.786.477-1.25 1.357-1.25 2.316v.915a.5.5 0 0 1-.5.5h-5.657a.5.5 0 1 1 0-1h5.157v-.415c0-1.276.62-2.497 1.731-3.171a13.23 13.23 0 0 0 6.365-11.327c0-7.312-5.941-13.253-13.253-13.253a.5.5 0 0 1-.5-.5z","key":2})])]);
	}
	
	Innovasjon48px.displayName = "Innovasjon48px";
	
	Innovasjon48px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = Innovasjon48px;
	
	Innovasjon48px.default = Innovasjon48px;


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function KlimaOgMiljo48px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 klima og miljø"),React.createElement("g",{"clipRule":"evenodd","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M35.253 13.191l-.498-.048-.051-.497a.5.5 0 0 1 .549.545zm-4.697 17.415c-2.395 3.392-5.202 4.766-7.903 4.789-2.676.022-5.153-1.283-6.918-3.066l.71-.703c1.623 1.639 3.854 2.789 6.2 2.769 2.321-.02 4.85-1.186 7.095-4.366.812-1.15 1.509-2.773 2.095-4.592.584-1.812 1.05-3.787 1.409-5.62a80.002 80.002 0 0 0 .947-6.107 89.536 89.536 0 0 0-6.306.986c-1.872.365-3.875.828-5.685 1.397-1.818.571-3.402 1.238-4.463 1.996-2.507 1.807-3.678 3.967-3.959 6.079-.282 2.124.33 4.248 1.475 5.975l-.833.553c-1.259-1.898-1.952-4.262-1.633-6.66.32-2.41 1.656-4.806 4.366-6.76h.001c1.192-.851 2.897-1.556 4.747-2.137 1.858-.584 3.9-1.055 5.793-1.424a90.701 90.701 0 0 1 6.861-1.053l.11-.012.028-.003.01-.001.052.497.498.048-.001.01-.003.028-.01.106-.045.404a80.953 80.953 0 0 1-.97 6.272c-.363 1.855-.837 3.87-1.437 5.733-.598 1.855-1.332 3.59-2.23 4.862z","key":0}),React.createElement("path",{"d":"M19.319 28.376a.5.5 0 0 1 .543-.453l6.74.61a.5.5 0 1 1-.09.995l-6.74-.61a.5.5 0 0 1-.453-.542zM23.653 23.956a.5.5 0 0 1 .526-.472l4.404.237a.5.5 0 1 1-.054.999l-4.404-.238a.5.5 0 0 1-.472-.526z","key":1}),React.createElement("path",{"d":"M29.926 18.108a.5.5 0 0 1 0 .707L13.158 35.583a.5.5 0 0 1-.707-.707l16.767-16.768a.5.5 0 0 1 .708 0zM23.577 18.47a.5.5 0 0 1 .532.467l.135 2.032a.5.5 0 0 1-.998.066l-.135-2.032a.5.5 0 0 1 .466-.532zM18.752 20.437a.5.5 0 0 1 .546.45l.406 4.268a.5.5 0 0 1-.995.095l-.407-4.268a.5.5 0 0 1 .45-.545zM36.28 33.476a.5.5 0 0 1 .5.5v4.14h4.14a.5.5 0 1 1 0 1h-4.64a.5.5 0 0 1-.5-.5v-4.64a.5.5 0 0 1 .5-.5zM6.613 9.417a.5.5 0 0 1 .5-.5h4.607a.5.5 0 0 1 .5.5v4.607a.5.5 0 1 1-1 0V9.917H7.113a.5.5 0 0 1-.5-.5z","key":2}),React.createElement("path",{"d":"M16.3 5.875a19.617 19.617 0 0 1 7.717-1.565c10.879 0 19.707 8.828 19.707 19.707 0 6.013-2.678 11.366-6.917 14.98a.5.5 0 1 1-.649-.76c4.026-3.433 6.566-8.512 6.566-14.22 0-10.327-8.38-18.707-18.707-18.707-2.608 0-5.082.528-7.324 1.484a.5.5 0 1 1-.392-.92zM11.896 9.091a.5.5 0 0 1-.053.705C7.85 13.23 5.31 18.31 5.31 24.017c0 10.326 8.38 18.707 18.707 18.707 2.608 0 5.082-.528 7.324-1.484a.5.5 0 0 1 .392.92 19.617 19.617 0 0 1-7.716 1.564c-10.879 0-19.707-8.828-19.707-19.707 0-6.013 2.677-11.365 6.881-14.98a.5.5 0 0 1 .705.054z","key":3})])]);
	}
	
	KlimaOgMiljo48px.displayName = "KlimaOgMiljo48px";
	
	KlimaOgMiljo48px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = KlimaOgMiljo48px;
	
	KlimaOgMiljo48px.default = KlimaOgMiljo48px;


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Leaf48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M39.414 30.314c-4.793 5.183-11.425 7.811-19.709 7.811-3.852 0-8.118-.584-12.678-1.72-4.419 6.541-5.036 10.772-5.048 10.861a1 1 0 0 1-1.11.871A1 1 0 0 1 0 47.025c.047-.403.739-5.355 5.98-12.757-.099-4.061.242-17.556 8.431-26.414C21.473.219 32.552-1.851 47.048 1.818a1 1 0 0 1 .751.898c.052.703 1.142 17.294-8.385 27.598zm6.427-26.731C32.46.349 22.302 2.264 15.872 9.219c-6.32 6.836-7.633 16.949-7.856 22.355 1.887-2.359 4.221-4.911 7.095-7.605a.986.986 0 0 1 .419-.39 99.005 99.005 0 0 1 7.397-6.184v-6.943a1 1 0 0 1 .997-1.003 1 1 0 0 1 .997 1.003v5.463c4.358-3.166 9.467-6.434 15.476-9.736a.99.99 0 0 1 1.352.397 1.005 1.005 0 0 1-.396 1.361C31.58 13.308 24.238 18.6 18.7 23.481h14.198c.551 0 .997.448.997 1.002a1 1 0 0 1-.997 1.003H16.495c-3.516 3.317-6.19 6.407-8.218 9.159 4.112.974 7.954 1.476 11.428 1.476 7.705 0 13.841-2.41 18.242-7.163 7.859-8.492 7.985-22.106 7.894-25.375z","key":1})]);
	}
	
	Leaf48px.displayName = "Leaf48px";
	
	Leaf48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 47.85 48.1"};
	
	module.exports = Leaf48px;
	
	Leaf48px.default = Leaf48px;


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Medal148px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M43.72 10.012c.012.063.007.125.007.188 0 .065.005.128-.008.193-.013.069-.044.13-.072.195-.02.047-.025.096-.052.14L32.828 28.159c1.272 2.066 1.971 4.409 1.971 6.841 0 7.169-5.796 13-12.921 13-7.124 0-12.921-5.831-12.921-13 0-2.436.699-4.778 1.972-6.842L.161 10.728c-.027-.044-.032-.093-.051-.139-.028-.065-.059-.127-.073-.196-.012-.065-.008-.127-.008-.192 0-.064-.005-.125.007-.189.014-.07.045-.133.073-.2.019-.045.024-.093.05-.137l5.633-9.2c.015-.024.043-.035.06-.058a.972.972 0 0 1 .24-.23c.036-.025.067-.053.107-.072A.962.962 0 0 1 6.638 0h29.718c.148 0 .285.037.41.094.111-.043.22-.092.341-.094h.011c.345 0 .665.179.847.475l5.632 9.2c.026.043.031.092.05.137.028.067.06.13.073.2zM21.878 46c6.029 0 10.933-4.935 10.933-11 0-2.24-.671-4.404-1.941-6.259a10.93 10.93 0 0 0-6.712-4.509 11.38 11.38 0 0 0-4.57.002 10.933 10.933 0 0 0-6.703 4.508A11.035 11.035 0 0 0 10.945 35c0 6.065 4.905 11 10.933 11zm1.745-23.877L29.538 12H14.219l5.918 10.13a13.426 13.426 0 0 1 3.486-.007zM6.619 2.939l-4.444 7.259L12.19 26.411a12.89 12.89 0 0 1 5.897-3.842L6.619 2.939zM13.05 10h17.657l4.674-8H8.376l4.674 8zm24.087-7.061L25.649 22.603c2.296.714 4.343 2.005 5.918 3.807l10.015-16.213-4.445-7.258z","key":1})]);
	}
	
	Medal148px.displayName = "Medal148px";
	
	Medal148px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 43.75 48"};
	
	module.exports = Medal148px;
	
	Medal148px.default = Medal148px;


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function People48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M48 32a1 1 0 0 1-1 .999h-2.153l-1.861 11.165a.999.999 0 0 1-.986.835h-6a1 1 0 0 1-.99-.858l-1-6.984a1.001 1.001 0 0 1 1.98-.284L36.867 43h4.286l1.861-11.165c.006-.04.03-.071.041-.109a.992.992 0 0 1 .071-.186c.031-.058.066-.107.106-.157.04-.05.08-.095.129-.137a.928.928 0 0 1 .158-.106.935.935 0 0 1 .17-.078.993.993 0 0 1 .195-.04c.04-.004.075-.023.116-.023h2V25.7c0-.018.009-.033.01-.05-.001-.018-.01-.033-.01-.051 0-4.157-1.839-8.6-7-8.6a1 1 0 1 1 0-2c5.467 0 9 4.161 9 10.6 0 .018-.009.033-.01.051.001.017.01.032.01.05V32zm-9.001-17.001A6.006 6.006 0 0 1 33 9c0-3.309 2.691-6 5.999-6A6.007 6.007 0 0 1 45 9a6.007 6.007 0 0 1-6.001 5.999zm0-9.999A4.004 4.004 0 0 0 35 9a4.003 4.003 0 0 0 3.999 3.999A4.004 4.004 0 0 0 43 9c0-2.206-1.795-4-4.001-4zM34 22c0 .016-.009.03-.01.046.001.017.01.03.01.047v8.906c0 .552-.448 1.001-1 1.001h-3.117l-1.891 15.124A1 1 0 0 1 27 48h-6a1 1 0 0 1-.992-.876L18.117 32H15c-.552 0-1-.449-1-1.001v-8.906c0-.017.009-.03.009-.047 0-.016-.009-.03-.009-.046 0-5.513 4.483-9.997 9.995-10A6.006 6.006 0 0 1 18 5.999c0-3.309 2.691-6 6-6s6 2.691 6 6A6.006 6.006 0 0 1 24.005 12C29.517 12.003 34 16.487 34 22zM28 5.999A4.004 4.004 0 0 0 24 2c-2.206 0-4 1.794-4 3.999a4.005 4.005 0 0 0 4 4.002c2.205 0 4-1.795 4-4.002zM24 14c-4.411 0-8 3.588-8 8 0 .016-.009.03-.01.046.001.017.01.03.01.047V30h3c.047 0 .088.02.133.027.067.009.13.016.192.038.065.023.121.056.18.091.051.031.1.059.145.098a.93.93 0 0 1 .134.153c.037.048.072.093.1.147.031.062.047.127.065.195.012.043.037.08.043.127L21.883 46h4.234l1.891-15.124c.006-.047.031-.085.043-.129.018-.066.033-.131.064-.191.029-.057.066-.105.105-.156a1 1 0 0 1 .125-.143.89.89 0 0 1 .158-.106c.055-.032.107-.063.167-.085.064-.022.129-.03.198-.04.045-.006.085-.026.132-.026h3v-7.907c0-.017.009-.03.009-.047 0-.016-.009-.03-.009-.046 0-4.412-3.589-8-8-8zm-14.999.999A6.007 6.007 0 0 1 3 9c0-3.309 2.692-6 6.001-6A6.006 6.006 0 0 1 15 9a6.006 6.006 0 0 1-5.999 5.999zm0-9.999A4.005 4.005 0 0 0 5 9a4.004 4.004 0 0 0 4.001 3.999A4.003 4.003 0 0 0 13 9c0-2.206-1.794-4-3.999-4zM9 14.999a1.001 1.001 0 0 1 0 2c-5.161 0-7 4.443-7 8.6 0 .018-.009.033-.01.051.001.017.01.032.01.05v5.299h2c.04 0 .073.018.112.023a.984.984 0 0 1 .204.041.915.915 0 0 1 .159.073.904.904 0 0 1 .29.243.943.943 0 0 1 .11.162c.031.059.051.12.07.184.011.039.035.07.041.11L6.847 43h4.286l.877-6.127a1.006 1.006 0 0 1 1.131-.848c.548.079.927.586.849 1.132l-1 6.984a1 1 0 0 1-.99.858H6a.999.999 0 0 1-.986-.835L3.153 32.999H1A1 1 0 0 1 0 32v-6.3c0-.018.009-.033.01-.05-.001-.018-.01-.033-.01-.051 0-6.439 3.533-10.6 9-10.6z","key":1})]);
	}
	
	People48px.displayName = "People48px";
	
	People48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 48"};
	
	module.exports = People48px;
	
	People48px.default = People48px;


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function PiggyBank48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M47 31.978h-2.827c-1.021 2.84-3.024 5.502-5.549 7.342l1.846 5.172a.999.999 0 0 1-.593 1.273l-5.764 2.14a1 1 0 0 1-1.289-.596l-1.491-4.111c-1.845.5-3.869.772-5.8.772-1.796 0-3.77-.273-5.651-.776l-1.442 4.105a.994.994 0 0 1-.943.668c-.118 0-.235-.021-.349-.062l-5.763-2.14a1 1 0 0 1-.594-1.273l1.803-5.052c-3.871-2.689-6.146-6.441-6.408-10.473C1.308 28.816 0 24.363 0 21.983a.999.999 0 1 1 2 0c.003.501.158 4.826 4.213 4.985.803-7.812 9.152-13.978 19.32-13.978 2.56 0 4.799.28 6.821.857 4.183-4.435 9.525-3.875 9.761-3.849a.998.998 0 1 1 .564 1.726c-.019.018-2.198 2.128-2.602 6.545 1.961 1.727 3.303 3.65 4.068 5.713H47a1 1 0 0 1 1 1v5.996a1 1 0 0 1-1 1zm-1-5.997h-2.538c-.019 0-.036-.01-.055-.011a.946.946 0 0 1-.204-.041c-.059-.016-.118-.028-.172-.054-.058-.028-.106-.068-.158-.107-.051-.038-.102-.072-.145-.12-.042-.045-.07-.098-.102-.151-.037-.059-.073-.115-.097-.181-.006-.019-.021-.031-.026-.05-.625-2.107-2.019-4.07-4.143-5.835a.996.996 0 0 1-.3-1.107l.006-.019c.225-2.864 1.101-4.93 1.888-6.253a10.331 10.331 0 0 0-6.521 3.585.997.997 0 0 1-1.069.302c-1.981-.64-4.216-.951-6.831-.951-9.593 0-17.399 5.925-17.399 13.208 0 3.856 2.26 7.499 6.2 9.999a1 1 0 0 1 .406 1.18l-1.733 4.859 3.884 1.443 1.417-4.037a.998.998 0 0 1 1.242-.622c1.962.614 4.087.953 5.983.953 2.057 0 4.226-.338 6.109-.951a1.003 1.003 0 0 1 1.25.61l1.469 4.05 3.894-1.446-1.679-4.704a.94.94 0 0 1-.072-.119c-.231-.456-.112-1.001.318-1.279 2.689-1.728 4.812-4.509 5.681-7.438.005-.019.02-.031.026-.05.024-.067.061-.124.098-.183.032-.052.06-.104.1-.149.044-.048.096-.083.148-.122.051-.038.099-.078.157-.105.053-.026.11-.037.168-.053a.933.933 0 0 1 .21-.043c.018-.001.034-.01.052-.01H46v-3.998zm-12-4.029h3v3.061h-3v-3.061zm-7.335-10.346a1 1 0 0 1-.808-1.161A8.18 8.18 0 0 0 26 8.992c0-3.857-3.141-6.996-7-6.996s-7 3.139-7 6.996c0 1.389.529 2.967 1.417 4.219a.999.999 0 1 1-1.633 1.154C10.65 12.763 10 10.805 10 8.992c0-4.96 4.037-8.995 9-8.995s9 4.035 9 8.995c0 .564-.057 1.155-.174 1.806a.999.999 0 0 1-1.161.808z","key":1})]);
	}
	
	PiggyBank48px.displayName = "PiggyBank48px";
	
	PiggyBank48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 48"};
	
	module.exports = PiggyBank48px;
	
	PiggyBank48px.default = PiggyBank48px;


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Samarbeid48px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 samarbeid"),React.createElement("g",{"clipRule":"evenodd","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M22.657 36.878c-.679-.646-1.738-.635-2.368-.004l-1.008 1.008c-.645.677-.635 1.733-.008 2.365.678.646 1.738.634 2.368.003l1.008-1.007c.645-.677.635-1.734.008-2.365zm-3.076-.711c1.03-1.03 2.715-1.02 3.771-.007l.008.007c1.03 1.03 1.02 2.715.007 3.771l-.007.008-1.012 1.011c-1.03 1.03-2.714 1.02-3.77.008l-.008-.008c-1.03-1.03-1.02-2.714-.008-3.77l.007-.008 1.012-1.012.333.333z","key":0}),React.createElement("path",{"d":"M19.621 33.806c-.678-.646-1.738-.634-2.368-.003l-2.562 2.561c-.645.677-.634 1.734-.007 2.365.678.646 1.737.634 2.368.004l2.561-2.562c.645-.677.635-1.733.008-2.365zm-3.075-.71c1.03-1.03 2.714-1.02 3.77-.008l.009.007c1.03 1.031 1.02 2.715.007 3.772l-.007.007-2.566 2.566c-1.03 1.03-2.715 1.02-3.771.007l-.008-.007c-1.03-1.03-1.02-2.715-.007-3.771l.007-.008z","key":1}),React.createElement("path",{"d":"M16.55 30.735c-.678-.646-1.738-.634-2.368-.004l-2.562 2.562c-.656.688-.659 1.74-.012 2.36.679.65 1.74.64 2.372.008l2.562-2.562c.645-.676.635-1.733.008-2.364zm-3.075-.711c1.03-1.03 2.714-1.02 3.77-.007l.008.007c1.03 1.03 1.02 2.715.008 3.771l-.008.008-2.566 2.565c-1.03 1.03-2.714 1.02-3.77.008-1.087-1.041-1.018-2.732-.016-3.779l.008-.007z","key":2}),React.createElement("path",{"d":"M13.515 27.7c-.679-.647-1.738-.635-2.369-.004l-1.802 1.803c-.645.676-.635 1.733-.008 2.364.678.646 1.737.635 2.368.004l1.803-1.803c.645-.677.635-1.733.008-2.365zm-3.076-.711c1.03-1.03 2.715-1.02 3.771-.008l.008.008c1.03 1.03 1.02 2.714.007 3.77l-.007.008-1.807 1.807c-1.03 1.03-2.714 1.02-3.77.007l-.009-.007c-1.03-1.03-1.02-2.715-.007-3.771l.007-.008zM25.58 34.794a.5.5 0 0 1 .707 0l3.938 3.939c.631.63 1.69.642 2.368-.004.629-.632.638-1.692-.01-2.368a.5.5 0 0 1 .721-.692c1.013 1.056 1.023 2.74-.007 3.77l-.008.008c-1.056 1.013-2.74 1.023-3.77-.007l-3.94-3.939a.5.5 0 0 1 0-.707z","key":3}),React.createElement("path",{"d":"M28.651 31.722a.5.5 0 0 1 .707 0l3.94 3.94c.63.63 1.69.641 2.367-.005.627-.63.638-1.687-.007-2.364l-.755-.755a.5.5 0 1 1 .707-.707l.766.766c1.013 1.057 1.023 2.74-.007 3.771l-.008.008c-1.056 1.012-2.74 1.023-3.77-.008l-3.94-3.939a.5.5 0 0 1 0-.707zM28.044 37.208a.5.5 0 0 1 .707.015c1.013 1.056 1.023 2.74-.007 3.77l-.007.008c-1.057 1.012-2.741 1.023-3.772-.007l-1.806-1.807a.5.5 0 1 1 .707-.707l1.807 1.806c.63.631 1.69.643 2.368-.003.628-.633.637-1.692-.012-2.369a.5.5 0 0 1 .015-.706z","key":4}),React.createElement("path",{"d":"M31.723 28.651a.5.5 0 0 1 .707 0l3.18 3.18c.72.72 1.94.64 2.556-.252.43-.65.306-1.578-.264-2.149a.5.5 0 0 1 .707-.707c.874.874 1.111 2.328.388 3.414l-.004.006a2.665 2.665 0 0 1-4.09.395l-3.18-3.18a.5.5 0 0 1 0-.707zM40.48 6.64a.5.5 0 0 1-.06.705l-6.881 5.785L43.7 25.265l2.978-2.497a.5.5 0 1 1 .642.766l-3.36 2.818a.5.5 0 0 1-.705-.062l-10.804-12.9a.5.5 0 0 1 .061-.704l7.263-6.107a.5.5 0 0 1 .705.061zM7.266 6.423a.5.5 0 0 1 .705-.06l7.516 6.323a.5.5 0 0 1 .061.704L4.744 26.29a.5.5 0 0 1-.705.062L.68 23.534a.5.5 0 0 1 .642-.767L4.3 25.264 14.46 13.13 7.327 7.128a.5.5 0 0 1-.06-.705z","key":5}),React.createElement("path",{"d":"M33.141 14.675c.389-.08.653-.182.744-.245l.574.82c-.27.189-.711.322-1.117.405a5.595 5.595 0 0 1-1.314.118h-8.046c-1.07 0-2.105.397-3.296 1.588l-1.41 1.41c-.345.345-.54.798-.54 1.272v5.926c0 .158.102.259.26.259h.758a2.569 2.569 0 0 0 2.572-2.571v-1.518a.5.5 0 0 1 .146-.354c2.508-2.508 6.619-2.508 9.127 0l6.54 6.541 4.275-3.606.644.764-4.625 3.903a.5.5 0 0 1-.676-.029l-6.866-6.866c-2.069-2.069-5.437-2.116-7.565-.14v1.304a3.569 3.569 0 0 1-3.572 3.572h-.759a1.24 1.24 0 0 1-1.259-1.259v-5.926c0-.754.311-1.458.833-1.98l1.41-1.409c1.338-1.339 2.616-1.88 4.003-1.88h8.083a4.59 4.59 0 0 0 1.076-.1zM9.46 28.665l-4.228-3.541.642-.767 4.228 3.541z","key":6}),React.createElement("path",{"d":"M14.209 14.193c.681.533 1.348.544 2.185.544h3.216c.664 0 1.187.234 1.559.453a6.723 6.723 0 0 1 .442.287c.056.038.09.06.113.072l.009.005a.272.272 0 0 0-.065-.017l-.141.99a.845.845 0 0 1-.284-.101 2.512 2.512 0 0 1-.19-.118 15.921 15.921 0 0 1-.08-.055c-.097-.066-.195-.133-.312-.201-.287-.17-.631-.315-1.051-.315h-3.25c-.819 0-1.8 0-2.768-.757z","key":7})])]);
	}
	
	Samarbeid48px.displayName = "Samarbeid48px";
	
	Samarbeid48px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = Samarbeid48px;
	
	Samarbeid48px.default = Samarbeid48px;


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ShakingHands48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M47 31.994h-4.48l.299.427c.035.047 1.222 1.673 1.222 3.572 0 2.103-1.03 3.759-2.828 4.542a4.656 4.656 0 0 1-1.868.404c-.899 0-1.722-.279-2.443-.694-.143.998-.6 2.117-1.885 2.96-.853.559-1.726.839-2.604.839-.288 0-.576-.03-.865-.09-1.093-.229-1.951-.86-2.533-1.422a4.133 4.133 0 0 1-1.853 1.794c-.972.482-1.865.667-2.651.667-1.588 0-2.743-.752-3.255-1.334-.447.606-1.053 1.145-1.856 1.595-.954.534-1.826.743-2.6.743-1.798.002-3.067-1.132-3.596-1.971l-5.787-8.219c-.63-1.031-2.706-3.813-4.417-3.813H1c-.553 0-1-.447-1-.999V7.997a1 1 0 0 1 1-1h6c1.408 0 2.55-.433 3.994-.982C13.361 5.116 16.308 3.998 22 3.998c.192 0 .362.068.514.162l.367-.377C25.546 1.029 26.543-.002 29-.002h2.955c5.016 0 6.429.95 8.995 2.673l.504.337c4.539 3.027 6.07 4.134 6.133 4.179.26.189.413.49.413.81v22.998a.999.999 0 0 1-1 .999zM11.705 7.885C10.133 8.481 8.775 8.997 7 8.997H2v20.997h1c3.142 0 5.797 4.236 6.09 4.719l5.777 8.204c.229.343 1.357 1.825 3.556.592.832-.466 1.357-1.015 1.562-1.632.002-.004.005-.006.006-.01l-5.81-8.3a.999.999 0 1 1 1.638-1.146l6.959 9.942c.21.207 1.377 1.22 3.497.171.828-.409 1.097-1.068 1.307-1.823l-6.401-9.143a1 1 0 1 1 1.638-1.147l7 9.999c.195.293 1.827 2.606 4.101 1.112 1.14-.747 1.112-1.867.986-2.951l-.009-.084a7.297 7.297 0 0 1-.56-.776l-6.135-8.124a1 1 0 1 1 1.596-1.205l6.167 8.167c.022.029.043.06.061.091.076.126 1.915 3.127 4.388 2.051 1.345-.585 1.627-1.795 1.627-2.708 0-1.23-.839-2.396-.847-2.407L27.802 14.457a26.484 26.484 0 0 1-4.748 2.901c-3.905 1.856-6.909 2.151-8.931.874C12.774 17.38 12 15.836 12 13.997c0-1.227 1.059-1.953 2.661-3.053 1.482-1.016 3.511-2.408 5.965-4.862l.052-.052c-4.46.159-6.954 1.087-8.973 1.855zM46 8.514c-.716-.503-2.429-1.69-5.655-3.841l-.51-.342c-2.385-1.601-3.474-2.333-7.88-2.333H29c-1.565 0-2.047.452-4.682 3.175-.635.657-1.38 1.425-2.278 2.323-2.585 2.585-4.789 4.096-6.248 5.097-.798.548-1.703 1.168-1.796 1.432.004.641.159 1.862 1.195 2.517 1.364.861 3.851.509 7.004-.991 3.169-1.505 5.109-3.273 5.128-3.291a1 1 0 0 1 1.496.164l12.302 17.57H46V8.514z","key":1})]);
	}
	
	ShakingHands48px.displayName = "ShakingHands48px";
	
	ShakingHands48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 46"};
	
	module.exports = ShakingHands48px;
	
	ShakingHands48px.default = ShakingHands48px;


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function SoccerShoes48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M43.86 19.999h-3.937v.999a1 1 0 1 1-1.997 0v-.999h-3.994v.999a1 1 0 1 1-1.997 0v-.999H27.94v.999a.998.998 0 1 1-1.997 0v-.999H13.961v.999a.998.998 0 1 1-1.997 0v-.999H7.97v.999a.998.998 0 1 1-1.997 0v-.999h-.28c-1.916 0-3.302-.463-4.237-1.416C-.092 17.006-.049 14.504 0 11.606c.008-.52.017-1.058.017-1.608 0-4.613 1.464-9.999 5.589-9.999 1.817 0 2.758.8 3.589 1.509.899.766 1.748 1.49 4.059 1.49 2.531 0 3.629-.861 4.692-1.695.818-.641 1.665-1.304 2.958-1.304 1.44 0 2.514.857 3.872 1.941 1.437 1.148 3.227 2.576 6.305 3.834 1.55.633 3.347 1.271 5.249 1.947 7.18 2.547 11.581 4.238 11.581 6.778 0 2.32 0 5.5-4.051 5.5zM23.532 3.504c-1.239-.99-1.919-1.505-2.628-1.505-.577 0-.99.301-1.728.88-1.14.895-2.702 2.119-5.922 2.119-3.045 0-4.324-1.092-5.353-1.966-.73-.623-1.212-1.033-2.295-1.033-2.468 0-3.592 4.145-3.592 7.999 0 .561-.009 1.11-.019 1.643-.04 2.447-.076 4.561.885 5.539.54.551 1.461.819 2.813.819h9.514l9.15-13.846a59.146 59.146 0 0 1-.825-.649zm2.446 1.82l-8.376 12.675h3.725l7.349-11.124a24.226 24.226 0 0 1-2.698-1.551zM30.519 7.7c-.004.007-.004.016-.009.023l-6.789 10.276h3.726l6.058-9.168A89.779 89.779 0 0 1 30.519 7.7zm5.144 1.906l-.223-.08-.001.002-5.597 8.471H43.86c1.747 0 2.054-.524 2.054-3.5 0-1.257-6.923-3.713-10.251-4.893z","key":1})]);
	}
	
	SoccerShoes48px.displayName = "SoccerShoes48px";
	
	SoccerShoes48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 47.91 22"};
	
	module.exports = SoccerShoes48px;
	
	SoccerShoes48px.default = SoccerShoes48px;


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0148px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m-.533 32h2.21V15.1h-1.95l-3.692 1.976.442 1.742 2.938-1.586h.052V32z"}));
	}
	
	StepCircle0148px.displayName = "StepCircle0148px";
	
	StepCircle0148px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = StepCircle0148px;
	
	StepCircle0148px.default = StepCircle0148px;


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0248px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m5.291 32v-1.898h-7.566v-.052l1.326-1.248c3.562-3.432 5.824-5.954 5.824-9.074 0-2.418-1.534-4.914-5.148-4.914-1.95 0-3.64.754-4.784 1.716l.728 1.612c.78-.65 2.054-1.43 3.588-1.43 2.522 0 3.328 1.586 3.328 3.302 0 2.548-1.976 4.732-6.292 8.84l-1.794 1.742V32h10.79z"}));
	}
	
	StepCircle0248px.displayName = "StepCircle0248px";
	
	StepCircle0248px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = StepCircle0248px;
	
	StepCircle0248px.default = StepCircle0248px;


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0348px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m-5.577 31.142c.832.546 2.496 1.144 4.394 1.144 4.03 0 6.162-2.366 6.162-5.07 0-2.366-1.69-3.926-3.77-4.316v-.052c2.054-.754 3.12-2.236 3.12-4.004 0-2.054-1.508-4.03-4.836-4.03-1.82 0-3.536.65-4.446 1.3l.624 1.664c.728-.52 2.028-1.118 3.38-1.118 2.106 0 2.964 1.196 2.964 2.548 0 2.002-2.106 2.86-3.77 2.86h-1.274v1.716h1.274c2.21 0 4.342 1.014 4.368 3.38.026 1.43-.91 3.276-3.822 3.276-1.612 0-3.094-.65-3.744-1.04l-.624 1.742z"}));
	}
	
	StepCircle0348px.displayName = "StepCircle0348px";
	
	StepCircle0348px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = StepCircle0348px;
	
	StepCircle0348px.default = StepCircle0348px;


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0448px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m3.731 32h-2.158v-4.628h-7.852V25.89l7.54-10.79h2.47v10.504h2.366v1.768h-2.366V32zm-7.696-6.396h5.538v-5.642c0-.884.026-1.768.078-2.652h-.078c-.52.988-.936 1.716-1.404 2.496l-4.134 5.746v.052z"}));
	}
	
	StepCircle0448px.displayName = "StepCircle0448px";
	
	StepCircle0448px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = StepCircle0448px;
	
	StepCircle0448px.default = StepCircle0448px;


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0548px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m4.589 15.1h-8.086l-1.092 8.112a14.108 14.108 0 0 1 2.366-.182c3.354 0 4.836 1.56 4.836 3.718.026 2.288-1.846 3.692-3.978 3.692-1.56 0-2.938-.52-3.64-.936l-.572 1.742c.832.52 2.366 1.04 4.212 1.04 3.666 0 6.292-2.47 6.292-5.772 0-2.132-1.092-3.614-2.418-4.342-1.04-.624-2.314-.91-3.64-.91-.624 0-.988.052-1.378.104l.65-4.342h6.448V15.1z"}));
	}
	
	StepCircle0548px.displayName = "StepCircle0548px";
	
	StepCircle0548px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = StepCircle0548px;
	
	StepCircle0548px.default = StepCircle0548px;


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0648px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m4.147 14.84v1.872c-.468-.026-1.066.026-1.716.13-3.614.572-5.486 3.172-5.876 5.98h.052c.806-1.092 2.236-1.976 4.108-1.976 2.99 0 5.096 2.184 5.096 5.46 0 3.12-2.106 5.98-5.642 5.98-3.588 0-5.954-2.808-5.954-7.202 0-3.328 1.17-5.954 2.86-7.618 1.404-1.378 3.276-2.236 5.408-2.496.676-.104 1.248-.13 1.664-.13zm-3.952 15.678h.026c1.95 0 3.276-1.638 3.276-4.056s-1.378-3.874-3.484-3.874c-1.378 0-2.678.832-3.302 2.08a2.13 2.13 0 0 0-.234.988c.026 2.782 1.326 4.862 3.718 4.862z"}));
	}
	
	StepCircle0648px.displayName = "StepCircle0648px";
	
	StepCircle0648px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = StepCircle0648px;
	
	StepCircle0648px.default = StepCircle0648px;


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0748px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m-5.187 15.1v1.898h8.268v.052L19.775 32h2.34l7.358-15.392V15.1h-10.66z"}));
	}
	
	StepCircle0748px.displayName = "StepCircle0748px";
	
	StepCircle0748px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = StepCircle0748px;
	
	StepCircle0748px.default = StepCircle0748px;


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0848px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m.143 14.814h.026c3.276 0 4.94 2.028 4.94 4.16 0 1.43-.728 2.99-2.808 3.952v.078c2.106.832 3.406 2.34 3.406 4.368 0 2.964-2.522 4.914-5.746 4.914-3.536 0-5.668-2.08-5.668-4.55 0-2.132 1.274-3.666 3.328-4.55v-.078c-1.898-.884-2.704-2.34-2.704-3.796 0-2.678 2.262-4.498 5.226-4.498zm-.156 15.808h.026c2.054 0 3.38-1.274 3.38-3.016 0-2.028-1.43-3.042-3.718-3.692-1.976.572-3.042 1.898-3.042 3.51-.078 1.69 1.222 3.198 3.354 3.198zm.078-14.17h-.026c-1.898 0-2.938 1.248-2.938 2.704-.026 1.69 1.274 2.6 3.224 3.12 1.456-.494 2.574-1.534 2.574-3.068 0-1.352-.806-2.756-2.834-2.756z"}));
	}
	
	StepCircle0848px.displayName = "StepCircle0848px";
	
	StepCircle0848px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = StepCircle0848px;
	
	StepCircle0848px.default = StepCircle0848px;


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0948px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m-4.173 32.26v-1.872c.494.026 1.066 0 1.846-.104 1.326-.156 2.574-.702 3.536-1.612 1.118-1.04 1.924-2.496 2.236-4.498h-.078c-.936 1.144-2.288 1.82-4.004 1.82-3.042 0-4.992-2.288-4.992-5.2 0-3.172 2.34-5.98 5.798-5.98s5.59 2.782 5.59 7.124c0 3.718-1.248 6.318-2.912 7.93-1.3 1.248-3.094 2.054-4.914 2.262-.832.104-1.586.156-2.106.13zm4.16-15.704h-.026c-1.924 0-3.302 1.716-3.302 4.108 0 2.106 1.274 3.588 3.25 3.588 1.534 0 2.73-.754 3.354-1.768.104-.208.182-.468.182-.832.026-2.912-1.066-5.096-3.458-5.096z"}));
	}
	
	StepCircle0948px.displayName = "StepCircle0948px";
	
	StepCircle0948px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = StepCircle0948px;
	
	StepCircle0948px.default = StepCircle0948px;


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle1048px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m-6.452 32h2.21V15.1h-1.95l-3.692 1.976.442 1.742 2.938-1.586h.052V32zm12.28.286h-.026c-3.302 0-5.564-3.094-5.616-8.684 0-5.694 2.47-8.788 5.902-8.788 3.536 0 5.59 3.172 5.59 8.554 0 5.746-2.158 8.918-5.85 8.918zm.078-1.768h.026c2.314 0 3.432-2.73 3.432-7.046 0-4.16-1.04-6.89-3.432-6.89-2.08 0-3.432 2.652-3.432 6.89-.052 4.394 1.3 7.046 3.406 7.046z"}));
	}
	
	StepCircle1048px.displayName = "StepCircle1048px";
	
	StepCircle1048px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = StepCircle1048px;
	
	StepCircle1048px.default = StepCircle1048px;


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepPyramid0048px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M15.888 20L9.325 31H39.16l-6.152-11H15.888zm1.193-2l7.644-12.813L31.891 18H17.08zM8.13 33L2.165 43h43.706L40.28 33H8.131zm37.887 12H1.961c-.789 0-1.427-.33-1.75-.906-.32-.571-.274-1.277.128-1.937L23.09 4.026C23.485 3.371 24.083 3 24.73 3c.665 0 1.27.387 1.656 1.062l21.31 38.106c.376.659.405 1.366.075 1.932-.332.572-.972.9-1.754.9z"})),React.createElement("use",{"xlinkHref":"#a","fillRule":"evenodd","key":1})]);
	}
	
	StepPyramid0048px.displayName = "StepPyramid0048px";
	
	StepPyramid0048px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = StepPyramid0048px;
	
	StepPyramid0048px.default = StepPyramid0048px;


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepPyramid0148px (props) {
	    return React.createElement("symbol",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"d":"M15.888 20L9.325 31H39.16l-6.152-11H15.888zm1.193-2l7.644-12.813L31.891 18H17.08zM8.13 33L2.165 43h43.706L40.28 33H8.131zm37.887 12H1.961c-.789 0-1.427-.33-1.75-.906-.32-.571-.274-1.277.128-1.937L23.09 4.026C23.485 3.371 24.083 3 24.73 3c.665 0 1.27.387 1.656 1.062l21.31 38.106c.376.659.405 1.366.075 1.932-.332.572-.972.9-1.754.9z","key":0}),React.createElement("path",{"d":"M7 32h34l6 12H1z","key":1})]));
	}
	
	StepPyramid0148px.displayName = "StepPyramid0148px";
	
	StepPyramid0148px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = StepPyramid0148px;
	
	StepPyramid0148px.default = StepPyramid0148px;


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepPyramid0248px (props) {
	    return React.createElement("symbol",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"d":"M15.888 20L9.325 31H39.16l-6.152-11H15.888zm1.193-2l7.644-12.813L31.891 18H17.08zM8.13 33L2.165 43h43.706L40.28 33H8.131zm37.887 12H1.961c-.789 0-1.427-.33-1.75-.906-.32-.571-.274-1.277.128-1.937L23.09 4.026C23.485 3.371 24.083 3 24.73 3c.665 0 1.27.387 1.656 1.062l21.31 38.106c.376.659.405 1.366.075 1.932-.332.572-.972.9-1.754.9z","key":0}),React.createElement("path",{"d":"M15 19h19l7 13H8z","key":1})]));
	}
	
	StepPyramid0248px.displayName = "StepPyramid0248px";
	
	StepPyramid0248px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = StepPyramid0248px;
	
	StepPyramid0248px.default = StepPyramid0248px;


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepPyramid0348px (props) {
	    return React.createElement("symbol",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"d":"M15.888 20L9.325 31H39.16l-6.152-11H15.888zm1.193-2l7.644-12.813L31.891 18H17.08zM8.13 33L2.165 43h43.706L40.28 33H8.131zm37.887 12H1.961c-.789 0-1.427-.33-1.75-.906-.32-.571-.274-1.277.128-1.937L23.09 4.026C23.485 3.371 24.083 3 24.73 3c.665 0 1.27.387 1.656 1.062l21.31 38.106c.376.659.405 1.366.075 1.932-.332.572-.972.9-1.754.9z","key":0}),React.createElement("path",{"d":"M24 4h1l9 15H15z","key":1})]));
	}
	
	StepPyramid0348px.displayName = "StepPyramid0348px";
	
	StepPyramid0348px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = StepPyramid0348px;
	
	StepPyramid0348px.default = StepPyramid0348px;


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Stethoscope48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M42 33.875v2.101c0 .056-.023.105-.032.159.009.053.032.102.032.158 0 7.31-5.519 11.673-14.765 11.673-7.793 0-13.235-6.057-13.235-14.73v-3.33C4.315 28.519 0 7.265 0 4.263 0 1.193 3.732.142 5.938.005a.985.985 0 0 1 1.059.934 1 1 0 0 1-.933 1.06C6.023 2.001 2 2.35 2 4.263c0 3.586 4.848 23.718 13 23.718 8.152 0 13-20.132 13-23.718 0-1.924-4.021-2.262-4.062-2.264a1 1 0 0 1-.936-1.06.984.984 0 0 1 1.061-.934C26.268.142 30 1.193 30 4.263c0 3.002-4.315 24.256-14 25.643v3.33c0 7.496 4.62 12.732 11.235 12.732 4.768 0 12.765-1.257 12.765-9.675 0-.056.023-.105.032-.158-.009-.054-.032-.103-.032-.159v-2.101c-3.384-.489-6-3.378-6-6.893 0-3.856 3.14-6.995 6.999-6.995 3.86 0 7.001 3.139 7.001 6.995 0 3.514-2.616 6.403-6 6.893zm-1.001-11.889A5.003 5.003 0 0 0 36 26.982c0 2.662 2.1 4.826 4.73 4.969.087-.025.174-.054.27-.054.096 0 .182.029.27.054 2.629-.144 4.73-2.307 4.73-4.969a5.004 5.004 0 0 0-5.001-4.996z","key":1})]);
	}
	
	Stethoscope48px.displayName = "Stethoscope48px";
	
	Stethoscope48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 47.97"};
	
	module.exports = Stethoscope48px;
	
	Stethoscope48px.default = Stethoscope48px;


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Strategien48px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 strategien"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M47.603 22.138v1.07l-10.38 18.797H35.73l10.286-18.583v-.062h-9.08v-1.222zM.397 29.198v-.917l1.905-1.895c5.746-5.41 8.254-8.19 8.254-11.614 0-2.262-.984-4.493-4.476-4.493-1.969 0-3.493.978-4.381 1.712l-.604-1.009a7.978 7.978 0 0 1 5.27-1.987c4.286 0 5.746 3.118 5.746 5.471 0 3.913-2.952 7.06-8.127 11.982l-1.46 1.436v.061h10.159v1.253zM31.096 22.138H25.19V9.332h-1.238l-10.064 13.05v.978h9.841v5.838h1.46v-5.837h5.874l.38-.612zM23.73 14.1v8.038H15.7v-.061l6.444-8.252c.476-.703.953-1.376 1.587-2.507l.096.03a38.51 38.51 0 0 0-.096 2.752z","key":0}),React.createElement("path",{"d":"M30.746 29.229a.956.956 0 0 1-.285-.061c-.254-.153-.35-.49-.191-.734l3.524-5.685-3.524-5.685c-.159-.244-.063-.58.19-.733a.578.578 0 0 1 .762.183l3.683 5.96a.566.566 0 0 1 0 .55l-3.683 5.96c-.127.153-.285.245-.476.245zM47.603 22.138v1.07l-10.38 18.797H35.73l10.286-18.583v-.062h-9.08v-1.222zM.397 29.198v-.917l1.905-1.895c5.746-5.41 8.254-8.19 8.254-11.614 0-2.262-.984-4.493-4.476-4.493-1.969 0-3.493.978-4.381 1.712l-.604-1.009a7.978 7.978 0 0 1 5.27-1.987c4.286 0 5.746 3.118 5.746 5.471 0 3.913-2.952 7.06-8.127 11.982l-1.46 1.436v.061h10.159v1.253z","key":1}),React.createElement("path",{"d":"M31.096 22.138H25.19V9.332h-1.238l-10.064 13.05v.978h9.841v5.838h1.46v-5.837h5.874l.38-.612zM23.73 14.1v8.038H15.7v-.061l6.444-8.252c.476-.703.953-1.376 1.587-2.507l.096.03a38.51 38.51 0 0 0-.096 2.752z","key":2}),React.createElement("path",{"d":"M30.746 29.229a.956.956 0 0 1-.285-.061c-.254-.153-.35-.49-.191-.734l3.524-5.685-3.524-5.685c-.159-.244-.063-.58.19-.733a.578.578 0 0 1 .762.183l3.683 5.96a.566.566 0 0 1 0 .55l-3.683 5.96c-.127.153-.285.245-.476.245z","key":3})])]);
	}
	
	Strategien48px.displayName = "Strategien48px";
	
	Strategien48px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = Strategien48px;
	
	Strategien48px.default = Strategien48px;


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Sun48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M47 24.999H37a1 1 0 1 1 0-2h10a.999.999 0 1 1 0 2zM35.708 13.205a.994.994 0 0 1-1.414 0 .998.998 0 0 1 0-1.413l6-6a.999.999 0 1 1 1.414 1.414l-6 5.999zm-.001 20.587l6 6a.999.999 0 1 1-1.414 1.414l-6-6a.999.999 0 1 1 1.414-1.414zM24 32.497c-4.963 0-9-4.037-9-8.999 0-4.962 4.037-8.999 9-8.999s9 4.037 9 8.999c0 4.962-4.037 8.999-9 8.999zm0-15.999c-3.859 0-7 3.142-7 7 0 3.86 3.141 6.998 7 6.998s7-3.138 7-6.998c0-3.858-3.141-7-7-7zm0-4.499a1 1 0 0 1-1-1v-10a1 1 0 1 1 2 0v10a1 1 0 0 1-1 1zM7.708 41.206a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l6-6a.999.999 0 1 1 1.414 1.414l-6 6zM13 13.499a.994.994 0 0 1-.707-.294l-6-5.999a.999.999 0 1 1 1.414-1.414l6 6a.998.998 0 0 1 0 1.413.994.994 0 0 1-.707.294zm-1 10.499a1 1 0 0 1-1 1.001H1a1 1 0 1 1 0-2h10c.553 0 1 .447 1 .999zm12 12.001a1 1 0 0 1 1 1v9.999a1 1 0 1 1-2 0v-9.999a1 1 0 0 1 1-1z","key":1})]);
	}
	
	Sun48px.displayName = "Sun48px";
	
	Sun48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 48"};
	
	module.exports = Sun48px;
	
	Sun48px.default = Sun48px;


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Supercar48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M46.002 28.466V31a.999.999 0 0 1-1 .999H34.999a1 1 0 0 1-1-.999v-2.001H14.001V31a1 1 0 0 1-1 .999H3c-.553 0-1-.447-1-.999v-2.533c-1.188-.68-2-1.945-2-3.409v-6.436c0-3.793 2.351-6.825 6.122-8.113l2.959-6.904c1.252-2.507 8.39-3.606 14.92-3.606 5.675 0 14.591.946 15.895 3.553l3.025 7.053a.99.99 0 0 1 .078.403C46.113 12.504 48 15.266 48 18.622v6.436c0 1.463-.811 2.728-1.998 3.408zM36 29.999h8.002v-1H36v1zm-1.826-3.001c-1.027-1.156-1.656-2.463-1.844-2.887a3.01 3.01 0 0 0-2.329-1.112H17.999a3.01 3.01 0 0 0-2.329 1.112c-.188.424-.817 1.731-1.844 2.887h20.348zM4 29.999h8.001v-1H4v1zM38.083 4.393c-.45-.8-5.714-2.394-14.082-2.394-8.294 0-12.693 1.621-13.106 2.447L8.528 9.972c2.036-.231 9.101-.973 15.473-.973 7.475 0 15.928 1.023 16.012 1.034.192.035.361.098.547.14l-2.477-5.78zM46 18.622c0-3.315-2.469-5.911-6.288-6.613C39.687 12.008 31.351 11 24.001 11S8.313 12.008 8.229 12.019C4.465 12.677 2 15.272 2 18.622v6.436c0 1.07.871 1.94 1.942 1.94H10c1.9 0 3.442-2.728 3.877-3.78.032-.078.074-.153.125-.221a5.022 5.022 0 0 1 3.997-1.998h12.002c1.565 0 3.059.748 3.997 1.998.051.068.093.143.125.221.435 1.052 1.977 3.78 3.877 3.78h6.058c1.071 0 1.942-.87 1.942-1.94v-6.436zm-2.802.358l-5.002 1a1.002 1.002 0 0 1-1.177-.785 1 1 0 0 1 .784-1.176l5.002-1.001a.996.996 0 0 1 1.177.786 1 1 0 0 1-.784 1.176zM10.001 20c-.065 0-.13-.007-.197-.02l-5-1a1 1 0 0 1 .392-1.962l5.001 1.001A1 1 0 0 1 10.001 20z","key":1})]);
	}
	
	Supercar48px.displayName = "Supercar48px";
	
	Supercar48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 32"};
	
	module.exports = Supercar48px;
	
	Supercar48px.default = Supercar48px;


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Tractor48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M46.264 32.16a.998.998 0 0 1-.984.839h-2.537a6.983 6.983 0 0 1 2.11 5c0 3.86-3.131 7-6.979 7-3.847 0-6.976-3.14-6.976-7 0-1.959.811-3.728 2.109-5h-7.23c.015.119.041.233.053.353.057.58.084 1.117.084 1.647 0 .552-.446 1-.997 1a.998.998 0 0 1-.997-1c0-.464-.024-.938-.074-1.447A13.942 13.942 0 0 0 9.945 20.999a13.83 13.83 0 0 0-8.354 2.783.994.994 0 0 1-1.394-.203 1.002 1.002 0 0 1 .201-1.4 15.834 15.834 0 0 1 5.482-2.65V.999c0-.553.544-1 1.095-1h15.949c.401 0 .763.242.919.612l7.811 18.612 5.224.72v-4.768c0-2.303 1.789-4.176 3.987-4.176.551 0 .997.448.997 1.001a.998.998 0 0 1-.997.999c-1.099 0-1.993.976-1.993 2.176v5.043l8.109 1.118a1 1 0 0 1 .849 1.151l-1.566 9.673zm-13.373 5.839c0 2.757 2.235 5 4.983 5 2.749 0 4.985-2.243 4.985-5 0-2.756-2.236-5-4.985-5-2.748 0-4.983 2.244-4.983 5zm-10.629-36H7.88v17h21.517l-7.135-17zm7.639 19h-12.21a15.942 15.942 0 0 1 7.704 10h19.037l1.266-7.82-15.797-2.18zm-19.935 4c5.496 0 9.967 4.486 9.967 10 0 5.515-4.471 10-9.967 10s-9.968-4.485-9.968-10c0-5.514 4.472-10 9.968-10zm0 18c4.396 0 7.974-3.589 7.974-8 0-4.41-3.578-8-7.974-8-4.397 0-7.974 3.59-7.974 8 0 4.411 3.577 8 7.974 8z","key":1})]);
	}
	
	Tractor48px.displayName = "Tractor48px";
	
	Tractor48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 47.82 45"};
	
	module.exports = Tractor48px;
	
	Tractor48px.default = Tractor48px;


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function UmbrellaOpen48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M48 22.42c0 1.301-1.536 3.14-3 3.14H25v15.161c0 3.996-3.219 7.245-7.176 7.245-3.954 0-6.824-2.883-6.824-6.858 0-.555.447-1.008 1-1.008.553 0 1 .453 1 1.008 0 2.898 1.938 4.843 4.824 4.843 2.854 0 5.176-2.347 5.176-5.23V25.56H3c-1.362 0-3-1.648-3-3.09C0 11.148 11.408 5.091 23 4.76V.99c0-.556.447-1.008 1-1.008.553 0 1 .452 1 1.008v3.77c11.592.33 23 6.37 23 17.66zM24 6.743c-10.933 0-22 5.402-22 15.727 0 .303-.245 1.09 0 1.09h21.224a.98.98 0 0 1 .776-.398c.32 0 .593.162.776.398H45c.22 0 1-.795 1-1.14C46 12.127 34.932 6.743 24 6.743z","key":1})]);
	}
	
	UmbrellaOpen48px.displayName = "UmbrellaOpen48px";
	
	UmbrellaOpen48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 47.97"};
	
	module.exports = UmbrellaOpen48px;
	
	UmbrellaOpen48px.default = UmbrellaOpen48px;


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoAnlegg48px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M24 46a1 1 0 0 1-1-1v-6a1 1 0 0 1 2 0v6a1 1 0 0 1-1 1zm23.8-3.4a1 1 0 0 1-.8.4l-.6-.2L29.7 30H25v3a1 1 0 0 1-2 0v-3h-4.7L1.6 42.8a1 1 0 1 1-1.2-1.6L4 38.4V24a20 20 0 0 1 40 0v14.4l3.6 2.8a1 1 0 0 1 .2 1.4zM6 36.9l11-8.4V24a7 7 0 0 1 14 0v4.5l11 8.4V24a18 18 0 0 0-36 0zM29 28v-4a5 5 0 0 0-10 0v4z"}));
	}
	
	VoAnlegg48px.displayName = "VoAnlegg48px";
	
	VoAnlegg48px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = VoAnlegg48px;
	
	VoAnlegg48px.default = VoAnlegg48px;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoBygg48px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M47 26h-4V13.8h-.1v-.2h-.6l-28-6-.3-2.7a1 1 0 0 0-2 0L11.6 8l-11 5.1A1 1 0 0 0 1 15h9.8L7.1 46H4a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2h-3.1l-3.7-31H41v11h-4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1zM5.5 13l5.8-2.7L11 13zm11.4 33H9.1l3.7-31h.4zM15 13l-.4-3.3 17 3.3zm31 20h-8v-5h8zm-32 6h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zm0-10a1 1 0 1 1-1-1 1 1 0 0 1 1 1z"}));
	}
	
	VoBygg48px.displayName = "VoBygg48px";
	
	VoBygg48px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = VoBygg48px;
	
	VoBygg48px.default = VoBygg48px;


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoEiendom48px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M47.461 27.649a.988.988 0 0 1-1.404-.086l-2.241-2.54v20.844c0 1.1-.893 1.997-1.991 1.997H5.99a1.998 1.998 0 0 1-1.991-1.997V25.023l-2.24 2.54a.992.992 0 0 1-1.405.086.998.998 0 0 1-.086-1.408l3.997-4.531c.016-.017.029-.036.046-.052L23.162.289c.377-.429 1.114-.429 1.491 0l18.852 21.369c.017.016.03.034.046.052l3.997 4.531a.998.998 0 0 1-.087 1.408zm-5.636-4.883L23.908 2.455 5.99 22.766v23.101h35.835V22.766zm-22.894.143a5.983 5.983 0 0 1 4.977 2.661 5.98 5.98 0 0 1 4.977-2.661c3.293 0 5.972 2.658 5.972 5.923 0 1.533-.703 3.145-1.88 4.313l-8.409 7.48c-.053.047-.116.071-.175.105-.038.022-.072.051-.112.068a.99.99 0 0 1-.373.078.985.985 0 0 1-.373-.078c-.041-.017-.074-.046-.113-.068-.059-.034-.121-.058-.174-.105l-8.37-7.443c-1.217-1.205-1.92-2.817-1.92-4.35 0-3.265 2.679-5.923 5.973-5.923zm-2.693 8.817l7.67 6.818 7.709-6.855c.756-.752 1.249-1.86 1.249-2.857 0-2.166-1.785-3.926-3.981-3.926-2.196 0-3.982 1.76-3.982 3.926a.996.996 0 1 1-1.991 0c0-2.166-1.785-3.926-3.981-3.926-2.196 0-3.982 1.76-3.982 3.926 0 .997.494 2.105 1.289 2.894z"}));
	}
	
	VoEiendom48px.displayName = "VoEiendom48px";
	
	VoEiendom48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 47.82 47.9"};
	
	module.exports = VoEiendom48px;
	
	VoEiendom48px.default = VoEiendom48px;


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoEnergi48px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M20 46h-.4a1 1 0 0 1-.6-1l1.9-17H12a1 1 0 0 1-.8-1.6l18-24a1 1 0 0 1 1.8.7L29.1 20H38a1 1 0 0 1 .8 1.6l-18 24a1 1 0 0 1-.8.4zm-6-20h8a1 1 0 0 1 1 1.1l-1.6 14.4L36 22h-8a1 1 0 0 1-1-1.1l1.6-14.4z"}));
	}
	
	VoEnergi48px.displayName = "VoEnergi48px";
	
	VoEnergi48px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = VoEnergi48px;
	
	VoEnergi48px.default = VoEnergi48px;


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoMiljo48px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M47.693 41.494a.996.996 0 0 1-.866.505H28.332l3.264 3.294a1.004 1.004 0 0 1-.004 1.415.997.997 0 0 1-1.409-.004l-4.887-4.934a.983.983 0 0 1-.385-.771c0-.005.003-.009.003-.014 0-.007-.004-.014-.004-.021a1 1 0 0 1 .294-.705l4.983-4.968a.992.992 0 0 1 1.409.004 1.003 1.003 0 0 1-.004 1.414L28.291 40h16.784l-8.629-14.55a1.003 1.003 0 0 1 .347-1.371.994.994 0 0 1 1.366.348l9.524 16.061c.183.309.187.693.01 1.006zM34.856 20.201c-.003.01-.009.017-.012.027-.01.034-.03.064-.043.097a1 1 0 0 1-.121.226c-.023.031-.052.056-.078.084a1.035 1.035 0 0 1-.199.163c-.018.011-.029.029-.048.039-.015.008-.032.005-.047.012a.968.968 0 0 1-.417.106c-.077 0-.156-.011-.234-.028l-6.962-1.677a1 1 0 1 1 .465-1.946l4.82 1.162-8.117-15.423-8.804 14.906a.997.997 0 1 1-1.714-1.02L23.057.489c.183-.313.531-.477.881-.491a.994.994 0 0 1 .856.534l8.766 16.657 1.118-4.427a1 1 0 0 1 1.211-.725c.533.136.856.68.721 1.217l-1.754 6.947zM13.958 30.998a.994.994 0 0 1-1.209-.726l-1.182-4.706L2.759 40H19.93c.55 0 .996.446.996.999 0 .554-.446 1-.996 1H1.001a.977.977 0 0 1-.808-.446l-.006-.009a.966.966 0 0 1-.131-.288c-.014-.048-.021-.094-.029-.144-.004-.039-.022-.073-.022-.113 0-.026.012-.047.014-.073a.969.969 0 0 1 .055-.269c.008-.025.015-.049.026-.072.019-.046.024-.096.051-.14l9.691-15.881-4.596 1.126a.995.995 0 0 1-1.205-.734 1.001 1.001 0 0 1 .732-1.209l6.944-1.701h.003a.97.97 0 0 1 .314-.014.967.967 0 0 1 .439.133h.001c.008.005.011.013.018.017a.989.989 0 0 1 .263.245c.052.07.08.152.111.232.015.04.043.071.054.114l1.761 7.011a1 1 0 0 1-.723 1.214z"}));
	}
	
	VoMiljo48px.displayName = "VoMiljo48px";
	
	VoMiljo48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 47.85 47"};
	
	module.exports = VoMiljo48px;
	
	VoMiljo48px.default = VoMiljo48px;


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoOffshore48px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M47 46h-7l-2-.2V39h3a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-7.3l12-10.2a1 1 0 0 0-1.1-1.7l-17.2 7.6L25 5.9a1 1 0 0 0-1-.9h-1V1a1 1 0 0 0-2 0v4h-1a1 1 0 0 0-1 .9L16.1 31H16v-7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3v7H1a1 1 0 0 0 0 2h25c.1 0 4.8-.1 7-2.2 2.2 2.1 6.9 2.2 7 2.2h7a1 1 0 0 0 0-2zm-7.8-22.3L30.6 31h-2.7l-.3-2.2zM20.9 7h2.2l2.8 24h-7.8zM4 25h10v7a1 1 0 0 0 1 1h25v4H4zm4 21v-7h6v7zm8 0v-7h12v6.8l-2 .2zm17.9-2.3a1 1 0 0 0-1.9 0 3.2 3.2 0 0 1-2 1.6V39h6v6.3a3.2 3.2 0 0 1-2.1-1.6zM8 28a1 1 0 1 1-1-1 1 1 0 0 1 1 1zm4 0a1 1 0 1 1-1-1 1 1 0 0 1 1 1z"}));
	}
	
	VoOffshore48px.displayName = "VoOffshore48px";
	
	VoOffshore48px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = VoOffshore48px;
	
	VoOffshore48px.default = VoOffshore48px;


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Volleyball48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M47.84 24.3a.971.971 0 0 1-.01.194c-.266 13.002-10.878 23.504-23.907 23.504a23.705 23.705 0 0 1-11.838-3.169.958.958 0 0 1-.432-.264C4.681 40.366-.01 32.731-.01 23.999c0-9.547 5.601-17.785 13.669-21.648a.952.952 0 0 1 .307-.149 23.695 23.695 0 0 1 9.957-2.204c9.242 0 17.262 5.291 21.248 13.004a.985.985 0 0 1 .151.315 23.873 23.873 0 0 1 2.533 10.682c0 .102-.014.2-.015.301zM22.902 45.938c11.277-8.514 11.606-20.529 11.465-23.824-5.103-.05-8.393 1.712-9.459 2.39.127 2.43-.198 11.338-10.623 19.227a21.773 21.773 0 0 0 8.617 2.207zm-10.551-3.284c2.859-2.054 4.933-4.181 6.464-6.232-2.793-1.549-12.653-7.954-14.751-21.733a21.862 21.862 0 0 0-2.079 9.31c0 7.869 4.154 14.766 10.366 18.655zm.933-37.881a22.155 22.155 0 0 0-7.602 7.04c.022.069.054.133.06.208 1.125 14.763 11.94 21.484 14.21 22.737 2.973-4.796 3.041-8.904 2.963-10.194-2.074-1.306-9.15-6.71-9.631-19.791zm10.639-2.775c-3.082 0-6.013.647-8.677 1.802.041 3.47.574 6.357 1.352 8.77 3.082-1.667 13.115-6.116 25.188-1.281-3.971-5.615-10.489-9.291-17.863-9.291zm19.643 12.295c-12.636-6.396-23.655-1.244-26.266.181 2.129 5.064 5.314 7.524 6.56 8.327 1.384-.868 5.333-2.906 11.288-2.67.008-.001.014-.007.022-.008.062-.006.118.011.177.015 3.005.144 6.503.859 10.45 2.607a21.913 21.913 0 0 0-2.231-8.452zm-7.189 7.934c.153 3.7-.314 14.869-10.272 23.663 10.755-1.071 19.227-9.973 19.707-20.921-3.544-1.677-6.701-2.47-9.435-2.742z","key":1})]);
	}
	
	Volleyball48px.displayName = "Volleyball48px";
	
	Volleyball48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 47.84 48"};
	
	module.exports = Volleyball48px;
	
	Volleyball48px.default = Volleyball48px;


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Wall48px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M46 31.999H1a1 1 0 0 1-1-1v-30A1 1 0 0 1 1-.002h30a1 1 0 0 1 1 1.001v9h7a1 1 0 0 1 1 1v9h6a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zm-29-2h13v-8H17v8zm-15 0h13v-8H2v8zm0-10h6v-8H2v8zm13-18H2v8h13v-8zm-5 10v8h13v-8H10zm20-10H17v8h13v-8zm8 10H25v8h13v-8zm7 10H32v8h13v-8z","key":1})]);
	}
	
	Wall48px.displayName = "Wall48px";
	
	Wall48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 47 32"};
	
	module.exports = Wall48px;
	
	Wall48px.default = Wall48px;


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function IDCard60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M57.066 51.999H2.934C1.316 51.999 0 50.695 0 49.09V10.907c0-1.603 1.316-2.908 2.934-2.908H25v-7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v7h22.066c1.618 0 2.934 1.305 2.934 2.908V49.09c0 1.605-1.316 2.909-2.934 2.909zM33 1.999h-6V16h6V1.999zm25 8.908c0-.492-.428-.908-.934-.908H35v7a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-7H2.934c-.506 0-.934.416-.934.908V49.09c0 .501.419.908.934.908h54.132A.922.922 0 0 0 58 49.09V10.907zM39.166 45.999H20.834C19.271 45.999 18 44.653 18 43v-1.001c0-.034.016-.064.02-.098a.985.985 0 0 1 .218-.528.94.94 0 0 1 .142-.14c.027-.022.044-.053.074-.072l6.825-4.451c-1.319-2.288-1.296-4.755-1.271-5.299-.001-.013-.008-.024-.008-.037l.003-4.626c0-.024.012-.045.014-.069.002-.033-.009-.063-.003-.096.456-2.704 3.39-4.532 5.887-4.58.033-.003.066-.004.099-.004 2.518 0 5.525 1.842 5.986 4.584.006.033-.005.063-.003.096.002.024.014.044.014.069L36 31.374c0 .013-.007.024-.008.038.025.544.047 3.011-1.272 5.298l6.826 4.451c.03.019.047.05.074.072a.94.94 0 0 1 .247.297.985.985 0 0 1 .113.371c.004.034.02.063.02.098V43c0 1.653-1.272 2.999-2.834 2.999zm-6.38-8.162c-.011-.007-.016-.019-.027-.026-.012-.009-.026-.011-.038-.021-.044-.033-.067-.08-.104-.119-.046-.05-.096-.094-.13-.151-.035-.055-.052-.115-.075-.176-.022-.06-.049-.116-.059-.18-.011-.063-.005-.125-.003-.189.001-.064-.002-.127.012-.191.014-.063.046-.121.072-.182.022-.049.029-.102.06-.149.008-.012.021-.018.029-.03.008-.011.009-.024.017-.035 1.628-2.106 1.454-4.914 1.452-4.941-.002-.024.009-.045.009-.069L34 31.374l-.003-4.514c-.312-1.614-2.289-2.823-3.92-2.86a.972.972 0 0 1-.077.003c-1.645 0-3.68 1.219-3.997 2.858L26 31.374l-.001.003c0 .024.011.045.009.07-.002.036-.174 2.837 1.451 4.941.009.011.01.024.018.035.008.012.021.018.029.03.031.047.038.1.06.15.026.061.058.118.072.181.014.064.011.126.012.191.001.064.008.126-.003.19-.011.062-.037.119-.059.178-.023.061-.04.121-.075.177-.034.057-.084.101-.13.151-.036.039-.06.086-.104.119-.012.01-.026.012-.039.021-.01.007-.015.019-.026.026L20 42.541V43c0 .542.382.999.834.999h18.332c.452 0 .834-.457.834-.999v-.459l-7.214-4.704z","key":1})]);
	}
	
	IDCard60px.displayName = "IDCard60px";
	
	IDCard60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 52"};
	
	module.exports = IDCard60px;
	
	IDCard60px.default = IDCard60px;


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function BarChartUp60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M57.784 59.88h-8.88c-.55 0-.904-.449-.904-1V20.879c0-.551.354-.991.904-.991h8.88c.55 0 1.216.44 1.216.991V58.88c0 .551-.666 1-1.216 1zm-.784-38h-7v36h7v-36zm1.775-16.534l-3.997 9.073a.995.995 0 0 1-1.313.51 1.002 1.002 0 0 1-.507-1.32l3.008-6.83-54.463 23.03a.997.997 0 0 1-1.304-.535 1.002 1.002 0 0 1 .532-1.31L55.28 4.9l-6.773-2.966a1.002 1.002 0 0 1-.516-1.316.994.994 0 0 1 1.311-.517l8.736 3.825a.979.979 0 0 1 .744.578.996.996 0 0 1 .072.424.99.99 0 0 1-.079.418zM1.117 37.884h9.042c.55 0 .841.444.841.995V58.88c0 .551-.291 1-.841 1H1.117c-.55 0-1.117-.449-1.117-1V38.879c0-.551.567-.995 1.117-.995zM2 57.88h7v-18H2v18zm15.128-25.994h8.878c.55 0 .996.447.996.999v25.996a.998.998 0 0 1-.996.999h-8.878c-.55 0-1.128-.449-1.128-1v-26c0-.552.578-.994 1.128-.994zM18 57.88h7.011V33.886L18 33.88v24zm14.975-31.993h8.88c.55 0 1.145.44 1.145.992V58.88c0 .551-.595 1-1.145 1h-8.88a.997.997 0 0 1-.995-.999V26.887c0-.552.445-1 .995-1zm.996 31.993H41v-30l-7.029.006V57.88z","key":1})]);
	}
	
	BarChartUp60px.displayName = "BarChartUp60px";
	
	BarChartUp60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59 59.88"};
	
	module.exports = BarChartUp60px;
	
	BarChartUp60px.default = BarChartUp60px;


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Bill260px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M43.981 17.088V56.42c0 1.939-1.556 3.517-3.47 3.517H3.469c-1.914 0-3.47-1.578-3.47-3.517V3.53c0-1.939 1.556-3.517 3.47-3.517h23.519c.045 0 .084.02.128.026a.804.804 0 0 1 .128.025 1 1 0 0 1 .452.243l15.883 15.869c.032.023.047.061.076.087.03.027.052.058.078.089.154.175.267.387.267.639 0 .034-.016.063-.019.097zM27.987 3.423v12.57h12.581L27.987 3.423zM41.981 17.99H26.988c-.553 0-1-.446-1-.999V2.01H3.469c-.811 0-1.471.682-1.471 1.52v52.89c0 .838.66 1.52 1.471 1.52h37.042c.811 0 1.47-.682 1.47-1.52V17.99zm-6.997 28.964h-3.998a.999.999 0 1 1 0-1.998h3.998a.999.999 0 1 1 0 1.998zm0-7.991h-3.998a.998.998 0 1 1 0-1.997h3.998a.999.999 0 1 1 0 1.997zm0-7.99h-3.998a.998.998 0 1 1 0-1.997h3.998a.999.999 0 1 1 0 1.997zm-9.995 15.981H8.995a.999.999 0 1 1 0-1.998h15.994a.999.999 0 1 1 0 1.998zm0-7.991H8.995a.998.998 0 1 1 0-1.997h15.994a.999.999 0 1 1 0 1.997zm0-7.99H8.995a.998.998 0 1 1 0-1.997h15.994a.999.999 0 1 1 0 1.997z","key":1})]);
	}
	
	Bill260px.displayName = "Bill260px";
	
	Bill260px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 44 59.94"};
	
	module.exports = Bill260px;
	
	Bill260px.default = Bill260px;


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Binoculars60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M60 40c0 6.617-5.383 12-12 12-6.616 0-11.997-5.381-12-11.996V30.003c0-.552-.45-1.001-1.003-1.001h-9.994c-.553 0-1.003.449-1.003 1.001v10.001C23.998 46.619 18.616 52 12 52 5.383 52 0 46.617 0 40c0-.936.118-1.844.322-2.718.002-.016-.003-.031-.001-.046L6.017 6.688c.003-.018.015-.03.019-.047s-.001-.033.004-.05c1.132-3.88 4.748-6.592 8.796-6.592 4.98 0 9.037 3.996 9.153 8.949.001.019.011.035.011.054v6h12V9.164C36 4.111 40.111 0 45.164 0c4.048 0 7.665 2.711 8.796 6.594.005.015 0 .03.004.046.004.017.016.03.019.048l5.696 30.548c.003.016-.003.03-.001.046.204.875.322 1.782.322 2.718zM12 50c5.514 0 10-4.487 10-10 0-5.514-4.486-10.001-10-10.001S2 34.486 2 40c0 5.513 4.486 10 10 10zM52.031 7.13C51.139 4.108 48.319 2 45.164 2A7.172 7.172 0 0 0 38 9.164v6.839a.998.998 0 0 1-1 .999H23c-.553 0-1-.446-1-.999V9.164c0-3.951-3.214-7.165-7.164-7.165A7.196 7.196 0 0 0 7.97 7.125L3.398 31.651A11.956 11.956 0 0 1 12 28c4.172 0 7.849 2.141 10 5.38v-3.377a3.005 3.005 0 0 1 3.003-3.001h9.994A3.005 3.005 0 0 1 38 30.003v3.377C40.151 30.141 43.828 28 48 28c3.373 0 6.42 1.403 8.602 3.651L52.031 7.13zM48 29.999c-5.514 0-10 4.487-10 10.001 0 5.513 4.486 10 10 10s10-4.487 10-10c0-5.514-4.486-10.001-10-10.001z","key":1})]);
	}
	
	Binoculars60px.displayName = "Binoculars60px";
	
	Binoculars60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 52"};
	
	module.exports = Binoculars60px;
	
	Binoculars60px.default = Binoculars60px;


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function BulbIdea60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M59 23.91h-4c-.553 0-1-.399-1-.95a.999.999 0 0 1 1-.998h4c.553 0 1 .447 1 .998 0 .551-.447.95-1 .95zM51.707 7.691a.996.996 0 0 1-.707.292.996.996 0 0 1-.707-1.704l6-5.991a1 1 0 0 1 1.414 0 .996.996 0 0 1 0 1.412l-6 5.991zM39.969 39.392l-.001.001c-.964.866-1.032 2.821-.976 3.501.001.014-.005.026-.005.04.001.015.009.028.009.044v11.028a.964.964 0 0 1-.012.152c-.011.068-1.133 6.743-8.987 6.743-7.852 0-8.976-6.675-8.986-6.743a.964.964 0 0 1-.012-.152V42.978c0-.016.008-.028.009-.043 0-.015-.006-.028-.005-.043.055-.666-.014-2.595-.987-3.509-5.897-4.433-9.018-10.212-9.018-16.724 0-10.845 8.522-19.668 18.999-19.668 10.478 0 19.001 8.823 19.001 19.668 0 6.516-3.124 12.299-9.029 16.733zm-9.972 19.513c5.844 0 6.881-4.362 6.999-4.984v-6.418a16.257 16.257 0 0 1-6.703 1.431c-3.119 0-5.742-.838-7.294-1.479v6.462c.121.609 1.197 4.988 6.998 4.988zm0-53.917c-9.373 0-16.999 7.928-16.999 17.671 0 7.44 4.513 12.368 8.298 15.192.016.012.023.03.038.042.015.013.033.016.047.029 1.81 1.695 1.645 4.706 1.618 5.081v2.261c1.747.821 7.881 3.216 13.997.006v-2.269c-.038-.503-.181-3.464 1.634-5.092.012-.011.027-.014.039-.024s.018-.025.031-.034c3.785-2.824 8.298-7.752 8.298-15.192 0-9.743-7.627-17.671-17.001-17.671zM3.707 44.634a1 1 0 0 1-1.414-1.413l6-5.99a1 1 0 0 1 1.414 0 .996.996 0 0 1 0 1.412l-6 5.991zM9 7.984a.996.996 0 0 1-.707-.292l-6-5.992a.996.996 0 0 1 0-1.412 1 1 0 0 1 1.414 0l6 5.992A.996.996 0 0 1 9 7.984zM6 21.962c0 .551-.447.947-1 .947H1c-.553 0-1-.396-1-.947a.998.998 0 0 1 1-.998h4c.553 0 1 .446 1 .998zM51.707 37.23l6 5.991A.998.998 0 0 1 57 44.926a1 1 0 0 1-.707-.292l-6-5.992a.996.996 0 0 1 0-1.412 1 1 0 0 1 1.414 0z","key":1})]);
	}
	
	BulbIdea60px.displayName = "BulbIdea60px";
	
	BulbIdea60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 60.91"};
	
	module.exports = BulbIdea60px;
	
	BulbIdea60px.default = BulbIdea60px;


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Chat360px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M59.295 59.955a1.005 1.005 0 0 1-1.121-.393l-6.47-9.511H22.012A5.017 5.017 0 0 1 17 45.04v-9.041a1 1 0 0 1 2 0v9.041a3.015 3.015 0 0 0 3.012 3.01h30.221c.032 0 .059.015.09.018.069.007.134.02.2.041a.91.91 0 0 1 .328.174c.053.043.1.088.143.14.021.025.048.039.067.065L58 55.751V24.012A3.015 3.015 0 0 0 54.988 21H48a1 1 0 1 1 0-2.001h6.988A5.018 5.018 0 0 1 60 24.012V59a1 1 0 0 1-.705.955zM37.988 31.051H8.295l-6.468 9.511a1.003 1.003 0 0 1-1.121.394A1.002 1.002 0 0 1 0 39.999V5.011A5.017 5.017 0 0 1 5.012 0h32.976A5.017 5.017 0 0 1 43 5.011v21.028a5.018 5.018 0 0 1-5.012 5.012zM41 5.011a3.016 3.016 0 0 0-3.012-3.012H5.012A3.015 3.015 0 0 0 2 5.011v31.74l4.94-7.263c.018-.026.045-.04.065-.064a.967.967 0 0 1 .145-.141.88.88 0 0 1 .327-.174.994.994 0 0 1 .201-.04c.031-.003.057-.018.089-.018h30.221A3.016 3.016 0 0 0 41 26.039V5.011z","key":1})]);
	}
	
	Chat360px.displayName = "Chat360px";
	
	Chat360px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 60"};
	
	module.exports = Chat360px;
	
	Chat360px.default = Chat360px;


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Coins260px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M41 57.999c-.519 0-1.059-.043-1.596-.088a.993.993 0 0 1-.404.088H3A1 1 0 0 1 2 57v-8.001a1 1 0 0 1 1-1h10v-6H7c-.553 0-1-.447-1-.999v-7.001H1a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h7v-6H3a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h5V1A1 1 0 0 1 9-.001h36A1 1 0 0 1 46 1v7.999a1 1 0 0 1-1 1h-5v6h5a1 1 0 0 1 1 1v3.695c8.273 2.228 14 9.635 14 18.305 0 10.477-8.523 19-19 19zM4 50v6h28.49c-.107-.054-.204-.125-.31-.18a19.011 19.011 0 0 1-1.327-.771c-.163-.103-.329-.199-.489-.307a18.735 18.735 0 0 1-1.652-1.254c-.096-.081-.183-.173-.277-.257a19.181 19.181 0 0 1-1.236-1.202c-.157-.167-.306-.34-.458-.514a19.173 19.173 0 0 1-.942-1.173c-.088-.118-.19-.222-.276-.342H4zm20.269-2.001c-.075-.136-.134-.279-.204-.417a18.559 18.559 0 0 1-.855-1.951c-.049-.132-.106-.261-.151-.394a18.315 18.315 0 0 1-.53-1.852c-.034-.151-.058-.306-.089-.459-.063-.308-.134-.614-.181-.927H15v6h9.269zM8 39.999h14.027c-.003-.044-.001-.088-.003-.133a15.956 15.956 0 0 1-.024-.867c0-.49.025-.979.062-1.466.012-.151.03-.301.046-.452a18.444 18.444 0 0 1 .439-2.562c.033-.134.061-.269.096-.403.01-.039.017-.078.028-.117H8v6zm-6-14V32h21.336l.115-.293c.273-.654.593-1.284.935-1.902.098-.176.202-.348.306-.521.283-.474.585-.934.908-1.381.1-.138.194-.281.298-.417.394-.515.806-1.015 1.25-1.487H2zm2-16v6h34v-6H4zm40-2V2H10v5.999h34zm0 10H10v6h19.349c.105-.082.223-.165.335-.248.083-.062.163-.124.251-.187.261-.186.535-.374.834-.566a.762.762 0 0 1 .191-.121c2.638-1.648 5.527-2.592 8.59-2.806.457-.062.972-.071 1.45-.071.653 0 1.294.044 1.928.109.17.017.338.039.507.061.187.024.38.038.565.068v-2.239zm.779 4.435A16.191 16.191 0 0 0 41 21.999c-.41 0-.846.007-1.249.061a16.61 16.61 0 0 0-7.86 2.592l-.04.028c-.586.377-1.082.735-1.515 1.09l-.008.008-.002.002a16.904 16.904 0 0 0-5.022 6.684 17.069 17.069 0 0 0-.706 2.092c-.014.054-.035.108-.049.162-.062.239-.104.481-.156.721-.049.23-.109.458-.149.689-.023.136-.032.275-.052.412-.05.338-.102.676-.131 1.017-.041.478-.061.96-.061 1.442 0 .412.008.847.062 1.247l.018.202c.008.098.018.194.033.289.023.085.046.17.046.263 0 .007-.003.013-.004.02.004.034.012.067.017.101.069.594.165 1.179.294 1.754.062.271.151.53.226.796.097.348.181.7.3 1.039.114.323.261.63.395.944.115.272.213.551.344.818.282.573.598 1.132.949 1.675l.083.126.052.077c.007.012.016.022.022.034 2.453 3.667 6.071 6.186 10.24 7.162.701.16 1.387.278 2.032.349.64.069 1.277.105 1.891.105 9.374 0 17-7.627 17-17.001 0-7.995-5.437-14.807-13.221-16.565zM41 51.999c-1.019 0-2.028-.118-3.002-.35-3.286-.771-6.11-2.777-7.947-5.65a12.868 12.868 0 0 1-2.001-6.006 8.275 8.275 0 0 1-.05-.994c0-1.721.337-3.404 1.001-5A12.896 12.896 0 0 1 34 28.05l.08-.049-.001-.002a12.792 12.792 0 0 1 5.929-1.951c.29-.038.636-.049.992-.049 7.168 0 13 5.832 13 13s-5.832 13-13 13zm0-24c-.272 0-.536.006-.8.039a10.686 10.686 0 0 0-5.052 1.653l-.073.041c-1.948 1.274-3.383 2.994-4.227 5.033A10.972 10.972 0 0 0 30 38.999c0 .273.007.537.039.801.138 1.873.706 3.58 1.696 5.121a10.9 10.9 0 0 0 6.724 4.781C39.284 49.9 40.138 50 41 50c6.065 0 11-4.935 11-11.001 0-6.065-4.935-11-11-11z","key":1})]);
	}
	
	Coins260px.displayName = "Coins260px";
	
	Coins260px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 58"};
	
	module.exports = Coins260px;
	
	Coins260px.default = Coins260px;


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ConstructionHelmet60px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"construction-helmet-60px"),React.createElement("path",{"d":"M10.9 45.5c-3.6 0-8.1-.2-9.7-1.2a2 2 0 0 1-1.1-1.8 2.4 2.4 0 0 1 1.5-1.8c0-2.8.3-11.3 5-18.4l.3-.3c5.2-7.5 16.8-8.3 17.3-8.3 15.1-.9 22.5 11.4 22.6 11.5a34 34 0 0 1 2.7 9.4 3.9 3.9 0 0 0 .8 2.3l.7.2c5.7 1.4 8.2 2.5 8.8 3.6a1.5 1.5 0 0 1 .1 1.2h-.1a5.5 5.5 0 0 1-5.2 2.5l-2.6-.2a100.2 100.2 0 0 0-10.9-.6c-4.3.1-25.2 1.5-25.4 1.5zm-8.6-2.9c1.8.9 9 1 13.2.8.8-.1 21.1-1.4 25.4-1.5a102.2 102.2 0 0 1 11.2.6l2.6.2a3.6 3.6 0 0 0 3.1-1.2c-.5-.4-2.2-1.2-7.3-2.4l-.7-.2c-1.8-.5-2.2-3.4-2.2-4a32.6 32.6 0 0 0-2.6-8.7s-6.9-11.3-20.7-10.5c-.1 0-11.3.8-15.9 7.7l-.3.3c-4.6 7.2-4.5 16-4.5 17.6a1 1 0 0 1-.6 1z","key":1})]);
	}
	
	ConstructionHelmet60px.displayName = "ConstructionHelmet60px";
	
	ConstructionHelmet60px.defaultProps = {"viewBox":"0 0 60 60"};
	
	module.exports = ConstructionHelmet60px;
	
	ConstructionHelmet60px.default = ConstructionHelmet60px;


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Diploma360px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M59 39.945h-5a.999.999 0 1 1 0-1.997h4V1.988H2v35.96h26a.999.999 0 1 1 0 1.997H1c-.553 0-1-.447-1-.999V.989a.999.999 0 0 1 1-.998h58c.553 0 1 .447 1 .998v37.957a.999.999 0 0 1-1 .999zM41 18.969c4.963 0 9 4.033 9 8.99a8.94 8.94 0 0 1-2 5.638v13.341a.998.998 0 1 1-1.555.83l-5.444-3.626-5.446 3.626a.997.997 0 0 1-1.027.05.997.997 0 0 1-.528-.88V33.597a8.94 8.94 0 0 1-2-5.638c0-4.957 4.037-8.99 9-8.99zm0 1.998c-3.859 0-7 3.136-7 6.992 0 3.855 3.141 6.992 7 6.992s7-3.137 7-6.992c0-3.856-3.141-6.992-7-6.992zm-.554 21.144a1.004 1.004 0 0 1 1.11 0L46 45.071v-9.642a8.953 8.953 0 0 1-5 1.52 8.953 8.953 0 0 1-5-1.52v9.642l4.446-2.96zM27.001 17.927a1 1 0 1 1 0 1.998H15a1 1 0 1 1 0-1.998h12.001zM8 10.978a1 1 0 0 1 1-.999h42a1 1 0 1 1 0 1.998H9a1 1 0 0 1-1-.999z","key":1})]);
	}
	
	Diploma360px.displayName = "Diploma360px";
	
	Diploma360px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 47.94"};
	
	module.exports = Diploma360px;
	
	Diploma360px.default = Diploma360px;


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function DiscountStar60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M55.936 29.892l3.731 7.285a.998.998 0 0 1-.345 1.292l-6.875 4.443-.411 8.176a.996.996 0 0 1-.945.944l-8.175.411-4.444 6.875a.996.996 0 0 1-1.29.345l-7.286-3.731-7.285 3.731a.997.997 0 0 1-1.291-.345l-4.443-6.875-8.175-.411a.997.997 0 0 1-.946-.945l-.408-8.175-6.877-4.443a.997.997 0 0 1-.345-1.292l3.731-7.285-3.731-7.285a.995.995 0 0 1 .345-1.29l6.877-4.445.408-8.174a.998.998 0 0 1 .946-.945l8.175-.41L21.32.467a.998.998 0 0 1 1.291-.346l7.285 3.733L37.182.121a.997.997 0 0 1 1.29.346l4.444 6.876 8.175.41a.996.996 0 0 1 .945.944l.411 8.175 6.875 4.445a.996.996 0 0 1 .345 1.29l-3.731 7.285zm-4.999-11.623a1 1 0 0 1-.454-.786l-.391-7.786-7.785-.39a1 1 0 0 1-.787-.454l-4.231-6.548-6.938 3.555a1.004 1.004 0 0 1-.909 0l-6.938-3.555-4.231 6.548a1 1 0 0 1-.787.454l-7.785.39-.389 7.785c-.017.32-.186.613-.454.787L2.309 22.5l3.554 6.938a.99.99 0 0 1 0 .908l-3.554 6.938 6.549 4.232c.268.174.437.467.454.787l.389 7.784 7.785.392c.32.016.613.184.787.454l4.231 6.547 6.938-3.554a.999.999 0 0 1 .909 0l6.938 3.554 4.231-6.547a.994.994 0 0 1 .787-.454l7.785-.392.391-7.785a.998.998 0 0 1 .454-.786l6.546-4.232-3.553-6.938a.99.99 0 0 1 0-.908l3.553-6.938-6.546-4.231zM39.858 42.838c-2.793 0-4.982-3.062-4.982-6.972 0-3.909 2.189-6.972 4.982-6.972 2.792 0 4.979 3.063 4.979 6.972 0 3.91-2.187 6.972-4.979 6.972zm0-11.952c-1.62 0-2.99 2.281-2.99 4.98 0 2.7 1.37 4.98 2.99 4.98 1.619 0 2.987-2.28 2.987-4.98 0-2.699-1.368-4.98-2.987-4.98zM26.857 42.157a.997.997 0 1 1-1.889-.63l7.968-23.904a.997.997 0 0 1 1.889.63l-7.968 23.904zm-6.921-11.271c-2.792 0-4.98-3.062-4.98-6.972 0-3.91 2.188-6.972 4.98-6.972 2.793 0 4.98 3.062 4.98 6.972 0 3.91-2.187 6.972-4.98 6.972zm0-11.952c-1.619 0-2.988 2.281-2.988 4.98 0 2.699 1.369 4.98 2.988 4.98 1.62 0 2.988-2.281 2.988-4.98 0-2.699-1.368-4.98-2.988-4.98z","key":1})]);
	}
	
	DiscountStar60px.displayName = "DiscountStar60px";
	
	DiscountStar60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.79 59.78"};
	
	module.exports = DiscountStar60px;
	
	DiscountStar60px.default = DiscountStar60px;


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function DocumentPencil60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M59.869 12.987l.001.005-.001.005-.003 36.269v.01c0 .073-.027.137-.041.205-.013.059-.011.118-.034.175l-.003.006a.008.008 0 0 1-.002.004l-3.974 9.65a.994.994 0 1 1-1.841 0l-3.987-9.659a.993.993 0 0 1 .016-.788V13.367a.815.815 0 0 1-.092-.375c0-.136.034-.268.092-.391v-7.19a.98.98 0 0 1-.092-.409c0-2.753 2.235-4.994 4.983-4.994 2.743 0 4.975 2.241 4.975 4.994 0 .037-.017.068-.021.104.006.042.025.079.025.123l-.001 7.758zM58 5.463a.978.978 0 0 1-.126-.461 2.993 2.993 0 0 0-2.983-2.996c-1.542 0-2.801 1.18-2.959 2.684.033.075.068.149.068.249v6.999h6V5.463zm0 8.477h-6v34.999c0 .078-.033.166-.053.25l2.943 7.131 3.059-7.426c.012-.029.036-.048.051-.076V13.94zM41.833 59.933H2.002a2.014 2.014 0 0 1-2.009-2.014V2.023C-.007.912.894.008 2.002.008H26.89c.022 0 .04.012.062.013.09.006.177.023.262.053.032.011.064.02.095.034a.995.995 0 0 1 .274.185l.013.01 15.789 15.829c.339.161.615.444.615.808v40.999c0 1.103-1.068 1.994-2.167 1.994zM1.985 57.919l40.015.02v-40H27c-.55 0-1-.448-1-.999V2.006H2.002l-.017 55.913zM28 2.939v13h13l-13-13z","key":1})]);
	}
	
	DocumentPencil60px.displayName = "DocumentPencil60px";
	
	DocumentPencil60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.88 59.94"};
	
	module.exports = DocumentPencil60px;
	
	DocumentPencil60px.default = DocumentPencil60px;


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function FagOgLedelse60px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 fag og ledelse"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M26.317 6.814a.5.5 0 0 1 .626-.33c5.212 1.62 8.94 4.812 9.521 10.099l.033.333c.102 1.233.315 1.668 1.306 2.182l.062.031H39a.5.5 0 0 1 .492.41l.008.09v4.157a.5.5 0 0 1-.299.457l-.143.045-.058.009-.067.001-.542-.018c-1.424-.052-2.543.038-3.714.44-3.245 1.12-5.582 1.504-8.623 1.568l-.888.01h-1.754c-4.152.004-6.567-.25-10.159-1.42l-.475-.158-.32-.102c-.952-.284-1.892-.37-3.014-.348l-.923.028-.09-.003-.035-.007-.063-.017a.5.5 0 0 1-.372-.4l-.007-.085v-4.124a.5.5 0 0 1 .41-.492l.09-.008H9.59l.062-.03c.939-.488 1.18-.904 1.29-1.993l.017-.188c.332-4.203 2.683-7.174 6.365-9.143a.5.5 0 1 1 .471.882c-3.301 1.766-5.407 4.353-5.807 7.997l-.033.345c-.135 1.621-.544 2.355-2.027 3.08a.502.502 0 0 1-.144.045l-.075.005h-.754v3.121l.072-.002c1.409-.052 2.555.026 3.75.388l.327.106c3.266 1.103 5.468 1.445 8.803 1.51l.986.012H25.5c3.212-.029 5.524-.375 8.85-1.522 1.206-.415 2.336-.532 3.7-.505l.449.013v-3.154h-.753a.499.499 0 0 1-.15-.022l-.07-.028c-1.418-.694-1.854-1.395-2.008-2.873l-.019-.207c-.418-4.994-3.88-8.014-8.853-9.56a.5.5 0 0 1-.33-.625z","key":0}),React.createElement("path",{"d":"M26.696 4.648a.5.5 0 0 1 .488.391l.012.087.626 14.449a.5.5 0 0 1-.987.132l-.012-.089-.606-13.971h-5.014l-.605 13.971a.5.5 0 0 1-.43.474l-.091.004a.5.5 0 0 1-.474-.431l-.004-.09.627-14.449a.5.5 0 0 1 .412-.47l.087-.008zM35.885 23.625a.5.5 0 0 1 .702.08c.177.222.43.604.68 1.112.735 1.486.946 3.049.287 4.531-.377.85-1.028 1.62-1.973 2.294l-.085.058-.063.304c-.087.403-.201.85-.345 1.333a18.975 18.975 0 0 1-1.712 4.041c-2.138 3.72-5.312 5.974-9.682 5.974s-7.544-2.254-9.682-5.974a18.975 18.975 0 0 1-1.712-4.041 19.079 19.079 0 0 1-.275-1.023l-.133-.611-.046-.03c-1.949-1.345-2.641-3.08-2.338-4.963l.039-.218a.5.5 0 0 1 .98.196c-.329 1.648.243 3.11 2.09 4.297a.5.5 0 0 1 .223.342l.042.227.05.237c.082.38.19.803.326 1.26a17.981 17.981 0 0 0 1.62 3.829c1.975 3.434 4.845 5.472 8.816 5.472s6.84-2.038 8.815-5.472a17.981 17.981 0 0 0 1.62-3.828c.103-.343.189-.667.26-.968l.095-.42.054-.28.01-.057a.5.5 0 0 1 .219-.34c.934-.613 1.543-1.3 1.873-2.044.518-1.166.347-2.438-.269-3.682a6.434 6.434 0 0 0-.397-.694l-.103-.15-.066-.09a.5.5 0 0 1 .08-.702z","key":1})])]);
	}
	
	FagOgLedelse60px.displayName = "FagOgLedelse60px";
	
	FagOgLedelse60px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = FagOgLedelse60px;
	
	FagOgLedelse60px.default = FagOgLedelse60px;


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function GraduationCap60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M55 38.945c-1.654 0-3-1.346-3-2.999 0-1.3.839-2.399 2-2.813V17.662l-10 5.551v18.844c0 .031-.015.058-.018.089a.984.984 0 0 1-.451.849c-.257.161-6.395 3.943-15.531 3.943-9.136 0-15.274-3.782-15.531-3.943a.984.984 0 0 1-.451-.849c-.003-.031-.018-.058-.018-.089V23.213L.515 16.837a.998.998 0 0 1 0-1.746l27-14.988c.3-.167.67-.167.97 0l27 14.988c.318.176.515.51.515.872 0 .018-.013.032-.013.049.001.024.013.043.013.067v17.054c1.161.414 2 1.513 2 2.813a3.003 3.003 0 0 1-3 2.999zm-13 2.621V24.323l-13.515 7.502a.993.993 0 0 1-.485.125.993.993 0 0 1-.485-.125L14 24.323v17.243c1.535.83 6.821 3.373 14 3.373s12.465-2.543 14-3.373zM28 2.12L3.06 15.963 28 29.808l24.94-13.845L28 2.12zm27.287 32.885c-.093.029-.185.058-.287.058-.102 0-.194-.029-.286-.058a.989.989 0 0 0-.714.941 1 1 0 0 0 2 0 .99.99 0 0 0-.713-.941z","key":1})]);
	}
	
	GraduationCap60px.displayName = "GraduationCap60px";
	
	GraduationCap60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 58 46.94"};
	
	module.exports = GraduationCap60px;
	
	GraduationCap60px.default = GraduationCap60px;


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Graph260px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M59 40H1a1 1 0 0 1-1-1V.999a1 1 0 0 1 2 0V38h57a1 1 0 1 1 0 2zm-9.5-28.001a3.456 3.456 0 0 1-1.751-.487l-10.084 9.517c.209.449.335.944.335 1.471 0 1.93-1.57 3.5-3.5 3.5S31 24.43 31 22.5c0-.57.15-1.101.393-1.577l-5.425-5.528-10.325 9.595c.222.459.357.967.357 1.51 0 1.929-1.57 3.5-3.5 3.5S9 28.429 9 26.5s1.57-3.5 3.5-3.5c.659 0 1.269.194 1.796.512l11.023-10.244a1.002 1.002 0 0 1 1.395.031l6.06 6.175a3.452 3.452 0 0 1 1.726-.475c.675 0 1.301.202 1.836.534l10.044-9.48A3.46 3.46 0 0 1 46 8.499a3.503 3.503 0 0 1 3.5-3.498c1.93 0 3.5 1.57 3.5 3.498 0 1.93-1.57 3.5-3.5 3.5zM12.5 25c-.827 0-1.5.673-1.5 1.5a1.501 1.501 0 0 0 3 0c0-.827-.673-1.5-1.5-1.5zm22-4.001c-.827 0-1.5.674-1.5 1.501 0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5-.673-1.501-1.5-1.501zM49.5 7c-.827 0-1.5.673-1.5 1.499a1.501 1.501 0 0 0 3 0C51 7.673 50.327 7 49.5 7z","key":1})]);
	}
	
	Graph260px.displayName = "Graph260px";
	
	Graph260px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 40"};
	
	module.exports = Graph260px;
	
	Graph260px.default = Graph260px;


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function GraphUp60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M59 40H1a1 1 0 0 1-1-1V.999a1 1 0 0 1 2 0V38h57a1 1 0 1 1 0 2zm-7-25a1 1 0 0 1-1-1V8.32L34.687 23.726a.996.996 0 0 1-1.434-.061l-7.375-8.298-13.26 10.419a.995.995 0 0 1-1.404-.169 1 1 0 0 1 .168-1.404l14-10.999a1.001 1.001 0 0 1 1.365.121l7.316 8.23L49.484 7H44a1 1 0 1 1 0-1.999h8l.012.002a.982.982 0 0 1 .272.055c.037.011.077.01.111.025.04.017.071.051.109.073.075.045.151.088.212.15l.011.008c.032.033.044.076.071.113.047.066.097.129.128.205.029.074.035.15.046.228.007.047.028.09.028.14v8a1 1 0 0 1-1 1z","key":1})]);
	}
	
	GraphUp60px.displayName = "GraphUp60px";
	
	GraphUp60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 40"};
	
	module.exports = GraphUp60px;
	
	GraphUp60px.default = GraphUp60px;


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Hammer60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M62.517 17.706l-7.976 8.001a.991.991 0 0 1-1.409 0l-9.265-9.294L28.826 31.5l.79.792c.277.278.366.692.229 1.059l-2.991 8.001c-.05.132-.128.254-.229.355l-16.949 17a.99.99 0 0 1-.705.292.99.99 0 0 1-.704-.292l-7.977-8a1.003 1.003 0 0 1 0-1.414l16.95-17.001c.1-.099.221-.178.354-.229l7.976-3a.993.993 0 0 1 1.055.229l.791.794 15.041-15.087L29.203 1.706a1.002 1.002 0 0 1 .705-1.707h15.953c.264 0 .518.106.704.293l5.278 5.294 1.289-1.293a.993.993 0 0 1 1.409 0 1 1 0 0 1 0 1.414L53.253 7l9.264 9.292a1 1 0 0 1 0 1.414zM25.669 31.162l-7.173 2.698L2.405 49.999l6.566 6.587 16.092-16.14 2.69-7.194-2.084-2.09zM45.448 2H32.315l21.521 21.585L60.403 17 45.448 2z","key":1})]);
	}
	
	Hammer60px.displayName = "Hammer60px";
	
	Hammer60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 62.82 59"};
	
	module.exports = Hammer60px;
	
	Hammer60px.default = Hammer60px;


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Heart60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M55.461 26.643l-.002.004-22.166 24.278c-.873.977-2.056 1.521-3.322 1.521h-.001c-1.266 0-2.448-.544-3.329-1.53L4.485 26.647l-.002-.004c-6.011-6.101-6.002-15.998.03-22.085 6.026-6.078 15.82-6.091 21.869-.047l.008.004 3.581 3.198 3.585-3.198c.002-.001.004-.001.005-.003 6.046-6.044 15.842-6.032 21.87.046 6.028 6.087 6.037 15.984.03 22.085zM54.017 5.985c-5.266-5.309-13.83-5.308-19.092 0-.007.008-.018.01-.026.017-.008.008-.01.018-.019.026l-4.247 3.788c-.053.047-.116.072-.175.106-.038.022-.071.051-.112.068a.983.983 0 0 1-.375.08.999.999 0 0 1-.378-.081c-.038-.015-.068-.043-.104-.063-.062-.035-.127-.061-.181-.11l-4.244-3.788c-.009-.008-.012-.019-.02-.027-.007-.007-.017-.009-.024-.016-5.263-5.308-13.829-5.308-19.093 0a13.597 13.597 0 0 0-3.954 9.632c0 3.639 1.404 7.059 3.954 9.632.006.006.007.014.013.019.004.005.011.007.016.012l22.163 24.277c.504.565 1.159.87 1.852.87.693 0 1.348-.305 1.845-.861L53.988 25.28c.005-.005.011-.007.016-.012.006-.005.007-.013.013-.019 5.26-5.311 5.26-13.953 0-19.264z","key":1})]);
	}
	
	Heart60px.displayName = "Heart60px";
	
	Heart60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.97 52.44"};
	
	module.exports = Heart60px;
	
	Heart60px.default = Heart60px;


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Innovasjon60px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 innovasjon"),React.createElement("g",{"clipRule":"evenodd","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M17.826 34.078a.5.5 0 0 1 .5-.5h11.348a.5.5 0 0 1 .5.5v5.453c0 .852-.664 1.517-1.516 1.517h-9.316a1.498 1.498 0 0 1-1.516-1.517zm1 .5v4.953c0 .3.217.517.516.517h9.316c.3 0 .516-.217.516-.517v-4.953z","key":0}),React.createElement("path",{"d":"M21.51 40.081a.5.5 0 0 1 .5.5c0 1.113.894 2.007 2.007 2.007a2.001 2.001 0 0 0 2.007-2.007.5.5 0 1 1 1 0 3.001 3.001 0 0 1-3.007 3.007 3.001 3.001 0 0 1-3.007-3.007.5.5 0 0 1 .5-.5zM23.483 5.421c-7.08.264-12.753 6.1-12.753 13.244a13.23 13.23 0 0 0 6.365 11.327c1.111.674 1.731 1.895 1.731 3.171v.38h4.657v-7.121c0-.951.95-1.53 1.793-1.213a2.749 2.749 0 0 0 1.145.273c1.08 0 1.94-.86 1.94-1.94 0-1.078-.86-1.938-1.94-1.938-.31 0-.71.106-1.131.268-.89.38-1.807-.298-1.807-1.209V16.7c0-.197-.195-.36-.429-.282a3.742 3.742 0 0 1-1.51.342c-1.631 0-2.939-1.308-2.939-2.94s1.308-2.938 2.939-2.938c.5 0 1.044.162 1.5.338a.3.3 0 0 0 .438-.279zm-4.976 29.123a.5.5 0 0 1-.681-.466v-.915c0-.96-.464-1.84-1.25-2.316A14.23 14.23 0 0 1 9.73 18.665c0-7.864 6.389-14.253 14.253-14.253a.5.5 0 0 1 .5.5v6.03c0 .91-.918 1.587-1.807 1.208-.42-.162-.822-.268-1.132-.268-1.079 0-1.939.86-1.939 1.939s.86 1.939 1.939 1.939a2.75 2.75 0 0 0 1.146-.273c.843-.317 1.793.262 1.793 1.213v3.963a.299.299 0 0 0 .438.279c.456-.175 1-.338 1.5-.338a2.929 2.929 0 0 1 2.94 2.939 2.929 2.929 0 0 1-2.94 2.939 3.742 3.742 0 0 1-1.51-.342c-.233-.079-.428.085-.428.282v7.622a.5.5 0 0 1-.5.5z","key":1}),React.createElement("path",{"d":"M23.517 4.912a.5.5 0 0 1 .5-.5c7.864 0 14.253 6.389 14.253 14.253 0 5.16-2.739 9.69-6.846 12.182-.786.477-1.25 1.357-1.25 2.316v.915a.5.5 0 0 1-.5.5h-5.657a.5.5 0 1 1 0-1h5.157v-.415c0-1.276.62-2.497 1.731-3.171a13.23 13.23 0 0 0 6.365-11.327c0-7.312-5.941-13.253-13.253-13.253a.5.5 0 0 1-.5-.5z","key":2})])]);
	}
	
	Innovasjon60px.displayName = "Innovasjon60px";
	
	Innovasjon60px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = Innovasjon60px;
	
	Innovasjon60px.default = Innovasjon60px;


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function KlimaOgMiljo60px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 klima og miljø"),React.createElement("g",{"clipRule":"evenodd","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M35.253 13.191l-.498-.048-.051-.497a.5.5 0 0 1 .549.545zm-4.697 17.415c-2.395 3.392-5.202 4.766-7.903 4.789-2.676.022-5.153-1.283-6.918-3.066l.71-.703c1.623 1.639 3.854 2.789 6.2 2.769 2.321-.02 4.85-1.186 7.095-4.366.812-1.15 1.509-2.773 2.095-4.592.584-1.812 1.05-3.787 1.409-5.62a80.002 80.002 0 0 0 .947-6.107 89.536 89.536 0 0 0-6.306.986c-1.872.365-3.875.828-5.685 1.397-1.818.571-3.402 1.238-4.463 1.996-2.507 1.807-3.678 3.967-3.959 6.079-.282 2.124.33 4.248 1.475 5.975l-.833.553c-1.259-1.898-1.952-4.262-1.633-6.66.32-2.41 1.656-4.806 4.366-6.76h.001c1.192-.851 2.897-1.556 4.747-2.137 1.858-.584 3.9-1.055 5.793-1.424a90.701 90.701 0 0 1 6.861-1.053l.11-.012.028-.003.01-.001.052.497.498.048-.001.01-.003.028-.01.106-.045.404a80.953 80.953 0 0 1-.97 6.272c-.363 1.855-.837 3.87-1.437 5.733-.598 1.855-1.332 3.59-2.23 4.862z","key":0}),React.createElement("path",{"d":"M19.319 28.376a.5.5 0 0 1 .543-.453l6.74.61a.5.5 0 1 1-.09.995l-6.74-.61a.5.5 0 0 1-.453-.542zM23.653 23.956a.5.5 0 0 1 .526-.472l4.404.237a.5.5 0 1 1-.054.999l-4.404-.238a.5.5 0 0 1-.472-.526z","key":1}),React.createElement("path",{"d":"M29.926 18.108a.5.5 0 0 1 0 .707L13.158 35.583a.5.5 0 0 1-.707-.707l16.767-16.768a.5.5 0 0 1 .708 0zM23.577 18.47a.5.5 0 0 1 .532.467l.135 2.032a.5.5 0 0 1-.998.066l-.135-2.032a.5.5 0 0 1 .466-.532zM18.752 20.437a.5.5 0 0 1 .546.45l.406 4.268a.5.5 0 0 1-.995.095l-.407-4.268a.5.5 0 0 1 .45-.545zM36.28 33.476a.5.5 0 0 1 .5.5v4.14h4.14a.5.5 0 1 1 0 1h-4.64a.5.5 0 0 1-.5-.5v-4.64a.5.5 0 0 1 .5-.5zM6.613 9.417a.5.5 0 0 1 .5-.5h4.607a.5.5 0 0 1 .5.5v4.607a.5.5 0 1 1-1 0V9.917H7.113a.5.5 0 0 1-.5-.5z","key":2}),React.createElement("path",{"d":"M16.3 5.875a19.617 19.617 0 0 1 7.717-1.565c10.879 0 19.707 8.828 19.707 19.707 0 6.013-2.678 11.366-6.917 14.98a.5.5 0 1 1-.649-.76c4.026-3.433 6.566-8.512 6.566-14.22 0-10.327-8.38-18.707-18.707-18.707-2.608 0-5.082.528-7.324 1.484a.5.5 0 1 1-.392-.92zM11.896 9.091a.5.5 0 0 1-.053.705C7.85 13.23 5.31 18.31 5.31 24.017c0 10.326 8.38 18.707 18.707 18.707 2.608 0 5.082-.528 7.324-1.484a.5.5 0 0 1 .392.92 19.617 19.617 0 0 1-7.716 1.564c-10.879 0-19.707-8.828-19.707-19.707 0-6.013 2.677-11.365 6.881-14.98a.5.5 0 0 1 .705.054z","key":3})])]);
	}
	
	KlimaOgMiljo60px.displayName = "KlimaOgMiljo60px";
	
	KlimaOgMiljo60px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = KlimaOgMiljo60px;
	
	KlimaOgMiljo60px.default = KlimaOgMiljo60px;


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Leaf60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M49.419 36.209c-5.94 6.428-14.218 9.686-24.607 9.686h-.002c-4.729 0-9.969-.698-15.568-2.05-6.51 9.075-7.244 15.006-7.256 15.123a.995.995 0 1 1-1.978-.205c.053-.512.869-7.007 7.972-16.693-.16-3.892-.227-21.121 10.182-32.386 5.94-6.429 14.22-9.688 24.611-9.688 4.863 0 10.259.724 16.039 2.154a.995.995 0 0 1 .753.893c.063.839 1.399 20.673-10.146 33.166zm8.198-32.297C40.6-.14 27.712 2.282 19.619 11.041c-8.303 8.986-9.548 22.386-9.659 28.453 4.26-5.286 10.347-11.364 19.01-17.85V11.9c0-.551.451-.999 1-.999.549 0 1 .448 1 .999v8.264c5.416-3.913 11.771-7.961 19.242-12.062a.988.988 0 0 1 1.348.395 1 1 0 0 1-.395 1.355c-12.03 6.604-21.107 13.076-27.984 19.049H40.97c.549 0 1 .448 1 .999 0 .551-.451 1-1 1h-20l-.033-.001c-4.4 4.034-7.802 7.813-10.402 11.204 16.73 3.863 29.425 1.409 37.427-7.251 9.769-10.569 9.778-27.286 9.655-30.94z","key":1})]);
	}
	
	Leaf60px.displayName = "Leaf60px";
	
	Leaf60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.63 59.9"};
	
	module.exports = Leaf60px;
	
	Leaf60px.default = Leaf60px;


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Medal160px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M55.737 12.578c.001.066.011.132-.002.198-.015.081-.054.153-.089.228-.019.042-.024.087-.049.127l-14.21 22.125c-.026.041-.071.058-.102.094a15.994 15.994 0 0 1 2.528 8.626c0 8.818-7.144 15.992-15.924 15.992s-15.923-7.174-15.923-15.992c0-3.075.879-6.042 2.527-8.626-.031-.036-.075-.053-.101-.094L.182 13.131c-.025-.039-.03-.084-.049-.125-.035-.075-.074-.149-.089-.23-.013-.066-.003-.131-.002-.198 0-.062-.009-.123.004-.185.017-.088.059-.168.1-.249.017-.034.021-.072.043-.105l.007-.011.001-.003L7.819.443c.014-.021.04-.031.055-.051A.995.995 0 0 1 8.11.175c.042-.029.077-.062.123-.084a.985.985 0 0 1 .416-.097h38.149c.064 0 .12.025.181.036.043-.007.08-.035.124-.036.346-.026.668.16.857.449l7.621 11.582.002.003.007.011c.021.032.025.069.042.103.041.081.083.162.101.251.012.062.003.123.004.185zm-41.78 31.398c0 7.716 6.25 13.993 13.932 13.993 7.683 0 13.933-6.277 13.933-13.993 0-2.851-.855-5.603-2.473-7.962a13.925 13.925 0 0 0-8.554-5.736 14.546 14.546 0 0 0-2.906-.296c-.971 0-1.953.101-2.916.299a13.919 13.919 0 0 0-8.544 5.734 14.005 14.005 0 0 0-2.472 7.961zm16.191-15.823c.022-.096.044-.193.096-.282l8.125-13.882H17.41l8.125 13.882c.053.092.076.19.098.289a16.61 16.61 0 0 1 4.515-.007zM8.599 2.882l-6.392 9.714 13.525 21.059a15.912 15.912 0 0 1 7.903-5.083L8.599 2.882zm7.652 9.126c.032-.003.061-.019.094-.019H39.54l5.85-9.996H10.389l5.862 10.015zm30.928-9.126L32.146 28.567a15.9 15.9 0 0 1 7.905 5.082l13.521-21.053-6.393-9.714z","key":1})]);
	}
	
	Medal160px.displayName = "Medal160px";
	
	Medal160px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 55.75 59.97"};
	
	module.exports = Medal160px;
	
	Medal160px.default = Medal160px;


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function People60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M60 38.999a1 1 0 0 1-1 1h-3.17l-2.847 15.185a1 1 0 0 1-.983.815h-6a.998.998 0 0 1-.976-.783l-2-9a.999.999 0 1 1 1.952-.434l1.826 8.217h4.368l2.847-15.185c.007-.037.03-.064.04-.099a.969.969 0 0 1 .837-.694c.037-.004.068-.022.106-.022h3v-6.875c0-.022.011-.041.012-.062-.001-.022-.012-.041-.012-.063 0-5.317-2.364-11-9-11a1 1 0 1 1 0-2c6.682 0 11 5.103 11 13 0 .022-.011.041-.013.063.002.021.013.04.013.062v7.875zm-18-28c0-3.86 3.14-7.001 7-7.001s7 3.141 7 7.001c0 3.86-3.14 7-7 7s-7-3.14-7-7zm7 4.999c2.757 0 5-2.242 5-4.999 0-2.757-2.243-5-5-5s-5 2.243-5 5a5.005 5.005 0 0 0 5 4.999zm-6 11.001c0 .022-.011.041-.013.062.002.022.013.041.013.063v11.875a1 1 0 0 1-1 1h-5.095l-1.91 19.099a1 1 0 0 1-.995.901h-8a1 1 0 0 1-.995-.901l-1.91-19.099H18a1 1 0 0 1-1-1V27.124c0-.022.011-.041.012-.063-.001-.021-.012-.04-.012-.062 0-7.168 5.831-13 13-13 7.168 0 13 5.832 13 13zM30 15.998c-6.066 0-11 4.935-11 11.001 0 .022-.011.041-.013.062.002.022.013.041.013.063v10.875h5c.06 0 .112.024.168.034.056.011.112.015.164.033.073.026.134.066.198.107.045.029.091.053.131.088.052.046.09.101.131.156.036.049.074.094.101.15.029.059.041.124.058.19.013.048.039.09.044.142l1.91 19.1h6.19l1.91-19.1c.005-.052.031-.094.044-.143.017-.065.029-.13.058-.189.028-.056.066-.102.103-.152.04-.054.077-.108.127-.153.041-.037.089-.062.136-.092.062-.039.122-.078.193-.103.053-.019.11-.024.166-.034.057-.01.108-.034.168-.034h5V27.124c0-.022.011-.041.013-.063-.002-.021-.013-.04-.013-.062 0-6.066-4.935-11.001-11-11.001zm-7-9C23 3.139 26.14 0 30 0s7 3.139 7 6.998a7.008 7.008 0 0 1-7 7.001c-3.86 0-7-3.14-7-7.001zm7 5.001c2.757 0 5-2.244 5-5.001a5.005 5.005 0 0 0-5-4.999c-2.757 0-5 2.243-5 4.999a5.007 5.007 0 0 0 5 5.001zm-18.998 6c-3.861 0-7.002-3.14-7.002-7s3.141-7.001 7.002-7.001c3.859 0 6.998 3.141 6.998 7.001 0 3.86-3.139 7-6.998 7zm0-12a5.007 5.007 0 0 0-5.002 5 5.006 5.006 0 0 0 5.002 4.999A5.004 5.004 0 0 0 16 10.999c0-2.757-2.242-5-4.998-5zm.998 13a1 1 0 0 1-1 1c-6.636 0-9 5.683-9 11 0 .022-.011.041-.013.063.002.021.013.04.013.062v6.875h3c.038 0 .071.018.108.022a1.012 1.012 0 0 1 .521.219.95.95 0 0 1 .239.29.969.969 0 0 1 .075.185c.01.034.033.062.04.099L8.83 53.999h4.368l1.826-8.217a.999.999 0 1 1 1.952.434l-2 9a1 1 0 0 1-.976.783H8a1 1 0 0 1-.983-.815L4.17 39.999H1a1 1 0 0 1-1-1v-7.875c0-.022.011-.041.012-.062C.011 31.04 0 31.021 0 30.999c0-7.897 4.318-13 11-13a1 1 0 0 1 1 1z","key":1})]);
	}
	
	People60px.displayName = "People60px";
	
	People60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 60"};
	
	module.exports = People60px;
	
	People60px.default = People60px;


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function PiggyBank60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M58.971 40h-3.748c-1.216 3.505-3.698 6.703-7.122 9.126l2.396 6.808a1 1 0 0 1-.591 1.268l-7.264 2.734a1.002 1.002 0 0 1-1.276-.552l-2.476-5.961C37.598 54.07 35.19 55 31.917 55c-3.249 0-5.654-.916-6.957-1.562l-2.237 5.916a1 1 0 0 1-1.287.582l-7.264-2.734a1 1 0 0 1-.591-1.268l2.344-6.661c-4.923-3.404-7.817-8.188-8.134-13.327-5.772-.535-7.631-5.953-7.792-8.891a.999.999 0 0 1 .943-1.053c.546-.048 1.022.391 1.052.944.017.27.45 6.35 5.804 6.99C8.518 23.954 19.044 16 31.917 16c3.589 0 6.301.309 8.674.997 5.213-5.698 12.184-5.025 12.489-4.991a.999.999 0 0 1 .548 1.75c-.029.026-3.156 2.851-3.654 8.698 2.58 2.278 4.347 4.813 5.285 7.546h3.712a1 1 0 0 1 .999 1v8c0 .553-.447 1-.999 1zm-1-8h-3.459a.986.986 0 0 1-.964-.82c-.806-2.741-2.589-5.29-5.304-7.577a1.002 1.002 0 0 1-.295-1.108l.02-.049c.306-3.99 1.692-6.759 2.821-8.397-2.323.247-6.147 1.217-9.11 4.738a.99.99 0 0 1-1.075.306C38.29 18.337 35.61 18 31.917 18c-12.235 0-22.19 7.634-22.19 17.018 0 5.023 2.894 9.766 7.939 13.012a1 1 0 0 1 .402 1.173l-2.276 6.472 5.415 2.038 2.292-6.067c.016-.04.047-.068.067-.105.02-.038.025-.08.051-.116.015-.022.039-.033.056-.053a.944.944 0 0 1 .137-.131c.054-.044.106-.085.167-.117.049-.026.099-.042.152-.059a.935.935 0 0 1 .209-.049c.055-.006.109-.001.165.002a.958.958 0 0 1 .212.035c.024.007.049.002.073.011.04.016.067.046.104.066.037.019.078.025.114.049.026.018 2.684 1.821 6.911 1.821 4.265 0 6.863-1.798 6.889-1.818.031-.022.068-.026.101-.044s.056-.047.091-.061c.029-.012.059-.008.088-.017a.933.933 0 0 1 .2-.04.987.987 0 0 1 .18-.003.97.97 0 0 1 .193.038c.06.018.116.037.171.065a.993.993 0 0 1 .157.104.972.972 0 0 1 .148.139c.019.023.046.036.064.061.021.031.026.067.043.099.019.033.048.057.063.093l2.537 6.107 5.444-2.048-2.22-6.311a.873.873 0 0 1-.094-.149c-.226-.455-.118-.991.306-1.268 3.643-2.373 6.227-5.65 7.274-9.228.006-.02.02-.033.027-.052.024-.066.06-.123.096-.182.033-.052.06-.105.101-.15.044-.048.097-.084.15-.124.05-.037.096-.075.152-.103.056-.027.116-.04.177-.056.067-.018.131-.036.201-.041.019-.001.036-.011.056-.011h3.459v-6zm-15.993-5h3.998v4h-3.998v-4zm-8.369-12.977a.998.998 0 0 1-.809-1.159c.125-.703.182-1.295.182-1.864 0-4.963-4.035-9-8.996-9-4.96 0-8.995 4.037-8.995 9 0 1.786.678 3.812 1.815 5.423a.999.999 0 1 1-1.632 1.154c-1.387-1.964-2.182-4.361-2.182-6.577 0-6.065 4.932-11 10.994-11 6.063 0 10.996 4.935 10.996 11 0 .68-.071 1.404-.214 2.214a.998.998 0 0 1-1.159.809z","key":1})]);
	}
	
	PiggyBank60px.displayName = "PiggyBank60px";
	
	PiggyBank60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.97 60"};
	
	module.exports = PiggyBank60px;
	
	PiggyBank60px.default = PiggyBank60px;


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Samarbeid60px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 samarbeid"),React.createElement("g",{"clipRule":"evenodd","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M22.657 36.878c-.679-.646-1.738-.635-2.368-.004l-1.008 1.008c-.645.677-.635 1.733-.008 2.365.678.646 1.738.634 2.368.003l1.008-1.007c.645-.677.635-1.734.008-2.365zm-3.076-.711c1.03-1.03 2.715-1.02 3.771-.007l.008.007c1.03 1.03 1.02 2.715.007 3.771l-.007.008-1.012 1.011c-1.03 1.03-2.714 1.02-3.77.008l-.008-.008c-1.03-1.03-1.02-2.714-.008-3.77l.007-.008 1.012-1.012.333.333z","key":0}),React.createElement("path",{"d":"M19.621 33.806c-.678-.646-1.738-.634-2.368-.003l-2.562 2.561c-.645.677-.634 1.734-.007 2.365.678.646 1.737.634 2.368.004l2.561-2.562c.645-.677.635-1.733.008-2.365zm-3.075-.71c1.03-1.03 2.714-1.02 3.77-.008l.009.007c1.03 1.031 1.02 2.715.007 3.772l-.007.007-2.566 2.566c-1.03 1.03-2.715 1.02-3.771.007l-.008-.007c-1.03-1.03-1.02-2.715-.007-3.771l.007-.008z","key":1}),React.createElement("path",{"d":"M16.55 30.735c-.678-.646-1.738-.634-2.368-.004l-2.562 2.562c-.656.688-.659 1.74-.012 2.36.679.65 1.74.64 2.372.008l2.562-2.562c.645-.676.635-1.733.008-2.364zm-3.075-.711c1.03-1.03 2.714-1.02 3.77-.007l.008.007c1.03 1.03 1.02 2.715.008 3.771l-.008.008-2.566 2.565c-1.03 1.03-2.714 1.02-3.77.008-1.087-1.041-1.018-2.732-.016-3.779l.008-.007z","key":2}),React.createElement("path",{"d":"M13.515 27.7c-.679-.647-1.738-.635-2.369-.004l-1.802 1.803c-.645.676-.635 1.733-.008 2.364.678.646 1.737.635 2.368.004l1.803-1.803c.645-.677.635-1.733.008-2.365zm-3.076-.711c1.03-1.03 2.715-1.02 3.771-.008l.008.008c1.03 1.03 1.02 2.714.007 3.77l-.007.008-1.807 1.807c-1.03 1.03-2.714 1.02-3.77.007l-.009-.007c-1.03-1.03-1.02-2.715-.007-3.771l.007-.008zM25.58 34.794a.5.5 0 0 1 .707 0l3.938 3.939c.631.63 1.69.642 2.368-.004.629-.632.638-1.692-.01-2.368a.5.5 0 0 1 .721-.692c1.013 1.056 1.023 2.74-.007 3.77l-.008.008c-1.056 1.013-2.74 1.023-3.77-.007l-3.94-3.939a.5.5 0 0 1 0-.707z","key":3}),React.createElement("path",{"d":"M28.651 31.722a.5.5 0 0 1 .707 0l3.94 3.94c.63.63 1.69.641 2.367-.005.627-.63.638-1.687-.007-2.364l-.755-.755a.5.5 0 1 1 .707-.707l.766.766c1.013 1.057 1.023 2.74-.007 3.771l-.008.008c-1.056 1.012-2.74 1.023-3.77-.008l-3.94-3.939a.5.5 0 0 1 0-.707zM28.044 37.208a.5.5 0 0 1 .707.015c1.013 1.056 1.023 2.74-.007 3.77l-.007.008c-1.057 1.012-2.741 1.023-3.772-.007l-1.806-1.807a.5.5 0 1 1 .707-.707l1.807 1.806c.63.631 1.69.643 2.368-.003.628-.633.637-1.692-.012-2.369a.5.5 0 0 1 .015-.706z","key":4}),React.createElement("path",{"d":"M31.723 28.651a.5.5 0 0 1 .707 0l3.18 3.18c.72.72 1.94.64 2.556-.252.43-.65.306-1.578-.264-2.149a.5.5 0 0 1 .707-.707c.874.874 1.111 2.328.388 3.414l-.004.006a2.665 2.665 0 0 1-4.09.395l-3.18-3.18a.5.5 0 0 1 0-.707zM40.48 6.64a.5.5 0 0 1-.06.705l-6.881 5.785L43.7 25.265l2.978-2.497a.5.5 0 1 1 .642.766l-3.36 2.818a.5.5 0 0 1-.705-.062l-10.804-12.9a.5.5 0 0 1 .061-.704l7.263-6.107a.5.5 0 0 1 .705.061zM7.266 6.423a.5.5 0 0 1 .705-.06l7.516 6.323a.5.5 0 0 1 .061.704L4.744 26.29a.5.5 0 0 1-.705.062L.68 23.534a.5.5 0 0 1 .642-.767L4.3 25.264 14.46 13.13 7.327 7.128a.5.5 0 0 1-.06-.705z","key":5}),React.createElement("path",{"d":"M33.141 14.675c.389-.08.653-.182.744-.245l.574.82c-.27.189-.711.322-1.117.405a5.595 5.595 0 0 1-1.314.118h-8.046c-1.07 0-2.105.397-3.296 1.588l-1.41 1.41c-.345.345-.54.798-.54 1.272v5.926c0 .158.102.259.26.259h.758a2.569 2.569 0 0 0 2.572-2.571v-1.518a.5.5 0 0 1 .146-.354c2.508-2.508 6.619-2.508 9.127 0l6.54 6.541 4.275-3.606.644.764-4.625 3.903a.5.5 0 0 1-.676-.029l-6.866-6.866c-2.069-2.069-5.437-2.116-7.565-.14v1.304a3.569 3.569 0 0 1-3.572 3.572h-.759a1.24 1.24 0 0 1-1.259-1.259v-5.926c0-.754.311-1.458.833-1.98l1.41-1.409c1.338-1.339 2.616-1.88 4.003-1.88h8.083a4.59 4.59 0 0 0 1.076-.1zM9.46 28.665l-4.228-3.541.642-.767 4.228 3.541z","key":6}),React.createElement("path",{"d":"M14.209 14.193c.681.533 1.348.544 2.185.544h3.216c.664 0 1.187.234 1.559.453a6.723 6.723 0 0 1 .442.287c.056.038.09.06.113.072l.009.005a.272.272 0 0 0-.065-.017l-.141.99a.845.845 0 0 1-.284-.101 2.512 2.512 0 0 1-.19-.118 15.921 15.921 0 0 1-.08-.055c-.097-.066-.195-.133-.312-.201-.287-.17-.631-.315-1.051-.315h-3.25c-.819 0-1.8 0-2.768-.757z","key":7})])]);
	}
	
	Samarbeid60px.displayName = "Samarbeid60px";
	
	Samarbeid60px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = Samarbeid60px;
	
	Samarbeid60px.default = Samarbeid60px;


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ShackingHands60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M59 39.984h-6.025l.541.776c.045.06 1.493 2.043 1.493 4.353 0 2.542-1.243 4.542-3.411 5.486a5.602 5.602 0 0 1-2.248.485c-1.227 0-2.332-.44-3.283-1.055-.105 1.296-.612 2.837-2.32 3.955C42.716 54.66 41.663 55 40.606 55a5.07 5.07 0 0 1-1.036-.108c-1.491-.312-2.623-1.246-3.32-1.979-.377.771-1.022 1.597-2.265 2.213-1.312.65-2.473.879-3.459.879-2.319 0-3.666-1.275-3.745-1.352a1.029 1.029 0 0 1-.121-.143l-.258-.369c-.507.79-1.251 1.481-2.331 2.085-.979.549-1.917.774-2.788.774-2.523 0-4.493-1.88-5.343-3.197l-6.626-9.062C8.349 43.417 5.336 39.984 3 39.984H1c-.553 0-1-.447-1-.999V9.995a1 1 0 0 1 1-1h7c1.832 0 3.461-.589 5.523-1.336C16.8 6.474 20.878 4.997 28 4.997c.141 0 .275.031.396.084l.379-.391c3.305-3.413 4.542-4.691 7.53-4.691h3.725c6.245 0 8.004 1.182 11.198 3.326l.634.426c5.749 3.83 7.701 5.454 7.781 5.521a.997.997 0 0 1 .357.765v28.948a.999.999 0 0 1-1 .999zM14.204 9.54c-2.157.78-4.021 1.455-6.204 1.455H2v26.99h1c3.766 0 7.515 5.007 7.93 5.579l6.659 9.108c.267.407 2.429 3.532 5.506 1.81 1.478-.827 1.846-1.582 1.991-2.219l-7.253-10.358a1 1 0 1 1 1.639-1.146l8.758 12.507c.323.262 2.035 1.468 4.869.067 1.255-.62 1.484-1.483 1.706-2.318L26.66 39.384a1 1 0 1 1 1.639-1.146l8.825 12.604c.255.386 2.44 3.494 5.526 1.47 1.564-1.024 1.522-2.586 1.36-3.969l-.02-.179a9.14 9.14 0 0 1-.74-1.02l-7.743-10.251a1 1 0 1 1 1.596-1.205l7.775 10.294a.89.89 0 0 1 .061.09c.102.168 2.538 4.145 5.86 2.694 1.826-.795 2.21-2.426 2.21-3.653 0-1.632-1.107-3.172-1.117-3.186l-1.498-2.147a.995.995 0 0 1-.35-.501l-15.24-21.838a44.745 44.745 0 0 1-6.166 3.537c-6.056 2.877-9.367 2.192-11.076 1.113C15.934 21.061 15 19.204 15 16.993c0-1.397 1.227-2.156 3.084-3.307 1.833-1.136 4.603-2.852 7.847-6.094.199-.199.362-.367.549-.556-5.83.195-9.393 1.46-12.276 2.504zM58 10.519c-.785-.613-2.942-2.237-7.247-5.105l-.641-.429c-3.053-2.051-4.447-2.986-10.082-2.986h-3.725c-2.075 0-2.766.646-6.092 4.082-.8.826-1.737 1.795-2.868 2.924-3.408 3.407-6.296 5.196-8.207 6.38-.903.559-2.138 1.324-2.138 1.608 0 .888.212 2.511 1.631 3.406 1.815 1.149 5.065.714 9.147-1.228 4.069-1.932 6.624-3.905 6.65-3.925a1.004 1.004 0 0 1 1.434.218l15.717 22.521H58V10.519z","key":1})]);
	}
	
	ShackingHands60px.displayName = "ShackingHands60px";
	
	ShackingHands60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 57"};
	
	module.exports = ShackingHands60px;
	
	ShackingHands60px.default = ShackingHands60px;


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function SoccerShoe60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M55.035 24.999h-5.139v2a.998.998 0 1 1-1.997 0v-2h-5.991v2a.998.998 0 1 1-1.997 0v-2H33.92v2a.999.999 0 1 1-1.997 0v-2H16.945v2a.998.998 0 1 1-1.997 0v-2H8.957v2a.999.999 0 1 1-1.997 0v-2h-.05c-2.329 0-4.009-.558-5.138-1.707-1.893-1.928-1.842-5.081-1.78-8.732.011-.668.022-1.356.022-2.06C.014 6.733 1.792-.001 6.8-.001c2.212 0 3.362 1.038 4.378 1.953C12.347 3.005 13.45 4 16.444 4c3.266 0 4.747-1.229 6.055-2.313 1-.828 2.035-1.688 3.591-1.688 1.728 0 3.05 1.071 4.724 2.426 1.826 1.476 4.098 3.315 8.014 4.936 1.961.812 4.23 1.629 6.633 2.492 8.973 3.227 14.421 5.402 14.421 8.396 0 3.008 0 6.75-4.847 6.75zM29.559 3.98c-1.473-1.193-2.447-1.981-3.469-1.981-.8 0-1.345.422-2.318 1.229C22.361 4.398 20.429 6 16.444 6c-3.759 0-5.336-1.42-6.602-2.562-.927-.835-1.597-1.439-3.042-1.439-3.29 0-4.789 5.444-4.789 10.501 0 .715-.011 1.415-.022 2.093-.054 3.202-.099 5.966 1.207 7.297.733.746 1.948 1.11 3.714 1.11h12.195L31.011 5.13a72.551 72.551 0 0 1-1.452-1.15zm3.075 2.317L21.506 23h5.316l9.649-14.502a29.696 29.696 0 0 1-3.837-2.201zm5.695 3.015L29.222 23h5.316l8.033-12.07a119.817 119.817 0 0 1-4.242-1.618zm6.457 2.424l-.283-.103L36.938 23h18.097c2.495 0 2.85-1.013 2.85-4.751 0-1.803-8.2-4.751-13.099-6.513z","key":1})]);
	}
	
	SoccerShoe60px.displayName = "SoccerShoe60px";
	
	SoccerShoe60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.88 28"};
	
	module.exports = SoccerShoe60px;
	
	SoccerShoe60px.default = SoccerShoe60px;


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0160px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm-.288-18h1.692V18.6H29.82l-4.428 2.628.432 1.368 3.816-2.232h.072V42z"}));
	}
	
	StepCircle0160px.displayName = "StepCircle0160px";
	
	StepCircle0160px.defaultProps = {"viewBox":"0 0 60 60"};
	
	module.exports = StepCircle0160px;
	
	StepCircle0160px.default = StepCircle0160px;


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0260px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm6.804-18v-1.44h-11.52v-.072l1.656-1.728c5.868-5.796 9.216-9.504 9.216-14.112 0-2.772-1.656-6.444-6.516-6.444-2.412 0-4.464.972-5.976 2.34l.684 1.188c1.008-.864 2.736-2.016 4.968-2.016 3.96 0 5.076 2.628 5.076 5.292 0 4.032-2.844 7.344-9.36 13.716l-2.16 2.232V42h13.932z"}));
	}
	
	StepCircle0260px.displayName = "StepCircle0260px";
	
	StepCircle0260px.defaultProps = {"viewBox":"0 0 60 60"};
	
	module.exports = StepCircle0260px;
	
	StepCircle0260px.default = StepCircle0260px;


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0360px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm-7.164-19.188c1.008.756 3.132 1.584 5.508 1.584 5.4 0 7.92-3.456 7.92-6.948 0-3.384-2.376-5.616-5.292-6.192v-.072c2.808-1.08 4.356-3.168 4.356-5.544 0-2.664-1.692-5.436-6.12-5.436-2.196 0-4.32.936-5.436 1.836l.684 1.26c1.044-.792 2.736-1.62 4.536-1.62 3.312 0 4.536 2.016 4.536 4.176 0 3.24-3.276 4.716-5.868 4.716h-1.548v1.44h1.476c3.456 0 6.84 1.584 6.876 5.508.036 2.088-1.116 5.4-5.904 5.4-2.232 0-4.212-.864-5.04-1.476l-.684 1.368z"}));
	}
	
	StepCircle0360px.displayName = "StepCircle0360px";
	
	StepCircle0360px.defaultProps = {"viewBox":"0 0 60 60"};
	
	module.exports = StepCircle0360px;
	
	StepCircle0360px.default = StepCircle0360px;


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0460px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm4.392-18h-1.656v-6.876h-11.16v-1.152L32.988 18.6h1.404v15.084h3.564v1.44h-3.564V42zm-10.764-8.316h9.108v-9.468c0-1.116.036-2.196.108-3.24l-.108-.036a27.69 27.69 0 0 1-1.836 2.952l-7.272 9.72v.072z"}));
	}
	
	StepCircle0460px.displayName = "StepCircle0460px";
	
	StepCircle0460px.defaultProps = {"viewBox":"0 0 60 60"};
	
	module.exports = StepCircle0460px;
	
	StepCircle0460px.default = StepCircle0460px;


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0560px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm5.832-41.4H25.68l-1.512 10.584c.828-.144 1.944-.252 3.348-.252 4.644 0 6.732 2.556 6.768 5.94.036 3.528-2.664 6.048-6.048 6.048-2.16 0-3.924-.792-4.824-1.404l-.684 1.368c1.008.756 2.988 1.512 5.4 1.512 4.32 0 7.884-3.132 7.884-7.848 0-3.096-1.8-5.184-3.636-6.084-1.368-.684-2.808-1.008-4.356-1.008-1.044 0-1.62.072-2.16.18l1.152-7.524h8.82V18.6z"}));
	}
	
	StepCircle0560px.displayName = "StepCircle0560px";
	
	StepCircle0560px.defaultProps = {"viewBox":"0 0 60 60"};
	
	module.exports = StepCircle0560px;
	
	StepCircle0560px.default = StepCircle0560px;


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0660px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm5.256-41.796v1.584c-.684 0-1.548.036-2.52.252-5.04 1.044-7.92 5.364-8.388 9.972h.072c1.08-1.728 3.204-3.276 6.048-3.276 4.284 0 6.984 3.168 6.984 7.524 0 4.068-2.556 8.136-7.308 8.136-4.212 0-7.596-3.42-7.596-9.828 0-4.716 1.656-8.352 3.816-10.62 1.692-1.764 4.032-2.988 6.552-3.456a10.049 10.049 0 0 1 2.34-.288zm-5.004 22.752h.036c3.168 0 5.364-2.592 5.364-6.552 0-4.104-2.376-6.192-5.616-6.192-2.196 0-4.284 1.332-5.364 3.384-.216.396-.396.864-.396 1.368 0 4.716 2.124 7.992 5.976 7.992z"}));
	}
	
	StepCircle0660px.displayName = "StepCircle0660px";
	
	StepCircle0660px.defaultProps = {"viewBox":"0 0 60 60"};
	
	module.exports = StepCircle0660px;
	
	StepCircle0660px.default = StepCircle0660px;


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0760px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm-6.552-41.4v1.44h11.88v.072L24.888 42h1.692l10.548-22.176V18.6h-13.68z"}));
	}
	
	StepCircle0760px.displayName = "StepCircle0760px";
	
	StepCircle0760px.defaultProps = {"viewBox":"0 0 60 60"};
	
	module.exports = StepCircle0760px;
	
	StepCircle0760px.default = StepCircle0760px;


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0860px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm.216-41.796h.036c3.924 0 6.228 2.628 6.228 5.616 0 1.944-.936 4.176-4.14 5.616v.144c3.312 1.296 4.968 3.492 4.968 6.192 0 3.96-3.456 6.624-7.344 6.624-4.176 0-7.308-2.664-7.308-6.228 0-3.024 1.872-5.22 4.896-6.516v-.144c-2.844-1.224-3.96-3.276-3.96-5.292 0-3.528 2.88-6.012 6.624-6.012zm-.288 22.752h.036c3.42 0 5.58-2.088 5.58-4.932 0-3.312-2.232-4.788-6.012-5.868-3.312.972-5.076 3.096-5.076 5.652-.144 2.772 1.944 5.148 5.472 5.148zm.18-21.348h-.036c-3.096 0-4.788 2.016-4.788 4.356-.036 2.808 1.98 4.212 5.148 5.004 2.484-.864 4.284-2.448 4.284-5.004 0-2.124-1.296-4.356-4.608-4.356z"}));
	}
	
	StepCircle0860px.displayName = "StepCircle0860px";
	
	StepCircle0860px.defaultProps = {"viewBox":"0 0 60 60"};
	
	module.exports = StepCircle0860px;
	
	StepCircle0860px.default = StepCircle0860px;


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle0960px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm-5.184-17.604v-1.584c.684.072 1.584 0 2.664-.18 1.908-.288 3.672-1.224 5.076-2.736 1.548-1.656 2.736-4.032 3.168-7.416l-.108.036c-1.476 1.908-3.528 3.024-6.048 3.024-4.356 0-6.66-3.42-6.66-7.092 0-4.32 2.952-8.244 7.488-8.244 4.032 0 7.056 3.42 7.056 9.756 0 5.292-1.836 8.928-3.996 11.088-1.512 1.584-3.636 2.664-5.472 3.024-1.26.252-2.376.36-3.168.324zm5.292-22.752h-.036c-3.204 0-5.436 2.844-5.436 6.696 0 3.456 2.16 5.724 5.256 5.724 2.484 0 4.536-1.296 5.544-3.024.144-.288.324-.612.324-1.044 0-4.932-1.836-8.352-5.652-8.352z"}));
	}
	
	StepCircle0960px.displayName = "StepCircle0960px";
	
	StepCircle0960px.defaultProps = {"viewBox":"0 0 60 60"};
	
	module.exports = StepCircle0960px;
	
	StepCircle0960px.default = StepCircle0960px;


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function StepCircle1060px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm-7.222-18h1.692V18.6h-1.584l-4.428 2.628.432 1.368 3.816-2.232h.072V42zm13.94.396h-.036c-3.672 0-7.056-3.6-7.164-11.988 0-8.496 3.744-12.204 7.668-12.204 4.104 0 7.164 3.708 7.164 11.772 0 8.388-3.024 12.42-7.632 12.42zm.144-1.44h.036c3.888 0 5.652-4.428 5.652-10.8 0-6.12-1.656-10.512-5.616-10.512-3.384 0-5.616 4.32-5.616 10.512-.108 6.516 2.124 10.8 5.544 10.8z"}));
	}
	
	StepCircle1060px.displayName = "StepCircle1060px";
	
	StepCircle1060px.defaultProps = {"viewBox":"0 0 60 60"};
	
	module.exports = StepCircle1060px;
	
	StepCircle1060px.default = StepCircle1060px;


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Stethoscope60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M52 41.942v3.912c0 8.856-6.707 14.145-17.94 14.145-9.457 0-16.06-7.365-16.06-17.91 0-.019.01-.035.011-.054-.001-.018-.011-.034-.011-.053v-4.049C5.546 36.52 0 9.056 0 5.2 0 .525 6.65.027 6.934.007c.56-.008 1.026.38 1.063.93a1.004 1.004 0 0 1-.929 1.067C7.018 2.007 2 2.388 2 5.2c0 3.429 5.674 30.801 17 30.801S36 8.629 36 5.2c0-2.78-5.016-3.193-5.066-3.196a1.003 1.003 0 0 1-.932-1.065c.037-.551.526-.94 1.064-.932C31.35.027 38 .525 38 5.2c0 3.856-5.546 31.319-18 32.733v4.049c0 .019-.01.035-.011.053.001.019.011.035.011.054C20 51.457 25.781 58 34.06 58 38.852 58 50 56.815 50 45.854v-3.912c-4.493-.499-8-4.316-8-8.94 0-4.962 4.037-8.999 8.999-8.999 4.963 0 9.001 4.037 9.001 8.999 0 4.624-3.507 8.44-8 8.94zm-1.001-15.94c-3.859 0-6.999 3.141-6.999 7a7.007 7.007 0 0 0 6.999 6.999c3.86 0 7.001-3.14 7.001-6.999 0-3.859-3.141-7-7.001-7z","key":1})]);
	}
	
	Stethoscope60px.displayName = "Stethoscope60px";
	
	Stethoscope60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 60"};
	
	module.exports = Stethoscope60px;
	
	Stethoscope60px.default = Stethoscope60px;


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Strategien60px (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 strategien"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M47.603 22.138v1.07l-10.38 18.797H35.73l10.286-18.583v-.062h-9.08v-1.222zM.397 29.198v-.917l1.905-1.895c5.746-5.41 8.254-8.19 8.254-11.614 0-2.262-.984-4.493-4.476-4.493-1.969 0-3.493.978-4.381 1.712l-.604-1.009a7.978 7.978 0 0 1 5.27-1.987c4.286 0 5.746 3.118 5.746 5.471 0 3.913-2.952 7.06-8.127 11.982l-1.46 1.436v.061h10.159v1.253zM31.096 22.138H25.19V9.332h-1.238l-10.064 13.05v.978h9.841v5.838h1.46v-5.837h5.874l.38-.612zM23.73 14.1v8.038H15.7v-.061l6.444-8.252c.476-.703.953-1.376 1.587-2.507l.096.03a38.51 38.51 0 0 0-.096 2.752z","key":0}),React.createElement("path",{"d":"M30.746 29.229a.956.956 0 0 1-.285-.061c-.254-.153-.35-.49-.191-.734l3.524-5.685-3.524-5.685c-.159-.244-.063-.58.19-.733a.578.578 0 0 1 .762.183l3.683 5.96a.566.566 0 0 1 0 .55l-3.683 5.96c-.127.153-.285.245-.476.245zM47.603 22.138v1.07l-10.38 18.797H35.73l10.286-18.583v-.062h-9.08v-1.222zM.397 29.198v-.917l1.905-1.895c5.746-5.41 8.254-8.19 8.254-11.614 0-2.262-.984-4.493-4.476-4.493-1.969 0-3.493.978-4.381 1.712l-.604-1.009a7.978 7.978 0 0 1 5.27-1.987c4.286 0 5.746 3.118 5.746 5.471 0 3.913-2.952 7.06-8.127 11.982l-1.46 1.436v.061h10.159v1.253z","key":1}),React.createElement("path",{"d":"M31.096 22.138H25.19V9.332h-1.238l-10.064 13.05v.978h9.841v5.838h1.46v-5.837h5.874l.38-.612zM23.73 14.1v8.038H15.7v-.061l6.444-8.252c.476-.703.953-1.376 1.587-2.507l.096.03a38.51 38.51 0 0 0-.096 2.752z","key":2}),React.createElement("path",{"d":"M30.746 29.229a.956.956 0 0 1-.285-.061c-.254-.153-.35-.49-.191-.734l3.524-5.685-3.524-5.685c-.159-.244-.063-.58.19-.733a.578.578 0 0 1 .762.183l3.683 5.96a.566.566 0 0 1 0 .55l-3.683 5.96c-.127.153-.285.245-.476.245z","key":3})])]);
	}
	
	Strategien60px.displayName = "Strategien60px";
	
	Strategien60px.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = Strategien60px;
	
	Strategien60px.default = Strategien60px;


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Sun60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M59 30.999H47A1 1 0 1 1 47 29h12a1 1 0 1 1 0 1.999zM44.707 16.207a.996.996 0 0 1-.707.292 1 1 0 0 1-.707-1.707l8-8a1 1 0 0 1 1.414 1.414l-8 8.001zM30 40.498c-6.065 0-11-4.935-11-10.998 0-6.066 4.935-11.001 11-11.001S41 23.434 41 29.5c0 6.063-4.935 10.998-11 10.998zM30 20.5c-4.963 0-9 4.036-9 9 0 4.961 4.037 8.999 9 8.999s9-4.038 9-8.999c0-4.964-4.037-9-9-9zm0-7.5a1 1 0 0 1-1-1.001v-11a1 1 0 1 1 2 0v11A1 1 0 0 1 30 13zM8.707 52.207a.996.996 0 0 1-.707.292 1 1 0 0 1-.707-1.707l8-8a.999.999 0 1 1 1.414 1.414l-8 8.001zM16 16.499a.996.996 0 0 1-.707-.292l-8-8.001a.999.999 0 1 1 1.414-1.414l8 8A1 1 0 0 1 16 16.499zm-2 13.5a1 1 0 0 1-1 1H1A1 1 0 1 1 1 29h12c.553 0 1 .446 1 .999zm16 16a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0v-12a1 1 0 0 1 1-1zm14.707-3.207l8 8a1 1 0 1 1-1.414 1.415l-8-8.001a.999.999 0 1 1 1.414-1.414z","key":1})]);
	}
	
	Sun60px.displayName = "Sun60px";
	
	Sun60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 60"};
	
	module.exports = Sun60px;
	
	Sun60px.default = Sun60px;


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Supercar60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M57 35.568V39a1 1 0 0 1-1 .999H44A1 1 0 0 1 43 39v-3.001H17V39a1 1 0 0 1-1 .999H4A1 1 0 0 1 3 39v-3.432c-1.708-.74-3-2.367-3-4.291v-8.238c0-4.897 3.107-8.78 8.049-10.285.011-.044.008-.089.025-.133l3.348-8.216C12.942 1.357 22.111-.001 30-.001c7.092 0 18.22 1.155 19.809 4.337.015.03.029.062.042.095l3.085 8.217a.972.972 0 0 1 .04.491c4.356 1.746 7.024 5.406 7.024 9.9v8.238c0 1.924-1.292 3.551-3 4.291zM45 38h10v-2.001h-7.126c-.073.017-.143.045-.223.045-.211 0-.418-.021-.624-.045H45V38zm-1.949-3.956c-1.62-1.417-2.672-3.128-2.885-3.49A3.966 3.966 0 0 0 37 29H23a3.966 3.966 0 0 0-3.166 1.554c-.213.362-1.265 2.073-2.885 3.49h26.102zM5 38h10v-2.001h-2.028a5.358 5.358 0 0 1-.624.045c-.079 0-.149-.028-.223-.045H5V38zM48.001 5.195C47.233 3.879 39.928 2 30 2c-9.881 0-16.081 1.875-16.758 3.23l-2.861 7.028C12.746 11.984 21.834 11 30.002 11c9.41 0 20.053 1.308 20.159 1.321.192.036.375.084.563.126l-2.723-7.252zM58 23.039c0-4.388-3.197-7.819-8.146-8.743-.044-.003-10.568-1.297-19.852-1.297-9.285 0-19.812 1.294-19.918 1.306C5.193 15.175 2 18.607 2 23.039v8.238c0 1.374.987 2.508 2.274 2.722h8.593c2.912-.446 5.24-4.453 5.264-4.495a.904.904 0 0 1 .069-.105 5.95 5.95 0 0 1 4.8-2.4h14a5.95 5.95 0 0 1 4.8 2.4.904.904 0 0 1 .069.105c.024.042 2.352 4.049 5.263 4.495h8.593C57.012 33.785 58 32.651 58 31.277v-8.238zm-3.684-.091l-6 2a.996.996 0 0 1-1.264-.632 1 1 0 0 1 .632-1.265l6-2.001a1 1 0 1 1 .632 1.898zM12 25a1 1 0 0 1-.316-.052l-6-2a1 1 0 0 1 .632-1.898l6 2.001A1 1 0 0 1 12 25z","key":1})]);
	}
	
	Supercar60px.displayName = "Supercar60px";
	
	Supercar60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 40"};
	
	module.exports = Supercar60px;
	
	Supercar60px.default = Supercar60px;


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Tractor60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M57.856 39.164a.998.998 0 0 1-.984.835h-2.369A8.994 8.994 0 0 1 57.851 47c0 4.962-4.028 9-8.978 9-4.949 0-8.976-4.038-8.976-9a8.997 8.997 0 0 1 3.347-7.001H31.521c.126.637.226 1.284.293 1.943.07.727.104 1.399.104 2.058a1 1 0 0 1-.997 1 1 1 0 0 1-.998-1c0-.594-.031-1.203-.094-1.861C28.896 32.94 21.315 26 12.194 26a17.38 17.38 0 0 0-10.593 3.573.996.996 0 0 1-1.397-.193 1 1 0 0 1 .193-1.401 19.381 19.381 0 0 1 7.632-3.52.873.873 0 0 1-.149-.46v-23C7.88.447 8.427 0 8.978 0h19.948c.397 0 .757.236.915.6l9.843 22.7 7.195 1.048v-6.115c0-2.886 2.238-5.234 4.987-5.234.552 0 .998.448.998 1 0 .553-.446 1-.998 1-1.65 0-2.992 1.451-2.992 3.234v6.406l10.117 1.474a.995.995 0 0 1 .841 1.154l-1.976 11.897zM41.892 47c0 3.86 3.132 7 6.981 7 3.85 0 6.983-3.14 6.983-7s-3.133-7.001-6.983-7.001c-3.849 0-6.981 3.141-6.981 7.001zM28.272 2H9.88v20.999h27.499L28.272 2zm9.208 22.999H18.374c6.002 1.996 10.749 6.826 12.646 13.033.054-.009.104-.032.161-.032h24.845l1.671-10.055-20.217-2.946zm-24.513 5c7.15 0 12.966 5.833 12.966 13C25.933 50.168 20.117 56 12.967 56 5.818 56 .001 50.168.001 42.999c0-7.167 5.817-13 12.966-13zm0 24.001c6.049 0 10.971-4.935 10.971-11.001 0-6.065-4.922-11-10.971-11s-10.971 4.935-10.971 11C1.996 49.065 6.918 54 12.967 54z","key":1})]);
	}
	
	Tractor60px.displayName = "Tractor60px";
	
	Tractor60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.82 56"};
	
	module.exports = Tractor60px;
	
	Tractor60px.default = Tractor60px;


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function UmbrellaOpen60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M60 26.846C60 28.455 58.551 30 57 30H31v20.19c0 4.845-4.143 8.789-9.234 8.789-5.079 0-8.766-3.593-8.766-8.54a.999.999 0 1 1 2 0c0 3.791 2.846 6.544 6.766 6.544 3.989 0 7.234-3.048 7.234-6.793V30H3c-1.579 0-3-1.493-3-3.106C0 13.274 14.424 6.006 29 5.687V.974a1 1 0 1 1 2 0v4.713c14.575.318 29 7.569 29 21.159zM30 7.669c-13.914 0-28 6.604-28 19.225C2 27.348 2.49 28 3 28h26.625a.996.996 0 0 1 .375-.076c.133 0 .259.029.375.076H57c.487 0 1-.694 1-1.154C58 14.257 43.914 7.669 30 7.669z","key":1})]);
	}
	
	UmbrellaOpen60px.displayName = "UmbrellaOpen60px";
	
	UmbrellaOpen60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 59"};
	
	module.exports = UmbrellaOpen60px;
	
	UmbrellaOpen60px.default = UmbrellaOpen60px;


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoAnlegg60px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M30 56a1 1 0 0 1-1-1v-8a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1zm29.8-3.4a1 1 0 0 1-.8.4l-.6-.2L37.7 38H31v3a1 1 0 0 1-2 0v-3h-6.7L1.6 52.8a1 1 0 1 1-1.2-1.6L4 48.6V32a26 26 0 0 1 52 0v16.6l3.6 2.6a1 1 0 0 1 .2 1.4zM37 32a7 7 0 0 0-14 0v4h14zm17 0a24 24 0 0 0-48 0v15.2l15-10.7V32a9 9 0 0 1 18 0v4.5l15 10.7z"}));
	}
	
	VoAnlegg60px.displayName = "VoAnlegg60px";
	
	VoAnlegg60px.defaultProps = {"viewBox":"0 0 60 60"};
	
	module.exports = VoAnlegg60px;
	
	VoAnlegg60px.default = VoAnlegg60px;


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoBygg60px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M17 46a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2zm43-13v8a1 1 0 0 1-1 1H47a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h5V16H18.2l4.7 42H27a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2h4.1l4.7-42H1a1 1 0 0 1-.4-1.9l14.1-6.6.3-2.6a1 1 0 0 1 2 0l.3 2.3L53.2 14h.6v.2h.1V32h5a1 1 0 0 1 1.1 1zM14 14l.5-4.2-9 4.2zm2.2 2h-.4l-4.7 42h9.8zm26.1-2L17.5 9.3 18 14zM58 34H48v6h10zm-43 0a1 1 0 1 0 1-1 1 1 0 0 0-1 1z"}));
	}
	
	VoBygg60px.displayName = "VoBygg60px";
	
	VoBygg60px.defaultProps = {"viewBox":"0 0 60 60"};
	
	module.exports = VoBygg60px;
	
	VoBygg60px.default = VoBygg60px;


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoEiendom60px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M59.473 33.663a.992.992 0 0 1-1.408-.07l-4.155-4.595v28.901c0 1.101-.982 1.985-2.081 1.985H7.988c-1.098 0-2.078-.884-2.078-1.985V28.995l-4.158 4.598a.998.998 0 1 1-1.477-1.341L5.91 26.02v-.121c0-.386.267-.513.613-.557L29.17.298c.378-.417 1.1-.417 1.477 0l22.647 25.044c.347.044.616.17.616.557v.124l5.633 6.229a1.001 1.001 0 0 1-.07 1.411zm-7.563-6.877L29.909 2.456 7.902 26.792c.003.036.008.075.008.107v31h44V26.786zm-27.98 1.145c2.55 0 4.762 1.427 5.979 3.529 1.216-2.102 3.428-3.529 5.978-3.529 3.845 0 6.975 3.211 6.975 7.156 0 1.845-.817 3.789-2.184 5.201l-10.093 9.346c-.06.055-.131.086-.199.124-.035.019-.065.048-.102.063a.998.998 0 0 1-.375.077.994.994 0 0 1-.375-.077c-.037-.015-.067-.044-.103-.063-.068-.038-.139-.069-.199-.124l-10.054-9.308c-1.406-1.45-2.223-3.394-2.223-5.239 0-3.945 3.13-7.156 6.975-7.156zm-3.36 10.967l9.339 8.643 9.378-8.681c.961-.995 1.582-2.455 1.582-3.773 0-2.844-2.235-5.16-4.982-5.16-2.747 0-4.982 2.316-4.982 5.16 0 .552-.446 1-.996 1a.998.998 0 0 1-.997-1c0-2.844-2.235-5.16-4.982-5.16-2.747 0-4.982 2.316-4.982 5.16 0 1.318.621 2.778 1.622 3.811z"}));
	}
	
	VoEiendom60px.displayName = "VoEiendom60px";
	
	VoEiendom60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.82 59.9"};
	
	module.exports = VoEiendom60px;
	
	VoEiendom60px.default = VoEiendom60px;


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoEnergi60px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M25 56h-.3a1 1 0 0 1-.7-1l1.9-20H15a1 1 0 0 1-.8-1.6l20-29a1 1 0 0 1 1.8.7L34.1 25H45a1 1 0 0 1 .8 1.6l-20 29a1 1 0 0 1-.8.4zm-8.1-23H27a1 1 0 0 1 1 1.1l-1.6 17.2L43.1 27H33a1 1 0 0 1-1-1.1l1.6-17.2z"}));
	}
	
	VoEnergi60px.displayName = "VoEnergi60px";
	
	VoEnergi60px.defaultProps = {"viewBox":"0 0 60 60"};
	
	module.exports = VoEnergi60px;
	
	VoEnergi60px.default = VoEnergi60px;


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoMiljo60px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M59.7 51.511a.998.998 0 0 1-.873.516h-.002l-24.511-.057 4.287 4.324A1 1 0 0 1 37.894 58a.984.984 0 0 1-.706-.296l-5.982-6.032a1.003 1.003 0 0 1-.215-.324.999.999 0 0 1-.065-.323c-.001-.021-.012-.04-.012-.062v-.001a1.013 1.013 0 0 1 .293-.706l.001-.001 5.983-5.964a.993.993 0 0 1 1.41.004 1 1 0 0 1-.004 1.414l-4.275 4.261 22.699.053-11.497-18.366a.997.997 0 1 1 1.688-1.065l12.459 19.903c.194.309.204.698.029 1.016zM43.812 25.268a.996.996 0 0 1-.164.305c-.016.022-.039.037-.058.058a.975.975 0 0 1-.215.18c-.014.009-.023.024-.039.032-.016.009-.034.006-.051.013a.97.97 0 0 1-.421.108l-.002.001v-.001l-.001.001a.955.955 0 0 1-.282-.042l-7.932-2.349a1.001 1.001 0 0 1-.674-1.243.996.996 0 0 1 1.238-.675l5.631 1.668L29.891 3.049 19.194 21.686a.996.996 0 0 1-1.362.368 1.002 1.002 0 0 1-.365-1.366L29.054.501c.179-.314.511-.495.876-.502a.999.999 0 0 1 .863.524l11.829 21.899 1.797-5.664a.993.993 0 0 1 1.253-.648 1 1 0 0 1 .647 1.256l-2.507 7.902zm-26.17 11.658a.997.997 0 0 1-1.239-.676l-1.726-5.828L2.762 50h22.172c.551 0 .996.447.996 1a.996.996 0 0 1-.996.999H1.008a.981.981 0 0 1-.946-.748.9.9 0 0 1-.028-.137C.029 51.075.011 51.04.011 51c0-.026.013-.047.015-.073a.948.948 0 0 1 .056-.28c.007-.019.012-.038.02-.056.02-.049.025-.101.054-.148l12.635-20.762-5.515 1.646a.993.993 0 0 1-1.239-.673.999.999 0 0 1 .671-1.243l8.002-2.388c.007-.002.014 0 .021-.002.074-.021.149-.019.226-.022.055-.003.108-.015.162-.008.063.008.122.038.183.058.056.019.115.024.168.053.007.004.011.011.019.016.008.004.017.004.025.009.049.03.08.076.122.113.051.044.106.082.146.136.044.057.068.122.098.185.022.047.056.086.071.135l2.363 7.987a1 1 0 0 1-.672 1.243z"}));
	}
	
	VoMiljo60px.displayName = "VoMiljo60px";
	
	VoMiljo60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.82 58"};
	
	module.exports = VoMiljo60px;
	
	VoMiljo60px.default = VoMiljo60px;


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function VoOffshore60px (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M59 58H49a11.8 11.8 0 0 1-3-.5V48h5a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H40.9l16.7-13.2a1 1 0 0 0-1-1.7L33.4 35.7 30 6.9a1 1 0 0 0-1-.9h-1V1a1 1 0 1 0-2 0v5h-1a1 1 0 0 0-1 .9L20.1 40H20v-9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h5v10H1a1 1 0 1 0 0 2h32c2 0 6-.8 8-3.1 2 2.3 6 3.1 8 3.1h10a1 1 0 0 0 0-2zm-9.2-27.6L37.7 40h-3.8l-.3-2.2zM25.9 8h2.2l3.8 32h-9.8zM4 32h14v9a1 1 0 0 0 1 1h31v4H4zm6 26V48h8v10zm10 0V48h14v9.9H20zm21.9-3.3a1 1 0 0 0-1.9 0c-.5 1.4-2.3 2.3-4.1 2.9V48h8v8.8a4 4 0 0 1-2-2.1zM8 35a1 1 0 1 1-1-1 1 1 0 0 1 1 1zm4 0a1 1 0 1 1-1-1 1 1 0 0 1 1 1z"}));
	}
	
	VoOffshore60px.displayName = "VoOffshore60px";
	
	VoOffshore60px.defaultProps = {"viewBox":"0 0 60 60"};
	
	module.exports = VoOffshore60px;
	
	VoOffshore60px.default = VoOffshore60px;


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Volleyball60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M59.837 30.368a.96.96 0 0 1-.012.239c-.328 16.259-13.602 29.392-29.901 29.392-5.391 0-10.44-1.456-14.814-3.966a.964.964 0 0 1-.544-.332C5.853 50.45-.008 40.91-.008 30c0-11.933 7.004-22.23 17.092-27.059a.986.986 0 0 1 .375-.182c3.801-1.754 8.013-2.76 12.465-2.76 11.544 0 21.565 6.596 26.556 16.216a.981.981 0 0 1 .194.403c2.017 4.035 3.181 8.57 3.181 13.382 0 .124-.017.244-.018.368zM28.695 57.962c.014-.012.02-.029.035-.04C43.408 46.89 43.551 31.177 43.348 27.354c-6.831-.122-11.179 2.313-12.448 3.14.179 2.81-.014 14.329-13.633 24.435a27.725 27.725 0 0 0 11.428 3.033zm-13.342-4.118c3.812-2.717 6.562-5.542 8.547-8.256-3.026-1.669-16.496-10.063-18.911-28.181A27.845 27.845 0 0 0 1.987 30c0 10.084 5.365 18.914 13.366 23.844zm1.365-48.508a28.169 28.169 0 0 0-10.085 9.249.984.984 0 0 1 .095.333C8.199 34.204 22.664 42.67 25.027 43.929c4.013-6.35 3.989-11.807 3.879-13.363-2.41-1.468-11.724-8.222-12.188-25.23zM29.924 2c-3.988 0-7.776.856-11.211 2.371.037 4.631.763 8.449 1.82 11.614 3.55-1.921 16.933-8.052 32.621-1.429C48.155 7.004 39.628 2 29.924 2zm24.962 15.561c-16.484-8.381-30.753-1.318-33.653.317 2.798 6.808 7.115 9.989 8.612 10.92 1.571-1.015 6.579-3.733 14.271-3.414.011-.002.019-.009.03-.011.088-.01.17.009.253.02 3.841.196 8.328 1.139 13.402 3.441-.167-4.04-1.214-7.847-2.915-11.273zm-9.54 9.897c.18 4.303-.254 19.204-13.411 30.441 14.117-1.016 25.341-12.574 25.872-26.852-4.697-2.244-8.872-3.272-12.461-3.589z","key":1})]);
	}
	
	Volleyball60px.displayName = "Volleyball60px";
	
	Volleyball60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.84 60"};
	
	module.exports = Volleyball60px;
	
	Volleyball60px.default = Volleyball60px;


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Wall60px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M58 41H1a1 1 0 0 1-1-1.001v-39a1 1 0 0 1 1-1h37a1 1 0 0 1 1 1v12h10A1 1 0 0 1 50 14v11.999h8a1 1 0 0 1 1 1v13A1 1 0 0 1 58 41zm-37-2h17V27.999H21V39zM2 39h17V27.999H2V39zm0-13.001h9v-11H2v11zM18 2H2v10.999h16V2zm-5 12.999v11h16v-11H13zM37 2H20v10.999h17V2zm11 12.999H31v11h17v-11zm9 13H40V39h17V27.999z","key":1})]);
	}
	
	Wall60px.displayName = "Wall60px";
	
	Wall60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59 41"};
	
	module.exports = Wall60px;
	
	Wall60px.default = Wall60px;


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function FagOgLedelse (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 fag og ledelse"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M26.317 6.814a.5.5 0 0 1 .626-.33c5.212 1.62 8.94 4.812 9.521 10.099l.033.333c.102 1.233.315 1.668 1.306 2.182l.062.031H39a.5.5 0 0 1 .492.41l.008.09v4.157a.5.5 0 0 1-.299.457l-.143.045-.058.009-.067.001-.542-.018c-1.424-.052-2.543.038-3.714.44-3.245 1.12-5.582 1.504-8.623 1.568l-.888.01h-1.754c-4.152.004-6.567-.25-10.159-1.42l-.475-.158-.32-.102c-.952-.284-1.892-.37-3.014-.348l-.923.028-.09-.003-.035-.007-.063-.017a.5.5 0 0 1-.372-.4l-.007-.085v-4.124a.5.5 0 0 1 .41-.492l.09-.008H9.59l.062-.03c.939-.488 1.18-.904 1.29-1.993l.017-.188c.332-4.203 2.683-7.174 6.365-9.143a.5.5 0 1 1 .471.882c-3.301 1.766-5.407 4.353-5.807 7.997l-.033.345c-.135 1.621-.544 2.355-2.027 3.08a.502.502 0 0 1-.144.045l-.075.005h-.754v3.121l.072-.002c1.409-.052 2.555.026 3.75.388l.327.106c3.266 1.103 5.468 1.445 8.803 1.51l.986.012H25.5c3.212-.029 5.524-.375 8.85-1.522 1.206-.415 2.336-.532 3.7-.505l.449.013v-3.154h-.753a.499.499 0 0 1-.15-.022l-.07-.028c-1.418-.694-1.854-1.395-2.008-2.873l-.019-.207c-.418-4.994-3.88-8.014-8.853-9.56a.5.5 0 0 1-.33-.625z","key":0}),React.createElement("path",{"d":"M26.696 4.648a.5.5 0 0 1 .488.391l.012.087.626 14.449a.5.5 0 0 1-.987.132l-.012-.089-.606-13.971h-5.014l-.605 13.971a.5.5 0 0 1-.43.474l-.091.004a.5.5 0 0 1-.474-.431l-.004-.09.627-14.449a.5.5 0 0 1 .412-.47l.087-.008zM35.885 23.625a.5.5 0 0 1 .702.08c.177.222.43.604.68 1.112.735 1.486.946 3.049.287 4.531-.377.85-1.028 1.62-1.973 2.294l-.085.058-.063.304c-.087.403-.201.85-.345 1.333a18.975 18.975 0 0 1-1.712 4.041c-2.138 3.72-5.312 5.974-9.682 5.974s-7.544-2.254-9.682-5.974a18.975 18.975 0 0 1-1.712-4.041 19.079 19.079 0 0 1-.275-1.023l-.133-.611-.046-.03c-1.949-1.345-2.641-3.08-2.338-4.963l.039-.218a.5.5 0 0 1 .98.196c-.329 1.648.243 3.11 2.09 4.297a.5.5 0 0 1 .223.342l.042.227.05.237c.082.38.19.803.326 1.26a17.981 17.981 0 0 0 1.62 3.829c1.975 3.434 4.845 5.472 8.816 5.472s6.84-2.038 8.815-5.472a17.981 17.981 0 0 0 1.62-3.828c.103-.343.189-.667.26-.968l.095-.42.054-.28.01-.057a.5.5 0 0 1 .219-.34c.934-.613 1.543-1.3 1.873-2.044.518-1.166.347-2.438-.269-3.682a6.434 6.434 0 0 0-.397-.694l-.103-.15-.066-.09a.5.5 0 0 1 .08-.702z","key":1})])]);
	}
	
	FagOgLedelse.displayName = "FagOgLedelse";
	
	FagOgLedelse.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = FagOgLedelse;
	
	FagOgLedelse.default = FagOgLedelse;


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Innovasjon (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 innovasjon"),React.createElement("g",{"clipRule":"evenodd","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M17.826 34.078a.5.5 0 0 1 .5-.5h11.348a.5.5 0 0 1 .5.5v5.453c0 .852-.664 1.517-1.516 1.517h-9.316a1.498 1.498 0 0 1-1.516-1.517zm1 .5v4.953c0 .3.217.517.516.517h9.316c.3 0 .516-.217.516-.517v-4.953z","key":0}),React.createElement("path",{"d":"M21.51 40.081a.5.5 0 0 1 .5.5c0 1.113.894 2.007 2.007 2.007a2.001 2.001 0 0 0 2.007-2.007.5.5 0 1 1 1 0 3.001 3.001 0 0 1-3.007 3.007 3.001 3.001 0 0 1-3.007-3.007.5.5 0 0 1 .5-.5zM23.483 5.421c-7.08.264-12.753 6.1-12.753 13.244a13.23 13.23 0 0 0 6.365 11.327c1.111.674 1.731 1.895 1.731 3.171v.38h4.657v-7.121c0-.951.95-1.53 1.793-1.213a2.749 2.749 0 0 0 1.145.273c1.08 0 1.94-.86 1.94-1.94 0-1.078-.86-1.938-1.94-1.938-.31 0-.71.106-1.131.268-.89.38-1.807-.298-1.807-1.209V16.7c0-.197-.195-.36-.429-.282a3.742 3.742 0 0 1-1.51.342c-1.631 0-2.939-1.308-2.939-2.94s1.308-2.938 2.939-2.938c.5 0 1.044.162 1.5.338a.3.3 0 0 0 .438-.279zm-4.976 29.123a.5.5 0 0 1-.681-.466v-.915c0-.96-.464-1.84-1.25-2.316A14.23 14.23 0 0 1 9.73 18.665c0-7.864 6.389-14.253 14.253-14.253a.5.5 0 0 1 .5.5v6.03c0 .91-.918 1.587-1.807 1.208-.42-.162-.822-.268-1.132-.268-1.079 0-1.939.86-1.939 1.939s.86 1.939 1.939 1.939a2.75 2.75 0 0 0 1.146-.273c.843-.317 1.793.262 1.793 1.213v3.963a.299.299 0 0 0 .438.279c.456-.175 1-.338 1.5-.338a2.929 2.929 0 0 1 2.94 2.939 2.929 2.929 0 0 1-2.94 2.939 3.742 3.742 0 0 1-1.51-.342c-.233-.079-.428.085-.428.282v7.622a.5.5 0 0 1-.5.5z","key":1}),React.createElement("path",{"d":"M23.517 4.912a.5.5 0 0 1 .5-.5c7.864 0 14.253 6.389 14.253 14.253 0 5.16-2.739 9.69-6.846 12.182-.786.477-1.25 1.357-1.25 2.316v.915a.5.5 0 0 1-.5.5h-5.657a.5.5 0 1 1 0-1h5.157v-.415c0-1.276.62-2.497 1.731-3.171a13.23 13.23 0 0 0 6.365-11.327c0-7.312-5.941-13.253-13.253-13.253a.5.5 0 0 1-.5-.5z","key":2})])]);
	}
	
	Innovasjon.displayName = "Innovasjon";
	
	Innovasjon.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = Innovasjon;
	
	Innovasjon.default = Innovasjon;


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function KlimaOgMiljo (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 klima og miljø"),React.createElement("g",{"clipRule":"evenodd","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M35.253 13.191l-.498-.048-.051-.497a.5.5 0 0 1 .549.545zm-4.697 17.415c-2.395 3.392-5.202 4.766-7.903 4.789-2.676.022-5.153-1.283-6.918-3.066l.71-.703c1.623 1.639 3.854 2.789 6.2 2.769 2.321-.02 4.85-1.186 7.095-4.366.812-1.15 1.509-2.773 2.095-4.592.584-1.812 1.05-3.787 1.409-5.62a80.002 80.002 0 0 0 .947-6.107 89.536 89.536 0 0 0-6.306.986c-1.872.365-3.875.828-5.685 1.397-1.818.571-3.402 1.238-4.463 1.996-2.507 1.807-3.678 3.967-3.959 6.079-.282 2.124.33 4.248 1.475 5.975l-.833.553c-1.259-1.898-1.952-4.262-1.633-6.66.32-2.41 1.656-4.806 4.366-6.76h.001c1.192-.851 2.897-1.556 4.747-2.137 1.858-.584 3.9-1.055 5.793-1.424a90.701 90.701 0 0 1 6.861-1.053l.11-.012.028-.003.01-.001.052.497.498.048-.001.01-.003.028-.01.106-.045.404a80.953 80.953 0 0 1-.97 6.272c-.363 1.855-.837 3.87-1.437 5.733-.598 1.855-1.332 3.59-2.23 4.862z","key":0}),React.createElement("path",{"d":"M19.319 28.376a.5.5 0 0 1 .543-.453l6.74.61a.5.5 0 1 1-.09.995l-6.74-.61a.5.5 0 0 1-.453-.542zM23.653 23.956a.5.5 0 0 1 .526-.472l4.404.237a.5.5 0 1 1-.054.999l-4.404-.238a.5.5 0 0 1-.472-.526z","key":1}),React.createElement("path",{"d":"M29.926 18.108a.5.5 0 0 1 0 .707L13.158 35.583a.5.5 0 0 1-.707-.707l16.767-16.768a.5.5 0 0 1 .708 0zM23.577 18.47a.5.5 0 0 1 .532.467l.135 2.032a.5.5 0 0 1-.998.066l-.135-2.032a.5.5 0 0 1 .466-.532zM18.752 20.437a.5.5 0 0 1 .546.45l.406 4.268a.5.5 0 0 1-.995.095l-.407-4.268a.5.5 0 0 1 .45-.545zM36.28 33.476a.5.5 0 0 1 .5.5v4.14h4.14a.5.5 0 1 1 0 1h-4.64a.5.5 0 0 1-.5-.5v-4.64a.5.5 0 0 1 .5-.5zM6.613 9.417a.5.5 0 0 1 .5-.5h4.607a.5.5 0 0 1 .5.5v4.607a.5.5 0 1 1-1 0V9.917H7.113a.5.5 0 0 1-.5-.5z","key":2}),React.createElement("path",{"d":"M16.3 5.875a19.617 19.617 0 0 1 7.717-1.565c10.879 0 19.707 8.828 19.707 19.707 0 6.013-2.678 11.366-6.917 14.98a.5.5 0 1 1-.649-.76c4.026-3.433 6.566-8.512 6.566-14.22 0-10.327-8.38-18.707-18.707-18.707-2.608 0-5.082.528-7.324 1.484a.5.5 0 1 1-.392-.92zM11.896 9.091a.5.5 0 0 1-.053.705C7.85 13.23 5.31 18.31 5.31 24.017c0 10.326 8.38 18.707 18.707 18.707 2.608 0 5.082-.528 7.324-1.484a.5.5 0 0 1 .392.92 19.617 19.617 0 0 1-7.716 1.564c-10.879 0-19.707-8.828-19.707-19.707 0-6.013 2.677-11.365 6.881-14.98a.5.5 0 0 1 .705.054z","key":3})])]);
	}
	
	KlimaOgMiljo.displayName = "KlimaOgMiljo";
	
	KlimaOgMiljo.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = KlimaOgMiljo;
	
	KlimaOgMiljo.default = KlimaOgMiljo;


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Samarbeid (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 samarbeid"),React.createElement("g",{"clipRule":"evenodd","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M22.657 36.878c-.679-.646-1.738-.635-2.368-.004l-1.008 1.008c-.645.677-.635 1.733-.008 2.365.678.646 1.738.634 2.368.003l1.008-1.007c.645-.677.635-1.734.008-2.365zm-3.076-.711c1.03-1.03 2.715-1.02 3.771-.007l.008.007c1.03 1.03 1.02 2.715.007 3.771l-.007.008-1.012 1.011c-1.03 1.03-2.714 1.02-3.77.008l-.008-.008c-1.03-1.03-1.02-2.714-.008-3.77l.007-.008 1.012-1.012.333.333z","key":0}),React.createElement("path",{"d":"M19.621 33.806c-.678-.646-1.738-.634-2.368-.003l-2.562 2.561c-.645.677-.634 1.734-.007 2.365.678.646 1.737.634 2.368.004l2.561-2.562c.645-.677.635-1.733.008-2.365zm-3.075-.71c1.03-1.03 2.714-1.02 3.77-.008l.009.007c1.03 1.031 1.02 2.715.007 3.772l-.007.007-2.566 2.566c-1.03 1.03-2.715 1.02-3.771.007l-.008-.007c-1.03-1.03-1.02-2.715-.007-3.771l.007-.008z","key":1}),React.createElement("path",{"d":"M16.55 30.735c-.678-.646-1.738-.634-2.368-.004l-2.562 2.562c-.656.688-.659 1.74-.012 2.36.679.65 1.74.64 2.372.008l2.562-2.562c.645-.676.635-1.733.008-2.364zm-3.075-.711c1.03-1.03 2.714-1.02 3.77-.007l.008.007c1.03 1.03 1.02 2.715.008 3.771l-.008.008-2.566 2.565c-1.03 1.03-2.714 1.02-3.77.008-1.087-1.041-1.018-2.732-.016-3.779l.008-.007z","key":2}),React.createElement("path",{"d":"M13.515 27.7c-.679-.647-1.738-.635-2.369-.004l-1.802 1.803c-.645.676-.635 1.733-.008 2.364.678.646 1.737.635 2.368.004l1.803-1.803c.645-.677.635-1.733.008-2.365zm-3.076-.711c1.03-1.03 2.715-1.02 3.771-.008l.008.008c1.03 1.03 1.02 2.714.007 3.77l-.007.008-1.807 1.807c-1.03 1.03-2.714 1.02-3.77.007l-.009-.007c-1.03-1.03-1.02-2.715-.007-3.771l.007-.008zM25.58 34.794a.5.5 0 0 1 .707 0l3.938 3.939c.631.63 1.69.642 2.368-.004.629-.632.638-1.692-.01-2.368a.5.5 0 0 1 .721-.692c1.013 1.056 1.023 2.74-.007 3.77l-.008.008c-1.056 1.013-2.74 1.023-3.77-.007l-3.94-3.939a.5.5 0 0 1 0-.707z","key":3}),React.createElement("path",{"d":"M28.651 31.722a.5.5 0 0 1 .707 0l3.94 3.94c.63.63 1.69.641 2.367-.005.627-.63.638-1.687-.007-2.364l-.755-.755a.5.5 0 1 1 .707-.707l.766.766c1.013 1.057 1.023 2.74-.007 3.771l-.008.008c-1.056 1.012-2.74 1.023-3.77-.008l-3.94-3.939a.5.5 0 0 1 0-.707zM28.044 37.208a.5.5 0 0 1 .707.015c1.013 1.056 1.023 2.74-.007 3.77l-.007.008c-1.057 1.012-2.741 1.023-3.772-.007l-1.806-1.807a.5.5 0 1 1 .707-.707l1.807 1.806c.63.631 1.69.643 2.368-.003.628-.633.637-1.692-.012-2.369a.5.5 0 0 1 .015-.706z","key":4}),React.createElement("path",{"d":"M31.723 28.651a.5.5 0 0 1 .707 0l3.18 3.18c.72.72 1.94.64 2.556-.252.43-.65.306-1.578-.264-2.149a.5.5 0 0 1 .707-.707c.874.874 1.111 2.328.388 3.414l-.004.006a2.665 2.665 0 0 1-4.09.395l-3.18-3.18a.5.5 0 0 1 0-.707zM40.48 6.64a.5.5 0 0 1-.06.705l-6.881 5.785L43.7 25.265l2.978-2.497a.5.5 0 1 1 .642.766l-3.36 2.818a.5.5 0 0 1-.705-.062l-10.804-12.9a.5.5 0 0 1 .061-.704l7.263-6.107a.5.5 0 0 1 .705.061zM7.266 6.423a.5.5 0 0 1 .705-.06l7.516 6.323a.5.5 0 0 1 .061.704L4.744 26.29a.5.5 0 0 1-.705.062L.68 23.534a.5.5 0 0 1 .642-.767L4.3 25.264 14.46 13.13 7.327 7.128a.5.5 0 0 1-.06-.705z","key":5}),React.createElement("path",{"d":"M33.141 14.675c.389-.08.653-.182.744-.245l.574.82c-.27.189-.711.322-1.117.405a5.595 5.595 0 0 1-1.314.118h-8.046c-1.07 0-2.105.397-3.296 1.588l-1.41 1.41c-.345.345-.54.798-.54 1.272v5.926c0 .158.102.259.26.259h.758a2.569 2.569 0 0 0 2.572-2.571v-1.518a.5.5 0 0 1 .146-.354c2.508-2.508 6.619-2.508 9.127 0l6.54 6.541 4.275-3.606.644.764-4.625 3.903a.5.5 0 0 1-.676-.029l-6.866-6.866c-2.069-2.069-5.437-2.116-7.565-.14v1.304a3.569 3.569 0 0 1-3.572 3.572h-.759a1.24 1.24 0 0 1-1.259-1.259v-5.926c0-.754.311-1.458.833-1.98l1.41-1.409c1.338-1.339 2.616-1.88 4.003-1.88h8.083a4.59 4.59 0 0 0 1.076-.1zM9.46 28.665l-4.228-3.541.642-.767 4.228 3.541z","key":6}),React.createElement("path",{"d":"M14.209 14.193c.681.533 1.348.544 2.185.544h3.216c.664 0 1.187.234 1.559.453a6.723 6.723 0 0 1 .442.287c.056.038.09.06.113.072l.009.005a.272.272 0 0 0-.065-.017l-.141.99a.845.845 0 0 1-.284-.101 2.512 2.512 0 0 1-.19-.118 15.921 15.921 0 0 1-.08-.055c-.097-.066-.195-.133-.312-.201-.287-.17-.631-.315-1.051-.315h-3.25c-.819 0-1.8 0-2.768-.757z","key":7})])]);
	}
	
	Samarbeid.displayName = "Samarbeid";
	
	Samarbeid.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = Samarbeid;
	
	Samarbeid.default = Samarbeid;


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Strategien (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"24/7 strategien"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M47.603 22.138v1.07l-10.38 18.797H35.73l10.286-18.583v-.062h-9.08v-1.222zM.397 29.198v-.917l1.905-1.895c5.746-5.41 8.254-8.19 8.254-11.614 0-2.262-.984-4.493-4.476-4.493-1.969 0-3.493.978-4.381 1.712l-.604-1.009a7.978 7.978 0 0 1 5.27-1.987c4.286 0 5.746 3.118 5.746 5.471 0 3.913-2.952 7.06-8.127 11.982l-1.46 1.436v.061h10.159v1.253zM31.096 22.138H25.19V9.332h-1.238l-10.064 13.05v.978h9.841v5.838h1.46v-5.837h5.874l.38-.612zM23.73 14.1v8.038H15.7v-.061l6.444-8.252c.476-.703.953-1.376 1.587-2.507l.096.03a38.51 38.51 0 0 0-.096 2.752z","key":0}),React.createElement("path",{"d":"M30.746 29.229a.956.956 0 0 1-.285-.061c-.254-.153-.35-.49-.191-.734l3.524-5.685-3.524-5.685c-.159-.244-.063-.58.19-.733a.578.578 0 0 1 .762.183l3.683 5.96a.566.566 0 0 1 0 .55l-3.683 5.96c-.127.153-.285.245-.476.245zM47.603 22.138v1.07l-10.38 18.797H35.73l10.286-18.583v-.062h-9.08v-1.222zM.397 29.198v-.917l1.905-1.895c5.746-5.41 8.254-8.19 8.254-11.614 0-2.262-.984-4.493-4.476-4.493-1.969 0-3.493.978-4.381 1.712l-.604-1.009a7.978 7.978 0 0 1 5.27-1.987c4.286 0 5.746 3.118 5.746 5.471 0 3.913-2.952 7.06-8.127 11.982l-1.46 1.436v.061h10.159v1.253z","key":1}),React.createElement("path",{"d":"M31.096 22.138H25.19V9.332h-1.238l-10.064 13.05v.978h9.841v5.838h1.46v-5.837h5.874l.38-.612zM23.73 14.1v8.038H15.7v-.061l6.444-8.252c.476-.703.953-1.376 1.587-2.507l.096.03a38.51 38.51 0 0 0-.096 2.752z","key":2}),React.createElement("path",{"d":"M30.746 29.229a.956.956 0 0 1-.285-.061c-.254-.153-.35-.49-.191-.734l3.524-5.685-3.524-5.685c-.159-.244-.063-.58.19-.733a.578.578 0 0 1 .762.183l3.683 5.96a.566.566 0 0 1 0 .55l-3.683 5.96c-.127.153-.285.245-.476.245z","key":3})])]);
	}
	
	Strategien.displayName = "Strategien";
	
	Strategien.defaultProps = {"viewBox":"0 0 48 48"};
	
	module.exports = Strategien;
	
	Strategien.default = Strategien;


/***/ }),
/* 1235 */
1222,
/* 1236 */
1223,
/* 1237 */
1224,
/* 1238 */
1225,
/* 1239 */
1226,
/* 1240 */
1227,
/* 1241 */
1230,
/* 1242 */
1231,
/* 1243 */
1232,
/* 1244 */
1233,
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowDown (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M8 12.667a.668.668 0 0 1-.491-.216l-7.334-8a.667.667 0 0 1 .983-.902L8 11.013l6.842-7.464a.667.667 0 0 1 .983.902l-7.334 8a.668.668 0 0 1-.49.216"}));
	}
	
	ArrowDown.displayName = "ArrowDown";
	
	ArrowDown.defaultProps = {"viewBox":"-2 -1 20 20"};
	
	module.exports = ArrowDown;
	
	ArrowDown.default = ArrowDown;


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowGreyLeft (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M.804 38.647a.805.805 0 0 1-.556-1.386l18.687-17.938L.248 1.386A.805.805 0 0 1 1.361.224l19.291 18.519a.805.805 0 0 1 0 1.161L1.361 38.424a.804.804 0 0 1-.557.223z"}));
	}
	
	ArrowGreyLeft.displayName = "ArrowGreyLeft";
	
	ArrowGreyLeft.defaultProps = {"viewBox":"0 0 21 39"};
	
	module.exports = ArrowGreyLeft;
	
	ArrowGreyLeft.default = ArrowGreyLeft;


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowGreyLightClose (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M118.305 12.946l10.216 10.255a.998.998 0 0 1 0 1.409.99.99 0 0 1-1.403 0l-10.217-10.255-10.216 10.255a.99.99 0 0 1-1.403 0 .998.998 0 0 1 0-1.409l10.216-10.255-10.216-10.254a.998.998 0 0 1 0-1.409.99.99 0 0 1 1.403 0l10.216 10.254 10.216-10.254a.99.99 0 0 1 1.404 0 1 1 0 0 1 0 1.409l-10.216 10.254z"}));
	}
	
	ArrowGreyLightClose.displayName = "ArrowGreyLightClose";
	
	ArrowGreyLightClose.defaultProps = {"viewBox":"0 0 24 24"};
	
	module.exports = ArrowGreyLightClose;
	
	ArrowGreyLightClose.default = ArrowGreyLightClose;


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowGreyLightLeft (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M12.918 23.91a.985.985 0 0 1-.671-.262L.33 12.695a.998.998 0 0 1 0-1.468L12.247.274a.992.992 0 0 1 1.404.061.999.999 0 0 1-.061 1.407L2.471 11.961l11.119 10.22a.999.999 0 0 1 .061 1.407.99.99 0 0 1-.733.322z"}));
	}
	
	ArrowGreyLightLeft.displayName = "ArrowGreyLightLeft";
	
	ArrowGreyLightLeft.defaultProps = {"viewBox":"0 0 14 24"};
	
	module.exports = ArrowGreyLightLeft;
	
	ArrowGreyLightLeft.default = ArrowGreyLightLeft;


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowGreyLightRight (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M1.017 23.91a.99.99 0 0 1-.733-.322.999.999 0 0 1 .061-1.407l11.12-10.22L.345 1.742A.999.999 0 0 1 .284.335.992.992 0 0 1 1.688.274l11.918 10.953a1 1 0 0 1 0 1.468L1.688 23.649a.989.989 0 0 1-.671.261z"}));
	}
	
	ArrowGreyLightRight.displayName = "ArrowGreyLightRight";
	
	ArrowGreyLightRight.defaultProps = {"viewBox":"0 0 14 24"};
	
	module.exports = ArrowGreyLightRight;
	
	ArrowGreyLightRight.default = ArrowGreyLightRight;


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowGreyRight (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M53.096 67.647a.805.805 0 0 0 .556-1.386L34.965 48.323l18.687-17.937a.805.805 0 0 0-1.113-1.162L33.248 47.743a.805.805 0 0 0 0 1.161l19.291 18.52c.157.148.357.223.557.223z"}));
	}
	
	ArrowGreyRight.displayName = "ArrowGreyRight";
	
	ArrowGreyRight.defaultProps = {"viewBox":"33 29 21 39"};
	
	module.exports = ArrowGreyRight;
	
	ArrowGreyRight.default = ArrowGreyRight;


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowLeft (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M20.096 38.647a.805.805 0 0 0 .556-1.386L1.965 19.323 20.652 1.386A.805.805 0 0 0 19.539.224L.248 18.743a.805.805 0 0 0 0 1.161l19.291 18.52c.157.148.357.223.557.223z"}));
	}
	
	ArrowLeft.displayName = "ArrowLeft";
	
	ArrowLeft.defaultProps = {"viewBox":"0 0 21 39"};
	
	module.exports = ArrowLeft;
	
	ArrowLeft.default = ArrowLeft;


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowLineLeft (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M2.06 3.873h9.324c.173 0 .32.059.435.185.123.118.181.27.181.446a.592.592 0 0 1-.18.446.593.593 0 0 1-.436.186H2.06l2.7 2.77a.6.6 0 0 1 .181.437c0 .169-.065.32-.18.447a.567.567 0 0 1-.87.017L.213 5.034a.702.702 0 0 1-.164-.253.839.839 0 0 1 0-.573.737.737 0 0 1 .164-.252L3.891.185A.588.588 0 0 1 4.326 0c.164 0 .311.067.443.202.115.135.18.278.189.446a.608.608 0 0 1-.19.446l-2.7 2.77-.008.009z"}));
	}
	
	ArrowLineLeft.displayName = "ArrowLineLeft";
	
	ArrowLineLeft.defaultProps = {"viewBox":"0 0 12 9"};
	
	module.exports = ArrowLineLeft;
	
	ArrowLineLeft.default = ArrowLineLeft;


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowLineLongRight (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M1.777 5h-1v2h1V5zm48 1l-10-5.774v11.547l10-5.773zm-48 1h39V5h-39v2z"}));
	}
	
	ArrowLineLongRight.displayName = "ArrowLineLongRight";
	
	ArrowLineLongRight.defaultProps = {"viewBox":"0 0 50 12"};
	
	module.exports = ArrowLineLongRight;
	
	ArrowLineLongRight.default = ArrowLineLongRight;


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowLineRight (props) {
	    return React.createElement("symbol",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"d":"M9.94 6.127H.616a.563.563 0 0 1-.435-.185A.592.592 0 0 1 0 5.496c0-.177.057-.329.18-.446a.594.594 0 0 1 .436-.186H9.94l-2.7-2.77a.6.6 0 0 1-.181-.437c0-.169.065-.32.18-.447a.567.567 0 0 1 .87-.017l3.678 3.772c.073.076.13.16.164.253.033.084.049.185.049.286a.738.738 0 0 1-.213.539L8.109 9.815a.588.588 0 0 1-.435.185.605.605 0 0 1-.443-.202.723.723 0 0 1-.189-.446c0-.169.058-.312.19-.446l2.7-2.77.008-.009z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"d":"M0 0h12v12H0z"})))]);
	}
	
	ArrowLineRight.displayName = "ArrowLineRight";
	
	ArrowLineRight.defaultProps = {"viewBox":"0 0 12 12"};
	
	module.exports = ArrowLineRight;
	
	ArrowLineRight.default = ArrowLineRight;


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowLineTop (props) {
	    return React.createElement("symbol",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"d":"M6.127 2.06v9.324c0 .173-.059.32-.185.435a.592.592 0 0 1-.446.181.592.592 0 0 1-.446-.18.593.593 0 0 1-.186-.436V2.06l-2.77 2.7a.6.6 0 0 1-.437.181.654.654 0 0 1-.447-.18.567.567 0 0 1-.017-.87L4.966.213A.702.702 0 0 1 5.218.05a.839.839 0 0 1 .573 0 .737.737 0 0 1 .252.164l3.772 3.678c.126.123.185.27.185.435a.605.605 0 0 1-.202.443.723.723 0 0 1-.446.189.608.608 0 0 1-.446-.19l-2.77-2.7-.009-.008z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"transform":"rotate(-90 6 6)","d":"M0 0h12v12H0z"})))]);
	}
	
	ArrowLineTop.displayName = "ArrowLineTop";
	
	ArrowLineTop.defaultProps = {"viewBox":"0 0 12 12"};
	
	module.exports = ArrowLineTop;
	
	ArrowLineTop.default = ArrowLineTop;


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowRight (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M.804 38.647a.805.805 0 0 1-.556-1.386l18.687-17.938L.248 1.386A.805.805 0 0 1 1.361.224l19.291 18.519a.805.805 0 0 1 0 1.161L1.361 38.424a.804.804 0 0 1-.557.223z"}));
	}
	
	ArrowRight.displayName = "ArrowRight";
	
	ArrowRight.defaultProps = {"viewBox":"0 0 21 39"};
	
	module.exports = ArrowRight;
	
	ArrowRight.default = ArrowRight;


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Arrows (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"Group 9"),React.createElement("g",{"stroke":"#FFF","strokeWidth":"2","fillRule":"evenodd","key":1},React.createElement("path",{"d":"M9.367 15.55l7.183-6.92-7.183-6.997M1.367 15.55L8.55 8.63 1.367 1.633"}))]);
	}
	
	Arrows.displayName = "Arrows";
	
	Arrows.defaultProps = {"viewBox":"0 0 18 17"};
	
	module.exports = Arrows;
	
	Arrows.default = Arrows;


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Binoculars (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M19 21c-2.62 0-4.753-2.033-4.96-4.601-.009-.055-.032-.104-.032-.161v-.161C14.007 16.051 14 16.026 14 16c0-.026.007-.05.008-.076l-.002-3.059c0-.139.067-.824-.006-.865h-4c.007.026-.006.726-.006.864l-.002 3.059c.001.027.008.051.008.077 0 .027-.007.051-.008.078v.036c0 .013-.007.024-.007.037C9.903 18.837 7.705 21 5 21c-2.757 0-5-2.243-5-5 0-.381.051-.748.132-1.105L2.013 3.046c.003-.021.017-.037.021-.058.005-.022-.001-.045.006-.067A4.084 4.084 0 0 1 5.938 0a4.063 4.063 0 0 1 3.986 3.314.996.996 0 0 1 .076.375V5h4V3.813c0-.088.029-.168.05-.25C14.299 1.561 15.993 0 18.061 0a4.085 4.085 0 0 1 3.899 2.921c.006.022.001.044.006.067.004.02.018.037.021.058l1.881 11.85c.081.356.132.723.132 1.104 0 2.757-2.243 5-5 5zM2.074 15.414c-.003.022-.016.039-.021.06-.03.171-.053.346-.053.526 0 1.654 1.346 3 3 3a2.999 2.999 0 0 0 2.992-2.922v-.155A2.999 2.999 0 0 0 5 13c-1.409 0-2.586.98-2.906 2.291l-.02.123zM20.029 3.46A2.069 2.069 0 0 0 18.061 2c-1.136 0-2.06.924-2.061 2.06l.002 2.442c0 .266-.106.521-.293.708-.188.187-.443-.21-.709-.21H9c-.266 0-.522.397-.709.21a1.002 1.002 0 0 1-.293-.708L8 4.059A2.065 2.065 0 0 0 5.938 2c-.9 0-1.704.599-1.967 1.46L2.68 11.598A4.932 4.932 0 0 1 5 11c1.175 0 2.243.425 3.097 1.106C8.338 11.095 9.013 10 10 10h4c.987 0 1.662 1.095 1.902 2.106C16.757 11.425 17.825 11 19 11c.842 0 1.623.229 2.32.598L20.029 3.46zm1.918 12.014c-.005-.021-.018-.038-.021-.06l-.02-.123A2.998 2.998 0 0 0 19 13a2.998 2.998 0 0 0-2.992 2.924v.153A2.999 2.999 0 0 0 19 19c1.654 0 3-1.346 3-3 0-.18-.023-.355-.053-.526z","key":1})]);
	}
	
	Binoculars.displayName = "Binoculars";
	
	Binoculars.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 24 21"};
	
	module.exports = Binoculars;
	
	Binoculars.default = Binoculars;


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Briefcase (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"Stresskoffert"),React.createElement("path",{"d":"M1.5 16.5v-6h5.25c0 .596.234 1.16.664 1.59.429.426.992.66 1.586.66 1.24 0 2.25-1.01 2.25-2.25h5.25l-.002 6H1.5zM8.25 9A.75.75 0 0 1 9 8.25a.758.758 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75.758.758 0 0 1-.75-.75V9zm8.25-3.75V9h-5.25c0-.596-.234-1.16-.664-1.59A2.24 2.24 0 0 0 9 6.75C7.76 6.75 6.75 7.76 6.75 9H1.5V5.25h15zM6.75 3a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v.75h-4.5V3zm9.75.75h-3.75V3c0-1.24-1.01-2.25-2.25-2.25h-3C6.26.75 5.25 1.76 5.25 3v.75H1.5c-.827 0-1.5.673-1.5 1.5V16.5c0 .827.673 1.5 1.5 1.5h15c.827 0 1.5-.673 1.5-1.5V5.25c0-.827-.673-1.5-1.5-1.5z","key":1})]);
	}
	
	Briefcase.displayName = "Briefcase";
	
	Briefcase.defaultProps = {"viewBox":"0 0 18 18"};
	
	module.exports = Briefcase;
	
	Briefcase.default = Briefcase;


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function CalendarAdd (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 1.681c.415 0 .752.319.752.712v.71h4.497v-.71c0-.393.336-.712.751-.712s.752.319.752.712v.71h1.498c.597 0 1.17.224 1.592.624.422.4.66.943.66 1.509v4.974c0 .394-.337.712-.752.712S15 10.604 15 10.21V8.79H3.002v6.395c0 .188.078.369.219.502a.77.77 0 0 0 .53.208h6c.414 0 .75.319.75.712 0 .393-.336.712-.75.712h-6c-.598 0-1.17-.225-1.593-.625-.422-.4-.659-.943-.659-1.509v-9.95c0-.565.237-1.108.66-1.508.422-.4.994-.625 1.591-.625H5.25v-.71c0-.392.336-.711.751-.711zM5.25 4.526H3.75a.77.77 0 0 0-.53.208.691.691 0 0 0-.218.502v2.13h11.997v-2.13a.691.691 0 0 0-.22-.502.77.77 0 0 0-.529-.208h-1.498v.71c0 .393-.337.712-.752.712s-.751-.32-.751-.712v-.71H6.752v.71c0 .393-.337.712-.752.712s-.751-.32-.751-.712v-.71zm9.001 7.105c.415 0 .752.318.752.712v1.42H16.5c.415 0 .752.319.752.712 0 .393-.337.712-.752.712h-1.498v1.42c0 .393-.337.712-.752.712s-.751-.32-.751-.712v-1.42H12c-.415 0-.751-.32-.751-.712 0-.393.336-.712.751-.712H13.5v-1.42c0-.394.336-.712.751-.712z"}));
	}
	
	CalendarAdd.displayName = "CalendarAdd";
	
	CalendarAdd.defaultProps = {"viewBox":"0 0 18 19"};
	
	module.exports = CalendarAdd;
	
	CalendarAdd.default = CalendarAdd;


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Calendar (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M18.333 20H1.667A1.669 1.669 0 0 1 0 18.333v-15c0-.919.748-1.666 1.667-1.666h4.166V.833a.833.833 0 1 1 1.667 0v.834h5V.833a.833.833 0 1 1 1.667 0v.834h4.166c.92 0 1.667.747 1.667 1.666v15c0 .92-.747 1.667-1.667 1.667zM14.167 3.333v.834a.833.833 0 1 1-1.667 0v-.834h-5v.834a.833.833 0 1 1-1.667 0v-.834H1.667v15H18.33l.002-15h-4.166zM15.833 15h-1.666a.833.833 0 0 1-.834-.833V12.5c0-.46.373-.833.834-.833h1.666c.461 0 .834.373.834.833v1.667c0 .46-.373.833-.834.833zm0-5h-1.666a.833.833 0 0 1-.834-.833V7.5c0-.46.373-.833.834-.833h1.666c.461 0 .834.373.834.833v1.667c0 .46-.373.833-.834.833zm-5 5H9.167a.833.833 0 0 1-.834-.833V12.5c0-.46.373-.833.834-.833h1.666c.461 0 .834.373.834.833v1.667c0 .46-.373.833-.834.833zm0-5H9.167a.833.833 0 0 1-.834-.833V7.5c0-.46.373-.833.834-.833h1.666c.461 0 .834.373.834.833v1.667c0 .46-.373.833-.834.833zm-5 5H4.167a.833.833 0 0 1-.834-.833V12.5c0-.46.373-.833.834-.833h1.666c.461 0 .834.373.834.833v1.667c0 .46-.373.833-.834.833zm0-5H4.167a.833.833 0 0 1-.834-.833V7.5c0-.46.373-.833.834-.833h1.666c.461 0 .834.373.834.833v1.667c0 .46-.373.833-.834.833z"}));
	}
	
	Calendar.displayName = "Calendar";
	
	Calendar.defaultProps = {"viewBox":"0 0 20 20"};
	
	module.exports = Calendar;
	
	Calendar.default = Calendar;


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function CameraTripod24px (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M13.243 14H9.77l5.811 8.427a1.009 1.009 0 0 1-.242 1.392.972.972 0 0 1-1.372-.246l-5.104-7.401V22c0 .552-.441 1-.985 1a.993.993 0 0 1-.985-1v-5.828l-5.104 7.401a.972.972 0 0 1-1.372.246 1.01 1.01 0 0 1-.242-1.392L5.986 14H2.514c-1.388 0-2.483-.661-2.483-2V5c0-1.339 1.095-3 2.483-3h1.785L4.782.657A.987.987 0 0 1 5.708 0h4.341c.414 0 .784.263.926.657L11.457 2h1.786c1.387 0 2.788 1.661 2.788 3v7c0 1.339-1.401 2-2.788 2zm.788-9c0-.228-.497-1-.788-1h-2.472l-.003.001a.956.956 0 0 1-.346-.072c-.033-.013-.063-.03-.095-.047a.945.945 0 0 1-.201-.138.845.845 0 0 1-.223-.29c-.015-.03-.035-.055-.047-.087-.003-.009-.01-.015-.013-.024L9.36 2H6.397l-.484 1.343c-.003.008-.01.013-.013.022-.028.072-.074.131-.117.193-.03.045-.052.096-.089.134-.046.049-.106.08-.161.119-.049.033-.092.075-.145.099-.053.024-.113.029-.17.043-.069.017-.134.04-.205.042-.009 0-.017.005-.025.005H2.514c-.291 0-.547.2-.547.428v7.143c0 .229.256.429.547.429h10.729c.291 0 .788.229.788 0V5zm-5.966 6c-1.664 0-3.018-1.346-3.018-3s1.354-3 3.018-3a3.012 3.012 0 0 1 3.018 3c0 1.654-1.353 3-3.018 3zm0-4c-.554 0-1.006.449-1.006 1 0 .551.452 1 1.006 1 .555 0 1.006-.449 1.006-1 0-.551-.451-1-1.006-1zM2.952 5h1.971v1H2.952V5z","key":1})]);
	}
	
	CameraTripod24px.displayName = "CameraTripod24px";
	
	CameraTripod24px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 16.031 24"};
	
	module.exports = CameraTripod24px;
	
	CameraTripod24px.default = CameraTripod24px;


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Checkmark (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M11.367 0l-6.48 6.48L2.081 3.67 0 5.753l4.887 4.89 8.561-8.563L11.367 0","fillRule":"evenodd"}));
	}
	
	Checkmark.displayName = "Checkmark";
	
	Checkmark.defaultProps = {"viewBox":"0 0 14 11"};
	
	module.exports = Checkmark;
	
	Checkmark.default = Checkmark;


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Close (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M13.314 11.955L23.53 22.21a.998.998 0 0 1 0 1.409.99.99 0 0 1-1.403 0L11.91 13.364 1.694 23.619a.99.99 0 0 1-1.403 0 .998.998 0 0 1 0-1.41l10.216-10.254L.291 1.7a.998.998 0 0 1 0-1.41.99.99 0 0 1 1.403 0L11.91 10.547 22.126.292a.99.99 0 0 1 1.404 0 1 1 0 0 1 0 1.409L13.314 11.955z"}));
	}
	
	Close.displayName = "Close";
	
	Close.defaultProps = {"viewBox":"0 0 24 24"};
	
	module.exports = Close;
	
	Close.default = Close;


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Download (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M7.7 11.992a.692.692 0 0 1-.259-.047.718.718 0 0 1-.236-.165L3.647 8.222a.652.652 0 0 1-.2-.506.735.735 0 0 1 .224-.507.691.691 0 0 1 .507-.212c.196 0 .365.07.506.212l2.31 2.333V1.507A.687.687 0 0 1 7.7.8a.687.687 0 0 1 .707.707v8.035l2.333-2.333a.692.692 0 0 1 .506-.212c.197 0 .365.07.507.212.141.141.212.31.212.507 0 .196-.07.365-.212.506L8.195 11.78a.718.718 0 0 1-.236.165.692.692 0 0 1-.259.047zM1.574 15.88c-.377 0-.707-.141-.99-.424a1.356 1.356 0 0 1-.424-.99v-2.662a.687.687 0 0 1 .707-.707.687.687 0 0 1 .707.707v2.662h12.252v-2.662a.687.687 0 0 1 .707-.707.687.687 0 0 1 .707.707v2.662c0 .377-.141.707-.424.99a1.356 1.356 0 0 1-.99.424H1.574z"}));
	}
	
	Download.displayName = "Download";
	
	Download.defaultProps = {"viewBox":"0 0 16 16"};
	
	module.exports = Download;
	
	Download.default = Download;


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Email (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"email"),React.createElement("path",{"d":"M21 18H3c-1.654 0-3-1.346-3-3V3c0-1.654 1.346-3 3-3h18c1.654 0 3 1.346 3 3v12c0 1.654-1.346 3-3 3zM3 16h18c.551 0 1-.449 1-1V3.203l-9.372 7.575a.996.996 0 0 1-1.256 0L2 3.203V15c0 .551.449 1 1 1zM20.307 2H3.693L12 8.715 20.307 2z","key":1})]);
	}
	
	Email.displayName = "Email";
	
	Email.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 24 18"};
	
	module.exports = Email;
	
	Email.default = Email;


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Facebook (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M23.37 0H1.365A1.37 1.37 0 0 0 0 1.375v22.17c0 .76.611 1.375 1.365 1.375h11.847v-9.65H9.988v-3.761h3.224V8.735c0-3.218 1.95-4.971 4.8-4.971 1.366 0 2.54.102 2.881.148v3.364h-1.976c-1.55 0-1.85.743-1.85 1.832v2.4h3.696l-.481 3.762h-3.215v9.65h6.303a1.37 1.37 0 0 0 1.365-1.375V1.375A1.37 1.37 0 0 0 23.37 0"}));
	}
	
	Facebook.displayName = "Facebook";
	
	Facebook.defaultProps = {"viewBox":"0 0 25 25"};
	
	module.exports = Facebook;
	
	Facebook.default = Facebook;


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Filetable (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"filetable"),React.createElement("path",{"d":"M17.981 7.086V22.21a1.73 1.73 0 0 1-1.726 1.729H1.724A1.73 1.73 0 0 1-.002 22.21V1.738A1.73 1.73 0 0 1 1.724.011h9.264c.046 0 .085.02.129.026a.769.769 0 0 1 .125.025c.172.046.331.12.453.241l5.885 5.873c.031.022.047.061.076.086.029.028.051.058.077.089.154.175.267.387.267.638 0 .035-.016.063-.019.097zm-5.994-3.672v2.578h2.583l-2.583-2.578zm3.996 4.572h-4.995a.998.998 0 0 1-.999-.997V1.97H2l-.003 19.975h13.986V7.986zM3.995 9.981h9.99c.552 0 .999.446.999.997v7.976c0 .55-.447.997-.999.997h-9.99a.998.998 0 0 1-.999-.997v-7.976c0-.551.446-.997.999-.997zm8.991 1.994H8.99v1.994h3.996v-1.994zm0 3.988H8.99v1.994h3.996v-1.994zm-7.992 1.994h1.998v-1.994H4.994v1.994zm0-3.988h1.998v-1.994H4.994v1.994z","key":1})]);
	}
	
	Filetable.displayName = "Filetable";
	
	Filetable.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 18 23.94"};
	
	module.exports = Filetable;
	
	Filetable.default = Filetable;


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Grid (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M22 24h-7c-1.103 0-2-.897-2-2v-7c0-1.103.897-2 2-2h7c1.103 0 2 .897 2 2v7c0 1.103-.897 2-2 2zm-7-9v7h6.997L22 15h-7zm7-4h-7c-1.103 0-2-.897-2-2V2c0-1.103.897-2 2-2h7c1.103 0 2 .897 2 2v7c0 1.103-.897 2-2 2zm-7-9v7h6.997L22 2h-7zM9.002 24H2c-1.103 0-2-.897-2-2v-7c0-1.103.897-2 2-2h7.002c1.103 0 2 .897 2 2v7c0 1.103-.897 2-2 2zM2 15v7h6.999l.003-7H2zm7.002-4H2c-1.103 0-2-.897-2-2V2C0 .897.897 0 2 0h7.002c1.103 0 2 .897 2 2v7c0 1.103-.897 2-2 2zM2 2v7h6.999l.003-7H2z"}));
	}
	
	Grid.displayName = "Grid";
	
	Grid.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 24 24"};
	
	module.exports = Grid;
	
	Grid.default = Grid;


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Hamburger (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"hamburger meny"),React.createElement("path",{"d":"M1 8a1 1 0 1 1 0-2h18a1 1 0 0 1 0 2H1zm0 6a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2H1zM1 2a1 1 0 1 1 0-2h18a1 1 0 0 1 0 2H1z","fillRule":"nonzero","key":1})]);
	}
	
	Hamburger.displayName = "Hamburger";
	
	Hamburger.defaultProps = {"viewBox":"0 0 20 14"};
	
	module.exports = Hamburger;
	
	Hamburger.default = Hamburger;


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function IconShare (props) {
	    return React.createElement("symbol",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"d":"M29.624 7.373l-5 4.998a1.245 1.245 0 0 1-1.77 0 1.248 1.248 0 0 1 0-1.767l2.868-2.866H19.99c-5.423 0-10.002 4.465-10.002 9.748a1.25 1.25 0 0 1-2.501 0c0-6.753 5.61-12.248 12.503-12.248h5.733l-2.867-2.865A1.25 1.25 0 1 1 24.623.605l5 5a1.25 1.25 0 0 1 0 1.768zm-22.138.365h-5v17.497h22.503v-8.748a1.25 1.25 0 0 1 2.502 0v8.748a2.504 2.504 0 0 1-2.502 2.5H2.485a2.503 2.503 0 0 1-2.5-2.5V7.738c0-1.377 1.122-2.5 2.5-2.5h5.001a1.25 1.25 0 1 1 0 2.5z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"transform":"translate(0 .255)","d":"M0 0h30v27.49H0z"})))]);
	}
	
	IconShare.displayName = "IconShare";
	
	IconShare.defaultProps = {"viewBox":"0 0 30 28"};
	
	module.exports = IconShare;
	
	IconShare.default = IconShare;


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Instagram (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M0 7.67C0 3.435 3.411 0 7.614 0H17.2c4.205 0 7.614 3.437 7.614 7.67v9.66c0 4.236-3.411 7.67-7.614 7.67H7.614C3.409 25 0 21.563 0 17.33V7.67zm2.256 0v9.66c0 2.979 2.4 5.397 5.358 5.397H17.2c2.958 0 5.358-2.417 5.358-5.398V7.671c0-2.98-2.4-5.398-5.358-5.398H7.614c-2.958 0-5.358 2.417-5.358 5.398zm10.151 11.364c-3.582 0-6.485-2.925-6.485-6.534s2.903-6.534 6.485-6.534c3.582 0 6.485 2.925 6.485 6.534s-2.903 6.534-6.485 6.534zm0-2.273c2.336 0 4.23-1.908 4.23-4.261s-1.894-4.261-4.23-4.261c-2.336 0-4.23 1.908-4.23 4.261s1.894 4.261 4.23 4.261zm6.626-9.375c-.856 0-1.55-.7-1.55-1.562 0-.863.694-1.563 1.55-1.563.857 0 1.551.7 1.551 1.563s-.694 1.562-1.55 1.562z"}));
	}
	
	Instagram.displayName = "Instagram";
	
	Instagram.defaultProps = {"viewBox":"0 0 25 25"};
	
	module.exports = Instagram;
	
	Instagram.default = Instagram;


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Linkedin (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M22.739 0H2.26A2.261 2.261 0 0 0 0 2.261v20.477A2.261 2.261 0 0 0 2.261 25h20.477A2.261 2.261 0 0 0 25 22.738V2.261A2.261 2.261 0 0 0 22.739 0zM7.736 21.587a.658.658 0 0 1-.658.658H4.277a.658.658 0 0 1-.659-.658V9.843c0-.363.295-.658.659-.658h2.8c.364 0 .66.295.66.658v11.744zM5.677 8.078a2.661 2.661 0 1 1 0-5.323 2.661 2.661 0 0 1 0 5.323zm16.7 13.562c0 .334-.272.605-.606.605h-3.006a.605.605 0 0 1-.605-.605V16.13c0-.821.241-3.6-2.148-3.6-1.852 0-2.228 1.902-2.303 2.755v6.354c0 .334-.271.605-.606.605h-2.907a.605.605 0 0 1-.605-.605V9.79c0-.334.27-.605.605-.605h2.907c.335 0 .606.271.606.605v1.025c.687-1.031 1.707-1.827 3.881-1.827 4.814 0 4.786 4.497 4.786 6.968v5.684z"}));
	}
	
	Linkedin.displayName = "Linkedin";
	
	Linkedin.defaultProps = {"viewBox":"0 0 25 25"};
	
	module.exports = Linkedin;
	
	Linkedin.default = Linkedin;


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function List (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M2 21h20v-3H2v3zm21 2H1a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1zM2 13h20v-3H2v3zm21 2H1a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1zM2 5h20V2H2v3zm21 2H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1z"}));
	}
	
	List.displayName = "List";
	
	List.defaultProps = {"viewBox":"0 0 24 24"};
	
	module.exports = List;
	
	List.default = List;


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Location (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"Lokasjon"),React.createElement("path",{"d":"M7.506 17.82a.795.795 0 0 1-1.012 0C6.228 17.6 0 12.377 0 6.781 0 3.042 3.14 0 7 0s7 3.043 7 6.782C14 12.378 7.772 17.6 7.506 17.82zM7 1.5c-3.001 0-5.444 2.37-5.444 5.282 0 4.052 4.004 8.117 5.443 9.448 1.44-1.332 5.445-5.404 5.445-9.448C12.444 3.87 10.001 1.5 7 1.5zm0 8.306c-1.716 0-3.111-1.346-3.111-3s1.395-3 3.111-3c1.716 0 3.111 1.346 3.111 3s-1.395 3-3.111 3zm0-4.5c-.857 0-1.556.672-1.556 1.5 0 .827.699 1.5 1.556 1.5.858 0 1.556-.673 1.556-1.5 0-.828-.698-1.5-1.556-1.5z","key":1})]);
	}
	
	Location.displayName = "Location";
	
	Location.defaultProps = {"viewBox":"0 0 14 18"};
	
	module.exports = Location;
	
	Location.default = Location;


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Magnifier (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M23.608 23.707a.994.994 0 0 1-1.409 0l-7.653-7.682A8.898 8.898 0 0 1 8.956 18C4.012 18-.011 13.963-.011 9.001-.011 4.038 4.012 0 8.956 0c4.944 0 8.966 4.038 8.966 9.001a8.97 8.97 0 0 1-1.967 5.61l7.653 7.682c.389.39.389 1.024 0 1.414zM8.956 2C5.11 2 1.982 5.141 1.982 9.001 1.982 12.86 5.11 16 8.956 16c3.845 0 6.974-3.14 6.974-6.999C15.93 5.141 12.801 2 8.956 2z"}));
	}
	
	Magnifier.displayName = "Magnifier";
	
	Magnifier.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 23.906 24"};
	
	module.exports = Magnifier;
	
	Magnifier.default = Magnifier;


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Map (props) {
	    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M23.551 23.796a1.006 1.006 0 0 1-.945.083l-6.63-2.836-7.624 2.854c-.011.004-.021.002-.031.006a.996.996 0 0 1-.321.058c-.033 0-.062-.016-.094-.02a1.013 1.013 0 0 1-.299-.061l-.001-.001-7-2.994A.997.997 0 0 1 0 19.968V1.005A.997.997 0 0 1 1.316.058l3 .998a.998.998 0 1 1-.632 1.893L2 2.389V19.31l5 2.139v-3.477a.999.999 0 0 1 1-.998c.553 0 1 .447 1 .998v3.55l6-2.246v-1.304a.999.999 0 0 1 1-.998c.553 0 1 .447 1 .998v1.338l5 2.138V4.718l-2.316-.77a.998.998 0 1 1 .632-1.894l3 .998a.998.998 0 0 1 .684.947v18.963a1 1 0 0 1-.449.834zM12.64 17.741a1.002 1.002 0 0 1-1.28 0C11.101 17.525 5 12.393 5 6.843 5 3.074 8.141.007 12 .007s7 3.067 7 6.836c0 5.55-6.101 10.682-6.36 10.898zM12 2.003c-2.757 0-5 2.171-5 4.84 0 3.662 3.522 7.384 5 8.785 1.477-1.401 5-5.123 5-8.785 0-2.669-2.243-4.84-5-4.84zm-2 4.99a2 2 0 0 1 4 0 2 2 0 0 1-4 0z","key":1})]);
	}
	
	Map.displayName = "Map";
	
	Map.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 24 23.97"};
	
	module.exports = Map;
	
	Map.default = Map;


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function MinusCircle (props) {
	    return React.createElement("symbol",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 3.002a8.998 8.998 0 1 0 0 17.996 8.998 8.998 0 0 0 0-17.996zM.998 12C.998 5.924 5.924.998 12 .998 18.076.998 23 5.924 23 12c0 6.076-4.925 11.002-11.001 11.002S.998 18.076.998 12zM16 10.998a1.002 1.002 0 0 1 0 2.004H8a1.002 1.002 0 0 1 0-2.004h8z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"d":"M0 5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v14a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5z"})))]);
	}
	
	MinusCircle.displayName = "MinusCircle";
	
	MinusCircle.defaultProps = {"viewBox":"0 0 24 24"};
	
	module.exports = MinusCircle;
	
	MinusCircle.default = MinusCircle;


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Minus (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M19.167 10.833H.833a.833.833 0 1 1 0-1.666h18.334a.833.833 0 0 1 0 1.666z"}));
	}
	
	Minus.displayName = "Minus";
	
	Minus.defaultProps = {"viewBox":"0 0 20 20"};
	
	module.exports = Minus;
	
	Minus.default = Minus;


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Pdf (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M20.25 14.983H18v1.497h1.5a.749.749 0 1 1 0 1.497H18v2.244a.749.749 0 0 1-1.5 0v-5.986c0-.412.335-.748.75-.748h3a.749.749 0 1 1 0 1.496zM6 20.97a.749.749 0 0 1-.75-.748v-5.987c0-.412.335-.748.75-.748h1.5c1.262 0 2.25 1.143 2.25 2.603 0 1.442-.979 2.599-2.228 2.634H6.75v1.497a.749.749 0 0 1-.75.749zm1.5-3.742c.358-.01.75-.44.75-1.138 0-.692-.382-1.107-.75-1.107h-.75v2.245h.75zm3.75 3.742a.749.749 0 0 1-.75-.748v-5.987c0-.412.335-.748.75-.748h1.573a2.927 2.927 0 0 1 2.927 2.92v1.642c0 1.61-1.313 2.921-2.927 2.921H11.25zm3-2.92v-1.643c0-.784-.64-1.424-1.427-1.424H12v4.49h.823c.787 0 1.427-.638 1.427-1.424zM18 11.241a.749.749 0 0 1-.75.748.749.749 0 0 1-.75-.748V8.249h-6a.75.75 0 0 1-.75-.749V1.478H1.5v20.97l15.75.018a.749.749 0 1 1 0 1.497H1.519C.68 23.963 0 23.283 0 22.448V1.533C0 .698.681.017 1.519.017H10.5c.018 0 .033.01.05.01a.753.753 0 0 1 .191.039c.026.009.052.015.075.027.076.035.148.08.21.141l.005.004 6.668 6.651c.023.018.035.046.057.066.022.02.038.043.058.066.116.132.2.29.2.479 0 .026-.012.047-.014.073v3.669zm-6.75-8.67v4.18h4.19l-4.19-4.18z"}));
	}
	
	Pdf.displayName = "Pdf";
	
	Pdf.defaultProps = {"viewBox":"0 0 21 24"};
	
	module.exports = Pdf;
	
	Pdf.default = Pdf;


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function PlusCircle (props) {
	    return React.createElement("symbol",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 3.002a8.998 8.998 0 1 0 0 17.996 8.998 8.998 0 0 0 0-17.996zM.998 12C.998 5.924 5.924.998 12 .998 18.076.998 23 5.924 23 12c0 6.076-4.925 11.002-11.001 11.002S.998 18.076.998 12zM12 6.998C12.553 6.998 13 7.447 13 8v2.998H16a1.002 1.002 0 0 1 0 2.004H13V16a1.002 1.002 0 0 1-2.003 0v-2.998H8a1.002 1.002 0 0 1 0-2.004h2.998V8c0-.553.449-1.002 1.002-1.002z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"d":"M0 5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v14a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5z"})))]);
	}
	
	PlusCircle.displayName = "PlusCircle";
	
	PlusCircle.defaultProps = {"viewBox":"0 0 24 24"};
	
	module.exports = PlusCircle;
	
	PlusCircle.default = PlusCircle;


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Plus (props) {
	    return React.createElement("symbol",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"d":"M17.25 8.75h-7.5v-7.5a.75.75 0 0 0-1.5 0v7.5H.75a.75.75 0 0 0 0 1.5h7.5v7.5a.75.75 0 1 0 1.5 0v-7.5h7.5a.75.75 0 1 0 0-1.5z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"transform":"translate(0 .5)","d":"M0 0h18v18H0z"})))]);
	}
	
	Plus.displayName = "Plus";
	
	Plus.defaultProps = {"viewBox":"0 0 18 19"};
	
	module.exports = Plus;
	
	Plus.default = Plus;


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Printer (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M20.625 18.567h-2.808v3.427c0 .38-.308.689-.687.689H4.755c-.38 0-.63-.303-.63-.683v-3.433h-2.75A1.378 1.378 0 0 1 0 17.191V7.558c0-.76.617-1.377 1.375-1.377h2.75V1.372c0-.38.308-.689.688-.689h12.375c.379 0 .687.308.687.69V6.18h2.75c.758 0 1.375.618 1.375 1.377v9.633c0 .758-.617 1.376-1.375 1.376zm-15.183-.695l.002.007-.002.007v3.42l11.058.006v-3.16a.684.684 0 0 1 0-.547V13.75l-11.058-.013v4.135zM16.5 2.06h-11v4.12h11V2.06zm4.125 5.498h-3.4c-.013 0-.024.007-.038.007H4.813c-.013 0-.024-.007-.037-.007h-3.4v9.633h2.75v-4.128c0-.381.25-.702.63-.702H17.13c.38 0 .687.307.687.688v4.142h2.808V7.558zM16.5 9.63c0-.381.308-.688.688-.688h.687a.687.687 0 1 1 0 1.375h-.688a.687.687 0 0 1-.687-.687z"}));
	}
	
	Printer.displayName = "Printer";
	
	Printer.defaultProps = {"viewBox":"0 0 22 23"};
	
	module.exports = Printer;
	
	Printer.default = Printer;


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Search (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M14.083 15L8.604 9.52a4.593 4.593 0 0 1-1.457.845 5.154 5.154 0 0 1-1.772.302c-1.502 0-2.774-.521-3.814-1.563C.52 8.063 0 6.806 0 5.334c0-1.473.52-2.73 1.563-3.771C2.603.52 3.865 0 5.342 0c1.48 0 2.737.52 3.772 1.563 1.034 1.041 1.552 2.3 1.552 3.773A5.189 5.189 0 0 1 9.5 8.625l5.5 5.458-.917.917zM5.354 9.417c1.129 0 2.088-.4 2.878-1.198.79-.799 1.185-1.76 1.185-2.886 0-1.125-.395-2.086-1.185-2.885-.79-.799-1.75-1.198-2.878-1.198-1.14 0-2.109.4-2.907 1.198-.798.799-1.197 1.76-1.197 2.885 0 1.125.399 2.087 1.197 2.886.798.798 1.767 1.198 2.907 1.198z"}));
	}
	
	Search.displayName = "Search";
	
	Search.defaultProps = {"viewBox":"0 0 15 15"};
	
	module.exports = Search;
	
	Search.default = Search;


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Share (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"share"),React.createElement("path",{"d":"M23.606 5.672l-3.985 3.983a.993.993 0 0 1-1.409 0 .995.995 0 0 1 0-1.408l2.285-2.284h-4.569c-4.321 0-7.97 3.558-7.97 7.768a.995.995 0 1 1-1.993 0c0-5.381 4.47-9.76 9.963-9.76h4.569l-2.285-2.283A.996.996 0 0 1 19.621.279l3.985 3.984a.996.996 0 0 1 0 1.409zm-17.641.291H1.98v13.943h17.933v-6.971a.996.996 0 0 1 1.993 0v6.971a1.995 1.995 0 0 1-1.993 1.992H1.98a1.994 1.994 0 0 1-1.992-1.992V5.963c0-1.097.894-1.992 1.992-1.992h3.985a.996.996 0 1 1 0 1.992z","key":1})]);
	}
	
	Share.displayName = "Share";
	
	Share.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 23.906 21.906"};
	
	module.exports = Share;
	
	Share.default = Share;


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Twitter (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M25.004 5.452c-.92.408-1.909.684-2.946.808a5.145 5.145 0 0 0 2.255-2.838 10.27 10.27 0 0 1-3.257 1.244 5.13 5.13 0 0 0-8.741 4.679A14.564 14.564 0 0 1 1.74 3.985a5.106 5.106 0 0 0-.695 2.58c0 1.78.906 3.35 2.282 4.27a5.109 5.109 0 0 1-2.323-.642v.064a5.133 5.133 0 0 0 4.114 5.03 5.14 5.14 0 0 1-2.316.088 5.135 5.135 0 0 0 4.792 3.563 10.292 10.292 0 0 1-6.371 2.196c-.414 0-.823-.025-1.224-.072a14.519 14.519 0 0 0 7.864 2.305c9.435 0 14.595-7.817 14.595-14.596 0-.222-.005-.444-.015-.664a10.422 10.422 0 0 0 2.56-2.655z"}));
	}
	
	Twitter.displayName = "Twitter";
	
	Twitter.defaultProps = {"viewBox":"0 0 25 25"};
	
	module.exports = Twitter;
	
	Twitter.default = Twitter;


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Youtube (props) {
	    return React.createElement("symbol",props,React.createElement("path",{"d":"M14.447 9.16v6.662l5.288-3.36-5.288-3.302zm-1.032 9.59c-.172 0-.344-.043-.499-.13a1.043 1.043 0 0 1-.533-.912V7.292c0-.377.202-.726.53-.91a1.02 1.02 0 0 1 1.044.023l8.27 5.163a1.048 1.048 0 0 1 .007 1.768l-8.27 5.255c-.168.105-.357.159-.55.159zM16.51 2.083c-7.627 0-11.163.638-11.199.644-.779.147-1.787.949-2.11 1.682-.01.023-1.137 2.705-1.137 8.091 0 5.386 1.127 8.067 1.138 8.094.322.73 1.33 1.532 2.111 1.679.034.006 3.57.644 11.177.644h.02c7.607 0 11.142-.638 11.176-.644.782-.147 1.788-.949 2.112-1.683.01-.024 1.138-2.705 1.138-8.09s-1.128-8.068-1.139-8.094c-.323-.73-1.33-1.532-2.112-1.679-.033-.006-3.568-.644-11.175-.644zm0 22.917h-.02c-7.83 0-11.404-.651-11.552-.678-1.463-.275-3.02-1.515-3.624-2.887C1.26 21.314 0 18.383 0 12.5c0-5.882 1.261-8.815 1.314-8.936.604-1.37 2.161-2.61 3.623-2.886C5.087.651 8.66 0 16.49 0c7.851 0 11.423.651 11.57.678 1.463.275 3.02 1.516 3.624 2.886C31.738 3.685 33 6.618 33 12.5c0 5.883-1.262 8.815-1.317 8.935-.603 1.372-2.16 2.612-3.622 2.887-.148.027-3.72.678-11.55.678z"}));
	}
	
	Youtube.displayName = "Youtube";
	
	Youtube.defaultProps = {"viewBox":"0 0 33 25"};
	
	module.exports = Youtube;
	
	Youtube.default = Youtube;


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ZoomIn (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"Zoom In"),React.createElement("path",{"d":"M23 11H13V1a1 1 0 0 0-2 0v10H1a1 1 0 0 0 0 2h10v10a1 1 0 0 0 2 0V13h10a1 1 0 0 0 0-2","key":1})]);
	}
	
	ZoomIn.displayName = "ZoomIn";
	
	ZoomIn.defaultProps = {"viewBox":"0 0 24 24"};
	
	module.exports = ZoomIn;
	
	ZoomIn.default = ZoomIn;


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ZoomOut (props) {
	    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"Zoom Out"),React.createElement("path",{"d":"M23 13H1a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2","key":1})]);
	}
	
	ZoomOut.displayName = "ZoomOut";
	
	ZoomOut.defaultProps = {"viewBox":"0 0 24 24"};
	
	module.exports = ZoomOut;
	
	ZoomOut.default = ZoomOut;


/***/ }),
/* 1290 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// app.42127db028d064b06b8d.js